(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea735"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea735"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jhwMH", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("jSNlv", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var o = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), o.call(this, t);
        };
        var r = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else r.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s, o = this;
            if (f) return o.$offset = u, o.$u = 0 === s, o;
            if (0 !== s) {
                var r = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
                (o = this.local().add(u + r, t)).$offset = u, o.$x.$localOffset = r;
            } else o = this.utc();
            return o;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRegister("6N7gE", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

});

parcelRegister("17sxp", function(module, exports) {
!function(e, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    return function(e, i) {
        i.prototype.isSameOrBefore = function(e, i) {
            return this.isSame(e, i) || this.isBefore(e, i);
        };
    };
});

});

parcelRegister("ojnWK", function(module, exports) {

$parcel$export(module.exports, "focus", () => src_default);
$parcel$export(module.exports, "default", () => module_default);
// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively2(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
    if (node.tabIndex < 0) {
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (nodeIsAttached) return !node.getClientRects().length;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = getTabindex(element, isScope);
        var elements = isScope ? sortByOrder2(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
// node_modules/focus-trap/dist/focus-trap.esm.js
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
    return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false;
        }
        return true;
    });
    return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element) {
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = void 0;
        if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) return optionValue;
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue;
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue);
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
        var node = getNodeForOption("initialFocus");
        if (node === false) return false;
        if (node === void 0) {
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            var focusableNodes = focusable(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return void 0;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus2(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus2(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
            });
            return;
        }
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
        var target = getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0;
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    };
    var checkTab = function checkTab2(e) {
        var target = getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
            if (containerIndex < 0) {
                if (e.shiftKey) destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        }
    };
    var checkKey = function checkKey2(e) {
        if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if (isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
        if (!state.active) return;
        activeFocusTraps.activateTrap(trap);
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners2() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation2() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            removeListeners();
            state.active = false;
            state.paused = false;
            activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation2() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    };
    trap.updateContainerElements(elements);
    return trap;
};
// packages/focus/src/index.js
function src_default(Alpine) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", ()=>{
        lastFocused = currentFocused;
        currentFocused = document.activeElement;
    });
    Alpine.magic("focus", (el)=>{
        let within = el;
        return {
            __noscroll: false,
            __wrapAround: false,
            within (el2) {
                within = el2;
                return this;
            },
            withoutScrolling () {
                this.__noscroll = true;
                return this;
            },
            noscroll () {
                this.__noscroll = true;
                return this;
            },
            withWrapAround () {
                this.__wrapAround = true;
                return this;
            },
            wrap () {
                return this.withWrapAround();
            },
            focusable (el2) {
                return isFocusable(el2);
            },
            previouslyFocused () {
                return lastFocused;
            },
            lastFocused () {
                return lastFocused;
            },
            focused () {
                return currentFocused;
            },
            focusables () {
                if (Array.isArray(within)) return within;
                return focusable(within, {
                    displayCheck: "none"
                });
            },
            all () {
                return this.focusables();
            },
            isFirst (el2) {
                let els = this.all();
                return els[0] && els[0].isSameNode(el2);
            },
            isLast (el2) {
                let els = this.all();
                return els.length && els.slice(-1)[0].isSameNode(el2);
            },
            getFirst () {
                return this.all()[0];
            },
            getLast () {
                return this.all().slice(-1)[0];
            },
            getNext () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === list.length - 1) return list[0];
                return list[list.indexOf(current) + 1];
            },
            getPrevious () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === 0) return list.slice(-1)[0];
                return list[list.indexOf(current) - 1];
            },
            first () {
                this.focus(this.getFirst());
            },
            last () {
                this.focus(this.getLast());
            },
            next () {
                this.focus(this.getNext());
            },
            previous () {
                this.focus(this.getPrevious());
            },
            prev () {
                return this.previous();
            },
            focus (el2) {
                if (!el2) return;
                setTimeout(()=>{
                    if (!el2.hasAttribute("tabindex")) el2.setAttribute("tabindex", "0");
                    el2.focus({
                        preventScroll: this.__noscroll
                    });
                });
            }
        };
    });
    Alpine.directive("trap", Alpine.skipDuringClone((el, { expression, modifiers }, { effect, evaluateLater, cleanup })=>{
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: ()=>el
        };
        if (modifiers.includes("noautofocus")) options.initialFocus = false;
        else {
            let autofocusEl = el.querySelector("[autofocus]");
            if (autofocusEl) options.initialFocus = autofocusEl;
        }
        let trap = createFocusTrap(el, options);
        let undoInert = ()=>{};
        let undoDisableScrolling = ()=>{};
        const releaseFocus = ()=>{
            undoInert();
            undoInert = ()=>{};
            undoDisableScrolling();
            undoDisableScrolling = ()=>{};
            trap.deactivate({
                returnFocus: !modifiers.includes("noreturn")
            });
        };
        effect(()=>evaluator((value)=>{
                if (oldValue === value) return;
                if (value && !oldValue) {
                    if (modifiers.includes("noscroll")) undoDisableScrolling = disableScrolling();
                    if (modifiers.includes("inert")) undoInert = setInert(el);
                    setTimeout(()=>{
                        trap.activate();
                    }, 15);
                }
                if (!value && oldValue) releaseFocus();
                oldValue = !!value;
            }));
        cleanup(releaseFocus);
    }, // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate })=>{
        if (modifiers.includes("inert") && evaluate(expression)) setInert(el);
    }));
}
function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling)=>{
        let cache = sibling.hasAttribute("aria-hidden");
        sibling.setAttribute("aria-hidden", "true");
        undos.push(()=>cache || sibling.removeAttribute("aria-hidden"));
    });
    return ()=>{
        while(undos.length)undos.pop()();
    };
}
function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode) return;
    Array.from(el.parentNode.children).forEach((sibling)=>{
        if (sibling.isSameNode(el)) crawlSiblingsUp(el.parentNode, callback);
        else callback(sibling);
    });
}
function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return ()=>{
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;
    };
}
// packages/focus/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/ 
});

parcelRegister("a9mZZ", function(module, exports) {

$parcel$export(module.exports, "sort", () => src_default);
$parcel$export(module.exports, "default", () => module_default);
// node_modules/sortablejs/modular/sortable.esm.js
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj2) {
        return typeof obj2;
    };
    else _typeof = function(obj2) {
        return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
    return _typeof(obj);
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var version = "1.15.2";
function userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/* @__PURE__ */ navigator.userAgent.match(pattern);
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
    capture: false,
    passive: false
};
function on(el, event, fn) {
    el.addEventListener(event, fn, !IE11OrLess && captureMode);
}
function off(el, event, fn) {
    el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}
function matches(el, selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector, ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        }while (el = getParentOrHost(el));
    }
    return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace(R_SPACE, " ");
        }
    }
}
function css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        container = container || el.parentNode;
        if (!IE11OrLess) {
            do if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect();
                top -= containerRect.top + parseInt(css(container, "border-top-width"));
                left -= containerRect.left + parseInt(css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
function isScrolledPast(el, elSide, parentSide) {
    var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
    while(parent){
        var parentSideVal = getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === getWindowScrollingElement()) break;
        parent = getParentAutoScrollElement(parent, false);
    }
    return false;
}
function getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== Sortable.ghost && (includeDragEl || children[i] !== Sortable.dragged) && closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
function lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === Sortable.ghost || css(last, "display") === "none" || selector && !matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
function index(el, selector) {
    var index2 = 0;
    if (!el || !el.parentNode) return -1;
    while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector || matches(el, selector))) index2++;
    return index2;
}
function getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
    if (el) do {
        var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
function indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
    if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return getWindowScrollingElement();
}
function extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle(callback, ms) {
    return function() {
        if (!_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            _throttleTimeout = setTimeout(function() {
                _throttleTimeout = void 0;
            }, ms);
        }
    };
}
function cancelThrottle() {
    clearTimeout(_throttleTimeout);
    _throttleTimeout = void 0;
}
function scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function getChildContainingRectFromElement(container, options, ghostEl2) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!closest(child, options.draggable, container, false) || child.animated || child === ghostEl2) return;
        var childRect = getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var expando = "Sortable" + new Date().getTime();
function AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if (css(child, "display") === "none" || child === Sortable.ghost) return;
                animationStates.push({
                    target: child,
                    rect: getRect(child)
                });
                var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
                if (child.thisAnimationDuration) {
                    var childMatrix = matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice(indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = matrix(target, true);
                if (targetMatrix) {
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) {
                    if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                if (!isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                css(target, "transition", "");
                css(target, "transform", "");
                var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = repaint(target);
                css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    css(target, "transition", "");
                    css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function repaint(target) {
    return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults = {
    initializeByDefault: true
};
var PluginManager = {
    mount: function mount(plugin) {
        for(var option2 in defaults)if (defaults.hasOwnProperty(option2) && !(option2 in plugin)) plugin[option2] = defaults[option2];
        plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
                sortable: sortable
            }, evt));
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName](_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
        plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            _extends(defaults2, initialized.defaults);
        });
        for(var option2 in sortable.options){
            if (!sortable.options.hasOwnProperty(option2)) continue;
            var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
            if (typeof modified !== "undefined") sortable.options[option2] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl2 && rootEl2[expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
    if (window.CustomEvent && !IE11OrLess && !Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl2;
    evt.from = fromEl || rootEl2;
    evt.item = targetEl || rootEl2;
    evt.clone = cloneEl2;
    evt.oldIndex = oldIndex2;
    evt.newIndex = newIndex2;
    evt.oldDraggableIndex = oldDraggableIndex2;
    evt.newDraggableIndex = newDraggableIndex2;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
    var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
    for(var option2 in allEventProperties)evt[option2] = allEventProperties[option2];
    if (rootEl2) rootEl2.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var _excluded = [
    "evt"
];
var pluginEvent2 = function pluginEvent3(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data = _objectWithoutProperties(_ref, _excluded);
    PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
        dragEl: dragEl,
        parentEl: parentEl,
        ghostEl: ghostEl,
        rootEl: rootEl,
        nextEl: nextEl,
        lastDownEl: lastDownEl,
        cloneEl: cloneEl,
        cloneHidden: cloneHidden,
        dragStarted: moved,
        putSortable: putSortable,
        activeSortable: Sortable.active,
        originalEvent: originalEvent,
        oldIndex: oldIndex,
        oldDraggableIndex: oldDraggableIndex,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        hideGhostForTarget: _hideGhostForTarget,
        unhideGhostForTarget: _unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            _dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function _dispatchEvent(info) {
    dispatchEvent(_objectSpread2({
        putSortable: putSortable,
        cloneEl: cloneEl,
        targetEl: dragEl,
        rootEl: rootEl,
        oldIndex: oldIndex,
        oldDraggableIndex: oldDraggableIndex,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex
    }, info));
}
var dragEl;
var parentEl;
var ghostEl;
var rootEl;
var nextEl;
var lastDownEl;
var cloneEl;
var cloneHidden;
var oldIndex;
var newIndex;
var oldDraggableIndex;
var newDraggableIndex;
var activeGroup;
var putSortable;
var awaitingDragStarted = false;
var ignoreNextClick = false;
var sortables = [];
var tapEvt;
var touchEvt;
var lastDx;
var lastDy;
var tapDistanceLeft;
var tapDistanceTop;
var moved;
var lastTarget;
var lastDirection;
var pastFirstInvertThresh = false;
var isCircumstantialInvert = false;
var targetMoveDistance;
var ghostRelativeParent;
var ghostRelativeParentInitialScroll = [];
var _silent = false;
var savedInputChecked = [];
var documentExists = typeof document !== "undefined";
var PositionGhostAbsolutely = IOS;
var CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float";
var supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div");
var supportCssPointerEvents = function() {
    if (!documentExists) return;
    if (IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}();
var _detectDirection = function _detectDirection2(el, options) {
    var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
};
var _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
};
var _detectNearestEmptySortable = function _detectNearestEmptySortable2(x, y) {
    var ret;
    sortables.some(function(sortable) {
        var threshold = sortable[expando].options.emptyInsertThreshold;
        if (!threshold || lastChild(sortable)) return;
        var rect = getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
};
var _prepareGroup = function _prepareGroup2(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl2, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl2, evt), pull)(to, from, dragEl2, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || _typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
};
var _hideGhostForTarget = function _hideGhostForTarget2() {
    if (!supportCssPointerEvents && ghostEl) css(ghostEl, "display", "none");
};
var _unhideGhostForTarget = function _unhideGhostForTarget2() {
    if (!supportCssPointerEvents && ghostEl) css(ghostEl, "display", "");
};
if (documentExists && !ChromeForAndroid) document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        ignoreNextClick = false;
        return false;
    }
}, true);
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
    if (dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[expando]._onDragOver(event);
        }
    }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
    if (dragEl) dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
};
function Sortable(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el;
    this.options = options = _extends({}, options);
    el[expando] = this;
    var defaults2 = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return _detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl2) {
            dataTransfer.setData("Text", dragEl2.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && !Safari,
        emptyInsertThreshold: 5
    };
    PluginManager.initializePlugins(this, el, defaults2);
    for(var name in defaults2)!(name in options) && (options[name] = defaults2[name]);
    _prepareGroup(options);
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    this.nativeDraggable = options.forceFallback ? false : supportDraggable;
    if (this.nativeDraggable) this.options.touchStartThreshold = 1;
    if (options.supportPointer) on(el, "pointerdown", this._onTapStart);
    else {
        on(el, "mousedown", this._onTapStart);
        on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        on(el, "dragover", this);
        on(el, "dragenter", this);
    }
    sortables.push(this.el);
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */ {
    constructor: Sortable,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        _saveInputCheckedState(el);
        if (dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return;
        if (originalTarget.isContentEditable) return;
        if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if (lastDownEl === target) return;
        oldIndex = index(target);
        oldDraggableIndex = index(target, options.draggable);
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                _dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                pluginEvent2("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return;
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    _dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    pluginEvent2("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return;
            }
        }
        if (options.handle && !closest(originalTarget, options.handle, el, false)) return;
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(evt, touch, target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !dragEl && target.parentNode === el) {
            var dragRect = getRect(target);
            rootEl = el;
            dragEl = target;
            parentEl = dragEl.parentNode;
            nextEl = dragEl.nextSibling;
            lastDownEl = target;
            activeGroup = options.group;
            Sortable.dragged = dragEl;
            tapEvt = {
                target: dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            tapDistanceLeft = tapEvt.clientX - dragRect.left;
            tapDistanceTop = tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn2() {
                pluginEvent2("delayEnded", _this, {
                    evt: evt
                });
                if (Sortable.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                _this._disableDelayedDragEvents();
                if (!FireFox && _this.nativeDraggable) dragEl.draggable = true;
                _this._triggerDragStart(evt, touch);
                _dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                });
                toggleClass(dragEl, options.chosenClass, true);
            };
            options.ignore.split(",").forEach(function(criteria) {
                find(dragEl, criteria.trim(), _disableDraggable);
            });
            on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
            on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
            on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
            on(ownerDocument, "mouseup", _this._onDrop);
            on(ownerDocument, "touchend", _this._onDrop);
            on(ownerDocument, "touchcancel", _this._onDrop);
            if (FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                dragEl.draggable = true;
            }
            pluginEvent2("delayStart", this, {
                evt: evt
            });
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
                if (Sortable.eventCanceled) {
                    this._onDrop();
                    return;
                }
                on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                on(ownerDocument, "touchend", _this._disableDelayedDrag);
                on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        dragEl && _disableDraggable(dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        off(ownerDocument, "mouseup", this._disableDelayedDrag);
        off(ownerDocument, "touchend", this._disableDelayedDrag);
        off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(evt, touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) on(document, "pointermove", this._onTouchMove);
            else if (touch) on(document, "touchmove", this._onTouchMove);
            else on(document, "mousemove", this._onTouchMove);
        } else {
            on(dragEl, "dragend", this);
            on(rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) _nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        awaitingDragStarted = false;
        if (rootEl && dragEl) {
            pluginEvent2("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) on(document, "dragover", _checkOutsideTargetEl);
            var options = this.options;
            !fallback && toggleClass(dragEl, options.dragClass, false);
            toggleClass(dragEl, options.ghostClass, true);
            Sortable.active = this;
            fallback && this._appendGhost();
            _dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if (touchEvt) {
            this._lastX = touchEvt.clientX;
            this._lastY = touchEvt.clientY;
            _hideGhostForTarget();
            var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            dragEl.parentNode[expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[expando]) {
                    var inserted = void 0;
                    inserted = parent[expando]._onDragOver({
                        clientX: touchEvt.clientX,
                        clientY: touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent;
            }while (parent = parent.parentNode);
            _unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(evt) {
        if (tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            if (!Sortable.active && !awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if (ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - (lastDx || 0);
                    ghostMatrix.f += dy - (lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                css(ghostEl, "webkitTransform", cssMatrix);
                css(ghostEl, "mozTransform", cssMatrix);
                css(ghostEl, "msTransform", cssMatrix);
                css(ghostEl, "transform", cssMatrix);
                lastDx = dx;
                lastDy = dy;
                touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        if (!ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
            if (PositionGhostAbsolutely) {
                ghostRelativeParent = container;
                while(css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document)ghostRelativeParent = ghostRelativeParent.parentNode;
                if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
                    if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
                    rect.top += ghostRelativeParent.scrollTop;
                    rect.left += ghostRelativeParent.scrollLeft;
                } else ghostRelativeParent = getWindowScrollingElement();
                ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
            }
            ghostEl = dragEl.cloneNode(true);
            toggleClass(ghostEl, options.ghostClass, false);
            toggleClass(ghostEl, options.fallbackClass, true);
            toggleClass(ghostEl, options.dragClass, true);
            css(ghostEl, "transition", "");
            css(ghostEl, "transform", "");
            css(ghostEl, "box-sizing", "border-box");
            css(ghostEl, "margin", 0);
            css(ghostEl, "top", rect.top);
            css(ghostEl, "left", rect.left);
            css(ghostEl, "width", rect.width);
            css(ghostEl, "height", rect.height);
            css(ghostEl, "opacity", "0.8");
            css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
            css(ghostEl, "zIndex", "100000");
            css(ghostEl, "pointerEvents", "none");
            Sortable.ghost = ghostEl;
            container.appendChild(ghostEl);
            css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(evt, fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        pluginEvent2("dragStart", this, {
            evt: evt
        });
        if (Sortable.eventCanceled) {
            this._onDrop();
            return;
        }
        pluginEvent2("setupClone", this);
        if (!Sortable.eventCanceled) {
            cloneEl = clone(dragEl);
            cloneEl.removeAttribute("id");
            cloneEl.draggable = false;
            cloneEl.style["will-change"] = "";
            this._hideClone();
            toggleClass(cloneEl, this.options.chosenClass, false);
            Sortable.clone = cloneEl;
        }
        _this.cloneId = _nextTick(function() {
            pluginEvent2("clone", _this);
            if (Sortable.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) rootEl.insertBefore(cloneEl, dragEl);
            _this._hideClone();
            _dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && toggleClass(dragEl, options.dragClass, true);
        if (fallback) {
            ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            off(document, "mouseup", _this._onDrop);
            off(document, "touchend", _this._onDrop);
            off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, dragEl);
            }
            on(document, "drop", _this);
            css(dragEl, "transform", "translateZ(0)");
        }
        awaitingDragStarted = true;
        _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
        on(document, "selectstart", _this);
        moved = true;
        if (Safari) css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if (_silent) return;
        function dragOverEvent(name, extra) {
            pluginEvent2(name, _this, _objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target2, after2) {
                    return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
                },
                changed: changed
            }, extra));
        }
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    toggleClass(dragEl, options.ghostClass, true);
                }
                if (putSortable !== _this && _this !== Sortable.active) putSortable = _this;
                else if (_this === Sortable.active && putSortable) putSortable = null;
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            if (target === dragEl && !dragEl.animated || target === el && !target.animated) lastTarget = null;
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
                !insertion && nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        function changed() {
            newIndex = index(dragEl);
            newDraggableIndex = index(dragEl, options.draggable);
            _dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: newIndex,
                newDraggableIndex: newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if (Sortable.eventCanceled) return completedFired;
        if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = getRect(dragEl);
            dragOverEvent("dragOverValid");
            if (Sortable.eventCanceled) return completedFired;
            if (revert) {
                parentEl = rootEl;
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!Sortable.eventCanceled) {
                    if (nextEl) rootEl.insertBefore(dragEl, nextEl);
                    else rootEl.appendChild(dragEl);
                }
                return completed(true);
            }
            var elLastChild = lastChild(el, options.draggable);
            if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                if (elLastChild === dragEl) return completed(false);
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = getRect(target);
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) el.insertBefore(dragEl, elLastChild.nextSibling);
                    else el.appendChild(dragEl);
                    parentEl = el;
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
                var firstChild = getChild(el, 0, options, true);
                if (firstChild === dragEl) return completed(false);
                target = firstChild;
                targetRect = getRect(target);
                if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore(dragEl, firstChild);
                    parentEl = el;
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if (lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    pastFirstInvertThresh = false;
                    isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    var dragIndex = index(dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = parentEl.children[dragIndex];
                    }while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
                }
                if (direction === 0 || sibling === target) return completed(false);
                lastTarget = target;
                lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    _silent = true;
                    setTimeout(_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild(dragEl);
                    else target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
                    if (scrolledPastTop) scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    parentEl = dragEl.parentNode;
                    if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains(dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        off(document, "mousemove", this._onTouchMove);
        off(document, "touchmove", this._onTouchMove);
        off(document, "pointermove", this._onTouchMove);
        off(document, "dragover", nearestEmptyInsertDetectEvent);
        off(document, "mousemove", nearestEmptyInsertDetectEvent);
        off(document, "touchmove", nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        off(ownerDocument, "mouseup", this._onDrop);
        off(ownerDocument, "touchend", this._onDrop);
        off(ownerDocument, "pointerup", this._onDrop);
        off(ownerDocument, "touchcancel", this._onDrop);
        off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(evt) {
        var el = this.el, options = this.options;
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);
        pluginEvent2("drop", this, {
            evt: evt
        });
        parentEl = dragEl && dragEl.parentNode;
        newIndex = index(dragEl);
        newDraggableIndex = index(dragEl, options.draggable);
        if (Sortable.eventCanceled) {
            this._nulling();
            return;
        }
        awaitingDragStarted = false;
        isCircumstantialInvert = false;
        pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        _cancelNextTick(this.cloneId);
        _cancelNextTick(this._dragStartId);
        if (this.nativeDraggable) {
            off(document, "drop", this);
            off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if (Safari) css(document.body, "user-select", "");
        css(dragEl, "transform", "");
        if (evt) {
            if (moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
            if (dragEl) {
                if (this.nativeDraggable) off(dragEl, "dragend", this);
                _disableDraggable(dragEl);
                dragEl.style["will-change"] = "";
                if (moved && !awaitingDragStarted) toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
                toggleClass(dragEl, this.options.chosenClass, false);
                _dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if (rootEl !== parentEl) {
                    if (newIndex >= 0) {
                        _dispatchEvent({
                            rootEl: parentEl,
                            name: "add",
                            toEl: parentEl,
                            fromEl: rootEl,
                            originalEvent: evt
                        });
                        _dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: parentEl,
                            originalEvent: evt
                        });
                        _dispatchEvent({
                            rootEl: parentEl,
                            name: "sort",
                            toEl: parentEl,
                            fromEl: rootEl,
                            originalEvent: evt
                        });
                        _dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: parentEl,
                            originalEvent: evt
                        });
                    }
                    putSortable && putSortable.save();
                } else {
                    if (newIndex !== oldIndex) {
                        if (newIndex >= 0) {
                            _dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: parentEl,
                                originalEvent: evt
                            });
                            _dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if (Sortable.active) {
                    if (newIndex == null || newIndex === -1) {
                        newIndex = oldIndex;
                        newDraggableIndex = oldDraggableIndex;
                    }
                    _dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: parentEl,
                        originalEvent: evt
                    });
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        pluginEvent2("nulling", this);
        rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
        savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        savedInputChecked.length = lastDx = lastDy = 0;
    },
    handleEvent: function handleEvent(evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if (dragEl) {
                    this._onDragOver(evt);
                    _globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if (closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl2 = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl2.children[i];
            if (closest(el, this.options.draggable, rootEl2, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl2.removeChild(items[id]);
                rootEl2.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") _prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        pluginEvent2("destroy", this);
        var el = this.el;
        el[expando] = null;
        off(el, "mousedown", this._onTapStart);
        off(el, "touchstart", this._onTapStart);
        off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            off(el, "dragover", this);
            off(el, "dragenter", this);
        }
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
            el2.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        sortables.splice(sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!cloneHidden) {
            pluginEvent2("hideClone", this);
            if (Sortable.eventCanceled) return;
            css(cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && cloneEl.parentNode) cloneEl.parentNode.removeChild(cloneEl);
            cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable2) {
        if (putSortable2.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if (cloneHidden) {
            pluginEvent2("showClone", this);
            if (Sortable.eventCanceled) return;
            if (dragEl.parentNode == rootEl && !this.options.group.revertClone) rootEl.insertBefore(cloneEl, dragEl);
            else if (nextEl) rootEl.insertBefore(cloneEl, nextEl);
            else rootEl.appendChild(cloneEl);
            if (this.options.group.revertClone) this.animate(dragEl, cloneEl);
            css(cloneEl, "display", "");
            cloneHidden = false;
        }
    }
};
function _globalDragOver(evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
    if (window.CustomEvent && !IE11OrLess && !Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl2;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function _disableDraggable(el) {
    el.draggable = false;
}
function _unsilent() {
    _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = getRect(getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
    var lastElRect = getRect(lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = getChildContainingRectFromElement(sortable.el, sortable.options, ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
            if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) pastFirstInvertThresh = true;
            if (!pastFirstInvertThresh) {
                if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) return -lastDirection;
            } else invert = true;
        } else {
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return _getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
function _getInsertDirection(target) {
    if (index(dragEl) < index(target)) return 1;
    else return -1;
}
function _generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function _saveInputCheckedState(root) {
    savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && savedInputChecked.push(el);
    }
}
function _nextTick(fn) {
    return setTimeout(fn, 0);
}
function _cancelNextTick(id) {
    return clearTimeout(id);
}
if (documentExists) on(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
Sortable.utils = {
    on: on,
    off: off,
    css: css,
    find: find,
    is: function is(el, selector) {
        return !!closest(el, selector, el, false);
    },
    extend: extend,
    throttle: throttle,
    closest: closest,
    toggleClass: toggleClass,
    clone: clone,
    index: index,
    nextTick: _nextTick,
    cancelNextTick: _cancelNextTick,
    detectDirection: _detectDirection,
    getChild: getChild
};
Sortable.get = function(element) {
    return element[expando];
};
Sortable.mount = function() {
    for(var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++)plugins2[_key] = arguments[_key];
    if (plugins2[0].constructor === Array) plugins2 = plugins2[0];
    plugins2.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
        PluginManager.mount(plugin);
    });
};
Sortable.create = function(el, options) {
    return new Sortable(el, options);
};
Sortable.version = version;
var autoScrolls = [];
var scrollEl;
var scrollRootEl;
var scrolling = false;
var lastAutoScrollX;
var lastAutoScrollY;
var touchEvt$1;
var pointerElemChangedInterval;
function AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) on(document, "touchmove", this._handleFallbackAutoScroll);
                else on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop3() {
            if (this.sortable.nativeDraggable) off(document, "dragover", this._handleAutoScroll);
            else {
                off(document, "pointermove", this._handleFallbackAutoScroll);
                off(document, "touchmove", this._handleFallbackAutoScroll);
                off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            clearPointerElemChangedInterval();
            clearAutoScrolls();
            cancelThrottle();
        },
        nulling: function nulling() {
            touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
            autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            touchEvt$1 = evt;
            if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
                autoScroll(evt, this.options, elem, fallback);
                var ogElemScroller = getParentAutoScrollElement(elem, true);
                if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
                    pointerElemChangedInterval && clearPointerElemChangedInterval();
                    pointerElemChangedInterval = setInterval(function() {
                        var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            clearAutoScrolls();
                        }
                        autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    lastAutoScrollX = x;
                    lastAutoScrollY = y;
                }
            } else {
                if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
                    clearAutoScrolls();
                    return;
                }
                autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return _extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function clearAutoScrolls() {
    autoScrolls.forEach(function(autoScroll2) {
        clearInterval(autoScroll2.pid);
    });
    autoScrolls = [];
}
function clearPointerElemChangedInterval() {
    clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle(function(evt, options, rootEl2, isFallback) {
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    if (scrollRootEl !== rootEl2) {
        scrollRootEl = rootEl2;
        clearAutoScrolls();
        scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if (scrollEl === true) scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
    var layersOut = 0;
    var currentParent = scrollEl;
    do {
        var el = currentParent, rect = getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!autoScrolls[i]) autoScrolls[i] = {};
        }
        if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
            autoScrolls[layersOut].el = el;
            autoScrolls[layersOut].vx = vx;
            autoScrolls[layersOut].vy = vy;
            clearInterval(autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                autoScrolls[layersOut].pid = setInterval((function() {
                    if (isFallback && this.layer === 0) Sortable.active._onTouchMove(touchEvt$1);
                    var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") return;
                    }
                    scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
    scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
    var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable2 || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl2,
            putSortable: putSortable2
        });
    }
};
function Revert() {}
Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex2 = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex2;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable2) putSortable2.captureAnimationState();
        var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl2, nextSibling);
        else this.sortable.el.appendChild(dragEl2);
        this.sortable.animateAll();
        if (putSortable2) putSortable2.animateAll();
    },
    drop: drop
};
_extends(Revert, {
    pluginName: "revertOnSpill"
});
function Remove() {}
Remove.prototype = {
    onSpill: function onSpill2(_ref4) {
        var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
        var parentSortable = putSortable2 || this.sortable;
        parentSortable.captureAnimationState();
        dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
        parentSortable.animateAll();
    },
    drop: drop
};
_extends(Remove, {
    pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
var sortable_esm_default = Sortable;
// packages/sort/src/index.js
function src_default(Alpine2) {
    Alpine2.directive("sort", (el, { value, modifiers, expression }, { effect, evaluate, evaluateLater, cleanup })=>{
        if (value === "config") return;
        if (value === "handle") return;
        if (value === "group") return;
        if (value === "key" || value === "item") {
            if ([
                void 0,
                null,
                ""
            ].includes(expression)) return;
            el._x_sort_key = evaluate(expression);
            return;
        }
        let preferences = {
            hideGhost: !modifiers.includes("ghost"),
            useHandles: !!el.querySelector("[x-sort\\:handle]"),
            group: getGroupName(el, modifiers)
        };
        let handleSort = generateSortHandler(expression, evaluateLater);
        let config = getConfigurationOverrides(el, modifiers, evaluate);
        let sortable = initSortable(el, config, preferences, (key, position)=>{
            handleSort(key, position);
        });
        cleanup(()=>sortable.destroy());
    });
}
function generateSortHandler(expression, evaluateLater) {
    if ([
        void 0,
        null,
        ""
    ].includes(expression)) return ()=>{};
    let handle = evaluateLater(expression);
    return (key, position)=>{
        Alpine.dontAutoEvaluateFunctions(()=>{
            handle(// If a function is returned, call it with the key/position params...
            (received)=>{
                if (typeof received === "function") received(key, position);
            }, // Provide $key and $position to the scope in case they want to call their own function...
            {
                scope: {
                    // Supporting both `$item` AND `$key` ($key for BC)...
                    $key: key,
                    $item: key,
                    $position: position
                }
            });
        });
    };
}
function getConfigurationOverrides(el, modifiers, evaluate) {
    return el.hasAttribute("x-sort:config") ? evaluate(el.getAttribute("x-sort:config")) : {};
}
function initSortable(el, config, preferences, handle) {
    let ghostRef;
    let options = {
        animation: 150,
        handle: preferences.useHandles ? "[x-sort\\:handle]" : null,
        group: preferences.group,
        filter (e) {
            if (!el.querySelector("[x-sort\\:item]")) return false;
            let itemHasAttribute = e.target.closest("[x-sort\\:item]");
            return itemHasAttribute ? false : true;
        },
        onSort (e) {
            if (e.from !== e.to) {
                if (e.to !== e.target) return;
            }
            let key = e.item._x_sort_key;
            let position = e.newIndex;
            if (key !== void 0 || key !== null) handle(key, position);
        },
        onStart () {
            document.body.classList.add("sorting");
            ghostRef = document.querySelector(".sortable-ghost");
            if (preferences.hideGhost && ghostRef) ghostRef.style.opacity = "0";
        },
        onEnd () {
            document.body.classList.remove("sorting");
            if (preferences.hideGhost && ghostRef) ghostRef.style.opacity = "1";
            ghostRef = void 0;
            keepElementsWithinMorphMarkers(el);
        }
    };
    return new sortable_esm_default(el, {
        ...options,
        ...config
    });
}
function keepElementsWithinMorphMarkers(el) {
    let cursor = el.firstChild;
    while(cursor.nextSibling){
        if (cursor.textContent.trim() === "[if ENDBLOCK]><![endif]") {
            el.append(cursor);
            break;
        }
        cursor = cursor.nextSibling;
    }
}
function getGroupName(el, modifiers) {
    if (el.hasAttribute("x-sort:group")) return el.getAttribute("x-sort:group");
    return modifiers.indexOf("group") !== -1 ? modifiers[modifiers.indexOf("group") + 1] : null;
}
// packages/sort/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

sortablejs/modular/sortable.esm.js:
  (**!
   * Sortable 1.15.2
   * @author	RubaXa   <trash@rubaxa.org>
   * @author	owenm    <owen23355@gmail.com>
   * @license MIT
   *)
*/ 
});

parcelRegister("lrtgD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c2d27d3da567dd$export$2e2bcd8739ae039);
var $f9c2d27d3da567dd$export$2e2bcd8739ae039 = ({ options: options })=>({
        options: options,
        newOption: "",
        addOption () {
            if (this.newOption.trim() === "") return;
            const uniqueId = this.slugify(this.newOption) + "-" + Math.floor(Math.random() * 10000);
            const newOptionObj = {
                text: this.newOption,
                value: uniqueId,
                order: this.options.length + 1
            };
            this.options.push(newOptionObj);
            this.newOption = "";
        },
        deleteOption (index) {
            // Event filtering
            if (document.activeElement != this.$el) return;
            this.options.splice(index, 1);
            this.options.forEach((option, idx)=>option.order = idx + 1);
        },
        dragStart (event, index) {
            event.dataTransfer.setData("optionIndex", index);
        },
        drop (event, dropIndex) {
            const dragIndex = event.dataTransfer.getData("optionIndex");
            const draggedItem = this.options.splice(dragIndex, 1)[0];
            this.options.splice(dropIndex, 0, draggedItem);
            this.options.forEach((option, idx)=>option.order = idx + 1);
        },
        slugify (text) {
            return text.toString().toLowerCase().replace(/\s+/g, "-").replace(/[^\w\-]+/g, "").replace(/\-\-+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
        },
        serializedOptions () {
            return JSON.stringify(this.options);
        }
    });

});

parcelRegister("bV58F", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad9010a1120133a$export$2e2bcd8739ae039);
var $8ad9010a1120133a$export$2e2bcd8739ae039 = ()=>({
        search: "",
        searchUrl: "",
        isCommandPaletteOpen: false,
        closingCallback: ()=>{},
        handleOpen (e) {
            if (e.detail.search_url) {
                this.searchUrl = e.detail.search_url;
                this.search = e.detail.search || "";
                this.isCommandPaletteOpen = true;
                this.closingCallback = e.detail.closingCallback || this.closingCallback;
            }
            if (this.search) this.searchData();
        },
        handleClose (e) {
            this.isCommandPaletteOpen = false;
            this.closingCallback();
        },
        updateURL () {
            let baseUrl = this.searchUrl;
            // Prepend a placeholder domain to form a full URL for parsing
            const placeholderDomain = "https://placeholder.com";
            let url;
            try {
                url = new URL(placeholderDomain + baseUrl);
            } catch (e) {
                console.error("Invalid URL provided.");
                return;
            }
            // Set or update the "search" query parameter
            if (this.search) url.searchParams.set("search", this.search);
            else url.searchParams.delete("search");
            // Remove the placeholder domain from the final URL string
            return url.toString().replace(placeholderDomain, "");
        },
        searchData () {
            let newUrl = this.updateURL();
            htmx.ajax("GET", newUrl, {
                target: "#candidate_palette_results",
                swap: "innerHTML"
            });
        }
    });

});

parcelRegister("lguVw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7b314fc56502022$export$2e2bcd8739ae039);
var $f7b314fc56502022$export$2e2bcd8739ae039 = ({ type: type, subject: subject, body: body, templates: templates, name: name, url: url, actionButtonText: actionButtonText, editorId: editorId })=>({
        type: // Props
        type,
        subject: subject,
        body: body,
        templates: templates,
        name: name,
        url: url,
        actionButtonText: actionButtonText,
        editorId: editorId,
        // State
        lastFocusedElement: null,
        // Models
        template: "",
        // Placeholder functionality
        placeholders: [
            {
                text: "Candidate Name",
                value: "candidate_name",
                preview: "Susan"
            },
            {
                text: "Candidate Surname",
                value: "candidate_surname",
                preview: "Doe"
            },
            {
                text: "Candidate ID",
                value: "candidate_id",
                preview: "j6sXGVs7qYrZrpWZ"
            },
            {
                text: "Position Title",
                value: "position_name",
                preview: "Lead Researcher"
            }
        ],
        insertPlaceholderBody (placeholderValue) {
            // Define the value to be inserted
            let insertValue = `{{ ${placeholderValue} }}`;
            let editor = window[this.editorId];
            // Insert the placeholder at the current cursor position
            editor.model.change((writer)=>{
                const insertPosition = editor.model.document.selection.getFirstPosition();
                editor.model.insertContent(writer.createText(insertValue), insertPosition);
            });
        },
        insertPlaceholderSubject (input, placeholderValue) {
            let insertValue = `{{ ${placeholderValue} }}`;
            const startPos = input.selectionStart;
            const endPos = input.selectionEnd;
            const beforeCursor = input.value.substring(0, startPos);
            const afterCursor = input.value.substring(endPos);
            // If the cursor is next to a character, add a space.
            let prefixSpace = "";
            let suffixSpace = "";
            if (startPos > 0 && beforeCursor.at(-1) !== " ") prefixSpace = " ";
            if (afterCursor.at(0) !== " ") suffixSpace = " ";
            insertValue = prefixSpace + insertValue + suffixSpace;
            input.value = beforeCursor + insertValue + afterCursor;
            // Update the cursor position after inserting text
            const newPosition = startPos + insertValue.length;
            input.setSelectionRange(newPosition, newPosition);
            // Update AlpineJS's internal state for the input/textarea
            this.subject = input.value;
        },
        insertPlaceholder (input, placeholderValue) {
            if (input && input.id === "subject") this.insertPlaceholderSubject(input, placeholderValue);
            else if (input && input.role === "textbox") this.insertPlaceholderBody(placeholderValue);
        },
        updateTemplate () {
            if (this.template === "0") {
                this.subject = "";
                this.body = "";
            } else fetch(`/api/templates/${this.template}/`).then((response)=>{
                // Check if the request was successful
                if (!response.ok) throw new Error("Response was not ok");
                return response.json();
            }).then((data)=>{
                this.subject = data.subject;
                this.body = data.html_body;
            }).catch((error)=>{
                console.error("There was a problem with the fetch operation:", error.message);
            });
        }
    });

});

parcelRegister("busg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d86a8d4647c102$export$2e2bcd8739ae039);
/** Filter component
 * Alpine properties
 * $popover
 * $store: filterFields
 *
 */ var $85d86a8d4647c102$export$2e2bcd8739ae039 = ({ fieldName: fieldName, fieldId: fieldId, fieldInitializedWithData: fieldInitializedWithData, resetFromParent: resetFromParent, type: type, url: url, target: target, initialOpenState: initialOpenState, queryParam: queryParam, updateStore: updateStore, isEmpty: isEmpty, displayText: displayText, initFromURL: initFromURL, initFromStore: initFromStore, cleanValue: cleanValue, cleanValueAndStore: cleanValueAndStore, labelText: labelText, manipulate_data_and_modify_url: manipulate_data_and_modify_url })=>({
        fieldName: // Props
        fieldName,
        fieldId: fieldId,
        fieldInitializedWithData: fieldInitializedWithData,
        resetFromParent: resetFromParent,
        type: type,
        url: url,
        target: target || "#candidates_table_wrapper",
        initialOpenState: initialOpenState,
        queryParam: // Unimplemented methods. Should be implemented later.
        queryParam,
        updateStore: updateStore,
        isEmpty: isEmpty,
        displayText: displayText,
        initFromURL: initFromURL,
        initFromStore: initFromStore,
        cleanValue: cleanValue,
        cleanValueAndStore: cleanValueAndStore,
        labelText: labelText,
        manipulate_data_and_modify_url: manipulate_data_and_modify_url,
        // State
        panelLocked: false,
        submitted: false,
        requestInProgress: false,
        timeoutId: null,
        // Common methods.
        hide () {
            this.__wrapper.classList.add("hidden");
        },
        remove () {
            this.__wrapper.remove();
        },
        initializeButton () {
            this.initialOpenState && this.$popover.open();
            this.$watch("$popover.isOpen", (value)=>{
                // cleanValueAndStore(); $store.filterFields.has(fieldId) && $store.filterFields.remove(fieldId); remove()
                if (this.submitted) this.submitted = false;
                else {
                    if (!value && !this.panelLocked) {
                        if (this.fieldInitializedWithData) {
                            this.resetFromParent = true;
                            this.cleanValue();
                            if (this.manipulate_data_and_modify_url === true) this.initFromURL();
                            else this.initFromStore();
                        } else {
                            this.$store.filterFields.remove(this.fieldId);
                            this.remove();
                        }
                    } else if (!value && this.panelLocked) this.$popover.open();
                }
            });
        },
        // Event listeners
        openFilterPanelListener: {
            /** Opens the panel on `open-filter-panel` event if `fieldId` matches with the event detail.
     *
     */ ["x-on:open-filter-panel.window"] () {
                this.$event.detail === this.fieldId && this.$popover.open();
            }
        },
        get __wrapper () {
            return this.$root.parentElement;
        }
    });

});

parcelRegister("cSEGC", function(module, exports) {

$parcel$export(module.exports, "default", () => $960a16a0d6d71319$export$2e2bcd8739ae039);
var $960a16a0d6d71319$export$2e2bcd8739ae039 = ({ modelValue: modelValue = null, choices: choices = [], htmlName: htmlName = '', label: label = '' })=>({
        modelValue: // Props
        modelValue,
        label: label,
        choices: choices,
        htmlName: htmlName,
        // State
        init () {
            this.selected = this.modelValue; // Initialize selected in init()
            this.query = '';
        },
        selected: null,
        query: '',
        // Computed
        get filteredOptions () {
            return this.query === '' ? this.choices : this.choices.filter((option)=>{
                return option.label.toLowerCase().includes(this.query.toLowerCase());
            });
        },
        // Methods
        handleQueryChange (event) {
            this.query = event.target.value;
        }
    });

});

parcelRegister("8DTOO", function(module, exports) {

$parcel$export(module.exports, "default", () => $64ad43a0866d003e$export$2e2bcd8739ae039);
/**
 * File upload handler with IndexedDB persistence
 * @typedef {Object} FileUploadState
 * @property {string} storageKey - Unique identifier for the file in IndexedDB
 * @property {string} fileName - Name of the uploaded file
 * @property {string} fileTempURL - Temp URL of the file to let user download
 * @property {string|null} fileData - Base64 data URL of the file content
 */ /**
 * Creates a new file upload handler instance
 * @param {Object} params - Initialization parameters
 * @param {string} [params.storageKey] - Initial storage key, typically provided by server
 * @param {number} [params.maxFileSize=5] - Maximum file size in MB (defaults to 5MB)
 * @returns {FileUploadState} File upload state and methods
 */ var $64ad43a0866d003e$export$2e2bcd8739ae039 = ({ storageKey: storageKey, maxFileSize: maxFileSize = 5 })=>({
        storageKey: storageKey,
        fileName: "",
        fileTempURL: "",
        fileData: null,
        DB_NAME: "FileUploadDB",
        STORE_NAME: "files",
        maxFileSize: maxFileSize,
        /**
   * Opens IndexedDB connection
   * @returns {Promise<IDBDatabase>}
   */ async openDB () {
            return new Promise((resolve, reject)=>{
                const request = indexedDB.open(this.DB_NAME, 1);
                request.onerror = ()=>reject(request.error);
                request.onsuccess = ()=>resolve(request.result);
                request.onupgradeneeded = (event)=>{
                    const db = event.target.result;
                    if (!db.objectStoreNames.contains(this.STORE_NAME)) {
                        const store = db.createObjectStore(this.STORE_NAME, {
                            keyPath: "key"
                        });
                        // Add timestamp index for expire policy if needed
                        store.createIndex("timestamp", "timestamp", {
                            unique: false
                        });
                    }
                };
            });
        },
        /**
   * Cleans up database, removing all files except the current one
   * @param {string} currentKey - Key of the file to keep
   * @returns {Promise<void>}
   */ async cleanupDB (currentKey) {
            const db = await this.openDB();
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction([
                    this.STORE_NAME
                ], "readwrite");
                const store = transaction.objectStore(this.STORE_NAME);
                // Get all keys and delete everything except current file
                const request = store.getAllKeys();
                request.onsuccess = ()=>{
                    const keys = request.result;
                    keys.forEach((key)=>{
                        if (key !== currentKey) store.delete(key);
                    });
                };
                request.onerror = ()=>reject(request.error);
                transaction.oncomplete = ()=>{
                    db.close();
                    resolve();
                };
            });
        },
        /**
   * Saves file data to IndexedDB and cleans up old files
   * @param {string} key - Storage key
   * @param {Object} data - File data to store
   * @returns {Promise<void>}
   */ async saveToDB (key, data) {
            const db = await this.openDB();
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction([
                    this.STORE_NAME
                ], "readwrite");
                const store = transaction.objectStore(this.STORE_NAME);
                // Add timestamp to data
                const fileData = {
                    key: key,
                    ...data,
                    timestamp: new Date().getTime()
                };
                const request = store.put(fileData);
                request.onerror = ()=>reject(request.error);
                request.onsuccess = async ()=>{
                    try {
                        // Clean up old files after successful save
                        await this.cleanupDB(key);
                        resolve();
                    } catch (e) {
                        console.warn("Error during cleanup:", e);
                        resolve(); // Still resolve as the file was saved successfully
                    }
                };
                transaction.oncomplete = ()=>db.close();
            });
        },
        /**
   * Retrieves file data from IndexedDB
   * @param {string} key - Storage key to retrieve
   * @returns {Promise<Object|null>}
   */ async getFromDB (key) {
            const db = await this.openDB();
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction([
                    this.STORE_NAME
                ], "readonly");
                const store = transaction.objectStore(this.STORE_NAME);
                const request = store.get(key);
                request.onerror = ()=>reject(request.error);
                request.onsuccess = ()=>resolve(request.result);
                transaction.oncomplete = ()=>db.close();
            });
        },
        /**
   * Removes file data from IndexedDB
   * @param {string} key - Storage key to remove
   * @returns {Promise<void>}
   */ async removeFromDB (key) {
            const db = await this.openDB();
            return new Promise((resolve, reject)=>{
                const transaction = db.transaction([
                    this.STORE_NAME
                ], "readwrite");
                const store = transaction.objectStore(this.STORE_NAME);
                const request = store.delete(key);
                request.onerror = ()=>reject(request.error);
                request.onsuccess = ()=>resolve();
                transaction.oncomplete = ()=>db.close();
            });
        },
        /**
   * Generates a unique storage key from file data
   * @param {string} fileData - Base64 data URL of file content
   * @returns {Promise<string>} Storage key prefixed with '__hrx_file__'
   */ async generateStorageKey (fileData) {
            // Convert the complete data URL string to bytes for hashing
            const encoder = new TextEncoder();
            const data = encoder.encode(fileData);
            // Generate SHA-256 hash of the data
            const hashBuffer = await crypto.subtle.digest("SHA-256", data);
            // Convert hash buffer to hexadecimal string
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            const hashHex = hashArray.map((b)=>b.toString(16).padStart(2, "0")).join("");
            return `__hrx_file__${hashHex}`;
        },
        /**
   * Initializes the file input with data from IndexedDB if available
   * @returns {Promise<void>}
   */ async init () {
            // Only proceed if we have a storage key (typically from server)
            if (this.storageKey) try {
                const savedFile = await this.getFromDB(this.storageKey);
                if (savedFile) {
                    this.fileName = savedFile.name;
                    this.fileTempURL = URL.createObjectURL(savedFile);
                    this.fileData = savedFile.data;
                    // Create and assign file to input
                    const dataTransfer = new DataTransfer();
                    const file = this.base64ToFile(savedFile.data, savedFile.name, savedFile.type);
                    dataTransfer.items.add(file);
                    this.$refs.input.files = dataTransfer.files;
                    // Notify listeners that file is attached
                    document.dispatchEvent(new Event("file_attached"));
                }
            } catch (e) {
                console.warn("Error retrieving file data:", e);
                await this.removeFromDB(this.storageKey);
            }
        },
        /**
   * Handles file upload events
   * @returns {Promise<void>}
   */ async fileHandler () {
            let file = this.$refs.input.files[0];
            if (file) {
                // Check file size limit (configurable, defaults to 5MB)
                if (file.size / 1024 / 1024 > this.maxFileSize) {
                    alert(`File size exceeds ${this.maxFileSize}MB. Please upload a file up to ${this.maxFileSize}MB.`);
                    // Clear all file data
                    this.$refs.input.value = "";
                    if (this.storageKey) await this.removeFromDB(this.storageKey);
                    this.fileName = "";
                    this.fileTempURL = null;
                    this.fileData = null;
                    this.storageKey = null;
                } else {
                    this.fileName = file.name;
                    this.fileTempURL = URL.createObjectURL(file);
                    // Convert file to data URL and save to localStorage
                    const reader = new FileReader();
                    reader.onload = async (e)=>{
                        // Store the data URL (format: "data:mime/type;base64,...")
                        this.fileData = e.target.result;
                        // Generate unique storage key based on file content
                        this.storageKey = await this.generateStorageKey(this.fileData);
                        try {
                            await this.saveToDB(this.storageKey, {
                                name: file.name,
                                type: file.type,
                                data: this.fileData
                            });
                            document.dispatchEvent(new Event("file_attached"));
                        } catch (e) {
                            console.error("Error saving file:", e);
                            alert("Error saving file. Please try again.");
                        }
                    };
                    reader.readAsDataURL(file);
                }
            }
        },
        /**
   * Converts base64 data URL back to a File object
   * @param {string} base64Data - Base64 data URL of file content
   * @param {string} filename - Name of the file
   * @param {string} type - MIME type of the file
   * @returns {File} Reconstructed File object
   */ base64ToFile (base64Data, filename, type) {
            // Extract base64 data from data URL and convert to binary
            const binaryString = window.atob(base64Data.split(",")[1]);
            const bytes = new Uint8Array(binaryString.length);
            // Convert binary string to byte array
            for(let i = 0; i < binaryString.length; i++)bytes[i] = binaryString.charCodeAt(i);
            // Create Blob and File objects from binary data
            const blob = new Blob([
                bytes
            ], {
                type: type
            });
            return new File([
                blob
            ], filename, {
                type: type
            });
        }
    });

});

parcelRegister("bKHmb", function(module, exports) {

$parcel$export(module.exports, "default", () => $88e59f55e53b00e7$export$2e2bcd8739ae039);
var $88e59f55e53b00e7$export$2e2bcd8739ae039 = ({ inputId: inputId, inputName: inputName })=>({
        inputId: // Props
        inputId,
        inputName: inputName,
        // State
        invalid: false,
        errorText: "",
        input: null,
        iti: null,
        maskPattern: "",
        nationalMode: true,
        placeholderNumberType: "MOBILE",
        // Handlers
        reset () {
            this.errorText = "";
            this.invalid = false;
        },
        getExampleNumber () {
            if (!window.intlTelInputUtils) return null;
            return window.intlTelInputUtils.getExampleNumber(this.iti.getSelectedCountryData().iso2, this.nationalMode, intlTelInputUtils.numberType[this.placeholderNumberType]);
        },
        generateMaskPattern (exampleNumber) {
            const startsWithZero = exampleNumber.startsWith("0");
            if (startsWithZero) return "0" + exampleNumber.substring(1).replace(/\d/g, "9");
            else return exampleNumber.replace(/\d/g, "9");
        },
        updateMask () {
            const example = this.getExampleNumber();
            if (example) this.maskPattern = this.generateMaskPattern(example);
        },
        handler (event) {
            this.reset();
            if (this.input.value.trim() && this.iti) {
                if (!window.intlTelInputUtils) {
                    // If utils not loaded, wait for promise and retry handler
                    this.iti.promise.then(()=>{
                        this.handler(event);
                    });
                    return; // Stop current execution
                }
                if (!this.iti.isValidNumber()) {
                    this.invalid = true;
                    const example = this.getExampleNumber();
                    // Handle case where getExampleNumber returned null
                    this.errorText = example ? `Enter a valid phone number (e.g. ${example}).` : `Enter a valid phone number.`;
                    event.preventDefault();
                    this.input.focus();
                }
            }
        },
        init () {
            this.input = document.querySelector(`#${this.inputId}`);
            this.iti = window.intlTelInput(this.input, {
                utilsScript: "https://fastly.jsdelivr.net/npm/intl-tel-input@20.3.0/build/js/utils.js",
                preferredCountries: [],
                separateDialCode: false,
                showFlags: true,
                nationalMode: this.nationalMode,
                hiddenInput: function(telInputName) {
                    return {
                        phone: inputName
                    };
                },
                initialCountry: "auto",
                placeholderNumberType: this.placeholderNumberType,
                geoIpLookup: (callback)=>{
                    fetch("https://ipapi.co/json").then((res)=>res.json()).then((data)=>callback(data.country_code)).catch(()=>callback("us"));
                },
                customPlaceholder: function(selectedCountryPlaceholder, selectedCountryData) {
                    if (selectedCountryData.name === "Turkey") return "05__ ___ __ __";
                    else return selectedCountryPlaceholder;
                }
            });
            this.iti.promise.then(()=>{
                this.updateMask();
                this.input.addEventListener("countrychange", ()=>{
                    this.updateMask();
                });
            });
        }
    });
function $88e59f55e53b00e7$var$testPhoneNumberInput() {
    const iti = window.intlTelInputGlobals.getInstance(document.querySelector("#id_phone_number"));
    const allCountries = window.intlTelInputGlobals.getCountryData();
    const form = document.querySelector("form");
    form.setAttribute("hx-swap", "none");
    form.first_name.value = "John";
    form.last_name.value = "Doe";
    form.email.value = "john.doe@example.com";
    allCountries.forEach((countryData, index)=>{
        setTimeout(()=>{
            // Set the country
            iti.setCountry(countryData.iso2);
            // Generate a valid phone number for this country
            const exampleNumber = intlTelInputUtils.getExampleNumber(countryData.iso2, true, intlTelInputUtils.numberType.MOBILE);
            // Set the number in the input
            iti.setNumber(exampleNumber);
            // Submit the form
            htmx.trigger(form, "submit");
            // Log the action
            console.log(`Tested country: ${countryData.name}, Phone: ${exampleNumber}`);
        }, 3000 * index);
    });
}

});

parcelRegister("aFSg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c57d257fcc40f70$export$2e2bcd8739ae039);
var $7c57d257fcc40f70$export$2e2bcd8739ae039 = ()=>{
    const beforeUnloadHandler = (event)=>{
        event.preventDefault();
        event.returnValue = true;
    };
    const htmxBeforeRequestHandler = (event)=>{
        // Determine if the event target is a navigation request.
        const isNavigationRequest = event.detail.boosted && event.target.tagName === "A";
        if (isNavigationRequest) {
            const isConfirmed = confirm("You have unsaved changes. Are you sure you want to navigate away?");
            if (!isConfirmed) event.preventDefault(); // Prevent navigation
        }
    };
    return {
        // State
        formData: JSON.parse(document.querySelector("#form_data").textContent),
        initialFormData: JSON.parse(document.querySelector("#form_data").textContent),
        // Methods
        init () {
            // Watch form data and add beforeUnloadHandler callback to beforeunload event when form state is dirty
            // This will prevent unintended data loss and provide better UX
            this.$watch("formData", ()=>{
                if (this.checkFormState(this.formData, this.initialFormData)) {
                    window.addEventListener("beforeunload", beforeUnloadHandler);
                    window.addEventListener("htmx:beforeRequest", htmxBeforeRequestHandler);
                } else {
                    window.removeEventListener("beforeunload", beforeUnloadHandler);
                    window.removeEventListener("htmx:beforeRequest", htmxBeforeRequestHandler);
                }
            });
            // we should handle saving, because it runs destroy in some conditions
            window.addEventListener("htmx:beforeRequest", (event)=>{
                const isSaveRequest = event.detail.elt.id == "job-settings-update-button-main" || event.detail.elt.id == "job-settings-update-button-flyout";
                if (isSaveRequest) {
                    window.removeEventListener("beforeunload", beforeUnloadHandler);
                    window.removeEventListener("htmx:beforeRequest", htmxBeforeRequestHandler);
                }
            });
        },
        // we should also handle organic destroy(navigating instead of saving)
        destroy () {
            // Remove the beforeUnloadHandler callback from beforeunload when component lifecycle ends
            window.removeEventListener("beforeunload", beforeUnloadHandler);
            window.removeEventListener("htmx:beforeRequest", htmxBeforeRequestHandler);
        },
        /**
     * Recursively checks if two objects (obj1 and obj2) are deeply equal.
     */ isDeepEqual (obj1, obj2) {
            // Fast equality check for identical references or primitives
            if (obj1 === obj2) return true;
            // Check if either argument is not an object or is null
            if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) return false;
            // Get the keys of both objects
            const keys1 = Object.keys(obj1);
            const keys2 = Object.keys(obj2);
            // If the number of properties is different, objects are not equal
            if (keys1.length !== keys2.length) return false;
            // Check each property in obj1 to ensure it exists and is equal in obj2
            for (let key of keys1){
                if (!keys2.includes(key)) return false;
                // Special handling for functions and deeper dive into nested objects
                if (typeof obj1[key] === "function" || typeof obj2[key] === "function") {
                    if (obj1[key].toString() !== obj2[key].toString()) return false;
                } else if (!this.isDeepEqual(obj1[key], obj2[key])) return false;
            }
            return true;
        },
        /**
     * Determines the dirty state of the form by comparing formData and initialFormData.
     */ checkFormState (formData, initialFormData) {
            const isDirty = !this.isDeepEqual(formData, initialFormData);
            return isDirty;
        }
    };
};

});

parcelRegister("b4EcM", function(module, exports) {

$parcel$export(module.exports, "default", () => $80ff41514b128c4d$export$2e2bcd8739ae039);
parcelRequire("5IiZx");
var $80ff41514b128c4d$export$2e2bcd8739ae039 = ({ stagesData: stagesData, url: url, pipeline: pipeline, job: job = null })=>({
        stagesData: // Props
        stagesData,
        url: url,
        pipeline: pipeline,
        job: job,
        errors: {},
        // State
        editingStageId: null,
        newStageAdded: false,
        isModalOpen: false,
        selectedStage: null,
        deletedStageId: null,
        stageApplicationCount: null,
        requestInProgress: false,
        getCsrf () {
            return JSON.parse(document.querySelector("body").getAttribute("hx-headers"))["X-CSRFToken"];
        },
        // Handlers
        addStage (stageType) {
            if (!this.newStageAdded) {
                const stageTypeIndex = this.stagesData.findIndex((typeData)=>typeData.stage_type.value === stageType);
                const newStage = {
                    id: 0,
                    color: "#94A3B8",
                    name: "",
                    description: "",
                    order: null,
                    stage_type: stageType
                };
                // Add the new stage to the end of its group
                this.stagesData[stageTypeIndex].stages.push(newStage);
                this.newStageAdded = true;
                this.editingStageId = 0;
                // Re-assign order for every stage
                this.reassignOrders();
            }
        },
        reassignOrders () {
            let order = 1;
            this.stagesData.forEach((stageTypeData)=>{
                stageTypeData.stages.forEach((stage)=>{
                    stage.order = order;
                    order++;
                });
            });
        },
        removeNewStage () {
            this.stagesData.forEach((stageTypeData)=>{
                const newStageIndex = stageTypeData.stages.findIndex((stage)=>stage.id === 0);
                if (newStageIndex !== -1) {
                    stageTypeData.stages.splice(newStageIndex, 1);
                    this.newStageAdded = false;
                }
            });
        },
        formHandler (stageData) {
            this.requestInProgress = true;
            // Form validation
            if (!stageData.name) {
                stageData.errors = {
                    name: [
                        "This field is required."
                    ]
                };
                return;
            }
            // Add pipeline and stage_type to each stage
            this.stagesData.forEach((group)=>{
                group.stages.forEach((stage)=>{
                    stage.pipeline = this.pipeline;
                    stage.stage_type = group.stage_type.value;
                });
            });
            // Convert the entire stagesData state into a JSON string
            const payload = JSON.stringify({
                pipeline: this.pipeline,
                stagesData: this.stagesData
            });
            fetch(this.url, {
                method: "POST",
                headers: {
                    "X-CSRFToken": this.getCsrf(),
                    "Content-Type": "application/json"
                },
                body: payload
            }).then(async (response)=>{
                this.requestInProgress = false;
                if (!response.ok) {
                    const errorData = await response.json();
                    const error = new Error(response.statusText);
                    error.errors = errorData;
                    throw error;
                }
                return response.json();
            }).then((data)=>{
                this.stagesData = data.data; // Update the state
                this.editingStageId = null;
                this.newStageAdded = false;
                this.derived = true;
            }).catch((error)=>{
                console.error("Error:", error);
                stageData.errors = error.errors.errors;
            });
        },
        getStageApplicationCount (stageId) {
            if (window.fromOrg) return new Promise((resolve, reject)=>{
                resolve(0);
            });
            let applicationCount = fetch(`/jobs/${this.job}/stages/${stageId}/application_count/`, {
                method: "GET"
            }).then(async (response)=>{
                if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
                return response.json();
            }).then((data)=>{
                return data.data.application_count;
            }).catch((error)=>{
                console.error("Error:", error);
            });
            return applicationCount;
        },
        deleteStage (stageId) {
            this.getStageApplicationCount(stageId).then((data)=>{
                if (data === 0) this.executeDeleteStage(stageId, null);
                else {
                    this.deletedStageId = stageId;
                    this.stageApplicationCount = data;
                    this.isModalOpen = true;
                }
            });
        },
        executeDeleteStage (stageId, newStageId) {
            this.requestInProgress = true;
            fetch(url, {
                method: "DELETE",
                headers: {
                    "X-CSRFToken": this.getCsrf(),
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    id: stageId,
                    newStageId: newStageId
                })
            }).then(async (response)=>{
                this.requestInProgress = false;
                if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
                return response.json();
            }).then((data)=>{
                this.stagesData = data.data; // Update the state
                this.derived = true;
            }).catch((error)=>{
                console.error("Error:", error);
            });
        },
        confirmStageSelection () {
            if (this.selectedStage) {
                this.executeDeleteStage(this.deletedStageId, this.selectedStage);
                this.isModalOpen = false;
                this.selectedStage = null;
                this.deletedStageId = null;
            } else alert("Please select a stage.");
        },
        getNewOrderingDataFromHtml () {
            let newOrderingData = [];
            const baseStages = document.querySelectorAll(".sortable");
            let counter = 0;
            baseStages.forEach((stage, index)=>{
                let currentStage = {
                    order: counter + 1,
                    stage_type: {
                        value: stage.dataset.stageTypeId,
                        label: stage.dataset.stageTypeLabel
                    },
                    stages: []
                };
                stage.querySelectorAll(".stage").forEach((stage, stageIndex)=>{
                    let stageData = {
                        id: stage.dataset.stageId,
                        order: counter + 1,
                        name: stage.dataset.stageName,
                        color: stage.dataset.colorCode,
                        description: stage.dataset.stageDescription,
                        pipeline: this.pipeline,
                        stage_type: stage.dataset.stageType
                    };
                    currentStage.stages.push(stageData);
                    counter++;
                });
                newOrderingData.push(currentStage);
            });
            return newOrderingData;
        },
        updateOrder () {
            this.requestInProgress = true;
            this.stagesData = this.getNewOrderingDataFromHtml();
            const payload = JSON.stringify({
                pipeline: this.pipeline,
                stagesData: this.stagesData
            });
            fetch(this.url, {
                method: "POST",
                headers: {
                    "X-CSRFToken": this.getCsrf(),
                    "Content-Type": "application/json"
                },
                body: payload
            }).then(async (response)=>{
                this.requestInProgress = false;
                if (!response.ok) {
                    const errorData = await response.json();
                    const error = new Error(response.statusText);
                    error.errors = errorData;
                    throw error;
                }
                return response.json();
            }).then((data)=>{
                this.stagesData = data.data; // Update the state
                this.derived = true;
            }).then().catch((error)=>{
                console.error("Error:", error);
            });
        }
    });

});
parcelRegister("5IiZx", function(module, exports) {
/*! js-cookie v3.0.5 | MIT */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === 'undefined') return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = '';
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += '; ' + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
            }
            return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === 'undefined' || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split('=');
                var value = parts.slice(1).join('=');
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, '', assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: '/'
    });
    /* eslint-enable no-var */ return api;
});

});


parcelRegister("1c3wp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de9a4c6f9b7d159$export$2e2bcd8739ae039);

var $5IiZx = parcelRequire("5IiZx");
var $0de9a4c6f9b7d159$export$2e2bcd8739ae039 = ({ rejectReasons: rejectReasons, sortableUpdateUrl: sortableUpdateUrl })=>({
        rejectReasons: // Props
        rejectReasons,
        sortableUpdateUrl: sortableUpdateUrl,
        // State
        isModalOpen: false,
        rejectReasonApplicationCount: 0,
        selectedRejectReason: null,
        deletedRejectReasonId: null,
        sortableDeleteUrl: null,
        requestInProgress: false,
        editingSortableItemId: null,
        init () {
            // Watch `editingSortableItemId` value and notify others of its state
            // This will help the Sortable instances to disable themselves based
            // on `editingSortableItemId` value.
            this.$watch("editingSortableItemId", (value)=>{
                this.$dispatch("editingSortableItem", {
                    value: value
                });
            });
        },
        updateSortableItem () {
            let formDiv = document.getElementById("editingForm-" + this.editingSortableItemId);
            let inputs = [
                ...formDiv.getElementsByTagName("input"),
                ...formDiv.getElementsByTagName("select")
            ];
            let data = {};
            inputs.forEach((input)=>{
                data[input.name] = input.value;
                data["id"] = input.parentElement.parentElement.dataset.itemId;
            });
            // send request with ajax
            fetch(this.sortableUpdateUrl, {
                method: "POST",
                headers: {
                    "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).get("csrftoken"),
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            }).then(async (response)=>{
                if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
                location.reload();
            }).catch((error)=>{
                console.error("Error:", error);
            });
        },
        getRejectReasonApplicationCount (rejectReasonUrl) {
            let applicationCount = fetch(rejectReasonUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response)=>{
                if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
                return response.json();
            }).then((data)=>{
                return data.data.application_count;
            }).catch((error)=>{
                console.error("Error:", error);
            });
            return applicationCount;
        },
        executeDeleteRejectReason (deletedRejectReasonId, newRejectReasonId) {
            fetch(this.sortableDeleteUrl, {
                method: "DELETE",
                headers: {
                    "X-CSRFToken": (0, (/*@__PURE__*/$parcel$interopDefault($5IiZx))).get("csrftoken"),
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    deletedRejectReasonId: deletedRejectReasonId,
                    newRejectReasonId: newRejectReasonId
                })
            }).then(async (response)=>{
                if (!response.ok) throw new Error("Network response was not ok " + response.statusText);
            }).catch((error)=>{
                console.error("Error:", error);
            });
        },
        async deleteRejectReason (rejectReasonUrl, sortableDeleteUrl, deletedRejectReasonId) {
            let applicationCount = await this.getRejectReasonApplicationCount(rejectReasonUrl);
            this.sortableDeleteUrl = sortableDeleteUrl;
            if (applicationCount === 0) document.getElementById("hiddenBtn-" + deletedRejectReasonId).click();
            else {
                this.isModalOpen = true;
                this.rejectReasonApplicationCount = applicationCount;
                this.deletedRejectReasonId = deletedRejectReasonId;
            }
        },
        confirmRejectReasonSelection () {
            if (this.selectedRejectReason) {
                this.executeDeleteRejectReason(this.deletedRejectReasonId, this.selectedRejectReason);
                this.isModalOpen = false;
                this.selectedRejectReason = null;
                this.deletedRejectReasonId = null;
                location.reload();
            } else alert("Please select a reject reason.");
        }
    });

});

parcelRegister("46Bky", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fd4ae0529f23c4f$export$2e2bcd8739ae039);

var $gufiS = parcelRequire("gufiS");
var $2fd4ae0529f23c4f$export$2e2bcd8739ae039 = ({ initialValue: initialValue, placeholder: placeholder, editorId: editorId })=>({
        input: initialValue ? initialValue : "",
        placeholder: placeholder ? placeholder : "",
        editorId: editorId ? editorId : "editor",
        init () {
            const editorId = this.editorId;
            const editorElement = document.getElementById(editorId);
            (0, (/*@__PURE__*/$parcel$interopDefault($gufiS))).create(editorElement, {
                placeholder: this.placeholder
            }).then((editor)=>{
                window[editorId] = editor;
                // Set initial conent
                editor.setData(this.input);
                // Listen change event to update the input state
                editor.model.document.on("change:data", ()=>{
                    this.updateInputFromEditor(editor);
                });
                // Listen input's change events to update editor
                this.$watch("input", (newValue)=>{
                    this.updateEditorFromInput(editor, newValue);
                });
            }).catch((error)=>{
                console.log(error);
            });
        },
        updateInputFromEditor (editor) {
            const editorContent = editor.getData();
            if (this.input !== editorContent) this.input = editorContent;
        },
        updateEditorFromInput (editor, newValue) {
            const editorContent = editor.getData();
            if (newValue !== editorContent) editor.setData(newValue);
        }
    });

});
parcelRegister("gufiS", function(module, exports) {
(function(t) {
    const e = t["en"] = t["en"] || {};
    e.dictionary = Object.assign(e.dictionary || {}, {
        "%0 of %1": "%0 of %1",
        Accept: "Accept",
        "Align center": "Align center",
        "Align left": "Align left",
        "Align right": "Align right",
        Aquamarine: "Aquamarine",
        Black: "Black",
        "Block quote": "Block quote",
        Blue: "Blue",
        Bold: "Bold",
        "Bulleted List": "Bulleted List",
        "Bulleted list styles toolbar": "Bulleted list styles toolbar",
        Cancel: "Cancel",
        "Choose heading": "Choose heading",
        Circle: "Circle",
        Clear: "Clear",
        "Click to edit block": "Click to edit block",
        Code: "Code",
        Decimal: "Decimal",
        "Decimal with leading zero": "Decimal with leading zero",
        "Decrease indent": "Decrease indent",
        "Dim grey": "Dim grey",
        Disc: "Disc",
        Downloadable: "Downloadable",
        "Drag to move": "Drag to move",
        "Dropdown toolbar": "Dropdown toolbar",
        "Edit block": "Edit block",
        "Edit link": "Edit link",
        "Editor block content toolbar": "Editor block content toolbar",
        "Editor contextual toolbar": "Editor contextual toolbar",
        "Editor editing area: %0": "Editor editing area: %0",
        "Editor toolbar": "Editor toolbar",
        Green: "Green",
        Grey: "Grey",
        Heading: "Heading",
        "Heading 1": "Heading 1",
        "Heading 2": "Heading 2",
        "Heading 3": "Heading 3",
        "Heading 4": "Heading 4",
        "Heading 5": "Heading 5",
        "Heading 6": "Heading 6",
        HEX: "HEX",
        "Horizontal line": "Horizontal line",
        "Increase indent": "Increase indent",
        "Insert paragraph after block": "Insert paragraph after block",
        "Insert paragraph before block": "Insert paragraph before block",
        Italic: "Italic",
        Justify: "Justify",
        "Light blue": "Light blue",
        "Light green": "Light green",
        "Light grey": "Light grey",
        Link: "Link",
        "Link image": "Link image",
        "Link URL": "Link URL",
        "List properties": "List properties",
        "Lower-latin": "Lower-latin",
        "Lower\u2013roman": "Lower\u2013roman",
        Next: "Next",
        "No results found": "No results found",
        "No searchable items": "No searchable items",
        "Numbered List": "Numbered List",
        "Numbered list styles toolbar": "Numbered list styles toolbar",
        "Open in a new tab": "Open in a new tab",
        "Open link in new tab": "Open link in new tab",
        Orange: "Orange",
        Paragraph: "Paragraph",
        "Press Enter to type after or press Shift + Enter to type before the widget": "Press Enter to type after or press Shift + Enter to type before the widget",
        Previous: "Previous",
        Purple: "Purple",
        Red: "Red",
        Redo: "Redo",
        "Reversed order": "Reversed order",
        "Rich Text Editor": "Rich Text Editor",
        Save: "Save",
        "Select all": "Select all",
        "Show more items": "Show more items",
        Square: "Square",
        "Start at": "Start at",
        "Start index must be greater than 0.": "Start index must be greater than 0.",
        Strikethrough: "Strikethrough",
        Subscript: "Subscript",
        Superscript: "Superscript",
        "Text alignment": "Text alignment",
        "Text alignment toolbar": "Text alignment toolbar",
        "This link has no URL": "This link has no URL",
        "To-do List": "To-do List",
        "Toggle the circle list style": "Toggle the circle list style",
        "Toggle the decimal list style": "Toggle the decimal list style",
        "Toggle the decimal with leading zero list style": "Toggle the decimal with leading zero list style",
        "Toggle the disc list style": "Toggle the disc list style",
        "Toggle the lower\u2013latin list style": "Toggle the lower\u2013latin list style",
        "Toggle the lower\u2013roman list style": "Toggle the lower\u2013roman list style",
        "Toggle the square list style": "Toggle the square list style",
        "Toggle the upper\u2013latin list style": "Toggle the upper\u2013latin list style",
        "Toggle the upper\u2013roman list style": "Toggle the upper\u2013roman list style",
        Turquoise: "Turquoise",
        "Type or paste your content here.": "Type or paste your content here.",
        "Type your title": "Type your title",
        Underline: "Underline",
        Undo: "Undo",
        Unlink: "Unlink",
        "Upper-latin": "Upper-latin",
        "Upper-roman": "Upper-roman",
        White: "White",
        "Widget toolbar": "Widget toolbar",
        Yellow: "Yellow"
    });
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {}));
/*!
 * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */ (function t(e, n) {
    module.exports = n();
})(self, ()=>(()=>{
        var t = {
            8168: (t, e, n)=>{
                const o = n(8874);
                const i = {};
                for (const t of Object.keys(o))i[o[t]] = t;
                const r = {
                    rgb: {
                        channels: 3,
                        labels: "rgb"
                    },
                    hsl: {
                        channels: 3,
                        labels: "hsl"
                    },
                    hsv: {
                        channels: 3,
                        labels: "hsv"
                    },
                    hwb: {
                        channels: 3,
                        labels: "hwb"
                    },
                    cmyk: {
                        channels: 4,
                        labels: "cmyk"
                    },
                    xyz: {
                        channels: 3,
                        labels: "xyz"
                    },
                    lab: {
                        channels: 3,
                        labels: "lab"
                    },
                    lch: {
                        channels: 3,
                        labels: "lch"
                    },
                    hex: {
                        channels: 1,
                        labels: [
                            "hex"
                        ]
                    },
                    keyword: {
                        channels: 1,
                        labels: [
                            "keyword"
                        ]
                    },
                    ansi16: {
                        channels: 1,
                        labels: [
                            "ansi16"
                        ]
                    },
                    ansi256: {
                        channels: 1,
                        labels: [
                            "ansi256"
                        ]
                    },
                    hcg: {
                        channels: 3,
                        labels: [
                            "h",
                            "c",
                            "g"
                        ]
                    },
                    apple: {
                        channels: 3,
                        labels: [
                            "r16",
                            "g16",
                            "b16"
                        ]
                    },
                    gray: {
                        channels: 1,
                        labels: [
                            "gray"
                        ]
                    }
                };
                t.exports = r;
                for (const t of Object.keys(r)){
                    if (!("channels" in r[t])) throw new Error("missing channels property: " + t);
                    if (!("labels" in r[t])) throw new Error("missing channel labels property: " + t);
                    if (r[t].labels.length !== r[t].channels) throw new Error("channel and label counts mismatch: " + t);
                    const { channels: e, labels: n } = r[t];
                    delete r[t].channels;
                    delete r[t].labels;
                    Object.defineProperty(r[t], "channels", {
                        value: e
                    });
                    Object.defineProperty(r[t], "labels", {
                        value: n
                    });
                }
                r.rgb.hsl = function(t) {
                    const e = t[0] / 255;
                    const n = t[1] / 255;
                    const o = t[2] / 255;
                    const i = Math.min(e, n, o);
                    const r = Math.max(e, n, o);
                    const s = r - i;
                    let a;
                    let c;
                    if (r === i) a = 0;
                    else if (e === r) a = (n - o) / s;
                    else if (n === r) a = 2 + (o - e) / s;
                    else if (o === r) a = 4 + (e - n) / s;
                    a = Math.min(a * 60, 360);
                    if (a < 0) a += 360;
                    const l = (i + r) / 2;
                    if (r === i) c = 0;
                    else if (l <= .5) c = s / (r + i);
                    else c = s / (2 - r - i);
                    return [
                        a,
                        c * 100,
                        l * 100
                    ];
                };
                r.rgb.hsv = function(t) {
                    let e;
                    let n;
                    let o;
                    let i;
                    let r;
                    const s = t[0] / 255;
                    const a = t[1] / 255;
                    const c = t[2] / 255;
                    const l = Math.max(s, a, c);
                    const d = l - Math.min(s, a, c);
                    const u = function(t) {
                        return (l - t) / 6 / d + 0.5;
                    };
                    if (d === 0) {
                        i = 0;
                        r = 0;
                    } else {
                        r = d / l;
                        e = u(s);
                        n = u(a);
                        o = u(c);
                        if (s === l) i = o - n;
                        else if (a === l) i = 1 / 3 + e - o;
                        else if (c === l) i = 2 / 3 + n - e;
                        if (i < 0) i += 1;
                        else if (i > 1) i -= 1;
                    }
                    return [
                        i * 360,
                        r * 100,
                        l * 100
                    ];
                };
                r.rgb.hwb = function(t) {
                    const e = t[0];
                    const n = t[1];
                    let o = t[2];
                    const i = r.rgb.hsl(t)[0];
                    const s = 1 / 255 * Math.min(e, Math.min(n, o));
                    o = 1 - 1 / 255 * Math.max(e, Math.max(n, o));
                    return [
                        i,
                        s * 100,
                        o * 100
                    ];
                };
                r.rgb.cmyk = function(t) {
                    const e = t[0] / 255;
                    const n = t[1] / 255;
                    const o = t[2] / 255;
                    const i = Math.min(1 - e, 1 - n, 1 - o);
                    const r = (1 - e - i) / (1 - i) || 0;
                    const s = (1 - n - i) / (1 - i) || 0;
                    const a = (1 - o - i) / (1 - i) || 0;
                    return [
                        r * 100,
                        s * 100,
                        a * 100,
                        i * 100
                    ];
                };
                function s(t, e) {
                    return (t[0] - e[0]) ** 2 + (t[1] - e[1]) ** 2 + (t[2] - e[2]) ** 2;
                }
                r.rgb.keyword = function(t) {
                    const e = i[t];
                    if (e) return e;
                    let n = Infinity;
                    let r;
                    for (const e of Object.keys(o)){
                        const i = o[e];
                        const a = s(t, i);
                        if (a < n) {
                            n = a;
                            r = e;
                        }
                    }
                    return r;
                };
                r.keyword.rgb = function(t) {
                    return o[t];
                };
                r.rgb.xyz = function(t) {
                    let e = t[0] / 255;
                    let n = t[1] / 255;
                    let o = t[2] / 255;
                    e = e > .04045 ? ((e + .055) / 1.055) ** 2.4 : e / 12.92;
                    n = n > .04045 ? ((n + .055) / 1.055) ** 2.4 : n / 12.92;
                    o = o > .04045 ? ((o + .055) / 1.055) ** 2.4 : o / 12.92;
                    const i = e * .4124 + n * .3576 + o * .1805;
                    const r = e * .2126 + n * .7152 + o * .0722;
                    const s = e * .0193 + n * .1192 + o * .9505;
                    return [
                        i * 100,
                        r * 100,
                        s * 100
                    ];
                };
                r.rgb.lab = function(t) {
                    const e = r.rgb.xyz(t);
                    let n = e[0];
                    let o = e[1];
                    let i = e[2];
                    n /= 95.047;
                    o /= 100;
                    i /= 108.883;
                    n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116;
                    o = o > .008856 ? o ** (1 / 3) : 7.787 * o + 16 / 116;
                    i = i > .008856 ? i ** (1 / 3) : 7.787 * i + 16 / 116;
                    const s = 116 * o - 16;
                    const a = 500 * (n - o);
                    const c = 200 * (o - i);
                    return [
                        s,
                        a,
                        c
                    ];
                };
                r.hsl.rgb = function(t) {
                    const e = t[0] / 360;
                    const n = t[1] / 100;
                    const o = t[2] / 100;
                    let i;
                    let r;
                    let s;
                    if (n === 0) {
                        s = o * 255;
                        return [
                            s,
                            s,
                            s
                        ];
                    }
                    if (o < .5) i = o * (1 + n);
                    else i = o + n - o * n;
                    const a = 2 * o - i;
                    const c = [
                        0,
                        0,
                        0
                    ];
                    for(let t = 0; t < 3; t++){
                        r = e + 1 / 3 * -(t - 1);
                        if (r < 0) r++;
                        if (r > 1) r--;
                        if (6 * r < 1) s = a + (i - a) * 6 * r;
                        else if (2 * r < 1) s = i;
                        else if (3 * r < 2) s = a + (i - a) * (2 / 3 - r) * 6;
                        else s = a;
                        c[t] = s * 255;
                    }
                    return c;
                };
                r.hsl.hsv = function(t) {
                    const e = t[0];
                    let n = t[1] / 100;
                    let o = t[2] / 100;
                    let i = n;
                    const r = Math.max(o, .01);
                    o *= 2;
                    n *= o <= 1 ? o : 2 - o;
                    i *= r <= 1 ? r : 2 - r;
                    const s = (o + n) / 2;
                    const a = o === 0 ? 2 * i / (r + i) : 2 * n / (o + n);
                    return [
                        e,
                        a * 100,
                        s * 100
                    ];
                };
                r.hsv.rgb = function(t) {
                    const e = t[0] / 60;
                    const n = t[1] / 100;
                    let o = t[2] / 100;
                    const i = Math.floor(e) % 6;
                    const r = e - Math.floor(e);
                    const s = 255 * o * (1 - n);
                    const a = 255 * o * (1 - n * r);
                    const c = 255 * o * (1 - n * (1 - r));
                    o *= 255;
                    switch(i){
                        case 0:
                            return [
                                o,
                                c,
                                s
                            ];
                        case 1:
                            return [
                                a,
                                o,
                                s
                            ];
                        case 2:
                            return [
                                s,
                                o,
                                c
                            ];
                        case 3:
                            return [
                                s,
                                a,
                                o
                            ];
                        case 4:
                            return [
                                c,
                                s,
                                o
                            ];
                        case 5:
                            return [
                                o,
                                s,
                                a
                            ];
                    }
                };
                r.hsv.hsl = function(t) {
                    const e = t[0];
                    const n = t[1] / 100;
                    const o = t[2] / 100;
                    const i = Math.max(o, .01);
                    let r;
                    let s;
                    s = (2 - n) * o;
                    const a = (2 - n) * i;
                    r = n * i;
                    r /= a <= 1 ? a : 2 - a;
                    r = r || 0;
                    s /= 2;
                    return [
                        e,
                        r * 100,
                        s * 100
                    ];
                };
                r.hwb.rgb = function(t) {
                    const e = t[0] / 360;
                    let n = t[1] / 100;
                    let o = t[2] / 100;
                    const i = n + o;
                    let r;
                    if (i > 1) {
                        n /= i;
                        o /= i;
                    }
                    const s = Math.floor(6 * e);
                    const a = 1 - o;
                    r = 6 * e - s;
                    if ((s & 1) !== 0) r = 1 - r;
                    const c = n + r * (a - n);
                    let l;
                    let d;
                    let u;
                    switch(s){
                        default:
                        case 6:
                        case 0:
                            l = a;
                            d = c;
                            u = n;
                            break;
                        case 1:
                            l = c;
                            d = a;
                            u = n;
                            break;
                        case 2:
                            l = n;
                            d = a;
                            u = c;
                            break;
                        case 3:
                            l = n;
                            d = c;
                            u = a;
                            break;
                        case 4:
                            l = c;
                            d = n;
                            u = a;
                            break;
                        case 5:
                            l = a;
                            d = n;
                            u = c;
                            break;
                    }
                    return [
                        l * 255,
                        d * 255,
                        u * 255
                    ];
                };
                r.cmyk.rgb = function(t) {
                    const e = t[0] / 100;
                    const n = t[1] / 100;
                    const o = t[2] / 100;
                    const i = t[3] / 100;
                    const r = 1 - Math.min(1, e * (1 - i) + i);
                    const s = 1 - Math.min(1, n * (1 - i) + i);
                    const a = 1 - Math.min(1, o * (1 - i) + i);
                    return [
                        r * 255,
                        s * 255,
                        a * 255
                    ];
                };
                r.xyz.rgb = function(t) {
                    const e = t[0] / 100;
                    const n = t[1] / 100;
                    const o = t[2] / 100;
                    let i;
                    let r;
                    let s;
                    i = e * 3.2406 + n * -1.5372 + o * -0.4986;
                    r = e * -0.9689 + n * 1.8758 + o * .0415;
                    s = e * .0557 + n * -0.204 + o * 1.057;
                    i = i > .0031308 ? 1.055 * i ** (1 / 2.4) - .055 : i * 12.92;
                    r = r > .0031308 ? 1.055 * r ** (1 / 2.4) - .055 : r * 12.92;
                    s = s > .0031308 ? 1.055 * s ** (1 / 2.4) - .055 : s * 12.92;
                    i = Math.min(Math.max(0, i), 1);
                    r = Math.min(Math.max(0, r), 1);
                    s = Math.min(Math.max(0, s), 1);
                    return [
                        i * 255,
                        r * 255,
                        s * 255
                    ];
                };
                r.xyz.lab = function(t) {
                    let e = t[0];
                    let n = t[1];
                    let o = t[2];
                    e /= 95.047;
                    n /= 100;
                    o /= 108.883;
                    e = e > .008856 ? e ** (1 / 3) : 7.787 * e + 16 / 116;
                    n = n > .008856 ? n ** (1 / 3) : 7.787 * n + 16 / 116;
                    o = o > .008856 ? o ** (1 / 3) : 7.787 * o + 16 / 116;
                    const i = 116 * n - 16;
                    const r = 500 * (e - n);
                    const s = 200 * (n - o);
                    return [
                        i,
                        r,
                        s
                    ];
                };
                r.lab.xyz = function(t) {
                    const e = t[0];
                    const n = t[1];
                    const o = t[2];
                    let i;
                    let r;
                    let s;
                    r = (e + 16) / 116;
                    i = n / 500 + r;
                    s = r - o / 200;
                    const a = r ** 3;
                    const c = i ** 3;
                    const l = s ** 3;
                    r = a > .008856 ? a : (r - 16 / 116) / 7.787;
                    i = c > .008856 ? c : (i - 16 / 116) / 7.787;
                    s = l > .008856 ? l : (s - 16 / 116) / 7.787;
                    i *= 95.047;
                    r *= 100;
                    s *= 108.883;
                    return [
                        i,
                        r,
                        s
                    ];
                };
                r.lab.lch = function(t) {
                    const e = t[0];
                    const n = t[1];
                    const o = t[2];
                    let i;
                    const r = Math.atan2(o, n);
                    i = r * 360 / 2 / Math.PI;
                    if (i < 0) i += 360;
                    const s = Math.sqrt(n * n + o * o);
                    return [
                        e,
                        s,
                        i
                    ];
                };
                r.lch.lab = function(t) {
                    const e = t[0];
                    const n = t[1];
                    const o = t[2];
                    const i = o / 360 * 2 * Math.PI;
                    const r = n * Math.cos(i);
                    const s = n * Math.sin(i);
                    return [
                        e,
                        r,
                        s
                    ];
                };
                r.rgb.ansi16 = function(t, e = null) {
                    const [n, o, i] = t;
                    let s = e === null ? r.rgb.hsv(t)[2] : e;
                    s = Math.round(s / 50);
                    if (s === 0) return 30;
                    let a = 30 + (Math.round(i / 255) << 2 | Math.round(o / 255) << 1 | Math.round(n / 255));
                    if (s === 2) a += 60;
                    return a;
                };
                r.hsv.ansi16 = function(t) {
                    return r.rgb.ansi16(r.hsv.rgb(t), t[2]);
                };
                r.rgb.ansi256 = function(t) {
                    const e = t[0];
                    const n = t[1];
                    const o = t[2];
                    if (e === n && n === o) {
                        if (e < 8) return 16;
                        if (e > 248) return 231;
                        return Math.round((e - 8) / 247 * 24) + 232;
                    }
                    const i = 16 + 36 * Math.round(e / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(o / 255 * 5);
                    return i;
                };
                r.ansi16.rgb = function(t) {
                    let e = t % 10;
                    if (e === 0 || e === 7) {
                        if (t > 50) e += 3.5;
                        e = e / 10.5 * 255;
                        return [
                            e,
                            e,
                            e
                        ];
                    }
                    const n = (~~(t > 50) + 1) * .5;
                    const o = (e & 1) * n * 255;
                    const i = (e >> 1 & 1) * n * 255;
                    const r = (e >> 2 & 1) * n * 255;
                    return [
                        o,
                        i,
                        r
                    ];
                };
                r.ansi256.rgb = function(t) {
                    if (t >= 232) {
                        const e = (t - 232) * 10 + 8;
                        return [
                            e,
                            e,
                            e
                        ];
                    }
                    t -= 16;
                    let e;
                    const n = Math.floor(t / 36) / 5 * 255;
                    const o = Math.floor((e = t % 36) / 6) / 5 * 255;
                    const i = e % 6 / 5 * 255;
                    return [
                        n,
                        o,
                        i
                    ];
                };
                r.rgb.hex = function(t) {
                    const e = ((Math.round(t[0]) & 255) << 16) + ((Math.round(t[1]) & 255) << 8) + (Math.round(t[2]) & 255);
                    const n = e.toString(16).toUpperCase();
                    return "000000".substring(n.length) + n;
                };
                r.hex.rgb = function(t) {
                    const e = t.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
                    if (!e) return [
                        0,
                        0,
                        0
                    ];
                    let n = e[0];
                    if (e[0].length === 3) n = n.split("").map((t)=>t + t).join("");
                    const o = parseInt(n, 16);
                    const i = o >> 16 & 255;
                    const r = o >> 8 & 255;
                    const s = o & 255;
                    return [
                        i,
                        r,
                        s
                    ];
                };
                r.rgb.hcg = function(t) {
                    const e = t[0] / 255;
                    const n = t[1] / 255;
                    const o = t[2] / 255;
                    const i = Math.max(Math.max(e, n), o);
                    const r = Math.min(Math.min(e, n), o);
                    const s = i - r;
                    let a;
                    let c;
                    if (s < 1) a = r / (1 - s);
                    else a = 0;
                    if (s <= 0) c = 0;
                    else if (i === e) c = (n - o) / s % 6;
                    else if (i === n) c = 2 + (o - e) / s;
                    else c = 4 + (e - n) / s;
                    c /= 6;
                    c %= 1;
                    return [
                        c * 360,
                        s * 100,
                        a * 100
                    ];
                };
                r.hsl.hcg = function(t) {
                    const e = t[1] / 100;
                    const n = t[2] / 100;
                    const o = n < .5 ? 2 * e * n : 2 * e * (1 - n);
                    let i = 0;
                    if (o < 1) i = (n - .5 * o) / (1 - o);
                    return [
                        t[0],
                        o * 100,
                        i * 100
                    ];
                };
                r.hsv.hcg = function(t) {
                    const e = t[1] / 100;
                    const n = t[2] / 100;
                    const o = e * n;
                    let i = 0;
                    if (o < 1) i = (n - o) / (1 - o);
                    return [
                        t[0],
                        o * 100,
                        i * 100
                    ];
                };
                r.hcg.rgb = function(t) {
                    const e = t[0] / 360;
                    const n = t[1] / 100;
                    const o = t[2] / 100;
                    if (n === 0) return [
                        o * 255,
                        o * 255,
                        o * 255
                    ];
                    const i = [
                        0,
                        0,
                        0
                    ];
                    const r = e % 1 * 6;
                    const s = r % 1;
                    const a = 1 - s;
                    let c = 0;
                    switch(Math.floor(r)){
                        case 0:
                            i[0] = 1;
                            i[1] = s;
                            i[2] = 0;
                            break;
                        case 1:
                            i[0] = a;
                            i[1] = 1;
                            i[2] = 0;
                            break;
                        case 2:
                            i[0] = 0;
                            i[1] = 1;
                            i[2] = s;
                            break;
                        case 3:
                            i[0] = 0;
                            i[1] = a;
                            i[2] = 1;
                            break;
                        case 4:
                            i[0] = s;
                            i[1] = 0;
                            i[2] = 1;
                            break;
                        default:
                            i[0] = 1;
                            i[1] = 0;
                            i[2] = a;
                    }
                    c = (1 - n) * o;
                    return [
                        (n * i[0] + c) * 255,
                        (n * i[1] + c) * 255,
                        (n * i[2] + c) * 255
                    ];
                };
                r.hcg.hsv = function(t) {
                    const e = t[1] / 100;
                    const n = t[2] / 100;
                    const o = e + n * (1 - e);
                    let i = 0;
                    if (o > 0) i = e / o;
                    return [
                        t[0],
                        i * 100,
                        o * 100
                    ];
                };
                r.hcg.hsl = function(t) {
                    const e = t[1] / 100;
                    const n = t[2] / 100;
                    const o = n * (1 - e) + .5 * e;
                    let i = 0;
                    if (o > 0 && o < .5) i = e / (2 * o);
                    else if (o >= .5 && o < 1) i = e / (2 * (1 - o));
                    return [
                        t[0],
                        i * 100,
                        o * 100
                    ];
                };
                r.hcg.hwb = function(t) {
                    const e = t[1] / 100;
                    const n = t[2] / 100;
                    const o = e + n * (1 - e);
                    return [
                        t[0],
                        (o - e) * 100,
                        (1 - o) * 100
                    ];
                };
                r.hwb.hcg = function(t) {
                    const e = t[1] / 100;
                    const n = t[2] / 100;
                    const o = 1 - n;
                    const i = o - e;
                    let r = 0;
                    if (i < 1) r = (o - i) / (1 - i);
                    return [
                        t[0],
                        i * 100,
                        r * 100
                    ];
                };
                r.apple.rgb = function(t) {
                    return [
                        t[0] / 65535 * 255,
                        t[1] / 65535 * 255,
                        t[2] / 65535 * 255
                    ];
                };
                r.rgb.apple = function(t) {
                    return [
                        t[0] / 255 * 65535,
                        t[1] / 255 * 65535,
                        t[2] / 255 * 65535
                    ];
                };
                r.gray.rgb = function(t) {
                    return [
                        t[0] / 100 * 255,
                        t[0] / 100 * 255,
                        t[0] / 100 * 255
                    ];
                };
                r.gray.hsl = function(t) {
                    return [
                        0,
                        0,
                        t[0]
                    ];
                };
                r.gray.hsv = r.gray.hsl;
                r.gray.hwb = function(t) {
                    return [
                        0,
                        100,
                        t[0]
                    ];
                };
                r.gray.cmyk = function(t) {
                    return [
                        0,
                        0,
                        0,
                        t[0]
                    ];
                };
                r.gray.lab = function(t) {
                    return [
                        t[0],
                        0,
                        0
                    ];
                };
                r.gray.hex = function(t) {
                    const e = Math.round(t[0] / 100 * 255) & 255;
                    const n = (e << 16) + (e << 8) + e;
                    const o = n.toString(16).toUpperCase();
                    return "000000".substring(o.length) + o;
                };
                r.rgb.gray = function(t) {
                    const e = (t[0] + t[1] + t[2]) / 3;
                    return [
                        e / 255 * 100
                    ];
                };
            },
            2085: (t, e, n)=>{
                const o = n(8168);
                const i = n(4111);
                const r = {};
                const s = Object.keys(o);
                function a(t) {
                    const e = function(...e) {
                        const n = e[0];
                        if (n === undefined || n === null) return n;
                        if (n.length > 1) e = n;
                        return t(e);
                    };
                    if ("conversion" in t) e.conversion = t.conversion;
                    return e;
                }
                function c(t) {
                    const e = function(...e) {
                        const n = e[0];
                        if (n === undefined || n === null) return n;
                        if (n.length > 1) e = n;
                        const o = t(e);
                        if (typeof o === "object") for(let t = o.length, e = 0; e < t; e++)o[e] = Math.round(o[e]);
                        return o;
                    };
                    if ("conversion" in t) e.conversion = t.conversion;
                    return e;
                }
                s.forEach((t)=>{
                    r[t] = {};
                    Object.defineProperty(r[t], "channels", {
                        value: o[t].channels
                    });
                    Object.defineProperty(r[t], "labels", {
                        value: o[t].labels
                    });
                    const e = i(t);
                    const n = Object.keys(e);
                    n.forEach((n)=>{
                        const o = e[n];
                        r[t][n] = c(o);
                        r[t][n].raw = a(o);
                    });
                });
                t.exports = r;
            },
            4111: (t, e, n)=>{
                const o = n(8168);
                function i() {
                    const t = {};
                    const e = Object.keys(o);
                    for(let n = e.length, o = 0; o < n; o++)t[e[o]] = {
                        distance: -1,
                        parent: null
                    };
                    return t;
                }
                function r(t) {
                    const e = i();
                    const n = [
                        t
                    ];
                    e[t].distance = 0;
                    while(n.length){
                        const t = n.pop();
                        const i = Object.keys(o[t]);
                        for(let o = i.length, r = 0; r < o; r++){
                            const o = i[r];
                            const s = e[o];
                            if (s.distance === -1) {
                                s.distance = e[t].distance + 1;
                                s.parent = t;
                                n.unshift(o);
                            }
                        }
                    }
                    return e;
                }
                function s(t, e) {
                    return function(n) {
                        return e(t(n));
                    };
                }
                function a(t, e) {
                    const n = [
                        e[t].parent,
                        t
                    ];
                    let i = o[e[t].parent][t];
                    let r = e[t].parent;
                    while(e[r].parent){
                        n.unshift(e[r].parent);
                        i = s(o[e[r].parent][r], i);
                        r = e[r].parent;
                    }
                    i.conversion = n;
                    return i;
                }
                t.exports = function(t) {
                    const e = r(t);
                    const n = {};
                    const o = Object.keys(e);
                    for(let t = o.length, i = 0; i < t; i++){
                        const t = o[i];
                        const r = e[t];
                        if (r.parent === null) continue;
                        n[t] = a(t, e);
                    }
                    return n;
                };
            },
            8874: (t)=>{
                "use strict";
                t.exports = {
                    aliceblue: [
                        240,
                        248,
                        255
                    ],
                    antiquewhite: [
                        250,
                        235,
                        215
                    ],
                    aqua: [
                        0,
                        255,
                        255
                    ],
                    aquamarine: [
                        127,
                        255,
                        212
                    ],
                    azure: [
                        240,
                        255,
                        255
                    ],
                    beige: [
                        245,
                        245,
                        220
                    ],
                    bisque: [
                        255,
                        228,
                        196
                    ],
                    black: [
                        0,
                        0,
                        0
                    ],
                    blanchedalmond: [
                        255,
                        235,
                        205
                    ],
                    blue: [
                        0,
                        0,
                        255
                    ],
                    blueviolet: [
                        138,
                        43,
                        226
                    ],
                    brown: [
                        165,
                        42,
                        42
                    ],
                    burlywood: [
                        222,
                        184,
                        135
                    ],
                    cadetblue: [
                        95,
                        158,
                        160
                    ],
                    chartreuse: [
                        127,
                        255,
                        0
                    ],
                    chocolate: [
                        210,
                        105,
                        30
                    ],
                    coral: [
                        255,
                        127,
                        80
                    ],
                    cornflowerblue: [
                        100,
                        149,
                        237
                    ],
                    cornsilk: [
                        255,
                        248,
                        220
                    ],
                    crimson: [
                        220,
                        20,
                        60
                    ],
                    cyan: [
                        0,
                        255,
                        255
                    ],
                    darkblue: [
                        0,
                        0,
                        139
                    ],
                    darkcyan: [
                        0,
                        139,
                        139
                    ],
                    darkgoldenrod: [
                        184,
                        134,
                        11
                    ],
                    darkgray: [
                        169,
                        169,
                        169
                    ],
                    darkgreen: [
                        0,
                        100,
                        0
                    ],
                    darkgrey: [
                        169,
                        169,
                        169
                    ],
                    darkkhaki: [
                        189,
                        183,
                        107
                    ],
                    darkmagenta: [
                        139,
                        0,
                        139
                    ],
                    darkolivegreen: [
                        85,
                        107,
                        47
                    ],
                    darkorange: [
                        255,
                        140,
                        0
                    ],
                    darkorchid: [
                        153,
                        50,
                        204
                    ],
                    darkred: [
                        139,
                        0,
                        0
                    ],
                    darksalmon: [
                        233,
                        150,
                        122
                    ],
                    darkseagreen: [
                        143,
                        188,
                        143
                    ],
                    darkslateblue: [
                        72,
                        61,
                        139
                    ],
                    darkslategray: [
                        47,
                        79,
                        79
                    ],
                    darkslategrey: [
                        47,
                        79,
                        79
                    ],
                    darkturquoise: [
                        0,
                        206,
                        209
                    ],
                    darkviolet: [
                        148,
                        0,
                        211
                    ],
                    deeppink: [
                        255,
                        20,
                        147
                    ],
                    deepskyblue: [
                        0,
                        191,
                        255
                    ],
                    dimgray: [
                        105,
                        105,
                        105
                    ],
                    dimgrey: [
                        105,
                        105,
                        105
                    ],
                    dodgerblue: [
                        30,
                        144,
                        255
                    ],
                    firebrick: [
                        178,
                        34,
                        34
                    ],
                    floralwhite: [
                        255,
                        250,
                        240
                    ],
                    forestgreen: [
                        34,
                        139,
                        34
                    ],
                    fuchsia: [
                        255,
                        0,
                        255
                    ],
                    gainsboro: [
                        220,
                        220,
                        220
                    ],
                    ghostwhite: [
                        248,
                        248,
                        255
                    ],
                    gold: [
                        255,
                        215,
                        0
                    ],
                    goldenrod: [
                        218,
                        165,
                        32
                    ],
                    gray: [
                        128,
                        128,
                        128
                    ],
                    green: [
                        0,
                        128,
                        0
                    ],
                    greenyellow: [
                        173,
                        255,
                        47
                    ],
                    grey: [
                        128,
                        128,
                        128
                    ],
                    honeydew: [
                        240,
                        255,
                        240
                    ],
                    hotpink: [
                        255,
                        105,
                        180
                    ],
                    indianred: [
                        205,
                        92,
                        92
                    ],
                    indigo: [
                        75,
                        0,
                        130
                    ],
                    ivory: [
                        255,
                        255,
                        240
                    ],
                    khaki: [
                        240,
                        230,
                        140
                    ],
                    lavender: [
                        230,
                        230,
                        250
                    ],
                    lavenderblush: [
                        255,
                        240,
                        245
                    ],
                    lawngreen: [
                        124,
                        252,
                        0
                    ],
                    lemonchiffon: [
                        255,
                        250,
                        205
                    ],
                    lightblue: [
                        173,
                        216,
                        230
                    ],
                    lightcoral: [
                        240,
                        128,
                        128
                    ],
                    lightcyan: [
                        224,
                        255,
                        255
                    ],
                    lightgoldenrodyellow: [
                        250,
                        250,
                        210
                    ],
                    lightgray: [
                        211,
                        211,
                        211
                    ],
                    lightgreen: [
                        144,
                        238,
                        144
                    ],
                    lightgrey: [
                        211,
                        211,
                        211
                    ],
                    lightpink: [
                        255,
                        182,
                        193
                    ],
                    lightsalmon: [
                        255,
                        160,
                        122
                    ],
                    lightseagreen: [
                        32,
                        178,
                        170
                    ],
                    lightskyblue: [
                        135,
                        206,
                        250
                    ],
                    lightslategray: [
                        119,
                        136,
                        153
                    ],
                    lightslategrey: [
                        119,
                        136,
                        153
                    ],
                    lightsteelblue: [
                        176,
                        196,
                        222
                    ],
                    lightyellow: [
                        255,
                        255,
                        224
                    ],
                    lime: [
                        0,
                        255,
                        0
                    ],
                    limegreen: [
                        50,
                        205,
                        50
                    ],
                    linen: [
                        250,
                        240,
                        230
                    ],
                    magenta: [
                        255,
                        0,
                        255
                    ],
                    maroon: [
                        128,
                        0,
                        0
                    ],
                    mediumaquamarine: [
                        102,
                        205,
                        170
                    ],
                    mediumblue: [
                        0,
                        0,
                        205
                    ],
                    mediumorchid: [
                        186,
                        85,
                        211
                    ],
                    mediumpurple: [
                        147,
                        112,
                        219
                    ],
                    mediumseagreen: [
                        60,
                        179,
                        113
                    ],
                    mediumslateblue: [
                        123,
                        104,
                        238
                    ],
                    mediumspringgreen: [
                        0,
                        250,
                        154
                    ],
                    mediumturquoise: [
                        72,
                        209,
                        204
                    ],
                    mediumvioletred: [
                        199,
                        21,
                        133
                    ],
                    midnightblue: [
                        25,
                        25,
                        112
                    ],
                    mintcream: [
                        245,
                        255,
                        250
                    ],
                    mistyrose: [
                        255,
                        228,
                        225
                    ],
                    moccasin: [
                        255,
                        228,
                        181
                    ],
                    navajowhite: [
                        255,
                        222,
                        173
                    ],
                    navy: [
                        0,
                        0,
                        128
                    ],
                    oldlace: [
                        253,
                        245,
                        230
                    ],
                    olive: [
                        128,
                        128,
                        0
                    ],
                    olivedrab: [
                        107,
                        142,
                        35
                    ],
                    orange: [
                        255,
                        165,
                        0
                    ],
                    orangered: [
                        255,
                        69,
                        0
                    ],
                    orchid: [
                        218,
                        112,
                        214
                    ],
                    palegoldenrod: [
                        238,
                        232,
                        170
                    ],
                    palegreen: [
                        152,
                        251,
                        152
                    ],
                    paleturquoise: [
                        175,
                        238,
                        238
                    ],
                    palevioletred: [
                        219,
                        112,
                        147
                    ],
                    papayawhip: [
                        255,
                        239,
                        213
                    ],
                    peachpuff: [
                        255,
                        218,
                        185
                    ],
                    peru: [
                        205,
                        133,
                        63
                    ],
                    pink: [
                        255,
                        192,
                        203
                    ],
                    plum: [
                        221,
                        160,
                        221
                    ],
                    powderblue: [
                        176,
                        224,
                        230
                    ],
                    purple: [
                        128,
                        0,
                        128
                    ],
                    rebeccapurple: [
                        102,
                        51,
                        153
                    ],
                    red: [
                        255,
                        0,
                        0
                    ],
                    rosybrown: [
                        188,
                        143,
                        143
                    ],
                    royalblue: [
                        65,
                        105,
                        225
                    ],
                    saddlebrown: [
                        139,
                        69,
                        19
                    ],
                    salmon: [
                        250,
                        128,
                        114
                    ],
                    sandybrown: [
                        244,
                        164,
                        96
                    ],
                    seagreen: [
                        46,
                        139,
                        87
                    ],
                    seashell: [
                        255,
                        245,
                        238
                    ],
                    sienna: [
                        160,
                        82,
                        45
                    ],
                    silver: [
                        192,
                        192,
                        192
                    ],
                    skyblue: [
                        135,
                        206,
                        235
                    ],
                    slateblue: [
                        106,
                        90,
                        205
                    ],
                    slategray: [
                        112,
                        128,
                        144
                    ],
                    slategrey: [
                        112,
                        128,
                        144
                    ],
                    snow: [
                        255,
                        250,
                        250
                    ],
                    springgreen: [
                        0,
                        255,
                        127
                    ],
                    steelblue: [
                        70,
                        130,
                        180
                    ],
                    tan: [
                        210,
                        180,
                        140
                    ],
                    teal: [
                        0,
                        128,
                        128
                    ],
                    thistle: [
                        216,
                        191,
                        216
                    ],
                    tomato: [
                        255,
                        99,
                        71
                    ],
                    turquoise: [
                        64,
                        224,
                        208
                    ],
                    violet: [
                        238,
                        130,
                        238
                    ],
                    wheat: [
                        245,
                        222,
                        179
                    ],
                    white: [
                        255,
                        255,
                        255
                    ],
                    whitesmoke: [
                        245,
                        245,
                        245
                    ],
                    yellow: [
                        255,
                        255,
                        0
                    ],
                    yellowgreen: [
                        154,
                        205,
                        50
                    ]
                };
            },
            5363: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck-content code{background-color:hsla(0,0%,78%,.3);border-radius:2px;padding:.15em}.ck.ck-editor__editable .ck-code_selected{background-color:hsla(0,0%,78%,.5)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-basic-styles/theme/code.css"
                        ],
                        names: [],
                        mappings: "AAKA,iBACC,kCAAuC,CAEvC,iBAAkB,CADlB,aAED,CAEA,0CACC,kCACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content code {\n\tbackground-color: hsla(0, 0%, 78%, 0.3);\n\tpadding: .15em;\n\tborder-radius: 2px;\n}\n\n.ck.ck-editor__editable .ck-code_selected  {\n\tbackground-color: hsla(0, 0%, 78%, 0.5);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3789: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css"
                        ],
                        names: [],
                        mappings: "AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            799: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}.ck.ck-clipboard-drop-target-line{pointer-events:none;position:absolute}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) transparent transparent transparent;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}.ck.ck-clipboard-drop-target-line{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);height:0;margin-top:-1px}.ck.ck-clipboard-drop-target-line:before{border-style:solid;content:"";height:0;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-width)*-.5);width:0}[dir=ltr] .ck.ck-clipboard-drop-target-line:before{border-color:transparent transparent transparent var(--ck-clipboard-drop-target-color);border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height);left:-1px}[dir=rtl] .ck.ck-clipboard-drop-target-line:before{border-color:transparent var(--ck-clipboard-drop-target-color) transparent transparent;border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0;right:-1px}',
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"
                        ],
                        names: [],
                        mappings: "AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CAIF,kCAEC,mBAAoB,CADpB,iBAED,CC9BA,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,sFAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CAOF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD,CAGD,kCAGC,gDAAiD,CADjD,sDAAuD,CADvD,QAAS,CAGT,eAwBD,CAtBC,yCAMC,kBAAmB,CALnB,UAAW,CAIX,QAAS,CAHT,iBAAkB,CAClB,uDAA0D,CAC1D,OAiBD,CArBA,mDAYE,sFAAuF,CADvF,+JAAoK,CAFpK,SAYF,CArBA,mDAmBE,sFAAuF,CADvF,+JAAmK,CAFnK,UAKF",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\tposition: absolute;\n\tpointer-events: none;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import \"@ckeditor/ckeditor5-ui/theme/mixins/_dir.css\";\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n\n.ck.ck-clipboard-drop-target-line {\n\theight: 0;\n\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\tbackground: var(--ck-clipboard-drop-target-color);\n\tmargin-top: -1px;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: absolute;\n\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\twidth: 0;\n\t\theight: 0;\n\t\tborder-style: solid;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tleft: -1px;\n\n\t\t\tborder-width: calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height);\n\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tright: -1px;\n\n\t\t\tborder-width:calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0;\n\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t}\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3624: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"
                        ],
                        names: [],
                        mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            7372: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text);cursor:text}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"
                        ],
                        names: [],
                        mappings: "AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC5BC,qDAEC,6CAA8C,CAD9C,WAED",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n\tposition: relative;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            5037: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css"
                        ],
                        names: [],
                        mappings: "AAMA,qDACC,YACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4249: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"
                        ],
                        names: [],
                        mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            9893: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck-editor__editable .ck-horizontal-line{display:flow-root}.ck-content hr{background:#dedede;border:0;height:4px;margin:15px 0}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css"
                        ],
                        names: [],
                        mappings: "AAMA,yCAEC,iBACD,CAEA,eAGC,kBAA2B,CAC3B,QAAS,CAFT,UAAW,CADX,aAID",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n\n.ck-editor__editable .ck-horizontal-line {\n\t/* Necessary to render properly next to floated objects, e.g. side image case. */\n\tdisplay: flow-root;\n}\n\n.ck-content hr {\n\tmargin: 15px 0;\n\theight: 4px;\n\tbackground: hsl(0, 0%, 87%);\n\tborder: 0;\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3925: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css"
                        ],
                        names: [],
                        mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,oCACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            7536: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"
                        ],
                        names: [],
                        mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4874: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"
                        ],
                        names: [],
                        mappings: "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& > .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4330: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    '.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{display:block;position:absolute}:root{--ck-link-image-indicator-icon-size:20;--ck-link-image-indicator-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{background-color:rgba(0,0,0,.4);background-image:url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");background-position:50%;background-repeat:no-repeat;background-size:14px;border-radius:100%;content:"";height:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size));overflow:hidden;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);width:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size))}',
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkimage.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkimage.css"
                        ],
                        names: [],
                        mappings: "AASE,+FACC,aAAc,CACd,iBACD,CCPF,MAEC,sCAAuC,CACvC,oEACD,CAME,+FAUC,+BAAqC,CACrC,83BAA+3B,CAG/3B,uBAA2B,CAD3B,2BAA4B,CAD5B,oBAAqB,CAGrB,kBAAmB,CAdnB,UAAW,CAsBX,oGAAuG,CAFvG,eAAgB,CAbhB,sCAAwC,CADxC,oCAAsC,CAetC,mGAED",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Match the icon size with the upload indicator brought by the image upload feature. */\n\t--ck-link-image-indicator-icon-size: 20;\n\t--ck-link-image-indicator-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck.ck-editor__editable {\n\t/* Linked image indicator */\n\t& figure.image > a,\n\t& a span.image-inline {\n\t\t&::after {\n\t\t\tcontent: "";\n\n\t\t\t/*\n\t\t\t * Smaller images should have the icon closer to the border.\n\t\t\t * Match the icon position with the upload indicator brought by the image upload feature.\n\t\t\t */\n\t\t\ttop: min(var(--ck-spacing-medium), 6%);\n\t\t\tright: min(var(--ck-spacing-medium), 6%);\n\n\t\t\tbackground-color: hsla(0, 0%, 0%, .4);\n\t\t\tbackground-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");\n\t\t\tbackground-size: 14px;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-position: center;\n\t\t\tborder-radius: 100%;\n\n\t\t\t/*\n\t\t\t* Use CSS math to simulate container queries.\n\t\t\t* https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t\t\t*/\n\t\t\toverflow: hidden;\n\t\t\twidth: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t\theight: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n\t\t}\n\t}\n}\n\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            5782: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-collapsible.ck-collapsible_collapsed>.ck-collapsible__children{display:none}:root{--ck-collapsible-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-collapsible>.ck.ck-button{border-radius:0;color:inherit;font-weight:700;padding:var(--ck-spacing-medium) var(--ck-spacing-large);width:100%}.ck.ck-collapsible>.ck.ck-button:focus{background:transparent}.ck.ck-collapsible>.ck.ck-button:active,.ck.ck-collapsible>.ck.ck-button:hover:not(:focus),.ck.ck-collapsible>.ck.ck-button:not(:focus){background:transparent;border-color:transparent;box-shadow:none}.ck.ck-collapsible>.ck.ck-button>.ck-icon{margin-right:var(--ck-spacing-medium);width:var(--ck-collapsible-arrow-size)}.ck.ck-collapsible>.ck-collapsible__children{padding:0 var(--ck-spacing-large) var(--ck-spacing-large)}.ck.ck-collapsible.ck-collapsible_collapsed>.ck.ck-button .ck-icon{transform:rotate(-90deg)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-list/theme/collapsible.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-list/collapsible.css"
                        ],
                        names: [],
                        mappings: "AAMC,sEACC,YACD,CCHD,MACC,yDACD,CAGC,iCAIC,eAAgB,CAChB,aAAc,CAHd,eAAiB,CACjB,wDAAyD,CAFzD,UAoBD,CAdC,uCACC,sBACD,CAEA,wIACC,sBAAuB,CACvB,wBAAyB,CACzB,eACD,CAEA,0CACC,qCAAsC,CACtC,sCACD,CAGD,6CACC,yDACD,CAGC,mEACC,wBACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-collapsible.ck-collapsible_collapsed {\n\t& > .ck-collapsible__children {\n\t\tdisplay: none;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-collapsible-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-collapsible {\n\t& > .ck.ck-button {\n\t\twidth: 100%;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large);\n\t\tborder-radius: 0;\n\t\tcolor: inherit;\n\n\t\t&:focus {\n\t\t\tbackground: transparent;\n\t\t}\n\n\t\t&:active, &:not(:focus), &:hover:not(:focus) {\n\t\t\tbackground: transparent;\n\t\t\tborder-color: transparent;\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t& > .ck-icon {\n\t\t\tmargin-right: var(--ck-spacing-medium);\n\t\t\twidth: var(--ck-collapsible-arrow-size);\n\t\t}\n\t}\n\n\t& > .ck-collapsible__children {\n\t\tpadding: 0 var(--ck-spacing-large) var(--ck-spacing-large);\n\t}\n\n\t&.ck-collapsible_collapsed {\n\t\t& > .ck.ck-button .ck-icon {\n\t\t\ttransform: rotate(-90deg);\n\t\t}\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3190: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck-editor__editable .ck-list-bogus-paragraph{display:block}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-list/theme/documentlist.css"
                        ],
                        names: [],
                        mappings: "AAKA,8CACC,aACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-editor__editable .ck-list-bogus-paragraph {\n\tdisplay: block;\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4784: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck-content ol{list-style-type:decimal}.ck-content ol ol{list-style-type:lower-latin}.ck-content ol ol ol{list-style-type:lower-roman}.ck-content ol ol ol ol{list-style-type:upper-latin}.ck-content ol ol ol ol ol{list-style-type:upper-roman}.ck-content ul{list-style-type:disc}.ck-content ul ul{list-style-type:circle}.ck-content ul ul ul,.ck-content ul ul ul ul{list-style-type:square}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-list/theme/list.css"
                        ],
                        names: [],
                        mappings: "AAKA,eACC,uBAiBD,CAfC,kBACC,2BAaD,CAXC,qBACC,2BASD,CAPC,wBACC,2BAKD,CAHC,2BACC,2BACD,CAMJ,eACC,oBAaD,CAXC,kBACC,sBASD,CAJE,6CACC,sBACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content ol {\n\tlist-style-type: decimal;\n\n\t& ol {\n\t\tlist-style-type: lower-latin;\n\n\t\t& ol {\n\t\t\tlist-style-type: lower-roman;\n\n\t\t\t& ol {\n\t\t\t\tlist-style-type: upper-latin;\n\n\t\t\t\t& ol {\n\t\t\t\t\tlist-style-type: upper-roman;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-content ul {\n\tlist-style-type: disc;\n\n\t& ul {\n\t\tlist-style-type: circle;\n\n\t\t& ul {\n\t\t\tlist-style-type: square;\n\n\t\t\t& ul {\n\t\t\t\tlist-style-type: square;\n\t\t\t}\n\t\t}\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            9938: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-list-properties.ck-list-properties_without-styles{padding:var(--ck-spacing-large)}.ck.ck-list-properties.ck-list-properties_without-styles>*{min-width:14em}.ck.ck-list-properties.ck-list-properties_without-styles>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-list-styles-list{grid-template-columns:repeat(4,auto)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible{border-top:1px solid var(--ck-color-base-border)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*{width:100%}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties .ck.ck-numbered-list-properties__start-index .ck-input{min-width:auto;width:100%}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order{background:transparent;margin-bottom:calc(var(--ck-spacing-tiny)*-1);padding-left:0;padding-right:0}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:active,.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:hover{background:none;border-color:transparent;box-shadow:none}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-list/listproperties.css"
                        ],
                        names: [],
                        mappings: "AAOC,yDACC,+BASD,CAPC,2DACC,cAKD,CAHC,6DACC,qCACD,CASD,wFACC,oCACD,CAGA,mFACC,gDAWD,CARE,+GACC,UAKD,CAHC,iHACC,qCACD,CAMJ,8EACC,cAAe,CACf,UACD,CAEA,uEACC,sBAAuB,CAGvB,6CAAgD,CAFhD,cAAe,CACf,eAQD,CALC,2JAGC,eAAgB,CADhB,wBAAyB,CADzB,eAGD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-properties {\n\t/* When there are no list styles and there is no collapsible. */\n\t&.ck-list-properties_without-styles {\n\t\tpadding: var(--ck-spacing-large);\n\n\t\t& > * {\n\t\t\tmin-width: 14em;\n\n\t\t\t& + * {\n\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * When the numbered list property fields (start at, reversed) should be displayed,\n\t * more horizontal space is needed. Reconfigure the style grid to create that space.\n\t */\n\t&.ck-list-properties_with-numbered-properties {\n\t\t& > .ck-list-styles-list {\n\t\t\tgrid-template-columns: repeat( 4, auto );\n\t\t}\n\n\t\t/* When list styles are rendered and property fields are in a collapsible. */\n\t\t& > .ck-collapsible {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\n\t\t\t& > .ck-collapsible__children {\n\t\t\t\t& > * {\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t& + * {\n\t\t\t\t\t\tmargin-top: var(--ck-spacing-standard);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& .ck.ck-numbered-list-properties__start-index .ck-input {\n\t\tmin-width: auto;\n\t\twidth: 100%;\n\t}\n\n\t& .ck.ck-numbered-list-properties__reversed-order {\n\t\tbackground: transparent;\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\t\tmargin-bottom: calc(-1 * var(--ck-spacing-tiny));\n\n\t\t&:active, &:hover {\n\t\t\tbox-shadow: none;\n\t\t\tborder-color: transparent;\n\t\t\tbackground: none;\n\t\t}\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            2591: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-list-styles-list{display:grid}:root{--ck-list-style-button-size:44px}.ck.ck-list-styles-list{column-gap:var(--ck-spacing-medium);grid-template-columns:repeat(3,auto);padding:var(--ck-spacing-large);row-gap:var(--ck-spacing-medium)}.ck.ck-list-styles-list .ck-button{box-sizing:content-box;margin:0;padding:0}.ck.ck-list-styles-list .ck-button,.ck.ck-list-styles-list .ck-button .ck-icon{height:var(--ck-list-style-button-size);width:var(--ck-list-style-button-size)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-list/theme/liststyles.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-list/liststyles.css"
                        ],
                        names: [],
                        mappings: "AAKA,wBACC,YACD,CCFA,MACC,gCACD,CAEA,wBAGC,mCAAoC,CAFpC,oCAAwC,CAGxC,+BAAgC,CAFhC,gCA4BD,CAxBC,mCAiBC,sBAAuB,CAPvB,QAAS,CANT,SAmBD,CAJC,+EAhBA,uCAAwC,CADxC,sCAoBA",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-styles-list {\n\tdisplay: grid;\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-list-style-button-size: 44px;\n}\n\n.ck.ck-list-styles-list {\n\tgrid-template-columns: repeat( 3, auto );\n\trow-gap: var(--ck-spacing-medium);\n\tcolumn-gap: var(--ck-spacing-medium);\n\tpadding: var(--ck-spacing-large);\n\n\t& .ck-button {\n\t\t/* Make the button look like a thumbnail (the icon "takes it all"). */\n\t\twidth: var(--ck-list-style-button-size);\n\t\theight: var(--ck-list-style-button-size);\n\t\tpadding: 0;\n\n\t\t/*\n\t\t * Buttons are aligned by the grid so disable default button margins to not collide with the\n\t\t * gaps in the grid.\n\t\t */\n\t\tmargin: 0;\n\n\t\t/*\n\t\t * Make sure the button border (which is displayed on focus, BTW) does not steal pixels\n\t\t * from the button dimensions and, as a result, decrease the size of the icon\n\t\t * (which becomes blurry as it scales down).\n\t\t */\n\t\tbox-sizing: content-box;\n\n\t\t& .ck-icon {\n\t\t\twidth: var(--ck-list-style-button-size);\n\t\t\theight: var(--ck-list-style-button-size);\n\t\t}\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            9292: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ':root{--ck-todo-list-checkmark-size:16px}.ck-content .todo-list{list-style:none}.ck-content .todo-list li{margin-bottom:5px;position:relative}.ck-content .todo-list li .todo-list{margin-top:5px}.ck-content .todo-list .todo-list__label>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-content[dir=rtl] .todo-list .todo-list__label>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-content .todo-list .todo-list__label>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}.ck-content .todo-list .todo-list__label>input:after{border-color:transparent;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:content-box;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-content .todo-list .todo-list__label>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-content .todo-list .todo-list__label>input[checked]:after{border-color:#fff}.ck-content .todo-list .todo-list__label .todo-list__label__description{vertical-align:middle}.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}.ck-editor__editable.ck-content .todo-list .todo-list__label>input,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{cursor:pointer}.ck-editor__editable.ck-content .todo-list .todo-list__label>input:hover:before,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:hover:before{box-shadow:0 0 0 5px rgba(0,0,0,.1)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-editor__editable.ck-content[dir=rtl] .todo-list .todo-list__label>span[contenteditable=false]>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:after{border-color:transparent;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:content-box;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:after{border-color:#fff}.ck-editor__editable.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}',
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-list/theme/todolist.css"
                        ],
                        names: [],
                        mappings: "AAKA,MACC,kCACD,CAwEA,uBACC,eAwBD,CAtBC,0BAEC,iBAAkB,CADlB,iBAMD,CAHC,qCACC,cACD,CAIA,+CAlFD,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAiFC,CAFA,wDAhEA,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAgEA,CA5DD,sDAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UAKD,CAEA,qDAaC,wBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,sBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+DACC,kBAA8B,CAC9B,oBACD,CAEA,8DACC,iBACD,CAwBA,wEACC,qBACD,CAEA,mGACC,iBACD,CAYD,kKAEC,cAKD,CAHC,4LACC,mCACD,CAMD,+FApHA,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAmHA,CAFA,wGAlGC,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAkGD,CA9FA,sGAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UAKD,CAEA,qGAaC,wBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,sBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+GACC,kBAA8B,CAC9B,oBACD,CAEA,8GACC,iBACD,CA2DA,uHACC,iBACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-todo-list-checkmark-size: 16px;\n}\n\n@define-mixin todo-list-checkbox {\n\t-webkit-appearance: none;\n\tdisplay: inline-block;\n\tposition: relative;\n\twidth: var(--ck-todo-list-checkmark-size);\n\theight: var(--ck-todo-list-checkmark-size);\n\tvertical-align: middle;\n\n\t/* Needed on iOS */\n\tborder: 0;\n\n\t/* LTR styles */\n\tleft: -25px;\n\tmargin-right: -15px;\n\tright: 0;\n\tmargin-left: 0;\n\n\t/* RTL styles */\n\t@nest [dir=rtl]& {\n\t\tleft: 0;\n\t\tmargin-right: 0;\n\t\tright: -25px;\n\t\tmargin-left: -15px;\n\t}\n\n\t&::before {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: border-box;\n\t\tcontent: '';\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\tborder: 1px solid hsl(0, 0%, 20%);\n\t\tborder-radius: 2px;\n\t\ttransition: 250ms ease-in-out box-shadow;\n\t}\n\n\t&::after {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\tbox-sizing: content-box;\n\t\tpointer-events: none;\n\t\tcontent: '';\n\n\t\t/* Calculate tick position, size and border-width proportional to the checkmark size. */\n\t\tleft: calc( var(--ck-todo-list-checkmark-size) / 3 );\n\t\ttop: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\twidth: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n\t\theight: calc( var(--ck-todo-list-checkmark-size) / 2.6 );\n\t\tborder-style: solid;\n\t\tborder-color: transparent;\n\t\tborder-width: 0 calc( var(--ck-todo-list-checkmark-size) / 8 ) calc( var(--ck-todo-list-checkmark-size) / 8 ) 0;\n\t\ttransform: rotate(45deg);\n\t}\n\n\t&[checked] {\n\t\t&::before {\n\t\t\tbackground: hsl(126, 64%, 41%);\n\t\t\tborder-color: hsl(126, 64%, 41%);\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: hsl(0, 0%, 100%);\n\t\t}\n\t}\n}\n\n/*\n * To-do list content styles.\n */\n.ck-content .todo-list {\n\tlist-style: none;\n\n\t& li {\n\t\tposition: relative;\n\t\tmargin-bottom: 5px;\n\n\t\t& .todo-list {\n\t\t\tmargin-top: 5px;\n\t\t}\n\t}\n\n\t& .todo-list__label {\n\t\t& > input {\n\t\t\t@mixin todo-list-checkbox;\n\t\t}\n\n\t\t& .todo-list__label__description {\n\t\t\tvertical-align: middle;\n\t\t}\n\n\t\t&.todo-list__label_without-description input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n\n/*\n * To-do list editing view styles.\n */\n.ck-editor__editable.ck-content .todo-list .todo-list__label {\n\t/*\n\t * To-do list should be interactive only during the editing\n\t * (https://github.com/ckeditor/ckeditor5/issues/2090).\n\t */\n\t& > input,\n\t& > span[contenteditable=false] > input {\n\t\tcursor: pointer;\n\n\t\t&:hover::before {\n\t\t\tbox-shadow: 0 0 0 5px hsla(0, 0%, 0%, 0.1);\n\t\t}\n\t}\n\n\t/*\n\t * Document Lists - editing view has an additional span around checkbox.\n\t */\n\t& > span[contenteditable=false] > input {\n\t\t@mixin todo-list-checkbox;\n\t}\n\n\t&.todo-list__label_without-description {\n\t\t& input[type=checkbox] {\n\t\t\tposition: absolute;\n\t\t}\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4029: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-autocomplete{position:relative}.ck.ck-autocomplete>.ck-search__results{position:absolute;z-index:var(--ck-z-modal)}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{bottom:100%}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{bottom:auto;top:100%}.ck.ck-autocomplete>.ck-search__results{border-radius:0}.ck-rounded-corners .ck.ck-autocomplete>.ck-search__results,.ck.ck-autocomplete>.ck-search__results.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-autocomplete>.ck-search__results{background:var(--ck-color-base-background);border:1px solid var(--ck-color-dropdown-panel-border);box-shadow:var(--ck-drop-shadow),0 0;max-height:200px;min-width:auto;overflow-y:auto}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-1px}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{border-top-left-radius:0;border-top-right-radius:0;margin-top:-1px}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/autocomplete/autocomplete.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/autocomplete/autocomplete.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"
                        ],
                        names: [],
                        mappings: "AAKA,oBACC,iBAeD,CAbC,wCACC,iBAAkB,CAClB,yBAUD,CARC,6DACC,WACD,CAEA,6DAEC,WAAY,CADZ,QAED,CCVD,wCCEA,eDuBA,CAzBA,uHCMC,qCDmBD,CAzBA,wCAMC,0CAA2C,CAC3C,sDAAuD,CEPxD,oCAA8B,CFI7B,gBAAiB,CAIjB,cAAe,CAHf,eAoBD,CAfC,6DACC,2BAA4B,CAC5B,4BAA6B,CAG7B,kBACD,CAEA,6DACC,wBAAyB,CACzB,yBAA0B,CAG1B,eACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-autocomplete {\n\tposition: relative;\n\n\t& > .ck-search__results {\n\t\tposition: absolute;\n\t\tz-index: var(--ck-z-modal);\n\n\t\t&.ck-search__results_n {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck.ck-autocomplete {\n\t& > .ck-search__results {\n\t\t@mixin ck-rounded-corners;\n\t\t@mixin ck-drop-shadow;\n\n\t\tmax-height: 200px;\n\t\toverflow-y: auto;\n\t\tbackground: var(--ck-color-base-background);\n\t\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\t\tmin-width: auto;\n\n\t\t&.ck-search__results_n {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-bottom: -1px;\n\t\t}\n\n\t\t&.ck-search__results_s {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-top-right-radius: 0;\n\n\t\t\t/* Prevent duplicated borders between the input and the results pane. */\n\t\t\tmargin-top: -1px;\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4971: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;justify-content:left;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid transparent;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"
                        ],
                        names: [],
                        mappings: "AAOA,6BAMC,kBAAmB,CADnB,mBAAoB,CAEpB,oBAAqB,CAHrB,iBAAkB,CCFlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDkBD,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEjBD,6BCAC,oDD4ID,CCzIE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eF6ID,CA5IA,wIEGE,qCFyIF,CA5IA,6BA6BC,uBAAwB,CANxB,4BAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBAuID,CA7GC,oFGhCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHqCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAOA,gLKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDmIA,CChIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDgHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC/IC,mDDoJD,CCjJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDgID,2CAIC,wCACD,CAEA,uCAEC,eACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\n\t\tcolor: var(--ck-color-button-on-color);\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            7258: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:transparent;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid transparent;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:transparent;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css"
                        ],
                        names: [],
                        mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,sBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eD4EA,CAxCA,yIChCC,qCDwED,CAxCA,2DAKE,gBAmCF,CAxCA,2DAUE,iBA8BF,CAxCA,iDAkBC,uDAAwD,CAFxD,4BAA6B,CAD7B,iFAAsF,CAEtF,0CAuBD,CApBC,2ECxDD,eDmEC,CAXA,6LCpDA,qCAAsC,CDsDpC,8CASF,CAXA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAMD,CAEA,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEhFA,kCFkFA,CAGA,oCACC,wBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating\u2013point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n	/* 34px at 13px font-size */\n	--ck-switch-button-toggle-width: 2.6153846154em;\n	/* 14px at 13px font-size */\n	--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n	--ck-switch-button-translation: calc(\n		var(--ck-switch-button-toggle-width) -\n		var(--ck-switch-button-toggle-inner-size) -\n		2px /* Border */\n	);\n	--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n	/* Unlike a regular button, the switch button text color and background should never change.\n	 * Changing toggle switch (background, outline) is enough to carry the information about the\n	 * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)\n	 */\n	&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {\n		color: inherit;\n		background: transparent;\n	}\n\n	& .ck-button__label {\n		@mixin ck-dir ltr {\n			/* Separate the label from the switch */\n			margin-right: calc(2 * var(--ck-spacing-large));\n		}\n\n		@mixin ck-dir rtl {\n			/* Separate the label from the switch */\n			margin-left: calc(2 * var(--ck-spacing-large));\n		}\n	}\n\n	& .ck-button__toggle {\n		@mixin ck-rounded-corners;\n\n		@mixin ck-dir ltr {\n			/* Make sure the toggle is always to the right as far as possible. */\n			margin-left: auto;\n		}\n\n		@mixin ck-dir rtl {\n			/* Make sure the toggle is always to the left as far as possible. */\n			margin-right: auto;\n		}\n\n		/* Apply some smooth transition to the box-shadow and border. */\n		/* Gently animate the background color of the toggle switch */\n		transition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n		border: 1px solid transparent;\n		width: var(--ck-switch-button-toggle-width);\n		background: var(--ck-color-switch-button-off-background);\n\n		& .ck-button__toggle__inner {\n			@mixin ck-rounded-corners {\n				border-radius: calc(.5 * var(--ck-border-radius));\n			}\n\n			width: var(--ck-switch-button-toggle-inner-size);\n			height: var(--ck-switch-button-toggle-inner-size);\n			background: var(--ck-color-switch-button-inner-background);\n\n			/* Gently animate the inner part of the toggle switch */\n			transition: all 300ms ease;\n		}\n\n		&:hover {\n			background: var(--ck-color-switch-button-off-hover-background);\n\n			& .ck-button__toggle__inner {\n				box-shadow: var(--ck-switch-button-inner-hover-shadow);\n			}\n		}\n	}\n\n	&.ck-disabled .ck-button__toggle {\n		@mixin ck-disabled;\n	}\n\n	/* Overriding default .ck-button:focus styles + an outline around the toogle */\n	&:focus {\n		border-color: transparent;\n		outline: none;\n		box-shadow: none;\n\n		& .ck-button__toggle {\n			box-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n			outline-offset: 1px;\n			outline: var(--ck-focus-ring);\n		}\n	}\n\n	/* stylelint-disable-next-line no-descending-specificity */\n	&.ck-on {\n		& .ck-button__toggle {\n			background: var(--ck-color-switch-button-on-background);\n\n			&:hover {\n				background: var(--ck-color-switch-button-on-hover-background);\n			}\n\n			& .ck-button__toggle__inner {\n				/*\n				* Move the toggle switch to the right. It will be animated.\n				*/\n				@mixin ck-dir ltr {\n					transform: translateX( var( --ck-switch-button-translation ) );\n				}\n\n				@mixin ck-dir rtl {\n					transform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n				}\n			}\n		}\n	}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4923: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-selector__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css"
                        ],
                        names: [],
                        mappings: "AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBAOC,QAAS,CALT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CACV,8BAA+B,CAL/B,oCAyCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,+DACC,gDACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\twidth: var(--ck-color-grid-tile-size);\n\theight: var(--ck-color-grid-tile-size);\n\tmin-width: var(--ck-color-grid-tile-size);\n\tmin-height: var(--ck-color-grid-tile-size);\n\tpadding: 0;\n\ttransition: .2s ease box-shadow;\n\tborder: 0;\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t&.ck-color-selector__color-tile_bordered {\n\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&.ck-on,\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\t/* Disable the default .ck-button\'s border ring. */\n\t\tborder: 0;\n\t}\n\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4257: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".color-picker-hex-input{width:max-content}.color-picker-hex-input .ck.ck-input{min-width:unset}.ck.ck-color-picker__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;margin:var(--ck-spacing-large) 0 0;width:unset}.ck.ck-color-picker__row .ck.ck-labeled-field-view{padding-top:unset}.ck.ck-color-picker__row .ck.ck-input-text{width:unset}.ck.ck-color-picker__row .ck-color-picker__hash-view{padding-right:var(--ck-spacing-medium);padding-top:var(--ck-spacing-tiny)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorpicker/colorpicker.css"
                        ],
                        names: [],
                        mappings: "AAKA,wBACC,iBAKD,CAHC,qCACC,eACD,CAGD,yBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAA8B,CAC9B,kCAAmC,CACnC,WAcD,CAZC,mDACC,iBACD,CAEA,2CACC,WACD,CAEA,qDAEC,sCAAuC,CADvC,kCAED",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.color-picker-hex-input {\n\twidth: max-content;\n\n\t& .ck.ck-input {\n\t\tmin-width: unset;\n\t}\n}\n\n.ck.ck-color-picker__row {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\tjustify-content: space-between;\n\tmargin: var(--ck-spacing-large) 0 0;\n\twidth: unset;\n\n\t& .ck.ck-labeled-field-view {\n\t\tpadding-top: unset;\n\t}\n\n\t& .ck.ck-input-text {\n\t\twidth: unset;\n\t}\n\n\t& .ck-color-picker__hash-view {\n\t\tpadding-top: var(--ck-spacing-tiny);\n\t\tpadding-right: var(--ck-spacing-medium);\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            6306: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{align-items:center;display:flex}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{justify-content:flex-start}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{display:flex;flex-direction:row;justify-content:space-around}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-cancel,.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-save{flex:1}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{width:100%}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-left:var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment label.ck.ck-color-grid__label{font-weight:unset}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker{padding:8px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker{height:100px;min-width:180px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation){border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue){border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius)}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue-pointer),.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation-pointer){height:15px;width:15px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{padding:0 8px 8px}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorselector/colorselector.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorselector/colorselector.css"
                        ],
                        names: [],
                        mappings: "AAUE,oLAGC,kBAAmB,CADnB,YAMD,CARA,wMAME,0BAEF,CAKA,iFACC,YAAa,CACb,kBAAmB,CACnB,4BAMD,CAJC,oMAEC,MACD,CCrBD,oLAEC,UACD,CAEA,0FAEC,2BAA4B,CAC5B,4BAA6B,CAF7B,qEAiBD,CAbC,sGACC,gDACD,CAEA,gHAEE,uCAMF,CARA,gHAME,sCAEF,CAGD,6EACC,iBACD,CAKA,oEACC,WAoBD,CAlBC,sFACC,YAAa,CACb,eAeD,CAbC,wGACC,iEACD,CAEA,iGACC,iEACD,CAEA,yNAGC,WAAY,CADZ,UAED,CAIF,iFACC,iBACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tjustify-content: flex-start;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: space-around;\n\n\t\t\t& .ck-button-save,\n\t\t\t& .ck-button-cancel {\n\t\t\t\tflex: 1\n\t\t\t}\n\t\t}\n\t}\n}\n',
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n\t/* View fragment with color grids. */\n\t& .ck-color-grids-fragment {\n\t\t& .ck-button.ck-color-selector__remove-color,\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t& .ck-button.ck-color-selector__color-picker {\n\t\t\tpadding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t& .ck.ck-icon {\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tmargin-right: var(--ck-spacing-standard);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& label.ck.ck-color-grid__label {\n\t\t\tfont-weight: unset;\n\t\t}\n\t}\n\n\t/* View fragment with a color picker. */\n\t& .ck-color-picker-fragment {\n\t\t& .ck.ck-color-picker {\n\t\t\tpadding: 8px;\n\n\t\t\t& .hex-color-picker {\n\t\t\t\theight: 100px;\n\t\t\t\tmin-width: 180px;\n\n\t\t\t\t&::part(saturation) {\n\t\t\t\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\t\t\t\t}\n\n\t\t\t\t&::part(hue) {\n\t\t\t\t\tborder-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n\t\t\t\t}\n\n\t\t\t\t&::part(saturation-pointer),\n\t\t\t\t&::part(hue-pointer) {\n\t\t\t\t\twidth: 15px;\n\t\t\t\t\theight: 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t& .ck.ck-color-selector_action-bar {\n\t\t\tpadding: 0 8px 8px;\n\t\t}\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            5062: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-modal)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}.ck.ck-dropdown__panel:focus{outline:none}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"
                        ],
                        names: [],
                        mappings: "AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eHkHD,CAhCA,qFG9EE,qCH8GF,CAhCA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAuBD,CAnBC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD,CAEA,6BACC,YACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\t}\n\n\t& .ck-dropdown__panel {\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            1883: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"
                        ],
                        names: [],
                        mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4791: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton>.ck-splitbutton__arrow:not(:focus){border-bottom-width:0;border-top-width:0}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:focus:after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:focus:after{--ck-color-split-button-hover-border:var(--ck-color-focus-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}',
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"
                        ],
                        names: [],
                        mappings: "AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CAKD,sDAEC,qBAAwB,CADxB,kBAED,CAQC,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGA,sIACC,iEACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCCzFA,eDmGA,CAVA,qHCrFC,qCD+FD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n}\n\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* Make sure the divider stretches 100% height of the button\n\thttps://github.com/ckeditor/ckeditor5/issues/10936 */\n\t& > .ck-splitbutton__arrow:not(:focus) {\n\t\tborder-top-width: 0px;\n\t\tborder-bottom-width: 0px;\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t/* Make sure the divider between the buttons looks fine when the button is focused */\n\t\t& > .ck-splitbutton__arrow:focus::after {\n\t\t\t--ck-color-split-button-hover-border: var(--ck-color-focus-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            2704: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"
                        ],
                        names: [],
                        mappings: "AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            9847: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid transparent;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"
                        ],
                        names: [],
                        mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,4BAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,oDACD,CAIA,gEACC,iDACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-panel-background);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-panel-background);\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            1874: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__header .ck-icon{margin-right:var(--ck-spacing-medium)}.ck.ck-form__header h2.ck-form__header__label{flex-grow:1}:root{--ck-form-header-height:38px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}.ck.ck-form__header .ck-form__header__label{font-weight:700}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"
                        ],
                        names: [],
                        mappings: "AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BASD,CAPC,6BACC,qCACD,CAEA,8CACC,WACD,CCbD,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAQD,CAHC,4CACC,eACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\t& .ck-icon {\n\t\tmargin-right: var(--ck-spacing-medium);\n\t}\n\n\t& h2.ck-form__header__label {\n\t\tflex-grow: 1;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& .ck-form__header__label {\n\t\tfont-weight: bold;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4746: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-highlighted-text mark{background:var(--ck-color-highlight-background);font-size:inherit;font-weight:inherit;line-height:inherit;vertical-align:initial}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/highlightedtext/highlightedtext.css"
                        ],
                        names: [],
                        mappings: "AAKA,6BACC,+CAAgD,CAIhD,iBAAkB,CAFlB,mBAAoB,CACpB,mBAAoB,CAFpB,sBAID",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-highlighted-text mark {\n\tbackground: var(--ck-color-highlight-background);\n\tvertical-align: initial;\n\tfont-weight: inherit;\n\tline-height: inherit;\n\tfont-size: inherit;\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            1977: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"
                        ],
                        names: [],
                        mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\t}\n\n\t/* Allows dynamic coloring of an icon by inheriting its color from the parent. */\n\t&.ck-icon_inherit-color {\n\t\tcolor: inherit;\n\n\t\t& * {\n\t\t\tcolor: inherit;\n\n\t\t\t&:not([fill]) {\n\t\t\t\t/* Needed by FF. */\n\t\t\t\tfill: currentColor;\n\t\t\t}\n\t\t}\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            2470: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"
                        ],
                        names: [],
                        mappings: "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eD2CD,CAtCA,iECDE,qCDuCF,CAtCA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DA0BD,CAxBC,mBEnBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YFuBA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BG/BD,oDHkCC,CAGD,sBAEC,sCAAuC,CADvC,+CAMD,CAHC,4BGzCD,iDH2CC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3525: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"
                        ],
                        names: [],
                        mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            2933: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:transparent;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"
                        ],
                        names: [],
                        mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eD8GD,CAzGA,2FCDE,qCD0GF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAiBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAP9C,mBAAoB,CAYpB,sBAAuB,CARvB,6DAA+D,CAH/D,oBAAqB,CAgBrB,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,oUAGE,+HAYF,CAfA,oUAOE,wIAQF,CAfA,gTAaC,sBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            179: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{border-radius:0;min-height:unset;padding:calc(var(--ck-line-height-base)*.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*.4*var(--ck-font-size-base));text-align:left;width:100%}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck-list .ck-list__group{padding-top:var(--ck-spacing-medium);:not(.ck-hidden)~&{border-top:1px solid var(--ck-color-base-border)}}.ck-list .ck-list__group>span{font-size:11px;font-weight:700;padding:var(--ck-spacing-medium)}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"
                        ],
                        names: [],
                        mappings: "AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAIC,eAAgB,CAHhB,gBAAiB,CAQjB,iIAEiE,CARjE,eAAgB,CADhB,UAwCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,yBACC,oCAAqC,CAGrC,mBACC,gDACD,CAOD,CALC,8BACC,cAAe,CACf,eAAiB,CACjB,gCACD,CAGD,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-switchbutton):not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-list .ck-list__group {\n\tpadding-top: var(--ck-spacing-medium);\n\n\t/* The group should have a border when it\'s not the first item. */\n\t*:not(.ck-hidden) ~ & {\n\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t}\n\n\t& > span {\n\t\tfont-size: 11px;\n\t\tfont-weight: bold;\n\t\tpadding: var(--ck-spacing-medium);\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4460: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:transparent transparent var(--ck-color-panel-border) transparent;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:transparent transparent var(--ck-color-panel-background) transparent;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) transparent transparent;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) transparent transparent transparent;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:transparent transparent transparent var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:transparent transparent transparent var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:transparent var(--ck-color-panel-border) transparent transparent;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:transparent var(--ck-color-panel-background) transparent transparent;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}',
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"
                        ],
                        names: [],
                        mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,kDACD,CAEA,2CACC,iFAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,iEAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,iFAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,oDACD,CAEA,2CACC,iFAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,mDACD,CAEA,2CACC,iFAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n',
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-border-width: 1px;\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t\tmargin-top: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t\tmargin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_e"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-border);\n\t\t\tmargin-right: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-background);\n\t\t\tmargin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_w"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent var(--ck-color-panel-border) transparent transparent;\n\t\t\tmargin-left: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent var(--ck-color-panel-background) transparent transparent;\n\t\t\tmargin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_e {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_w {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            7592: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"
                        ],
                        names: [],
                        mappings: "AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            6356: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"
                        ],
                        names: [],
                        mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3707: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-modal)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"
                        ],
                        names: [],
                        mappings: "AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            6603: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}',
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"
                        ],
                        names: [],
                        mappings: "AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAmED,CAjEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA8CF,CA5CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDpEH",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n\t&::after {\n\t\tcontent: "";\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tright: -1px;\n\t\ttop: -1px;\n\t\tbottom: -1px;\n\t\tz-index: 1;\n\t}\n\n\t&:focus::after {\n\t\tdisplay: none;\n\t}\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button {\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -1px;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom: -1px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t&:focus::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\t\t\tborder-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            9332: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{position:absolute;top:50%;transform:translateY(-50%)}[dir=ltr] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{left:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{right:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view .ck-search__reset{position:absolute;top:50%;transform:translateY(-50%)}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{display:block}.ck.ck-search>.ck-search__results>.ck-search__info:not(.ck-hidden)~*{display:none}:root{--ck-search-field-view-horizontal-spacing:calc(var(--ck-icon-size) + var(--ck-spacing-medium))}.ck.ck-search>.ck-labeled-field-view .ck-input{width:100%}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon{--ck-labeled-field-label-default-position-x:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon>.ck-labeled-field-view__input-wrapper>.ck-icon{opacity:.5;pointer-events:none}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input,[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input:not(.ck-input-text_empty){padding-left:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset{--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset.ck-labeled-field-view_empty{--ck-labeled-field-empty-unfocused-max-width:100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{background:none;min-height:auto;min-width:auto;opacity:.5;padding:0}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{left:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset:hover{opacity:1}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input:not(.ck-input-text_empty),[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{padding-right:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-search__results{min-width:100%}.ck.ck-search>.ck-search__results>.ck-search__info{padding:var(--ck-spacing-medium) var(--ck-spacing-large);width:100%}.ck.ck-search>.ck-search__results>.ck-search__info *{white-space:normal}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{font-weight:700}.ck.ck-search>.ck-search__results>.ck-search__info>span:last-child{margin-top:var(--ck-spacing-medium)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/search/search.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/search/search.css"
                        ],
                        names: [],
                        mappings: "AASE,oFACC,iBAAkB,CAClB,OAAQ,CACR,0BASD,CAZA,8FAME,6BAMF,CAZA,8FAUE,8BAEF,CAEA,uDACC,iBAAkB,CAClB,OAAQ,CACR,0BACD,CAKC,oEACC,aACD,CAGA,qEACC,YACD,CChCH,MACC,8FACD,CAIE,+CACC,UACD,CAEA,gEACC,0FAoBD,CAlBC,+GACC,UAAW,CACX,mBACD,CAEA,0EACC,UAWD,CAJE,kMACC,2DACD,CAKH,iEACC,sGAwCD,CAtCC,6FACC,6HACD,CAEA,mFAIC,eAAgB,CAFhB,eAAgB,CADhB,cAAe,CAIf,UAAW,CACX,SAaD,CAnBA,6FASE,8BAUF,CAnBA,6FAaE,6BAMF,CAHC,yFACC,SACD,CAGD,2EACC,UAWD,CAZA,oMAUE,4DAEF,CAIF,kCACC,cAkBD,CAhBC,mDAEC,wDAAyD,CADzD,UAcD,CAXC,qDACC,kBACD,CAEA,oEACC,eACD,CAEA,mEACC,mCACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\n\t\t& .ck-search__reset {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\t& > .ck-search__info {\n\t\t\t& > span:first-child {\n\t\t\t\tdisplay: block;\n\t\t\t}\n\n\t\t\t/* Hide the filtered view when nothing was found */\n\t\t\t&:not(.ck-hidden) ~ * {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n',
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-search-field-view-horizontal-spacing: calc(var(--ck-icon-size) + var(--ck-spacing-medium));\n}\n\n.ck.ck-search {\n\t& > .ck-labeled-field-view {\n\t\t& .ck-input {\n\t\t\twidth: 100%;\n\t\t}\n\n\t\t&.ck-search__query_with-icon {\n\t\t\t--ck-labeled-field-label-default-position-x: var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n\t\t\t\topacity: .5;\n\t\t\t\tpointer-events: none;\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-left: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-search__query_with-reset {\n\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-search-field-view-horizontal-spacing);\n\n\t\t\t&.ck-labeled-field-view_empty {\n\t\t\t\t--ck-labeled-field-empty-unfocused-max-width: 100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium);\n\t\t\t}\n\n\t\t\t& .ck-search__reset {\n\t\t\t\tmin-width: auto;\n\t\t\t\tmin-height: auto;\n\n\t\t\t\tbackground: none;\n\t\t\t\topacity: .5;\n\t\t\t\tpadding: 0;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\tright: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tleft: var(--ck-spacing-medium);\n\t\t\t\t}\n\n\t\t\t\t&:hover {\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t& .ck-input {\n\t\t\t\twidth: 100%;\n\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\t&:not(.ck-input-text_empty) {\n\t\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\tpadding-right: var(--ck-search-field-view-horizontal-spacing);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck-search__results {\n\t\tmin-width: 100%;\n\n\t\t& > .ck-search__info {\n\t\t\twidth: 100%;\n\t\t\tpadding: var(--ck-spacing-medium) var(--ck-spacing-large);\n\n\t\t\t& * {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\n\t\t\t& > span:first-child {\n\t\t\t\tfont-weight: bold;\n\t\t\t}\n\n\t\t\t& > span:last-child {\n\t\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t\t}\n\t\t}\n\t}\n}\n\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            6446: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-spinner-container{display:block;position:relative}.ck.ck-spinner{left:0;margin:0 auto;position:absolute;right:0;top:50%;transform:translateY(-50%);z-index:1}:root{--ck-toolbar-spinner-size:18px}.ck.ck-spinner-container{animation:rotate 1.5s linear infinite}.ck.ck-spinner,.ck.ck-spinner-container{height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}.ck.ck-spinner{border:2px solid var(--ck-color-text);border-radius:50%;border-top:2px solid transparent}@keyframes rotate{to{transform:rotate(1turn)}}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/spinner/spinner.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/spinner/spinner.css"
                        ],
                        names: [],
                        mappings: "AASA,yBACC,aAAc,CACd,iBACD,CAEA,eAGC,MAAO,CAEP,aAAc,CAJd,iBAAkB,CAGlB,OAAQ,CAFR,OAAQ,CAIR,0BAA2B,CAC3B,SACD,CCjBA,MACC,8BACD,CAEA,yBAGC,qCACD,CAEA,wCAJC,qCAAsC,CADtC,oCAWD,CANA,eAKC,qCAA6B,CAF7B,iBAAkB,CAElB,gCACD,CAEA,kBACC,GACC,uBACD,CACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\tdisplay: block;\n\tposition: relative;\n}\n\n.ck.ck-spinner {\n\tposition: absolute;\n\ttop: 50%;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n\ttransform: translateY(-50%);\n\tz-index: 1;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tanimation: 1.5s infinite rotate linear;\n}\n\n.ck.ck-spinner {\n\twidth: var(--ck-toolbar-spinner-size);\n\theight: var(--ck-toolbar-spinner-size);\n\tborder-radius: 50%;\n\tborder: 2px solid var(--ck-color-text);\n\tborder-top-color: transparent;\n}\n\n@keyframes rotate {\n\tto {\n\t\ttransform: rotate(360deg)\n\t}\n}\n\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            5224: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck-textarea{overflow-x:hidden}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/textarea/textarea.css"
                        ],
                        names: [],
                        mappings: "AASA,aACC,iBACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/*\n * This fixes a problem in Firefox when the initial height of the complement does not match the number of rows.\n * This bug is especially visible when rows=1.\n */\n.ck-textarea {\n\toverflow-x: hidden\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4176: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"
                        ],
                        names: [],
                        mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4768: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck.ck-toolbar:focus{outline:none}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css"
                        ],
                        names: [],
                        mappings: "AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDwGD,CA3GA,qECOE,qCDoGF,CA3GA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAuGD,CApGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAGD,qBACC,YACD,CAtGD,qCAyGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t/* A drop-down containing the nested toolbar with configured items. */\n\t& .ck-toolbar__nested-toolbar-dropdown {\n\t\t/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */\n\t\t& > .ck-dropdown__panel {\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& > .ck-button > .ck-button__label {\n\t\t\tmax-width: 7em;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\n\t&:focus {\n\t\toutline: none;\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3888: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck.ck-balloon-panel.ck-tooltip{--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-tooltip-text-padding:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium);pointer-events:none;z-index:calc(var(--ck-z-modal) + 100)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip.ck-tooltip_multi-line .ck-tooltip__text{display:inline-block;padding:var(--ck-tooltip-text-padding) 0;white-space:break-spaces}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css"
                        ],
                        names: [],
                        mappings: "AAKA,gCCGC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,6BAA8B,CAC9B,8DAA+D,CAE/D,kCAAmC,CDRnC,mBAAoB,CAEpB,qCACD,CCOC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAEA,wEAEC,oBAAqB,CACrB,wCAAyC,CAFzC,wBAGD,CApBD,gCAuBC,eAMD,CAHC,uCACC,YACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t/* Keep tooltips transparent for any interactions. */\n\tpointer-events: none;\n\n\tz-index: calc( var(--ck-z-modal) + 100 );\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t--ck-balloon-border-width: 0px;\n\t--ck-balloon-arrow-offset: 0px;\n\t--ck-balloon-arrow-half-width: 4px;\n\t--ck-balloon-arrow-height: 4px;\n\t--ck-tooltip-text-padding: 4px;\n\t--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n\tpadding: 0 var(--ck-spacing-medium);\n\n\t& .ck-tooltip__text {\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t}\n\n\t&.ck-tooltip_multi-line .ck-tooltip__text {\n\t\twhite-space: break-spaces;\n\t\tdisplay: inline-block;\n\t\tpadding: var(--ck-tooltip-text-padding) 0;\n\t}\n\n\t/* Reset balloon panel styles */\n\tbox-shadow: none;\n\n\t/* Hide the default shadow of the .ck-balloon-panel tip */\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            5167: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck-hidden{display:none!important}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{box-sizing:border-box;height:auto;position:static;width:auto}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-powered-by-line-height:10px;--ck-powered-by-padding-vertical:2px;--ck-powered-by-padding-horizontal:4px;--ck-powered-by-text-color:#4f4f4f;--ck-powered-by-border-radius:var(--ck-border-radius);--ck-powered-by-background:#fff;--ck-powered-by-border-color:var(--ck-color-focus-border)}.ck.ck-balloon-panel.ck-powered-by-balloon{--ck-border-radius:var(--ck-powered-by-border-radius);background:var(--ck-powered-by-background);box-shadow:none;min-height:unset;z-index:calc(var(--ck-z-modal) - 1)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by{line-height:var(--ck-powered-by-line-height)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by a{align-items:center;cursor:pointer;display:flex;filter:grayscale(80%);line-height:var(--ck-powered-by-line-height);opacity:.66;padding:var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-powered-by__label{color:var(--ck-powered-by-text-color);cursor:pointer;font-size:7.5px;font-weight:700;letter-spacing:-.2px;line-height:normal;margin-right:4px;padding-left:2px;text-transform:uppercase}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-icon{cursor:pointer;display:block}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by:hover a{filter:grayscale(0);opacity:1}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_inside]{border-color:transparent}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_border]{border:var(--ck-focus-ring);border-color:var(--ck-powered-by-border-color)}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:rgba(119,186,248,.3);--ck-color-focus-error-shadow:rgba(255,64,31,.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,.15);--ck-color-shadow-drop-active:rgba(0,0,0,.2);--ck-color-shadow-inner:rgba(0,0,0,.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,176,255,.1);--ck-color-link-fake-selection:rgba(31,176,255,.3);--ck-color-highlight-background:#ff0;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{word-wrap:break-word;background:transparent;border:0;margin:0;padding:0;text-decoration:none;transition:none;vertical-align:middle}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_poweredby.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"
                        ],
                        names: [],
                        mappings: "AAQA,WAGC,sBACD,CCPA,2EAGC,qBAAsB,CAEtB,WAAY,CACZ,eAAgB,CAFhB,UAGD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,gCAAiC,CACjC,oCAAqC,CACrC,sCAAuC,CACvC,kCAA2C,CAC3C,qDAAsD,CACtD,+BAA4C,CAC5C,yDACD,CAEA,2CACC,qDAAsD,CAGtD,0CAA2C,CAD3C,eAAgB,CAEhB,gBAAiB,CACjB,mCAiDD,CA/CC,6DACC,4CAoCD,CAlCC,+DAGC,kBAAmB,CAFnB,cAAe,CACf,YAAa,CAGb,qBAAsB,CACtB,4CAA6C,CAF7C,WAAY,CAGZ,qFACD,CAEA,mFASC,qCAAsC,CAFtC,cAAe,CANf,eAAgB,CAIhB,eAAiB,CAHjB,oBAAqB,CAMrB,kBAAmB,CAFnB,gBAAiB,CAHjB,gBAAiB,CACjB,wBAOD,CAEA,sEAEC,cAAe,CADf,aAED,CAGC,qEACC,mBAAqB,CACrB,SACD,CAIF,mEACC,wBACD,CAEA,mEACC,2BAA4B,CAC5B,8CACD,CChED,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,qDAA8D,CAC9D,gDAAyD,CACzD,yCAAqD,CACrD,sCAAsD,CACtD,4CAA0D,CAC1D,sCAAsD,CAItD,gDAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,yDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,oDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,uDAAmE,CACnE,kDAAgE,CAIhE,oCAAwD,CCvGxD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJuGD,CIjGA,2EAaC,oBAAqB,CANrB,sBAAuB,CADvB,QAAS,CAFT,QAAS,CACT,SAAU,CAGV,oBAAqB,CAErB,eAAgB,CADhB,qBAKD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-powered-by-line-height: 10px;\n\t--ck-powered-by-padding-vertical: 2px;\n\t--ck-powered-by-padding-horizontal: 4px;\n\t--ck-powered-by-text-color: hsl(0, 0%, 31%);\n\t--ck-powered-by-border-radius: var(--ck-border-radius);\n\t--ck-powered-by-background: hsl(0, 0%, 100%);\n\t--ck-powered-by-border-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-balloon-panel.ck-powered-by-balloon {\n\t--ck-border-radius: var(--ck-powered-by-border-radius);\n\n\tbox-shadow: none;\n\tbackground: var(--ck-powered-by-background);\n\tmin-height: unset;\n\tz-index: calc( var(--ck-z-modal) - 1 );\n\n\t& .ck.ck-powered-by {\n\t\tline-height: var(--ck-powered-by-line-height);\n\n\t\t& a {\n\t\t\tcursor: pointer;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\topacity: .66;\n\t\t\tfilter: grayscale(80%);\n\t\t\tline-height: var(--ck-powered-by-line-height);\n\t\t\tpadding: var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal);\n\t\t}\n\n\t\t& .ck-powered-by__label {\n\t\t\tfont-size: 7.5px;\n\t\t\tletter-spacing: -.2px;\n\t\t\tpadding-left: 2px;\n\t\t\ttext-transform: uppercase;\n\t\t\tfont-weight: bold;\n\t\t\tmargin-right: 4px;\n\t\t\tcursor: pointer;\n\t\t\tline-height: normal;\n\t\t\tcolor: var(--ck-powered-by-text-color);\n\n\t\t}\n\n\t\t& .ck-icon {\n\t\t\tdisplay: block;\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t&:hover {\n\t\t\t& a {\n\t\t\t\tfilter: grayscale(0%);\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[class*="position_inside"] {\n\t\tborder-color: transparent;\n\t}\n\n\t&[class*="position_border"] {\n\t\tborder: var(--ck-focus-ring);\n\t\tborder-color: var(--ck-powered-by-border-color);\n\t}\n}\n\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(220, 6%, 81%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 50.2%, 42.5%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(218.2, 100%, 52.5%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t218, 81.8%, 56.9%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(212.4, 89.3%, 89%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(212, 100%, 97.1%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(211, 15%, 95%);\n\t--ck-color-button-on-color:\t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 57.6%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 49%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n\n\t/* -- Search result highlight ---------------------------------------------------------------- */\n\n\t--ck-color-highlight-background:\t\t\t\t\t\t\thsl(60, 100%, 50%)\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck-reset_all {\n\t& .ck-rtl *:not(.ck-reset_all-excluded *) {\n\t\ttext-align: right;\n\t}\n\n\t& iframe:not(.ck-reset_all-excluded *) {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *) {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *),\n\t& input[type="text"]:not(.ck-reset_all-excluded *),\n\t& input[type="password"]:not(.ck-reset_all-excluded *) {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n\t\tcursor: default;\n\t}\n\n\t& fieldset:not(.ck-reset_all-excluded *) {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            7153: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:transparent;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background);border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:transparent;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css"
                        ],
                        names: [],
                        mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,yBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGAKC,iEAAkE,CCnCnE,2BAA2B,CCF3B,qCAA8B,CDC9B,YDqCA,CAIA,4EAKC,4BAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAgCD,CAnBC,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAWD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n",
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n',
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            4875: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}",
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"
                        ],
                        names: [],
                        mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD",
                        sourcesContent: [
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n",
                            "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n"
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            2347: (t, e, n)=>{
                "use strict";
                n.d(e, {
                    Z: ()=>c
                });
                var o = n(4015);
                var i = n.n(o);
                var r = n(3645);
                var s = n.n(r);
                var a = s()(i());
                a.push([
                    t.id,
                    '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3));border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid hsla(0,0%,100%,.5);pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}',
                    "",
                    {
                        version: 3,
                        sources: [
                            "webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css",
                            "webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"
                        ],
                        names: [],
                        mappings: "AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAkDD,CA1CC,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAoBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,uEAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,oCAAwC,CARxC,mBAUD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD",
                        sourcesContent: [
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n',
                            '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'
                        ],
                        sourceRoot: ""
                    }
                ]);
                const c = a;
            },
            3645: (t)=>{
                "use strict";
                t.exports = function(t) {
                    var e = [];
                    e.toString = function e() {
                        return this.map(function(e) {
                            var n = t(e);
                            if (e[2]) return "@media ".concat(e[2], " {").concat(n, "}");
                            return n;
                        }).join("");
                    };
                    e.i = function(t, n, o) {
                        if (typeof t === "string") t = [
                            [
                                null,
                                t,
                                ""
                            ]
                        ];
                        var i = {};
                        if (o) for(var r = 0; r < this.length; r++){
                            var s = this[r][0];
                            if (s != null) i[s] = true;
                        }
                        for(var a = 0; a < t.length; a++){
                            var c = [].concat(t[a]);
                            if (o && i[c[0]]) continue;
                            if (n) {
                                if (!c[2]) c[2] = n;
                                else c[2] = "".concat(n, " and ").concat(c[2]);
                            }
                            e.push(c);
                        }
                    };
                    return e;
                };
            },
            4015: (t)=>{
                "use strict";
                function e(t, e) {
                    return s(t) || r(t, e) || o(t, e) || n();
                }
                function n() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                function o(t, e) {
                    if (!t) return;
                    if (typeof t === "string") return i(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    if (n === "Object" && t.constructor) n = t.constructor.name;
                    if (n === "Map" || n === "Set") return Array.from(t);
                    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return i(t, e);
                }
                function i(t, e) {
                    if (e == null || e > t.length) e = t.length;
                    for(var n = 0, o = new Array(e); n < e; n++)o[n] = t[n];
                    return o;
                }
                function r(t, e) {
                    var n = t && (typeof Symbol !== "undefined" && t[Symbol.iterator] || t["@@iterator"]);
                    if (n == null) return;
                    var o = [];
                    var i = true;
                    var r = false;
                    var s, a;
                    try {
                        for(n = n.call(t); !(i = (s = n.next()).done); i = true){
                            o.push(s.value);
                            if (e && o.length === e) break;
                        }
                    } catch (t) {
                        r = true;
                        a = t;
                    } finally{
                        try {
                            if (!i && n["return"] != null) n["return"]();
                        } finally{
                            if (r) throw a;
                        }
                    }
                    return o;
                }
                function s(t) {
                    if (Array.isArray(t)) return t;
                }
                t.exports = function t(n) {
                    var o = e(n, 4), i = o[1], r = o[3];
                    if (!r) return i;
                    if (typeof btoa === "function") {
                        var s = btoa(unescape(encodeURIComponent(JSON.stringify(r))));
                        var a = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(s);
                        var c = "/*# ".concat(a, " */");
                        var l = r.sources.map(function(t) {
                            return "/*# sourceURL=".concat(r.sourceRoot || "").concat(t, " */");
                        });
                        return [
                            i
                        ].concat(l).concat([
                            c
                        ]).join("\n");
                    }
                    return [
                        i
                    ].join("\n");
                };
            },
            3379: (t, e, n)=>{
                "use strict";
                var o = function t() {
                    var e;
                    return function t() {
                        if (typeof e === "undefined") e = Boolean(window && document && document.all && !window.atob);
                        return e;
                    };
                }();
                var i = function t() {
                    var e = {};
                    return function t(n) {
                        if (typeof e[n] === "undefined") {
                            var o = document.querySelector(n);
                            if (window.HTMLIFrameElement && o instanceof window.HTMLIFrameElement) try {
                                o = o.contentDocument.head;
                            } catch (t) {
                                o = null;
                            }
                            e[n] = o;
                        }
                        return e[n];
                    };
                }();
                var r = [];
                function s(t) {
                    var e = -1;
                    for(var n = 0; n < r.length; n++)if (r[n].identifier === t) {
                        e = n;
                        break;
                    }
                    return e;
                }
                function a(t, e) {
                    var n = {};
                    var o = [];
                    for(var i = 0; i < t.length; i++){
                        var a = t[i];
                        var c = e.base ? a[0] + e.base : a[0];
                        var l = n[c] || 0;
                        var d = "".concat(c, " ").concat(l);
                        n[c] = l + 1;
                        var u = s(d);
                        var h = {
                            css: a[1],
                            media: a[2],
                            sourceMap: a[3]
                        };
                        if (u !== -1) {
                            r[u].references++;
                            r[u].updater(h);
                        } else r.push({
                            identifier: d,
                            updater: g(h, e),
                            references: 1
                        });
                        o.push(d);
                    }
                    return o;
                }
                function c(t) {
                    var e = document.createElement("style");
                    var o = t.attributes || {};
                    if (typeof o.nonce === "undefined") {
                        var r = (0, n.nc);
                        if (r) o.nonce = r;
                    }
                    Object.keys(o).forEach(function(t) {
                        e.setAttribute(t, o[t]);
                    });
                    if (typeof t.insert === "function") t.insert(e);
                    else {
                        var s = i(t.insert || "head");
                        if (!s) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
                        s.appendChild(e);
                    }
                    return e;
                }
                function l(t) {
                    if (t.parentNode === null) return false;
                    t.parentNode.removeChild(t);
                }
                var d = function t() {
                    var e = [];
                    return function t(n, o) {
                        e[n] = o;
                        return e.filter(Boolean).join("\n");
                    };
                }();
                function u(t, e, n, o) {
                    var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
                    if (t.styleSheet) t.styleSheet.cssText = d(e, i);
                    else {
                        var r = document.createTextNode(i);
                        var s = t.childNodes;
                        if (s[e]) t.removeChild(s[e]);
                        if (s.length) t.insertBefore(r, s[e]);
                        else t.appendChild(r);
                    }
                }
                function h(t, e, n) {
                    var o = n.css;
                    var i = n.media;
                    var r = n.sourceMap;
                    if (i) t.setAttribute("media", i);
                    else t.removeAttribute("media");
                    if (r && typeof btoa !== "undefined") o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */");
                    if (t.styleSheet) t.styleSheet.cssText = o;
                    else {
                        while(t.firstChild)t.removeChild(t.firstChild);
                        t.appendChild(document.createTextNode(o));
                    }
                }
                var f = null;
                var p = 0;
                function g(t, e) {
                    var n;
                    var o;
                    var i;
                    if (e.singleton) {
                        var r = p++;
                        n = f || (f = c(e));
                        o = u.bind(null, n, r, false);
                        i = u.bind(null, n, r, true);
                    } else {
                        n = c(e);
                        o = h.bind(null, n, e);
                        i = function t() {
                            l(n);
                        };
                    }
                    o(t);
                    return function e(n) {
                        if (n) {
                            if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) return;
                            o(t = n);
                        } else i();
                    };
                }
                t.exports = function(t, e) {
                    e = e || {};
                    if (!e.singleton && typeof e.singleton !== "boolean") e.singleton = o();
                    t = t || [];
                    var n = a(t, e);
                    return function t(o) {
                        o = o || [];
                        if (Object.prototype.toString.call(o) !== "[object Array]") return;
                        for(var i = 0; i < n.length; i++){
                            var c = n[i];
                            var l = s(c);
                            r[l].references--;
                        }
                        var d = a(o, e);
                        for(var u = 0; u < n.length; u++){
                            var h = n[u];
                            var f = s(h);
                            if (r[f].references === 0) {
                                r[f].updater();
                                r.splice(f, 1);
                            }
                        }
                        n = d;
                    };
                };
            }
        };
        var e = {};
        function n(o) {
            var i = e[o];
            if (i !== undefined) return i.exports;
            var r = e[o] = {
                id: o,
                exports: {}
            };
            t[o](r, r.exports, n);
            return r.exports;
        }
        (()=>{
            n.n = (t)=>{
                var e = t && t.__esModule ? ()=>t["default"] : ()=>t;
                n.d(e, {
                    a: e
                });
                return e;
            };
        })();
        (()=>{
            n.d = (t, e)=>{
                for(var o in e)if (n.o(e, o) && !n.o(t, o)) Object.defineProperty(t, o, {
                    enumerable: true,
                    get: e[o]
                });
            };
        })();
        (()=>{
            n.o = (t, e)=>Object.prototype.hasOwnProperty.call(t, e);
        })();
        (()=>{
            n.nc = undefined;
        })();
        var o = {};
        (()=>{
            "use strict";
            n.d(o, {
                default: ()=>ON
            });
            function t({ emitter: t, activator: e, callback: n, contextElements: o }) {
                t.listenTo(document, "mousedown", (t, i)=>{
                    if (!e()) return;
                    const r = typeof i.composedPath == "function" ? i.composedPath() : [];
                    const s = typeof o == "function" ? o() : o;
                    for (const t of s){
                        if (t.contains(i.target) || r.includes(t)) return;
                    }
                    n();
                });
            }
            function e(t) {
                class e extends t {
                    disableCssTransitions() {
                        this._isCssTransitionsDisabled = true;
                    }
                    enableCssTransitions() {
                        this._isCssTransitionsDisabled = false;
                    }
                    constructor(...t){
                        super(...t);
                        this.set("_isCssTransitionsDisabled", false);
                        this.initializeCssTransitionDisablerMixin();
                    }
                    initializeCssTransitionDisablerMixin() {
                        this.extendTemplate({
                            attributes: {
                                class: [
                                    this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")
                                ]
                            }
                        });
                    }
                }
                return e;
            }
            function i({ view: t }) {
                t.listenTo(t.element, "submit", (e, n)=>{
                    n.preventDefault();
                    t.fire("submit");
                }, {
                    useCapture: true
                });
            }
            function r() {
                try {
                    return navigator.userAgent.toLowerCase();
                } catch (t) {
                    return "";
                }
            }
            const s = r();
            const a = {
                isMac: l(s),
                isWindows: d(s),
                isGecko: u(s),
                isSafari: h(s),
                isiOS: f(s),
                isAndroid: p(s),
                isBlink: g(s),
                features: {
                    isRegExpUnicodePropertySupported: m()
                }
            };
            const c = a;
            function l(t) {
                return t.indexOf("macintosh") > -1;
            }
            function d(t) {
                return t.indexOf("windows") > -1;
            }
            function u(t) {
                return !!t.match(/gecko\/\d+/);
            }
            function h(t) {
                return t.indexOf(" applewebkit/") > -1 && t.indexOf("chrome") === -1;
            }
            function f(t) {
                return !!t.match(/iphone|ipad/i) || l(t) && navigator.maxTouchPoints > 0;
            }
            function p(t) {
                return t.indexOf("android") > -1;
            }
            function g(t) {
                return t.indexOf("chrome/") > -1 && t.indexOf("edge/") < 0;
            }
            function m() {
                let t = false;
                try {
                    t = "\u0107".search(new RegExp("[\\p{L}]", "u")) === 0;
                } catch (t) {}
                return t;
            }
            function k(t, e, n, o) {
                n = n || function(t, e) {
                    return t === e;
                };
                const i = Array.isArray(t) ? t : Array.prototype.slice.call(t);
                const r = Array.isArray(e) ? e : Array.prototype.slice.call(e);
                const s = b(i, r, n);
                const a = o ? v(s, r.length) : A(r, s);
                return a;
            }
            function b(t, e, n) {
                const o = w(t, e, n);
                if (o === -1) return {
                    firstIndex: -1,
                    lastIndexOld: -1,
                    lastIndexNew: -1
                };
                const i = _(t, o);
                const r = _(e, o);
                const s = w(i, r, n);
                const a = t.length - s;
                const c = e.length - s;
                return {
                    firstIndex: o,
                    lastIndexOld: a,
                    lastIndexNew: c
                };
            }
            function w(t, e, n) {
                for(let o = 0; o < Math.max(t.length, e.length); o++){
                    if (t[o] === undefined || e[o] === undefined || !n(t[o], e[o])) return o;
                }
                return -1;
            }
            function _(t, e) {
                return t.slice(e).reverse();
            }
            function A(t, e) {
                const n = [];
                const { firstIndex: o, lastIndexOld: i, lastIndexNew: r } = e;
                if (r - o > 0) n.push({
                    index: o,
                    type: "insert",
                    values: t.slice(o, r)
                });
                if (i - o > 0) n.push({
                    index: o + (r - o),
                    type: "delete",
                    howMany: i - o
                });
                return n;
            }
            function v(t, e) {
                const { firstIndex: n, lastIndexOld: o, lastIndexNew: i } = t;
                if (n === -1) return Array(e).fill("equal");
                let r = [];
                if (n > 0) r = r.concat(Array(n).fill("equal"));
                if (i - n > 0) r = r.concat(Array(i - n).fill("insert"));
                if (o - n > 0) r = r.concat(Array(o - n).fill("delete"));
                if (i < e) r = r.concat(Array(e - i).fill("equal"));
                return r;
            }
            function C(t, e, n) {
                n = n || function(t, e) {
                    return t === e;
                };
                const o = t.length;
                const i = e.length;
                if (o > 200 || i > 200 || o + i > 300) return C.fastDiff(t, e, n, true);
                let r, s;
                if (i < o) {
                    const n = t;
                    t = e;
                    e = n;
                    r = "delete";
                    s = "insert";
                } else {
                    r = "insert";
                    s = "delete";
                }
                const a = t.length;
                const c = e.length;
                const l = c - a;
                const d = {};
                const u = {};
                function h(o) {
                    const i = (u[o - 1] !== undefined ? u[o - 1] : -1) + 1;
                    const l = u[o + 1] !== undefined ? u[o + 1] : -1;
                    const h = i > l ? -1 : 1;
                    if (d[o + h]) d[o] = d[o + h].slice(0);
                    if (!d[o]) d[o] = [];
                    d[o].push(i > l ? r : s);
                    let f = Math.max(i, l);
                    let p = f - o;
                    while(p < a && f < c && n(t[p], e[f])){
                        p++;
                        f++;
                        d[o].push("equal");
                    }
                    return f;
                }
                let f = 0;
                let p;
                do {
                    for(p = -f; p < l; p++)u[p] = h(p);
                    for(p = l + f; p > l; p--)u[p] = h(p);
                    u[l] = h(l);
                    f++;
                }while (u[l] !== c);
                return d[l].slice(1);
            }
            C.fastDiff = k;
            function y() {
                return function t() {
                    t.called = true;
                };
            }
            const x = y;
            class E {
                constructor(t, e){
                    this.source = t;
                    this.name = e;
                    this.path = [];
                    this.stop = x();
                    this.off = x();
                }
            }
            const D = new Array(256).fill("").map((t, e)=>("0" + e.toString(16)).slice(-2));
            function S() {
                const t = Math.random() * 4294967296 >>> 0;
                const e = Math.random() * 4294967296 >>> 0;
                const n = Math.random() * 4294967296 >>> 0;
                const o = Math.random() * 4294967296 >>> 0;
                return "e" + D[t >> 0 & 255] + D[t >> 8 & 255] + D[t >> 16 & 255] + D[t >> 24 & 255] + D[e >> 0 & 255] + D[e >> 8 & 255] + D[e >> 16 & 255] + D[e >> 24 & 255] + D[n >> 0 & 255] + D[n >> 8 & 255] + D[n >> 16 & 255] + D[n >> 24 & 255] + D[o >> 0 & 255] + D[o >> 8 & 255] + D[o >> 16 & 255] + D[o >> 24 & 255];
            }
            const T = {
                get (t = "normal") {
                    if (typeof t != "number") return this[t] || this.normal;
                    else return t;
                },
                highest: 1e5,
                high: 1e3,
                normal: 0,
                low: -1000,
                lowest: -100000
            };
            const B = T;
            function P(t, e) {
                const n = B.get(e.priority);
                for(let o = 0; o < t.length; o++)if (B.get(t[o].priority) < n) {
                    t.splice(o, 0, e);
                    return;
                }
                t.push(e);
            }
            const I = "https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html";
            class R extends Error {
                constructor(t, e, n){
                    super(L(t, n));
                    this.name = "CKEditorError";
                    this.context = e;
                    this.data = n;
                }
                is(t) {
                    return t === "CKEditorError";
                }
                static rethrowUnexpectedError(t, e) {
                    if (t.is && t.is("CKEditorError")) throw t;
                    const n = new R(t.message, e);
                    n.stack = t.stack;
                    throw n;
                }
            }
            function O(t, e) {
                console.warn(...z(t, e));
            }
            function V(t, e) {
                console.error(...z(t, e));
            }
            function M(t) {
                return `\nRead more: ${I}#error-${t}`;
            }
            function L(t, e) {
                const n = new WeakSet;
                const o = (t, e)=>{
                    if (typeof e === "object" && e !== null) {
                        if (n.has(e)) return `[object ${e.constructor.name}]`;
                        n.add(e);
                    }
                    return e;
                };
                const i = e ? ` ${JSON.stringify(e, o)}` : "";
                const r = M(t);
                return t + i + r;
            }
            function z(t, e) {
                const n = M(t);
                return e ? [
                    t,
                    e,
                    n
                ] : [
                    t,
                    n
                ];
            }
            const N = "40.0.0";
            const F = null;
            const H = new Date(2023, 9, 4);
            if (globalThis.CKEDITOR_VERSION) throw new R("ckeditor-duplicated-modules", null);
            else globalThis.CKEDITOR_VERSION = N;
            const j = Symbol("listeningTo");
            const q = Symbol("emitterId");
            const W = Symbol("delegations");
            const $ = G(Object);
            function G(t) {
                if (!t) return $;
                class e extends t {
                    on(t, e, n) {
                        this.listenTo(this, t, e, n);
                    }
                    once(t, e, n) {
                        let o = false;
                        const i = (t, ...n)=>{
                            if (!o) {
                                o = true;
                                t.off();
                                e.call(this, t, ...n);
                            }
                        };
                        this.listenTo(this, t, i, n);
                    }
                    off(t, e) {
                        this.stopListening(this, t, e);
                    }
                    listenTo(t, e, n, o = {}) {
                        let i, r;
                        if (!this[j]) this[j] = {};
                        const s = this[j];
                        if (!Z(t)) K(t);
                        const a = Z(t);
                        if (!(i = s[a])) i = s[a] = {
                            emitter: t,
                            callbacks: {}
                        };
                        if (!(r = i.callbacks[e])) r = i.callbacks[e] = [];
                        r.push(n);
                        nt(this, t, e, n, o);
                    }
                    stopListening(t, e, n) {
                        const o = this[j];
                        let i = t && Z(t);
                        const r = o && i ? o[i] : undefined;
                        const s = r && e ? r.callbacks[e] : undefined;
                        if (!o || t && !r || e && !s) return;
                        if (n) {
                            ot(this, t, e, n);
                            const o = s.indexOf(n);
                            if (o !== -1) {
                                if (s.length === 1) delete r.callbacks[e];
                                else ot(this, t, e, n);
                            }
                        } else if (s) {
                            while(n = s.pop())ot(this, t, e, n);
                            delete r.callbacks[e];
                        } else if (r) {
                            for(e in r.callbacks)this.stopListening(t, e);
                            delete o[i];
                        } else {
                            for(i in o)this.stopListening(o[i].emitter);
                            delete this[j];
                        }
                    }
                    fire(t, ...e) {
                        try {
                            const n = t instanceof E ? t : new E(this, t);
                            const o = n.name;
                            let i = tt(this, o);
                            n.path.push(this);
                            if (i) {
                                const t = [
                                    n,
                                    ...e
                                ];
                                i = Array.from(i);
                                for(let e = 0; e < i.length; e++){
                                    i[e].callback.apply(this, t);
                                    if (n.off.called) {
                                        delete n.off.called;
                                        this._removeEventListener(o, i[e].callback);
                                    }
                                    if (n.stop.called) break;
                                }
                            }
                            const r = this[W];
                            if (r) {
                                const t = r.get(o);
                                const i = r.get("*");
                                if (t) et(t, n, e);
                                if (i) et(i, n, e);
                            }
                            return n.return;
                        } catch (t) {
                            R.rethrowUnexpectedError(t, this);
                        }
                    }
                    delegate(...t) {
                        return {
                            to: (e, n)=>{
                                if (!this[W]) this[W] = new Map;
                                t.forEach((t)=>{
                                    const o = this[W].get(t);
                                    if (!o) this[W].set(t, new Map([
                                        [
                                            e,
                                            n
                                        ]
                                    ]));
                                    else o.set(e, n);
                                });
                            }
                        };
                    }
                    stopDelegating(t, e) {
                        if (!this[W]) return;
                        if (!t) this[W].clear();
                        else if (!e) this[W].delete(t);
                        else {
                            const n = this[W].get(t);
                            if (n) n.delete(e);
                        }
                    }
                    _addEventListener(t, e, n) {
                        Q(this, t);
                        const o = X(this, t);
                        const i = B.get(n.priority);
                        const r = {
                            callback: e,
                            priority: i
                        };
                        for (const t of o)P(t, r);
                    }
                    _removeEventListener(t, e) {
                        const n = X(this, t);
                        for (const t of n){
                            for(let n = 0; n < t.length; n++)if (t[n].callback == e) {
                                t.splice(n, 1);
                                n--;
                            }
                        }
                    }
                }
                return e;
            }
            [
                "on",
                "once",
                "off",
                "listenTo",
                "stopListening",
                "fire",
                "delegate",
                "stopDelegating",
                "_addEventListener",
                "_removeEventListener"
            ].forEach((t)=>{
                G[t] = $.prototype[t];
            });
            function U(t, e) {
                const n = t[j];
                if (n && n[e]) return n[e].emitter;
                return null;
            }
            function K(t, e) {
                if (!t[q]) t[q] = e || S();
            }
            function Z(t) {
                return t[q];
            }
            function J(t) {
                if (!t._events) Object.defineProperty(t, "_events", {
                    value: {}
                });
                return t._events;
            }
            function Y() {
                return {
                    callbacks: [],
                    childEvents: []
                };
            }
            function Q(t, e) {
                const n = J(t);
                if (n[e]) return;
                let o = e;
                let i = null;
                const r = [];
                while(o !== ""){
                    if (n[o]) break;
                    n[o] = Y();
                    r.push(n[o]);
                    if (i) n[o].childEvents.push(i);
                    i = o;
                    o = o.substr(0, o.lastIndexOf(":"));
                }
                if (o !== "") {
                    for (const t of r)t.callbacks = n[o].callbacks.slice();
                    n[o].childEvents.push(i);
                }
            }
            function X(t, e) {
                const n = J(t)[e];
                if (!n) return [];
                let o = [
                    n.callbacks
                ];
                for(let e = 0; e < n.childEvents.length; e++){
                    const i = X(t, n.childEvents[e]);
                    o = o.concat(i);
                }
                return o;
            }
            function tt(t, e) {
                let n;
                if (!t._events || !(n = t._events[e]) || !n.callbacks.length) {
                    if (e.indexOf(":") > -1) return tt(t, e.substr(0, e.lastIndexOf(":")));
                    else return null;
                }
                return n.callbacks;
            }
            function et(t, e, n) {
                for (let [o, i] of t){
                    if (!i) i = e.name;
                    else if (typeof i == "function") i = i(e.name);
                    const t = new E(e.source, i);
                    t.path = [
                        ...e.path
                    ];
                    o.fire(t, ...n);
                }
            }
            function nt(t, e, n, o, i) {
                if (e._addEventListener) e._addEventListener(n, o, i);
                else t._addEventListener.call(e, n, o, i);
            }
            function ot(t, e, n, o) {
                if (e._removeEventListener) e._removeEventListener(n, o);
                else t._removeEventListener.call(e, n, o);
            }
            function it(t) {
                var e = typeof t;
                return t != null && (e == "object" || e == "function");
            }
            const rt = it;
            const st = Symbol("observableProperties");
            const at = Symbol("boundObservables");
            const ct = Symbol("boundProperties");
            const lt = Symbol("decoratedMethods");
            const dt = Symbol("decoratedOriginal");
            const ut = ht(G());
            function ht(t) {
                if (!t) return ut;
                class e extends t {
                    set(t, e) {
                        if (rt(t)) {
                            Object.keys(t).forEach((e)=>{
                                this.set(e, t[e]);
                            }, this);
                            return;
                        }
                        ft(this);
                        const n = this[st];
                        if (t in this && !n.has(t)) throw new R("observable-set-cannot-override", this);
                        Object.defineProperty(this, t, {
                            enumerable: true,
                            configurable: true,
                            get () {
                                return n.get(t);
                            },
                            set (e) {
                                const o = n.get(t);
                                let i = this.fire(`set:${t}`, t, e, o);
                                if (i === undefined) i = e;
                                if (o !== i || !n.has(t)) {
                                    n.set(t, i);
                                    this.fire(`change:${t}`, t, i, o);
                                }
                            }
                        });
                        this[t] = e;
                    }
                    bind(...t) {
                        if (!t.length || !kt(t)) throw new R("observable-bind-wrong-properties", this);
                        if (new Set(t).size !== t.length) throw new R("observable-bind-duplicate-properties", this);
                        ft(this);
                        const e = this[ct];
                        t.forEach((t)=>{
                            if (e.has(t)) throw new R("observable-bind-rebind", this);
                        });
                        const n = new Map;
                        t.forEach((t)=>{
                            const o = {
                                property: t,
                                to: []
                            };
                            e.set(t, o);
                            n.set(t, o);
                        });
                        return {
                            to: pt,
                            toMany: gt,
                            _observable: this,
                            _bindProperties: t,
                            _to: [],
                            _bindings: n
                        };
                    }
                    unbind(...t) {
                        if (!this[st]) return;
                        const e = this[ct];
                        const n = this[at];
                        if (t.length) {
                            if (!kt(t)) throw new R("observable-unbind-wrong-properties", this);
                            t.forEach((t)=>{
                                const o = e.get(t);
                                if (!o) return;
                                o.to.forEach(([t, e])=>{
                                    const i = n.get(t);
                                    const r = i[e];
                                    r.delete(o);
                                    if (!r.size) delete i[e];
                                    if (!Object.keys(i).length) {
                                        n.delete(t);
                                        this.stopListening(t, "change");
                                    }
                                });
                                e.delete(t);
                            });
                        } else {
                            n.forEach((t, e)=>{
                                this.stopListening(e, "change");
                            });
                            n.clear();
                            e.clear();
                        }
                    }
                    decorate(t) {
                        ft(this);
                        const e = this[t];
                        if (!e) throw new R("observablemixin-cannot-decorate-undefined", this, {
                            object: this,
                            methodName: t
                        });
                        this.on(t, (t, n)=>{
                            t.return = e.apply(this, n);
                        });
                        this[t] = function(...e) {
                            return this.fire(t, e);
                        };
                        this[t][dt] = e;
                        if (!this[lt]) this[lt] = [];
                        this[lt].push(t);
                    }
                    stopListening(t, e, n) {
                        if (!t && this[lt]) {
                            for (const t of this[lt])this[t] = this[t][dt];
                            delete this[lt];
                        }
                        super.stopListening(t, e, n);
                    }
                }
                return e;
            }
            [
                "set",
                "bind",
                "unbind",
                "decorate",
                "on",
                "once",
                "off",
                "listenTo",
                "stopListening",
                "fire",
                "delegate",
                "stopDelegating",
                "_addEventListener",
                "_removeEventListener"
            ].forEach((t)=>{
                ht[t] = ut.prototype[t];
            });
            function ft(t) {
                if (t[st]) return;
                Object.defineProperty(t, st, {
                    value: new Map
                });
                Object.defineProperty(t, at, {
                    value: new Map
                });
                Object.defineProperty(t, ct, {
                    value: new Map
                });
            }
            function pt(...t) {
                const e = bt(...t);
                const n = Array.from(this._bindings.keys());
                const o = n.length;
                if (!e.callback && e.to.length > 1) throw new R("observable-bind-to-no-callback", this);
                if (o > 1 && e.callback) throw new R("observable-bind-to-extra-callback", this);
                e.to.forEach((t)=>{
                    if (t.properties.length && t.properties.length !== o) throw new R("observable-bind-to-properties-length", this);
                    if (!t.properties.length) t.properties = this._bindProperties;
                });
                this._to = e.to;
                if (e.callback) this._bindings.get(n[0]).callback = e.callback;
                vt(this._observable, this._to);
                _t(this);
                this._bindProperties.forEach((t)=>{
                    At(this._observable, t);
                });
            }
            function gt(t, e, n) {
                if (this._bindings.size > 1) throw new R("observable-bind-to-many-not-one-binding", this);
                this.to(...mt(t, e), n);
            }
            function mt(t, e) {
                const n = t.map((t)=>[
                        t,
                        e
                    ]);
                return Array.prototype.concat.apply([], n);
            }
            function kt(t) {
                return t.every((t)=>typeof t == "string");
            }
            function bt(...t) {
                if (!t.length) throw new R("observable-bind-to-parse-error", null);
                const e = {
                    to: []
                };
                let n;
                if (typeof t[t.length - 1] == "function") e.callback = t.pop();
                t.forEach((t)=>{
                    if (typeof t == "string") n.properties.push(t);
                    else if (typeof t == "object") {
                        n = {
                            observable: t,
                            properties: []
                        };
                        e.to.push(n);
                    } else throw new R("observable-bind-to-parse-error", null);
                });
                return e;
            }
            function wt(t, e, n, o) {
                const i = t[at];
                const r = i.get(n);
                const s = r || {};
                if (!s[o]) s[o] = new Set;
                s[o].add(e);
                if (!r) i.set(n, s);
            }
            function _t(t) {
                let e;
                t._bindings.forEach((n, o)=>{
                    t._to.forEach((i)=>{
                        e = i.properties[n.callback ? 0 : t._bindProperties.indexOf(o)];
                        n.to.push([
                            i.observable,
                            e
                        ]);
                        wt(t._observable, n, i.observable, e);
                    });
                });
            }
            function At(t, e) {
                const n = t[ct];
                const o = n.get(e);
                let i;
                if (o.callback) i = o.callback.apply(t, o.to.map((t)=>t[0][t[1]]));
                else {
                    i = o.to[0];
                    i = i[0][i[1]];
                }
                if (Object.prototype.hasOwnProperty.call(t, e)) t[e] = i;
                else t.set(e, i);
            }
            function vt(t, e) {
                e.forEach((e)=>{
                    const n = t[at];
                    let o;
                    if (!n.get(e.observable)) t.listenTo(e.observable, "change", (i, r)=>{
                        o = n.get(e.observable)[r];
                        if (o) o.forEach((e)=>{
                            At(t, e.property);
                        });
                    });
                });
            }
            class Ct {
                constructor(){
                    this._replacedElements = [];
                }
                replace(t, e) {
                    this._replacedElements.push({
                        element: t,
                        newElement: e
                    });
                    t.style.display = "none";
                    if (e) t.parentNode.insertBefore(e, t.nextSibling);
                }
                restore() {
                    this._replacedElements.forEach(({ element: t, newElement: e })=>{
                        t.style.display = "";
                        if (e) e.remove();
                    });
                    this._replacedElements = [];
                }
            }
            function yt(t) {
                let e = 0;
                for (const n of t)e++;
                return e;
            }
            function xt(t, e) {
                const n = Math.min(t.length, e.length);
                for(let o = 0; o < n; o++){
                    if (t[o] != e[o]) return o;
                }
                if (t.length == e.length) return "same";
                else if (t.length < e.length) return "prefix";
                else return "extension";
            }
            function Et(t) {
                return !!(t && t[Symbol.iterator]);
            }
            var Dt = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
            const St = Dt;
            var Tt = typeof self == "object" && self && self.Object === Object && self;
            var Bt = St || Tt || Function("return this")();
            const Pt = Bt;
            var It = Pt.Symbol;
            const Rt = It;
            var Ot = Object.prototype;
            var Vt = Ot.hasOwnProperty;
            var Mt = Ot.toString;
            var Lt = Rt ? Rt.toStringTag : undefined;
            function zt(t) {
                var e = Vt.call(t, Lt), n = t[Lt];
                try {
                    t[Lt] = undefined;
                    var o = true;
                } catch (t) {}
                var i = Mt.call(t);
                if (o) {
                    if (e) t[Lt] = n;
                    else delete t[Lt];
                }
                return i;
            }
            const Nt = zt;
            var Ft = Object.prototype;
            var Ht = Ft.toString;
            function jt(t) {
                return Ht.call(t);
            }
            const qt = jt;
            var Wt = "[object Null]", $t = "[object Undefined]";
            var Gt = Rt ? Rt.toStringTag : undefined;
            function Ut(t) {
                if (t == null) return t === undefined ? $t : Wt;
                return Gt && Gt in Object(t) ? Nt(t) : qt(t);
            }
            const Kt = Ut;
            var Zt = Array.isArray;
            const Jt = Zt;
            function Yt(t) {
                return t != null && typeof t == "object";
            }
            const Qt = Yt;
            var Xt = "[object String]";
            function te(t) {
                return typeof t == "string" || !Jt(t) && Qt(t) && Kt(t) == Xt;
            }
            const ee = te;
            function ne(t, e, n = {}, o = []) {
                const i = n && n.xmlns;
                const r = i ? t.createElementNS(i, e) : t.createElement(e);
                for(const t in n)r.setAttribute(t, n[t]);
                if (ee(o) || !Et(o)) o = [
                    o
                ];
                for (let e of o){
                    if (ee(e)) e = t.createTextNode(e);
                    r.appendChild(e);
                }
                return r;
            }
            function oe(t, e) {
                return function(n) {
                    return t(e(n));
                };
            }
            const ie = oe;
            var re = ie(Object.getPrototypeOf, Object);
            const se = re;
            var ae = "[object Object]";
            var ce = Function.prototype, le = Object.prototype;
            var de = ce.toString;
            var ue = le.hasOwnProperty;
            var he = de.call(Object);
            function fe(t) {
                if (!Qt(t) || Kt(t) != ae) return false;
                var e = se(t);
                if (e === null) return true;
                var n = ue.call(e, "constructor") && e.constructor;
                return typeof n == "function" && n instanceof n && de.call(n) == he;
            }
            const pe = fe;
            function ge() {
                this.__data__ = [];
                this.size = 0;
            }
            const me = ge;
            function ke(t, e) {
                return t === e || t !== t && e !== e;
            }
            const be = ke;
            function we(t, e) {
                var n = t.length;
                while(n--){
                    if (be(t[n][0], e)) return n;
                }
                return -1;
            }
            const _e = we;
            var Ae = Array.prototype;
            var ve = Ae.splice;
            function Ce(t) {
                var e = this.__data__, n = _e(e, t);
                if (n < 0) return false;
                var o = e.length - 1;
                if (n == o) e.pop();
                else ve.call(e, n, 1);
                --this.size;
                return true;
            }
            const ye = Ce;
            function xe(t) {
                var e = this.__data__, n = _e(e, t);
                return n < 0 ? undefined : e[n][1];
            }
            const Ee = xe;
            function De(t) {
                return _e(this.__data__, t) > -1;
            }
            const Se = De;
            function Te(t, e) {
                var n = this.__data__, o = _e(n, t);
                if (o < 0) {
                    ++this.size;
                    n.push([
                        t,
                        e
                    ]);
                } else n[o][1] = e;
                return this;
            }
            const Be = Te;
            function Pe(t) {
                var e = -1, n = t == null ? 0 : t.length;
                this.clear();
                while(++e < n){
                    var o = t[e];
                    this.set(o[0], o[1]);
                }
            }
            Pe.prototype.clear = me;
            Pe.prototype["delete"] = ye;
            Pe.prototype.get = Ee;
            Pe.prototype.has = Se;
            Pe.prototype.set = Be;
            const Ie = Pe;
            function Re() {
                this.__data__ = new Ie;
                this.size = 0;
            }
            const Oe = Re;
            function Ve(t) {
                var e = this.__data__, n = e["delete"](t);
                this.size = e.size;
                return n;
            }
            const Me = Ve;
            function Le(t) {
                return this.__data__.get(t);
            }
            const ze = Le;
            function Ne(t) {
                return this.__data__.has(t);
            }
            const Fe = Ne;
            var He = "[object AsyncFunction]", je = "[object Function]", qe = "[object GeneratorFunction]", We = "[object Proxy]";
            function $e(t) {
                if (!rt(t)) return false;
                var e = Kt(t);
                return e == je || e == qe || e == He || e == We;
            }
            const Ge = $e;
            var Ue = Pt["__core-js_shared__"];
            const Ke = Ue;
            var Ze = function() {
                var t = /[^.]+$/.exec(Ke && Ke.keys && Ke.keys.IE_PROTO || "");
                return t ? "Symbol(src)_1." + t : "";
            }();
            function Je(t) {
                return !!Ze && Ze in t;
            }
            const Ye = Je;
            var Qe = Function.prototype;
            var Xe = Qe.toString;
            function tn(t) {
                if (t != null) {
                    try {
                        return Xe.call(t);
                    } catch (t) {}
                    try {
                        return t + "";
                    } catch (t) {}
                }
                return "";
            }
            const en = tn;
            var nn = /[\\^$.*+?()[\]{}|]/g;
            var on = /^\[object .+?Constructor\]$/;
            var rn = Function.prototype, sn = Object.prototype;
            var an = rn.toString;
            var cn = sn.hasOwnProperty;
            var ln = RegExp("^" + an.call(cn).replace(nn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
            function dn(t) {
                if (!rt(t) || Ye(t)) return false;
                var e = Ge(t) ? ln : on;
                return e.test(en(t));
            }
            const un = dn;
            function hn(t, e) {
                return t == null ? undefined : t[e];
            }
            const fn = hn;
            function pn(t, e) {
                var n = fn(t, e);
                return un(n) ? n : undefined;
            }
            const gn = pn;
            var mn = gn(Pt, "Map");
            const kn = mn;
            var bn = gn(Object, "create");
            const wn = bn;
            function _n() {
                this.__data__ = wn ? wn(null) : {};
                this.size = 0;
            }
            const An = _n;
            function vn(t) {
                var e = this.has(t) && delete this.__data__[t];
                this.size -= e ? 1 : 0;
                return e;
            }
            const Cn = vn;
            var yn = "__lodash_hash_undefined__";
            var xn = Object.prototype;
            var En = xn.hasOwnProperty;
            function Dn(t) {
                var e = this.__data__;
                if (wn) {
                    var n = e[t];
                    return n === yn ? undefined : n;
                }
                return En.call(e, t) ? e[t] : undefined;
            }
            const Sn = Dn;
            var Tn = Object.prototype;
            var Bn = Tn.hasOwnProperty;
            function Pn(t) {
                var e = this.__data__;
                return wn ? e[t] !== undefined : Bn.call(e, t);
            }
            const In = Pn;
            var Rn = "__lodash_hash_undefined__";
            function On(t, e) {
                var n = this.__data__;
                this.size += this.has(t) ? 0 : 1;
                n[t] = wn && e === undefined ? Rn : e;
                return this;
            }
            const Vn = On;
            function Mn(t) {
                var e = -1, n = t == null ? 0 : t.length;
                this.clear();
                while(++e < n){
                    var o = t[e];
                    this.set(o[0], o[1]);
                }
            }
            Mn.prototype.clear = An;
            Mn.prototype["delete"] = Cn;
            Mn.prototype.get = Sn;
            Mn.prototype.has = In;
            Mn.prototype.set = Vn;
            const Ln = Mn;
            function zn() {
                this.size = 0;
                this.__data__ = {
                    hash: new Ln,
                    map: new (kn || Ie),
                    string: new Ln
                };
            }
            const Nn = zn;
            function Fn(t) {
                var e = typeof t;
                return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
            }
            const Hn = Fn;
            function jn(t, e) {
                var n = t.__data__;
                return Hn(e) ? n[typeof e == "string" ? "string" : "hash"] : n.map;
            }
            const qn = jn;
            function Wn(t) {
                var e = qn(this, t)["delete"](t);
                this.size -= e ? 1 : 0;
                return e;
            }
            const $n = Wn;
            function Gn(t) {
                return qn(this, t).get(t);
            }
            const Un = Gn;
            function Kn(t) {
                return qn(this, t).has(t);
            }
            const Zn = Kn;
            function Jn(t, e) {
                var n = qn(this, t), o = n.size;
                n.set(t, e);
                this.size += n.size == o ? 0 : 1;
                return this;
            }
            const Yn = Jn;
            function Qn(t) {
                var e = -1, n = t == null ? 0 : t.length;
                this.clear();
                while(++e < n){
                    var o = t[e];
                    this.set(o[0], o[1]);
                }
            }
            Qn.prototype.clear = Nn;
            Qn.prototype["delete"] = $n;
            Qn.prototype.get = Un;
            Qn.prototype.has = Zn;
            Qn.prototype.set = Yn;
            const Xn = Qn;
            var to = 200;
            function eo(t, e) {
                var n = this.__data__;
                if (n instanceof Ie) {
                    var o = n.__data__;
                    if (!kn || o.length < to - 1) {
                        o.push([
                            t,
                            e
                        ]);
                        this.size = ++n.size;
                        return this;
                    }
                    n = this.__data__ = new Xn(o);
                }
                n.set(t, e);
                this.size = n.size;
                return this;
            }
            const no = eo;
            function oo(t) {
                var e = this.__data__ = new Ie(t);
                this.size = e.size;
            }
            oo.prototype.clear = Oe;
            oo.prototype["delete"] = Me;
            oo.prototype.get = ze;
            oo.prototype.has = Fe;
            oo.prototype.set = no;
            const io = oo;
            function ro(t, e) {
                var n = -1, o = t == null ? 0 : t.length;
                while(++n < o){
                    if (e(t[n], n, t) === false) break;
                }
                return t;
            }
            const so = ro;
            var ao = function() {
                try {
                    var t = gn(Object, "defineProperty");
                    t({}, "", {});
                    return t;
                } catch (t) {}
            }();
            const co = ao;
            function lo(t, e, n) {
                if (e == "__proto__" && co) co(t, e, {
                    configurable: true,
                    enumerable: true,
                    value: n,
                    writable: true
                });
                else t[e] = n;
            }
            const uo = lo;
            var ho = Object.prototype;
            var fo = ho.hasOwnProperty;
            function po(t, e, n) {
                var o = t[e];
                if (!(fo.call(t, e) && be(o, n)) || n === undefined && !(e in t)) uo(t, e, n);
            }
            const go = po;
            function mo(t, e, n, o) {
                var i = !n;
                n || (n = {});
                var r = -1, s = e.length;
                while(++r < s){
                    var a = e[r];
                    var c = o ? o(n[a], t[a], a, n, t) : undefined;
                    if (c === undefined) c = t[a];
                    if (i) uo(n, a, c);
                    else go(n, a, c);
                }
                return n;
            }
            const ko = mo;
            function bo(t, e) {
                var n = -1, o = Array(t);
                while(++n < t)o[n] = e(n);
                return o;
            }
            const wo = bo;
            var _o = "[object Arguments]";
            function Ao(t) {
                return Qt(t) && Kt(t) == _o;
            }
            const vo = Ao;
            var Co = Object.prototype;
            var yo = Co.hasOwnProperty;
            var xo = Co.propertyIsEnumerable;
            var Eo = vo(function() {
                return arguments;
            }()) ? vo : function(t) {
                return Qt(t) && yo.call(t, "callee") && !xo.call(t, "callee");
            };
            const Do = Eo;
            function So() {
                return false;
            }
            const To = So;
            var Bo = exports && !exports.nodeType && exports;
            var Po = Bo && true && module && !module.nodeType && module;
            var Io = Po && Po.exports === Bo;
            var Ro = Io ? Pt.Buffer : undefined;
            var Oo = Ro ? Ro.isBuffer : undefined;
            var Vo = Oo || To;
            const Mo = Vo;
            var Lo = 9007199254740991;
            var zo = /^(?:0|[1-9]\d*)$/;
            function No(t, e) {
                var n = typeof t;
                e = e == null ? Lo : e;
                return !!e && (n == "number" || n != "symbol" && zo.test(t)) && t > -1 && t % 1 == 0 && t < e;
            }
            const Fo = No;
            var Ho = 9007199254740991;
            function jo(t) {
                return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Ho;
            }
            const qo = jo;
            var Wo = "[object Arguments]", $o = "[object Array]", Go = "[object Boolean]", Uo = "[object Date]", Ko = "[object Error]", Zo = "[object Function]", Jo = "[object Map]", Yo = "[object Number]", Qo = "[object Object]", Xo = "[object RegExp]", ti = "[object Set]", ei = "[object String]", ni = "[object WeakMap]";
            var oi = "[object ArrayBuffer]", ii = "[object DataView]", ri = "[object Float32Array]", si = "[object Float64Array]", ai = "[object Int8Array]", ci = "[object Int16Array]", li = "[object Int32Array]", di = "[object Uint8Array]", ui = "[object Uint8ClampedArray]", hi = "[object Uint16Array]", fi = "[object Uint32Array]";
            var pi = {};
            pi[ri] = pi[si] = pi[ai] = pi[ci] = pi[li] = pi[di] = pi[ui] = pi[hi] = pi[fi] = true;
            pi[Wo] = pi[$o] = pi[oi] = pi[Go] = pi[ii] = pi[Uo] = pi[Ko] = pi[Zo] = pi[Jo] = pi[Yo] = pi[Qo] = pi[Xo] = pi[ti] = pi[ei] = pi[ni] = false;
            function gi(t) {
                return Qt(t) && qo(t.length) && !!pi[Kt(t)];
            }
            const mi = gi;
            function ki(t) {
                return function(e) {
                    return t(e);
                };
            }
            const bi = ki;
            var wi = exports && !exports.nodeType && exports;
            var _i = wi && true && module && !module.nodeType && module;
            var Ai = _i && _i.exports === wi;
            var vi = Ai && St.process;
            var Ci = function() {
                try {
                    var t = _i && _i.require && _i.require("util").types;
                    if (t) return t;
                    return vi && vi.binding && vi.binding("util");
                } catch (t) {}
            }();
            const yi = Ci;
            var xi = yi && yi.isTypedArray;
            var Ei = xi ? bi(xi) : mi;
            const Di = Ei;
            var Si = Object.prototype;
            var Ti = Si.hasOwnProperty;
            function Bi(t, e) {
                var n = Jt(t), o = !n && Do(t), i = !n && !o && Mo(t), r = !n && !o && !i && Di(t), s = n || o || i || r, a = s ? wo(t.length, String) : [], c = a.length;
                for(var l in t)if ((e || Ti.call(t, l)) && !(s && (l == "length" || i && (l == "offset" || l == "parent") || r && (l == "buffer" || l == "byteLength" || l == "byteOffset") || Fo(l, c)))) a.push(l);
                return a;
            }
            const Pi = Bi;
            var Ii = Object.prototype;
            function Ri(t) {
                var e = t && t.constructor, n = typeof e == "function" && e.prototype || Ii;
                return t === n;
            }
            const Oi = Ri;
            var Vi = ie(Object.keys, Object);
            const Mi = Vi;
            var Li = Object.prototype;
            var zi = Li.hasOwnProperty;
            function Ni(t) {
                if (!Oi(t)) return Mi(t);
                var e = [];
                for(var n in Object(t))if (zi.call(t, n) && n != "constructor") e.push(n);
                return e;
            }
            const Fi = Ni;
            function Hi(t) {
                return t != null && qo(t.length) && !Ge(t);
            }
            const ji = Hi;
            function qi(t) {
                return ji(t) ? Pi(t) : Fi(t);
            }
            const Wi = qi;
            function $i(t, e) {
                return t && ko(e, Wi(e), t);
            }
            const Gi = $i;
            function Ui(t) {
                var e = [];
                if (t != null) for(var n in Object(t))e.push(n);
                return e;
            }
            const Ki = Ui;
            var Zi = Object.prototype;
            var Ji = Zi.hasOwnProperty;
            function Yi(t) {
                if (!rt(t)) return Ki(t);
                var e = Oi(t), n = [];
                for(var o in t)if (!(o == "constructor" && (e || !Ji.call(t, o)))) n.push(o);
                return n;
            }
            const Qi = Yi;
            function Xi(t) {
                return ji(t) ? Pi(t, true) : Qi(t);
            }
            const tr = Xi;
            function er(t, e) {
                return t && ko(e, tr(e), t);
            }
            const nr = er;
            var or = exports && !exports.nodeType && exports;
            var ir = or && true && module && !module.nodeType && module;
            var rr = ir && ir.exports === or;
            var sr = rr ? Pt.Buffer : undefined, ar = sr ? sr.allocUnsafe : undefined;
            function cr(t, e) {
                if (e) return t.slice();
                var n = t.length, o = ar ? ar(n) : new t.constructor(n);
                t.copy(o);
                return o;
            }
            const lr = cr;
            function dr(t, e) {
                var n = -1, o = t.length;
                e || (e = Array(o));
                while(++n < o)e[n] = t[n];
                return e;
            }
            const ur = dr;
            function hr(t, e) {
                var n = -1, o = t == null ? 0 : t.length, i = 0, r = [];
                while(++n < o){
                    var s = t[n];
                    if (e(s, n, t)) r[i++] = s;
                }
                return r;
            }
            const fr = hr;
            function pr() {
                return [];
            }
            const gr = pr;
            var mr = Object.prototype;
            var kr = mr.propertyIsEnumerable;
            var br = Object.getOwnPropertySymbols;
            var wr = !br ? gr : function(t) {
                if (t == null) return [];
                t = Object(t);
                return fr(br(t), function(e) {
                    return kr.call(t, e);
                });
            };
            const _r = wr;
            function Ar(t, e) {
                return ko(t, _r(t), e);
            }
            const vr = Ar;
            function Cr(t, e) {
                var n = -1, o = e.length, i = t.length;
                while(++n < o)t[i + n] = e[n];
                return t;
            }
            const yr = Cr;
            var xr = Object.getOwnPropertySymbols;
            var Er = !xr ? gr : function(t) {
                var e = [];
                while(t){
                    yr(e, _r(t));
                    t = se(t);
                }
                return e;
            };
            const Dr = Er;
            function Sr(t, e) {
                return ko(t, Dr(t), e);
            }
            const Tr = Sr;
            function Br(t, e, n) {
                var o = e(t);
                return Jt(t) ? o : yr(o, n(t));
            }
            const Pr = Br;
            function Ir(t) {
                return Pr(t, Wi, _r);
            }
            const Rr = Ir;
            function Or(t) {
                return Pr(t, tr, Dr);
            }
            const Vr = Or;
            var Mr = gn(Pt, "DataView");
            const Lr = Mr;
            var zr = gn(Pt, "Promise");
            const Nr = zr;
            var Fr = gn(Pt, "Set");
            const Hr = Fr;
            var jr = gn(Pt, "WeakMap");
            const qr = jr;
            var Wr = "[object Map]", $r = "[object Object]", Gr = "[object Promise]", Ur = "[object Set]", Kr = "[object WeakMap]";
            var Zr = "[object DataView]";
            var Jr = en(Lr), Yr = en(kn), Qr = en(Nr), Xr = en(Hr), ts = en(qr);
            var es = Kt;
            if (Lr && es(new Lr(new ArrayBuffer(1))) != Zr || kn && es(new kn) != Wr || Nr && es(Nr.resolve()) != Gr || Hr && es(new Hr) != Ur || qr && es(new qr) != Kr) es = function(t) {
                var e = Kt(t), n = e == $r ? t.constructor : undefined, o = n ? en(n) : "";
                if (o) switch(o){
                    case Jr:
                        return Zr;
                    case Yr:
                        return Wr;
                    case Qr:
                        return Gr;
                    case Xr:
                        return Ur;
                    case ts:
                        return Kr;
                }
                return e;
            };
            const ns = es;
            var os = Object.prototype;
            var is = os.hasOwnProperty;
            function rs(t) {
                var e = t.length, n = new t.constructor(e);
                if (e && typeof t[0] == "string" && is.call(t, "index")) {
                    n.index = t.index;
                    n.input = t.input;
                }
                return n;
            }
            const ss = rs;
            var as = Pt.Uint8Array;
            const cs = as;
            function ls(t) {
                var e = new t.constructor(t.byteLength);
                new cs(e).set(new cs(t));
                return e;
            }
            const ds = ls;
            function us(t, e) {
                var n = e ? ds(t.buffer) : t.buffer;
                return new t.constructor(n, t.byteOffset, t.byteLength);
            }
            const hs = us;
            var fs = /\w*$/;
            function ps(t) {
                var e = new t.constructor(t.source, fs.exec(t));
                e.lastIndex = t.lastIndex;
                return e;
            }
            const gs = ps;
            var ms = Rt ? Rt.prototype : undefined, ks = ms ? ms.valueOf : undefined;
            function bs(t) {
                return ks ? Object(ks.call(t)) : {};
            }
            const ws = bs;
            function _s(t, e) {
                var n = e ? ds(t.buffer) : t.buffer;
                return new t.constructor(n, t.byteOffset, t.length);
            }
            const As = _s;
            var vs = "[object Boolean]", Cs = "[object Date]", ys = "[object Map]", xs = "[object Number]", Es = "[object RegExp]", Ds = "[object Set]", Ss = "[object String]", Ts = "[object Symbol]";
            var Bs = "[object ArrayBuffer]", Ps = "[object DataView]", Is = "[object Float32Array]", Rs = "[object Float64Array]", Os = "[object Int8Array]", Vs = "[object Int16Array]", Ms = "[object Int32Array]", Ls = "[object Uint8Array]", zs = "[object Uint8ClampedArray]", Ns = "[object Uint16Array]", Fs = "[object Uint32Array]";
            function Hs(t, e, n) {
                var o = t.constructor;
                switch(e){
                    case Bs:
                        return ds(t);
                    case vs:
                    case Cs:
                        return new o(+t);
                    case Ps:
                        return hs(t, n);
                    case Is:
                    case Rs:
                    case Os:
                    case Vs:
                    case Ms:
                    case Ls:
                    case zs:
                    case Ns:
                    case Fs:
                        return As(t, n);
                    case ys:
                        return new o;
                    case xs:
                    case Ss:
                        return new o(t);
                    case Es:
                        return gs(t);
                    case Ds:
                        return new o;
                    case Ts:
                        return ws(t);
                }
            }
            const js = Hs;
            var qs = Object.create;
            var Ws = function() {
                function t() {}
                return function(e) {
                    if (!rt(e)) return {};
                    if (qs) return qs(e);
                    t.prototype = e;
                    var n = new t;
                    t.prototype = undefined;
                    return n;
                };
            }();
            const $s = Ws;
            function Gs(t) {
                return typeof t.constructor == "function" && !Oi(t) ? $s(se(t)) : {};
            }
            const Us = Gs;
            var Ks = "[object Map]";
            function Zs(t) {
                return Qt(t) && ns(t) == Ks;
            }
            const Js = Zs;
            var Ys = yi && yi.isMap;
            var Qs = Ys ? bi(Ys) : Js;
            const Xs = Qs;
            var ta = "[object Set]";
            function ea(t) {
                return Qt(t) && ns(t) == ta;
            }
            const na = ea;
            var oa = yi && yi.isSet;
            var ia = oa ? bi(oa) : na;
            const ra = ia;
            var sa = 1, aa = 2, ca = 4;
            var la = "[object Arguments]", da = "[object Array]", ua = "[object Boolean]", ha = "[object Date]", fa = "[object Error]", pa = "[object Function]", ga = "[object GeneratorFunction]", ma = "[object Map]", ka = "[object Number]", ba = "[object Object]", wa = "[object RegExp]", _a = "[object Set]", Aa = "[object String]", va = "[object Symbol]", Ca = "[object WeakMap]";
            var ya = "[object ArrayBuffer]", xa = "[object DataView]", Ea = "[object Float32Array]", Da = "[object Float64Array]", Sa = "[object Int8Array]", Ta = "[object Int16Array]", Ba = "[object Int32Array]", Pa = "[object Uint8Array]", Ia = "[object Uint8ClampedArray]", Ra = "[object Uint16Array]", Oa = "[object Uint32Array]";
            var Va = {};
            Va[la] = Va[da] = Va[ya] = Va[xa] = Va[ua] = Va[ha] = Va[Ea] = Va[Da] = Va[Sa] = Va[Ta] = Va[Ba] = Va[ma] = Va[ka] = Va[ba] = Va[wa] = Va[_a] = Va[Aa] = Va[va] = Va[Pa] = Va[Ia] = Va[Ra] = Va[Oa] = true;
            Va[fa] = Va[pa] = Va[Ca] = false;
            function Ma(t, e, n, o, i, r) {
                var s, a = e & sa, c = e & aa, l = e & ca;
                if (n) s = i ? n(t, o, i, r) : n(t);
                if (s !== undefined) return s;
                if (!rt(t)) return t;
                var d = Jt(t);
                if (d) {
                    s = ss(t);
                    if (!a) return ur(t, s);
                } else {
                    var u = ns(t), h = u == pa || u == ga;
                    if (Mo(t)) return lr(t, a);
                    if (u == ba || u == la || h && !i) {
                        s = c || h ? {} : Us(t);
                        if (!a) return c ? Tr(t, nr(s, t)) : vr(t, Gi(s, t));
                    } else {
                        if (!Va[u]) return i ? t : {};
                        s = js(t, u, a);
                    }
                }
                r || (r = new io);
                var f = r.get(t);
                if (f) return f;
                r.set(t, s);
                if (ra(t)) t.forEach(function(o) {
                    s.add(Ma(o, e, n, o, t, r));
                });
                else if (Xs(t)) t.forEach(function(o, i) {
                    s.set(i, Ma(o, e, n, i, t, r));
                });
                var p = l ? c ? Vr : Rr : c ? tr : Wi;
                var g = d ? undefined : p(t);
                so(g || t, function(o, i) {
                    if (g) {
                        i = o;
                        o = t[i];
                    }
                    go(s, i, Ma(o, e, n, i, t, r));
                });
                return s;
            }
            const La = Ma;
            var za = 1, Na = 4;
            function Fa(t, e) {
                e = typeof e == "function" ? e : undefined;
                return La(t, za | Na, e);
            }
            const Ha = Fa;
            function ja(t) {
                return Qt(t) && t.nodeType === 1 && !pe(t);
            }
            const qa = ja;
            class Wa {
                constructor(t, e){
                    this._config = {};
                    if (e) this.define($a(e));
                    if (t) this._setObjectToTarget(this._config, t);
                }
                set(t, e) {
                    this._setToTarget(this._config, t, e);
                }
                define(t, e) {
                    const n = true;
                    this._setToTarget(this._config, t, e, n);
                }
                get(t) {
                    return this._getFromSource(this._config, t);
                }
                *names() {
                    for (const t of Object.keys(this._config))yield t;
                }
                _setToTarget(t, e, n, o = false) {
                    if (pe(e)) {
                        this._setObjectToTarget(t, e, o);
                        return;
                    }
                    const i = e.split(".");
                    e = i.pop();
                    for (const e of i){
                        if (!pe(t[e])) t[e] = {};
                        t = t[e];
                    }
                    if (pe(n)) {
                        if (!pe(t[e])) t[e] = {};
                        t = t[e];
                        this._setObjectToTarget(t, n, o);
                        return;
                    }
                    if (o && typeof t[e] != "undefined") return;
                    t[e] = n;
                }
                _getFromSource(t, e) {
                    const n = e.split(".");
                    e = n.pop();
                    for (const e of n){
                        if (!pe(t[e])) {
                            t = null;
                            break;
                        }
                        t = t[e];
                    }
                    return t ? $a(t[e]) : undefined;
                }
                _setObjectToTarget(t, e, n) {
                    Object.keys(e).forEach((o)=>{
                        this._setToTarget(t, o, e[o], n);
                    });
                }
            }
            function $a(t) {
                return Ha(t, Ga);
            }
            function Ga(t) {
                return qa(t) ? t : undefined;
            }
            function Ua(t) {
                if (t) {
                    if (t.defaultView) return t instanceof t.defaultView.Document;
                    else if (t.ownerDocument && t.ownerDocument.defaultView) return t instanceof t.ownerDocument.defaultView.Node;
                }
                return false;
            }
            function Ka(t) {
                const e = Object.prototype.toString.apply(t);
                if (e == "[object Window]") return true;
                if (e == "[object global]") return true;
                return false;
            }
            const Za = Ja(G());
            function Ja(t) {
                if (!t) return Za;
                class e extends t {
                    listenTo(t, e, n, o = {}) {
                        if (Ua(t) || Ka(t)) {
                            const i = {
                                capture: !!o.useCapture,
                                passive: !!o.usePassive
                            };
                            const r = this._getProxyEmitter(t, i) || new Ya(t, i);
                            this.listenTo(r, e, n, o);
                        } else super.listenTo(t, e, n, o);
                    }
                    stopListening(t, e, n) {
                        if (Ua(t) || Ka(t)) {
                            const o = this._getAllProxyEmitters(t);
                            for (const t of o)this.stopListening(t, e, n);
                        } else super.stopListening(t, e, n);
                    }
                    _getProxyEmitter(t, e) {
                        return U(this, Xa(t, e));
                    }
                    _getAllProxyEmitters(t) {
                        return [
                            {
                                capture: false,
                                passive: false
                            },
                            {
                                capture: false,
                                passive: true
                            },
                            {
                                capture: true,
                                passive: false
                            },
                            {
                                capture: true,
                                passive: true
                            }
                        ].map((e)=>this._getProxyEmitter(t, e)).filter((t)=>!!t);
                    }
                }
                return e;
            }
            [
                "_getProxyEmitter",
                "_getAllProxyEmitters",
                "on",
                "once",
                "off",
                "listenTo",
                "stopListening",
                "fire",
                "delegate",
                "stopDelegating",
                "_addEventListener",
                "_removeEventListener"
            ].forEach((t)=>{
                Ja[t] = Za.prototype[t];
            });
            class Ya extends G() {
                constructor(t, e){
                    super();
                    K(this, Xa(t, e));
                    this._domNode = t;
                    this._options = e;
                }
                attach(t) {
                    if (this._domListeners && this._domListeners[t]) return;
                    const e = this._createDomListener(t);
                    this._domNode.addEventListener(t, e, this._options);
                    if (!this._domListeners) this._domListeners = {};
                    this._domListeners[t] = e;
                }
                detach(t) {
                    let e;
                    if (this._domListeners[t] && (!(e = this._events[t]) || !e.callbacks.length)) this._domListeners[t].removeListener();
                }
                _addEventListener(t, e, n) {
                    this.attach(t);
                    G().prototype._addEventListener.call(this, t, e, n);
                }
                _removeEventListener(t, e) {
                    G().prototype._removeEventListener.call(this, t, e);
                    this.detach(t);
                }
                _createDomListener(t) {
                    const e = (e)=>{
                        this.fire(t, e);
                    };
                    e.removeListener = ()=>{
                        this._domNode.removeEventListener(t, e, this._options);
                        delete this._domListeners[t];
                    };
                    return e;
                }
            }
            function Qa(t) {
                return t["data-ck-expando"] || (t["data-ck-expando"] = S());
            }
            function Xa(t, e) {
                let n = Qa(t);
                for (const t of Object.keys(e).sort())if (e[t]) n += "-" + t;
                return n;
            }
            let tc;
            try {
                tc = {
                    window: window,
                    document: document
                };
            } catch (t) {
                tc = {
                    window: {},
                    document: {}
                };
            }
            const ec = tc;
            function nc(t) {
                let e = t.parentElement;
                if (!e) return null;
                while(e.tagName != "BODY"){
                    const t = e.style.overflowY || $parcel$global.window.getComputedStyle(e).overflowY;
                    if (t === "auto" || t === "scroll") break;
                    e = e.parentElement;
                    if (!e) return null;
                }
                return e;
            }
            function oc(t) {
                const e = [];
                let n = t;
                while(n && n.nodeType != Node.DOCUMENT_NODE){
                    e.unshift(n);
                    n = n.parentNode;
                }
                return e;
            }
            function ic(t) {
                if (t instanceof HTMLTextAreaElement) return t.value;
                return t.innerHTML;
            }
            function rc(t) {
                return Object.prototype.toString.call(t) == "[object Text]";
            }
            function sc(t) {
                return Object.prototype.toString.apply(t) == "[object Range]";
            }
            function ac(t) {
                const e = t.ownerDocument.defaultView.getComputedStyle(t);
                return {
                    top: parseInt(e.borderTopWidth, 10),
                    right: parseInt(e.borderRightWidth, 10),
                    bottom: parseInt(e.borderBottomWidth, 10),
                    left: parseInt(e.borderLeftWidth, 10)
                };
            }
            function cc(t) {
                if (!t || !t.parentNode) return null;
                if (t.offsetParent === ec.document.body) return null;
                return t.offsetParent;
            }
            const lc = [
                "top",
                "right",
                "bottom",
                "left",
                "width",
                "height"
            ];
            class dc {
                constructor(t){
                    const e = sc(t);
                    Object.defineProperty(this, "_source", {
                        value: t._source || t,
                        writable: true,
                        enumerable: false
                    });
                    if (fc(t) || e) {
                        if (e) {
                            const e = dc.getDomRangeRects(t);
                            uc(this, dc.getBoundingRect(e));
                        } else uc(this, t.getBoundingClientRect());
                    } else if (Ka(t)) {
                        const { innerWidth: e, innerHeight: n } = t;
                        uc(this, {
                            top: 0,
                            right: e,
                            bottom: n,
                            left: 0,
                            width: e,
                            height: n
                        });
                    } else uc(this, t);
                }
                clone() {
                    return new dc(this);
                }
                moveTo(t, e) {
                    this.top = e;
                    this.right = t + this.width;
                    this.bottom = e + this.height;
                    this.left = t;
                    return this;
                }
                moveBy(t, e) {
                    this.top += e;
                    this.right += t;
                    this.left += t;
                    this.bottom += e;
                    return this;
                }
                getIntersection(t) {
                    const e = {
                        top: Math.max(this.top, t.top),
                        right: Math.min(this.right, t.right),
                        bottom: Math.min(this.bottom, t.bottom),
                        left: Math.max(this.left, t.left),
                        width: 0,
                        height: 0
                    };
                    e.width = e.right - e.left;
                    e.height = e.bottom - e.top;
                    if (e.width < 0 || e.height < 0) return null;
                    else {
                        const t = new dc(e);
                        t._source = this._source;
                        return t;
                    }
                }
                getIntersectionArea(t) {
                    const e = this.getIntersection(t);
                    if (e) return e.getArea();
                    else return 0;
                }
                getArea() {
                    return this.width * this.height;
                }
                getVisible() {
                    const t = this._source;
                    let e = this.clone();
                    if (hc(t)) return e;
                    let n = t;
                    let o = t.parentNode || t.commonAncestorContainer;
                    let i;
                    while(o && !hc(o)){
                        const t = gc(o) === "visible";
                        if (n instanceof HTMLElement && pc(n) === "absolute") i = n;
                        const r = pc(o);
                        if (t || i && (r === "relative" && t || r !== "relative")) {
                            n = o;
                            o = o.parentNode;
                            continue;
                        }
                        const s = new dc(o);
                        const a = e.getIntersection(s);
                        if (a) {
                            if (a.getArea() < e.getArea()) e = a;
                        } else return null;
                        n = o;
                        o = o.parentNode;
                    }
                    return e;
                }
                isEqual(t) {
                    for (const e of lc){
                        if (this[e] !== t[e]) return false;
                    }
                    return true;
                }
                contains(t) {
                    const e = this.getIntersection(t);
                    return !!(e && e.isEqual(t));
                }
                toAbsoluteRect() {
                    const { scrollX: t, scrollY: e } = ec.window;
                    const n = this.clone().moveBy(t, e);
                    if (fc(n._source)) {
                        const t = cc(n._source);
                        if (t) mc(n, t);
                    }
                    return n;
                }
                excludeScrollbarsAndBorders() {
                    const t = this._source;
                    let e, n, o;
                    if (Ka(t)) {
                        e = t.innerWidth - t.document.documentElement.clientWidth;
                        n = t.innerHeight - t.document.documentElement.clientHeight;
                        o = t.getComputedStyle(t.document.documentElement).direction;
                    } else {
                        const i = ac(t);
                        e = t.offsetWidth - t.clientWidth - i.left - i.right;
                        n = t.offsetHeight - t.clientHeight - i.top - i.bottom;
                        o = t.ownerDocument.defaultView.getComputedStyle(t).direction;
                        this.left += i.left;
                        this.top += i.top;
                        this.right -= i.right;
                        this.bottom -= i.bottom;
                        this.width = this.right - this.left;
                        this.height = this.bottom - this.top;
                    }
                    this.width -= e;
                    if (o === "ltr") this.right -= e;
                    else this.left += e;
                    this.height -= n;
                    this.bottom -= n;
                    return this;
                }
                static getDomRangeRects(t) {
                    const e = [];
                    const n = Array.from(t.getClientRects());
                    if (n.length) for (const t of n)e.push(new dc(t));
                    else {
                        let n = t.startContainer;
                        if (rc(n)) n = n.parentNode;
                        const o = new dc(n.getBoundingClientRect());
                        o.right = o.left;
                        o.width = 0;
                        e.push(o);
                    }
                    return e;
                }
                static getBoundingRect(t) {
                    const e = {
                        left: Number.POSITIVE_INFINITY,
                        top: Number.POSITIVE_INFINITY,
                        right: Number.NEGATIVE_INFINITY,
                        bottom: Number.NEGATIVE_INFINITY,
                        width: 0,
                        height: 0
                    };
                    let n = 0;
                    for (const o of t){
                        n++;
                        e.left = Math.min(e.left, o.left);
                        e.top = Math.min(e.top, o.top);
                        e.right = Math.max(e.right, o.right);
                        e.bottom = Math.max(e.bottom, o.bottom);
                    }
                    if (n == 0) return null;
                    e.width = e.right - e.left;
                    e.height = e.bottom - e.top;
                    return new dc(e);
                }
            }
            function uc(t, e) {
                for (const n of lc)t[n] = e[n];
            }
            function hc(t) {
                if (!fc(t)) return false;
                return t === t.ownerDocument.body;
            }
            function fc(t) {
                return t !== null && typeof t === "object" && t.nodeType === 1 && typeof t.getBoundingClientRect === "function";
            }
            function pc(t) {
                return t instanceof HTMLElement ? t.ownerDocument.defaultView.getComputedStyle(t).position : "static";
            }
            function gc(t) {
                return t instanceof HTMLElement ? t.ownerDocument.defaultView.getComputedStyle(t).overflow : "visible";
            }
            function mc(t, e) {
                const n = new dc(e);
                const o = ac(e);
                let i = 0;
                let r = 0;
                i -= n.left;
                r -= n.top;
                i += e.scrollLeft;
                r += e.scrollTop;
                i -= o.left;
                r -= o.top;
                t.moveBy(i, r);
            }
            class kc {
                constructor(t, e){
                    if (!kc._observerInstance) kc._createObserver();
                    this._element = t;
                    this._callback = e;
                    kc._addElementCallback(t, e);
                    kc._observerInstance.observe(t);
                }
                get element() {
                    return this._element;
                }
                destroy() {
                    kc._deleteElementCallback(this._element, this._callback);
                }
                static _addElementCallback(t, e) {
                    if (!kc._elementCallbacks) kc._elementCallbacks = new Map;
                    let n = kc._elementCallbacks.get(t);
                    if (!n) {
                        n = new Set;
                        kc._elementCallbacks.set(t, n);
                    }
                    n.add(e);
                }
                static _deleteElementCallback(t, e) {
                    const n = kc._getElementCallbacks(t);
                    if (n) {
                        n.delete(e);
                        if (!n.size) {
                            kc._elementCallbacks.delete(t);
                            kc._observerInstance.unobserve(t);
                        }
                    }
                    if (kc._elementCallbacks && !kc._elementCallbacks.size) {
                        kc._observerInstance = null;
                        kc._elementCallbacks = null;
                    }
                }
                static _getElementCallbacks(t) {
                    if (!kc._elementCallbacks) return null;
                    return kc._elementCallbacks.get(t);
                }
                static _createObserver() {
                    kc._observerInstance = new ec.window.ResizeObserver((t)=>{
                        for (const e of t){
                            const t = kc._getElementCallbacks(e.target);
                            if (t) for (const n of t)n(e);
                        }
                    });
                }
            }
            kc._observerInstance = null;
            kc._elementCallbacks = null;
            function bc(t, e) {
                if (t instanceof HTMLTextAreaElement) t.value = e;
                t.innerHTML = e;
            }
            function wc(t) {
                return (e)=>e + t;
            }
            function _c(t) {
                let e = 0;
                while(t.previousSibling){
                    t = t.previousSibling;
                    e++;
                }
                return e;
            }
            function Ac(t, e, n) {
                t.insertBefore(n, t.childNodes[e] || null);
            }
            function vc(t) {
                return t && t.nodeType === Node.COMMENT_NODE;
            }
            function Cc(t) {
                try {
                    ec.document.createAttribute(t);
                } catch (t) {
                    return false;
                }
                return true;
            }
            function yc(t) {
                return !!(t && t.getClientRects && t.getClientRects().length);
            }
            function xc({ element: t, target: e, positions: n, limiter: o, fitInViewport: i, viewportOffsetConfig: r }) {
                if (Ge(e)) e = e();
                if (Ge(o)) o = o();
                const s = cc(t);
                const a = Dc(r);
                const c = new dc(t);
                const l = Ec(e, a);
                let d;
                if (!l || !a.getIntersection(l)) return null;
                const u = {
                    targetRect: l,
                    elementRect: c,
                    positionedElementAncestor: s,
                    viewportRect: a
                };
                if (!o && !i) d = new Tc(n[0], u);
                else {
                    if (o) {
                        const t = Ec(o, a);
                        if (t) u.limiterRect = t;
                    }
                    d = Sc(n, u);
                }
                return d;
            }
            function Ec(t, e) {
                const n = new dc(t).getVisible();
                if (!n) return null;
                return n.getIntersection(e);
            }
            function Dc(t) {
                t = Object.assign({
                    top: 0,
                    bottom: 0,
                    left: 0,
                    right: 0
                }, t);
                const e = new dc(ec.window);
                e.top += t.top;
                e.height -= t.top;
                e.bottom -= t.bottom;
                e.height -= t.bottom;
                return e;
            }
            function Sc(t, e) {
                const { elementRect: n } = e;
                const o = n.getArea();
                const i = t.map((t)=>new Tc(t, e)).filter((t)=>!!t.name);
                let r = 0;
                let s = null;
                for (const t of i){
                    const { limiterIntersectionArea: e, viewportIntersectionArea: n } = t;
                    if (e === o) return t;
                    const i = n ** 2 + e ** 2;
                    if (i > r) {
                        r = i;
                        s = t;
                    }
                }
                return s;
            }
            class Tc {
                constructor(t, e){
                    const n = t(e.targetRect, e.elementRect, e.viewportRect, e.limiterRect);
                    if (!n) return;
                    const { left: o, top: i, name: r, config: s } = n;
                    this.name = r;
                    this.config = s;
                    this._positioningFunctionCoordinates = {
                        left: o,
                        top: i
                    };
                    this._options = e;
                }
                get left() {
                    return this._absoluteRect.left;
                }
                get top() {
                    return this._absoluteRect.top;
                }
                get limiterIntersectionArea() {
                    const t = this._options.limiterRect;
                    if (t) return t.getIntersectionArea(this._rect);
                    return 0;
                }
                get viewportIntersectionArea() {
                    const t = this._options.viewportRect;
                    return t.getIntersectionArea(this._rect);
                }
                get _rect() {
                    if (this._cachedRect) return this._cachedRect;
                    this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top);
                    return this._cachedRect;
                }
                get _absoluteRect() {
                    if (this._cachedAbsoluteRect) return this._cachedAbsoluteRect;
                    this._cachedAbsoluteRect = this._rect.toAbsoluteRect();
                    return this._cachedAbsoluteRect;
                }
            }
            function Bc(t) {
                const e = t.parentNode;
                if (e) e.removeChild(t);
            }
            function Pc({ target: t, viewportOffset: e = 0, ancestorOffset: n = 0, alignToTop: o, forceScroll: i }) {
                const r = Nc(t);
                let s = r;
                let a = null;
                e = jc(e);
                while(s){
                    let c;
                    if (s == r) c = Fc(t);
                    else c = Fc(a);
                    Oc({
                        parent: c,
                        getRect: ()=>Hc(t, s),
                        alignToTop: o,
                        ancestorOffset: n,
                        forceScroll: i
                    });
                    const l = Hc(t, s);
                    Rc({
                        window: s,
                        rect: l,
                        viewportOffset: e,
                        alignToTop: o,
                        forceScroll: i
                    });
                    if (s.parent != s) {
                        a = s.frameElement;
                        s = s.parent;
                        if (!a) return;
                    } else s = null;
                }
            }
            function Ic(t, e, n) {
                const o = Fc(t);
                Oc({
                    parent: o,
                    getRect: ()=>new Rect(t),
                    ancestorOffset: e,
                    limiterElement: n
                });
            }
            function Rc({ window: t, rect: e, alignToTop: n, forceScroll: o, viewportOffset: i }) {
                const r = e.clone().moveBy(0, i.bottom);
                const s = e.clone().moveBy(0, -i.top);
                const a = new dc(t).excludeScrollbarsAndBorders();
                const c = [
                    s,
                    r
                ];
                const l = n && o;
                const d = c.every((t)=>a.contains(t));
                let { scrollX: u, scrollY: h } = t;
                const f = u;
                const p = h;
                if (l) h -= a.top - e.top + i.top;
                else if (!d) {
                    if (Mc(s, a)) h -= a.top - e.top + i.top;
                    else if (Vc(r, a)) {
                        if (n) h += e.top - a.top - i.top;
                        else h += e.bottom - a.bottom + i.bottom;
                    }
                }
                if (!d) {
                    if (Lc(e, a)) u -= a.left - e.left + i.left;
                    else if (zc(e, a)) u += e.right - a.right + i.right;
                }
                if (u != f || h !== p) t.scrollTo(u, h);
            }
            function Oc({ parent: t, getRect: e, alignToTop: n, forceScroll: o, ancestorOffset: i = 0, limiterElement: r }) {
                const s = Nc(t);
                const a = n && o;
                let c, l, d;
                const u = r || s.document.body;
                while(t != u){
                    l = e();
                    c = new dc(t).excludeScrollbarsAndBorders();
                    d = c.contains(l);
                    if (a) t.scrollTop -= c.top - l.top + i;
                    else if (!d) {
                        if (Mc(l, c)) t.scrollTop -= c.top - l.top + i;
                        else if (Vc(l, c)) {
                            if (n) t.scrollTop += l.top - c.top - i;
                            else t.scrollTop += l.bottom - c.bottom + i;
                        }
                    }
                    if (!d) {
                        if (Lc(l, c)) t.scrollLeft -= c.left - l.left + i;
                        else if (zc(l, c)) t.scrollLeft += l.right - c.right + i;
                    }
                    t = t.parentNode;
                }
            }
            function Vc(t, e) {
                return t.bottom > e.bottom;
            }
            function Mc(t, e) {
                return t.top < e.top;
            }
            function Lc(t, e) {
                return t.left < e.left;
            }
            function zc(t, e) {
                return t.right > e.right;
            }
            function Nc(t) {
                if (sc(t)) return t.startContainer.ownerDocument.defaultView;
                else return t.ownerDocument.defaultView;
            }
            function Fc(t) {
                if (sc(t)) {
                    let e = t.commonAncestorContainer;
                    if (rc(e)) e = e.parentNode;
                    return e;
                } else return t.parentNode;
            }
            function Hc(t, e) {
                const n = Nc(t);
                const o = new dc(t);
                if (n === e) return o;
                else {
                    let t = n;
                    while(t != e){
                        const e = t.frameElement;
                        const n = new dc(e).excludeScrollbarsAndBorders();
                        o.moveBy(n.left, n.top);
                        t = t.parent;
                    }
                }
                return o;
            }
            function jc(t) {
                if (typeof t === "number") return {
                    top: t,
                    bottom: t,
                    left: t,
                    right: t
                };
                return t;
            }
            const qc = {
                ctrl: "\u2303",
                cmd: "\u2318",
                alt: "\u2325",
                shift: "\u21E7"
            };
            const Wc = {
                ctrl: "Ctrl+",
                alt: "Alt+",
                shift: "Shift+"
            };
            const $c = tl();
            const Gc = Object.fromEntries(Object.entries($c).map(([t, e])=>[
                    e,
                    t.charAt(0).toUpperCase() + t.slice(1)
                ]));
            function Uc(t) {
                let e;
                if (typeof t == "string") {
                    e = $c[t.toLowerCase()];
                    if (!e) throw new R("keyboard-unknown-key", null, {
                        key: t
                    });
                } else e = t.keyCode + (t.altKey ? $c.alt : 0) + (t.ctrlKey ? $c.ctrl : 0) + (t.shiftKey ? $c.shift : 0) + (t.metaKey ? $c.cmd : 0);
                return e;
            }
            function Kc(t) {
                if (typeof t == "string") t = el(t);
                return t.map((t)=>typeof t == "string" ? Qc(t) : t).reduce((t, e)=>e + t, 0);
            }
            function Zc(t) {
                let e = Kc(t);
                const n = Object.entries(c.isMac || c.isiOS ? qc : Wc);
                const o = n.reduce((t, [n, o])=>{
                    if ((e & $c[n]) != 0) {
                        e &= ~$c[n];
                        t += o;
                    }
                    return t;
                }, "");
                return o + (e ? Gc[e] : "");
            }
            function Jc(t) {
                return t == $c.arrowright || t == $c.arrowleft || t == $c.arrowup || t == $c.arrowdown;
            }
            function Yc(t, e) {
                const n = e === "ltr";
                switch(t){
                    case $c.arrowleft:
                        return n ? "left" : "right";
                    case $c.arrowright:
                        return n ? "right" : "left";
                    case $c.arrowup:
                        return "up";
                    case $c.arrowdown:
                        return "down";
                }
            }
            function Qc(t) {
                if (t.endsWith("!")) return Uc(t.slice(0, -1));
                const e = Uc(t);
                return (c.isMac || c.isiOS) && e == $c.ctrl ? $c.cmd : e;
            }
            function Xc(t, e) {
                const n = Yc(t, e);
                return n === "down" || n === "right";
            }
            function tl() {
                const t = {
                    arrowleft: 37,
                    arrowup: 38,
                    arrowright: 39,
                    arrowdown: 40,
                    backspace: 8,
                    delete: 46,
                    enter: 13,
                    space: 32,
                    esc: 27,
                    tab: 9,
                    ctrl: 1114112,
                    shift: 2228224,
                    alt: 4456448,
                    cmd: 8912896
                };
                for(let e = 65; e <= 90; e++){
                    const n = String.fromCharCode(e);
                    t[n.toLowerCase()] = e;
                }
                for(let e = 48; e <= 57; e++)t[e - 48] = e;
                for(let e = 112; e <= 123; e++)t["f" + (e - 111)] = e;
                for (const e of "`-=[];',./\\")t[e] = e.charCodeAt(0);
                return t;
            }
            function el(t) {
                return t.split("+").map((t)=>t.trim());
            }
            function nl(t) {
                return Array.isArray(t) ? t : [
                    t
                ];
            }
            if (!ec.window.CKEDITOR_TRANSLATIONS) ec.window.CKEDITOR_TRANSLATIONS = {};
            function ol(t, e, n) {
                if (!$parcel$global.window.CKEDITOR_TRANSLATIONS[t]) $parcel$global.window.CKEDITOR_TRANSLATIONS[t] = {};
                const o = $parcel$global.window.CKEDITOR_TRANSLATIONS[t];
                o.dictionary = o.dictionary || {};
                o.getPluralForm = n || o.getPluralForm;
                Object.assign(o.dictionary, e);
            }
            function il(t, e, n = 1) {
                if (typeof n !== "number") throw new R("translation-service-quantity-not-a-number", null, {
                    quantity: n
                });
                const o = al();
                if (o === 1) t = Object.keys(ec.window.CKEDITOR_TRANSLATIONS)[0];
                const i = e.id || e.string;
                if (o === 0 || !sl(t, i)) {
                    if (n !== 1) return e.plural;
                    return e.string;
                }
                const r = ec.window.CKEDITOR_TRANSLATIONS[t].dictionary;
                const s = ec.window.CKEDITOR_TRANSLATIONS[t].getPluralForm || ((t)=>t === 1 ? 0 : 1);
                const a = r[i];
                if (typeof a === "string") return a;
                const c = Number(s(n));
                return a[c];
            }
            function rl() {
                $parcel$global.window.CKEDITOR_TRANSLATIONS = {};
            }
            function sl(t, e) {
                return !!ec.window.CKEDITOR_TRANSLATIONS[t] && !!ec.window.CKEDITOR_TRANSLATIONS[t].dictionary[e];
            }
            function al() {
                return Object.keys(ec.window.CKEDITOR_TRANSLATIONS).length;
            }
            const cl = [
                "ar",
                "ara",
                "fa",
                "per",
                "fas",
                "he",
                "heb",
                "ku",
                "kur",
                "ug",
                "uig"
            ];
            function ll(t) {
                return cl.includes(t) ? "rtl" : "ltr";
            }
            class dl {
                constructor({ uiLanguage: t = "en", contentLanguage: e } = {}){
                    this.uiLanguage = t;
                    this.contentLanguage = e || this.uiLanguage;
                    this.uiLanguageDirection = ll(this.uiLanguage);
                    this.contentLanguageDirection = ll(this.contentLanguage);
                    this.t = (t, e)=>this._t(t, e);
                }
                get language() {
                    console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead.");
                    return this.uiLanguage;
                }
                _t(t, e = []) {
                    e = nl(e);
                    if (typeof t === "string") t = {
                        string: t
                    };
                    const n = !!t.plural;
                    const o = n ? e[0] : 1;
                    const i = il(this.uiLanguage, t, o);
                    return ul(i, e);
                }
            }
            function ul(t, e) {
                return t.replace(/%(\d+)/g, (t, n)=>n < e.length ? e[n] : t);
            }
            class hl extends G() {
                constructor(t = {}, e = {}){
                    super();
                    const n = Et(t);
                    if (!n) e = t;
                    this._items = [];
                    this._itemMap = new Map;
                    this._idProperty = e.idProperty || "id";
                    this._bindToExternalToInternalMap = new WeakMap;
                    this._bindToInternalToExternalMap = new WeakMap;
                    this._skippedIndexesFromExternal = [];
                    if (n) for (const e of t){
                        this._items.push(e);
                        this._itemMap.set(this._getItemIdBeforeAdding(e), e);
                    }
                }
                get length() {
                    return this._items.length;
                }
                get first() {
                    return this._items[0] || null;
                }
                get last() {
                    return this._items[this.length - 1] || null;
                }
                add(t, e) {
                    return this.addMany([
                        t
                    ], e);
                }
                addMany(t, e) {
                    if (e === undefined) e = this._items.length;
                    else if (e > this._items.length || e < 0) throw new R("collection-add-item-invalid-index", this);
                    let n = 0;
                    for (const o of t){
                        const t = this._getItemIdBeforeAdding(o);
                        const i = e + n;
                        this._items.splice(i, 0, o);
                        this._itemMap.set(t, o);
                        this.fire("add", o, i);
                        n++;
                    }
                    this.fire("change", {
                        added: t,
                        removed: [],
                        index: e
                    });
                    return this;
                }
                get(t) {
                    let e;
                    if (typeof t == "string") e = this._itemMap.get(t);
                    else if (typeof t == "number") e = this._items[t];
                    else throw new R("collection-get-invalid-arg", this);
                    return e || null;
                }
                has(t) {
                    if (typeof t == "string") return this._itemMap.has(t);
                    else {
                        const e = this._idProperty;
                        const n = t[e];
                        return n && this._itemMap.has(n);
                    }
                }
                getIndex(t) {
                    let e;
                    if (typeof t == "string") e = this._itemMap.get(t);
                    else e = t;
                    return e ? this._items.indexOf(e) : -1;
                }
                remove(t) {
                    const [e, n] = this._remove(t);
                    this.fire("change", {
                        added: [],
                        removed: [
                            e
                        ],
                        index: n
                    });
                    return e;
                }
                map(t, e) {
                    return this._items.map(t, e);
                }
                find(t, e) {
                    return this._items.find(t, e);
                }
                filter(t, e) {
                    return this._items.filter(t, e);
                }
                clear() {
                    if (this._bindToCollection) {
                        this.stopListening(this._bindToCollection);
                        this._bindToCollection = null;
                    }
                    const t = Array.from(this._items);
                    while(this.length)this._remove(0);
                    this.fire("change", {
                        added: [],
                        removed: t,
                        index: 0
                    });
                }
                bindTo(t) {
                    if (this._bindToCollection) throw new R("collection-bind-to-rebind", this);
                    this._bindToCollection = t;
                    return {
                        as: (t)=>{
                            this._setUpBindToBinding((e)=>new t(e));
                        },
                        using: (t)=>{
                            if (typeof t == "function") this._setUpBindToBinding(t);
                            else this._setUpBindToBinding((e)=>e[t]);
                        }
                    };
                }
                _setUpBindToBinding(t) {
                    const e = this._bindToCollection;
                    const n = (n, o, i)=>{
                        const r = e._bindToCollection == this;
                        const s = e._bindToInternalToExternalMap.get(o);
                        if (r && s) {
                            this._bindToExternalToInternalMap.set(o, s);
                            this._bindToInternalToExternalMap.set(s, o);
                        } else {
                            const n = t(o);
                            if (!n) {
                                this._skippedIndexesFromExternal.push(i);
                                return;
                            }
                            let r = i;
                            for (const t of this._skippedIndexesFromExternal)if (i > t) r--;
                            for (const t of e._skippedIndexesFromExternal)if (r >= t) r++;
                            this._bindToExternalToInternalMap.set(o, n);
                            this._bindToInternalToExternalMap.set(n, o);
                            this.add(n, r);
                            for(let t = 0; t < e._skippedIndexesFromExternal.length; t++)if (r <= e._skippedIndexesFromExternal[t]) e._skippedIndexesFromExternal[t]++;
                        }
                    };
                    for (const t of e)n(null, t, e.getIndex(t));
                    this.listenTo(e, "add", n);
                    this.listenTo(e, "remove", (t, e, n)=>{
                        const o = this._bindToExternalToInternalMap.get(e);
                        if (o) this.remove(o);
                        this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((t, e)=>{
                            if (n < e) t.push(e - 1);
                            if (n > e) t.push(e);
                            return t;
                        }, []);
                    });
                }
                _getItemIdBeforeAdding(t) {
                    const e = this._idProperty;
                    let n;
                    if (e in t) {
                        n = t[e];
                        if (typeof n != "string") throw new R("collection-add-invalid-id", this);
                        if (this.get(n)) throw new R("collection-add-item-already-exists", this);
                    } else t[e] = n = S();
                    return n;
                }
                _remove(t) {
                    let e, n, o;
                    let i = false;
                    const r = this._idProperty;
                    if (typeof t == "string") {
                        n = t;
                        o = this._itemMap.get(n);
                        i = !o;
                        if (o) e = this._items.indexOf(o);
                    } else if (typeof t == "number") {
                        e = t;
                        o = this._items[e];
                        i = !o;
                        if (o) n = o[r];
                    } else {
                        o = t;
                        n = o[r];
                        e = this._items.indexOf(o);
                        i = e == -1 || !this._itemMap.get(n);
                    }
                    if (i) throw new R("collection-remove-404", this);
                    this._items.splice(e, 1);
                    this._itemMap.delete(n);
                    const s = this._bindToInternalToExternalMap.get(o);
                    this._bindToInternalToExternalMap.delete(o);
                    this._bindToExternalToInternalMap.delete(s);
                    this.fire("remove", o, e);
                    return [
                        o,
                        e
                    ];
                }
                [Symbol.iterator]() {
                    return this._items[Symbol.iterator]();
                }
            }
            function fl(t) {
                const e = t.next();
                if (e.done) return null;
                return e.value;
            }
            class pl extends Ja(ht()) {
                constructor(){
                    super();
                    this._elements = new Set;
                    this._nextEventLoopTimeout = null;
                    this.set("isFocused", false);
                    this.set("focusedElement", null);
                }
                add(t) {
                    if (this._elements.has(t)) throw new R("focustracker-add-element-already-exist", this);
                    this.listenTo(t, "focus", ()=>this._focus(t), {
                        useCapture: true
                    });
                    this.listenTo(t, "blur", ()=>this._blur(), {
                        useCapture: true
                    });
                    this._elements.add(t);
                }
                remove(t) {
                    if (t === this.focusedElement) this._blur();
                    if (this._elements.has(t)) {
                        this.stopListening(t);
                        this._elements.delete(t);
                    }
                }
                destroy() {
                    this.stopListening();
                }
                _focus(t) {
                    clearTimeout(this._nextEventLoopTimeout);
                    this.focusedElement = t;
                    this.isFocused = true;
                }
                _blur() {
                    clearTimeout(this._nextEventLoopTimeout);
                    this._nextEventLoopTimeout = setTimeout(()=>{
                        this.focusedElement = null;
                        this.isFocused = false;
                    }, 0);
                }
            }
            class gl {
                constructor(){
                    this._listener = new (Ja());
                }
                listenTo(t) {
                    this._listener.listenTo(t, "keydown", (t, e)=>{
                        this._listener.fire("_keydown:" + Uc(e), e);
                    });
                }
                set(t, e, n = {}) {
                    const o = Kc(t);
                    const i = n.priority;
                    this._listener.listenTo(this._listener, "_keydown:" + o, (t, n)=>{
                        e(n, ()=>{
                            n.preventDefault();
                            n.stopPropagation();
                            t.stop();
                        });
                        t.return = true;
                    }, {
                        priority: i
                    });
                }
                press(t) {
                    return !!this._listener.fire("_keydown:" + Uc(t), t);
                }
                stopListening(t) {
                    this._listener.stopListening(t);
                }
                destroy() {
                    this.stopListening();
                }
            }
            function ml(t) {
                const e = new Map;
                for(const n in t)e.set(n, t[n]);
                return e;
            }
            function kl(t) {
                if (Et(t)) return new Map(t);
                else return ml(t);
            }
            const bl = 1e4;
            function wl(t, e, n, o) {
                if (Math.max(e.length, t.length) > bl) return t.slice(0, n).concat(e).concat(t.slice(n + o, t.length));
                else {
                    const i = Array.from(t);
                    i.splice(n, o, ...e);
                    return i;
                }
            }
            function _l(t, e) {
                let n;
                function o(...i) {
                    o.cancel();
                    n = setTimeout(()=>t(...i), e);
                }
                o.cancel = ()=>{
                    clearTimeout(n);
                };
                return o;
            }
            function Al(t) {
                function e(t) {
                    if (t.length >= 40 && t.length <= 255) return "VALID";
                    else return "INVALID";
                }
                if (!t) return "INVALID";
                let n = "";
                try {
                    n = atob(t);
                } catch (t) {
                    return "INVALID";
                }
                const o = n.split("-");
                const i = o[0];
                const r = o[1];
                if (!r) return e(t);
                try {
                    atob(r);
                } catch (n) {
                    try {
                        atob(i);
                        if (!atob(i).length) return e(t);
                    } catch (n) {
                        return e(t);
                    }
                }
                if (i.length < 40 || i.length > 255) return "INVALID";
                let s = "";
                try {
                    atob(i);
                    s = atob(r);
                } catch (t) {
                    return "INVALID";
                }
                if (s.length !== 8) return "INVALID";
                const a = Number(s.substring(0, 4));
                const c = Number(s.substring(4, 6)) - 1;
                const l = Number(s.substring(6, 8));
                const d = new Date(a, c, l);
                if (d < H || isNaN(Number(d))) return "INVALID";
                return "VALID";
            }
            function vl(t) {
                return !!t && t.length == 1 && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(t);
            }
            function Cl(t) {
                return !!t && t.length == 1 && /[\ud800-\udbff]/.test(t);
            }
            function yl(t) {
                return !!t && t.length == 1 && /[\udc00-\udfff]/.test(t);
            }
            function xl(t, e) {
                return Cl(t.charAt(e - 1)) && yl(t.charAt(e));
            }
            function El(t, e) {
                return vl(t.charAt(e));
            }
            const Dl = Tl();
            function Sl(t, e) {
                const n = String(t).matchAll(Dl);
                return Array.from(n).some((t)=>t.index < e && e < t.index + t[0].length);
            }
            function Tl() {
                const t = [
                    /\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u,
                    /\p{Emoji}\u{FE0F}?\u{20E3}/u,
                    /\p{Emoji}\u{FE0F}/u,
                    /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u
                ];
                const e = /\p{Regional_Indicator}{2}/u.source;
                const n = "(?:" + t.map((t)=>t.source).join("|") + ")";
                const o = `${e}|${n}(?:\u{200D}${n})*`;
                return new RegExp(o, "ug");
            }
            class Bl extends hl {
                constructor(t = []){
                    super(t, {
                        idProperty: "viewUid"
                    });
                    this.on("add", (t, e, n)=>{
                        this._renderViewIntoCollectionParent(e, n);
                    });
                    this.on("remove", (t, e)=>{
                        if (e.element && this._parentElement) e.element.remove();
                    });
                    this._parentElement = null;
                }
                destroy() {
                    this.map((t)=>t.destroy());
                }
                setParent(t) {
                    this._parentElement = t;
                    for (const t of this)this._renderViewIntoCollectionParent(t);
                }
                delegate(...t) {
                    if (!t.length || !Pl(t)) throw new R("ui-viewcollection-delegate-wrong-events", this);
                    return {
                        to: (e)=>{
                            for (const n of this)for (const o of t)n.delegate(o).to(e);
                            this.on("add", (n, o)=>{
                                for (const n of t)o.delegate(n).to(e);
                            });
                            this.on("remove", (n, o)=>{
                                for (const n of t)o.stopDelegating(n, e);
                            });
                        }
                    };
                }
                _renderViewIntoCollectionParent(t, e) {
                    if (!t.isRendered) t.render();
                    if (t.element && this._parentElement) this._parentElement.insertBefore(t.element, this._parentElement.children[e]);
                }
                remove(t) {
                    return super.remove(t);
                }
            }
            function Pl(t) {
                return t.every((t)=>typeof t == "string");
            }
            var Il = n(3379);
            var Rl = n.n(Il);
            var Ol = n(5167);
            var Vl = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Vl.insert = "head";
            Vl.singleton = true;
            var Ml = Rl()(Ol.Z, Vl);
            const Ll = Ol.Z.locals || {};
            class zl extends Ja(ht()) {
                constructor(t){
                    super();
                    this.element = null;
                    this.isRendered = false;
                    this.locale = t;
                    this.t = t && t.t;
                    this._viewCollections = new hl;
                    this._unboundChildren = this.createCollection();
                    this._viewCollections.on("add", (e, n)=>{
                        n.locale = t;
                        n.t = t && t.t;
                    });
                    this.decorate("render");
                }
                get bindTemplate() {
                    if (this._bindTemplate) return this._bindTemplate;
                    return this._bindTemplate = Fl.bind(this, this);
                }
                createCollection(t) {
                    const e = new Bl(t);
                    this._viewCollections.add(e);
                    return e;
                }
                registerChild(t) {
                    if (!Et(t)) t = [
                        t
                    ];
                    for (const e of t)this._unboundChildren.add(e);
                }
                deregisterChild(t) {
                    if (!Et(t)) t = [
                        t
                    ];
                    for (const e of t)this._unboundChildren.remove(e);
                }
                setTemplate(t) {
                    this.template = new Fl(t);
                }
                extendTemplate(t) {
                    Fl.extend(this.template, t);
                }
                render() {
                    if (this.isRendered) throw new R("ui-view-render-already-rendered", this);
                    if (this.template) {
                        this.element = this.template.render();
                        this.registerChild(this.template.getViews());
                    }
                    this.isRendered = true;
                }
                destroy() {
                    this.stopListening();
                    this._viewCollections.map((t)=>t.destroy());
                    if (this.template && this.template._revertData) this.template.revert(this.element);
                }
            }
            const Nl = "http://www.w3.org/1999/xhtml";
            class Fl extends G() {
                constructor(t){
                    super();
                    Object.assign(this, Yl(Jl(t)));
                    this._isRendered = false;
                    this._revertData = null;
                }
                render() {
                    const t = this._renderNode({
                        intoFragment: true
                    });
                    this._isRendered = true;
                    return t;
                }
                apply(t) {
                    this._revertData = ud();
                    this._renderNode({
                        node: t,
                        intoFragment: false,
                        isApplying: true,
                        revertData: this._revertData
                    });
                    return t;
                }
                revert(t) {
                    if (!this._revertData) throw new R("ui-template-revert-not-applied", [
                        this,
                        t
                    ]);
                    this._revertTemplateFromNode(t, this._revertData);
                }
                *getViews() {
                    function* t(e) {
                        if (e.children) for (const n of e.children){
                            if (ad(n)) yield n;
                            else if (cd(n)) yield* t(n);
                        }
                    }
                    yield* t(this);
                }
                static bind(t, e) {
                    return {
                        to (n, o) {
                            return new jl({
                                eventNameOrFunction: n,
                                attribute: n,
                                observable: t,
                                emitter: e,
                                callback: o
                            });
                        },
                        if (n, o, i) {
                            return new ql({
                                observable: t,
                                emitter: e,
                                attribute: n,
                                valueIfTrue: o,
                                callback: i
                            });
                        }
                    };
                }
                static extend(t, e) {
                    if (t._isRendered) throw new R("template-extend-render", [
                        this,
                        t
                    ]);
                    rd(t, Yl(Jl(e)));
                }
                _renderNode(t) {
                    let e;
                    if (t.node) e = this.tag && this.text;
                    else e = this.tag ? this.text : !this.text;
                    if (e) throw new R("ui-template-wrong-syntax", this);
                    if (this.text) return this._renderText(t);
                    else return this._renderElement(t);
                }
                _renderElement(t) {
                    let e = t.node;
                    if (!e) e = t.node = document.createElementNS(this.ns || Nl, this.tag);
                    this._renderAttributes(t);
                    this._renderElementChildren(t);
                    this._setUpListeners(t);
                    return e;
                }
                _renderText(t) {
                    let e = t.node;
                    if (e) t.revertData.text = e.textContent;
                    else e = t.node = document.createTextNode("");
                    if (Wl(this.text)) this._bindToObservable({
                        schema: this.text,
                        updater: Ul(e),
                        data: t
                    });
                    else e.textContent = this.text.join("");
                    return e;
                }
                _renderAttributes(t) {
                    if (!this.attributes) return;
                    const e = t.node;
                    const n = t.revertData;
                    for(const o in this.attributes){
                        const i = e.getAttribute(o);
                        const r = this.attributes[o];
                        if (n) n.attributes[o] = i;
                        const s = dd(r) ? r[0].ns : null;
                        if (Wl(r)) {
                            const a = dd(r) ? r[0].value : r;
                            if (n && hd(o)) a.unshift(i);
                            this._bindToObservable({
                                schema: a,
                                updater: Kl(e, o, s),
                                data: t
                            });
                        } else if (o == "style" && typeof r[0] !== "string") this._renderStyleAttribute(r[0], t);
                        else {
                            if (n && i && hd(o)) r.unshift(i);
                            const t = r.map((t)=>t ? t.value || t : t).reduce((t, e)=>t.concat(e), []).reduce(od, "");
                            if (!sd(t)) e.setAttributeNS(s, o, t);
                        }
                    }
                }
                _renderStyleAttribute(t, e) {
                    const n = e.node;
                    for(const o in t){
                        const i = t[o];
                        if (Wl(i)) this._bindToObservable({
                            schema: [
                                i
                            ],
                            updater: Zl(n, o),
                            data: e
                        });
                        else n.style[o] = i;
                    }
                }
                _renderElementChildren(t) {
                    const e = t.node;
                    const n = t.intoFragment ? document.createDocumentFragment() : e;
                    const o = t.isApplying;
                    let i = 0;
                    for (const r of this.children){
                        if (ld(r)) {
                            if (!o) {
                                r.setParent(e);
                                for (const t of r)n.appendChild(t.element);
                            }
                        } else if (ad(r)) {
                            if (!o) {
                                if (!r.isRendered) r.render();
                                n.appendChild(r.element);
                            }
                        } else if (Ua(r)) n.appendChild(r);
                        else if (o) {
                            const e = t.revertData;
                            const o = ud();
                            e.children.push(o);
                            r._renderNode({
                                intoFragment: false,
                                node: n.childNodes[i++],
                                isApplying: true,
                                revertData: o
                            });
                        } else n.appendChild(r.render());
                    }
                    if (t.intoFragment) e.appendChild(n);
                }
                _setUpListeners(t) {
                    if (!this.eventListeners) return;
                    for(const e in this.eventListeners){
                        const n = this.eventListeners[e].map((n)=>{
                            const [o, i] = e.split("@");
                            return n.activateDomEventListener(o, i, t);
                        });
                        if (t.revertData) t.revertData.bindings.push(n);
                    }
                }
                _bindToObservable({ schema: t, updater: e, data: n }) {
                    const o = n.revertData;
                    Gl(t, e, n);
                    const i = t.filter((t)=>!sd(t)).filter((t)=>t.observable).map((o)=>o.activateAttributeListener(t, e, n));
                    if (o) o.bindings.push(i);
                }
                _revertTemplateFromNode(t, e) {
                    for (const t of e.bindings)for (const e of t)e();
                    if (e.text) {
                        t.textContent = e.text;
                        return;
                    }
                    const n = t;
                    for(const t in e.attributes){
                        const o = e.attributes[t];
                        if (o === null) n.removeAttribute(t);
                        else n.setAttribute(t, o);
                    }
                    for(let t = 0; t < e.children.length; ++t)this._revertTemplateFromNode(n.childNodes[t], e.children[t]);
                }
            }
            class Hl {
                constructor(t){
                    this.attribute = t.attribute;
                    this.observable = t.observable;
                    this.emitter = t.emitter;
                    this.callback = t.callback;
                }
                getValue(t) {
                    const e = this.observable[this.attribute];
                    return this.callback ? this.callback(e, t) : e;
                }
                activateAttributeListener(t, e, n) {
                    const o = ()=>Gl(t, e, n);
                    this.emitter.listenTo(this.observable, `change:${this.attribute}`, o);
                    return ()=>{
                        this.emitter.stopListening(this.observable, `change:${this.attribute}`, o);
                    };
                }
            }
            class jl extends Hl {
                constructor(t){
                    super(t);
                    this.eventNameOrFunction = t.eventNameOrFunction;
                }
                activateDomEventListener(t, e, n) {
                    const o = (t, n)=>{
                        if (!e || n.target.matches(e)) {
                            if (typeof this.eventNameOrFunction == "function") this.eventNameOrFunction(n);
                            else this.observable.fire(this.eventNameOrFunction, n);
                        }
                    };
                    this.emitter.listenTo(n.node, t, o);
                    return ()=>{
                        this.emitter.stopListening(n.node, t, o);
                    };
                }
            }
            class ql extends Hl {
                constructor(t){
                    super(t);
                    this.valueIfTrue = t.valueIfTrue;
                }
                getValue(t) {
                    const e = super.getValue(t);
                    return sd(e) ? false : this.valueIfTrue || true;
                }
            }
            function Wl(t) {
                if (!t) return false;
                if (t.value) t = t.value;
                if (Array.isArray(t)) return t.some(Wl);
                else if (t instanceof Hl) return true;
                return false;
            }
            function $l(t, e) {
                return t.map((t)=>{
                    if (t instanceof Hl) return t.getValue(e);
                    return t;
                });
            }
            function Gl(t, e, { node: n }) {
                const o = $l(t, n);
                let i;
                if (t.length == 1 && t[0] instanceof ql) i = o[0];
                else i = o.reduce(od, "");
                if (sd(i)) e.remove();
                else e.set(i);
            }
            function Ul(t) {
                return {
                    set (e) {
                        t.textContent = e;
                    },
                    remove () {
                        t.textContent = "";
                    }
                };
            }
            function Kl(t, e, n) {
                return {
                    set (o) {
                        t.setAttributeNS(n, e, o);
                    },
                    remove () {
                        t.removeAttributeNS(n, e);
                    }
                };
            }
            function Zl(t, e) {
                return {
                    set (n) {
                        t.style[e] = n;
                    },
                    remove () {
                        t.style[e] = null;
                    }
                };
            }
            function Jl(t) {
                const e = Ha(t, (t)=>{
                    if (t && (t instanceof Hl || cd(t) || ad(t) || ld(t))) return t;
                });
                return e;
            }
            function Yl(t) {
                if (typeof t == "string") t = td(t);
                else if (t.text) ed(t);
                if (t.on) {
                    t.eventListeners = Xl(t.on);
                    delete t.on;
                }
                if (!t.text) {
                    if (t.attributes) Ql(t.attributes);
                    const e = [];
                    if (t.children) {
                        if (ld(t.children)) e.push(t.children);
                        else {
                            for (const n of t.children)if (cd(n) || ad(n) || Ua(n)) e.push(n);
                            else e.push(new Fl(n));
                        }
                    }
                    t.children = e;
                }
                return t;
            }
            function Ql(t) {
                for(const e in t){
                    if (t[e].value) t[e].value = nl(t[e].value);
                    nd(t, e);
                }
            }
            function Xl(t) {
                for(const e in t)nd(t, e);
                return t;
            }
            function td(t) {
                return {
                    text: [
                        t
                    ]
                };
            }
            function ed(t) {
                t.text = nl(t.text);
            }
            function nd(t, e) {
                t[e] = nl(t[e]);
            }
            function od(t, e) {
                if (sd(e)) return t;
                else if (sd(t)) return e;
                else return `${t} ${e}`;
            }
            function id(t, e) {
                for(const n in e)if (t[n]) t[n].push(...e[n]);
                else t[n] = e[n];
            }
            function rd(t, e) {
                if (e.attributes) {
                    if (!t.attributes) t.attributes = {};
                    id(t.attributes, e.attributes);
                }
                if (e.eventListeners) {
                    if (!t.eventListeners) t.eventListeners = {};
                    id(t.eventListeners, e.eventListeners);
                }
                if (e.text) t.text.push(...e.text);
                if (e.children && e.children.length) {
                    if (t.children.length != e.children.length) throw new R("ui-template-extend-children-mismatch", t);
                    let n = 0;
                    for (const o of e.children)rd(t.children[n++], o);
                }
            }
            function sd(t) {
                return !t && t !== 0;
            }
            function ad(t) {
                return t instanceof zl;
            }
            function cd(t) {
                return t instanceof Fl;
            }
            function ld(t) {
                return t instanceof Bl;
            }
            function dd(t) {
                return rt(t[0]) && t[0].ns;
            }
            function ud() {
                return {
                    children: [],
                    bindings: [],
                    attributes: {}
                };
            }
            function hd(t) {
                return t == "class" || t == "style";
            }
            class fd extends Bl {
                constructor(t, e = []){
                    super(e);
                    this.locale = t;
                }
                get bodyCollectionContainer() {
                    return this._bodyCollectionContainer;
                }
                attachToDom() {
                    this._bodyCollectionContainer = new Fl({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-reset_all",
                                "ck-body",
                                "ck-rounded-corners"
                            ],
                            dir: this.locale.uiLanguageDirection
                        },
                        children: this
                    }).render();
                    let t = document.querySelector(".ck-body-wrapper");
                    if (!t) {
                        t = ne(document, "div", {
                            class: "ck-body-wrapper"
                        });
                        document.body.appendChild(t);
                    }
                    t.appendChild(this._bodyCollectionContainer);
                }
                detachFromDom() {
                    super.destroy();
                    if (this._bodyCollectionContainer) this._bodyCollectionContainer.remove();
                    const t = document.querySelector(".ck-body-wrapper");
                    if (t && t.childElementCount == 0) t.remove();
                }
            }
            var pd = n(1977);
            var gd = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            gd.insert = "head";
            gd.singleton = true;
            var md = Rl()(pd.Z, gd);
            const kd = pd.Z.locals || {};
            class bd extends zl {
                constructor(){
                    super();
                    const t = this.bindTemplate;
                    this.set("content", "");
                    this.set("viewBox", "0 0 20 20");
                    this.set("fillColor", "");
                    this.set("isColorInherited", true);
                    this.set("isVisible", true);
                    this.setTemplate({
                        tag: "svg",
                        ns: "http://www.w3.org/2000/svg",
                        attributes: {
                            class: [
                                "ck",
                                "ck-icon",
                                t.if("isVisible", "ck-hidden", (t)=>!t),
                                "ck-reset_all-excluded",
                                t.if("isColorInherited", "ck-icon_inherit-color")
                            ],
                            viewBox: t.to("viewBox")
                        }
                    });
                }
                render() {
                    super.render();
                    this._updateXMLContent();
                    this._colorFillPaths();
                    this.on("change:content", ()=>{
                        this._updateXMLContent();
                        this._colorFillPaths();
                    });
                    this.on("change:fillColor", ()=>{
                        this._colorFillPaths();
                    });
                }
                _updateXMLContent() {
                    if (this.content) {
                        const t = (new DOMParser).parseFromString(this.content.trim(), "image/svg+xml");
                        const e = t.querySelector("svg");
                        const n = e.getAttribute("viewBox");
                        if (n) this.viewBox = n;
                        for (const { name: t, value: n } of Array.from(e.attributes))if (bd.presentationalAttributeNames.includes(t)) this.element.setAttribute(t, n);
                        while(this.element.firstChild)this.element.removeChild(this.element.firstChild);
                        while(e.childNodes.length > 0)this.element.appendChild(e.childNodes[0]);
                    }
                }
                _colorFillPaths() {
                    if (this.fillColor) this.element.querySelectorAll(".ck-icon__fill").forEach((t)=>{
                        t.style.fill = this.fillColor;
                    });
                }
            }
            bd.presentationalAttributeNames = [
                "alignment-baseline",
                "baseline-shift",
                "clip-path",
                "clip-rule",
                "color",
                "color-interpolation",
                "color-interpolation-filters",
                "color-rendering",
                "cursor",
                "direction",
                "display",
                "dominant-baseline",
                "fill",
                "fill-opacity",
                "fill-rule",
                "filter",
                "flood-color",
                "flood-opacity",
                "font-family",
                "font-size",
                "font-size-adjust",
                "font-stretch",
                "font-style",
                "font-variant",
                "font-weight",
                "image-rendering",
                "letter-spacing",
                "lighting-color",
                "marker-end",
                "marker-mid",
                "marker-start",
                "mask",
                "opacity",
                "overflow",
                "paint-order",
                "pointer-events",
                "shape-rendering",
                "stop-color",
                "stop-opacity",
                "stroke",
                "stroke-dasharray",
                "stroke-dashoffset",
                "stroke-linecap",
                "stroke-linejoin",
                "stroke-miterlimit",
                "stroke-opacity",
                "stroke-width",
                "text-anchor",
                "text-decoration",
                "text-overflow",
                "text-rendering",
                "transform",
                "unicode-bidi",
                "vector-effect",
                "visibility",
                "white-space",
                "word-spacing",
                "writing-mode"
            ];
            class wd extends zl {
                constructor(){
                    super();
                    this.set({
                        style: undefined,
                        text: undefined,
                        id: undefined
                    });
                    const t = this.bindTemplate;
                    this.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-button__label"
                            ],
                            style: t.to("style"),
                            id: t.to("id")
                        },
                        children: [
                            {
                                text: t.to("text")
                            }
                        ]
                    });
                }
            }
            var _d = n(4971);
            var Ad = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Ad.insert = "head";
            Ad.singleton = true;
            var vd = Rl()(_d.Z, Ad);
            const Cd = _d.Z.locals || {};
            class yd extends zl {
                constructor(t, e = new wd){
                    super(t);
                    this._focusDelayed = null;
                    const n = this.bindTemplate;
                    const o = S();
                    this.set("ariaChecked", undefined);
                    this.set("ariaLabel", undefined);
                    this.set("ariaLabelledBy", `ck-editor__aria-label_${o}`);
                    this.set("class", undefined);
                    this.set("labelStyle", undefined);
                    this.set("icon", undefined);
                    this.set("isEnabled", true);
                    this.set("isOn", false);
                    this.set("isVisible", true);
                    this.set("isToggleable", false);
                    this.set("keystroke", undefined);
                    this.set("label", undefined);
                    this.set("role", undefined);
                    this.set("tabindex", -1);
                    this.set("tooltip", false);
                    this.set("tooltipPosition", "s");
                    this.set("type", "button");
                    this.set("withText", false);
                    this.set("withKeystroke", false);
                    this.children = this.createCollection();
                    this.labelView = this._setupLabelView(e);
                    this.iconView = new bd;
                    this.iconView.extendTemplate({
                        attributes: {
                            class: "ck-button__icon"
                        }
                    });
                    this.keystrokeView = this._createKeystrokeView();
                    this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
                    const i = {
                        tag: "button",
                        attributes: {
                            class: [
                                "ck",
                                "ck-button",
                                n.to("class"),
                                n.if("isEnabled", "ck-disabled", (t)=>!t),
                                n.if("isVisible", "ck-hidden", (t)=>!t),
                                n.to("isOn", (t)=>t ? "ck-on" : "ck-off"),
                                n.if("withText", "ck-button_with-text"),
                                n.if("withKeystroke", "ck-button_with-keystroke")
                            ],
                            role: n.to("role"),
                            type: n.to("type", (t)=>t ? t : "button"),
                            tabindex: n.to("tabindex"),
                            "aria-label": n.to("ariaLabel"),
                            "aria-labelledby": n.to("ariaLabelledBy"),
                            "aria-disabled": n.if("isEnabled", true, (t)=>!t),
                            "aria-checked": n.to("isOn"),
                            "aria-pressed": n.to("isOn", (t)=>this.isToggleable ? String(!!t) : false),
                            "data-cke-tooltip-text": n.to("_tooltipString"),
                            "data-cke-tooltip-position": n.to("tooltipPosition")
                        },
                        children: this.children,
                        on: {
                            click: n.to((t)=>{
                                if (this.isEnabled) this.fire("execute");
                                else t.preventDefault();
                            })
                        }
                    };
                    if (c.isSafari) {
                        if (!this._focusDelayed) this._focusDelayed = _l(()=>this.focus(), 0);
                        i.on.mousedown = n.to(()=>{
                            this._focusDelayed();
                        });
                        i.on.mouseup = n.to(()=>{
                            this._focusDelayed.cancel();
                        });
                    }
                    this.setTemplate(i);
                }
                render() {
                    super.render();
                    if (this.icon) {
                        this.iconView.bind("content").to(this, "icon");
                        this.children.add(this.iconView);
                    }
                    this.children.add(this.labelView);
                    if (this.withKeystroke && this.keystroke) this.children.add(this.keystrokeView);
                }
                focus() {
                    this.element.focus();
                }
                destroy() {
                    if (this._focusDelayed) this._focusDelayed.cancel();
                    super.destroy();
                }
                _setupLabelView(t) {
                    t.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy");
                    return t;
                }
                _createKeystrokeView() {
                    const t = new zl;
                    t.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-button__keystroke"
                            ]
                        },
                        children: [
                            {
                                text: this.bindTemplate.to("keystroke", (t)=>Zc(t))
                            }
                        ]
                    });
                    return t;
                }
                _getTooltipString(t, e, n) {
                    if (t) {
                        if (typeof t == "string") return t;
                        else {
                            if (n) n = Zc(n);
                            if (t instanceof Function) return t(e, n);
                            else return `${e}${n ? ` (${n})` : ""}`;
                        }
                    }
                    return "";
                }
            }
            var xd = n(7258);
            var Ed = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Ed.insert = "head";
            Ed.singleton = true;
            var Dd = Rl()(xd.Z, Ed);
            const Sd = xd.Z.locals || {};
            class Td extends yd {
                constructor(t){
                    super(t);
                    this.isToggleable = true;
                    this.toggleSwitchView = this._createToggleView();
                    this.extendTemplate({
                        attributes: {
                            class: "ck-switchbutton"
                        }
                    });
                }
                render() {
                    super.render();
                    this.children.add(this.toggleSwitchView);
                }
                _createToggleView() {
                    const t = new zl;
                    t.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-button__toggle"
                            ]
                        },
                        children: [
                            {
                                tag: "span",
                                attributes: {
                                    class: [
                                        "ck",
                                        "ck-button__toggle__inner"
                                    ]
                                }
                            }
                        ]
                    });
                    return t;
                }
            }
            class Bd extends null {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.set("color", undefined);
                    this.set("hasBorder", false);
                    this.icon = checkIcon;
                    this.extendTemplate({
                        attributes: {
                            style: {
                                backgroundColor: e.to("color")
                            },
                            class: [
                                "ck",
                                "ck-color-grid__tile",
                                e.if("hasBorder", "ck-color-selector__color-tile_bordered")
                            ]
                        }
                    });
                }
                render() {
                    super.render();
                    this.iconView.fillColor = "hsl(0, 0%, 100%)";
                }
            }
            var Pd = n(4923);
            var Id = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Id.insert = "head";
            Id.singleton = true;
            var Rd = Rl()(Pd.Z, Id);
            const Od = Pd.Z.locals || {};
            class Vd extends null {
                constructor(t, e){
                    super(t);
                    const n = e && e.colorDefinitions ? e.colorDefinitions : [];
                    this.columns = e && e.columns ? e.columns : 5;
                    const o = {
                        gridTemplateColumns: `repeat( ${this.columns}, 1fr)`
                    };
                    this.set("selectedColor", undefined);
                    this.items = this.createCollection();
                    this.focusTracker = new FocusTracker;
                    this.keystrokes = new KeystrokeHandler;
                    this.items.on("add", (t, e)=>{
                        e.isOn = e.color === this.selectedColor;
                    });
                    n.forEach((t)=>{
                        const e = new ColorTileView;
                        e.set({
                            color: t.color,
                            label: t.label,
                            tooltip: true,
                            hasBorder: t.options.hasBorder
                        });
                        e.on("execute", ()=>{
                            this.fire("execute", {
                                value: t.color,
                                hasBorder: t.options.hasBorder,
                                label: t.label
                            });
                        });
                        this.items.add(e);
                    });
                    this.setTemplate({
                        tag: "div",
                        children: this.items,
                        attributes: {
                            class: [
                                "ck",
                                "ck-color-grid"
                            ],
                            style: o
                        }
                    });
                    this.on("change:selectedColor", (t, e, n)=>{
                        for (const t of this.items)t.isOn = t.color === n;
                    });
                }
                focus() {
                    if (this.items.length) this.items.first.focus();
                }
                focusLast() {
                    if (this.items.length) this.items.last.focus();
                }
                render() {
                    super.render();
                    for (const t of this.items)this.focusTracker.add(t.element);
                    this.items.on("add", (t, e)=>{
                        this.focusTracker.add(e.element);
                    });
                    this.items.on("remove", (t, e)=>{
                        this.focusTracker.remove(e.element);
                    });
                    this.keystrokes.listenTo(this.element);
                    addKeyboardHandlingForGrid({
                        keystrokeHandler: this.keystrokes,
                        focusTracker: this.focusTracker,
                        gridItems: this.items,
                        numberOfColumns: this.columns,
                        uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
                    });
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                }
            }
            var Md = n(8874);
            const Ld = null;
            var zd = {
                red: 0,
                orange: 60,
                yellow: 120,
                green: 180,
                blue: 240,
                purple: 300
            };
            function Nd(t) {
                var e, n = [], o = 1, i;
                if (typeof t === "string") {
                    if (names[t]) {
                        n = names[t].slice();
                        i = "rgb";
                    } else if (t === "transparent") {
                        o = 0;
                        i = "rgb";
                        n = [
                            0,
                            0,
                            0
                        ];
                    } else if (/^#[A-Fa-f0-9]+$/.test(t)) {
                        var r = t.slice(1);
                        var s = r.length;
                        var a = s <= 4;
                        o = 1;
                        if (a) {
                            n = [
                                parseInt(r[0] + r[0], 16),
                                parseInt(r[1] + r[1], 16),
                                parseInt(r[2] + r[2], 16)
                            ];
                            if (s === 4) o = parseInt(r[3] + r[3], 16) / 255;
                        } else {
                            n = [
                                parseInt(r[0] + r[1], 16),
                                parseInt(r[2] + r[3], 16),
                                parseInt(r[4] + r[5], 16)
                            ];
                            if (s === 8) o = parseInt(r[6] + r[7], 16) / 255;
                        }
                        if (!n[0]) n[0] = 0;
                        if (!n[1]) n[1] = 0;
                        if (!n[2]) n[2] = 0;
                        i = "rgb";
                    } else if (e = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(t)) {
                        var c = e[1];
                        var l = c === "rgb";
                        var r = c.replace(/a$/, "");
                        i = r;
                        var s = r === "cmyk" ? 4 : r === "gray" ? 1 : 3;
                        n = e[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(t, e) {
                            if (/%$/.test(t)) {
                                if (e === s) return parseFloat(t) / 100;
                                if (r === "rgb") return parseFloat(t) * 255 / 100;
                                return parseFloat(t);
                            } else if (r[e] === "h") {
                                if (/deg$/.test(t)) return parseFloat(t);
                                else if (zd[t] !== undefined) return zd[t];
                            }
                            return parseFloat(t);
                        });
                        if (c === r) n.push(1);
                        o = l ? 1 : n[s] === undefined ? 1 : n[s];
                        n = n.slice(0, s);
                    } else if (t.length > 10 && /[0-9](?:\s|\/)/.test(t)) {
                        n = t.match(/([0-9]+)/g).map(function(t) {
                            return parseFloat(t);
                        });
                        i = t.match(/([a-z])/gi).join("").toLowerCase();
                    }
                } else if (!isNaN(t)) {
                    i = "rgb";
                    n = [
                        t >>> 16,
                        (t & 65280) >>> 8,
                        t & 255
                    ];
                } else if (Array.isArray(t) || t.length) {
                    n = [
                        t[0],
                        t[1],
                        t[2]
                    ];
                    i = "rgb";
                    o = t.length === 4 ? t[3] : 1;
                } else if (t instanceof Object) {
                    if (t.r != null || t.red != null || t.R != null) {
                        i = "rgb";
                        n = [
                            t.r || t.red || t.R || 0,
                            t.g || t.green || t.G || 0,
                            t.b || t.blue || t.B || 0
                        ];
                    } else {
                        i = "hsl";
                        n = [
                            t.h || t.hue || t.H || 0,
                            t.s || t.saturation || t.S || 0,
                            t.l || t.lightness || t.L || t.b || t.brightness
                        ];
                    }
                    o = t.a || t.alpha || t.opacity || 1;
                    if (t.opacity != null) o /= 100;
                }
                return {
                    space: i,
                    values: n,
                    alpha: o
                };
            }
            var Fd = n(2085);
            function Hd(t, e) {
                if (!t) return "";
                const n = Wd(t);
                if (!n) return "";
                if (n.space === e) return t;
                if (!$d(n)) return "";
                const o = convert[n.space];
                const i = o[e];
                if (!i) return "";
                const r = i(n.space === "hex" ? n.hexValue : n.values);
                return qd(r, e);
            }
            function jd(t) {
                if (!t) return "";
                const e = Wd(t);
                if (!e) return "#000";
                if (e.space === "hex") return e.hexValue;
                return Hd(t, "hex");
            }
            function qd(t, e) {
                switch(e){
                    case "hex":
                        return `#${t}`;
                    case "rgb":
                        return `rgb( ${t[0]}, ${t[1]}, ${t[2]} )`;
                    case "hsl":
                        return `hsl( ${t[0]}, ${t[1]}%, ${t[2]}% )`;
                    case "hwb":
                        return `hwb( ${t[0]}, ${t[1]}, ${t[2]} )`;
                    case "lab":
                        return `lab( ${t[0]}% ${t[1]} ${t[2]} )`;
                    case "lch":
                        return `lch( ${t[0]}% ${t[1]} ${t[2]} )`;
                    default:
                        return "";
                }
            }
            function Wd(t) {
                if (t.startsWith("#")) {
                    const e = parse(t);
                    return {
                        space: "hex",
                        values: e.values,
                        hexValue: t,
                        alpha: e.alpha
                    };
                }
                const e = parse(t);
                if (!e.space) return null;
                return e;
            }
            function $d(t) {
                return Object.keys(convert).includes(t.space);
            }
            var Gd = n(3525);
            var Ud = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Ud.insert = "head";
            Ud.singleton = true;
            var Kd = Rl()(Gd.Z, Ud);
            const Zd = Gd.Z.locals || {};
            class Jd extends zl {
                constructor(t){
                    super(t);
                    this.set("text", undefined);
                    this.set("for", undefined);
                    this.id = `ck-editor__label_${S()}`;
                    const e = this.bindTemplate;
                    this.setTemplate({
                        tag: "label",
                        attributes: {
                            class: [
                                "ck",
                                "ck-label"
                            ],
                            id: this.id,
                            for: e.to("for")
                        },
                        children: [
                            {
                                text: e.to("text")
                            }
                        ]
                    });
                }
            }
            var Yd = n(2933);
            var Qd = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Qd.insert = "head";
            Qd.singleton = true;
            var Xd = Rl()(Yd.Z, Qd);
            const tu = Yd.Z.locals || {};
            class eu extends zl {
                constructor(t, e){
                    super(t);
                    const n = `ck-labeled-field-view-${S()}`;
                    const o = `ck-labeled-field-view-status-${S()}`;
                    this.fieldView = e(this, n, o);
                    this.set("label", undefined);
                    this.set("isEnabled", true);
                    this.set("isEmpty", true);
                    this.set("isFocused", false);
                    this.set("errorText", null);
                    this.set("infoText", null);
                    this.set("class", undefined);
                    this.set("placeholder", undefined);
                    this.labelView = this._createLabelView(n);
                    this.statusView = this._createStatusView(o);
                    this.fieldWrapperChildren = this.createCollection([
                        this.fieldView,
                        this.labelView
                    ]);
                    this.bind("_statusText").to(this, "errorText", this, "infoText", (t, e)=>t || e);
                    const i = this.bindTemplate;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-labeled-field-view",
                                i.to("class"),
                                i.if("isEnabled", "ck-disabled", (t)=>!t),
                                i.if("isEmpty", "ck-labeled-field-view_empty"),
                                i.if("isFocused", "ck-labeled-field-view_focused"),
                                i.if("placeholder", "ck-labeled-field-view_placeholder"),
                                i.if("errorText", "ck-error")
                            ]
                        },
                        children: [
                            {
                                tag: "div",
                                attributes: {
                                    class: [
                                        "ck",
                                        "ck-labeled-field-view__input-wrapper"
                                    ]
                                },
                                children: this.fieldWrapperChildren
                            },
                            this.statusView
                        ]
                    });
                }
                _createLabelView(t) {
                    const e = new Jd(this.locale);
                    e.for = t;
                    e.bind("text").to(this, "label");
                    return e;
                }
                _createStatusView(t) {
                    const e = new zl(this.locale);
                    const n = this.bindTemplate;
                    e.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-labeled-field-view__status",
                                n.if("errorText", "ck-labeled-field-view__status_error"),
                                n.if("_statusText", "ck-hidden", (t)=>!t)
                            ],
                            id: t,
                            role: n.if("errorText", "alert")
                        },
                        children: [
                            {
                                text: n.to("_statusText")
                            }
                        ]
                    });
                    return e;
                }
                focus(t) {
                    this.fieldView.focus(t);
                }
            }
            class nu extends zl {
                constructor(t){
                    super(t);
                    this.set("value", undefined);
                    this.set("id", undefined);
                    this.set("placeholder", undefined);
                    this.set("isReadOnly", false);
                    this.set("hasError", false);
                    this.set("ariaDescribedById", undefined);
                    this.focusTracker = new pl;
                    this.bind("isFocused").to(this.focusTracker);
                    this.set("isEmpty", true);
                    const e = this.bindTemplate;
                    this.setTemplate({
                        tag: "input",
                        attributes: {
                            class: [
                                "ck",
                                "ck-input",
                                e.if("isFocused", "ck-input_focused"),
                                e.if("isEmpty", "ck-input-text_empty"),
                                e.if("hasError", "ck-error")
                            ],
                            id: e.to("id"),
                            placeholder: e.to("placeholder"),
                            readonly: e.to("isReadOnly"),
                            "aria-invalid": e.if("hasError", true),
                            "aria-describedby": e.to("ariaDescribedById")
                        },
                        on: {
                            input: e.to((...t)=>{
                                this.fire("input", ...t);
                                this._updateIsEmpty();
                            }),
                            change: e.to(this._updateIsEmpty.bind(this))
                        }
                    });
                }
                render() {
                    super.render();
                    this.focusTracker.add(this.element);
                    this._setDomElementValue(this.value);
                    this._updateIsEmpty();
                    this.on("change:value", (t, e, n)=>{
                        this._setDomElementValue(n);
                        this._updateIsEmpty();
                    });
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                }
                select() {
                    this.element.select();
                }
                focus() {
                    this.element.focus();
                }
                reset() {
                    this.value = this.element.value = "";
                    this._updateIsEmpty();
                }
                _updateIsEmpty() {
                    this.isEmpty = ou(this.element);
                }
                _setDomElementValue(t) {
                    this.element.value = !t && t !== 0 ? "" : t;
                }
            }
            function ou(t) {
                return !t.value;
            }
            var iu = n(2470);
            var ru = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            ru.insert = "head";
            ru.singleton = true;
            var su = Rl()(iu.Z, ru);
            const au = iu.Z.locals || {};
            class cu extends nu {
                constructor(t){
                    super(t);
                    this.set("inputMode", "text");
                    const e = this.bindTemplate;
                    this.extendTemplate({
                        attributes: {
                            inputmode: e.to("inputMode")
                        }
                    });
                }
            }
            class lu extends cu {
                constructor(t){
                    super(t);
                    this.extendTemplate({
                        attributes: {
                            type: "text",
                            class: [
                                "ck-input-text"
                            ]
                        }
                    });
                }
            }
            class du extends null {
                constructor(t, { min: e, max: n, step: o } = {}){
                    super(t);
                    const i = this.bindTemplate;
                    this.set("min", e);
                    this.set("max", n);
                    this.set("step", o);
                    this.extendTemplate({
                        attributes: {
                            type: "number",
                            class: [
                                "ck-input-number"
                            ],
                            min: i.to("min"),
                            max: i.to("max"),
                            step: i.to("step")
                        }
                    });
                }
            }
            var uu = n(5224);
            var hu = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            hu.insert = "head";
            hu.singleton = true;
            var fu = Rl()(uu.Z, hu);
            const pu = uu.Z.locals || {};
            class gu extends null {
                constructor(t){
                    super(t);
                    const e = toUnit("px");
                    this.set("minRows", 2);
                    this.set("maxRows", 5);
                    this.set("_height", null);
                    this.set("resize", "none");
                    this.on("change:minRows", this._validateMinMaxRows.bind(this));
                    this.on("change:maxRows", this._validateMinMaxRows.bind(this));
                    const n = this.bindTemplate;
                    this.template.tag = "textarea";
                    this.extendTemplate({
                        attributes: {
                            class: [
                                "ck-textarea"
                            ],
                            style: {
                                height: n.to("_height", (t)=>t ? e(t) : null),
                                resize: n.to("resize")
                            },
                            rows: n.to("minRows")
                        }
                    });
                }
                render() {
                    super.render();
                    this.on("input", ()=>{
                        this._updateAutoGrowHeight(true);
                        this.fire("update");
                    });
                    this.on("change:value", ()=>{
                        $parcel$global.window.requestAnimationFrame(()=>{
                            this._updateAutoGrowHeight();
                            this.fire("update");
                        });
                    });
                }
                reset() {
                    super.reset();
                    this._updateAutoGrowHeight();
                    this.fire("update");
                }
                _updateAutoGrowHeight(t) {
                    const e = this.element;
                    const n = mu(e, "1");
                    const o = mu(e, e.value);
                    const i = n.ownerDocument.defaultView.getComputedStyle(n);
                    const r = parseFloat(i.paddingTop) + parseFloat(i.paddingBottom);
                    const s = getBorderWidths(n);
                    const a = parseFloat(i.lineHeight);
                    const c = s.top + s.bottom;
                    const l = new Rect(n).height;
                    const d = Math.round((o.scrollHeight - r) / a);
                    const u = this.maxRows * a + r + c;
                    const h = d === 1 ? l : this.minRows * a + r + c;
                    this._height = Math.min(Math.max(Math.max(d, this.minRows) * a + r + c, h), u);
                    if (t) e.scrollTop = e.scrollHeight;
                    n.remove();
                    o.remove();
                }
                _validateMinMaxRows() {
                    if (this.minRows > this.maxRows) throw new CKEditorError("ui-textarea-view-min-rows-greater-than-max-rows", {
                        textareaView: this,
                        minRows: this.minRows,
                        maxRows: this.maxRows
                    });
                }
            }
            function mu(t, e) {
                const n = t.cloneNode();
                n.style.position = "absolute";
                n.style.top = "-99999px";
                n.style.left = "-99999px";
                n.style.height = "auto";
                n.style.overflow = "hidden";
                n.style.width = t.ownerDocument.defaultView.getComputedStyle(t).width;
                n.tabIndex = -1;
                n.rows = 1;
                n.value = e;
                t.parentNode.insertBefore(n, t);
                return n;
            }
            class ku extends zl {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.set("isVisible", false);
                    this.set("position", "se");
                    this.children = this.createCollection();
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-reset",
                                "ck-dropdown__panel",
                                e.to("position", (t)=>`ck-dropdown__panel_${t}`),
                                e.if("isVisible", "ck-dropdown__panel-visible")
                            ],
                            tabindex: "-1"
                        },
                        children: this.children,
                        on: {
                            selectstart: e.to((t)=>{
                                if (t.target.tagName.toLocaleLowerCase() === "input") return;
                                t.preventDefault();
                            })
                        }
                    });
                }
                focus() {
                    if (this.children.length) {
                        const t = this.children.first;
                        if (typeof t.focus === "function") t.focus();
                        else O("ui-dropdown-panel-focus-child-missing-focus", {
                            childView: this.children.first,
                            dropdownPanel: this
                        });
                    }
                }
                focusLast() {
                    if (this.children.length) {
                        const t = this.children.last;
                        if (typeof t.focusLast === "function") t.focusLast();
                        else t.focus();
                    }
                }
            }
            var bu = n(5062);
            var wu = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            wu.insert = "head";
            wu.singleton = true;
            var _u = Rl()(bu.Z, wu);
            const Au = bu.Z.locals || {};
            class vu extends zl {
                constructor(t, e, n){
                    super(t);
                    const o = this.bindTemplate;
                    this.buttonView = e;
                    this.panelView = n;
                    this.set("isOpen", false);
                    this.set("isEnabled", true);
                    this.set("class", undefined);
                    this.set("id", undefined);
                    this.set("panelPosition", "auto");
                    this.keystrokes = new gl;
                    this.focusTracker = new pl;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-dropdown",
                                o.to("class"),
                                o.if("isEnabled", "ck-disabled", (t)=>!t)
                            ],
                            id: o.to("id"),
                            "aria-describedby": o.to("ariaDescribedById")
                        },
                        children: [
                            e,
                            n
                        ]
                    });
                    e.extendTemplate({
                        attributes: {
                            class: [
                                "ck-dropdown__button"
                            ],
                            "data-cke-tooltip-disabled": o.to("isOpen")
                        }
                    });
                }
                render() {
                    super.render();
                    this.focusTracker.add(this.buttonView.element);
                    this.focusTracker.add(this.panelView.element);
                    this.listenTo(this.buttonView, "open", ()=>{
                        this.isOpen = !this.isOpen;
                    });
                    this.panelView.bind("isVisible").to(this, "isOpen");
                    this.on("change:isOpen", (t, e, n)=>{
                        if (!n) return;
                        if (this.panelPosition === "auto") {
                            const t = vu._getOptimalPosition({
                                element: this.panelView.element,
                                target: this.buttonView.element,
                                fitInViewport: true,
                                positions: this._panelPositions
                            });
                            this.panelView.position = t ? t.name : this._panelPositions[0].name;
                        } else this.panelView.position = this.panelPosition;
                    });
                    this.keystrokes.listenTo(this.element);
                    const t = (t, e)=>{
                        if (this.isOpen) {
                            this.isOpen = false;
                            e();
                        }
                    };
                    this.keystrokes.set("arrowdown", (t, e)=>{
                        if (this.buttonView.isEnabled && !this.isOpen) {
                            this.isOpen = true;
                            e();
                        }
                    });
                    this.keystrokes.set("arrowright", (t, e)=>{
                        if (this.isOpen) e();
                    });
                    this.keystrokes.set("arrowleft", t);
                    this.keystrokes.set("esc", t);
                }
                focus() {
                    this.buttonView.focus();
                }
                get _panelPositions() {
                    const { south: t, north: e, southEast: n, southWest: o, northEast: i, northWest: r, southMiddleEast: s, southMiddleWest: a, northMiddleEast: c, northMiddleWest: l } = vu.defaultPanelPositions;
                    if (this.locale.uiLanguageDirection !== "rtl") return [
                        n,
                        o,
                        s,
                        a,
                        t,
                        i,
                        r,
                        c,
                        l,
                        e
                    ];
                    else return [
                        o,
                        n,
                        a,
                        s,
                        t,
                        r,
                        i,
                        l,
                        c,
                        e
                    ];
                }
            }
            vu.defaultPanelPositions = {
                south: (t, e)=>({
                        top: t.bottom,
                        left: t.left - (e.width - t.width) / 2,
                        name: "s"
                    }),
                southEast: (t)=>({
                        top: t.bottom,
                        left: t.left,
                        name: "se"
                    }),
                southWest: (t, e)=>({
                        top: t.bottom,
                        left: t.left - e.width + t.width,
                        name: "sw"
                    }),
                southMiddleEast: (t, e)=>({
                        top: t.bottom,
                        left: t.left - (e.width - t.width) / 4,
                        name: "sme"
                    }),
                southMiddleWest: (t, e)=>({
                        top: t.bottom,
                        left: t.left - (e.width - t.width) * 3 / 4,
                        name: "smw"
                    }),
                north: (t, e)=>({
                        top: t.top - e.height,
                        left: t.left - (e.width - t.width) / 2,
                        name: "n"
                    }),
                northEast: (t, e)=>({
                        top: t.top - e.height,
                        left: t.left,
                        name: "ne"
                    }),
                northWest: (t, e)=>({
                        top: t.top - e.height,
                        left: t.left - e.width + t.width,
                        name: "nw"
                    }),
                northMiddleEast: (t, e)=>({
                        top: t.top - e.height,
                        left: t.left - (e.width - t.width) / 4,
                        name: "nme"
                    }),
                northMiddleWest: (t, e)=>({
                        top: t.top - e.height,
                        left: t.left - (e.width - t.width) * 3 / 4,
                        name: "nmw"
                    })
            };
            vu._getOptimalPosition = xc;
            const Cu = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
            class yu extends yd {
                constructor(t){
                    super(t);
                    this.arrowView = this._createArrowView();
                    this.extendTemplate({
                        attributes: {
                            "aria-haspopup": true,
                            "aria-expanded": this.bindTemplate.to("isOn", (t)=>String(t))
                        }
                    });
                    this.delegate("execute").to(this, "open");
                }
                render() {
                    super.render();
                    this.children.add(this.arrowView);
                }
                _createArrowView() {
                    const t = new bd;
                    t.content = Cu;
                    t.extendTemplate({
                        attributes: {
                            class: "ck-dropdown__arrow"
                        }
                    });
                    return t;
                }
            }
            class xu extends G() {
                constructor(t){
                    super();
                    this.focusables = t.focusables;
                    this.focusTracker = t.focusTracker;
                    this.keystrokeHandler = t.keystrokeHandler;
                    this.actions = t.actions;
                    if (t.actions && t.keystrokeHandler) for(const e in t.actions){
                        let n = t.actions[e];
                        if (typeof n == "string") n = [
                            n
                        ];
                        for (const o of n)t.keystrokeHandler.set(o, (t, n)=>{
                            this[e]();
                            n();
                        });
                    }
                    this.on("forwardCycle", ()=>this.focusFirst(), {
                        priority: "low"
                    });
                    this.on("backwardCycle", ()=>this.focusLast(), {
                        priority: "low"
                    });
                }
                get first() {
                    return this.focusables.find(Eu) || null;
                }
                get last() {
                    return this.focusables.filter(Eu).slice(-1)[0] || null;
                }
                get next() {
                    return this._getFocusableItem(1);
                }
                get previous() {
                    return this._getFocusableItem(-1);
                }
                get current() {
                    let t = null;
                    if (this.focusTracker.focusedElement === null) return null;
                    this.focusables.find((e, n)=>{
                        const o = e.element === this.focusTracker.focusedElement;
                        if (o) t = n;
                        return o;
                    });
                    return t;
                }
                focusFirst() {
                    this._focus(this.first, 1);
                }
                focusLast() {
                    this._focus(this.last, -1);
                }
                focusNext() {
                    const t = this.next;
                    if (t && this.focusables.getIndex(t) === this.current) return;
                    if (t === this.first) this.fire("forwardCycle");
                    else this._focus(t, 1);
                }
                focusPrevious() {
                    const t = this.previous;
                    if (t && this.focusables.getIndex(t) === this.current) return;
                    if (t === this.last) this.fire("backwardCycle");
                    else this._focus(t, -1);
                }
                _focus(t, e) {
                    if (t) t.focus(e);
                }
                _getFocusableItem(t) {
                    const e = this.current;
                    const n = this.focusables.length;
                    if (!n) return null;
                    if (e === null) return this[t === 1 ? "first" : "last"];
                    let o = (e + n + t) % n;
                    do {
                        const e = this.focusables.get(o);
                        if (Eu(e)) return e;
                        o = (o + n + t) % n;
                    }while (o !== e);
                    return null;
                }
            }
            function Eu(t) {
                return !!("focus" in t && yc(t.element));
            }
            class Du extends zl {
                constructor(t){
                    super(t);
                    this.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-toolbar__separator"
                            ]
                        }
                    });
                }
            }
            class Su extends zl {
                constructor(t){
                    super(t);
                    this.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-toolbar__line-break"
                            ]
                        }
                    });
                }
            }
            function Tu(t) {
                return t.bindTemplate.to((e)=>{
                    if (e.target === t.element) e.preventDefault();
                });
            }
            function Bu(t) {
                if (Array.isArray(t)) return {
                    items: t,
                    removeItems: []
                };
                if (!t) return {
                    items: [],
                    removeItems: []
                };
                return Object.assign({
                    items: [],
                    removeItems: []
                }, t);
            }
            class Pu extends ht() {
                constructor(t){
                    super();
                    this._disableStack = new Set;
                    this.editor = t;
                    this.set("isEnabled", true);
                }
                forceDisabled(t) {
                    this._disableStack.add(t);
                    if (this._disableStack.size == 1) {
                        this.on("set:isEnabled", Iu, {
                            priority: "highest"
                        });
                        this.isEnabled = false;
                    }
                }
                clearForceDisabled(t) {
                    this._disableStack.delete(t);
                    if (this._disableStack.size == 0) {
                        this.off("set:isEnabled", Iu);
                        this.isEnabled = true;
                    }
                }
                destroy() {
                    this.stopListening();
                }
                static get isContextPlugin() {
                    return false;
                }
            }
            function Iu(t) {
                t.return = false;
                t.stop();
            }
            class Ru extends ht() {
                constructor(t){
                    super();
                    this.editor = t;
                    this.set("value", undefined);
                    this.set("isEnabled", false);
                    this._affectsData = true;
                    this._isEnabledBasedOnSelection = true;
                    this._disableStack = new Set;
                    this.decorate("execute");
                    this.listenTo(this.editor.model.document, "change", ()=>{
                        this.refresh();
                    });
                    this.listenTo(t, "change:isReadOnly", ()=>{
                        this.refresh();
                    });
                    this.on("set:isEnabled", (e)=>{
                        if (!this.affectsData) return;
                        const n = t.model.document.selection;
                        const o = n.getFirstPosition().root.rootName == "$graveyard";
                        const i = !o && t.model.canEditAt(n);
                        if (t.isReadOnly || this._isEnabledBasedOnSelection && !i) {
                            e.return = false;
                            e.stop();
                        }
                    }, {
                        priority: "highest"
                    });
                    this.on("execute", (t)=>{
                        if (!this.isEnabled) t.stop();
                    }, {
                        priority: "high"
                    });
                }
                get affectsData() {
                    return this._affectsData;
                }
                set affectsData(t) {
                    this._affectsData = t;
                }
                refresh() {
                    this.isEnabled = true;
                }
                forceDisabled(t) {
                    this._disableStack.add(t);
                    if (this._disableStack.size == 1) {
                        this.on("set:isEnabled", Ou, {
                            priority: "highest"
                        });
                        this.isEnabled = false;
                    }
                }
                clearForceDisabled(t) {
                    this._disableStack.delete(t);
                    if (this._disableStack.size == 0) {
                        this.off("set:isEnabled", Ou);
                        this.refresh();
                    }
                }
                execute(...t) {
                    return undefined;
                }
                destroy() {
                    this.stopListening();
                }
            }
            function Ou(t) {
                t.return = false;
                t.stop();
            }
            class Vu extends Ru {
                constructor(){
                    super(...arguments);
                    this._childCommandsDefinitions = [];
                }
                refresh() {}
                execute(...t) {
                    const e = this._getFirstEnabledCommand();
                    return !!e && e.execute(t);
                }
                registerChildCommand(t, e = {}) {
                    P(this._childCommandsDefinitions, {
                        command: t,
                        priority: e.priority || "normal"
                    });
                    t.on("change:isEnabled", ()=>this._checkEnabled());
                    this._checkEnabled();
                }
                _checkEnabled() {
                    this.isEnabled = !!this._getFirstEnabledCommand();
                }
                _getFirstEnabledCommand() {
                    const t = this._childCommandsDefinitions.find(({ command: t })=>t.isEnabled);
                    return t && t.command;
                }
            }
            class Mu extends G() {
                constructor(t, e = [], n = []){
                    super();
                    this._plugins = new Map;
                    this._context = t;
                    this._availablePlugins = new Map;
                    for (const t of e)if (t.pluginName) this._availablePlugins.set(t.pluginName, t);
                    this._contextPlugins = new Map;
                    for (const [t, e] of n){
                        this._contextPlugins.set(t, e);
                        this._contextPlugins.set(e, t);
                        if (t.pluginName) this._availablePlugins.set(t.pluginName, t);
                    }
                }
                *[Symbol.iterator]() {
                    for (const t of this._plugins)if (typeof t[0] == "function") yield t;
                }
                get(t) {
                    const e = this._plugins.get(t);
                    if (!e) {
                        let e = t;
                        if (typeof t == "function") e = t.pluginName || t.name;
                        throw new R("plugincollection-plugin-not-loaded", this._context, {
                            plugin: e
                        });
                    }
                    return e;
                }
                has(t) {
                    return this._plugins.has(t);
                }
                init(t, e = [], n = []) {
                    const o = this;
                    const i = this._context;
                    h(t);
                    p(t);
                    const r = t.filter((t)=>!d(t, e));
                    const s = [
                        ...f(r)
                    ];
                    _(s, n);
                    const a = b(s);
                    return w(a, "init").then(()=>w(a, "afterInit")).then(()=>a);
                    function c(t) {
                        return typeof t === "function";
                    }
                    function l(t) {
                        return c(t) && !!t.isContextPlugin;
                    }
                    function d(t, e) {
                        return e.some((e)=>{
                            if (e === t) return true;
                            if (u(t) === e) return true;
                            if (u(e) === t) return true;
                            return false;
                        });
                    }
                    function u(t) {
                        return c(t) ? t.pluginName || t.name : t;
                    }
                    function h(t, e = new Set) {
                        t.forEach((t)=>{
                            if (!c(t)) return;
                            if (e.has(t)) return;
                            e.add(t);
                            if (t.pluginName && !o._availablePlugins.has(t.pluginName)) o._availablePlugins.set(t.pluginName, t);
                            if (t.requires) h(t.requires, e);
                        });
                    }
                    function f(t, e = new Set) {
                        return t.map((t)=>c(t) ? t : o._availablePlugins.get(t)).reduce((t, n)=>{
                            if (e.has(n)) return t;
                            e.add(n);
                            if (n.requires) {
                                p(n.requires, n);
                                f(n.requires, e).forEach((e)=>t.add(e));
                            }
                            return t.add(n);
                        }, new Set);
                    }
                    function p(t, e = null) {
                        t.map((t)=>c(t) ? t : o._availablePlugins.get(t) || t).forEach((t)=>{
                            g(t, e);
                            m(t, e);
                            k(t, e);
                        });
                    }
                    function g(t, e) {
                        if (c(t)) return;
                        if (e) throw new R("plugincollection-soft-required", i, {
                            missingPlugin: t,
                            requiredBy: u(e)
                        });
                        throw new R("plugincollection-plugin-not-found", i, {
                            plugin: t
                        });
                    }
                    function m(t, e) {
                        if (!l(e)) return;
                        if (l(t)) return;
                        throw new R("plugincollection-context-required", i, {
                            plugin: u(t),
                            requiredBy: u(e)
                        });
                    }
                    function k(t, n) {
                        if (!n) return;
                        if (!d(t, e)) return;
                        throw new R("plugincollection-required", i, {
                            plugin: u(t),
                            requiredBy: u(n)
                        });
                    }
                    function b(t) {
                        return t.map((t)=>{
                            let e = o._contextPlugins.get(t);
                            e = e || new t(i);
                            o._add(t, e);
                            return e;
                        });
                    }
                    function w(t, e) {
                        return t.reduce((t, n)=>{
                            if (!n[e]) return t;
                            if (o._contextPlugins.has(n)) return t;
                            return t.then(n[e].bind(n));
                        }, Promise.resolve());
                    }
                    function _(t, e) {
                        for (const n of e){
                            if (typeof n != "function") throw new R("plugincollection-replace-plugin-invalid-type", null, {
                                pluginItem: n
                            });
                            const e = n.pluginName;
                            if (!e) throw new R("plugincollection-replace-plugin-missing-name", null, {
                                pluginItem: n
                            });
                            if (n.requires && n.requires.length) throw new R("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, {
                                pluginName: e
                            });
                            const i = o._availablePlugins.get(e);
                            if (!i) throw new R("plugincollection-plugin-for-replacing-not-exist", null, {
                                pluginName: e
                            });
                            const r = t.indexOf(i);
                            if (r === -1) {
                                if (o._contextPlugins.has(i)) return;
                                throw new R("plugincollection-plugin-for-replacing-not-loaded", null, {
                                    pluginName: e
                                });
                            }
                            if (i.requires && i.requires.length) throw new R("plugincollection-replaced-plugin-cannot-have-dependencies", null, {
                                pluginName: e
                            });
                            t.splice(r, 1, n);
                            o._availablePlugins.set(e, n);
                        }
                    }
                }
                destroy() {
                    const t = [];
                    for (const [, e] of this)if (typeof e.destroy == "function" && !this._contextPlugins.has(e)) t.push(e.destroy());
                    return Promise.all(t);
                }
                _add(t, e) {
                    this._plugins.set(t, e);
                    const n = t.pluginName;
                    if (!n) return;
                    if (this._plugins.has(n)) throw new R("plugincollection-plugin-name-conflict", null, {
                        pluginName: n,
                        plugin1: this._plugins.get(n).constructor,
                        plugin2: t
                    });
                    this._plugins.set(n, e);
                }
            }
            class Lu {
                constructor(t){
                    this._contextOwner = null;
                    this.config = new Wa(t, this.constructor.defaultConfig);
                    const e = this.constructor.builtinPlugins;
                    this.config.define("plugins", e);
                    this.plugins = new Mu(this, e);
                    const n = this.config.get("language") || {};
                    this.locale = new dl({
                        uiLanguage: typeof n === "string" ? n : n.ui,
                        contentLanguage: this.config.get("language.content")
                    });
                    this.t = this.locale.t;
                    this.editors = new hl;
                }
                initPlugins() {
                    const t = this.config.get("plugins") || [];
                    const e = this.config.get("substitutePlugins") || [];
                    for (const n of t.concat(e)){
                        if (typeof n != "function") throw new R("context-initplugins-constructor-only", null, {
                            Plugin: n
                        });
                        if (n.isContextPlugin !== true) throw new R("context-initplugins-invalid-plugin", null, {
                            Plugin: n
                        });
                    }
                    return this.plugins.init(t, [], e);
                }
                destroy() {
                    return Promise.all(Array.from(this.editors, (t)=>t.destroy())).then(()=>this.plugins.destroy());
                }
                _addEditor(t, e) {
                    if (this._contextOwner) throw new R("context-addeditor-private-context");
                    this.editors.add(t);
                    if (e) this._contextOwner = t;
                }
                _removeEditor(t) {
                    if (this.editors.has(t)) this.editors.remove(t);
                    if (this._contextOwner === t) return this.destroy();
                    return Promise.resolve();
                }
                _getEditorConfig() {
                    const t = {};
                    for (const e of this.config.names())if (![
                        "plugins",
                        "removePlugins",
                        "extraPlugins"
                    ].includes(e)) t[e] = this.config.get(e);
                    return t;
                }
                static create(t) {
                    return new Promise((e)=>{
                        const n = new this(t);
                        e(n.initPlugins().then(()=>n));
                    });
                }
            }
            class zu extends ht() {
                constructor(t){
                    super();
                    this.context = t;
                }
                destroy() {
                    this.stopListening();
                }
                static get isContextPlugin() {
                    return true;
                }
            }
            var Nu = n(7372);
            var Fu = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Fu.insert = "head";
            Fu.singleton = true;
            var Hu = Rl()(Nu.Z, Fu);
            const ju = Nu.Z.locals || {};
            const qu = new WeakMap;
            let Wu = false;
            function $u({ view: t, element: e, text: n, isDirectHost: o = true, keepOnFocus: i = false }) {
                const r = t.document;
                if (!qu.has(r)) {
                    qu.set(r, new Map);
                    r.registerPostFixer((t)=>Ju(r, t));
                    r.on("change:isComposing", ()=>{
                        t.change((t)=>Ju(r, t));
                    }, {
                        priority: "high"
                    });
                }
                if (e.is("editableElement")) e.on("change:placeholder", (t, e, n)=>{
                    s(n);
                });
                if (e.placeholder) s(e.placeholder);
                else if (n) s(n);
                if (n) Xu();
                function s(n) {
                    qu.get(r).set(e, {
                        text: n,
                        isDirectHost: o,
                        keepOnFocus: i,
                        hostElement: o ? e : null
                    });
                    t.change((t)=>Ju(r, t));
                }
            }
            function Gu(t, e) {
                const n = e.document;
                if (!qu.has(n)) return;
                t.change((t)=>{
                    const o = qu.get(n);
                    const i = o.get(e);
                    t.removeAttribute("data-placeholder", i.hostElement);
                    Ku(t, i.hostElement);
                    o.delete(e);
                });
            }
            function Uu(t, e) {
                if (!e.hasClass("ck-placeholder")) {
                    t.addClass("ck-placeholder", e);
                    return true;
                }
                return false;
            }
            function Ku(t, e) {
                if (e.hasClass("ck-placeholder")) {
                    t.removeClass("ck-placeholder", e);
                    return true;
                }
                return false;
            }
            function Zu(t, e) {
                if (!t.isAttached()) return false;
                const n = Array.from(t.getChildren()).some((t)=>!t.is("uiElement"));
                if (n) return false;
                const o = t.document;
                const i = o.selection;
                const r = i.anchor;
                if (o.isComposing && r && r.parent === t) return false;
                if (e) return true;
                if (!o.isFocused) return true;
                return !!r && r.parent !== t;
            }
            function Ju(t, e) {
                const n = qu.get(t);
                const o = [];
                let i = false;
                for (const [t, r] of n)if (r.isDirectHost) {
                    o.push(t);
                    if (Yu(e, t, r)) i = true;
                }
                for (const [t, r] of n){
                    if (r.isDirectHost) continue;
                    const n = Qu(t);
                    if (!n) continue;
                    if (o.includes(n)) continue;
                    r.hostElement = n;
                    if (Yu(e, t, r)) i = true;
                }
                return i;
            }
            function Yu(t, e, n) {
                const { text: o, isDirectHost: i, hostElement: r } = n;
                let s = false;
                if (r.getAttribute("data-placeholder") !== o) {
                    t.setAttribute("data-placeholder", o, r);
                    s = true;
                }
                const a = i || e.childCount == 1;
                if (a && Zu(r, n.keepOnFocus)) {
                    if (Uu(t, r)) s = true;
                } else if (Ku(t, r)) s = true;
                return s;
            }
            function Qu(t) {
                if (t.childCount) {
                    const e = t.getChild(0);
                    if (e.is("element") && !e.is("uiElement") && !e.is("attributeElement")) return e;
                }
                return null;
            }
            function Xu() {
                if (!Wu) O("enableplaceholder-deprecated-text-option");
                Wu = true;
            }
            class th {
                is() {
                    throw new Error("is() method is abstract");
                }
            }
            var eh = 4;
            function nh(t) {
                return La(t, eh);
            }
            const oh = nh;
            class ih extends G(th) {
                constructor(t){
                    super();
                    this.document = t;
                    this.parent = null;
                }
                get index() {
                    let t;
                    if (!this.parent) return null;
                    if ((t = this.parent.getChildIndex(this)) == -1) throw new R("view-node-not-found-in-parent", this);
                    return t;
                }
                get nextSibling() {
                    const t = this.index;
                    return t !== null && this.parent.getChild(t + 1) || null;
                }
                get previousSibling() {
                    const t = this.index;
                    return t !== null && this.parent.getChild(t - 1) || null;
                }
                get root() {
                    let t = this;
                    while(t.parent)t = t.parent;
                    return t;
                }
                isAttached() {
                    return this.root.is("rootElement");
                }
                getPath() {
                    const t = [];
                    let e = this;
                    while(e.parent){
                        t.unshift(e.index);
                        e = e.parent;
                    }
                    return t;
                }
                getAncestors(t = {}) {
                    const e = [];
                    let n = t.includeSelf ? this : this.parent;
                    while(n){
                        e[t.parentFirst ? "push" : "unshift"](n);
                        n = n.parent;
                    }
                    return e;
                }
                getCommonAncestor(t, e = {}) {
                    const n = this.getAncestors(e);
                    const o = t.getAncestors(e);
                    let i = 0;
                    while(n[i] == o[i] && n[i])i++;
                    return i === 0 ? null : n[i - 1];
                }
                isBefore(t) {
                    if (this == t) return false;
                    if (this.root !== t.root) return false;
                    const e = this.getPath();
                    const n = t.getPath();
                    const o = xt(e, n);
                    switch(o){
                        case "prefix":
                            return true;
                        case "extension":
                            return false;
                        default:
                            return e[o] < n[o];
                    }
                }
                isAfter(t) {
                    if (this == t) return false;
                    if (this.root !== t.root) return false;
                    return !this.isBefore(t);
                }
                _remove() {
                    this.parent._removeChildren(this.index);
                }
                _fireChange(t, e) {
                    this.fire(`change:${t}`, e);
                    if (this.parent) this.parent._fireChange(t, e);
                }
                toJSON() {
                    const t = oh(this);
                    delete t.parent;
                    return t;
                }
            }
            ih.prototype.is = function(t) {
                return t === "node" || t === "view:node";
            };
            class rh extends ih {
                constructor(t, e){
                    super(t);
                    this._textData = e;
                }
                get data() {
                    return this._textData;
                }
                get _data() {
                    return this.data;
                }
                set _data(t) {
                    this._fireChange("text", this);
                    this._textData = t;
                }
                isSimilar(t) {
                    if (!(t instanceof rh)) return false;
                    return this === t || this.data === t.data;
                }
                _clone() {
                    return new rh(this.document, this.data);
                }
            }
            rh.prototype.is = function(t) {
                return t === "$text" || t === "view:$text" || t === "text" || t === "view:text" || t === "node" || t === "view:node";
            };
            class sh extends th {
                constructor(t, e, n){
                    super();
                    this.textNode = t;
                    if (e < 0 || e > t.data.length) throw new R("view-textproxy-wrong-offsetintext", this);
                    if (n < 0 || e + n > t.data.length) throw new R("view-textproxy-wrong-length", this);
                    this.data = t.data.substring(e, e + n);
                    this.offsetInText = e;
                }
                get offsetSize() {
                    return this.data.length;
                }
                get isPartial() {
                    return this.data.length !== this.textNode.data.length;
                }
                get parent() {
                    return this.textNode.parent;
                }
                get root() {
                    return this.textNode.root;
                }
                get document() {
                    return this.textNode.document;
                }
                getAncestors(t = {}) {
                    const e = [];
                    let n = t.includeSelf ? this.textNode : this.parent;
                    while(n !== null){
                        e[t.parentFirst ? "push" : "unshift"](n);
                        n = n.parent;
                    }
                    return e;
                }
            }
            sh.prototype.is = function(t) {
                return t === "$textProxy" || t === "view:$textProxy" || t === "textProxy" || t === "view:textProxy";
            };
            class ah {
                constructor(...t){
                    this._patterns = [];
                    this.add(...t);
                }
                add(...t) {
                    for (let e of t){
                        if (typeof e == "string" || e instanceof RegExp) e = {
                            name: e
                        };
                        this._patterns.push(e);
                    }
                }
                match(...t) {
                    for (const e of t)for (const t of this._patterns){
                        const n = ch(e, t);
                        if (n) return {
                            element: e,
                            pattern: t,
                            match: n
                        };
                    }
                    return null;
                }
                matchAll(...t) {
                    const e = [];
                    for (const n of t)for (const t of this._patterns){
                        const o = ch(n, t);
                        if (o) e.push({
                            element: n,
                            pattern: t,
                            match: o
                        });
                    }
                    return e.length > 0 ? e : null;
                }
                getElementName() {
                    if (this._patterns.length !== 1) return null;
                    const t = this._patterns[0];
                    const e = t.name;
                    return typeof t != "function" && e && !(e instanceof RegExp) ? e : null;
                }
            }
            function ch(t, e) {
                if (typeof e == "function") return e(t);
                const n = {};
                if (e.name) {
                    n.name = lh(e.name, t.name);
                    if (!n.name) return null;
                }
                if (e.attributes) {
                    n.attributes = ph(e.attributes, t);
                    if (!n.attributes) return null;
                }
                if (e.classes) {
                    n.classes = gh(e.classes, t);
                    if (!n.classes) return null;
                }
                if (e.styles) {
                    n.styles = mh(e.styles, t);
                    if (!n.styles) return null;
                }
                return n;
            }
            function lh(t, e) {
                if (t instanceof RegExp) return !!e.match(t);
                return t === e;
            }
            function dh(t, e, n) {
                const o = uh(t);
                const i = Array.from(e);
                const r = [];
                o.forEach(([t, e])=>{
                    i.forEach((o)=>{
                        if (hh(t, o) && fh(e, o, n)) r.push(o);
                    });
                });
                if (!o.length || r.length < o.length) return undefined;
                return r;
            }
            function uh(t) {
                if (Array.isArray(t)) return t.map((t)=>{
                    if (pe(t)) {
                        if (t.key === undefined || t.value === undefined) O("matcher-pattern-missing-key-or-value", t);
                        return [
                            t.key,
                            t.value
                        ];
                    }
                    return [
                        t,
                        true
                    ];
                });
                if (pe(t)) return Object.entries(t);
                return [
                    [
                        t,
                        true
                    ]
                ];
            }
            function hh(t, e) {
                return t === true || t === e || t instanceof RegExp && e.match(t);
            }
            function fh(t, e, n) {
                if (t === true) return true;
                const o = n(e);
                return t === o || t instanceof RegExp && !!String(o).match(t);
            }
            function ph(t, e) {
                const n = new Set(e.getAttributeKeys());
                if (pe(t)) {
                    if (t.style !== undefined) O("matcher-pattern-deprecated-attributes-style-key", t);
                    if (t.class !== undefined) O("matcher-pattern-deprecated-attributes-class-key", t);
                } else {
                    n.delete("style");
                    n.delete("class");
                }
                return dh(t, n, (t)=>e.getAttribute(t));
            }
            function gh(t, e) {
                return dh(t, e.getClassNames(), ()=>{});
            }
            function mh(t, e) {
                return dh(t, e.getStyleNames(true), (t)=>e.getStyle(t));
            }
            var kh = "[object Symbol]";
            function bh(t) {
                return typeof t == "symbol" || Qt(t) && Kt(t) == kh;
            }
            const wh = bh;
            var _h = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ah = /^\w*$/;
            function vh(t, e) {
                if (Jt(t)) return false;
                var n = typeof t;
                if (n == "number" || n == "symbol" || n == "boolean" || t == null || wh(t)) return true;
                return Ah.test(t) || !_h.test(t) || e != null && t in Object(e);
            }
            const Ch = vh;
            var yh = "Expected a function";
            function xh(t, e) {
                if (typeof t != "function" || e != null && typeof e != "function") throw new TypeError(yh);
                var n = function() {
                    var o = arguments, i = e ? e.apply(this, o) : o[0], r = n.cache;
                    if (r.has(i)) return r.get(i);
                    var s = t.apply(this, o);
                    n.cache = r.set(i, s) || r;
                    return s;
                };
                n.cache = new (xh.Cache || Xn);
                return n;
            }
            xh.Cache = Xn;
            const Eh = xh;
            var Dh = 500;
            function Sh(t) {
                var e = Eh(t, function(t) {
                    if (n.size === Dh) n.clear();
                    return t;
                });
                var n = e.cache;
                return e;
            }
            const Th = Sh;
            var Bh = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
            var Ph = /\\(\\)?/g;
            var Ih = Th(function(t) {
                var e = [];
                if (t.charCodeAt(0) === 46) e.push("");
                t.replace(Bh, function(t, n, o, i) {
                    e.push(o ? i.replace(Ph, "$1") : n || t);
                });
                return e;
            });
            const Rh = Ih;
            function Oh(t, e) {
                var n = -1, o = t == null ? 0 : t.length, i = Array(o);
                while(++n < o)i[n] = e(t[n], n, t);
                return i;
            }
            const Vh = Oh;
            var Mh = 1 / 0;
            var Lh = Rt ? Rt.prototype : undefined, zh = Lh ? Lh.toString : undefined;
            function Nh(t) {
                if (typeof t == "string") return t;
                if (Jt(t)) return Vh(t, Nh) + "";
                if (wh(t)) return zh ? zh.call(t) : "";
                var e = t + "";
                return e == "0" && 1 / t == -Mh ? "-0" : e;
            }
            const Fh = Nh;
            function Hh(t) {
                return t == null ? "" : Fh(t);
            }
            const jh = Hh;
            function qh(t, e) {
                if (Jt(t)) return t;
                return Ch(t, e) ? [
                    t
                ] : Rh(jh(t));
            }
            const Wh = qh;
            function $h(t) {
                var e = t == null ? 0 : t.length;
                return e ? t[e - 1] : undefined;
            }
            const Gh = $h;
            var Uh = 1 / 0;
            function Kh(t) {
                if (typeof t == "string" || wh(t)) return t;
                var e = t + "";
                return e == "0" && 1 / t == -Uh ? "-0" : e;
            }
            const Zh = Kh;
            function Jh(t, e) {
                e = Wh(e, t);
                var n = 0, o = e.length;
                while(t != null && n < o)t = t[Zh(e[n++])];
                return n && n == o ? t : undefined;
            }
            const Yh = Jh;
            function Qh(t, e, n) {
                var o = -1, i = t.length;
                if (e < 0) e = -e > i ? 0 : i + e;
                n = n > i ? i : n;
                if (n < 0) n += i;
                i = e > n ? 0 : n - e >>> 0;
                e >>>= 0;
                var r = Array(i);
                while(++o < i)r[o] = t[o + e];
                return r;
            }
            const Xh = Qh;
            function tf(t, e) {
                return e.length < 2 ? t : Yh(t, Xh(e, 0, -1));
            }
            const ef = tf;
            function nf(t, e) {
                e = Wh(e, t);
                t = ef(t, e);
                return t == null || delete t[Zh(Gh(e))];
            }
            const of = nf;
            function rf(t, e) {
                return t == null ? true : of(t, e);
            }
            const sf = rf;
            function af(t, e, n) {
                var o = t == null ? undefined : Yh(t, e);
                return o === undefined ? n : o;
            }
            const cf = af;
            function lf(t, e, n) {
                if (n !== undefined && !be(t[e], n) || n === undefined && !(e in t)) uo(t, e, n);
            }
            const df = lf;
            function uf(t) {
                return function(e, n, o) {
                    var i = -1, r = Object(e), s = o(e), a = s.length;
                    while(a--){
                        var c = s[t ? a : ++i];
                        if (n(r[c], c, r) === false) break;
                    }
                    return e;
                };
            }
            const hf = uf;
            var ff = hf();
            const pf = ff;
            function gf(t) {
                return Qt(t) && ji(t);
            }
            const mf = gf;
            function kf(t, e) {
                if (e === "constructor" && typeof t[e] === "function") return;
                if (e == "__proto__") return;
                return t[e];
            }
            const bf = kf;
            function wf(t) {
                return ko(t, tr(t));
            }
            const _f = wf;
            function Af(t, e, n, o, i, r, s) {
                var a = bf(t, n), c = bf(e, n), l = s.get(c);
                if (l) {
                    df(t, n, l);
                    return;
                }
                var d = r ? r(a, c, n + "", t, e, s) : undefined;
                var u = d === undefined;
                if (u) {
                    var h = Jt(c), f = !h && Mo(c), p = !h && !f && Di(c);
                    d = c;
                    if (h || f || p) {
                        if (Jt(a)) d = a;
                        else if (mf(a)) d = ur(a);
                        else if (f) {
                            u = false;
                            d = lr(c, true);
                        } else if (p) {
                            u = false;
                            d = As(c, true);
                        } else d = [];
                    } else if (pe(c) || Do(c)) {
                        d = a;
                        if (Do(a)) d = _f(a);
                        else if (!rt(a) || Ge(a)) d = Us(c);
                    } else u = false;
                }
                if (u) {
                    s.set(c, d);
                    i(d, c, o, r, s);
                    s["delete"](c);
                }
                df(t, n, d);
            }
            const vf = Af;
            function Cf(t, e, n, o, i) {
                if (t === e) return;
                pf(e, function(r, s) {
                    i || (i = new io);
                    if (rt(r)) vf(t, e, s, n, Cf, o, i);
                    else {
                        var a = o ? o(bf(t, s), r, s + "", t, e, i) : undefined;
                        if (a === undefined) a = r;
                        df(t, s, a);
                    }
                }, tr);
            }
            const yf = Cf;
            function xf(t) {
                return t;
            }
            const Ef = xf;
            function Df(t, e, n) {
                switch(n.length){
                    case 0:
                        return t.call(e);
                    case 1:
                        return t.call(e, n[0]);
                    case 2:
                        return t.call(e, n[0], n[1]);
                    case 3:
                        return t.call(e, n[0], n[1], n[2]);
                }
                return t.apply(e, n);
            }
            const Sf = Df;
            var Tf = Math.max;
            function Bf(t, e, n) {
                e = Tf(e === undefined ? t.length - 1 : e, 0);
                return function() {
                    var o = arguments, i = -1, r = Tf(o.length - e, 0), s = Array(r);
                    while(++i < r)s[i] = o[e + i];
                    i = -1;
                    var a = Array(e + 1);
                    while(++i < e)a[i] = o[i];
                    a[e] = n(s);
                    return Sf(t, this, a);
                };
            }
            const Pf = Bf;
            function If(t) {
                return function() {
                    return t;
                };
            }
            const Rf = If;
            var Of = !co ? Ef : function(t, e) {
                return co(t, "toString", {
                    configurable: true,
                    enumerable: false,
                    value: Rf(e),
                    writable: true
                });
            };
            const Vf = Of;
            var Mf = 800, Lf = 16;
            var zf = Date.now;
            function Nf(t) {
                var e = 0, n = 0;
                return function() {
                    var o = zf(), i = Lf - (o - n);
                    n = o;
                    if (i > 0) {
                        if (++e >= Mf) return arguments[0];
                    } else e = 0;
                    return t.apply(undefined, arguments);
                };
            }
            const Ff = Nf;
            var Hf = Ff(Vf);
            const jf = Hf;
            function qf(t, e) {
                return jf(Pf(t, e, Ef), t + "");
            }
            const Wf = qf;
            function $f(t, e, n) {
                if (!rt(n)) return false;
                var o = typeof e;
                if (o == "number" ? ji(n) && Fo(e, n.length) : o == "string" && e in n) return be(n[e], t);
                return false;
            }
            const Gf = $f;
            function Uf(t) {
                return Wf(function(e, n) {
                    var o = -1, i = n.length, r = i > 1 ? n[i - 1] : undefined, s = i > 2 ? n[2] : undefined;
                    r = t.length > 3 && typeof r == "function" ? (i--, r) : undefined;
                    if (s && Gf(n[0], n[1], s)) {
                        r = i < 3 ? undefined : r;
                        i = 1;
                    }
                    e = Object(e);
                    while(++o < i){
                        var a = n[o];
                        if (a) t(e, a, o, r);
                    }
                    return e;
                });
            }
            const Kf = Uf;
            var Zf = Kf(function(t, e, n) {
                yf(t, e, n);
            });
            const Jf = Zf;
            function Yf(t, e, n, o) {
                if (!rt(t)) return t;
                e = Wh(e, t);
                var i = -1, r = e.length, s = r - 1, a = t;
                while(a != null && ++i < r){
                    var c = Zh(e[i]), l = n;
                    if (c === "__proto__" || c === "constructor" || c === "prototype") return t;
                    if (i != s) {
                        var d = a[c];
                        l = o ? o(d, c, a) : undefined;
                        if (l === undefined) l = rt(d) ? d : Fo(e[i + 1]) ? [] : {};
                    }
                    go(a, c, l);
                    a = a[c];
                }
                return t;
            }
            const Qf = Yf;
            function Xf(t, e, n) {
                return t == null ? t : Qf(t, e, n);
            }
            const tp = Xf;
            class ep {
                constructor(t){
                    this._styles = {};
                    this._styleProcessor = t;
                }
                get isEmpty() {
                    const t = Object.entries(this._styles);
                    const e = Array.from(t);
                    return !e.length;
                }
                get size() {
                    if (this.isEmpty) return 0;
                    return this.getStyleNames().length;
                }
                setTo(t) {
                    this.clear();
                    const e = Array.from(op(t).entries());
                    for (const [t, n] of e)this._styleProcessor.toNormalizedForm(t, n, this._styles);
                }
                has(t) {
                    if (this.isEmpty) return false;
                    const e = this._styleProcessor.getReducedForm(t, this._styles);
                    const n = e.find(([e])=>e === t);
                    return Array.isArray(n);
                }
                set(t, e) {
                    if (rt(t)) for (const [e, n] of Object.entries(t))this._styleProcessor.toNormalizedForm(e, n, this._styles);
                    else this._styleProcessor.toNormalizedForm(t, e, this._styles);
                }
                remove(t) {
                    const e = ip(t);
                    sf(this._styles, e);
                    delete this._styles[t];
                    this._cleanEmptyObjectsOnPath(e);
                }
                getNormalized(t) {
                    return this._styleProcessor.getNormalized(t, this._styles);
                }
                toString() {
                    if (this.isEmpty) return "";
                    return this._getStylesEntries().map((t)=>t.join(":")).sort().join(";") + ";";
                }
                getAsString(t) {
                    if (this.isEmpty) return;
                    if (this._styles[t] && !rt(this._styles[t])) return this._styles[t];
                    const e = this._styleProcessor.getReducedForm(t, this._styles);
                    const n = e.find(([e])=>e === t);
                    if (Array.isArray(n)) return n[1];
                }
                getStyleNames(t = false) {
                    if (this.isEmpty) return [];
                    if (t) return this._styleProcessor.getStyleNames(this._styles);
                    const e = this._getStylesEntries();
                    return e.map(([t])=>t);
                }
                clear() {
                    this._styles = {};
                }
                _getStylesEntries() {
                    const t = [];
                    const e = Object.keys(this._styles);
                    for (const n of e)t.push(...this._styleProcessor.getReducedForm(n, this._styles));
                    return t;
                }
                _cleanEmptyObjectsOnPath(t) {
                    const e = t.split(".");
                    const n = e.length > 1;
                    if (!n) return;
                    const o = e.splice(0, e.length - 1).join(".");
                    const i = cf(this._styles, o);
                    if (!i) return;
                    const r = !Array.from(Object.keys(i)).length;
                    if (r) this.remove(o);
                }
            }
            class np {
                constructor(){
                    this._normalizers = new Map;
                    this._extractors = new Map;
                    this._reducers = new Map;
                    this._consumables = new Map;
                }
                toNormalizedForm(t, e, n) {
                    if (rt(e)) {
                        rp(n, ip(t), e);
                        return;
                    }
                    if (this._normalizers.has(t)) {
                        const o = this._normalizers.get(t);
                        const { path: i, value: r } = o(e);
                        rp(n, i, r);
                    } else rp(n, t, e);
                }
                getNormalized(t, e) {
                    if (!t) return Jf({}, e);
                    if (e[t] !== undefined) return e[t];
                    if (this._extractors.has(t)) {
                        const n = this._extractors.get(t);
                        if (typeof n === "string") return cf(e, n);
                        const o = n(t, e);
                        if (o) return o;
                    }
                    return cf(e, ip(t));
                }
                getReducedForm(t, e) {
                    const n = this.getNormalized(t, e);
                    if (n === undefined) return [];
                    if (this._reducers.has(t)) {
                        const e = this._reducers.get(t);
                        return e(n);
                    }
                    return [
                        [
                            t,
                            n
                        ]
                    ];
                }
                getStyleNames(t) {
                    const e = Array.from(this._consumables.keys()).filter((e)=>{
                        const n = this.getNormalized(e, t);
                        if (n && typeof n == "object") return Object.keys(n).length;
                        return n;
                    });
                    const n = new Set([
                        ...e,
                        ...Object.keys(t)
                    ]);
                    return Array.from(n.values());
                }
                getRelatedStyles(t) {
                    return this._consumables.get(t) || [];
                }
                setNormalizer(t, e) {
                    this._normalizers.set(t, e);
                }
                setExtractor(t, e) {
                    this._extractors.set(t, e);
                }
                setReducer(t, e) {
                    this._reducers.set(t, e);
                }
                setStyleRelation(t, e) {
                    this._mapStyleNames(t, e);
                    for (const n of e)this._mapStyleNames(n, [
                        t
                    ]);
                }
                _mapStyleNames(t, e) {
                    if (!this._consumables.has(t)) this._consumables.set(t, []);
                    this._consumables.get(t).push(...e);
                }
            }
            function op(t) {
                let e = null;
                let n = 0;
                let o = 0;
                let i = null;
                const r = new Map;
                if (t === "") return r;
                if (t.charAt(t.length - 1) != ";") t = t + ";";
                for(let s = 0; s < t.length; s++){
                    const a = t.charAt(s);
                    if (e === null) switch(a){
                        case ":":
                            if (!i) {
                                i = t.substr(n, s - n);
                                o = s + 1;
                            }
                            break;
                        case '"':
                        case "'":
                            e = a;
                            break;
                        case ";":
                            {
                                const e = t.substr(o, s - o);
                                if (i) r.set(i.trim(), e.trim());
                                i = null;
                                n = s + 1;
                                break;
                            }
                    }
                    else if (a === e) e = null;
                }
                return r;
            }
            function ip(t) {
                return t.replace("-", ".");
            }
            function rp(t, e, n) {
                let o = n;
                if (rt(n)) o = Jf({}, cf(t, e), n);
                tp(t, e, o);
            }
            class sp extends ih {
                constructor(t, e, n, o){
                    super(t);
                    this._unsafeAttributesToRender = [];
                    this._customProperties = new Map;
                    this.name = e;
                    this._attrs = ap(n);
                    this._children = [];
                    if (o) this._insertChild(0, o);
                    this._classes = new Set;
                    if (this._attrs.has("class")) {
                        const t = this._attrs.get("class");
                        cp(this._classes, t);
                        this._attrs.delete("class");
                    }
                    this._styles = new ep(this.document.stylesProcessor);
                    if (this._attrs.has("style")) {
                        this._styles.setTo(this._attrs.get("style"));
                        this._attrs.delete("style");
                    }
                }
                get childCount() {
                    return this._children.length;
                }
                get isEmpty() {
                    return this._children.length === 0;
                }
                getChild(t) {
                    return this._children[t];
                }
                getChildIndex(t) {
                    return this._children.indexOf(t);
                }
                getChildren() {
                    return this._children[Symbol.iterator]();
                }
                *getAttributeKeys() {
                    if (this._classes.size > 0) yield "class";
                    if (!this._styles.isEmpty) yield "style";
                    yield* this._attrs.keys();
                }
                *getAttributes() {
                    yield* this._attrs.entries();
                    if (this._classes.size > 0) yield [
                        "class",
                        this.getAttribute("class")
                    ];
                    if (!this._styles.isEmpty) yield [
                        "style",
                        this.getAttribute("style")
                    ];
                }
                getAttribute(t) {
                    if (t == "class") {
                        if (this._classes.size > 0) return [
                            ...this._classes
                        ].join(" ");
                        return undefined;
                    }
                    if (t == "style") {
                        const t = this._styles.toString();
                        return t == "" ? undefined : t;
                    }
                    return this._attrs.get(t);
                }
                hasAttribute(t) {
                    if (t == "class") return this._classes.size > 0;
                    if (t == "style") return !this._styles.isEmpty;
                    return this._attrs.has(t);
                }
                isSimilar(t) {
                    if (!(t instanceof sp)) return false;
                    if (this === t) return true;
                    if (this.name != t.name) return false;
                    if (this._attrs.size !== t._attrs.size || this._classes.size !== t._classes.size || this._styles.size !== t._styles.size) return false;
                    for (const [e, n] of this._attrs){
                        if (!t._attrs.has(e) || t._attrs.get(e) !== n) return false;
                    }
                    for (const e of this._classes){
                        if (!t._classes.has(e)) return false;
                    }
                    for (const e of this._styles.getStyleNames()){
                        if (!t._styles.has(e) || t._styles.getAsString(e) !== this._styles.getAsString(e)) return false;
                    }
                    return true;
                }
                hasClass(...t) {
                    for (const e of t){
                        if (!this._classes.has(e)) return false;
                    }
                    return true;
                }
                getClassNames() {
                    return this._classes.keys();
                }
                getStyle(t) {
                    return this._styles.getAsString(t);
                }
                getNormalizedStyle(t) {
                    return this._styles.getNormalized(t);
                }
                getStyleNames(t) {
                    return this._styles.getStyleNames(t);
                }
                hasStyle(...t) {
                    for (const e of t){
                        if (!this._styles.has(e)) return false;
                    }
                    return true;
                }
                findAncestor(...t) {
                    const e = new ah(...t);
                    let n = this.parent;
                    while(n && !n.is("documentFragment")){
                        if (e.match(n)) return n;
                        n = n.parent;
                    }
                    return null;
                }
                getCustomProperty(t) {
                    return this._customProperties.get(t);
                }
                *getCustomProperties() {
                    yield* this._customProperties.entries();
                }
                getIdentity() {
                    const t = Array.from(this._classes).sort().join(",");
                    const e = this._styles.toString();
                    const n = Array.from(this._attrs).map((t)=>`${t[0]}="${t[1]}"`).sort().join(" ");
                    return this.name + (t == "" ? "" : ` class="${t}"`) + (!e ? "" : ` style="${e}"`) + (n == "" ? "" : ` ${n}`);
                }
                shouldRenderUnsafeAttribute(t) {
                    return this._unsafeAttributesToRender.includes(t);
                }
                _clone(t = false) {
                    const e = [];
                    if (t) for (const n of this.getChildren())e.push(n._clone(t));
                    const n = new this.constructor(this.document, this.name, this._attrs, e);
                    n._classes = new Set(this._classes);
                    n._styles.set(this._styles.getNormalized());
                    n._customProperties = new Map(this._customProperties);
                    n.getFillerOffset = this.getFillerOffset;
                    n._unsafeAttributesToRender = this._unsafeAttributesToRender;
                    return n;
                }
                _appendChild(t) {
                    return this._insertChild(this.childCount, t);
                }
                _insertChild(t, e) {
                    this._fireChange("children", this);
                    let n = 0;
                    const o = lp(this.document, e);
                    for (const e of o){
                        if (e.parent !== null) e._remove();
                        e.parent = this;
                        e.document = this.document;
                        this._children.splice(t, 0, e);
                        t++;
                        n++;
                    }
                    return n;
                }
                _removeChildren(t, e = 1) {
                    this._fireChange("children", this);
                    for(let n = t; n < t + e; n++)this._children[n].parent = null;
                    return this._children.splice(t, e);
                }
                _setAttribute(t, e) {
                    const n = String(e);
                    this._fireChange("attributes", this);
                    if (t == "class") cp(this._classes, n);
                    else if (t == "style") this._styles.setTo(n);
                    else this._attrs.set(t, n);
                }
                _removeAttribute(t) {
                    this._fireChange("attributes", this);
                    if (t == "class") {
                        if (this._classes.size > 0) {
                            this._classes.clear();
                            return true;
                        }
                        return false;
                    }
                    if (t == "style") {
                        if (!this._styles.isEmpty) {
                            this._styles.clear();
                            return true;
                        }
                        return false;
                    }
                    return this._attrs.delete(t);
                }
                _addClass(t) {
                    this._fireChange("attributes", this);
                    for (const e of nl(t))this._classes.add(e);
                }
                _removeClass(t) {
                    this._fireChange("attributes", this);
                    for (const e of nl(t))this._classes.delete(e);
                }
                _setStyle(t, e) {
                    this._fireChange("attributes", this);
                    if (typeof t != "string") this._styles.set(t);
                    else this._styles.set(t, e);
                }
                _removeStyle(t) {
                    this._fireChange("attributes", this);
                    for (const e of nl(t))this._styles.remove(e);
                }
                _setCustomProperty(t, e) {
                    this._customProperties.set(t, e);
                }
                _removeCustomProperty(t) {
                    return this._customProperties.delete(t);
                }
            }
            sp.prototype.is = function(t, e) {
                if (!e) return t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "element" || t === "view:element");
            };
            function ap(t) {
                const e = kl(t);
                for (const [t, n] of e){
                    if (n === null) e.delete(t);
                    else if (typeof n != "string") e.set(t, String(n));
                }
                return e;
            }
            function cp(t, e) {
                const n = e.split(/\s+/);
                t.clear();
                n.forEach((e)=>t.add(e));
            }
            function lp(t, e) {
                if (typeof e == "string") return [
                    new rh(t, e)
                ];
                if (!Et(e)) e = [
                    e
                ];
                return Array.from(e).map((e)=>{
                    if (typeof e == "string") return new rh(t, e);
                    if (e instanceof sh) return new rh(t, e.data);
                    return e;
                });
            }
            class dp extends sp {
                constructor(t, e, n, o){
                    super(t, e, n, o);
                    this.getFillerOffset = up;
                }
            }
            dp.prototype.is = function(t, e) {
                if (!e) return t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
            };
            function up() {
                const t = [
                    ...this.getChildren()
                ];
                const e = t[this.childCount - 1];
                if (e && e.is("element", "br")) return this.childCount;
                for (const e of t){
                    if (!e.is("uiElement")) return null;
                }
                return this.childCount;
            }
            class hp extends ht(dp) {
                constructor(t, e, n, o){
                    super(t, e, n, o);
                    this.set("isReadOnly", false);
                    this.set("isFocused", false);
                    this.set("placeholder", undefined);
                    this.bind("isReadOnly").to(t);
                    this.bind("isFocused").to(t, "isFocused", (e)=>e && t.selection.editableElement == this);
                    this.listenTo(t.selection, "change", ()=>{
                        this.isFocused = t.isFocused && t.selection.editableElement == this;
                    });
                }
                destroy() {
                    this.stopListening();
                }
            }
            hp.prototype.is = function(t, e) {
                if (!e) return t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
            };
            const fp = Symbol("rootName");
            class pp extends hp {
                constructor(t, e){
                    super(t, e);
                    this.rootName = "main";
                }
                get rootName() {
                    return this.getCustomProperty(fp);
                }
                set rootName(t) {
                    this._setCustomProperty(fp, t);
                }
                set _name(t) {
                    this.name = t;
                }
            }
            pp.prototype.is = function(t, e) {
                if (!e) return t === "rootElement" || t === "view:rootElement" || t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "rootElement" || t === "view:rootElement" || t === "editableElement" || t === "view:editableElement" || t === "containerElement" || t === "view:containerElement" || t === "element" || t === "view:element");
            };
            class gp {
                constructor(t = {}){
                    if (!t.boundaries && !t.startPosition) throw new R("view-tree-walker-no-start-position", null);
                    if (t.direction && t.direction != "forward" && t.direction != "backward") throw new R("view-tree-walker-unknown-direction", t.startPosition, {
                        direction: t.direction
                    });
                    this.boundaries = t.boundaries || null;
                    if (t.startPosition) this._position = mp._createAt(t.startPosition);
                    else this._position = mp._createAt(t.boundaries[t.direction == "backward" ? "end" : "start"]);
                    this.direction = t.direction || "forward";
                    this.singleCharacters = !!t.singleCharacters;
                    this.shallow = !!t.shallow;
                    this.ignoreElementEnd = !!t.ignoreElementEnd;
                    this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null;
                    this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
                }
                [Symbol.iterator]() {
                    return this;
                }
                get position() {
                    return this._position;
                }
                skip(t) {
                    let e;
                    let n;
                    do {
                        n = this.position;
                        e = this.next();
                    }while (!e.done && t(e.value));
                    if (!e.done) this._position = n;
                }
                next() {
                    if (this.direction == "forward") return this._next();
                    else return this._previous();
                }
                _next() {
                    let t = this.position.clone();
                    const e = this.position;
                    const n = t.parent;
                    if (n.parent === null && t.offset === n.childCount) return {
                        done: true,
                        value: undefined
                    };
                    if (n === this._boundaryEndParent && t.offset == this.boundaries.end.offset) return {
                        done: true,
                        value: undefined
                    };
                    let o;
                    if (n instanceof rh) {
                        if (t.isAtEnd) {
                            this._position = mp._createAfter(n);
                            return this._next();
                        }
                        o = n.data[t.offset];
                    } else o = n.getChild(t.offset);
                    if (o instanceof sp) {
                        if (!this.shallow) t = new mp(o, 0);
                        else {
                            if (this.boundaries && this.boundaries.end.isBefore(t)) return {
                                done: true,
                                value: undefined
                            };
                            t.offset++;
                        }
                        this._position = t;
                        return this._formatReturnValue("elementStart", o, e, t, 1);
                    }
                    if (o instanceof rh) {
                        if (this.singleCharacters) {
                            t = new mp(o, 0);
                            this._position = t;
                            return this._next();
                        }
                        let n = o.data.length;
                        let i;
                        if (o == this._boundaryEndParent) {
                            n = this.boundaries.end.offset;
                            i = new sh(o, 0, n);
                            t = mp._createAfter(i);
                        } else {
                            i = new sh(o, 0, o.data.length);
                            t.offset++;
                        }
                        this._position = t;
                        return this._formatReturnValue("text", i, e, t, n);
                    }
                    if (typeof o == "string") {
                        let o;
                        if (this.singleCharacters) o = 1;
                        else {
                            const e = n === this._boundaryEndParent ? this.boundaries.end.offset : n.data.length;
                            o = e - t.offset;
                        }
                        const i = new sh(n, t.offset, o);
                        t.offset += o;
                        this._position = t;
                        return this._formatReturnValue("text", i, e, t, o);
                    }
                    t = mp._createAfter(n);
                    this._position = t;
                    if (this.ignoreElementEnd) return this._next();
                    return this._formatReturnValue("elementEnd", n, e, t);
                }
                _previous() {
                    let t = this.position.clone();
                    const e = this.position;
                    const n = t.parent;
                    if (n.parent === null && t.offset === 0) return {
                        done: true,
                        value: undefined
                    };
                    if (n == this._boundaryStartParent && t.offset == this.boundaries.start.offset) return {
                        done: true,
                        value: undefined
                    };
                    let o;
                    if (n instanceof rh) {
                        if (t.isAtStart) {
                            this._position = mp._createBefore(n);
                            return this._previous();
                        }
                        o = n.data[t.offset - 1];
                    } else o = n.getChild(t.offset - 1);
                    if (o instanceof sp) {
                        if (this.shallow) {
                            t.offset--;
                            this._position = t;
                            return this._formatReturnValue("elementStart", o, e, t, 1);
                        }
                        t = new mp(o, o.childCount);
                        this._position = t;
                        if (this.ignoreElementEnd) return this._previous();
                        return this._formatReturnValue("elementEnd", o, e, t);
                    }
                    if (o instanceof rh) {
                        if (this.singleCharacters) {
                            t = new mp(o, o.data.length);
                            this._position = t;
                            return this._previous();
                        }
                        let n = o.data.length;
                        let i;
                        if (o == this._boundaryStartParent) {
                            const e = this.boundaries.start.offset;
                            i = new sh(o, e, o.data.length - e);
                            n = i.data.length;
                            t = mp._createBefore(i);
                        } else {
                            i = new sh(o, 0, o.data.length);
                            t.offset--;
                        }
                        this._position = t;
                        return this._formatReturnValue("text", i, e, t, n);
                    }
                    if (typeof o == "string") {
                        let o;
                        if (!this.singleCharacters) {
                            const e = n === this._boundaryStartParent ? this.boundaries.start.offset : 0;
                            o = t.offset - e;
                        } else o = 1;
                        t.offset -= o;
                        const i = new sh(n, t.offset, o);
                        this._position = t;
                        return this._formatReturnValue("text", i, e, t, o);
                    }
                    t = mp._createBefore(n);
                    this._position = t;
                    return this._formatReturnValue("elementStart", n, e, t, 1);
                }
                _formatReturnValue(t, e, n, o, i) {
                    if (e instanceof sh) {
                        if (e.offsetInText + e.data.length == e.textNode.data.length) {
                            if (this.direction == "forward" && !(this.boundaries && this.boundaries.end.isEqual(this.position))) {
                                o = mp._createAfter(e.textNode);
                                this._position = o;
                            } else n = mp._createAfter(e.textNode);
                        }
                        if (e.offsetInText === 0) {
                            if (this.direction == "backward" && !(this.boundaries && this.boundaries.start.isEqual(this.position))) {
                                o = mp._createBefore(e.textNode);
                                this._position = o;
                            } else n = mp._createBefore(e.textNode);
                        }
                    }
                    return {
                        done: false,
                        value: {
                            type: t,
                            item: e,
                            previousPosition: n,
                            nextPosition: o,
                            length: i
                        }
                    };
                }
            }
            class mp extends th {
                constructor(t, e){
                    super();
                    this.parent = t;
                    this.offset = e;
                }
                get nodeAfter() {
                    if (this.parent.is("$text")) return null;
                    return this.parent.getChild(this.offset) || null;
                }
                get nodeBefore() {
                    if (this.parent.is("$text")) return null;
                    return this.parent.getChild(this.offset - 1) || null;
                }
                get isAtStart() {
                    return this.offset === 0;
                }
                get isAtEnd() {
                    const t = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
                    return this.offset === t;
                }
                get root() {
                    return this.parent.root;
                }
                get editableElement() {
                    let t = this.parent;
                    while(!(t instanceof hp)){
                        if (t.parent) t = t.parent;
                        else return null;
                    }
                    return t;
                }
                getShiftedBy(t) {
                    const e = mp._createAt(this);
                    const n = e.offset + t;
                    e.offset = n < 0 ? 0 : n;
                    return e;
                }
                getLastMatchingPosition(t, e = {}) {
                    e.startPosition = this;
                    const n = new gp(e);
                    n.skip(t);
                    return n.position;
                }
                getAncestors() {
                    if (this.parent.is("documentFragment")) return [
                        this.parent
                    ];
                    else return this.parent.getAncestors({
                        includeSelf: true
                    });
                }
                getCommonAncestor(t) {
                    const e = this.getAncestors();
                    const n = t.getAncestors();
                    let o = 0;
                    while(e[o] == n[o] && e[o])o++;
                    return o === 0 ? null : e[o - 1];
                }
                isEqual(t) {
                    return this.parent == t.parent && this.offset == t.offset;
                }
                isBefore(t) {
                    return this.compareWith(t) == "before";
                }
                isAfter(t) {
                    return this.compareWith(t) == "after";
                }
                compareWith(t) {
                    if (this.root !== t.root) return "different";
                    if (this.isEqual(t)) return "same";
                    const e = this.parent.is("node") ? this.parent.getPath() : [];
                    const n = t.parent.is("node") ? t.parent.getPath() : [];
                    e.push(this.offset);
                    n.push(t.offset);
                    const o = xt(e, n);
                    switch(o){
                        case "prefix":
                            return "before";
                        case "extension":
                            return "after";
                        default:
                            return e[o] < n[o] ? "before" : "after";
                    }
                }
                getWalker(t = {}) {
                    t.startPosition = this;
                    return new gp(t);
                }
                clone() {
                    return new mp(this.parent, this.offset);
                }
                static _createAt(t, e) {
                    if (t instanceof mp) return new this(t.parent, t.offset);
                    else {
                        const n = t;
                        if (e == "end") e = n.is("$text") ? n.data.length : n.childCount;
                        else if (e == "before") return this._createBefore(n);
                        else if (e == "after") return this._createAfter(n);
                        else if (e !== 0 && !e) throw new R("view-createpositionat-offset-required", n);
                        return new mp(n, e);
                    }
                }
                static _createAfter(t) {
                    if (t.is("$textProxy")) return new mp(t.textNode, t.offsetInText + t.data.length);
                    if (!t.parent) throw new R("view-position-after-root", t, {
                        root: t
                    });
                    return new mp(t.parent, t.index + 1);
                }
                static _createBefore(t) {
                    if (t.is("$textProxy")) return new mp(t.textNode, t.offsetInText);
                    if (!t.parent) throw new R("view-position-before-root", t, {
                        root: t
                    });
                    return new mp(t.parent, t.index);
                }
            }
            mp.prototype.is = function(t) {
                return t === "position" || t === "view:position";
            };
            class kp extends th {
                constructor(t, e = null){
                    super();
                    this.start = t.clone();
                    this.end = e ? e.clone() : t.clone();
                }
                *[Symbol.iterator]() {
                    yield* new gp({
                        boundaries: this,
                        ignoreElementEnd: true
                    });
                }
                get isCollapsed() {
                    return this.start.isEqual(this.end);
                }
                get isFlat() {
                    return this.start.parent === this.end.parent;
                }
                get root() {
                    return this.start.root;
                }
                getEnlarged() {
                    let t = this.start.getLastMatchingPosition(bp, {
                        direction: "backward"
                    });
                    let e = this.end.getLastMatchingPosition(bp);
                    if (t.parent.is("$text") && t.isAtStart) t = mp._createBefore(t.parent);
                    if (e.parent.is("$text") && e.isAtEnd) e = mp._createAfter(e.parent);
                    return new kp(t, e);
                }
                getTrimmed() {
                    let t = this.start.getLastMatchingPosition(bp);
                    if (t.isAfter(this.end) || t.isEqual(this.end)) return new kp(t, t);
                    let e = this.end.getLastMatchingPosition(bp, {
                        direction: "backward"
                    });
                    const n = t.nodeAfter;
                    const o = e.nodeBefore;
                    if (n && n.is("$text")) t = new mp(n, 0);
                    if (o && o.is("$text")) e = new mp(o, o.data.length);
                    return new kp(t, e);
                }
                isEqual(t) {
                    return this == t || this.start.isEqual(t.start) && this.end.isEqual(t.end);
                }
                containsPosition(t) {
                    return t.isAfter(this.start) && t.isBefore(this.end);
                }
                containsRange(t, e = false) {
                    if (t.isCollapsed) e = false;
                    const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start);
                    const o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
                    return n && o;
                }
                getDifference(t) {
                    const e = [];
                    if (this.isIntersecting(t)) {
                        if (this.containsPosition(t.start)) e.push(new kp(this.start, t.start));
                        if (this.containsPosition(t.end)) e.push(new kp(t.end, this.end));
                    } else e.push(this.clone());
                    return e;
                }
                getIntersection(t) {
                    if (this.isIntersecting(t)) {
                        let e = this.start;
                        let n = this.end;
                        if (this.containsPosition(t.start)) e = t.start;
                        if (this.containsPosition(t.end)) n = t.end;
                        return new kp(e, n);
                    }
                    return null;
                }
                getWalker(t = {}) {
                    t.boundaries = this;
                    return new gp(t);
                }
                getCommonAncestor() {
                    return this.start.getCommonAncestor(this.end);
                }
                getContainedElement() {
                    if (this.isCollapsed) return null;
                    let t = this.start.nodeAfter;
                    let e = this.end.nodeBefore;
                    if (this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling) t = this.start.parent.nextSibling;
                    if (this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling) e = this.end.parent.previousSibling;
                    if (t && t.is("element") && t === e) return t;
                    return null;
                }
                clone() {
                    return new kp(this.start, this.end);
                }
                *getItems(t = {}) {
                    t.boundaries = this;
                    t.ignoreElementEnd = true;
                    const e = new gp(t);
                    for (const t of e)yield t.item;
                }
                *getPositions(t = {}) {
                    t.boundaries = this;
                    const e = new gp(t);
                    yield e.position;
                    for (const t of e)yield t.nextPosition;
                }
                isIntersecting(t) {
                    return this.start.isBefore(t.end) && this.end.isAfter(t.start);
                }
                static _createFromParentsAndOffsets(t, e, n, o) {
                    return new this(new mp(t, e), new mp(n, o));
                }
                static _createFromPositionAndShift(t, e) {
                    const n = t;
                    const o = t.getShiftedBy(e);
                    return e > 0 ? new this(n, o) : new this(o, n);
                }
                static _createIn(t) {
                    return this._createFromParentsAndOffsets(t, 0, t, t.childCount);
                }
                static _createOn(t) {
                    const e = t.is("$textProxy") ? t.offsetSize : 1;
                    return this._createFromPositionAndShift(mp._createBefore(t), e);
                }
            }
            kp.prototype.is = function(t) {
                return t === "range" || t === "view:range";
            };
            function bp(t) {
                if (t.item.is("attributeElement") || t.item.is("uiElement")) return true;
                return false;
            }
            class wp extends G(th) {
                constructor(...t){
                    super();
                    this._ranges = [];
                    this._lastRangeBackward = false;
                    this._isFake = false;
                    this._fakeSelectionLabel = "";
                    if (t.length) this.setTo(...t);
                }
                get isFake() {
                    return this._isFake;
                }
                get fakeSelectionLabel() {
                    return this._fakeSelectionLabel;
                }
                get anchor() {
                    if (!this._ranges.length) return null;
                    const t = this._ranges[this._ranges.length - 1];
                    const e = this._lastRangeBackward ? t.end : t.start;
                    return e.clone();
                }
                get focus() {
                    if (!this._ranges.length) return null;
                    const t = this._ranges[this._ranges.length - 1];
                    const e = this._lastRangeBackward ? t.start : t.end;
                    return e.clone();
                }
                get isCollapsed() {
                    return this.rangeCount === 1 && this._ranges[0].isCollapsed;
                }
                get rangeCount() {
                    return this._ranges.length;
                }
                get isBackward() {
                    return !this.isCollapsed && this._lastRangeBackward;
                }
                get editableElement() {
                    if (this.anchor) return this.anchor.editableElement;
                    return null;
                }
                *getRanges() {
                    for (const t of this._ranges)yield t.clone();
                }
                getFirstRange() {
                    let t = null;
                    for (const e of this._ranges)if (!t || e.start.isBefore(t.start)) t = e;
                    return t ? t.clone() : null;
                }
                getLastRange() {
                    let t = null;
                    for (const e of this._ranges)if (!t || e.end.isAfter(t.end)) t = e;
                    return t ? t.clone() : null;
                }
                getFirstPosition() {
                    const t = this.getFirstRange();
                    return t ? t.start.clone() : null;
                }
                getLastPosition() {
                    const t = this.getLastRange();
                    return t ? t.end.clone() : null;
                }
                isEqual(t) {
                    if (this.isFake != t.isFake) return false;
                    if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) return false;
                    if (this.rangeCount != t.rangeCount) return false;
                    else if (this.rangeCount === 0) return true;
                    if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return false;
                    for (const e of this._ranges){
                        let n = false;
                        for (const o of t._ranges)if (e.isEqual(o)) {
                            n = true;
                            break;
                        }
                        if (!n) return false;
                    }
                    return true;
                }
                isSimilar(t) {
                    if (this.isBackward != t.isBackward) return false;
                    const e = yt(this.getRanges());
                    const n = yt(t.getRanges());
                    if (e != n) return false;
                    if (e == 0) return true;
                    for (let e of this.getRanges()){
                        e = e.getTrimmed();
                        let n = false;
                        for (let o of t.getRanges()){
                            o = o.getTrimmed();
                            if (e.start.isEqual(o.start) && e.end.isEqual(o.end)) {
                                n = true;
                                break;
                            }
                        }
                        if (!n) return false;
                    }
                    return true;
                }
                getSelectedElement() {
                    if (this.rangeCount !== 1) return null;
                    return this.getFirstRange().getContainedElement();
                }
                setTo(...t) {
                    let [e, n, o] = t;
                    if (typeof n == "object") {
                        o = n;
                        n = undefined;
                    }
                    if (e === null) {
                        this._setRanges([]);
                        this._setFakeOptions(o);
                    } else if (e instanceof wp || e instanceof _p) {
                        this._setRanges(e.getRanges(), e.isBackward);
                        this._setFakeOptions({
                            fake: e.isFake,
                            label: e.fakeSelectionLabel
                        });
                    } else if (e instanceof kp) {
                        this._setRanges([
                            e
                        ], o && o.backward);
                        this._setFakeOptions(o);
                    } else if (e instanceof mp) {
                        this._setRanges([
                            new kp(e)
                        ]);
                        this._setFakeOptions(o);
                    } else if (e instanceof ih) {
                        const t = !!o && !!o.backward;
                        let i;
                        if (n === undefined) throw new R("view-selection-setto-required-second-parameter", this);
                        else if (n == "in") i = kp._createIn(e);
                        else if (n == "on") i = kp._createOn(e);
                        else i = new kp(mp._createAt(e, n));
                        this._setRanges([
                            i
                        ], t);
                        this._setFakeOptions(o);
                    } else if (Et(e)) {
                        this._setRanges(e, o && o.backward);
                        this._setFakeOptions(o);
                    } else throw new R("view-selection-setto-not-selectable", this);
                    this.fire("change");
                }
                setFocus(t, e) {
                    if (this.anchor === null) throw new R("view-selection-setfocus-no-ranges", this);
                    const n = mp._createAt(t, e);
                    if (n.compareWith(this.focus) == "same") return;
                    const o = this.anchor;
                    this._ranges.pop();
                    if (n.compareWith(o) == "before") this._addRange(new kp(n, o), true);
                    else this._addRange(new kp(o, n));
                    this.fire("change");
                }
                _setRanges(t, e = false) {
                    t = Array.from(t);
                    this._ranges = [];
                    for (const e of t)this._addRange(e);
                    this._lastRangeBackward = !!e;
                }
                _setFakeOptions(t = {}) {
                    this._isFake = !!t.fake;
                    this._fakeSelectionLabel = t.fake ? t.label || "" : "";
                }
                _addRange(t, e = false) {
                    if (!(t instanceof kp)) throw new R("view-selection-add-range-not-range", this);
                    this._pushRange(t);
                    this._lastRangeBackward = !!e;
                }
                _pushRange(t) {
                    for (const e of this._ranges){
                        if (t.isIntersecting(e)) throw new R("view-selection-range-intersects", this, {
                            addedRange: t,
                            intersectingRange: e
                        });
                    }
                    this._ranges.push(new kp(t.start, t.end));
                }
            }
            wp.prototype.is = function(t) {
                return t === "selection" || t === "view:selection";
            };
            class _p extends G(th) {
                constructor(...t){
                    super();
                    this._selection = new wp;
                    this._selection.delegate("change").to(this);
                    if (t.length) this._selection.setTo(...t);
                }
                get isFake() {
                    return this._selection.isFake;
                }
                get fakeSelectionLabel() {
                    return this._selection.fakeSelectionLabel;
                }
                get anchor() {
                    return this._selection.anchor;
                }
                get focus() {
                    return this._selection.focus;
                }
                get isCollapsed() {
                    return this._selection.isCollapsed;
                }
                get rangeCount() {
                    return this._selection.rangeCount;
                }
                get isBackward() {
                    return this._selection.isBackward;
                }
                get editableElement() {
                    return this._selection.editableElement;
                }
                get _ranges() {
                    return this._selection._ranges;
                }
                *getRanges() {
                    yield* this._selection.getRanges();
                }
                getFirstRange() {
                    return this._selection.getFirstRange();
                }
                getLastRange() {
                    return this._selection.getLastRange();
                }
                getFirstPosition() {
                    return this._selection.getFirstPosition();
                }
                getLastPosition() {
                    return this._selection.getLastPosition();
                }
                getSelectedElement() {
                    return this._selection.getSelectedElement();
                }
                isEqual(t) {
                    return this._selection.isEqual(t);
                }
                isSimilar(t) {
                    return this._selection.isSimilar(t);
                }
                _setTo(...t) {
                    this._selection.setTo(...t);
                }
                _setFocus(t, e) {
                    this._selection.setFocus(t, e);
                }
            }
            _p.prototype.is = function(t) {
                return t === "selection" || t == "documentSelection" || t == "view:selection" || t == "view:documentSelection";
            };
            class Ap extends E {
                constructor(t, e, n){
                    super(t, e);
                    this.startRange = n;
                    this._eventPhase = "none";
                    this._currentTarget = null;
                }
                get eventPhase() {
                    return this._eventPhase;
                }
                get currentTarget() {
                    return this._currentTarget;
                }
            }
            const vp = Symbol("bubbling contexts");
            function Cp(t) {
                class e extends t {
                    fire(t, ...e) {
                        try {
                            const n = t instanceof E ? t : new E(this, t);
                            const o = Dp(this);
                            if (!o.size) return;
                            yp(n, "capturing", this);
                            if (xp(o, "$capture", n, ...e)) return n.return;
                            const i = n.startRange || this.selection.getFirstRange();
                            const r = i ? i.getContainedElement() : null;
                            const s = r ? Boolean(Ep(o, r)) : false;
                            let a = r || Sp(i);
                            yp(n, "atTarget", a);
                            if (!s) {
                                if (xp(o, "$text", n, ...e)) return n.return;
                                yp(n, "bubbling", a);
                            }
                            while(a){
                                if (a.is("rootElement")) {
                                    if (xp(o, "$root", n, ...e)) return n.return;
                                } else if (a.is("element")) {
                                    if (xp(o, a.name, n, ...e)) return n.return;
                                }
                                if (xp(o, a, n, ...e)) return n.return;
                                a = a.parent;
                                yp(n, "bubbling", a);
                            }
                            yp(n, "bubbling", this);
                            xp(o, "$document", n, ...e);
                            return n.return;
                        } catch (t) {
                            R.rethrowUnexpectedError(t, this);
                        }
                    }
                    _addEventListener(t, e, n) {
                        const o = nl(n.context || "$document");
                        const i = Dp(this);
                        for (const r of o){
                            let o = i.get(r);
                            if (!o) {
                                o = new (G());
                                i.set(r, o);
                            }
                            this.listenTo(o, t, e, n);
                        }
                    }
                    _removeEventListener(t, e) {
                        const n = Dp(this);
                        for (const o of n.values())this.stopListening(o, t, e);
                    }
                }
                return e;
            }
            {
                const t = Cp(Object);
                [
                    "fire",
                    "_addEventListener",
                    "_removeEventListener"
                ].forEach((e)=>{
                    Cp[e] = t.prototype[e];
                });
            }
            function yp(t, e, n) {
                if (t instanceof Ap) {
                    t._eventPhase = e;
                    t._currentTarget = n;
                }
            }
            function xp(t, e, n, ...o) {
                const i = typeof e == "string" ? t.get(e) : Ep(t, e);
                if (!i) return false;
                i.fire(n, ...o);
                return n.stop.called;
            }
            function Ep(t, e) {
                for (const [n, o] of t){
                    if (typeof n == "function" && n(e)) return o;
                }
                return null;
            }
            function Dp(t) {
                if (!t[vp]) t[vp] = new Map;
                return t[vp];
            }
            function Sp(t) {
                if (!t) return null;
                const e = t.start.parent;
                const n = t.end.parent;
                const o = e.getPath();
                const i = n.getPath();
                return o.length > i.length ? e : n;
            }
            class Tp extends Cp(ht()) {
                constructor(t){
                    super();
                    this._postFixers = new Set;
                    this.selection = new _p;
                    this.roots = new hl({
                        idProperty: "rootName"
                    });
                    this.stylesProcessor = t;
                    this.set("isReadOnly", false);
                    this.set("isFocused", false);
                    this.set("isSelecting", false);
                    this.set("isComposing", false);
                }
                getRoot(t = "main") {
                    return this.roots.get(t);
                }
                registerPostFixer(t) {
                    this._postFixers.add(t);
                }
                destroy() {
                    this.roots.map((t)=>t.destroy());
                    this.stopListening();
                }
                _callPostFixers(t) {
                    let e = false;
                    do for (const n of this._postFixers){
                        e = n(t);
                        if (e) break;
                    }
                    while (e);
                }
            }
            const Bp = 10;
            class Pp extends sp {
                constructor(t, e, n, o){
                    super(t, e, n, o);
                    this._priority = Bp;
                    this._id = null;
                    this._clonesGroup = null;
                    this.getFillerOffset = Ip;
                }
                get priority() {
                    return this._priority;
                }
                get id() {
                    return this._id;
                }
                getElementsWithSameId() {
                    if (this.id === null) throw new R("attribute-element-get-elements-with-same-id-no-id", this);
                    return new Set(this._clonesGroup);
                }
                isSimilar(t) {
                    if (this.id !== null || t.id !== null) return this.id === t.id;
                    return super.isSimilar(t) && this.priority == t.priority;
                }
                _clone(t = false) {
                    const e = super._clone(t);
                    e._priority = this._priority;
                    e._id = this._id;
                    return e;
                }
            }
            Pp.DEFAULT_PRIORITY = Bp;
            Pp.prototype.is = function(t, e) {
                if (!e) return t === "attributeElement" || t === "view:attributeElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "attributeElement" || t === "view:attributeElement" || t === "element" || t === "view:element");
            };
            function Ip() {
                if (Rp(this)) return null;
                let t = this.parent;
                while(t && t.is("attributeElement")){
                    if (Rp(t) > 1) return null;
                    t = t.parent;
                }
                if (!t || Rp(t) > 1) return null;
                return this.childCount;
            }
            function Rp(t) {
                return Array.from(t.getChildren()).filter((t)=>!t.is("uiElement")).length;
            }
            class Op extends sp {
                constructor(t, e, n, o){
                    super(t, e, n, o);
                    this.getFillerOffset = Vp;
                }
                _insertChild(t, e) {
                    if (e && (e instanceof ih || Array.from(e).length > 0)) throw new R("view-emptyelement-cannot-add", [
                        this,
                        e
                    ]);
                    return 0;
                }
            }
            Op.prototype.is = function(t, e) {
                if (!e) return t === "emptyElement" || t === "view:emptyElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "emptyElement" || t === "view:emptyElement" || t === "element" || t === "view:element");
            };
            function Vp() {
                return null;
            }
            class Mp extends sp {
                constructor(t, e, n, o){
                    super(t, e, n, o);
                    this.getFillerOffset = zp;
                }
                _insertChild(t, e) {
                    if (e && (e instanceof ih || Array.from(e).length > 0)) throw new R("view-uielement-cannot-add", [
                        this,
                        e
                    ]);
                    return 0;
                }
                render(t, e) {
                    return this.toDomElement(t);
                }
                toDomElement(t) {
                    const e = t.createElement(this.name);
                    for (const t of this.getAttributeKeys())e.setAttribute(t, this.getAttribute(t));
                    return e;
                }
            }
            Mp.prototype.is = function(t, e) {
                if (!e) return t === "uiElement" || t === "view:uiElement" || t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "uiElement" || t === "view:uiElement" || t === "element" || t === "view:element");
            };
            function Lp(t) {
                t.document.on("arrowKey", (e, n)=>Np(e, n, t.domConverter), {
                    priority: "low"
                });
            }
            function zp() {
                return null;
            }
            function Np(t, e, n) {
                if (e.keyCode == $c.arrowright) {
                    const t = e.domTarget.ownerDocument.defaultView.getSelection();
                    const o = t.rangeCount == 1 && t.getRangeAt(0).collapsed;
                    if (o || e.shiftKey) {
                        const e = t.focusNode;
                        const i = t.focusOffset;
                        const r = n.domPositionToView(e, i);
                        if (r === null) return;
                        let s = false;
                        const a = r.getLastMatchingPosition((t)=>{
                            if (t.item.is("uiElement")) s = true;
                            if (t.item.is("uiElement") || t.item.is("attributeElement")) return true;
                            return false;
                        });
                        if (s) {
                            const e = n.viewPositionToDom(a);
                            if (o) t.collapse(e.parent, e.offset);
                            else t.extend(e.parent, e.offset);
                        }
                    }
                }
            }
            class Fp extends sp {
                constructor(t, e, n, o){
                    super(t, e, n, o);
                    this.getFillerOffset = Hp;
                }
                _insertChild(t, e) {
                    if (e && (e instanceof ih || Array.from(e).length > 0)) throw new R("view-rawelement-cannot-add", [
                        this,
                        e
                    ]);
                    return 0;
                }
                render(t, e) {}
            }
            Fp.prototype.is = function(t, e) {
                if (!e) return t === "rawElement" || t === "view:rawElement" || t === this.name || t === "view:" + this.name || t === "element" || t === "view:element" || t === "node" || t === "view:node";
                else return e === this.name && (t === "rawElement" || t === "view:rawElement" || t === "element" || t === "view:element");
            };
            function Hp() {
                return null;
            }
            class jp extends G(th) {
                constructor(t, e){
                    super();
                    this._children = [];
                    this._customProperties = new Map;
                    this.document = t;
                    if (e) this._insertChild(0, e);
                }
                [Symbol.iterator]() {
                    return this._children[Symbol.iterator]();
                }
                get childCount() {
                    return this._children.length;
                }
                get isEmpty() {
                    return this.childCount === 0;
                }
                get root() {
                    return this;
                }
                get parent() {
                    return null;
                }
                get name() {
                    return undefined;
                }
                getCustomProperty(t) {
                    return this._customProperties.get(t);
                }
                *getCustomProperties() {
                    yield* this._customProperties.entries();
                }
                _appendChild(t) {
                    return this._insertChild(this.childCount, t);
                }
                getChild(t) {
                    return this._children[t];
                }
                getChildIndex(t) {
                    return this._children.indexOf(t);
                }
                getChildren() {
                    return this._children[Symbol.iterator]();
                }
                _insertChild(t, e) {
                    this._fireChange("children", this);
                    let n = 0;
                    const o = qp(this.document, e);
                    for (const e of o){
                        if (e.parent !== null) e._remove();
                        e.parent = this;
                        this._children.splice(t, 0, e);
                        t++;
                        n++;
                    }
                    return n;
                }
                _removeChildren(t, e = 1) {
                    this._fireChange("children", this);
                    for(let n = t; n < t + e; n++)this._children[n].parent = null;
                    return this._children.splice(t, e);
                }
                _fireChange(t, e) {
                    this.fire("change:" + t, e);
                }
                _setCustomProperty(t, e) {
                    this._customProperties.set(t, e);
                }
                _removeCustomProperty(t) {
                    return this._customProperties.delete(t);
                }
            }
            jp.prototype.is = function(t) {
                return t === "documentFragment" || t === "view:documentFragment";
            };
            function qp(t, e) {
                if (typeof e == "string") return [
                    new rh(t, e)
                ];
                if (!Et(e)) e = [
                    e
                ];
                return Array.from(e).map((e)=>{
                    if (typeof e == "string") return new rh(t, e);
                    if (e instanceof sh) return new rh(t, e.data);
                    return e;
                });
            }
            class Wp {
                constructor(t){
                    this._cloneGroups = new Map;
                    this._slotFactory = null;
                    this.document = t;
                }
                setSelection(...t) {
                    this.document.selection._setTo(...t);
                }
                setSelectionFocus(t, e) {
                    this.document.selection._setFocus(t, e);
                }
                createDocumentFragment(t) {
                    return new jp(this.document, t);
                }
                createText(t) {
                    return new rh(this.document, t);
                }
                createAttributeElement(t, e, n = {}) {
                    const o = new Pp(this.document, t, e);
                    if (typeof n.priority === "number") o._priority = n.priority;
                    if (n.id) o._id = n.id;
                    if (n.renderUnsafeAttributes) o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes);
                    return o;
                }
                createContainerElement(t, e, n = {}, o = {}) {
                    let i = null;
                    if (pe(n)) o = n;
                    else i = n;
                    const r = new dp(this.document, t, e, i);
                    if (o.renderUnsafeAttributes) r._unsafeAttributesToRender.push(...o.renderUnsafeAttributes);
                    return r;
                }
                createEditableElement(t, e, n = {}) {
                    const o = new hp(this.document, t, e);
                    if (n.renderUnsafeAttributes) o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes);
                    return o;
                }
                createEmptyElement(t, e, n = {}) {
                    const o = new Op(this.document, t, e);
                    if (n.renderUnsafeAttributes) o._unsafeAttributesToRender.push(...n.renderUnsafeAttributes);
                    return o;
                }
                createUIElement(t, e, n) {
                    const o = new Mp(this.document, t, e);
                    if (n) o.render = n;
                    return o;
                }
                createRawElement(t, e, n, o = {}) {
                    const i = new Fp(this.document, t, e);
                    if (n) i.render = n;
                    if (o.renderUnsafeAttributes) i._unsafeAttributesToRender.push(...o.renderUnsafeAttributes);
                    return i;
                }
                setAttribute(t, e, n) {
                    n._setAttribute(t, e);
                }
                removeAttribute(t, e) {
                    e._removeAttribute(t);
                }
                addClass(t, e) {
                    e._addClass(t);
                }
                removeClass(t, e) {
                    e._removeClass(t);
                }
                setStyle(t, e, n) {
                    if (pe(t) && n === undefined) e._setStyle(t);
                    else n._setStyle(t, e);
                }
                removeStyle(t, e) {
                    e._removeStyle(t);
                }
                setCustomProperty(t, e, n) {
                    n._setCustomProperty(t, e);
                }
                removeCustomProperty(t, e) {
                    return e._removeCustomProperty(t);
                }
                breakAttributes(t) {
                    if (t instanceof mp) return this._breakAttributes(t);
                    else return this._breakAttributesRange(t);
                }
                breakContainer(t) {
                    const e = t.parent;
                    if (!e.is("containerElement")) throw new R("view-writer-break-non-container-element", this.document);
                    if (!e.parent) throw new R("view-writer-break-root", this.document);
                    if (t.isAtStart) return mp._createBefore(e);
                    else if (!t.isAtEnd) {
                        const n = e._clone(false);
                        this.insert(mp._createAfter(e), n);
                        const o = new kp(t, mp._createAt(e, "end"));
                        const i = new mp(n, 0);
                        this.move(o, i);
                    }
                    return mp._createAfter(e);
                }
                mergeAttributes(t) {
                    const e = t.offset;
                    const n = t.parent;
                    if (n.is("$text")) return t;
                    if (n.is("attributeElement") && n.childCount === 0) {
                        const t = n.parent;
                        const e = n.index;
                        n._remove();
                        this._removeFromClonedElementsGroup(n);
                        return this.mergeAttributes(new mp(t, e));
                    }
                    const o = n.getChild(e - 1);
                    const i = n.getChild(e);
                    if (!o || !i) return t;
                    if (o.is("$text") && i.is("$text")) return Jp(o, i);
                    else if (o.is("attributeElement") && i.is("attributeElement") && o.isSimilar(i)) {
                        const t = o.childCount;
                        o._appendChild(i.getChildren());
                        i._remove();
                        this._removeFromClonedElementsGroup(i);
                        return this.mergeAttributes(new mp(o, t));
                    }
                    return t;
                }
                mergeContainers(t) {
                    const e = t.nodeBefore;
                    const n = t.nodeAfter;
                    if (!e || !n || !e.is("containerElement") || !n.is("containerElement")) throw new R("view-writer-merge-containers-invalid-position", this.document);
                    const o = e.getChild(e.childCount - 1);
                    const i = o instanceof rh ? mp._createAt(o, "end") : mp._createAt(e, "end");
                    this.move(kp._createIn(n), mp._createAt(e, "end"));
                    this.remove(kp._createOn(n));
                    return i;
                }
                insert(t, e) {
                    e = Et(e) ? [
                        ...e
                    ] : [
                        e
                    ];
                    Qp(e, this.document);
                    const n = e.reduce((t, e)=>{
                        const n = t[t.length - 1];
                        const o = !e.is("uiElement");
                        if (!n || n.breakAttributes != o) t.push({
                            breakAttributes: o,
                            nodes: [
                                e
                            ]
                        });
                        else n.nodes.push(e);
                        return t;
                    }, []);
                    let o = null;
                    let i = t;
                    for (const { nodes: t, breakAttributes: e } of n){
                        const n = this._insertNodes(i, t, e);
                        if (!o) o = n.start;
                        i = n.end;
                    }
                    if (!o) return new kp(t);
                    return new kp(o, i);
                }
                remove(t) {
                    const e = t instanceof kp ? t : kp._createOn(t);
                    tg(e, this.document);
                    if (e.isCollapsed) return new jp(this.document);
                    const { start: n, end: o } = this._breakAttributesRange(e, true);
                    const i = n.parent;
                    const r = o.offset - n.offset;
                    const s = i._removeChildren(n.offset, r);
                    for (const t of s)this._removeFromClonedElementsGroup(t);
                    const a = this.mergeAttributes(n);
                    e.start = a;
                    e.end = a.clone();
                    return new jp(this.document, s);
                }
                clear(t, e) {
                    tg(t, this.document);
                    const n = t.getWalker({
                        direction: "backward",
                        ignoreElementEnd: true
                    });
                    for (const o of n){
                        const n = o.item;
                        let i;
                        if (n.is("element") && e.isSimilar(n)) i = kp._createOn(n);
                        else if (!o.nextPosition.isAfter(t.start) && n.is("$textProxy")) {
                            const t = n.getAncestors().find((t)=>t.is("element") && e.isSimilar(t));
                            if (t) i = kp._createIn(t);
                        }
                        if (i) {
                            if (i.end.isAfter(t.end)) i.end = t.end;
                            if (i.start.isBefore(t.start)) i.start = t.start;
                            this.remove(i);
                        }
                    }
                }
                move(t, e) {
                    let n;
                    if (e.isAfter(t.end)) {
                        e = this._breakAttributes(e, true);
                        const o = e.parent;
                        const i = o.childCount;
                        t = this._breakAttributesRange(t, true);
                        n = this.remove(t);
                        e.offset += o.childCount - i;
                    } else n = this.remove(t);
                    return this.insert(e, n);
                }
                wrap(t, e) {
                    if (!(e instanceof Pp)) throw new R("view-writer-wrap-invalid-attribute", this.document);
                    tg(t, this.document);
                    if (!t.isCollapsed) return this._wrapRange(t, e);
                    else {
                        let n = t.start;
                        if (n.parent.is("element") && !$p(n.parent)) n = n.getLastMatchingPosition((t)=>t.item.is("uiElement"));
                        n = this._wrapPosition(n, e);
                        const o = this.document.selection;
                        if (o.isCollapsed && o.getFirstPosition().isEqual(t.start)) this.setSelection(n);
                        return new kp(n);
                    }
                }
                unwrap(t, e) {
                    if (!(e instanceof Pp)) throw new R("view-writer-unwrap-invalid-attribute", this.document);
                    tg(t, this.document);
                    if (t.isCollapsed) return t;
                    const { start: n, end: o } = this._breakAttributesRange(t, true);
                    const i = n.parent;
                    const r = this._unwrapChildren(i, n.offset, o.offset, e);
                    const s = this.mergeAttributes(r.start);
                    if (!s.isEqual(r.start)) r.end.offset--;
                    const a = this.mergeAttributes(r.end);
                    return new kp(s, a);
                }
                rename(t, e) {
                    const n = new dp(this.document, t, e.getAttributes());
                    this.insert(mp._createAfter(e), n);
                    this.move(kp._createIn(e), mp._createAt(n, 0));
                    this.remove(kp._createOn(e));
                    return n;
                }
                clearClonedElementsGroup(t) {
                    this._cloneGroups.delete(t);
                }
                createPositionAt(t, e) {
                    return mp._createAt(t, e);
                }
                createPositionAfter(t) {
                    return mp._createAfter(t);
                }
                createPositionBefore(t) {
                    return mp._createBefore(t);
                }
                createRange(t, e) {
                    return new kp(t, e);
                }
                createRangeOn(t) {
                    return kp._createOn(t);
                }
                createRangeIn(t) {
                    return kp._createIn(t);
                }
                createSelection(...t) {
                    return new wp(...t);
                }
                createSlot(t = "children") {
                    if (!this._slotFactory) throw new R("view-writer-invalid-create-slot-context", this.document);
                    return this._slotFactory(this, t);
                }
                _registerSlotFactory(t) {
                    this._slotFactory = t;
                }
                _clearSlotFactory() {
                    this._slotFactory = null;
                }
                _insertNodes(t, e, n) {
                    let o;
                    if (n) o = Gp(t);
                    else o = t.parent.is("$text") ? t.parent.parent : t.parent;
                    if (!o) throw new R("view-writer-invalid-position-container", this.document);
                    let i;
                    if (n) i = this._breakAttributes(t, true);
                    else i = t.parent.is("$text") ? Zp(t) : t;
                    const r = o._insertChild(i.offset, e);
                    for (const t of e)this._addToClonedElementsGroup(t);
                    const s = i.getShiftedBy(r);
                    const a = this.mergeAttributes(i);
                    if (!a.isEqual(i)) s.offset--;
                    const c = this.mergeAttributes(s);
                    return new kp(a, c);
                }
                _wrapChildren(t, e, n, o) {
                    let i = e;
                    const r = [];
                    while(i < n){
                        const e = t.getChild(i);
                        const n = e.is("$text");
                        const s = e.is("attributeElement");
                        if (s && this._wrapAttributeElement(o, e)) r.push(new mp(t, i));
                        else if (n || !s || Up(o, e)) {
                            const n = o._clone();
                            e._remove();
                            n._appendChild(e);
                            t._insertChild(i, n);
                            this._addToClonedElementsGroup(n);
                            r.push(new mp(t, i));
                        } else this._wrapChildren(e, 0, e.childCount, o);
                        i++;
                    }
                    let s = 0;
                    for (const t of r){
                        t.offset -= s;
                        if (t.offset == e) continue;
                        const o = this.mergeAttributes(t);
                        if (!o.isEqual(t)) {
                            s++;
                            n--;
                        }
                    }
                    return kp._createFromParentsAndOffsets(t, e, t, n);
                }
                _unwrapChildren(t, e, n, o) {
                    let i = e;
                    const r = [];
                    while(i < n){
                        const e = t.getChild(i);
                        if (!e.is("attributeElement")) {
                            i++;
                            continue;
                        }
                        if (e.isSimilar(o)) {
                            const o = e.getChildren();
                            const s = e.childCount;
                            e._remove();
                            t._insertChild(i, o);
                            this._removeFromClonedElementsGroup(e);
                            r.push(new mp(t, i), new mp(t, i + s));
                            i += s;
                            n += s - 1;
                            continue;
                        }
                        if (this._unwrapAttributeElement(o, e)) {
                            r.push(new mp(t, i), new mp(t, i + 1));
                            i++;
                            continue;
                        }
                        this._unwrapChildren(e, 0, e.childCount, o);
                        i++;
                    }
                    let s = 0;
                    for (const t of r){
                        t.offset -= s;
                        if (t.offset == e || t.offset == n) continue;
                        const o = this.mergeAttributes(t);
                        if (!o.isEqual(t)) {
                            s++;
                            n--;
                        }
                    }
                    return kp._createFromParentsAndOffsets(t, e, t, n);
                }
                _wrapRange(t, e) {
                    const { start: n, end: o } = this._breakAttributesRange(t, true);
                    const i = n.parent;
                    const r = this._wrapChildren(i, n.offset, o.offset, e);
                    const s = this.mergeAttributes(r.start);
                    if (!s.isEqual(r.start)) r.end.offset--;
                    const a = this.mergeAttributes(r.end);
                    return new kp(s, a);
                }
                _wrapPosition(t, e) {
                    if (e.isSimilar(t.parent)) return Kp(t.clone());
                    if (t.parent.is("$text")) t = Zp(t);
                    const n = this.createAttributeElement("_wrapPosition-fake-element");
                    n._priority = Number.POSITIVE_INFINITY;
                    n.isSimilar = ()=>false;
                    t.parent._insertChild(t.offset, n);
                    const o = new kp(t, t.getShiftedBy(1));
                    this.wrap(o, e);
                    const i = new mp(n.parent, n.index);
                    n._remove();
                    const r = i.nodeBefore;
                    const s = i.nodeAfter;
                    if (r instanceof rh && s instanceof rh) return Jp(r, s);
                    return Kp(i);
                }
                _wrapAttributeElement(t, e) {
                    if (!eg(t, e)) return false;
                    if (t.name !== e.name || t.priority !== e.priority) return false;
                    for (const n of t.getAttributeKeys()){
                        if (n === "class" || n === "style") continue;
                        if (e.hasAttribute(n) && e.getAttribute(n) !== t.getAttribute(n)) return false;
                    }
                    for (const n of t.getStyleNames()){
                        if (e.hasStyle(n) && e.getStyle(n) !== t.getStyle(n)) return false;
                    }
                    for (const n of t.getAttributeKeys()){
                        if (n === "class" || n === "style") continue;
                        if (!e.hasAttribute(n)) this.setAttribute(n, t.getAttribute(n), e);
                    }
                    for (const n of t.getStyleNames())if (!e.hasStyle(n)) this.setStyle(n, t.getStyle(n), e);
                    for (const n of t.getClassNames())if (!e.hasClass(n)) this.addClass(n, e);
                    return true;
                }
                _unwrapAttributeElement(t, e) {
                    if (!eg(t, e)) return false;
                    if (t.name !== e.name || t.priority !== e.priority) return false;
                    for (const n of t.getAttributeKeys()){
                        if (n === "class" || n === "style") continue;
                        if (!e.hasAttribute(n) || e.getAttribute(n) !== t.getAttribute(n)) return false;
                    }
                    if (!e.hasClass(...t.getClassNames())) return false;
                    for (const n of t.getStyleNames()){
                        if (!e.hasStyle(n) || e.getStyle(n) !== t.getStyle(n)) return false;
                    }
                    for (const n of t.getAttributeKeys()){
                        if (n === "class" || n === "style") continue;
                        this.removeAttribute(n, e);
                    }
                    this.removeClass(Array.from(t.getClassNames()), e);
                    this.removeStyle(Array.from(t.getStyleNames()), e);
                    return true;
                }
                _breakAttributesRange(t, e = false) {
                    const n = t.start;
                    const o = t.end;
                    tg(t, this.document);
                    if (t.isCollapsed) {
                        const n = this._breakAttributes(t.start, e);
                        return new kp(n, n);
                    }
                    const i = this._breakAttributes(o, e);
                    const r = i.parent.childCount;
                    const s = this._breakAttributes(n, e);
                    i.offset += i.parent.childCount - r;
                    return new kp(s, i);
                }
                _breakAttributes(t, e = false) {
                    const n = t.offset;
                    const o = t.parent;
                    if (t.parent.is("emptyElement")) throw new R("view-writer-cannot-break-empty-element", this.document);
                    if (t.parent.is("uiElement")) throw new R("view-writer-cannot-break-ui-element", this.document);
                    if (t.parent.is("rawElement")) throw new R("view-writer-cannot-break-raw-element", this.document);
                    if (!e && o.is("$text") && Xp(o.parent)) return t.clone();
                    if (Xp(o)) return t.clone();
                    if (o.is("$text")) return this._breakAttributes(Zp(t), e);
                    const i = o.childCount;
                    if (n == i) {
                        const t = new mp(o.parent, o.index + 1);
                        return this._breakAttributes(t, e);
                    } else if (n === 0) {
                        const t = new mp(o.parent, o.index);
                        return this._breakAttributes(t, e);
                    } else {
                        const t = o.index + 1;
                        const i = o._clone();
                        o.parent._insertChild(t, i);
                        this._addToClonedElementsGroup(i);
                        const r = o.childCount - n;
                        const s = o._removeChildren(n, r);
                        i._appendChild(s);
                        const a = new mp(o.parent, t);
                        return this._breakAttributes(a, e);
                    }
                }
                _addToClonedElementsGroup(t) {
                    if (!t.root.is("rootElement")) return;
                    if (t.is("element")) for (const e of t.getChildren())this._addToClonedElementsGroup(e);
                    const e = t.id;
                    if (!e) return;
                    let n = this._cloneGroups.get(e);
                    if (!n) {
                        n = new Set;
                        this._cloneGroups.set(e, n);
                    }
                    n.add(t);
                    t._clonesGroup = n;
                }
                _removeFromClonedElementsGroup(t) {
                    if (t.is("element")) for (const e of t.getChildren())this._removeFromClonedElementsGroup(e);
                    const e = t.id;
                    if (!e) return;
                    const n = this._cloneGroups.get(e);
                    if (!n) return;
                    n.delete(t);
                }
            }
            function $p(t) {
                return Array.from(t.getChildren()).some((t)=>!t.is("uiElement"));
            }
            function Gp(t) {
                let e = t.parent;
                while(!Xp(e)){
                    if (!e) return undefined;
                    e = e.parent;
                }
                return e;
            }
            function Up(t, e) {
                if (t.priority < e.priority) return true;
                else if (t.priority > e.priority) return false;
                return t.getIdentity() < e.getIdentity();
            }
            function Kp(t) {
                const e = t.nodeBefore;
                if (e && e.is("$text")) return new mp(e, e.data.length);
                const n = t.nodeAfter;
                if (n && n.is("$text")) return new mp(n, 0);
                return t;
            }
            function Zp(t) {
                if (t.offset == t.parent.data.length) return new mp(t.parent.parent, t.parent.index + 1);
                if (t.offset === 0) return new mp(t.parent.parent, t.parent.index);
                const e = t.parent.data.slice(t.offset);
                t.parent._data = t.parent.data.slice(0, t.offset);
                t.parent.parent._insertChild(t.parent.index + 1, new rh(t.root.document, e));
                return new mp(t.parent.parent, t.parent.index + 1);
            }
            function Jp(t, e) {
                const n = t.data.length;
                t._data += e.data;
                e._remove();
                return new mp(t, n);
            }
            const Yp = [
                rh,
                Pp,
                dp,
                Op,
                Fp,
                Mp
            ];
            function Qp(t, e) {
                for (const n of t){
                    if (!Yp.some((t)=>n instanceof t)) throw new R("view-writer-insert-invalid-node-type", e);
                    if (!n.is("$text")) Qp(n.getChildren(), e);
                }
            }
            function Xp(t) {
                return t && (t.is("containerElement") || t.is("documentFragment"));
            }
            function tg(t, e) {
                const n = Gp(t.start);
                const o = Gp(t.end);
                if (!n || !o || n !== o) throw new R("view-writer-invalid-range-container", e);
            }
            function eg(t, e) {
                return t.id === null && e.id === null;
            }
            const ng = (t)=>t.createTextNode("\xa0");
            const og = (t)=>{
                const e = t.createElement("span");
                e.dataset.ckeFiller = "true";
                e.innerText = "\xa0";
                return e;
            };
            const ig = (t)=>{
                const e = t.createElement("br");
                e.dataset.ckeFiller = "true";
                return e;
            };
            const rg = 7;
            const sg = "\u2060".repeat(rg);
            function ag(t) {
                if (typeof t == "string") return t.substr(0, rg) === sg;
                return rc(t) && t.data.substr(0, rg) === sg;
            }
            function cg(t) {
                return t.data.length == rg && ag(t);
            }
            function lg(t) {
                const e = typeof t == "string" ? t : t.data;
                if (ag(t)) return e.slice(rg);
                return e;
            }
            function dg(t) {
                t.document.on("arrowKey", ug, {
                    priority: "low"
                });
            }
            function ug(t, e) {
                if (e.keyCode == $c.arrowleft) {
                    const t = e.domTarget.ownerDocument.defaultView.getSelection();
                    if (t.rangeCount == 1 && t.getRangeAt(0).collapsed) {
                        const e = t.getRangeAt(0).startContainer;
                        const n = t.getRangeAt(0).startOffset;
                        if (ag(e) && n <= rg) t.collapse(e, 0);
                    }
                }
            }
            var hg = n(5037);
            var fg = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            fg.insert = "head";
            fg.singleton = true;
            var pg = Rl()(hg.Z, fg);
            const gg = hg.Z.locals || {};
            class mg extends ht() {
                constructor(t, e){
                    super();
                    this.domDocuments = new Set;
                    this.markedAttributes = new Set;
                    this.markedChildren = new Set;
                    this.markedTexts = new Set;
                    this._inlineFiller = null;
                    this._fakeSelectionContainer = null;
                    this.domConverter = t;
                    this.selection = e;
                    this.set("isFocused", false);
                    this.set("isSelecting", false);
                    if (c.isBlink && !c.isAndroid) this.on("change:isSelecting", ()=>{
                        if (!this.isSelecting) this.render();
                    });
                    this.set("isComposing", false);
                    this.on("change:isComposing", ()=>{
                        if (!this.isComposing) this.render();
                    });
                }
                markToSync(t, e) {
                    if (t === "text") {
                        if (this.domConverter.mapViewToDom(e.parent)) this.markedTexts.add(e);
                    } else {
                        if (!this.domConverter.mapViewToDom(e)) return;
                        if (t === "attributes") this.markedAttributes.add(e);
                        else if (t === "children") this.markedChildren.add(e);
                        else {
                            const e = t;
                            throw new R("view-renderer-unknown-type", this);
                        }
                    }
                }
                render() {
                    if (this.isComposing && !c.isAndroid) return;
                    let t = null;
                    const e = c.isBlink && !c.isAndroid ? !this.isSelecting : true;
                    for (const t of this.markedChildren)this._updateChildrenMappings(t);
                    if (e) {
                        if (this._inlineFiller && !this._isSelectionInInlineFiller()) this._removeInlineFiller();
                        if (this._inlineFiller) t = this._getInlineFillerPosition();
                        else if (this._needsInlineFillerAtSelection()) {
                            t = this.selection.getFirstPosition();
                            this.markedChildren.add(t.parent);
                        }
                    } else if (this._inlineFiller && this._inlineFiller.parentNode) {
                        t = this.domConverter.domPositionToView(this._inlineFiller);
                        if (t && t.parent.is("$text")) t = mp._createBefore(t.parent);
                    }
                    for (const t of this.markedAttributes)this._updateAttrs(t);
                    for (const e of this.markedChildren)this._updateChildren(e, {
                        inlineFillerPosition: t
                    });
                    for (const e of this.markedTexts)if (!this.markedChildren.has(e.parent) && this.domConverter.mapViewToDom(e.parent)) this._updateText(e, {
                        inlineFillerPosition: t
                    });
                    if (e) {
                        if (t) {
                            const e = this.domConverter.viewPositionToDom(t);
                            const n = e.parent.ownerDocument;
                            if (!ag(e.parent)) this._inlineFiller = bg(n, e.parent, e.offset);
                            else this._inlineFiller = e.parent;
                        } else this._inlineFiller = null;
                    }
                    this._updateFocus();
                    this._updateSelection();
                    this.markedTexts.clear();
                    this.markedAttributes.clear();
                    this.markedChildren.clear();
                }
                _updateChildrenMappings(t) {
                    const e = this.domConverter.mapViewToDom(t);
                    if (!e) return;
                    const n = Array.from(e.childNodes);
                    const o = Array.from(this.domConverter.viewChildrenToDom(t, {
                        withChildren: false
                    }));
                    const i = this._diffNodeLists(n, o);
                    const r = this._findUpdateActions(i, n, o, wg);
                    if (r.indexOf("update") !== -1) {
                        const e = {
                            equal: 0,
                            insert: 0,
                            delete: 0
                        };
                        for (const i of r)if (i === "update") {
                            const i = e.equal + e.insert;
                            const r = e.equal + e.delete;
                            const s = t.getChild(i);
                            if (s && !(s.is("uiElement") || s.is("rawElement"))) this._updateElementMappings(s, n[r]);
                            Bc(o[i]);
                            e.equal++;
                        } else e[i]++;
                    }
                }
                _updateElementMappings(t, e) {
                    this.domConverter.unbindDomElement(e);
                    this.domConverter.bindElements(e, t);
                    this.markedChildren.add(t);
                    this.markedAttributes.add(t);
                }
                _getInlineFillerPosition() {
                    const t = this.selection.getFirstPosition();
                    if (t.parent.is("$text")) return mp._createBefore(t.parent);
                    else return t;
                }
                _isSelectionInInlineFiller() {
                    if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) return false;
                    const t = this.selection.getFirstPosition();
                    const e = this.domConverter.viewPositionToDom(t);
                    if (e && rc(e.parent) && ag(e.parent)) return true;
                    return false;
                }
                _removeInlineFiller() {
                    const t = this._inlineFiller;
                    if (!ag(t)) throw new R("view-renderer-filler-was-lost", this);
                    if (cg(t)) t.remove();
                    else t.data = t.data.substr(rg);
                    this._inlineFiller = null;
                }
                _needsInlineFillerAtSelection() {
                    if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) return false;
                    const t = this.selection.getFirstPosition();
                    const e = t.parent;
                    const n = t.offset;
                    if (!this.domConverter.mapViewToDom(e.root)) return false;
                    if (!e.is("element")) return false;
                    if (!kg(e)) return false;
                    if (n === e.getFillerOffset()) return false;
                    const o = t.nodeBefore;
                    const i = t.nodeAfter;
                    if (o instanceof rh || i instanceof rh) return false;
                    if (c.isAndroid && (o || i)) return false;
                    return true;
                }
                _updateText(t, e) {
                    const n = this.domConverter.findCorrespondingDomText(t);
                    const o = this.domConverter.viewToDom(t);
                    let i = o.data;
                    const r = e.inlineFillerPosition;
                    if (r && r.parent == t.parent && r.offset == t.index) i = sg + i;
                    xg(n, i);
                }
                _updateAttrs(t) {
                    const e = this.domConverter.mapViewToDom(t);
                    if (!e) return;
                    const n = Array.from(e.attributes).map((t)=>t.name);
                    const o = t.getAttributeKeys();
                    for (const n of o)this.domConverter.setDomElementAttribute(e, n, t.getAttribute(n), t);
                    for (const o of n)if (!t.hasAttribute(o)) this.domConverter.removeDomElementAttribute(e, o);
                }
                _updateChildren(t, e) {
                    const n = this.domConverter.mapViewToDom(t);
                    if (!n) return;
                    if (c.isAndroid) {
                        let t = null;
                        for (const e of Array.from(n.childNodes)){
                            if (t && rc(t) && rc(e)) {
                                n.normalize();
                                break;
                            }
                            t = e;
                        }
                    }
                    const o = e.inlineFillerPosition;
                    const i = n.childNodes;
                    const r = Array.from(this.domConverter.viewChildrenToDom(t, {
                        bind: true
                    }));
                    if (o && o.parent === t) bg(n.ownerDocument, r, o.offset);
                    const s = this._diffNodeLists(i, r);
                    const a = this._findUpdateActions(s, i, r, _g);
                    let l = 0;
                    const d = new Set;
                    for (const t of a){
                        if (t === "delete") {
                            d.add(i[l]);
                            Bc(i[l]);
                        } else if (t === "equal" || t === "update") l++;
                    }
                    l = 0;
                    for (const t of a){
                        if (t === "insert") {
                            Ac(n, l, r[l]);
                            l++;
                        } else if (t === "update") {
                            xg(i[l], r[l].data);
                            l++;
                        } else if (t === "equal") {
                            this._markDescendantTextToSync(this.domConverter.domToView(r[l]));
                            l++;
                        }
                    }
                    for (const t of d)if (!t.parentNode) this.domConverter.unbindDomElement(t);
                }
                _diffNodeLists(t, e) {
                    t = Cg(t, this._fakeSelectionContainer);
                    return C(t, e, Ag.bind(null, this.domConverter));
                }
                _findUpdateActions(t, e, n, o) {
                    if (t.indexOf("insert") === -1 || t.indexOf("delete") === -1) return t;
                    let i = [];
                    let r = [];
                    let s = [];
                    const a = {
                        equal: 0,
                        insert: 0,
                        delete: 0
                    };
                    for (const c of t){
                        if (c === "insert") s.push(n[a.equal + a.insert]);
                        else if (c === "delete") r.push(e[a.equal + a.delete]);
                        else {
                            i = i.concat(C(r, s, o).map((t)=>t === "equal" ? "update" : t));
                            i.push("equal");
                            r = [];
                            s = [];
                        }
                        a[c]++;
                    }
                    return i.concat(C(r, s, o).map((t)=>t === "equal" ? "update" : t));
                }
                _markDescendantTextToSync(t) {
                    if (!t) return;
                    if (t.is("$text")) this.markedTexts.add(t);
                    else if (t.is("element")) for (const e of t.getChildren())this._markDescendantTextToSync(e);
                }
                _updateSelection() {
                    if (c.isBlink && !c.isAndroid && this.isSelecting && !this.markedChildren.size) return;
                    if (this.selection.rangeCount === 0) {
                        this._removeDomSelection();
                        this._removeFakeSelection();
                        return;
                    }
                    const t = this.domConverter.mapViewToDom(this.selection.editableElement);
                    if (!this.isFocused || !t) return;
                    if (this.selection.isFake) this._updateFakeSelection(t);
                    else if (this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected) {
                        this._removeFakeSelection();
                        this._updateDomSelection(t);
                    } else if (!(this.isComposing && c.isAndroid)) this._updateDomSelection(t);
                }
                _updateFakeSelection(t) {
                    const e = t.ownerDocument;
                    if (!this._fakeSelectionContainer) this._fakeSelectionContainer = yg(e);
                    const n = this._fakeSelectionContainer;
                    this.domConverter.bindFakeSelection(n, this.selection);
                    if (!this._fakeSelectionNeedsUpdate(t)) return;
                    if (!n.parentElement || n.parentElement != t) t.appendChild(n);
                    n.textContent = this.selection.fakeSelectionLabel || "\xa0";
                    const o = e.getSelection();
                    const i = e.createRange();
                    o.removeAllRanges();
                    i.selectNodeContents(n);
                    o.addRange(i);
                }
                _updateDomSelection(t) {
                    const e = t.ownerDocument.defaultView.getSelection();
                    if (!this._domSelectionNeedsUpdate(e)) return;
                    const n = this.domConverter.viewPositionToDom(this.selection.anchor);
                    const o = this.domConverter.viewPositionToDom(this.selection.focus);
                    e.setBaseAndExtent(n.parent, n.offset, o.parent, o.offset);
                    if (c.isGecko) vg(o, e);
                }
                _domSelectionNeedsUpdate(t) {
                    if (!this.domConverter.isDomSelectionCorrect(t)) return true;
                    const e = t && this.domConverter.domSelectionToView(t);
                    if (e && this.selection.isEqual(e)) return false;
                    if (!this.selection.isCollapsed && this.selection.isSimilar(e)) return false;
                    return true;
                }
                _fakeSelectionNeedsUpdate(t) {
                    const e = this._fakeSelectionContainer;
                    const n = t.ownerDocument.getSelection();
                    if (!e || e.parentElement !== t) return true;
                    if (n.anchorNode !== e && !e.contains(n.anchorNode)) return true;
                    return e.textContent !== this.selection.fakeSelectionLabel;
                }
                _removeDomSelection() {
                    for (const t of this.domDocuments){
                        const e = t.getSelection();
                        if (e.rangeCount) {
                            const n = t.activeElement;
                            const o = this.domConverter.mapDomToView(n);
                            if (n && o) e.removeAllRanges();
                        }
                    }
                }
                _removeFakeSelection() {
                    const t = this._fakeSelectionContainer;
                    if (t) t.remove();
                }
                _updateFocus() {
                    if (this.isFocused) {
                        const t = this.selection.editableElement;
                        if (t) this.domConverter.focus(t);
                    }
                }
            }
            function kg(t) {
                if (t.getAttribute("contenteditable") == "false") return false;
                const e = t.findAncestor((t)=>t.hasAttribute("contenteditable"));
                return !e || e.getAttribute("contenteditable") == "true";
            }
            function bg(t, e, n) {
                const o = e instanceof Array ? e : e.childNodes;
                const i = o[n];
                if (rc(i)) {
                    i.data = sg + i.data;
                    return i;
                } else {
                    const i = t.createTextNode(sg);
                    if (Array.isArray(e)) o.splice(n, 0, i);
                    else Ac(e, n, i);
                    return i;
                }
            }
            function wg(t, e) {
                return Ua(t) && Ua(e) && !rc(t) && !rc(e) && !vc(t) && !vc(e) && t.tagName.toLowerCase() === e.tagName.toLowerCase();
            }
            function _g(t, e) {
                return Ua(t) && Ua(e) && rc(t) && rc(e);
            }
            function Ag(t, e, n) {
                if (e === n) return true;
                else if (rc(e) && rc(n)) return e.data === n.data;
                else if (t.isBlockFiller(e) && t.isBlockFiller(n)) return true;
                return false;
            }
            function vg(t, e) {
                const n = t.parent;
                if (n.nodeType != Node.ELEMENT_NODE || t.offset != n.childNodes.length - 1) return;
                const o = n.childNodes[t.offset];
                if (o && o.tagName == "BR") e.addRange(e.getRangeAt(0));
            }
            function Cg(t, e) {
                const n = Array.from(t);
                if (n.length == 0 || !e) return n;
                const o = n[n.length - 1];
                if (o == e) n.pop();
                return n;
            }
            function yg(t) {
                const e = t.createElement("div");
                e.className = "ck-fake-selection-container";
                Object.assign(e.style, {
                    position: "fixed",
                    top: 0,
                    left: "-9999px",
                    width: "42px"
                });
                e.textContent = "\xa0";
                return e;
            }
            function xg(t, e) {
                const n = t.data;
                if (n == e) return;
                const o = k(n, e);
                for (const e of o)if (e.type === "insert") t.insertData(e.index, e.values.join(""));
                else t.deleteData(e.index, e.howMany);
            }
            const Eg = ig(ec.document);
            const Dg = ng(ec.document);
            const Sg = og(ec.document);
            const Tg = "data-ck-unsafe-attribute-";
            const Bg = "data-ck-unsafe-element";
            class Pg {
                constructor(t, { blockFillerMode: e, renderingMode: n = "editing" } = {}){
                    this._domToViewMapping = new WeakMap;
                    this._viewToDomMapping = new WeakMap;
                    this._fakeSelectionMapping = new WeakMap;
                    this._rawContentElementMatcher = new ah;
                    this._inlineObjectElementMatcher = new ah;
                    this.document = t;
                    this.renderingMode = n;
                    this.blockFillerMode = e || (n === "editing" ? "br" : "nbsp");
                    this.preElements = [
                        "pre"
                    ];
                    this.blockElements = [
                        "address",
                        "article",
                        "aside",
                        "blockquote",
                        "caption",
                        "center",
                        "dd",
                        "details",
                        "dir",
                        "div",
                        "dl",
                        "dt",
                        "fieldset",
                        "figcaption",
                        "figure",
                        "footer",
                        "form",
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6",
                        "header",
                        "hgroup",
                        "legend",
                        "li",
                        "main",
                        "menu",
                        "nav",
                        "ol",
                        "p",
                        "pre",
                        "section",
                        "summary",
                        "table",
                        "tbody",
                        "td",
                        "tfoot",
                        "th",
                        "thead",
                        "tr",
                        "ul"
                    ];
                    this.inlineObjectElements = [
                        "object",
                        "iframe",
                        "input",
                        "button",
                        "textarea",
                        "select",
                        "option",
                        "video",
                        "embed",
                        "audio",
                        "img",
                        "canvas"
                    ];
                    this.unsafeElements = [
                        "script",
                        "style"
                    ];
                    this._domDocument = this.renderingMode === "editing" ? ec.document : ec.document.implementation.createHTMLDocument("");
                }
                bindFakeSelection(t, e) {
                    this._fakeSelectionMapping.set(t, new wp(e));
                }
                fakeSelectionToView(t) {
                    return this._fakeSelectionMapping.get(t);
                }
                bindElements(t, e) {
                    this._domToViewMapping.set(t, e);
                    this._viewToDomMapping.set(e, t);
                }
                unbindDomElement(t) {
                    const e = this._domToViewMapping.get(t);
                    if (e) {
                        this._domToViewMapping.delete(t);
                        this._viewToDomMapping.delete(e);
                        for (const e of Array.from(t.children))this.unbindDomElement(e);
                    }
                }
                bindDocumentFragments(t, e) {
                    this._domToViewMapping.set(t, e);
                    this._viewToDomMapping.set(e, t);
                }
                shouldRenderAttribute(t, e, n) {
                    if (this.renderingMode === "data") return true;
                    t = t.toLowerCase();
                    if (t.startsWith("on")) return false;
                    if (t === "srcdoc" && e.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) return false;
                    if (n === "img" && (t === "src" || t === "srcset")) return true;
                    if (n === "source" && t === "srcset") return true;
                    if (e.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i)) return false;
                    return true;
                }
                setContentOf(t, e) {
                    if (this.renderingMode === "data") {
                        t.innerHTML = e;
                        return;
                    }
                    const n = (new DOMParser).parseFromString(e, "text/html");
                    const o = n.createDocumentFragment();
                    const i = n.body.childNodes;
                    while(i.length > 0)o.appendChild(i[0]);
                    const r = n.createTreeWalker(o, NodeFilter.SHOW_ELEMENT);
                    const s = [];
                    let a;
                    while(a = r.nextNode())s.push(a);
                    for (const t of s){
                        for (const e of t.getAttributeNames())this.setDomElementAttribute(t, e, t.getAttribute(e));
                        const e = t.tagName.toLowerCase();
                        if (this._shouldRenameElement(e)) {
                            Mg(e);
                            t.replaceWith(this._createReplacementDomElement(e, t));
                        }
                    }
                    while(t.firstChild)t.firstChild.remove();
                    t.append(o);
                }
                viewToDom(t, e = {}) {
                    if (t.is("$text")) {
                        const e = this._processDataFromViewText(t);
                        return this._domDocument.createTextNode(e);
                    } else {
                        if (this.mapViewToDom(t)) return this.mapViewToDom(t);
                        let n;
                        if (t.is("documentFragment")) {
                            n = this._domDocument.createDocumentFragment();
                            if (e.bind) this.bindDocumentFragments(n, t);
                        } else if (t.is("uiElement")) {
                            if (t.name === "$comment") n = this._domDocument.createComment(t.getCustomProperty("$rawContent"));
                            else n = t.render(this._domDocument, this);
                            if (e.bind) this.bindElements(n, t);
                            return n;
                        } else {
                            if (this._shouldRenameElement(t.name)) {
                                Mg(t.name);
                                n = this._createReplacementDomElement(t.name);
                            } else if (t.hasAttribute("xmlns")) n = this._domDocument.createElementNS(t.getAttribute("xmlns"), t.name);
                            else n = this._domDocument.createElement(t.name);
                            if (t.is("rawElement")) t.render(n, this);
                            if (e.bind) this.bindElements(n, t);
                            for (const e of t.getAttributeKeys())this.setDomElementAttribute(n, e, t.getAttribute(e), t);
                        }
                        if (e.withChildren !== false) for (const o of this.viewChildrenToDom(t, e))n.appendChild(o);
                        return n;
                    }
                }
                setDomElementAttribute(t, e, n, o) {
                    const i = this.shouldRenderAttribute(e, n, t.tagName.toLowerCase()) || o && o.shouldRenderUnsafeAttribute(e);
                    if (!i) O("domconverter-unsafe-attribute-detected", {
                        domElement: t,
                        key: e,
                        value: n
                    });
                    if (!Cc(e)) {
                        O("domconverter-invalid-attribute-detected", {
                            domElement: t,
                            key: e,
                            value: n
                        });
                        return;
                    }
                    if (t.hasAttribute(e) && !i) t.removeAttribute(e);
                    else if (t.hasAttribute(Tg + e) && i) t.removeAttribute(Tg + e);
                    t.setAttribute(i ? e : Tg + e, n);
                }
                removeDomElementAttribute(t, e) {
                    if (e == Bg) return;
                    t.removeAttribute(e);
                    t.removeAttribute(Tg + e);
                }
                *viewChildrenToDom(t, e = {}) {
                    const n = t.getFillerOffset && t.getFillerOffset();
                    let o = 0;
                    for (const i of t.getChildren()){
                        if (n === o) yield this._getBlockFiller();
                        const t = i.is("element") && !!i.getCustomProperty("dataPipeline:transparentRendering") && !fl(i.getAttributes());
                        if (t && this.renderingMode == "data") yield* this.viewChildrenToDom(i, e);
                        else {
                            if (t) O("domconverter-transparent-rendering-unsupported-in-editing-pipeline", {
                                viewElement: i
                            });
                            yield this.viewToDom(i, e);
                        }
                        o++;
                    }
                    if (n === o) yield this._getBlockFiller();
                }
                viewRangeToDom(t) {
                    const e = this.viewPositionToDom(t.start);
                    const n = this.viewPositionToDom(t.end);
                    const o = this._domDocument.createRange();
                    o.setStart(e.parent, e.offset);
                    o.setEnd(n.parent, n.offset);
                    return o;
                }
                viewPositionToDom(t) {
                    const e = t.parent;
                    if (e.is("$text")) {
                        const n = this.findCorrespondingDomText(e);
                        if (!n) return null;
                        let o = t.offset;
                        if (ag(n)) o += rg;
                        return {
                            parent: n,
                            offset: o
                        };
                    } else {
                        let n, o, i;
                        if (t.offset === 0) {
                            n = this.mapViewToDom(e);
                            if (!n) return null;
                            i = n.childNodes[0];
                        } else {
                            const e = t.nodeBefore;
                            o = e.is("$text") ? this.findCorrespondingDomText(e) : this.mapViewToDom(e);
                            if (!o) return null;
                            n = o.parentNode;
                            i = o.nextSibling;
                        }
                        if (rc(i) && ag(i)) return {
                            parent: i,
                            offset: rg
                        };
                        const r = o ? _c(o) + 1 : 0;
                        return {
                            parent: n,
                            offset: r
                        };
                    }
                }
                domToView(t, e = {}) {
                    const n = [];
                    const o = this._domToView(t, e, n);
                    const i = o.next().value;
                    if (!i) return null;
                    o.next();
                    this._processDomInlineNodes(null, n, e);
                    if (i.is("$text") && i.data.length == 0) return null;
                    return i;
                }
                *domChildrenToView(t, e = {}, n = []) {
                    for(let o = 0; o < t.childNodes.length; o++){
                        const i = t.childNodes[o];
                        const r = this._domToView(i, e, n);
                        const s = r.next().value;
                        if (s !== null) {
                            if (this._isBlockViewElement(s)) this._processDomInlineNodes(t, n, e);
                            yield s;
                            r.next();
                        }
                    }
                    this._processDomInlineNodes(t, n, e);
                }
                domSelectionToView(t) {
                    if (Lg(t)) return new wp([]);
                    if (t.rangeCount === 1) {
                        let e = t.getRangeAt(0).startContainer;
                        if (rc(e)) e = e.parentNode;
                        const n = this.fakeSelectionToView(e);
                        if (n) return n;
                    }
                    const e = this.isDomSelectionBackward(t);
                    const n = [];
                    for(let e = 0; e < t.rangeCount; e++){
                        const o = t.getRangeAt(e);
                        const i = this.domRangeToView(o);
                        if (i) n.push(i);
                    }
                    return new wp(n, {
                        backward: e
                    });
                }
                domRangeToView(t) {
                    const e = this.domPositionToView(t.startContainer, t.startOffset);
                    const n = this.domPositionToView(t.endContainer, t.endOffset);
                    if (e && n) return new kp(e, n);
                    return null;
                }
                domPositionToView(t, e = 0) {
                    if (this.isBlockFiller(t)) return this.domPositionToView(t.parentNode, _c(t));
                    const n = this.mapDomToView(t);
                    if (n && (n.is("uiElement") || n.is("rawElement"))) return mp._createBefore(n);
                    if (rc(t)) {
                        if (cg(t)) return this.domPositionToView(t.parentNode, _c(t));
                        const n = this.findCorrespondingViewText(t);
                        let o = e;
                        if (!n) return null;
                        if (ag(t)) {
                            o -= rg;
                            o = o < 0 ? 0 : o;
                        }
                        return new mp(n, o);
                    } else {
                        if (e === 0) {
                            const e = this.mapDomToView(t);
                            if (e) return new mp(e, 0);
                        } else {
                            const n = t.childNodes[e - 1];
                            if (rc(n) && cg(n) || n && this.isBlockFiller(n)) return this.domPositionToView(n.parentNode, _c(n));
                            const o = rc(n) ? this.findCorrespondingViewText(n) : this.mapDomToView(n);
                            if (o && o.parent) return new mp(o.parent, o.index + 1);
                        }
                        return null;
                    }
                }
                mapDomToView(t) {
                    const e = this.getHostViewElement(t);
                    return e || this._domToViewMapping.get(t);
                }
                findCorrespondingViewText(t) {
                    if (cg(t)) return null;
                    const e = this.getHostViewElement(t);
                    if (e) return e;
                    const n = t.previousSibling;
                    if (n) {
                        if (!this.isElement(n)) return null;
                        const t = this.mapDomToView(n);
                        if (t) {
                            const e = t.nextSibling;
                            if (e instanceof rh) return e;
                            else return null;
                        }
                    } else {
                        const e = this.mapDomToView(t.parentNode);
                        if (e) {
                            const t = e.getChild(0);
                            if (t instanceof rh) return t;
                            else return null;
                        }
                    }
                    return null;
                }
                mapViewToDom(t) {
                    return this._viewToDomMapping.get(t);
                }
                findCorrespondingDomText(t) {
                    const e = t.previousSibling;
                    if (e && this.mapViewToDom(e)) return this.mapViewToDom(e).nextSibling;
                    if (!e && t.parent && this.mapViewToDom(t.parent)) return this.mapViewToDom(t.parent).childNodes[0];
                    return null;
                }
                focus(t) {
                    const e = this.mapViewToDom(t);
                    if (e && e.ownerDocument.activeElement !== e) {
                        const { scrollX: t, scrollY: n } = ec.window;
                        const o = [];
                        Rg(e, (t)=>{
                            const { scrollLeft: e, scrollTop: n } = t;
                            o.push([
                                e,
                                n
                            ]);
                        });
                        e.focus();
                        Rg(e, (t)=>{
                            const [e, n] = o.shift();
                            t.scrollLeft = e;
                            t.scrollTop = n;
                        });
                        ec.window.scrollTo(t, n);
                    }
                }
                _clearDomSelection() {
                    const t = this.mapViewToDom(this.document.selection.editableElement);
                    if (!t) return;
                    const e = t.ownerDocument.defaultView.getSelection();
                    const n = this.domSelectionToView(e);
                    const o = n && n.rangeCount > 0;
                    if (o) e.removeAllRanges();
                }
                isElement(t) {
                    return t && t.nodeType == Node.ELEMENT_NODE;
                }
                isDocumentFragment(t) {
                    return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
                }
                isBlockFiller(t) {
                    if (this.blockFillerMode == "br") return t.isEqualNode(Eg);
                    if (t.tagName === "BR" && Vg(t, this.blockElements) && t.parentNode.childNodes.length === 1) return true;
                    return t.isEqualNode(Sg) || Og(t, this.blockElements);
                }
                isDomSelectionBackward(t) {
                    if (t.isCollapsed) return false;
                    const e = this._domDocument.createRange();
                    try {
                        e.setStart(t.anchorNode, t.anchorOffset);
                        e.setEnd(t.focusNode, t.focusOffset);
                    } catch (t) {
                        return false;
                    }
                    const n = e.collapsed;
                    e.detach();
                    return n;
                }
                getHostViewElement(t) {
                    const e = oc(t);
                    e.pop();
                    while(e.length){
                        const t = e.pop();
                        const n = this._domToViewMapping.get(t);
                        if (n && (n.is("uiElement") || n.is("rawElement"))) return n;
                    }
                    return null;
                }
                isDomSelectionCorrect(t) {
                    return this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) && this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset);
                }
                registerRawContentMatcher(t) {
                    this._rawContentElementMatcher.add(t);
                }
                registerInlineObjectMatcher(t) {
                    this._inlineObjectElementMatcher.add(t);
                }
                _getBlockFiller() {
                    switch(this.blockFillerMode){
                        case "nbsp":
                            return ng(this._domDocument);
                        case "markedNbsp":
                            return og(this._domDocument);
                        case "br":
                            return ig(this._domDocument);
                    }
                }
                _isDomSelectionPositionCorrect(t, e) {
                    if (rc(t) && ag(t) && e < rg) return false;
                    if (this.isElement(t) && ag(t.childNodes[e])) return false;
                    const n = this.mapDomToView(t);
                    if (n && (n.is("uiElement") || n.is("rawElement"))) return false;
                    return true;
                }
                *_domToView(t, e, n) {
                    if (this.isBlockFiller(t)) return null;
                    const o = this.getHostViewElement(t);
                    if (o) return o;
                    if (vc(t) && e.skipComments) return null;
                    if (rc(t)) {
                        if (cg(t)) return null;
                        else {
                            const e = t.data;
                            if (e === "") return null;
                            const o = new rh(this.document, e);
                            n.push(o);
                            return o;
                        }
                    } else {
                        let o = this.mapDomToView(t);
                        if (o) {
                            if (this._isInlineObjectElement(o)) n.push(o);
                            return o;
                        }
                        if (this.isDocumentFragment(t)) {
                            o = new jp(this.document);
                            if (e.bind) this.bindDocumentFragments(t, o);
                        } else {
                            o = this._createViewElement(t, e);
                            if (e.bind) this.bindElements(t, o);
                            const i = t.attributes;
                            if (i) for(let t = i.length, e = 0; e < t; e++)o._setAttribute(i[e].name, i[e].value);
                            if (this._isViewElementWithRawContent(o, e)) {
                                o._setCustomProperty("$rawContent", t.innerHTML);
                                if (!this._isBlockViewElement(o)) n.push(o);
                                return o;
                            }
                            if (vc(t)) {
                                o._setCustomProperty("$rawContent", t.data);
                                return o;
                            }
                        }
                        yield o;
                        const i = [];
                        if (e.withChildren !== false) for (const n of this.domChildrenToView(t, e, i))o._appendChild(n);
                        if (this._isInlineObjectElement(o)) n.push(o);
                        else for (const t of i)n.push(t);
                    }
                }
                _processDomInlineNodes(t, e, n) {
                    if (!e.length) return;
                    if (t && !this.isDocumentFragment(t) && !this._isBlockDomElement(t)) return;
                    let o = false;
                    for(let t = 0; t < e.length; t++){
                        const i = e[t];
                        if (!i.is("$text")) {
                            o = false;
                            continue;
                        }
                        let r;
                        let s = false;
                        if (Ig(i, this.preElements)) r = lg(i.data);
                        else {
                            r = i.data.replace(/[ \n\t\r]{1,}/g, " ");
                            s = /[^\S\u00A0]/.test(r.charAt(r.length - 1));
                            const a = t > 0 ? e[t - 1] : null;
                            const c = t + 1 < e.length ? e[t + 1] : null;
                            const l = !a || a.is("element") && a.name == "br" || o;
                            const d = c ? false : !ag(i.data);
                            if (n.withChildren !== false) {
                                if (l) r = r.replace(/^ /, "");
                                if (d) r = r.replace(/ $/, "");
                            }
                            r = lg(r);
                            r = r.replace(/ \u00A0/g, "  ");
                            const u = c && c.is("element") && c.name != "br";
                            const h = c && c.is("$text") && c.data.charAt(0) == " ";
                            if (/[ \u00A0]\u00A0$/.test(r) || !c || u || h) r = r.replace(/\u00A0$/, " ");
                            if (l || a && a.is("element") && a.name != "br") r = r.replace(/^\u00A0/, " ");
                        }
                        if (r.length == 0 && i.parent) {
                            i._remove();
                            e.splice(t, 1);
                            t--;
                        } else {
                            i._data = r;
                            o = s;
                        }
                    }
                    e.length = 0;
                }
                _processDataFromViewText(t) {
                    let e = t.data;
                    if (t.getAncestors().some((t)=>this.preElements.includes(t.name))) return e;
                    if (e.charAt(0) == " ") {
                        const n = this._getTouchingInlineViewNode(t, false);
                        const o = n && n.is("$textProxy") && this._nodeEndsWithSpace(n);
                        if (o || !n) e = "\xa0" + e.substr(1);
                    }
                    if (e.charAt(e.length - 1) == " ") {
                        const n = this._getTouchingInlineViewNode(t, true);
                        const o = n && n.is("$textProxy") && n.data.charAt(0) == " ";
                        if (e.charAt(e.length - 2) == " " || !n || o) e = e.substr(0, e.length - 1) + "\xa0";
                    }
                    return e.replace(/ {2}/g, " \xa0");
                }
                _nodeEndsWithSpace(t) {
                    if (t.getAncestors().some((t)=>this.preElements.includes(t.name))) return false;
                    const e = this._processDataFromViewText(t);
                    return e.charAt(e.length - 1) == " ";
                }
                _getTouchingInlineViewNode(t, e) {
                    const n = new gp({
                        startPosition: e ? mp._createAfter(t) : mp._createBefore(t),
                        direction: e ? "forward" : "backward"
                    });
                    for (const t of n){
                        if (t.item.is("element", "br")) return null;
                        else if (this._isInlineObjectElement(t.item)) return t.item;
                        else if (t.item.is("containerElement")) return null;
                        else if (t.item.is("$textProxy")) return t.item;
                    }
                    return null;
                }
                _isBlockDomElement(t) {
                    return this.isElement(t) && this.blockElements.includes(t.tagName.toLowerCase());
                }
                _isBlockViewElement(t) {
                    return t.is("element") && this.blockElements.includes(t.name);
                }
                _isInlineObjectElement(t) {
                    if (!t.is("element")) return false;
                    return t.name == "br" || this.inlineObjectElements.includes(t.name) || !!this._inlineObjectElementMatcher.match(t);
                }
                _createViewElement(t, e) {
                    if (vc(t)) return new Mp(this.document, "$comment");
                    const n = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase();
                    return new sp(this.document, n);
                }
                _isViewElementWithRawContent(t, e) {
                    return e.withChildren !== false && t.is("element") && !!this._rawContentElementMatcher.match(t);
                }
                _shouldRenameElement(t) {
                    const e = t.toLowerCase();
                    return this.renderingMode === "editing" && this.unsafeElements.includes(e);
                }
                _createReplacementDomElement(t, e) {
                    const n = this._domDocument.createElement("span");
                    n.setAttribute(Bg, t);
                    if (e) {
                        while(e.firstChild)n.appendChild(e.firstChild);
                        for (const t of e.getAttributeNames())n.setAttribute(t, e.getAttribute(t));
                    }
                    return n;
                }
            }
            function Ig(t, e) {
                return t.getAncestors().some((t)=>t.is("element") && e.includes(t.name));
            }
            function Rg(t, e) {
                let n = t;
                while(n){
                    e(n);
                    n = n.parentElement;
                }
            }
            function Og(t, e) {
                const n = t.isEqualNode(Dg);
                return n && Vg(t, e) && t.parentNode.childNodes.length === 1;
            }
            function Vg(t, e) {
                const n = t.parentNode;
                return !!n && !!n.tagName && e.includes(n.tagName.toLowerCase());
            }
            function Mg(t) {
                if (t === "script") O("domconverter-unsafe-script-element-detected");
                if (t === "style") O("domconverter-unsafe-style-element-detected");
            }
            function Lg(t) {
                if (!c.isGecko) return false;
                if (!t.rangeCount) return false;
                const e = t.getRangeAt(0).startContainer;
                try {
                    Object.prototype.toString.call(e);
                } catch (t) {
                    return true;
                }
                return false;
            }
            class zg extends Ja() {
                constructor(t){
                    super();
                    this._isEnabled = false;
                    this.view = t;
                    this.document = t.document;
                }
                get isEnabled() {
                    return this._isEnabled;
                }
                enable() {
                    this._isEnabled = true;
                }
                disable() {
                    this._isEnabled = false;
                }
                destroy() {
                    this.disable();
                    this.stopListening();
                }
                checkShouldIgnoreEventFromTarget(t) {
                    if (t && t.nodeType === 3) t = t.parentNode;
                    if (!t || t.nodeType !== 1) return false;
                    return t.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
                }
            }
            var Ng = Kf(function(t, e) {
                ko(e, tr(e), t);
            });
            const Fg = Ng;
            class Hg {
                constructor(t, e, n){
                    this.view = t;
                    this.document = t.document;
                    this.domEvent = e;
                    this.domTarget = e.target;
                    Fg(this, n);
                }
                get target() {
                    return this.view.domConverter.mapDomToView(this.domTarget);
                }
                preventDefault() {
                    this.domEvent.preventDefault();
                }
                stopPropagation() {
                    this.domEvent.stopPropagation();
                }
            }
            class jg extends zg {
                constructor(){
                    super(...arguments);
                    this.useCapture = false;
                }
                observe(t) {
                    const e = typeof this.domEventType == "string" ? [
                        this.domEventType
                    ] : this.domEventType;
                    e.forEach((e)=>{
                        this.listenTo(t, e, (t, e)=>{
                            if (this.isEnabled && !this.checkShouldIgnoreEventFromTarget(e.target)) this.onDomEvent(e);
                        }, {
                            useCapture: this.useCapture
                        });
                    });
                }
                stopObserving(t) {
                    this.stopListening(t);
                }
                fire(t, e, n) {
                    if (this.isEnabled) this.document.fire(t, new Hg(this.view, e, n));
                }
            }
            class qg extends jg {
                constructor(){
                    super(...arguments);
                    this.domEventType = [
                        "keydown",
                        "keyup"
                    ];
                }
                onDomEvent(t) {
                    const e = {
                        keyCode: t.keyCode,
                        altKey: t.altKey,
                        ctrlKey: t.ctrlKey,
                        shiftKey: t.shiftKey,
                        metaKey: t.metaKey,
                        get keystroke () {
                            return Uc(this);
                        }
                    };
                    this.fire(t.type, t, e);
                }
            }
            var Wg = function() {
                return Pt.Date.now();
            };
            const $g = Wg;
            var Gg = /\s/;
            function Ug(t) {
                var e = t.length;
                while(e-- && Gg.test(t.charAt(e)));
                return e;
            }
            const Kg = Ug;
            var Zg = /^\s+/;
            function Jg(t) {
                return t ? t.slice(0, Kg(t) + 1).replace(Zg, "") : t;
            }
            const Yg = Jg;
            var Qg = 0 / 0;
            var Xg = /^[-+]0x[0-9a-f]+$/i;
            var tm = /^0b[01]+$/i;
            var em = /^0o[0-7]+$/i;
            var nm = parseInt;
            function om(t) {
                if (typeof t == "number") return t;
                if (wh(t)) return Qg;
                if (rt(t)) {
                    var e = typeof t.valueOf == "function" ? t.valueOf() : t;
                    t = rt(e) ? e + "" : e;
                }
                if (typeof t != "string") return t === 0 ? t : +t;
                t = Yg(t);
                var n = tm.test(t);
                return n || em.test(t) ? nm(t.slice(2), n ? 2 : 8) : Xg.test(t) ? Qg : +t;
            }
            const im = om;
            var rm = "Expected a function";
            var sm = Math.max, am = Math.min;
            function cm(t, e, n) {
                var o, i, r, s, a, c, l = 0, d = false, u = false, h = true;
                if (typeof t != "function") throw new TypeError(rm);
                e = im(e) || 0;
                if (rt(n)) {
                    d = !!n.leading;
                    u = "maxWait" in n;
                    r = u ? sm(im(n.maxWait) || 0, e) : r;
                    h = "trailing" in n ? !!n.trailing : h;
                }
                function f(e) {
                    var n = o, r = i;
                    o = i = undefined;
                    l = e;
                    s = t.apply(r, n);
                    return s;
                }
                function p(t) {
                    l = t;
                    a = setTimeout(k, e);
                    return d ? f(t) : s;
                }
                function g(t) {
                    var n = t - c, o = t - l, i = e - n;
                    return u ? am(i, r - o) : i;
                }
                function m(t) {
                    var n = t - c, o = t - l;
                    return c === undefined || n >= e || n < 0 || u && o >= r;
                }
                function k() {
                    var t = $g();
                    if (m(t)) return b(t);
                    a = setTimeout(k, g(t));
                }
                function b(t) {
                    a = undefined;
                    if (h && o) return f(t);
                    o = i = undefined;
                    return s;
                }
                function w() {
                    if (a !== undefined) clearTimeout(a);
                    l = 0;
                    o = c = i = a = undefined;
                }
                function _() {
                    return a === undefined ? s : b($g());
                }
                function A() {
                    var t = $g(), n = m(t);
                    o = arguments;
                    i = this;
                    c = t;
                    if (n) {
                        if (a === undefined) return p(c);
                        if (u) {
                            clearTimeout(a);
                            a = setTimeout(k, e);
                            return f(c);
                        }
                    }
                    if (a === undefined) a = setTimeout(k, e);
                    return s;
                }
                A.cancel = w;
                A.flush = _;
                return A;
            }
            const lm = cm;
            class dm extends zg {
                constructor(t){
                    super(t);
                    this._fireSelectionChangeDoneDebounced = lm((t)=>{
                        this.document.fire("selectionChangeDone", t);
                    }, 200);
                }
                observe() {
                    const t = this.document;
                    t.on("arrowKey", (e, n)=>{
                        const o = t.selection;
                        if (o.isFake && this.isEnabled) n.preventDefault();
                    }, {
                        context: "$capture"
                    });
                    t.on("arrowKey", (e, n)=>{
                        const o = t.selection;
                        if (o.isFake && this.isEnabled) this._handleSelectionMove(n.keyCode);
                    }, {
                        priority: "lowest"
                    });
                }
                stopObserving() {}
                destroy() {
                    super.destroy();
                    this._fireSelectionChangeDoneDebounced.cancel();
                }
                _handleSelectionMove(t) {
                    const e = this.document.selection;
                    const n = new wp(e.getRanges(), {
                        backward: e.isBackward,
                        fake: false
                    });
                    if (t == $c.arrowleft || t == $c.arrowup) n.setTo(n.getFirstPosition());
                    if (t == $c.arrowright || t == $c.arrowdown) n.setTo(n.getLastPosition());
                    const o = {
                        oldSelection: e,
                        newSelection: n,
                        domSelection: null
                    };
                    this.document.fire("selectionChange", o);
                    this._fireSelectionChangeDoneDebounced(o);
                }
            }
            var um = "__lodash_hash_undefined__";
            function hm(t) {
                this.__data__.set(t, um);
                return this;
            }
            const fm = hm;
            function pm(t) {
                return this.__data__.has(t);
            }
            const gm = pm;
            function mm(t) {
                var e = -1, n = t == null ? 0 : t.length;
                this.__data__ = new Xn;
                while(++e < n)this.add(t[e]);
            }
            mm.prototype.add = mm.prototype.push = fm;
            mm.prototype.has = gm;
            const km = mm;
            function bm(t, e) {
                var n = -1, o = t == null ? 0 : t.length;
                while(++n < o){
                    if (e(t[n], n, t)) return true;
                }
                return false;
            }
            const wm = bm;
            function _m(t, e) {
                return t.has(e);
            }
            const Am = _m;
            var vm = 1, Cm = 2;
            function ym(t, e, n, o, i, r) {
                var s = n & vm, a = t.length, c = e.length;
                if (a != c && !(s && c > a)) return false;
                var l = r.get(t);
                var d = r.get(e);
                if (l && d) return l == e && d == t;
                var u = -1, h = true, f = n & Cm ? new km : undefined;
                r.set(t, e);
                r.set(e, t);
                while(++u < a){
                    var p = t[u], g = e[u];
                    if (o) var m = s ? o(g, p, u, e, t, r) : o(p, g, u, t, e, r);
                    if (m !== undefined) {
                        if (m) continue;
                        h = false;
                        break;
                    }
                    if (f) {
                        if (!wm(e, function(t, e) {
                            if (!Am(f, e) && (p === t || i(p, t, n, o, r))) return f.push(e);
                        })) {
                            h = false;
                            break;
                        }
                    } else if (!(p === g || i(p, g, n, o, r))) {
                        h = false;
                        break;
                    }
                }
                r["delete"](t);
                r["delete"](e);
                return h;
            }
            const xm = ym;
            function Em(t) {
                var e = -1, n = Array(t.size);
                t.forEach(function(t, o) {
                    n[++e] = [
                        o,
                        t
                    ];
                });
                return n;
            }
            const Dm = Em;
            function Sm(t) {
                var e = -1, n = Array(t.size);
                t.forEach(function(t) {
                    n[++e] = t;
                });
                return n;
            }
            const Tm = Sm;
            var Bm = 1, Pm = 2;
            var Im = "[object Boolean]", Rm = "[object Date]", Om = "[object Error]", Vm = "[object Map]", Mm = "[object Number]", Lm = "[object RegExp]", zm = "[object Set]", Nm = "[object String]", Fm = "[object Symbol]";
            var Hm = "[object ArrayBuffer]", jm = "[object DataView]";
            var qm = Rt ? Rt.prototype : undefined, Wm = qm ? qm.valueOf : undefined;
            function $m(t, e, n, o, i, r, s) {
                switch(n){
                    case jm:
                        if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) return false;
                        t = t.buffer;
                        e = e.buffer;
                    case Hm:
                        if (t.byteLength != e.byteLength || !r(new cs(t), new cs(e))) return false;
                        return true;
                    case Im:
                    case Rm:
                    case Mm:
                        return be(+t, +e);
                    case Om:
                        return t.name == e.name && t.message == e.message;
                    case Lm:
                    case Nm:
                        return t == e + "";
                    case Vm:
                        var a = Dm;
                    case zm:
                        var c = o & Bm;
                        a || (a = Tm);
                        if (t.size != e.size && !c) return false;
                        var l = s.get(t);
                        if (l) return l == e;
                        o |= Pm;
                        s.set(t, e);
                        var d = xm(a(t), a(e), o, i, r, s);
                        s["delete"](t);
                        return d;
                    case Fm:
                        if (Wm) return Wm.call(t) == Wm.call(e);
                }
                return false;
            }
            const Gm = $m;
            var Um = 1;
            var Km = Object.prototype;
            var Zm = Km.hasOwnProperty;
            function Jm(t, e, n, o, i, r) {
                var s = n & Um, a = Rr(t), c = a.length, l = Rr(e), d = l.length;
                if (c != d && !s) return false;
                var u = c;
                while(u--){
                    var h = a[u];
                    if (!(s ? h in e : Zm.call(e, h))) return false;
                }
                var f = r.get(t);
                var p = r.get(e);
                if (f && p) return f == e && p == t;
                var g = true;
                r.set(t, e);
                r.set(e, t);
                var m = s;
                while(++u < c){
                    h = a[u];
                    var k = t[h], b = e[h];
                    if (o) var w = s ? o(b, k, h, e, t, r) : o(k, b, h, t, e, r);
                    if (!(w === undefined ? k === b || i(k, b, n, o, r) : w)) {
                        g = false;
                        break;
                    }
                    m || (m = h == "constructor");
                }
                if (g && !m) {
                    var _ = t.constructor, A = e.constructor;
                    if (_ != A && "constructor" in t && "constructor" in e && !(typeof _ == "function" && _ instanceof _ && typeof A == "function" && A instanceof A)) g = false;
                }
                r["delete"](t);
                r["delete"](e);
                return g;
            }
            const Ym = Jm;
            var Qm = 1;
            var Xm = "[object Arguments]", tk = "[object Array]", ek = "[object Object]";
            var nk = Object.prototype;
            var ok = nk.hasOwnProperty;
            function ik(t, e, n, o, i, r) {
                var s = Jt(t), a = Jt(e), c = s ? tk : ns(t), l = a ? tk : ns(e);
                c = c == Xm ? ek : c;
                l = l == Xm ? ek : l;
                var d = c == ek, u = l == ek, h = c == l;
                if (h && Mo(t)) {
                    if (!Mo(e)) return false;
                    s = true;
                    d = false;
                }
                if (h && !d) {
                    r || (r = new io);
                    return s || Di(t) ? xm(t, e, n, o, i, r) : Gm(t, e, c, n, o, i, r);
                }
                if (!(n & Qm)) {
                    var f = d && ok.call(t, "__wrapped__"), p = u && ok.call(e, "__wrapped__");
                    if (f || p) {
                        var g = f ? t.value() : t, m = p ? e.value() : e;
                        r || (r = new io);
                        return i(g, m, n, o, r);
                    }
                }
                if (!h) return false;
                r || (r = new io);
                return Ym(t, e, n, o, i, r);
            }
            const rk = ik;
            function sk(t, e, n, o, i) {
                if (t === e) return true;
                if (t == null || e == null || !Qt(t) && !Qt(e)) return t !== t && e !== e;
                return rk(t, e, n, o, sk, i);
            }
            const ak = sk;
            function ck(t, e, n) {
                n = typeof n == "function" ? n : undefined;
                var o = n ? n(t, e) : undefined;
                return o === undefined ? ak(t, e, undefined, n) : !!o;
            }
            const lk = ck;
            class dk extends zg {
                constructor(t){
                    super(t);
                    this._config = {
                        childList: true,
                        characterData: true,
                        subtree: true
                    };
                    this.domConverter = t.domConverter;
                    this.renderer = t._renderer;
                    this._domElements = new Set;
                    this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
                }
                flush() {
                    this._onMutations(this._mutationObserver.takeRecords());
                }
                observe(t) {
                    this._domElements.add(t);
                    if (this.isEnabled) this._mutationObserver.observe(t, this._config);
                }
                stopObserving(t) {
                    this._domElements.delete(t);
                    if (this.isEnabled) {
                        this._mutationObserver.disconnect();
                        for (const t of this._domElements)this._mutationObserver.observe(t, this._config);
                    }
                }
                enable() {
                    super.enable();
                    for (const t of this._domElements)this._mutationObserver.observe(t, this._config);
                }
                disable() {
                    super.disable();
                    this._mutationObserver.disconnect();
                }
                destroy() {
                    super.destroy();
                    this._mutationObserver.disconnect();
                }
                _onMutations(t) {
                    if (t.length === 0) return;
                    const e = this.domConverter;
                    const n = new Set;
                    const o = new Set;
                    for (const n of t){
                        const t = e.mapDomToView(n.target);
                        if (!t) continue;
                        if (t.is("uiElement") || t.is("rawElement")) continue;
                        if (n.type === "childList" && !this._isBogusBrMutation(n)) o.add(t);
                    }
                    for (const i of t){
                        const t = e.mapDomToView(i.target);
                        if (t && (t.is("uiElement") || t.is("rawElement"))) continue;
                        if (i.type === "characterData") {
                            const t = e.findCorrespondingViewText(i.target);
                            if (t && !o.has(t.parent)) n.add(t);
                            else if (!t && ag(i.target)) o.add(e.mapDomToView(i.target.parentNode));
                        }
                    }
                    let i = false;
                    for (const t of n){
                        i = true;
                        this.renderer.markToSync("text", t);
                    }
                    for (const t of o){
                        const n = e.mapViewToDom(t);
                        const o = Array.from(t.getChildren());
                        const r = Array.from(e.domChildrenToView(n, {
                            withChildren: false
                        }));
                        if (!lk(o, r, uk)) {
                            i = true;
                            this.renderer.markToSync("children", t);
                        }
                    }
                    if (i) this.view.forceRender();
                }
                _isBogusBrMutation(t) {
                    let e = null;
                    if (t.nextSibling === null && t.removedNodes.length === 0 && t.addedNodes.length == 1) e = this.domConverter.domToView(t.addedNodes[0], {
                        withChildren: false
                    });
                    return e && e.is("element", "br");
                }
            }
            function uk(t, e) {
                if (Array.isArray(t)) return;
                if (t === e) return true;
                else if (t.is("$text") && e.is("$text")) return t.data === e.data;
                return false;
            }
            class hk extends jg {
                constructor(t){
                    super(t);
                    this._isFocusChanging = false;
                    this.domEventType = [
                        "focus",
                        "blur"
                    ];
                    this.useCapture = true;
                    const e = this.document;
                    e.on("focus", ()=>{
                        this._isFocusChanging = true;
                        this._renderTimeoutId = setTimeout(()=>{
                            this.flush();
                            t.change(()=>{});
                        }, 50);
                    });
                    e.on("blur", (n, o)=>{
                        const i = e.selection.editableElement;
                        if (i === null || i === o.target) {
                            e.isFocused = false;
                            this._isFocusChanging = false;
                            t.change(()=>{});
                        }
                    });
                }
                flush() {
                    if (this._isFocusChanging) {
                        this._isFocusChanging = false;
                        this.document.isFocused = true;
                    }
                }
                onDomEvent(t) {
                    this.fire(t.type, t);
                }
                destroy() {
                    if (this._renderTimeoutId) clearTimeout(this._renderTimeoutId);
                    super.destroy();
                }
            }
            class fk extends zg {
                constructor(t){
                    super(t);
                    this.mutationObserver = t.getObserver(dk);
                    this.focusObserver = t.getObserver(hk);
                    this.selection = this.document.selection;
                    this.domConverter = t.domConverter;
                    this._documents = new WeakSet;
                    this._fireSelectionChangeDoneDebounced = lm((t)=>{
                        this.document.fire("selectionChangeDone", t);
                    }, 200);
                    this._clearInfiniteLoopInterval = setInterval(()=>this._clearInfiniteLoop(), 1e3);
                    this._documentIsSelectingInactivityTimeoutDebounced = lm(()=>this.document.isSelecting = false, 5e3);
                    this._loopbackCounter = 0;
                }
                observe(t) {
                    const e = t.ownerDocument;
                    const n = ()=>{
                        this.document.isSelecting = true;
                        this._documentIsSelectingInactivityTimeoutDebounced();
                    };
                    const o = ()=>{
                        if (!this.document.isSelecting) return;
                        this._handleSelectionChange(null, e);
                        this.document.isSelecting = false;
                        this._documentIsSelectingInactivityTimeoutDebounced.cancel();
                    };
                    this.listenTo(t, "selectstart", n, {
                        priority: "highest"
                    });
                    this.listenTo(t, "keydown", o, {
                        priority: "highest",
                        useCapture: true
                    });
                    this.listenTo(t, "keyup", o, {
                        priority: "highest",
                        useCapture: true
                    });
                    if (this._documents.has(e)) return;
                    this.listenTo(e, "mouseup", o, {
                        priority: "highest",
                        useCapture: true
                    });
                    this.listenTo(e, "selectionchange", (t, n)=>{
                        if (this.document.isComposing && !c.isAndroid) return;
                        this._handleSelectionChange(n, e);
                        this._documentIsSelectingInactivityTimeoutDebounced();
                    });
                    this._documents.add(e);
                }
                stopObserving(t) {
                    this.stopListening(t);
                }
                destroy() {
                    super.destroy();
                    clearInterval(this._clearInfiniteLoopInterval);
                    this._fireSelectionChangeDoneDebounced.cancel();
                    this._documentIsSelectingInactivityTimeoutDebounced.cancel();
                }
                _reportInfiniteLoop() {}
                _handleSelectionChange(t, e) {
                    if (!this.isEnabled) return;
                    const n = e.defaultView.getSelection();
                    if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) return;
                    this.mutationObserver.flush();
                    const o = this.domConverter.domSelectionToView(n);
                    if (o.rangeCount == 0) {
                        this.view.hasDomSelection = false;
                        return;
                    }
                    this.view.hasDomSelection = true;
                    this.focusObserver.flush();
                    if (this.selection.isEqual(o) && this.domConverter.isDomSelectionCorrect(n)) return;
                    if (++this._loopbackCounter > 60) {
                        this._reportInfiniteLoop();
                        return;
                    }
                    if (this.selection.isSimilar(o)) this.view.forceRender();
                    else {
                        const t = {
                            oldSelection: this.selection,
                            newSelection: o,
                            domSelection: n
                        };
                        this.document.fire("selectionChange", t);
                        this._fireSelectionChangeDoneDebounced(t);
                    }
                }
                _clearInfiniteLoop() {
                    this._loopbackCounter = 0;
                }
            }
            class pk extends jg {
                constructor(t){
                    super(t);
                    this.domEventType = [
                        "compositionstart",
                        "compositionupdate",
                        "compositionend"
                    ];
                    const e = this.document;
                    e.on("compositionstart", ()=>{
                        e.isComposing = true;
                    }, {
                        priority: "low"
                    });
                    e.on("compositionend", ()=>{
                        e.isComposing = false;
                    }, {
                        priority: "low"
                    });
                }
                onDomEvent(t) {
                    this.fire(t.type, t, {
                        data: t.data
                    });
                }
            }
            class gk {
                constructor(t, e = {}){
                    this._files = e.cacheFiles ? mk(t) : null;
                    this._native = t;
                }
                get files() {
                    if (!this._files) this._files = mk(this._native);
                    return this._files;
                }
                get types() {
                    return this._native.types;
                }
                getData(t) {
                    return this._native.getData(t);
                }
                setData(t, e) {
                    this._native.setData(t, e);
                }
                set effectAllowed(t) {
                    this._native.effectAllowed = t;
                }
                get effectAllowed() {
                    return this._native.effectAllowed;
                }
                set dropEffect(t) {
                    this._native.dropEffect = t;
                }
                get dropEffect() {
                    return this._native.dropEffect;
                }
                setDragImage(t, e, n) {
                    this._native.setDragImage(t, e, n);
                }
                get isCanceled() {
                    return this._native.dropEffect == "none" || !!this._native.mozUserCancelled;
                }
            }
            function mk(t) {
                const e = Array.from(t.files || []);
                const n = Array.from(t.items || []);
                if (e.length) return e;
                return n.filter((t)=>t.kind === "file").map((t)=>t.getAsFile());
            }
            class kk extends jg {
                constructor(){
                    super(...arguments);
                    this.domEventType = "beforeinput";
                }
                onDomEvent(t) {
                    const e = t.getTargetRanges();
                    const n = this.view;
                    const o = n.document;
                    let i = null;
                    let r = null;
                    let s = [];
                    if (t.dataTransfer) i = new gk(t.dataTransfer);
                    if (t.data !== null) r = t.data;
                    else if (i) r = i.getData("text/plain");
                    if (o.selection.isFake) s = Array.from(o.selection.getRanges());
                    else if (e.length) s = e.map((t)=>{
                        const e = n.domConverter.domPositionToView(t.startContainer, t.startOffset);
                        const o = n.domConverter.domPositionToView(t.endContainer, t.endOffset);
                        if (e) return n.createRange(e, o);
                        else if (o) return n.createRange(o);
                    }).filter((t)=>!!t);
                    else if (c.isAndroid) {
                        const e = t.target.ownerDocument.defaultView.getSelection();
                        s = Array.from(n.domConverter.domSelectionToView(e).getRanges());
                    }
                    if (c.isAndroid && t.inputType == "insertCompositionText" && r && r.endsWith("\n")) {
                        this.fire(t.type, t, {
                            inputType: "insertParagraph",
                            targetRanges: [
                                n.createRange(s[0].end)
                            ]
                        });
                        return;
                    }
                    if (t.inputType == "insertText" && r && r.includes("\n")) {
                        const e = r.split(/\n{1,2}/g);
                        let n = s;
                        for(let r = 0; r < e.length; r++){
                            const s = e[r];
                            if (s != "") {
                                this.fire(t.type, t, {
                                    data: s,
                                    dataTransfer: i,
                                    targetRanges: n,
                                    inputType: t.inputType,
                                    isComposing: t.isComposing
                                });
                                n = [
                                    o.selection.getFirstRange()
                                ];
                            }
                            if (r + 1 < e.length) {
                                this.fire(t.type, t, {
                                    inputType: "insertParagraph",
                                    targetRanges: n
                                });
                                n = [
                                    o.selection.getFirstRange()
                                ];
                            }
                        }
                        return;
                    }
                    this.fire(t.type, t, {
                        data: r,
                        dataTransfer: i,
                        targetRanges: s,
                        inputType: t.inputType,
                        isComposing: t.isComposing
                    });
                }
            }
            class bk extends zg {
                constructor(t){
                    super(t);
                    this.document.on("keydown", (t, e)=>{
                        if (this.isEnabled && Jc(e.keyCode)) {
                            const n = new Ap(this.document, "arrowKey", this.document.selection.getFirstRange());
                            this.document.fire(n, e);
                            if (n.stop.called) t.stop();
                        }
                    });
                }
                observe() {}
                stopObserving() {}
            }
            class wk extends zg {
                constructor(t){
                    super(t);
                    const e = this.document;
                    e.on("keydown", (t, n)=>{
                        if (!this.isEnabled || n.keyCode != $c.tab || n.ctrlKey) return;
                        const o = new Ap(e, "tab", e.selection.getFirstRange());
                        e.fire(o, n);
                        if (o.stop.called) t.stop();
                    });
                }
                observe() {}
                stopObserving() {}
            }
            var _k = 1, Ak = 4;
            function vk(t) {
                return La(t, _k | Ak);
            }
            const Ck = vk;
            class yk extends ht() {
                constructor(t){
                    super();
                    this.domRoots = new Map;
                    this._initialDomRootAttributes = new WeakMap;
                    this._observers = new Map;
                    this._ongoingChange = false;
                    this._postFixersInProgress = false;
                    this._renderingDisabled = false;
                    this._hasChangedSinceTheLastRendering = false;
                    this.document = new Tp(t);
                    this.domConverter = new Pg(this.document);
                    this.set("isRenderingInProgress", false);
                    this.set("hasDomSelection", false);
                    this._renderer = new mg(this.domConverter, this.document.selection);
                    this._renderer.bind("isFocused", "isSelecting", "isComposing").to(this.document, "isFocused", "isSelecting", "isComposing");
                    this._writer = new Wp(this.document);
                    this.addObserver(dk);
                    this.addObserver(hk);
                    this.addObserver(fk);
                    this.addObserver(qg);
                    this.addObserver(dm);
                    this.addObserver(pk);
                    this.addObserver(bk);
                    this.addObserver(kk);
                    this.addObserver(wk);
                    dg(this);
                    Lp(this);
                    this.on("render", ()=>{
                        this._render();
                        this.document.fire("layoutChanged");
                        this._hasChangedSinceTheLastRendering = false;
                    });
                    this.listenTo(this.document.selection, "change", ()=>{
                        this._hasChangedSinceTheLastRendering = true;
                    });
                    this.listenTo(this.document, "change:isFocused", ()=>{
                        this._hasChangedSinceTheLastRendering = true;
                    });
                    if (c.isiOS) this.listenTo(this.document, "blur", (t, e)=>{
                        const n = this.domConverter.mapDomToView(e.domEvent.relatedTarget);
                        if (!n) this.domConverter._clearDomSelection();
                    });
                }
                attachDomRoot(t, e = "main") {
                    const n = this.document.getRoot(e);
                    n._name = t.tagName.toLowerCase();
                    const o = {};
                    for (const { name: e, value: i } of Array.from(t.attributes)){
                        o[e] = i;
                        if (e === "class") this._writer.addClass(i.split(" "), n);
                        else this._writer.setAttribute(e, i, n);
                    }
                    this._initialDomRootAttributes.set(t, o);
                    const i = ()=>{
                        this._writer.setAttribute("contenteditable", (!n.isReadOnly).toString(), n);
                        if (n.isReadOnly) this._writer.addClass("ck-read-only", n);
                        else this._writer.removeClass("ck-read-only", n);
                    };
                    i();
                    this.domRoots.set(e, t);
                    this.domConverter.bindElements(t, n);
                    this._renderer.markToSync("children", n);
                    this._renderer.markToSync("attributes", n);
                    this._renderer.domDocuments.add(t.ownerDocument);
                    n.on("change:children", (t, e)=>this._renderer.markToSync("children", e));
                    n.on("change:attributes", (t, e)=>this._renderer.markToSync("attributes", e));
                    n.on("change:text", (t, e)=>this._renderer.markToSync("text", e));
                    n.on("change:isReadOnly", ()=>this.change(i));
                    n.on("change", ()=>{
                        this._hasChangedSinceTheLastRendering = true;
                    });
                    for (const n of this._observers.values())n.observe(t, e);
                }
                detachDomRoot(t) {
                    const e = this.domRoots.get(t);
                    Array.from(e.attributes).forEach(({ name: t })=>e.removeAttribute(t));
                    const n = this._initialDomRootAttributes.get(e);
                    for(const t in n)e.setAttribute(t, n[t]);
                    this.domRoots.delete(t);
                    this.domConverter.unbindDomElement(e);
                    for (const t of this._observers.values())t.stopObserving(e);
                }
                getDomRoot(t = "main") {
                    return this.domRoots.get(t);
                }
                addObserver(t) {
                    let e = this._observers.get(t);
                    if (e) return e;
                    e = new t(this);
                    this._observers.set(t, e);
                    for (const [t, n] of this.domRoots)e.observe(n, t);
                    e.enable();
                    return e;
                }
                getObserver(t) {
                    return this._observers.get(t);
                }
                disableObservers() {
                    for (const t of this._observers.values())t.disable();
                }
                enableObservers() {
                    for (const t of this._observers.values())t.enable();
                }
                scrollToTheSelection({ alignToTop: t, forceScroll: e, viewportOffset: n = 20, ancestorOffset: o = 20 } = {}) {
                    const i = this.document.selection.getFirstRange();
                    if (!i) return;
                    const r = Ck({
                        alignToTop: t,
                        forceScroll: e,
                        viewportOffset: n,
                        ancestorOffset: o
                    });
                    if (typeof n === "number") n = {
                        top: n,
                        bottom: n,
                        left: n,
                        right: n
                    };
                    const s = {
                        target: this.domConverter.viewRangeToDom(i),
                        viewportOffset: n,
                        ancestorOffset: o,
                        alignToTop: t,
                        forceScroll: e
                    };
                    this.fire("scrollToTheSelection", s, r);
                    Pc(s);
                }
                focus() {
                    if (!this.document.isFocused) {
                        const t = this.document.selection.editableElement;
                        if (t) {
                            this.domConverter.focus(t);
                            this.forceRender();
                        }
                    }
                }
                change(t) {
                    if (this.isRenderingInProgress || this._postFixersInProgress) throw new R("cannot-change-view-tree", this);
                    try {
                        if (this._ongoingChange) return t(this._writer);
                        this._ongoingChange = true;
                        const e = t(this._writer);
                        this._ongoingChange = false;
                        if (!this._renderingDisabled && this._hasChangedSinceTheLastRendering) {
                            this._postFixersInProgress = true;
                            this.document._callPostFixers(this._writer);
                            this._postFixersInProgress = false;
                            this.fire("render");
                        }
                        return e;
                    } catch (t) {
                        R.rethrowUnexpectedError(t, this);
                    }
                }
                forceRender() {
                    this._hasChangedSinceTheLastRendering = true;
                    this.getObserver(hk).flush();
                    this.change(()=>{});
                }
                destroy() {
                    for (const t of this._observers.values())t.destroy();
                    this.document.destroy();
                    this.stopListening();
                }
                createPositionAt(t, e) {
                    return mp._createAt(t, e);
                }
                createPositionAfter(t) {
                    return mp._createAfter(t);
                }
                createPositionBefore(t) {
                    return mp._createBefore(t);
                }
                createRange(t, e) {
                    return new kp(t, e);
                }
                createRangeOn(t) {
                    return kp._createOn(t);
                }
                createRangeIn(t) {
                    return kp._createIn(t);
                }
                createSelection(...t) {
                    return new wp(...t);
                }
                _disableRendering(t) {
                    this._renderingDisabled = t;
                    if (t == false) this.change(()=>{});
                }
                _render() {
                    this.isRenderingInProgress = true;
                    this.disableObservers();
                    this._renderer.render();
                    this.enableObservers();
                    this.isRenderingInProgress = false;
                }
            }
            class xk {
                is() {
                    throw new Error("is() method is abstract");
                }
            }
            class Ek extends xk {
                constructor(t){
                    super();
                    this.parent = null;
                    this._attrs = kl(t);
                }
                get document() {
                    return null;
                }
                get index() {
                    let t;
                    if (!this.parent) return null;
                    if ((t = this.parent.getChildIndex(this)) === null) throw new R("model-node-not-found-in-parent", this);
                    return t;
                }
                get startOffset() {
                    let t;
                    if (!this.parent) return null;
                    if ((t = this.parent.getChildStartOffset(this)) === null) throw new R("model-node-not-found-in-parent", this);
                    return t;
                }
                get offsetSize() {
                    return 1;
                }
                get endOffset() {
                    if (!this.parent) return null;
                    return this.startOffset + this.offsetSize;
                }
                get nextSibling() {
                    const t = this.index;
                    return t !== null && this.parent.getChild(t + 1) || null;
                }
                get previousSibling() {
                    const t = this.index;
                    return t !== null && this.parent.getChild(t - 1) || null;
                }
                get root() {
                    let t = this;
                    while(t.parent)t = t.parent;
                    return t;
                }
                isAttached() {
                    return this.parent === null ? false : this.root.isAttached();
                }
                getPath() {
                    const t = [];
                    let e = this;
                    while(e.parent){
                        t.unshift(e.startOffset);
                        e = e.parent;
                    }
                    return t;
                }
                getAncestors(t = {}) {
                    const e = [];
                    let n = t.includeSelf ? this : this.parent;
                    while(n){
                        e[t.parentFirst ? "push" : "unshift"](n);
                        n = n.parent;
                    }
                    return e;
                }
                getCommonAncestor(t, e = {}) {
                    const n = this.getAncestors(e);
                    const o = t.getAncestors(e);
                    let i = 0;
                    while(n[i] == o[i] && n[i])i++;
                    return i === 0 ? null : n[i - 1];
                }
                isBefore(t) {
                    if (this == t) return false;
                    if (this.root !== t.root) return false;
                    const e = this.getPath();
                    const n = t.getPath();
                    const o = xt(e, n);
                    switch(o){
                        case "prefix":
                            return true;
                        case "extension":
                            return false;
                        default:
                            return e[o] < n[o];
                    }
                }
                isAfter(t) {
                    if (this == t) return false;
                    if (this.root !== t.root) return false;
                    return !this.isBefore(t);
                }
                hasAttribute(t) {
                    return this._attrs.has(t);
                }
                getAttribute(t) {
                    return this._attrs.get(t);
                }
                getAttributes() {
                    return this._attrs.entries();
                }
                getAttributeKeys() {
                    return this._attrs.keys();
                }
                toJSON() {
                    const t = {};
                    if (this._attrs.size) t.attributes = Array.from(this._attrs).reduce((t, e)=>{
                        t[e[0]] = e[1];
                        return t;
                    }, {});
                    return t;
                }
                _clone(t) {
                    return new this.constructor(this._attrs);
                }
                _remove() {
                    this.parent._removeChildren(this.index);
                }
                _setAttribute(t, e) {
                    this._attrs.set(t, e);
                }
                _setAttributesTo(t) {
                    this._attrs = kl(t);
                }
                _removeAttribute(t) {
                    return this._attrs.delete(t);
                }
                _clearAttributes() {
                    this._attrs.clear();
                }
            }
            Ek.prototype.is = function(t) {
                return t === "node" || t === "model:node";
            };
            class Dk {
                constructor(t){
                    this._nodes = [];
                    if (t) this._insertNodes(0, t);
                }
                [Symbol.iterator]() {
                    return this._nodes[Symbol.iterator]();
                }
                get length() {
                    return this._nodes.length;
                }
                get maxOffset() {
                    return this._nodes.reduce((t, e)=>t + e.offsetSize, 0);
                }
                getNode(t) {
                    return this._nodes[t] || null;
                }
                getNodeIndex(t) {
                    const e = this._nodes.indexOf(t);
                    return e == -1 ? null : e;
                }
                getNodeStartOffset(t) {
                    const e = this.getNodeIndex(t);
                    return e === null ? null : this._nodes.slice(0, e).reduce((t, e)=>t + e.offsetSize, 0);
                }
                indexToOffset(t) {
                    if (t == this._nodes.length) return this.maxOffset;
                    const e = this._nodes[t];
                    if (!e) throw new R("model-nodelist-index-out-of-bounds", this);
                    return this.getNodeStartOffset(e);
                }
                offsetToIndex(t) {
                    let e = 0;
                    for (const n of this._nodes){
                        if (t >= e && t < e + n.offsetSize) return this.getNodeIndex(n);
                        e += n.offsetSize;
                    }
                    if (e != t) throw new R("model-nodelist-offset-out-of-bounds", this, {
                        offset: t,
                        nodeList: this
                    });
                    return this.length;
                }
                _insertNodes(t, e) {
                    for (const t of e){
                        if (!(t instanceof Ek)) throw new R("model-nodelist-insertnodes-not-node", this);
                    }
                    this._nodes = wl(this._nodes, Array.from(e), t, 0);
                }
                _removeNodes(t, e = 1) {
                    return this._nodes.splice(t, e);
                }
                toJSON() {
                    return this._nodes.map((t)=>t.toJSON());
                }
            }
            class Sk extends Ek {
                constructor(t, e){
                    super(e);
                    this._data = t || "";
                }
                get offsetSize() {
                    return this.data.length;
                }
                get data() {
                    return this._data;
                }
                toJSON() {
                    const t = super.toJSON();
                    t.data = this.data;
                    return t;
                }
                _clone() {
                    return new Sk(this.data, this.getAttributes());
                }
                static fromJSON(t) {
                    return new Sk(t.data, t.attributes);
                }
            }
            Sk.prototype.is = function(t) {
                return t === "$text" || t === "model:$text" || t === "text" || t === "model:text" || t === "node" || t === "model:node";
            };
            class Tk extends xk {
                constructor(t, e, n){
                    super();
                    this.textNode = t;
                    if (e < 0 || e > t.offsetSize) throw new R("model-textproxy-wrong-offsetintext", this);
                    if (n < 0 || e + n > t.offsetSize) throw new R("model-textproxy-wrong-length", this);
                    this.data = t.data.substring(e, e + n);
                    this.offsetInText = e;
                }
                get startOffset() {
                    return this.textNode.startOffset !== null ? this.textNode.startOffset + this.offsetInText : null;
                }
                get offsetSize() {
                    return this.data.length;
                }
                get endOffset() {
                    return this.startOffset !== null ? this.startOffset + this.offsetSize : null;
                }
                get isPartial() {
                    return this.offsetSize !== this.textNode.offsetSize;
                }
                get parent() {
                    return this.textNode.parent;
                }
                get root() {
                    return this.textNode.root;
                }
                getPath() {
                    const t = this.textNode.getPath();
                    if (t.length > 0) t[t.length - 1] += this.offsetInText;
                    return t;
                }
                getAncestors(t = {}) {
                    const e = [];
                    let n = t.includeSelf ? this : this.parent;
                    while(n){
                        e[t.parentFirst ? "push" : "unshift"](n);
                        n = n.parent;
                    }
                    return e;
                }
                hasAttribute(t) {
                    return this.textNode.hasAttribute(t);
                }
                getAttribute(t) {
                    return this.textNode.getAttribute(t);
                }
                getAttributes() {
                    return this.textNode.getAttributes();
                }
                getAttributeKeys() {
                    return this.textNode.getAttributeKeys();
                }
            }
            Tk.prototype.is = function(t) {
                return t === "$textProxy" || t === "model:$textProxy" || t === "textProxy" || t === "model:textProxy";
            };
            class Bk extends Ek {
                constructor(t, e, n){
                    super(e);
                    this._children = new Dk;
                    this.name = t;
                    if (n) this._insertChild(0, n);
                }
                get childCount() {
                    return this._children.length;
                }
                get maxOffset() {
                    return this._children.maxOffset;
                }
                get isEmpty() {
                    return this.childCount === 0;
                }
                getChild(t) {
                    return this._children.getNode(t);
                }
                getChildren() {
                    return this._children[Symbol.iterator]();
                }
                getChildIndex(t) {
                    return this._children.getNodeIndex(t);
                }
                getChildStartOffset(t) {
                    return this._children.getNodeStartOffset(t);
                }
                offsetToIndex(t) {
                    return this._children.offsetToIndex(t);
                }
                getNodeByPath(t) {
                    let e = this;
                    for (const n of t)e = e.getChild(e.offsetToIndex(n));
                    return e;
                }
                findAncestor(t, e = {}) {
                    let n = e.includeSelf ? this : this.parent;
                    while(n){
                        if (n.name === t) return n;
                        n = n.parent;
                    }
                    return null;
                }
                toJSON() {
                    const t = super.toJSON();
                    t.name = this.name;
                    if (this._children.length > 0) {
                        t.children = [];
                        for (const e of this._children)t.children.push(e.toJSON());
                    }
                    return t;
                }
                _clone(t = false) {
                    const e = t ? Array.from(this._children).map((t)=>t._clone(true)) : undefined;
                    return new Bk(this.name, this.getAttributes(), e);
                }
                _appendChild(t) {
                    this._insertChild(this.childCount, t);
                }
                _insertChild(t, e) {
                    const n = Pk(e);
                    for (const t of n){
                        if (t.parent !== null) t._remove();
                        t.parent = this;
                    }
                    this._children._insertNodes(t, n);
                }
                _removeChildren(t, e = 1) {
                    const n = this._children._removeNodes(t, e);
                    for (const t of n)t.parent = null;
                    return n;
                }
                static fromJSON(t) {
                    let e;
                    if (t.children) {
                        e = [];
                        for (const n of t.children)if (n.name) e.push(Bk.fromJSON(n));
                        else e.push(Sk.fromJSON(n));
                    }
                    return new Bk(t.name, t.attributes, e);
                }
            }
            Bk.prototype.is = function(t, e) {
                if (!e) return t === "element" || t === "model:element" || t === "node" || t === "model:node";
                return e === this.name && (t === "element" || t === "model:element");
            };
            function Pk(t) {
                if (typeof t == "string") return [
                    new Sk(t)
                ];
                if (!Et(t)) t = [
                    t
                ];
                return Array.from(t).map((t)=>{
                    if (typeof t == "string") return new Sk(t);
                    if (t instanceof Tk) return new Sk(t.data, t.getAttributes());
                    return t;
                });
            }
            class Ik {
                constructor(t){
                    if (!t || !t.boundaries && !t.startPosition) throw new R("model-tree-walker-no-start-position", null);
                    const e = t.direction || "forward";
                    if (e != "forward" && e != "backward") throw new R("model-tree-walker-unknown-direction", t, {
                        direction: e
                    });
                    this.direction = e;
                    this.boundaries = t.boundaries || null;
                    if (t.startPosition) this._position = t.startPosition.clone();
                    else this._position = Ok._createAt(this.boundaries[this.direction == "backward" ? "end" : "start"]);
                    this.position.stickiness = "toNone";
                    this.singleCharacters = !!t.singleCharacters;
                    this.shallow = !!t.shallow;
                    this.ignoreElementEnd = !!t.ignoreElementEnd;
                    this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null;
                    this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
                    this._visitedParent = this.position.parent;
                }
                [Symbol.iterator]() {
                    return this;
                }
                get position() {
                    return this._position;
                }
                skip(t) {
                    let e, n, o, i;
                    do {
                        o = this.position;
                        i = this._visitedParent;
                        ({ done: e, value: n } = this.next());
                    }while (!e && t(n));
                    if (!e) {
                        this._position = o;
                        this._visitedParent = i;
                    }
                }
                next() {
                    if (this.direction == "forward") return this._next();
                    else return this._previous();
                }
                _next() {
                    const t = this.position;
                    const e = this.position.clone();
                    const n = this._visitedParent;
                    if (n.parent === null && e.offset === n.maxOffset) return {
                        done: true,
                        value: undefined
                    };
                    if (n === this._boundaryEndParent && e.offset == this.boundaries.end.offset) return {
                        done: true,
                        value: undefined
                    };
                    const o = Vk(e, n);
                    const i = o || Mk(e, n, o);
                    if (i instanceof Bk) {
                        if (!this.shallow) {
                            e.path.push(0);
                            this._visitedParent = i;
                        } else {
                            if (this.boundaries && this.boundaries.end.isBefore(e)) return {
                                done: true,
                                value: undefined
                            };
                            e.offset++;
                        }
                        this._position = e;
                        return Rk("elementStart", i, t, e, 1);
                    }
                    if (i instanceof Sk) {
                        let o;
                        if (this.singleCharacters) o = 1;
                        else {
                            let t = i.endOffset;
                            if (this._boundaryEndParent == n && this.boundaries.end.offset < t) t = this.boundaries.end.offset;
                            o = t - e.offset;
                        }
                        const r = e.offset - i.startOffset;
                        const s = new Tk(i, r, o);
                        e.offset += o;
                        this._position = e;
                        return Rk("text", s, t, e, o);
                    }
                    e.path.pop();
                    e.offset++;
                    this._position = e;
                    this._visitedParent = n.parent;
                    if (this.ignoreElementEnd) return this._next();
                    return Rk("elementEnd", n, t, e);
                }
                _previous() {
                    const t = this.position;
                    const e = this.position.clone();
                    const n = this._visitedParent;
                    if (n.parent === null && e.offset === 0) return {
                        done: true,
                        value: undefined
                    };
                    if (n == this._boundaryStartParent && e.offset == this.boundaries.start.offset) return {
                        done: true,
                        value: undefined
                    };
                    const o = e.parent;
                    const i = Vk(e, o);
                    const r = i || Lk(e, o, i);
                    if (r instanceof Bk) {
                        e.offset--;
                        if (this.shallow) {
                            this._position = e;
                            return Rk("elementStart", r, t, e, 1);
                        }
                        e.path.push(r.maxOffset);
                        this._position = e;
                        this._visitedParent = r;
                        if (this.ignoreElementEnd) return this._previous();
                        return Rk("elementEnd", r, t, e);
                    }
                    if (r instanceof Sk) {
                        let o;
                        if (this.singleCharacters) o = 1;
                        else {
                            let t = r.startOffset;
                            if (this._boundaryStartParent == n && this.boundaries.start.offset > t) t = this.boundaries.start.offset;
                            o = e.offset - t;
                        }
                        const i = e.offset - r.startOffset;
                        const s = new Tk(r, i - o, o);
                        e.offset -= o;
                        this._position = e;
                        return Rk("text", s, t, e, o);
                    }
                    e.path.pop();
                    this._position = e;
                    this._visitedParent = n.parent;
                    return Rk("elementStart", n, t, e, 1);
                }
            }
            function Rk(t, e, n, o, i) {
                return {
                    done: false,
                    value: {
                        type: t,
                        item: e,
                        previousPosition: n,
                        nextPosition: o,
                        length: i
                    }
                };
            }
            class Ok extends xk {
                constructor(t, e, n = "toNone"){
                    super();
                    if (!t.is("element") && !t.is("documentFragment")) throw new R("model-position-root-invalid", t);
                    if (!(e instanceof Array) || e.length === 0) throw new R("model-position-path-incorrect-format", t, {
                        path: e
                    });
                    if (t.is("rootElement")) e = e.slice();
                    else {
                        e = [
                            ...t.getPath(),
                            ...e
                        ];
                        t = t.root;
                    }
                    this.root = t;
                    this.path = e;
                    this.stickiness = n;
                }
                get offset() {
                    return this.path[this.path.length - 1];
                }
                set offset(t) {
                    this.path[this.path.length - 1] = t;
                }
                get parent() {
                    let t = this.root;
                    for(let e = 0; e < this.path.length - 1; e++){
                        t = t.getChild(t.offsetToIndex(this.path[e]));
                        if (!t) throw new R("model-position-path-incorrect", this, {
                            position: this
                        });
                    }
                    if (t.is("$text")) throw new R("model-position-path-incorrect", this, {
                        position: this
                    });
                    return t;
                }
                get index() {
                    return this.parent.offsetToIndex(this.offset);
                }
                get textNode() {
                    return Vk(this, this.parent);
                }
                get nodeAfter() {
                    const t = this.parent;
                    return Mk(this, t, Vk(this, t));
                }
                get nodeBefore() {
                    const t = this.parent;
                    return Lk(this, t, Vk(this, t));
                }
                get isAtStart() {
                    return this.offset === 0;
                }
                get isAtEnd() {
                    return this.offset == this.parent.maxOffset;
                }
                compareWith(t) {
                    if (this.root != t.root) return "different";
                    const e = xt(this.path, t.path);
                    switch(e){
                        case "same":
                            return "same";
                        case "prefix":
                            return "before";
                        case "extension":
                            return "after";
                        default:
                            return this.path[e] < t.path[e] ? "before" : "after";
                    }
                }
                getLastMatchingPosition(t, e = {}) {
                    e.startPosition = this;
                    const n = new Ik(e);
                    n.skip(t);
                    return n.position;
                }
                getParentPath() {
                    return this.path.slice(0, -1);
                }
                getAncestors() {
                    const t = this.parent;
                    if (t.is("documentFragment")) return [
                        t
                    ];
                    else return t.getAncestors({
                        includeSelf: true
                    });
                }
                findAncestor(t) {
                    const e = this.parent;
                    if (e.is("element")) return e.findAncestor(t, {
                        includeSelf: true
                    });
                    return null;
                }
                getCommonPath(t) {
                    if (this.root != t.root) return [];
                    const e = xt(this.path, t.path);
                    const n = typeof e == "string" ? Math.min(this.path.length, t.path.length) : e;
                    return this.path.slice(0, n);
                }
                getCommonAncestor(t) {
                    const e = this.getAncestors();
                    const n = t.getAncestors();
                    let o = 0;
                    while(e[o] == n[o] && e[o])o++;
                    return o === 0 ? null : e[o - 1];
                }
                getShiftedBy(t) {
                    const e = this.clone();
                    const n = e.offset + t;
                    e.offset = n < 0 ? 0 : n;
                    return e;
                }
                isAfter(t) {
                    return this.compareWith(t) == "after";
                }
                isBefore(t) {
                    return this.compareWith(t) == "before";
                }
                isEqual(t) {
                    return this.compareWith(t) == "same";
                }
                isTouching(t) {
                    if (this.root !== t.root) return false;
                    const e = Math.min(this.path.length, t.path.length);
                    for(let n = 0; n < e; n++){
                        const e = this.path[n] - t.path[n];
                        if (e < -1 || e > 1) return false;
                        else if (e === 1) return zk(t, this, n);
                        else if (e === -1) return zk(this, t, n);
                    }
                    if (this.path.length === t.path.length) return true;
                    else if (this.path.length > t.path.length) return Nk(this.path, e);
                    else return Nk(t.path, e);
                }
                hasSameParentAs(t) {
                    if (this.root !== t.root) return false;
                    const e = this.getParentPath();
                    const n = t.getParentPath();
                    return xt(e, n) == "same";
                }
                getTransformedByOperation(t) {
                    let e;
                    switch(t.type){
                        case "insert":
                            e = this._getTransformedByInsertOperation(t);
                            break;
                        case "move":
                        case "remove":
                        case "reinsert":
                            e = this._getTransformedByMoveOperation(t);
                            break;
                        case "split":
                            e = this._getTransformedBySplitOperation(t);
                            break;
                        case "merge":
                            e = this._getTransformedByMergeOperation(t);
                            break;
                        default:
                            e = Ok._createAt(this);
                            break;
                    }
                    return e;
                }
                _getTransformedByInsertOperation(t) {
                    return this._getTransformedByInsertion(t.position, t.howMany);
                }
                _getTransformedByMoveOperation(t) {
                    return this._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany);
                }
                _getTransformedBySplitOperation(t) {
                    const e = t.movedRange;
                    const n = e.containsPosition(this) || e.start.isEqual(this) && this.stickiness == "toNext";
                    if (n) return this._getCombined(t.splitPosition, t.moveTargetPosition);
                    else {
                        if (t.graveyardPosition) return this._getTransformedByMove(t.graveyardPosition, t.insertionPosition, 1);
                        else return this._getTransformedByInsertion(t.insertionPosition, 1);
                    }
                }
                _getTransformedByMergeOperation(t) {
                    const e = t.movedRange;
                    const n = e.containsPosition(this) || e.start.isEqual(this);
                    let o;
                    if (n) {
                        o = this._getCombined(t.sourcePosition, t.targetPosition);
                        if (t.sourcePosition.isBefore(t.targetPosition)) o = o._getTransformedByDeletion(t.deletionPosition, 1);
                    } else if (this.isEqual(t.deletionPosition)) o = Ok._createAt(t.deletionPosition);
                    else o = this._getTransformedByMove(t.deletionPosition, t.graveyardPosition, 1);
                    return o;
                }
                _getTransformedByDeletion(t, e) {
                    const n = Ok._createAt(this);
                    if (this.root != t.root) return n;
                    if (xt(t.getParentPath(), this.getParentPath()) == "same") {
                        if (t.offset < this.offset) {
                            if (t.offset + e > this.offset) return null;
                            else n.offset -= e;
                        }
                    } else if (xt(t.getParentPath(), this.getParentPath()) == "prefix") {
                        const o = t.path.length - 1;
                        if (t.offset <= this.path[o]) {
                            if (t.offset + e > this.path[o]) return null;
                            else n.path[o] -= e;
                        }
                    }
                    return n;
                }
                _getTransformedByInsertion(t, e) {
                    const n = Ok._createAt(this);
                    if (this.root != t.root) return n;
                    if (xt(t.getParentPath(), this.getParentPath()) == "same") {
                        if (t.offset < this.offset || t.offset == this.offset && this.stickiness != "toPrevious") n.offset += e;
                    } else if (xt(t.getParentPath(), this.getParentPath()) == "prefix") {
                        const o = t.path.length - 1;
                        if (t.offset <= this.path[o]) n.path[o] += e;
                    }
                    return n;
                }
                _getTransformedByMove(t, e, n) {
                    e = e._getTransformedByDeletion(t, n);
                    if (t.isEqual(e)) return Ok._createAt(this);
                    const o = this._getTransformedByDeletion(t, n);
                    const i = o === null || t.isEqual(this) && this.stickiness == "toNext" || t.getShiftedBy(n).isEqual(this) && this.stickiness == "toPrevious";
                    if (i) return this._getCombined(t, e);
                    else return o._getTransformedByInsertion(e, n);
                }
                _getCombined(t, e) {
                    const n = t.path.length - 1;
                    const o = Ok._createAt(e);
                    o.stickiness = this.stickiness;
                    o.offset = o.offset + this.path[n] - t.offset;
                    o.path = [
                        ...o.path,
                        ...this.path.slice(n + 1)
                    ];
                    return o;
                }
                toJSON() {
                    return {
                        root: this.root.toJSON(),
                        path: Array.from(this.path),
                        stickiness: this.stickiness
                    };
                }
                clone() {
                    return new this.constructor(this.root, this.path, this.stickiness);
                }
                static _createAt(t, e, n = "toNone") {
                    if (t instanceof Ok) return new Ok(t.root, t.path, t.stickiness);
                    else {
                        const o = t;
                        if (e == "end") e = o.maxOffset;
                        else if (e == "before") return this._createBefore(o, n);
                        else if (e == "after") return this._createAfter(o, n);
                        else if (e !== 0 && !e) throw new R("model-createpositionat-offset-required", [
                            this,
                            t
                        ]);
                        if (!o.is("element") && !o.is("documentFragment")) throw new R("model-position-parent-incorrect", [
                            this,
                            t
                        ]);
                        const i = o.getPath();
                        i.push(e);
                        return new this(o.root, i, n);
                    }
                }
                static _createAfter(t, e) {
                    if (!t.parent) throw new R("model-position-after-root", [
                        this,
                        t
                    ], {
                        root: t
                    });
                    return this._createAt(t.parent, t.endOffset, e);
                }
                static _createBefore(t, e) {
                    if (!t.parent) throw new R("model-position-before-root", t, {
                        root: t
                    });
                    return this._createAt(t.parent, t.startOffset, e);
                }
                static fromJSON(t, e) {
                    if (t.root === "$graveyard") {
                        const n = new Ok(e.graveyard, t.path);
                        n.stickiness = t.stickiness;
                        return n;
                    }
                    if (!e.getRoot(t.root)) throw new R("model-position-fromjson-no-root", e, {
                        rootName: t.root
                    });
                    return new Ok(e.getRoot(t.root), t.path, t.stickiness);
                }
            }
            Ok.prototype.is = function(t) {
                return t === "position" || t === "model:position";
            };
            function Vk(t, e) {
                const n = e.getChild(e.offsetToIndex(t.offset));
                if (n && n.is("$text") && n.startOffset < t.offset) return n;
                return null;
            }
            function Mk(t, e, n) {
                if (n !== null) return null;
                return e.getChild(e.offsetToIndex(t.offset));
            }
            function Lk(t, e, n) {
                if (n !== null) return null;
                return e.getChild(e.offsetToIndex(t.offset) - 1);
            }
            function zk(t, e, n) {
                if (n + 1 === t.path.length) return false;
                if (!Nk(e.path, n + 1)) return false;
                if (!Fk(t, n + 1)) return false;
                return true;
            }
            function Nk(t, e) {
                while(e < t.length){
                    if (t[e] !== 0) return false;
                    e++;
                }
                return true;
            }
            function Fk(t, e) {
                let n = t.parent;
                let o = t.path.length - 1;
                let i = 0;
                while(o >= e){
                    if (t.path[o] + i !== n.maxOffset) return false;
                    i = 1;
                    o--;
                    n = n.parent;
                }
                return true;
            }
            class Hk extends xk {
                constructor(t, e){
                    super();
                    this.start = Ok._createAt(t);
                    this.end = e ? Ok._createAt(e) : Ok._createAt(t);
                    this.start.stickiness = this.isCollapsed ? "toNone" : "toNext";
                    this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
                }
                *[Symbol.iterator]() {
                    yield* new Ik({
                        boundaries: this,
                        ignoreElementEnd: true
                    });
                }
                get isCollapsed() {
                    return this.start.isEqual(this.end);
                }
                get isFlat() {
                    const t = this.start.getParentPath();
                    const e = this.end.getParentPath();
                    return xt(t, e) == "same";
                }
                get root() {
                    return this.start.root;
                }
                containsPosition(t) {
                    return t.isAfter(this.start) && t.isBefore(this.end);
                }
                containsRange(t, e = false) {
                    if (t.isCollapsed) e = false;
                    const n = this.containsPosition(t.start) || e && this.start.isEqual(t.start);
                    const o = this.containsPosition(t.end) || e && this.end.isEqual(t.end);
                    return n && o;
                }
                containsItem(t) {
                    const e = Ok._createBefore(t);
                    return this.containsPosition(e) || this.start.isEqual(e);
                }
                isEqual(t) {
                    return this.start.isEqual(t.start) && this.end.isEqual(t.end);
                }
                isIntersecting(t) {
                    return this.start.isBefore(t.end) && this.end.isAfter(t.start);
                }
                getDifference(t) {
                    const e = [];
                    if (this.isIntersecting(t)) {
                        if (this.containsPosition(t.start)) e.push(new Hk(this.start, t.start));
                        if (this.containsPosition(t.end)) e.push(new Hk(t.end, this.end));
                    } else e.push(new Hk(this.start, this.end));
                    return e;
                }
                getIntersection(t) {
                    if (this.isIntersecting(t)) {
                        let e = this.start;
                        let n = this.end;
                        if (this.containsPosition(t.start)) e = t.start;
                        if (this.containsPosition(t.end)) n = t.end;
                        return new Hk(e, n);
                    }
                    return null;
                }
                getJoined(t, e = false) {
                    let n = this.isIntersecting(t);
                    if (!n) {
                        if (this.start.isBefore(t.start)) n = e ? this.end.isTouching(t.start) : this.end.isEqual(t.start);
                        else n = e ? t.end.isTouching(this.start) : t.end.isEqual(this.start);
                    }
                    if (!n) return null;
                    let o = this.start;
                    let i = this.end;
                    if (t.start.isBefore(o)) o = t.start;
                    if (t.end.isAfter(i)) i = t.end;
                    return new Hk(o, i);
                }
                getMinimalFlatRanges() {
                    const t = [];
                    const e = this.start.getCommonPath(this.end).length;
                    const n = Ok._createAt(this.start);
                    let o = n.parent;
                    while(n.path.length > e + 1){
                        const e = o.maxOffset - n.offset;
                        if (e !== 0) t.push(new Hk(n, n.getShiftedBy(e)));
                        n.path = n.path.slice(0, -1);
                        n.offset++;
                        o = o.parent;
                    }
                    while(n.path.length <= this.end.path.length){
                        const e = this.end.path[n.path.length - 1];
                        const o = e - n.offset;
                        if (o !== 0) t.push(new Hk(n, n.getShiftedBy(o)));
                        n.offset = e;
                        n.path.push(0);
                    }
                    return t;
                }
                getWalker(t = {}) {
                    t.boundaries = this;
                    return new Ik(t);
                }
                *getItems(t = {}) {
                    t.boundaries = this;
                    t.ignoreElementEnd = true;
                    const e = new Ik(t);
                    for (const t of e)yield t.item;
                }
                *getPositions(t = {}) {
                    t.boundaries = this;
                    const e = new Ik(t);
                    yield e.position;
                    for (const t of e)yield t.nextPosition;
                }
                getTransformedByOperation(t) {
                    switch(t.type){
                        case "insert":
                            return this._getTransformedByInsertOperation(t);
                        case "move":
                        case "remove":
                        case "reinsert":
                            return this._getTransformedByMoveOperation(t);
                        case "split":
                            return [
                                this._getTransformedBySplitOperation(t)
                            ];
                        case "merge":
                            return [
                                this._getTransformedByMergeOperation(t)
                            ];
                    }
                    return [
                        new Hk(this.start, this.end)
                    ];
                }
                getTransformedByOperations(t) {
                    const e = [
                        new Hk(this.start, this.end)
                    ];
                    for (const n of t)for(let t = 0; t < e.length; t++){
                        const o = e[t].getTransformedByOperation(n);
                        e.splice(t, 1, ...o);
                        t += o.length - 1;
                    }
                    for(let t = 0; t < e.length; t++){
                        const n = e[t];
                        for(let o = t + 1; o < e.length; o++){
                            const t = e[o];
                            if (n.containsRange(t) || t.containsRange(n) || n.isEqual(t)) e.splice(o, 1);
                        }
                    }
                    return e;
                }
                getCommonAncestor() {
                    return this.start.getCommonAncestor(this.end);
                }
                getContainedElement() {
                    if (this.isCollapsed) return null;
                    const t = this.start.nodeAfter;
                    const e = this.end.nodeBefore;
                    if (t && t.is("element") && t === e) return t;
                    return null;
                }
                toJSON() {
                    return {
                        start: this.start.toJSON(),
                        end: this.end.toJSON()
                    };
                }
                clone() {
                    return new this.constructor(this.start, this.end);
                }
                _getTransformedByInsertOperation(t, e = false) {
                    return this._getTransformedByInsertion(t.position, t.howMany, e);
                }
                _getTransformedByMoveOperation(t, e = false) {
                    const n = t.sourcePosition;
                    const o = t.howMany;
                    const i = t.targetPosition;
                    return this._getTransformedByMove(n, i, o, e);
                }
                _getTransformedBySplitOperation(t) {
                    const e = this.start._getTransformedBySplitOperation(t);
                    let n = this.end._getTransformedBySplitOperation(t);
                    if (this.end.isEqual(t.insertionPosition)) n = this.end.getShiftedBy(1);
                    if (e.root != n.root) n = this.end.getShiftedBy(-1);
                    return new Hk(e, n);
                }
                _getTransformedByMergeOperation(t) {
                    if (this.start.isEqual(t.targetPosition) && this.end.isEqual(t.deletionPosition)) return new Hk(this.start);
                    let e = this.start._getTransformedByMergeOperation(t);
                    let n = this.end._getTransformedByMergeOperation(t);
                    if (e.root != n.root) n = this.end.getShiftedBy(-1);
                    if (e.isAfter(n)) {
                        if (t.sourcePosition.isBefore(t.targetPosition)) {
                            e = Ok._createAt(n);
                            e.offset = 0;
                        } else {
                            if (!t.deletionPosition.isEqual(e)) n = t.deletionPosition;
                            e = t.targetPosition;
                        }
                        return new Hk(e, n);
                    }
                    return new Hk(e, n);
                }
                _getTransformedByInsertion(t, e, n = false) {
                    if (n && this.containsPosition(t)) return [
                        new Hk(this.start, t),
                        new Hk(t.getShiftedBy(e), this.end._getTransformedByInsertion(t, e))
                    ];
                    else {
                        const n = new Hk(this.start, this.end);
                        n.start = n.start._getTransformedByInsertion(t, e);
                        n.end = n.end._getTransformedByInsertion(t, e);
                        return [
                            n
                        ];
                    }
                }
                _getTransformedByMove(t, e, n, o = false) {
                    if (this.isCollapsed) {
                        const o = this.start._getTransformedByMove(t, e, n);
                        return [
                            new Hk(o)
                        ];
                    }
                    const i = Hk._createFromPositionAndShift(t, n);
                    const r = e._getTransformedByDeletion(t, n);
                    if (this.containsPosition(e) && !o) {
                        if (i.containsPosition(this.start) || i.containsPosition(this.end)) {
                            const o = this.start._getTransformedByMove(t, e, n);
                            const i = this.end._getTransformedByMove(t, e, n);
                            return [
                                new Hk(o, i)
                            ];
                        }
                    }
                    let s;
                    const a = this.getDifference(i);
                    let c = null;
                    const l = this.getIntersection(i);
                    if (a.length == 1) c = new Hk(a[0].start._getTransformedByDeletion(t, n), a[0].end._getTransformedByDeletion(t, n));
                    else if (a.length == 2) c = new Hk(this.start, this.end._getTransformedByDeletion(t, n));
                    if (c) s = c._getTransformedByInsertion(r, n, l !== null || o);
                    else s = [];
                    if (l) {
                        const t = new Hk(l.start._getCombined(i.start, r), l.end._getCombined(i.start, r));
                        if (s.length == 2) s.splice(1, 0, t);
                        else s.push(t);
                    }
                    return s;
                }
                _getTransformedByDeletion(t, e) {
                    let n = this.start._getTransformedByDeletion(t, e);
                    let o = this.end._getTransformedByDeletion(t, e);
                    if (n == null && o == null) return null;
                    if (n == null) n = t;
                    if (o == null) o = t;
                    return new Hk(n, o);
                }
                static _createFromPositionAndShift(t, e) {
                    const n = t;
                    const o = t.getShiftedBy(e);
                    return e > 0 ? new this(n, o) : new this(o, n);
                }
                static _createIn(t) {
                    return new this(Ok._createAt(t, 0), Ok._createAt(t, t.maxOffset));
                }
                static _createOn(t) {
                    return this._createFromPositionAndShift(Ok._createBefore(t), t.offsetSize);
                }
                static _createFromRanges(t) {
                    if (t.length === 0) throw new R("range-create-from-ranges-empty-array", null);
                    else if (t.length == 1) return t[0].clone();
                    const e = t[0];
                    t.sort((t, e)=>t.start.isAfter(e.start) ? 1 : -1);
                    const n = t.indexOf(e);
                    const o = new this(e.start, e.end);
                    if (n > 0) for(let e = n - 1;; e++){
                        if (t[e].end.isEqual(o.start)) o.start = Ok._createAt(t[e].start);
                        else break;
                    }
                    for(let e = n + 1; e < t.length; e++){
                        if (t[e].start.isEqual(o.end)) o.end = Ok._createAt(t[e].end);
                        else break;
                    }
                    return o;
                }
                static fromJSON(t, e) {
                    return new this(Ok.fromJSON(t.start, e), Ok.fromJSON(t.end, e));
                }
            }
            Hk.prototype.is = function(t) {
                return t === "range" || t === "model:range";
            };
            class jk extends G() {
                constructor(){
                    super();
                    this._modelToViewMapping = new WeakMap;
                    this._viewToModelMapping = new WeakMap;
                    this._viewToModelLengthCallbacks = new Map;
                    this._markerNameToElements = new Map;
                    this._elementToMarkerNames = new Map;
                    this._deferredBindingRemovals = new Map;
                    this._unboundMarkerNames = new Set;
                    this.on("modelToViewPosition", (t, e)=>{
                        if (e.viewPosition) return;
                        const n = this._modelToViewMapping.get(e.modelPosition.parent);
                        if (!n) throw new R("mapping-model-position-view-parent-not-found", this, {
                            modelPosition: e.modelPosition
                        });
                        e.viewPosition = this.findPositionIn(n, e.modelPosition.offset);
                    }, {
                        priority: "low"
                    });
                    this.on("viewToModelPosition", (t, e)=>{
                        if (e.modelPosition) return;
                        const n = this.findMappedViewAncestor(e.viewPosition);
                        const o = this._viewToModelMapping.get(n);
                        const i = this._toModelOffset(e.viewPosition.parent, e.viewPosition.offset, n);
                        e.modelPosition = Ok._createAt(o, i);
                    }, {
                        priority: "low"
                    });
                }
                bindElements(t, e) {
                    this._modelToViewMapping.set(t, e);
                    this._viewToModelMapping.set(e, t);
                }
                unbindViewElement(t, e = {}) {
                    const n = this.toModelElement(t);
                    if (this._elementToMarkerNames.has(t)) for (const e of this._elementToMarkerNames.get(t))this._unboundMarkerNames.add(e);
                    if (e.defer) this._deferredBindingRemovals.set(t, t.root);
                    else {
                        this._viewToModelMapping.delete(t);
                        if (this._modelToViewMapping.get(n) == t) this._modelToViewMapping.delete(n);
                    }
                }
                unbindModelElement(t) {
                    const e = this.toViewElement(t);
                    this._modelToViewMapping.delete(t);
                    if (this._viewToModelMapping.get(e) == t) this._viewToModelMapping.delete(e);
                }
                bindElementToMarker(t, e) {
                    const n = this._markerNameToElements.get(e) || new Set;
                    n.add(t);
                    const o = this._elementToMarkerNames.get(t) || new Set;
                    o.add(e);
                    this._markerNameToElements.set(e, n);
                    this._elementToMarkerNames.set(t, o);
                }
                unbindElementFromMarkerName(t, e) {
                    const n = this._markerNameToElements.get(e);
                    if (n) {
                        n.delete(t);
                        if (n.size == 0) this._markerNameToElements.delete(e);
                    }
                    const o = this._elementToMarkerNames.get(t);
                    if (o) {
                        o.delete(e);
                        if (o.size == 0) this._elementToMarkerNames.delete(t);
                    }
                }
                flushUnboundMarkerNames() {
                    const t = Array.from(this._unboundMarkerNames);
                    this._unboundMarkerNames.clear();
                    return t;
                }
                flushDeferredBindings() {
                    for (const [t, e] of this._deferredBindingRemovals)if (t.root == e) this.unbindViewElement(t);
                    this._deferredBindingRemovals = new Map;
                }
                clearBindings() {
                    this._modelToViewMapping = new WeakMap;
                    this._viewToModelMapping = new WeakMap;
                    this._markerNameToElements = new Map;
                    this._elementToMarkerNames = new Map;
                    this._unboundMarkerNames = new Set;
                    this._deferredBindingRemovals = new Map;
                }
                toModelElement(t) {
                    return this._viewToModelMapping.get(t);
                }
                toViewElement(t) {
                    return this._modelToViewMapping.get(t);
                }
                toModelRange(t) {
                    return new Hk(this.toModelPosition(t.start), this.toModelPosition(t.end));
                }
                toViewRange(t) {
                    return new kp(this.toViewPosition(t.start), this.toViewPosition(t.end));
                }
                toModelPosition(t) {
                    const e = {
                        viewPosition: t,
                        mapper: this
                    };
                    this.fire("viewToModelPosition", e);
                    return e.modelPosition;
                }
                toViewPosition(t, e = {}) {
                    const n = {
                        modelPosition: t,
                        mapper: this,
                        isPhantom: e.isPhantom
                    };
                    this.fire("modelToViewPosition", n);
                    return n.viewPosition;
                }
                markerNameToElements(t) {
                    const e = this._markerNameToElements.get(t);
                    if (!e) return null;
                    const n = new Set;
                    for (const t of e){
                        if (t.is("attributeElement")) for (const e of t.getElementsWithSameId())n.add(e);
                        else n.add(t);
                    }
                    return n;
                }
                registerViewToModelLength(t, e) {
                    this._viewToModelLengthCallbacks.set(t, e);
                }
                findMappedViewAncestor(t) {
                    let e = t.parent;
                    while(!this._viewToModelMapping.has(e))e = e.parent;
                    return e;
                }
                _toModelOffset(t, e, n) {
                    if (n != t) {
                        const o = this._toModelOffset(t.parent, t.index, n);
                        const i = this._toModelOffset(t, e, t);
                        return o + i;
                    }
                    if (t.is("$text")) return e;
                    let o = 0;
                    for(let n = 0; n < e; n++)o += this.getModelLength(t.getChild(n));
                    return o;
                }
                getModelLength(t) {
                    if (this._viewToModelLengthCallbacks.get(t.name)) {
                        const e = this._viewToModelLengthCallbacks.get(t.name);
                        return e(t);
                    } else if (this._viewToModelMapping.has(t)) return 1;
                    else if (t.is("$text")) return t.data.length;
                    else if (t.is("uiElement")) return 0;
                    else {
                        let e = 0;
                        for (const n of t.getChildren())e += this.getModelLength(n);
                        return e;
                    }
                }
                findPositionIn(t, e) {
                    let n;
                    let o = 0;
                    let i = 0;
                    let r = 0;
                    if (t.is("$text")) return new mp(t, e);
                    while(i < e){
                        n = t.getChild(r);
                        o = this.getModelLength(n);
                        i += o;
                        r++;
                    }
                    if (i == e) return this._moveViewPositionToTextNode(new mp(t, r));
                    else return this.findPositionIn(n, e - (i - o));
                }
                _moveViewPositionToTextNode(t) {
                    const e = t.nodeBefore;
                    const n = t.nodeAfter;
                    if (e instanceof rh) return new mp(e, e.data.length);
                    else if (n instanceof rh) return new mp(n, 0);
                    return t;
                }
            }
            class qk {
                constructor(){
                    this._consumable = new Map;
                    this._textProxyRegistry = new Map;
                }
                add(t, e) {
                    e = Wk(e);
                    if (t instanceof Tk) t = this._getSymbolForTextProxy(t);
                    if (!this._consumable.has(t)) this._consumable.set(t, new Map);
                    this._consumable.get(t).set(e, true);
                }
                consume(t, e) {
                    e = Wk(e);
                    if (t instanceof Tk) t = this._getSymbolForTextProxy(t);
                    if (this.test(t, e)) {
                        this._consumable.get(t).set(e, false);
                        return true;
                    } else return false;
                }
                test(t, e) {
                    e = Wk(e);
                    if (t instanceof Tk) t = this._getSymbolForTextProxy(t);
                    const n = this._consumable.get(t);
                    if (n === undefined) return null;
                    const o = n.get(e);
                    if (o === undefined) return null;
                    return o;
                }
                revert(t, e) {
                    e = Wk(e);
                    if (t instanceof Tk) t = this._getSymbolForTextProxy(t);
                    const n = this.test(t, e);
                    if (n === false) {
                        this._consumable.get(t).set(e, true);
                        return true;
                    } else if (n === true) return false;
                    return null;
                }
                verifyAllConsumed(t) {
                    const e = [];
                    for (const [n, o] of this._consumable)for (const [i, r] of o){
                        const o = i.split(":")[0];
                        if (r && t == o) e.push({
                            event: i,
                            item: n.name || n.description
                        });
                    }
                    if (e.length) throw new R("conversion-model-consumable-not-consumed", null, {
                        items: e
                    });
                }
                _getSymbolForTextProxy(t) {
                    let e = null;
                    const n = this._textProxyRegistry.get(t.startOffset);
                    if (n) {
                        const o = n.get(t.endOffset);
                        if (o) e = o.get(t.parent);
                    }
                    if (!e) e = this._addSymbolForTextProxy(t);
                    return e;
                }
                _addSymbolForTextProxy(t) {
                    const e = t.startOffset;
                    const n = t.endOffset;
                    const o = t.parent;
                    const i = Symbol("$textProxy:" + t.data);
                    let r;
                    let s;
                    r = this._textProxyRegistry.get(e);
                    if (!r) {
                        r = new Map;
                        this._textProxyRegistry.set(e, r);
                    }
                    s = r.get(n);
                    if (!s) {
                        s = new Map;
                        r.set(n, s);
                    }
                    s.set(o, i);
                    return i;
                }
            }
            function Wk(t) {
                const e = t.split(":");
                if (e[0] == "insert") return e[0];
                if (e[0] == "addMarker" || e[0] == "removeMarker") return t;
                return e.length > 1 ? e[0] + ":" + e[1] : e[0];
            }
            class $k extends G() {
                constructor(t){
                    super();
                    this._conversionApi = {
                        dispatcher: this,
                        ...t
                    };
                    this._firedEventsMap = new WeakMap;
                }
                convertChanges(t, e, n) {
                    const o = this._createConversionApi(n, t.getRefreshedItems());
                    for (const e of t.getMarkersToRemove())this._convertMarkerRemove(e.name, e.range, o);
                    const i = this._reduceChanges(t.getChanges());
                    for (const t of i){
                        if (t.type === "insert") this._convertInsert(Hk._createFromPositionAndShift(t.position, t.length), o);
                        else if (t.type === "reinsert") this._convertReinsert(Hk._createFromPositionAndShift(t.position, t.length), o);
                        else if (t.type === "remove") this._convertRemove(t.position, t.length, t.name, o);
                        else this._convertAttribute(t.range, t.attributeKey, t.attributeOldValue, t.attributeNewValue, o);
                    }
                    for (const t of o.mapper.flushUnboundMarkerNames()){
                        const n = e.get(t).getRange();
                        this._convertMarkerRemove(t, n, o);
                        this._convertMarkerAdd(t, n, o);
                    }
                    for (const e of t.getMarkersToAdd())this._convertMarkerAdd(e.name, e.range, o);
                    o.mapper.flushDeferredBindings();
                    o.consumable.verifyAllConsumed("insert");
                }
                convert(t, e, n, o = {}) {
                    const i = this._createConversionApi(n, undefined, o);
                    this._convertInsert(t, i);
                    for (const [t, n] of e)this._convertMarkerAdd(t, n, i);
                    i.consumable.verifyAllConsumed("insert");
                }
                convertSelection(t, e, n) {
                    const o = this._createConversionApi(n);
                    this.fire("cleanSelection", {
                        selection: t
                    }, o);
                    const i = t.getFirstPosition().root;
                    if (!o.mapper.toViewElement(i)) return;
                    const r = Array.from(e.getMarkersAtPosition(t.getFirstPosition()));
                    this._addConsumablesForSelection(o.consumable, t, r);
                    this.fire("selection", {
                        selection: t
                    }, o);
                    if (!t.isCollapsed) return;
                    for (const e of r)if (o.consumable.test(t, "addMarker:" + e.name)) {
                        const n = e.getRange();
                        if (!Gk(t.getFirstPosition(), e, o.mapper)) continue;
                        const i = {
                            item: t,
                            markerName: e.name,
                            markerRange: n
                        };
                        this.fire(`addMarker:${e.name}`, i, o);
                    }
                    for (const e of t.getAttributeKeys())if (o.consumable.test(t, "attribute:" + e)) {
                        const n = {
                            item: t,
                            range: t.getFirstRange(),
                            attributeKey: e,
                            attributeOldValue: null,
                            attributeNewValue: t.getAttribute(e)
                        };
                        this.fire(`attribute:${e}:$text`, n, o);
                    }
                }
                _convertInsert(t, e, n = {}) {
                    if (!n.doNotAddConsumables) this._addConsumablesForInsert(e.consumable, Array.from(t));
                    for (const n of Array.from(t.getWalker({
                        shallow: true
                    })).map(Kk))this._testAndFire("insert", n, e);
                }
                _convertRemove(t, e, n, o) {
                    this.fire(`remove:${n}`, {
                        position: t,
                        length: e
                    }, o);
                }
                _convertAttribute(t, e, n, o, i) {
                    this._addConsumablesForRange(i.consumable, t, `attribute:${e}`);
                    for (const r of t){
                        const t = {
                            item: r.item,
                            range: Hk._createFromPositionAndShift(r.previousPosition, r.length),
                            attributeKey: e,
                            attributeOldValue: n,
                            attributeNewValue: o
                        };
                        this._testAndFire(`attribute:${e}`, t, i);
                    }
                }
                _convertReinsert(t, e) {
                    const n = Array.from(t.getWalker({
                        shallow: true
                    }));
                    this._addConsumablesForInsert(e.consumable, n);
                    for (const t of n.map(Kk))this._testAndFire("insert", {
                        ...t,
                        reconversion: true
                    }, e);
                }
                _convertMarkerAdd(t, e, n) {
                    if (e.root.rootName == "$graveyard") return;
                    const o = `addMarker:${t}`;
                    n.consumable.add(e, o);
                    this.fire(o, {
                        markerName: t,
                        markerRange: e
                    }, n);
                    if (!n.consumable.consume(e, o)) return;
                    this._addConsumablesForRange(n.consumable, e, o);
                    for (const i of e.getItems()){
                        if (!n.consumable.test(i, o)) continue;
                        const r = {
                            item: i,
                            range: Hk._createOn(i),
                            markerName: t,
                            markerRange: e
                        };
                        this.fire(o, r, n);
                    }
                }
                _convertMarkerRemove(t, e, n) {
                    if (e.root.rootName == "$graveyard") return;
                    this.fire(`removeMarker:${t}`, {
                        markerName: t,
                        markerRange: e
                    }, n);
                }
                _reduceChanges(t) {
                    const e = {
                        changes: t
                    };
                    this.fire("reduceChanges", e);
                    return e.changes;
                }
                _addConsumablesForInsert(t, e) {
                    for (const n of e){
                        const e = n.item;
                        if (t.test(e, "insert") === null) {
                            t.add(e, "insert");
                            for (const n of e.getAttributeKeys())t.add(e, "attribute:" + n);
                        }
                    }
                    return t;
                }
                _addConsumablesForRange(t, e, n) {
                    for (const o of e.getItems())t.add(o, n);
                    return t;
                }
                _addConsumablesForSelection(t, e, n) {
                    t.add(e, "selection");
                    for (const o of n)t.add(e, "addMarker:" + o.name);
                    for (const n of e.getAttributeKeys())t.add(e, "attribute:" + n);
                    return t;
                }
                _testAndFire(t, e, n) {
                    const o = Uk(t, e);
                    const i = e.item.is("$textProxy") ? n.consumable._getSymbolForTextProxy(e.item) : e.item;
                    const r = this._firedEventsMap.get(n);
                    const s = r.get(i);
                    if (!s) r.set(i, new Set([
                        o
                    ]));
                    else if (!s.has(o)) s.add(o);
                    else return;
                    this.fire(o, e, n);
                }
                _testAndFireAddAttributes(t, e) {
                    const n = {
                        item: t,
                        range: Hk._createOn(t)
                    };
                    for (const t of n.item.getAttributeKeys()){
                        n.attributeKey = t;
                        n.attributeOldValue = null;
                        n.attributeNewValue = n.item.getAttribute(t);
                        this._testAndFire(`attribute:${t}`, n, e);
                    }
                }
                _createConversionApi(t, e = new Set, n = {}) {
                    const o = {
                        ...this._conversionApi,
                        consumable: new qk,
                        writer: t,
                        options: n,
                        convertItem: (t)=>this._convertInsert(Hk._createOn(t), o),
                        convertChildren: (t)=>this._convertInsert(Hk._createIn(t), o, {
                                doNotAddConsumables: true
                            }),
                        convertAttributes: (t)=>this._testAndFireAddAttributes(t, o),
                        canReuseView: (t)=>!e.has(o.mapper.toModelElement(t))
                    };
                    this._firedEventsMap.set(o, new Map);
                    return o;
                }
            }
            function Gk(t, e, n) {
                const o = e.getRange();
                const i = Array.from(t.getAncestors());
                i.shift();
                i.reverse();
                const r = i.some((t)=>{
                    if (o.containsItem(t)) {
                        const e = n.toViewElement(t);
                        return !!e.getCustomProperty("addHighlight");
                    }
                });
                return !r;
            }
            function Uk(t, e) {
                const n = e.item.is("element") ? e.item.name : "$text";
                return `${t}:${n}`;
            }
            function Kk(t) {
                const e = t.item;
                const n = Hk._createFromPositionAndShift(t.previousPosition, t.length);
                return {
                    item: e,
                    range: n
                };
            }
            class Zk extends G(xk) {
                constructor(...t){
                    super();
                    this._lastRangeBackward = false;
                    this._attrs = new Map;
                    this._ranges = [];
                    if (t.length) this.setTo(...t);
                }
                get anchor() {
                    if (this._ranges.length > 0) {
                        const t = this._ranges[this._ranges.length - 1];
                        return this._lastRangeBackward ? t.end : t.start;
                    }
                    return null;
                }
                get focus() {
                    if (this._ranges.length > 0) {
                        const t = this._ranges[this._ranges.length - 1];
                        return this._lastRangeBackward ? t.start : t.end;
                    }
                    return null;
                }
                get isCollapsed() {
                    const t = this._ranges.length;
                    if (t === 1) return this._ranges[0].isCollapsed;
                    else return false;
                }
                get rangeCount() {
                    return this._ranges.length;
                }
                get isBackward() {
                    return !this.isCollapsed && this._lastRangeBackward;
                }
                isEqual(t) {
                    if (this.rangeCount != t.rangeCount) return false;
                    else if (this.rangeCount === 0) return true;
                    if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) return false;
                    for (const e of this._ranges){
                        let n = false;
                        for (const o of t._ranges)if (e.isEqual(o)) {
                            n = true;
                            break;
                        }
                        if (!n) return false;
                    }
                    return true;
                }
                *getRanges() {
                    for (const t of this._ranges)yield new Hk(t.start, t.end);
                }
                getFirstRange() {
                    let t = null;
                    for (const e of this._ranges)if (!t || e.start.isBefore(t.start)) t = e;
                    return t ? new Hk(t.start, t.end) : null;
                }
                getLastRange() {
                    let t = null;
                    for (const e of this._ranges)if (!t || e.end.isAfter(t.end)) t = e;
                    return t ? new Hk(t.start, t.end) : null;
                }
                getFirstPosition() {
                    const t = this.getFirstRange();
                    return t ? t.start.clone() : null;
                }
                getLastPosition() {
                    const t = this.getLastRange();
                    return t ? t.end.clone() : null;
                }
                setTo(...t) {
                    let [e, n, o] = t;
                    if (typeof n == "object") {
                        o = n;
                        n = undefined;
                    }
                    if (e === null) this._setRanges([]);
                    else if (e instanceof Zk) this._setRanges(e.getRanges(), e.isBackward);
                    else if (e && typeof e.getRanges == "function") this._setRanges(e.getRanges(), e.isBackward);
                    else if (e instanceof Hk) this._setRanges([
                        e
                    ], !!o && !!o.backward);
                    else if (e instanceof Ok) this._setRanges([
                        new Hk(e)
                    ]);
                    else if (e instanceof Ek) {
                        const t = !!o && !!o.backward;
                        let i;
                        if (n == "in") i = Hk._createIn(e);
                        else if (n == "on") i = Hk._createOn(e);
                        else if (n !== undefined) i = new Hk(Ok._createAt(e, n));
                        else throw new R("model-selection-setto-required-second-parameter", [
                            this,
                            e
                        ]);
                        this._setRanges([
                            i
                        ], t);
                    } else if (Et(e)) this._setRanges(e, o && !!o.backward);
                    else throw new R("model-selection-setto-not-selectable", [
                        this,
                        e
                    ]);
                }
                _setRanges(t, e = false) {
                    const n = Array.from(t);
                    const o = n.some((e)=>{
                        if (!(e instanceof Hk)) throw new R("model-selection-set-ranges-not-range", [
                            this,
                            t
                        ]);
                        return this._ranges.every((t)=>!t.isEqual(e));
                    });
                    if (n.length === this._ranges.length && !o) return;
                    this._replaceAllRanges(n);
                    this._lastRangeBackward = !!e;
                    this.fire("change:range", {
                        directChange: true
                    });
                }
                setFocus(t, e) {
                    if (this.anchor === null) throw new R("model-selection-setfocus-no-ranges", [
                        this,
                        t
                    ]);
                    const n = Ok._createAt(t, e);
                    if (n.compareWith(this.focus) == "same") return;
                    const o = this.anchor;
                    if (this._ranges.length) this._popRange();
                    if (n.compareWith(o) == "before") {
                        this._pushRange(new Hk(n, o));
                        this._lastRangeBackward = true;
                    } else {
                        this._pushRange(new Hk(o, n));
                        this._lastRangeBackward = false;
                    }
                    this.fire("change:range", {
                        directChange: true
                    });
                }
                getAttribute(t) {
                    return this._attrs.get(t);
                }
                getAttributes() {
                    return this._attrs.entries();
                }
                getAttributeKeys() {
                    return this._attrs.keys();
                }
                hasAttribute(t) {
                    return this._attrs.has(t);
                }
                removeAttribute(t) {
                    if (this.hasAttribute(t)) {
                        this._attrs.delete(t);
                        this.fire("change:attribute", {
                            attributeKeys: [
                                t
                            ],
                            directChange: true
                        });
                    }
                }
                setAttribute(t, e) {
                    if (this.getAttribute(t) !== e) {
                        this._attrs.set(t, e);
                        this.fire("change:attribute", {
                            attributeKeys: [
                                t
                            ],
                            directChange: true
                        });
                    }
                }
                getSelectedElement() {
                    if (this.rangeCount !== 1) return null;
                    return this.getFirstRange().getContainedElement();
                }
                *getSelectedBlocks() {
                    const t = new WeakSet;
                    for (const e of this.getRanges()){
                        const n = Qk(e.start, t);
                        if (tb(n, e)) yield n;
                        for (const n of e.getWalker()){
                            const o = n.item;
                            if (n.type == "elementEnd" && Yk(o, t, e)) yield o;
                        }
                        const o = Qk(e.end, t);
                        if (eb(o, e)) yield o;
                    }
                }
                containsEntireContent(t = this.anchor.root) {
                    const e = Ok._createAt(t, 0);
                    const n = Ok._createAt(t, "end");
                    return e.isTouching(this.getFirstPosition()) && n.isTouching(this.getLastPosition());
                }
                _pushRange(t) {
                    this._checkRange(t);
                    this._ranges.push(new Hk(t.start, t.end));
                }
                _checkRange(t) {
                    for(let e = 0; e < this._ranges.length; e++){
                        if (t.isIntersecting(this._ranges[e])) throw new R("model-selection-range-intersects", [
                            this,
                            t
                        ], {
                            addedRange: t,
                            intersectingRange: this._ranges[e]
                        });
                    }
                }
                _replaceAllRanges(t) {
                    this._removeAllRanges();
                    for (const e of t)this._pushRange(e);
                }
                _removeAllRanges() {
                    while(this._ranges.length > 0)this._popRange();
                }
                _popRange() {
                    this._ranges.pop();
                }
            }
            Zk.prototype.is = function(t) {
                return t === "selection" || t === "model:selection";
            };
            function Jk(t, e) {
                if (e.has(t)) return false;
                e.add(t);
                return t.root.document.model.schema.isBlock(t) && !!t.parent;
            }
            function Yk(t, e, n) {
                return Jk(t, e) && Xk(t, n);
            }
            function Qk(t, e) {
                const n = t.parent;
                const o = n.root.document.model.schema;
                const i = t.parent.getAncestors({
                    parentFirst: true,
                    includeSelf: true
                });
                let r = false;
                const s = i.find((t)=>{
                    if (r) return false;
                    r = o.isLimit(t);
                    return !r && Jk(t, e);
                });
                i.forEach((t)=>e.add(t));
                return s;
            }
            function Xk(t, e) {
                const n = nb(t);
                if (!n) return true;
                const o = e.containsRange(Hk._createOn(n), true);
                return !o;
            }
            function tb(t, e) {
                if (!t) return false;
                if (e.isCollapsed || t.isEmpty) return true;
                if (e.start.isTouching(Ok._createAt(t, t.maxOffset))) return false;
                return Xk(t, e);
            }
            function eb(t, e) {
                if (!t) return false;
                if (e.isCollapsed || t.isEmpty) return true;
                if (e.end.isTouching(Ok._createAt(t, 0))) return false;
                return Xk(t, e);
            }
            function nb(t) {
                const e = t.root.document.model.schema;
                let n = t.parent;
                while(n){
                    if (e.isBlock(n)) return n;
                    n = n.parent;
                }
            }
            class ob extends G(Hk) {
                constructor(t, e){
                    super(t, e);
                    ib.call(this);
                }
                detach() {
                    this.stopListening();
                }
                toRange() {
                    return new Hk(this.start, this.end);
                }
                static fromRange(t) {
                    return new ob(t.start, t.end);
                }
            }
            ob.prototype.is = function(t) {
                return t === "liveRange" || t === "model:liveRange" || t == "range" || t === "model:range";
            };
            function ib() {
                this.listenTo(this.root.document.model, "applyOperation", (t, e)=>{
                    const n = e[0];
                    if (!n.isDocumentOperation) return;
                    rb.call(this, n);
                }, {
                    priority: "low"
                });
            }
            function rb(t) {
                const e = this.getTransformedByOperation(t);
                const n = Hk._createFromRanges(e);
                const o = !n.isEqual(this);
                const i = sb(this, t);
                let r = null;
                if (o) {
                    if (n.root.rootName == "$graveyard") {
                        if (t.type == "remove") r = t.sourcePosition;
                        else r = t.deletionPosition;
                    }
                    const e = this.toRange();
                    this.start = n.start;
                    this.end = n.end;
                    this.fire("change:range", e, {
                        deletionPosition: r
                    });
                } else if (i) this.fire("change:content", this.toRange(), {
                    deletionPosition: r
                });
            }
            function sb(t, e) {
                switch(e.type){
                    case "insert":
                        return t.containsPosition(e.position);
                    case "move":
                    case "remove":
                    case "reinsert":
                    case "merge":
                        return t.containsPosition(e.sourcePosition) || t.start.isEqual(e.sourcePosition) || t.containsPosition(e.targetPosition);
                    case "split":
                        return t.containsPosition(e.splitPosition) || t.containsPosition(e.insertionPosition);
                }
                return false;
            }
            const ab = "selection:";
            class cb extends G(xk) {
                constructor(t){
                    super();
                    this._selection = new lb(t);
                    this._selection.delegate("change:range").to(this);
                    this._selection.delegate("change:attribute").to(this);
                    this._selection.delegate("change:marker").to(this);
                }
                get isCollapsed() {
                    return this._selection.isCollapsed;
                }
                get anchor() {
                    return this._selection.anchor;
                }
                get focus() {
                    return this._selection.focus;
                }
                get rangeCount() {
                    return this._selection.rangeCount;
                }
                get hasOwnRange() {
                    return this._selection.hasOwnRange;
                }
                get isBackward() {
                    return this._selection.isBackward;
                }
                get isGravityOverridden() {
                    return this._selection.isGravityOverridden;
                }
                get markers() {
                    return this._selection.markers;
                }
                get _ranges() {
                    return this._selection._ranges;
                }
                getRanges() {
                    return this._selection.getRanges();
                }
                getFirstPosition() {
                    return this._selection.getFirstPosition();
                }
                getLastPosition() {
                    return this._selection.getLastPosition();
                }
                getFirstRange() {
                    return this._selection.getFirstRange();
                }
                getLastRange() {
                    return this._selection.getLastRange();
                }
                getSelectedBlocks() {
                    return this._selection.getSelectedBlocks();
                }
                getSelectedElement() {
                    return this._selection.getSelectedElement();
                }
                containsEntireContent(t) {
                    return this._selection.containsEntireContent(t);
                }
                destroy() {
                    this._selection.destroy();
                }
                getAttributeKeys() {
                    return this._selection.getAttributeKeys();
                }
                getAttributes() {
                    return this._selection.getAttributes();
                }
                getAttribute(t) {
                    return this._selection.getAttribute(t);
                }
                hasAttribute(t) {
                    return this._selection.hasAttribute(t);
                }
                refresh() {
                    this._selection.updateMarkers();
                    this._selection._updateAttributes(false);
                }
                observeMarkers(t) {
                    this._selection.observeMarkers(t);
                }
                _setFocus(t, e) {
                    this._selection.setFocus(t, e);
                }
                _setTo(...t) {
                    this._selection.setTo(...t);
                }
                _setAttribute(t, e) {
                    this._selection.setAttribute(t, e);
                }
                _removeAttribute(t) {
                    this._selection.removeAttribute(t);
                }
                _getStoredAttributes() {
                    return this._selection.getStoredAttributes();
                }
                _overrideGravity() {
                    return this._selection.overrideGravity();
                }
                _restoreGravity(t) {
                    this._selection.restoreGravity(t);
                }
                static _getStoreAttributeKey(t) {
                    return ab + t;
                }
                static _isStoreAttributeKey(t) {
                    return t.startsWith(ab);
                }
            }
            cb.prototype.is = function(t) {
                return t === "selection" || t == "model:selection" || t == "documentSelection" || t == "model:documentSelection";
            };
            class lb extends Zk {
                constructor(t){
                    super();
                    this.markers = new hl({
                        idProperty: "name"
                    });
                    this._attributePriority = new Map;
                    this._selectionRestorePosition = null;
                    this._hasChangedRange = false;
                    this._overriddenGravityRegister = new Set;
                    this._observedMarkers = new Set;
                    this._model = t.model;
                    this._document = t;
                    this.listenTo(this._model, "applyOperation", (t, e)=>{
                        const n = e[0];
                        if (!n.isDocumentOperation || n.type == "marker" || n.type == "rename" || n.type == "noop") return;
                        if (this._ranges.length == 0 && this._selectionRestorePosition) this._fixGraveyardSelection(this._selectionRestorePosition);
                        this._selectionRestorePosition = null;
                        if (this._hasChangedRange) {
                            this._hasChangedRange = false;
                            this.fire("change:range", {
                                directChange: false
                            });
                        }
                    }, {
                        priority: "lowest"
                    });
                    this.on("change:range", ()=>{
                        this._validateSelectionRanges(this.getRanges());
                    });
                    this.listenTo(this._model.markers, "update", (t, e, n, o)=>{
                        this._updateMarker(e, o);
                    });
                    this.listenTo(this._document, "change", (t, e)=>{
                        ub(this._model, e);
                    });
                }
                get isCollapsed() {
                    const t = this._ranges.length;
                    return t === 0 ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
                }
                get anchor() {
                    return super.anchor || this._document._getDefaultRange().start;
                }
                get focus() {
                    return super.focus || this._document._getDefaultRange().end;
                }
                get rangeCount() {
                    return this._ranges.length ? this._ranges.length : 1;
                }
                get hasOwnRange() {
                    return this._ranges.length > 0;
                }
                get isGravityOverridden() {
                    return !!this._overriddenGravityRegister.size;
                }
                destroy() {
                    for(let t = 0; t < this._ranges.length; t++)this._ranges[t].detach();
                    this.stopListening();
                }
                *getRanges() {
                    if (this._ranges.length) yield* super.getRanges();
                    else yield this._document._getDefaultRange();
                }
                getFirstRange() {
                    return super.getFirstRange() || this._document._getDefaultRange();
                }
                getLastRange() {
                    return super.getLastRange() || this._document._getDefaultRange();
                }
                setTo(...t) {
                    super.setTo(...t);
                    this._updateAttributes(true);
                    this.updateMarkers();
                }
                setFocus(t, e) {
                    super.setFocus(t, e);
                    this._updateAttributes(true);
                    this.updateMarkers();
                }
                setAttribute(t, e) {
                    if (this._setAttribute(t, e)) {
                        const e = [
                            t
                        ];
                        this.fire("change:attribute", {
                            attributeKeys: e,
                            directChange: true
                        });
                    }
                }
                removeAttribute(t) {
                    if (this._removeAttribute(t)) {
                        const e = [
                            t
                        ];
                        this.fire("change:attribute", {
                            attributeKeys: e,
                            directChange: true
                        });
                    }
                }
                overrideGravity() {
                    const t = S();
                    this._overriddenGravityRegister.add(t);
                    if (this._overriddenGravityRegister.size === 1) this._updateAttributes(true);
                    return t;
                }
                restoreGravity(t) {
                    if (!this._overriddenGravityRegister.has(t)) throw new R("document-selection-gravity-wrong-restore", this, {
                        uid: t
                    });
                    this._overriddenGravityRegister.delete(t);
                    if (!this.isGravityOverridden) this._updateAttributes(true);
                }
                observeMarkers(t) {
                    this._observedMarkers.add(t);
                    this.updateMarkers();
                }
                _replaceAllRanges(t) {
                    this._validateSelectionRanges(t);
                    super._replaceAllRanges(t);
                }
                _popRange() {
                    this._ranges.pop().detach();
                }
                _pushRange(t) {
                    const e = this._prepareRange(t);
                    if (e) this._ranges.push(e);
                }
                _validateSelectionRanges(t) {
                    for (const e of t){
                        if (!this._document._validateSelectionRange(e)) throw new R("document-selection-wrong-position", this, {
                            range: e
                        });
                    }
                }
                _prepareRange(t) {
                    this._checkRange(t);
                    if (t.root == this._document.graveyard) return;
                    const e = ob.fromRange(t);
                    e.on("change:range", (t, n, o)=>{
                        this._hasChangedRange = true;
                        if (e.root == this._document.graveyard) {
                            this._selectionRestorePosition = o.deletionPosition;
                            const t = this._ranges.indexOf(e);
                            this._ranges.splice(t, 1);
                            e.detach();
                        }
                    });
                    return e;
                }
                updateMarkers() {
                    if (!this._observedMarkers.size) return;
                    const t = [];
                    let e = false;
                    for (const e of this._model.markers){
                        const n = e.name.split(":", 1)[0];
                        if (!this._observedMarkers.has(n)) continue;
                        const o = e.getRange();
                        for (const n of this.getRanges())if (o.containsRange(n, !n.isCollapsed)) t.push(e);
                    }
                    const n = Array.from(this.markers);
                    for (const n of t)if (!this.markers.has(n)) {
                        this.markers.add(n);
                        e = true;
                    }
                    for (const n of Array.from(this.markers))if (!t.includes(n)) {
                        this.markers.remove(n);
                        e = true;
                    }
                    if (e) this.fire("change:marker", {
                        oldMarkers: n,
                        directChange: false
                    });
                }
                _updateMarker(t, e) {
                    const n = t.name.split(":", 1)[0];
                    if (!this._observedMarkers.has(n)) return;
                    let o = false;
                    const i = Array.from(this.markers);
                    const r = this.markers.has(t);
                    if (!e) {
                        if (r) {
                            this.markers.remove(t);
                            o = true;
                        }
                    } else {
                        let n = false;
                        for (const t of this.getRanges())if (e.containsRange(t, !t.isCollapsed)) {
                            n = true;
                            break;
                        }
                        if (n && !r) {
                            this.markers.add(t);
                            o = true;
                        } else if (!n && r) {
                            this.markers.remove(t);
                            o = true;
                        }
                    }
                    if (o) this.fire("change:marker", {
                        oldMarkers: i,
                        directChange: false
                    });
                }
                _updateAttributes(t) {
                    const e = kl(this._getSurroundingAttributes());
                    const n = kl(this.getAttributes());
                    if (t) {
                        this._attributePriority = new Map;
                        this._attrs = new Map;
                    } else {
                        for (const [t, e] of this._attributePriority)if (e == "low") {
                            this._attrs.delete(t);
                            this._attributePriority.delete(t);
                        }
                    }
                    this._setAttributesTo(e);
                    const o = [];
                    for (const [t, e] of this.getAttributes())if (!n.has(t) || n.get(t) !== e) o.push(t);
                    for (const [t] of n)if (!this.hasAttribute(t)) o.push(t);
                    if (o.length > 0) this.fire("change:attribute", {
                        attributeKeys: o,
                        directChange: false
                    });
                }
                _setAttribute(t, e, n = true) {
                    const o = n ? "normal" : "low";
                    if (o == "low" && this._attributePriority.get(t) == "normal") return false;
                    const i = super.getAttribute(t);
                    if (i === e) return false;
                    this._attrs.set(t, e);
                    this._attributePriority.set(t, o);
                    return true;
                }
                _removeAttribute(t, e = true) {
                    const n = e ? "normal" : "low";
                    if (n == "low" && this._attributePriority.get(t) == "normal") return false;
                    this._attributePriority.set(t, n);
                    if (!super.hasAttribute(t)) return false;
                    this._attrs.delete(t);
                    return true;
                }
                _setAttributesTo(t) {
                    const e = new Set;
                    for (const [e, n] of this.getAttributes()){
                        if (t.get(e) === n) continue;
                        this._removeAttribute(e, false);
                    }
                    for (const [n, o] of t){
                        const t = this._setAttribute(n, o, false);
                        if (t) e.add(n);
                    }
                    return e;
                }
                *getStoredAttributes() {
                    const t = this.getFirstPosition().parent;
                    if (this.isCollapsed && t.isEmpty) {
                        for (const e of t.getAttributeKeys())if (e.startsWith(ab)) {
                            const n = e.substr(ab.length);
                            yield [
                                n,
                                t.getAttribute(e)
                            ];
                        }
                    }
                }
                _getSurroundingAttributes() {
                    const t = this.getFirstPosition();
                    const e = this._model.schema;
                    if (t.root.rootName == "$graveyard") return null;
                    let n = null;
                    if (!this.isCollapsed) {
                        const t = this.getFirstRange();
                        for (const o of t){
                            if (o.item.is("element") && e.isObject(o.item)) {
                                n = db(o.item, e);
                                break;
                            }
                            if (o.type == "text") {
                                n = o.item.getAttributes();
                                break;
                            }
                        }
                    } else {
                        const o = t.textNode ? t.textNode : t.nodeBefore;
                        const i = t.textNode ? t.textNode : t.nodeAfter;
                        if (!this.isGravityOverridden) n = db(o, e);
                        if (!n) n = db(i, e);
                        if (!this.isGravityOverridden && !n) {
                            let t = o;
                            while(t && !n){
                                t = t.previousSibling;
                                n = db(t, e);
                            }
                        }
                        if (!n) {
                            let t = i;
                            while(t && !n){
                                t = t.nextSibling;
                                n = db(t, e);
                            }
                        }
                        if (!n) n = this.getStoredAttributes();
                    }
                    return n;
                }
                _fixGraveyardSelection(t) {
                    const e = this._model.schema.getNearestSelectionRange(t);
                    if (e) this._pushRange(e);
                }
            }
            function db(t, e) {
                if (!t) return null;
                if (t instanceof Tk || t instanceof Sk) return t.getAttributes();
                if (!e.isInline(t)) return null;
                if (!e.isObject(t)) return [];
                const n = [];
                for (const [o, i] of t.getAttributes())if (e.checkAttribute("$text", o) && e.getAttributeProperties(o).copyFromObject !== false) n.push([
                    o,
                    i
                ]);
                return n;
            }
            function ub(t, e) {
                const n = t.document.differ;
                for (const o of n.getChanges()){
                    if (o.type != "insert") continue;
                    const n = o.position.parent;
                    const i = o.length === n.maxOffset;
                    if (i) t.enqueueChange(e, (t)=>{
                        const e = Array.from(n.getAttributeKeys()).filter((t)=>t.startsWith(ab));
                        for (const o of e)t.removeAttribute(o, n);
                    });
                }
            }
            class hb {
                constructor(t){
                    this._dispatchers = t;
                }
                add(t) {
                    for (const e of this._dispatchers)t(e);
                    return this;
                }
            }
            class fb extends hb {
                elementToElement(t) {
                    return this.add(Vb(t));
                }
                elementToStructure(t) {
                    return this.add(Mb(t));
                }
                attributeToElement(t) {
                    return this.add(Lb(t));
                }
                attributeToAttribute(t) {
                    return this.add(zb(t));
                }
                markerToElement(t) {
                    return this.add(Nb(t));
                }
                markerToHighlight(t) {
                    return this.add(Hb(t));
                }
                markerToData(t) {
                    return this.add(Fb(t));
                }
            }
            function pb() {
                return (t, e, n)=>{
                    if (!n.consumable.consume(e.item, t.name)) return;
                    const o = n.writer;
                    const i = n.mapper.toViewPosition(e.range.start);
                    const r = o.createText(e.item.data);
                    o.insert(i, r);
                };
            }
            function gb() {
                return (t, e, n)=>{
                    n.convertAttributes(e.item);
                    if (!e.reconversion && e.item.is("element") && !e.item.isEmpty) n.convertChildren(e.item);
                };
            }
            function mb() {
                return (t, e, n)=>{
                    const o = n.mapper.toViewPosition(e.position);
                    const i = e.position.getShiftedBy(e.length);
                    const r = n.mapper.toViewPosition(i, {
                        isPhantom: true
                    });
                    const s = n.writer.createRange(o, r);
                    const a = n.writer.remove(s.getTrimmed());
                    for (const t of n.writer.createRangeIn(a).getItems())n.mapper.unbindViewElement(t, {
                        defer: true
                    });
                };
            }
            function kb(t, e) {
                const n = t.createAttributeElement("span", e.attributes);
                if (e.classes) n._addClass(e.classes);
                if (typeof e.priority === "number") n._priority = e.priority;
                n._id = e.id;
                return n;
            }
            function bb() {
                return (t, e, n)=>{
                    const o = e.selection;
                    if (o.isCollapsed) return;
                    if (!n.consumable.consume(o, "selection")) return;
                    const i = [];
                    for (const t of o.getRanges())i.push(n.mapper.toViewRange(t));
                    n.writer.setSelection(i, {
                        backward: o.isBackward
                    });
                };
            }
            function wb() {
                return (t, e, n)=>{
                    const o = e.selection;
                    if (!o.isCollapsed) return;
                    if (!n.consumable.consume(o, "selection")) return;
                    const i = n.writer;
                    const r = o.getFirstPosition();
                    const s = n.mapper.toViewPosition(r);
                    const a = i.breakAttributes(s);
                    i.setSelection(a);
                };
            }
            function _b() {
                return (t, e, n)=>{
                    const o = n.writer;
                    const i = o.document.selection;
                    for (const t of i.getRanges()){
                        if (t.isCollapsed) {
                            if (t.end.parent.isAttached()) n.writer.mergeAttributes(t.start);
                        }
                    }
                    o.setSelection(null);
                };
            }
            function Ab(t) {
                return (e, n, o)=>{
                    if (!o.consumable.test(n.item, e.name)) return;
                    const i = t(n.attributeOldValue, o, n);
                    const r = t(n.attributeNewValue, o, n);
                    if (!i && !r) return;
                    o.consumable.consume(n.item, e.name);
                    const s = o.writer;
                    const a = s.document.selection;
                    if (n.item instanceof Zk || n.item instanceof cb) s.wrap(a.getFirstRange(), r);
                    else {
                        let t = o.mapper.toViewRange(n.range);
                        if (n.attributeOldValue !== null && i) t = s.unwrap(t, i);
                        if (n.attributeNewValue !== null && r) s.wrap(t, r);
                    }
                };
            }
            function vb(t, e = nw) {
                return (n, o, i)=>{
                    if (!e(o.item, i.consumable, {
                        preflight: true
                    })) return;
                    const r = t(o.item, i, o);
                    if (!r) return;
                    e(o.item, i.consumable);
                    const s = i.mapper.toViewPosition(o.range.start);
                    i.mapper.bindElements(o.item, r);
                    i.writer.insert(s, r);
                    i.convertAttributes(o.item);
                    tw(r, o.item.getChildren(), i, {
                        reconversion: o.reconversion
                    });
                };
            }
            function Cb(t, e) {
                return (n, o, i)=>{
                    if (!e(o.item, i.consumable, {
                        preflight: true
                    })) return;
                    const r = new Map;
                    i.writer._registerSlotFactory(Yb(o.item, r, i));
                    const s = t(o.item, i, o);
                    i.writer._clearSlotFactory();
                    if (!s) return;
                    Qb(o.item, r, i);
                    e(o.item, i.consumable);
                    const a = i.mapper.toViewPosition(o.range.start);
                    i.mapper.bindElements(o.item, s);
                    i.writer.insert(a, s);
                    i.convertAttributes(o.item);
                    Xb(s, r, i, {
                        reconversion: o.reconversion
                    });
                };
            }
            function yb(t) {
                return (e, n, o)=>{
                    n.isOpening = true;
                    const i = t(n, o);
                    n.isOpening = false;
                    const r = t(n, o);
                    if (!i || !r) return;
                    const s = n.markerRange;
                    if (s.isCollapsed && !o.consumable.consume(s, e.name)) return;
                    for (const t of s){
                        if (!o.consumable.consume(t.item, e.name)) return;
                    }
                    const a = o.mapper;
                    const c = o.writer;
                    c.insert(a.toViewPosition(s.start), i);
                    o.mapper.bindElementToMarker(i, n.markerName);
                    if (!s.isCollapsed) {
                        c.insert(a.toViewPosition(s.end), r);
                        o.mapper.bindElementToMarker(r, n.markerName);
                    }
                    e.stop();
                };
            }
            function xb() {
                return (t, e, n)=>{
                    const o = n.mapper.markerNameToElements(e.markerName);
                    if (!o) return;
                    for (const t of o){
                        n.mapper.unbindElementFromMarkerName(t, e.markerName);
                        n.writer.clear(n.writer.createRangeOn(t), t);
                    }
                    n.writer.clearClonedElementsGroup(e.markerName);
                    t.stop();
                };
            }
            function Eb(t) {
                return (e, n, o)=>{
                    const i = t(n.markerName, o);
                    if (!i) return;
                    const r = n.markerRange;
                    if (!o.consumable.consume(r, e.name)) return;
                    Db(r, false, o, n, i);
                    Db(r, true, o, n, i);
                    e.stop();
                };
            }
            function Db(t, e, n, o, i) {
                const r = e ? t.start : t.end;
                const s = r.nodeAfter && r.nodeAfter.is("element") ? r.nodeAfter : null;
                const a = r.nodeBefore && r.nodeBefore.is("element") ? r.nodeBefore : null;
                if (s || a) {
                    let t;
                    let r;
                    if (e && s || !e && !a) {
                        t = s;
                        r = true;
                    } else {
                        t = a;
                        r = false;
                    }
                    const c = n.mapper.toViewElement(t);
                    if (c) {
                        Sb(c, e, r, n, o, i);
                        return;
                    }
                }
                const c = n.mapper.toViewPosition(r);
                Tb(c, e, n, o, i);
            }
            function Sb(t, e, n, o, i, r) {
                const s = `data-${r.group}-${e ? "start" : "end"}-${n ? "before" : "after"}`;
                const a = t.hasAttribute(s) ? t.getAttribute(s).split(",") : [];
                a.unshift(r.name);
                o.writer.setAttribute(s, a.join(","), t);
                o.mapper.bindElementToMarker(t, i.markerName);
            }
            function Tb(t, e, n, o, i) {
                const r = `${i.group}-${e ? "start" : "end"}`;
                const s = i.name ? {
                    name: i.name
                } : null;
                const a = n.writer.createUIElement(r, s);
                n.writer.insert(t, a);
                n.mapper.bindElementToMarker(a, o.markerName);
            }
            function Bb(t) {
                return (e, n, o)=>{
                    const i = t(n.markerName, o);
                    if (!i) return;
                    const r = o.mapper.markerNameToElements(n.markerName);
                    if (!r) return;
                    for (const t of r){
                        o.mapper.unbindElementFromMarkerName(t, n.markerName);
                        if (t.is("containerElement")) {
                            s(`data-${i.group}-start-before`, t);
                            s(`data-${i.group}-start-after`, t);
                            s(`data-${i.group}-end-before`, t);
                            s(`data-${i.group}-end-after`, t);
                        } else o.writer.clear(o.writer.createRangeOn(t), t);
                    }
                    o.writer.clearClonedElementsGroup(n.markerName);
                    e.stop();
                    function s(t, e) {
                        if (e.hasAttribute(t)) {
                            const n = new Set(e.getAttribute(t).split(","));
                            n.delete(i.name);
                            if (n.size == 0) o.writer.removeAttribute(t, e);
                            else o.writer.setAttribute(t, Array.from(n).join(","), e);
                        }
                    }
                };
            }
            function Pb(t) {
                return (e, n, o)=>{
                    if (!o.consumable.test(n.item, e.name)) return;
                    const i = t(n.attributeOldValue, o, n);
                    const r = t(n.attributeNewValue, o, n);
                    if (!i && !r) return;
                    o.consumable.consume(n.item, e.name);
                    const s = o.mapper.toViewElement(n.item);
                    const a = o.writer;
                    if (!s) throw new R("conversion-attribute-to-attribute-on-text", o.dispatcher, n);
                    if (n.attributeOldValue !== null && i) {
                        if (i.key == "class") {
                            const t = nl(i.value);
                            for (const e of t)a.removeClass(e, s);
                        } else if (i.key == "style") {
                            const t = Object.keys(i.value);
                            for (const e of t)a.removeStyle(e, s);
                        } else a.removeAttribute(i.key, s);
                    }
                    if (n.attributeNewValue !== null && r) {
                        if (r.key == "class") {
                            const t = nl(r.value);
                            for (const e of t)a.addClass(e, s);
                        } else if (r.key == "style") {
                            const t = Object.keys(r.value);
                            for (const e of t)a.setStyle(e, r.value[e], s);
                        } else a.setAttribute(r.key, r.value, s);
                    }
                };
            }
            function Ib(t) {
                return (e, n, o)=>{
                    if (!n.item) return;
                    if (!(n.item instanceof Zk || n.item instanceof cb) && !n.item.is("$textProxy")) return;
                    const i = Ub(t, n, o);
                    if (!i) return;
                    if (!o.consumable.consume(n.item, e.name)) return;
                    const r = o.writer;
                    const s = kb(r, i);
                    const a = r.document.selection;
                    if (n.item instanceof Zk || n.item instanceof cb) r.wrap(a.getFirstRange(), s);
                    else {
                        const t = o.mapper.toViewRange(n.range);
                        const e = r.wrap(t, s);
                        for (const t of e.getItems())if (t.is("attributeElement") && t.isSimilar(s)) {
                            o.mapper.bindElementToMarker(t, n.markerName);
                            break;
                        }
                    }
                };
            }
            function Rb(t) {
                return (e, n, o)=>{
                    if (!n.item) return;
                    if (!(n.item instanceof Bk)) return;
                    const i = Ub(t, n, o);
                    if (!i) return;
                    if (!o.consumable.test(n.item, e.name)) return;
                    const r = o.mapper.toViewElement(n.item);
                    if (r && r.getCustomProperty("addHighlight")) {
                        o.consumable.consume(n.item, e.name);
                        for (const t of Hk._createIn(n.item))o.consumable.consume(t.item, e.name);
                        const t = r.getCustomProperty("addHighlight");
                        t(r, i, o.writer);
                        o.mapper.bindElementToMarker(r, n.markerName);
                    }
                };
            }
            function Ob(t) {
                return (e, n, o)=>{
                    if (n.markerRange.isCollapsed) return;
                    const i = Ub(t, n, o);
                    if (!i) return;
                    const r = kb(o.writer, i);
                    const s = o.mapper.markerNameToElements(n.markerName);
                    if (!s) return;
                    for (const t of s){
                        o.mapper.unbindElementFromMarkerName(t, n.markerName);
                        if (t.is("attributeElement")) o.writer.unwrap(o.writer.createRangeOn(t), r);
                        else {
                            const e = t.getCustomProperty("removeHighlight");
                            e(t, i.id, o.writer);
                        }
                    }
                    o.writer.clearClonedElementsGroup(n.markerName);
                    e.stop();
                };
            }
            function Vb(t) {
                const e = jb(t.model);
                const n = qb(t.view, "container");
                if (e.attributes.length) e.children = true;
                return (o)=>{
                    o.on(`insert:${e.name}`, vb(n, Jb(e)), {
                        priority: t.converterPriority || "normal"
                    });
                    if (e.children || e.attributes.length) o.on("reduceChanges", Zb(e), {
                        priority: "low"
                    });
                };
            }
            function Mb(t) {
                const e = jb(t.model);
                const n = qb(t.view, "container");
                e.children = true;
                return (o)=>{
                    if (o._conversionApi.schema.checkChild(e.name, "$text")) throw new R("conversion-element-to-structure-disallowed-text", o, {
                        elementName: e.name
                    });
                    o.on(`insert:${e.name}`, Cb(n, Jb(e)), {
                        priority: t.converterPriority || "normal"
                    });
                    o.on("reduceChanges", Zb(e), {
                        priority: "low"
                    });
                };
            }
            function Lb(t) {
                t = Ck(t);
                let e = t.model;
                if (typeof e == "string") e = {
                    key: e
                };
                let n = `attribute:${e.key}`;
                if (e.name) n += ":" + e.name;
                if (e.values) for (const n of e.values)t.view[n] = qb(t.view[n], "attribute");
                else t.view = qb(t.view, "attribute");
                const o = $b(t);
                return (e)=>{
                    e.on(n, Ab(o), {
                        priority: t.converterPriority || "normal"
                    });
                };
            }
            function zb(t) {
                t = Ck(t);
                let e = t.model;
                if (typeof e == "string") e = {
                    key: e
                };
                let n = `attribute:${e.key}`;
                if (e.name) n += ":" + e.name;
                if (e.values) for (const n of e.values)t.view[n] = Gb(t.view[n]);
                else t.view = Gb(t.view);
                const o = $b(t);
                return (e)=>{
                    e.on(n, Pb(o), {
                        priority: t.converterPriority || "normal"
                    });
                };
            }
            function Nb(t) {
                const e = qb(t.view, "ui");
                return (n)=>{
                    n.on(`addMarker:${t.model}`, yb(e), {
                        priority: t.converterPriority || "normal"
                    });
                    n.on(`removeMarker:${t.model}`, xb(), {
                        priority: t.converterPriority || "normal"
                    });
                };
            }
            function Fb(t) {
                t = Ck(t);
                const e = t.model;
                let n = t.view;
                if (!n) n = (n)=>({
                        group: e,
                        name: n.substr(t.model.length + 1)
                    });
                return (o)=>{
                    o.on(`addMarker:${e}`, Eb(n), {
                        priority: t.converterPriority || "normal"
                    });
                    o.on(`removeMarker:${e}`, Bb(n), {
                        priority: t.converterPriority || "normal"
                    });
                };
            }
            function Hb(t) {
                return (e)=>{
                    e.on(`addMarker:${t.model}`, Ib(t.view), {
                        priority: t.converterPriority || "normal"
                    });
                    e.on(`addMarker:${t.model}`, Rb(t.view), {
                        priority: t.converterPriority || "normal"
                    });
                    e.on(`removeMarker:${t.model}`, Ob(t.view), {
                        priority: t.converterPriority || "normal"
                    });
                };
            }
            function jb(t) {
                if (typeof t == "string") t = {
                    name: t
                };
                if (!t.attributes) t.attributes = [];
                else if (!Array.isArray(t.attributes)) t.attributes = [
                    t.attributes
                ];
                t.children = !!t.children;
                return t;
            }
            function qb(t, e) {
                if (typeof t == "function") return t;
                return (n, o)=>Wb(t, o, e);
            }
            function Wb(t, e, n) {
                if (typeof t == "string") t = {
                    name: t
                };
                let o;
                const i = e.writer;
                const r = Object.assign({}, t.attributes);
                if (n == "container") o = i.createContainerElement(t.name, r);
                else if (n == "attribute") {
                    const e = {
                        priority: t.priority || Pp.DEFAULT_PRIORITY
                    };
                    o = i.createAttributeElement(t.name, r, e);
                } else o = i.createUIElement(t.name, r);
                if (t.styles) {
                    const e = Object.keys(t.styles);
                    for (const n of e)i.setStyle(n, t.styles[n], o);
                }
                if (t.classes) {
                    const e = t.classes;
                    if (typeof e == "string") i.addClass(e, o);
                    else for (const t of e)i.addClass(t, o);
                }
                return o;
            }
            function $b(t) {
                if (t.model.values) return (e, n, o)=>{
                    const i = t.view[e];
                    if (i) return i(e, n, o);
                    return null;
                };
                else return t.view;
            }
            function Gb(t) {
                if (typeof t == "string") return (e)=>({
                        key: t,
                        value: e
                    });
                else if (typeof t == "object") {
                    if (t.value) return ()=>t;
                    else return (e)=>({
                            key: t.key,
                            value: e
                        });
                } else return t;
            }
            function Ub(t, e, n) {
                const o = typeof t == "function" ? t(e, n) : t;
                if (!o) return null;
                if (!o.priority) o.priority = 10;
                if (!o.id) o.id = e.markerName;
                return o;
            }
            function Kb(t) {
                return (e, n)=>{
                    if (!e.is("element", t.name)) return false;
                    if (n.type == "attribute") {
                        if (t.attributes.includes(n.attributeKey)) return true;
                    } else {
                        if (t.children) return true;
                    }
                    return false;
                };
            }
            function Zb(t) {
                const e = Kb(t);
                return (t, n)=>{
                    const o = [];
                    if (!n.reconvertedElements) n.reconvertedElements = new Set;
                    for (const t of n.changes){
                        const i = t.type == "attribute" ? t.range.start.nodeAfter : t.position.parent;
                        if (!i || !e(i, t)) {
                            o.push(t);
                            continue;
                        }
                        if (!n.reconvertedElements.has(i)) {
                            n.reconvertedElements.add(i);
                            const t = Ok._createBefore(i);
                            let e = o.length;
                            for(let n = o.length - 1; n >= 0; n--){
                                const i = o[n];
                                const r = i.type == "attribute" ? i.range.start : i.position;
                                const s = r.compareWith(t);
                                if (s == "before" || i.type == "remove" && s == "same") break;
                                e = n;
                            }
                            o.splice(e, 0, {
                                type: "remove",
                                name: i.name,
                                position: t,
                                length: 1
                            }, {
                                type: "reinsert",
                                name: i.name,
                                position: t,
                                length: 1
                            });
                        }
                    }
                    n.changes = o;
                };
            }
            function Jb(t) {
                return (e, n, o = {})=>{
                    const i = [
                        "insert"
                    ];
                    for (const n of t.attributes)if (e.hasAttribute(n)) i.push(`attribute:${n}`);
                    if (!i.every((t)=>n.test(e, t))) return false;
                    if (!o.preflight) i.forEach((t)=>n.consume(e, t));
                    return true;
                };
            }
            function Yb(t, e, n) {
                return (o, i)=>{
                    const r = o.createContainerElement("$slot");
                    let s = null;
                    if (i === "children") s = Array.from(t.getChildren());
                    else if (typeof i == "function") s = Array.from(t.getChildren()).filter((t)=>i(t));
                    else throw new R("conversion-slot-mode-unknown", n.dispatcher, {
                        modeOrFilter: i
                    });
                    e.set(r, s);
                    return r;
                };
            }
            function Qb(t, e, n) {
                const o = Array.from(e.values()).flat();
                const i = new Set(o);
                if (i.size != o.length) throw new R("conversion-slot-filter-overlap", n.dispatcher, {
                    element: t
                });
                if (i.size != t.childCount) throw new R("conversion-slot-filter-incomplete", n.dispatcher, {
                    element: t
                });
            }
            function Xb(t, e, n, o) {
                n.mapper.on("modelToViewPosition", s, {
                    priority: "highest"
                });
                let i = null;
                let r = null;
                for ([i, r] of e){
                    tw(t, r, n, o);
                    n.writer.move(n.writer.createRangeIn(i), n.writer.createPositionBefore(i));
                    n.writer.remove(i);
                }
                n.mapper.off("modelToViewPosition", s);
                function s(t, e) {
                    const n = e.modelPosition.nodeAfter;
                    const o = r.indexOf(n);
                    if (o < 0) return;
                    e.viewPosition = e.mapper.findPositionIn(i, o);
                }
            }
            function tw(t, e, n, o) {
                for (const i of e)if (!ew(t.root, i, n, o)) n.convertItem(i);
            }
            function ew(t, e, n, o) {
                const { writer: i, mapper: r } = n;
                if (!o.reconversion) return false;
                const s = r.toViewElement(e);
                if (!s || s.root == t) return false;
                if (!n.canReuseView(s)) return false;
                i.move(i.createRangeOn(s), r.toViewPosition(Ok._createBefore(e)));
                return true;
            }
            function nw(t, e, { preflight: n } = {}) {
                if (n) return e.test(t, "insert");
                else return e.consume(t, "insert");
            }
            function ow(t) {
                const { schema: e, document: n } = t.model;
                for (const o of n.getRoots()){
                    if (o.isEmpty && !e.checkChild(o, "$text")) {
                        if (e.checkChild(o, "paragraph")) {
                            t.insertElement("paragraph", o);
                            return true;
                        }
                    }
                }
                return false;
            }
            function iw(t, e, n) {
                const o = n.createContext(t);
                if (!n.checkChild(o, "paragraph")) return false;
                if (!n.checkChild(o.push("paragraph"), e)) return false;
                return true;
            }
            function rw(t, e) {
                const n = e.createElement("paragraph");
                e.insert(n, t);
                return e.createPositionAt(n, 0);
            }
            class sw extends hb {
                elementToElement(t) {
                    return this.add(dw(t));
                }
                elementToAttribute(t) {
                    return this.add(uw(t));
                }
                attributeToAttribute(t) {
                    return this.add(hw(t));
                }
                elementToMarker(t) {
                    return this.add(fw(t));
                }
                dataToMarker(t) {
                    return this.add(pw(t));
                }
            }
            function aw() {
                return (t, e, n)=>{
                    if (!e.modelRange && n.consumable.consume(e.viewItem, {
                        name: true
                    })) {
                        const { modelRange: t, modelCursor: o } = n.convertChildren(e.viewItem, e.modelCursor);
                        e.modelRange = t;
                        e.modelCursor = o;
                    }
                };
            }
            function cw() {
                return (t, e, { schema: n, consumable: o, writer: i })=>{
                    let r = e.modelCursor;
                    if (!o.test(e.viewItem)) return;
                    if (!n.checkChild(r, "$text")) {
                        if (!iw(r, "$text", n)) return;
                        if (e.viewItem.data.trim().length == 0) return;
                        const t = r.nodeBefore;
                        r = rw(r, i);
                        if (t && t.is("element", "$marker")) {
                            i.move(i.createRangeOn(t), r);
                            r = i.createPositionAfter(t);
                        }
                    }
                    o.consume(e.viewItem);
                    const s = i.createText(e.viewItem.data);
                    i.insert(s, r);
                    e.modelRange = i.createRange(r, r.getShiftedBy(s.offsetSize));
                    e.modelCursor = e.modelRange.end;
                };
            }
            function lw(t, e) {
                return (n, o)=>{
                    const i = o.newSelection;
                    const r = [];
                    for (const t of i.getRanges())r.push(e.toModelRange(t));
                    const s = t.createSelection(r, {
                        backward: i.isBackward
                    });
                    if (!s.isEqual(t.document.selection)) t.change((t)=>{
                        t.setSelection(s);
                    });
                };
            }
            function dw(t) {
                t = Ck(t);
                const e = kw(t);
                const n = mw(t.view);
                const o = n ? `element:${n}` : "element";
                return (n)=>{
                    n.on(o, e, {
                        priority: t.converterPriority || "normal"
                    });
                };
            }
            function uw(t) {
                t = Ck(t);
                _w(t);
                const e = Aw(t, false);
                const n = mw(t.view);
                const o = n ? `element:${n}` : "element";
                return (n)=>{
                    n.on(o, e, {
                        priority: t.converterPriority || "low"
                    });
                };
            }
            function hw(t) {
                t = Ck(t);
                let e = null;
                if (typeof t.view == "string" || t.view.key) e = ww(t);
                _w(t, e);
                const n = Aw(t, true);
                return (e)=>{
                    e.on("element", n, {
                        priority: t.converterPriority || "low"
                    });
                };
            }
            function fw(t) {
                const e = yw(t.model);
                return dw({
                    ...t,
                    model: e
                });
            }
            function pw(t) {
                t = Ck(t);
                if (!t.model) t.model = (e)=>e ? t.view + ":" + e : t.view;
                const e = {
                    view: t.view,
                    model: t.model
                };
                const n = kw(xw(e, "start"));
                const o = kw(xw(e, "end"));
                return (i)=>{
                    i.on(`element:${t.view}-start`, n, {
                        priority: t.converterPriority || "normal"
                    });
                    i.on(`element:${t.view}-end`, o, {
                        priority: t.converterPriority || "normal"
                    });
                    const r = B.low;
                    const s = B.highest;
                    const a = B.get(t.converterPriority) / s;
                    i.on("element", gw(e), {
                        priority: r + a
                    });
                };
            }
            function gw(t) {
                return (e, n, o)=>{
                    const i = `data-${t.view}`;
                    if (!o.consumable.test(n.viewItem, {
                        attributes: i + "-end-after"
                    }) && !o.consumable.test(n.viewItem, {
                        attributes: i + "-start-after"
                    }) && !o.consumable.test(n.viewItem, {
                        attributes: i + "-end-before"
                    }) && !o.consumable.test(n.viewItem, {
                        attributes: i + "-start-before"
                    })) return;
                    if (!n.modelRange) Object.assign(n, o.convertChildren(n.viewItem, n.modelCursor));
                    if (o.consumable.consume(n.viewItem, {
                        attributes: i + "-end-after"
                    })) r(n.modelRange.end, n.viewItem.getAttribute(i + "-end-after").split(","));
                    if (o.consumable.consume(n.viewItem, {
                        attributes: i + "-start-after"
                    })) r(n.modelRange.end, n.viewItem.getAttribute(i + "-start-after").split(","));
                    if (o.consumable.consume(n.viewItem, {
                        attributes: i + "-end-before"
                    })) r(n.modelRange.start, n.viewItem.getAttribute(i + "-end-before").split(","));
                    if (o.consumable.consume(n.viewItem, {
                        attributes: i + "-start-before"
                    })) r(n.modelRange.start, n.viewItem.getAttribute(i + "-start-before").split(","));
                    function r(e, i) {
                        for (const r of i){
                            const i = t.model(r, o);
                            const s = o.writer.createElement("$marker", {
                                "data-name": i
                            });
                            o.writer.insert(s, e);
                            if (n.modelCursor.isEqual(e)) n.modelCursor = n.modelCursor.getShiftedBy(1);
                            else n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1);
                            n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0];
                        }
                    }
                };
            }
            function mw(t) {
                if (typeof t == "string") return t;
                if (typeof t == "object" && typeof t.name == "string") return t.name;
                return null;
            }
            function kw(t) {
                const e = new ah(t.view);
                return (n, o, i)=>{
                    const r = e.match(o.viewItem);
                    if (!r) return;
                    const s = r.match;
                    s.name = true;
                    if (!i.consumable.test(o.viewItem, s)) return;
                    const a = bw(t.model, o.viewItem, i);
                    if (!a) return;
                    if (!i.safeInsert(a, o.modelCursor)) return;
                    i.consumable.consume(o.viewItem, s);
                    i.convertChildren(o.viewItem, a);
                    i.updateConversionResult(a, o);
                };
            }
            function bw(t, e, n) {
                if (t instanceof Function) return t(e, n);
                else return n.writer.createElement(t);
            }
            function ww(t) {
                if (typeof t.view == "string") t.view = {
                    key: t.view
                };
                const e = t.view.key;
                let n;
                if (e == "class" || e == "style") {
                    const o = e == "class" ? "classes" : "styles";
                    n = {
                        [o]: t.view.value
                    };
                } else {
                    const o = typeof t.view.value == "undefined" ? /[\s\S]*/ : t.view.value;
                    n = {
                        attributes: {
                            [e]: o
                        }
                    };
                }
                if (t.view.name) n.name = t.view.name;
                t.view = n;
                return e;
            }
            function _w(t, e = null) {
                const n = e === null ? true : (t)=>t.getAttribute(e);
                const o = typeof t.model != "object" ? t.model : t.model.key;
                const i = typeof t.model != "object" || typeof t.model.value == "undefined" ? n : t.model.value;
                t.model = {
                    key: o,
                    value: i
                };
            }
            function Aw(t, e) {
                const n = new ah(t.view);
                return (o, i, r)=>{
                    if (!i.modelRange && e) return;
                    const s = n.match(i.viewItem);
                    if (!s) return;
                    if (vw(t.view, i.viewItem)) s.match.name = true;
                    else delete s.match.name;
                    if (!r.consumable.test(i.viewItem, s.match)) return;
                    const a = t.model.key;
                    const c = typeof t.model.value == "function" ? t.model.value(i.viewItem, r) : t.model.value;
                    if (c === null) return;
                    if (!i.modelRange) Object.assign(i, r.convertChildren(i.viewItem, i.modelCursor));
                    const l = Cw(i.modelRange, {
                        key: a,
                        value: c
                    }, e, r);
                    if (l) {
                        if (r.consumable.test(i.viewItem, {
                            name: true
                        })) s.match.name = true;
                        r.consumable.consume(i.viewItem, s.match);
                    }
                };
            }
            function vw(t, e) {
                const n = typeof t == "function" ? t(e) : t;
                if (typeof n == "object" && !mw(n)) return false;
                return !n.classes && !n.attributes && !n.styles;
            }
            function Cw(t, e, n, o) {
                let i = false;
                for (const r of Array.from(t.getItems({
                    shallow: n
                }))){
                    if (!o.schema.checkAttribute(r, e.key)) continue;
                    i = true;
                    if (r.hasAttribute(e.key)) continue;
                    o.writer.setAttribute(e.key, e.value, r);
                }
                return i;
            }
            function yw(t) {
                return (e, n)=>{
                    const o = typeof t == "string" ? t : t(e, n);
                    return n.writer.createElement("$marker", {
                        "data-name": o
                    });
                };
            }
            function xw(t, e) {
                const n = (e, n)=>{
                    const o = e.getAttribute("name");
                    const i = t.model(o, n);
                    return n.writer.createElement("$marker", {
                        "data-name": i
                    });
                };
                return {
                    view: `${t.view}-${e}`,
                    model: n
                };
            }
            function Ew(t) {
                t.document.registerPostFixer((e)=>Dw(e, t));
            }
            function Dw(t, e) {
                const n = e.document.selection;
                const o = e.schema;
                const i = [];
                let r = false;
                for (const t of n.getRanges()){
                    const e = Sw(t, o);
                    if (e && !e.isEqual(t)) {
                        i.push(e);
                        r = true;
                    } else i.push(t);
                }
                if (r) t.setSelection(Rw(i), {
                    backward: n.isBackward
                });
                return false;
            }
            function Sw(t, e) {
                if (t.isCollapsed) return Tw(t, e);
                return Bw(t, e);
            }
            function Tw(t, e) {
                const n = t.start;
                const o = e.getNearestSelectionRange(n);
                if (!o) {
                    const t = n.getAncestors().reverse().find((t)=>e.isObject(t));
                    if (t) return Hk._createOn(t);
                    return null;
                }
                if (!o.isCollapsed) return o;
                const i = o.start;
                if (n.isEqual(i)) return null;
                return new Hk(i);
            }
            function Bw(t, e) {
                const { start: n, end: o } = t;
                const i = e.checkChild(n, "$text");
                const r = e.checkChild(o, "$text");
                const s = e.getLimitElement(n);
                const a = e.getLimitElement(o);
                if (s === a) {
                    if (i && r) return null;
                    if (Iw(n, o, e)) {
                        const t = n.nodeAfter && e.isSelectable(n.nodeAfter);
                        const i = t ? null : e.getNearestSelectionRange(n, "forward");
                        const r = o.nodeBefore && e.isSelectable(o.nodeBefore);
                        const s = r ? null : e.getNearestSelectionRange(o, "backward");
                        const a = i ? i.start : n;
                        const c = s ? s.end : o;
                        return new Hk(a, c);
                    }
                }
                const c = s && !s.is("rootElement");
                const l = a && !a.is("rootElement");
                if (c || l) {
                    const t = n.nodeAfter && o.nodeBefore && n.nodeAfter.parent === o.nodeBefore.parent;
                    const i = c && (!t || !Ow(n.nodeAfter, e));
                    const r = l && (!t || !Ow(o.nodeBefore, e));
                    let d = n;
                    let u = o;
                    if (i) d = Ok._createBefore(Pw(s, e));
                    if (r) u = Ok._createAfter(Pw(a, e));
                    return new Hk(d, u);
                }
                return null;
            }
            function Pw(t, e) {
                let n = t;
                let o = n;
                while(e.isLimit(o) && o.parent){
                    n = o;
                    o = o.parent;
                }
                return n;
            }
            function Iw(t, e, n) {
                const o = t.nodeAfter && !n.isLimit(t.nodeAfter) || n.checkChild(t, "$text");
                const i = e.nodeBefore && !n.isLimit(e.nodeBefore) || n.checkChild(e, "$text");
                return o || i;
            }
            function Rw(t) {
                const e = [
                    ...t
                ];
                const n = new Set;
                let o = 1;
                while(o < e.length){
                    const t = e[o];
                    const i = e.slice(0, o);
                    for (const [r, s] of i.entries()){
                        if (n.has(r)) continue;
                        if (t.isEqual(s)) n.add(r);
                        else if (t.isIntersecting(s)) {
                            n.add(r);
                            n.add(o);
                            const i = t.getJoined(s);
                            e.push(i);
                        }
                    }
                    o++;
                }
                const i = e.filter((t, e)=>!n.has(e));
                return i;
            }
            function Ow(t, e) {
                return t && e.isSelectable(t);
            }
            class Vw extends ht() {
                constructor(t, e){
                    super();
                    this.model = t;
                    this.view = new yk(e);
                    this.mapper = new jk;
                    this.downcastDispatcher = new $k({
                        mapper: this.mapper,
                        schema: t.schema
                    });
                    const n = this.model.document;
                    const o = n.selection;
                    const i = this.model.markers;
                    this.listenTo(this.model, "_beforeChanges", ()=>{
                        this.view._disableRendering(true);
                    }, {
                        priority: "highest"
                    });
                    this.listenTo(this.model, "_afterChanges", ()=>{
                        this.view._disableRendering(false);
                    }, {
                        priority: "lowest"
                    });
                    this.listenTo(n, "change", ()=>{
                        this.view.change((t)=>{
                            this.downcastDispatcher.convertChanges(n.differ, i, t);
                            this.downcastDispatcher.convertSelection(o, i, t);
                        });
                    }, {
                        priority: "low"
                    });
                    this.listenTo(this.view.document, "selectionChange", lw(this.model, this.mapper));
                    this.listenTo(this.view.document, "beforeinput", Mw(this.mapper, this.model.schema, this.view), {
                        priority: "high"
                    });
                    this.downcastDispatcher.on("insert:$text", pb(), {
                        priority: "lowest"
                    });
                    this.downcastDispatcher.on("insert", gb(), {
                        priority: "lowest"
                    });
                    this.downcastDispatcher.on("remove", mb(), {
                        priority: "low"
                    });
                    this.downcastDispatcher.on("cleanSelection", _b());
                    this.downcastDispatcher.on("selection", bb(), {
                        priority: "low"
                    });
                    this.downcastDispatcher.on("selection", wb(), {
                        priority: "low"
                    });
                    this.view.document.roots.bindTo(this.model.document.roots).using((t)=>{
                        if (t.rootName == "$graveyard") return null;
                        const e = new pp(this.view.document, t.name);
                        e.rootName = t.rootName;
                        this.mapper.bindElements(t, e);
                        return e;
                    });
                }
                destroy() {
                    this.view.destroy();
                    this.stopListening();
                }
                reconvertMarker(t) {
                    const e = typeof t == "string" ? t : t.name;
                    const n = this.model.markers.get(e);
                    if (!n) throw new R("editingcontroller-reconvertmarker-marker-not-exist", this, {
                        markerName: e
                    });
                    this.model.change(()=>{
                        this.model.markers._refresh(n);
                    });
                }
                reconvertItem(t) {
                    this.model.change(()=>{
                        this.model.document.differ._refreshItem(t);
                    });
                }
            }
            function Mw(t, e, n) {
                return (o, i)=>{
                    if (n.document.isComposing && !c.isAndroid) return;
                    for(let n = 0; n < i.targetRanges.length; n++){
                        const o = i.targetRanges[n];
                        const r = t.toModelRange(o);
                        const s = Sw(r, e);
                        if (!s || s.isEqual(r)) continue;
                        i.targetRanges[n] = t.toViewRange(s);
                    }
                };
            }
            class Lw {
                constructor(){
                    this._consumables = new Map;
                }
                add(t, e) {
                    let n;
                    if (t.is("$text") || t.is("documentFragment")) {
                        this._consumables.set(t, true);
                        return;
                    }
                    if (!this._consumables.has(t)) {
                        n = new Nw(t);
                        this._consumables.set(t, n);
                    } else n = this._consumables.get(t);
                    n.add(e);
                }
                test(t, e) {
                    const n = this._consumables.get(t);
                    if (n === undefined) return null;
                    if (t.is("$text") || t.is("documentFragment")) return n;
                    return n.test(e);
                }
                consume(t, e) {
                    if (this.test(t, e)) {
                        if (t.is("$text") || t.is("documentFragment")) this._consumables.set(t, false);
                        else this._consumables.get(t).consume(e);
                        return true;
                    }
                    return false;
                }
                revert(t, e) {
                    const n = this._consumables.get(t);
                    if (n !== undefined) {
                        if (t.is("$text") || t.is("documentFragment")) this._consumables.set(t, true);
                        else n.revert(e);
                    }
                }
                static consumablesFromElement(t) {
                    const e = {
                        element: t,
                        name: true,
                        attributes: [],
                        classes: [],
                        styles: []
                    };
                    const n = t.getAttributeKeys();
                    for (const t of n){
                        if (t == "style" || t == "class") continue;
                        e.attributes.push(t);
                    }
                    const o = t.getClassNames();
                    for (const t of o)e.classes.push(t);
                    const i = t.getStyleNames();
                    for (const t of i)e.styles.push(t);
                    return e;
                }
                static createFrom(t, e) {
                    if (!e) e = new Lw;
                    if (t.is("$text")) {
                        e.add(t);
                        return e;
                    }
                    if (t.is("element")) e.add(t, Lw.consumablesFromElement(t));
                    if (t.is("documentFragment")) e.add(t);
                    for (const n of t.getChildren())e = Lw.createFrom(n, e);
                    return e;
                }
            }
            const zw = [
                "attributes",
                "classes",
                "styles"
            ];
            class Nw {
                constructor(t){
                    this.element = t;
                    this._canConsumeName = null;
                    this._consumables = {
                        attributes: new Map,
                        styles: new Map,
                        classes: new Map
                    };
                }
                add(t) {
                    if (t.name) this._canConsumeName = true;
                    for (const e of zw)if (e in t) this._add(e, t[e]);
                }
                test(t) {
                    if (t.name && !this._canConsumeName) return this._canConsumeName;
                    for (const e of zw)if (e in t) {
                        const n = this._test(e, t[e]);
                        if (n !== true) return n;
                    }
                    return true;
                }
                consume(t) {
                    if (t.name) this._canConsumeName = false;
                    for (const e of zw)if (e in t) this._consume(e, t[e]);
                }
                revert(t) {
                    if (t.name) this._canConsumeName = true;
                    for (const e of zw)if (e in t) this._revert(e, t[e]);
                }
                _add(t, e) {
                    const n = Jt(e) ? e : [
                        e
                    ];
                    const o = this._consumables[t];
                    for (const e of n){
                        if (t === "attributes" && (e === "class" || e === "style")) throw new R("viewconsumable-invalid-attribute", this);
                        o.set(e, true);
                        if (t === "styles") for (const t of this.element.document.stylesProcessor.getRelatedStyles(e))o.set(t, true);
                    }
                }
                _test(t, e) {
                    const n = Jt(e) ? e : [
                        e
                    ];
                    const o = this._consumables[t];
                    for (const e of n)if (t === "attributes" && (e === "class" || e === "style")) {
                        const t = e == "class" ? "classes" : "styles";
                        const n = this._test(t, [
                            ...this._consumables[t].keys()
                        ]);
                        if (n !== true) return n;
                    } else {
                        const t = o.get(e);
                        if (t === undefined) return null;
                        if (!t) return false;
                    }
                    return true;
                }
                _consume(t, e) {
                    const n = Jt(e) ? e : [
                        e
                    ];
                    const o = this._consumables[t];
                    for (const e of n)if (t === "attributes" && (e === "class" || e === "style")) {
                        const t = e == "class" ? "classes" : "styles";
                        this._consume(t, [
                            ...this._consumables[t].keys()
                        ]);
                    } else {
                        o.set(e, false);
                        if (t == "styles") for (const t of this.element.document.stylesProcessor.getRelatedStyles(e))o.set(t, false);
                    }
                }
                _revert(t, e) {
                    const n = Jt(e) ? e : [
                        e
                    ];
                    const o = this._consumables[t];
                    for (const e of n)if (t === "attributes" && (e === "class" || e === "style")) {
                        const t = e == "class" ? "classes" : "styles";
                        this._revert(t, [
                            ...this._consumables[t].keys()
                        ]);
                    } else {
                        const t = o.get(e);
                        if (t === false) o.set(e, true);
                    }
                }
            }
            class Fw extends ht() {
                constructor(){
                    super();
                    this._sourceDefinitions = {};
                    this._attributeProperties = {};
                    this.decorate("checkChild");
                    this.decorate("checkAttribute");
                    this.on("checkAttribute", (t, e)=>{
                        e[0] = new Hw(e[0]);
                    }, {
                        priority: "highest"
                    });
                    this.on("checkChild", (t, e)=>{
                        e[0] = new Hw(e[0]);
                        e[1] = this.getDefinition(e[1]);
                    }, {
                        priority: "highest"
                    });
                }
                register(t, e) {
                    if (this._sourceDefinitions[t]) throw new R("schema-cannot-register-item-twice", this, {
                        itemName: t
                    });
                    this._sourceDefinitions[t] = [
                        Object.assign({}, e)
                    ];
                    this._clearCache();
                }
                extend(t, e) {
                    if (!this._sourceDefinitions[t]) throw new R("schema-cannot-extend-missing-item", this, {
                        itemName: t
                    });
                    this._sourceDefinitions[t].push(Object.assign({}, e));
                    this._clearCache();
                }
                getDefinitions() {
                    if (!this._compiledDefinitions) this._compile();
                    return this._compiledDefinitions;
                }
                getDefinition(t) {
                    let e;
                    if (typeof t == "string") e = t;
                    else if ("is" in t && (t.is("$text") || t.is("$textProxy"))) e = "$text";
                    else e = t.name;
                    return this.getDefinitions()[e];
                }
                isRegistered(t) {
                    return !!this.getDefinition(t);
                }
                isBlock(t) {
                    const e = this.getDefinition(t);
                    return !!(e && e.isBlock);
                }
                isLimit(t) {
                    const e = this.getDefinition(t);
                    if (!e) return false;
                    return !!(e.isLimit || e.isObject);
                }
                isObject(t) {
                    const e = this.getDefinition(t);
                    if (!e) return false;
                    return !!(e.isObject || e.isLimit && e.isSelectable && e.isContent);
                }
                isInline(t) {
                    const e = this.getDefinition(t);
                    return !!(e && e.isInline);
                }
                isSelectable(t) {
                    const e = this.getDefinition(t);
                    if (!e) return false;
                    return !!(e.isSelectable || e.isObject);
                }
                isContent(t) {
                    const e = this.getDefinition(t);
                    if (!e) return false;
                    return !!(e.isContent || e.isObject);
                }
                checkChild(t, e) {
                    if (!e) return false;
                    return this._checkContextMatch(e, t);
                }
                checkAttribute(t, e) {
                    const n = this.getDefinition(t.last);
                    if (!n) return false;
                    return n.allowAttributes.includes(e);
                }
                checkMerge(t, e) {
                    if (t instanceof Ok) {
                        const e = t.nodeBefore;
                        const n = t.nodeAfter;
                        if (!(e instanceof Bk)) throw new R("schema-check-merge-no-element-before", this);
                        if (!(n instanceof Bk)) throw new R("schema-check-merge-no-element-after", this);
                        return this.checkMerge(e, n);
                    }
                    for (const n of e.getChildren()){
                        if (!this.checkChild(t, n)) return false;
                    }
                    return true;
                }
                addChildCheck(t) {
                    this.on("checkChild", (e, [n, o])=>{
                        if (!o) return;
                        const i = t(n, o);
                        if (typeof i == "boolean") {
                            e.stop();
                            e.return = i;
                        }
                    }, {
                        priority: "high"
                    });
                }
                addAttributeCheck(t) {
                    this.on("checkAttribute", (e, [n, o])=>{
                        const i = t(n, o);
                        if (typeof i == "boolean") {
                            e.stop();
                            e.return = i;
                        }
                    }, {
                        priority: "high"
                    });
                }
                setAttributeProperties(t, e) {
                    this._attributeProperties[t] = Object.assign(this.getAttributeProperties(t), e);
                }
                getAttributeProperties(t) {
                    return this._attributeProperties[t] || {};
                }
                getLimitElement(t) {
                    let e;
                    if (t instanceof Ok) e = t.parent;
                    else {
                        const n = t instanceof Hk ? [
                            t
                        ] : Array.from(t.getRanges());
                        e = n.reduce((t, e)=>{
                            const n = e.getCommonAncestor();
                            if (!t) return n;
                            return t.getCommonAncestor(n, {
                                includeSelf: true
                            });
                        }, null);
                    }
                    while(!this.isLimit(e)){
                        if (e.parent) e = e.parent;
                        else break;
                    }
                    return e;
                }
                checkAttributeInSelection(t, e) {
                    if (t.isCollapsed) {
                        const n = t.getFirstPosition();
                        const o = [
                            ...n.getAncestors(),
                            new Sk("", t.getAttributes())
                        ];
                        return this.checkAttribute(o, e);
                    } else {
                        const n = t.getRanges();
                        for (const t of n)for (const n of t){
                            if (this.checkAttribute(n.item, e)) return true;
                        }
                    }
                    return false;
                }
                *getValidRanges(t, e) {
                    t = i_(t);
                    for (const n of t)yield* this._getValidRangesForRange(n, e);
                }
                getNearestSelectionRange(t, e = "both") {
                    if (t.root.rootName == "$graveyard") return null;
                    if (this.checkChild(t, "$text")) return new Hk(t);
                    let n, o;
                    const i = t.getAncestors().reverse().find((t)=>this.isLimit(t)) || t.root;
                    if (e == "both" || e == "backward") n = new Ik({
                        boundaries: Hk._createIn(i),
                        startPosition: t,
                        direction: "backward"
                    });
                    if (e == "both" || e == "forward") o = new Ik({
                        boundaries: Hk._createIn(i),
                        startPosition: t
                    });
                    for (const t of o_(n, o)){
                        const e = t.walker == n ? "elementEnd" : "elementStart";
                        const o = t.value;
                        if (o.type == e && this.isObject(o.item)) return Hk._createOn(o.item);
                        if (this.checkChild(o.nextPosition, "$text")) return new Hk(o.nextPosition);
                    }
                    return null;
                }
                findAllowedParent(t, e) {
                    let n = t.parent;
                    while(n){
                        if (this.checkChild(n, e)) return n;
                        if (this.isLimit(n)) return null;
                        n = n.parent;
                    }
                    return null;
                }
                setAllowedAttributes(t, e, n) {
                    const o = n.model;
                    for (const [i, r] of Object.entries(e))if (o.schema.checkAttribute(t, i)) n.setAttribute(i, r, t);
                }
                removeDisallowedAttributes(t, e) {
                    for (const n of t)if (n.is("$text")) r_(this, n, e);
                    else {
                        const t = Hk._createIn(n);
                        const o = t.getPositions();
                        for (const t of o){
                            const n = t.nodeBefore || t.parent;
                            r_(this, n, e);
                        }
                    }
                }
                getAttributesWithProperty(t, e, n) {
                    const o = {};
                    for (const [i, r] of t.getAttributes()){
                        const t = this.getAttributeProperties(i);
                        if (t[e] === undefined) continue;
                        if (n === undefined || n === t[e]) o[i] = r;
                    }
                    return o;
                }
                createContext(t) {
                    return new Hw(t);
                }
                _clearCache() {
                    this._compiledDefinitions = null;
                }
                _compile() {
                    const t = {};
                    const e = this._sourceDefinitions;
                    const n = Object.keys(e);
                    for (const o of n)t[o] = jw(e[o], o);
                    for (const e of n)qw(t, e);
                    for (const e of n)Ww(t, e);
                    for (const e of n)$w(t, e);
                    for (const e of n){
                        Gw(t, e);
                        Uw(t, e);
                    }
                    for (const e of n){
                        Kw(t, e);
                        Zw(t, e);
                        Jw(t, e);
                    }
                    this._compiledDefinitions = t;
                }
                _checkContextMatch(t, e, n = e.length - 1) {
                    const o = e.getItem(n);
                    if (t.allowIn.includes(o.name)) {
                        if (n == 0) return true;
                        else {
                            const t = this.getDefinition(o);
                            return this._checkContextMatch(t, e, n - 1);
                        }
                    } else return false;
                }
                *_getValidRangesForRange(t, e) {
                    let n = t.start;
                    let o = t.start;
                    for (const i of t.getItems({
                        shallow: true
                    })){
                        if (i.is("element")) yield* this._getValidRangesForRange(Hk._createIn(i), e);
                        if (!this.checkAttribute(i, e)) {
                            if (!n.isEqual(o)) yield new Hk(n, o);
                            n = Ok._createAfter(i);
                        }
                        o = Ok._createAfter(i);
                    }
                    if (!n.isEqual(o)) yield new Hk(n, o);
                }
            }
            class Hw {
                constructor(t){
                    if (t instanceof Hw) return t;
                    let e;
                    if (typeof t == "string") e = [
                        t
                    ];
                    else if (!Array.isArray(t)) e = t.getAncestors({
                        includeSelf: true
                    });
                    else e = t;
                    this._items = e.map(n_);
                }
                get length() {
                    return this._items.length;
                }
                get last() {
                    return this._items[this._items.length - 1];
                }
                [Symbol.iterator]() {
                    return this._items[Symbol.iterator]();
                }
                push(t) {
                    const e = new Hw([
                        t
                    ]);
                    e._items = [
                        ...this._items,
                        ...e._items
                    ];
                    return e;
                }
                getItem(t) {
                    return this._items[t];
                }
                *getNames() {
                    yield* this._items.map((t)=>t.name);
                }
                endsWith(t) {
                    return Array.from(this.getNames()).join(" ").endsWith(t);
                }
                startsWith(t) {
                    return Array.from(this.getNames()).join(" ").startsWith(t);
                }
            }
            function jw(t, e) {
                const n = {
                    name: e,
                    allowIn: [],
                    allowContentOf: [],
                    allowWhere: [],
                    allowAttributes: [],
                    allowAttributesOf: [],
                    allowChildren: [],
                    inheritTypesFrom: []
                };
                Yw(t, n);
                Qw(t, n, "allowIn");
                Qw(t, n, "allowContentOf");
                Qw(t, n, "allowWhere");
                Qw(t, n, "allowAttributes");
                Qw(t, n, "allowAttributesOf");
                Qw(t, n, "allowChildren");
                Qw(t, n, "inheritTypesFrom");
                Xw(t, n);
                return n;
            }
            function qw(t, e) {
                const n = t[e];
                for (const o of n.allowChildren){
                    const n = t[o];
                    if (!n) continue;
                    n.allowIn.push(e);
                }
                n.allowChildren.length = 0;
            }
            function Ww(t, e) {
                for (const n of t[e].allowContentOf)if (t[n]) {
                    const o = t_(t, n);
                    o.forEach((t)=>{
                        t.allowIn.push(e);
                    });
                }
                delete t[e].allowContentOf;
            }
            function $w(t, e) {
                for (const n of t[e].allowWhere){
                    const o = t[n];
                    if (o) {
                        const n = o.allowIn;
                        t[e].allowIn.push(...n);
                    }
                }
                delete t[e].allowWhere;
            }
            function Gw(t, e) {
                for (const n of t[e].allowAttributesOf){
                    const o = t[n];
                    if (o) {
                        const n = o.allowAttributes;
                        t[e].allowAttributes.push(...n);
                    }
                }
                delete t[e].allowAttributesOf;
            }
            function Uw(t, e) {
                const n = t[e];
                for (const e of n.inheritTypesFrom){
                    const o = t[e];
                    if (o) {
                        const t = Object.keys(o).filter((t)=>t.startsWith("is"));
                        for (const e of t)if (!(e in n)) n[e] = o[e];
                    }
                }
                delete n.inheritTypesFrom;
            }
            function Kw(t, e) {
                const n = t[e];
                const o = n.allowIn.filter((e)=>t[e]);
                n.allowIn = Array.from(new Set(o));
            }
            function Zw(t, e) {
                const n = t[e];
                for (const o of n.allowIn){
                    const n = t[o];
                    n.allowChildren.push(e);
                }
            }
            function Jw(t, e) {
                const n = t[e];
                n.allowAttributes = Array.from(new Set(n.allowAttributes));
            }
            function Yw(t, e) {
                for (const n of t){
                    const t = Object.keys(n).filter((t)=>t.startsWith("is"));
                    for (const o of t)e[o] = !!n[o];
                }
            }
            function Qw(t, e, n) {
                for (const o of t){
                    const t = o[n];
                    if (typeof t == "string") e[n].push(t);
                    else if (Array.isArray(t)) e[n].push(...t);
                }
            }
            function Xw(t, e) {
                for (const n of t){
                    const t = n.inheritAllFrom;
                    if (t) {
                        e.allowContentOf.push(t);
                        e.allowWhere.push(t);
                        e.allowAttributesOf.push(t);
                        e.inheritTypesFrom.push(t);
                    }
                }
            }
            function t_(t, e) {
                const n = t[e];
                return e_(t).filter((t)=>t.allowIn.includes(n.name));
            }
            function e_(t) {
                return Object.keys(t).map((e)=>t[e]);
            }
            function n_(t) {
                if (typeof t == "string" || t.is("documentFragment")) return {
                    name: typeof t == "string" ? t : "$documentFragment",
                    *getAttributeKeys () {},
                    getAttribute () {}
                };
                else return {
                    name: t.is("element") ? t.name : "$text",
                    *getAttributeKeys () {
                        yield* t.getAttributeKeys();
                    },
                    getAttribute (e) {
                        return t.getAttribute(e);
                    }
                };
            }
            function* o_(t, e) {
                let n = false;
                while(!n){
                    n = true;
                    if (t) {
                        const e = t.next();
                        if (!e.done) {
                            n = false;
                            yield {
                                walker: t,
                                value: e.value
                            };
                        }
                    }
                    if (e) {
                        const t = e.next();
                        if (!t.done) {
                            n = false;
                            yield {
                                walker: e,
                                value: t.value
                            };
                        }
                    }
                }
            }
            function* i_(t) {
                for (const e of t)yield* e.getMinimalFlatRanges();
            }
            function r_(t, e, n) {
                for (const o of e.getAttributeKeys())if (!t.checkAttribute(e, o)) n.removeAttribute(o, e);
            }
            class s_ extends G() {
                constructor(t){
                    super();
                    this._splitParts = new Map;
                    this._cursorParents = new Map;
                    this._modelCursor = null;
                    this._emptyElementsToKeep = new Set;
                    this.conversionApi = {
                        ...t,
                        consumable: null,
                        writer: null,
                        store: null,
                        convertItem: (t, e)=>this._convertItem(t, e),
                        convertChildren: (t, e)=>this._convertChildren(t, e),
                        safeInsert: (t, e)=>this._safeInsert(t, e),
                        updateConversionResult: (t, e)=>this._updateConversionResult(t, e),
                        splitToAllowedParent: (t, e)=>this._splitToAllowedParent(t, e),
                        getSplitParts: (t)=>this._getSplitParts(t),
                        keepEmptyElement: (t)=>this._keepEmptyElement(t)
                    };
                }
                convert(t, e, n = [
                    "$root"
                ]) {
                    this.fire("viewCleanup", t);
                    this._modelCursor = c_(n, e);
                    this.conversionApi.writer = e;
                    this.conversionApi.consumable = Lw.createFrom(t);
                    this.conversionApi.store = {};
                    const { modelRange: o } = this._convertItem(t, this._modelCursor);
                    const i = e.createDocumentFragment();
                    if (o) {
                        this._removeEmptyElements();
                        for (const t of Array.from(this._modelCursor.parent.getChildren()))e.append(t, i);
                        i.markers = a_(i, e);
                    }
                    this._modelCursor = null;
                    this._splitParts.clear();
                    this._cursorParents.clear();
                    this._emptyElementsToKeep.clear();
                    this.conversionApi.writer = null;
                    this.conversionApi.store = null;
                    return i;
                }
                _convertItem(t, e) {
                    const n = {
                        viewItem: t,
                        modelCursor: e,
                        modelRange: null
                    };
                    if (t.is("element")) this.fire(`element:${t.name}`, n, this.conversionApi);
                    else if (t.is("$text")) this.fire("text", n, this.conversionApi);
                    else this.fire("documentFragment", n, this.conversionApi);
                    if (n.modelRange && !(n.modelRange instanceof Hk)) throw new R("view-conversion-dispatcher-incorrect-result", this);
                    return {
                        modelRange: n.modelRange,
                        modelCursor: n.modelCursor
                    };
                }
                _convertChildren(t, e) {
                    let n = e.is("position") ? e : Ok._createAt(e, 0);
                    const o = new Hk(n);
                    for (const e of Array.from(t.getChildren())){
                        const t = this._convertItem(e, n);
                        if (t.modelRange instanceof Hk) {
                            o.end = t.modelRange.end;
                            n = t.modelCursor;
                        }
                    }
                    return {
                        modelRange: o,
                        modelCursor: n
                    };
                }
                _safeInsert(t, e) {
                    const n = this._splitToAllowedParent(t, e);
                    if (!n) return false;
                    this.conversionApi.writer.insert(t, n.position);
                    return true;
                }
                _updateConversionResult(t, e) {
                    const n = this._getSplitParts(t);
                    const o = this.conversionApi.writer;
                    if (!e.modelRange) e.modelRange = o.createRange(o.createPositionBefore(t), o.createPositionAfter(n[n.length - 1]));
                    const i = this._cursorParents.get(t);
                    if (i) e.modelCursor = o.createPositionAt(i, 0);
                    else e.modelCursor = e.modelRange.end;
                }
                _splitToAllowedParent(t, e) {
                    const { schema: n, writer: o } = this.conversionApi;
                    let i = n.findAllowedParent(e, t);
                    if (i) {
                        if (i === e.parent) return {
                            position: e
                        };
                        if (this._modelCursor.parent.getAncestors().includes(i)) i = null;
                    }
                    if (!i) {
                        if (!iw(e, t, n)) return null;
                        return {
                            position: rw(e, o)
                        };
                    }
                    const r = this.conversionApi.writer.split(e, i);
                    const s = [];
                    for (const t of r.range.getWalker())if (t.type == "elementEnd") s.push(t.item);
                    else {
                        const e = s.pop();
                        const n = t.item;
                        this._registerSplitPair(e, n);
                    }
                    const a = r.range.end.parent;
                    this._cursorParents.set(t, a);
                    return {
                        position: r.position,
                        cursorParent: a
                    };
                }
                _registerSplitPair(t, e) {
                    if (!this._splitParts.has(t)) this._splitParts.set(t, [
                        t
                    ]);
                    const n = this._splitParts.get(t);
                    this._splitParts.set(e, n);
                    n.push(e);
                }
                _getSplitParts(t) {
                    let e;
                    if (!this._splitParts.has(t)) e = [
                        t
                    ];
                    else e = this._splitParts.get(t);
                    return e;
                }
                _keepEmptyElement(t) {
                    this._emptyElementsToKeep.add(t);
                }
                _removeEmptyElements() {
                    let t = false;
                    for (const e of this._splitParts.keys())if (e.isEmpty && !this._emptyElementsToKeep.has(e)) {
                        this.conversionApi.writer.remove(e);
                        this._splitParts.delete(e);
                        t = true;
                    }
                    if (t) this._removeEmptyElements();
                }
            }
            function a_(t, e) {
                const n = new Set;
                const o = new Map;
                const i = Hk._createIn(t).getItems();
                for (const t of i)if (t.is("element", "$marker")) n.add(t);
                for (const t of n){
                    const n = t.getAttribute("data-name");
                    const i = e.createPositionBefore(t);
                    if (!o.has(n)) o.set(n, new Hk(i.clone()));
                    else o.get(n).end = i.clone();
                    e.remove(t);
                }
                return o;
            }
            function c_(t, e) {
                let n;
                for (const o of new Hw(t)){
                    const t = {};
                    for (const e of o.getAttributeKeys())t[e] = o.getAttribute(e);
                    const i = e.createElement(o.name, t);
                    if (n) e.insert(i, n);
                    n = Ok._createAt(i, 0);
                }
                return n;
            }
            class l_ {
                getHtml(t) {
                    const e = document.implementation.createHTMLDocument("");
                    const n = e.createElement("div");
                    n.appendChild(t);
                    return n.innerHTML;
                }
            }
            class d_ {
                constructor(t){
                    this.skipComments = true;
                    this.domParser = new DOMParser;
                    this.domConverter = new Pg(t, {
                        renderingMode: "data"
                    });
                    this.htmlWriter = new l_;
                }
                toData(t) {
                    const e = this.domConverter.viewToDom(t);
                    return this.htmlWriter.getHtml(e);
                }
                toView(t) {
                    const e = this._toDom(t);
                    return this.domConverter.domToView(e, {
                        skipComments: this.skipComments
                    });
                }
                registerRawContentMatcher(t) {
                    this.domConverter.registerRawContentMatcher(t);
                }
                useFillerType(t) {
                    this.domConverter.blockFillerMode = t == "marked" ? "markedNbsp" : "nbsp";
                }
                _toDom(t) {
                    if (!t.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i)) t = `<body>${t}</body>`;
                    const e = this.domParser.parseFromString(t, "text/html");
                    const n = e.createDocumentFragment();
                    const o = e.body.childNodes;
                    while(o.length > 0)n.appendChild(o[0]);
                    return n;
                }
            }
            class u_ extends G() {
                constructor(t, e){
                    super();
                    this.model = t;
                    this.mapper = new jk;
                    this.downcastDispatcher = new $k({
                        mapper: this.mapper,
                        schema: t.schema
                    });
                    this.downcastDispatcher.on("insert:$text", pb(), {
                        priority: "lowest"
                    });
                    this.downcastDispatcher.on("insert", gb(), {
                        priority: "lowest"
                    });
                    this.upcastDispatcher = new s_({
                        schema: t.schema
                    });
                    this.viewDocument = new Tp(e);
                    this.stylesProcessor = e;
                    this.htmlProcessor = new d_(this.viewDocument);
                    this.processor = this.htmlProcessor;
                    this._viewWriter = new Wp(this.viewDocument);
                    this.upcastDispatcher.on("text", cw(), {
                        priority: "lowest"
                    });
                    this.upcastDispatcher.on("element", aw(), {
                        priority: "lowest"
                    });
                    this.upcastDispatcher.on("documentFragment", aw(), {
                        priority: "lowest"
                    });
                    ht().prototype.decorate.call(this, "init");
                    ht().prototype.decorate.call(this, "set");
                    ht().prototype.decorate.call(this, "get");
                    ht().prototype.decorate.call(this, "toView");
                    ht().prototype.decorate.call(this, "toModel");
                    this.on("init", ()=>{
                        this.fire("ready");
                    }, {
                        priority: "lowest"
                    });
                    this.on("ready", ()=>{
                        this.model.enqueueChange({
                            isUndoable: false
                        }, ow);
                    }, {
                        priority: "lowest"
                    });
                }
                get(t = {}) {
                    const { rootName: e = "main", trim: n = "empty" } = t;
                    if (!this._checkIfRootsExists([
                        e
                    ])) throw new R("datacontroller-get-non-existent-root", this);
                    const o = this.model.document.getRoot(e);
                    if (!o.isAttached()) O("datacontroller-get-detached-root", this);
                    if (n === "empty" && !this.model.hasContent(o, {
                        ignoreWhitespaces: true
                    })) return "";
                    return this.stringify(o, t);
                }
                stringify(t, e = {}) {
                    const n = this.toView(t, e);
                    return this.processor.toData(n);
                }
                toView(t, e = {}) {
                    const n = this.viewDocument;
                    const o = this._viewWriter;
                    this.mapper.clearBindings();
                    const i = Hk._createIn(t);
                    const r = new jp(n);
                    this.mapper.bindElements(t, r);
                    const s = t.is("documentFragment") ? t.markers : h_(t);
                    this.downcastDispatcher.convert(i, s, o, e);
                    return r;
                }
                init(t) {
                    if (this.model.document.version) throw new R("datacontroller-init-document-not-empty", this);
                    let e = {};
                    if (typeof t === "string") e.main = t;
                    else e = t;
                    if (!this._checkIfRootsExists(Object.keys(e))) throw new R("datacontroller-init-non-existent-root", this);
                    this.model.enqueueChange({
                        isUndoable: false
                    }, (t)=>{
                        for (const n of Object.keys(e)){
                            const o = this.model.document.getRoot(n);
                            t.insert(this.parse(e[n], o), o, 0);
                        }
                    });
                    return Promise.resolve();
                }
                set(t, e = {}) {
                    let n = {};
                    if (typeof t === "string") n.main = t;
                    else n = t;
                    if (!this._checkIfRootsExists(Object.keys(n))) throw new R("datacontroller-set-non-existent-root", this);
                    this.model.enqueueChange(e.batchType || {}, (t)=>{
                        t.setSelection(null);
                        t.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
                        for (const e of Object.keys(n)){
                            const o = this.model.document.getRoot(e);
                            t.remove(t.createRangeIn(o));
                            t.insert(this.parse(n[e], o), o, 0);
                        }
                    });
                }
                parse(t, e = "$root") {
                    const n = this.processor.toView(t);
                    return this.toModel(n, e);
                }
                toModel(t, e = "$root") {
                    return this.model.change((n)=>this.upcastDispatcher.convert(t, n, e));
                }
                addStyleProcessorRules(t) {
                    t(this.stylesProcessor);
                }
                registerRawContentMatcher(t) {
                    if (this.processor && this.processor !== this.htmlProcessor) this.processor.registerRawContentMatcher(t);
                    this.htmlProcessor.registerRawContentMatcher(t);
                }
                destroy() {
                    this.stopListening();
                }
                _checkIfRootsExists(t) {
                    for (const e of t){
                        if (!this.model.document.getRoot(e)) return false;
                    }
                    return true;
                }
            }
            function h_(t) {
                const e = [];
                const n = t.root.document;
                if (!n) return new Map;
                const o = Hk._createIn(t);
                for (const t of n.model.markers){
                    const n = t.getRange();
                    const i = n.isCollapsed;
                    const r = n.start.isEqual(o.start) || n.end.isEqual(o.end);
                    if (i && r) e.push([
                        t.name,
                        n
                    ]);
                    else {
                        const i = o.getIntersection(n);
                        if (i) e.push([
                            t.name,
                            i
                        ]);
                    }
                }
                e.sort(([t, e], [n, o])=>{
                    if (e.end.compareWith(o.start) !== "after") return 1;
                    else if (e.start.compareWith(o.end) !== "before") return -1;
                    else switch(e.start.compareWith(o.start)){
                        case "before":
                            return 1;
                        case "after":
                            return -1;
                        default:
                            switch(e.end.compareWith(o.end)){
                                case "before":
                                    return 1;
                                case "after":
                                    return -1;
                                default:
                                    return n.localeCompare(t);
                            }
                    }
                });
                return new Map(e);
            }
            class f_ {
                constructor(t, e){
                    this._helpers = new Map;
                    this._downcast = nl(t);
                    this._createConversionHelpers({
                        name: "downcast",
                        dispatchers: this._downcast,
                        isDowncast: true
                    });
                    this._upcast = nl(e);
                    this._createConversionHelpers({
                        name: "upcast",
                        dispatchers: this._upcast,
                        isDowncast: false
                    });
                }
                addAlias(t, e) {
                    const n = this._downcast.includes(e);
                    const o = this._upcast.includes(e);
                    if (!o && !n) throw new R("conversion-add-alias-dispatcher-not-registered", this);
                    this._createConversionHelpers({
                        name: t,
                        dispatchers: [
                            e
                        ],
                        isDowncast: n
                    });
                }
                for(t) {
                    if (!this._helpers.has(t)) throw new R("conversion-for-unknown-group", this);
                    return this._helpers.get(t);
                }
                elementToElement(t) {
                    this.for("downcast").elementToElement(t);
                    for (const { model: e, view: n } of p_(t))this.for("upcast").elementToElement({
                        model: e,
                        view: n,
                        converterPriority: t.converterPriority
                    });
                }
                attributeToElement(t) {
                    this.for("downcast").attributeToElement(t);
                    for (const { model: e, view: n } of p_(t))this.for("upcast").elementToAttribute({
                        view: n,
                        model: e,
                        converterPriority: t.converterPriority
                    });
                }
                attributeToAttribute(t) {
                    this.for("downcast").attributeToAttribute(t);
                    for (const { model: e, view: n } of p_(t))this.for("upcast").attributeToAttribute({
                        view: n,
                        model: e
                    });
                }
                _createConversionHelpers({ name: t, dispatchers: e, isDowncast: n }) {
                    if (this._helpers.has(t)) throw new R("conversion-group-exists", this);
                    const o = n ? new fb(e) : new sw(e);
                    this._helpers.set(t, o);
                }
            }
            function* p_(t) {
                if (t.model.values) for (const e of t.model.values){
                    const n = {
                        key: t.model.key,
                        value: e
                    };
                    const o = t.view[e];
                    const i = t.upcastAlso ? t.upcastAlso[e] : undefined;
                    yield* g_(n, o, i);
                }
                else yield* g_(t.model, t.view, t.upcastAlso);
            }
            function* g_(t, e, n) {
                yield {
                    model: t,
                    view: e
                };
                if (n) for (const e of nl(n))yield {
                    model: t,
                    view: e
                };
            }
            class m_ {
                constructor(t){
                    this.baseVersion = t;
                    this.isDocumentOperation = this.baseVersion !== null;
                    this.batch = null;
                }
                _validate() {}
                toJSON() {
                    const t = Object.assign({}, this);
                    t.__className = this.constructor.className;
                    delete t.batch;
                    delete t.isDocumentOperation;
                    return t;
                }
                static get className() {
                    return "Operation";
                }
                static fromJSON(t, e) {
                    return new this(t.baseVersion);
                }
            }
            function k_(t, e) {
                const n = A_(e);
                const o = n.reduce((t, e)=>t + e.offsetSize, 0);
                const i = t.parent;
                C_(t);
                const r = t.index;
                i._insertChild(r, n);
                v_(i, r + n.length);
                v_(i, r);
                return new Hk(t, t.getShiftedBy(o));
            }
            function b_(t) {
                if (!t.isFlat) throw new R("operation-utils-remove-range-not-flat", this);
                const e = t.start.parent;
                C_(t.start);
                C_(t.end);
                const n = e._removeChildren(t.start.index, t.end.index - t.start.index);
                v_(e, t.start.index);
                return n;
            }
            function w_(t, e) {
                if (!t.isFlat) throw new R("operation-utils-move-range-not-flat", this);
                const n = b_(t);
                e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset);
                return k_(e, n);
            }
            function __(t, e, n) {
                C_(t.start);
                C_(t.end);
                for (const o of t.getItems({
                    shallow: true
                })){
                    const t = o.is("$textProxy") ? o.textNode : o;
                    if (n !== null) t._setAttribute(e, n);
                    else t._removeAttribute(e);
                    v_(t.parent, t.index);
                }
                v_(t.end.parent, t.end.index);
            }
            function A_(t) {
                const e = [];
                function n(t) {
                    if (typeof t == "string") e.push(new Sk(t));
                    else if (t instanceof Tk) e.push(new Sk(t.data, t.getAttributes()));
                    else if (t instanceof Ek) e.push(t);
                    else if (Et(t)) for (const e of t)n(e);
                }
                n(t);
                for(let t = 1; t < e.length; t++){
                    const n = e[t];
                    const o = e[t - 1];
                    if (n instanceof Sk && o instanceof Sk && y_(n, o)) {
                        e.splice(t - 1, 2, new Sk(o.data + n.data, o.getAttributes()));
                        t--;
                    }
                }
                return e;
            }
            function v_(t, e) {
                const n = t.getChild(e - 1);
                const o = t.getChild(e);
                if (n && o && n.is("$text") && o.is("$text") && y_(n, o)) {
                    const i = new Sk(n.data + o.data, n.getAttributes());
                    t._removeChildren(e - 1, 2);
                    t._insertChild(e - 1, i);
                }
            }
            function C_(t) {
                const e = t.textNode;
                const n = t.parent;
                if (e) {
                    const o = t.offset - e.startOffset;
                    const i = e.index;
                    n._removeChildren(i, 1);
                    const r = new Sk(e.data.substr(0, o), e.getAttributes());
                    const s = new Sk(e.data.substr(o), e.getAttributes());
                    n._insertChild(i, [
                        r,
                        s
                    ]);
                }
            }
            function y_(t, e) {
                const n = t.getAttributes();
                const o = e.getAttributes();
                for (const t of n){
                    if (t[1] !== e.getAttribute(t[0])) return false;
                    o.next();
                }
                return o.next().done;
            }
            class x_ extends m_ {
                constructor(t, e, n, o){
                    super(o);
                    this.sourcePosition = t.clone();
                    this.sourcePosition.stickiness = "toNext";
                    this.howMany = e;
                    this.targetPosition = n.clone();
                    this.targetPosition.stickiness = "toNone";
                }
                get type() {
                    if (this.targetPosition.root.rootName == "$graveyard") return "remove";
                    else if (this.sourcePosition.root.rootName == "$graveyard") return "reinsert";
                    return "move";
                }
                get affectedSelectable() {
                    return [
                        Hk._createFromPositionAndShift(this.sourcePosition, this.howMany),
                        Hk._createFromPositionAndShift(this.targetPosition, 0)
                    ];
                }
                clone() {
                    return new x_(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
                }
                getMovedRangeStart() {
                    return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
                }
                getReversed() {
                    const t = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
                    return new x_(this.getMovedRangeStart(), this.howMany, t, this.baseVersion + 1);
                }
                _validate() {
                    const t = this.sourcePosition.parent;
                    const e = this.targetPosition.parent;
                    const n = this.sourcePosition.offset;
                    const o = this.targetPosition.offset;
                    if (n + this.howMany > t.maxOffset) throw new R("move-operation-nodes-do-not-exist", this);
                    else if (t === e && n < o && o < n + this.howMany) throw new R("move-operation-range-into-itself", this);
                    else if (this.sourcePosition.root == this.targetPosition.root) {
                        if (xt(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath()) == "prefix") {
                            const t = this.sourcePosition.path.length - 1;
                            if (this.targetPosition.path[t] >= n && this.targetPosition.path[t] < n + this.howMany) throw new R("move-operation-node-into-itself", this);
                        }
                    }
                }
                _execute() {
                    w_(Hk._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
                }
                toJSON() {
                    const t = super.toJSON();
                    t.sourcePosition = this.sourcePosition.toJSON();
                    t.targetPosition = this.targetPosition.toJSON();
                    return t;
                }
                static get className() {
                    return "MoveOperation";
                }
                static fromJSON(t, e) {
                    const n = Ok.fromJSON(t.sourcePosition, e);
                    const o = Ok.fromJSON(t.targetPosition, e);
                    return new this(n, t.howMany, o, t.baseVersion);
                }
            }
            class E_ extends m_ {
                constructor(t, e, n){
                    super(n);
                    this.position = t.clone();
                    this.position.stickiness = "toNone";
                    this.nodes = new Dk(A_(e));
                    this.shouldReceiveAttributes = false;
                }
                get type() {
                    return "insert";
                }
                get howMany() {
                    return this.nodes.maxOffset;
                }
                get affectedSelectable() {
                    return this.position.clone();
                }
                clone() {
                    const t = new Dk([
                        ...this.nodes
                    ].map((t)=>t._clone(true)));
                    const e = new E_(this.position, t, this.baseVersion);
                    e.shouldReceiveAttributes = this.shouldReceiveAttributes;
                    return e;
                }
                getReversed() {
                    const t = this.position.root.document.graveyard;
                    const e = new Ok(t, [
                        0
                    ]);
                    return new x_(this.position, this.nodes.maxOffset, e, this.baseVersion + 1);
                }
                _validate() {
                    const t = this.position.parent;
                    if (!t || t.maxOffset < this.position.offset) throw new R("insert-operation-position-invalid", this);
                }
                _execute() {
                    const t = this.nodes;
                    this.nodes = new Dk([
                        ...t
                    ].map((t)=>t._clone(true)));
                    k_(this.position, t);
                }
                toJSON() {
                    const t = super.toJSON();
                    t.position = this.position.toJSON();
                    t.nodes = this.nodes.toJSON();
                    return t;
                }
                static get className() {
                    return "InsertOperation";
                }
                static fromJSON(t, e) {
                    const n = [];
                    for (const e of t.nodes)if (e.name) n.push(Bk.fromJSON(e));
                    else n.push(Sk.fromJSON(e));
                    const o = new E_(Ok.fromJSON(t.position, e), n, t.baseVersion);
                    o.shouldReceiveAttributes = t.shouldReceiveAttributes;
                    return o;
                }
            }
            class D_ extends m_ {
                constructor(t, e, n, o, i){
                    super(i);
                    this.splitPosition = t.clone();
                    this.splitPosition.stickiness = "toNext";
                    this.howMany = e;
                    this.insertionPosition = n;
                    this.graveyardPosition = o ? o.clone() : null;
                    if (this.graveyardPosition) this.graveyardPosition.stickiness = "toNext";
                }
                get type() {
                    return "split";
                }
                get moveTargetPosition() {
                    const t = this.insertionPosition.path.slice();
                    t.push(0);
                    return new Ok(this.insertionPosition.root, t);
                }
                get movedRange() {
                    const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
                    return new Hk(this.splitPosition, t);
                }
                get affectedSelectable() {
                    const t = [
                        Hk._createFromPositionAndShift(this.splitPosition, 0),
                        Hk._createFromPositionAndShift(this.insertionPosition, 0)
                    ];
                    if (this.graveyardPosition) t.push(Hk._createFromPositionAndShift(this.graveyardPosition, 0));
                    return t;
                }
                clone() {
                    return new D_(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
                }
                getReversed() {
                    const t = this.splitPosition.root.document.graveyard;
                    const e = new Ok(t, [
                        0
                    ]);
                    return new S_(this.moveTargetPosition, this.howMany, this.splitPosition, e, this.baseVersion + 1);
                }
                _validate() {
                    const t = this.splitPosition.parent;
                    const e = this.splitPosition.offset;
                    if (!t || t.maxOffset < e) throw new R("split-operation-position-invalid", this);
                    else if (!t.parent) throw new R("split-operation-split-in-root", this);
                    else if (this.howMany != t.maxOffset - this.splitPosition.offset) throw new R("split-operation-how-many-invalid", this);
                    else if (this.graveyardPosition && !this.graveyardPosition.nodeAfter) throw new R("split-operation-graveyard-position-invalid", this);
                }
                _execute() {
                    const t = this.splitPosition.parent;
                    if (this.graveyardPosition) w_(Hk._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
                    else {
                        const e = t._clone();
                        k_(this.insertionPosition, e);
                    }
                    const e = new Hk(Ok._createAt(t, this.splitPosition.offset), Ok._createAt(t, t.maxOffset));
                    w_(e, this.moveTargetPosition);
                }
                toJSON() {
                    const t = super.toJSON();
                    t.splitPosition = this.splitPosition.toJSON();
                    t.insertionPosition = this.insertionPosition.toJSON();
                    if (this.graveyardPosition) t.graveyardPosition = this.graveyardPosition.toJSON();
                    return t;
                }
                static get className() {
                    return "SplitOperation";
                }
                static getInsertionPosition(t) {
                    const e = t.path.slice(0, -1);
                    e[e.length - 1]++;
                    return new Ok(t.root, e, "toPrevious");
                }
                static fromJSON(t, e) {
                    const n = Ok.fromJSON(t.splitPosition, e);
                    const o = Ok.fromJSON(t.insertionPosition, e);
                    const i = t.graveyardPosition ? Ok.fromJSON(t.graveyardPosition, e) : null;
                    return new this(n, t.howMany, o, i, t.baseVersion);
                }
            }
            class S_ extends m_ {
                constructor(t, e, n, o, i){
                    super(i);
                    this.sourcePosition = t.clone();
                    this.sourcePosition.stickiness = "toPrevious";
                    this.howMany = e;
                    this.targetPosition = n.clone();
                    this.targetPosition.stickiness = "toNext";
                    this.graveyardPosition = o.clone();
                }
                get type() {
                    return "merge";
                }
                get deletionPosition() {
                    return new Ok(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
                }
                get movedRange() {
                    const t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
                    return new Hk(this.sourcePosition, t);
                }
                get affectedSelectable() {
                    const t = this.sourcePosition.parent;
                    return [
                        Hk._createOn(t),
                        Hk._createFromPositionAndShift(this.targetPosition, 0),
                        Hk._createFromPositionAndShift(this.graveyardPosition, 0)
                    ];
                }
                clone() {
                    return new S_(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
                }
                getReversed() {
                    const t = this.targetPosition._getTransformedByMergeOperation(this);
                    const e = this.sourcePosition.path.slice(0, -1);
                    const n = new Ok(this.sourcePosition.root, e)._getTransformedByMergeOperation(this);
                    return new D_(t, this.howMany, n, this.graveyardPosition, this.baseVersion + 1);
                }
                _validate() {
                    const t = this.sourcePosition.parent;
                    const e = this.targetPosition.parent;
                    if (!t.parent) throw new R("merge-operation-source-position-invalid", this);
                    else if (!e.parent) throw new R("merge-operation-target-position-invalid", this);
                    else if (this.howMany != t.maxOffset) throw new R("merge-operation-how-many-invalid", this);
                }
                _execute() {
                    const t = this.sourcePosition.parent;
                    const e = Hk._createIn(t);
                    w_(e, this.targetPosition);
                    w_(Hk._createOn(t), this.graveyardPosition);
                }
                toJSON() {
                    const t = super.toJSON();
                    t.sourcePosition = t.sourcePosition.toJSON();
                    t.targetPosition = t.targetPosition.toJSON();
                    t.graveyardPosition = t.graveyardPosition.toJSON();
                    return t;
                }
                static get className() {
                    return "MergeOperation";
                }
                static fromJSON(t, e) {
                    const n = Ok.fromJSON(t.sourcePosition, e);
                    const o = Ok.fromJSON(t.targetPosition, e);
                    const i = Ok.fromJSON(t.graveyardPosition, e);
                    return new this(n, t.howMany, o, i, t.baseVersion);
                }
            }
            class T_ extends m_ {
                constructor(t, e, n, o, i, r){
                    super(r);
                    this.name = t;
                    this.oldRange = e ? e.clone() : null;
                    this.newRange = n ? n.clone() : null;
                    this.affectsData = i;
                    this._markers = o;
                }
                get type() {
                    return "marker";
                }
                get affectedSelectable() {
                    const t = [];
                    if (this.oldRange) t.push(this.oldRange.clone());
                    if (this.newRange) {
                        if (this.oldRange) t.push(...this.newRange.getDifference(this.oldRange));
                        else t.push(this.newRange.clone());
                    }
                    return t;
                }
                clone() {
                    return new T_(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
                }
                getReversed() {
                    return new T_(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
                }
                _execute() {
                    if (this.newRange) this._markers._set(this.name, this.newRange, true, this.affectsData);
                    else this._markers._remove(this.name);
                }
                toJSON() {
                    const t = super.toJSON();
                    if (this.oldRange) t.oldRange = this.oldRange.toJSON();
                    if (this.newRange) t.newRange = this.newRange.toJSON();
                    delete t._markers;
                    return t;
                }
                static get className() {
                    return "MarkerOperation";
                }
                static fromJSON(t, e) {
                    return new T_(t.name, t.oldRange ? Hk.fromJSON(t.oldRange, e) : null, t.newRange ? Hk.fromJSON(t.newRange, e) : null, e.model.markers, t.affectsData, t.baseVersion);
                }
            }
            function B_(t, e) {
                return ak(t, e);
            }
            const P_ = B_;
            class I_ extends m_ {
                constructor(t, e, n, o, i){
                    super(i);
                    this.range = t.clone();
                    this.key = e;
                    this.oldValue = n === undefined ? null : n;
                    this.newValue = o === undefined ? null : o;
                }
                get type() {
                    if (this.oldValue === null) return "addAttribute";
                    else if (this.newValue === null) return "removeAttribute";
                    else return "changeAttribute";
                }
                get affectedSelectable() {
                    return this.range.clone();
                }
                clone() {
                    return new I_(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
                }
                getReversed() {
                    return new I_(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
                }
                toJSON() {
                    const t = super.toJSON();
                    t.range = this.range.toJSON();
                    return t;
                }
                _validate() {
                    if (!this.range.isFlat) throw new R("attribute-operation-range-not-flat", this);
                    for (const t of this.range.getItems({
                        shallow: true
                    })){
                        if (this.oldValue !== null && !P_(t.getAttribute(this.key), this.oldValue)) throw new R("attribute-operation-wrong-old-value", this, {
                            item: t,
                            key: this.key,
                            value: this.oldValue
                        });
                        if (this.oldValue === null && this.newValue !== null && t.hasAttribute(this.key)) throw new R("attribute-operation-attribute-exists", this, {
                            node: t,
                            key: this.key
                        });
                    }
                }
                _execute() {
                    if (!P_(this.oldValue, this.newValue)) __(this.range, this.key, this.newValue);
                }
                static get className() {
                    return "AttributeOperation";
                }
                static fromJSON(t, e) {
                    return new I_(Hk.fromJSON(t.range, e), t.key, t.oldValue, t.newValue, t.baseVersion);
                }
            }
            class R_ extends m_ {
                get type() {
                    return "noop";
                }
                get affectedSelectable() {
                    return null;
                }
                clone() {
                    return new R_(this.baseVersion);
                }
                getReversed() {
                    return new R_(this.baseVersion + 1);
                }
                _execute() {}
                static get className() {
                    return "NoOperation";
                }
            }
            class O_ extends m_ {
                constructor(t, e, n, o){
                    super(o);
                    this.position = t;
                    this.position.stickiness = "toNext";
                    this.oldName = e;
                    this.newName = n;
                }
                get type() {
                    return "rename";
                }
                get affectedSelectable() {
                    return this.position.nodeAfter;
                }
                clone() {
                    return new O_(this.position.clone(), this.oldName, this.newName, this.baseVersion);
                }
                getReversed() {
                    return new O_(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
                }
                _validate() {
                    const t = this.position.nodeAfter;
                    if (!(t instanceof Bk)) throw new R("rename-operation-wrong-position", this);
                    else if (t.name !== this.oldName) throw new R("rename-operation-wrong-name", this);
                }
                _execute() {
                    const t = this.position.nodeAfter;
                    t.name = this.newName;
                }
                toJSON() {
                    const t = super.toJSON();
                    t.position = this.position.toJSON();
                    return t;
                }
                static get className() {
                    return "RenameOperation";
                }
                static fromJSON(t, e) {
                    return new O_(Ok.fromJSON(t.position, e), t.oldName, t.newName, t.baseVersion);
                }
            }
            class V_ extends m_ {
                constructor(t, e, n, o, i){
                    super(i);
                    this.root = t;
                    this.key = e;
                    this.oldValue = n === undefined ? null : n;
                    this.newValue = o === undefined ? null : o;
                }
                get type() {
                    if (this.oldValue === null) return "addRootAttribute";
                    else if (this.newValue === null) return "removeRootAttribute";
                    else return "changeRootAttribute";
                }
                get affectedSelectable() {
                    return this.root;
                }
                clone() {
                    return new V_(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
                }
                getReversed() {
                    return new V_(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
                }
                _validate() {
                    if (this.root != this.root.root || this.root.is("documentFragment")) throw new R("rootattribute-operation-not-a-root", this, {
                        root: this.root,
                        key: this.key
                    });
                    if (this.oldValue !== null && this.root.getAttribute(this.key) !== this.oldValue) throw new R("rootattribute-operation-wrong-old-value", this, {
                        root: this.root,
                        key: this.key
                    });
                    if (this.oldValue === null && this.newValue !== null && this.root.hasAttribute(this.key)) throw new R("rootattribute-operation-attribute-exists", this, {
                        root: this.root,
                        key: this.key
                    });
                }
                _execute() {
                    if (this.newValue !== null) this.root._setAttribute(this.key, this.newValue);
                    else this.root._removeAttribute(this.key);
                }
                toJSON() {
                    const t = super.toJSON();
                    t.root = this.root.toJSON();
                    return t;
                }
                static get className() {
                    return "RootAttributeOperation";
                }
                static fromJSON(t, e) {
                    if (!e.getRoot(t.root)) throw new R("rootattribute-operation-fromjson-no-root", this, {
                        rootName: t.root
                    });
                    return new V_(e.getRoot(t.root), t.key, t.oldValue, t.newValue, t.baseVersion);
                }
            }
            class M_ extends m_ {
                constructor(t, e, n, o, i){
                    super(i);
                    this.rootName = t;
                    this.elementName = e;
                    this.isAdd = n;
                    this._document = o;
                    if (!this._document.getRoot(this.rootName)) {
                        const t = this._document.createRoot(this.elementName, this.rootName);
                        t._isAttached = false;
                    }
                }
                get type() {
                    return this.isAdd ? "addRoot" : "detachRoot";
                }
                get affectedSelectable() {
                    return this._document.getRoot(this.rootName);
                }
                clone() {
                    return new M_(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
                }
                getReversed() {
                    return new M_(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
                }
                _execute() {
                    this._document.getRoot(this.rootName)._isAttached = this.isAdd;
                }
                toJSON() {
                    const t = super.toJSON();
                    delete t._document;
                    return t;
                }
                static get className() {
                    return "RootOperation";
                }
                static fromJSON(t, e) {
                    return new M_(t.rootName, t.elementName, t.isAdd, e, t.baseVersion);
                }
            }
            const L_ = {};
            L_[I_.className] = I_;
            L_[E_.className] = E_;
            L_[T_.className] = T_;
            L_[x_.className] = x_;
            L_[R_.className] = R_;
            L_[m_.className] = m_;
            L_[O_.className] = O_;
            L_[V_.className] = V_;
            L_[M_.className] = M_;
            L_[D_.className] = D_;
            L_[S_.className] = S_;
            class z_ {
                static fromJSON(t, e) {
                    return L_[t.__className].fromJSON(t, e);
                }
            }
            const N_ = new Map;
            function F_(t, e, n) {
                let o = N_.get(t);
                if (!o) {
                    o = new Map;
                    N_.set(t, o);
                }
                o.set(e, n);
            }
            function H_(t, e) {
                const n = N_.get(t);
                if (n && n.has(e)) return n.get(e);
                return j_;
            }
            function j_(t) {
                return [
                    t
                ];
            }
            function q_(t, e, n = {}) {
                const o = H_(t.constructor, e.constructor);
                try {
                    t = t.clone();
                    return o(t, e, n);
                } catch (t) {
                    throw t;
                }
            }
            function W_(t, e, n) {
                t = t.slice();
                e = e.slice();
                const o = new $_(n.document, n.useRelations, n.forceWeakRemove);
                o.setOriginalOperations(t);
                o.setOriginalOperations(e);
                const i = o.originalOperations;
                if (t.length == 0 || e.length == 0) return {
                    operationsA: t,
                    operationsB: e,
                    originalOperations: i
                };
                const r = new WeakMap;
                for (const e of t)r.set(e, 0);
                const s = {
                    nextBaseVersionA: t[t.length - 1].baseVersion + 1,
                    nextBaseVersionB: e[e.length - 1].baseVersion + 1,
                    originalOperationsACount: t.length,
                    originalOperationsBCount: e.length
                };
                let a = 0;
                while(a < t.length){
                    const n = t[a];
                    const i = r.get(n);
                    if (i == e.length) {
                        a++;
                        continue;
                    }
                    const s = e[i];
                    const c = q_(n, s, o.getContext(n, s, true));
                    const l = q_(s, n, o.getContext(s, n, false));
                    o.updateRelation(n, s);
                    o.setOriginalOperations(c, n);
                    o.setOriginalOperations(l, s);
                    for (const t of c)r.set(t, i + l.length);
                    t.splice(a, 1, ...c);
                    e.splice(i, 1, ...l);
                }
                if (n.padWithNoOps) {
                    const n = t.length - s.originalOperationsACount;
                    const o = e.length - s.originalOperationsBCount;
                    U_(t, o - n);
                    U_(e, n - o);
                }
                G_(t, s.nextBaseVersionB);
                G_(e, s.nextBaseVersionA);
                return {
                    operationsA: t,
                    operationsB: e,
                    originalOperations: i
                };
            }
            class $_ {
                constructor(t, e, n = false){
                    this.originalOperations = new Map;
                    this._history = t.history;
                    this._useRelations = e;
                    this._forceWeakRemove = !!n;
                    this._relations = new Map;
                }
                setOriginalOperations(t, e = null) {
                    const n = e ? this.originalOperations.get(e) : null;
                    for (const e of t)this.originalOperations.set(e, n || e);
                }
                updateRelation(t, e) {
                    if (t instanceof x_) {
                        if (e instanceof S_) {
                            if (t.targetPosition.isEqual(e.sourcePosition) || e.movedRange.containsPosition(t.targetPosition)) this._setRelation(t, e, "insertAtSource");
                            else if (t.targetPosition.isEqual(e.deletionPosition)) this._setRelation(t, e, "insertBetween");
                            else if (t.targetPosition.isAfter(e.sourcePosition)) this._setRelation(t, e, "moveTargetAfter");
                        } else if (e instanceof x_) {
                            if (t.targetPosition.isEqual(e.sourcePosition) || t.targetPosition.isBefore(e.sourcePosition)) this._setRelation(t, e, "insertBefore");
                            else this._setRelation(t, e, "insertAfter");
                        }
                    } else if (t instanceof D_) {
                        if (e instanceof S_) {
                            if (t.splitPosition.isBefore(e.sourcePosition)) this._setRelation(t, e, "splitBefore");
                        } else if (e instanceof x_) {
                            if (t.splitPosition.isEqual(e.sourcePosition) || t.splitPosition.isBefore(e.sourcePosition)) this._setRelation(t, e, "splitBefore");
                            else {
                                const n = Hk._createFromPositionAndShift(e.sourcePosition, e.howMany);
                                if (t.splitPosition.hasSameParentAs(e.sourcePosition) && n.containsPosition(t.splitPosition)) {
                                    const o = n.end.offset - t.splitPosition.offset;
                                    const i = t.splitPosition.offset - n.start.offset;
                                    this._setRelation(t, e, {
                                        howMany: o,
                                        offset: i
                                    });
                                }
                            }
                        }
                    } else if (t instanceof S_) {
                        if (e instanceof S_) {
                            if (!t.targetPosition.isEqual(e.sourcePosition)) this._setRelation(t, e, "mergeTargetNotMoved");
                            if (t.sourcePosition.isEqual(e.targetPosition)) this._setRelation(t, e, "mergeSourceNotMoved");
                            if (t.sourcePosition.isEqual(e.sourcePosition)) this._setRelation(t, e, "mergeSameElement");
                        } else if (e instanceof D_) {
                            if (t.sourcePosition.isEqual(e.splitPosition)) this._setRelation(t, e, "splitAtSource");
                        }
                    } else if (t instanceof T_) {
                        const n = t.newRange;
                        if (!n) return;
                        if (e instanceof x_) {
                            const o = Hk._createFromPositionAndShift(e.sourcePosition, e.howMany);
                            const i = o.containsPosition(n.start) || o.start.isEqual(n.start);
                            const r = o.containsPosition(n.end) || o.end.isEqual(n.end);
                            if ((i || r) && !o.containsRange(n)) this._setRelation(t, e, {
                                side: i ? "left" : "right",
                                path: i ? n.start.path.slice() : n.end.path.slice()
                            });
                        } else if (e instanceof S_) {
                            const o = n.start.isEqual(e.targetPosition);
                            const i = n.start.isEqual(e.deletionPosition);
                            const r = n.end.isEqual(e.deletionPosition);
                            const s = n.end.isEqual(e.sourcePosition);
                            if (o || i || r || s) this._setRelation(t, e, {
                                wasInLeftElement: o,
                                wasStartBeforeMergedElement: i,
                                wasEndBeforeMergedElement: r,
                                wasInRightElement: s
                            });
                        }
                    }
                }
                getContext(t, e, n) {
                    return {
                        aIsStrong: n,
                        aWasUndone: this._wasUndone(t),
                        bWasUndone: this._wasUndone(e),
                        abRelation: this._useRelations ? this._getRelation(t, e) : null,
                        baRelation: this._useRelations ? this._getRelation(e, t) : null,
                        forceWeakRemove: this._forceWeakRemove
                    };
                }
                _wasUndone(t) {
                    const e = this.originalOperations.get(t);
                    return e.wasUndone || this._history.isUndoneOperation(e);
                }
                _getRelation(t, e) {
                    const n = this.originalOperations.get(e);
                    const o = this._history.getUndoneOperation(n);
                    if (!o) return null;
                    const i = this.originalOperations.get(t);
                    const r = this._relations.get(i);
                    if (r) return r.get(o) || null;
                    return null;
                }
                _setRelation(t, e, n) {
                    const o = this.originalOperations.get(t);
                    const i = this.originalOperations.get(e);
                    let r = this._relations.get(o);
                    if (!r) {
                        r = new Map;
                        this._relations.set(o, r);
                    }
                    r.set(i, n);
                }
            }
            function G_(t, e) {
                for (const n of t)n.baseVersion = e++;
            }
            function U_(t, e) {
                for(let n = 0; n < e; n++)t.push(new R_(0));
            }
            F_(I_, I_, (t, e, n)=>{
                if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
                    const o = t.range.getDifference(e.range).map((e)=>new I_(e, t.key, t.oldValue, t.newValue, 0));
                    const i = t.range.getIntersection(e.range);
                    if (i) {
                        if (n.aIsStrong) o.push(new I_(i, e.key, e.newValue, t.newValue, 0));
                    }
                    if (o.length == 0) return [
                        new R_(0)
                    ];
                    return o;
                } else return [
                    t
                ];
            });
            F_(I_, E_, (t, e)=>{
                if (t.range.start.hasSameParentAs(e.position) && t.range.containsPosition(e.position)) {
                    const n = t.range._getTransformedByInsertion(e.position, e.howMany, !e.shouldReceiveAttributes);
                    const o = n.map((e)=>new I_(e, t.key, t.oldValue, t.newValue, t.baseVersion));
                    if (e.shouldReceiveAttributes) {
                        const n = K_(e, t.key, t.oldValue);
                        if (n) o.unshift(n);
                    }
                    return o;
                }
                t.range = t.range._getTransformedByInsertion(e.position, e.howMany, false)[0];
                return [
                    t
                ];
            });
            function K_(t, e, n) {
                const o = t.nodes;
                const i = o.getNode(0).getAttribute(e);
                if (i == n) return null;
                const r = new Hk(t.position, t.position.getShiftedBy(t.howMany));
                return new I_(r, e, i, n, 0);
            }
            F_(I_, S_, (t, e)=>{
                const n = [];
                if (t.range.start.hasSameParentAs(e.deletionPosition)) {
                    if (t.range.containsPosition(e.deletionPosition) || t.range.start.isEqual(e.deletionPosition)) n.push(Hk._createFromPositionAndShift(e.graveyardPosition, 1));
                }
                const o = t.range._getTransformedByMergeOperation(e);
                if (!o.isCollapsed) n.push(o);
                return n.map((e)=>new I_(e, t.key, t.oldValue, t.newValue, t.baseVersion));
            });
            F_(I_, x_, (t, e)=>{
                const n = Z_(t.range, e);
                return n.map((e)=>new I_(e, t.key, t.oldValue, t.newValue, t.baseVersion));
            });
            function Z_(t, e) {
                const n = Hk._createFromPositionAndShift(e.sourcePosition, e.howMany);
                let o = null;
                let i = [];
                if (n.containsRange(t, true)) o = t;
                else if (t.start.hasSameParentAs(n.start)) {
                    i = t.getDifference(n);
                    o = t.getIntersection(n);
                } else i = [
                    t
                ];
                const r = [];
                for (let t of i){
                    t = t._getTransformedByDeletion(e.sourcePosition, e.howMany);
                    const n = e.getMovedRangeStart();
                    const o = t.start.hasSameParentAs(n);
                    const i = t._getTransformedByInsertion(n, e.howMany, o);
                    r.push(...i);
                }
                if (o) r.push(o._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany, false)[0]);
                return r;
            }
            F_(I_, D_, (t, e)=>{
                if (t.range.end.isEqual(e.insertionPosition)) {
                    if (!e.graveyardPosition) t.range.end.offset++;
                    return [
                        t
                    ];
                }
                if (t.range.start.hasSameParentAs(e.splitPosition) && t.range.containsPosition(e.splitPosition)) {
                    const n = t.clone();
                    n.range = new Hk(e.moveTargetPosition.clone(), t.range.end._getCombined(e.splitPosition, e.moveTargetPosition));
                    t.range.end = e.splitPosition.clone();
                    t.range.end.stickiness = "toPrevious";
                    return [
                        t,
                        n
                    ];
                }
                t.range = t.range._getTransformedBySplitOperation(e);
                return [
                    t
                ];
            });
            F_(E_, I_, (t, e)=>{
                const n = [
                    t
                ];
                if (t.shouldReceiveAttributes && t.position.hasSameParentAs(e.range.start) && e.range.containsPosition(t.position)) {
                    const o = K_(t, e.key, e.newValue);
                    if (o) n.push(o);
                }
                return n;
            });
            F_(E_, E_, (t, e, n)=>{
                if (t.position.isEqual(e.position) && n.aIsStrong) return [
                    t
                ];
                t.position = t.position._getTransformedByInsertOperation(e);
                return [
                    t
                ];
            });
            F_(E_, x_, (t, e)=>{
                t.position = t.position._getTransformedByMoveOperation(e);
                return [
                    t
                ];
            });
            F_(E_, D_, (t, e)=>{
                t.position = t.position._getTransformedBySplitOperation(e);
                return [
                    t
                ];
            });
            F_(E_, S_, (t, e)=>{
                t.position = t.position._getTransformedByMergeOperation(e);
                return [
                    t
                ];
            });
            F_(T_, E_, (t, e)=>{
                if (t.oldRange) t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0];
                if (t.newRange) t.newRange = t.newRange._getTransformedByInsertOperation(e)[0];
                return [
                    t
                ];
            });
            F_(T_, T_, (t, e, n)=>{
                if (t.name == e.name) {
                    if (n.aIsStrong) t.oldRange = e.newRange ? e.newRange.clone() : null;
                    else return [
                        new R_(0)
                    ];
                }
                return [
                    t
                ];
            });
            F_(T_, S_, (t, e)=>{
                if (t.oldRange) t.oldRange = t.oldRange._getTransformedByMergeOperation(e);
                if (t.newRange) t.newRange = t.newRange._getTransformedByMergeOperation(e);
                return [
                    t
                ];
            });
            F_(T_, x_, (t, e, n)=>{
                if (t.oldRange) t.oldRange = Hk._createFromRanges(t.oldRange._getTransformedByMoveOperation(e));
                if (t.newRange) {
                    if (n.abRelation) {
                        const o = Hk._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
                        if (n.abRelation.side == "left" && e.targetPosition.isEqual(t.newRange.start)) {
                            t.newRange.end = o.end;
                            t.newRange.start.path = n.abRelation.path;
                            return [
                                t
                            ];
                        } else if (n.abRelation.side == "right" && e.targetPosition.isEqual(t.newRange.end)) {
                            t.newRange.start = o.start;
                            t.newRange.end.path = n.abRelation.path;
                            return [
                                t
                            ];
                        }
                    }
                    t.newRange = Hk._createFromRanges(t.newRange._getTransformedByMoveOperation(e));
                }
                return [
                    t
                ];
            });
            F_(T_, D_, (t, e, n)=>{
                if (t.oldRange) t.oldRange = t.oldRange._getTransformedBySplitOperation(e);
                if (t.newRange) {
                    if (n.abRelation) {
                        const o = t.newRange._getTransformedBySplitOperation(e);
                        if (t.newRange.start.isEqual(e.splitPosition) && n.abRelation.wasStartBeforeMergedElement) t.newRange.start = Ok._createAt(e.insertionPosition);
                        else if (t.newRange.start.isEqual(e.splitPosition) && !n.abRelation.wasInLeftElement) t.newRange.start = Ok._createAt(e.moveTargetPosition);
                        if (t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasInRightElement) t.newRange.end = Ok._createAt(e.moveTargetPosition);
                        else if (t.newRange.end.isEqual(e.splitPosition) && n.abRelation.wasEndBeforeMergedElement) t.newRange.end = Ok._createAt(e.insertionPosition);
                        else t.newRange.end = o.end;
                        return [
                            t
                        ];
                    }
                    t.newRange = t.newRange._getTransformedBySplitOperation(e);
                }
                return [
                    t
                ];
            });
            F_(S_, E_, (t, e)=>{
                if (t.sourcePosition.hasSameParentAs(e.position)) t.howMany += e.howMany;
                t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e);
                t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e);
                return [
                    t
                ];
            });
            F_(S_, S_, (t, e, n)=>{
                if (t.sourcePosition.isEqual(e.sourcePosition) && t.targetPosition.isEqual(e.targetPosition)) {
                    if (!n.bWasUndone) return [
                        new R_(0)
                    ];
                    else {
                        const n = e.graveyardPosition.path.slice();
                        n.push(0);
                        t.sourcePosition = new Ok(e.graveyardPosition.root, n);
                        t.howMany = 0;
                        return [
                            t
                        ];
                    }
                }
                if (t.sourcePosition.isEqual(e.sourcePosition) && !t.targetPosition.isEqual(e.targetPosition) && !n.bWasUndone && n.abRelation != "splitAtSource") {
                    const o = t.targetPosition.root.rootName == "$graveyard";
                    const i = e.targetPosition.root.rootName == "$graveyard";
                    const r = o && !i;
                    const s = i && !o;
                    const a = s || !r && n.aIsStrong;
                    if (a) {
                        const n = e.targetPosition._getTransformedByMergeOperation(e);
                        const o = t.targetPosition._getTransformedByMergeOperation(e);
                        return [
                            new x_(n, t.howMany, o, 0)
                        ];
                    } else return [
                        new R_(0)
                    ];
                }
                if (t.sourcePosition.hasSameParentAs(e.targetPosition)) t.howMany += e.howMany;
                t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e);
                t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e);
                if (!t.graveyardPosition.isEqual(e.graveyardPosition) || !n.aIsStrong) t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e);
                return [
                    t
                ];
            });
            F_(S_, x_, (t, e, n)=>{
                const o = Hk._createFromPositionAndShift(e.sourcePosition, e.howMany);
                if (e.type == "remove" && !n.bWasUndone && !n.forceWeakRemove) {
                    if (t.deletionPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.sourcePosition)) return [
                        new R_(0)
                    ];
                }
                if (t.sourcePosition.hasSameParentAs(e.targetPosition)) t.howMany += e.howMany;
                if (t.sourcePosition.hasSameParentAs(e.sourcePosition)) t.howMany -= e.howMany;
                t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e);
                t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e);
                if (!t.graveyardPosition.isEqual(e.targetPosition)) t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
                return [
                    t
                ];
            });
            F_(S_, D_, (t, e, n)=>{
                if (e.graveyardPosition) {
                    t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(e.graveyardPosition, 1);
                    if (t.deletionPosition.isEqual(e.graveyardPosition)) t.howMany = e.howMany;
                }
                if (t.targetPosition.isEqual(e.splitPosition)) {
                    const o = e.howMany != 0;
                    const i = e.graveyardPosition && t.deletionPosition.isEqual(e.graveyardPosition);
                    if (o || i || n.abRelation == "mergeTargetNotMoved") {
                        t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e);
                        return [
                            t
                        ];
                    }
                }
                if (t.sourcePosition.isEqual(e.splitPosition)) {
                    if (n.abRelation == "mergeSourceNotMoved") {
                        t.howMany = 0;
                        t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
                        return [
                            t
                        ];
                    }
                    if (n.abRelation == "mergeSameElement" || t.sourcePosition.offset > 0) {
                        t.sourcePosition = e.moveTargetPosition.clone();
                        t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
                        return [
                            t
                        ];
                    }
                }
                if (t.sourcePosition.hasSameParentAs(e.splitPosition)) t.howMany = e.splitPosition.offset;
                t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e);
                t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e);
                return [
                    t
                ];
            });
            F_(x_, E_, (t, e)=>{
                const n = Hk._createFromPositionAndShift(t.sourcePosition, t.howMany);
                const o = n._getTransformedByInsertOperation(e, false)[0];
                t.sourcePosition = o.start;
                t.howMany = o.end.offset - o.start.offset;
                if (!t.targetPosition.isEqual(e.position)) t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e);
                return [
                    t
                ];
            });
            F_(x_, x_, (t, e, n)=>{
                const o = Hk._createFromPositionAndShift(t.sourcePosition, t.howMany);
                const i = Hk._createFromPositionAndShift(e.sourcePosition, e.howMany);
                let r = n.aIsStrong;
                let s = !n.aIsStrong;
                if (n.abRelation == "insertBefore" || n.baRelation == "insertAfter") s = true;
                else if (n.abRelation == "insertAfter" || n.baRelation == "insertBefore") s = false;
                let a;
                if (t.targetPosition.isEqual(e.targetPosition) && s) a = t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
                else a = t.targetPosition._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
                if (J_(t, e) && J_(e, t)) return [
                    e.getReversed()
                ];
                const c = o.containsPosition(e.targetPosition);
                if (c && o.containsRange(i, true)) {
                    o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
                    o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
                    return Y_([
                        o
                    ], a);
                }
                const l = i.containsPosition(t.targetPosition);
                if (l && i.containsRange(o, true)) {
                    o.start = o.start._getCombined(e.sourcePosition, e.getMovedRangeStart());
                    o.end = o.end._getCombined(e.sourcePosition, e.getMovedRangeStart());
                    return Y_([
                        o
                    ], a);
                }
                const d = xt(t.sourcePosition.getParentPath(), e.sourcePosition.getParentPath());
                if (d == "prefix" || d == "extension") {
                    o.start = o.start._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
                    o.end = o.end._getTransformedByMove(e.sourcePosition, e.targetPosition, e.howMany);
                    return Y_([
                        o
                    ], a);
                }
                if (t.type == "remove" && e.type != "remove" && !n.aWasUndone && !n.forceWeakRemove) r = true;
                else if (t.type != "remove" && e.type == "remove" && !n.bWasUndone && !n.forceWeakRemove) r = false;
                const u = [];
                const h = o.getDifference(i);
                for (const t of h){
                    t.start = t.start._getTransformedByDeletion(e.sourcePosition, e.howMany);
                    t.end = t.end._getTransformedByDeletion(e.sourcePosition, e.howMany);
                    const n = xt(t.start.getParentPath(), e.getMovedRangeStart().getParentPath()) == "same";
                    const o = t._getTransformedByInsertion(e.getMovedRangeStart(), e.howMany, n);
                    u.push(...o);
                }
                const f = o.getIntersection(i);
                if (f !== null && r) {
                    f.start = f.start._getCombined(e.sourcePosition, e.getMovedRangeStart());
                    f.end = f.end._getCombined(e.sourcePosition, e.getMovedRangeStart());
                    if (u.length === 0) u.push(f);
                    else if (u.length == 1) {
                        if (i.start.isBefore(o.start) || i.start.isEqual(o.start)) u.unshift(f);
                        else u.push(f);
                    } else u.splice(1, 0, f);
                }
                if (u.length === 0) return [
                    new R_(t.baseVersion)
                ];
                return Y_(u, a);
            });
            F_(x_, D_, (t, e, n)=>{
                let o = t.targetPosition.clone();
                if (!t.targetPosition.isEqual(e.insertionPosition) || !e.graveyardPosition || n.abRelation == "moveTargetAfter") o = t.targetPosition._getTransformedBySplitOperation(e);
                const i = Hk._createFromPositionAndShift(t.sourcePosition, t.howMany);
                if (i.end.isEqual(e.insertionPosition)) {
                    if (!e.graveyardPosition) t.howMany++;
                    t.targetPosition = o;
                    return [
                        t
                    ];
                }
                if (i.start.hasSameParentAs(e.splitPosition) && i.containsPosition(e.splitPosition)) {
                    let t = new Hk(e.splitPosition, i.end);
                    t = t._getTransformedBySplitOperation(e);
                    const n = [
                        new Hk(i.start, e.splitPosition),
                        t
                    ];
                    return Y_(n, o);
                }
                if (t.targetPosition.isEqual(e.splitPosition) && n.abRelation == "insertAtSource") o = e.moveTargetPosition;
                if (t.targetPosition.isEqual(e.insertionPosition) && n.abRelation == "insertBetween") o = t.targetPosition;
                const r = i._getTransformedBySplitOperation(e);
                const s = [
                    r
                ];
                if (e.graveyardPosition) {
                    const o = i.start.isEqual(e.graveyardPosition) || i.containsPosition(e.graveyardPosition);
                    if (t.howMany > 1 && o && !n.aWasUndone) s.push(Hk._createFromPositionAndShift(e.insertionPosition, 1));
                }
                return Y_(s, o);
            });
            F_(x_, S_, (t, e, n)=>{
                const o = Hk._createFromPositionAndShift(t.sourcePosition, t.howMany);
                if (e.deletionPosition.hasSameParentAs(t.sourcePosition) && o.containsPosition(e.sourcePosition)) {
                    if (t.type == "remove" && !n.forceWeakRemove) {
                        if (!n.aWasUndone) {
                            const n = [];
                            let o = e.graveyardPosition.clone();
                            let i = e.targetPosition._getTransformedByMergeOperation(e);
                            if (t.howMany > 1) {
                                n.push(new x_(t.sourcePosition, t.howMany - 1, t.targetPosition, 0));
                                o = o._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1);
                                i = i._getTransformedByMove(t.sourcePosition, t.targetPosition, t.howMany - 1);
                            }
                            const r = e.deletionPosition._getCombined(t.sourcePosition, t.targetPosition);
                            const s = new x_(o, 1, r, 0);
                            const a = s.getMovedRangeStart().path.slice();
                            a.push(0);
                            const c = new Ok(s.targetPosition.root, a);
                            i = i._getTransformedByMove(o, r, 1);
                            const l = new x_(i, e.howMany, c, 0);
                            n.push(s);
                            n.push(l);
                            return n;
                        }
                    } else if (t.howMany == 1) {
                        if (!n.bWasUndone) return [
                            new R_(0)
                        ];
                        else {
                            t.sourcePosition = e.graveyardPosition.clone();
                            t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e);
                            return [
                                t
                            ];
                        }
                    }
                }
                const i = Hk._createFromPositionAndShift(t.sourcePosition, t.howMany);
                const r = i._getTransformedByMergeOperation(e);
                t.sourcePosition = r.start;
                t.howMany = r.end.offset - r.start.offset;
                t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e);
                return [
                    t
                ];
            });
            F_(O_, E_, (t, e)=>{
                t.position = t.position._getTransformedByInsertOperation(e);
                return [
                    t
                ];
            });
            F_(O_, S_, (t, e)=>{
                if (t.position.isEqual(e.deletionPosition)) {
                    t.position = e.graveyardPosition.clone();
                    t.position.stickiness = "toNext";
                    return [
                        t
                    ];
                }
                t.position = t.position._getTransformedByMergeOperation(e);
                return [
                    t
                ];
            });
            F_(O_, x_, (t, e)=>{
                t.position = t.position._getTransformedByMoveOperation(e);
                return [
                    t
                ];
            });
            F_(O_, O_, (t, e, n)=>{
                if (t.position.isEqual(e.position)) {
                    if (n.aIsStrong) t.oldName = e.newName;
                    else return [
                        new R_(0)
                    ];
                }
                return [
                    t
                ];
            });
            F_(O_, D_, (t, e)=>{
                const n = t.position.path;
                const o = e.splitPosition.getParentPath();
                if (xt(n, o) == "same" && !e.graveyardPosition) {
                    const e = new O_(t.position.getShiftedBy(1), t.oldName, t.newName, 0);
                    return [
                        t,
                        e
                    ];
                }
                t.position = t.position._getTransformedBySplitOperation(e);
                return [
                    t
                ];
            });
            F_(V_, V_, (t, e, n)=>{
                if (t.root === e.root && t.key === e.key) {
                    if (!n.aIsStrong || t.newValue === e.newValue) return [
                        new R_(0)
                    ];
                    else t.oldValue = e.newValue;
                }
                return [
                    t
                ];
            });
            F_(M_, M_, (t, e)=>{
                if (t.rootName === e.rootName && t.isAdd === e.isAdd) return [
                    new R_(0)
                ];
                return [
                    t
                ];
            });
            F_(D_, E_, (t, e)=>{
                if (t.splitPosition.hasSameParentAs(e.position) && t.splitPosition.offset < e.position.offset) t.howMany += e.howMany;
                t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e);
                t.insertionPosition = t.insertionPosition._getTransformedByInsertOperation(e);
                return [
                    t
                ];
            });
            F_(D_, S_, (t, e, n)=>{
                if (!t.graveyardPosition && !n.bWasUndone && t.splitPosition.hasSameParentAs(e.sourcePosition)) {
                    const n = e.graveyardPosition.path.slice();
                    n.push(0);
                    const o = new Ok(e.graveyardPosition.root, n);
                    const i = D_.getInsertionPosition(new Ok(e.graveyardPosition.root, n));
                    const r = new D_(o, 0, i, null, 0);
                    t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e);
                    t.insertionPosition = D_.getInsertionPosition(t.splitPosition);
                    t.graveyardPosition = r.insertionPosition.clone();
                    t.graveyardPosition.stickiness = "toNext";
                    return [
                        r,
                        t
                    ];
                }
                if (t.splitPosition.hasSameParentAs(e.deletionPosition) && !t.splitPosition.isAfter(e.deletionPosition)) t.howMany--;
                if (t.splitPosition.hasSameParentAs(e.targetPosition)) t.howMany += e.howMany;
                t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e);
                t.insertionPosition = D_.getInsertionPosition(t.splitPosition);
                if (t.graveyardPosition) t.graveyardPosition = t.graveyardPosition._getTransformedByMergeOperation(e);
                return [
                    t
                ];
            });
            F_(D_, x_, (t, e, n)=>{
                const o = Hk._createFromPositionAndShift(e.sourcePosition, e.howMany);
                if (t.graveyardPosition) {
                    const i = o.start.isEqual(t.graveyardPosition) || o.containsPosition(t.graveyardPosition);
                    if (!n.bWasUndone && i) {
                        const n = t.splitPosition._getTransformedByMoveOperation(e);
                        const o = t.graveyardPosition._getTransformedByMoveOperation(e);
                        const i = o.path.slice();
                        i.push(0);
                        const r = new Ok(o.root, i);
                        const s = new x_(n, t.howMany, r, 0);
                        return [
                            s
                        ];
                    }
                    t.graveyardPosition = t.graveyardPosition._getTransformedByMoveOperation(e);
                }
                const i = t.splitPosition.isEqual(e.targetPosition);
                if (i && (n.baRelation == "insertAtSource" || n.abRelation == "splitBefore")) {
                    t.howMany += e.howMany;
                    t.splitPosition = t.splitPosition._getTransformedByDeletion(e.sourcePosition, e.howMany);
                    t.insertionPosition = D_.getInsertionPosition(t.splitPosition);
                    return [
                        t
                    ];
                }
                if (i && n.abRelation && n.abRelation.howMany) {
                    const { howMany: e, offset: o } = n.abRelation;
                    t.howMany += e;
                    t.splitPosition = t.splitPosition.getShiftedBy(o);
                    return [
                        t
                    ];
                }
                if (t.splitPosition.hasSameParentAs(e.sourcePosition) && o.containsPosition(t.splitPosition)) {
                    const n = e.howMany - (t.splitPosition.offset - e.sourcePosition.offset);
                    t.howMany -= n;
                    if (t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset) t.howMany += e.howMany;
                    t.splitPosition = e.sourcePosition.clone();
                    t.insertionPosition = D_.getInsertionPosition(t.splitPosition);
                    return [
                        t
                    ];
                }
                if (!e.sourcePosition.isEqual(e.targetPosition)) {
                    if (t.splitPosition.hasSameParentAs(e.sourcePosition) && t.splitPosition.offset <= e.sourcePosition.offset) t.howMany -= e.howMany;
                    if (t.splitPosition.hasSameParentAs(e.targetPosition) && t.splitPosition.offset < e.targetPosition.offset) t.howMany += e.howMany;
                }
                t.splitPosition.stickiness = "toNone";
                t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e);
                t.splitPosition.stickiness = "toNext";
                if (t.graveyardPosition) t.insertionPosition = t.insertionPosition._getTransformedByMoveOperation(e);
                else t.insertionPosition = D_.getInsertionPosition(t.splitPosition);
                return [
                    t
                ];
            });
            F_(D_, D_, (t, e, n)=>{
                if (t.splitPosition.isEqual(e.splitPosition)) {
                    if (!t.graveyardPosition && !e.graveyardPosition) return [
                        new R_(0)
                    ];
                    if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) return [
                        new R_(0)
                    ];
                    if (n.abRelation == "splitBefore") {
                        t.howMany = 0;
                        t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e);
                        return [
                            t
                        ];
                    }
                }
                if (t.graveyardPosition && e.graveyardPosition && t.graveyardPosition.isEqual(e.graveyardPosition)) {
                    const o = t.splitPosition.root.rootName == "$graveyard";
                    const i = e.splitPosition.root.rootName == "$graveyard";
                    const r = o && !i;
                    const s = i && !o;
                    const a = s || !r && n.aIsStrong;
                    if (a) {
                        const n = [];
                        if (e.howMany) n.push(new x_(e.moveTargetPosition, e.howMany, e.splitPosition, 0));
                        if (t.howMany) n.push(new x_(t.splitPosition, t.howMany, t.moveTargetPosition, 0));
                        return n;
                    } else return [
                        new R_(0)
                    ];
                }
                if (t.graveyardPosition) t.graveyardPosition = t.graveyardPosition._getTransformedBySplitOperation(e);
                if (t.splitPosition.isEqual(e.insertionPosition) && n.abRelation == "splitBefore") {
                    t.howMany++;
                    return [
                        t
                    ];
                }
                if (e.splitPosition.isEqual(t.insertionPosition) && n.baRelation == "splitBefore") {
                    const n = e.insertionPosition.path.slice();
                    n.push(0);
                    const o = new Ok(e.insertionPosition.root, n);
                    const i = new x_(t.insertionPosition, 1, o, 0);
                    return [
                        t,
                        i
                    ];
                }
                if (t.splitPosition.hasSameParentAs(e.splitPosition) && t.splitPosition.offset < e.splitPosition.offset) t.howMany -= e.howMany;
                t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e);
                t.insertionPosition = D_.getInsertionPosition(t.splitPosition);
                return [
                    t
                ];
            });
            function J_(t, e) {
                return t.targetPosition._getTransformedByDeletion(e.sourcePosition, e.howMany) === null;
            }
            function Y_(t, e) {
                const n = [];
                for(let o = 0; o < t.length; o++){
                    const i = t[o];
                    const r = new x_(i.start, i.end.offset - i.start.offset, e, 0);
                    n.push(r);
                    for(let e = o + 1; e < t.length; e++)t[e] = t[e]._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany)[0];
                    e = e._getTransformedByMove(r.sourcePosition, r.targetPosition, r.howMany);
                }
                return n;
            }
            class Q_ extends G(Ok) {
                constructor(t, e, n = "toNone"){
                    super(t, e, n);
                    if (!this.root.is("rootElement")) throw new R("model-liveposition-root-not-rootelement", t);
                    X_.call(this);
                }
                detach() {
                    this.stopListening();
                }
                toPosition() {
                    return new Ok(this.root, this.path.slice(), this.stickiness);
                }
                static fromPosition(t, e) {
                    return new this(t.root, t.path.slice(), e ? e : t.stickiness);
                }
            }
            Q_.prototype.is = function(t) {
                return t === "livePosition" || t === "model:livePosition" || t == "position" || t === "model:position";
            };
            function X_() {
                this.listenTo(this.root.document.model, "applyOperation", (t, e)=>{
                    const n = e[0];
                    if (!n.isDocumentOperation) return;
                    tA.call(this, n);
                }, {
                    priority: "low"
                });
            }
            function tA(t) {
                const e = this.getTransformedByOperation(t);
                if (!this.isEqual(e)) {
                    const t = this.toPosition();
                    this.path = e.path;
                    this.root = e.root;
                    this.fire("change", t);
                }
            }
            class eA {
                constructor(t = {}){
                    if (typeof t === "string") {
                        t = t === "transparent" ? {
                            isUndoable: false
                        } : {};
                        O("batch-constructor-deprecated-string-type");
                    }
                    const { isUndoable: e = true, isLocal: n = true, isUndo: o = false, isTyping: i = false } = t;
                    this.operations = [];
                    this.isUndoable = e;
                    this.isLocal = n;
                    this.isUndo = o;
                    this.isTyping = i;
                }
                get type() {
                    O("batch-type-deprecated");
                    return "default";
                }
                get baseVersion() {
                    for (const t of this.operations){
                        if (t.baseVersion !== null) return t.baseVersion;
                    }
                    return null;
                }
                addOperation(t) {
                    t.batch = this;
                    this.operations.push(t);
                    return t;
                }
            }
            class nA {
                constructor(t){
                    this._changesInElement = new Map;
                    this._elementSnapshots = new Map;
                    this._changedMarkers = new Map;
                    this._changedRoots = new Map;
                    this._changeCount = 0;
                    this._cachedChanges = null;
                    this._cachedChangesWithGraveyard = null;
                    this._refreshedItems = new Set;
                    this._markerCollection = t;
                }
                get isEmpty() {
                    return this._changesInElement.size == 0 && this._changedMarkers.size == 0 && this._changedRoots.size == 0;
                }
                bufferOperation(t) {
                    const e = t;
                    switch(e.type){
                        case "insert":
                            if (this._isInInsertedElement(e.position.parent)) return;
                            this._markInsert(e.position.parent, e.position.offset, e.nodes.maxOffset);
                            break;
                        case "addAttribute":
                        case "removeAttribute":
                        case "changeAttribute":
                            for (const t of e.range.getItems({
                                shallow: true
                            })){
                                if (this._isInInsertedElement(t.parent)) continue;
                                this._markAttribute(t);
                            }
                            break;
                        case "remove":
                        case "move":
                        case "reinsert":
                            {
                                if (e.sourcePosition.isEqual(e.targetPosition) || e.sourcePosition.getShiftedBy(e.howMany).isEqual(e.targetPosition)) return;
                                const t = this._isInInsertedElement(e.sourcePosition.parent);
                                const n = this._isInInsertedElement(e.targetPosition.parent);
                                if (!t) this._markRemove(e.sourcePosition.parent, e.sourcePosition.offset, e.howMany);
                                if (!n) this._markInsert(e.targetPosition.parent, e.getMovedRangeStart().offset, e.howMany);
                                break;
                            }
                        case "rename":
                            {
                                if (this._isInInsertedElement(e.position.parent)) return;
                                this._markRemove(e.position.parent, e.position.offset, 1);
                                this._markInsert(e.position.parent, e.position.offset, 1);
                                const t = Hk._createFromPositionAndShift(e.position, 1);
                                for (const e of this._markerCollection.getMarkersIntersectingRange(t)){
                                    const t = e.getData();
                                    this.bufferMarkerChange(e.name, t, t);
                                }
                                break;
                            }
                        case "split":
                            {
                                const t = e.splitPosition.parent;
                                if (!this._isInInsertedElement(t)) this._markRemove(t, e.splitPosition.offset, e.howMany);
                                if (!this._isInInsertedElement(e.insertionPosition.parent)) this._markInsert(e.insertionPosition.parent, e.insertionPosition.offset, 1);
                                if (e.graveyardPosition) this._markRemove(e.graveyardPosition.parent, e.graveyardPosition.offset, 1);
                                break;
                            }
                        case "merge":
                            {
                                const t = e.sourcePosition.parent;
                                if (!this._isInInsertedElement(t.parent)) this._markRemove(t.parent, t.startOffset, 1);
                                const n = e.graveyardPosition.parent;
                                this._markInsert(n, e.graveyardPosition.offset, 1);
                                const o = e.targetPosition.parent;
                                if (!this._isInInsertedElement(o)) this._markInsert(o, e.targetPosition.offset, t.maxOffset);
                                break;
                            }
                        case "detachRoot":
                        case "addRoot":
                            {
                                const t = e.affectedSelectable;
                                if (!t._isLoaded) return;
                                if (t.isAttached() == e.isAdd) return;
                                this._bufferRootStateChange(e.rootName, e.isAdd);
                                break;
                            }
                        case "addRootAttribute":
                        case "removeRootAttribute":
                        case "changeRootAttribute":
                            {
                                if (!e.root._isLoaded) return;
                                const t = e.root.rootName;
                                this._bufferRootAttributeChange(t, e.key, e.oldValue, e.newValue);
                                break;
                            }
                    }
                    this._cachedChanges = null;
                }
                bufferMarkerChange(t, e, n) {
                    if (e.range && e.range.root.is("rootElement") && !e.range.root._isLoaded) e.range = null;
                    if (n.range && n.range.root.is("rootElement") && !n.range.root._isLoaded) n.range = null;
                    let o = this._changedMarkers.get(t);
                    if (!o) {
                        o = {
                            newMarkerData: n,
                            oldMarkerData: e
                        };
                        this._changedMarkers.set(t, o);
                    } else o.newMarkerData = n;
                    if (o.oldMarkerData.range == null && n.range == null) this._changedMarkers.delete(t);
                }
                getMarkersToRemove() {
                    const t = [];
                    for (const [e, n] of this._changedMarkers)if (n.oldMarkerData.range != null) t.push({
                        name: e,
                        range: n.oldMarkerData.range
                    });
                    return t;
                }
                getMarkersToAdd() {
                    const t = [];
                    for (const [e, n] of this._changedMarkers)if (n.newMarkerData.range != null) t.push({
                        name: e,
                        range: n.newMarkerData.range
                    });
                    return t;
                }
                getChangedMarkers() {
                    return Array.from(this._changedMarkers).map(([t, e])=>({
                            name: t,
                            data: {
                                oldRange: e.oldMarkerData.range,
                                newRange: e.newMarkerData.range
                            }
                        }));
                }
                hasDataChanges() {
                    if (this._changesInElement.size > 0) return true;
                    if (this._changedRoots.size > 0) return true;
                    for (const { newMarkerData: t, oldMarkerData: e } of this._changedMarkers.values()){
                        if (t.affectsData !== e.affectsData) return true;
                        if (t.affectsData) {
                            const n = t.range && !e.range;
                            const o = !t.range && e.range;
                            const i = t.range && e.range && !t.range.isEqual(e.range);
                            if (n || o || i) return true;
                        }
                    }
                    return false;
                }
                getChanges(t = {}) {
                    if (this._cachedChanges) {
                        if (t.includeChangesInGraveyard) return this._cachedChangesWithGraveyard.slice();
                        else return this._cachedChanges.slice();
                    }
                    let e = [];
                    for (const t of this._changesInElement.keys()){
                        const n = this._changesInElement.get(t).sort((t, e)=>{
                            if (t.offset === e.offset) {
                                if (t.type != e.type) return t.type == "remove" ? -1 : 1;
                                return 0;
                            }
                            return t.offset < e.offset ? -1 : 1;
                        });
                        const o = this._elementSnapshots.get(t);
                        const i = oA(t.getChildren());
                        const r = iA(o.length, n);
                        let s = 0;
                        let a = 0;
                        for (const n of r){
                            if (n === "i") {
                                e.push(this._getInsertDiff(t, s, i[s]));
                                s++;
                            } else if (n === "r") {
                                e.push(this._getRemoveDiff(t, s, o[a]));
                                a++;
                            } else if (n === "a") {
                                const n = i[s].attributes;
                                const r = o[a].attributes;
                                let c;
                                if (i[s].name == "$text") c = new Hk(Ok._createAt(t, s), Ok._createAt(t, s + 1));
                                else {
                                    const e = t.offsetToIndex(s);
                                    c = new Hk(Ok._createAt(t, s), Ok._createAt(t.getChild(e), 0));
                                }
                                e.push(...this._getAttributesDiff(c, r, n));
                                s++;
                                a++;
                            } else {
                                s++;
                                a++;
                            }
                        }
                    }
                    e.sort((t, e)=>{
                        if (t.position.root != e.position.root) return t.position.root.rootName < e.position.root.rootName ? -1 : 1;
                        if (t.position.isEqual(e.position)) return t.changeCount - e.changeCount;
                        return t.position.isBefore(e.position) ? -1 : 1;
                    });
                    for(let t = 1, n = 0; t < e.length; t++){
                        const o = e[n];
                        const i = e[t];
                        const r = o.type == "remove" && i.type == "remove" && o.name == "$text" && i.name == "$text" && o.position.isEqual(i.position);
                        const s = o.type == "insert" && i.type == "insert" && o.name == "$text" && i.name == "$text" && o.position.parent == i.position.parent && o.position.offset + o.length == i.position.offset;
                        const a = o.type == "attribute" && i.type == "attribute" && o.position.parent == i.position.parent && o.range.isFlat && i.range.isFlat && o.position.offset + o.length == i.position.offset && o.attributeKey == i.attributeKey && o.attributeOldValue == i.attributeOldValue && o.attributeNewValue == i.attributeNewValue;
                        if (r || s || a) {
                            o.length++;
                            if (a) o.range.end = o.range.end.getShiftedBy(1);
                            e[t] = null;
                        } else n = t;
                    }
                    e = e.filter((t)=>t);
                    for (const t of e){
                        delete t.changeCount;
                        if (t.type == "attribute") {
                            delete t.position;
                            delete t.length;
                        }
                    }
                    this._changeCount = 0;
                    this._cachedChangesWithGraveyard = e;
                    this._cachedChanges = e.filter(rA);
                    if (t.includeChangesInGraveyard) return this._cachedChangesWithGraveyard.slice();
                    else return this._cachedChanges.slice();
                }
                getChangedRoots() {
                    return Array.from(this._changedRoots.values()).map((t)=>{
                        const e = {
                            ...t
                        };
                        if (e.state !== undefined) delete e.attributes;
                        return e;
                    });
                }
                getRefreshedItems() {
                    return new Set(this._refreshedItems);
                }
                reset() {
                    this._changesInElement.clear();
                    this._elementSnapshots.clear();
                    this._changedMarkers.clear();
                    this._changedRoots.clear();
                    this._refreshedItems = new Set;
                    this._cachedChanges = null;
                }
                _bufferRootStateChange(t, e) {
                    if (!this._changedRoots.has(t)) {
                        this._changedRoots.set(t, {
                            name: t,
                            state: e ? "attached" : "detached"
                        });
                        return;
                    }
                    const n = this._changedRoots.get(t);
                    if (n.state !== undefined) {
                        delete n.state;
                        if (n.attributes === undefined) this._changedRoots.delete(t);
                    } else n.state = e ? "attached" : "detached";
                }
                _bufferRootAttributeChange(t, e, n, o) {
                    const i = this._changedRoots.get(t) || {
                        name: t
                    };
                    const r = i.attributes || {};
                    if (r[e]) {
                        const t = r[e];
                        if (o === t.oldValue) delete r[e];
                        else t.newValue = o;
                    } else r[e] = {
                        oldValue: n,
                        newValue: o
                    };
                    if (Object.entries(r).length === 0) {
                        delete i.attributes;
                        if (i.state === undefined) this._changedRoots.delete(t);
                    } else {
                        i.attributes = r;
                        this._changedRoots.set(t, i);
                    }
                }
                _refreshItem(t) {
                    if (this._isInInsertedElement(t.parent)) return;
                    this._markRemove(t.parent, t.startOffset, t.offsetSize);
                    this._markInsert(t.parent, t.startOffset, t.offsetSize);
                    this._refreshedItems.add(t);
                    const e = Hk._createOn(t);
                    for (const t of this._markerCollection.getMarkersIntersectingRange(e)){
                        const e = t.getData();
                        this.bufferMarkerChange(t.name, e, e);
                    }
                    this._cachedChanges = null;
                }
                _bufferRootLoad(t) {
                    if (!t.isAttached()) return;
                    this._bufferRootStateChange(t.rootName, true);
                    this._markInsert(t, 0, t.maxOffset);
                    for (const e of t.getAttributeKeys())this._bufferRootAttributeChange(t.rootName, e, null, t.getAttribute(e));
                    for (const e of this._markerCollection)if (e.getRange().root == t) {
                        const t = e.getData();
                        this.bufferMarkerChange(e.name, {
                            ...t,
                            range: null
                        }, t);
                    }
                }
                _markInsert(t, e, n) {
                    if (t.root.is("rootElement") && !t.root._isLoaded) return;
                    const o = {
                        type: "insert",
                        offset: e,
                        howMany: n,
                        count: this._changeCount++
                    };
                    this._markChange(t, o);
                }
                _markRemove(t, e, n) {
                    if (t.root.is("rootElement") && !t.root._isLoaded) return;
                    const o = {
                        type: "remove",
                        offset: e,
                        howMany: n,
                        count: this._changeCount++
                    };
                    this._markChange(t, o);
                    this._removeAllNestedChanges(t, e, n);
                }
                _markAttribute(t) {
                    if (t.root.is("rootElement") && !t.root._isLoaded) return;
                    const e = {
                        type: "attribute",
                        offset: t.startOffset,
                        howMany: t.offsetSize,
                        count: this._changeCount++
                    };
                    this._markChange(t.parent, e);
                }
                _markChange(t, e) {
                    this._makeSnapshot(t);
                    const n = this._getChangesForElement(t);
                    this._handleChange(e, n);
                    n.push(e);
                    for(let t = 0; t < n.length; t++)if (n[t].howMany < 1) {
                        n.splice(t, 1);
                        t--;
                    }
                }
                _getChangesForElement(t) {
                    let e;
                    if (this._changesInElement.has(t)) e = this._changesInElement.get(t);
                    else {
                        e = [];
                        this._changesInElement.set(t, e);
                    }
                    return e;
                }
                _makeSnapshot(t) {
                    if (!this._elementSnapshots.has(t)) this._elementSnapshots.set(t, oA(t.getChildren()));
                }
                _handleChange(t, e) {
                    t.nodesToHandle = t.howMany;
                    for (const n of e){
                        const o = t.offset + t.howMany;
                        const i = n.offset + n.howMany;
                        if (t.type == "insert") {
                            if (n.type == "insert") {
                                if (t.offset <= n.offset) n.offset += t.howMany;
                                else if (t.offset < i) {
                                    n.howMany += t.nodesToHandle;
                                    t.nodesToHandle = 0;
                                }
                            }
                            if (n.type == "remove") {
                                if (t.offset < n.offset) n.offset += t.howMany;
                            }
                            if (n.type == "attribute") {
                                if (t.offset <= n.offset) n.offset += t.howMany;
                                else if (t.offset < i) {
                                    const i = n.howMany;
                                    n.howMany = t.offset - n.offset;
                                    e.unshift({
                                        type: "attribute",
                                        offset: o,
                                        howMany: i - n.howMany,
                                        count: this._changeCount++
                                    });
                                }
                            }
                        }
                        if (t.type == "remove") {
                            if (n.type == "insert") {
                                if (o <= n.offset) n.offset -= t.howMany;
                                else if (o <= i) {
                                    if (t.offset < n.offset) {
                                        const e = o - n.offset;
                                        n.offset = t.offset;
                                        n.howMany -= e;
                                        t.nodesToHandle -= e;
                                    } else {
                                        n.howMany -= t.nodesToHandle;
                                        t.nodesToHandle = 0;
                                    }
                                } else {
                                    if (t.offset <= n.offset) {
                                        t.nodesToHandle -= n.howMany;
                                        n.howMany = 0;
                                    } else if (t.offset < i) {
                                        const e = i - t.offset;
                                        n.howMany -= e;
                                        t.nodesToHandle -= e;
                                    }
                                }
                            }
                            if (n.type == "remove") {
                                if (o <= n.offset) n.offset -= t.howMany;
                                else if (t.offset < n.offset) {
                                    t.nodesToHandle += n.howMany;
                                    n.howMany = 0;
                                }
                            }
                            if (n.type == "attribute") {
                                if (o <= n.offset) n.offset -= t.howMany;
                                else if (t.offset < n.offset) {
                                    const e = o - n.offset;
                                    n.offset = t.offset;
                                    n.howMany -= e;
                                } else if (t.offset < i) {
                                    if (o <= i) {
                                        const o = n.howMany;
                                        n.howMany = t.offset - n.offset;
                                        const i = o - n.howMany - t.nodesToHandle;
                                        e.unshift({
                                            type: "attribute",
                                            offset: t.offset,
                                            howMany: i,
                                            count: this._changeCount++
                                        });
                                    } else n.howMany -= i - t.offset;
                                }
                            }
                        }
                        if (t.type == "attribute") {
                            if (n.type == "insert") {
                                if (t.offset < n.offset && o > n.offset) {
                                    if (o > i) {
                                        const t = {
                                            type: "attribute",
                                            offset: i,
                                            howMany: o - i,
                                            count: this._changeCount++
                                        };
                                        this._handleChange(t, e);
                                        e.push(t);
                                    }
                                    t.nodesToHandle = n.offset - t.offset;
                                    t.howMany = t.nodesToHandle;
                                } else if (t.offset >= n.offset && t.offset < i) {
                                    if (o > i) {
                                        t.nodesToHandle = o - i;
                                        t.offset = i;
                                    } else t.nodesToHandle = 0;
                                }
                            }
                            if (n.type == "remove") {
                                if (t.offset < n.offset && o > n.offset) {
                                    const i = {
                                        type: "attribute",
                                        offset: n.offset,
                                        howMany: o - n.offset,
                                        count: this._changeCount++
                                    };
                                    this._handleChange(i, e);
                                    e.push(i);
                                    t.nodesToHandle = n.offset - t.offset;
                                    t.howMany = t.nodesToHandle;
                                }
                            }
                            if (n.type == "attribute") {
                                if (t.offset >= n.offset && o <= i) {
                                    t.nodesToHandle = 0;
                                    t.howMany = 0;
                                    t.offset = 0;
                                } else if (t.offset <= n.offset && o >= i) n.howMany = 0;
                            }
                        }
                    }
                    t.howMany = t.nodesToHandle;
                    delete t.nodesToHandle;
                }
                _getInsertDiff(t, e, n) {
                    return {
                        type: "insert",
                        position: Ok._createAt(t, e),
                        name: n.name,
                        attributes: new Map(n.attributes),
                        length: 1,
                        changeCount: this._changeCount++
                    };
                }
                _getRemoveDiff(t, e, n) {
                    return {
                        type: "remove",
                        position: Ok._createAt(t, e),
                        name: n.name,
                        attributes: new Map(n.attributes),
                        length: 1,
                        changeCount: this._changeCount++
                    };
                }
                _getAttributesDiff(t, e, n) {
                    const o = [];
                    n = new Map(n);
                    for (const [i, r] of e){
                        const e = n.has(i) ? n.get(i) : null;
                        if (e !== r) o.push({
                            type: "attribute",
                            position: t.start,
                            range: t.clone(),
                            length: 1,
                            attributeKey: i,
                            attributeOldValue: r,
                            attributeNewValue: e,
                            changeCount: this._changeCount++
                        });
                        n.delete(i);
                    }
                    for (const [e, i] of n)o.push({
                        type: "attribute",
                        position: t.start,
                        range: t.clone(),
                        length: 1,
                        attributeKey: e,
                        attributeOldValue: null,
                        attributeNewValue: i,
                        changeCount: this._changeCount++
                    });
                    return o;
                }
                _isInInsertedElement(t) {
                    const e = t.parent;
                    if (!e) return false;
                    const n = this._changesInElement.get(e);
                    const o = t.startOffset;
                    if (n) for (const t of n){
                        if (t.type == "insert" && o >= t.offset && o < t.offset + t.howMany) return true;
                    }
                    return this._isInInsertedElement(e);
                }
                _removeAllNestedChanges(t, e, n) {
                    const o = new Hk(Ok._createAt(t, e), Ok._createAt(t, e + n));
                    for (const t of o.getItems({
                        shallow: true
                    }))if (t.is("element")) {
                        this._elementSnapshots.delete(t);
                        this._changesInElement.delete(t);
                        this._removeAllNestedChanges(t, 0, t.maxOffset);
                    }
                }
            }
            function oA(t) {
                const e = [];
                for (const n of t){
                    if (n.is("$text")) for(let t = 0; t < n.data.length; t++)e.push({
                        name: "$text",
                        attributes: new Map(n.getAttributes())
                    });
                    else e.push({
                        name: n.name,
                        attributes: new Map(n.getAttributes())
                    });
                }
                return e;
            }
            function iA(t, e) {
                const n = [];
                let o = 0;
                let i = 0;
                for (const t of e){
                    if (t.offset > o) {
                        for(let e = 0; e < t.offset - o; e++)n.push("e");
                        i += t.offset - o;
                    }
                    if (t.type == "insert") {
                        for(let e = 0; e < t.howMany; e++)n.push("i");
                        o = t.offset + t.howMany;
                    } else if (t.type == "remove") {
                        for(let e = 0; e < t.howMany; e++)n.push("r");
                        o = t.offset;
                        i += t.howMany;
                    } else {
                        n.push(..."a".repeat(t.howMany).split(""));
                        o = t.offset + t.howMany;
                        i += t.howMany;
                    }
                }
                if (i < t) for(let e = 0; e < t - i - o; e++)n.push("e");
                return n;
            }
            function rA(t) {
                const e = "position" in t && t.position.root.rootName == "$graveyard";
                const n = "range" in t && t.range.root.rootName == "$graveyard";
                return !e && !n;
            }
            class sA {
                constructor(){
                    this._operations = [];
                    this._undoPairs = new Map;
                    this._undoneOperations = new Set;
                    this._baseVersionToOperationIndex = new Map;
                    this._version = 0;
                    this._gaps = new Map;
                }
                get version() {
                    return this._version;
                }
                set version(t) {
                    if (this._operations.length && t > this._version + 1) this._gaps.set(this._version, t);
                    this._version = t;
                }
                get lastOperation() {
                    return this._operations[this._operations.length - 1];
                }
                addOperation(t) {
                    if (t.baseVersion !== this.version) throw new R("model-document-history-addoperation-incorrect-version", this, {
                        operation: t,
                        historyVersion: this.version
                    });
                    this._operations.push(t);
                    this._version++;
                    this._baseVersionToOperationIndex.set(t.baseVersion, this._operations.length - 1);
                }
                getOperations(t, e = this.version) {
                    if (!this._operations.length) return [];
                    const n = this._operations[0];
                    if (t === undefined) t = n.baseVersion;
                    let o = e - 1;
                    for (const [e, n] of this._gaps){
                        if (t > e && t < n) t = n;
                        if (o > e && o < n) o = e - 1;
                    }
                    if (o < n.baseVersion || t > this.lastOperation.baseVersion) return [];
                    let i = this._baseVersionToOperationIndex.get(t);
                    if (i === undefined) i = 0;
                    let r = this._baseVersionToOperationIndex.get(o);
                    if (r === undefined) r = this._operations.length - 1;
                    return this._operations.slice(i, r + 1);
                }
                getOperation(t) {
                    const e = this._baseVersionToOperationIndex.get(t);
                    if (e === undefined) return;
                    return this._operations[e];
                }
                setOperationAsUndone(t, e) {
                    this._undoPairs.set(e, t);
                    this._undoneOperations.add(t);
                }
                isUndoingOperation(t) {
                    return this._undoPairs.has(t);
                }
                isUndoneOperation(t) {
                    return this._undoneOperations.has(t);
                }
                getUndoneOperation(t) {
                    return this._undoPairs.get(t);
                }
                reset() {
                    this._version = 0;
                    this._undoPairs = new Map;
                    this._operations = [];
                    this._undoneOperations = new Set;
                    this._gaps = new Map;
                    this._baseVersionToOperationIndex = new Map;
                }
            }
            class aA extends Bk {
                constructor(t, e, n = "main"){
                    super(e);
                    this._isAttached = true;
                    this._isLoaded = true;
                    this._document = t;
                    this.rootName = n;
                }
                get document() {
                    return this._document;
                }
                isAttached() {
                    return this._isAttached;
                }
                toJSON() {
                    return this.rootName;
                }
            }
            aA.prototype.is = function(t, e) {
                if (!e) return t === "rootElement" || t === "model:rootElement" || t === "element" || t === "model:element" || t === "node" || t === "model:node";
                return e === this.name && (t === "rootElement" || t === "model:rootElement" || t === "element" || t === "model:element");
            };
            const cA = "$graveyard";
            class lA extends G() {
                constructor(t){
                    super();
                    this.model = t;
                    this.history = new sA;
                    this.selection = new cb(this);
                    this.roots = new hl({
                        idProperty: "rootName"
                    });
                    this.differ = new nA(t.markers);
                    this.isReadOnly = false;
                    this._postFixers = new Set;
                    this._hasSelectionChangedFromTheLastChangeBlock = false;
                    this.createRoot("$root", cA);
                    this.listenTo(t, "applyOperation", (t, e)=>{
                        const n = e[0];
                        if (n.isDocumentOperation) this.differ.bufferOperation(n);
                    }, {
                        priority: "high"
                    });
                    this.listenTo(t, "applyOperation", (t, e)=>{
                        const n = e[0];
                        if (n.isDocumentOperation) this.history.addOperation(n);
                    }, {
                        priority: "low"
                    });
                    this.listenTo(this.selection, "change", ()=>{
                        this._hasSelectionChangedFromTheLastChangeBlock = true;
                    });
                    this.listenTo(t.markers, "update", (t, e, n, o, i)=>{
                        const r = {
                            ...e.getData(),
                            range: o
                        };
                        this.differ.bufferMarkerChange(e.name, i, r);
                        if (n === null) e.on("change", (t, n)=>{
                            const o = e.getData();
                            this.differ.bufferMarkerChange(e.name, {
                                ...o,
                                range: n
                            }, o);
                        });
                    });
                    this.registerPostFixer((t)=>{
                        let e = false;
                        for (const n of this.roots)if (!n.isAttached() && !n.isEmpty) {
                            t.remove(t.createRangeIn(n));
                            e = true;
                        }
                        for (const n of this.model.markers)if (!n.getRange().root.isAttached()) {
                            t.removeMarker(n);
                            e = true;
                        }
                        return e;
                    });
                }
                get version() {
                    return this.history.version;
                }
                set version(t) {
                    this.history.version = t;
                }
                get graveyard() {
                    return this.getRoot(cA);
                }
                createRoot(t = "$root", e = "main") {
                    if (this.roots.get(e)) throw new R("model-document-createroot-name-exists", this, {
                        name: e
                    });
                    const n = new aA(this, t, e);
                    this.roots.add(n);
                    return n;
                }
                destroy() {
                    this.selection.destroy();
                    this.stopListening();
                }
                getRoot(t = "main") {
                    return this.roots.get(t);
                }
                getRootNames(t = false) {
                    return this.getRoots(t).map((t)=>t.rootName);
                }
                getRoots(t = false) {
                    return Array.from(this.roots).filter((e)=>e != this.graveyard && (t || e.isAttached()) && e._isLoaded);
                }
                registerPostFixer(t) {
                    this._postFixers.add(t);
                }
                toJSON() {
                    const t = oh(this);
                    t.selection = "[engine.model.DocumentSelection]";
                    t.model = "[engine.model.Model]";
                    return t;
                }
                _handleChangeBlock(t) {
                    if (this._hasDocumentChangedFromTheLastChangeBlock()) {
                        this._callPostFixers(t);
                        this.selection.refresh();
                        if (this.differ.hasDataChanges()) this.fire("change:data", t.batch);
                        else this.fire("change", t.batch);
                        this.selection.refresh();
                        this.differ.reset();
                    }
                    this._hasSelectionChangedFromTheLastChangeBlock = false;
                }
                _hasDocumentChangedFromTheLastChangeBlock() {
                    return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
                }
                _getDefaultRoot() {
                    const t = this.getRoots();
                    return t.length ? t[0] : this.graveyard;
                }
                _getDefaultRange() {
                    const t = this._getDefaultRoot();
                    const e = this.model;
                    const n = e.schema;
                    const o = e.createPositionFromPath(t, [
                        0
                    ]);
                    const i = n.getNearestSelectionRange(o);
                    return i || e.createRange(o);
                }
                _validateSelectionRange(t) {
                    return dA(t.start) && dA(t.end);
                }
                _callPostFixers(t) {
                    let e = false;
                    do for (const n of this._postFixers){
                        this.selection.refresh();
                        e = n(t);
                        if (e) break;
                    }
                    while (e);
                }
            }
            function dA(t) {
                const e = t.textNode;
                if (e) {
                    const n = e.data;
                    const o = t.offset - e.startOffset;
                    return !xl(n, o) && !El(n, o);
                }
                return true;
            }
            class uA extends G() {
                constructor(){
                    super(...arguments);
                    this._markers = new Map;
                }
                [Symbol.iterator]() {
                    return this._markers.values();
                }
                has(t) {
                    const e = t instanceof hA ? t.name : t;
                    return this._markers.has(e);
                }
                get(t) {
                    return this._markers.get(t) || null;
                }
                _set(t, e, n = false, o = false) {
                    const i = t instanceof hA ? t.name : t;
                    if (i.includes(",")) throw new R("markercollection-incorrect-marker-name", this);
                    const r = this._markers.get(i);
                    if (r) {
                        const t = r.getData();
                        const s = r.getRange();
                        let a = false;
                        if (!s.isEqual(e)) {
                            r._attachLiveRange(ob.fromRange(e));
                            a = true;
                        }
                        if (n != r.managedUsingOperations) {
                            r._managedUsingOperations = n;
                            a = true;
                        }
                        if (typeof o === "boolean" && o != r.affectsData) {
                            r._affectsData = o;
                            a = true;
                        }
                        if (a) this.fire(`update:${i}`, r, s, e, t);
                        return r;
                    }
                    const s = ob.fromRange(e);
                    const a = new hA(i, s, n, o);
                    this._markers.set(i, a);
                    this.fire(`update:${i}`, a, null, e, {
                        ...a.getData(),
                        range: null
                    });
                    return a;
                }
                _remove(t) {
                    const e = t instanceof hA ? t.name : t;
                    const n = this._markers.get(e);
                    if (n) {
                        this._markers.delete(e);
                        this.fire(`update:${e}`, n, n.getRange(), null, n.getData());
                        this._destroyMarker(n);
                        return true;
                    }
                    return false;
                }
                _refresh(t) {
                    const e = t instanceof hA ? t.name : t;
                    const n = this._markers.get(e);
                    if (!n) throw new R("markercollection-refresh-marker-not-exists", this);
                    const o = n.getRange();
                    this.fire(`update:${e}`, n, o, o, n.getData());
                }
                *getMarkersAtPosition(t) {
                    for (const e of this)if (e.getRange().containsPosition(t)) yield e;
                }
                *getMarkersIntersectingRange(t) {
                    for (const e of this)if (e.getRange().getIntersection(t) !== null) yield e;
                }
                destroy() {
                    for (const t of this._markers.values())this._destroyMarker(t);
                    this._markers = null;
                    this.stopListening();
                }
                *getMarkersGroup(t) {
                    for (const e of this._markers.values())if (e.name.startsWith(t + ":")) yield e;
                }
                _destroyMarker(t) {
                    t.stopListening();
                    t._detachLiveRange();
                }
            }
            class hA extends G(xk) {
                constructor(t, e, n, o){
                    super();
                    this.name = t;
                    this._liveRange = this._attachLiveRange(e);
                    this._managedUsingOperations = n;
                    this._affectsData = o;
                }
                get managedUsingOperations() {
                    if (!this._liveRange) throw new R("marker-destroyed", this);
                    return this._managedUsingOperations;
                }
                get affectsData() {
                    if (!this._liveRange) throw new R("marker-destroyed", this);
                    return this._affectsData;
                }
                getData() {
                    return {
                        range: this.getRange(),
                        affectsData: this.affectsData,
                        managedUsingOperations: this.managedUsingOperations
                    };
                }
                getStart() {
                    if (!this._liveRange) throw new R("marker-destroyed", this);
                    return this._liveRange.start.clone();
                }
                getEnd() {
                    if (!this._liveRange) throw new R("marker-destroyed", this);
                    return this._liveRange.end.clone();
                }
                getRange() {
                    if (!this._liveRange) throw new R("marker-destroyed", this);
                    return this._liveRange.toRange();
                }
                _attachLiveRange(t) {
                    if (this._liveRange) this._detachLiveRange();
                    t.delegate("change:range").to(this);
                    t.delegate("change:content").to(this);
                    this._liveRange = t;
                    return t;
                }
                _detachLiveRange() {
                    this._liveRange.stopDelegating("change:range", this);
                    this._liveRange.stopDelegating("change:content", this);
                    this._liveRange.detach();
                    this._liveRange = null;
                }
            }
            hA.prototype.is = function(t) {
                return t === "marker" || t === "model:marker";
            };
            class fA extends m_ {
                constructor(t, e){
                    super(null);
                    this.sourcePosition = t.clone();
                    this.howMany = e;
                }
                get type() {
                    return "detach";
                }
                get affectedSelectable() {
                    return null;
                }
                toJSON() {
                    const t = super.toJSON();
                    t.sourcePosition = this.sourcePosition.toJSON();
                    return t;
                }
                _validate() {
                    if (this.sourcePosition.root.document) throw new R("detach-operation-on-document-node", this);
                }
                _execute() {
                    b_(Hk._createFromPositionAndShift(this.sourcePosition, this.howMany));
                }
                static get className() {
                    return "DetachOperation";
                }
            }
            class pA extends xk {
                constructor(t){
                    super();
                    this.markers = new Map;
                    this._children = new Dk;
                    if (t) this._insertChild(0, t);
                }
                [Symbol.iterator]() {
                    return this.getChildren();
                }
                get childCount() {
                    return this._children.length;
                }
                get maxOffset() {
                    return this._children.maxOffset;
                }
                get isEmpty() {
                    return this.childCount === 0;
                }
                get nextSibling() {
                    return null;
                }
                get previousSibling() {
                    return null;
                }
                get root() {
                    return this;
                }
                get parent() {
                    return null;
                }
                get document() {
                    return null;
                }
                isAttached() {
                    return false;
                }
                getAncestors() {
                    return [];
                }
                getChild(t) {
                    return this._children.getNode(t);
                }
                getChildren() {
                    return this._children[Symbol.iterator]();
                }
                getChildIndex(t) {
                    return this._children.getNodeIndex(t);
                }
                getChildStartOffset(t) {
                    return this._children.getNodeStartOffset(t);
                }
                getPath() {
                    return [];
                }
                getNodeByPath(t) {
                    let e = this;
                    for (const n of t)e = e.getChild(e.offsetToIndex(n));
                    return e;
                }
                offsetToIndex(t) {
                    return this._children.offsetToIndex(t);
                }
                toJSON() {
                    const t = [];
                    for (const e of this._children)t.push(e.toJSON());
                    return t;
                }
                static fromJSON(t) {
                    const e = [];
                    for (const n of t)if (n.name) e.push(Bk.fromJSON(n));
                    else e.push(Sk.fromJSON(n));
                    return new pA(e);
                }
                _appendChild(t) {
                    this._insertChild(this.childCount, t);
                }
                _insertChild(t, e) {
                    const n = gA(e);
                    for (const t of n){
                        if (t.parent !== null) t._remove();
                        t.parent = this;
                    }
                    this._children._insertNodes(t, n);
                }
                _removeChildren(t, e = 1) {
                    const n = this._children._removeNodes(t, e);
                    for (const t of n)t.parent = null;
                    return n;
                }
            }
            pA.prototype.is = function(t) {
                return t === "documentFragment" || t === "model:documentFragment";
            };
            function gA(t) {
                if (typeof t == "string") return [
                    new Sk(t)
                ];
                if (!Et(t)) t = [
                    t
                ];
                return Array.from(t).map((t)=>{
                    if (typeof t == "string") return new Sk(t);
                    if (t instanceof Tk) return new Sk(t.data, t.getAttributes());
                    return t;
                });
            }
            class mA {
                constructor(t, e){
                    this.model = t;
                    this.batch = e;
                }
                createText(t, e) {
                    return new Sk(t, e);
                }
                createElement(t, e) {
                    return new Bk(t, e);
                }
                createDocumentFragment() {
                    return new pA;
                }
                cloneElement(t, e = true) {
                    return t._clone(e);
                }
                insert(t, e, n = 0) {
                    this._assertWriterUsedCorrectly();
                    if (t instanceof Sk && t.data == "") return;
                    const o = Ok._createAt(e, n);
                    if (t.parent) {
                        if (AA(t.root, o.root)) {
                            this.move(Hk._createOn(t), o);
                            return;
                        } else {
                            if (t.root.document) throw new R("model-writer-insert-forbidden-move", this);
                            else this.remove(t);
                        }
                    }
                    const i = o.root.document ? o.root.document.version : null;
                    const r = new E_(o, t, i);
                    if (t instanceof Sk) r.shouldReceiveAttributes = true;
                    this.batch.addOperation(r);
                    this.model.applyOperation(r);
                    if (t instanceof pA) for (const [e, n] of t.markers){
                        const t = Ok._createAt(n.root, 0);
                        const i = new Hk(n.start._getCombined(t, o), n.end._getCombined(t, o));
                        const r = {
                            range: i,
                            usingOperation: true,
                            affectsData: true
                        };
                        if (this.model.markers.has(e)) this.updateMarker(e, r);
                        else this.addMarker(e, r);
                    }
                }
                insertText(t, e, n, o) {
                    if (e instanceof pA || e instanceof Bk || e instanceof Ok) this.insert(this.createText(t), e, n);
                    else this.insert(this.createText(t, e), n, o);
                }
                insertElement(t, e, n, o) {
                    if (e instanceof pA || e instanceof Bk || e instanceof Ok) this.insert(this.createElement(t), e, n);
                    else this.insert(this.createElement(t, e), n, o);
                }
                append(t, e) {
                    this.insert(t, e, "end");
                }
                appendText(t, e, n) {
                    if (e instanceof pA || e instanceof Bk) this.insert(this.createText(t), e, "end");
                    else this.insert(this.createText(t, e), n, "end");
                }
                appendElement(t, e, n) {
                    if (e instanceof pA || e instanceof Bk) this.insert(this.createElement(t), e, "end");
                    else this.insert(this.createElement(t, e), n, "end");
                }
                setAttribute(t, e, n) {
                    this._assertWriterUsedCorrectly();
                    if (n instanceof Hk) {
                        const o = n.getMinimalFlatRanges();
                        for (const n of o)kA(this, t, e, n);
                    } else bA(this, t, e, n);
                }
                setAttributes(t, e) {
                    for (const [n, o] of kl(t))this.setAttribute(n, o, e);
                }
                removeAttribute(t, e) {
                    this._assertWriterUsedCorrectly();
                    if (e instanceof Hk) {
                        const n = e.getMinimalFlatRanges();
                        for (const e of n)kA(this, t, null, e);
                    } else bA(this, t, null, e);
                }
                clearAttributes(t) {
                    this._assertWriterUsedCorrectly();
                    const e = (t)=>{
                        for (const e of t.getAttributeKeys())this.removeAttribute(e, t);
                    };
                    if (!(t instanceof Hk)) e(t);
                    else for (const n of t.getItems())e(n);
                }
                move(t, e, n) {
                    this._assertWriterUsedCorrectly();
                    if (!(t instanceof Hk)) throw new R("writer-move-invalid-range", this);
                    if (!t.isFlat) throw new R("writer-move-range-not-flat", this);
                    const o = Ok._createAt(e, n);
                    if (o.isEqual(t.start)) return;
                    this._addOperationForAffectedMarkers("move", t);
                    if (!AA(t.root, o.root)) throw new R("writer-move-different-document", this);
                    const i = t.root.document ? t.root.document.version : null;
                    const r = new x_(t.start, t.end.offset - t.start.offset, o, i);
                    this.batch.addOperation(r);
                    this.model.applyOperation(r);
                }
                remove(t) {
                    this._assertWriterUsedCorrectly();
                    const e = t instanceof Hk ? t : Hk._createOn(t);
                    const n = e.getMinimalFlatRanges().reverse();
                    for (const t of n){
                        this._addOperationForAffectedMarkers("move", t);
                        _A(t.start, t.end.offset - t.start.offset, this.batch, this.model);
                    }
                }
                merge(t) {
                    this._assertWriterUsedCorrectly();
                    const e = t.nodeBefore;
                    const n = t.nodeAfter;
                    this._addOperationForAffectedMarkers("merge", t);
                    if (!(e instanceof Bk)) throw new R("writer-merge-no-element-before", this);
                    if (!(n instanceof Bk)) throw new R("writer-merge-no-element-after", this);
                    if (!t.root.document) this._mergeDetached(t);
                    else this._merge(t);
                }
                createPositionFromPath(t, e, n) {
                    return this.model.createPositionFromPath(t, e, n);
                }
                createPositionAt(t, e) {
                    return this.model.createPositionAt(t, e);
                }
                createPositionAfter(t) {
                    return this.model.createPositionAfter(t);
                }
                createPositionBefore(t) {
                    return this.model.createPositionBefore(t);
                }
                createRange(t, e) {
                    return this.model.createRange(t, e);
                }
                createRangeIn(t) {
                    return this.model.createRangeIn(t);
                }
                createRangeOn(t) {
                    return this.model.createRangeOn(t);
                }
                createSelection(...t) {
                    return this.model.createSelection(...t);
                }
                _mergeDetached(t) {
                    const e = t.nodeBefore;
                    const n = t.nodeAfter;
                    this.move(Hk._createIn(n), Ok._createAt(e, "end"));
                    this.remove(n);
                }
                _merge(t) {
                    const e = Ok._createAt(t.nodeBefore, "end");
                    const n = Ok._createAt(t.nodeAfter, 0);
                    const o = t.root.document.graveyard;
                    const i = new Ok(o, [
                        0
                    ]);
                    const r = t.root.document.version;
                    const s = new S_(n, t.nodeAfter.maxOffset, e, i, r);
                    this.batch.addOperation(s);
                    this.model.applyOperation(s);
                }
                rename(t, e) {
                    this._assertWriterUsedCorrectly();
                    if (!(t instanceof Bk)) throw new R("writer-rename-not-element-instance", this);
                    const n = t.root.document ? t.root.document.version : null;
                    const o = new O_(Ok._createBefore(t), t.name, e, n);
                    this.batch.addOperation(o);
                    this.model.applyOperation(o);
                }
                split(t, e) {
                    this._assertWriterUsedCorrectly();
                    let n = t.parent;
                    if (!n.parent) throw new R("writer-split-element-no-parent", this);
                    if (!e) e = n.parent;
                    if (!t.parent.getAncestors({
                        includeSelf: true
                    }).includes(e)) throw new R("writer-split-invalid-limit-element", this);
                    let o;
                    let i;
                    do {
                        const e = n.root.document ? n.root.document.version : null;
                        const r = n.maxOffset - t.offset;
                        const s = D_.getInsertionPosition(t);
                        const a = new D_(t, r, s, null, e);
                        this.batch.addOperation(a);
                        this.model.applyOperation(a);
                        if (!o && !i) {
                            o = n;
                            i = t.parent.nextSibling;
                        }
                        t = this.createPositionAfter(t.parent);
                        n = t.parent;
                    }while (n !== e);
                    return {
                        position: t,
                        range: new Hk(Ok._createAt(o, "end"), Ok._createAt(i, 0))
                    };
                }
                wrap(t, e) {
                    this._assertWriterUsedCorrectly();
                    if (!t.isFlat) throw new R("writer-wrap-range-not-flat", this);
                    const n = e instanceof Bk ? e : new Bk(e);
                    if (n.childCount > 0) throw new R("writer-wrap-element-not-empty", this);
                    if (n.parent !== null) throw new R("writer-wrap-element-attached", this);
                    this.insert(n, t.start);
                    const o = new Hk(t.start.getShiftedBy(1), t.end.getShiftedBy(1));
                    this.move(o, Ok._createAt(n, 0));
                }
                unwrap(t) {
                    this._assertWriterUsedCorrectly();
                    if (t.parent === null) throw new R("writer-unwrap-element-no-parent", this);
                    this.move(Hk._createIn(t), this.createPositionAfter(t));
                    this.remove(t);
                }
                addMarker(t, e) {
                    this._assertWriterUsedCorrectly();
                    if (!e || typeof e.usingOperation != "boolean") throw new R("writer-addmarker-no-usingoperation", this);
                    const n = e.usingOperation;
                    const o = e.range;
                    const i = e.affectsData === undefined ? false : e.affectsData;
                    if (this.model.markers.has(t)) throw new R("writer-addmarker-marker-exists", this);
                    if (!o) throw new R("writer-addmarker-no-range", this);
                    if (!n) return this.model.markers._set(t, o, n, i);
                    wA(this, t, null, o, i);
                    return this.model.markers.get(t);
                }
                updateMarker(t, e) {
                    this._assertWriterUsedCorrectly();
                    const n = typeof t == "string" ? t : t.name;
                    const o = this.model.markers.get(n);
                    if (!o) throw new R("writer-updatemarker-marker-not-exists", this);
                    if (!e) {
                        O("writer-updatemarker-reconvert-using-editingcontroller", {
                            markerName: n
                        });
                        this.model.markers._refresh(o);
                        return;
                    }
                    const i = typeof e.usingOperation == "boolean";
                    const r = typeof e.affectsData == "boolean";
                    const s = r ? e.affectsData : o.affectsData;
                    if (!i && !e.range && !r) throw new R("writer-updatemarker-wrong-options", this);
                    const a = o.getRange();
                    const c = e.range ? e.range : a;
                    if (i && e.usingOperation !== o.managedUsingOperations) {
                        if (e.usingOperation) wA(this, n, null, c, s);
                        else {
                            wA(this, n, a, null, s);
                            this.model.markers._set(n, c, undefined, s);
                        }
                        return;
                    }
                    if (o.managedUsingOperations) wA(this, n, a, c, s);
                    else this.model.markers._set(n, c, undefined, s);
                }
                removeMarker(t) {
                    this._assertWriterUsedCorrectly();
                    const e = typeof t == "string" ? t : t.name;
                    if (!this.model.markers.has(e)) throw new R("writer-removemarker-no-marker", this);
                    const n = this.model.markers.get(e);
                    if (!n.managedUsingOperations) {
                        this.model.markers._remove(e);
                        return;
                    }
                    const o = n.getRange();
                    wA(this, e, o, null, n.affectsData);
                }
                addRoot(t, e = "$root") {
                    this._assertWriterUsedCorrectly();
                    const n = this.model.document.getRoot(t);
                    if (n && n.isAttached()) throw new R("writer-addroot-root-exists", this);
                    const o = this.model.document;
                    const i = new M_(t, e, true, o, o.version);
                    this.batch.addOperation(i);
                    this.model.applyOperation(i);
                    return this.model.document.getRoot(t);
                }
                detachRoot(t) {
                    this._assertWriterUsedCorrectly();
                    const e = typeof t == "string" ? this.model.document.getRoot(t) : t;
                    if (!e || !e.isAttached()) throw new R("writer-detachroot-no-root", this);
                    for (const t of this.model.markers)if (t.getRange().root === e) this.removeMarker(t);
                    for (const t of e.getAttributeKeys())this.removeAttribute(t, e);
                    this.remove(this.createRangeIn(e));
                    const n = this.model.document;
                    const o = new M_(e.rootName, e.name, false, n, n.version);
                    this.batch.addOperation(o);
                    this.model.applyOperation(o);
                }
                setSelection(...t) {
                    this._assertWriterUsedCorrectly();
                    this.model.document.selection._setTo(...t);
                }
                setSelectionFocus(t, e) {
                    this._assertWriterUsedCorrectly();
                    this.model.document.selection._setFocus(t, e);
                }
                setSelectionAttribute(t, e) {
                    this._assertWriterUsedCorrectly();
                    if (typeof t === "string") this._setSelectionAttribute(t, e);
                    else for (const [e, n] of kl(t))this._setSelectionAttribute(e, n);
                }
                removeSelectionAttribute(t) {
                    this._assertWriterUsedCorrectly();
                    if (typeof t === "string") this._removeSelectionAttribute(t);
                    else for (const e of t)this._removeSelectionAttribute(e);
                }
                overrideSelectionGravity() {
                    return this.model.document.selection._overrideGravity();
                }
                restoreSelectionGravity(t) {
                    this.model.document.selection._restoreGravity(t);
                }
                _setSelectionAttribute(t, e) {
                    const n = this.model.document.selection;
                    if (n.isCollapsed && n.anchor.parent.isEmpty) {
                        const o = cb._getStoreAttributeKey(t);
                        this.setAttribute(o, e, n.anchor.parent);
                    }
                    n._setAttribute(t, e);
                }
                _removeSelectionAttribute(t) {
                    const e = this.model.document.selection;
                    if (e.isCollapsed && e.anchor.parent.isEmpty) {
                        const n = cb._getStoreAttributeKey(t);
                        this.removeAttribute(n, e.anchor.parent);
                    }
                    e._removeAttribute(t);
                }
                _assertWriterUsedCorrectly() {
                    if (this.model._currentWriter !== this) throw new R("writer-incorrect-use", this);
                }
                _addOperationForAffectedMarkers(t, e) {
                    for (const n of this.model.markers){
                        if (!n.managedUsingOperations) continue;
                        const o = n.getRange();
                        let i = false;
                        if (t === "move") {
                            const t = e;
                            i = t.containsPosition(o.start) || t.start.isEqual(o.start) || t.containsPosition(o.end) || t.end.isEqual(o.end);
                        } else {
                            const t = e;
                            const n = t.nodeBefore;
                            const r = t.nodeAfter;
                            const s = o.start.parent == n && o.start.isAtEnd;
                            const a = o.end.parent == r && o.end.offset == 0;
                            const c = o.end.nodeAfter == r;
                            const l = o.start.nodeAfter == r;
                            i = s || a || c || l;
                        }
                        if (i) this.updateMarker(n.name, {
                            range: o
                        });
                    }
                }
            }
            function kA(t, e, n, o) {
                const i = t.model;
                const r = i.document;
                let s = o.start;
                let a;
                let c;
                let l;
                for (const t of o.getWalker({
                    shallow: true
                })){
                    l = t.item.getAttribute(e);
                    if (a && c != l) {
                        if (c != n) d();
                        s = a;
                    }
                    a = t.nextPosition;
                    c = l;
                }
                if (a instanceof Ok && a != s && c != n) d();
                function d() {
                    const o = new Hk(s, a);
                    const l = o.root.document ? r.version : null;
                    const d = new I_(o, e, c, n, l);
                    t.batch.addOperation(d);
                    i.applyOperation(d);
                }
            }
            function bA(t, e, n, o) {
                const i = t.model;
                const r = i.document;
                const s = o.getAttribute(e);
                let a, c;
                if (s != n) {
                    const l = o.root === o;
                    if (l) {
                        const t = o.document ? r.version : null;
                        c = new V_(o, e, s, n, t);
                    } else {
                        a = new Hk(Ok._createBefore(o), t.createPositionAfter(o));
                        const i = a.root.document ? r.version : null;
                        c = new I_(a, e, s, n, i);
                    }
                    t.batch.addOperation(c);
                    i.applyOperation(c);
                }
            }
            function wA(t, e, n, o, i) {
                const r = t.model;
                const s = r.document;
                const a = new T_(e, n, o, r.markers, !!i, s.version);
                t.batch.addOperation(a);
                r.applyOperation(a);
            }
            function _A(t, e, n, o) {
                let i;
                if (t.root.document) {
                    const n = o.document;
                    const r = new Ok(n.graveyard, [
                        0
                    ]);
                    i = new x_(t, e, r, n.version);
                } else i = new fA(t, e);
                n.addOperation(i);
                o.applyOperation(i);
            }
            function AA(t, e) {
                if (t === e) return true;
                if (t instanceof aA && e instanceof aA) return true;
                return false;
            }
            function vA(t, e, n = {}) {
                if (e.isCollapsed) return;
                const o = e.getFirstRange();
                if (o.root.rootName == "$graveyard") return;
                const i = t.schema;
                t.change((t)=>{
                    if (!n.doNotResetEntireContent && VA(i, e)) {
                        OA(t, e);
                        return;
                    }
                    const r = {};
                    if (!n.doNotAutoparagraph) {
                        const t = e.getSelectedElement();
                        if (t) Object.assign(r, i.getAttributesWithProperty(t, "copyOnReplace", true));
                    }
                    const [s, a] = CA(o);
                    if (!s.isTouching(a)) t.remove(t.createRange(s, a));
                    if (!n.leaveUnmerged) {
                        xA(t, s, a);
                        i.removeDisallowedAttributes(s.parent.getChildren(), t);
                    }
                    MA(t, e, s);
                    if (!n.doNotAutoparagraph && PA(i, s)) RA(t, s, e, r);
                    s.detach();
                    a.detach();
                });
            }
            function CA(t) {
                const e = t.root.document.model;
                const n = t.start;
                let o = t.end;
                if (e.hasContent(t, {
                    ignoreMarkers: true
                })) {
                    const n = yA(o);
                    if (n && o.isTouching(e.createPositionAt(n, 0))) {
                        const n = e.createSelection(t);
                        e.modifySelection(n, {
                            direction: "backward"
                        });
                        const i = n.getLastPosition();
                        const r = e.createRange(i, o);
                        if (!e.hasContent(r, {
                            ignoreMarkers: true
                        })) o = i;
                    }
                }
                return [
                    Q_.fromPosition(n, "toPrevious"),
                    Q_.fromPosition(o, "toNext")
                ];
            }
            function yA(t) {
                const e = t.parent;
                const n = e.root.document.model.schema;
                const o = e.getAncestors({
                    parentFirst: true,
                    includeSelf: true
                });
                for (const t of o){
                    if (n.isLimit(t)) return null;
                    if (n.isBlock(t)) return t;
                }
            }
            function xA(t, e, n) {
                const o = t.model;
                if (!TA(t.model.schema, e, n)) return;
                const [i, r] = BA(e, n);
                if (!i || !r) return;
                if (!o.hasContent(i, {
                    ignoreMarkers: true
                }) && o.hasContent(r, {
                    ignoreMarkers: true
                })) DA(t, e, n, i.parent);
                else EA(t, e, n, i.parent);
            }
            function EA(t, e, n, o) {
                const i = e.parent;
                const r = n.parent;
                if (i == o || r == o) return;
                e = t.createPositionAfter(i);
                n = t.createPositionBefore(r);
                if (!n.isEqual(e)) t.insert(r, e);
                t.merge(e);
                while(n.parent.isEmpty){
                    const e = n.parent;
                    n = t.createPositionBefore(e);
                    t.remove(e);
                }
                if (!TA(t.model.schema, e, n)) return;
                EA(t, e, n, o);
            }
            function DA(t, e, n, o) {
                const i = e.parent;
                const r = n.parent;
                if (i == o || r == o) return;
                e = t.createPositionAfter(i);
                n = t.createPositionBefore(r);
                if (!n.isEqual(e)) t.insert(i, n);
                while(e.parent.isEmpty){
                    const n = e.parent;
                    e = t.createPositionBefore(n);
                    t.remove(n);
                }
                n = t.createPositionBefore(r);
                SA(t, n);
                if (!TA(t.model.schema, e, n)) return;
                DA(t, e, n, o);
            }
            function SA(t, e) {
                const n = e.nodeBefore;
                const o = e.nodeAfter;
                if (n.name != o.name) t.rename(n, o.name);
                t.clearAttributes(n);
                t.setAttributes(Object.fromEntries(o.getAttributes()), n);
                t.merge(e);
            }
            function TA(t, e, n) {
                const o = e.parent;
                const i = n.parent;
                if (o == i) return false;
                if (t.isLimit(o) || t.isLimit(i)) return false;
                return IA(e, n, t);
            }
            function BA(t, e) {
                const n = t.getAncestors();
                const o = e.getAncestors();
                let i = 0;
                while(n[i] && n[i] == o[i])i++;
                return [
                    n[i],
                    o[i]
                ];
            }
            function PA(t, e) {
                const n = t.checkChild(e, "$text");
                const o = t.checkChild(e, "paragraph");
                return !n && o;
            }
            function IA(t, e, n) {
                const o = new Hk(t, e);
                for (const t of o.getWalker()){
                    if (n.isLimit(t.item)) return false;
                }
                return true;
            }
            function RA(t, e, n, o = {}) {
                const i = t.createElement("paragraph");
                t.model.schema.setAllowedAttributes(i, o, t);
                t.insert(i, e);
                MA(t, n, t.createPositionAt(i, 0));
            }
            function OA(t, e) {
                const n = t.model.schema.getLimitElement(e);
                t.remove(t.createRangeIn(n));
                RA(t, t.createPositionAt(n, 0), e);
            }
            function VA(t, e) {
                const n = t.getLimitElement(e);
                if (!e.containsEntireContent(n)) return false;
                const o = e.getFirstRange();
                if (o.start.parent == o.end.parent) return false;
                return t.checkChild(n, "paragraph");
            }
            function MA(t, e, n) {
                if (e instanceof cb) t.setSelection(n);
                else e.setTo(n);
            }
            function LA(t, e) {
                return t.change((t)=>{
                    const n = t.createDocumentFragment();
                    const o = e.getFirstRange();
                    if (!o || o.isCollapsed) return n;
                    const i = o.start.root;
                    const r = o.start.getCommonPath(o.end);
                    const s = i.getNodeByPath(r);
                    let a;
                    if (o.start.parent == o.end.parent) a = o;
                    else a = t.createRange(t.createPositionAt(s, o.start.path[r.length]), t.createPositionAt(s, o.end.path[r.length] + 1));
                    const c = a.end.offset - a.start.offset;
                    for (const e of a.getItems({
                        shallow: true
                    }))if (e.is("$textProxy")) t.appendText(e.data, e.getAttributes(), n);
                    else t.append(t.cloneElement(e, true), n);
                    if (a != o) {
                        const e = o._getTransformedByMove(a.start, t.createPositionAt(n, 0), c)[0];
                        const i = t.createRange(t.createPositionAt(n, 0), e.start);
                        const r = t.createRange(e.end, t.createPositionAt(n, "end"));
                        zA(r, t);
                        zA(i, t);
                    }
                    return n;
                });
            }
            function zA(t, e) {
                const n = [];
                Array.from(t.getItems({
                    direction: "backward"
                })).map((t)=>e.createRangeOn(t)).filter((e)=>{
                    const n = (e.start.isAfter(t.start) || e.start.isEqual(t.start)) && (e.end.isBefore(t.end) || e.end.isEqual(t.end));
                    return n;
                }).forEach((t)=>{
                    n.push(t.start.parent);
                    e.remove(t);
                });
                n.forEach((t)=>{
                    let n = t;
                    while(n.parent && n.isEmpty){
                        const t = e.createRangeOn(n);
                        n = n.parent;
                        e.remove(t);
                    }
                });
            }
            function NA(t, e, n) {
                return t.change((o)=>{
                    const i = n ? n : t.document.selection;
                    if (!i.isCollapsed) t.deleteContent(i, {
                        doNotAutoparagraph: true
                    });
                    const r = new FA(t, o, i.anchor);
                    const s = [];
                    let a;
                    if (e.is("documentFragment")) {
                        if (e.markers.size) {
                            const t = [];
                            for (const [n, o] of e.markers){
                                const { start: e, end: i } = o;
                                const r = e.isEqual(i);
                                t.push({
                                    position: e,
                                    name: n,
                                    isCollapsed: r
                                }, {
                                    position: i,
                                    name: n,
                                    isCollapsed: r
                                });
                            }
                            t.sort(({ position: t }, { position: e })=>t.isBefore(e) ? 1 : -1);
                            for (const { position: n, name: i, isCollapsed: r } of t){
                                let t = null;
                                let a = null;
                                const c = n.parent === e && n.isAtStart;
                                const l = n.parent === e && n.isAtEnd;
                                if (!c && !l) {
                                    t = o.createElement("$marker");
                                    o.insert(t, n);
                                } else if (r) a = c ? "start" : "end";
                                s.push({
                                    name: i,
                                    element: t,
                                    collapsed: a
                                });
                            }
                        }
                        a = e.getChildren();
                    } else a = [
                        e
                    ];
                    r.handleNodes(a);
                    let c = r.getSelectionRange();
                    if (e.is("documentFragment") && s.length) {
                        const t = c ? ob.fromRange(c) : null;
                        const e = {};
                        for(let t = s.length - 1; t >= 0; t--){
                            const { name: n, element: i, collapsed: a } = s[t];
                            const c = !e[n];
                            if (c) e[n] = [];
                            if (i) {
                                const t = o.createPositionAt(i, "before");
                                e[n].push(t);
                                o.remove(i);
                            } else {
                                const t = r.getAffectedRange();
                                if (!t) {
                                    if (a) e[n].push(r.position);
                                    continue;
                                }
                                if (a) e[n].push(t[a]);
                                else e[n].push(c ? t.start : t.end);
                            }
                        }
                        for (const [t, [n, i]] of Object.entries(e))if (n && i && n.root === i.root) o.addMarker(t, {
                            usingOperation: true,
                            affectsData: true,
                            range: new Hk(n, i)
                        });
                        if (t) {
                            c = t.toRange();
                            t.detach();
                        }
                    }
                    if (c) {
                        if (i instanceof cb) o.setSelection(c);
                        else i.setTo(c);
                    } else ;
                    const l = r.getAffectedRange() || t.createRange(i.anchor);
                    r.destroy();
                    return l;
                });
            }
            class FA {
                constructor(t, e, n){
                    this._firstNode = null;
                    this._lastNode = null;
                    this._lastAutoParagraph = null;
                    this._filterAttributesOf = [];
                    this._affectedStart = null;
                    this._affectedEnd = null;
                    this._nodeToSelect = null;
                    this.model = t;
                    this.writer = e;
                    this.position = n;
                    this.canMergeWith = new Set([
                        this.position.parent
                    ]);
                    this.schema = t.schema;
                    this._documentFragment = e.createDocumentFragment();
                    this._documentFragmentPosition = e.createPositionAt(this._documentFragment, 0);
                }
                handleNodes(t) {
                    for (const e of Array.from(t))this._handleNode(e);
                    this._insertPartialFragment();
                    if (this._lastAutoParagraph) this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph);
                    this._mergeOnRight();
                    this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer);
                    this._filterAttributesOf = [];
                }
                _updateLastNodeFromAutoParagraph(t) {
                    const e = this.writer.createPositionAfter(this._lastNode);
                    const n = this.writer.createPositionAfter(t);
                    if (n.isAfter(e)) {
                        this._lastNode = t;
                        if (this.position.parent != t || !this.position.isAtEnd) throw new R("insertcontent-invalid-insertion-position", this);
                        this.position = n;
                        this._setAffectedBoundaries(this.position);
                    }
                }
                getSelectionRange() {
                    if (this._nodeToSelect) return Hk._createOn(this._nodeToSelect);
                    return this.model.schema.getNearestSelectionRange(this.position);
                }
                getAffectedRange() {
                    if (!this._affectedStart) return null;
                    return new Hk(this._affectedStart, this._affectedEnd);
                }
                destroy() {
                    if (this._affectedStart) this._affectedStart.detach();
                    if (this._affectedEnd) this._affectedEnd.detach();
                }
                _handleNode(t) {
                    if (this.schema.isObject(t)) {
                        this._handleObject(t);
                        return;
                    }
                    let e = this._checkAndAutoParagraphToAllowedPosition(t);
                    if (!e) {
                        e = this._checkAndSplitToAllowedPosition(t);
                        if (!e) {
                            this._handleDisallowedNode(t);
                            return;
                        }
                    }
                    this._appendToFragment(t);
                    if (!this._firstNode) this._firstNode = t;
                    this._lastNode = t;
                }
                _insertPartialFragment() {
                    if (this._documentFragment.isEmpty) return;
                    const t = Q_.fromPosition(this.position, "toNext");
                    this._setAffectedBoundaries(this.position);
                    if (this._documentFragment.getChild(0) == this._firstNode) {
                        this.writer.insert(this._firstNode, this.position);
                        this._mergeOnLeft();
                        this.position = t.toPosition();
                    }
                    if (!this._documentFragment.isEmpty) this.writer.insert(this._documentFragment, this.position);
                    this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0);
                    this.position = t.toPosition();
                    t.detach();
                }
                _handleObject(t) {
                    if (this._checkAndSplitToAllowedPosition(t)) this._appendToFragment(t);
                    else this._tryAutoparagraphing(t);
                }
                _handleDisallowedNode(t) {
                    if (t.is("element")) this.handleNodes(t.getChildren());
                    else this._tryAutoparagraphing(t);
                }
                _appendToFragment(t) {
                    if (!this.schema.checkChild(this.position, t)) throw new R("insertcontent-wrong-position", this, {
                        node: t,
                        position: this.position
                    });
                    this.writer.insert(t, this._documentFragmentPosition);
                    this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t.offsetSize);
                    if (this.schema.isObject(t) && !this.schema.checkChild(this.position, "$text")) this._nodeToSelect = t;
                    else this._nodeToSelect = null;
                    this._filterAttributesOf.push(t);
                }
                _setAffectedBoundaries(t) {
                    if (!this._affectedStart) this._affectedStart = Q_.fromPosition(t, "toPrevious");
                    if (!this._affectedEnd || this._affectedEnd.isBefore(t)) {
                        if (this._affectedEnd) this._affectedEnd.detach();
                        this._affectedEnd = Q_.fromPosition(t, "toNext");
                    }
                }
                _mergeOnLeft() {
                    const t = this._firstNode;
                    if (!(t instanceof Bk)) return;
                    if (!this._canMergeLeft(t)) return;
                    const e = Q_._createBefore(t);
                    e.stickiness = "toNext";
                    const n = Q_.fromPosition(this.position, "toNext");
                    if (this._affectedStart.isEqual(e)) {
                        this._affectedStart.detach();
                        this._affectedStart = Q_._createAt(e.nodeBefore, "end", "toPrevious");
                    }
                    if (this._firstNode === this._lastNode) {
                        this._firstNode = e.nodeBefore;
                        this._lastNode = e.nodeBefore;
                    }
                    this.writer.merge(e);
                    if (e.isEqual(this._affectedEnd) && this._firstNode === this._lastNode) {
                        this._affectedEnd.detach();
                        this._affectedEnd = Q_._createAt(e.nodeBefore, "end", "toNext");
                    }
                    this.position = n.toPosition();
                    n.detach();
                    this._filterAttributesOf.push(this.position.parent);
                    e.detach();
                }
                _mergeOnRight() {
                    const t = this._lastNode;
                    if (!(t instanceof Bk)) return;
                    if (!this._canMergeRight(t)) return;
                    const e = Q_._createAfter(t);
                    e.stickiness = "toNext";
                    if (!this.position.isEqual(e)) throw new R("insertcontent-invalid-insertion-position", this);
                    this.position = Ok._createAt(e.nodeBefore, "end");
                    const n = Q_.fromPosition(this.position, "toPrevious");
                    if (this._affectedEnd.isEqual(e)) {
                        this._affectedEnd.detach();
                        this._affectedEnd = Q_._createAt(e.nodeBefore, "end", "toNext");
                    }
                    if (this._firstNode === this._lastNode) {
                        this._firstNode = e.nodeBefore;
                        this._lastNode = e.nodeBefore;
                    }
                    this.writer.merge(e);
                    if (e.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode) {
                        this._affectedStart.detach();
                        this._affectedStart = Q_._createAt(e.nodeBefore, 0, "toPrevious");
                    }
                    this.position = n.toPosition();
                    n.detach();
                    this._filterAttributesOf.push(this.position.parent);
                    e.detach();
                }
                _canMergeLeft(t) {
                    const e = t.previousSibling;
                    return e instanceof Bk && this.canMergeWith.has(e) && this.model.schema.checkMerge(e, t);
                }
                _canMergeRight(t) {
                    const e = t.nextSibling;
                    return e instanceof Bk && this.canMergeWith.has(e) && this.model.schema.checkMerge(t, e);
                }
                _tryAutoparagraphing(t) {
                    const e = this.writer.createElement("paragraph");
                    if (this._getAllowedIn(this.position.parent, e) && this.schema.checkChild(e, t)) {
                        e._appendChild(t);
                        this._handleNode(e);
                    }
                }
                _checkAndAutoParagraphToAllowedPosition(t) {
                    if (this.schema.checkChild(this.position.parent, t)) return true;
                    if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t)) return false;
                    this._insertPartialFragment();
                    const e = this.writer.createElement("paragraph");
                    this.writer.insert(e, this.position);
                    this._setAffectedBoundaries(this.position);
                    this._lastAutoParagraph = e;
                    this.position = this.writer.createPositionAt(e, 0);
                    return true;
                }
                _checkAndSplitToAllowedPosition(t) {
                    const e = this._getAllowedIn(this.position.parent, t);
                    if (!e) return false;
                    if (e != this.position.parent) this._insertPartialFragment();
                    while(e != this.position.parent){
                        if (this.position.isAtStart) {
                            const t = this.position.parent;
                            this.position = this.writer.createPositionBefore(t);
                            if (t.isEmpty && t.parent === e) this.writer.remove(t);
                        } else if (this.position.isAtEnd) this.position = this.writer.createPositionAfter(this.position.parent);
                        else {
                            const t = this.writer.createPositionAfter(this.position.parent);
                            this._setAffectedBoundaries(this.position);
                            this.writer.split(this.position);
                            this.position = t;
                            this.canMergeWith.add(this.position.nodeAfter);
                        }
                    }
                    return true;
                }
                _getAllowedIn(t, e) {
                    if (this.schema.checkChild(t, e)) return t;
                    if (this.schema.isLimit(t)) return null;
                    return this._getAllowedIn(t.parent, e);
                }
            }
            function HA(t, e, n = "auto") {
                const o = t.getSelectedElement();
                if (o && e.schema.isObject(o) && !e.schema.isInline(o)) {
                    if (n == "before" || n == "after") return e.createRange(e.createPositionAt(o, n));
                    return e.createRangeOn(o);
                }
                const i = fl(t.getSelectedBlocks());
                if (!i) return e.createRange(t.focus);
                if (i.isEmpty) return e.createRange(e.createPositionAt(i, 0));
                const r = e.createPositionAfter(i);
                if (t.focus.isTouching(r)) return e.createRange(r);
                return e.createRange(e.createPositionBefore(i));
            }
            function jA(t, e, n, o = {}) {
                if (!t.schema.isObject(e)) throw new R("insertobject-element-not-an-object", t, {
                    object: e
                });
                const i = n ? n : t.document.selection;
                let r = i;
                if (o.findOptimalPosition && t.schema.isBlock(e)) r = t.createSelection(HA(i, t, o.findOptimalPosition));
                const s = fl(i.getSelectedBlocks());
                const a = {};
                if (s) Object.assign(a, t.schema.getAttributesWithProperty(s, "copyOnReplace", true));
                return t.change((n)=>{
                    if (!r.isCollapsed) t.deleteContent(r, {
                        doNotAutoparagraph: true
                    });
                    let i = e;
                    const s = r.anchor.parent;
                    if (!t.schema.checkChild(s, e) && t.schema.checkChild(s, "paragraph") && t.schema.checkChild("paragraph", e)) {
                        i = n.createElement("paragraph");
                        n.insert(e, i);
                    }
                    t.schema.setAllowedAttributes(i, a, n);
                    const c = t.insertContent(i, r);
                    if (c.isCollapsed) return c;
                    if (o.setSelection) qA(n, e, o.setSelection, a);
                    return c;
                });
            }
            function qA(t, e, n, o) {
                const i = t.model;
                if (n == "on") {
                    t.setSelection(e, "on");
                    return;
                }
                if (n != "after") throw new R("insertobject-invalid-place-parameter-value", i);
                let r = e.nextSibling;
                if (i.schema.isInline(e)) {
                    t.setSelection(e, "after");
                    return;
                }
                const s = r && i.schema.checkChild(r, "$text");
                if (!s && i.schema.checkChild(e.parent, "paragraph")) {
                    r = t.createElement("paragraph");
                    i.schema.setAllowedAttributes(r, o, t);
                    i.insertContent(r, t.createPositionAfter(e));
                }
                if (r) t.setSelection(r, 0);
            }
            const WA = ' ,.?!:;"-()';
            function $A(t, e, n = {}) {
                const o = t.schema;
                const i = n.direction != "backward";
                const r = n.unit ? n.unit : "character";
                const s = !!n.treatEmojiAsSingleUnit;
                const a = e.focus;
                const c = new Ik({
                    boundaries: ZA(a, i),
                    singleCharacters: true,
                    direction: i ? "forward" : "backward"
                });
                const l = {
                    walker: c,
                    schema: o,
                    isForward: i,
                    unit: r,
                    treatEmojiAsSingleUnit: s
                };
                let d;
                while(d = c.next()){
                    if (d.done) return;
                    const n = GA(l, d.value);
                    if (n) {
                        if (e instanceof cb) t.change((t)=>{
                            t.setSelectionFocus(n);
                        });
                        else e.setFocus(n);
                        return;
                    }
                }
            }
            function GA(t, e) {
                const { isForward: n, walker: o, unit: i, schema: r, treatEmojiAsSingleUnit: s } = t;
                const { type: a, item: c, nextPosition: l } = e;
                if (a == "text") {
                    if (t.unit === "word") return KA(o, n);
                    return UA(o, i, s);
                }
                if (a == (n ? "elementStart" : "elementEnd")) {
                    if (r.isSelectable(c)) return Ok._createAt(c, n ? "after" : "before");
                    if (r.checkChild(l, "$text")) return l;
                } else {
                    if (r.isLimit(c)) {
                        o.skip(()=>true);
                        return;
                    }
                    if (r.checkChild(l, "$text")) return l;
                }
            }
            function UA(t, e, n) {
                const o = t.position.textNode;
                if (o) {
                    const i = o.data;
                    let r = t.position.offset - o.startOffset;
                    while(xl(i, r) || e == "character" && El(i, r) || n && Sl(i, r)){
                        t.next();
                        r = t.position.offset - o.startOffset;
                    }
                }
                return t.position;
            }
            function KA(t, e) {
                let n = t.position.textNode;
                if (!n) n = e ? t.position.nodeAfter : t.position.nodeBefore;
                while(n && n.is("$text")){
                    const o = t.position.offset - n.startOffset;
                    if (YA(n, o, e)) n = e ? t.position.nodeAfter : t.position.nodeBefore;
                    else if (JA(n.data, o, e)) break;
                    else t.next();
                }
                return t.position;
            }
            function ZA(t, e) {
                const n = t.root;
                const o = Ok._createAt(n, e ? "end" : 0);
                if (e) return new Hk(t, o);
                else return new Hk(o, t);
            }
            function JA(t, e, n) {
                const o = e + (n ? 0 : -1);
                return WA.includes(t.charAt(o));
            }
            function YA(t, e, n) {
                return e === (n ? t.offsetSize : 0);
            }
            class QA extends ht() {
                constructor(){
                    super();
                    this.markers = new uA;
                    this.document = new lA(this);
                    this.schema = new Fw;
                    this._pendingChanges = [];
                    this._currentWriter = null;
                    [
                        "deleteContent",
                        "modifySelection",
                        "getSelectedContent",
                        "applyOperation"
                    ].forEach((t)=>this.decorate(t));
                    this.on("applyOperation", (t, e)=>{
                        const n = e[0];
                        n._validate();
                    }, {
                        priority: "highest"
                    });
                    this.schema.register("$root", {
                        isLimit: true
                    });
                    this.schema.register("$container", {
                        allowIn: [
                            "$root",
                            "$container"
                        ]
                    });
                    this.schema.register("$block", {
                        allowIn: [
                            "$root",
                            "$container"
                        ],
                        isBlock: true
                    });
                    this.schema.register("$blockObject", {
                        allowWhere: "$block",
                        isBlock: true,
                        isObject: true
                    });
                    this.schema.register("$inlineObject", {
                        allowWhere: "$text",
                        allowAttributesOf: "$text",
                        isInline: true,
                        isObject: true
                    });
                    this.schema.register("$text", {
                        allowIn: "$block",
                        isInline: true,
                        isContent: true
                    });
                    this.schema.register("$clipboardHolder", {
                        allowContentOf: "$root",
                        allowChildren: "$text",
                        isLimit: true
                    });
                    this.schema.register("$documentFragment", {
                        allowContentOf: "$root",
                        allowChildren: "$text",
                        isLimit: true
                    });
                    this.schema.register("$marker");
                    this.schema.addChildCheck((t, e)=>{
                        if (e.name === "$marker") return true;
                    });
                    Ew(this);
                    this.document.registerPostFixer(ow);
                    this.on("insertContent", (t, [e, n])=>{
                        t.return = NA(this, e, n);
                    });
                    this.on("insertObject", (t, [e, n, o])=>{
                        t.return = jA(this, e, n, o);
                    });
                    this.on("canEditAt", (t)=>{
                        const e = !this.document.isReadOnly;
                        t.return = e;
                        if (!e) t.stop();
                    });
                }
                change(t) {
                    try {
                        if (this._pendingChanges.length === 0) {
                            this._pendingChanges.push({
                                batch: new eA,
                                callback: t
                            });
                            return this._runPendingChanges()[0];
                        } else return t(this._currentWriter);
                    } catch (t) {
                        R.rethrowUnexpectedError(t, this);
                    }
                }
                enqueueChange(t, e) {
                    try {
                        if (!t) t = new eA;
                        else if (typeof t === "function") {
                            e = t;
                            t = new eA;
                        } else if (!(t instanceof eA)) t = new eA(t);
                        this._pendingChanges.push({
                            batch: t,
                            callback: e
                        });
                        if (this._pendingChanges.length == 1) this._runPendingChanges();
                    } catch (t) {
                        R.rethrowUnexpectedError(t, this);
                    }
                }
                applyOperation(t) {
                    t._execute();
                }
                insertContent(t, e, n, ...o) {
                    const i = XA(e, n);
                    return this.fire("insertContent", [
                        t,
                        i,
                        n,
                        ...o
                    ]);
                }
                insertObject(t, e, n, o, ...i) {
                    const r = XA(e, n);
                    return this.fire("insertObject", [
                        t,
                        r,
                        o,
                        o,
                        ...i
                    ]);
                }
                deleteContent(t, e) {
                    vA(this, t, e);
                }
                modifySelection(t, e) {
                    $A(this, t, e);
                }
                getSelectedContent(t) {
                    return LA(this, t);
                }
                hasContent(t, e = {}) {
                    const n = t instanceof Hk ? t : Hk._createIn(t);
                    if (n.isCollapsed) return false;
                    const { ignoreWhitespaces: o = false, ignoreMarkers: i = false } = e;
                    if (!i) for (const t of this.markers.getMarkersIntersectingRange(n)){
                        if (t.affectsData) return true;
                    }
                    for (const t of n.getItems())if (this.schema.isContent(t)) {
                        if (t.is("$textProxy")) {
                            if (!o) return true;
                            else if (t.data.search(/\S/) !== -1) return true;
                        } else return true;
                    }
                    return false;
                }
                canEditAt(t) {
                    const e = XA(t);
                    return this.fire("canEditAt", [
                        e
                    ]);
                }
                createPositionFromPath(t, e, n) {
                    return new Ok(t, e, n);
                }
                createPositionAt(t, e) {
                    return Ok._createAt(t, e);
                }
                createPositionAfter(t) {
                    return Ok._createAfter(t);
                }
                createPositionBefore(t) {
                    return Ok._createBefore(t);
                }
                createRange(t, e) {
                    return new Hk(t, e);
                }
                createRangeIn(t) {
                    return Hk._createIn(t);
                }
                createRangeOn(t) {
                    return Hk._createOn(t);
                }
                createSelection(...t) {
                    return new Zk(...t);
                }
                createBatch(t) {
                    return new eA(t);
                }
                createOperationFromJSON(t) {
                    return z_.fromJSON(t, this.document);
                }
                destroy() {
                    this.document.destroy();
                    this.stopListening();
                }
                _runPendingChanges() {
                    const t = [];
                    this.fire("_beforeChanges");
                    try {
                        while(this._pendingChanges.length){
                            const e = this._pendingChanges[0].batch;
                            this._currentWriter = new mA(this, e);
                            const n = this._pendingChanges[0].callback(this._currentWriter);
                            t.push(n);
                            this.document._handleChangeBlock(this._currentWriter);
                            this._pendingChanges.shift();
                            this._currentWriter = null;
                        }
                    } finally{
                        this._pendingChanges.length = 0;
                        this._currentWriter = null;
                        this.fire("_afterChanges");
                    }
                    return t;
                }
            }
            function XA(t, e) {
                if (!t) return;
                if (t instanceof Zk || t instanceof cb) return t;
                if (t instanceof Ek) {
                    if (e || e === 0) return new Zk(t, e);
                    else if (t.is("rootElement")) return new Zk(t, "in");
                    else return new Zk(t, "on");
                }
                return new Zk(t);
            }
            class tv extends jg {
                constructor(){
                    super(...arguments);
                    this.domEventType = "click";
                }
                onDomEvent(t) {
                    this.fire(t.type, t);
                }
            }
            class ev extends jg {
                constructor(){
                    super(...arguments);
                    this.domEventType = [
                        "mousedown",
                        "mouseup",
                        "mouseover",
                        "mouseout"
                    ];
                }
                onDomEvent(t) {
                    this.fire(t.type, t);
                }
            }
            class nv {
                constructor(t){
                    this.document = t;
                }
                createDocumentFragment(t) {
                    return new DocumentFragment(this.document, t);
                }
                createElement(t, e, n) {
                    return new Element(this.document, t, e, n);
                }
                createText(t) {
                    return new Text(this.document, t);
                }
                clone(t, e = false) {
                    return t._clone(e);
                }
                appendChild(t, e) {
                    return e._appendChild(t);
                }
                insertChild(t, e, n) {
                    return n._insertChild(t, e);
                }
                removeChildren(t, e, n) {
                    return n._removeChildren(t, e);
                }
                remove(t) {
                    const e = t.parent;
                    if (e) return this.removeChildren(e.getChildIndex(t), 1, e);
                    return [];
                }
                replace(t, e) {
                    const n = t.parent;
                    if (n) {
                        const o = n.getChildIndex(t);
                        this.removeChildren(o, 1, n);
                        this.insertChild(o, e, n);
                        return true;
                    }
                    return false;
                }
                unwrapElement(t) {
                    const e = t.parent;
                    if (e) {
                        const n = e.getChildIndex(t);
                        this.remove(t);
                        this.insertChild(n, t.getChildren(), e);
                    }
                }
                rename(t, e) {
                    const n = new Element(this.document, t, e.getAttributes(), e.getChildren());
                    return this.replace(e, n) ? n : null;
                }
                setAttribute(t, e, n) {
                    n._setAttribute(t, e);
                }
                removeAttribute(t, e) {
                    e._removeAttribute(t);
                }
                addClass(t, e) {
                    e._addClass(t);
                }
                removeClass(t, e) {
                    e._removeClass(t);
                }
                setStyle(t, e, n) {
                    if (isPlainObject(t) && n === undefined) e._setStyle(t);
                    else n._setStyle(t, e);
                }
                removeStyle(t, e) {
                    e._removeStyle(t);
                }
                setCustomProperty(t, e, n) {
                    n._setCustomProperty(t, e);
                }
                removeCustomProperty(t, e) {
                    return e._removeCustomProperty(t);
                }
                createPositionAt(t, e) {
                    return Position._createAt(t, e);
                }
                createPositionAfter(t) {
                    return Position._createAfter(t);
                }
                createPositionBefore(t) {
                    return Position._createBefore(t);
                }
                createRange(t, e) {
                    return new Range(t, e);
                }
                createRangeOn(t) {
                    return Range._createOn(t);
                }
                createRangeIn(t) {
                    return Range._createIn(t);
                }
                createSelection(...t) {
                    return new Selection(...t);
                }
            }
            const ov = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
            const iv = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i;
            const rv = /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
            const sv = /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i;
            const av = /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i;
            const cv = /\w+\((?:[^()]|\([^()]*\))*\)|\S+/gi;
            const lv = new Set([
                "black",
                "silver",
                "gray",
                "white",
                "maroon",
                "red",
                "purple",
                "fuchsia",
                "green",
                "lime",
                "olive",
                "yellow",
                "navy",
                "blue",
                "teal",
                "aqua",
                "orange",
                "aliceblue",
                "antiquewhite",
                "aquamarine",
                "azure",
                "beige",
                "bisque",
                "blanchedalmond",
                "blueviolet",
                "brown",
                "burlywood",
                "cadetblue",
                "chartreuse",
                "chocolate",
                "coral",
                "cornflowerblue",
                "cornsilk",
                "crimson",
                "cyan",
                "darkblue",
                "darkcyan",
                "darkgoldenrod",
                "darkgray",
                "darkgreen",
                "darkgrey",
                "darkkhaki",
                "darkmagenta",
                "darkolivegreen",
                "darkorange",
                "darkorchid",
                "darkred",
                "darksalmon",
                "darkseagreen",
                "darkslateblue",
                "darkslategray",
                "darkslategrey",
                "darkturquoise",
                "darkviolet",
                "deeppink",
                "deepskyblue",
                "dimgray",
                "dimgrey",
                "dodgerblue",
                "firebrick",
                "floralwhite",
                "forestgreen",
                "gainsboro",
                "ghostwhite",
                "gold",
                "goldenrod",
                "greenyellow",
                "grey",
                "honeydew",
                "hotpink",
                "indianred",
                "indigo",
                "ivory",
                "khaki",
                "lavender",
                "lavenderblush",
                "lawngreen",
                "lemonchiffon",
                "lightblue",
                "lightcoral",
                "lightcyan",
                "lightgoldenrodyellow",
                "lightgray",
                "lightgreen",
                "lightgrey",
                "lightpink",
                "lightsalmon",
                "lightseagreen",
                "lightskyblue",
                "lightslategray",
                "lightslategrey",
                "lightsteelblue",
                "lightyellow",
                "limegreen",
                "linen",
                "magenta",
                "mediumaquamarine",
                "mediumblue",
                "mediumorchid",
                "mediumpurple",
                "mediumseagreen",
                "mediumslateblue",
                "mediumspringgreen",
                "mediumturquoise",
                "mediumvioletred",
                "midnightblue",
                "mintcream",
                "mistyrose",
                "moccasin",
                "navajowhite",
                "oldlace",
                "olivedrab",
                "orangered",
                "orchid",
                "palegoldenrod",
                "palegreen",
                "paleturquoise",
                "palevioletred",
                "papayawhip",
                "peachpuff",
                "peru",
                "pink",
                "plum",
                "powderblue",
                "rosybrown",
                "royalblue",
                "saddlebrown",
                "salmon",
                "sandybrown",
                "seagreen",
                "seashell",
                "sienna",
                "skyblue",
                "slateblue",
                "slategray",
                "slategrey",
                "snow",
                "springgreen",
                "steelblue",
                "tan",
                "thistle",
                "tomato",
                "turquoise",
                "violet",
                "wheat",
                "whitesmoke",
                "yellowgreen",
                "activeborder",
                "activecaption",
                "appworkspace",
                "background",
                "buttonface",
                "buttonhighlight",
                "buttonshadow",
                "buttontext",
                "captiontext",
                "graytext",
                "highlight",
                "highlighttext",
                "inactiveborder",
                "inactivecaption",
                "inactivecaptiontext",
                "infobackground",
                "infotext",
                "menu",
                "menutext",
                "scrollbar",
                "threeddarkshadow",
                "threedface",
                "threedhighlight",
                "threedlightshadow",
                "threedshadow",
                "window",
                "windowframe",
                "windowtext",
                "rebeccapurple",
                "currentcolor",
                "transparent"
            ]);
            function dv(t) {
                if (t.startsWith("#")) return ov.test(t);
                if (t.startsWith("rgb")) return iv.test(t) || rv.test(t);
                if (t.startsWith("hsl")) return sv.test(t) || av.test(t);
                return lv.has(t.toLowerCase());
            }
            const uv = null;
            function hv(t) {
                return uv.includes(t);
            }
            const fv = /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/;
            function pv(t) {
                return fv.test(t);
            }
            const gv = /^[+-]?[0-9]*([.][0-9]+)?%$/;
            function mv(t) {
                return gv.test(t);
            }
            const kv = null;
            function bv(t) {
                return kv.includes(t);
            }
            const wv = null;
            function _v(t) {
                return wv.includes(t);
            }
            const Av = null;
            function vv(t) {
                return Av.includes(t);
            }
            const Cv = /^url\(/;
            function yv(t) {
                return Cv.test(t);
            }
            function xv(t = "") {
                if (t === "") return {
                    top: undefined,
                    right: undefined,
                    bottom: undefined,
                    left: undefined
                };
                const e = Tv(t);
                const n = e[0];
                const o = e[2] || n;
                const i = e[1] || n;
                const r = e[3] || i;
                return {
                    top: n,
                    bottom: o,
                    right: i,
                    left: r
                };
            }
            function Ev(t) {
                return (e)=>{
                    const { top: n, right: o, bottom: i, left: r } = e;
                    const s = [];
                    if (![
                        n,
                        o,
                        r,
                        i
                    ].every((t)=>!!t)) {
                        if (n) s.push([
                            t + "-top",
                            n
                        ]);
                        if (o) s.push([
                            t + "-right",
                            o
                        ]);
                        if (i) s.push([
                            t + "-bottom",
                            i
                        ]);
                        if (r) s.push([
                            t + "-left",
                            r
                        ]);
                    } else s.push([
                        t,
                        Dv(e)
                    ]);
                    return s;
                };
            }
            function Dv({ top: t, right: e, bottom: n, left: o }) {
                const i = [];
                if (o !== e) i.push(t, e, n, o);
                else if (n !== t) i.push(t, e, n);
                else if (e !== t) i.push(t, e);
                else i.push(t);
                return i.join(" ");
            }
            function Sv(t) {
                return (e)=>({
                        path: t,
                        value: xv(e)
                    });
            }
            function Tv(t) {
                const e = t.matchAll(cv);
                return Array.from(e).map((t)=>t[0]);
            }
            function Bv(t) {
                t.setNormalizer("background", Pv());
                t.setNormalizer("background-color", Iv());
                t.setReducer("background", Rv());
                t.setStyleRelation("background", [
                    "background-color"
                ]);
            }
            function Pv() {
                return (t)=>{
                    const e = {};
                    const n = getShorthandValues(t);
                    for (const t of n){
                        if (isRepeat(t)) {
                            e.repeat = e.repeat || [];
                            e.repeat.push(t);
                        } else if (isPosition(t)) {
                            e.position = e.position || [];
                            e.position.push(t);
                        } else if (isAttachment(t)) e.attachment = t;
                        else if (isColor(t)) e.color = t;
                        else if (isURL(t)) e.image = t;
                    }
                    return {
                        path: "background",
                        value: e
                    };
                };
            }
            function Iv() {
                return (t)=>({
                        path: "background.color",
                        value: t
                    });
            }
            function Rv() {
                return (t)=>{
                    const e = [];
                    e.push([
                        "background-color",
                        t.color
                    ]);
                    return e;
                };
            }
            function Ov(t) {
                t.setNormalizer("border", Vv());
                t.setNormalizer("border-top", Mv("top"));
                t.setNormalizer("border-right", Mv("right"));
                t.setNormalizer("border-bottom", Mv("bottom"));
                t.setNormalizer("border-left", Mv("left"));
                t.setNormalizer("border-color", Lv("color"));
                t.setNormalizer("border-width", Lv("width"));
                t.setNormalizer("border-style", Lv("style"));
                t.setNormalizer("border-top-color", Nv("color", "top"));
                t.setNormalizer("border-top-style", Nv("style", "top"));
                t.setNormalizer("border-top-width", Nv("width", "top"));
                t.setNormalizer("border-right-color", Nv("color", "right"));
                t.setNormalizer("border-right-style", Nv("style", "right"));
                t.setNormalizer("border-right-width", Nv("width", "right"));
                t.setNormalizer("border-bottom-color", Nv("color", "bottom"));
                t.setNormalizer("border-bottom-style", Nv("style", "bottom"));
                t.setNormalizer("border-bottom-width", Nv("width", "bottom"));
                t.setNormalizer("border-left-color", Nv("color", "left"));
                t.setNormalizer("border-left-style", Nv("style", "left"));
                t.setNormalizer("border-left-width", Nv("width", "left"));
                t.setExtractor("border-top", Fv("top"));
                t.setExtractor("border-right", Fv("right"));
                t.setExtractor("border-bottom", Fv("bottom"));
                t.setExtractor("border-left", Fv("left"));
                t.setExtractor("border-top-color", "border.color.top");
                t.setExtractor("border-right-color", "border.color.right");
                t.setExtractor("border-bottom-color", "border.color.bottom");
                t.setExtractor("border-left-color", "border.color.left");
                t.setExtractor("border-top-width", "border.width.top");
                t.setExtractor("border-right-width", "border.width.right");
                t.setExtractor("border-bottom-width", "border.width.bottom");
                t.setExtractor("border-left-width", "border.width.left");
                t.setExtractor("border-top-style", "border.style.top");
                t.setExtractor("border-right-style", "border.style.right");
                t.setExtractor("border-bottom-style", "border.style.bottom");
                t.setExtractor("border-left-style", "border.style.left");
                t.setReducer("border-color", getBoxSidesValueReducer("border-color"));
                t.setReducer("border-style", getBoxSidesValueReducer("border-style"));
                t.setReducer("border-width", getBoxSidesValueReducer("border-width"));
                t.setReducer("border-top", Wv("top"));
                t.setReducer("border-right", Wv("right"));
                t.setReducer("border-bottom", Wv("bottom"));
                t.setReducer("border-left", Wv("left"));
                t.setReducer("border", qv());
                t.setStyleRelation("border", [
                    "border-color",
                    "border-style",
                    "border-width",
                    "border-top",
                    "border-right",
                    "border-bottom",
                    "border-left",
                    "border-top-color",
                    "border-right-color",
                    "border-bottom-color",
                    "border-left-color",
                    "border-top-style",
                    "border-right-style",
                    "border-bottom-style",
                    "border-left-style",
                    "border-top-width",
                    "border-right-width",
                    "border-bottom-width",
                    "border-left-width"
                ]);
                t.setStyleRelation("border-color", [
                    "border-top-color",
                    "border-right-color",
                    "border-bottom-color",
                    "border-left-color"
                ]);
                t.setStyleRelation("border-style", [
                    "border-top-style",
                    "border-right-style",
                    "border-bottom-style",
                    "border-left-style"
                ]);
                t.setStyleRelation("border-width", [
                    "border-top-width",
                    "border-right-width",
                    "border-bottom-width",
                    "border-left-width"
                ]);
                t.setStyleRelation("border-top", [
                    "border-top-color",
                    "border-top-style",
                    "border-top-width"
                ]);
                t.setStyleRelation("border-right", [
                    "border-right-color",
                    "border-right-style",
                    "border-right-width"
                ]);
                t.setStyleRelation("border-bottom", [
                    "border-bottom-color",
                    "border-bottom-style",
                    "border-bottom-width"
                ]);
                t.setStyleRelation("border-left", [
                    "border-left-color",
                    "border-left-style",
                    "border-left-width"
                ]);
            }
            function Vv() {
                return (t)=>{
                    const { color: e, style: n, width: o } = jv(t);
                    return {
                        path: "border",
                        value: {
                            color: getBoxSidesValues(e),
                            style: getBoxSidesValues(n),
                            width: getBoxSidesValues(o)
                        }
                    };
                };
            }
            function Mv(t) {
                return (e)=>{
                    const { color: n, style: o, width: i } = jv(e);
                    const r = {};
                    if (n !== undefined) r.color = {
                        [t]: n
                    };
                    if (o !== undefined) r.style = {
                        [t]: o
                    };
                    if (i !== undefined) r.width = {
                        [t]: i
                    };
                    return {
                        path: "border",
                        value: r
                    };
                };
            }
            function Lv(t) {
                return (e)=>({
                        path: "border",
                        value: zv(e, t)
                    });
            }
            function zv(t, e) {
                return {
                    [e]: getBoxSidesValues(t)
                };
            }
            function Nv(t, e) {
                return (n)=>({
                        path: "border",
                        value: {
                            [t]: {
                                [e]: n
                            }
                        }
                    });
            }
            function Fv(t) {
                return (e, n)=>{
                    if (n.border) return Hv(n.border, t);
                };
            }
            function Hv(t, e) {
                const n = {};
                if (t.width && t.width[e]) n.width = t.width[e];
                if (t.style && t.style[e]) n.style = t.style[e];
                if (t.color && t.color[e]) n.color = t.color[e];
                return n;
            }
            function jv(t) {
                const e = {};
                const n = getShorthandValues(t);
                for (const t of n){
                    if (isLength(t) || /thin|medium|thick/.test(t)) e.width = t;
                    else if (isLineStyle(t)) e.style = t;
                    else e.color = t;
                }
                return e;
            }
            function qv() {
                return (e)=>{
                    const n = Hv(e, "top");
                    const o = Hv(e, "right");
                    const i = Hv(e, "bottom");
                    const r = Hv(e, "left");
                    const s = [
                        n,
                        o,
                        i,
                        r
                    ];
                    const a = {
                        width: t(s, "width"),
                        style: t(s, "style"),
                        color: t(s, "color")
                    };
                    const c = $v(a, "all");
                    if (c.length) return c;
                    const l = Object.entries(a).reduce((t, [e, n])=>{
                        if (n) {
                            t.push([
                                `border-${e}`,
                                n
                            ]);
                            s.forEach((t)=>delete t[e]);
                        }
                        return t;
                    }, []);
                    return [
                        ...l,
                        ...$v(n, "top"),
                        ...$v(o, "right"),
                        ...$v(i, "bottom"),
                        ...$v(r, "left")
                    ];
                };
                function t(t, e) {
                    return t.map((t)=>t[e]).reduce((t, e)=>t == e ? t : null);
                }
            }
            function Wv(t) {
                return (e)=>$v(e, t);
            }
            function $v(t, e) {
                const n = [];
                if (t && t.width) n.push("width");
                if (t && t.style) n.push("style");
                if (t && t.color) n.push("color");
                if (n.length == 3) {
                    const o = n.map((e)=>t[e]).join(" ");
                    return [
                        e == "all" ? [
                            "border",
                            o
                        ] : [
                            `border-${e}`,
                            o
                        ]
                    ];
                }
                if (e == "all") return [];
                return n.map((n)=>[
                        `border-${e}-${n}`,
                        t[n]
                    ]);
            }
            function Gv(t) {
                t.setNormalizer("margin", getPositionShorthandNormalizer("margin"));
                t.setNormalizer("margin-top", (t)=>({
                        path: "margin.top",
                        value: t
                    }));
                t.setNormalizer("margin-right", (t)=>({
                        path: "margin.right",
                        value: t
                    }));
                t.setNormalizer("margin-bottom", (t)=>({
                        path: "margin.bottom",
                        value: t
                    }));
                t.setNormalizer("margin-left", (t)=>({
                        path: "margin.left",
                        value: t
                    }));
                t.setReducer("margin", getBoxSidesValueReducer("margin"));
                t.setStyleRelation("margin", [
                    "margin-top",
                    "margin-right",
                    "margin-bottom",
                    "margin-left"
                ]);
            }
            function Uv(t) {
                t.setNormalizer("padding", getPositionShorthandNormalizer("padding"));
                t.setNormalizer("padding-top", (t)=>({
                        path: "padding.top",
                        value: t
                    }));
                t.setNormalizer("padding-right", (t)=>({
                        path: "padding.right",
                        value: t
                    }));
                t.setNormalizer("padding-bottom", (t)=>({
                        path: "padding.bottom",
                        value: t
                    }));
                t.setNormalizer("padding-left", (t)=>({
                        path: "padding.left",
                        value: t
                    }));
                t.setReducer("padding", getBoxSidesValueReducer("padding"));
                t.setStyleRelation("padding", [
                    "padding-top",
                    "padding-right",
                    "padding-bottom",
                    "padding-left"
                ]);
            }
            class Kv {
                constructor(){
                    this._commands = new Map;
                }
                add(t, e) {
                    this._commands.set(t, e);
                }
                get(t) {
                    return this._commands.get(t);
                }
                execute(t, ...e) {
                    const n = this.get(t);
                    if (!n) throw new R("commandcollection-command-not-found", this, {
                        commandName: t
                    });
                    return n.execute(...e);
                }
                *names() {
                    yield* this._commands.keys();
                }
                *commands() {
                    yield* this._commands.values();
                }
                [Symbol.iterator]() {
                    return this._commands[Symbol.iterator]();
                }
                destroy() {
                    for (const t of this.commands())t.destroy();
                }
            }
            class Zv extends gl {
                constructor(t){
                    super();
                    this.editor = t;
                }
                set(t, e, n = {}) {
                    if (typeof e == "string") {
                        const t = e;
                        e = (e, n)=>{
                            this.editor.execute(t);
                            n();
                        };
                    }
                    super.set(t, e, n);
                }
            }
            class Jv extends ht() {
                constructor(t = {}){
                    super();
                    const e = this.constructor;
                    const n = t.language || e.defaultConfig && e.defaultConfig.language;
                    this._context = t.context || new Lu({
                        language: n
                    });
                    this._context._addEditor(this, !t.context);
                    const o = Array.from(e.builtinPlugins || []);
                    this.config = new Wa(t, e.defaultConfig);
                    this.config.define("plugins", o);
                    this.config.define(this._context._getEditorConfig());
                    this.plugins = new Mu(this, o, this._context.plugins);
                    this.locale = this._context.locale;
                    this.t = this.locale.t;
                    this._readOnlyLocks = new Set;
                    this.commands = new Kv;
                    this.set("state", "initializing");
                    this.once("ready", ()=>this.state = "ready", {
                        priority: "high"
                    });
                    this.once("destroy", ()=>this.state = "destroyed", {
                        priority: "high"
                    });
                    this.model = new QA;
                    this.on("change:isReadOnly", ()=>{
                        this.model.document.isReadOnly = this.isReadOnly;
                    });
                    const i = new np;
                    this.data = new u_(this.model, i);
                    this.editing = new Vw(this.model, i);
                    this.editing.view.document.bind("isReadOnly").to(this);
                    this.conversion = new f_([
                        this.editing.downcastDispatcher,
                        this.data.downcastDispatcher
                    ], this.data.upcastDispatcher);
                    this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher);
                    this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher);
                    this.keystrokes = new Zv(this);
                    this.keystrokes.listenTo(this.editing.view.document);
                }
                get isReadOnly() {
                    return this._readOnlyLocks.size > 0;
                }
                set isReadOnly(t) {
                    throw new R("editor-isreadonly-has-no-setter");
                }
                enableReadOnlyMode(t) {
                    if (typeof t !== "string" && typeof t !== "symbol") throw new R("editor-read-only-lock-id-invalid", null, {
                        lockId: t
                    });
                    if (this._readOnlyLocks.has(t)) return;
                    this._readOnlyLocks.add(t);
                    if (this._readOnlyLocks.size === 1) this.fire("change:isReadOnly", "isReadOnly", true, false);
                }
                disableReadOnlyMode(t) {
                    if (typeof t !== "string" && typeof t !== "symbol") throw new R("editor-read-only-lock-id-invalid", null, {
                        lockId: t
                    });
                    if (!this._readOnlyLocks.has(t)) return;
                    this._readOnlyLocks.delete(t);
                    if (this._readOnlyLocks.size === 0) this.fire("change:isReadOnly", "isReadOnly", false, true);
                }
                initPlugins() {
                    const t = this.config;
                    const e = t.get("plugins");
                    const n = t.get("removePlugins") || [];
                    const o = t.get("extraPlugins") || [];
                    const i = t.get("substitutePlugins") || [];
                    return this.plugins.init(e.concat(o), n, i);
                }
                destroy() {
                    let t = Promise.resolve();
                    if (this.state == "initializing") t = new Promise((t)=>this.once("ready", t));
                    return t.then(()=>{
                        this.fire("destroy");
                        this.stopListening();
                        this.commands.destroy();
                    }).then(()=>this.plugins.destroy()).then(()=>{
                        this.model.destroy();
                        this.data.destroy();
                        this.editing.destroy();
                        this.keystrokes.destroy();
                    }).then(()=>this._context._removeEditor(this));
                }
                execute(t, ...e) {
                    try {
                        return this.commands.execute(t, ...e);
                    } catch (t) {
                        R.rethrowUnexpectedError(t, this);
                    }
                }
                focus() {
                    this.editing.view.focus();
                }
                static create(...t) {
                    throw new Error("This is an abstract method.");
                }
            }
            function Yv(t) {
                if (!Ge(t.updateSourceElement)) throw new R("attachtoform-missing-elementapi-interface", t);
                const e = t.sourceElement;
                if (Qv(e) && e.form) {
                    let n;
                    const o = e.form;
                    const i = ()=>t.updateSourceElement();
                    if (Ge(o.submit)) {
                        n = o.submit;
                        o.submit = ()=>{
                            i();
                            n.apply(o);
                        };
                    }
                    o.addEventListener("submit", i);
                    t.on("destroy", ()=>{
                        o.removeEventListener("submit", i);
                        if (n) o.submit = n;
                    });
                }
            }
            function Qv(t) {
                return !!t && t.tagName.toLowerCase() === "textarea";
            }
            function Xv(t) {
                class e extends t {
                    setData(t) {
                        this.data.set(t);
                    }
                    getData(t) {
                        return this.data.get(t);
                    }
                }
                return e;
            }
            {
                const t = Xv(Object);
                Xv.setData = t.prototype.setData;
                Xv.getData = t.prototype.getData;
            }
            function tC(t) {
                class e extends t {
                    updateSourceElement(t = this.data.get()) {
                        if (!this.sourceElement) throw new R("editor-missing-sourceelement", this);
                        const e = this.config.get("updateSourceElementOnDestroy");
                        const n = this.sourceElement instanceof HTMLTextAreaElement;
                        if (!e && !n) {
                            bc(this.sourceElement, "");
                            return;
                        }
                        bc(this.sourceElement, t);
                    }
                }
                return e;
            }
            tC.updateSourceElement = tC(Object).prototype.updateSourceElement;
            function eC(t, e) {
                if (e.ckeditorInstance) throw new CKEditorError("editor-source-element-already-used", t);
                e.ckeditorInstance = t;
                t.once("destroy", ()=>{
                    delete e.ckeditorInstance;
                });
            }
            class nC extends zu {
                static get pluginName() {
                    return "PendingActions";
                }
                init() {
                    this.set("hasAny", false);
                    this._actions = new hl({
                        idProperty: "_id"
                    });
                    this._actions.delegate("add", "remove").to(this);
                }
                add(t) {
                    if (typeof t !== "string") throw new R("pendingactions-add-invalid-message", this);
                    const e = new (ht());
                    e.set("message", t);
                    this._actions.add(e);
                    this.hasAny = true;
                    return e;
                }
                remove(t) {
                    this._actions.remove(t);
                    this.hasAny = !!this._actions.length;
                }
                get first() {
                    return this._actions.get(0);
                }
                [Symbol.iterator]() {
                    return this._actions[Symbol.iterator]();
                }
            }
            const oC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>';
            const iC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>';
            const rC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>';
            const sC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>';
            const aC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>';
            const cC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1z"/><path d="M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052z"/><path d="M11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z"/></svg>';
            const lC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>';
            const dC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.68 13.74h-.001l4.209 4.208a1 1 0 1 0 1.414-1.414l-4.267-4.268a6 6 0 1 0-1.355 1.474ZM13 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"/></svg>';
            const uC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>';
            const hC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>';
            const fC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>';
            const pC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>';
            const gC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
            const mC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>';
            const kC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>';
            const bC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>';
            const wC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>';
            const _C = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>';
            const AC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>';
            const vC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>';
            const CC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>';
            const yC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>';
            const xC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>';
            const EC = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>';
            const DC = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>';
            const SC = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>';
            const TC = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>';
            const BC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>';
            const PC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>';
            const IC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>';
            const RC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>';
            const OC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/></svg>';
            const VC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>';
            const MC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>';
            const LC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>';
            const zC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></svg>';
            const NC = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></svg>';
            const FC = {
                bold: VC,
                cancel: oC,
                caption: iC,
                check: rC,
                cog: sC,
                eraser: aC,
                history: cC,
                image: uC,
                lowVision: lC,
                loupe: dC,
                importExport: NC,
                paragraph: MC,
                plus: LC,
                text: zC,
                alignBottom: hC,
                alignMiddle: fC,
                alignTop: pC,
                alignLeft: gC,
                alignCenter: mC,
                alignRight: kC,
                alignJustify: bC,
                objectLeft: yC,
                objectCenter: _C,
                objectRight: xC,
                objectFullWidth: vC,
                objectInline: CC,
                objectBlockLeft: wC,
                objectBlockRight: AC,
                objectSizeFull: EC,
                objectSizeLarge: DC,
                objectSizeSmall: SC,
                objectSizeMedium: TC,
                pencil: BC,
                pilcrow: PC,
                quote: IC,
                threeVerticalDots: RC,
                dragIndicator: OC
            };
            var HC = n(4768);
            var jC = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            jC.insert = "head";
            jC.singleton = true;
            var qC = Rl()(HC.Z, jC);
            const WC = HC.Z.locals || {};
            const { threeVerticalDots: $C } = FC;
            const GC = {
                alignLeft: FC.alignLeft,
                bold: FC.bold,
                importExport: FC.importExport,
                paragraph: FC.paragraph,
                plus: FC.plus,
                text: FC.text,
                threeVerticalDots: FC.threeVerticalDots,
                pilcrow: FC.pilcrow,
                dragIndicator: FC.dragIndicator
            };
            class UC extends zl {
                constructor(t, e){
                    super(t);
                    const n = this.bindTemplate;
                    const o = this.t;
                    this.options = e || {};
                    this.set("ariaLabel", o("Editor toolbar"));
                    this.set("maxWidth", "auto");
                    this.items = this.createCollection();
                    this.focusTracker = new pl;
                    this.keystrokes = new gl;
                    this.set("class", undefined);
                    this.set("isCompact", false);
                    this.itemsView = new KC(t);
                    this.children = this.createCollection();
                    this.children.add(this.itemsView);
                    this.focusables = this.createCollection();
                    const i = t.uiLanguageDirection === "rtl";
                    this._focusCycler = new xu({
                        focusables: this.focusables,
                        focusTracker: this.focusTracker,
                        keystrokeHandler: this.keystrokes,
                        actions: {
                            focusPrevious: [
                                i ? "arrowright" : "arrowleft",
                                "arrowup"
                            ],
                            focusNext: [
                                i ? "arrowleft" : "arrowright",
                                "arrowdown"
                            ]
                        }
                    });
                    const r = [
                        "ck",
                        "ck-toolbar",
                        n.to("class"),
                        n.if("isCompact", "ck-toolbar_compact")
                    ];
                    if (this.options.shouldGroupWhenFull && this.options.isFloating) r.push("ck-toolbar_floating");
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: r,
                            role: "toolbar",
                            "aria-label": n.to("ariaLabel"),
                            style: {
                                maxWidth: n.to("maxWidth")
                            },
                            tabindex: -1
                        },
                        children: this.children,
                        on: {
                            mousedown: Tu(this)
                        }
                    });
                    this._behavior = this.options.shouldGroupWhenFull ? new JC(this) : new ZC(this);
                }
                render() {
                    super.render();
                    this.focusTracker.add(this.element);
                    for (const t of this.items)this.focusTracker.add(t.element);
                    this.items.on("add", (t, e)=>{
                        this.focusTracker.add(e.element);
                    });
                    this.items.on("remove", (t, e)=>{
                        this.focusTracker.remove(e.element);
                    });
                    this.keystrokes.listenTo(this.element);
                    this._behavior.render(this);
                }
                destroy() {
                    this._behavior.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                    return super.destroy();
                }
                focus() {
                    this._focusCycler.focusFirst();
                }
                focusLast() {
                    this._focusCycler.focusLast();
                }
                fillFromConfig(t, e, n) {
                    this.items.addMany(this._buildItemsFromConfig(t, e, n));
                }
                _buildItemsFromConfig(t, e, n) {
                    const o = Bu(t);
                    const i = n || o.removeItems;
                    const r = this._cleanItemsConfiguration(o.items, e, i).map((t)=>{
                        if (rt(t)) return this._createNestedToolbarDropdown(t, e, i);
                        else if (t === "|") return new Du;
                        else if (t === "-") return new Su;
                        return e.create(t);
                    }).filter((t)=>!!t);
                    return r;
                }
                _cleanItemsConfiguration(t, e, n) {
                    const o = t.filter((t, o, i)=>{
                        if (t === "|") return true;
                        if (n.indexOf(t) !== -1) return false;
                        if (t === "-") {
                            if (this.options.shouldGroupWhenFull) {
                                O("toolbarview-line-break-ignored-when-grouping-items", i);
                                return false;
                            }
                            return true;
                        }
                        if (!rt(t) && !e.has(t)) {
                            O("toolbarview-item-unavailable", {
                                item: t
                            });
                            return false;
                        }
                        return true;
                    });
                    return this._cleanSeparatorsAndLineBreaks(o);
                }
                _cleanSeparatorsAndLineBreaks(t) {
                    const e = (t)=>t !== "-" && t !== "|";
                    const n = t.length;
                    const o = t.findIndex(e);
                    if (o === -1) return [];
                    const i = n - t.slice().reverse().findIndex(e);
                    return t.slice(o, i).filter((t, n, o)=>{
                        if (e(t)) return true;
                        const i = n > 0 && o[n - 1] === t;
                        return !i;
                    });
                }
                _createNestedToolbarDropdown(t, e, n) {
                    let { label: o, icon: i, items: r, tooltip: s = true, withText: a = false } = t;
                    r = this._cleanItemsConfiguration(r, e, n);
                    if (!r.length) return null;
                    const c = this.locale;
                    const l = by(c);
                    if (!o) O("toolbarview-nested-toolbar-dropdown-missing-label", t);
                    l.class = "ck-toolbar__nested-toolbar-dropdown";
                    l.buttonView.set({
                        label: o,
                        tooltip: s,
                        withText: !!a
                    });
                    if (i !== false) l.buttonView.icon = GC[i] || i || $C;
                    else l.buttonView.withText = true;
                    wy(l, ()=>l.toolbarView._buildItemsFromConfig(r, e, n));
                    return l;
                }
            }
            class KC extends zl {
                constructor(t){
                    super(t);
                    this.children = this.createCollection();
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-toolbar__items"
                            ]
                        },
                        children: this.children
                    });
                }
            }
            class ZC {
                constructor(t){
                    const e = t.bindTemplate;
                    t.set("isVertical", false);
                    t.itemsView.children.bindTo(t.items).using((t)=>t);
                    t.focusables.bindTo(t.items).using((t)=>t);
                    t.extendTemplate({
                        attributes: {
                            class: [
                                e.if("isVertical", "ck-toolbar_vertical")
                            ]
                        }
                    });
                }
                render() {}
                destroy() {}
            }
            class JC {
                constructor(t){
                    this.resizeObserver = null;
                    this.cachedPadding = null;
                    this.shouldUpdateGroupingOnNextResize = false;
                    this.view = t;
                    this.viewChildren = t.children;
                    this.viewFocusables = t.focusables;
                    this.viewItemsView = t.itemsView;
                    this.viewFocusTracker = t.focusTracker;
                    this.viewLocale = t.locale;
                    this.ungroupedItems = t.createCollection();
                    this.groupedItems = t.createCollection();
                    this.groupedItemsDropdown = this._createGroupedItemsDropdown();
                    t.itemsView.children.bindTo(this.ungroupedItems).using((t)=>t);
                    this.ungroupedItems.on("change", this._updateFocusCycleableItems.bind(this));
                    t.children.on("change", this._updateFocusCycleableItems.bind(this));
                    t.items.on("change", (t, e)=>{
                        const n = e.index;
                        const o = Array.from(e.added);
                        for (const t of e.removed)if (n >= this.ungroupedItems.length) this.groupedItems.remove(t);
                        else this.ungroupedItems.remove(t);
                        for(let t = n; t < n + o.length; t++){
                            const e = o[t - n];
                            if (t > this.ungroupedItems.length) this.groupedItems.add(e, t - this.ungroupedItems.length);
                            else this.ungroupedItems.add(e, t);
                        }
                        this._updateGrouping();
                    });
                    t.extendTemplate({
                        attributes: {
                            class: [
                                "ck-toolbar_grouping"
                            ]
                        }
                    });
                }
                render(t) {
                    this.viewElement = t.element;
                    this._enableGroupingOnResize();
                    this._enableGroupingOnMaxWidthChange(t);
                }
                destroy() {
                    this.groupedItemsDropdown.destroy();
                    this.resizeObserver.destroy();
                }
                _updateGrouping() {
                    if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) return;
                    if (!yc(this.viewElement)) {
                        this.shouldUpdateGroupingOnNextResize = true;
                        return;
                    }
                    const t = this.groupedItems.length;
                    let e;
                    while(this._areItemsOverflowing){
                        this._groupLastItem();
                        e = true;
                    }
                    if (!e && this.groupedItems.length) {
                        while(this.groupedItems.length && !this._areItemsOverflowing)this._ungroupFirstItem();
                        if (this._areItemsOverflowing) this._groupLastItem();
                    }
                    if (this.groupedItems.length !== t) this.view.fire("groupedItemsUpdate");
                }
                get _areItemsOverflowing() {
                    if (!this.ungroupedItems.length) return false;
                    const t = this.viewElement;
                    const e = this.viewLocale.uiLanguageDirection;
                    const n = new dc(t.lastChild);
                    const o = new dc(t);
                    if (!this.cachedPadding) {
                        const n = ec.window.getComputedStyle(t);
                        const o = e === "ltr" ? "paddingRight" : "paddingLeft";
                        this.cachedPadding = Number.parseInt(n[o]);
                    }
                    if (e === "ltr") return n.right > o.right - this.cachedPadding;
                    else return n.left < o.left + this.cachedPadding;
                }
                _enableGroupingOnResize() {
                    let t;
                    this.resizeObserver = new kc(this.viewElement, (e)=>{
                        if (!t || t !== e.contentRect.width || this.shouldUpdateGroupingOnNextResize) {
                            this.shouldUpdateGroupingOnNextResize = false;
                            this._updateGrouping();
                            t = e.contentRect.width;
                        }
                    });
                    this._updateGrouping();
                }
                _enableGroupingOnMaxWidthChange(t) {
                    t.on("change:maxWidth", ()=>{
                        this._updateGrouping();
                    });
                }
                _groupLastItem() {
                    if (!this.groupedItems.length) {
                        this.viewChildren.add(new Du);
                        this.viewChildren.add(this.groupedItemsDropdown);
                        this.viewFocusTracker.add(this.groupedItemsDropdown.element);
                    }
                    this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
                }
                _ungroupFirstItem() {
                    this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first));
                    if (!this.groupedItems.length) {
                        this.viewChildren.remove(this.groupedItemsDropdown);
                        this.viewChildren.remove(this.viewChildren.last);
                        this.viewFocusTracker.remove(this.groupedItemsDropdown.element);
                    }
                }
                _createGroupedItemsDropdown() {
                    const t = this.viewLocale;
                    const e = t.t;
                    const n = by(t);
                    n.class = "ck-toolbar__grouped-dropdown";
                    n.panelPosition = t.uiLanguageDirection === "ltr" ? "sw" : "se";
                    wy(n, this.groupedItems);
                    n.buttonView.set({
                        label: e("Show more items"),
                        tooltip: true,
                        tooltipPosition: t.uiLanguageDirection === "rtl" ? "se" : "sw",
                        icon: $C
                    });
                    return n;
                }
                _updateFocusCycleableItems() {
                    this.viewFocusables.clear();
                    this.ungroupedItems.map((t)=>{
                        this.viewFocusables.add(t);
                    });
                    if (this.groupedItems.length) this.viewFocusables.add(this.groupedItemsDropdown);
                }
            }
            class YC extends zl {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    const n = `ck-editor__label_${S()}`;
                    const o = new ny(t);
                    this.children = this.createCollection();
                    this.children.addMany([
                        this._createLabel(n),
                        o
                    ]);
                    this.set({
                        label: "",
                        isVisible: true
                    });
                    o.set({
                        role: "group",
                        ariaLabelledBy: n
                    });
                    o.focusTracker.destroy();
                    o.keystrokes.destroy();
                    this.items = o.items;
                    this.setTemplate({
                        tag: "li",
                        attributes: {
                            role: "presentation",
                            class: [
                                "ck",
                                "ck-list__group",
                                e.if("isVisible", "ck-hidden", (t)=>!t)
                            ]
                        },
                        children: this.children
                    });
                }
                _createLabel(t) {
                    const e = new zl(this.locale);
                    const n = this.bindTemplate;
                    e.setTemplate({
                        tag: "span",
                        attributes: {
                            id: t
                        },
                        children: [
                            {
                                text: n.to("label")
                            }
                        ]
                    });
                    return e;
                }
                focus() {
                    if (this.items.first) this.items.first.focus();
                }
            }
            var QC = n(179);
            var XC = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            XC.insert = "head";
            XC.singleton = true;
            var ty = Rl()(QC.Z, XC);
            const ey = QC.Z.locals || {};
            class ny extends zl {
                constructor(t){
                    super(t);
                    this._listItemGroupToChangeListeners = new WeakMap;
                    const e = this.bindTemplate;
                    this.focusables = new Bl;
                    this.items = this.createCollection();
                    this.focusTracker = new pl;
                    this.keystrokes = new gl;
                    this._focusCycler = new xu({
                        focusables: this.focusables,
                        focusTracker: this.focusTracker,
                        keystrokeHandler: this.keystrokes,
                        actions: {
                            focusPrevious: "arrowup",
                            focusNext: "arrowdown"
                        }
                    });
                    this.set("ariaLabel", undefined);
                    this.set("ariaLabelledBy", undefined);
                    this.set("role", undefined);
                    this.setTemplate({
                        tag: "ul",
                        attributes: {
                            class: [
                                "ck",
                                "ck-reset",
                                "ck-list"
                            ],
                            role: e.to("role"),
                            "aria-label": e.to("ariaLabel"),
                            "aria-labelledby": e.to("ariaLabelledBy")
                        },
                        children: this.items
                    });
                }
                render() {
                    super.render();
                    for (const t of this.items)if (t instanceof YC) this._registerFocusableItemsGroup(t);
                    else this._registerFocusableListItem(t);
                    this.items.on("change", (t, e)=>{
                        for (const t of e.removed)if (t instanceof YC) this._deregisterFocusableItemsGroup(t);
                        else this._deregisterFocusableListItem(t);
                        for (const t of Array.from(e.added).reverse())if (t instanceof YC) this._registerFocusableItemsGroup(t, e.index);
                        else this._registerFocusableListItem(t, e.index);
                    });
                    this.keystrokes.listenTo(this.element);
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                }
                focus() {
                    this._focusCycler.focusFirst();
                }
                focusFirst() {
                    this._focusCycler.focusFirst();
                }
                focusLast() {
                    this._focusCycler.focusLast();
                }
                _registerFocusableListItem(t, e) {
                    this.focusTracker.add(t.element);
                    this.focusables.add(t, e);
                }
                _deregisterFocusableListItem(t) {
                    this.focusTracker.remove(t.element);
                    this.focusables.remove(t);
                }
                _getOnGroupItemsChangeCallback(t) {
                    return (e, n)=>{
                        for (const t of n.removed)this._deregisterFocusableListItem(t);
                        for (const e of Array.from(n.added).reverse())this._registerFocusableListItem(e, this.items.getIndex(t) + n.index);
                    };
                }
                _registerFocusableItemsGroup(t, e) {
                    Array.from(t.items).forEach((t, n)=>{
                        const o = typeof e !== "undefined" ? e + n : undefined;
                        this._registerFocusableListItem(t, o);
                    });
                    const n = this._getOnGroupItemsChangeCallback(t);
                    this._listItemGroupToChangeListeners.set(t, n);
                    t.items.on("change", n);
                }
                _deregisterFocusableItemsGroup(t) {
                    for (const e of t.items)this._deregisterFocusableListItem(e);
                    t.items.off("change", this._listItemGroupToChangeListeners.get(t));
                    this._listItemGroupToChangeListeners.delete(t);
                }
            }
            class oy extends zl {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.set("isVisible", true);
                    this.children = this.createCollection();
                    this.setTemplate({
                        tag: "li",
                        attributes: {
                            class: [
                                "ck",
                                "ck-list__item",
                                e.if("isVisible", "ck-hidden", (t)=>!t)
                            ],
                            role: "presentation"
                        },
                        children: this.children
                    });
                }
                focus() {
                    if (this.children.first) this.children.first.focus();
                }
            }
            class iy extends zl {
                constructor(t){
                    super(t);
                    this.setTemplate({
                        tag: "li",
                        attributes: {
                            class: [
                                "ck",
                                "ck-list__separator"
                            ]
                        }
                    });
                }
            }
            var ry = n(4791);
            var sy = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            sy.insert = "head";
            sy.singleton = true;
            var ay = Rl()(ry.Z, sy);
            const cy = ry.Z.locals || {};
            class ly extends zl {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.set("class", undefined);
                    this.set("labelStyle", undefined);
                    this.set("icon", undefined);
                    this.set("isEnabled", true);
                    this.set("isOn", false);
                    this.set("isToggleable", false);
                    this.set("isVisible", true);
                    this.set("keystroke", undefined);
                    this.set("withKeystroke", false);
                    this.set("label", undefined);
                    this.set("tabindex", -1);
                    this.set("tooltip", false);
                    this.set("tooltipPosition", "s");
                    this.set("type", "button");
                    this.set("withText", false);
                    this.children = this.createCollection();
                    this.actionView = this._createActionView();
                    this.arrowView = this._createArrowView();
                    this.keystrokes = new gl;
                    this.focusTracker = new pl;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-splitbutton",
                                e.to("class"),
                                e.if("isVisible", "ck-hidden", (t)=>!t),
                                this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")
                            ]
                        },
                        children: this.children
                    });
                }
                render() {
                    super.render();
                    this.children.add(this.actionView);
                    this.children.add(this.arrowView);
                    this.focusTracker.add(this.actionView.element);
                    this.focusTracker.add(this.arrowView.element);
                    this.keystrokes.listenTo(this.element);
                    this.keystrokes.set("arrowright", (t, e)=>{
                        if (this.focusTracker.focusedElement === this.actionView.element) {
                            this.arrowView.focus();
                            e();
                        }
                    });
                    this.keystrokes.set("arrowleft", (t, e)=>{
                        if (this.focusTracker.focusedElement === this.arrowView.element) {
                            this.actionView.focus();
                            e();
                        }
                    });
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                }
                focus() {
                    this.actionView.focus();
                }
                _createActionView() {
                    const t = new yd;
                    t.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this);
                    t.extendTemplate({
                        attributes: {
                            class: "ck-splitbutton__action"
                        }
                    });
                    t.delegate("execute").to(this);
                    return t;
                }
                _createArrowView() {
                    const t = new yd;
                    const e = t.bindTemplate;
                    t.icon = Cu;
                    t.extendTemplate({
                        attributes: {
                            class: [
                                "ck-splitbutton__arrow"
                            ],
                            "data-cke-tooltip-disabled": e.to("isOn"),
                            "aria-haspopup": true,
                            "aria-expanded": e.to("isOn", (t)=>String(t))
                        }
                    });
                    t.bind("isEnabled").to(this);
                    t.bind("label").to(this);
                    t.bind("tooltip").to(this);
                    t.delegate("execute").to(this, "open");
                    return t;
                }
            }
            var dy = n(2704);
            var uy = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            uy.insert = "head";
            uy.singleton = true;
            var hy = Rl()(dy.Z, uy);
            const fy = dy.Z.locals || {};
            var py = n(1883);
            var gy = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            gy.insert = "head";
            gy.singleton = true;
            var my = Rl()(py.Z, gy);
            const ky = py.Z.locals || {};
            function by(t, e = yu) {
                const n = new e(t);
                const o = new ku(t);
                const i = new vu(t, n, o);
                n.bind("isEnabled").to(i);
                if (n instanceof ly) n.arrowView.bind("isOn").to(i, "isOpen");
                else n.bind("isOn").to(i, "isOpen");
                yy(i);
                return i;
            }
            function wy(t, e, n = {}) {
                t.extendTemplate({
                    attributes: {
                        class: [
                            "ck-toolbar-dropdown"
                        ]
                    }
                });
                if (t.isOpen) _y(t, e, n);
                else t.once("change:isOpen", ()=>_y(t, e, n), {
                    priority: "highest"
                });
                if (n.enableActiveItemFocusOnDropdownOpen) Cy(t, ()=>t.toolbarView.items.find((t)=>t.isOn));
            }
            function _y(t, e, n) {
                const o = t.locale;
                const i = o.t;
                const r = t.toolbarView = new UC(o);
                const s = typeof e == "function" ? e() : e;
                r.ariaLabel = n.ariaLabel || i("Dropdown toolbar");
                if (n.maxWidth) r.maxWidth = n.maxWidth;
                if (n.class) r.class = n.class;
                if (n.isCompact) r.isCompact = n.isCompact;
                if (n.isVertical) r.isVertical = true;
                if (s instanceof Bl) r.items.bindTo(s).using((t)=>t);
                else r.items.addMany(s);
                t.panelView.children.add(r);
                r.items.delegate("execute").to(t);
            }
            function Ay(t, e, n = {}) {
                if (t.isOpen) vy(t, e, n);
                else t.once("change:isOpen", ()=>vy(t, e, n), {
                    priority: "highest"
                });
                Cy(t, ()=>t.listView.items.find((t)=>{
                        if (t instanceof oy) return t.children.first.isOn;
                        return false;
                    }));
            }
            function vy(t, e, n) {
                const o = t.locale;
                const i = t.listView = new ny(o);
                const r = typeof e == "function" ? e() : e;
                i.ariaLabel = n.ariaLabel;
                i.role = n.role;
                Py(t, i.items, r, o);
                t.panelView.children.add(i);
                i.items.delegate("execute").to(t);
            }
            function Cy(t, e) {
                t.on("change:isOpen", ()=>{
                    if (!t.isOpen) return;
                    const n = e();
                    if (!n) return;
                    if (typeof n.focus === "function") n.focus();
                    else O("ui-dropdown-focus-child-on-open-child-missing-focus", {
                        view: n
                    });
                }, {
                    priority: B.low - 10
                });
            }
            function yy(t) {
                xy(t);
                Ey(t);
                Dy(t);
                Sy(t);
                Ty(t);
                By(t);
            }
            function xy(e) {
                e.on("render", ()=>{
                    t({
                        emitter: e,
                        activator: ()=>e.isOpen,
                        callback: ()=>{
                            e.isOpen = false;
                        },
                        contextElements: ()=>[
                                e.element,
                                ...e.focusTracker._elements
                            ]
                    });
                });
            }
            function Ey(t) {
                t.on("execute", (e)=>{
                    if (e.source instanceof Td) return;
                    t.isOpen = false;
                });
            }
            function Dy(t) {
                t.focusTracker.on("change:isFocused", (e, n, o)=>{
                    if (t.isOpen && !o) t.isOpen = false;
                });
            }
            function Sy(t) {
                t.keystrokes.set("arrowdown", (e, n)=>{
                    if (t.isOpen) {
                        t.panelView.focus();
                        n();
                    }
                });
                t.keystrokes.set("arrowup", (e, n)=>{
                    if (t.isOpen) {
                        t.panelView.focusLast();
                        n();
                    }
                });
            }
            function Ty(t) {
                t.on("change:isOpen", (e, n, o)=>{
                    if (o) return;
                    const i = t.panelView.element;
                    if (i && i.contains(ec.document.activeElement)) t.buttonView.focus();
                });
            }
            function By(t) {
                t.on("change:isOpen", (e, n, o)=>{
                    if (!o) return;
                    t.panelView.focus();
                }, {
                    priority: "low"
                });
            }
            function Py(t, e, n, o) {
                e.bindTo(n).using((e)=>{
                    if (e.type === "separator") return new iy(o);
                    else if (e.type === "group") {
                        const n = new YC(o);
                        n.set({
                            label: e.label
                        });
                        Py(t, n.items, e.items, o);
                        n.items.delegate("execute").to(t);
                        return n;
                    } else if (e.type === "button" || e.type === "switchbutton") {
                        const t = new oy(o);
                        let n;
                        if (e.type === "button") n = new yd(o);
                        else n = new Td(o);
                        n.bind(...Object.keys(e.model)).to(e.model);
                        n.delegate("execute").to(t);
                        t.children.add(n);
                        return t;
                    }
                    return null;
                });
            }
            const Iy = (t, e, n)=>{
                const o = new lu(t.locale);
                o.set({
                    id: e,
                    ariaDescribedById: n
                });
                o.bind("isReadOnly").to(t, "isEnabled", (t)=>!t);
                o.bind("hasError").to(t, "errorText", (t)=>!!t);
                o.on("input", ()=>{
                    t.errorText = null;
                });
                t.bind("isEmpty", "isFocused", "placeholder").to(o);
                return o;
            };
            const Ry = (t, e, n)=>{
                const o = new InputNumberView(t.locale);
                o.set({
                    id: e,
                    ariaDescribedById: n,
                    inputMode: "numeric"
                });
                o.bind("isReadOnly").to(t, "isEnabled", (t)=>!t);
                o.bind("hasError").to(t, "errorText", (t)=>!!t);
                o.on("input", ()=>{
                    t.errorText = null;
                });
                t.bind("isEmpty", "isFocused", "placeholder").to(o);
                return o;
            };
            const Oy = (t, e, n)=>{
                const o = new TextareaView(t.locale);
                o.set({
                    id: e,
                    ariaDescribedById: n
                });
                o.bind("isReadOnly").to(t, "isEnabled", (t)=>!t);
                o.bind("hasError").to(t, "errorText", (t)=>!!t);
                o.on("input", ()=>{
                    t.errorText = null;
                });
                t.bind("isEmpty", "isFocused", "placeholder").to(o);
                return o;
            };
            const Vy = (t, e, n)=>{
                const o = createDropdown(t.locale);
                o.set({
                    id: e,
                    ariaDescribedById: n
                });
                o.bind("isEnabled").to(t);
                return o;
            };
            const My = (t, e = 0, n = 1)=>t > n ? n : t < e ? e : t;
            const Ly = (t, e = 0, n = Math.pow(10, e))=>Math.round(n * t) / n;
            const zy = {
                grad: 0.9,
                turn: 360,
                rad: 360 / (Math.PI * 2)
            };
            const Ny = (t)=>sx(Fy(t));
            const Fy = (t)=>{
                if (t[0] === "#") t = t.substring(1);
                if (t.length < 6) return {
                    r: parseInt(t[0] + t[0], 16),
                    g: parseInt(t[1] + t[1], 16),
                    b: parseInt(t[2] + t[2], 16),
                    a: t.length === 4 ? Ly(parseInt(t[3] + t[3], 16) / 255, 2) : 1
                };
                return {
                    r: parseInt(t.substring(0, 2), 16),
                    g: parseInt(t.substring(2, 4), 16),
                    b: parseInt(t.substring(4, 6), 16),
                    a: t.length === 8 ? Ly(parseInt(t.substring(6, 8), 16) / 255, 2) : 1
                };
            };
            const Hy = (t, e = "deg")=>Number(t) * (zy[e] || 1);
            const jy = (t)=>{
                const e = /hsla?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
                const n = e.exec(t);
                if (!n) return {
                    h: 0,
                    s: 0,
                    v: 0,
                    a: 1
                };
                return Wy({
                    h: Hy(n[1], n[2]),
                    s: Number(n[3]),
                    l: Number(n[4]),
                    a: n[5] === undefined ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
            };
            const qy = null;
            const Wy = ({ h: t, s: e, l: n, a: o })=>{
                e *= (n < 50 ? n : 100 - n) / 100;
                return {
                    h: t,
                    s: e > 0 ? 2 * e / (n + e) * 100 : 0,
                    v: n + e,
                    a: o
                };
            };
            const $y = (t)=>rx(Yy(t));
            const Gy = ({ h: t, s: e, v: n, a: o })=>{
                const i = (200 - e) * n / 100;
                return {
                    h: Ly(t),
                    s: Ly(i > 0 && i < 200 ? e * n / 100 / (i <= 100 ? i : 200 - i) * 100 : 0),
                    l: Ly(i / 2),
                    a: Ly(o, 2)
                };
            };
            const Uy = (t)=>{
                const { h: e, s: n, v: o } = ax(t);
                return `hsv(${e}, ${n}%, ${o}%)`;
            };
            const Ky = (t)=>{
                const { h: e, s: n, v: o, a: i } = ax(t);
                return `hsva(${e}, ${n}%, ${o}%, ${i})`;
            };
            const Zy = (t)=>{
                const { h: e, s: n, l: o } = Gy(t);
                return `hsl(${e}, ${n}%, ${o}%)`;
            };
            const Jy = (t)=>{
                const { h: e, s: n, l: o, a: i } = Gy(t);
                return `hsla(${e}, ${n}%, ${o}%, ${i})`;
            };
            const Yy = ({ h: t, s: e, v: n, a: o })=>{
                t = t / 360 * 6;
                e = e / 100;
                n = n / 100;
                const i = Math.floor(t), r = n * (1 - e), s = n * (1 - (t - i) * e), a = n * (1 - (1 - t + i) * e), c = i % 6;
                return {
                    r: Ly([
                        n,
                        s,
                        r,
                        r,
                        a,
                        n
                    ][c] * 255),
                    g: Ly([
                        a,
                        n,
                        n,
                        s,
                        r,
                        r
                    ][c] * 255),
                    b: Ly([
                        r,
                        r,
                        a,
                        n,
                        n,
                        s
                    ][c] * 255),
                    a: Ly(o, 2)
                };
            };
            const Qy = (t)=>{
                const { r: e, g: n, b: o } = Yy(t);
                return `rgb(${e}, ${n}, ${o})`;
            };
            const Xy = (t)=>{
                const { r: e, g: n, b: o, a: i } = Yy(t);
                return `rgba(${e}, ${n}, ${o}, ${i})`;
            };
            const tx = (t)=>{
                const e = /hsva?\(?\s*(-?\d*\.?\d+)(deg|rad|grad|turn)?[,\s]+(-?\d*\.?\d+)%?[,\s]+(-?\d*\.?\d+)%?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
                const n = e.exec(t);
                if (!n) return {
                    h: 0,
                    s: 0,
                    v: 0,
                    a: 1
                };
                return ax({
                    h: Hy(n[1], n[2]),
                    s: Number(n[3]),
                    v: Number(n[4]),
                    a: n[5] === undefined ? 1 : Number(n[5]) / (n[6] ? 100 : 1)
                });
            };
            const ex = null;
            const nx = (t)=>{
                const e = /rgba?\(?\s*(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?[,\s]+(-?\d*\.?\d+)(%)?,?\s*[/\s]*(-?\d*\.?\d+)?(%)?\s*\)?/i;
                const n = e.exec(t);
                if (!n) return {
                    h: 0,
                    s: 0,
                    v: 0,
                    a: 1
                };
                return sx({
                    r: Number(n[1]) / (n[2] ? 100 / 255 : 1),
                    g: Number(n[3]) / (n[4] ? 100 / 255 : 1),
                    b: Number(n[5]) / (n[6] ? 100 / 255 : 1),
                    a: n[7] === undefined ? 1 : Number(n[7]) / (n[8] ? 100 : 1)
                });
            };
            const ox = null;
            const ix = (t)=>{
                const e = t.toString(16);
                return e.length < 2 ? "0" + e : e;
            };
            const rx = ({ r: t, g: e, b: n, a: o })=>{
                const i = o < 1 ? ix(Ly(o * 255)) : "";
                return "#" + ix(t) + ix(e) + ix(n) + i;
            };
            const sx = ({ r: t, g: e, b: n, a: o })=>{
                const i = Math.max(t, e, n);
                const r = i - Math.min(t, e, n);
                const s = r ? i === t ? (e - n) / r : i === e ? 2 + (n - t) / r : 4 + (t - e) / r : 0;
                return {
                    h: Ly(60 * (s < 0 ? s + 6 : s)),
                    s: Ly(i ? r / i * 100 : 0),
                    v: Ly(i / 255 * 100),
                    a: o
                };
            };
            const ax = (t)=>({
                    h: round(t.h),
                    s: round(t.s),
                    v: round(t.v),
                    a: round(t.a, 2)
                });
            const cx = ({ r: t, g: e, b: n })=>({
                    r: t,
                    g: e,
                    b: n
                });
            const lx = ({ h: t, s: e, l: n })=>({
                    h: t,
                    s: e,
                    l: n
                });
            const dx = (t)=>{
                const { h: e, s: n, v: o } = ax(t);
                return {
                    h: e,
                    s: n,
                    v: o
                };
            };
            const ux = (t, e)=>{
                if (t === e) return true;
                for(const n in t){
                    if (t[n] !== e[n]) return false;
                }
                return true;
            };
            const hx = (t, e)=>t.replace(/\s/g, "") === e.replace(/\s/g, "");
            const fx = (t, e)=>{
                if (t.toLowerCase() === e.toLowerCase()) return true;
                return ux(Fy(t), Fy(e));
            };
            const px = {};
            const gx = (t)=>{
                let e = px[t];
                if (!e) {
                    e = document.createElement("template");
                    e.innerHTML = t;
                    px[t] = e;
                }
                return e;
            };
            const mx = (t, e, n)=>{
                t.dispatchEvent(new CustomEvent(e, {
                    bubbles: true,
                    detail: n
                }));
            };
            let kx = false;
            const bx = (t)=>"touches" in t;
            const wx = (t)=>{
                if (kx && !bx(t)) return false;
                if (!kx) kx = bx(t);
                return true;
            };
            const _x = (t, e)=>{
                const n = bx(e) ? e.touches[0] : e;
                const o = t.el.getBoundingClientRect();
                mx(t.el, "move", t.getMove({
                    x: My((n.pageX - (o.left + window.pageXOffset)) / o.width),
                    y: My((n.pageY - (o.top + window.pageYOffset)) / o.height)
                }));
            };
            const Ax = (t, e)=>{
                const n = e.keyCode;
                if (n > 40 || t.xy && n < 37 || n < 33) return;
                e.preventDefault();
                mx(t.el, "move", t.getMove({
                    x: n === 39 ? .01 : n === 37 ? -0.01 : n === 34 ? .05 : n === 33 ? -0.05 : n === 35 ? 1 : n === 36 ? -1 : 0,
                    y: n === 40 ? .01 : n === 38 ? -0.01 : 0
                }, true));
            };
            class vx {
                constructor(t, e, n, o){
                    const i = gx(`<div role="slider" tabindex="0" part="${e}" ${n}><div part="${e}-pointer"></div></div>`);
                    t.appendChild(i.content.cloneNode(true));
                    const r = t.querySelector(`[part=${e}]`);
                    r.addEventListener("mousedown", this);
                    r.addEventListener("touchstart", this);
                    r.addEventListener("keydown", this);
                    this.el = r;
                    this.xy = o;
                    this.nodes = [
                        r.firstChild,
                        r
                    ];
                }
                set dragging(t) {
                    const e = t ? document.addEventListener : document.removeEventListener;
                    e(kx ? "touchmove" : "mousemove", this);
                    e(kx ? "touchend" : "mouseup", this);
                }
                handleEvent(t) {
                    switch(t.type){
                        case "mousedown":
                        case "touchstart":
                            t.preventDefault();
                            if (!wx(t) || !kx && t.button != 0) return;
                            this.el.focus();
                            _x(this, t);
                            this.dragging = true;
                            break;
                        case "mousemove":
                        case "touchmove":
                            t.preventDefault();
                            _x(this, t);
                            break;
                        case "mouseup":
                        case "touchend":
                            this.dragging = false;
                            break;
                        case "keydown":
                            Ax(this, t);
                            break;
                    }
                }
                style(t) {
                    t.forEach((t, e)=>{
                        for(const n in t)this.nodes[e].style.setProperty(n, t[n]);
                    });
                }
            }
            class Cx extends vx {
                constructor(t){
                    super(t, "hue", 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', false);
                }
                update({ h: t }) {
                    this.h = t;
                    this.style([
                        {
                            left: `${t / 360 * 100}%`,
                            color: Zy({
                                h: t,
                                s: 100,
                                v: 100,
                                a: 1
                            })
                        }
                    ]);
                    this.el.setAttribute("aria-valuenow", `${Ly(t)}`);
                }
                getMove(t, e) {
                    return {
                        h: e ? My(this.h + t.x * 360, 0, 360) : 360 * t.x
                    };
                }
            }
            class yx extends vx {
                constructor(t){
                    super(t, "saturation", 'aria-label="Color"', true);
                }
                update(t) {
                    this.hsva = t;
                    this.style([
                        {
                            top: `${100 - t.v}%`,
                            left: `${t.s}%`,
                            color: Zy(t)
                        },
                        {
                            "background-color": Zy({
                                h: t.h,
                                s: 100,
                                v: 100,
                                a: 1
                            })
                        }
                    ]);
                    this.el.setAttribute("aria-valuetext", `Saturation ${Ly(t.s)}%, Brightness ${Ly(t.v)}%`);
                }
                getMove(t, e) {
                    return {
                        s: e ? My(this.hsva.s + t.x * 100, 0, 100) : t.x * 100,
                        v: e ? My(this.hsva.v - t.y * 100, 0, 100) : Math.round(100 - t.y * 100)
                    };
                }
            }
            const xx = `:host{display:flex;flex-direction:column;position:relative;width:200px;height:200px;user-select:none;-webkit-user-select:none;cursor:default}:host([hidden]){display:none!important}[role=slider]{position:relative;touch-action:none;user-select:none;-webkit-user-select:none;outline:0}[role=slider]:last-child{border-radius:0 0 8px 8px}[part$=pointer]{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;display:flex;place-content:center center;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}[part$=pointer]::after{content:"";width:100%;height:100%;border-radius:inherit;background-color:currentColor}[role=slider]:focus [part$=pointer]{transform:translate(-50%,-50%) scale(1.1)}`;
            const Ex = `[part=hue]{flex:0 0 24px;background:linear-gradient(to right,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%)}[part=hue-pointer]{top:50%;z-index:2}`;
            const Dx = `[part=saturation]{flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,rgba(255,255,255,0));box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part=saturation-pointer]{z-index:3}`;
            const Sx = Symbol("same");
            const Tx = Symbol("color");
            const Bx = Symbol("hsva");
            const Px = Symbol("update");
            const Ix = Symbol("parts");
            const Rx = Symbol("css");
            const Ox = Symbol("sliders");
            class Vx extends HTMLElement {
                static get observedAttributes() {
                    return [
                        "color"
                    ];
                }
                get [Rx]() {
                    return [
                        xx,
                        Ex,
                        Dx
                    ];
                }
                get [Ox]() {
                    return [
                        yx,
                        Cx
                    ];
                }
                get color() {
                    return this[Tx];
                }
                set color(t) {
                    if (!this[Sx](t)) {
                        const e = this.colorModel.toHsva(t);
                        this[Px](e);
                        this[Tx] = t;
                    }
                }
                constructor(){
                    super();
                    const t = gx(`<style>${this[Rx].join("")}</style>`);
                    const e = this.attachShadow({
                        mode: "open"
                    });
                    e.appendChild(t.content.cloneNode(true));
                    e.addEventListener("move", this);
                    this[Ix] = this[Ox].map((t)=>new t(e));
                }
                connectedCallback() {
                    if (this.hasOwnProperty("color")) {
                        const t = this.color;
                        delete this["color"];
                        this.color = t;
                    } else if (!this.color) this.color = this.colorModel.defaultColor;
                }
                attributeChangedCallback(t, e, n) {
                    const o = this.colorModel.fromAttr(n);
                    if (!this[Sx](o)) this.color = o;
                }
                handleEvent(t) {
                    const e = this[Bx];
                    const n = {
                        ...e,
                        ...t.detail
                    };
                    this[Px](n);
                    let o;
                    if (!ux(n, e) && !this[Sx](o = this.colorModel.fromHsva(n))) {
                        this[Tx] = o;
                        mx(this, "color-changed", {
                            value: o
                        });
                    }
                }
                [Sx](t) {
                    return this.color && this.colorModel.equal(t, this.color);
                }
                [Px](t) {
                    this[Bx] = t;
                    this[Ix].forEach((e)=>e.update(t));
                }
            }
            const Mx = {
                defaultColor: "#000",
                toHsva: Ny,
                fromHsva: ({ h: t, s: e, v: n })=>$y({
                        h: t,
                        s: e,
                        v: n,
                        a: 1
                    }),
                equal: fx,
                fromAttr: (t)=>t
            };
            class Lx extends Vx {
                get colorModel() {
                    return Mx;
                }
            }
            class zx extends Lx {
            }
            customElements.define("hex-color-picker", zx);
            var Nx = n(4257);
            var Fx = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Fx.insert = "head";
            Fx.singleton = true;
            var Hx = Rl()(Nx.Z, Fx);
            const jx = Nx.Z.locals || {};
            const qx = 150;
            class Wx extends null {
                constructor(t, e = {}){
                    super(t);
                    this.set({
                        color: "",
                        _hexColor: ""
                    });
                    this.hexInputRow = this._createInputRow();
                    const n = this.createCollection();
                    if (!e.hideInput) n.add(this.hexInputRow);
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-color-picker"
                            ],
                            tabindex: -1
                        },
                        children: n
                    });
                    this._config = e;
                    this._debounceColorPickerEvent = debounce((t)=>{
                        this.set("color", t);
                        this.fire("colorSelected", {
                            color: this.color
                        });
                    }, qx, {
                        leading: true
                    });
                    this.on("set:color", (t, e, n)=>{
                        t.return = convertColor(n, this._config.format || "hsl");
                    });
                    this.on("change:color", ()=>{
                        this._hexColor = $x(this.color);
                    });
                    this.on("change:_hexColor", ()=>{
                        if (document.activeElement !== this.picker) this.picker.setAttribute("color", this._hexColor);
                        if ($x(this.color) != $x(this._hexColor)) this.color = this._hexColor;
                    });
                }
                render() {
                    super.render();
                    this.picker = $parcel$global.document.createElement("hex-color-picker");
                    this.picker.setAttribute("class", "hex-color-picker");
                    this.picker.setAttribute("tabindex", "-1");
                    this._createSlidersView();
                    if (this.element) {
                        if (this.hexInputRow.element) this.element.insertBefore(this.picker, this.hexInputRow.element);
                        else this.element.appendChild(this.picker);
                        const t = document.createElement("style");
                        t.textContent = '[role="slider"]:focus [part$="pointer"] {border: 1px solid #fff;outline: 1px solid var(--ck-color-focus-border);box-shadow: 0 0 0 2px #fff;}';
                        this.picker.shadowRoot.appendChild(t);
                    }
                    this.picker.addEventListener("color-changed", (t)=>{
                        const e = t;
                        const n = e.detail.value;
                        this._debounceColorPickerEvent(n);
                    });
                }
                focus() {
                    if (!this._config.hideInput && (env.isGecko || env.isiOS || env.isSafari)) {
                        const t = this.hexInputRow.children.get(1);
                        t.focus();
                    }
                    const t = this.slidersView.first;
                    t.focus();
                }
                _createSlidersView() {
                    const t = [
                        ...this.picker.shadowRoot.children
                    ];
                    const e = t.filter((t)=>t.getAttribute("role") === "slider");
                    const n = e.map((t)=>{
                        const e = new Gx(t);
                        return e;
                    });
                    this.slidersView = this.createCollection();
                    n.forEach((t)=>{
                        this.slidersView.add(t);
                    });
                }
                _createInputRow() {
                    const t = new Ux;
                    const e = this._createColorInput();
                    return new Kx(this.locale, [
                        t,
                        e
                    ]);
                }
                _createColorInput() {
                    const t = new LabeledFieldView(this.locale, createLabeledInputText);
                    const { t: e } = this.locale;
                    t.set({
                        label: e("HEX"),
                        class: "color-picker-hex-input"
                    });
                    t.fieldView.bind("value").to(this, "_hexColor", (e)=>{
                        if (t.isFocused) return t.fieldView.value;
                        else return e.startsWith("#") ? e.substring(1) : e;
                    });
                    t.fieldView.on("input", ()=>{
                        const e = t.fieldView.element.value;
                        if (e) {
                            const t = e.trim();
                            const n = t.startsWith("#") ? t.substring(1) : t;
                            const o = [
                                3,
                                4,
                                6,
                                8
                            ].includes(n.length) && /(([0-9a-fA-F]{2}){3,4}|([0-9a-fA-F]){3,4})/.test(n);
                            if (o) this._debounceColorPickerEvent("#" + n);
                        }
                    });
                    return t;
                }
            }
            function $x(t) {
                let e = convertToHex(t);
                if (!e) e = "#000";
                if (e.length === 4) e = "#" + [
                    e[1],
                    e[1],
                    e[2],
                    e[2],
                    e[3],
                    e[3]
                ].join("");
                return e.toLowerCase();
            }
            class Gx extends null {
                constructor(t){
                    super();
                    this.element = t;
                }
                focus() {
                    this.element.focus();
                }
            }
            class Ux extends null {
                constructor(t){
                    super(t);
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-color-picker__hash-view"
                            ]
                        },
                        children: "#"
                    });
                }
            }
            class Kx extends null {
                constructor(t, e){
                    super(t);
                    this.children = this.createCollection(e);
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-color-picker__row"
                            ]
                        },
                        children: this.children
                    });
                }
            }
            class Zx extends ht(hl) {
                constructor(t){
                    super(t);
                    this.set("isEmpty", true);
                    this.on("change", ()=>{
                        this.set("isEmpty", this.length === 0);
                    });
                }
                add(t, e) {
                    if (this.find((e)=>e.color === t.color)) return this;
                    return super.add(t, e);
                }
                hasColor(t) {
                    return !!this.find((e)=>e.color === t);
                }
            }
            class Jx extends null {
                constructor(t, { colors: e, columns: n, removeButtonLabel: o, documentColorsLabel: i, documentColorsCount: r, colorPickerLabel: s, focusTracker: a, focusables: c }){
                    super(t);
                    const l = this.bindTemplate;
                    this.set("isVisible", true);
                    this.focusTracker = a;
                    this.items = this.createCollection();
                    this.colorDefinitions = e;
                    this.columns = n;
                    this.documentColors = new DocumentColorCollection;
                    this.documentColorsCount = r;
                    this._focusables = c;
                    this._removeButtonLabel = o;
                    this._colorPickerLabel = s;
                    this._documentColorsLabel = i;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck-color-grids-fragment",
                                l.if("isVisible", "ck-hidden", (t)=>!t)
                            ]
                        },
                        children: this.items
                    });
                    this.removeColorButtonView = this._createRemoveColorButton();
                    this.items.add(this.removeColorButtonView);
                }
                updateDocumentColors(t, e) {
                    const n = t.document;
                    const o = this.documentColorsCount;
                    this.documentColors.clear();
                    for (const i of n.getRoots()){
                        const n = t.createRangeIn(i);
                        for (const t of n.getItems())if (t.is("$textProxy") && t.hasAttribute(e)) {
                            this._addColorToDocumentColors(t.getAttribute(e));
                            if (this.documentColors.length >= o) return;
                        }
                    }
                }
                updateSelectedColors() {
                    const t = this.documentColorsGrid;
                    const e = this.staticColorsGrid;
                    const n = this.selectedColor;
                    e.selectedColor = n;
                    if (t) t.selectedColor = n;
                }
                render() {
                    super.render();
                    this.staticColorsGrid = this._createStaticColorsGrid();
                    this.items.add(this.staticColorsGrid);
                    if (this.documentColorsCount) {
                        const t = Template.bind(this.documentColors, this.documentColors);
                        const e = new LabelView(this.locale);
                        e.text = this._documentColorsLabel;
                        e.extendTemplate({
                            attributes: {
                                class: [
                                    "ck",
                                    "ck-color-grid__label",
                                    t.if("isEmpty", "ck-hidden")
                                ]
                            }
                        });
                        this.items.add(e);
                        this.documentColorsGrid = this._createDocumentColorsGrid();
                        this.items.add(this.documentColorsGrid);
                    }
                    this._createColorPickerButton();
                    this._addColorSelectorElementsToFocusTracker();
                    this.focus();
                }
                focus() {
                    this.removeColorButtonView.focus();
                }
                destroy() {
                    super.destroy();
                }
                addColorPickerButton() {
                    if (this.colorPickerButtonView) {
                        this.items.add(this.colorPickerButtonView);
                        this.focusTracker.add(this.colorPickerButtonView.element);
                        this._focusables.add(this.colorPickerButtonView);
                    }
                }
                _addColorSelectorElementsToFocusTracker() {
                    this.focusTracker.add(this.removeColorButtonView.element);
                    this._focusables.add(this.removeColorButtonView);
                    if (this.staticColorsGrid) {
                        this.focusTracker.add(this.staticColorsGrid.element);
                        this._focusables.add(this.staticColorsGrid);
                    }
                    if (this.documentColorsGrid) {
                        this.focusTracker.add(this.documentColorsGrid.element);
                        this._focusables.add(this.documentColorsGrid);
                    }
                }
                _createColorPickerButton() {
                    this.colorPickerButtonView = new ButtonView;
                    this.colorPickerButtonView.set({
                        label: this._colorPickerLabel,
                        withText: true,
                        icon: colorPaletteIcon,
                        class: "ck-color-selector__color-picker"
                    });
                    this.colorPickerButtonView.on("execute", ()=>{
                        this.fire("colorPicker:show");
                    });
                }
                _createRemoveColorButton() {
                    const t = new ButtonView;
                    t.set({
                        withText: true,
                        icon: removeButtonIcon,
                        label: this._removeButtonLabel
                    });
                    t.class = "ck-color-selector__remove-color";
                    t.on("execute", ()=>{
                        this.fire("execute", {
                            value: null,
                            source: "removeColorButton"
                        });
                    });
                    t.render();
                    return t;
                }
                _createStaticColorsGrid() {
                    const t = new ColorGridView(this.locale, {
                        colorDefinitions: this.colorDefinitions,
                        columns: this.columns
                    });
                    t.on("execute", (t, e)=>{
                        this.fire("execute", {
                            value: e.value,
                            source: "staticColorsGrid"
                        });
                    });
                    return t;
                }
                _createDocumentColorsGrid() {
                    const t = Template.bind(this.documentColors, this.documentColors);
                    const e = new ColorGridView(this.locale, {
                        columns: this.columns
                    });
                    e.extendTemplate({
                        attributes: {
                            class: t.if("isEmpty", "ck-hidden")
                        }
                    });
                    e.items.bindTo(this.documentColors).using((t)=>{
                        const e = new ColorTileView;
                        e.set({
                            color: t.color,
                            hasBorder: t.options && t.options.hasBorder
                        });
                        if (t.label) e.set({
                            label: t.label,
                            tooltip: true
                        });
                        e.on("execute", ()=>{
                            this.fire("execute", {
                                value: t.color,
                                source: "documentColorsGrid"
                            });
                        });
                        return e;
                    });
                    this.documentColors.on("change:isEmpty", (t, n, o)=>{
                        if (o) e.selectedColor = null;
                    });
                    return e;
                }
                _addColorToDocumentColors(t) {
                    const e = this.colorDefinitions.find((e)=>e.color === t);
                    if (!e) this.documentColors.add({
                        color: t,
                        label: t,
                        options: {
                            hasBorder: false
                        }
                    });
                    else this.documentColors.add(Object.assign({}, e));
                }
            }
            class Yx extends null {
                constructor(t, { focusTracker: e, focusables: n, keystrokes: o, colorPickerViewConfig: i }){
                    super(t);
                    this.items = this.createCollection();
                    this.focusTracker = e;
                    this.keystrokes = o;
                    this.set("isVisible", false);
                    this.set("selectedColor", undefined);
                    this._focusables = n;
                    this._colorPickerViewConfig = i;
                    const r = this.bindTemplate;
                    const { saveButtonView: s, cancelButtonView: a } = this._createActionButtons();
                    this.saveButtonView = s;
                    this.cancelButtonView = a;
                    this.actionBarView = this._createActionBarView({
                        saveButtonView: s,
                        cancelButtonView: a
                    });
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck-color-picker-fragment",
                                r.if("isVisible", "ck-hidden", (t)=>!t)
                            ]
                        },
                        children: this.items
                    });
                }
                render() {
                    super.render();
                    const t = new ColorPickerView(this.locale, {
                        ...this._colorPickerViewConfig
                    });
                    this.colorPickerView = t;
                    this.colorPickerView.render();
                    if (this.selectedColor) t.color = this.selectedColor;
                    this.listenTo(this, "change:selectedColor", (e, n, o)=>{
                        t.color = o;
                    });
                    this.items.add(this.colorPickerView);
                    this.items.add(this.actionBarView);
                    this._addColorPickersElementsToFocusTracker();
                    this._stopPropagationOnArrowsKeys();
                    this._executeOnEnterPress();
                    this._executeUponColorChange();
                }
                destroy() {
                    super.destroy();
                }
                focus() {
                    this.colorPickerView.focus();
                }
                _executeOnEnterPress() {
                    this.keystrokes.set("enter", (t)=>{
                        if (this.isVisible && this.focusTracker.focusedElement !== this.cancelButtonView.element) {
                            this.fire("execute", {
                                value: this.selectedColor
                            });
                            t.stopPropagation();
                            t.preventDefault();
                        }
                    });
                }
                _stopPropagationOnArrowsKeys() {
                    const t = (t)=>t.stopPropagation();
                    this.keystrokes.set("arrowright", t);
                    this.keystrokes.set("arrowleft", t);
                    this.keystrokes.set("arrowup", t);
                    this.keystrokes.set("arrowdown", t);
                }
                _addColorPickersElementsToFocusTracker() {
                    for (const t of this.colorPickerView.slidersView){
                        this.focusTracker.add(t.element);
                        this._focusables.add(t);
                    }
                    const t = this.colorPickerView.hexInputRow.children.get(1);
                    if (t.element) {
                        this.focusTracker.add(t.element);
                        this._focusables.add(t);
                    }
                    this.focusTracker.add(this.saveButtonView.element);
                    this._focusables.add(this.saveButtonView);
                    this.focusTracker.add(this.cancelButtonView.element);
                    this._focusables.add(this.cancelButtonView);
                }
                _createActionBarView({ saveButtonView: t, cancelButtonView: e }) {
                    const n = new View;
                    const o = this.createCollection();
                    o.add(t);
                    o.add(e);
                    n.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-color-selector_action-bar"
                            ]
                        },
                        children: o
                    });
                    return n;
                }
                _createActionButtons() {
                    const t = this.locale;
                    const e = t.t;
                    const n = new ButtonView(t);
                    const o = new ButtonView(t);
                    n.set({
                        icon: checkButtonIcon,
                        class: "ck-button-save",
                        type: "button",
                        withText: false,
                        label: e("Accept")
                    });
                    o.set({
                        icon: cancelButtonIcon,
                        class: "ck-button-cancel",
                        type: "button",
                        withText: false,
                        label: e("Cancel")
                    });
                    n.on("execute", ()=>{
                        this.fire("execute", {
                            source: "colorPickerSaveButton",
                            value: this.selectedColor
                        });
                    });
                    o.on("execute", ()=>{
                        this.fire("colorPicker:cancel");
                    });
                    return {
                        saveButtonView: n,
                        cancelButtonView: o
                    };
                }
                _executeUponColorChange() {
                    this.colorPickerView.on("colorSelected", (t, e)=>{
                        this.fire("execute", {
                            value: e.color,
                            source: "colorPicker"
                        });
                        this.set("selectedColor", e.color);
                    });
                }
            }
            var Qx = n(6306);
            var Xx = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            Xx.insert = "head";
            Xx.singleton = true;
            var tE = Rl()(Qx.Z, Xx);
            const eE = Qx.Z.locals || {};
            class nE extends null {
                constructor(t, { colors: e, columns: n, removeButtonLabel: o, documentColorsLabel: i, documentColorsCount: r, colorPickerLabel: s, colorPickerViewConfig: a }){
                    super(t);
                    this.items = this.createCollection();
                    this.focusTracker = new FocusTracker;
                    this.keystrokes = new KeystrokeHandler;
                    this._focusables = new ViewCollection;
                    this._colorPickerViewConfig = a;
                    this._focusCycler = new FocusCycler({
                        focusables: this._focusables,
                        focusTracker: this.focusTracker,
                        keystrokeHandler: this.keystrokes,
                        actions: {
                            focusPrevious: "shift + tab",
                            focusNext: "tab"
                        }
                    });
                    this.colorGridsFragmentView = new ColorGridsFragmentView(t, {
                        colors: e,
                        columns: n,
                        removeButtonLabel: o,
                        documentColorsLabel: i,
                        documentColorsCount: r,
                        colorPickerLabel: s,
                        focusTracker: this.focusTracker,
                        focusables: this._focusables
                    });
                    this.colorPickerFragmentView = new ColorPickerFragmentView(t, {
                        focusables: this._focusables,
                        focusTracker: this.focusTracker,
                        keystrokes: this.keystrokes,
                        colorPickerViewConfig: a
                    });
                    this.set("_isColorGridsFragmentVisible", true);
                    this.set("_isColorPickerFragmentVisible", false);
                    this.set("selectedColor", undefined);
                    this.colorGridsFragmentView.bind("isVisible").to(this, "_isColorGridsFragmentVisible");
                    this.colorPickerFragmentView.bind("isVisible").to(this, "_isColorPickerFragmentVisible");
                    this.on("change:selectedColor", (t, e, n)=>{
                        this.colorGridsFragmentView.set("selectedColor", n);
                        this.colorPickerFragmentView.set("selectedColor", n);
                    });
                    this.colorGridsFragmentView.on("change:selectedColor", (t, e, n)=>{
                        this.set("selectedColor", n);
                    });
                    this.colorPickerFragmentView.on("change:selectedColor", (t, e, n)=>{
                        this.set("selectedColor", n);
                    });
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-color-selector"
                            ]
                        },
                        children: this.items
                    });
                }
                render() {
                    super.render();
                    this.keystrokes.listenTo(this.element);
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                }
                appendUI() {
                    this._appendColorGridsFragment();
                    if (this._colorPickerViewConfig) this._appendColorPickerFragment();
                }
                showColorPickerFragment() {
                    if (!this.colorPickerFragmentView.colorPickerView || this._isColorPickerFragmentVisible) return;
                    this._isColorPickerFragmentVisible = true;
                    this.colorPickerFragmentView.focus();
                    this._isColorGridsFragmentVisible = false;
                }
                showColorGridsFragment() {
                    if (this._isColorGridsFragmentVisible) return;
                    this._isColorGridsFragmentVisible = true;
                    this.colorGridsFragmentView.focus();
                    this._isColorPickerFragmentVisible = false;
                }
                focus() {
                    this._focusCycler.focusFirst();
                }
                focusLast() {
                    this._focusCycler.focusLast();
                }
                updateDocumentColors(t, e) {
                    this.colorGridsFragmentView.updateDocumentColors(t, e);
                }
                updateSelectedColors() {
                    this.colorGridsFragmentView.updateSelectedColors();
                }
                _appendColorGridsFragment() {
                    if (this.items.length) return;
                    this.items.add(this.colorGridsFragmentView);
                    this.colorGridsFragmentView.delegate("execute").to(this);
                    this.colorGridsFragmentView.delegate("colorPicker:show").to(this);
                }
                _appendColorPickerFragment() {
                    if (this.items.length === 2) return;
                    this.items.add(this.colorPickerFragmentView);
                    if (this.colorGridsFragmentView.colorPickerButtonView) this.colorGridsFragmentView.colorPickerButtonView.on("execute", ()=>{
                        this.showColorPickerFragment();
                    });
                    this.colorGridsFragmentView.addColorPickerButton();
                    this.colorPickerFragmentView.delegate("execute").to(this);
                    this.colorPickerFragmentView.delegate("colorPicker:cancel").to(this);
                }
            }
            class oE {
                constructor(t){
                    this._components = new Map;
                    this.editor = t;
                }
                *names() {
                    for (const t of this._components.values())yield t.originalName;
                }
                add(t, e) {
                    this._components.set(iE(t), {
                        callback: e,
                        originalName: t
                    });
                }
                create(t) {
                    if (!this.has(t)) throw new R("componentfactory-item-missing", this, {
                        name: t
                    });
                    return this._components.get(iE(t)).callback(this.editor.locale);
                }
                has(t) {
                    return this._components.has(iE(t));
                }
            }
            function iE(t) {
                return String(t).toLowerCase();
            }
            var rE = n(4460);
            var sE = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            sE.insert = "head";
            sE.singleton = true;
            var aE = Rl()(rE.Z, sE);
            const cE = rE.Z.locals || {};
            const lE = wc("px");
            const dE = ec.document.body;
            const uE = {
                top: -99999,
                left: -99999,
                name: "arrowless",
                config: {
                    withArrow: false
                }
            };
            class hE extends zl {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.set("top", 0);
                    this.set("left", 0);
                    this.set("position", "arrow_nw");
                    this.set("isVisible", false);
                    this.set("withArrow", true);
                    this.set("class", undefined);
                    this._pinWhenIsVisibleCallback = null;
                    this.content = this.createCollection();
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-balloon-panel",
                                e.to("position", (t)=>`ck-balloon-panel_${t}`),
                                e.if("isVisible", "ck-balloon-panel_visible"),
                                e.if("withArrow", "ck-balloon-panel_with-arrow"),
                                e.to("class")
                            ],
                            style: {
                                top: e.to("top", lE),
                                left: e.to("left", lE)
                            }
                        },
                        children: this.content
                    });
                }
                show() {
                    this.isVisible = true;
                }
                hide() {
                    this.isVisible = false;
                }
                attachTo(t) {
                    this.show();
                    const e = hE.defaultPositions;
                    const n = Object.assign({}, {
                        element: this.element,
                        positions: [
                            e.southArrowNorth,
                            e.southArrowNorthMiddleWest,
                            e.southArrowNorthMiddleEast,
                            e.southArrowNorthWest,
                            e.southArrowNorthEast,
                            e.northArrowSouth,
                            e.northArrowSouthMiddleWest,
                            e.northArrowSouthMiddleEast,
                            e.northArrowSouthWest,
                            e.northArrowSouthEast,
                            e.viewportStickyNorth
                        ],
                        limiter: dE,
                        fitInViewport: true
                    }, t);
                    const o = hE._getOptimalPosition(n) || uE;
                    const i = parseInt(o.left);
                    const r = parseInt(o.top);
                    const s = o.name;
                    const a = o.config || {};
                    const { withArrow: c = true } = a;
                    this.top = r;
                    this.left = i;
                    this.position = s;
                    this.withArrow = c;
                }
                pin(t) {
                    this.unpin();
                    this._pinWhenIsVisibleCallback = ()=>{
                        if (this.isVisible) this._startPinning(t);
                        else this._stopPinning();
                    };
                    this._startPinning(t);
                    this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
                }
                unpin() {
                    if (this._pinWhenIsVisibleCallback) {
                        this._stopPinning();
                        this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback);
                        this._pinWhenIsVisibleCallback = null;
                        this.hide();
                    }
                }
                _startPinning(t) {
                    this.attachTo(t);
                    const e = fE(t.target);
                    const n = t.limiter ? fE(t.limiter) : dE;
                    this.listenTo(ec.document, "scroll", (o, i)=>{
                        const r = i.target;
                        const s = e && r.contains(e);
                        const a = n && r.contains(n);
                        if (s || a || !e || !n) this.attachTo(t);
                    }, {
                        useCapture: true
                    });
                    this.listenTo(ec.window, "resize", ()=>{
                        this.attachTo(t);
                    });
                }
                _stopPinning() {
                    this.stopListening(ec.document, "scroll");
                    this.stopListening(ec.window, "resize");
                }
            }
            hE.arrowSideOffset = 25;
            hE.arrowHeightOffset = 10;
            hE.stickyVerticalOffset = 20;
            hE._getOptimalPosition = xc;
            hE.defaultPositions = pE();
            function fE(t) {
                if (qa(t)) return t;
                if (sc(t)) return t.commonAncestorContainer;
                if (typeof t == "function") return fE(t());
                return null;
            }
            function pE(t = {}) {
                const { sideOffset: e = hE.arrowSideOffset, heightOffset: n = hE.arrowHeightOffset, stickyVerticalOffset: o = hE.stickyVerticalOffset, config: i } = t;
                return {
                    northWestArrowSouthWest: (t, n)=>({
                            top: r(t, n),
                            left: t.left - e,
                            name: "arrow_sw",
                            ...i && {
                                config: i
                            }
                        }),
                    northWestArrowSouthMiddleWest: (t, n)=>({
                            top: r(t, n),
                            left: t.left - n.width * .25 - e,
                            name: "arrow_smw",
                            ...i && {
                                config: i
                            }
                        }),
                    northWestArrowSouth: (t, e)=>({
                            top: r(t, e),
                            left: t.left - e.width / 2,
                            name: "arrow_s",
                            ...i && {
                                config: i
                            }
                        }),
                    northWestArrowSouthMiddleEast: (t, n)=>({
                            top: r(t, n),
                            left: t.left - n.width * .75 + e,
                            name: "arrow_sme",
                            ...i && {
                                config: i
                            }
                        }),
                    northWestArrowSouthEast: (t, n)=>({
                            top: r(t, n),
                            left: t.left - n.width + e,
                            name: "arrow_se",
                            ...i && {
                                config: i
                            }
                        }),
                    northArrowSouthWest: (t, n)=>({
                            top: r(t, n),
                            left: t.left + t.width / 2 - e,
                            name: "arrow_sw",
                            ...i && {
                                config: i
                            }
                        }),
                    northArrowSouthMiddleWest: (t, n)=>({
                            top: r(t, n),
                            left: t.left + t.width / 2 - n.width * .25 - e,
                            name: "arrow_smw",
                            ...i && {
                                config: i
                            }
                        }),
                    northArrowSouth: (t, e)=>({
                            top: r(t, e),
                            left: t.left + t.width / 2 - e.width / 2,
                            name: "arrow_s",
                            ...i && {
                                config: i
                            }
                        }),
                    northArrowSouthMiddleEast: (t, n)=>({
                            top: r(t, n),
                            left: t.left + t.width / 2 - n.width * .75 + e,
                            name: "arrow_sme",
                            ...i && {
                                config: i
                            }
                        }),
                    northArrowSouthEast: (t, n)=>({
                            top: r(t, n),
                            left: t.left + t.width / 2 - n.width + e,
                            name: "arrow_se",
                            ...i && {
                                config: i
                            }
                        }),
                    northEastArrowSouthWest: (t, n)=>({
                            top: r(t, n),
                            left: t.right - e,
                            name: "arrow_sw",
                            ...i && {
                                config: i
                            }
                        }),
                    northEastArrowSouthMiddleWest: (t, n)=>({
                            top: r(t, n),
                            left: t.right - n.width * .25 - e,
                            name: "arrow_smw",
                            ...i && {
                                config: i
                            }
                        }),
                    northEastArrowSouth: (t, e)=>({
                            top: r(t, e),
                            left: t.right - e.width / 2,
                            name: "arrow_s",
                            ...i && {
                                config: i
                            }
                        }),
                    northEastArrowSouthMiddleEast: (t, n)=>({
                            top: r(t, n),
                            left: t.right - n.width * .75 + e,
                            name: "arrow_sme",
                            ...i && {
                                config: i
                            }
                        }),
                    northEastArrowSouthEast: (t, n)=>({
                            top: r(t, n),
                            left: t.right - n.width + e,
                            name: "arrow_se",
                            ...i && {
                                config: i
                            }
                        }),
                    southWestArrowNorthWest: (t)=>({
                            top: s(t),
                            left: t.left - e,
                            name: "arrow_nw",
                            ...i && {
                                config: i
                            }
                        }),
                    southWestArrowNorthMiddleWest: (t, n)=>({
                            top: s(t),
                            left: t.left - n.width * .25 - e,
                            name: "arrow_nmw",
                            ...i && {
                                config: i
                            }
                        }),
                    southWestArrowNorth: (t, e)=>({
                            top: s(t),
                            left: t.left - e.width / 2,
                            name: "arrow_n",
                            ...i && {
                                config: i
                            }
                        }),
                    southWestArrowNorthMiddleEast: (t, n)=>({
                            top: s(t),
                            left: t.left - n.width * .75 + e,
                            name: "arrow_nme",
                            ...i && {
                                config: i
                            }
                        }),
                    southWestArrowNorthEast: (t, n)=>({
                            top: s(t),
                            left: t.left - n.width + e,
                            name: "arrow_ne",
                            ...i && {
                                config: i
                            }
                        }),
                    southArrowNorthWest: (t)=>({
                            top: s(t),
                            left: t.left + t.width / 2 - e,
                            name: "arrow_nw",
                            ...i && {
                                config: i
                            }
                        }),
                    southArrowNorthMiddleWest: (t, n)=>({
                            top: s(t),
                            left: t.left + t.width / 2 - n.width * .25 - e,
                            name: "arrow_nmw",
                            ...i && {
                                config: i
                            }
                        }),
                    southArrowNorth: (t, e)=>({
                            top: s(t),
                            left: t.left + t.width / 2 - e.width / 2,
                            name: "arrow_n",
                            ...i && {
                                config: i
                            }
                        }),
                    southArrowNorthMiddleEast: (t, n)=>({
                            top: s(t),
                            left: t.left + t.width / 2 - n.width * .75 + e,
                            name: "arrow_nme",
                            ...i && {
                                config: i
                            }
                        }),
                    southArrowNorthEast: (t, n)=>({
                            top: s(t),
                            left: t.left + t.width / 2 - n.width + e,
                            name: "arrow_ne",
                            ...i && {
                                config: i
                            }
                        }),
                    southEastArrowNorthWest: (t)=>({
                            top: s(t),
                            left: t.right - e,
                            name: "arrow_nw",
                            ...i && {
                                config: i
                            }
                        }),
                    southEastArrowNorthMiddleWest: (t, n)=>({
                            top: s(t),
                            left: t.right - n.width * .25 - e,
                            name: "arrow_nmw",
                            ...i && {
                                config: i
                            }
                        }),
                    southEastArrowNorth: (t, e)=>({
                            top: s(t),
                            left: t.right - e.width / 2,
                            name: "arrow_n",
                            ...i && {
                                config: i
                            }
                        }),
                    southEastArrowNorthMiddleEast: (t, n)=>({
                            top: s(t),
                            left: t.right - n.width * .75 + e,
                            name: "arrow_nme",
                            ...i && {
                                config: i
                            }
                        }),
                    southEastArrowNorthEast: (t, n)=>({
                            top: s(t),
                            left: t.right - n.width + e,
                            name: "arrow_ne",
                            ...i && {
                                config: i
                            }
                        }),
                    westArrowEast: (t, e)=>({
                            top: t.top + t.height / 2 - e.height / 2,
                            left: t.left - e.width - n,
                            name: "arrow_e",
                            ...i && {
                                config: i
                            }
                        }),
                    eastArrowWest: (t, e)=>({
                            top: t.top + t.height / 2 - e.height / 2,
                            left: t.right + n,
                            name: "arrow_w",
                            ...i && {
                                config: i
                            }
                        }),
                    viewportStickyNorth: (t, e, n, r)=>{
                        const s = r || n;
                        if (!t.getIntersection(s)) return null;
                        if (s.height - t.height > o) return null;
                        return {
                            top: s.top + o,
                            left: t.left + t.width / 2 - e.width / 2,
                            name: "arrowless",
                            config: {
                                withArrow: false,
                                ...i
                            }
                        };
                    }
                };
                function r(t, e) {
                    return t.top - e.height - n;
                }
                function s(t) {
                    return t.bottom + n;
                }
            }
            var gE = n(3888);
            var mE = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            mE.insert = "head";
            mE.singleton = true;
            var kE = Rl()(gE.Z, mE);
            const bE = gE.Z.locals || {};
            const wE = "ck-tooltip";
            class _E extends Ja() {
                constructor(t){
                    super();
                    this._currentElementWithTooltip = null;
                    this._currentTooltipPosition = null;
                    this._resizeObserver = null;
                    _E._editors.add(t);
                    if (_E._instance) return _E._instance;
                    _E._instance = this;
                    this.tooltipTextView = new zl(t.locale);
                    this.tooltipTextView.set("text", "");
                    this.tooltipTextView.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-tooltip__text"
                            ]
                        },
                        children: [
                            {
                                text: this.tooltipTextView.bindTemplate.to("text")
                            }
                        ]
                    });
                    this.balloonPanelView = new hE(t.locale);
                    this.balloonPanelView.class = wE;
                    this.balloonPanelView.content.add(this.tooltipTextView);
                    this._pinTooltipDebounced = lm(this._pinTooltip, 600);
                    this.listenTo(ec.document, "mouseenter", this._onEnterOrFocus.bind(this), {
                        useCapture: true
                    });
                    this.listenTo(ec.document, "mouseleave", this._onLeaveOrBlur.bind(this), {
                        useCapture: true
                    });
                    this.listenTo(ec.document, "focus", this._onEnterOrFocus.bind(this), {
                        useCapture: true
                    });
                    this.listenTo(ec.document, "blur", this._onLeaveOrBlur.bind(this), {
                        useCapture: true
                    });
                    this.listenTo(ec.document, "scroll", this._onScroll.bind(this), {
                        useCapture: true
                    });
                    this._watchdogExcluded = true;
                }
                destroy(t) {
                    const e = t.ui.view && t.ui.view.body;
                    _E._editors.delete(t);
                    this.stopListening(t.ui);
                    if (e && e.has(this.balloonPanelView)) e.remove(this.balloonPanelView);
                    if (!_E._editors.size) {
                        this._unpinTooltip();
                        this.balloonPanelView.destroy();
                        this.stopListening();
                        _E._instance = null;
                    }
                }
                static getPositioningFunctions(t) {
                    const e = _E.defaultBalloonPositions;
                    return ({
                        s: [
                            e.southArrowNorth,
                            e.southArrowNorthEast,
                            e.southArrowNorthWest
                        ],
                        n: [
                            e.northArrowSouth
                        ],
                        e: [
                            e.eastArrowWest
                        ],
                        w: [
                            e.westArrowEast
                        ],
                        sw: [
                            e.southArrowNorthEast
                        ],
                        se: [
                            e.southArrowNorthWest
                        ]
                    })[t];
                }
                _onEnterOrFocus(t, { target: e }) {
                    const n = AE(e);
                    if (!n) return;
                    if (n === this._currentElementWithTooltip) return;
                    this._unpinTooltip();
                    this._pinTooltipDebounced(n, vE(n));
                }
                _onLeaveOrBlur(t, { target: e, relatedTarget: n }) {
                    if (t.name === "mouseleave") {
                        if (!qa(e)) return;
                        if (this._currentElementWithTooltip && e !== this._currentElementWithTooltip) return;
                        const t = AE(e);
                        const o = AE(n);
                        if (t && t !== o) this._unpinTooltip();
                    } else {
                        if (this._currentElementWithTooltip && e !== this._currentElementWithTooltip) return;
                        this._unpinTooltip();
                    }
                }
                _onScroll(t, { target: e }) {
                    if (!this._currentElementWithTooltip) return;
                    if (e.contains(this.balloonPanelView.element) && e.contains(this._currentElementWithTooltip)) return;
                    this._unpinTooltip();
                }
                _pinTooltip(t, { text: e, position: n, cssClass: o }) {
                    const i = fl(_E._editors.values()).ui.view.body;
                    if (!i.has(this.balloonPanelView)) i.add(this.balloonPanelView);
                    this.tooltipTextView.text = e;
                    this.balloonPanelView.pin({
                        target: t,
                        positions: _E.getPositioningFunctions(n)
                    });
                    this._resizeObserver = new kc(t, ()=>{
                        if (!yc(t)) this._unpinTooltip();
                    });
                    this.balloonPanelView.class = [
                        wE,
                        o
                    ].filter((t)=>t).join(" ");
                    for (const t of _E._editors)this.listenTo(t.ui, "update", this._updateTooltipPosition.bind(this), {
                        priority: "low"
                    });
                    this._currentElementWithTooltip = t;
                    this._currentTooltipPosition = n;
                }
                _unpinTooltip() {
                    this._pinTooltipDebounced.cancel();
                    this.balloonPanelView.unpin();
                    for (const t of _E._editors)this.stopListening(t.ui, "update");
                    this._currentElementWithTooltip = null;
                    this._currentTooltipPosition = null;
                    if (this._resizeObserver) this._resizeObserver.destroy();
                }
                _updateTooltipPosition() {
                    if (!yc(this._currentElementWithTooltip)) {
                        this._unpinTooltip();
                        return;
                    }
                    this.balloonPanelView.pin({
                        target: this._currentElementWithTooltip,
                        positions: _E.getPositioningFunctions(this._currentTooltipPosition)
                    });
                }
            }
            _E.defaultBalloonPositions = pE({
                heightOffset: 5,
                sideOffset: 13
            });
            _E._editors = new Set;
            _E._instance = null;
            function AE(t) {
                if (!qa(t)) return null;
                return t.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])");
            }
            function vE(t) {
                return {
                    text: t.dataset.ckeTooltipText,
                    position: t.dataset.ckeTooltipPosition || "s",
                    cssClass: t.dataset.ckeTooltipClass || ""
                };
            }
            var CE = "Expected a function";
            function yE(t, e, n) {
                var o = true, i = true;
                if (typeof t != "function") throw new TypeError(CE);
                if (rt(n)) {
                    o = "leading" in n ? !!n.leading : o;
                    i = "trailing" in n ? !!n.trailing : i;
                }
                return lm(t, e, {
                    leading: o,
                    maxWait: e,
                    trailing: i
                });
            }
            const xE = yE;
            const EE = '<svg xmlns="http://www.w3.org/2000/svg" width="53" height="10" viewBox="0 0 53 10"><path fill="#1C2331" d="M31.724 1.492a15.139 15.139 0 0 0 .045 1.16 2.434 2.434 0 0 0-.687-.34 3.68 3.68 0 0 0-1.103-.166 2.332 2.332 0 0 0-1.14.255 1.549 1.549 0 0 0-.686.87c-.15.41-.225.98-.225 1.712 0 .939.148 1.659.444 2.161.297.503.792.754 1.487.754.452.015.9-.094 1.294-.316.296-.174.557-.4.771-.669l.14.852h1.282V.007h-1.623v1.485ZM31 6.496a1.77 1.77 0 0 1-.494.061.964.964 0 0 1-.521-.127.758.758 0 0 1-.296-.466 3.984 3.984 0 0 1-.093-.992 4.208 4.208 0 0 1 .098-1.052.753.753 0 0 1 .307-.477 1.08 1.08 0 0 1 .55-.122c.233-.004.466.026.69.089l.483.144v2.553c-.11.076-.213.143-.307.2a1.73 1.73 0 0 1-.417.189ZM35.68 0l-.702.004c-.322.002-.482.168-.48.497l.004.581c.002.33.164.493.486.49l.702-.004c.322-.002.481-.167.48-.496L36.165.49c-.002-.33-.164-.493-.486-.491ZM36.145 2.313l-1.612.01.034 5.482 1.613-.01-.035-5.482ZM39.623.79 37.989.8 38 2.306l-.946.056.006 1.009.949-.006.024 2.983c.003.476.143.844.419 1.106.275.26.658.39 1.148.387.132 0 .293-.01.483-.03.19-.02.38-.046.57-.08.163-.028.324-.068.482-.119l-.183-1.095-.702.004a.664.664 0 0 1-.456-.123.553.553 0 0 1-.14-.422l-.016-2.621 1.513-.01-.006-1.064-1.514.01-.01-1.503ZM46.226 2.388c-.41-.184-.956-.274-1.636-.27-.673.004-1.215.101-1.627.29-.402.179-.72.505-.888.91-.18.419-.268.979-.264 1.68.004.688.1 1.24.285 1.655.172.404.495.724.9.894.414.18.957.268 1.63.264.68-.004 1.224-.099 1.632-.284.4-.176.714-.501.878-.905.176-.418.263-.971.258-1.658-.004-.702-.097-1.261-.28-1.677a1.696 1.696 0 0 0-.888-.9Zm-.613 3.607a.77.77 0 0 1-.337.501 1.649 1.649 0 0 1-1.317.009.776.776 0 0 1-.343-.497 4.066 4.066 0 0 1-.105-1.02 4.136 4.136 0 0 1 .092-1.03.786.786 0 0 1 .337-.507 1.59 1.59 0 0 1 1.316-.008.79.79 0 0 1 .344.502c.078.337.113.683.105 1.03.012.343-.019.685-.092 1.02ZM52.114 2.07a2.67 2.67 0 0 0-1.128.278c-.39.191-.752.437-1.072.73l-.157-.846-1.273.008.036 5.572 1.623-.01-.024-3.78c.35-.124.646-.22.887-.286.26-.075.53-.114.8-.118l.45-.003.144-1.546-.286.001ZM22.083 7.426l-1.576-2.532a2.137 2.137 0 0 0-.172-.253 1.95 1.95 0 0 0-.304-.29.138.138 0 0 1 .042-.04 1.7 1.7 0 0 0 .328-.374l1.75-2.71c.01-.015.025-.028.024-.048-.01-.01-.021-.007-.031-.007L20.49 1.17a.078.078 0 0 0-.075.045l-.868 1.384c-.23.366-.46.732-.688 1.099a.108.108 0 0 1-.112.06c-.098-.005-.196-.001-.294-.002-.018 0-.038.006-.055-.007.002-.02.002-.039.005-.058a4.6 4.6 0 0 0 .046-.701V1.203c0-.02-.009-.032-.03-.03h-.033L16.93 1.17c-.084 0-.073-.01-.073.076v6.491c-.001.018.006.028.025.027h1.494c.083 0 .072.007.072-.071v-2.19c0-.055-.003-.11-.004-.166a3.366 3.366 0 0 0-.05-.417h.06c.104 0 .209.002.313-.002a.082.082 0 0 1 .084.05c.535.913 1.07 1.824 1.607 2.736a.104.104 0 0 0 .103.062c.554-.003 1.107-.002 1.66-.002l.069-.003-.019-.032-.188-.304ZM27.112 6.555c-.005-.08-.004-.08-.082-.08h-2.414c-.053 0-.106-.003-.159-.011a.279.279 0 0 1-.246-.209.558.558 0 0 1-.022-.15c0-.382 0-.762-.002-1.143 0-.032.007-.049.042-.044h2.504c.029.003.037-.012.034-.038V3.814c0-.089.013-.078-.076-.078h-2.44c-.07 0-.062.003-.062-.06v-.837c0-.047.004-.093.013-.14a.283.283 0 0 1 .241-.246.717.717 0 0 1 .146-.011h2.484c.024.002.035-.009.036-.033l.003-.038.03-.496c.01-.183.024-.365.034-.548.005-.085.003-.087-.082-.094-.218-.018-.437-.038-.655-.05a17.845 17.845 0 0 0-.657-.026 72.994 72.994 0 0 0-1.756-.016 1.7 1.7 0 0 0-.471.064 1.286 1.286 0 0 0-.817.655c-.099.196-.149.413-.145.633v3.875c0 .072.003.144.011.216a1.27 1.27 0 0 0 .711 1.029c.228.113.48.167.734.158.757-.005 1.515.002 2.272-.042.274-.016.548-.034.82-.053.03-.002.043-.008.04-.041-.008-.104-.012-.208-.019-.312a69.964 69.964 0 0 1-.05-.768ZM16.14 7.415l-.127-1.075c-.004-.03-.014-.04-.044-.037a13.125 13.125 0 0 1-.998.073c-.336.01-.672.02-1.008.016-.116-.001-.233-.014-.347-.039a.746.746 0 0 1-.45-.262c-.075-.1-.132-.211-.167-.33a3.324 3.324 0 0 1-.126-.773 9.113 9.113 0 0 1-.015-.749c0-.285.022-.57.065-.852.023-.158.066-.312.127-.46a.728.728 0 0 1 .518-.443 1.64 1.64 0 0 1 .397-.048c.628-.001 1.255.003 1.882.05.022.001.033-.006.036-.026l.003-.031.06-.55c.019-.177.036-.355.057-.532.004-.034-.005-.046-.04-.056a5.595 5.595 0 0 0-1.213-.21 10.783 10.783 0 0 0-.708-.02c-.24-.003-.48.01-.719.041a3.477 3.477 0 0 0-.625.14 1.912 1.912 0 0 0-.807.497c-.185.2-.33.433-.424.688a4.311 4.311 0 0 0-.24 1.096c-.031.286-.045.572-.042.86-.006.43.024.86.091 1.286.04.25.104.497.193.734.098.279.26.53.473.734.214.205.473.358.756.446.344.11.702.17 1.063.177a8.505 8.505 0 0 0 1.578-.083 6.11 6.11 0 0 0 .766-.18c.03-.008.047-.023.037-.057a.157.157 0 0 1-.003-.025Z"/><path fill="#AFE229" d="M6.016 6.69a1.592 1.592 0 0 0-.614.21c-.23.132-.422.32-.56.546-.044.072-.287.539-.287.539l-.836 1.528.009.006c.038.025.08.046.123.063.127.046.26.07.395.073.505.023 1.011-.007 1.517-.003.29.009.58.002.869-.022a.886.886 0 0 0 .395-.116.962.962 0 0 0 .312-.286c.056-.083.114-.163.164-.249.24-.408.48-.816.718-1.226.075-.128.148-.257.222-.386l.112-.192a1.07 1.07 0 0 0 .153-.518l-1.304.023s-1.258-.005-1.388.01Z"/><path fill="#771BFF" d="m2.848 9.044.76-1.39.184-.352c-.124-.067-.245-.14-.367-.21-.346-.204-.706-.384-1.045-.6a.984.984 0 0 1-.244-.207c-.108-.134-.136-.294-.144-.46-.021-.409-.002-.818-.009-1.227-.003-.195 0-.39.003-.585.004-.322.153-.553.427-.713l.833-.488c.22-.13.44-.257.662-.385.05-.029.105-.052.158-.077.272-.128.519-.047.76.085l.044.028c.123.06.242.125.358.196.318.178.635.357.952.537.095.056.187.117.275.184.194.144.254.35.266.578.016.284.007.569.006.853-.001.28.004.558 0 .838.592-.003 1.259 0 1.259 0l.723-.013c-.003-.292-.007-.584-.007-.876 0-.524.015-1.048-.016-1.571-.024-.42-.135-.8-.492-1.067a5.02 5.02 0 0 0-.506-.339A400.52 400.52 0 0 0 5.94.787C5.722.664 5.513.524 5.282.423 5.255.406 5.228.388 5.2.373 4.758.126 4.305-.026 3.807.21c-.097.046-.197.087-.29.14A699.896 699.896 0 0 0 .783 1.948c-.501.294-.773.717-.778 1.31-.004.36-.009.718-.001 1.077.016.754-.017 1.508.024 2.261.016.304.07.6.269.848.127.15.279.28.448.382.622.4 1.283.734 1.92 1.11l.183.109Z"/></svg>\n';
            const DE = 53;
            const SE = 10;
            const TE = 50;
            const BE = 350;
            const PE = "Powered by";
            class IE extends Ja() {
                constructor(t){
                    super();
                    this.editor = t;
                    this._balloonView = null;
                    this._lastFocusedEditableElement = null;
                    this._showBalloonThrottled = xE(this._showBalloon.bind(this), 50, {
                        leading: true
                    });
                    t.on("ready", this._handleEditorReady.bind(this));
                }
                destroy() {
                    const t = this._balloonView;
                    if (t) {
                        t.unpin();
                        this._balloonView = null;
                    }
                    this._showBalloonThrottled.cancel();
                    this.stopListening();
                }
                _handleEditorReady() {
                    const t = this.editor;
                    const e = !!t.config.get("ui.poweredBy.forceVisible");
                    if (!e && true) return;
                    if (!t.ui.view) return;
                    t.ui.focusTracker.on("change:isFocused", (t, e, n)=>{
                        this._updateLastFocusedEditableElement();
                        if (n) this._showBalloon();
                        else this._hideBalloon();
                    });
                    t.ui.focusTracker.on("change:focusedElement", (t, e, n)=>{
                        this._updateLastFocusedEditableElement();
                        if (n) this._showBalloon();
                    });
                    t.ui.on("update", ()=>{
                        this._showBalloonThrottled();
                    });
                }
                _createBalloonView() {
                    const t = this.editor;
                    const e = this._balloonView = new hE;
                    const n = zE(t);
                    const o = new RE(t.locale, n.label);
                    e.content.add(o);
                    e.set({
                        class: "ck-powered-by-balloon"
                    });
                    t.ui.view.body.add(e);
                    t.ui.focusTracker.add(e.element);
                    this._balloonView = e;
                }
                _showBalloon() {
                    if (!this._lastFocusedEditableElement) return;
                    const t = OE(this.editor, this._lastFocusedEditableElement);
                    if (t) {
                        if (!this._balloonView) this._createBalloonView();
                        this._balloonView.pin(t);
                    }
                }
                _hideBalloon() {
                    if (this._balloonView) this._balloonView.unpin();
                }
                _updateLastFocusedEditableElement() {
                    const t = this.editor;
                    const e = t.ui.focusTracker.isFocused;
                    const n = t.ui.focusTracker.focusedElement;
                    if (!e || !n) {
                        this._lastFocusedEditableElement = null;
                        return;
                    }
                    const o = Array.from(t.ui.getEditableElementsNames()).map((e)=>t.ui.getEditableElement(e));
                    if (o.includes(n)) this._lastFocusedEditableElement = n;
                    else this._lastFocusedEditableElement = o[0];
                }
            }
            class RE extends zl {
                constructor(t, e){
                    super(t);
                    const n = new bd;
                    const o = this.bindTemplate;
                    n.set({
                        content: EE,
                        isColorInherited: false
                    });
                    n.extendTemplate({
                        attributes: {
                            style: {
                                width: DE + "px",
                                height: SE + "px"
                            }
                        }
                    });
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-powered-by"
                            ],
                            "aria-hidden": true
                        },
                        children: [
                            {
                                tag: "a",
                                attributes: {
                                    href: "https://ckeditor.com/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo",
                                    target: "_blank",
                                    tabindex: "-1"
                                },
                                children: [
                                    ...e ? [
                                        {
                                            tag: "span",
                                            attributes: {
                                                class: [
                                                    "ck",
                                                    "ck-powered-by__label"
                                                ]
                                            },
                                            children: [
                                                e
                                            ]
                                        }
                                    ] : [],
                                    n
                                ],
                                on: {
                                    dragstart: o.to((t)=>t.preventDefault())
                                }
                            }
                        ]
                    });
                }
            }
            function OE(t, e) {
                const n = zE(t);
                const o = n.side === "right" ? VE(e, n) : ME(e, n);
                return {
                    target: e,
                    positions: [
                        o
                    ]
                };
            }
            function VE(t, e) {
                return LE(t, e, (t, n)=>t.left + t.width - n.width - e.horizontalOffset);
            }
            function ME(t, e) {
                return LE(t, e, (t)=>t.left + e.horizontalOffset);
            }
            function LE(t, e, n) {
                return (o, i)=>{
                    const r = new dc(t);
                    if (r.width < BE || r.height < TE) return null;
                    let s;
                    if (e.position === "inside") s = r.bottom - i.height;
                    else s = r.bottom - i.height / 2;
                    s -= e.verticalOffset;
                    const a = n(r, i);
                    const c = o.clone().moveTo(a, s).getIntersection(i.clone().moveTo(a, s));
                    const l = c.getVisible();
                    if (!l || l.getArea() < i.getArea()) return null;
                    return {
                        top: s,
                        left: a,
                        name: `position_${e.position}-side_${e.side}`,
                        config: {
                            withArrow: false
                        }
                    };
                };
            }
            function zE(t) {
                const e = t.config.get("ui.poweredBy");
                const n = e && e.position || "border";
                return {
                    position: n,
                    label: PE,
                    verticalOffset: n === "inside" ? 5 : 0,
                    horizontalOffset: 5,
                    side: t.locale.contentLanguageDirection === "ltr" ? "right" : "left",
                    ...e
                };
            }
            class NE extends ht() {
                constructor(t){
                    super();
                    this.isReady = false;
                    this._editableElementsMap = new Map;
                    this._focusableToolbarDefinitions = [];
                    const e = t.editing.view;
                    this.editor = t;
                    this.componentFactory = new oE(t);
                    this.focusTracker = new pl;
                    this.tooltipManager = new _E(t);
                    this.poweredBy = new IE(t);
                    this.set("viewportOffset", this._readViewportOffsetFromConfig());
                    this.once("ready", ()=>{
                        this.isReady = true;
                    });
                    this.listenTo(e.document, "layoutChanged", this.update.bind(this));
                    this.listenTo(e, "scrollToTheSelection", this._handleScrollToTheSelection.bind(this));
                    this._initFocusTracking();
                }
                get element() {
                    return null;
                }
                update() {
                    this.fire("update");
                }
                destroy() {
                    this.stopListening();
                    this.focusTracker.destroy();
                    this.tooltipManager.destroy(this.editor);
                    this.poweredBy.destroy();
                    for (const t of this._editableElementsMap.values()){
                        t.ckeditorInstance = null;
                        this.editor.keystrokes.stopListening(t);
                    }
                    this._editableElementsMap = new Map;
                    this._focusableToolbarDefinitions = [];
                }
                setEditableElement(t, e) {
                    this._editableElementsMap.set(t, e);
                    if (!e.ckeditorInstance) e.ckeditorInstance = this.editor;
                    this.focusTracker.add(e);
                    const n = ()=>{
                        if (this.editor.editing.view.getDomRoot(t)) return;
                        this.editor.keystrokes.listenTo(e);
                    };
                    if (this.isReady) n();
                    else this.once("ready", n);
                }
                removeEditableElement(t) {
                    const e = this._editableElementsMap.get(t);
                    if (!e) return;
                    this._editableElementsMap.delete(t);
                    this.editor.keystrokes.stopListening(e);
                    this.focusTracker.remove(e);
                    e.ckeditorInstance = null;
                }
                getEditableElement(t = "main") {
                    return this._editableElementsMap.get(t);
                }
                getEditableElementsNames() {
                    return this._editableElementsMap.keys();
                }
                addToolbar(t, e = {}) {
                    if (t.isRendered) {
                        this.focusTracker.add(t.element);
                        this.editor.keystrokes.listenTo(t.element);
                    } else t.once("render", ()=>{
                        this.focusTracker.add(t.element);
                        this.editor.keystrokes.listenTo(t.element);
                    });
                    this._focusableToolbarDefinitions.push({
                        toolbarView: t,
                        options: e
                    });
                }
                get _editableElements() {
                    console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", {
                        editorUI: this
                    });
                    return this._editableElementsMap;
                }
                _readViewportOffsetFromConfig() {
                    const t = this.editor;
                    const e = t.config.get("ui.viewportOffset");
                    if (e) return e;
                    const n = t.config.get("toolbar.viewportTopOffset");
                    if (n) {
                        console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead.");
                        return {
                            top: n
                        };
                    }
                    return {
                        top: 0
                    };
                }
                _initFocusTracking() {
                    const t = this.editor;
                    const e = t.editing.view;
                    let n;
                    let o;
                    t.keystrokes.set("Alt+F10", (t, i)=>{
                        const r = this.focusTracker.focusedElement;
                        if (Array.from(this._editableElementsMap.values()).includes(r) && !Array.from(e.domRoots.values()).includes(r)) n = r;
                        const s = this._getCurrentFocusedToolbarDefinition();
                        if (!s || !o) o = this._getFocusableCandidateToolbarDefinitions();
                        for(let t = 0; t < o.length; t++){
                            const t = o.shift();
                            o.push(t);
                            if (t !== s && this._focusFocusableCandidateToolbar(t)) {
                                if (s && s.options.afterBlur) s.options.afterBlur();
                                break;
                            }
                        }
                        i();
                    });
                    t.keystrokes.set("Esc", (e, o)=>{
                        const i = this._getCurrentFocusedToolbarDefinition();
                        if (!i) return;
                        if (n) {
                            n.focus();
                            n = null;
                        } else t.editing.view.focus();
                        if (i.options.afterBlur) i.options.afterBlur();
                        o();
                    });
                }
                _getFocusableCandidateToolbarDefinitions() {
                    const t = [];
                    for (const e of this._focusableToolbarDefinitions){
                        const { toolbarView: n, options: o } = e;
                        if (yc(n.element) || o.beforeFocus) t.push(e);
                    }
                    t.sort((t, e)=>FE(t) - FE(e));
                    return t;
                }
                _getCurrentFocusedToolbarDefinition() {
                    for (const t of this._focusableToolbarDefinitions){
                        if (t.toolbarView.element && t.toolbarView.element.contains(this.focusTracker.focusedElement)) return t;
                    }
                    return null;
                }
                _focusFocusableCandidateToolbar(t) {
                    const { toolbarView: e, options: { beforeFocus: n } } = t;
                    if (n) n();
                    if (!yc(e.element)) return false;
                    e.focus();
                    return true;
                }
                _handleScrollToTheSelection(t, e) {
                    const n = {
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        ...this.viewportOffset
                    };
                    e.viewportOffset.top += n.top;
                    e.viewportOffset.bottom += n.bottom;
                    e.viewportOffset.left += n.left;
                    e.viewportOffset.right += n.right;
                }
            }
            function FE(t) {
                const { toolbarView: e, options: n } = t;
                let o = 10;
                if (yc(e.element)) o--;
                if (n.isContextual) o--;
                return o;
            }
            var HE = n(9847);
            var jE = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            jE.insert = "head";
            jE.singleton = true;
            var qE = Rl()(HE.Z, jE);
            const WE = HE.Z.locals || {};
            class $E extends zl {
                constructor(t){
                    super(t);
                    this.body = new fd(t);
                }
                render() {
                    super.render();
                    this.body.attachToDom();
                }
                destroy() {
                    this.body.detachFromDom();
                    return super.destroy();
                }
            }
            class GE extends $E {
                constructor(t){
                    super(t);
                    this.top = this.createCollection();
                    this.main = this.createCollection();
                    this._voiceLabelView = this._createVoiceLabel();
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-reset",
                                "ck-editor",
                                "ck-rounded-corners"
                            ],
                            role: "application",
                            dir: t.uiLanguageDirection,
                            lang: t.uiLanguage,
                            "aria-labelledby": this._voiceLabelView.id
                        },
                        children: [
                            this._voiceLabelView,
                            {
                                tag: "div",
                                attributes: {
                                    class: [
                                        "ck",
                                        "ck-editor__top",
                                        "ck-reset_all"
                                    ],
                                    role: "presentation"
                                },
                                children: this.top
                            },
                            {
                                tag: "div",
                                attributes: {
                                    class: [
                                        "ck",
                                        "ck-editor__main"
                                    ],
                                    role: "presentation"
                                },
                                children: this.main
                            }
                        ]
                    });
                }
                _createVoiceLabel() {
                    const t = this.t;
                    const e = new Jd;
                    e.text = t("Rich Text Editor");
                    e.extendTemplate({
                        attributes: {
                            class: "ck-voice-label"
                        }
                    });
                    return e;
                }
            }
            class UE extends zl {
                constructor(t, e, n){
                    super(t);
                    this.name = null;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-content",
                                "ck-editor__editable",
                                "ck-rounded-corners"
                            ],
                            lang: t.contentLanguage,
                            dir: t.contentLanguageDirection
                        }
                    });
                    this.set("isFocused", false);
                    this._editableElement = n;
                    this._hasExternalElement = !!this._editableElement;
                    this._editingView = e;
                }
                render() {
                    super.render();
                    if (this._hasExternalElement) this.template.apply(this.element = this._editableElement);
                    else this._editableElement = this.element;
                    this.on("change:isFocused", ()=>this._updateIsFocusedClasses());
                    this._updateIsFocusedClasses();
                }
                destroy() {
                    if (this._hasExternalElement) this.template.revert(this._editableElement);
                    super.destroy();
                }
                get hasExternalElement() {
                    return this._hasExternalElement;
                }
                _updateIsFocusedClasses() {
                    const t = this._editingView;
                    if (t.isRenderingInProgress) n(this);
                    else e(this);
                    function e(e) {
                        t.change((n)=>{
                            const o = t.document.getRoot(e.name);
                            n.addClass(e.isFocused ? "ck-focused" : "ck-blurred", o);
                            n.removeClass(e.isFocused ? "ck-blurred" : "ck-focused", o);
                        });
                    }
                    function n(o) {
                        t.once("change:isRenderingInProgress", (t, i, r)=>{
                            if (!r) e(o);
                            else n(o);
                        });
                    }
                }
            }
            class KE extends UE {
                constructor(t, e, n, o = {}){
                    super(t, e, n);
                    const i = t.t;
                    this.extendTemplate({
                        attributes: {
                            role: "textbox",
                            class: "ck-editor__editable_inline"
                        }
                    });
                    this._generateLabel = o.label || (()=>i("Editor editing area: %0", this.name));
                }
                render() {
                    super.render();
                    const t = this._editingView;
                    t.change((e)=>{
                        const n = t.document.getRoot(this.name);
                        e.setAttribute("aria-label", this._generateLabel(this), n);
                    });
                }
            }
            var ZE = n(1874);
            var JE = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            JE.insert = "head";
            JE.singleton = true;
            var YE = Rl()(ZE.Z, JE);
            const QE = ZE.Z.locals || {};
            class XE extends null {
                constructor(t, e = {}){
                    super(t);
                    const n = this.bindTemplate;
                    this.set("label", e.label || "");
                    this.set("class", e.class || null);
                    this.children = this.createCollection();
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-form__header",
                                n.to("class")
                            ]
                        },
                        children: this.children
                    });
                    if (e.icon) {
                        this.iconView = new IconView;
                        this.iconView.content = e.icon;
                        this.children.add(this.iconView);
                    }
                    const o = new View(t);
                    o.setTemplate({
                        tag: "h2",
                        attributes: {
                            class: [
                                "ck",
                                "ck-form__header__label"
                            ]
                        },
                        children: [
                            {
                                text: n.to("label")
                            }
                        ]
                    });
                    this.children.add(o);
                }
            }
            class tD extends null {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.setTemplate({
                        tag: "iframe",
                        attributes: {
                            class: [
                                "ck",
                                "ck-reset_all"
                            ],
                            sandbox: "allow-same-origin allow-scripts"
                        },
                        on: {
                            load: e.to("loaded")
                        }
                    });
                }
                render() {
                    return new Promise((t)=>{
                        this.on("loaded", t);
                        return super.render();
                    });
                }
            }
            class eD extends null {
                static get pluginName() {
                    return "Notification";
                }
                init() {
                    this.on("show:warning", (t, e)=>{
                        window.alert(e.message);
                    }, {
                        priority: "lowest"
                    });
                }
                showSuccess(t, e = {}) {
                    this._showNotification({
                        message: t,
                        type: "success",
                        namespace: e.namespace,
                        title: e.title
                    });
                }
                showInfo(t, e = {}) {
                    this._showNotification({
                        message: t,
                        type: "info",
                        namespace: e.namespace,
                        title: e.title
                    });
                }
                showWarning(t, e = {}) {
                    this._showNotification({
                        message: t,
                        type: "warning",
                        namespace: e.namespace,
                        title: e.title
                    });
                }
                _showNotification(t) {
                    const e = t.namespace ? `show:${t.type}:${t.namespace}` : `show:${t.type}`;
                    this.fire(e, {
                        message: t.message,
                        type: t.type,
                        title: t.title || ""
                    });
                }
            }
            class nD extends ht() {
                constructor(t, e){
                    super();
                    if (e) Fg(this, e);
                    if (t) this.set(t);
                }
            }
            const oD = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>';
            const iD = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>';
            var rD = n(7592);
            var sD = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            sD.insert = "head";
            sD.singleton = true;
            var aD = Rl()(rD.Z, sD);
            const cD = rD.Z.locals || {};
            var lD = n(6356);
            var dD = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            dD.insert = "head";
            dD.singleton = true;
            var uD = Rl()(lD.Z, dD);
            const hD = lD.Z.locals || {};
            const fD = wc("px");
            class pD extends Pu {
                static get pluginName() {
                    return "ContextualBalloon";
                }
                constructor(t){
                    super(t);
                    this._viewToStack = new Map;
                    this._idToStack = new Map;
                    this._view = null;
                    this._rotatorView = null;
                    this._fakePanelsView = null;
                    this.positionLimiter = ()=>{
                        const t = this.editor.editing.view;
                        const e = t.document;
                        const n = e.selection.editableElement;
                        if (n) return t.domConverter.mapViewToDom(n.root);
                        return null;
                    };
                    this.set("visibleView", null);
                    this.set("_numberOfStacks", 0);
                    this.set("_singleViewMode", false);
                }
                destroy() {
                    super.destroy();
                    if (this._view) this._view.destroy();
                    if (this._rotatorView) this._rotatorView.destroy();
                    if (this._fakePanelsView) this._fakePanelsView.destroy();
                }
                get view() {
                    if (!this._view) this._createPanelView();
                    return this._view;
                }
                hasView(t) {
                    return Array.from(this._viewToStack.keys()).includes(t);
                }
                add(t) {
                    if (!this._view) this._createPanelView();
                    if (this.hasView(t.view)) throw new R("contextualballoon-add-view-exist", [
                        this,
                        t
                    ]);
                    const e = t.stackId || "main";
                    if (!this._idToStack.has(e)) {
                        this._idToStack.set(e, new Map([
                            [
                                t.view,
                                t
                            ]
                        ]));
                        this._viewToStack.set(t.view, this._idToStack.get(e));
                        this._numberOfStacks = this._idToStack.size;
                        if (!this._visibleStack || t.singleViewMode) this.showStack(e);
                        return;
                    }
                    const n = this._idToStack.get(e);
                    if (t.singleViewMode) this.showStack(e);
                    n.set(t.view, t);
                    this._viewToStack.set(t.view, n);
                    if (n === this._visibleStack) this._showView(t);
                }
                remove(t) {
                    if (!this.hasView(t)) throw new R("contextualballoon-remove-view-not-exist", [
                        this,
                        t
                    ]);
                    const e = this._viewToStack.get(t);
                    if (this._singleViewMode && this.visibleView === t) this._singleViewMode = false;
                    if (this.visibleView === t) {
                        if (e.size === 1) {
                            if (this._idToStack.size > 1) this._showNextStack();
                            else {
                                this.view.hide();
                                this.visibleView = null;
                                this._rotatorView.hideView();
                            }
                        } else this._showView(Array.from(e.values())[e.size - 2]);
                    }
                    if (e.size === 1) {
                        this._idToStack.delete(this._getStackId(e));
                        this._numberOfStacks = this._idToStack.size;
                    } else e.delete(t);
                    this._viewToStack.delete(t);
                }
                updatePosition(t) {
                    if (t) this._visibleStack.get(this.visibleView).position = t;
                    this.view.pin(this._getBalloonPosition());
                    this._fakePanelsView.updatePosition();
                }
                showStack(t) {
                    this.visibleStack = t;
                    const e = this._idToStack.get(t);
                    if (!e) throw new R("contextualballoon-showstack-stack-not-exist", this);
                    if (this._visibleStack === e) return;
                    this._showView(Array.from(e.values()).pop());
                }
                _createPanelView() {
                    this._view = new hE(this.editor.locale);
                    this.editor.ui.view.body.add(this._view);
                    this.editor.ui.focusTracker.add(this._view.element);
                    this._rotatorView = this._createRotatorView();
                    this._fakePanelsView = this._createFakePanelsView();
                }
                get _visibleStack() {
                    return this._viewToStack.get(this.visibleView);
                }
                _getStackId(t) {
                    const e = Array.from(this._idToStack.entries()).find((e)=>e[1] === t);
                    return e[0];
                }
                _showNextStack() {
                    const t = Array.from(this._idToStack.values());
                    let e = t.indexOf(this._visibleStack) + 1;
                    if (!t[e]) e = 0;
                    this.showStack(this._getStackId(t[e]));
                }
                _showPrevStack() {
                    const t = Array.from(this._idToStack.values());
                    let e = t.indexOf(this._visibleStack) - 1;
                    if (!t[e]) e = t.length - 1;
                    this.showStack(this._getStackId(t[e]));
                }
                _createRotatorView() {
                    const t = new gD(this.editor.locale);
                    const e = this.editor.locale.t;
                    this.view.content.add(t);
                    t.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (t, e)=>!e && t > 1);
                    t.on("change:isNavigationVisible", ()=>this.updatePosition(), {
                        priority: "low"
                    });
                    t.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (t, n)=>{
                        if (n < 2) return "";
                        const o = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
                        return e("%0 of %1", [
                            o,
                            n
                        ]);
                    });
                    t.buttonNextView.on("execute", ()=>{
                        if (t.focusTracker.isFocused) this.editor.editing.view.focus();
                        this._showNextStack();
                    });
                    t.buttonPrevView.on("execute", ()=>{
                        if (t.focusTracker.isFocused) this.editor.editing.view.focus();
                        this._showPrevStack();
                    });
                    return t;
                }
                _createFakePanelsView() {
                    const t = new mD(this.editor.locale, this.view);
                    t.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (t, e)=>{
                        const n = !e && t >= 2;
                        return n ? Math.min(t - 1, 2) : 0;
                    });
                    t.listenTo(this.view, "change:top", ()=>t.updatePosition());
                    t.listenTo(this.view, "change:left", ()=>t.updatePosition());
                    this.editor.ui.view.body.add(t);
                    return t;
                }
                _showView({ view: t, balloonClassName: e = "", withArrow: n = true, singleViewMode: o = false }) {
                    this.view.class = e;
                    this.view.withArrow = n;
                    this._rotatorView.showView(t);
                    this.visibleView = t;
                    this.view.pin(this._getBalloonPosition());
                    this._fakePanelsView.updatePosition();
                    if (o) this._singleViewMode = true;
                }
                _getBalloonPosition() {
                    let t = Array.from(this._visibleStack.values()).pop().position;
                    if (t) {
                        if (!t.limiter) t = Object.assign({}, t, {
                            limiter: this.positionLimiter
                        });
                        t = Object.assign({}, t, {
                            viewportOffsetConfig: this.editor.ui.viewportOffset
                        });
                    }
                    return t;
                }
            }
            class gD extends zl {
                constructor(t){
                    super(t);
                    const e = t.t;
                    const n = this.bindTemplate;
                    this.set("isNavigationVisible", true);
                    this.focusTracker = new pl;
                    this.buttonPrevView = this._createButtonView(e("Previous"), oD);
                    this.buttonNextView = this._createButtonView(e("Next"), iD);
                    this.content = this.createCollection();
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-balloon-rotator"
                            ],
                            "z-index": "-1"
                        },
                        children: [
                            {
                                tag: "div",
                                attributes: {
                                    class: [
                                        "ck-balloon-rotator__navigation",
                                        n.to("isNavigationVisible", (t)=>t ? "" : "ck-hidden")
                                    ]
                                },
                                children: [
                                    this.buttonPrevView,
                                    {
                                        tag: "span",
                                        attributes: {
                                            class: [
                                                "ck-balloon-rotator__counter"
                                            ]
                                        },
                                        children: [
                                            {
                                                text: n.to("counter")
                                            }
                                        ]
                                    },
                                    this.buttonNextView
                                ]
                            },
                            {
                                tag: "div",
                                attributes: {
                                    class: "ck-balloon-rotator__content"
                                },
                                children: this.content
                            }
                        ]
                    });
                }
                render() {
                    super.render();
                    this.focusTracker.add(this.element);
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                }
                showView(t) {
                    this.hideView();
                    this.content.add(t);
                }
                hideView() {
                    this.content.clear();
                }
                _createButtonView(t, e) {
                    const n = new yd(this.locale);
                    n.set({
                        label: t,
                        icon: e,
                        tooltip: true
                    });
                    return n;
                }
            }
            class mD extends zl {
                constructor(t, e){
                    super(t);
                    const n = this.bindTemplate;
                    this.set("top", 0);
                    this.set("left", 0);
                    this.set("height", 0);
                    this.set("width", 0);
                    this.set("numberOfPanels", 0);
                    this.content = this.createCollection();
                    this._balloonPanelView = e;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck-fake-panel",
                                n.to("numberOfPanels", (t)=>t ? "" : "ck-hidden")
                            ],
                            style: {
                                top: n.to("top", fD),
                                left: n.to("left", fD),
                                width: n.to("width", fD),
                                height: n.to("height", fD)
                            }
                        },
                        children: this.content
                    });
                    this.on("change:numberOfPanels", (t, e, n, o)=>{
                        if (n > o) this._addPanels(n - o);
                        else this._removePanels(o - n);
                        this.updatePosition();
                    });
                }
                _addPanels(t) {
                    while(t--){
                        const t = new zl;
                        t.setTemplate({
                            tag: "div"
                        });
                        this.content.add(t);
                        this.registerChild(t);
                    }
                }
                _removePanels(t) {
                    while(t--){
                        const t = this.content.last;
                        this.content.remove(t);
                        this.deregisterChild(t);
                        t.destroy();
                    }
                }
                updatePosition() {
                    if (this.numberOfPanels) {
                        const { top: t, left: e } = this._balloonPanelView;
                        const { width: n, height: o } = new dc(this._balloonPanelView.element);
                        Object.assign(this, {
                            top: t,
                            left: e,
                            width: n,
                            height: o
                        });
                    }
                }
            }
            var kD = n(3707);
            var bD = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            bD.insert = "head";
            bD.singleton = true;
            var wD = Rl()(kD.Z, bD);
            const _D = kD.Z.locals || {};
            const AD = wc("px");
            class vD extends zl {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.set("isActive", false);
                    this.set("isSticky", false);
                    this.set("limiterElement", null);
                    this.set("limiterBottomOffset", 50);
                    this.set("viewportTopOffset", 0);
                    this.set("_marginLeft", null);
                    this.set("_isStickyToTheBottomOfLimiter", false);
                    this.set("_stickyTopOffset", null);
                    this.set("_stickyBottomOffset", null);
                    this.content = this.createCollection();
                    this._contentPanelPlaceholder = new Fl({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-sticky-panel__placeholder"
                            ],
                            style: {
                                display: e.to("isSticky", (t)=>t ? "block" : "none"),
                                height: e.to("isSticky", (t)=>t ? AD(this._contentPanelRect.height) : null)
                            }
                        }
                    }).render();
                    this._contentPanel = new Fl({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-sticky-panel__content",
                                e.if("isSticky", "ck-sticky-panel__content_sticky"),
                                e.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")
                            ],
                            style: {
                                width: e.to("isSticky", (t)=>t ? AD(this._contentPanelPlaceholder.getBoundingClientRect().width) : null),
                                top: e.to("_stickyTopOffset", (t)=>t ? AD(t) : t),
                                bottom: e.to("_stickyBottomOffset", (t)=>t ? AD(t) : t),
                                marginLeft: e.to("_marginLeft")
                            }
                        },
                        children: this.content
                    }).render();
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-sticky-panel"
                            ]
                        },
                        children: [
                            this._contentPanelPlaceholder,
                            this._contentPanel
                        ]
                    });
                }
                render() {
                    super.render();
                    this.checkIfShouldBeSticky();
                    this.listenTo(ec.document, "scroll", ()=>{
                        this.checkIfShouldBeSticky();
                    }, {
                        useCapture: true
                    });
                    this.listenTo(this, "change:isActive", ()=>{
                        this.checkIfShouldBeSticky();
                    });
                }
                checkIfShouldBeSticky() {
                    if (!this.limiterElement || !this.isActive) {
                        this._unstick();
                        return;
                    }
                    const t = new dc(this.limiterElement);
                    let e = t.getVisible();
                    if (e) {
                        const t = new dc(ec.window);
                        t.top += this.viewportTopOffset;
                        t.height -= this.viewportTopOffset;
                        e = e.getIntersection(t);
                    }
                    if (e && t.top < e.top) {
                        const n = e.top;
                        if (n + this._contentPanelRect.height + this.limiterBottomOffset > e.bottom) {
                            const n = Math.max(t.bottom - e.bottom, 0) + this.limiterBottomOffset;
                            if (t.bottom - n > t.top + this._contentPanelRect.height) this._stickToBottomOfLimiter(n);
                            else this._unstick();
                        } else if (this._contentPanelRect.height + this.limiterBottomOffset < t.height) this._stickToTopOfAncestors(n);
                        else this._unstick();
                    } else this._unstick();
                }
                _stickToTopOfAncestors(t) {
                    this.isSticky = true;
                    this._isStickyToTheBottomOfLimiter = false;
                    this._stickyTopOffset = t;
                    this._stickyBottomOffset = null;
                    this._marginLeft = AD(-ec.window.scrollX);
                }
                _stickToBottomOfLimiter(t) {
                    this.isSticky = true;
                    this._isStickyToTheBottomOfLimiter = true;
                    this._stickyTopOffset = null;
                    this._stickyBottomOffset = t;
                    this._marginLeft = AD(-ec.window.scrollX);
                }
                _unstick() {
                    this.isSticky = false;
                    this._isStickyToTheBottomOfLimiter = false;
                    this._stickyTopOffset = null;
                    this._stickyBottomOffset = null;
                    this._marginLeft = null;
                }
                get _contentPanelRect() {
                    return new dc(this._contentPanel);
                }
            }
            class CD extends eu {
                constructor(t, e){
                    const n = t.t;
                    const o = Object.assign({}, {
                        showResetButton: true,
                        showIcon: true,
                        creator: Iy
                    }, e);
                    super(t, o.creator);
                    this.label = e.label;
                    this._viewConfig = o;
                    if (this._viewConfig.showIcon) {
                        this.iconView = new bd;
                        this.iconView.content = FC.loupe;
                        this.fieldWrapperChildren.add(this.iconView, 0);
                        this.extendTemplate({
                            attributes: {
                                class: "ck-search__query_with-icon"
                            }
                        });
                    }
                    if (this._viewConfig.showResetButton) {
                        this.resetButtonView = new yd(t);
                        this.resetButtonView.set({
                            label: n("Clear"),
                            icon: FC.cancel,
                            class: "ck-search__reset",
                            isVisible: false,
                            tooltip: true
                        });
                        this.resetButtonView.on("execute", ()=>{
                            this.reset();
                            this.focus();
                            this.fire("reset");
                        });
                        this.resetButtonView.bind("isVisible").to(this.fieldView, "isEmpty", (t)=>!t);
                        this.fieldWrapperChildren.add(this.resetButtonView);
                        this.extendTemplate({
                            attributes: {
                                class: "ck-search__query_with-reset"
                            }
                        });
                    }
                }
                reset() {
                    this.fieldView.reset();
                    if (this._viewConfig.showResetButton) this.resetButtonView.isVisible = false;
                }
            }
            class yD extends zl {
                constructor(){
                    super();
                    const t = this.bindTemplate;
                    this.set({
                        isVisible: false,
                        primaryText: "",
                        secondaryText: ""
                    });
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-search__info",
                                t.if("isVisible", "ck-hidden", (t)=>!t)
                            ],
                            tabindex: -1
                        },
                        children: [
                            {
                                tag: "span",
                                children: [
                                    {
                                        text: [
                                            t.to("primaryText")
                                        ]
                                    }
                                ]
                            },
                            {
                                tag: "span",
                                children: [
                                    {
                                        text: [
                                            t.to("secondaryText")
                                        ]
                                    }
                                ]
                            }
                        ]
                    });
                }
                focus() {
                    this.element.focus();
                }
            }
            class xD extends zl {
                constructor(t){
                    super(t);
                    this.children = this.createCollection();
                    this.focusTracker = new pl;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-search__results"
                            ],
                            tabindex: -1
                        },
                        children: this.children
                    });
                    this._focusCycler = new xu({
                        focusables: this.children,
                        focusTracker: this.focusTracker
                    });
                }
                render() {
                    super.render();
                    for (const t of this.children)this.focusTracker.add(t.element);
                }
                focus() {
                    this._focusCycler.focusFirst();
                }
                focusFirst() {
                    this._focusCycler.focusFirst();
                }
                focusLast() {
                    this._focusCycler.focusLast();
                }
            }
            var ED = /[\\^$.*+?()[\]{}|]/g, DD = RegExp(ED.source);
            function SD(t) {
                t = jh(t);
                return t && DD.test(t) ? t.replace(ED, "\\$&") : t;
            }
            const TD = SD;
            var BD = n(9332);
            var PD = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            PD.insert = "head";
            PD.singleton = true;
            var ID = Rl()(BD.Z, PD);
            const RD = BD.Z.locals || {};
            class OD extends zl {
                constructor(t, e){
                    super(t);
                    this._config = e;
                    this.filteredView = e.filteredView;
                    this.queryView = this._createSearchTextQueryView();
                    this.focusTracker = new pl;
                    this.keystrokes = new gl;
                    this.resultsView = new xD(t);
                    this.children = this.createCollection();
                    this.focusableChildren = this.createCollection([
                        this.queryView,
                        this.resultsView
                    ]);
                    this.set("isEnabled", true);
                    this.set("resultsCount", 0);
                    this.set("totalItemsCount", 0);
                    if (e.infoView && e.infoView.instance) this.infoView = e.infoView.instance;
                    else {
                        this.infoView = new yD;
                        this._enableDefaultInfoViewBehavior();
                        this.on("render", ()=>{
                            this.search("");
                        });
                    }
                    this.resultsView.children.addMany([
                        this.infoView,
                        this.filteredView
                    ]);
                    this.focusCycler = new xu({
                        focusables: this.focusableChildren,
                        focusTracker: this.focusTracker,
                        keystrokeHandler: this.keystrokes,
                        actions: {
                            focusPrevious: "shift + tab",
                            focusNext: "tab"
                        }
                    });
                    this.on("search", (t, { resultsCount: e, totalItemsCount: n })=>{
                        this.resultsCount = e;
                        this.totalItemsCount = n;
                    });
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-search",
                                e.class || null
                            ],
                            tabindex: "-1"
                        },
                        children: this.children
                    });
                }
                render() {
                    super.render();
                    this.children.addMany([
                        this.queryView,
                        this.resultsView
                    ]);
                    const t = (t)=>t.stopPropagation();
                    for (const t of this.focusableChildren)this.focusTracker.add(t.element);
                    this.keystrokes.listenTo(this.element);
                    this.keystrokes.set("arrowright", t);
                    this.keystrokes.set("arrowleft", t);
                    this.keystrokes.set("arrowup", t);
                    this.keystrokes.set("arrowdown", t);
                }
                focus() {
                    this.queryView.focus();
                }
                reset() {
                    this.queryView.reset();
                    this.search("");
                }
                search(t) {
                    const e = t ? new RegExp(TD(t), "ig") : null;
                    const n = this.filteredView.filter(e);
                    this.fire("search", {
                        query: t,
                        ...n
                    });
                }
                _createSearchTextQueryView() {
                    const t = new CD(this.locale, this._config.queryView);
                    this.listenTo(t.fieldView, "input", ()=>{
                        this.search(t.fieldView.element.value);
                    });
                    t.on("reset", ()=>this.reset());
                    t.bind("isEnabled").to(this);
                    return t;
                }
                _enableDefaultInfoViewBehavior() {
                    const t = this.locale.t;
                    const e = this.infoView;
                    this.on("search", (o, i)=>{
                        if (!i.resultsCount) {
                            const o = this._config.infoView && this._config.infoView.text;
                            let r, s;
                            if (i.totalItemsCount) {
                                if (o && o.notFound) {
                                    r = o.notFound.primary;
                                    s = o.notFound.secondary;
                                } else {
                                    r = t("No results found");
                                    s = "";
                                }
                            } else if (o && o.noSearchableItems) {
                                r = o.noSearchableItems.primary;
                                s = o.noSearchableItems.secondary;
                            } else {
                                r = t("No searchable items");
                                s = "";
                            }
                            e.set({
                                primaryText: n(r, i),
                                secondaryText: n(s, i),
                                isVisible: true
                            });
                        } else e.set({
                            isVisible: false
                        });
                    });
                    function n(t, { query: e, resultsCount: n, totalItemsCount: o }) {
                        return typeof t === "function" ? t(e, n, o) : t;
                    }
                }
            }
            var VD = n(4029);
            var MD = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            MD.insert = "head";
            MD.singleton = true;
            var LD = Rl()(VD.Z, MD);
            const zD = VD.Z.locals || {};
            class ND extends OD {
                constructor(t, e){
                    super(t, e);
                    this._config = e;
                    const n = wc("px");
                    this.extendTemplate({
                        attributes: {
                            class: [
                                "ck-autocomplete"
                            ]
                        }
                    });
                    const o = this.resultsView.bindTemplate;
                    this.resultsView.set("isVisible", false);
                    this.resultsView.set("_position", "s");
                    this.resultsView.set("_width", 0);
                    this.resultsView.extendTemplate({
                        attributes: {
                            class: [
                                o.if("isVisible", "ck-hidden", (t)=>!t),
                                o.to("_position", (t)=>`ck-search__results_${t}`)
                            ],
                            style: {
                                width: o.to("_width", n)
                            }
                        }
                    });
                    this.focusTracker.on("change:isFocused", (t, n, o)=>{
                        this._updateResultsVisibility();
                        if (o) this.resultsView.element.scrollTop = 0;
                        else if (e.resetOnBlur) this.queryView.reset();
                    });
                    this.on("search", ()=>{
                        this._updateResultsVisibility();
                        this._updateResultsViewWidthAndPosition();
                    });
                    this.keystrokes.set("esc", (t, e)=>{
                        this.resultsView.isVisible = false;
                        e();
                    });
                    this.listenTo(ec.document, "scroll", ()=>{
                        this._updateResultsViewWidthAndPosition();
                    });
                    this.on("change:isEnabled", ()=>{
                        this._updateResultsVisibility();
                    });
                    this.filteredView.on("execute", (t, { value: e })=>{
                        this.focus();
                        this.reset();
                        this.queryView.fieldView.value = this.queryView.fieldView.element.value = e;
                        this.resultsView.isVisible = false;
                    });
                    this.resultsView.on("change:isVisible", ()=>{
                        this._updateResultsViewWidthAndPosition();
                    });
                }
                _updateResultsViewWidthAndPosition() {
                    if (!this.resultsView.isVisible) return;
                    this.resultsView._width = new dc(this.queryView.fieldView.element).width;
                    const t = ND._getOptimalPosition({
                        element: this.resultsView.element,
                        target: this.queryView.element,
                        fitInViewport: true,
                        positions: ND.defaultResultsPositions
                    });
                    this.resultsView._position = t ? t.name : "s";
                }
                _updateResultsVisibility() {
                    const t = typeof this._config.queryMinChars === "undefined" ? 0 : this._config.queryMinChars;
                    const e = this.queryView.fieldView.element.value.length;
                    this.resultsView.isVisible = this.focusTracker.isFocused && this.isEnabled && e >= t;
                }
            }
            ND.defaultResultsPositions = [
                (t)=>({
                        top: t.bottom,
                        left: t.left,
                        name: "s"
                    }),
                (t, e)=>({
                        top: t.top - e.height,
                        left: t.left,
                        name: "n"
                    })
            ];
            ND._getOptimalPosition = xc;
            var FD = n(4746);
            var HD = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            HD.insert = "head";
            HD.singleton = true;
            var jD = Rl()(FD.Z, HD);
            const qD = FD.Z.locals || {};
            class WD extends null {
                constructor(){
                    super();
                    this.set("text", undefined);
                    this.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-highlighted-text"
                            ]
                        }
                    });
                    this.on("render", ()=>{
                        this.on("change:text", ()=>{
                            this._updateInnerHTML(this.text);
                        });
                        this._updateInnerHTML(this.text);
                    });
                }
                highlightText(t) {
                    this._updateInnerHTML($D(this.text || "", t));
                }
                _updateInnerHTML(t) {
                    this.element.innerHTML = t || "";
                }
            }
            function $D(t, e) {
                if (!e) return escape(t);
                const n = [];
                let o = 0;
                let i = e.exec(t);
                while(i !== null){
                    const r = i.index;
                    if (r !== o) n.push({
                        text: t.substring(o, r),
                        isMatch: false
                    });
                    n.push({
                        text: i[0],
                        isMatch: true
                    });
                    o = e.lastIndex;
                    i = e.exec(t);
                }
                if (o !== t.length) n.push({
                    text: t.substring(o),
                    isMatch: false
                });
                const r = n.map((t)=>{
                    t.text = escape(t.text);
                    return t;
                }).map((t)=>t.isMatch ? `<mark>${t.text}</mark>` : t.text).join("");
                return r;
            }
            var GD = n(6446);
            var UD = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            UD.insert = "head";
            UD.singleton = true;
            var KD = Rl()(GD.Z, UD);
            const ZD = GD.Z.locals || {};
            class JD extends null {
                constructor(){
                    super();
                    this.set("isVisible", false);
                    const t = this.bindTemplate;
                    this.setTemplate({
                        tag: "span",
                        attributes: {
                            class: [
                                "ck",
                                "ck-spinner-container",
                                t.if("isVisible", "ck-hidden", (t)=>!t)
                            ]
                        },
                        children: [
                            {
                                tag: "span",
                                attributes: {
                                    class: [
                                        "ck",
                                        "ck-spinner"
                                    ]
                                }
                            }
                        ]
                    });
                }
            }
            const YD = wc("px");
            class QD extends null {
                static get pluginName() {
                    return "BalloonToolbar";
                }
                static get requires() {
                    return [
                        ContextualBalloon
                    ];
                }
                constructor(t){
                    super(t);
                    this._resizeObserver = null;
                    this._balloonConfig = normalizeToolbarConfig(t.config.get("balloonToolbar"));
                    this.toolbarView = this._createToolbarView();
                    this.focusTracker = new FocusTracker;
                    t.ui.once("ready", ()=>{
                        this.focusTracker.add(t.ui.getEditableElement());
                        this.focusTracker.add(this.toolbarView.element);
                    });
                    t.ui.addToolbar(this.toolbarView, {
                        beforeFocus: ()=>this.show(true),
                        afterBlur: ()=>this.hide(),
                        isContextual: true
                    });
                    this._balloon = t.plugins.get(ContextualBalloon);
                    this._fireSelectionChangeDebounced = debounce(()=>this.fire("_selectionChangeDebounced"), 200);
                    this.decorate("show");
                }
                init() {
                    const t = this.editor;
                    const e = t.model.document.selection;
                    this.listenTo(this.focusTracker, "change:isFocused", (t, e, n)=>{
                        const o = this._balloon.visibleView === this.toolbarView;
                        if (!n && o) this.hide();
                        else if (n) this.show();
                    });
                    this.listenTo(e, "change:range", (t, n)=>{
                        if (n.directChange || e.isCollapsed) this.hide();
                        this._fireSelectionChangeDebounced();
                    });
                    this.listenTo(this, "_selectionChangeDebounced", ()=>{
                        if (this.editor.editing.view.document.isFocused) this.show();
                    });
                    if (!this._balloonConfig.shouldNotGroupWhenFull) this.listenTo(t, "ready", ()=>{
                        const e = t.ui.view.editable.element;
                        this._resizeObserver = new ResizeObserver(e, (t)=>{
                            this.toolbarView.maxWidth = YD(t.contentRect.width * .9);
                        });
                    });
                    this.listenTo(this.toolbarView, "groupedItemsUpdate", ()=>{
                        this._updatePosition();
                    });
                }
                afterInit() {
                    const t = this.editor.ui.componentFactory;
                    this.toolbarView.fillFromConfig(this._balloonConfig, t);
                }
                _createToolbarView() {
                    const t = this.editor.locale.t;
                    const e = !this._balloonConfig.shouldNotGroupWhenFull;
                    const n = new ToolbarView(this.editor.locale, {
                        shouldGroupWhenFull: e,
                        isFloating: true
                    });
                    n.ariaLabel = t("Editor contextual toolbar");
                    n.render();
                    return n;
                }
                show(t = false) {
                    const e = this.editor;
                    const n = e.model.document.selection;
                    const o = e.model.schema;
                    if (this._balloon.hasView(this.toolbarView)) return;
                    if (n.isCollapsed && !t) return;
                    if (XD(n, o)) return;
                    if (Array.from(this.toolbarView.items).every((t)=>t.isEnabled !== undefined && !t.isEnabled)) return;
                    this.listenTo(this.editor.ui, "update", ()=>{
                        this._updatePosition();
                    });
                    this._balloon.add({
                        view: this.toolbarView,
                        position: this._getBalloonPositionData(),
                        balloonClassName: "ck-toolbar-container"
                    });
                }
                hide() {
                    if (this._balloon.hasView(this.toolbarView)) {
                        this.stopListening(this.editor.ui, "update");
                        this._balloon.remove(this.toolbarView);
                    }
                }
                _getBalloonPositionData() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    const o = n.selection;
                    const i = n.selection.isBackward;
                    return {
                        target: ()=>{
                            const t = i ? o.getFirstRange() : o.getLastRange();
                            const n = Rect.getDomRangeRects(e.domConverter.viewRangeToDom(t));
                            if (i) return n[0];
                            else {
                                if (n.length > 1 && n[n.length - 1].width === 0) n.pop();
                                return n[n.length - 1];
                            }
                        },
                        positions: this._getBalloonPositions(i)
                    };
                }
                _updatePosition() {
                    this._balloon.updatePosition(this._getBalloonPositionData());
                }
                destroy() {
                    super.destroy();
                    this.stopListening();
                    this._fireSelectionChangeDebounced.cancel();
                    this.toolbarView.destroy();
                    this.focusTracker.destroy();
                    if (this._resizeObserver) this._resizeObserver.destroy();
                }
                _getBalloonPositions(t) {
                    const e = env.isSafari && env.isiOS;
                    const n = e ? generatePositions({
                        heightOffset: Math.max(BalloonPanelView.arrowHeightOffset, Math.round(20 / $parcel$global.window.visualViewport.scale))
                    }) : BalloonPanelView.defaultPositions;
                    return t ? [
                        n.northWestArrowSouth,
                        n.northWestArrowSouthWest,
                        n.northWestArrowSouthEast,
                        n.northWestArrowSouthMiddleEast,
                        n.northWestArrowSouthMiddleWest,
                        n.southWestArrowNorth,
                        n.southWestArrowNorthWest,
                        n.southWestArrowNorthEast,
                        n.southWestArrowNorthMiddleWest,
                        n.southWestArrowNorthMiddleEast
                    ] : [
                        n.southEastArrowNorth,
                        n.southEastArrowNorthEast,
                        n.southEastArrowNorthWest,
                        n.southEastArrowNorthMiddleEast,
                        n.southEastArrowNorthMiddleWest,
                        n.northEastArrowSouth,
                        n.northEastArrowSouthEast,
                        n.northEastArrowSouthWest,
                        n.northEastArrowSouthMiddleEast,
                        n.northEastArrowSouthMiddleWest
                    ];
                }
            }
            function XD(t, e) {
                if (t.rangeCount === 1) return false;
                return [
                    ...t.getRanges()
                ].every((t)=>{
                    const n = t.getContainedElement();
                    return n && e.isSelectable(n);
                });
            }
            var tS = n(4176);
            var eS = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            eS.insert = "head";
            eS.singleton = true;
            var nS = Rl()(tS.Z, eS);
            const oS = tS.Z.locals || {};
            const iS = wc("px");
            class rS extends null {
                constructor(t){
                    super(t);
                    const e = this.bindTemplate;
                    this.isVisible = false;
                    this.isToggleable = true;
                    this.set("top", 0);
                    this.set("left", 0);
                    this.extendTemplate({
                        attributes: {
                            class: "ck-block-toolbar-button",
                            style: {
                                top: e.to("top", (t)=>iS(t)),
                                left: e.to("left", (t)=>iS(t))
                            }
                        }
                    });
                }
            }
            const sS = wc("px");
            class aS extends null {
                static get pluginName() {
                    return "BlockToolbar";
                }
                constructor(t){
                    super(t);
                    this._resizeObserver = null;
                    this._blockToolbarConfig = normalizeToolbarConfig(this.editor.config.get("blockToolbar"));
                    this.toolbarView = this._createToolbarView();
                    this.panelView = this._createPanelView();
                    this.buttonView = this._createButtonView();
                    clickOutsideHandler({
                        emitter: this.panelView,
                        contextElements: [
                            this.panelView.element,
                            this.buttonView.element
                        ],
                        activator: ()=>this.panelView.isVisible,
                        callback: ()=>this._hidePanel()
                    });
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    const n = e("Click to edit block");
                    const o = e("Drag to move");
                    const i = e("Edit block");
                    const r = t.plugins.has("DragDropBlockToolbar");
                    const s = r ? `${n}\n${o}` : i;
                    this.buttonView.label = s;
                    if (r) this.buttonView.element.dataset.ckeTooltipClass = "ck-tooltip_multi-line";
                    this.listenTo(t.model.document.selection, "change:range", (t, e)=>{
                        if (e.directChange) this._hidePanel();
                    });
                    this.listenTo(t.ui, "update", ()=>this._updateButton());
                    this.listenTo(t, "change:isReadOnly", ()=>this._updateButton(), {
                        priority: "low"
                    });
                    this.listenTo(t.ui.focusTracker, "change:isFocused", ()=>this._updateButton());
                    this.listenTo(this.buttonView, "change:isVisible", (t, e, n)=>{
                        if (n) this.buttonView.listenTo(window, "resize", ()=>this._updateButton());
                        else {
                            this.buttonView.stopListening(window, "resize");
                            this._hidePanel();
                        }
                    });
                    t.ui.addToolbar(this.toolbarView, {
                        beforeFocus: ()=>this._showPanel(),
                        afterBlur: ()=>this._hidePanel()
                    });
                }
                afterInit() {
                    this.toolbarView.fillFromConfig(this._blockToolbarConfig, this.editor.ui.componentFactory);
                    for (const t of this.toolbarView.items)t.on("execute", ()=>this._hidePanel(true), {
                        priority: "high"
                    });
                }
                destroy() {
                    super.destroy();
                    this.panelView.destroy();
                    this.buttonView.destroy();
                    this.toolbarView.destroy();
                    if (this._resizeObserver) this._resizeObserver.destroy();
                }
                _createToolbarView() {
                    const t = this.editor.locale.t;
                    const e = !this._blockToolbarConfig.shouldNotGroupWhenFull;
                    const n = new ToolbarView(this.editor.locale, {
                        shouldGroupWhenFull: e,
                        isFloating: true
                    });
                    n.ariaLabel = t("Editor block content toolbar");
                    return n;
                }
                _createPanelView() {
                    const t = this.editor;
                    const e = new BalloonPanelView(t.locale);
                    e.content.add(this.toolbarView);
                    e.class = "ck-toolbar-container";
                    t.ui.view.body.add(e);
                    t.ui.focusTracker.add(e.element);
                    this.toolbarView.keystrokes.set("Esc", (t, e)=>{
                        this._hidePanel(true);
                        e();
                    });
                    return e;
                }
                _createButtonView() {
                    const t = this.editor;
                    const e = t.t;
                    const n = new BlockButtonView(t.locale);
                    const o = this._blockToolbarConfig.icon;
                    const i = NESTED_TOOLBAR_ICONS[o] || o || NESTED_TOOLBAR_ICONS.dragIndicator;
                    n.set({
                        label: e("Edit block"),
                        icon: i,
                        withText: false
                    });
                    n.bind("isOn").to(this.panelView, "isVisible");
                    n.bind("tooltip").to(this.panelView, "isVisible", (t)=>!t);
                    this.listenTo(n, "execute", ()=>{
                        if (!this.panelView.isVisible) this._showPanel();
                        else this._hidePanel(true);
                    });
                    t.ui.view.body.add(n);
                    t.ui.focusTracker.add(n.element);
                    return n;
                }
                _updateButton() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.editing.view;
                    if (!t.ui.focusTracker.isFocused) {
                        this._hideButton();
                        return;
                    }
                    if (!t.model.canEditAt(t.model.document.selection)) {
                        this._hideButton();
                        return;
                    }
                    const o = Array.from(e.document.selection.getSelectedBlocks())[0];
                    if (!o || Array.from(this.toolbarView.items).every((t)=>!t.isEnabled)) {
                        this._hideButton();
                        return;
                    }
                    const i = n.domConverter.mapViewToDom(t.editing.mapper.toViewElement(o));
                    this.buttonView.isVisible = true;
                    this._setupToolbarResize();
                    this._attachButtonToElement(i);
                    if (this.panelView.isVisible) this._showPanel();
                }
                _hideButton() {
                    this.buttonView.isVisible = false;
                }
                _showPanel() {
                    if (!this.buttonView.isVisible) return;
                    const t = this.panelView.isVisible;
                    this.panelView.show();
                    const e = this._getSelectedEditableElement();
                    this.toolbarView.maxWidth = this._getToolbarMaxWidth(e);
                    this.panelView.pin({
                        target: this.buttonView.element,
                        limiter: e
                    });
                    if (!t) this.toolbarView.items.get(0).focus();
                }
                _getSelectedEditableElement() {
                    const t = this.editor.model.document.selection.getFirstRange().root.rootName;
                    return this.editor.ui.getEditableElement(t);
                }
                _hidePanel(t) {
                    this.panelView.isVisible = false;
                    if (t) this.editor.editing.view.focus();
                }
                _attachButtonToElement(t) {
                    const e = window.getComputedStyle(t);
                    const n = new Rect(this._getSelectedEditableElement());
                    const o = parseInt(e.paddingTop, 10);
                    const i = parseInt(e.lineHeight, 10) || parseInt(e.fontSize, 10) * 1.2;
                    const r = new Rect(this.buttonView.element);
                    const s = new Rect(t);
                    let a;
                    if (this.editor.locale.uiLanguageDirection === "ltr") a = n.left - r.width;
                    else a = n.right;
                    const c = s.top + o + (i - r.height) / 2;
                    r.moveTo(a, c);
                    const l = r.toAbsoluteRect();
                    this.buttonView.top = l.top;
                    this.buttonView.left = l.left;
                }
                _setupToolbarResize() {
                    const t = this._getSelectedEditableElement();
                    if (!this._blockToolbarConfig.shouldNotGroupWhenFull) {
                        if (this._resizeObserver && this._resizeObserver.element !== t) {
                            this._resizeObserver.destroy();
                            this._resizeObserver = null;
                        }
                        if (!this._resizeObserver) this._resizeObserver = new ResizeObserver(t, ()=>{
                            this.toolbarView.maxWidth = this._getToolbarMaxWidth(t);
                        });
                    }
                }
                _getToolbarMaxWidth(t) {
                    const e = new Rect(t);
                    const n = new Rect(this.buttonView.element);
                    const o = this.editor.locale.uiLanguageDirection === "rtl";
                    const i = o ? n.left - e.right + n.width : e.left - n.left;
                    return sS(e.width + i);
                }
            }
            const cS = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.209 18.717A8.5 8.5 0 1 1 18.686 9.6h-.008l.002.12a3 3 0 0 1-2.866 2.997h-.268l-.046-.002v.002h-4.791a2 2 0 1 0 0 4 1 1 0 1 1-.128 1.992 8.665 8.665 0 0 1-.372.008Zm-3.918-7.01a1.25 1.25 0 1 0-2.415-.648 1.25 1.25 0 0 0 2.415.647ZM5.723 8.18a1.25 1.25 0 1 0 .647-2.414 1.25 1.25 0 0 0-.647 2.414ZM9.76 6.155a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Zm4.028 1.759a1.25 1.25 0 1 0 .647-2.415 1.25 1.25 0 0 0-.647 2.415Z"/></svg>';
            const lS = {
                colorPaletteIcon: cS
            };
            class dS extends NE {
                constructor(t, e){
                    super(t);
                    this.view = e;
                    this._toolbarConfig = Bu(t.config.get("toolbar"));
                    this._elementReplacer = new Ct;
                    this.listenTo(t.editing.view, "scrollToTheSelection", this._handleScrollToTheSelectionWithStickyPanel.bind(this));
                }
                get element() {
                    return this.view.element;
                }
                init(t) {
                    const e = this.editor;
                    const n = this.view;
                    const o = e.editing.view;
                    const i = n.editable;
                    const r = o.document.getRoot();
                    i.name = r.rootName;
                    n.render();
                    const s = i.element;
                    this.setEditableElement(i.name, s);
                    n.editable.bind("isFocused").to(this.focusTracker);
                    o.attachDomRoot(s);
                    if (t) this._elementReplacer.replace(t, this.element);
                    this._initPlaceholder();
                    this._initToolbar();
                    this.fire("ready");
                }
                destroy() {
                    super.destroy();
                    const t = this.view;
                    const e = this.editor.editing.view;
                    this._elementReplacer.restore();
                    e.detachDomRoot(t.editable.name);
                    t.destroy();
                }
                _initToolbar() {
                    const t = this.view;
                    t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused");
                    t.stickyPanel.limiterElement = t.element;
                    t.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", ({ top: t })=>t || 0);
                    t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory);
                    this.addToolbar(t.toolbar);
                }
                _initPlaceholder() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document.getRoot();
                    const o = t.sourceElement;
                    let i;
                    const r = t.config.get("placeholder");
                    if (r) i = typeof r === "string" ? r : r[this.view.editable.name];
                    if (!i && o && o.tagName.toLowerCase() === "textarea") i = o.getAttribute("placeholder");
                    if (i) n.placeholder = i;
                    $u({
                        view: e,
                        element: n,
                        isDirectHost: false,
                        keepOnFocus: true
                    });
                }
                _handleScrollToTheSelectionWithStickyPanel(t, e, n) {
                    const o = this.view.stickyPanel;
                    if (o.isSticky) {
                        const t = new dc(o.element).height;
                        e.viewportOffset.top += t;
                    } else {
                        const t = ()=>{
                            this.editor.editing.view.scrollToTheSelection(n);
                        };
                        this.listenTo(o, "change:isSticky", t);
                        setTimeout(()=>{
                            this.stopListening(o, "change:isSticky", t);
                        }, 20);
                    }
                }
            }
            var uS = n(3624);
            var hS = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            hS.insert = "head";
            hS.singleton = true;
            var fS = Rl()(uS.Z, hS);
            const pS = uS.Z.locals || {};
            class gS extends GE {
                constructor(t, e, n = {}){
                    super(t);
                    this.stickyPanel = new vD(t);
                    this.toolbar = new UC(t, {
                        shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
                    });
                    this.editable = new KE(t, e);
                }
                render() {
                    super.render();
                    this.stickyPanel.content.add(this.toolbar);
                    this.top.add(this.stickyPanel);
                    this.main.add(this.editable);
                }
            }
            class mS {
                constructor(t){
                    this.crashes = [];
                    this.state = "initializing";
                    this._now = Date.now;
                    this.crashes = [];
                    this._crashNumberLimit = typeof t.crashNumberLimit === "number" ? t.crashNumberLimit : 3;
                    this._minimumNonErrorTimePeriod = typeof t.minimumNonErrorTimePeriod === "number" ? t.minimumNonErrorTimePeriod : 5e3;
                    this._boundErrorHandler = (t)=>{
                        const e = "error" in t ? t.error : t.reason;
                        if (e instanceof Error) this._handleError(e, t);
                    };
                    this._listeners = {};
                    if (!this._restart) throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
                }
                destroy() {
                    this._stopErrorHandling();
                    this._listeners = {};
                }
                on(t, e) {
                    if (!this._listeners[t]) this._listeners[t] = [];
                    this._listeners[t].push(e);
                }
                off(t, e) {
                    this._listeners[t] = this._listeners[t].filter((t)=>t !== e);
                }
                _fire(t, ...e) {
                    const n = this._listeners[t] || [];
                    for (const t of n)t.apply(this, [
                        null,
                        ...e
                    ]);
                }
                _startErrorHandling() {
                    window.addEventListener("error", this._boundErrorHandler);
                    window.addEventListener("unhandledrejection", this._boundErrorHandler);
                }
                _stopErrorHandling() {
                    window.removeEventListener("error", this._boundErrorHandler);
                    window.removeEventListener("unhandledrejection", this._boundErrorHandler);
                }
                _handleError(t, e) {
                    if (this._shouldReactToError(t)) {
                        this.crashes.push({
                            message: t.message,
                            stack: t.stack,
                            filename: e instanceof ErrorEvent ? e.filename : undefined,
                            lineno: e instanceof ErrorEvent ? e.lineno : undefined,
                            colno: e instanceof ErrorEvent ? e.colno : undefined,
                            date: this._now()
                        });
                        const n = this._shouldRestart();
                        this.state = "crashed";
                        this._fire("stateChange");
                        this._fire("error", {
                            error: t,
                            causesRestart: n
                        });
                        if (n) this._restart();
                        else {
                            this.state = "crashedPermanently";
                            this._fire("stateChange");
                        }
                    }
                }
                _shouldReactToError(t) {
                    return t.is && t.is("CKEditorError") && t.context !== undefined && t.context !== null && this.state === "ready" && this._isErrorComingFromThisItem(t);
                }
                _shouldRestart() {
                    if (this.crashes.length <= this._crashNumberLimit) return true;
                    const t = this.crashes[this.crashes.length - 1].date;
                    const e = this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date;
                    const n = (t - e) / this._crashNumberLimit;
                    return n > this._minimumNonErrorTimePeriod;
                }
            }
            function kS(t, e = new Set) {
                const n = [
                    t
                ];
                const o = new Set;
                let i = 0;
                while(n.length > i){
                    const t = n[i++];
                    if (o.has(t) || !bS(t) || e.has(t)) continue;
                    o.add(t);
                    if (Symbol.iterator in t) try {
                        for (const e of t)n.push(e);
                    } catch (t) {}
                    else for(const e in t){
                        if (e === "defaultValue") continue;
                        n.push(t[e]);
                    }
                }
                return o;
            }
            function bS(t) {
                const e = Object.prototype.toString.call(t);
                const n = typeof t;
                return !(n === "number" || n === "boolean" || n === "string" || n === "symbol" || n === "function" || e === "[object Date]" || e === "[object RegExp]" || e === "[object Module]" || t === undefined || t === null || t._watchdogExcluded || t instanceof EventTarget || t instanceof Event);
            }
            function wS(t, e, n = new Set) {
                if (t === e && AS(t)) return true;
                const o = kS(t, n);
                const i = kS(e, n);
                for (const t of o){
                    if (i.has(t)) return true;
                }
                return false;
            }
            function _S(t, e, n) {
                const { subNodes: o, prevNodeMap: i } = getSubNodes(t, n.subNodes);
                const { subNodes: r, prevNodeMap: s } = getSubNodes(e, n.subNodes);
                for (const n of o)if (r.has(n)) {
                    const o = [];
                    o.push(n);
                    let r = i.get(n);
                    while(r && r !== t){
                        o.push(r);
                        r = i.get(r);
                    }
                    r = s.get(n);
                    while(r && r !== e){
                        o.unshift(r);
                        r = s.get(r);
                    }
                    console.log("--------");
                    console.log({
                        target1: t
                    });
                    console.log({
                        sharedNode: n
                    });
                    console.log({
                        target2: e
                    });
                    console.log({
                        connection: o
                    });
                    return true;
                }
                return false;
            }
            function AS(t) {
                return typeof t === "object" && t !== null;
            }
            class vS extends mS {
                constructor(t, e = {}){
                    super(e);
                    this._editor = null;
                    this._initUsingData = true;
                    this._editables = {};
                    this._throttledSave = xE(this._save.bind(this), typeof e.saveInterval === "number" ? e.saveInterval : 5e3);
                    if (t) this._creator = (e, n)=>t.create(e, n);
                    this._destructor = (t)=>t.destroy();
                }
                get editor() {
                    return this._editor;
                }
                get _item() {
                    return this._editor;
                }
                setCreator(t) {
                    this._creator = t;
                }
                setDestructor(t) {
                    this._destructor = t;
                }
                _restart() {
                    return Promise.resolve().then(()=>{
                        this.state = "initializing";
                        this._fire("stateChange");
                        return this._destroy();
                    }).catch((t)=>{
                        console.error("An error happened during the editor destroying.", t);
                    }).then(()=>{
                        const t = {};
                        const e = [];
                        const n = this._config.rootsAttributes || {};
                        const o = {};
                        for (const [i, r] of Object.entries(this._data.roots))if (r.isLoaded) {
                            t[i] = "";
                            o[i] = n[i] || {};
                        } else e.push(i);
                        const i = {
                            ...this._config,
                            extraPlugins: this._config.extraPlugins || [],
                            lazyRoots: e,
                            rootsAttributes: o,
                            _watchdogInitialData: this._data
                        };
                        delete i.initialData;
                        i.extraPlugins.push(CS);
                        if (this._initUsingData) return this.create(t, i, i.context);
                        else {
                            if (qa(this._elementOrData)) return this.create(this._elementOrData, i, i.context);
                            else return this.create(this._editables, i, i.context);
                        }
                    }).then(()=>{
                        this._fire("restart");
                    });
                }
                create(t = this._elementOrData, e = this._config, n) {
                    return Promise.resolve().then(()=>{
                        super._startErrorHandling();
                        this._elementOrData = t;
                        this._initUsingData = typeof t == "string" || Object.keys(t).length > 0 && typeof Object.values(t)[0] == "string";
                        this._config = this._cloneEditorConfiguration(e) || {};
                        this._config.context = n;
                        return this._creator(t, this._config);
                    }).then((t)=>{
                        this._editor = t;
                        t.model.document.on("change:data", this._throttledSave);
                        this._lastDocumentVersion = t.model.document.version;
                        this._data = this._getData();
                        if (!this._initUsingData) this._editables = this._getEditables();
                        this.state = "ready";
                        this._fire("stateChange");
                    });
                }
                destroy() {
                    return Promise.resolve().then(()=>{
                        this.state = "destroyed";
                        this._fire("stateChange");
                        super.destroy();
                        return this._destroy();
                    });
                }
                _destroy() {
                    return Promise.resolve().then(()=>{
                        this._stopErrorHandling();
                        this._throttledSave.cancel();
                        const t = this._editor;
                        this._editor = null;
                        t.model.document.off("change:data", this._throttledSave);
                        return this._destructor(t);
                    });
                }
                _save() {
                    const t = this._editor.model.document.version;
                    try {
                        this._data = this._getData();
                        if (!this._initUsingData) this._editables = this._getEditables();
                        this._lastDocumentVersion = t;
                    } catch (t) {
                        console.error(t, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
                    }
                }
                _setExcludedProperties(t) {
                    this._excludedProps = t;
                }
                _getData() {
                    const t = this._editor;
                    const e = t.model.document.roots.filter((t)=>t.isAttached() && t.rootName != "$graveyard");
                    const { plugins: n } = t;
                    const o = n.has("CommentsRepository") && n.get("CommentsRepository");
                    const i = n.has("TrackChanges") && n.get("TrackChanges");
                    const r = {
                        roots: {},
                        markers: {},
                        commentThreads: JSON.stringify([]),
                        suggestions: JSON.stringify([])
                    };
                    e.forEach((t)=>{
                        r.roots[t.rootName] = {
                            content: JSON.stringify(Array.from(t.getChildren())),
                            attributes: JSON.stringify(Array.from(t.getAttributes())),
                            isLoaded: t._isLoaded
                        };
                    });
                    for (const e of t.model.markers){
                        if (!e._affectsData) continue;
                        r.markers[e.name] = {
                            rangeJSON: e.getRange().toJSON(),
                            usingOperation: e._managedUsingOperations,
                            affectsData: e._affectsData
                        };
                    }
                    if (o) r.commentThreads = JSON.stringify(o.getCommentThreads({
                        toJSON: true,
                        skipNotAttached: true
                    }));
                    if (i) r.suggestions = JSON.stringify(i.getSuggestions({
                        toJSON: true,
                        skipNotAttached: true
                    }));
                    return r;
                }
                _getEditables() {
                    const t = {};
                    for (const e of this.editor.model.document.getRootNames()){
                        const n = this.editor.ui.getEditableElement(e);
                        if (n) t[e] = n;
                    }
                    return t;
                }
                _isErrorComingFromThisItem(t) {
                    return wS(this._editor, t.context, this._excludedProps);
                }
                _cloneEditorConfiguration(t) {
                    return Ha(t, (t, e)=>{
                        if (qa(t)) return t;
                        if (e === "context") return t;
                    });
                }
            }
            class CS {
                constructor(t){
                    this.editor = t;
                    this._data = t.config.get("_watchdogInitialData");
                }
                init() {
                    this.editor.data.on("init", (t)=>{
                        t.stop();
                        this.editor.model.enqueueChange({
                            isUndoable: false
                        }, (t)=>{
                            this._restoreCollaborationData();
                            this._restoreEditorData(t);
                        });
                        this.editor.data.fire("ready");
                    }, {
                        priority: 999
                    });
                }
                _createNode(t, e) {
                    if ("name" in e) {
                        const n = t.createElement(e.name, e.attributes);
                        if (e.children) for (const o of e.children)n._appendChild(this._createNode(t, o));
                        return n;
                    } else return t.createText(e.data, e.attributes);
                }
                _restoreEditorData(t) {
                    const e = this.editor;
                    Object.entries(this._data.roots).forEach(([n, { content: o, attributes: i }])=>{
                        const r = JSON.parse(o);
                        const s = JSON.parse(i);
                        const a = e.model.document.getRoot(n);
                        for (const [e, n] of s)t.setAttribute(e, n, a);
                        for (const e of r){
                            const n = this._createNode(t, e);
                            t.insert(n, a, "end");
                        }
                    });
                    Object.entries(this._data.markers).forEach(([n, o])=>{
                        const { document: i } = e.model;
                        const { rangeJSON: { start: r, end: s }, ...a } = o;
                        const c = i.getRoot(r.root);
                        const l = t.createPositionFromPath(c, r.path, r.stickiness);
                        const d = t.createPositionFromPath(c, s.path, s.stickiness);
                        const u = t.createRange(l, d);
                        t.addMarker(n, {
                            range: u,
                            ...a
                        });
                    });
                }
                _restoreCollaborationData() {
                    const t = JSON.parse(this._data.commentThreads);
                    const e = JSON.parse(this._data.suggestions);
                    t.forEach((t)=>{
                        const e = this.editor.config.get("collaboration.channelId");
                        const n = this.editor.plugins.get("CommentsRepository");
                        if (n.hasCommentThread(t.threadId)) {
                            const e = n.getCommentThread(t.threadId);
                            e.remove();
                        }
                        n.addCommentThread({
                            channelId: e,
                            ...t
                        });
                    });
                    e.forEach((t)=>{
                        const e = this.editor.plugins.get("TrackChangesEditing");
                        if (e.hasSuggestion(t.id)) {
                            const n = e.getSuggestion(t.id);
                            n.attributes = t.attributes;
                        } else e.addSuggestionData(t);
                    });
                }
            }
            const yS = Symbol("MainQueueId");
            class xS extends mS {
                constructor(t, e = {}){
                    super(e);
                    this._watchdogs = new Map;
                    this._context = null;
                    this._contextProps = new Set;
                    this._actionQueues = new ES;
                    this._watchdogConfig = e;
                    this._creator = (e)=>t.create(e);
                    this._destructor = (t)=>t.destroy();
                    this._actionQueues.onEmpty(()=>{
                        if (this.state === "initializing") {
                            this.state = "ready";
                            this._fire("stateChange");
                        }
                    });
                }
                setCreator(t) {
                    this._creator = t;
                }
                setDestructor(t) {
                    this._destructor = t;
                }
                get context() {
                    return this._context;
                }
                create(t = {}) {
                    return this._actionQueues.enqueue(yS, ()=>{
                        this._contextConfig = t;
                        return this._create();
                    });
                }
                getItem(t) {
                    const e = this._getWatchdog(t);
                    return e._item;
                }
                getItemState(t) {
                    const e = this._getWatchdog(t);
                    return e.state;
                }
                add(t) {
                    const e = DS(t);
                    return Promise.all(e.map((t)=>this._actionQueues.enqueue(t.id, ()=>{
                            if (this.state === "destroyed") throw new Error("Cannot add items to destroyed watchdog.");
                            if (!this._context) throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
                            let e;
                            if (this._watchdogs.has(t.id)) throw new Error(`Item with the given id is already added: '${t.id}'.`);
                            if (t.type === "editor") {
                                e = new vS(null, this._watchdogConfig);
                                e.setCreator(t.creator);
                                e._setExcludedProperties(this._contextProps);
                                if (t.destructor) e.setDestructor(t.destructor);
                                this._watchdogs.set(t.id, e);
                                e.on("error", (n, { error: o, causesRestart: i })=>{
                                    this._fire("itemError", {
                                        itemId: t.id,
                                        error: o
                                    });
                                    if (!i) return;
                                    this._actionQueues.enqueue(t.id, ()=>new Promise((n)=>{
                                            const o = ()=>{
                                                e.off("restart", o);
                                                this._fire("itemRestart", {
                                                    itemId: t.id
                                                });
                                                n();
                                            };
                                            e.on("restart", o);
                                        }));
                                });
                                return e.create(t.sourceElementOrData, t.config, this._context);
                            } else throw new Error(`Not supported item type: '${t.type}'.`);
                        })));
                }
                remove(t) {
                    const e = DS(t);
                    return Promise.all(e.map((t)=>this._actionQueues.enqueue(t, ()=>{
                            const e = this._getWatchdog(t);
                            this._watchdogs.delete(t);
                            return e.destroy();
                        })));
                }
                destroy() {
                    return this._actionQueues.enqueue(yS, ()=>{
                        this.state = "destroyed";
                        this._fire("stateChange");
                        super.destroy();
                        return this._destroy();
                    });
                }
                _restart() {
                    return this._actionQueues.enqueue(yS, ()=>{
                        this.state = "initializing";
                        this._fire("stateChange");
                        return this._destroy().catch((t)=>{
                            console.error("An error happened during destroying the context or items.", t);
                        }).then(()=>this._create()).then(()=>this._fire("restart"));
                    });
                }
                _create() {
                    return Promise.resolve().then(()=>{
                        this._startErrorHandling();
                        return this._creator(this._contextConfig);
                    }).then((t)=>{
                        this._context = t;
                        this._contextProps = kS(this._context);
                        return Promise.all(Array.from(this._watchdogs.values()).map((t)=>{
                            t._setExcludedProperties(this._contextProps);
                            return t.create(undefined, undefined, this._context);
                        }));
                    });
                }
                _destroy() {
                    return Promise.resolve().then(()=>{
                        this._stopErrorHandling();
                        const t = this._context;
                        this._context = null;
                        this._contextProps = new Set;
                        return Promise.all(Array.from(this._watchdogs.values()).map((t)=>t.destroy())).then(()=>this._destructor(t));
                    });
                }
                _getWatchdog(t) {
                    const e = this._watchdogs.get(t);
                    if (!e) throw new Error(`Item with the given id was not registered: ${t}.`);
                    return e;
                }
                _isErrorComingFromThisItem(t) {
                    for (const e of this._watchdogs.values()){
                        if (e._isErrorComingFromThisItem(t)) return false;
                    }
                    return wS(this._context, t.context);
                }
            }
            class ES {
                constructor(){
                    this._onEmptyCallbacks = [];
                    this._queues = new Map;
                    this._activeActions = 0;
                }
                onEmpty(t) {
                    this._onEmptyCallbacks.push(t);
                }
                enqueue(t, e) {
                    const n = t === yS;
                    this._activeActions++;
                    if (!this._queues.get(t)) this._queues.set(t, Promise.resolve());
                    const o = n ? Promise.all(this._queues.values()) : Promise.all([
                        this._queues.get(yS),
                        this._queues.get(t)
                    ]);
                    const i = o.then(e);
                    const r = i.catch(()=>{});
                    this._queues.set(t, r);
                    return i.finally(()=>{
                        this._activeActions--;
                        if (this._queues.get(t) === r && this._activeActions === 0) this._onEmptyCallbacks.forEach((t)=>t());
                    });
                }
            }
            function DS(t) {
                return Array.isArray(t) ? t : [
                    t
                ];
            }
            class SS extends Xv(tC(Jv)) {
                constructor(t, e = {}){
                    if (!BS(t) && e.initialData !== undefined) throw new R("editor-create-initial-data", null);
                    super(e);
                    if (this.config.get("initialData") === undefined) this.config.set("initialData", TS(t));
                    if (BS(t)) this.sourceElement = t;
                    this.model.document.createRoot();
                    const n = !this.config.get("toolbar.shouldNotGroupWhenFull");
                    const o = new gS(this.locale, this.editing.view, {
                        shouldToolbarGroupWhenFull: n
                    });
                    this.ui = new dS(this, o);
                    Yv(this);
                }
                destroy() {
                    if (this.sourceElement) this.updateSourceElement();
                    this.ui.destroy();
                    return super.destroy();
                }
                static create(t, e = {}) {
                    return new Promise((n)=>{
                        const o = new this(t, e);
                        n(o.initPlugins().then(()=>o.ui.init(BS(t) ? t : null)).then(()=>o.data.init(o.config.get("initialData"))).then(()=>o.fire("ready")).then(()=>o));
                    });
                }
            }
            SS.Context = Lu;
            SS.EditorWatchdog = vS;
            SS.ContextWatchdog = xS;
            function TS(t) {
                return BS(t) ? ic(t) : t;
            }
            function BS(t) {
                return qa(t);
            }
            const PS = [
                "left",
                "right",
                "center",
                "justify"
            ];
            function IS(t) {
                return PS.includes(t);
            }
            function RS(t, e) {
                if (e.contentLanguageDirection == "rtl") return t === "right";
                else return t === "left";
            }
            function OS(t) {
                const e = t.map((t)=>{
                    let e;
                    if (typeof t == "string") e = {
                        name: t
                    };
                    else e = t;
                    return e;
                }).filter((t)=>{
                    const e = PS.includes(t.name);
                    if (!e) O("alignment-config-name-not-recognized", {
                        option: t
                    });
                    return e;
                });
                const n = e.filter((t)=>Boolean(t.className)).length;
                if (n && n < e.length) throw new R("alignment-config-classnames-are-missing", {
                    configuredOptions: t
                });
                e.forEach((e, n, o)=>{
                    const i = o.slice(n + 1);
                    const r = i.some((t)=>t.name == e.name);
                    if (r) throw new R("alignment-config-name-already-defined", {
                        option: e,
                        configuredOptions: t
                    });
                    if (e.className) {
                        const n = i.some((t)=>t.className == e.className);
                        if (n) throw new R("alignment-config-classname-already-defined", {
                            option: e,
                            configuredOptions: t
                        });
                    }
                });
                return e;
            }
            const VS = "alignment";
            class MS extends Ru {
                refresh() {
                    const t = this.editor;
                    const e = t.locale;
                    const n = fl(this.editor.model.document.selection.getSelectedBlocks());
                    this.isEnabled = Boolean(n) && this._canBeAligned(n);
                    if (this.isEnabled && n.hasAttribute("alignment")) this.value = n.getAttribute("alignment");
                    else this.value = e.contentLanguageDirection === "rtl" ? "right" : "left";
                }
                execute(t = {}) {
                    const e = this.editor;
                    const n = e.locale;
                    const o = e.model;
                    const i = o.document;
                    const r = t.value;
                    o.change((t)=>{
                        const e = Array.from(i.selection.getSelectedBlocks()).filter((t)=>this._canBeAligned(t));
                        const o = e[0].getAttribute("alignment");
                        const s = RS(r, n) || o === r || !r;
                        if (s) LS(e, t);
                        else zS(e, t, r);
                    });
                }
                _canBeAligned(t) {
                    return this.editor.model.schema.checkAttribute(t, VS);
                }
            }
            function LS(t, e) {
                for (const n of t)e.removeAttribute(VS, n);
            }
            function zS(t, e, n) {
                for (const o of t)e.setAttribute(VS, n, o);
            }
            class NS extends Pu {
                static get pluginName() {
                    return "AlignmentEditing";
                }
                constructor(t){
                    super(t);
                    t.config.define("alignment", {
                        options: PS.map((t)=>({
                                name: t
                            }))
                    });
                }
                init() {
                    const t = this.editor;
                    const e = t.locale;
                    const n = t.model.schema;
                    const o = OS(t.config.get("alignment.options"));
                    const i = o.filter((t)=>IS(t.name) && !RS(t.name, e));
                    const r = i.some((t)=>!!t.className);
                    n.extend("$block", {
                        allowAttributes: "alignment"
                    });
                    t.model.schema.setAttributeProperties("alignment", {
                        isFormatting: true
                    });
                    if (r) t.conversion.attributeToAttribute(qS(i));
                    else t.conversion.for("downcast").attributeToAttribute(FS(i));
                    const s = HS(i);
                    for (const e of s)t.conversion.for("upcast").attributeToAttribute(e);
                    const a = jS(i);
                    for (const e of a)t.conversion.for("upcast").attributeToAttribute(e);
                    t.commands.add("alignment", new MS(t));
                }
            }
            function FS(t) {
                const e = {};
                for (const { name: n } of t)e[n] = {
                    key: "style",
                    value: {
                        "text-align": n
                    }
                };
                const n = {
                    model: {
                        key: "alignment",
                        values: t.map((t)=>t.name)
                    },
                    view: e
                };
                return n;
            }
            function HS(t) {
                const e = [];
                for (const { name: n } of t)e.push({
                    view: {
                        key: "style",
                        value: {
                            "text-align": n
                        }
                    },
                    model: {
                        key: "alignment",
                        value: n
                    }
                });
                return e;
            }
            function jS(t) {
                const e = [];
                for (const { name: n } of t)e.push({
                    view: {
                        key: "align",
                        value: n
                    },
                    model: {
                        key: "alignment",
                        value: n
                    }
                });
                return e;
            }
            function qS(t) {
                const e = {};
                for (const n of t)e[n.name] = {
                    key: "class",
                    value: n.className
                };
                const n = {
                    model: {
                        key: "alignment",
                        values: t.map((t)=>t.name)
                    },
                    view: e
                };
                return n;
            }
            const WS = new Map([
                [
                    "left",
                    FC.alignLeft
                ],
                [
                    "right",
                    FC.alignRight
                ],
                [
                    "center",
                    FC.alignCenter
                ],
                [
                    "justify",
                    FC.alignJustify
                ]
            ]);
            class $S extends Pu {
                get localizedOptionTitles() {
                    const t = this.editor.t;
                    return {
                        left: t("Align left"),
                        right: t("Align right"),
                        center: t("Align center"),
                        justify: t("Justify")
                    };
                }
                static get pluginName() {
                    return "AlignmentUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.ui.componentFactory;
                    const n = t.t;
                    const o = OS(t.config.get("alignment.options"));
                    o.map((t)=>t.name).filter(IS).forEach((t)=>this._addButton(t));
                    e.add("alignment", (i)=>{
                        const r = by(i);
                        wy(r, ()=>o.map((t)=>e.create(`alignment:${t.name}`)), {
                            enableActiveItemFocusOnDropdownOpen: true,
                            isVertical: true,
                            ariaLabel: n("Text alignment toolbar")
                        });
                        r.buttonView.set({
                            label: n("Text alignment"),
                            tooltip: true
                        });
                        r.extendTemplate({
                            attributes: {
                                class: "ck-alignment-dropdown"
                            }
                        });
                        const s = i.contentLanguageDirection === "rtl" ? WS.get("right") : WS.get("left");
                        const a = t.commands.get("alignment");
                        r.buttonView.bind("icon").to(a, "value", (t)=>WS.get(t) || s);
                        r.bind("isEnabled").to(a, "isEnabled");
                        this.listenTo(r, "execute", ()=>{
                            t.editing.view.focus();
                        });
                        return r;
                    });
                }
                _addButton(t) {
                    const e = this.editor;
                    e.ui.componentFactory.add(`alignment:${t}`, (n)=>{
                        const o = e.commands.get("alignment");
                        const i = new yd(n);
                        i.set({
                            label: this.localizedOptionTitles[t],
                            icon: WS.get(t),
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isEnabled").to(o);
                        i.bind("isOn").to(o, "value", (e)=>e === t);
                        this.listenTo(i, "execute", ()=>{
                            e.execute("alignment", {
                                value: t
                            });
                            e.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class GS extends Pu {
                static get requires() {
                    return [
                        NS,
                        $S
                    ];
                }
                static get pluginName() {
                    return "Alignment";
                }
            }
            class US extends Ru {
                constructor(t, e){
                    super(t);
                    this.attributeKey = e;
                }
                refresh() {
                    const t = this.editor.model;
                    const e = t.document;
                    this.value = this._getValueFromFirstAllowedNode();
                    this.isEnabled = t.schema.checkAttributeInSelection(e.selection, this.attributeKey);
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    const o = n.selection;
                    const i = t.forceValue === undefined ? !this.value : t.forceValue;
                    e.change((t)=>{
                        if (o.isCollapsed) {
                            if (i) t.setSelectionAttribute(this.attributeKey, true);
                            else t.removeSelectionAttribute(this.attributeKey);
                        } else {
                            const n = e.schema.getValidRanges(o.getRanges(), this.attributeKey);
                            for (const e of n)if (i) t.setAttribute(this.attributeKey, i, e);
                            else t.removeAttribute(this.attributeKey, e);
                        }
                    });
                }
                _getValueFromFirstAllowedNode() {
                    const t = this.editor.model;
                    const e = t.schema;
                    const n = t.document.selection;
                    if (n.isCollapsed) return n.hasAttribute(this.attributeKey);
                    for (const t of n.getRanges())for (const n of t.getItems()){
                        if (e.checkAttribute(n, this.attributeKey)) return n.hasAttribute(this.attributeKey);
                    }
                    return false;
                }
            }
            const KS = "bold";
            class ZS extends Pu {
                static get pluginName() {
                    return "BoldEditing";
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: KS
                    });
                    t.model.schema.setAttributeProperties(KS, {
                        isFormatting: true,
                        copyOnEnter: true
                    });
                    t.conversion.attributeToElement({
                        model: KS,
                        view: "strong",
                        upcastAlso: [
                            "b",
                            (t)=>{
                                const e = t.getStyle("font-weight");
                                if (!e) return null;
                                if (e == "bold" || Number(e) >= 600) return {
                                    name: true,
                                    styles: [
                                        "font-weight"
                                    ]
                                };
                                return null;
                            }
                        ]
                    });
                    t.commands.add(KS, new US(t, KS));
                    t.keystrokes.set("CTRL+B", KS);
                }
            }
            const JS = "bold";
            class YS extends Pu {
                static get pluginName() {
                    return "BoldUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add(JS, (n)=>{
                        const o = t.commands.get(JS);
                        const i = new yd(n);
                        i.set({
                            label: e("Bold"),
                            icon: FC.bold,
                            keystroke: "CTRL+B",
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute(JS);
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class QS extends Pu {
                static get requires() {
                    return [
                        ZS,
                        YS
                    ];
                }
                static get pluginName() {
                    return "Bold";
                }
            }
            class XS {
                constructor(t, e = 20){
                    this._batch = null;
                    this.model = t;
                    this._size = 0;
                    this.limit = e;
                    this._isLocked = false;
                    this._changeCallback = (t, e)=>{
                        if (e.isLocal && e.isUndoable && e !== this._batch) this._reset(true);
                    };
                    this._selectionChangeCallback = ()=>{
                        this._reset();
                    };
                    this.model.document.on("change", this._changeCallback);
                    this.model.document.selection.on("change:range", this._selectionChangeCallback);
                    this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
                }
                get batch() {
                    if (!this._batch) this._batch = this.model.createBatch({
                        isTyping: true
                    });
                    return this._batch;
                }
                get size() {
                    return this._size;
                }
                input(t) {
                    this._size += t;
                    if (this._size >= this.limit) this._reset(true);
                }
                get isLocked() {
                    return this._isLocked;
                }
                lock() {
                    this._isLocked = true;
                }
                unlock() {
                    this._isLocked = false;
                }
                destroy() {
                    this.model.document.off("change", this._changeCallback);
                    this.model.document.selection.off("change:range", this._selectionChangeCallback);
                    this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
                }
                _reset(t = false) {
                    if (!this.isLocked || t) {
                        this._batch = null;
                        this._size = 0;
                    }
                }
            }
            class tT extends Ru {
                constructor(t, e){
                    super(t);
                    this._buffer = new XS(t.model, e);
                    this._isEnabledBasedOnSelection = false;
                }
                get buffer() {
                    return this._buffer;
                }
                destroy() {
                    super.destroy();
                    this._buffer.destroy();
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    const o = t.text || "";
                    const i = o.length;
                    let r = n.selection;
                    if (t.selection) r = t.selection;
                    else if (t.range) r = e.createSelection(t.range);
                    if (!e.canEditAt(r)) return;
                    const s = t.resultRange;
                    e.enqueueChange(this._buffer.batch, (t)=>{
                        this._buffer.lock();
                        e.deleteContent(r);
                        if (o) e.insertContent(t.createText(o, n.selection.getAttributes()), r);
                        if (s) t.setSelection(s);
                        else if (!r.is("documentSelection")) t.setSelection(r);
                        this._buffer.unlock();
                        this._buffer.input(i);
                    });
                }
            }
            const eT = [
                "insertText",
                "insertReplacementText"
            ];
            class nT extends zg {
                constructor(t){
                    super(t);
                    this.focusObserver = t.getObserver(hk);
                    if (c.isAndroid) eT.push("insertCompositionText");
                    const e = t.document;
                    e.on("beforeinput", (n, o)=>{
                        if (!this.isEnabled) return;
                        const { data: i, targetRanges: r, inputType: s, domEvent: a } = o;
                        if (!eT.includes(s)) return;
                        this.focusObserver.flush();
                        const c = new E(e, "insertText");
                        e.fire(c, new Hg(t, a, {
                            text: i,
                            selection: t.createSelection(r)
                        }));
                        if (c.stop.called) n.stop();
                    });
                    e.on("compositionend", (n, { data: o, domEvent: i })=>{
                        if (!this.isEnabled || c.isAndroid) return;
                        if (!o) return;
                        e.fire("insertText", new Hg(t, i, {
                            text: o,
                            selection: e.selection
                        }));
                    }, {
                        priority: "lowest"
                    });
                }
                observe() {}
                stopObserving() {}
            }
            class oT extends Pu {
                static get pluginName() {
                    return "Input";
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.editing.view;
                    const o = e.document.selection;
                    n.addObserver(nT);
                    const i = new tT(t, t.config.get("typing.undoStep") || 20);
                    t.commands.add("insertText", i);
                    t.commands.add("input", i);
                    this.listenTo(n.document, "insertText", (o, i)=>{
                        if (!n.document.isComposing) i.preventDefault();
                        const { text: r, selection: s, resultRange: a } = i;
                        const l = Array.from(s.getRanges()).map((e)=>t.editing.mapper.toModelRange(e));
                        let d = r;
                        if (c.isAndroid) {
                            const t = Array.from(l[0].getItems()).reduce((t, e)=>t + (e.is("$textProxy") ? e.data : ""), "");
                            if (t) {
                                if (t.length <= d.length) {
                                    if (d.startsWith(t)) {
                                        d = d.substring(t.length);
                                        l[0].start = l[0].start.getShiftedBy(t.length);
                                    }
                                } else if (t.startsWith(d)) {
                                    l[0].start = l[0].start.getShiftedBy(d.length);
                                    d = "";
                                }
                            }
                        }
                        const u = {
                            text: d,
                            selection: e.createSelection(l)
                        };
                        if (a) u.resultRange = t.editing.mapper.toModelRange(a);
                        t.execute("insertText", u);
                        n.scrollToTheSelection();
                    });
                    if (c.isAndroid) this.listenTo(n.document, "keydown", (t, r)=>{
                        if (o.isCollapsed || r.keyCode != 229 || !n.document.isComposing) return;
                        iT(e, i);
                    });
                    else this.listenTo(n.document, "compositionstart", ()=>{
                        if (o.isCollapsed) return;
                        iT(e, i);
                    });
                }
            }
            function iT(t, e) {
                if (!e.isEnabled) return;
                const n = e.buffer;
                n.lock();
                t.enqueueChange(n.batch, ()=>{
                    t.deleteContent(t.document.selection);
                });
                n.unlock();
            }
            class rT extends Ru {
                constructor(t, e){
                    super(t);
                    this.direction = e;
                    this._buffer = new XS(t.model, t.config.get("typing.undoStep"));
                    this._isEnabledBasedOnSelection = false;
                }
                get buffer() {
                    return this._buffer;
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    e.enqueueChange(this._buffer.batch, (o)=>{
                        this._buffer.lock();
                        const i = o.createSelection(t.selection || n.selection);
                        if (!e.canEditAt(i)) return;
                        const r = t.sequence || 1;
                        const s = i.isCollapsed;
                        if (i.isCollapsed) e.modifySelection(i, {
                            direction: this.direction,
                            unit: t.unit,
                            treatEmojiAsSingleUnit: true
                        });
                        if (this._shouldEntireContentBeReplacedWithParagraph(r)) {
                            this._replaceEntireContentWithParagraph(o);
                            return;
                        }
                        if (this._shouldReplaceFirstBlockWithParagraph(i, r)) {
                            this.editor.execute("paragraph", {
                                selection: i
                            });
                            return;
                        }
                        if (i.isCollapsed) return;
                        let a = 0;
                        i.getFirstRange().getMinimalFlatRanges().forEach((t)=>{
                            a += yt(t.getWalker({
                                singleCharacters: true,
                                ignoreElementEnd: true,
                                shallow: true
                            }));
                        });
                        e.deleteContent(i, {
                            doNotResetEntireContent: s,
                            direction: this.direction
                        });
                        this._buffer.input(a);
                        o.setSelection(i);
                        this._buffer.unlock();
                    });
                }
                _shouldEntireContentBeReplacedWithParagraph(t) {
                    if (t > 1) return false;
                    const e = this.editor.model;
                    const n = e.document;
                    const o = n.selection;
                    const i = e.schema.getLimitElement(o);
                    const r = o.isCollapsed && o.containsEntireContent(i);
                    if (!r) return false;
                    if (!e.schema.checkChild(i, "paragraph")) return false;
                    const s = i.getChild(0);
                    if (s && s.is("element", "paragraph")) return false;
                    return true;
                }
                _replaceEntireContentWithParagraph(t) {
                    const e = this.editor.model;
                    const n = e.document;
                    const o = n.selection;
                    const i = e.schema.getLimitElement(o);
                    const r = t.createElement("paragraph");
                    t.remove(t.createRangeIn(i));
                    t.insert(r, i);
                    t.setSelection(r, 0);
                }
                _shouldReplaceFirstBlockWithParagraph(t, e) {
                    const n = this.editor.model;
                    if (e > 1 || this.direction != "backward") return false;
                    if (!t.isCollapsed) return false;
                    const o = t.getFirstPosition();
                    const i = n.schema.getLimitElement(o);
                    const r = i.getChild(0);
                    if (o.parent != r) return false;
                    if (!t.containsEntireContent(r)) return false;
                    if (!n.schema.checkChild(i, "paragraph")) return false;
                    if (r.name == "paragraph") return false;
                    return true;
                }
            }
            const sT = "character";
            const aT = "word";
            const cT = "codePoint";
            const lT = "selection";
            const dT = "backward";
            const uT = "forward";
            const hT = {
                deleteContent: {
                    unit: lT,
                    direction: dT
                },
                deleteContentBackward: {
                    unit: cT,
                    direction: dT
                },
                deleteWordBackward: {
                    unit: aT,
                    direction: dT
                },
                deleteHardLineBackward: {
                    unit: lT,
                    direction: dT
                },
                deleteSoftLineBackward: {
                    unit: lT,
                    direction: dT
                },
                deleteContentForward: {
                    unit: sT,
                    direction: uT
                },
                deleteWordForward: {
                    unit: aT,
                    direction: uT
                },
                deleteHardLineForward: {
                    unit: lT,
                    direction: uT
                },
                deleteSoftLineForward: {
                    unit: lT,
                    direction: uT
                }
            };
            class fT extends zg {
                constructor(t){
                    super(t);
                    const e = t.document;
                    let n = 0;
                    e.on("keydown", ()=>{
                        n++;
                    });
                    e.on("keyup", ()=>{
                        n = 0;
                    });
                    e.on("beforeinput", (o, i)=>{
                        if (!this.isEnabled) return;
                        const { targetRanges: r, domEvent: s, inputType: a } = i;
                        const l = hT[a];
                        if (!l) return;
                        const d = {
                            direction: l.direction,
                            unit: l.unit,
                            sequence: n
                        };
                        if (d.unit == lT) d.selectionToRemove = t.createSelection(r[0]);
                        if (a === "deleteContentBackward") {
                            if (c.isAndroid) d.sequence = 1;
                            if (gT(r)) {
                                d.unit = lT;
                                d.selectionToRemove = t.createSelection(r);
                            }
                        }
                        const u = new Ap(e, "delete", r[0]);
                        e.fire(u, new Hg(t, s, d));
                        if (u.stop.called) o.stop();
                    });
                    if (c.isBlink) pT(this);
                }
                observe() {}
                stopObserving() {}
            }
            function pT(t) {
                const e = t.view;
                const n = e.document;
                let o = null;
                let i = false;
                n.on("keydown", (t, { keyCode: e })=>{
                    o = e;
                    i = false;
                });
                n.on("keyup", (a, { keyCode: c, domEvent: l })=>{
                    const d = n.selection;
                    const u = t.isEnabled && c == o && r(c) && !d.isCollapsed && !i;
                    o = null;
                    if (u) {
                        const t = d.getFirstRange();
                        const o = new Ap(n, "delete", t);
                        const i = {
                            unit: lT,
                            direction: s(c),
                            selectionToRemove: d
                        };
                        n.fire(o, new Hg(e, l, i));
                    }
                });
                n.on("beforeinput", (t, { inputType: e })=>{
                    const n = hT[e];
                    const a = r(o) && n && n.direction == s(o);
                    if (a) i = true;
                }, {
                    priority: "high"
                });
                n.on("beforeinput", (t, { inputType: e, data: n })=>{
                    const i = o == $c.delete && e == "insertText" && n == "";
                    if (i) t.stop();
                }, {
                    priority: "high"
                });
                function r(t) {
                    return t == $c.backspace || t == $c.delete;
                }
                function s(t) {
                    return t == $c.backspace ? dT : uT;
                }
            }
            function gT(t) {
                if (t.length != 1 || t[0].isCollapsed) return false;
                const e = t[0].getWalker({
                    direction: "backward",
                    singleCharacters: true,
                    ignoreElementEnd: true
                });
                let n = 0;
                for (const { nextPosition: t } of e){
                    if (!t.parent.is("$text")) n++;
                    else {
                        const e = t.parent.data;
                        const o = t.offset;
                        if (xl(e, o) || El(e, o) || Sl(e, o)) continue;
                        n++;
                    }
                    if (n > 1) return true;
                }
                return false;
            }
            class mT extends Pu {
                static get pluginName() {
                    return "Delete";
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    const o = t.model.document;
                    e.addObserver(fT);
                    this._undoOnBackspace = false;
                    const i = new rT(t, "forward");
                    t.commands.add("deleteForward", i);
                    t.commands.add("forwardDelete", i);
                    t.commands.add("delete", new rT(t, "backward"));
                    this.listenTo(n, "delete", (o, i)=>{
                        if (!n.isComposing) i.preventDefault();
                        const { direction: r, sequence: s, selectionToRemove: a, unit: c } = i;
                        const l = r === "forward" ? "deleteForward" : "delete";
                        const d = {
                            sequence: s
                        };
                        if (c == "selection") {
                            const e = Array.from(a.getRanges()).map((e)=>t.editing.mapper.toModelRange(e));
                            d.selection = t.model.createSelection(e);
                        } else d.unit = c;
                        t.execute(l, d);
                        e.scrollToTheSelection();
                    }, {
                        priority: "low"
                    });
                    if (this.editor.plugins.has("UndoEditing")) {
                        this.listenTo(n, "delete", (e, n)=>{
                            if (this._undoOnBackspace && n.direction == "backward" && n.sequence == 1 && n.unit == "codePoint") {
                                this._undoOnBackspace = false;
                                t.execute("undo");
                                n.preventDefault();
                                e.stop();
                            }
                        }, {
                            context: "$capture"
                        });
                        this.listenTo(o, "change", ()=>{
                            this._undoOnBackspace = false;
                        });
                    }
                }
                requestUndoOnBackspace() {
                    if (this.editor.plugins.has("UndoEditing")) this._undoOnBackspace = true;
                }
            }
            class kT extends Pu {
                static get requires() {
                    return [
                        oT,
                        mT
                    ];
                }
                static get pluginName() {
                    return "Typing";
                }
            }
            function bT(t, e) {
                let n = t.start;
                const o = Array.from(t.getWalker({
                    ignoreElementEnd: false
                })).reduce((t, { item: o })=>{
                    if (!(o.is("$text") || o.is("$textProxy"))) {
                        n = e.createPositionAfter(o);
                        return "";
                    }
                    return t + o.data;
                }, "");
                return {
                    text: o,
                    range: e.createRange(n, t.end)
                };
            }
            class wT extends ht() {
                constructor(t, e){
                    super();
                    this.model = t;
                    this.testCallback = e;
                    this._hasMatch = false;
                    this.set("isEnabled", true);
                    this.on("change:isEnabled", ()=>{
                        if (this.isEnabled) this._startListening();
                        else {
                            this.stopListening(t.document.selection);
                            this.stopListening(t.document);
                        }
                    });
                    this._startListening();
                }
                get hasMatch() {
                    return this._hasMatch;
                }
                _startListening() {
                    const t = this.model;
                    const e = t.document;
                    this.listenTo(e.selection, "change:range", (t, { directChange: n })=>{
                        if (!n) return;
                        if (!e.selection.isCollapsed) {
                            if (this.hasMatch) {
                                this.fire("unmatched");
                                this._hasMatch = false;
                            }
                            return;
                        }
                        this._evaluateTextBeforeSelection("selection");
                    });
                    this.listenTo(e, "change:data", (t, e)=>{
                        if (e.isUndo || !e.isLocal) return;
                        this._evaluateTextBeforeSelection("data", {
                            batch: e
                        });
                    });
                }
                _evaluateTextBeforeSelection(t, e = {}) {
                    const n = this.model;
                    const o = n.document;
                    const i = o.selection;
                    const r = n.createRange(n.createPositionAt(i.focus.parent, 0), i.focus);
                    const { text: s, range: a } = bT(r, n);
                    const c = this.testCallback(s);
                    if (!c && this.hasMatch) this.fire("unmatched");
                    this._hasMatch = !!c;
                    if (c) {
                        const n = Object.assign(e, {
                            text: s,
                            range: a
                        });
                        if (typeof c == "object") Object.assign(n, c);
                        this.fire(`matched:${t}`, n);
                    }
                }
            }
            class _T extends Pu {
                static get pluginName() {
                    return "TwoStepCaretMovement";
                }
                constructor(t){
                    super(t);
                    this.attributes = new Set;
                    this._overrideUid = null;
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.editing.view;
                    const o = t.locale;
                    const i = e.document.selection;
                    this.listenTo(n.document, "arrowKey", (t, e)=>{
                        if (!i.isCollapsed) return;
                        if (e.shiftKey || e.altKey || e.ctrlKey) return;
                        const n = e.keyCode == $c.arrowright;
                        const r = e.keyCode == $c.arrowleft;
                        if (!n && !r) return;
                        const s = o.contentLanguageDirection;
                        let a = false;
                        if (s === "ltr" && n || s === "rtl" && r) a = this._handleForwardMovement(e);
                        else a = this._handleBackwardMovement(e);
                        if (a === true) t.stop();
                    }, {
                        context: "$text",
                        priority: "highest"
                    });
                    this._isNextGravityRestorationSkipped = false;
                    this.listenTo(i, "change:range", (t, e)=>{
                        if (this._isNextGravityRestorationSkipped) {
                            this._isNextGravityRestorationSkipped = false;
                            return;
                        }
                        if (!this._isGravityOverridden) return;
                        if (!e.directChange && xT(i.getFirstPosition(), this.attributes)) return;
                        this._restoreGravity();
                    });
                }
                registerAttribute(t) {
                    this.attributes.add(t);
                }
                _handleForwardMovement(t) {
                    const e = this.attributes;
                    const n = this.editor.model;
                    const o = n.document.selection;
                    const i = o.getFirstPosition();
                    if (this._isGravityOverridden) return false;
                    if (i.isAtStart && AT(o, e)) return false;
                    if (xT(i, e)) {
                        CT(t);
                        this._overrideGravity();
                        return true;
                    }
                    return false;
                }
                _handleBackwardMovement(t) {
                    const e = this.attributes;
                    const n = this.editor.model;
                    const o = n.document.selection;
                    const i = o.getFirstPosition();
                    if (this._isGravityOverridden) {
                        CT(t);
                        this._restoreGravity();
                        vT(n, e, i);
                        return true;
                    } else {
                        if (i.isAtStart) {
                            if (AT(o, e)) {
                                CT(t);
                                vT(n, e, i);
                                return true;
                            }
                            return false;
                        }
                        if (yT(i, e)) {
                            if (i.isAtEnd && !AT(o, e) && xT(i, e)) {
                                CT(t);
                                vT(n, e, i);
                                return true;
                            }
                            this._isNextGravityRestorationSkipped = true;
                            this._overrideGravity();
                            return false;
                        }
                    }
                    return false;
                }
                get _isGravityOverridden() {
                    return !!this._overrideUid;
                }
                _overrideGravity() {
                    this._overrideUid = this.editor.model.change((t)=>t.overrideSelectionGravity());
                }
                _restoreGravity() {
                    this.editor.model.change((t)=>{
                        t.restoreSelectionGravity(this._overrideUid);
                        this._overrideUid = null;
                    });
                }
            }
            function AT(t, e) {
                for (const n of e){
                    if (t.hasAttribute(n)) return true;
                }
                return false;
            }
            function vT(t, e, n) {
                const o = n.nodeBefore;
                t.change((n)=>{
                    if (o) {
                        const e = [];
                        const i = t.schema.isObject(o) && t.schema.isInline(o);
                        for (const [n, r] of o.getAttributes())if (t.schema.checkAttribute("$text", n) && (!i || t.schema.getAttributeProperties(n).copyFromObject !== false)) e.push([
                            n,
                            r
                        ]);
                        n.setSelectionAttribute(e);
                    } else n.removeSelectionAttribute(e);
                });
            }
            function CT(t) {
                t.preventDefault();
            }
            function yT(t, e) {
                const n = t.getShiftedBy(-1);
                return xT(n, e);
            }
            function xT(t, e) {
                const { nodeBefore: n, nodeAfter: o } = t;
                for (const t of e){
                    const e = n ? n.getAttribute(t) : undefined;
                    const i = o ? o.getAttribute(t) : undefined;
                    if (i !== e) return true;
                }
                return false;
            }
            const ET = {
                copyright: {
                    from: "(c)",
                    to: "\xa9"
                },
                registeredTrademark: {
                    from: "(r)",
                    to: "\xae"
                },
                trademark: {
                    from: "(tm)",
                    to: "\u2122"
                },
                oneHalf: {
                    from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
                    to: [
                        null,
                        "\xbd",
                        null
                    ]
                },
                oneThird: {
                    from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
                    to: [
                        null,
                        "\u2153",
                        null
                    ]
                },
                twoThirds: {
                    from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
                    to: [
                        null,
                        "\u2154",
                        null
                    ]
                },
                oneForth: {
                    from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
                    to: [
                        null,
                        "\xbc",
                        null
                    ]
                },
                threeQuarters: {
                    from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
                    to: [
                        null,
                        "\xbe",
                        null
                    ]
                },
                lessThanOrEqual: {
                    from: "<=",
                    to: "\u2264"
                },
                greaterThanOrEqual: {
                    from: ">=",
                    to: "\u2265"
                },
                notEqual: {
                    from: "!=",
                    to: "\u2260"
                },
                arrowLeft: {
                    from: "<-",
                    to: "\u2190"
                },
                arrowRight: {
                    from: "->",
                    to: "\u2192"
                },
                horizontalEllipsis: {
                    from: "...",
                    to: "\u2026"
                },
                enDash: {
                    from: /(^| )(--)( )$/,
                    to: [
                        null,
                        "\u2013",
                        null
                    ]
                },
                emDash: {
                    from: /(^| )(---)( )$/,
                    to: [
                        null,
                        "\u2014",
                        null
                    ]
                },
                quotesPrimary: {
                    from: RT('"'),
                    to: [
                        null,
                        "\u201C",
                        null,
                        "\u201D"
                    ]
                },
                quotesSecondary: {
                    from: RT("'"),
                    to: [
                        null,
                        "\u2018",
                        null,
                        "\u2019"
                    ]
                },
                quotesPrimaryEnGb: {
                    from: RT("'"),
                    to: [
                        null,
                        "\u2018",
                        null,
                        "\u2019"
                    ]
                },
                quotesSecondaryEnGb: {
                    from: RT('"'),
                    to: [
                        null,
                        "\u201C",
                        null,
                        "\u201D"
                    ]
                },
                quotesPrimaryPl: {
                    from: RT('"'),
                    to: [
                        null,
                        "\u201E",
                        null,
                        "\u201D"
                    ]
                },
                quotesSecondaryPl: {
                    from: RT("'"),
                    to: [
                        null,
                        "\u201A",
                        null,
                        "\u2019"
                    ]
                }
            };
            const DT = {
                symbols: [
                    "copyright",
                    "registeredTrademark",
                    "trademark"
                ],
                mathematical: [
                    "oneHalf",
                    "oneThird",
                    "twoThirds",
                    "oneForth",
                    "threeQuarters",
                    "lessThanOrEqual",
                    "greaterThanOrEqual",
                    "notEqual",
                    "arrowLeft",
                    "arrowRight"
                ],
                typography: [
                    "horizontalEllipsis",
                    "enDash",
                    "emDash"
                ],
                quotes: [
                    "quotesPrimary",
                    "quotesSecondary"
                ]
            };
            const ST = null;
            class TT extends null {
                static get requires() {
                    return [
                        "Delete",
                        "Input"
                    ];
                }
                static get pluginName() {
                    return "TextTransformation";
                }
                constructor(t){
                    super(t);
                    t.config.define("typing", {
                        transformations: {
                            include: ST
                        }
                    });
                }
                init() {
                    const t = this.editor.model;
                    const e = t.document.selection;
                    e.on("change:range", ()=>{
                        this.isEnabled = !e.anchor.parent.is("element", "codeBlock");
                    });
                    this._enableTransformationWatchers();
                }
                _enableTransformationWatchers() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.plugins.get("Delete");
                    const o = OT(t.config.get("typing.transformations"));
                    const i = (t)=>{
                        for (const e of o){
                            const n = e.from;
                            const o = n.test(t);
                            if (o) return {
                                normalizedTransformation: e
                            };
                        }
                    };
                    const r = new TextWatcher(t.model, i);
                    r.on("matched:data", (t, o)=>{
                        if (!o.batch.isTyping) return;
                        const { from: i, to: r } = o.normalizedTransformation;
                        const s = i.exec(o.text);
                        const a = r(s.slice(1));
                        const c = o.range;
                        let l = s.index;
                        e.enqueueChange((t)=>{
                            for(let n = 1; n < s.length; n++){
                                const o = s[n];
                                const i = a[n - 1];
                                if (i == null) {
                                    l += o.length;
                                    continue;
                                }
                                const r = c.start.getShiftedBy(l);
                                const d = e.createRange(r, r.getShiftedBy(o.length));
                                const u = IT(r);
                                e.insertContent(t.createText(i, u), d);
                                l += i.length;
                            }
                            e.enqueueChange(()=>{
                                n.requestUndoOnBackspace();
                            });
                        });
                    });
                    r.bind("isEnabled").to(this);
                }
            }
            function BT(t) {
                if (typeof t == "string") return new RegExp(`(${escapeRegExp(t)})$`);
                return t;
            }
            function PT(t) {
                if (typeof t == "string") return ()=>[
                        t
                    ];
                else if (t instanceof Array) return ()=>t;
                return t;
            }
            function IT(t) {
                const e = t.textNode ? t.textNode : t.nodeAfter;
                return e.getAttributes();
            }
            function RT(t) {
                return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`);
            }
            function OT(t) {
                const e = t.extra || [];
                const n = t.remove || [];
                const o = (t)=>!n.includes(t);
                const i = t.include.concat(e).filter(o);
                return VT(i).filter(o).map((t)=>typeof t == "string" && ET[t] ? ET[t] : t).filter((t)=>typeof t === "object").map((t)=>({
                        from: BT(t.from),
                        to: PT(t.to)
                    }));
            }
            function VT(t) {
                const e = new Set;
                for (const n of t){
                    if (typeof n == "string" && DT[n]) for (const t of DT[n])e.add(t);
                    else e.add(n);
                }
                return Array.from(e);
            }
            function MT(t, e, n, o) {
                return o.createRange(LT(t, e, n, true, o), LT(t, e, n, false, o));
            }
            function LT(t, e, n, o, i) {
                let r = t.textNode || (o ? t.nodeBefore : t.nodeAfter);
                let s = null;
                while(r && r.getAttribute(e) == n){
                    s = r;
                    r = o ? r.previousSibling : r.nextSibling;
                }
                return s ? i.createPositionAt(s, o ? "before" : "after") : t;
            }
            function zT(t, e, n, o) {
                const i = t.editing.view;
                const r = new Set;
                i.document.registerPostFixer((i)=>{
                    const s = t.model.document.selection;
                    let a = false;
                    if (s.hasAttribute(e)) {
                        const c = MT(s.getFirstPosition(), e, s.getAttribute(e), t.model);
                        const l = t.editing.mapper.toViewRange(c);
                        for (const t of l.getItems())if (t.is("element", n) && !t.hasClass(o)) {
                            i.addClass(o, t);
                            r.add(t);
                            a = true;
                        }
                    }
                    return a;
                });
                t.conversion.for("editingDowncast").add((t)=>{
                    t.on("insert", e, {
                        priority: "highest"
                    });
                    t.on("remove", e, {
                        priority: "highest"
                    });
                    t.on("attribute", e, {
                        priority: "highest"
                    });
                    t.on("selection", e, {
                        priority: "highest"
                    });
                    function e() {
                        i.change((t)=>{
                            for (const e of r.values()){
                                t.removeClass(o, e);
                                r.delete(e);
                            }
                        });
                    }
                });
            }
            const NT = "code";
            const FT = "ck-code_selected";
            class HT extends null {
                static get pluginName() {
                    return "CodeEditing";
                }
                static get requires() {
                    return [
                        TwoStepCaretMovement
                    ];
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: NT
                    });
                    t.model.schema.setAttributeProperties(NT, {
                        isFormatting: true,
                        copyOnEnter: false
                    });
                    t.conversion.attributeToElement({
                        model: NT,
                        view: "code",
                        upcastAlso: {
                            styles: {
                                "word-wrap": "break-word"
                            }
                        }
                    });
                    t.commands.add(NT, new AttributeCommand(t, NT));
                    t.plugins.get(TwoStepCaretMovement).registerAttribute(NT);
                    inlineHighlight(t, NT, "code", FT);
                }
            }
            var jT = n(5363);
            var qT = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            qT.insert = "head";
            qT.singleton = true;
            var WT = Rl()(jT.Z, qT);
            const $T = jT.Z.locals || {};
            const GT = "code";
            class UT extends null {
                static get pluginName() {
                    return "CodeUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add(GT, (n)=>{
                        const o = t.commands.get(GT);
                        const i = new ButtonView(n);
                        i.set({
                            label: e("Code"),
                            icon: codeIcon,
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute(GT);
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class KT extends null {
                static get requires() {
                    return [
                        CodeEditing,
                        CodeUI
                    ];
                }
                static get pluginName() {
                    return "Code";
                }
            }
            const ZT = "italic";
            class JT extends Pu {
                static get pluginName() {
                    return "ItalicEditing";
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: ZT
                    });
                    t.model.schema.setAttributeProperties(ZT, {
                        isFormatting: true,
                        copyOnEnter: true
                    });
                    t.conversion.attributeToElement({
                        model: ZT,
                        view: "i",
                        upcastAlso: [
                            "em",
                            {
                                styles: {
                                    "font-style": "italic"
                                }
                            }
                        ]
                    });
                    t.commands.add(ZT, new US(t, ZT));
                    t.keystrokes.set("CTRL+I", ZT);
                }
            }
            const YT = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>';
            const QT = "italic";
            class XT extends Pu {
                static get pluginName() {
                    return "ItalicUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add(QT, (n)=>{
                        const o = t.commands.get(QT);
                        const i = new yd(n);
                        i.set({
                            label: e("Italic"),
                            icon: YT,
                            keystroke: "CTRL+I",
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute(QT);
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class tB extends Pu {
                static get requires() {
                    return [
                        JT,
                        XT
                    ];
                }
                static get pluginName() {
                    return "Italic";
                }
            }
            const eB = "strikethrough";
            class nB extends null {
                static get pluginName() {
                    return "StrikethroughEditing";
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: eB
                    });
                    t.model.schema.setAttributeProperties(eB, {
                        isFormatting: true,
                        copyOnEnter: true
                    });
                    t.conversion.attributeToElement({
                        model: eB,
                        view: "s",
                        upcastAlso: [
                            "del",
                            "strike",
                            {
                                styles: {
                                    "text-decoration": "line-through"
                                }
                            }
                        ]
                    });
                    t.commands.add(eB, new AttributeCommand(t, eB));
                    t.keystrokes.set("CTRL+SHIFT+X", "strikethrough");
                }
            }
            const oB = "strikethrough";
            class iB extends null {
                static get pluginName() {
                    return "StrikethroughUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add(oB, (n)=>{
                        const o = t.commands.get(oB);
                        const i = new ButtonView(n);
                        i.set({
                            label: e("Strikethrough"),
                            icon: strikethroughIcon,
                            keystroke: "CTRL+SHIFT+X",
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute(oB);
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class rB extends null {
                static get requires() {
                    return [
                        StrikethroughEditing,
                        StrikethroughUI
                    ];
                }
                static get pluginName() {
                    return "Strikethrough";
                }
            }
            const sB = "subscript";
            class aB extends null {
                static get pluginName() {
                    return "SubscriptEditing";
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: sB
                    });
                    t.model.schema.setAttributeProperties(sB, {
                        isFormatting: true,
                        copyOnEnter: true
                    });
                    t.conversion.attributeToElement({
                        model: sB,
                        view: "sub",
                        upcastAlso: [
                            {
                                styles: {
                                    "vertical-align": "sub"
                                }
                            }
                        ]
                    });
                    t.commands.add(sB, new AttributeCommand(t, sB));
                }
            }
            const cB = "subscript";
            class lB extends null {
                static get pluginName() {
                    return "SubscriptUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add(cB, (n)=>{
                        const o = t.commands.get(cB);
                        const i = new ButtonView(n);
                        i.set({
                            label: e("Subscript"),
                            icon: subscriptIcon,
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute(cB);
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class dB extends null {
                static get requires() {
                    return [
                        SubscriptEditing,
                        SubscriptUI
                    ];
                }
                static get pluginName() {
                    return "Subscript";
                }
            }
            const uB = "superscript";
            class hB extends null {
                static get pluginName() {
                    return "SuperscriptEditing";
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: uB
                    });
                    t.model.schema.setAttributeProperties(uB, {
                        isFormatting: true,
                        copyOnEnter: true
                    });
                    t.conversion.attributeToElement({
                        model: uB,
                        view: "sup",
                        upcastAlso: [
                            {
                                styles: {
                                    "vertical-align": "super"
                                }
                            }
                        ]
                    });
                    t.commands.add(uB, new AttributeCommand(t, uB));
                }
            }
            const fB = "superscript";
            class pB extends null {
                static get pluginName() {
                    return "SuperscriptUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add(fB, (n)=>{
                        const o = t.commands.get(fB);
                        const i = new ButtonView(n);
                        i.set({
                            label: e("Superscript"),
                            icon: superscriptIcon,
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute(fB);
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class gB extends null {
                static get requires() {
                    return [
                        SuperscriptEditing,
                        SuperscriptUI
                    ];
                }
                static get pluginName() {
                    return "Superscript";
                }
            }
            const mB = "underline";
            class kB extends null {
                static get pluginName() {
                    return "UnderlineEditing";
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: mB
                    });
                    t.model.schema.setAttributeProperties(mB, {
                        isFormatting: true,
                        copyOnEnter: true
                    });
                    t.conversion.attributeToElement({
                        model: mB,
                        view: "u",
                        upcastAlso: {
                            styles: {
                                "text-decoration": "underline"
                            }
                        }
                    });
                    t.commands.add(mB, new AttributeCommand(t, mB));
                    t.keystrokes.set("CTRL+U", "underline");
                }
            }
            const bB = "underline";
            class wB extends null {
                static get pluginName() {
                    return "UnderlineUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add(bB, (n)=>{
                        const o = t.commands.get(bB);
                        const i = new ButtonView(n);
                        i.set({
                            label: e("Underline"),
                            icon: underlineIcon,
                            keystroke: "CTRL+U",
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute(bB);
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class _B extends null {
                static get requires() {
                    return [
                        UnderlineEditing,
                        UnderlineUI
                    ];
                }
                static get pluginName() {
                    return "Underline";
                }
            }
            function* AB(t, e) {
                for (const n of e)if (n && t.getAttributeProperties(n[0]).copyOnEnter) yield n;
            }
            class vB extends Ru {
                execute() {
                    this.editor.model.change((t)=>{
                        this.enterBlock(t);
                        this.fire("afterExecute", {
                            writer: t
                        });
                    });
                }
                enterBlock(t) {
                    const e = this.editor.model;
                    const n = e.document.selection;
                    const o = e.schema;
                    const i = n.isCollapsed;
                    const r = n.getFirstRange();
                    const s = r.start.parent;
                    const a = r.end.parent;
                    if (o.isLimit(s) || o.isLimit(a)) {
                        if (!i && s == a) e.deleteContent(n);
                        return false;
                    }
                    if (i) {
                        const e = AB(t.model.schema, n.getAttributes());
                        CB(t, r.start);
                        t.setSelectionAttribute(e);
                        return true;
                    } else {
                        const o = !(r.start.isAtStart && r.end.isAtEnd);
                        const i = s == a;
                        e.deleteContent(n, {
                            leaveUnmerged: o
                        });
                        if (o) {
                            if (i) {
                                CB(t, n.focus);
                                return true;
                            } else t.setSelection(a, 0);
                        }
                    }
                    return false;
                }
            }
            function CB(t, e) {
                t.split(e);
                t.setSelection(e.parent.nextSibling, 0);
            }
            const yB = {
                insertParagraph: {
                    isSoft: false
                },
                insertLineBreak: {
                    isSoft: true
                }
            };
            class xB extends zg {
                constructor(t){
                    super(t);
                    const e = this.document;
                    let n = false;
                    e.on("keydown", (t, e)=>{
                        n = e.shiftKey;
                    });
                    e.on("beforeinput", (o, i)=>{
                        if (!this.isEnabled) return;
                        let r = i.inputType;
                        if (c.isSafari && n && r == "insertParagraph") r = "insertLineBreak";
                        const s = i.domEvent;
                        const a = yB[r];
                        if (!a) return;
                        const l = new Ap(e, "enter", i.targetRanges[0]);
                        e.fire(l, new Hg(t, s, {
                            isSoft: a.isSoft
                        }));
                        if (l.stop.called) o.stop();
                    });
                }
                observe() {}
                stopObserving() {}
            }
            class EB extends Pu {
                static get pluginName() {
                    return "Enter";
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    e.addObserver(xB);
                    t.commands.add("enter", new vB(t));
                    this.listenTo(n, "enter", (o, i)=>{
                        if (!n.isComposing) i.preventDefault();
                        if (i.isSoft) return;
                        t.execute("enter");
                        e.scrollToTheSelection();
                    }, {
                        priority: "low"
                    });
                }
            }
            class DB extends Ru {
                execute() {
                    const t = this.editor.model;
                    const e = t.document;
                    t.change((n)=>{
                        TB(t, n, e.selection);
                        this.fire("afterExecute", {
                            writer: n
                        });
                    });
                }
                refresh() {
                    const t = this.editor.model;
                    const e = t.document;
                    this.isEnabled = SB(t.schema, e.selection);
                }
            }
            function SB(t, e) {
                if (e.rangeCount > 1) return false;
                const n = e.anchor;
                if (!n || !t.checkChild(n, "softBreak")) return false;
                const o = e.getFirstRange();
                const i = o.start.parent;
                const r = o.end.parent;
                if ((PB(i, t) || PB(r, t)) && i !== r) return false;
                return true;
            }
            function TB(t, e, n) {
                const o = n.isCollapsed;
                const i = n.getFirstRange();
                const r = i.start.parent;
                const s = i.end.parent;
                const a = r == s;
                if (o) {
                    const o = AB(t.schema, n.getAttributes());
                    BB(t, e, i.end);
                    e.removeSelectionAttribute(n.getAttributeKeys());
                    e.setSelectionAttribute(o);
                } else {
                    const o = !(i.start.isAtStart && i.end.isAtEnd);
                    t.deleteContent(n, {
                        leaveUnmerged: o
                    });
                    if (a) BB(t, e, n.focus);
                    else if (o) e.setSelection(s, 0);
                }
            }
            function BB(t, e, n) {
                const o = e.createElement("softBreak");
                t.insertContent(o, n);
                e.setSelection(o, "after");
            }
            function PB(t, e) {
                if (t.is("rootElement")) return false;
                return e.isLimit(t) || PB(t.parent, e);
            }
            class IB extends Pu {
                static get pluginName() {
                    return "ShiftEnter";
                }
                init() {
                    const t = this.editor;
                    const e = t.model.schema;
                    const n = t.conversion;
                    const o = t.editing.view;
                    const i = o.document;
                    e.register("softBreak", {
                        allowWhere: "$text",
                        isInline: true
                    });
                    n.for("upcast").elementToElement({
                        model: "softBreak",
                        view: "br"
                    });
                    n.for("downcast").elementToElement({
                        model: "softBreak",
                        view: (t, { writer: e })=>e.createEmptyElement("br")
                    });
                    o.addObserver(xB);
                    t.commands.add("shiftEnter", new DB(t));
                    this.listenTo(i, "enter", (e, n)=>{
                        if (!i.isComposing) n.preventDefault();
                        if (!n.isSoft) return;
                        t.execute("shiftEnter");
                        o.scrollToTheSelection();
                    }, {
                        priority: "low"
                    });
                }
            }
            class RB extends Ru {
                refresh() {
                    this.value = this._getValue();
                    this.isEnabled = this._checkEnabled();
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.schema;
                    const o = e.document.selection;
                    const i = Array.from(o.getSelectedBlocks());
                    const r = t.forceValue === undefined ? !this.value : t.forceValue;
                    e.change((t)=>{
                        if (!r) this._removeQuote(t, i.filter(OB));
                        else {
                            const e = i.filter((t)=>OB(t) || MB(n, t));
                            this._applyQuote(t, e);
                        }
                    });
                }
                _getValue() {
                    const t = this.editor.model.document.selection;
                    const e = fl(t.getSelectedBlocks());
                    return !!(e && OB(e));
                }
                _checkEnabled() {
                    if (this.value) return true;
                    const t = this.editor.model.document.selection;
                    const e = this.editor.model.schema;
                    const n = fl(t.getSelectedBlocks());
                    if (!n) return false;
                    return MB(e, n);
                }
                _removeQuote(t, e) {
                    VB(t, e).reverse().forEach((e)=>{
                        if (e.start.isAtStart && e.end.isAtEnd) {
                            t.unwrap(e.start.parent);
                            return;
                        }
                        if (e.start.isAtStart) {
                            const n = t.createPositionBefore(e.start.parent);
                            t.move(e, n);
                            return;
                        }
                        if (!e.end.isAtEnd) t.split(e.end);
                        const n = t.createPositionAfter(e.end.parent);
                        t.move(e, n);
                    });
                }
                _applyQuote(t, e) {
                    const n = [];
                    VB(t, e).reverse().forEach((e)=>{
                        let o = OB(e.start);
                        if (!o) {
                            o = t.createElement("blockQuote");
                            t.wrap(e, o);
                        }
                        n.push(o);
                    });
                    n.reverse().reduce((e, n)=>{
                        if (e.nextSibling == n) {
                            t.merge(t.createPositionAfter(e));
                            return e;
                        }
                        return n;
                    });
                }
            }
            function OB(t) {
                return t.parent.name == "blockQuote" ? t.parent : null;
            }
            function VB(t, e) {
                let n;
                let o = 0;
                const i = [];
                while(o < e.length){
                    const r = e[o];
                    const s = e[o + 1];
                    if (!n) n = t.createPositionBefore(r);
                    if (!s || r.nextSibling != s) {
                        i.push(t.createRange(n, t.createPositionAfter(r)));
                        n = null;
                    }
                    o++;
                }
                return i;
            }
            function MB(t, e) {
                const n = t.checkChild(e.parent, "blockQuote");
                const o = t.checkChild([
                    "$root",
                    "blockQuote"
                ], e);
                return n && o;
            }
            class LB extends Pu {
                static get pluginName() {
                    return "BlockQuoteEditing";
                }
                static get requires() {
                    return [
                        EB,
                        mT
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.model.schema;
                    t.commands.add("blockQuote", new RB(t));
                    e.register("blockQuote", {
                        inheritAllFrom: "$container"
                    });
                    t.conversion.elementToElement({
                        model: "blockQuote",
                        view: "blockquote"
                    });
                    t.model.document.registerPostFixer((n)=>{
                        const o = t.model.document.differ.getChanges();
                        for (const t of o){
                            if (t.type == "insert") {
                                const o = t.position.nodeAfter;
                                if (!o) continue;
                                if (o.is("element", "blockQuote") && o.isEmpty) {
                                    n.remove(o);
                                    return true;
                                } else if (o.is("element", "blockQuote") && !e.checkChild(t.position, o)) {
                                    n.unwrap(o);
                                    return true;
                                } else if (o.is("element")) {
                                    const t = n.createRangeIn(o);
                                    for (const o of t.getItems())if (o.is("element", "blockQuote") && !e.checkChild(n.createPositionBefore(o), o)) {
                                        n.unwrap(o);
                                        return true;
                                    }
                                }
                            } else if (t.type == "remove") {
                                const e = t.position.parent;
                                if (e.is("element", "blockQuote") && e.isEmpty) {
                                    n.remove(e);
                                    return true;
                                }
                            }
                        }
                        return false;
                    });
                    const n = this.editor.editing.view.document;
                    const o = t.model.document.selection;
                    const i = t.commands.get("blockQuote");
                    this.listenTo(n, "enter", (e, n)=>{
                        if (!o.isCollapsed || !i.value) return;
                        const r = o.getLastPosition().parent;
                        if (r.isEmpty) {
                            t.execute("blockQuote");
                            t.editing.view.scrollToTheSelection();
                            n.preventDefault();
                            e.stop();
                        }
                    }, {
                        context: "blockquote"
                    });
                    this.listenTo(n, "delete", (e, n)=>{
                        if (n.direction != "backward" || !o.isCollapsed || !i.value) return;
                        const r = o.getLastPosition().parent;
                        if (r.isEmpty && !r.previousSibling) {
                            t.execute("blockQuote");
                            t.editing.view.scrollToTheSelection();
                            n.preventDefault();
                            e.stop();
                        }
                    }, {
                        context: "blockquote"
                    });
                }
            }
            var zB = n(3789);
            var NB = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            NB.insert = "head";
            NB.singleton = true;
            var FB = Rl()(zB.Z, NB);
            const HB = zB.Z.locals || {};
            class jB extends Pu {
                static get pluginName() {
                    return "BlockQuoteUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add("blockQuote", (n)=>{
                        const o = t.commands.get("blockQuote");
                        const i = new yd(n);
                        i.set({
                            label: e("Block quote"),
                            icon: FC.quote,
                            tooltip: true,
                            isToggleable: true
                        });
                        i.bind("isOn", "isEnabled").to(o, "value", "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute("blockQuote");
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class qB extends Pu {
                static get requires() {
                    return [
                        LB,
                        jB
                    ];
                }
                static get pluginName() {
                    return "BlockQuote";
                }
            }
            class WB extends jg {
                constructor(t){
                    super(t);
                    this.domEventType = [
                        "paste",
                        "copy",
                        "cut",
                        "drop",
                        "dragover",
                        "dragstart",
                        "dragend",
                        "dragenter",
                        "dragleave"
                    ];
                    const e = this.document;
                    this.listenTo(e, "paste", n("clipboardInput"), {
                        priority: "low"
                    });
                    this.listenTo(e, "drop", n("clipboardInput"), {
                        priority: "low"
                    });
                    this.listenTo(e, "dragover", n("dragging"), {
                        priority: "low"
                    });
                    function n(t) {
                        return (n, o)=>{
                            o.preventDefault();
                            const i = o.dropRange ? [
                                o.dropRange
                            ] : null;
                            const r = new E(e, t);
                            e.fire(r, {
                                dataTransfer: o.dataTransfer,
                                method: n.name,
                                targetRanges: i,
                                target: o.target,
                                domEvent: o.domEvent
                            });
                            if (r.stop.called) o.stopPropagation();
                        };
                    }
                }
                onDomEvent(t) {
                    const e = "clipboardData" in t ? t.clipboardData : t.dataTransfer;
                    const n = t.type == "drop" || t.type == "paste";
                    const o = {
                        dataTransfer: new gk(e, {
                            cacheFiles: n
                        })
                    };
                    if (t.type == "drop" || t.type == "dragover") o.dropRange = $B(this.view, t);
                    this.fire(t.type, t, o);
                }
            }
            function $B(t, e) {
                const n = e.target.ownerDocument;
                const o = e.clientX;
                const i = e.clientY;
                let r;
                if (n.caretRangeFromPoint && n.caretRangeFromPoint(o, i)) r = n.caretRangeFromPoint(o, i);
                else if (e.rangeParent) {
                    r = n.createRange();
                    r.setStart(e.rangeParent, e.rangeOffset);
                    r.collapse(true);
                }
                if (r) return t.domConverter.domRangeToView(r);
                return null;
            }
            function GB(t) {
                t = t.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;");
                if (t.includes("</p><p>") || t.includes("<br>")) t = `<p>${t}</p>`;
                return t;
            }
            function UB(t) {
                return t.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t, e)=>{
                    if (e.length == 1) return " ";
                    return e;
                }).replace(/<!--[\s\S]*?-->/g, "");
            }
            const KB = [
                "figcaption",
                "li"
            ];
            function ZB(t) {
                let e = "";
                if (t.is("$text") || t.is("$textProxy")) e = t.data;
                else if (t.is("element", "img") && t.hasAttribute("alt")) e = t.getAttribute("alt");
                else if (t.is("element", "br")) e = "\n";
                else {
                    let n = null;
                    for (const o of t.getChildren()){
                        const t = ZB(o);
                        if (n && (n.is("containerElement") || o.is("containerElement"))) {
                            if (KB.includes(n.name) || KB.includes(o.name)) e += "\n";
                            else e += "\n\n";
                        }
                        e += t;
                        n = o;
                    }
                }
                return e;
            }
            class JB extends Pu {
                static get pluginName() {
                    return "ClipboardPipeline";
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view;
                    e.addObserver(WB);
                    this._setupPasteDrop();
                    this._setupCopyCut();
                }
                _fireOutputTransformationEvent(t, e, n) {
                    const o = this.editor.model.getSelectedContent(e);
                    this.fire("outputTransformation", {
                        dataTransfer: t,
                        content: o,
                        method: n
                    });
                }
                _setupPasteDrop() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.editing.view;
                    const o = n.document;
                    this.listenTo(o, "clipboardInput", (e, n)=>{
                        if (n.method == "paste" && !t.model.canEditAt(t.model.document.selection)) e.stop();
                    }, {
                        priority: "highest"
                    });
                    this.listenTo(o, "clipboardInput", (t, e)=>{
                        const o = e.dataTransfer;
                        let i;
                        if (e.content) i = e.content;
                        else {
                            let t = "";
                            if (o.getData("text/html")) t = UB(o.getData("text/html"));
                            else if (o.getData("text/plain")) t = GB(o.getData("text/plain"));
                            i = this.editor.data.htmlProcessor.toView(t);
                        }
                        const r = new E(this, "inputTransformation");
                        this.fire(r, {
                            content: i,
                            dataTransfer: o,
                            targetRanges: e.targetRanges,
                            method: e.method
                        });
                        if (r.stop.called) t.stop();
                        n.scrollToTheSelection();
                    }, {
                        priority: "low"
                    });
                    this.listenTo(this, "inputTransformation", (t, n)=>{
                        if (n.content.isEmpty) return;
                        const o = this.editor.data;
                        const i = o.toModel(n.content, "$clipboardHolder");
                        if (i.childCount == 0) return;
                        t.stop();
                        e.change(()=>{
                            this.fire("contentInsertion", {
                                content: i,
                                method: n.method,
                                dataTransfer: n.dataTransfer,
                                targetRanges: n.targetRanges
                            });
                        });
                    }, {
                        priority: "low"
                    });
                    this.listenTo(this, "contentInsertion", (t, n)=>{
                        n.resultRange = e.insertContent(n.content);
                    }, {
                        priority: "low"
                    });
                }
                _setupCopyCut() {
                    const t = this.editor;
                    const e = t.model.document;
                    const n = t.editing.view;
                    const o = n.document;
                    const i = (t, n)=>{
                        const o = n.dataTransfer;
                        n.preventDefault();
                        this._fireOutputTransformationEvent(o, e.selection, t.name);
                    };
                    this.listenTo(o, "copy", i, {
                        priority: "low"
                    });
                    this.listenTo(o, "cut", (e, n)=>{
                        if (!t.model.canEditAt(t.model.document.selection)) n.preventDefault();
                        else i(e, n);
                    }, {
                        priority: "low"
                    });
                    this.listenTo(this, "outputTransformation", (e, n)=>{
                        const i = t.data.toView(n.content);
                        o.fire("clipboardOutput", {
                            dataTransfer: n.dataTransfer,
                            content: i,
                            method: n.method
                        });
                    }, {
                        priority: "low"
                    });
                    this.listenTo(o, "clipboardOutput", (n, o)=>{
                        if (!o.content.isEmpty) {
                            o.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(o.content));
                            o.dataTransfer.setData("text/plain", ZB(o.content));
                        }
                        if (o.method == "cut") t.model.deleteContent(e.selection);
                    }, {
                        priority: "low"
                    });
                }
            }
            class YB extends G() {
                constructor(){
                    super(...arguments);
                    this._stack = [];
                }
                add(t, e) {
                    const n = this._stack;
                    const o = n[0];
                    this._insertDescriptor(t);
                    const i = n[0];
                    if (o !== i && !QB(o, i)) this.fire("change:top", {
                        oldDescriptor: o,
                        newDescriptor: i,
                        writer: e
                    });
                }
                remove(t, e) {
                    const n = this._stack;
                    const o = n[0];
                    this._removeDescriptor(t);
                    const i = n[0];
                    if (o !== i && !QB(o, i)) this.fire("change:top", {
                        oldDescriptor: o,
                        newDescriptor: i,
                        writer: e
                    });
                }
                _insertDescriptor(t) {
                    const e = this._stack;
                    const n = e.findIndex((e)=>e.id === t.id);
                    if (QB(t, e[n])) return;
                    if (n > -1) e.splice(n, 1);
                    let o = 0;
                    while(e[o] && XB(e[o], t))o++;
                    e.splice(o, 0, t);
                }
                _removeDescriptor(t) {
                    const e = this._stack;
                    const n = e.findIndex((e)=>e.id === t);
                    if (n > -1) e.splice(n, 1);
                }
            }
            function QB(t, e) {
                return t && e && t.priority == e.priority && tP(t.classes) == tP(e.classes);
            }
            function XB(t, e) {
                if (t.priority > e.priority) return true;
                else if (t.priority < e.priority) return false;
                return tP(t.classes) > tP(e.classes);
            }
            function tP(t) {
                return Array.isArray(t) ? t.sort().join(",") : t;
            }
            const eP = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>';
            const nP = "ck-widget";
            const oP = "ck-widget_selected";
            function iP(t) {
                if (!t.is("element")) return false;
                return !!t.getCustomProperty("widget");
            }
            function rP(t, e, n = {}) {
                if (!t.is("containerElement")) throw new R("widget-to-widget-wrong-element-type", null, {
                    element: t
                });
                e.setAttribute("contenteditable", "false", t);
                e.addClass(nP, t);
                e.setCustomProperty("widget", true, t);
                t.getFillerOffset = pP;
                e.setCustomProperty("widgetLabel", [], t);
                if (n.label) lP(t, n.label);
                if (n.hasSelectionHandle) gP(t, e);
                cP(t, e);
                return t;
            }
            function sP(t, e, n) {
                if (e.classes) n.addClass(nl(e.classes), t);
                if (e.attributes) for(const o in e.attributes)n.setAttribute(o, e.attributes[o], t);
            }
            function aP(t, e, n) {
                if (e.classes) n.removeClass(nl(e.classes), t);
                if (e.attributes) for(const o in e.attributes)n.removeAttribute(o, t);
            }
            function cP(t, e, n = sP, o = aP) {
                const i = new YB;
                i.on("change:top", (e, i)=>{
                    if (i.oldDescriptor) o(t, i.oldDescriptor, i.writer);
                    if (i.newDescriptor) n(t, i.newDescriptor, i.writer);
                });
                const r = (t, e, n)=>i.add(e, n);
                const s = (t, e, n)=>i.remove(e, n);
                e.setCustomProperty("addHighlight", r, t);
                e.setCustomProperty("removeHighlight", s, t);
            }
            function lP(t, e) {
                const n = t.getCustomProperty("widgetLabel");
                n.push(e);
            }
            function dP(t) {
                const e = t.getCustomProperty("widgetLabel");
                return e.reduce((t, e)=>{
                    if (typeof e === "function") return t ? t + ". " + e() : e();
                    else return t ? t + ". " + e : e;
                }, "");
            }
            function uP(t, e, n = {}) {
                e.addClass([
                    "ck-editor__editable",
                    "ck-editor__nested-editable"
                ], t);
                e.setAttribute("role", "textbox", t);
                if (n.label) e.setAttribute("aria-label", n.label, t);
                e.setAttribute("contenteditable", t.isReadOnly ? "false" : "true", t);
                t.on("change:isReadOnly", (n, o, i)=>{
                    e.setAttribute("contenteditable", i ? "false" : "true", t);
                });
                t.on("change:isFocused", (n, o, i)=>{
                    if (i) e.addClass("ck-editor__nested-editable_focused", t);
                    else e.removeClass("ck-editor__nested-editable_focused", t);
                });
                cP(t, e);
                return t;
            }
            function hP(t, e) {
                const n = t.getSelectedElement();
                if (n) {
                    const o = AP(t);
                    if (o) return e.createRange(e.createPositionAt(n, o));
                }
                return HA(t, e);
            }
            function fP(t, e) {
                return (n, o)=>{
                    const { mapper: i, viewPosition: r } = o;
                    const s = i.findMappedViewAncestor(r);
                    if (!e(s)) return;
                    const a = i.toModelElement(s);
                    o.modelPosition = t.createPositionAt(a, r.isAtStart ? "before" : "after");
                };
            }
            function pP() {
                return null;
            }
            function gP(t, e) {
                const n = e.createUIElement("div", {
                    class: "ck ck-widget__selection-handle"
                }, function(t) {
                    const e = this.toDomElement(t);
                    const n = new bd;
                    n.set("content", eP);
                    n.render();
                    e.appendChild(n.element);
                    return e;
                });
                e.insert(e.createPositionAt(t, 0), n);
                e.addClass([
                    "ck-widget_with-selection-handle"
                ], t);
            }
            const mP = "widget-type-around";
            function kP(t, e, n) {
                return !!t && iP(t) && !n.isInline(e);
            }
            function bP(t) {
                return t.closest(".ck-widget__type-around__button");
            }
            function wP(t) {
                return t.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
            }
            function _P(t, e) {
                const n = t.closest(".ck-widget");
                return e.mapDomToView(n);
            }
            function AP(t) {
                return t.getAttribute(mP);
            }
            const vP = '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>';
            var CP = n(2347);
            var yP = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            yP.insert = "head";
            yP.singleton = true;
            var xP = Rl()(CP.Z, yP);
            const EP = CP.Z.locals || {};
            const DP = [
                "before",
                "after"
            ];
            const SP = (new DOMParser).parseFromString(vP, "image/svg+xml").firstChild;
            const TP = "ck-widget__type-around_disabled";
            class BP extends Pu {
                constructor(){
                    super(...arguments);
                    this._currentFakeCaretModelElement = null;
                }
                static get pluginName() {
                    return "WidgetTypeAround";
                }
                static get requires() {
                    return [
                        EB,
                        mT
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view;
                    this.on("change:isEnabled", (n, o, i)=>{
                        e.change((t)=>{
                            for (const n of e.document.roots)if (i) t.removeClass(TP, n);
                            else t.addClass(TP, n);
                        });
                        if (!i) t.model.change((t)=>{
                            t.removeSelectionAttribute(mP);
                        });
                    });
                    this._enableTypeAroundUIInjection();
                    this._enableInsertingParagraphsOnButtonClick();
                    this._enableInsertingParagraphsOnEnterKeypress();
                    this._enableInsertingParagraphsOnTypingKeystroke();
                    this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows();
                    this._enableDeleteIntegration();
                    this._enableInsertContentIntegration();
                    this._enableInsertObjectIntegration();
                    this._enableDeleteContentIntegration();
                }
                destroy() {
                    super.destroy();
                    this._currentFakeCaretModelElement = null;
                }
                _insertParagraph(t, e) {
                    const n = this.editor;
                    const o = n.editing.view;
                    const i = n.model.schema.getAttributesWithProperty(t, "copyOnReplace", true);
                    n.execute("insertParagraph", {
                        position: n.model.createPositionAt(t, e),
                        attributes: i
                    });
                    o.focus();
                    o.scrollToTheSelection();
                }
                _listenToIfEnabled(t, e, n, o) {
                    this.listenTo(t, e, (...t)=>{
                        if (this.isEnabled) n(...t);
                    }, o);
                }
                _insertParagraphAccordingToFakeCaretPosition() {
                    const t = this.editor;
                    const e = t.model;
                    const n = e.document.selection;
                    const o = AP(n);
                    if (!o) return false;
                    const i = n.getSelectedElement();
                    this._insertParagraph(i, o);
                    return true;
                }
                _enableTypeAroundUIInjection() {
                    const t = this.editor;
                    const e = t.model.schema;
                    const n = t.locale.t;
                    const o = {
                        before: n("Insert paragraph before block"),
                        after: n("Insert paragraph after block")
                    };
                    t.editing.downcastDispatcher.on("insert", (t, i, r)=>{
                        const s = r.mapper.toViewElement(i.item);
                        if (!s) return;
                        if (kP(s, i.item, e)) {
                            PP(r.writer, o, s);
                            const t = s.getCustomProperty("widgetLabel");
                            t.push(()=>this.isEnabled ? n("Press Enter to type after or press Shift + Enter to type before the widget") : "");
                        }
                    }, {
                        priority: "low"
                    });
                }
                _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
                    const t = this.editor;
                    const e = t.model;
                    const n = e.document.selection;
                    const o = e.schema;
                    const i = t.editing.view;
                    this._listenToIfEnabled(i.document, "arrowKey", (t, e)=>{
                        this._handleArrowKeyPress(t, e);
                    }, {
                        context: [
                            iP,
                            "$text"
                        ],
                        priority: "high"
                    });
                    this._listenToIfEnabled(n, "change:range", (e, n)=>{
                        if (!n.directChange) return;
                        t.model.change((t)=>{
                            t.removeSelectionAttribute(mP);
                        });
                    });
                    this._listenToIfEnabled(e.document, "change:data", ()=>{
                        const e = n.getSelectedElement();
                        if (e) {
                            const n = t.editing.mapper.toViewElement(e);
                            if (kP(n, e, o)) return;
                        }
                        t.model.change((t)=>{
                            t.removeSelectionAttribute(mP);
                        });
                    });
                    this._listenToIfEnabled(t.editing.downcastDispatcher, "selection", (t, e, n)=>{
                        const i = n.writer;
                        if (this._currentFakeCaretModelElement) {
                            const t = n.mapper.toViewElement(this._currentFakeCaretModelElement);
                            if (t) {
                                i.removeClass(DP.map(r), t);
                                this._currentFakeCaretModelElement = null;
                            }
                        }
                        const s = e.selection.getSelectedElement();
                        if (!s) return;
                        const a = n.mapper.toViewElement(s);
                        if (!kP(a, s, o)) return;
                        const c = AP(e.selection);
                        if (!c) return;
                        i.addClass(r(c), a);
                        this._currentFakeCaretModelElement = s;
                    });
                    this._listenToIfEnabled(t.ui.focusTracker, "change:isFocused", (e, n, o)=>{
                        if (!o) t.model.change((t)=>{
                            t.removeSelectionAttribute(mP);
                        });
                    });
                    function r(t) {
                        return `ck-widget_type-around_show-fake-caret_${t}`;
                    }
                }
                _handleArrowKeyPress(t, e) {
                    const n = this.editor;
                    const o = n.model;
                    const i = o.document.selection;
                    const r = o.schema;
                    const s = n.editing.view;
                    const a = e.keyCode;
                    const c = Xc(a, n.locale.contentLanguageDirection);
                    const l = s.document.selection.getSelectedElement();
                    const d = n.editing.mapper.toModelElement(l);
                    let u;
                    if (kP(l, d, r)) u = this._handleArrowKeyPressOnSelectedWidget(c);
                    else if (i.isCollapsed) u = this._handleArrowKeyPressWhenSelectionNextToAWidget(c);
                    else if (!e.shiftKey) u = this._handleArrowKeyPressWhenNonCollapsedSelection(c);
                    if (u) {
                        e.preventDefault();
                        t.stop();
                    }
                }
                _handleArrowKeyPressOnSelectedWidget(t) {
                    const e = this.editor;
                    const n = e.model;
                    const o = n.document.selection;
                    const i = AP(o);
                    return n.change((e)=>{
                        if (i) {
                            const n = i === (t ? "after" : "before");
                            if (!n) {
                                e.removeSelectionAttribute(mP);
                                return true;
                            }
                        } else {
                            e.setSelectionAttribute(mP, t ? "after" : "before");
                            return true;
                        }
                        return false;
                    });
                }
                _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
                    const e = this.editor;
                    const n = e.model;
                    const o = n.schema;
                    const i = e.plugins.get("Widget");
                    const r = i._getObjectElementNextToSelection(t);
                    const s = e.editing.mapper.toViewElement(r);
                    if (kP(s, r, o)) {
                        n.change((e)=>{
                            i._setSelectionOverElement(r);
                            e.setSelectionAttribute(mP, t ? "before" : "after");
                        });
                        return true;
                    }
                    return false;
                }
                _handleArrowKeyPressWhenNonCollapsedSelection(t) {
                    const e = this.editor;
                    const n = e.model;
                    const o = n.schema;
                    const i = e.editing.mapper;
                    const r = n.document.selection;
                    const s = t ? r.getLastPosition().nodeBefore : r.getFirstPosition().nodeAfter;
                    const a = i.toViewElement(s);
                    if (kP(a, s, o)) {
                        n.change((e)=>{
                            e.setSelection(s, "on");
                            e.setSelectionAttribute(mP, t ? "after" : "before");
                        });
                        return true;
                    }
                    return false;
                }
                _enableInsertingParagraphsOnButtonClick() {
                    const t = this.editor;
                    const e = t.editing.view;
                    this._listenToIfEnabled(e.document, "mousedown", (n, o)=>{
                        const i = bP(o.domTarget);
                        if (!i) return;
                        const r = wP(i);
                        const s = _P(i, e.domConverter);
                        const a = t.editing.mapper.toModelElement(s);
                        this._insertParagraph(a, r);
                        o.preventDefault();
                        n.stop();
                    });
                }
                _enableInsertingParagraphsOnEnterKeypress() {
                    const t = this.editor;
                    const e = t.model.document.selection;
                    const n = t.editing.view;
                    this._listenToIfEnabled(n.document, "enter", (n, o)=>{
                        if (n.eventPhase != "atTarget") return;
                        const i = e.getSelectedElement();
                        const r = t.editing.mapper.toViewElement(i);
                        const s = t.model.schema;
                        let a;
                        if (this._insertParagraphAccordingToFakeCaretPosition()) a = true;
                        else if (kP(r, i, s)) {
                            this._insertParagraph(i, o.isSoft ? "before" : "after");
                            a = true;
                        }
                        if (a) {
                            o.preventDefault();
                            n.stop();
                        }
                    }, {
                        context: iP
                    });
                }
                _enableInsertingParagraphsOnTypingKeystroke() {
                    const t = this.editor;
                    const e = t.editing.view.document;
                    this._listenToIfEnabled(e, "insertText", (t, n)=>{
                        if (this._insertParagraphAccordingToFakeCaretPosition()) n.selection = e.selection;
                    }, {
                        priority: "high"
                    });
                    if (c.isAndroid) this._listenToIfEnabled(e, "keydown", (t, e)=>{
                        if (e.keyCode == 229) this._insertParagraphAccordingToFakeCaretPosition();
                    });
                    else this._listenToIfEnabled(e, "compositionstart", ()=>{
                        this._insertParagraphAccordingToFakeCaretPosition();
                    }, {
                        priority: "high"
                    });
                }
                _enableDeleteIntegration() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = t.model;
                    const o = n.schema;
                    this._listenToIfEnabled(e.document, "delete", (e, i)=>{
                        if (e.eventPhase != "atTarget") return;
                        const r = AP(n.document.selection);
                        if (!r) return;
                        const s = i.direction;
                        const a = n.document.selection.getSelectedElement();
                        const c = r === "before";
                        const l = s == "forward";
                        const d = c === l;
                        if (d) t.execute("delete", {
                            selection: n.createSelection(a, "on")
                        });
                        else {
                            const e = o.getNearestSelectionRange(n.createPositionAt(a, r), s);
                            if (e) {
                                if (!e.isCollapsed) n.change((n)=>{
                                    n.setSelection(e);
                                    t.execute(l ? "deleteForward" : "delete");
                                });
                                else {
                                    const i = n.createSelection(e.start);
                                    n.modifySelection(i, {
                                        direction: s
                                    });
                                    if (!i.focus.isEqual(e.start)) n.change((n)=>{
                                        n.setSelection(e);
                                        t.execute(l ? "deleteForward" : "delete");
                                    });
                                    else {
                                        const t = OP(o, e.start.parent);
                                        n.deleteContent(n.createSelection(t, "on"), {
                                            doNotAutoparagraph: true
                                        });
                                    }
                                }
                            }
                        }
                        i.preventDefault();
                        e.stop();
                    }, {
                        context: iP
                    });
                }
                _enableInsertContentIntegration() {
                    const t = this.editor;
                    const e = this.editor.model;
                    const n = e.document.selection;
                    this._listenToIfEnabled(t.model, "insertContent", (t, [o, i])=>{
                        if (i && !i.is("documentSelection")) return;
                        const r = AP(n);
                        if (!r) return;
                        t.stop();
                        return e.change((t)=>{
                            const i = n.getSelectedElement();
                            const s = e.createPositionAt(i, r);
                            const a = t.createSelection(s);
                            const c = e.insertContent(o, a);
                            t.setSelection(a);
                            return c;
                        });
                    }, {
                        priority: "high"
                    });
                }
                _enableInsertObjectIntegration() {
                    const t = this.editor;
                    const e = this.editor.model;
                    const n = e.document.selection;
                    this._listenToIfEnabled(t.model, "insertObject", (t, e)=>{
                        const [, o, i = {}] = e;
                        if (o && !o.is("documentSelection")) return;
                        const r = AP(n);
                        if (!r) return;
                        i.findOptimalPosition = r;
                        e[3] = i;
                    }, {
                        priority: "high"
                    });
                }
                _enableDeleteContentIntegration() {
                    const t = this.editor;
                    const e = this.editor.model;
                    const n = e.document.selection;
                    this._listenToIfEnabled(t.model, "deleteContent", (t, [e])=>{
                        if (e && !e.is("documentSelection")) return;
                        const o = AP(n);
                        if (o) t.stop();
                    }, {
                        priority: "high"
                    });
                }
            }
            function PP(t, e, n) {
                const o = t.createUIElement("div", {
                    class: "ck ck-reset_all ck-widget__type-around"
                }, function(t) {
                    const n = this.toDomElement(t);
                    IP(n, e);
                    RP(n);
                    return n;
                });
                t.insert(t.createPositionAt(n, "end"), o);
            }
            function IP(t, e) {
                for (const n of DP){
                    const o = new Fl({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-widget__type-around__button",
                                `ck-widget__type-around__button_${n}`
                            ],
                            title: e[n],
                            "aria-hidden": "true"
                        },
                        children: [
                            t.ownerDocument.importNode(SP, true)
                        ]
                    });
                    t.appendChild(o.render());
                }
            }
            function RP(t) {
                const e = new Fl({
                    tag: "div",
                    attributes: {
                        class: [
                            "ck",
                            "ck-widget__type-around__fake-caret"
                        ]
                    }
                });
                t.appendChild(e.render());
            }
            function OP(t, e) {
                let n = e;
                for (const o of e.getAncestors({
                    parentFirst: true
                })){
                    if (o.childCount > 1 || t.isLimit(o)) break;
                    n = o;
                }
                return n;
            }
            function VP(t) {
                const e = t.model;
                return (n, o)=>{
                    const i = o.keyCode == $c.arrowup;
                    const r = o.keyCode == $c.arrowdown;
                    const s = o.shiftKey;
                    const a = e.document.selection;
                    if (!i && !r) return;
                    const c = r;
                    if (s && FP(a, c)) return;
                    const l = MP(t, a, c);
                    if (!l) return;
                    if (l.isCollapsed) {
                        if (a.isCollapsed) return;
                        else if (s) return;
                    }
                    if (l.isCollapsed || NP(t, l, c)) {
                        e.change((t)=>{
                            const n = c ? l.end : l.start;
                            if (s) {
                                const o = e.createSelection(a.anchor);
                                o.setFocus(n);
                                t.setSelection(o);
                            } else t.setSelection(n);
                        });
                        n.stop();
                        o.preventDefault();
                        o.stopPropagation();
                    }
                };
            }
            function MP(t, e, n) {
                const o = t.model;
                if (n) {
                    const t = e.isCollapsed ? e.focus : e.getLastPosition();
                    const n = LP(o, t, "forward");
                    if (!n) return null;
                    const i = o.createRange(t, n);
                    const r = zP(o.schema, i, "backward");
                    if (r) return o.createRange(t, r);
                    return null;
                } else {
                    const t = e.isCollapsed ? e.focus : e.getFirstPosition();
                    const n = LP(o, t, "backward");
                    if (!n) return null;
                    const i = o.createRange(n, t);
                    const r = zP(o.schema, i, "forward");
                    if (r) return o.createRange(r, t);
                    return null;
                }
            }
            function LP(t, e, n) {
                const o = t.schema;
                const i = t.createRangeIn(e.root);
                const r = n == "forward" ? "elementStart" : "elementEnd";
                for (const { previousPosition: t, item: s, type: a } of i.getWalker({
                    startPosition: e,
                    direction: n
                })){
                    if (o.isLimit(s) && !o.isInline(s)) return t;
                    if (a == r && o.isBlock(s)) return null;
                }
                return null;
            }
            function zP(t, e, n) {
                const o = n == "backward" ? e.end : e.start;
                if (t.checkChild(o, "$text")) return o;
                for (const { nextPosition: o } of e.getWalker({
                    direction: n
                })){
                    if (t.checkChild(o, "$text")) return o;
                }
                return null;
            }
            function NP(t, e, n) {
                const o = t.model;
                const i = t.view.domConverter;
                if (n) {
                    const t = o.createSelection(e.start);
                    o.modifySelection(t);
                    if (!t.focus.isAtEnd && !e.start.isEqual(t.focus)) e = o.createRange(t.focus, e.end);
                }
                const r = t.mapper.toViewRange(e);
                const s = i.viewRangeToDom(r);
                const a = dc.getDomRangeRects(s);
                let c;
                for (const t of a){
                    if (c === undefined) {
                        c = Math.round(t.bottom);
                        continue;
                    }
                    if (Math.round(t.top) >= c) return false;
                    c = Math.max(c, Math.round(t.bottom));
                }
                return true;
            }
            function FP(t, e) {
                return !t.isCollapsed && t.isBackward == e;
            }
            var HP = n(7153);
            var jP = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            jP.insert = "head";
            jP.singleton = true;
            var qP = Rl()(HP.Z, jP);
            const WP = HP.Z.locals || {};
            class $P extends Pu {
                constructor(){
                    super(...arguments);
                    this._previouslySelected = new Set;
                }
                static get pluginName() {
                    return "Widget";
                }
                static get requires() {
                    return [
                        BP,
                        mT
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    this.editor.editing.downcastDispatcher.on("selection", (e, n, o)=>{
                        const i = o.writer;
                        const r = n.selection;
                        if (r.isCollapsed) return;
                        const s = r.getSelectedElement();
                        if (!s) return;
                        const a = t.editing.mapper.toViewElement(s);
                        if (!iP(a)) return;
                        if (!o.consumable.consume(r, "selection")) return;
                        i.setSelection(i.createRangeOn(a), {
                            fake: true,
                            label: dP(a)
                        });
                    });
                    this.editor.editing.downcastDispatcher.on("selection", (t, e, n)=>{
                        this._clearPreviouslySelectedWidgets(n.writer);
                        const o = n.writer;
                        const i = o.document.selection;
                        let r = null;
                        for (const t of i.getRanges())for (const e of t){
                            const t = e.item;
                            if (iP(t) && !UP(t, r)) {
                                o.addClass(oP, t);
                                this._previouslySelected.add(t);
                                r = t;
                            }
                        }
                    }, {
                        priority: "low"
                    });
                    e.addObserver(ev);
                    this.listenTo(n, "mousedown", (...t)=>this._onMousedown(...t));
                    this.listenTo(n, "arrowKey", (...t)=>{
                        this._handleSelectionChangeOnArrowKeyPress(...t);
                    }, {
                        context: [
                            iP,
                            "$text"
                        ]
                    });
                    this.listenTo(n, "arrowKey", (...t)=>{
                        this._preventDefaultOnArrowKeyPress(...t);
                    }, {
                        context: "$root"
                    });
                    this.listenTo(n, "arrowKey", VP(this.editor.editing), {
                        context: "$text"
                    });
                    this.listenTo(n, "delete", (t, e)=>{
                        if (this._handleDelete(e.direction == "forward")) {
                            e.preventDefault();
                            t.stop();
                        }
                    }, {
                        context: "$root"
                    });
                }
                _onMousedown(t, e) {
                    const n = this.editor;
                    const o = n.editing.view;
                    const i = o.document;
                    let r = e.target;
                    if (GP(r)) {
                        if ((c.isSafari || c.isGecko) && e.domEvent.detail >= 3) {
                            const t = n.editing.mapper;
                            const o = r.is("attributeElement") ? r.findAncestor((t)=>!t.is("attributeElement")) : r;
                            const i = t.toModelElement(o);
                            e.preventDefault();
                            this.editor.model.change((t)=>{
                                t.setSelection(i, "in");
                            });
                        }
                        return;
                    }
                    if (!iP(r)) {
                        r = r.findAncestor(iP);
                        if (!r) return;
                    }
                    if (c.isAndroid) e.preventDefault();
                    if (!i.isFocused) o.focus();
                    const s = n.editing.mapper.toModelElement(r);
                    this._setSelectionOverElement(s);
                }
                _handleSelectionChangeOnArrowKeyPress(t, e) {
                    const n = e.keyCode;
                    const o = this.editor.model;
                    const i = o.schema;
                    const r = o.document.selection;
                    const s = r.getSelectedElement();
                    const a = Yc(n, this.editor.locale.contentLanguageDirection);
                    const c = a == "down" || a == "right";
                    const l = a == "up" || a == "down";
                    if (s && i.isObject(s)) {
                        const n = c ? r.getLastPosition() : r.getFirstPosition();
                        const s = i.getNearestSelectionRange(n, c ? "forward" : "backward");
                        if (s) {
                            o.change((t)=>{
                                t.setSelection(s);
                            });
                            e.preventDefault();
                            t.stop();
                        }
                        return;
                    }
                    if (!r.isCollapsed && !e.shiftKey) {
                        const n = r.getFirstPosition();
                        const s = r.getLastPosition();
                        const a = n.nodeAfter;
                        const l = s.nodeBefore;
                        if (a && i.isObject(a) || l && i.isObject(l)) {
                            o.change((t)=>{
                                t.setSelection(c ? s : n);
                            });
                            e.preventDefault();
                            t.stop();
                        }
                        return;
                    }
                    if (!r.isCollapsed) return;
                    const d = this._getObjectElementNextToSelection(c);
                    if (d && i.isObject(d)) {
                        if (i.isInline(d) && l) return;
                        this._setSelectionOverElement(d);
                        e.preventDefault();
                        t.stop();
                    }
                }
                _preventDefaultOnArrowKeyPress(t, e) {
                    const n = this.editor.model;
                    const o = n.schema;
                    const i = n.document.selection.getSelectedElement();
                    if (i && o.isObject(i)) {
                        e.preventDefault();
                        t.stop();
                    }
                }
                _handleDelete(t) {
                    const e = this.editor.model.document;
                    const n = e.selection;
                    if (!this.editor.model.canEditAt(n)) return;
                    if (!n.isCollapsed) return;
                    const o = this._getObjectElementNextToSelection(t);
                    if (o) {
                        this.editor.model.change((t)=>{
                            let e = n.anchor.parent;
                            while(e.isEmpty){
                                const n = e;
                                e = n.parent;
                                t.remove(n);
                            }
                            this._setSelectionOverElement(o);
                        });
                        return true;
                    }
                }
                _setSelectionOverElement(t) {
                    this.editor.model.change((e)=>{
                        e.setSelection(e.createRangeOn(t));
                    });
                }
                _getObjectElementNextToSelection(t) {
                    const e = this.editor.model;
                    const n = e.schema;
                    const o = e.document.selection;
                    const i = e.createSelection(o);
                    e.modifySelection(i, {
                        direction: t ? "forward" : "backward"
                    });
                    if (i.isEqual(o)) return null;
                    const r = t ? i.focus.nodeBefore : i.focus.nodeAfter;
                    if (!!r && n.isObject(r)) return r;
                    return null;
                }
                _clearPreviouslySelectedWidgets(t) {
                    for (const e of this._previouslySelected)t.removeClass(oP, e);
                    this._previouslySelected.clear();
                }
            }
            function GP(t) {
                let e = t;
                while(e){
                    if (e.is("editableElement") && !e.is("rootElement")) return true;
                    if (iP(e)) return false;
                    e = e.parent;
                }
                return false;
            }
            function UP(t, e) {
                if (!e) return false;
                return Array.from(t.getAncestors()).includes(e);
            }
            class KP extends null {
                constructor(){
                    super(...arguments);
                    this._toolbarDefinitions = new Map;
                }
                static get requires() {
                    return [
                        ContextualBalloon
                    ];
                }
                static get pluginName() {
                    return "WidgetToolbarRepository";
                }
                init() {
                    const t = this.editor;
                    if (t.plugins.has("BalloonToolbar")) {
                        const e = t.plugins.get("BalloonToolbar");
                        this.listenTo(e, "show", (e)=>{
                            if (YP(t.editing.view.document.selection)) e.stop();
                        }, {
                            priority: "high"
                        });
                    }
                    this._balloon = this.editor.plugins.get("ContextualBalloon");
                    this.on("change:isEnabled", ()=>{
                        this._updateToolbarsVisibility();
                    });
                    this.listenTo(t.ui, "update", ()=>{
                        this._updateToolbarsVisibility();
                    });
                    this.listenTo(t.ui.focusTracker, "change:isFocused", ()=>{
                        this._updateToolbarsVisibility();
                    }, {
                        priority: "low"
                    });
                }
                destroy() {
                    super.destroy();
                    for (const t of this._toolbarDefinitions.values())t.view.destroy();
                }
                register(t, { ariaLabel: e, items: n, getRelatedElement: o, balloonClassName: i = "ck-toolbar-container" }) {
                    if (!n.length) {
                        logWarning("widget-toolbar-no-items", {
                            toolbarId: t
                        });
                        return;
                    }
                    const r = this.editor;
                    const s = r.t;
                    const a = new ToolbarView(r.locale);
                    a.ariaLabel = e || s("Widget toolbar");
                    if (this._toolbarDefinitions.has(t)) throw new CKEditorError("widget-toolbar-duplicated", this, {
                        toolbarId: t
                    });
                    const c = {
                        view: a,
                        getRelatedElement: o,
                        balloonClassName: i,
                        itemsConfig: n,
                        initialized: false
                    };
                    r.ui.addToolbar(a, {
                        isContextual: true,
                        beforeFocus: ()=>{
                            const t = o(r.editing.view.document.selection);
                            if (t) this._showToolbar(c, t);
                        },
                        afterBlur: ()=>{
                            this._hideToolbar(c);
                        }
                    });
                    this._toolbarDefinitions.set(t, c);
                }
                _updateToolbarsVisibility() {
                    let t = 0;
                    let e = null;
                    let n = null;
                    for (const o of this._toolbarDefinitions.values()){
                        const i = o.getRelatedElement(this.editor.editing.view.document.selection);
                        if (!this.isEnabled || !i) {
                            if (this._isToolbarInBalloon(o)) this._hideToolbar(o);
                        } else if (!this.editor.ui.focusTracker.isFocused) {
                            if (this._isToolbarVisible(o)) this._hideToolbar(o);
                        } else {
                            const r = i.getAncestors().length;
                            if (r > t) {
                                t = r;
                                e = i;
                                n = o;
                            }
                        }
                    }
                    if (n) this._showToolbar(n, e);
                }
                _hideToolbar(t) {
                    this._balloon.remove(t.view);
                    this.stopListening(this._balloon, "change:visibleView");
                }
                _showToolbar(t, e) {
                    if (this._isToolbarVisible(t)) ZP(this.editor, e);
                    else if (!this._isToolbarInBalloon(t)) {
                        if (!t.initialized) {
                            t.initialized = true;
                            t.view.fillFromConfig(t.itemsConfig, this.editor.ui.componentFactory);
                        }
                        this._balloon.add({
                            view: t.view,
                            position: JP(this.editor, e),
                            balloonClassName: t.balloonClassName
                        });
                        this.listenTo(this._balloon, "change:visibleView", ()=>{
                            for (const t of this._toolbarDefinitions.values())if (this._isToolbarVisible(t)) {
                                const e = t.getRelatedElement(this.editor.editing.view.document.selection);
                                ZP(this.editor, e);
                            }
                        });
                    }
                }
                _isToolbarVisible(t) {
                    return this._balloon.visibleView === t.view;
                }
                _isToolbarInBalloon(t) {
                    return this._balloon.hasView(t.view);
                }
            }
            function ZP(t, e) {
                const n = t.plugins.get("ContextualBalloon");
                const o = JP(t, e);
                n.updatePosition(o);
            }
            function JP(t, e) {
                const n = t.editing.view;
                const o = BalloonPanelView.defaultPositions;
                return {
                    target: n.domConverter.mapViewToDom(e),
                    positions: [
                        o.northArrowSouth,
                        o.northArrowSouthWest,
                        o.northArrowSouthEast,
                        o.southArrowNorth,
                        o.southArrowNorthWest,
                        o.southArrowNorthEast,
                        o.viewportStickyNorth
                    ]
                };
            }
            function YP(t) {
                const e = t.getSelectedElement();
                return !!(e && isWidget(e));
            }
            class QP extends ht() {
                constructor(t){
                    super();
                    this.set("activeHandlePosition", null);
                    this.set("proposedWidthPercents", null);
                    this.set("proposedWidth", null);
                    this.set("proposedHeight", null);
                    this.set("proposedHandleHostWidth", null);
                    this.set("proposedHandleHostHeight", null);
                    this._options = t;
                    this._referenceCoordinates = null;
                }
                get originalWidth() {
                    return this._originalWidth;
                }
                get originalHeight() {
                    return this._originalHeight;
                }
                get originalWidthPercents() {
                    return this._originalWidthPercents;
                }
                get aspectRatio() {
                    return this._aspectRatio;
                }
                begin(t, e, n) {
                    const o = new dc(e);
                    this.activeHandlePosition = nI(t);
                    this._referenceCoordinates = tI(e, oI(this.activeHandlePosition));
                    this._originalWidth = o.width;
                    this._originalHeight = o.height;
                    this._aspectRatio = o.width / o.height;
                    const i = n.style.width;
                    if (i && i.match(/^\d+(\.\d*)?%$/)) this._originalWidthPercents = parseFloat(i);
                    else this._originalWidthPercents = XP(n, o);
                }
                update(t) {
                    this.proposedWidth = t.width;
                    this.proposedHeight = t.height;
                    this.proposedWidthPercents = t.widthPercents;
                    this.proposedHandleHostWidth = t.handleHostWidth;
                    this.proposedHandleHostHeight = t.handleHostHeight;
                }
            }
            function XP(t, e) {
                const n = t.parentElement;
                let o = parseFloat(n.ownerDocument.defaultView.getComputedStyle(n).width);
                const i = 5;
                let r = 0;
                let s = n;
                while(isNaN(o)){
                    s = s.parentElement;
                    if (++r > i) return 0;
                    o = parseFloat(n.ownerDocument.defaultView.getComputedStyle(s).width);
                }
                return e.width / o * 100;
            }
            function tI(t, e) {
                const n = new dc(t);
                const o = e.split("-");
                const i = {
                    x: o[1] == "right" ? n.right : n.left,
                    y: o[0] == "bottom" ? n.bottom : n.top
                };
                i.x += t.ownerDocument.defaultView.scrollX;
                i.y += t.ownerDocument.defaultView.scrollY;
                return i;
            }
            function eI(t) {
                return `ck-widget__resizer__handle-${t}`;
            }
            function nI(t) {
                const e = [
                    "top-left",
                    "top-right",
                    "bottom-right",
                    "bottom-left"
                ];
                for (const n of e){
                    if (t.classList.contains(eI(n))) return n;
                }
            }
            function oI(t) {
                const e = t.split("-");
                const n = {
                    top: "bottom",
                    bottom: "top",
                    left: "right",
                    right: "left"
                };
                return `${n[e[0]]}-${n[e[1]]}`;
            }
            class iI extends zl {
                constructor(){
                    super();
                    const t = this.bindTemplate;
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-size-view",
                                t.to("_viewPosition", (t)=>t ? `ck-orientation-${t}` : "")
                            ],
                            style: {
                                display: t.if("_isVisible", "none", (t)=>!t)
                            }
                        },
                        children: [
                            {
                                text: t.to("_label")
                            }
                        ]
                    });
                }
                _bindToState(t, e) {
                    this.bind("_isVisible").to(e, "proposedWidth", e, "proposedHeight", (t, e)=>t !== null && e !== null);
                    this.bind("_label").to(e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", e, "proposedWidthPercents", (e, n, o)=>{
                        if (t.unit === "px") return `${e}\xd7${n}`;
                        else return `${o}%`;
                    });
                    this.bind("_viewPosition").to(e, "activeHandlePosition", e, "proposedHandleHostWidth", e, "proposedHandleHostHeight", (t, e, n)=>e < 50 || n < 50 ? "above-center" : t);
                }
                _dismiss() {
                    this.unbind();
                    this._isVisible = false;
                }
            }
            class rI extends ht() {
                constructor(t){
                    super();
                    this._viewResizerWrapper = null;
                    this._options = t;
                    this.set("isEnabled", true);
                    this.set("isSelected", false);
                    this.bind("isVisible").to(this, "isEnabled", this, "isSelected", (t, e)=>t && e);
                    this.decorate("begin");
                    this.decorate("cancel");
                    this.decorate("commit");
                    this.decorate("updateSize");
                    this.on("commit", (t)=>{
                        if (!this.state.proposedWidth && !this.state.proposedWidthPercents) {
                            this._cleanup();
                            t.stop();
                        }
                    }, {
                        priority: "high"
                    });
                }
                get state() {
                    return this._state;
                }
                show() {
                    const t = this._options.editor.editing.view;
                    t.change((t)=>{
                        t.removeClass("ck-hidden", this._viewResizerWrapper);
                    });
                }
                hide() {
                    const t = this._options.editor.editing.view;
                    t.change((t)=>{
                        t.addClass("ck-hidden", this._viewResizerWrapper);
                    });
                }
                attach() {
                    const t = this;
                    const e = this._options.viewElement;
                    const n = this._options.editor.editing.view;
                    n.change((n)=>{
                        const o = n.createUIElement("div", {
                            class: "ck ck-reset_all ck-widget__resizer"
                        }, function(e) {
                            const n = this.toDomElement(e);
                            t._appendHandles(n);
                            t._appendSizeUI(n);
                            return n;
                        });
                        n.insert(n.createPositionAt(e, "end"), o);
                        n.addClass("ck-widget_with-resizer", e);
                        this._viewResizerWrapper = o;
                        if (!this.isVisible) this.hide();
                    });
                    this.on("change:isVisible", ()=>{
                        if (this.isVisible) {
                            this.show();
                            this.redraw();
                        } else this.hide();
                    });
                }
                begin(t) {
                    this._state = new QP(this._options);
                    this._sizeView._bindToState(this._options, this.state);
                    this._initialViewWidth = this._options.viewElement.getStyle("width");
                    this.state.begin(t, this._getHandleHost(), this._getResizeHost());
                }
                updateSize(t) {
                    const e = this._proposeNewSize(t);
                    const n = this._options.editor.editing.view;
                    n.change((t)=>{
                        const n = this._options.unit || "%";
                        const o = (n === "%" ? e.widthPercents : e.width) + n;
                        t.setStyle("width", o, this._options.viewElement);
                    });
                    const o = this._getHandleHost();
                    const i = new dc(o);
                    const r = Math.round(i.width);
                    const s = Math.round(i.height);
                    const a = new dc(o);
                    e.width = Math.round(a.width);
                    e.height = Math.round(a.height);
                    this.redraw(i);
                    this.state.update({
                        ...e,
                        handleHostWidth: r,
                        handleHostHeight: s
                    });
                }
                commit() {
                    const t = this._options.unit || "%";
                    const e = (t === "%" ? this.state.proposedWidthPercents : this.state.proposedWidth) + t;
                    this._options.editor.editing.view.change(()=>{
                        this._cleanup();
                        this._options.onCommit(e);
                    });
                }
                cancel() {
                    this._cleanup();
                }
                destroy() {
                    this.cancel();
                }
                redraw(t) {
                    const e = this._domResizerWrapper;
                    if (!cI(e)) return;
                    const n = e.parentElement;
                    const o = this._getHandleHost();
                    const i = this._viewResizerWrapper;
                    const r = [
                        i.getStyle("width"),
                        i.getStyle("height"),
                        i.getStyle("left"),
                        i.getStyle("top")
                    ];
                    let s;
                    if (n.isSameNode(o)) {
                        const e = t || new dc(o);
                        s = [
                            e.width + "px",
                            e.height + "px",
                            undefined,
                            undefined
                        ];
                    } else s = [
                        o.offsetWidth + "px",
                        o.offsetHeight + "px",
                        o.offsetLeft + "px",
                        o.offsetTop + "px"
                    ];
                    if (xt(r, s) !== "same") this._options.editor.editing.view.change((t)=>{
                        t.setStyle({
                            width: s[0],
                            height: s[1],
                            left: s[2],
                            top: s[3]
                        }, i);
                    });
                }
                containsHandle(t) {
                    return this._domResizerWrapper.contains(t);
                }
                static isResizeHandle(t) {
                    return t.classList.contains("ck-widget__resizer__handle");
                }
                _cleanup() {
                    this._sizeView._dismiss();
                    const t = this._options.editor.editing.view;
                    t.change((t)=>{
                        t.setStyle("width", this._initialViewWidth, this._options.viewElement);
                    });
                }
                _proposeNewSize(t) {
                    const e = this.state;
                    const n = aI(t);
                    const o = this._options.isCentered ? this._options.isCentered(this) : true;
                    const i = {
                        x: e._referenceCoordinates.x - (n.x + e.originalWidth),
                        y: n.y - e.originalHeight - e._referenceCoordinates.y
                    };
                    if (o && e.activeHandlePosition.endsWith("-right")) i.x = n.x - (e._referenceCoordinates.x + e.originalWidth);
                    if (o) i.x *= 2;
                    let r = Math.abs(e.originalWidth + i.x);
                    let s = Math.abs(e.originalHeight + i.y);
                    const a = r / e.aspectRatio > s ? "width" : "height";
                    if (a == "width") s = r / e.aspectRatio;
                    else r = s * e.aspectRatio;
                    return {
                        width: Math.round(r),
                        height: Math.round(s),
                        widthPercents: Math.min(Math.round(e.originalWidthPercents / e.originalWidth * r * 100) / 100, 100)
                    };
                }
                _getResizeHost() {
                    const t = this._domResizerWrapper.parentElement;
                    return this._options.getResizeHost(t);
                }
                _getHandleHost() {
                    const t = this._domResizerWrapper.parentElement;
                    return this._options.getHandleHost(t);
                }
                get _domResizerWrapper() {
                    return this._options.editor.editing.view.domConverter.mapViewToDom(this._viewResizerWrapper);
                }
                _appendHandles(t) {
                    const e = [
                        "top-left",
                        "top-right",
                        "bottom-right",
                        "bottom-left"
                    ];
                    for (const n of e)t.appendChild(new Fl({
                        tag: "div",
                        attributes: {
                            class: `ck-widget__resizer__handle ${sI(n)}`
                        }
                    }).render());
                }
                _appendSizeUI(t) {
                    this._sizeView = new iI;
                    this._sizeView.render();
                    t.appendChild(this._sizeView.element);
                }
            }
            function sI(t) {
                return `ck-widget__resizer__handle-${t}`;
            }
            function aI(t) {
                return {
                    x: t.pageX,
                    y: t.pageY
                };
            }
            function cI(t) {
                return t && t.ownerDocument && t.ownerDocument.contains(t);
            }
            var lI = n(4875);
            var dI = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            dI.insert = "head";
            dI.singleton = true;
            var uI = Rl()(lI.Z, dI);
            const hI = lI.Z.locals || {};
            class fI extends null {
                constructor(){
                    super(...arguments);
                    this._resizers = new Map;
                }
                static get pluginName() {
                    return "WidgetResize";
                }
                init() {
                    const t = this.editor.editing;
                    const e = $parcel$global.window.document;
                    this.set("selectedResizer", null);
                    this.set("_activeResizer", null);
                    t.view.addObserver(MouseObserver);
                    this._observer = new (DomEmitterMixin());
                    this.listenTo(t.view.document, "mousedown", this._mouseDownListener.bind(this), {
                        priority: "high"
                    });
                    this._observer.listenTo(e, "mousemove", this._mouseMoveListener.bind(this));
                    this._observer.listenTo(e, "mouseup", this._mouseUpListener.bind(this));
                    this._redrawSelectedResizerThrottled = throttle(()=>this.redrawSelectedResizer(), 200);
                    this.editor.ui.on("update", this._redrawSelectedResizerThrottled);
                    this.editor.model.document.on("change", ()=>{
                        for (const [t, e] of this._resizers)if (!t.isAttached()) {
                            this._resizers.delete(t);
                            e.destroy();
                        }
                    }, {
                        priority: "lowest"
                    });
                    this._observer.listenTo($parcel$global.window, "resize", this._redrawSelectedResizerThrottled);
                    const n = this.editor.editing.view.document.selection;
                    n.on("change", ()=>{
                        const t = n.getSelectedElement();
                        const e = this.getResizerByViewElement(t) || null;
                        if (e) this.select(e);
                        else this.deselect();
                    });
                }
                redrawSelectedResizer() {
                    if (this.selectedResizer && this.selectedResizer.isVisible) this.selectedResizer.redraw();
                }
                destroy() {
                    super.destroy();
                    this._observer.stopListening();
                    for (const t of this._resizers.values())t.destroy();
                    this._redrawSelectedResizerThrottled.cancel();
                }
                select(t) {
                    this.deselect();
                    this.selectedResizer = t;
                    this.selectedResizer.isSelected = true;
                }
                deselect() {
                    if (this.selectedResizer) this.selectedResizer.isSelected = false;
                    this.selectedResizer = null;
                }
                attachTo(t) {
                    const e = new Resizer(t);
                    const n = this.editor.plugins;
                    e.attach();
                    if (n.has("WidgetToolbarRepository")) {
                        const t = n.get("WidgetToolbarRepository");
                        e.on("begin", ()=>{
                            t.forceDisabled("resize");
                        }, {
                            priority: "lowest"
                        });
                        e.on("cancel", ()=>{
                            t.clearForceDisabled("resize");
                        }, {
                            priority: "highest"
                        });
                        e.on("commit", ()=>{
                            t.clearForceDisabled("resize");
                        }, {
                            priority: "highest"
                        });
                    }
                    this._resizers.set(t.viewElement, e);
                    const o = this.editor.editing.view.document.selection;
                    const i = o.getSelectedElement();
                    if (this.getResizerByViewElement(i) == e) this.select(e);
                    return e;
                }
                getResizerByViewElement(t) {
                    return this._resizers.get(t);
                }
                _getResizerByHandle(t) {
                    for (const e of this._resizers.values()){
                        if (e.containsHandle(t)) return e;
                    }
                }
                _mouseDownListener(t, e) {
                    const n = e.domTarget;
                    if (!Resizer.isResizeHandle(n)) return;
                    this._activeResizer = this._getResizerByHandle(n) || null;
                    if (this._activeResizer) {
                        this._activeResizer.begin(n);
                        t.stop();
                        e.preventDefault();
                    }
                }
                _mouseMoveListener(t, e) {
                    if (this._activeResizer) this._activeResizer.updateSize(e);
                }
                _mouseUpListener() {
                    if (this._activeResizer) {
                        this._activeResizer.commit();
                        this._activeResizer = null;
                    }
                }
            }
            const pI = wc("px");
            class gI extends zl {
                constructor(){
                    super();
                    const t = this.bindTemplate;
                    this.set({
                        isVisible: false,
                        left: null,
                        top: null,
                        width: null
                    });
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-clipboard-drop-target-line",
                                t.if("isVisible", "ck-hidden", (t)=>!t)
                            ],
                            style: {
                                left: t.to("left", (t)=>pI(t)),
                                top: t.to("top", (t)=>pI(t)),
                                width: t.to("width", (t)=>pI(t))
                            }
                        }
                    });
                }
            }
            class mI extends Pu {
                constructor(){
                    super(...arguments);
                    this.removeDropMarkerDelayed = _l(()=>this.removeDropMarker(), 40);
                    this._updateDropMarkerThrottled = xE((t)=>this._updateDropMarker(t), 40);
                    this._reconvertMarkerThrottled = xE(()=>{
                        if (this.editor.model.markers.has("drop-target")) this.editor.editing.reconvertMarker("drop-target");
                    }, 0);
                    this._dropTargetLineView = new gI;
                    this._domEmitter = new (Ja());
                    this._scrollables = new Map;
                }
                static get pluginName() {
                    return "DragDropTarget";
                }
                init() {
                    this._setupDropMarker();
                }
                destroy() {
                    this._domEmitter.stopListening();
                    for (const { resizeObserver: t } of this._scrollables.values())t.destroy();
                    this._updateDropMarkerThrottled.cancel();
                    this.removeDropMarkerDelayed.cancel();
                    this._reconvertMarkerThrottled.cancel();
                    return super.destroy();
                }
                updateDropMarker(t, e, n, o, i) {
                    this.removeDropMarkerDelayed.cancel();
                    const r = kI(this.editor, t, e, n, o, i);
                    if (r) this._updateDropMarkerThrottled(r);
                }
                getFinalDropRange(t, e, n, o, i) {
                    const r = kI(this.editor, t, e, n, o, i);
                    this.removeDropMarker();
                    return r;
                }
                removeDropMarker() {
                    const t = this.editor.model;
                    this.removeDropMarkerDelayed.cancel();
                    this._updateDropMarkerThrottled.cancel();
                    this._dropTargetLineView.isVisible = false;
                    if (t.markers.has("drop-target")) t.change((t)=>{
                        t.removeMarker("drop-target");
                    });
                }
                _setupDropMarker() {
                    const t = this.editor;
                    t.ui.view.body.add(this._dropTargetLineView);
                    t.conversion.for("editingDowncast").markerToHighlight({
                        model: "drop-target",
                        view: {
                            classes: [
                                "ck-clipboard-drop-target-range"
                            ]
                        }
                    });
                    t.conversion.for("editingDowncast").markerToElement({
                        model: "drop-target",
                        view: (e, { writer: n })=>{
                            if (t.model.schema.checkChild(e.markerRange.start, "$text")) {
                                this._dropTargetLineView.isVisible = false;
                                return this._createDropTargetPosition(n);
                            } else if (e.markerRange.isCollapsed) this._updateDropTargetLine(e.markerRange);
                            else this._dropTargetLineView.isVisible = false;
                        }
                    });
                }
                _updateDropMarker(t) {
                    const e = this.editor;
                    const n = e.model.markers;
                    e.model.change((e)=>{
                        if (n.has("drop-target")) {
                            if (!n.get("drop-target").getRange().isEqual(t)) e.updateMarker("drop-target", {
                                range: t
                            });
                        } else e.addMarker("drop-target", {
                            range: t,
                            usingOperation: false,
                            affectsData: false
                        });
                    });
                }
                _createDropTargetPosition(t) {
                    return t.createUIElement("span", {
                        class: "ck ck-clipboard-drop-target-position"
                    }, function(t) {
                        const e = this.toDomElement(t);
                        e.append("\u2060", t.createElement("span"), "\u2060");
                        return e;
                    });
                }
                _updateDropTargetLine(t) {
                    const e = this.editor.editing;
                    const n = t.start.nodeBefore;
                    const o = t.start.nodeAfter;
                    const i = t.start.parent;
                    const r = n ? e.mapper.toViewElement(n) : null;
                    const s = r ? e.view.domConverter.mapViewToDom(r) : null;
                    const a = o ? e.mapper.toViewElement(o) : null;
                    const c = a ? e.view.domConverter.mapViewToDom(a) : null;
                    const l = e.mapper.toViewElement(i);
                    const d = e.view.domConverter.mapViewToDom(l);
                    const u = this._getScrollableRect(l);
                    const { scrollX: h, scrollY: f } = ec.window;
                    const p = s ? new dc(s) : null;
                    const g = c ? new dc(c) : null;
                    const m = new dc(d).excludeScrollbarsAndBorders();
                    const k = p ? p.bottom : m.top;
                    const b = g ? g.top : m.bottom;
                    const w = ec.window.getComputedStyle(d);
                    const _ = k <= b ? (k + b) / 2 : b;
                    if (u.top < _ && _ < u.bottom) {
                        const t = m.left + parseFloat(w.paddingLeft);
                        const e = m.right - parseFloat(w.paddingRight);
                        const n = Math.max(t + h, u.left);
                        const o = Math.min(e + h, u.right);
                        this._dropTargetLineView.set({
                            isVisible: true,
                            left: n,
                            top: _ + f,
                            width: o - n
                        });
                    } else this._dropTargetLineView.isVisible = false;
                }
                _getScrollableRect(t) {
                    const e = t.root.rootName;
                    let n;
                    if (this._scrollables.has(e)) n = this._scrollables.get(e).domElement;
                    else {
                        const o = this.editor.editing.view.domConverter.mapViewToDom(t);
                        n = vI(o);
                        this._domEmitter.listenTo(n, "scroll", this._reconvertMarkerThrottled, {
                            usePassive: true
                        });
                        const i = new kc(n, this._reconvertMarkerThrottled);
                        this._scrollables.set(e, {
                            domElement: n,
                            resizeObserver: i
                        });
                    }
                    return new dc(n).excludeScrollbarsAndBorders();
                }
            }
            function kI(t, e, n, o, i, r) {
                const s = t.model;
                const a = t.editing.mapper;
                const c = AI(t, e);
                let l = c;
                while(l){
                    if (!r) {
                        if (s.schema.checkChild(l, "$text")) {
                            const e = n ? n[0].start : null;
                            const r = e ? a.toModelPosition(e) : null;
                            if (r) {
                                if (s.schema.checkChild(r, "$text")) return s.createRange(r);
                                else if (e) return wI(t, AI(t, e.parent), o, i);
                            }
                        } else if (s.schema.isInline(l)) return wI(t, l, o, i);
                    }
                    if (s.schema.isBlock(l)) return wI(t, l, o, i);
                    else if (s.schema.checkChild(l, "$block")) {
                        const e = Array.from(l.getChildren()).filter((e)=>e.is("element") && !bI(t, e));
                        let n = 0;
                        let r = e.length;
                        if (r == 0) return s.createRange(s.createPositionAt(l, "end"));
                        while(n < r - 1){
                            const s = Math.floor((n + r) / 2);
                            const a = _I(t, e[s], o, i);
                            if (a == "before") r = s;
                            else n = s;
                        }
                        return wI(t, e[n], o, i);
                    }
                    l = l.parent;
                }
                return null;
            }
            function bI(t, e) {
                const n = t.editing.mapper;
                const o = t.editing.view.domConverter;
                const i = n.toViewElement(e);
                const r = o.mapViewToDom(i);
                return ec.window.getComputedStyle(r).float != "none";
            }
            function wI(t, e, n, o) {
                const i = t.model;
                return i.createRange(i.createPositionAt(e, _I(t, e, n, o)));
            }
            function _I(t, e, n, o) {
                const i = t.editing.mapper;
                const r = t.editing.view.domConverter;
                const s = i.toViewElement(e);
                const a = r.mapViewToDom(s);
                const c = new dc(a);
                if (t.model.schema.isInline(e)) return n < (c.left + c.right) / 2 ? "before" : "after";
                else return o < (c.top + c.bottom) / 2 ? "before" : "after";
            }
            function AI(t, e) {
                const n = t.editing.mapper;
                const o = t.editing.view;
                const i = n.toModelElement(e);
                if (i) return i;
                const r = o.createPositionBefore(e);
                const s = n.findMappedViewAncestor(r);
                return n.toModelElement(s);
            }
            function vI(t) {
                let e = t;
                do {
                    e = e.parentElement;
                    const t = ec.window.getComputedStyle(e).overflowY;
                    if (t == "auto" || t == "scroll") break;
                }while (e.tagName != "BODY");
                return e;
            }
            class CI extends Pu {
                constructor(){
                    super(...arguments);
                    this._isBlockDragging = false;
                    this._domEmitter = new (Ja());
                }
                static get pluginName() {
                    return "DragDropBlockToolbar";
                }
                init() {
                    const t = this.editor;
                    this.listenTo(t, "change:isReadOnly", (t, e, n)=>{
                        if (n) {
                            this.forceDisabled("readOnlyMode");
                            this._isBlockDragging = false;
                        } else this.clearForceDisabled("readOnlyMode");
                    });
                    if (c.isAndroid) this.forceDisabled("noAndroidSupport");
                    if (t.plugins.has("BlockToolbar")) {
                        const e = t.plugins.get("BlockToolbar");
                        const n = e.buttonView.element;
                        this._domEmitter.listenTo(n, "dragstart", (t, e)=>this._handleBlockDragStart(e));
                        this._domEmitter.listenTo(ec.document, "dragover", (t, e)=>this._handleBlockDragging(e));
                        this._domEmitter.listenTo(ec.document, "drop", (t, e)=>this._handleBlockDragging(e));
                        this._domEmitter.listenTo(ec.document, "dragend", ()=>this._handleBlockDragEnd(), {
                            useCapture: true
                        });
                        if (this.isEnabled) n.setAttribute("draggable", "true");
                        this.on("change:isEnabled", (t, e, o)=>{
                            n.setAttribute("draggable", o ? "true" : "false");
                        });
                    }
                }
                destroy() {
                    this._domEmitter.stopListening();
                    return super.destroy();
                }
                _handleBlockDragStart(t) {
                    if (!this.isEnabled) return;
                    const e = this.editor.model;
                    const n = e.document.selection;
                    const o = this.editor.editing.view;
                    const i = Array.from(n.getSelectedBlocks());
                    const r = e.createRange(e.createPositionBefore(i[0]), e.createPositionAfter(i[i.length - 1]));
                    e.change((t)=>t.setSelection(r));
                    this._isBlockDragging = true;
                    o.focus();
                    o.getObserver(WB).onDomEvent(t);
                }
                _handleBlockDragging(t) {
                    if (!this.isEnabled || !this._isBlockDragging) return;
                    const e = t.clientX + (this.editor.locale.contentLanguageDirection == "ltr" ? 100 : -100);
                    const n = t.clientY;
                    const o = document.elementFromPoint(e, n);
                    const i = this.editor.editing.view;
                    if (!o || !o.closest(".ck-editor__editable")) return;
                    i.getObserver(WB).onDomEvent({
                        ...t,
                        type: t.type,
                        dataTransfer: t.dataTransfer,
                        target: o,
                        clientX: e,
                        clientY: n,
                        preventDefault: ()=>t.preventDefault(),
                        stopPropagation: ()=>t.stopPropagation()
                    });
                }
                _handleBlockDragEnd() {
                    this._isBlockDragging = false;
                }
            }
            var yI = n(799);
            var xI = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            xI.insert = "head";
            xI.singleton = true;
            var EI = Rl()(yI.Z, xI);
            const DI = yI.Z.locals || {};
            class SI extends Pu {
                constructor(){
                    super(...arguments);
                    this._clearDraggableAttributesDelayed = _l(()=>this._clearDraggableAttributes(), 40);
                    this._blockMode = false;
                    this._domEmitter = new (Ja());
                }
                static get pluginName() {
                    return "DragDrop";
                }
                static get requires() {
                    return [
                        JB,
                        $P,
                        mI,
                        CI
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view;
                    this._draggedRange = null;
                    this._draggingUid = "";
                    this._draggableElement = null;
                    e.addObserver(WB);
                    e.addObserver(ev);
                    this._setupDragging();
                    this._setupContentInsertionIntegration();
                    this._setupClipboardInputIntegration();
                    this._setupDraggableAttributeHandling();
                    this.listenTo(t, "change:isReadOnly", (t, e, n)=>{
                        if (n) this.forceDisabled("readOnlyMode");
                        else this.clearForceDisabled("readOnlyMode");
                    });
                    this.on("change:isEnabled", (t, e, n)=>{
                        if (!n) this._finalizeDragging(false);
                    });
                    if (c.isAndroid) this.forceDisabled("noAndroidSupport");
                }
                destroy() {
                    if (this._draggedRange) {
                        this._draggedRange.detach();
                        this._draggedRange = null;
                    }
                    if (this._previewContainer) this._previewContainer.remove();
                    this._domEmitter.stopListening();
                    this._clearDraggableAttributesDelayed.cancel();
                    return super.destroy();
                }
                _setupDragging() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.editing.view;
                    const o = n.document;
                    const i = t.plugins.get(mI);
                    this.listenTo(o, "dragstart", (t, n)=>{
                        if (n.target && n.target.is("editableElement")) {
                            n.preventDefault();
                            return;
                        }
                        this._prepareDraggedRange(n.target);
                        if (!this._draggedRange) {
                            n.preventDefault();
                            return;
                        }
                        this._draggingUid = S();
                        n.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy";
                        n.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
                        const o = e.createSelection(this._draggedRange.toRange());
                        const i = this.editor.plugins.get("ClipboardPipeline");
                        i._fireOutputTransformationEvent(n.dataTransfer, o, "dragstart");
                        const { dataTransfer: r, domTarget: s, domEvent: a } = n;
                        const { clientX: c } = a;
                        this._updatePreview({
                            dataTransfer: r,
                            domTarget: s,
                            clientX: c
                        });
                        n.stopPropagation();
                        if (!this.isEnabled) {
                            this._draggedRange.detach();
                            this._draggedRange = null;
                            this._draggingUid = "";
                        }
                    }, {
                        priority: "low"
                    });
                    this.listenTo(o, "dragend", (t, e)=>{
                        this._finalizeDragging(!e.dataTransfer.isCanceled && e.dataTransfer.dropEffect == "move");
                    }, {
                        priority: "low"
                    });
                    this._domEmitter.listenTo(ec.document, "dragend", ()=>{
                        this._blockMode = false;
                    }, {
                        useCapture: true
                    });
                    this.listenTo(o, "dragenter", ()=>{
                        if (!this.isEnabled) return;
                        n.focus();
                    });
                    this.listenTo(o, "dragleave", ()=>{
                        i.removeDropMarkerDelayed();
                    });
                    this.listenTo(o, "dragging", (t, e)=>{
                        if (!this.isEnabled) {
                            e.dataTransfer.dropEffect = "none";
                            return;
                        }
                        const { clientX: n, clientY: o } = e.domEvent;
                        i.updateDropMarker(e.target, e.targetRanges, n, o, this._blockMode);
                        if (!this._draggedRange) e.dataTransfer.dropEffect = "copy";
                        if (!c.isGecko) {
                            if (e.dataTransfer.effectAllowed == "copy") e.dataTransfer.dropEffect = "copy";
                            else if ([
                                "all",
                                "copyMove"
                            ].includes(e.dataTransfer.effectAllowed)) e.dataTransfer.dropEffect = "move";
                        }
                        t.stop();
                    }, {
                        priority: "low"
                    });
                }
                _setupClipboardInputIntegration() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    const o = t.plugins.get(mI);
                    this.listenTo(n, "clipboardInput", (e, n)=>{
                        if (n.method != "drop") return;
                        const { clientX: i, clientY: r } = n.domEvent;
                        const s = o.getFinalDropRange(n.target, n.targetRanges, i, r, this._blockMode);
                        if (!s) {
                            this._finalizeDragging(false);
                            e.stop();
                            return;
                        }
                        if (this._draggedRange && this._draggingUid != n.dataTransfer.getData("application/ckeditor5-dragging-uid")) {
                            this._draggedRange.detach();
                            this._draggedRange = null;
                            this._draggingUid = "";
                        }
                        const a = TI(n.dataTransfer) == "move";
                        if (a && this._draggedRange && this._draggedRange.containsRange(s, true)) {
                            this._finalizeDragging(false);
                            e.stop();
                            return;
                        }
                        n.targetRanges = [
                            t.editing.mapper.toViewRange(s)
                        ];
                    }, {
                        priority: "high"
                    });
                }
                _setupContentInsertionIntegration() {
                    const t = this.editor.plugins.get(JB);
                    t.on("contentInsertion", (t, e)=>{
                        if (!this.isEnabled || e.method !== "drop") return;
                        const n = e.targetRanges.map((t)=>this.editor.editing.mapper.toModelRange(t));
                        this.editor.model.change((t)=>t.setSelection(n));
                    }, {
                        priority: "high"
                    });
                    t.on("contentInsertion", (t, e)=>{
                        if (!this.isEnabled || e.method !== "drop") return;
                        const n = TI(e.dataTransfer) == "move";
                        const o = !e.resultRange || !e.resultRange.isCollapsed;
                        this._finalizeDragging(o && n);
                    }, {
                        priority: "lowest"
                    });
                }
                _setupDraggableAttributeHandling() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    this.listenTo(n, "mousedown", (o, i)=>{
                        if (c.isAndroid || !i) return;
                        this._clearDraggableAttributesDelayed.cancel();
                        let r = BI(i.target);
                        if (c.isBlink && !t.isReadOnly && !r && !n.selection.isCollapsed) {
                            const t = n.selection.getSelectedElement();
                            if (!t || !iP(t)) r = n.selection.editableElement;
                        }
                        if (r) {
                            e.change((t)=>{
                                t.setAttribute("draggable", "true", r);
                            });
                            this._draggableElement = t.editing.mapper.toModelElement(r);
                        }
                    });
                    this.listenTo(n, "mouseup", ()=>{
                        if (!c.isAndroid) this._clearDraggableAttributesDelayed();
                    });
                }
                _clearDraggableAttributes() {
                    const t = this.editor.editing;
                    t.view.change((e)=>{
                        if (this._draggableElement && this._draggableElement.root.rootName != "$graveyard") e.removeAttribute("draggable", t.mapper.toViewElement(this._draggableElement));
                        this._draggableElement = null;
                    });
                }
                _finalizeDragging(t) {
                    const e = this.editor;
                    const n = e.model;
                    const o = e.plugins.get(mI);
                    o.removeDropMarker();
                    this._clearDraggableAttributes();
                    if (e.plugins.has("WidgetToolbarRepository")) {
                        const t = e.plugins.get("WidgetToolbarRepository");
                        t.clearForceDisabled("dragDrop");
                    }
                    this._draggingUid = "";
                    if (this._previewContainer) {
                        this._previewContainer.remove();
                        this._previewContainer = undefined;
                    }
                    if (!this._draggedRange) return;
                    if (t && this.isEnabled) n.change((t)=>{
                        const e = n.createSelection(this._draggedRange);
                        n.deleteContent(e, {
                            doNotAutoparagraph: true
                        });
                        const o = e.getFirstPosition().parent;
                        if (o.isEmpty && !n.schema.checkChild(o, "$text") && n.schema.checkChild(o, "paragraph")) t.insertElement("paragraph", o, 0);
                    });
                    this._draggedRange.detach();
                    this._draggedRange = null;
                }
                _prepareDraggedRange(t) {
                    const e = this.editor;
                    const n = e.model;
                    const o = n.document.selection;
                    const i = t ? BI(t) : null;
                    if (i) {
                        const t = e.editing.mapper.toModelElement(i);
                        this._draggedRange = ob.fromRange(n.createRangeOn(t));
                        this._blockMode = n.schema.isBlock(t);
                        if (e.plugins.has("WidgetToolbarRepository")) {
                            const t = e.plugins.get("WidgetToolbarRepository");
                            t.forceDisabled("dragDrop");
                        }
                        return;
                    }
                    if (o.isCollapsed && !o.getFirstPosition().parent.isEmpty) return;
                    const r = Array.from(o.getSelectedBlocks());
                    const s = o.getFirstRange();
                    if (r.length == 0) {
                        this._draggedRange = ob.fromRange(s);
                        return;
                    }
                    const a = PI(n, r);
                    if (r.length > 1) {
                        this._draggedRange = ob.fromRange(a);
                        this._blockMode = true;
                    } else if (r.length == 1) {
                        const t = s.start.isTouching(a.start) && s.end.isTouching(a.end);
                        this._draggedRange = ob.fromRange(t ? a : s);
                        this._blockMode = t;
                    }
                    n.change((t)=>t.setSelection(this._draggedRange.toRange()));
                }
                _updatePreview({ dataTransfer: t, domTarget: e, clientX: n }) {
                    const o = this.editor.editing.view;
                    const i = o.document.selection.editableElement;
                    const r = o.domConverter.mapViewToDom(i);
                    const s = ec.window.getComputedStyle(r);
                    if (!this._previewContainer) {
                        this._previewContainer = ne(ec.document, "div", {
                            style: "position: fixed; left: -999999px;"
                        });
                        ec.document.body.appendChild(this._previewContainer);
                    } else if (this._previewContainer.firstElementChild) this._previewContainer.removeChild(this._previewContainer.firstElementChild);
                    const a = new dc(r);
                    if (r.contains(e)) return;
                    const l = parseFloat(s.paddingLeft);
                    const d = ne(ec.document, "div");
                    d.className = "ck ck-content";
                    d.style.width = s.width;
                    d.style.paddingLeft = `${a.left - n + l}px`;
                    if (c.isiOS) d.style.backgroundColor = "white";
                    d.innerHTML = t.getData("text/html");
                    t.setDragImage(d, 0, 0);
                    this._previewContainer.appendChild(d);
                }
            }
            function TI(t) {
                if (c.isGecko) return t.dropEffect;
                return [
                    "all",
                    "copyMove"
                ].includes(t.effectAllowed) ? "move" : "copy";
            }
            function BI(t) {
                if (t.is("editableElement")) return null;
                if (t.hasClass("ck-widget__selection-handle")) return t.findAncestor(iP);
                if (iP(t)) return t;
                const e = t.findAncestor((t)=>iP(t) || t.is("editableElement"));
                if (iP(e)) return e;
                return null;
            }
            function PI(t, e) {
                const n = e[0];
                const o = e[e.length - 1];
                const i = n.getCommonAncestor(o);
                const r = t.createPositionBefore(n);
                const s = t.createPositionAfter(o);
                if (i && i.is("element") && !t.schema.isLimit(i)) {
                    const e = t.createRangeOn(i);
                    const n = r.isTouching(e.start);
                    const o = s.isTouching(e.end);
                    if (n && o) return PI(t, [
                        i
                    ]);
                }
                return t.createRange(r, s);
            }
            class II extends Pu {
                static get pluginName() {
                    return "PastePlainText";
                }
                static get requires() {
                    return [
                        JB
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.editing.view;
                    const o = n.document;
                    const i = e.document.selection;
                    let r = false;
                    n.addObserver(WB);
                    this.listenTo(o, "keydown", (t, e)=>{
                        r = e.shiftKey;
                    });
                    t.plugins.get(JB).on("contentInsertion", (t, n)=>{
                        if (!r && !RI(n.content, e.schema)) return;
                        e.change((t)=>{
                            const o = Array.from(i.getAttributes()).filter(([t])=>e.schema.getAttributeProperties(t).isFormatting);
                            if (!i.isCollapsed) e.deleteContent(i, {
                                doNotAutoparagraph: true
                            });
                            o.push(...i.getAttributes());
                            const r = t.createRangeIn(n.content);
                            for (const e of r.getItems())if (e.is("$textProxy")) t.setAttributes(o, e);
                        });
                    });
                }
            }
            function RI(t, e) {
                if (t.childCount > 1) return false;
                const n = t.getChild(0);
                if (e.isObject(n)) return false;
                return Array.from(n.getAttributeKeys()).length == 0;
            }
            class OI extends Pu {
                static get pluginName() {
                    return "Clipboard";
                }
                static get requires() {
                    return [
                        JB,
                        SI,
                        II
                    ];
                }
            }
            class VI extends Ru {
                constructor(t){
                    super(t);
                    this.affectsData = false;
                }
                execute() {
                    const t = this.editor.model;
                    const e = t.document.selection;
                    let n = t.schema.getLimitElement(e);
                    if (e.containsEntireContent(n) || !MI(t.schema, n)) do {
                        n = n.parent;
                        if (!n) return;
                    }while (!MI(t.schema, n));
                    t.change((t)=>{
                        t.setSelection(n, "in");
                    });
                }
            }
            function MI(t, e) {
                return t.isLimit(e) && (t.checkChild(e, "$text") || t.checkChild(e, "paragraph"));
            }
            const LI = Kc("Ctrl+A");
            class zI extends Pu {
                static get pluginName() {
                    return "SelectAllEditing";
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    t.commands.add("selectAll", new VI(t));
                    this.listenTo(n, "keydown", (e, n)=>{
                        if (Uc(n) === LI) {
                            t.execute("selectAll");
                            n.preventDefault();
                        }
                    });
                }
            }
            const NI = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>';
            class FI extends Pu {
                static get pluginName() {
                    return "SelectAllUI";
                }
                init() {
                    const t = this.editor;
                    t.ui.componentFactory.add("selectAll", (e)=>{
                        const n = t.commands.get("selectAll");
                        const o = new yd(e);
                        const i = e.t;
                        o.set({
                            label: i("Select all"),
                            icon: NI,
                            keystroke: "Ctrl+A",
                            tooltip: true
                        });
                        o.bind("isEnabled").to(n, "isEnabled");
                        this.listenTo(o, "execute", ()=>{
                            t.execute("selectAll");
                            t.editing.view.focus();
                        });
                        return o;
                    });
                }
            }
            class HI extends Pu {
                static get requires() {
                    return [
                        zI,
                        FI
                    ];
                }
                static get pluginName() {
                    return "SelectAll";
                }
            }
            class jI extends Ru {
                constructor(t){
                    super(t);
                    this._stack = [];
                    this._createdBatches = new WeakSet;
                    this.refresh();
                    this._isEnabledBasedOnSelection = false;
                    this.listenTo(t.data, "set", (t, e)=>{
                        e[1] = {
                            ...e[1]
                        };
                        const n = e[1];
                        if (!n.batchType) n.batchType = {
                            isUndoable: false
                        };
                    }, {
                        priority: "high"
                    });
                    this.listenTo(t.data, "set", (t, e)=>{
                        const n = e[1];
                        if (!n.batchType.isUndoable) this.clearStack();
                    });
                }
                refresh() {
                    this.isEnabled = this._stack.length > 0;
                }
                get createdBatches() {
                    return this._createdBatches;
                }
                addBatch(t) {
                    const e = this.editor.model.document.selection;
                    const n = {
                        ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
                        isBackward: e.isBackward
                    };
                    this._stack.push({
                        batch: t,
                        selection: n
                    });
                    this.refresh();
                }
                clearStack() {
                    this._stack = [];
                    this.refresh();
                }
                _restoreSelection(t, e, n) {
                    const o = this.editor.model;
                    const i = o.document;
                    const r = [];
                    const s = t.map((t)=>t.getTransformedByOperations(n));
                    const a = s.flat();
                    for (const t of s){
                        const e = t.filter((t)=>t.root != i.graveyard).filter((t)=>!WI(t, a));
                        if (!e.length) continue;
                        qI(e);
                        r.push(e[0]);
                    }
                    if (r.length) o.change((t)=>{
                        t.setSelection(r, {
                            backward: e
                        });
                    });
                }
                _undo(t, e) {
                    const n = this.editor.model;
                    const o = n.document;
                    this._createdBatches.add(e);
                    const i = t.operations.slice().filter((t)=>t.isDocumentOperation);
                    i.reverse();
                    for (const t of i){
                        const i = t.baseVersion + 1;
                        const r = Array.from(o.history.getOperations(i));
                        const s = W_([
                            t.getReversed()
                        ], r, {
                            useRelations: true,
                            document: this.editor.model.document,
                            padWithNoOps: false,
                            forceWeakRemove: true
                        });
                        const a = s.operationsA;
                        for (let i of a){
                            const r = i.affectedSelectable;
                            if (r && !n.canEditAt(r)) i = new R_(i.baseVersion);
                            e.addOperation(i);
                            n.applyOperation(i);
                            o.history.setOperationAsUndone(t, i);
                        }
                    }
                }
            }
            function qI(t) {
                t.sort((t, e)=>t.start.isBefore(e.start) ? -1 : 1);
                for(let e = 1; e < t.length; e++){
                    const n = t[e - 1];
                    const o = n.getJoined(t[e], true);
                    if (o) {
                        e--;
                        t.splice(e, 2, o);
                    }
                }
            }
            function WI(t, e) {
                return e.some((e)=>e !== t && e.containsRange(t, true));
            }
            class $I extends jI {
                execute(t = null) {
                    const e = t ? this._stack.findIndex((e)=>e.batch == t) : this._stack.length - 1;
                    const n = this._stack.splice(e, 1)[0];
                    const o = this.editor.model.createBatch({
                        isUndo: true
                    });
                    this.editor.model.enqueueChange(o, ()=>{
                        this._undo(n.batch, o);
                        const t = this.editor.model.document.history.getOperations(n.batch.baseVersion);
                        this._restoreSelection(n.selection.ranges, n.selection.isBackward, t);
                    });
                    this.fire("revert", n.batch, o);
                    this.refresh();
                }
            }
            class GI extends jI {
                execute() {
                    const t = this._stack.pop();
                    const e = this.editor.model.createBatch({
                        isUndo: true
                    });
                    this.editor.model.enqueueChange(e, ()=>{
                        const n = t.batch.operations[t.batch.operations.length - 1];
                        const o = n.baseVersion + 1;
                        const i = this.editor.model.document.history.getOperations(o);
                        this._restoreSelection(t.selection.ranges, t.selection.isBackward, i);
                        this._undo(t.batch, e);
                    });
                    this.refresh();
                }
            }
            class UI extends Pu {
                constructor(){
                    super(...arguments);
                    this._batchRegistry = new WeakSet;
                }
                static get pluginName() {
                    return "UndoEditing";
                }
                init() {
                    const t = this.editor;
                    this._undoCommand = new $I(t);
                    this._redoCommand = new GI(t);
                    t.commands.add("undo", this._undoCommand);
                    t.commands.add("redo", this._redoCommand);
                    this.listenTo(t.model, "applyOperation", (t, e)=>{
                        const n = e[0];
                        if (!n.isDocumentOperation) return;
                        const o = n.batch;
                        const i = this._redoCommand.createdBatches.has(o);
                        const r = this._undoCommand.createdBatches.has(o);
                        const s = this._batchRegistry.has(o);
                        if (s) return;
                        this._batchRegistry.add(o);
                        if (!o.isUndoable) return;
                        if (i) this._undoCommand.addBatch(o);
                        else if (!r) {
                            this._undoCommand.addBatch(o);
                            this._redoCommand.clearStack();
                        }
                    }, {
                        priority: "highest"
                    });
                    this.listenTo(this._undoCommand, "revert", (t, e, n)=>{
                        this._redoCommand.addBatch(n);
                    });
                    t.keystrokes.set("CTRL+Z", "undo");
                    t.keystrokes.set("CTRL+Y", "redo");
                    t.keystrokes.set("CTRL+SHIFT+Z", "redo");
                }
            }
            const KI = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>';
            const ZI = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
            class JI extends Pu {
                static get pluginName() {
                    return "UndoUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.locale;
                    const n = t.t;
                    const o = e.uiLanguageDirection == "ltr" ? KI : ZI;
                    const i = e.uiLanguageDirection == "ltr" ? ZI : KI;
                    this._addButton("undo", n("Undo"), "CTRL+Z", o);
                    this._addButton("redo", n("Redo"), "CTRL+Y", i);
                }
                _addButton(t, e, n, o) {
                    const i = this.editor;
                    i.ui.componentFactory.add(t, (r)=>{
                        const s = i.commands.get(t);
                        const a = new yd(r);
                        a.set({
                            label: e,
                            icon: o,
                            keystroke: n,
                            tooltip: true
                        });
                        a.bind("isEnabled").to(s, "isEnabled");
                        this.listenTo(a, "execute", ()=>{
                            i.execute(t);
                            i.editing.view.focus();
                        });
                        return a;
                    });
                }
            }
            class YI extends Pu {
                static get requires() {
                    return [
                        UI,
                        JI
                    ];
                }
                static get pluginName() {
                    return "Undo";
                }
            }
            class QI extends Pu {
                static get requires() {
                    return [
                        OI,
                        EB,
                        HI,
                        IB,
                        kT,
                        YI
                    ];
                }
                static get pluginName() {
                    return "Essentials";
                }
            }
            class XI extends Ru {
                constructor(t){
                    super(t);
                    this._isEnabledBasedOnSelection = false;
                }
                refresh() {
                    const t = this.editor.model;
                    const e = t.document;
                    const n = fl(e.selection.getSelectedBlocks());
                    this.value = !!n && n.is("element", "paragraph");
                    this.isEnabled = !!n && tR(n, t.schema);
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    const o = t.selection || n.selection;
                    if (!e.canEditAt(o)) return;
                    e.change((t)=>{
                        const n = o.getSelectedBlocks();
                        for (const o of n)if (!o.is("element", "paragraph") && tR(o, e.schema)) t.rename(o, "paragraph");
                    });
                }
            }
            function tR(t, e) {
                return e.checkChild(t.parent, "paragraph") && !e.isObject(t);
            }
            class eR extends Ru {
                constructor(t){
                    super(t);
                    this._isEnabledBasedOnSelection = false;
                }
                execute(t) {
                    const e = this.editor.model;
                    const n = t.attributes;
                    let o = t.position;
                    if (!e.canEditAt(o)) return;
                    e.change((t)=>{
                        o = this._findPositionToInsertParagraph(o, t);
                        if (!o) return;
                        const i = t.createElement("paragraph");
                        if (n) e.schema.setAllowedAttributes(i, n, t);
                        e.insertContent(i, o);
                        t.setSelection(i, "in");
                    });
                }
                _findPositionToInsertParagraph(t, e) {
                    const n = this.editor.model;
                    if (n.schema.checkChild(t, "paragraph")) return t;
                    const o = n.schema.findAllowedParent(t, "paragraph");
                    if (!o) return null;
                    const i = t.parent;
                    const r = n.schema.checkChild(i, "$text");
                    if (i.isEmpty || r && t.isAtEnd) return n.createPositionAfter(i);
                    if (!i.isEmpty && r && t.isAtStart) return n.createPositionBefore(i);
                    return e.split(t, o).position;
                }
            }
            class nR extends Pu {
                static get pluginName() {
                    return "Paragraph";
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    t.commands.add("paragraph", new XI(t));
                    t.commands.add("insertParagraph", new eR(t));
                    e.schema.register("paragraph", {
                        inheritAllFrom: "$block"
                    });
                    t.conversion.elementToElement({
                        model: "paragraph",
                        view: "p"
                    });
                    t.conversion.for("upcast").elementToElement({
                        model: (t, { writer: e })=>{
                            if (!nR.paragraphLikeElements.has(t.name)) return null;
                            if (t.isEmpty) return null;
                            return e.createElement("paragraph");
                        },
                        view: /.+/,
                        converterPriority: "low"
                    });
                }
            }
            nR.paragraphLikeElements = new Set([
                "blockquote",
                "dd",
                "div",
                "dt",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6",
                "li",
                "p",
                "td",
                "th"
            ]);
            const oR = FC.paragraph;
            class iR extends null {
                static get requires() {
                    return [
                        Paragraph
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add("paragraph", (n)=>{
                        const o = new ButtonView(n);
                        const i = t.commands.get("paragraph");
                        o.label = e("Paragraph");
                        o.icon = oR;
                        o.tooltip = true;
                        o.isToggleable = true;
                        o.bind("isEnabled").to(i);
                        o.bind("isOn").to(i, "value");
                        o.on("execute", ()=>{
                            t.execute("paragraph");
                        });
                        return o;
                    });
                }
            }
            class rR extends Ru {
                constructor(t, e){
                    super(t);
                    this.modelElements = e;
                }
                refresh() {
                    const t = fl(this.editor.model.document.selection.getSelectedBlocks());
                    this.value = !!t && this.modelElements.includes(t.name) && t.name;
                    this.isEnabled = !!t && this.modelElements.some((e)=>sR(t, e, this.editor.model.schema));
                }
                execute(t) {
                    const e = this.editor.model;
                    const n = e.document;
                    const o = t.value;
                    e.change((t)=>{
                        const i = Array.from(n.selection.getSelectedBlocks()).filter((t)=>sR(t, o, e.schema));
                        for (const e of i)if (!e.is("element", o)) t.rename(e, o);
                    });
                }
            }
            function sR(t, e, n) {
                return n.checkChild(t.parent, e) && !n.isObject(t);
            }
            const aR = "paragraph";
            class cR extends Pu {
                static get pluginName() {
                    return "HeadingEditing";
                }
                constructor(t){
                    super(t);
                    t.config.define("heading", {
                        options: [
                            {
                                model: "paragraph",
                                title: "Paragraph",
                                class: "ck-heading_paragraph"
                            },
                            {
                                model: "heading1",
                                view: "h2",
                                title: "Heading 1",
                                class: "ck-heading_heading1"
                            },
                            {
                                model: "heading2",
                                view: "h3",
                                title: "Heading 2",
                                class: "ck-heading_heading2"
                            },
                            {
                                model: "heading3",
                                view: "h4",
                                title: "Heading 3",
                                class: "ck-heading_heading3"
                            }
                        ]
                    });
                }
                static get requires() {
                    return [
                        nR
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.config.get("heading.options");
                    const n = [];
                    for (const o of e){
                        if (o.model === "paragraph") continue;
                        t.model.schema.register(o.model, {
                            inheritAllFrom: "$block"
                        });
                        t.conversion.elementToElement(o);
                        n.push(o.model);
                    }
                    this._addDefaultH1Conversion(t);
                    t.commands.add("heading", new rR(t, n));
                }
                afterInit() {
                    const t = this.editor;
                    const e = t.commands.get("enter");
                    const n = t.config.get("heading.options");
                    if (e) this.listenTo(e, "afterExecute", (e, o)=>{
                        const i = t.model.document.selection.getFirstPosition().parent;
                        const r = n.some((t)=>i.is("element", t.model));
                        if (r && !i.is("element", aR) && i.childCount === 0) o.writer.rename(i, aR);
                    });
                }
                _addDefaultH1Conversion(t) {
                    t.conversion.for("upcast").elementToElement({
                        model: "heading1",
                        view: "h1",
                        converterPriority: B.low + 1
                    });
                }
            }
            function lR(t) {
                const e = t.t;
                const n = {
                    Paragraph: e("Paragraph"),
                    "Heading 1": e("Heading 1"),
                    "Heading 2": e("Heading 2"),
                    "Heading 3": e("Heading 3"),
                    "Heading 4": e("Heading 4"),
                    "Heading 5": e("Heading 5"),
                    "Heading 6": e("Heading 6")
                };
                return t.config.get("heading.options").map((t)=>{
                    const e = n[t.title];
                    if (e && e != t.title) t.title = e;
                    return t;
                });
            }
            var dR = n(4249);
            var uR = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            uR.insert = "head";
            uR.singleton = true;
            var hR = Rl()(dR.Z, uR);
            const fR = dR.Z.locals || {};
            class pR extends Pu {
                static get pluginName() {
                    return "HeadingUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    const n = lR(t);
                    const o = e("Choose heading");
                    const i = e("Heading");
                    t.ui.componentFactory.add("heading", (e)=>{
                        const r = {};
                        const s = new hl;
                        const a = t.commands.get("heading");
                        const c = t.commands.get("paragraph");
                        const l = [
                            a
                        ];
                        for (const t of n){
                            const e = {
                                type: "button",
                                model: new nD({
                                    label: t.title,
                                    class: t.class,
                                    role: "menuitemradio",
                                    withText: true
                                })
                            };
                            if (t.model === "paragraph") {
                                e.model.bind("isOn").to(c, "value");
                                e.model.set("commandName", "paragraph");
                                l.push(c);
                            } else {
                                e.model.bind("isOn").to(a, "value", (e)=>e === t.model);
                                e.model.set({
                                    commandName: "heading",
                                    commandValue: t.model
                                });
                            }
                            s.add(e);
                            r[t.model] = t.title;
                        }
                        const d = by(e);
                        Ay(d, s, {
                            ariaLabel: i,
                            role: "menu"
                        });
                        d.buttonView.set({
                            ariaLabel: i,
                            ariaLabelledBy: undefined,
                            isOn: false,
                            withText: true,
                            tooltip: i
                        });
                        d.extendTemplate({
                            attributes: {
                                class: [
                                    "ck-heading-dropdown"
                                ]
                            }
                        });
                        d.bind("isEnabled").toMany(l, "isEnabled", (...t)=>t.some((t)=>t));
                        d.buttonView.bind("label").to(a, "value", c, "value", (t, e)=>{
                            const n = t || e && "paragraph";
                            if (typeof n === "boolean") return o;
                            if (!r[n]) return o;
                            return r[n];
                        });
                        this.listenTo(d, "execute", (e)=>{
                            const { commandName: n, commandValue: o } = e.source;
                            t.execute(n, o ? {
                                value: o
                            } : undefined);
                            t.editing.view.focus();
                        });
                        return d;
                    });
                }
            }
            class gR extends Pu {
                static get requires() {
                    return [
                        cR,
                        pR
                    ];
                }
                static get pluginName() {
                    return "Heading";
                }
            }
            const mR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 9v10h-2v-8h-2V9h4zM4 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V11H4v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H3a1 1 0 0 1 1 1v4.5z"/></svg>';
            const kR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm16.076 8.343V18.5h-6.252c.067-.626.27-1.22.61-1.78.338-.561 1.006-1.305 2.005-2.232.804-.749 1.297-1.257 1.479-1.523.245-.368.368-.732.368-1.092 0-.398-.107-.703-.32-.917-.214-.214-.51-.32-.886-.32-.372 0-.669.111-.889.336-.22.224-.347.596-.38 1.117l-1.778-.178c.106-.982.438-1.686.997-2.114.558-.427 1.257-.64 2.095-.64.918 0 1.64.247 2.164.742.525.495.787 1.11.787 1.847 0 .419-.075.818-.225 1.197-.15.378-.388.775-.714 1.19-.216.275-.605.67-1.168 1.187-.563.516-.92.859-1.07 1.028a3.11 3.11 0 0 0-.365.495h3.542z"/></svg>';
            const bR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V11H3v4.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1H2a1 1 0 0 1 1 1v4.5zm9.989 7.53 1.726-.209c.055.44.203.777.445 1.01.24.232.533.349.876.349.368 0 .678-.14.93-.42.251-.279.377-.655.377-1.13 0-.448-.12-.803-.362-1.066a1.153 1.153 0 0 0-.882-.393c-.228 0-.501.044-.819.133l.197-1.453c.482.012.85-.092 1.105-.315.253-.222.38-.517.38-.885 0-.313-.093-.563-.279-.75-.186-.185-.434-.278-.743-.278a1.07 1.07 0 0 0-.78.317c-.216.212-.347.52-.394.927l-1.644-.28c.114-.562.287-1.012.517-1.348.231-.337.553-.601.965-.794a3.24 3.24 0 0 1 1.387-.289c.876 0 1.579.28 2.108.838.436.457.653.973.653 1.549 0 .817-.446 1.468-1.339 1.955.533.114.96.37 1.28.768.319.398.478.878.478 1.441 0 .817-.298 1.513-.895 2.088-.596.576-1.339.864-2.228.864-.842 0-1.54-.243-2.094-.727-.555-.485-.876-1.118-.965-1.901z"/></svg>';
            const wR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm13.55 10v-1.873h-3.81v-1.561l4.037-5.91h1.498v5.904h1.156v1.567h-1.156V18.5H17.05zm0-3.44v-3.18l-2.14 3.18h2.14z"/></svg>';
            const _R = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm9.578 7.607 1.777-.184c.05.402.201.72.45.955a1.223 1.223 0 0 0 1.81-.101c.258-.303.387-.759.387-1.368 0-.572-.128-1-.384-1.286-.256-.285-.59-.428-1-.428-.512 0-.971.226-1.377.679l-1.448-.21.915-4.843h4.716v1.67H15.56l-.28 1.58a2.697 2.697 0 0 1 1.219-.298 2.68 2.68 0 0 1 2.012.863c.55.576.825 1.323.825 2.241a3.36 3.36 0 0 1-.666 2.05c-.605.821-1.445 1.232-2.52 1.232-.86 0-1.56-.23-2.101-.692-.542-.461-.866-1.081-.971-1.86z"/></svg>';
            const AR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3.5 8.5h5V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1h-.5a1 1 0 0 1-1-1V11h-5v4.5a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h.5a1 1 0 0 1 1 1v4.5zm15.595 2.973-1.726.19c-.043-.355-.153-.617-.33-.787-.178-.169-.409-.253-.692-.253-.377 0-.695.169-.956.507-.26.339-.424 1.043-.492 2.114.445-.525.997-.787 1.657-.787.745 0 1.383.284 1.914.85.531.568.797 1.3.797 2.197 0 .952-.28 1.716-.838 2.291-.559.576-1.276.864-2.152.864-.94 0-1.712-.365-2.317-1.095-.605-.73-.908-1.927-.908-3.59 0-1.705.316-2.935.946-3.688.63-.753 1.45-1.13 2.457-1.13.706 0 1.291.198 1.755.594.463.395.758.97.885 1.723zm-4.043 3.891c0 .58.133 1.028.4 1.343.266.315.57.473.914.473.33 0 .605-.13.825-.388.22-.258.33-.68.33-1.27 0-.604-.118-1.047-.355-1.329a1.115 1.115 0 0 0-.89-.422c-.342 0-.632.134-.869.403s-.355.666-.355 1.19z"/></svg>';
            const vR = {
                heading1: mR,
                heading2: kR,
                heading3: bR,
                heading4: wR,
                heading5: _R,
                heading6: AR
            };
            class CR extends null {
                init() {
                    const t = getLocalizedOptions(this.editor);
                    t.filter((t)=>t.model !== "paragraph").map((t)=>this._createButton(t));
                }
                _createButton(t) {
                    const e = this.editor;
                    e.ui.componentFactory.add(t.model, (n)=>{
                        const o = new ButtonView(n);
                        const i = e.commands.get("heading");
                        o.label = t.title;
                        o.icon = t.icon || vR[t.model];
                        o.tooltip = true;
                        o.isToggleable = true;
                        o.bind("isEnabled").to(i);
                        o.bind("isOn").to(i, "value", (e)=>e == t.model);
                        o.on("execute", ()=>{
                            e.execute("heading", {
                                value: t.model
                            });
                            e.editing.view.focus();
                        });
                        return o;
                    });
                }
            }
            const yR = new Set([
                "paragraph",
                "heading1",
                "heading2",
                "heading3",
                "heading4",
                "heading5",
                "heading6"
            ]);
            class xR extends null {
                constructor(){
                    super(...arguments);
                    this._bodyPlaceholder = new Map;
                }
                static get pluginName() {
                    return "Title";
                }
                static get requires() {
                    return [
                        "Paragraph"
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    e.schema.register("title", {
                        isBlock: true,
                        allowIn: "$root"
                    });
                    e.schema.register("title-content", {
                        isBlock: true,
                        allowIn: "title",
                        allowAttributes: [
                            "alignment"
                        ]
                    });
                    e.schema.extend("$text", {
                        allowIn: "title-content"
                    });
                    e.schema.addAttributeCheck((t)=>{
                        if (t.endsWith("title-content $text")) return false;
                    });
                    t.editing.mapper.on("modelToViewPosition", DR(t.editing.view));
                    t.data.mapper.on("modelToViewPosition", DR(t.editing.view));
                    t.conversion.for("downcast").elementToElement({
                        model: "title-content",
                        view: "h1"
                    });
                    t.conversion.for("downcast").add((t)=>t.on("insert:title", (t, e, n)=>{
                            n.consumable.consume(e.item, t.name);
                        }));
                    t.data.upcastDispatcher.on("element:h1", ER, {
                        priority: "high"
                    });
                    t.data.upcastDispatcher.on("element:h2", ER, {
                        priority: "high"
                    });
                    t.data.upcastDispatcher.on("element:h3", ER, {
                        priority: "high"
                    });
                    e.document.registerPostFixer((t)=>this._fixTitleContent(t));
                    e.document.registerPostFixer((t)=>this._fixTitleElement(t));
                    e.document.registerPostFixer((t)=>this._fixBodyElement(t));
                    e.document.registerPostFixer((t)=>this._fixExtraParagraph(t));
                    this._attachPlaceholders();
                    this._attachTabPressHandling();
                }
                getTitle(t = {}) {
                    const e = t.rootName ? t.rootName : undefined;
                    const n = this._getTitleElement(e);
                    const o = n.getChild(0);
                    return this.editor.data.stringify(o, t);
                }
                getBody(t = {}) {
                    const e = this.editor;
                    const n = e.data;
                    const o = e.model;
                    const i = t.rootName ? t.rootName : undefined;
                    const r = e.model.document.getRoot(i);
                    const s = e.editing.view;
                    const a = new DowncastWriter(s.document);
                    const c = o.createRangeIn(r);
                    const l = a.createDocumentFragment();
                    const d = o.createPositionAfter(r.getChild(0));
                    const u = o.createRange(d, o.createPositionAt(r, "end"));
                    const h = new Map;
                    for (const t of o.markers){
                        const e = u.getIntersection(t.getRange());
                        if (e) h.set(t.name, e);
                    }
                    n.mapper.clearBindings();
                    n.mapper.bindElements(r, l);
                    n.downcastDispatcher.convert(c, h, a, t);
                    a.remove(a.createRangeOn(l.getChild(0)));
                    return e.data.processor.toData(l);
                }
                _getTitleElement(t) {
                    const e = this.editor.model.document.getRoot(t);
                    for (const t of e.getChildren()){
                        if (SR(t)) return t;
                    }
                }
                _fixTitleContent(t) {
                    let e = false;
                    for (const n of this.editor.model.document.getRootNames()){
                        const o = this._getTitleElement(n);
                        if (!o || o.maxOffset === 1) continue;
                        const i = Array.from(o.getChildren());
                        i.shift();
                        for (const e of i){
                            t.move(t.createRangeOn(e), o, "after");
                            t.rename(e, "paragraph");
                        }
                        e = true;
                    }
                    return e;
                }
                _fixTitleElement(t) {
                    let e = false;
                    const n = this.editor.model;
                    for (const o of this.editor.model.document.getRoots()){
                        const i = Array.from(o.getChildren()).filter(SR);
                        const r = i[0];
                        const s = o.getChild(0);
                        if (s.is("element", "title")) {
                            if (i.length > 1) {
                                BR(i, t, n);
                                e = true;
                            }
                            continue;
                        }
                        if (!r && !yR.has(s.name)) {
                            const n = t.createElement("title");
                            t.insert(n, o);
                            t.insertElement("title-content", n);
                            e = true;
                            continue;
                        }
                        if (yR.has(s.name)) TR(s, t, n);
                        else t.move(t.createRangeOn(r), o, 0);
                        BR(i, t, n);
                        e = true;
                    }
                    return e;
                }
                _fixBodyElement(t) {
                    let e = false;
                    for (const n of this.editor.model.document.getRootNames()){
                        const o = this.editor.model.document.getRoot(n);
                        if (o.childCount < 2) {
                            const i = t.createElement("paragraph");
                            t.insert(i, o, 1);
                            this._bodyPlaceholder.set(n, i);
                            e = true;
                        }
                    }
                    return e;
                }
                _fixExtraParagraph(t) {
                    let e = false;
                    for (const n of this.editor.model.document.getRootNames()){
                        const o = this.editor.model.document.getRoot(n);
                        const i = this._bodyPlaceholder.get(n);
                        if (IR(i, o)) {
                            this._bodyPlaceholder.delete(n);
                            t.remove(i);
                            e = true;
                        }
                    }
                    return e;
                }
                _attachPlaceholders() {
                    const t = this.editor;
                    const e = t.t;
                    const n = t.editing.view;
                    const o = t.sourceElement;
                    const i = t.config.get("title.placeholder") || e("Type your title");
                    const r = t.config.get("placeholder") || o && o.tagName.toLowerCase() === "textarea" && o.getAttribute("placeholder") || e("Type or paste your content here.");
                    t.editing.downcastDispatcher.on("insert:title-content", (t, e, o)=>{
                        const r = o.mapper.toViewElement(e.item);
                        r.placeholder = i;
                        enablePlaceholder({
                            view: n,
                            element: r,
                            keepOnFocus: true
                        });
                    });
                    const s = new Map;
                    n.document.registerPostFixer((t)=>{
                        let e = false;
                        for (const o of n.document.roots){
                            if (o.isEmpty) continue;
                            const n = o.getChild(1);
                            const i = s.get(o.rootName);
                            if (n !== i) {
                                if (i) {
                                    hidePlaceholder(t, i);
                                    t.removeAttribute("data-placeholder", i);
                                }
                                t.setAttribute("data-placeholder", r, n);
                                s.set(o.rootName, n);
                                e = true;
                            }
                            if (needsPlaceholder(n, true) && o.childCount === 2 && n.name === "p") e = showPlaceholder(t, n) ? true : e;
                            else e = hidePlaceholder(t, n) ? true : e;
                        }
                        return e;
                    });
                }
                _attachTabPressHandling() {
                    const t = this.editor;
                    const e = t.model;
                    t.keystrokes.set("TAB", (t, n)=>{
                        e.change((t)=>{
                            const o = e.document.selection;
                            const i = Array.from(o.getSelectedBlocks());
                            if (i.length === 1 && i[0].is("element", "title-content")) {
                                const e = o.getFirstPosition().root;
                                const i = e.getChild(1);
                                t.setSelection(i, 0);
                                n();
                            }
                        });
                    });
                    t.keystrokes.set("SHIFT + TAB", (n, o)=>{
                        e.change((n)=>{
                            const i = e.document.selection;
                            if (!i.isCollapsed) return;
                            const r = first(i.getSelectedBlocks());
                            const s = i.getFirstPosition();
                            const a = t.model.document.getRoot(s.root.rootName);
                            const c = a.getChild(0);
                            const l = a.getChild(1);
                            if (r === l && s.isAtStart) {
                                n.setSelection(c.getChild(0), 0);
                                o();
                            }
                        });
                    });
                }
            }
            function ER(t, e, n) {
                const o = e.modelCursor;
                const i = e.viewItem;
                if (!o.isAtStart || !o.parent.is("element", "$root")) return;
                if (!n.consumable.consume(i, {
                    name: true
                })) return;
                const r = n.writer;
                const s = r.createElement("title");
                const a = r.createElement("title-content");
                r.append(a, s);
                r.insert(s, o);
                n.convertChildren(i, a);
                n.updateConversionResult(s, e);
            }
            function DR(t) {
                return (e, n)=>{
                    const o = n.modelPosition.parent;
                    if (!o.is("element", "title")) return;
                    const i = o.parent;
                    const r = n.mapper.toViewElement(i);
                    n.viewPosition = t.createPositionAt(r, 0);
                    e.stop();
                };
            }
            function SR(t) {
                return t.is("element", "title");
            }
            function TR(t, e, n) {
                const o = e.createElement("title");
                e.insert(o, t, "before");
                e.insert(t, o, 0);
                e.rename(t, "title-content");
                n.schema.removeDisallowedAttributes([
                    t
                ], e);
            }
            function BR(t, e, n) {
                let o = false;
                for (const i of t)if (i.index !== 0) {
                    PR(i, e, n);
                    o = true;
                }
                return o;
            }
            function PR(t, e, n) {
                const o = t.getChild(0);
                if (o.isEmpty) {
                    e.remove(t);
                    return;
                }
                e.move(e.createRangeOn(o), t, "before");
                e.rename(o, "paragraph");
                e.remove(t);
                n.schema.removeDisallowedAttributes([
                    o
                ], e);
            }
            function IR(t, e) {
                if (!t || !t.is("element", "paragraph") || t.childCount) return false;
                if (e.childCount <= 2 || e.getChild(e.childCount - 1) !== t) return false;
                return true;
            }
            class RR extends Ru {
                refresh() {
                    const t = this.editor.model;
                    const e = t.schema;
                    const n = t.document.selection;
                    this.isEnabled = OR(n, e, t);
                }
                execute() {
                    const t = this.editor.model;
                    t.change((e)=>{
                        const n = e.createElement("horizontalLine");
                        t.insertObject(n, null, null, {
                            setSelection: "after"
                        });
                    });
                }
            }
            function OR(t, e, n) {
                const o = VR(t, n);
                return e.checkChild(o, "horizontalLine");
            }
            function VR(t, e) {
                const n = hP(t, e);
                const o = n.start.parent;
                if (o.isEmpty && !o.is("element", "$root")) return o.parent;
                return o;
            }
            var MR = n(9893);
            var LR = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            LR.insert = "head";
            LR.singleton = true;
            var zR = Rl()(MR.Z, LR);
            const NR = MR.Z.locals || {};
            class FR extends Pu {
                static get pluginName() {
                    return "HorizontalLineEditing";
                }
                init() {
                    const t = this.editor;
                    const e = t.model.schema;
                    const n = t.t;
                    const o = t.conversion;
                    e.register("horizontalLine", {
                        inheritAllFrom: "$blockObject"
                    });
                    o.for("dataDowncast").elementToElement({
                        model: "horizontalLine",
                        view: (t, { writer: e })=>e.createEmptyElement("hr")
                    });
                    o.for("editingDowncast").elementToStructure({
                        model: "horizontalLine",
                        view: (t, { writer: e })=>{
                            const o = n("Horizontal line");
                            const i = e.createContainerElement("div", null, e.createEmptyElement("hr"));
                            e.addClass("ck-horizontal-line", i);
                            e.setCustomProperty("hr", true, i);
                            return HR(i, e, o);
                        }
                    });
                    o.for("upcast").elementToElement({
                        view: "hr",
                        model: "horizontalLine"
                    });
                    t.commands.add("horizontalLine", new RR(t));
                }
            }
            function HR(t, e, n) {
                e.setCustomProperty("horizontalLine", true, t);
                return rP(t, e, {
                    label: n
                });
            }
            const jR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 9h16v2H2z"/></svg>';
            class qR extends Pu {
                static get pluginName() {
                    return "HorizontalLineUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add("horizontalLine", (n)=>{
                        const o = t.commands.get("horizontalLine");
                        const i = new yd(n);
                        i.set({
                            label: e("Horizontal line"),
                            icon: jR,
                            tooltip: true
                        });
                        i.bind("isEnabled").to(o, "isEnabled");
                        this.listenTo(i, "execute", ()=>{
                            t.execute("horizontalLine");
                            t.editing.view.focus();
                        });
                        return i;
                    });
                }
            }
            class WR extends Pu {
                static get requires() {
                    return [
                        FR,
                        qR,
                        $P
                    ];
                }
                static get pluginName() {
                    return "HorizontalLine";
                }
            }
            class $R extends Pu {
                static get pluginName() {
                    return "IndentEditing";
                }
                init() {
                    const t = this.editor;
                    t.commands.add("indent", new Vu(t));
                    t.commands.add("outdent", new Vu(t));
                }
            }
            const GR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>';
            const UR = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
            class KR extends Pu {
                static get pluginName() {
                    return "IndentUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.locale;
                    const n = t.t;
                    const o = e.uiLanguageDirection == "ltr" ? GR : UR;
                    const i = e.uiLanguageDirection == "ltr" ? UR : GR;
                    this._defineButton("indent", n("Increase indent"), o);
                    this._defineButton("outdent", n("Decrease indent"), i);
                }
                _defineButton(t, e, n) {
                    const o = this.editor;
                    o.ui.componentFactory.add(t, (i)=>{
                        const r = o.commands.get(t);
                        const s = new yd(i);
                        s.set({
                            label: e,
                            icon: n,
                            tooltip: true
                        });
                        s.bind("isEnabled").to(r, "isEnabled");
                        this.listenTo(s, "execute", ()=>{
                            o.execute(t);
                            o.editing.view.focus();
                        });
                        return s;
                    });
                }
            }
            class ZR extends Pu {
                static get pluginName() {
                    return "Indent";
                }
                static get requires() {
                    return [
                        $R,
                        KR
                    ];
                }
            }
            class JR extends null {
                constructor(t, e){
                    super(t);
                    this._indentBehavior = e;
                }
                refresh() {
                    const t = this.editor;
                    const e = t.model;
                    const n = first(e.document.selection.getSelectedBlocks());
                    if (!n || !this._isIndentationChangeAllowed(n)) {
                        this.isEnabled = false;
                        return;
                    }
                    this.isEnabled = this._indentBehavior.checkEnabled(n.getAttribute("blockIndent"));
                }
                execute() {
                    const t = this.editor.model;
                    const e = this._getBlocksToChange();
                    t.change((t)=>{
                        for (const n of e){
                            const e = n.getAttribute("blockIndent");
                            const o = this._indentBehavior.getNextIndent(e);
                            if (o) t.setAttribute("blockIndent", o, n);
                            else t.removeAttribute("blockIndent", n);
                        }
                    });
                }
                _getBlocksToChange() {
                    const t = this.editor.model;
                    const e = t.document.selection;
                    const n = Array.from(e.getSelectedBlocks());
                    return n.filter((t)=>this._isIndentationChangeAllowed(t));
                }
                _isIndentationChangeAllowed(t) {
                    const e = this.editor;
                    if (!e.model.schema.checkAttribute(t, "blockIndent")) return false;
                    if (!e.plugins.has("DocumentListUtils")) return true;
                    if (!this._indentBehavior.isForward) return true;
                    const n = e.plugins.get("DocumentListUtils");
                    return !n.isListItemBlock(t);
                }
            }
            const YR = null;
            class QR extends null {
                constructor(t){
                    super(t);
                    t.config.define("indentBlock", {
                        offset: 40,
                        unit: "px"
                    });
                }
                static get pluginName() {
                    return "IndentBlock";
                }
                init() {
                    const t = this.editor;
                    const e = t.config.get("indentBlock");
                    if (e.classes && e.classes.length) {
                        this._setupConversionUsingClasses(e.classes);
                        t.commands.add("indentBlock", new IndentBlockCommand(t, new IndentUsingClasses({
                            direction: "forward",
                            classes: e.classes
                        })));
                        t.commands.add("outdentBlock", new IndentBlockCommand(t, new IndentUsingClasses({
                            direction: "backward",
                            classes: e.classes
                        })));
                    } else {
                        t.data.addStyleProcessorRules(addMarginRules);
                        this._setupConversionUsingOffset();
                        t.commands.add("indentBlock", new IndentBlockCommand(t, new IndentUsingOffset({
                            direction: "forward",
                            offset: e.offset,
                            unit: e.unit
                        })));
                        t.commands.add("outdentBlock", new IndentBlockCommand(t, new IndentUsingOffset({
                            direction: "backward",
                            offset: e.offset,
                            unit: e.unit
                        })));
                    }
                }
                afterInit() {
                    const t = this.editor;
                    const e = t.model.schema;
                    const n = t.commands.get("indent");
                    const o = t.commands.get("outdent");
                    const i = t.config.get("heading.options");
                    const r = i && i.map((t)=>t.model);
                    const s = r || YR;
                    s.forEach((t)=>{
                        if (e.isRegistered(t)) e.extend(t, {
                            allowAttributes: "blockIndent"
                        });
                    });
                    e.setAttributeProperties("blockIndent", {
                        isFormatting: true
                    });
                    n.registerChildCommand(t.commands.get("indentBlock"));
                    o.registerChildCommand(t.commands.get("outdentBlock"));
                }
                _setupConversionUsingOffset() {
                    const t = this.editor.conversion;
                    const e = this.editor.locale;
                    const n = e.contentLanguageDirection === "rtl" ? "margin-right" : "margin-left";
                    t.for("upcast").attributeToAttribute({
                        view: {
                            styles: {
                                [n]: /[\s\S]+/
                            }
                        },
                        model: {
                            key: "blockIndent",
                            value: (t)=>{
                                if (!t.is("element", "li")) return t.getStyle(n);
                            }
                        }
                    });
                    t.for("downcast").attributeToAttribute({
                        model: "blockIndent",
                        view: (t)=>({
                                key: "style",
                                value: {
                                    [n]: t
                                }
                            })
                    });
                }
                _setupConversionUsingClasses(t) {
                    const e = {
                        model: {
                            key: "blockIndent",
                            values: []
                        },
                        view: {}
                    };
                    for (const n of t){
                        e.model.values.push(n);
                        e.view[n] = {
                            key: "class",
                            value: [
                                n
                            ]
                        };
                    }
                    this.editor.conversion.attributeToAttribute(e);
                }
            }
            class XR {
                constructor(){
                    this._definitions = new Set;
                }
                get length() {
                    return this._definitions.size;
                }
                add(t) {
                    if (Array.isArray(t)) t.forEach((t)=>this._definitions.add(t));
                    else this._definitions.add(t);
                }
                getDispatcher() {
                    return (t)=>{
                        t.on("attribute:linkHref", (t, e, n)=>{
                            if (!n.consumable.test(e.item, "attribute:linkHref")) return;
                            if (!(e.item.is("selection") || n.schema.isInline(e.item))) return;
                            const o = n.writer;
                            const i = o.document.selection;
                            for (const t of this._definitions){
                                const r = o.createAttributeElement("a", t.attributes, {
                                    priority: 5
                                });
                                if (t.classes) o.addClass(t.classes, r);
                                for(const e in t.styles)o.setStyle(e, t.styles[e], r);
                                o.setCustomProperty("link", true, r);
                                if (t.callback(e.attributeNewValue)) {
                                    if (e.item.is("selection")) o.wrap(i.getFirstRange(), r);
                                    else o.wrap(n.mapper.toViewRange(e.range), r);
                                } else o.unwrap(n.mapper.toViewRange(e.range), r);
                            }
                        }, {
                            priority: "high"
                        });
                    };
                }
                getDispatcherForLinkedImage() {
                    return (t)=>{
                        t.on("attribute:linkHref:imageBlock", (t, e, { writer: n, mapper: o })=>{
                            const i = o.toViewElement(e.item);
                            const r = Array.from(i.getChildren()).find((t)=>t.is("element", "a"));
                            for (const t of this._definitions){
                                const o = kl(t.attributes);
                                if (t.callback(e.attributeNewValue)) {
                                    for (const [t, e] of o)if (t === "class") n.addClass(e, r);
                                    else n.setAttribute(t, e, r);
                                    if (t.classes) n.addClass(t.classes, r);
                                    for(const e in t.styles)n.setStyle(e, t.styles[e], r);
                                } else {
                                    for (const [t, e] of o)if (t === "class") n.removeClass(e, r);
                                    else n.removeAttribute(t, r);
                                    if (t.classes) n.removeClass(t.classes, r);
                                    for(const e in t.styles)n.removeStyle(e, r);
                                }
                            }
                        });
                    };
                }
            }
            function tO(t, e, n) {
                var o = t.length;
                n = n === undefined ? o : n;
                return !e && n >= o ? t : Xh(t, e, n);
            }
            const eO = tO;
            var nO = "\\ud800-\\udfff", oO = "\\u0300-\\u036f", iO = "\\ufe20-\\ufe2f", rO = "\\u20d0-\\u20ff", sO = oO + iO + rO, aO = "\\ufe0e\\ufe0f";
            var cO = "\\u200d";
            var lO = RegExp("[" + cO + nO + sO + aO + "]");
            function dO(t) {
                return lO.test(t);
            }
            const uO = dO;
            function hO(t) {
                return t.split("");
            }
            const fO = hO;
            var pO = "\\ud800-\\udfff", gO = "\\u0300-\\u036f", mO = "\\ufe20-\\ufe2f", kO = "\\u20d0-\\u20ff", bO = gO + mO + kO, wO = "\\ufe0e\\ufe0f";
            var _O = "[" + pO + "]", AO = "[" + bO + "]", vO = "\\ud83c[\\udffb-\\udfff]", CO = "(?:" + AO + "|" + vO + ")", yO = "[^" + pO + "]", xO = "(?:\\ud83c[\\udde6-\\uddff]){2}", EO = "[\\ud800-\\udbff][\\udc00-\\udfff]", DO = "\\u200d";
            var SO = CO + "?", TO = "[" + wO + "]?", BO = "(?:" + DO + "(?:" + [
                yO,
                xO,
                EO
            ].join("|") + ")" + TO + SO + ")*", PO = TO + SO + BO, IO = "(?:" + [
                yO + AO + "?",
                AO,
                xO,
                EO,
                _O
            ].join("|") + ")";
            var RO = RegExp(vO + "(?=" + vO + ")|" + IO + PO, "g");
            function OO(t) {
                return t.match(RO) || [];
            }
            const VO = OO;
            function MO(t) {
                return uO(t) ? VO(t) : fO(t);
            }
            const LO = MO;
            function zO(t) {
                return function(e) {
                    e = jh(e);
                    var n = uO(e) ? LO(e) : undefined;
                    var o = n ? n[0] : e.charAt(0);
                    var i = n ? eO(n, 1).join("") : e.slice(1);
                    return o[t]() + i;
                };
            }
            const NO = zO;
            var FO = NO("toUpperCase");
            const HO = FO;
            const jO = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g;
            const qO = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;
            const WO = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i;
            const $O = /^((\w+:(\/{2,})?)|(\W))/i;
            const GO = "Ctrl+K";
            function UO(t) {
                return t.is("attributeElement") && !!t.getCustomProperty("link");
            }
            function KO(t, { writer: e }) {
                const n = e.createAttributeElement("a", {
                    href: t
                }, {
                    priority: 5
                });
                e.setCustomProperty("link", true, n);
                return n;
            }
            function ZO(t) {
                const e = String(t);
                return JO(e) ? e : "#";
            }
            function JO(t) {
                const e = t.replace(jO, "");
                return !!e.match(qO);
            }
            function YO(t, e) {
                const n = {
                    "Open in a new tab": t("Open in a new tab"),
                    Downloadable: t("Downloadable")
                };
                e.forEach((t)=>{
                    if ("label" in t && n[t.label]) t.label = n[t.label];
                    return t;
                });
                return e;
            }
            function QO(t) {
                const e = [];
                if (t) for (const [n, o] of Object.entries(t)){
                    const t = Object.assign({}, o, {
                        id: `link${HO(n)}`
                    });
                    e.push(t);
                }
                return e;
            }
            function XO(t, e) {
                if (!t) return false;
                return e.checkAttribute(t.name, "linkHref");
            }
            function tV(t) {
                return WO.test(t);
            }
            function eV(t, e) {
                const n = tV(t) ? "mailto:" : e;
                const o = !!n && !nV(t);
                return t && o ? n + t : t;
            }
            function nV(t) {
                return $O.test(t);
            }
            function oV(t) {
                window.open(t, "_blank", "noopener");
            }
            class iV extends Ru {
                constructor(){
                    super(...arguments);
                    this.manualDecorators = new hl;
                    this.automaticDecorators = new XR;
                }
                restoreManualDecoratorStates() {
                    for (const t of this.manualDecorators)t.value = this._getDecoratorStateFromModel(t.id);
                }
                refresh() {
                    const t = this.editor.model;
                    const e = t.document.selection;
                    const n = e.getSelectedElement() || fl(e.getSelectedBlocks());
                    if (XO(n, t.schema)) {
                        this.value = n.getAttribute("linkHref");
                        this.isEnabled = t.schema.checkAttribute(n, "linkHref");
                    } else {
                        this.value = e.getAttribute("linkHref");
                        this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref");
                    }
                    for (const t of this.manualDecorators)t.value = this._getDecoratorStateFromModel(t.id);
                }
                execute(t, e = {}) {
                    const n = this.editor.model;
                    const o = n.document.selection;
                    const i = [];
                    const r = [];
                    for(const t in e)if (e[t]) i.push(t);
                    else r.push(t);
                    n.change((e)=>{
                        if (o.isCollapsed) {
                            const s = o.getFirstPosition();
                            if (o.hasAttribute("linkHref")) {
                                const a = rV(o);
                                let c = MT(s, "linkHref", o.getAttribute("linkHref"), n);
                                if (o.getAttribute("linkHref") === a) c = this._updateLinkContent(n, e, c, t);
                                e.setAttribute("linkHref", t, c);
                                i.forEach((t)=>{
                                    e.setAttribute(t, true, c);
                                });
                                r.forEach((t)=>{
                                    e.removeAttribute(t, c);
                                });
                                e.setSelection(e.createPositionAfter(c.end.nodeBefore));
                            } else if (t !== "") {
                                const r = kl(o.getAttributes());
                                r.set("linkHref", t);
                                i.forEach((t)=>{
                                    r.set(t, true);
                                });
                                const { end: a } = n.insertContent(e.createText(t, r), s);
                                e.setSelection(a);
                            }
                            [
                                "linkHref",
                                ...i,
                                ...r
                            ].forEach((t)=>{
                                e.removeSelectionAttribute(t);
                            });
                        } else {
                            const s = n.schema.getValidRanges(o.getRanges(), "linkHref");
                            const a = [];
                            for (const t of o.getSelectedBlocks())if (n.schema.checkAttribute(t, "linkHref")) a.push(e.createRangeOn(t));
                            const c = a.slice();
                            for (const t of s)if (this._isRangeToUpdate(t, a)) c.push(t);
                            for (const s of c){
                                let a = s;
                                if (c.length === 1) {
                                    const i = rV(o);
                                    if (o.getAttribute("linkHref") === i) {
                                        a = this._updateLinkContent(n, e, s, t);
                                        e.setSelection(e.createSelection(a));
                                    }
                                }
                                e.setAttribute("linkHref", t, a);
                                i.forEach((t)=>{
                                    e.setAttribute(t, true, a);
                                });
                                r.forEach((t)=>{
                                    e.removeAttribute(t, a);
                                });
                            }
                        }
                    });
                }
                _getDecoratorStateFromModel(t) {
                    const e = this.editor.model;
                    const n = e.document.selection;
                    const o = n.getSelectedElement();
                    if (XO(o, e.schema)) return o.getAttribute(t);
                    return n.getAttribute(t);
                }
                _isRangeToUpdate(t, e) {
                    for (const n of e){
                        if (n.containsRange(t)) return false;
                    }
                    return true;
                }
                _updateLinkContent(t, e, n, o) {
                    const i = e.createText(o, {
                        linkHref: o
                    });
                    return t.insertContent(i, n);
                }
            }
            function rV(t) {
                if (t.isCollapsed) {
                    const e = t.getFirstPosition();
                    return e.textNode && e.textNode.data;
                } else {
                    const e = Array.from(t.getFirstRange().getItems());
                    if (e.length > 1) return null;
                    const n = e[0];
                    if (n.is("$text") || n.is("$textProxy")) return n.data;
                    return null;
                }
            }
            class sV extends Ru {
                refresh() {
                    const t = this.editor.model;
                    const e = t.document.selection;
                    const n = e.getSelectedElement();
                    if (XO(n, t.schema)) this.isEnabled = t.schema.checkAttribute(n, "linkHref");
                    else this.isEnabled = t.schema.checkAttributeInSelection(e, "linkHref");
                }
                execute() {
                    const t = this.editor;
                    const e = this.editor.model;
                    const n = e.document.selection;
                    const o = t.commands.get("link");
                    e.change((t)=>{
                        const i = n.isCollapsed ? [
                            MT(n.getFirstPosition(), "linkHref", n.getAttribute("linkHref"), e)
                        ] : e.schema.getValidRanges(n.getRanges(), "linkHref");
                        for (const e of i){
                            t.removeAttribute("linkHref", e);
                            if (o) for (const n of o.manualDecorators)t.removeAttribute(n.id, e);
                        }
                    });
                }
            }
            class aV extends ht() {
                constructor({ id: t, label: e, attributes: n, classes: o, styles: i, defaultValue: r }){
                    super();
                    this.id = t;
                    this.set("value", undefined);
                    this.defaultValue = r;
                    this.label = e;
                    this.attributes = n;
                    this.classes = o;
                    this.styles = i;
                }
                _createPattern() {
                    return {
                        attributes: this.attributes,
                        classes: this.classes,
                        styles: this.styles
                    };
                }
            }
            var cV = n(3925);
            var lV = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            lV.insert = "head";
            lV.singleton = true;
            var dV = Rl()(cV.Z, lV);
            const uV = cV.Z.locals || {};
            const hV = "ck-link_selected";
            const fV = "automatic";
            const pV = "manual";
            const gV = /^(https?:)?\/\//;
            class mV extends Pu {
                static get pluginName() {
                    return "LinkEditing";
                }
                static get requires() {
                    return [
                        _T,
                        oT,
                        JB
                    ];
                }
                constructor(t){
                    super(t);
                    t.config.define("link", {
                        addTargetToExternalLinks: false
                    });
                }
                init() {
                    const t = this.editor;
                    t.model.schema.extend("$text", {
                        allowAttributes: "linkHref"
                    });
                    t.conversion.for("dataDowncast").attributeToElement({
                        model: "linkHref",
                        view: KO
                    });
                    t.conversion.for("editingDowncast").attributeToElement({
                        model: "linkHref",
                        view: (t, e)=>KO(ZO(t), e)
                    });
                    t.conversion.for("upcast").elementToAttribute({
                        view: {
                            name: "a",
                            attributes: {
                                href: true
                            }
                        },
                        model: {
                            key: "linkHref",
                            value: (t)=>t.getAttribute("href")
                        }
                    });
                    t.commands.add("link", new iV(t));
                    t.commands.add("unlink", new sV(t));
                    const e = YO(t.t, QO(t.config.get("link.decorators")));
                    this._enableAutomaticDecorators(e.filter((t)=>t.mode === fV));
                    this._enableManualDecorators(e.filter((t)=>t.mode === pV));
                    const n = t.plugins.get(_T);
                    n.registerAttribute("linkHref");
                    zT(t, "linkHref", "a", hV);
                    this._enableLinkOpen();
                    this._enableInsertContentSelectionAttributesFixer();
                    this._enableClickingAfterLink();
                    this._enableTypingOverLink();
                    this._handleDeleteContentAfterLink();
                    this._enableClipboardIntegration();
                }
                _enableAutomaticDecorators(t) {
                    const e = this.editor;
                    const n = e.commands.get("link");
                    const o = n.automaticDecorators;
                    if (e.config.get("link.addTargetToExternalLinks")) o.add({
                        id: "linkIsExternal",
                        mode: fV,
                        callback: (t)=>!!t && gV.test(t),
                        attributes: {
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }
                    });
                    o.add(t);
                    if (o.length) e.conversion.for("downcast").add(o.getDispatcher());
                }
                _enableManualDecorators(t) {
                    if (!t.length) return;
                    const e = this.editor;
                    const n = e.commands.get("link");
                    const o = n.manualDecorators;
                    t.forEach((t)=>{
                        e.model.schema.extend("$text", {
                            allowAttributes: t.id
                        });
                        const n = new aV(t);
                        o.add(n);
                        e.conversion.for("downcast").attributeToElement({
                            model: n.id,
                            view: (t, { writer: e, schema: o }, { item: i })=>{
                                if (!(i.is("selection") || o.isInline(i))) return;
                                if (t) {
                                    const t = e.createAttributeElement("a", n.attributes, {
                                        priority: 5
                                    });
                                    if (n.classes) e.addClass(n.classes, t);
                                    for(const o in n.styles)e.setStyle(o, n.styles[o], t);
                                    e.setCustomProperty("link", true, t);
                                    return t;
                                }
                            }
                        });
                        e.conversion.for("upcast").elementToAttribute({
                            view: {
                                name: "a",
                                ...n._createPattern()
                            },
                            model: {
                                key: n.id
                            }
                        });
                    });
                }
                _enableLinkOpen() {
                    const t = this.editor;
                    const e = t.editing.view;
                    const n = e.document;
                    this.listenTo(n, "click", (t, e)=>{
                        const n = c.isMac ? e.domEvent.metaKey : e.domEvent.ctrlKey;
                        if (!n) return;
                        let o = e.domTarget;
                        if (o.tagName.toLowerCase() != "a") o = o.closest("a");
                        if (!o) return;
                        const i = o.getAttribute("href");
                        if (!i) return;
                        t.stop();
                        e.preventDefault();
                        oV(i);
                    }, {
                        context: "$capture"
                    });
                    this.listenTo(n, "keydown", (e, n)=>{
                        const o = t.commands.get("link");
                        const i = o.value;
                        const r = !!i && n.keyCode === $c.enter && n.altKey;
                        if (!r) return;
                        e.stop();
                        oV(i);
                    });
                }
                _enableInsertContentSelectionAttributesFixer() {
                    const t = this.editor;
                    const e = t.model;
                    const n = e.document.selection;
                    this.listenTo(e, "insertContent", ()=>{
                        const t = n.anchor.nodeBefore;
                        const o = n.anchor.nodeAfter;
                        if (!n.hasAttribute("linkHref")) return;
                        if (!t) return;
                        if (!t.hasAttribute("linkHref")) return;
                        if (o && o.hasAttribute("linkHref")) return;
                        e.change((t)=>{
                            kV(t, _V(e.schema));
                        });
                    }, {
                        priority: "low"
                    });
                }
                _enableClickingAfterLink() {
                    const t = this.editor;
                    const e = t.model;
                    t.editing.view.addObserver(ev);
                    let n = false;
                    this.listenTo(t.editing.view.document, "mousedown", ()=>{
                        n = true;
                    });
                    this.listenTo(t.editing.view.document, "selectionChange", ()=>{
                        if (!n) return;
                        n = false;
                        const t = e.document.selection;
                        if (!t.isCollapsed) return;
                        if (!t.hasAttribute("linkHref")) return;
                        const o = t.getFirstPosition();
                        const i = MT(o, "linkHref", t.getAttribute("linkHref"), e);
                        if (o.isTouching(i.start) || o.isTouching(i.end)) e.change((t)=>{
                            kV(t, _V(e.schema));
                        });
                    });
                }
                _enableTypingOverLink() {
                    const t = this.editor;
                    const e = t.editing.view;
                    let n = null;
                    let o = false;
                    this.listenTo(e.document, "delete", ()=>{
                        o = true;
                    }, {
                        priority: "high"
                    });
                    this.listenTo(t.model, "deleteContent", ()=>{
                        const e = t.model.document.selection;
                        if (e.isCollapsed) return;
                        if (o) {
                            o = false;
                            return;
                        }
                        if (!wV(t)) return;
                        if (bV(t.model)) n = e.getAttributes();
                    }, {
                        priority: "high"
                    });
                    this.listenTo(t.model, "insertContent", (e, [i])=>{
                        o = false;
                        if (!wV(t)) return;
                        if (!n) return;
                        t.model.change((t)=>{
                            for (const [e, o] of n)t.setAttribute(e, o, i);
                        });
                        n = null;
                    }, {
                        priority: "high"
                    });
                }
                _handleDeleteContentAfterLink() {
                    const t = this.editor;
                    const e = t.model;
                    const n = e.document.selection;
                    const o = t.editing.view;
                    let i = false;
                    let r = false;
                    this.listenTo(o.document, "delete", (t, e)=>{
                        r = e.direction === "backward";
                    }, {
                        priority: "high"
                    });
                    this.listenTo(e, "deleteContent", ()=>{
                        i = false;
                        const t = n.getFirstPosition();
                        const o = n.getAttribute("linkHref");
                        if (!o) return;
                        const r = MT(t, "linkHref", o, e);
                        i = r.containsPosition(t) || r.end.isEqual(t);
                    }, {
                        priority: "high"
                    });
                    this.listenTo(e, "deleteContent", ()=>{
                        if (!r) return;
                        r = false;
                        if (i) return;
                        t.model.enqueueChange((t)=>{
                            kV(t, _V(e.schema));
                        });
                    }, {
                        priority: "low"
                    });
                }
                _enableClipboardIntegration() {
                    const t = this.editor;
                    const e = t.model;
                    const n = this.editor.config.get("link.defaultProtocol");
                    if (!n) return;
                    this.listenTo(t.plugins.get("ClipboardPipeline"), "contentInsertion", (t, o)=>{
                        e.change((t)=>{
                            const e = t.createRangeIn(o.content);
                            for (const o of e.getItems())if (o.hasAttribute("linkHref")) {
                                const e = eV(o.getAttribute("linkHref"), n);
                                t.setAttribute("linkHref", e, o);
                            }
                        });
                    });
                }
            }
            function kV(t, e) {
                t.removeSelectionAttribute("linkHref");
                for (const n of e)t.removeSelectionAttribute(n);
            }
            function bV(t) {
                const e = t.document.selection;
                const n = e.getFirstPosition();
                const o = e.getLastPosition();
                const i = n.nodeAfter;
                if (!i) return false;
                if (!i.is("$text")) return false;
                if (!i.hasAttribute("linkHref")) return false;
                const r = o.textNode || o.nodeBefore;
                if (i === r) return true;
                const s = MT(n, "linkHref", i.getAttribute("linkHref"), t);
                return s.containsRange(t.createRange(n, o), true);
            }
            function wV(t) {
                const e = t.model.change((t)=>t.batch);
                return e.isTyping;
            }
            function _V(t) {
                const e = t.getDefinition("$text").allowAttributes;
                return e.filter((t)=>t.startsWith("link"));
            }
            var AV = n(6603);
            var vV = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            vV.insert = "head";
            vV.singleton = true;
            var CV = Rl()(AV.Z, vV);
            const yV = AV.Z.locals || {};
            var xV = n(4874);
            var EV = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            EV.insert = "head";
            EV.singleton = true;
            var DV = Rl()(xV.Z, EV);
            const SV = xV.Z.locals || {};
            class TV extends zl {
                constructor(t, e){
                    super(t);
                    this.focusTracker = new pl;
                    this.keystrokes = new gl;
                    this._focusables = new Bl;
                    const n = t.t;
                    this.urlInputView = this._createUrlInput();
                    this.saveButtonView = this._createButton(n("Save"), FC.check, "ck-button-save");
                    this.saveButtonView.type = "submit";
                    this.cancelButtonView = this._createButton(n("Cancel"), FC.cancel, "ck-button-cancel", "cancel");
                    this._manualDecoratorSwitches = this._createManualDecoratorSwitches(e);
                    this.children = this._createFormChildren(e.manualDecorators);
                    this._focusCycler = new xu({
                        focusables: this._focusables,
                        focusTracker: this.focusTracker,
                        keystrokeHandler: this.keystrokes,
                        actions: {
                            focusPrevious: "shift + tab",
                            focusNext: "tab"
                        }
                    });
                    const o = [
                        "ck",
                        "ck-link-form",
                        "ck-responsive-form"
                    ];
                    if (e.manualDecorators.length) o.push("ck-link-form_layout-vertical", "ck-vertical-form");
                    this.setTemplate({
                        tag: "form",
                        attributes: {
                            class: o,
                            tabindex: "-1"
                        },
                        children: this.children
                    });
                }
                getDecoratorSwitchesState() {
                    return Array.from(this._manualDecoratorSwitches).reduce((t, e)=>{
                        t[e.name] = e.isOn;
                        return t;
                    }, {});
                }
                render() {
                    super.render();
                    i({
                        view: this
                    });
                    const t = [
                        this.urlInputView,
                        ...this._manualDecoratorSwitches,
                        this.saveButtonView,
                        this.cancelButtonView
                    ];
                    t.forEach((t)=>{
                        this._focusables.add(t);
                        this.focusTracker.add(t.element);
                    });
                    this.keystrokes.listenTo(this.element);
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                }
                focus() {
                    this._focusCycler.focusFirst();
                }
                _createUrlInput() {
                    const t = this.locale.t;
                    const e = new eu(this.locale, Iy);
                    e.label = t("Link URL");
                    return e;
                }
                _createButton(t, e, n, o) {
                    const i = new yd(this.locale);
                    i.set({
                        label: t,
                        icon: e,
                        tooltip: true
                    });
                    i.extendTemplate({
                        attributes: {
                            class: n
                        }
                    });
                    if (o) i.delegate("execute").to(this, o);
                    return i;
                }
                _createManualDecoratorSwitches(t) {
                    const e = this.createCollection();
                    for (const n of t.manualDecorators){
                        const o = new Td(this.locale);
                        o.set({
                            name: n.id,
                            label: n.label,
                            withText: true
                        });
                        o.bind("isOn").toMany([
                            n,
                            t
                        ], "value", (t, e)=>e === undefined && t === undefined ? !!n.defaultValue : !!t);
                        o.on("execute", ()=>{
                            n.set("value", !o.isOn);
                        });
                        e.add(o);
                    }
                    return e;
                }
                _createFormChildren(t) {
                    const e = this.createCollection();
                    e.add(this.urlInputView);
                    if (t.length) {
                        const t = new zl;
                        t.setTemplate({
                            tag: "ul",
                            children: this._manualDecoratorSwitches.map((t)=>({
                                    tag: "li",
                                    children: [
                                        t
                                    ],
                                    attributes: {
                                        class: [
                                            "ck",
                                            "ck-list__item"
                                        ]
                                    }
                                })),
                            attributes: {
                                class: [
                                    "ck",
                                    "ck-reset",
                                    "ck-list"
                                ]
                            }
                        });
                        e.add(t);
                    }
                    e.add(this.saveButtonView);
                    e.add(this.cancelButtonView);
                    return e;
                }
            }
            var BV = n(7536);
            var PV = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            PV.insert = "head";
            PV.singleton = true;
            var IV = Rl()(BV.Z, PV);
            const RV = BV.Z.locals || {};
            const OV = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>';
            class VV extends zl {
                constructor(t){
                    super(t);
                    this.focusTracker = new pl;
                    this.keystrokes = new gl;
                    this._focusables = new Bl;
                    const e = t.t;
                    this.previewButtonView = this._createPreviewButton();
                    this.unlinkButtonView = this._createButton(e("Unlink"), OV, "unlink");
                    this.editButtonView = this._createButton(e("Edit link"), FC.pencil, "edit");
                    this.set("href", undefined);
                    this._focusCycler = new xu({
                        focusables: this._focusables,
                        focusTracker: this.focusTracker,
                        keystrokeHandler: this.keystrokes,
                        actions: {
                            focusPrevious: "shift + tab",
                            focusNext: "tab"
                        }
                    });
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-link-actions",
                                "ck-responsive-form"
                            ],
                            tabindex: "-1"
                        },
                        children: [
                            this.previewButtonView,
                            this.editButtonView,
                            this.unlinkButtonView
                        ]
                    });
                }
                render() {
                    super.render();
                    const t = [
                        this.previewButtonView,
                        this.editButtonView,
                        this.unlinkButtonView
                    ];
                    t.forEach((t)=>{
                        this._focusables.add(t);
                        this.focusTracker.add(t.element);
                    });
                    this.keystrokes.listenTo(this.element);
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                }
                focus() {
                    this._focusCycler.focusFirst();
                }
                _createButton(t, e, n) {
                    const o = new yd(this.locale);
                    o.set({
                        label: t,
                        icon: e,
                        tooltip: true
                    });
                    o.delegate("execute").to(this, n);
                    return o;
                }
                _createPreviewButton() {
                    const t = new yd(this.locale);
                    const e = this.bindTemplate;
                    const n = this.t;
                    t.set({
                        withText: true,
                        tooltip: n("Open link in new tab")
                    });
                    t.extendTemplate({
                        attributes: {
                            class: [
                                "ck",
                                "ck-link-actions__preview"
                            ],
                            href: e.to("href", (t)=>t && ZO(t)),
                            target: "_blank",
                            rel: "noopener noreferrer"
                        }
                    });
                    t.bind("label").to(this, "href", (t)=>t || n("This link has no URL"));
                    t.bind("isEnabled").to(this, "href", (t)=>!!t);
                    t.template.tag = "a";
                    t.template.eventListeners = {};
                    return t;
                }
            }
            const MV = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>';
            const LV = "link-ui";
            class zV extends Pu {
                constructor(){
                    super(...arguments);
                    this.actionsView = null;
                    this.formView = null;
                }
                static get requires() {
                    return [
                        pD
                    ];
                }
                static get pluginName() {
                    return "LinkUI";
                }
                init() {
                    const t = this.editor;
                    t.editing.view.addObserver(tv);
                    this._balloon = t.plugins.get(pD);
                    this._createToolbarLinkButton();
                    this._enableBalloonActivators();
                    t.conversion.for("editingDowncast").markerToHighlight({
                        model: LV,
                        view: {
                            classes: [
                                "ck-fake-link-selection"
                            ]
                        }
                    });
                    t.conversion.for("editingDowncast").markerToElement({
                        model: LV,
                        view: {
                            name: "span",
                            classes: [
                                "ck-fake-link-selection",
                                "ck-fake-link-selection_collapsed"
                            ]
                        }
                    });
                }
                destroy() {
                    super.destroy();
                    if (this.formView) this.formView.destroy();
                    if (this.actionsView) this.actionsView.destroy();
                }
                _createViews() {
                    this.actionsView = this._createActionsView();
                    this.formView = this._createFormView();
                    this._enableUserBalloonInteractions();
                }
                _createActionsView() {
                    const t = this.editor;
                    const e = new VV(t.locale);
                    const n = t.commands.get("link");
                    const o = t.commands.get("unlink");
                    e.bind("href").to(n, "value");
                    e.editButtonView.bind("isEnabled").to(n);
                    e.unlinkButtonView.bind("isEnabled").to(o);
                    this.listenTo(e, "edit", ()=>{
                        this._addFormView();
                    });
                    this.listenTo(e, "unlink", ()=>{
                        t.execute("unlink");
                        this._hideUI();
                    });
                    e.keystrokes.set("Esc", (t, e)=>{
                        this._hideUI();
                        e();
                    });
                    e.keystrokes.set(GO, (t, e)=>{
                        this._addFormView();
                        e();
                    });
                    return e;
                }
                _createFormView() {
                    const t = this.editor;
                    const n = t.commands.get("link");
                    const o = t.config.get("link.defaultProtocol");
                    const i = new (e(TV))(t.locale, n);
                    i.urlInputView.fieldView.bind("value").to(n, "value");
                    i.urlInputView.bind("isEnabled").to(n, "isEnabled");
                    i.saveButtonView.bind("isEnabled").to(n);
                    this.listenTo(i, "submit", ()=>{
                        const { value: e } = i.urlInputView.fieldView.element;
                        const n = eV(e, o);
                        t.execute("link", n, i.getDecoratorSwitchesState());
                        this._closeFormView();
                    });
                    this.listenTo(i, "cancel", ()=>{
                        this._closeFormView();
                    });
                    i.keystrokes.set("Esc", (t, e)=>{
                        this._closeFormView();
                        e();
                    });
                    return i;
                }
                _createToolbarLinkButton() {
                    const t = this.editor;
                    const e = t.commands.get("link");
                    const n = t.t;
                    t.ui.componentFactory.add("link", (t)=>{
                        const o = new yd(t);
                        o.isEnabled = true;
                        o.label = n("Link");
                        o.icon = MV;
                        o.keystroke = GO;
                        o.tooltip = true;
                        o.isToggleable = true;
                        o.bind("isEnabled").to(e, "isEnabled");
                        o.bind("isOn").to(e, "value", (t)=>!!t);
                        this.listenTo(o, "execute", ()=>this._showUI(true));
                        return o;
                    });
                }
                _enableBalloonActivators() {
                    const t = this.editor;
                    const e = t.editing.view.document;
                    this.listenTo(e, "click", ()=>{
                        const t = this._getSelectedLinkElement();
                        if (t) this._showUI();
                    });
                    t.keystrokes.set(GO, (e, n)=>{
                        n();
                        if (t.commands.get("link").isEnabled) this._showUI(true);
                    });
                }
                _enableUserBalloonInteractions() {
                    this.editor.keystrokes.set("Tab", (t, e)=>{
                        if (this._areActionsVisible && !this.actionsView.focusTracker.isFocused) {
                            this.actionsView.focus();
                            e();
                        }
                    }, {
                        priority: "high"
                    });
                    this.editor.keystrokes.set("Esc", (t, e)=>{
                        if (this._isUIVisible) {
                            this._hideUI();
                            e();
                        }
                    });
                    t({
                        emitter: this.formView,
                        activator: ()=>this._isUIInPanel,
                        contextElements: ()=>[
                                this._balloon.view.element
                            ],
                        callback: ()=>this._hideUI()
                    });
                }
                _addActionsView() {
                    if (!this.actionsView) this._createViews();
                    if (this._areActionsInPanel) return;
                    this._balloon.add({
                        view: this.actionsView,
                        position: this._getBalloonPositionData()
                    });
                }
                _addFormView() {
                    if (!this.formView) this._createViews();
                    if (this._isFormInPanel) return;
                    const t = this.editor;
                    const e = t.commands.get("link");
                    this.formView.disableCssTransitions();
                    this._balloon.add({
                        view: this.formView,
                        position: this._getBalloonPositionData()
                    });
                    if (this._balloon.visibleView === this.formView) this.formView.urlInputView.fieldView.select();
                    this.formView.enableCssTransitions();
                    this.formView.urlInputView.fieldView.element.value = e.value || "";
                }
                _closeFormView() {
                    const t = this.editor.commands.get("link");
                    t.restoreManualDecoratorStates();
                    if (t.value !== undefined) this._removeFormView();
                    else this._hideUI();
                }
                _removeFormView() {
                    if (this._isFormInPanel) {
                        this.formView.saveButtonView.focus();
                        this._balloon.remove(this.formView);
                        this.editor.editing.view.focus();
                        this._hideFakeVisualSelection();
                    }
                }
                _showUI(t = false) {
                    if (!this.formView) this._createViews();
                    if (!this._getSelectedLinkElement()) {
                        this._showFakeVisualSelection();
                        this._addActionsView();
                        if (t) this._balloon.showStack("main");
                        this._addFormView();
                    } else {
                        if (this._areActionsVisible) this._addFormView();
                        else this._addActionsView();
                        if (t) this._balloon.showStack("main");
                    }
                    this._startUpdatingUI();
                }
                _hideUI() {
                    if (!this._isUIInPanel) return;
                    const t = this.editor;
                    this.stopListening(t.ui, "update");
                    this.stopListening(this._balloon, "change:visibleView");
                    t.editing.view.focus();
                    this._removeFormView();
                    this._balloon.remove(this.actionsView);
                    this._hideFakeVisualSelection();
                }
                _startUpdatingUI() {
                    const t = this.editor;
                    const e = t.editing.view.document;
                    let n = this._getSelectedLinkElement();
                    let o = r();
                    const i = ()=>{
                        const t = this._getSelectedLinkElement();
                        const e = r();
                        if (n && !t || !n && e !== o) this._hideUI();
                        else if (this._isUIVisible) this._balloon.updatePosition(this._getBalloonPositionData());
                        n = t;
                        o = e;
                    };
                    function r() {
                        return e.selection.focus.getAncestors().reverse().find((t)=>t.is("element"));
                    }
                    this.listenTo(t.ui, "update", i);
                    this.listenTo(this._balloon, "change:visibleView", i);
                }
                get _isFormInPanel() {
                    return !!this.formView && this._balloon.hasView(this.formView);
                }
                get _areActionsInPanel() {
                    return !!this.actionsView && this._balloon.hasView(this.actionsView);
                }
                get _areActionsVisible() {
                    return !!this.actionsView && this._balloon.visibleView === this.actionsView;
                }
                get _isUIInPanel() {
                    return this._isFormInPanel || this._areActionsInPanel;
                }
                get _isUIVisible() {
                    const t = this._balloon.visibleView;
                    return !!this.formView && t == this.formView || this._areActionsVisible;
                }
                _getBalloonPositionData() {
                    const t = this.editor.editing.view;
                    const e = this.editor.model;
                    const n = t.document;
                    let o;
                    if (e.markers.has(LV)) {
                        const e = Array.from(this.editor.editing.mapper.markerNameToElements(LV));
                        const n = t.createRange(t.createPositionBefore(e[0]), t.createPositionAfter(e[e.length - 1]));
                        o = t.domConverter.viewRangeToDom(n);
                    } else o = ()=>{
                        const e = this._getSelectedLinkElement();
                        return e ? t.domConverter.mapViewToDom(e) : t.domConverter.viewRangeToDom(n.selection.getFirstRange());
                    };
                    return {
                        target: o
                    };
                }
                _getSelectedLinkElement() {
                    const t = this.editor.editing.view;
                    const e = t.document.selection;
                    const n = e.getSelectedElement();
                    if (e.isCollapsed || n && iP(n)) return NV(e.getFirstPosition());
                    else {
                        const n = e.getFirstRange().getTrimmed();
                        const o = NV(n.start);
                        const i = NV(n.end);
                        if (!o || o != i) return null;
                        if (t.createRangeIn(o).getTrimmed().isEqual(n)) return o;
                        else return null;
                    }
                }
                _showFakeVisualSelection() {
                    const t = this.editor.model;
                    t.change((e)=>{
                        const n = t.document.selection.getFirstRange();
                        if (t.markers.has(LV)) e.updateMarker(LV, {
                            range: n
                        });
                        else if (n.start.isAtEnd) {
                            const o = n.start.getLastMatchingPosition(({ item: e })=>!t.schema.isContent(e), {
                                boundaries: n
                            });
                            e.addMarker(LV, {
                                usingOperation: false,
                                affectsData: false,
                                range: e.createRange(o, n.end)
                            });
                        } else e.addMarker(LV, {
                            usingOperation: false,
                            affectsData: false,
                            range: n
                        });
                    });
                }
                _hideFakeVisualSelection() {
                    const t = this.editor.model;
                    if (t.markers.has(LV)) t.change((t)=>{
                        t.removeMarker(LV);
                    });
                }
            }
            function NV(t) {
                return t.getAncestors().find((t)=>UO(t)) || null;
            }
            const FV = 4;
            const HV = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
            const jV = 2;
            class qV extends Pu {
                static get requires() {
                    return [
                        mT
                    ];
                }
                static get pluginName() {
                    return "AutoLink";
                }
                init() {
                    const t = this.editor;
                    const e = t.model.document.selection;
                    e.on("change:range", ()=>{
                        this.isEnabled = !e.anchor.parent.is("element", "codeBlock");
                    });
                    this._enableTypingHandling();
                }
                afterInit() {
                    this._enableEnterHandling();
                    this._enableShiftEnterHandling();
                }
                _enableTypingHandling() {
                    const t = this.editor;
                    const e = new wT(t.model, (t)=>{
                        if (!WV(t)) return;
                        const e = $V(t.substr(0, t.length - 1));
                        if (e) return {
                            url: e
                        };
                    });
                    e.on("matched:data", (e, n)=>{
                        const { batch: o, range: i, url: r } = n;
                        if (!o.isTyping) return;
                        const s = i.end.getShiftedBy(-1);
                        const a = s.getShiftedBy(-r.length);
                        const c = t.model.createRange(a, s);
                        this._applyAutoLink(r, c);
                    });
                    e.bind("isEnabled").to(this);
                }
                _enableEnterHandling() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.commands.get("enter");
                    if (!n) return;
                    n.on("execute", ()=>{
                        const t = e.document.selection.getFirstPosition();
                        if (!t.parent.previousSibling) return;
                        const n = e.createRangeIn(t.parent.previousSibling);
                        this._checkAndApplyAutoLinkOnRange(n);
                    });
                }
                _enableShiftEnterHandling() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.commands.get("shiftEnter");
                    if (!n) return;
                    n.on("execute", ()=>{
                        const t = e.document.selection.getFirstPosition();
                        const n = e.createRange(e.createPositionAt(t.parent, 0), t.getShiftedBy(-1));
                        this._checkAndApplyAutoLinkOnRange(n);
                    });
                }
                _checkAndApplyAutoLinkOnRange(t) {
                    const e = this.editor.model;
                    const { text: n, range: o } = bT(t, e);
                    const i = $V(n);
                    if (i) {
                        const t = e.createRange(o.end.getShiftedBy(-i.length), o.end);
                        this._applyAutoLink(i, t);
                    }
                }
                _applyAutoLink(t, e) {
                    const n = this.editor.model;
                    const o = this.editor.config.get("link.defaultProtocol");
                    const i = eV(t, o);
                    if (!this.isEnabled || !GV(e, n) || !nV(i) || UV(e)) return;
                    this._persistAutoLink(i, e);
                }
                _persistAutoLink(t, e) {
                    const n = this.editor.model;
                    const o = this.editor.plugins.get("Delete");
                    n.enqueueChange((i)=>{
                        i.setAttribute("linkHref", t, e);
                        n.enqueueChange(()=>{
                            o.requestUndoOnBackspace();
                        });
                    });
                }
            }
            function WV(t) {
                return t.length > FV && t[t.length - 1] === " " && t[t.length - 2] !== " ";
            }
            function $V(t) {
                const e = HV.exec(t);
                return e ? e[jV] : null;
            }
            function GV(t, e) {
                return e.schema.checkAttributeInSelection(e.createSelection(t), "linkHref");
            }
            function UV(t) {
                const e = t.start.nodeAfter;
                return !!e && e.hasAttribute("linkHref");
            }
            class KV extends Pu {
                static get requires() {
                    return [
                        mV,
                        zV,
                        qV
                    ];
                }
                static get pluginName() {
                    return "Link";
                }
            }
            class ZV extends null {
                static get requires() {
                    return [
                        "ImageEditing",
                        "ImageUtils",
                        LinkEditing
                    ];
                }
                static get pluginName() {
                    return "LinkImageEditing";
                }
                init() {
                    const t = this.editor;
                    const e = t.model.schema;
                    if (t.plugins.has("ImageBlockEditing")) e.extend("imageBlock", {
                        allowAttributes: [
                            "linkHref"
                        ]
                    });
                    t.conversion.for("upcast").add(JV(t));
                    t.conversion.for("downcast").add(YV(t));
                    this._enableAutomaticDecorators();
                    this._enableManualDecorators();
                }
                _enableAutomaticDecorators() {
                    const t = this.editor;
                    const e = t.commands.get("link");
                    const n = e.automaticDecorators;
                    if (n.length) t.conversion.for("downcast").add(n.getDispatcherForLinkedImage());
                }
                _enableManualDecorators() {
                    const t = this.editor;
                    const e = t.commands.get("link");
                    for (const n of e.manualDecorators){
                        if (t.plugins.has("ImageBlockEditing")) t.model.schema.extend("imageBlock", {
                            allowAttributes: n.id
                        });
                        if (t.plugins.has("ImageInlineEditing")) t.model.schema.extend("imageInline", {
                            allowAttributes: n.id
                        });
                        t.conversion.for("downcast").add(QV(n));
                        t.conversion.for("upcast").add(XV(t, n));
                    }
                }
            }
            function JV(t) {
                const e = t.plugins.has("ImageInlineEditing");
                const n = t.plugins.get("ImageUtils");
                return (t)=>{
                    t.on("element:a", (t, o, i)=>{
                        const r = o.viewItem;
                        const s = n.findViewImgElement(r);
                        if (!s) return;
                        const a = s.findAncestor((t)=>n.isBlockImageView(t));
                        if (e && !a) return;
                        const c = {
                            attributes: [
                                "href"
                            ]
                        };
                        if (!i.consumable.consume(r, c)) return;
                        const l = r.getAttribute("href");
                        if (!l) return;
                        let d = o.modelCursor.parent;
                        if (!d.is("element", "imageBlock")) {
                            const t = i.convertItem(s, o.modelCursor);
                            o.modelRange = t.modelRange;
                            o.modelCursor = t.modelCursor;
                            d = o.modelCursor.nodeBefore;
                        }
                        if (d && d.is("element", "imageBlock")) i.writer.setAttribute("linkHref", l, d);
                    }, {
                        priority: "high"
                    });
                };
            }
            function YV(t) {
                const e = t.plugins.get("ImageUtils");
                return (t)=>{
                    t.on("attribute:linkHref:imageBlock", (t, n, o)=>{
                        if (!o.consumable.consume(n.item, t.name)) return;
                        const i = o.mapper.toViewElement(n.item);
                        const r = o.writer;
                        const s = Array.from(i.getChildren()).find((t)=>t.is("element", "a"));
                        const a = e.findViewImgElement(i);
                        const c = a.parent.is("element", "picture") ? a.parent : a;
                        if (s) {
                            if (n.attributeNewValue) r.setAttribute("href", n.attributeNewValue, s);
                            else {
                                r.move(r.createRangeOn(c), r.createPositionAt(i, 0));
                                r.remove(s);
                            }
                        } else {
                            const t = r.createContainerElement("a", {
                                href: n.attributeNewValue
                            });
                            r.insert(r.createPositionAt(i, 0), t);
                            r.move(r.createRangeOn(c), r.createPositionAt(t, 0));
                        }
                    }, {
                        priority: "high"
                    });
                };
            }
            function QV(t) {
                return (e)=>{
                    e.on(`attribute:${t.id}:imageBlock`, (e, n, o)=>{
                        const i = o.mapper.toViewElement(n.item);
                        const r = Array.from(i.getChildren()).find((t)=>t.is("element", "a"));
                        if (!r) return;
                        for (const [e, n] of toMap(t.attributes))o.writer.setAttribute(e, n, r);
                        if (t.classes) o.writer.addClass(t.classes, r);
                        for(const e in t.styles)o.writer.setStyle(e, t.styles[e], r);
                    });
                };
            }
            function XV(t, e) {
                const n = t.plugins.has("ImageInlineEditing");
                const o = t.plugins.get("ImageUtils");
                return (t)=>{
                    t.on("element:a", (t, i, r)=>{
                        const s = i.viewItem;
                        const a = o.findViewImgElement(s);
                        if (!a) return;
                        const c = a.findAncestor((t)=>o.isBlockImageView(t));
                        if (n && !c) return;
                        const l = new Matcher(e._createPattern());
                        const d = l.match(s);
                        if (!d) return;
                        if (!r.consumable.consume(s, d.match)) return;
                        const u = i.modelCursor.nodeBefore || i.modelCursor.parent;
                        r.writer.setAttribute(e.id, true, u);
                    }, {
                        priority: "high"
                    });
                };
            }
            class tM extends null {
                static get requires() {
                    return [
                        LinkEditing,
                        LinkUI,
                        "ImageBlockEditing"
                    ];
                }
                static get pluginName() {
                    return "LinkImageUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.editing.view.document;
                    this.listenTo(e, "click", (e, n)=>{
                        if (this._isSelectedLinkedImage(t.model.document.selection)) {
                            n.preventDefault();
                            e.stop();
                        }
                    }, {
                        priority: "high"
                    });
                    this._createToolbarLinkImageButton();
                }
                _createToolbarLinkImageButton() {
                    const t = this.editor;
                    const e = t.t;
                    t.ui.componentFactory.add("linkImage", (n)=>{
                        const o = new ButtonView(n);
                        const i = t.plugins.get("LinkUI");
                        const r = t.commands.get("link");
                        o.set({
                            isEnabled: true,
                            label: e("Link image"),
                            icon: linkIcon,
                            keystroke: LINK_KEYSTROKE,
                            tooltip: true,
                            isToggleable: true
                        });
                        o.bind("isEnabled").to(r, "isEnabled");
                        o.bind("isOn").to(r, "value", (t)=>!!t);
                        this.listenTo(o, "execute", ()=>{
                            if (this._isSelectedLinkedImage(t.model.document.selection)) i._addActionsView();
                            else i._showUI(true);
                        });
                        return o;
                    });
                }
                _isSelectedLinkedImage(t) {
                    const e = t.getSelectedElement();
                    const n = this.editor.plugins.get("ImageUtils");
                    return n.isImage(e) && e.hasAttribute("linkHref");
                }
            }
            var eM = n(4330);
            var nM = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            nM.insert = "head";
            nM.singleton = true;
            var oM = Rl()(eM.Z, nM);
            const iM = eM.Z.locals || {};
            class rM extends null {
                static get requires() {
                    return [
                        LinkImageEditing,
                        LinkImageUI
                    ];
                }
                static get pluginName() {
                    return "LinkImage";
                }
            }
            class sM {
                constructor(t, e){
                    this._startElement = t;
                    this._referenceIndent = t.getAttribute("listIndent");
                    this._isForward = e.direction == "forward";
                    this._includeSelf = !!e.includeSelf;
                    this._sameAttributes = nl(e.sameAttributes || []);
                    this._sameIndent = !!e.sameIndent;
                    this._lowerIndent = !!e.lowerIndent;
                    this._higherIndent = !!e.higherIndent;
                }
                static first(t, e) {
                    const n = new this(t, e);
                    const o = n[Symbol.iterator]();
                    return fl(o);
                }
                *[Symbol.iterator]() {
                    const t = [];
                    for (const { node: e } of aM(this._getStartNode(), this._isForward ? "forward" : "backward")){
                        const n = e.getAttribute("listIndent");
                        if (n < this._referenceIndent) {
                            if (!this._lowerIndent) break;
                            this._referenceIndent = n;
                        } else if (n > this._referenceIndent) {
                            if (!this._higherIndent) continue;
                            if (!this._isForward) {
                                t.push(e);
                                continue;
                            }
                        } else {
                            if (!this._sameIndent) {
                                if (this._higherIndent) {
                                    if (t.length) {
                                        yield* t;
                                        t.length = 0;
                                    }
                                    break;
                                }
                                continue;
                            }
                            if (this._sameAttributes.some((t)=>e.getAttribute(t) !== this._startElement.getAttribute(t))) break;
                        }
                        if (t.length) {
                            yield* t;
                            t.length = 0;
                        }
                        yield e;
                    }
                }
                _getStartNode() {
                    if (this._includeSelf) return this._startElement;
                    return this._isForward ? this._startElement.nextSibling : this._startElement.previousSibling;
                }
            }
            function* aM(t, e = "forward") {
                const n = e == "forward";
                const o = [];
                let i = null;
                while(dM(t)){
                    let e = null;
                    if (i) {
                        const n = t.getAttribute("listIndent");
                        const r = i.getAttribute("listIndent");
                        if (n > r) o[r] = i;
                        else if (n < r) {
                            e = o[n];
                            o.length = n;
                        } else e = i;
                    }
                    yield {
                        node: t,
                        previous: i,
                        previousNodeInList: e
                    };
                    i = t;
                    t = n ? t.nextSibling : t.previousSibling;
                }
            }
            class cM {
                constructor(t){
                    this._listHead = t;
                }
                [Symbol.iterator]() {
                    return aM(this._listHead, "forward");
                }
            }
            class lM {
                static next() {
                    return uid();
                }
            }
            function dM(t) {
                return !!t && t.is("element") && t.hasAttribute("listItemId");
            }
            function uM(t, e = {}) {
                return [
                    ...hM(t, {
                        ...e,
                        direction: "backward"
                    }),
                    ...hM(t, {
                        ...e,
                        direction: "forward"
                    })
                ];
            }
            function hM(t, e = {}) {
                const n = e.direction == "forward";
                const o = Array.from(new ListWalker(t, {
                    ...e,
                    includeSelf: n,
                    sameIndent: true,
                    sameAttributes: "listItemId"
                }));
                return n ? o : o.reverse();
            }
            function fM(t) {
                return Array.from(new ListWalker(t, {
                    direction: "forward",
                    higherIndent: true
                }));
            }
            function pM(t) {
                const e = new ListWalker(t, {
                    sameIndent: true,
                    sameAttributes: "listType"
                });
                const n = new ListWalker(t, {
                    sameIndent: true,
                    sameAttributes: "listType",
                    includeSelf: true,
                    direction: "forward"
                });
                return [
                    ...Array.from(e).reverse(),
                    ...n
                ];
            }
            function gM(t) {
                const e = ListWalker.first(t, {
                    sameIndent: true,
                    sameAttributes: "listItemId"
                });
                if (!e) return true;
                return false;
            }
            function mM(t) {
                const e = ListWalker.first(t, {
                    direction: "forward",
                    sameIndent: true,
                    sameAttributes: "listItemId"
                });
                if (!e) return true;
                return false;
            }
            function kM(t, e = {}) {
                t = toArray(t);
                const n = e.withNested !== false;
                const o = new Set;
                for (const e of t)for (const t of uM(e, {
                    higherIndent: n
                }))o.add(t);
                return EM(o);
            }
            function bM(t) {
                t = toArray(t);
                const e = new Set;
                for (const n of t)for (const t of pM(n))e.add(t);
                return EM(e);
            }
            function wM(t, e) {
                const n = hM(t, {
                    direction: "forward"
                });
                const o = lM.next();
                for (const t of n)e.setAttribute("listItemId", o, t);
                return n;
            }
            function _M(t, e, n) {
                const o = {};
                for (const [t, n] of e.getAttributes())if (t.startsWith("list")) o[t] = n;
                const i = hM(t, {
                    direction: "forward"
                });
                for (const t of i)n.setAttributes(o, t);
                return i;
            }
            function AM(t, e, { expand: n, indentBy: o = 1 } = {}) {
                t = toArray(t);
                const i = n ? kM(t) : t;
                for (const t of i){
                    const n = t.getAttribute("listIndent") + o;
                    if (n < 0) CM(t, e);
                    else e.setAttribute("listIndent", n, t);
                }
                return i;
            }
            function vM(t, e) {
                t = toArray(t);
                const n = kM(t);
                const o = new Set;
                const i = Math.min(...n.map((t)=>t.getAttribute("listIndent")));
                const r = new Map;
                for (const t of n)r.set(t, ListWalker.first(t, {
                    lowerIndent: true
                }));
                for (const t of n){
                    if (o.has(t)) continue;
                    o.add(t);
                    const n = t.getAttribute("listIndent") - 1;
                    if (n < 0) {
                        CM(t, e);
                        continue;
                    }
                    if (t.getAttribute("listIndent") == i) {
                        const n = TM(t, r.get(t), e);
                        for (const t of n)o.add(t);
                        if (n.length) continue;
                    }
                    e.setAttribute("listIndent", n, t);
                }
                return EM(o);
            }
            function CM(t, e) {
                t = toArray(t);
                for (const n of t)if (n.is("element", "listItem")) e.rename(n, "paragraph");
                for (const n of t){
                    for (const t of n.getAttributeKeys())if (t.startsWith("list")) e.removeAttribute(t, n);
                }
                return t;
            }
            function yM(t) {
                if (!t.length) return false;
                const e = t[0].getAttribute("listItemId");
                if (!e) return false;
                return !t.some((t)=>t.getAttribute("listItemId") != e);
            }
            function xM(t, e) {
                const n = [];
                let o = Number.POSITIVE_INFINITY;
                for (const { node: i } of iterateSiblingListBlocks(t.nextSibling, "forward")){
                    const t = i.getAttribute("listIndent");
                    if (t == 0) break;
                    if (t < o) o = t;
                    const r = t - o;
                    e.setAttribute("listIndent", r, i);
                    n.push(i);
                }
                return n;
            }
            function EM(t) {
                return Array.from(t).filter((t)=>t.root.rootName !== "$graveyard").sort((t, e)=>t.index - e.index);
            }
            function DM(t) {
                const e = t.document.selection.getSelectedElement();
                if (!e) return null;
                if (t.schema.isObject(e) && t.schema.isBlock(e)) return e;
                return null;
            }
            function SM(t, e) {
                return e.checkChild(t.parent, "listItem") && e.checkChild(t, "$text") && !e.isObject(t);
            }
            function TM(t, e, n) {
                const o = hM(e, {
                    direction: "forward"
                });
                if (o.pop().index > t.index) return _M(t, e, n);
                return [];
            }
            class BM extends null {
                constructor(t, e){
                    super(t);
                    this._direction = e;
                }
                refresh() {
                    this.isEnabled = this._checkEnabled();
                }
                execute() {
                    const t = this.editor.model;
                    const e = PM(t.document.selection);
                    t.change((t)=>{
                        const n = [];
                        if (isSingleListItem(e) && !isFirstBlockOfListItem(e[0])) {
                            if (this._direction == "forward") n.push(...indentBlocks(e, t));
                            n.push(...splitListItemBefore(e[0], t));
                        } else if (this._direction == "forward") n.push(...indentBlocks(e, t, {
                            expand: true
                        }));
                        else n.push(...outdentBlocksWithMerge(e, t));
                        for (const e of n){
                            if (!e.hasAttribute("listType")) continue;
                            const n = ListWalker.first(e, {
                                sameIndent: true
                            });
                            if (n) t.setAttribute("listType", n.getAttribute("listType"), e);
                        }
                        this._fireAfterExecute(n);
                    });
                }
                _fireAfterExecute(t) {
                    this.fire("afterExecute", sortBlocks(new Set(t)));
                }
                _checkEnabled() {
                    let t = PM(this.editor.model.document.selection);
                    let e = t[0];
                    if (!e) return false;
                    if (this._direction == "backward") return true;
                    if (isSingleListItem(t) && !isFirstBlockOfListItem(t[0])) return true;
                    t = expandListBlocksToCompleteItems(t);
                    e = t[0];
                    const n = ListWalker.first(e, {
                        sameIndent: true
                    });
                    if (!n) return false;
                    if (n.getAttribute("listType") == e.getAttribute("listType")) return true;
                    return false;
                }
            }
            function PM(t) {
                const e = Array.from(t.getSelectedBlocks());
                const n = e.findIndex((t)=>!isListItemBlock(t));
                if (n != -1) e.length = n;
                return e;
            }
            class IM extends null {
                constructor(t, e){
                    super(t);
                    this.type = e;
                }
                refresh() {
                    this.value = this._getValue();
                    this.isEnabled = this._checkEnabled();
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    const o = getSelectedBlockObject(e);
                    const i = Array.from(n.selection.getSelectedBlocks()).filter((t)=>e.schema.checkAttribute(t, "listType") || canBecomeSimpleListItem(t, e.schema));
                    const r = t.forceValue !== undefined ? !t.forceValue : this.value;
                    e.change((t)=>{
                        if (r) {
                            const e = i[i.length - 1];
                            const n = getListItemBlocks(e, {
                                direction: "forward"
                            });
                            const o = [];
                            if (n.length > 1) o.push(...splitListItemBefore(n[1], t));
                            o.push(...removeListAttributes(i, t));
                            o.push(...outdentFollowingItems(e, t));
                            this._fireAfterExecute(o);
                        } else if ((o || n.selection.isCollapsed) && isListItemBlock(i[0])) {
                            const e = getListItems(o || i[0]);
                            for (const n of e)t.setAttribute("listType", this.type, n);
                            this._fireAfterExecute(e);
                        } else {
                            const n = [];
                            for (const o of i)if (!o.hasAttribute("listType")) {
                                if (!o.is("element", "listItem") && canBecomeSimpleListItem(o, e.schema)) t.rename(o, "listItem");
                                t.setAttributes({
                                    listIndent: 0,
                                    listItemId: ListItemUid.next(),
                                    listType: this.type
                                }, o);
                                n.push(o);
                            } else {
                                for (const e of expandListBlocksToCompleteItems(o, {
                                    withNested: false
                                }))if (e.getAttribute("listType") != this.type) {
                                    t.setAttribute("listType", this.type, e);
                                    n.push(e);
                                }
                            }
                            this._fireAfterExecute(n);
                        }
                    });
                }
                _fireAfterExecute(t) {
                    this.fire("afterExecute", sortBlocks(new Set(t)));
                }
                _getValue() {
                    const t = this.editor.model.document.selection;
                    const e = Array.from(t.getSelectedBlocks());
                    if (!e.length) return false;
                    for (const t of e){
                        if (t.getAttribute("listType") != this.type) return false;
                    }
                    return true;
                }
                _checkEnabled() {
                    const t = this.editor.model;
                    const e = t.schema;
                    const n = t.document.selection;
                    const o = Array.from(n.getSelectedBlocks());
                    if (!o.length) return false;
                    if (this.value) return true;
                    for (const t of o){
                        if (e.checkAttribute(t, "listType") || canBecomeSimpleListItem(t, e)) return true;
                    }
                    return false;
                }
            }
            class RM extends null {
                constructor(t, e){
                    super(t);
                    this._direction = e;
                }
                refresh() {
                    this.isEnabled = this._checkEnabled();
                }
                execute({ shouldMergeOnBlocksContentLevel: t = false } = {}) {
                    const e = this.editor.model;
                    const n = e.document.selection;
                    const o = [];
                    e.change((i)=>{
                        const { firstElement: r, lastElement: s } = this._getMergeSubjectElements(n, t);
                        const a = r.getAttribute("listIndent") || 0;
                        const c = s.getAttribute("listIndent");
                        const l = s.getAttribute("listItemId");
                        if (a != c) {
                            const t = getNestedListBlocks(s);
                            o.push(...indentBlocks([
                                s,
                                ...t
                            ], i, {
                                indentBy: a - c,
                                expand: a < c
                            }));
                        }
                        if (t) {
                            let t = n;
                            if (n.isCollapsed) t = i.createSelection(i.createRange(i.createPositionAt(r, "end"), i.createPositionAt(s, 0)));
                            e.deleteContent(t, {
                                doNotResetEntireContent: n.isCollapsed
                            });
                            const a = t.getLastPosition().parent;
                            const c = a.nextSibling;
                            o.push(a);
                            if (c && c !== s && c.getAttribute("listItemId") == l) o.push(...mergeListItemBefore(c, a, i));
                        } else o.push(...mergeListItemBefore(s, r, i));
                        this._fireAfterExecute(o);
                    });
                }
                _fireAfterExecute(t) {
                    this.fire("afterExecute", sortBlocks(new Set(t)));
                }
                _checkEnabled() {
                    const t = this.editor.model;
                    const e = t.document.selection;
                    const n = getSelectedBlockObject(t);
                    if (e.isCollapsed || n) {
                        const t = n || e.getFirstPosition().parent;
                        if (!isListItemBlock(t)) return false;
                        const o = this._direction == "backward" ? t.previousSibling : t.nextSibling;
                        if (!o) return false;
                        if (isSingleListItem([
                            t,
                            o
                        ])) return false;
                    } else {
                        const t = e.getLastPosition();
                        const n = e.getFirstPosition();
                        if (t.parent === n.parent) return false;
                        if (!isListItemBlock(t.parent)) return false;
                    }
                    return true;
                }
                _getMergeSubjectElements(t, e) {
                    const n = this.editor.model;
                    const o = getSelectedBlockObject(n);
                    let i, r;
                    if (t.isCollapsed || o) {
                        const n = o || t.getFirstPosition().parent;
                        const s = isFirstBlockOfListItem(n);
                        if (this._direction == "backward") {
                            r = n;
                            if (s && !e) i = ListWalker.first(n, {
                                sameIndent: true,
                                lowerIndent: true
                            });
                            else i = n.previousSibling;
                        } else {
                            i = n;
                            r = n.nextSibling;
                        }
                    } else {
                        i = t.getFirstPosition().parent;
                        r = t.getLastPosition().parent;
                    }
                    return {
                        firstElement: i,
                        lastElement: r
                    };
                }
            }
            class OM extends null {
                constructor(t, e){
                    super(t);
                    this._direction = e;
                }
                refresh() {
                    this.isEnabled = this._checkEnabled();
                }
                execute() {
                    const t = this.editor;
                    t.model.change((t)=>{
                        const e = splitListItemBefore(this._getStartBlock(), t);
                        this._fireAfterExecute(e);
                    });
                }
                _fireAfterExecute(t) {
                    this.fire("afterExecute", sortBlocks(new Set(t)));
                }
                _checkEnabled() {
                    const t = this.editor.model.document.selection;
                    const e = this._getStartBlock();
                    return t.isCollapsed && isListItemBlock(e) && !isFirstBlockOfListItem(e);
                }
                _getStartBlock() {
                    const t = this.editor.model.document;
                    const e = t.selection.getFirstPosition().parent;
                    return this._direction == "before" ? e : e.nextSibling;
                }
            }
            class VM extends null {
                static get pluginName() {
                    return "DocumentListUtils";
                }
                expandListBlocksToCompleteList(t) {
                    return expandListBlocksToCompleteList(t);
                }
                isFirstBlockOfListItem(t) {
                    return isFirstBlockOfListItem(t);
                }
                isListItemBlock(t) {
                    return isListItemBlock(t);
                }
                expandListBlocksToCompleteItems(t, e = {}) {
                    return expandListBlocksToCompleteItems(t, e);
                }
            }
            function MM(t, e) {
                const n = t.nodeBefore;
                if (!isListItemBlock(n)) {
                    const n = t.nodeAfter;
                    if (isListItemBlock(n)) e.set(n, n);
                } else {
                    let t = n;
                    for (const { node: n } of iterateSiblingListBlocks(t, "backward")){
                        t = n;
                        if (e.has(t)) return;
                    }
                    e.set(n, t);
                }
            }
            function LM(t, e) {
                let n = 0;
                let o = -1;
                let i = null;
                let r = false;
                for (const { node: s } of t){
                    const t = s.getAttribute("listIndent");
                    if (t > n) {
                        let a;
                        if (i === null) {
                            i = t - n;
                            a = n;
                        } else {
                            if (i > t) i = t;
                            a = t - i;
                        }
                        if (a > o + 1) a = o + 1;
                        e.setAttribute("listIndent", a, s);
                        r = true;
                        o = a;
                    } else {
                        i = null;
                        n = t + 1;
                        o = t;
                    }
                }
                return r;
            }
            function zM(t, e, n) {
                const o = new Set;
                let i = false;
                for (const { node: r } of t){
                    if (o.has(r)) continue;
                    let t = r.getAttribute("listType");
                    let s = r.getAttribute("listItemId");
                    if (e.has(s)) s = ListItemUid.next();
                    e.add(s);
                    if (r.is("element", "listItem")) {
                        if (r.getAttribute("listItemId") != s) {
                            n.setAttribute("listItemId", s, r);
                            i = true;
                        }
                        continue;
                    }
                    for (const e of getListItemBlocks(r, {
                        direction: "forward"
                    })){
                        o.add(e);
                        if (e.getAttribute("listType") != t) {
                            s = ListItemUid.next();
                            t = e.getAttribute("listType");
                        }
                        if (e.getAttribute("listItemId") != s) {
                            n.setAttribute("listItemId", s, e);
                            i = true;
                        }
                    }
                }
                return i;
            }
            function NM() {
                return (t, e, n)=>{
                    const { writer: o, schema: i } = n;
                    if (!e.modelRange) return;
                    const r = Array.from(e.modelRange.getItems({
                        shallow: true
                    })).filter((t)=>i.checkAttribute(t, "listItemId"));
                    if (!r.length) return;
                    const s = ListItemUid.next();
                    const a = getIndent(e.viewItem);
                    let c = e.viewItem.parent && e.viewItem.parent.is("element", "ol") ? "numbered" : "bulleted";
                    const l = r[0].getAttribute("listType");
                    if (l) c = l;
                    const d = {
                        listItemId: s,
                        listIndent: a,
                        listType: c
                    };
                    for (const t of r)if (!t.hasAttribute("listItemId")) o.setAttributes(d, t);
                    if (r.length > 1) {
                        if (r[1].getAttribute("listItemId") != d.listItemId) n.keepEmptyElement(r[0]);
                    }
                };
            }
            function FM() {
                return (t, e, n)=>{
                    if (!n.consumable.test(e.viewItem, {
                        name: true
                    })) return;
                    const o = new UpcastWriter(e.viewItem.document);
                    for (const t of Array.from(e.viewItem.getChildren()))if (!isListItemView(t) && !isListView(t)) o.remove(t);
                };
            }
            function HM(t, e, n, o) {
                return ()=>{
                    const o = t.document.differ.getChanges();
                    const s = [];
                    const a = new Map;
                    const c = new Set;
                    for (const t of o){
                        if (t.type == "insert" && t.name != "$text") {
                            findAndAddListHeadToMap(t.position, a);
                            if (!t.attributes.has("listItemId")) findAndAddListHeadToMap(t.position.getShiftedBy(t.length), a);
                            else c.add(t.position.nodeAfter);
                        } else if (t.type == "remove" && t.attributes.has("listItemId")) findAndAddListHeadToMap(t.position, a);
                        else if (t.type == "attribute") {
                            const e = t.range.start.nodeAfter;
                            if (n.includes(t.attributeKey)) {
                                findAndAddListHeadToMap(t.range.start, a);
                                if (t.attributeNewValue === null) {
                                    findAndAddListHeadToMap(t.range.start.getShiftedBy(1), a);
                                    if (r(e)) s.push(e);
                                } else c.add(e);
                            } else if (isListItemBlock(e)) {
                                if (r(e)) s.push(e);
                            }
                        }
                    }
                    for (const t of a.values())s.push(...i(t, c));
                    for (const t of new Set(s))e.reconvertItem(t);
                };
                function i(t, e) {
                    const o = [];
                    const i = new Set;
                    const a = [];
                    for (const { node: c, previous: l } of iterateSiblingListBlocks(t, "forward")){
                        if (i.has(c)) continue;
                        const t = c.getAttribute("listIndent");
                        if (l && t < l.getAttribute("listIndent")) a.length = t + 1;
                        a[t] = Object.fromEntries(Array.from(c.getAttributes()).filter(([t])=>n.includes(t)));
                        const d = getListItemBlocks(c, {
                            direction: "forward"
                        });
                        for (const t of d){
                            i.add(t);
                            if (r(t, d)) o.push(t);
                            else if (s(t, a, e)) o.push(t);
                        }
                    }
                    return o;
                }
                function r(t, i) {
                    const r = e.mapper.toViewElement(t);
                    if (!r) return false;
                    const s = o.fire("checkElement", {
                        modelElement: t,
                        viewElement: r
                    });
                    if (s) return true;
                    if (!t.is("element", "paragraph") && !t.is("element", "listItem")) return false;
                    const a = JM(t, n, i);
                    if (a && r.is("element", "p")) return true;
                    else if (!a && r.is("element", "span")) return true;
                    return false;
                }
                function s(t, n, i) {
                    if (i.has(t)) return false;
                    const r = e.mapper.toViewElement(t);
                    let s = n.length - 1;
                    for(let t = r.parent; !t.is("editableElement"); t = t.parent){
                        const e = isListItemView(t);
                        const i = isListView(t);
                        if (!i && !e) continue;
                        const r = `checkAttributes:${e ? "item" : "list"}`;
                        const a = o.fire(r, {
                            viewElement: t,
                            modelAttributes: n[s]
                        });
                        if (a) break;
                        if (i) {
                            s--;
                            if (s < 0) return false;
                        }
                    }
                    return true;
                }
            }
            function jM(t, e, n, { dataPipeline: o } = {}) {
                const i = ZM(t);
                return (r, s, a)=>{
                    const { writer: c, mapper: l, consumable: d } = a;
                    const u = s.item;
                    if (!t.includes(s.attributeKey)) return;
                    if (!i(u, d)) return;
                    const h = WM(u, l, n);
                    $M(h, c, l);
                    UM(h, c);
                    const f = GM(u, h, e, c, {
                        dataPipeline: o
                    });
                    KM(u, f, e, c);
                };
            }
            function qM(t, { dataPipeline: e } = {}) {
                return (n, { writer: o })=>{
                    if (!JM(n, t)) return null;
                    if (!e) return o.createContainerElement("span", {
                        class: "ck-list-bogus-paragraph"
                    });
                    const i = o.createContainerElement("p");
                    o.setCustomProperty("dataPipeline:transparentRendering", true, i);
                    return i;
                };
            }
            function WM(t, e, n) {
                const o = n.createRangeOn(t);
                const i = e.toViewRange(o).getTrimmed();
                return i.end.nodeBefore;
            }
            function $M(t, e, n) {
                while(t.parent.is("attributeElement") && t.parent.getCustomProperty("listItemWrapper"))e.unwrap(e.createRangeIn(t.parent), t.parent);
                const o = e.createPositionBefore(t).getWalker({
                    direction: "backward"
                });
                const i = [];
                for (const { item: t } of o){
                    if (t.is("element") && n.toModelElement(t)) break;
                    if (t.is("element") && t.getCustomProperty("listItemMarker")) i.push(t);
                }
                for (const t of i)e.remove(t);
            }
            function GM(t, e, n, o, { dataPipeline: i }) {
                let r = o.createRangeOn(e);
                if (!isFirstBlockOfListItem(t)) return r;
                for (const s of n){
                    if (s.scope != "itemMarker") continue;
                    const n = s.createElement(o, t, {
                        dataPipeline: i
                    });
                    if (!n) continue;
                    o.setCustomProperty("listItemMarker", true, n);
                    o.insert(r.start, n);
                    r = o.createRange(o.createPositionBefore(n), o.createPositionAfter(e));
                    if (!s.createWrapperElement || !s.canWrapElement) continue;
                    const a = s.createWrapperElement(o, t, {
                        dataPipeline: i
                    });
                    o.setCustomProperty("listItemWrapper", true, a);
                    if (s.canWrapElement(t)) r = o.wrap(r, a);
                    else {
                        r = o.wrap(o.createRangeOn(n), a);
                        r = o.createRange(r.start, o.createPositionAfter(e));
                    }
                }
                return r;
            }
            function UM(t, e) {
                let n = t.parent;
                while(n.is("attributeElement") && [
                    "ul",
                    "ol",
                    "li"
                ].includes(n.name)){
                    const o = n.parent;
                    e.unwrap(e.createRangeOn(t), n);
                    n = o;
                }
            }
            function KM(t, e, n, o) {
                if (!t.hasAttribute("listIndent")) return;
                const i = t.getAttribute("listIndent");
                let r = t;
                for(let t = i; t >= 0; t--){
                    const i = createListItemElement(o, t, r.getAttribute("listItemId"));
                    const s = createListElement(o, t, r.getAttribute("listType"));
                    for (const t of n)if ((t.scope == "list" || t.scope == "item") && r.hasAttribute(t.attributeName)) t.setAttributeOnDowncast(o, r.getAttribute(t.attributeName), t.scope == "list" ? s : i);
                    e = o.wrap(e, i);
                    e = o.wrap(e, s);
                    if (t == 0) break;
                    r = ListWalker.first(r, {
                        lowerIndent: true
                    });
                    if (!r) break;
                }
            }
            function ZM(t) {
                return (e, n)=>{
                    const o = [];
                    for (const n of t)if (e.hasAttribute(n)) o.push(`attribute:${n}`);
                    if (!o.every((t)=>n.test(e, t) !== false)) return false;
                    o.forEach((t)=>n.consume(e, t));
                    return true;
                };
            }
            function JM(t, e, n = getAllListItemBlocks(t)) {
                if (!isListItemBlock(t)) return false;
                for (const n of t.getAttributeKeys()){
                    if (n.startsWith("selection:")) continue;
                    if (!e.includes(n)) return false;
                }
                return n.length < 2;
            }
            var YM = n(3190);
            var QM = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            QM.insert = "head";
            QM.singleton = true;
            var XM = Rl()(YM.Z, QM);
            const tL = YM.Z.locals || {};
            var eL = n(4784);
            var nL = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            nL.insert = "head";
            nL.singleton = true;
            var oL = Rl()(eL.Z, nL);
            const iL = eL.Z.locals || {};
            const rL = null;
            class sL extends null {
                static get pluginName() {
                    return "DocumentListEditing";
                }
                static get requires() {
                    return [
                        Enter,
                        Delete,
                        DocumentListUtils,
                        ClipboardPipeline
                    ];
                }
                constructor(t){
                    super(t);
                    this._downcastStrategies = [];
                    t.config.define("list.multiBlock", true);
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.config.get("list.multiBlock");
                    if (t.plugins.has("ListEditing")) throw new CKEditorError("document-list-feature-conflict", this, {
                        conflictPlugin: "ListEditing"
                    });
                    e.schema.register("$listItem", {
                        allowAttributes: rL
                    });
                    if (n) {
                        e.schema.extend("$container", {
                            allowAttributesOf: "$listItem"
                        });
                        e.schema.extend("$block", {
                            allowAttributesOf: "$listItem"
                        });
                        e.schema.extend("$blockObject", {
                            allowAttributesOf: "$listItem"
                        });
                    } else e.schema.register("listItem", {
                        inheritAllFrom: "$block",
                        allowAttributesOf: "$listItem"
                    });
                    for (const t of rL)e.schema.setAttributeProperties(t, {
                        copyOnReplace: true
                    });
                    t.commands.add("numberedList", new DocumentListCommand(t, "numbered"));
                    t.commands.add("bulletedList", new DocumentListCommand(t, "bulleted"));
                    t.commands.add("indentList", new DocumentListIndentCommand(t, "forward"));
                    t.commands.add("outdentList", new DocumentListIndentCommand(t, "backward"));
                    t.commands.add("splitListItemBefore", new DocumentListSplitCommand(t, "before"));
                    t.commands.add("splitListItemAfter", new DocumentListSplitCommand(t, "after"));
                    if (n) {
                        t.commands.add("mergeListItemBackward", new DocumentListMergeCommand(t, "backward"));
                        t.commands.add("mergeListItemForward", new DocumentListMergeCommand(t, "forward"));
                    }
                    this._setupDeleteIntegration();
                    this._setupEnterIntegration();
                    this._setupTabIntegration();
                    this._setupClipboardIntegration();
                }
                afterInit() {
                    const t = this.editor;
                    const e = t.commands;
                    const n = e.get("indent");
                    const o = e.get("outdent");
                    if (n) n.registerChildCommand(e.get("indentList"), {
                        priority: "high"
                    });
                    if (o) o.registerChildCommand(e.get("outdentList"), {
                        priority: "lowest"
                    });
                    this._setupModelPostFixing();
                    this._setupConversion();
                }
                registerDowncastStrategy(t) {
                    this._downcastStrategies.push(t);
                }
                getListAttributeNames() {
                    return [
                        ...rL,
                        ...this._downcastStrategies.map((t)=>t.attributeName)
                    ];
                }
                _setupDeleteIntegration() {
                    const t = this.editor;
                    const e = t.commands.get("mergeListItemBackward");
                    const n = t.commands.get("mergeListItemForward");
                    this.listenTo(t.editing.view.document, "delete", (o, i)=>{
                        const r = t.model.document.selection;
                        if (getSelectedBlockObject(t.model)) return;
                        t.model.change(()=>{
                            const s = r.getFirstPosition();
                            if (r.isCollapsed && i.direction == "backward") {
                                if (!s.isAtStart) return;
                                const n = s.parent;
                                if (!isListItemBlock(n)) return;
                                const r = ListWalker.first(n, {
                                    sameAttributes: "listType",
                                    sameIndent: true
                                });
                                if (!r && n.getAttribute("listIndent") === 0) {
                                    if (!isLastBlockOfListItem(n)) t.execute("splitListItemAfter");
                                    t.execute("outdentList");
                                } else {
                                    if (!e || !e.isEnabled) return;
                                    e.execute({
                                        shouldMergeOnBlocksContentLevel: lL(t.model, "backward")
                                    });
                                }
                                i.preventDefault();
                                o.stop();
                            } else {
                                if (r.isCollapsed && !r.getLastPosition().isAtEnd) return;
                                if (!n || !n.isEnabled) return;
                                n.execute({
                                    shouldMergeOnBlocksContentLevel: lL(t.model, "forward")
                                });
                                i.preventDefault();
                                o.stop();
                            }
                        });
                    }, {
                        context: "li"
                    });
                }
                _setupEnterIntegration() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.commands;
                    const o = n.get("enter");
                    this.listenTo(t.editing.view.document, "enter", (n, o)=>{
                        const i = e.document;
                        const r = i.selection.getFirstPosition().parent;
                        if (i.selection.isCollapsed && isListItemBlock(r) && r.isEmpty && !o.isSoft) {
                            const e = isFirstBlockOfListItem(r);
                            const i = isLastBlockOfListItem(r);
                            if (e && i) {
                                t.execute("outdentList");
                                o.preventDefault();
                                n.stop();
                            } else if (e && !i) {
                                t.execute("splitListItemAfter");
                                o.preventDefault();
                                n.stop();
                            } else if (i) {
                                t.execute("splitListItemBefore");
                                o.preventDefault();
                                n.stop();
                            }
                        }
                    }, {
                        context: "li"
                    });
                    this.listenTo(o, "afterExecute", ()=>{
                        const e = n.get("splitListItemBefore");
                        e.refresh();
                        if (!e.isEnabled) return;
                        const o = t.model.document;
                        const i = o.selection.getLastPosition().parent;
                        const r = getAllListItemBlocks(i);
                        if (r.length === 2) e.execute();
                    });
                }
                _setupTabIntegration() {
                    const t = this.editor;
                    this.listenTo(t.editing.view.document, "tab", (e, n)=>{
                        const o = n.shiftKey ? "outdentList" : "indentList";
                        const i = this.editor.commands.get(o);
                        if (i.isEnabled) {
                            t.execute(o);
                            n.stopPropagation();
                            n.preventDefault();
                            e.stop();
                        }
                    }, {
                        context: "li"
                    });
                }
                _setupConversion() {
                    const t = this.editor;
                    const e = t.model;
                    const n = this.getListAttributeNames();
                    const o = t.config.get("list.multiBlock");
                    const i = o ? "paragraph" : "listItem";
                    t.conversion.for("upcast").elementToElement({
                        view: "li",
                        model: (t, { writer: e })=>e.createElement(i, {
                                listType: ""
                            })
                    }).elementToElement({
                        view: "p",
                        model: (t, { writer: e })=>{
                            if (t.parent && t.parent.is("element", "li")) return e.createElement(i, {
                                listType: ""
                            });
                            return null;
                        },
                        converterPriority: "high"
                    }).add((t)=>{
                        t.on("element:li", listItemUpcastConverter());
                        t.on("element:ul", listUpcastCleanList(), {
                            priority: "high"
                        });
                        t.on("element:ol", listUpcastCleanList(), {
                            priority: "high"
                        });
                    });
                    if (!o) t.conversion.for("downcast").elementToElement({
                        model: "listItem",
                        view: "p"
                    });
                    t.conversion.for("editingDowncast").elementToElement({
                        model: i,
                        view: bogusParagraphCreator(n),
                        converterPriority: "high"
                    }).add((t)=>{
                        t.on("attribute", listItemDowncastConverter(n, this._downcastStrategies, e));
                    });
                    t.conversion.for("dataDowncast").elementToElement({
                        model: i,
                        view: bogusParagraphCreator(n, {
                            dataPipeline: true
                        }),
                        converterPriority: "high"
                    }).add((t)=>{
                        t.on("attribute", listItemDowncastConverter(n, this._downcastStrategies, e, {
                            dataPipeline: true
                        }));
                    });
                    this.listenTo(e.document, "change:data", reconvertItemsOnDataChange(e, t.editing, n, this), {
                        priority: "high"
                    });
                    this.on("checkAttributes:item", (t, { viewElement: e, modelAttributes: n })=>{
                        if (e.id != n.listItemId) {
                            t.return = true;
                            t.stop();
                        }
                    });
                    this.on("checkAttributes:list", (t, { viewElement: e, modelAttributes: n })=>{
                        if (e.name != getViewElementNameForListType(n.listType) || e.id != getViewElementIdForListType(n.listType, n.listIndent)) {
                            t.return = true;
                            t.stop();
                        }
                    });
                }
                _setupModelPostFixing() {
                    const t = this.editor.model;
                    const e = this.getListAttributeNames();
                    t.document.registerPostFixer((n)=>aL(t, n, e, this));
                    this.on("postFixer", (t, { listNodes: e, writer: n })=>{
                        t.return = fixListIndents(e, n) || t.return;
                    }, {
                        priority: "high"
                    });
                    this.on("postFixer", (t, { listNodes: e, writer: n, seenIds: o })=>{
                        t.return = fixListItemIds(e, o, n) || t.return;
                    }, {
                        priority: "high"
                    });
                }
                _setupClipboardIntegration() {
                    const t = this.editor.model;
                    const e = this.editor.plugins.get("ClipboardPipeline");
                    this.listenTo(t, "insertContent", cL(t), {
                        priority: "high"
                    });
                    this.listenTo(e, "outputTransformation", (e, n)=>{
                        t.change((t)=>{
                            const e = Array.from(n.content.getChildren());
                            const o = e[e.length - 1];
                            if (e.length > 1 && o.is("element") && o.isEmpty) {
                                const n = e.slice(0, -1);
                                if (n.every(isListItemBlock)) t.remove(o);
                            }
                            if (n.method == "copy" || n.method == "cut") {
                                const e = Array.from(n.content.getChildren());
                                const o = isSingleListItem(e);
                                if (o) removeListAttributes(e, t);
                            }
                        });
                    });
                }
            }
            function aL(t, e, n, o) {
                const i = t.document.differ.getChanges();
                const r = new Map;
                const s = o.editor.config.get("list.multiBlock");
                let a = false;
                for (const o of i){
                    if (o.type == "insert" && o.name != "$text") {
                        const i = o.position.nodeAfter;
                        if (!t.schema.checkAttribute(i, "listItemId")) {
                            for (const t of Array.from(i.getAttributeKeys()))if (n.includes(t)) {
                                e.removeAttribute(t, i);
                                a = true;
                            }
                        }
                        findAndAddListHeadToMap(o.position, r);
                        if (!o.attributes.has("listItemId")) findAndAddListHeadToMap(o.position.getShiftedBy(o.length), r);
                        for (const { item: e, previousPosition: n } of t.createRangeIn(i))if (isListItemBlock(e)) findAndAddListHeadToMap(n, r);
                    } else if (o.type == "remove") findAndAddListHeadToMap(o.position, r);
                    else if (o.type == "attribute" && n.includes(o.attributeKey)) {
                        findAndAddListHeadToMap(o.range.start, r);
                        if (o.attributeNewValue === null) findAndAddListHeadToMap(o.range.start.getShiftedBy(1), r);
                    }
                    if (!s && o.type == "attribute" && rL.includes(o.attributeKey)) {
                        const t = o.range.start.nodeAfter;
                        if (o.attributeNewValue === null && t && t.is("element", "listItem")) {
                            e.rename(t, "paragraph");
                            a = true;
                        } else if (o.attributeOldValue === null && t && t.is("element") && t.name != "listItem") {
                            e.rename(t, "listItem");
                            a = true;
                        }
                    }
                }
                const c = new Set;
                for (const t of r.values())a = o.fire("postFixer", {
                    listNodes: new ListBlocksIterable(t),
                    listHead: t,
                    writer: e,
                    seenIds: c
                }) || a;
                return a;
            }
            function cL(t) {
                return (e, [n, o])=>{
                    const i = n.is("documentFragment") ? n.getChild(0) : n;
                    if (!isListItemBlock(i)) return;
                    let r;
                    if (!o) r = t.document.selection;
                    else r = t.createSelection(o);
                    const s = r.getFirstPosition();
                    let a = null;
                    if (isListItemBlock(s.parent)) a = s.parent;
                    else if (isListItemBlock(s.nodeBefore)) a = s.nodeBefore;
                    if (!a) return;
                    const c = a.getAttribute("listIndent") - i.getAttribute("listIndent");
                    if (c <= 0) return;
                    t.change((t)=>{
                        for (const { node: e } of iterateSiblingListBlocks(i, "forward"))t.setAttribute("listIndent", e.getAttribute("listIndent") + c, e);
                    });
                };
            }
            function lL(t, e) {
                const n = t.document.selection;
                if (!n.isCollapsed) return !getSelectedBlockObject(t);
                if (e === "forward") return true;
                const o = n.getFirstPosition();
                const i = o.parent;
                const r = i.previousSibling;
                if (t.schema.isObject(r)) return false;
                if (r.isEmpty) return true;
                return isSingleListItem([
                    i,
                    r
                ]);
            }
            function dL(t) {
                const e = t.createContainerElement("li");
                e.getFillerOffset = CL;
                return e;
            }
            function uL(t, e) {
                const n = e.mapper;
                const o = e.writer;
                const i = t.getAttribute("listType") == "numbered" ? "ol" : "ul";
                const r = dL(o);
                const s = o.createContainerElement(i, null);
                o.insert(o.createPositionAt(s, 0), r);
                n.bindElements(t, r);
                return r;
            }
            function hL(t, e, n, o) {
                const i = e.parent;
                const r = n.mapper;
                const s = n.writer;
                let a = r.toViewPosition(o.createPositionBefore(t));
                const c = gL(t.previousSibling, {
                    sameIndent: true,
                    smallerIndent: true,
                    listIndent: t.getAttribute("listIndent")
                });
                const l = t.previousSibling;
                if (c && c.getAttribute("listIndent") == t.getAttribute("listIndent")) {
                    const t = r.toViewElement(c);
                    a = s.breakContainer(s.createPositionAfter(t));
                } else if (l && l.name == "listItem") {
                    a = r.toViewPosition(o.createPositionAt(l, "end"));
                    const t = r.findMappedViewAncestor(a);
                    const e = kL(t);
                    if (e) a = s.createPositionBefore(e);
                    else a = s.createPositionAt(t, "end");
                } else a = r.toViewPosition(o.createPositionBefore(t));
                a = pL(a);
                s.insert(a, i);
                if (l && l.name == "listItem") {
                    const t = r.toViewElement(l);
                    const n = s.createRange(s.createPositionAt(t, 0), a);
                    const o = n.getWalker({
                        ignoreElementEnd: true
                    });
                    for (const t of o)if (t.item.is("element", "li")) {
                        const n = s.breakContainer(s.createPositionBefore(t.item));
                        const i = t.item.parent;
                        const r = s.createPositionAt(e, "end");
                        fL(s, r.nodeBefore, r.nodeAfter);
                        s.move(s.createRangeOn(i), r);
                        o._position = n;
                    }
                } else {
                    const n = i.nextSibling;
                    if (n && (n.is("element", "ul") || n.is("element", "ol"))) {
                        let o = null;
                        for (const e of n.getChildren()){
                            const n = r.toModelElement(e);
                            if (n && n.getAttribute("listIndent") > t.getAttribute("listIndent")) o = e;
                            else break;
                        }
                        if (o) {
                            s.breakContainer(s.createPositionAfter(o));
                            s.move(s.createRangeOn(o.parent), s.createPositionAt(e, "end"));
                        }
                    }
                }
                fL(s, i, i.nextSibling);
                fL(s, i.previousSibling, i);
            }
            function fL(t, e, n) {
                if (!e || !n || e.name != "ul" && e.name != "ol") return null;
                if (e.name != n.name || e.getAttribute("class") !== n.getAttribute("class")) return null;
                return t.mergeContainers(t.createPositionAfter(e));
            }
            function pL(t) {
                return t.getLastMatchingPosition((t)=>t.item.is("uiElement"));
            }
            function gL(t, e) {
                const n = !!e.sameIndent;
                const o = !!e.smallerIndent;
                const i = e.listIndent;
                let r = t;
                while(r && r.name == "listItem"){
                    const t = r.getAttribute("listIndent");
                    if (n && i == t || o && i > t) return r;
                    if (e.direction === "forward") r = r.nextSibling;
                    else r = r.previousSibling;
                }
                return null;
            }
            function mL(t, e, n, o) {
                t.ui.componentFactory.add(e, (i)=>{
                    const r = t.commands.get(e);
                    const s = new yd(i);
                    s.set({
                        label: n,
                        icon: o,
                        tooltip: true,
                        isToggleable: true
                    });
                    s.bind("isOn", "isEnabled").to(r, "value", "isEnabled");
                    s.on("execute", ()=>{
                        t.execute(e);
                        t.editing.view.focus();
                    });
                    return s;
                });
            }
            function kL(t) {
                for (const e of t.getChildren()){
                    if (e.name == "ul" || e.name == "ol") return e;
                }
                return null;
            }
            function bL(t, e) {
                const n = [];
                const o = t.parent;
                const i = {
                    ignoreElementEnd: false,
                    startPosition: t,
                    shallow: true,
                    direction: e
                };
                const r = o.getAttribute("listIndent");
                const s = [
                    ...new Ik(i)
                ].filter((t)=>t.item.is("element")).map((t)=>t.item);
                for (const t of s){
                    if (!t.is("element", "listItem")) break;
                    if (t.getAttribute("listIndent") < r) break;
                    if (t.getAttribute("listIndent") > r) continue;
                    if (t.getAttribute("listType") !== o.getAttribute("listType")) break;
                    if (t.getAttribute("listStyle") !== o.getAttribute("listStyle")) break;
                    if (t.getAttribute("listReversed") !== o.getAttribute("listReversed")) break;
                    if (t.getAttribute("listStart") !== o.getAttribute("listStart")) break;
                    if (e === "backward") n.unshift(t);
                    else n.push(t);
                }
                return n;
            }
            function wL(t) {
                const e = t.document;
                let n = [
                    ...e.selection.getSelectedBlocks()
                ].filter((t)=>t.is("element", "listItem")).map((e)=>{
                    const n = t.change((t)=>t.createPositionAt(e, 0));
                    return [
                        ...bL(n, "backward"),
                        ...bL(n, "forward")
                    ];
                }).flat();
                n = [
                    ...new Set(n)
                ];
                return n;
            }
            const _L = [
                "disc",
                "circle",
                "square"
            ];
            const AL = [
                "decimal",
                "decimal-leading-zero",
                "lower-roman",
                "upper-roman",
                "lower-latin",
                "upper-latin"
            ];
            function vL(t) {
                if (_L.includes(t)) return "bulleted";
                if (AL.includes(t)) return "numbered";
                return null;
            }
            function CL() {
                const t = !this.isEmpty && (this.getChild(0).name == "ul" || this.getChild(0).name == "ol");
                if (this.isEmpty || t) return 0;
                return up.call(this);
            }
            const yL = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>';
            const xL = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>';
            class EL extends Pu {
                static get pluginName() {
                    return "ListUI";
                }
                init() {
                    const t = this.editor.t;
                    mL(this.editor, "numberedList", t("Numbered List"), yL);
                    mL(this.editor, "bulletedList", t("Bulleted List"), xL);
                }
            }
            class DL extends null {
                static get requires() {
                    return [
                        DocumentListEditing,
                        ListUI
                    ];
                }
                static get pluginName() {
                    return "DocumentList";
                }
            }
            class SL extends null {
                static get pluginName() {
                    return "AdjacentListsSupport";
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    e.schema.register("listSeparator", {
                        allowWhere: "$block",
                        isBlock: true
                    });
                    t.conversion.for("upcast").add((t)=>{
                        t.on("element:ol", TL());
                        t.on("element:ul", TL());
                    }).elementToElement({
                        model: "listSeparator",
                        view: "ck-list-separator"
                    });
                    t.conversion.for("editingDowncast").elementToElement({
                        model: "listSeparator",
                        view: {
                            name: "div",
                            classes: [
                                "ck-list-separator",
                                "ck-hidden"
                            ]
                        }
                    });
                    t.conversion.for("dataDowncast").elementToElement({
                        model: "listSeparator",
                        view: (t, e)=>{
                            const n = e.writer.createContainerElement("ck-list-separator");
                            e.writer.setCustomProperty("dataPipeline:transparentRendering", true, n);
                            n.getFillerOffset = ()=>null;
                            return n;
                        }
                    });
                }
            }
            function TL() {
                return (t, e, n)=>{
                    const o = e.viewItem;
                    const i = o.nextSibling;
                    if (!i) return;
                    if (o.name !== i.name) return;
                    if (!e.modelRange) Object.assign(e, n.convertChildren(e.viewItem, e.modelCursor));
                    const r = n.writer;
                    const s = r.createElement("listSeparator");
                    if (!n.safeInsert(s, e.modelCursor)) return;
                    const a = n.getSplitParts(s);
                    e.modelRange = r.createRange(e.modelRange.start, r.createPositionAfter(a[a.length - 1]));
                    n.updateConversionResult(s, e);
                };
            }
            class BL extends null {
                refresh() {
                    const t = this._getValue();
                    this.value = t;
                    this.isEnabled = t != null;
                }
                execute({ startIndex: t = 1 } = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    let o = Array.from(n.selection.getSelectedBlocks()).filter((t)=>isListItemBlock(t) && t.getAttribute("listType") == "numbered");
                    o = expandListBlocksToCompleteList(o);
                    e.change((e)=>{
                        for (const n of o)e.setAttribute("listStart", t >= 0 ? t : 1, n);
                    });
                }
                _getValue() {
                    const t = this.editor.model;
                    const e = t.document;
                    const n = first(e.selection.getSelectedBlocks());
                    if (n && isListItemBlock(n) && n.getAttribute("listType") == "numbered") return n.getAttribute("listStart");
                    return null;
                }
            }
            const PL = {};
            const IL = {};
            const RL = {};
            const OL = [
                {
                    listStyle: "disc",
                    typeAttribute: "disc",
                    listType: "bulleted"
                },
                {
                    listStyle: "circle",
                    typeAttribute: "circle",
                    listType: "bulleted"
                },
                {
                    listStyle: "square",
                    typeAttribute: "square",
                    listType: "bulleted"
                },
                {
                    listStyle: "decimal",
                    typeAttribute: "1",
                    listType: "numbered"
                },
                {
                    listStyle: "decimal-leading-zero",
                    typeAttribute: null,
                    listType: "numbered"
                },
                {
                    listStyle: "lower-roman",
                    typeAttribute: "i",
                    listType: "numbered"
                },
                {
                    listStyle: "upper-roman",
                    typeAttribute: "I",
                    listType: "numbered"
                },
                {
                    listStyle: "lower-alpha",
                    typeAttribute: "a",
                    listType: "numbered"
                },
                {
                    listStyle: "upper-alpha",
                    typeAttribute: "A",
                    listType: "numbered"
                },
                {
                    listStyle: "lower-latin",
                    typeAttribute: "a",
                    listType: "numbered"
                },
                {
                    listStyle: "upper-latin",
                    typeAttribute: "A",
                    listType: "numbered"
                }
            ];
            for (const { listStyle: t, typeAttribute: e, listType: n } of OL){
                PL[t] = n;
                IL[t] = e;
                if (e) RL[e] = t;
            }
            function VL() {
                return OL.map((t)=>t.listStyle);
            }
            function ML(t) {
                return PL[t] || null;
            }
            function LL(t) {
                return RL[t] || null;
            }
            function zL(t) {
                return IL[t] || null;
            }
            class NL extends null {
                constructor(t, e, n){
                    super(t);
                    this.defaultType = e;
                    this._supportedTypes = n;
                }
                refresh() {
                    this.value = this._getValue();
                    this.isEnabled = this._checkEnabled();
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    e.change((e)=>{
                        this._tryToConvertItemsToList(t);
                        let o = Array.from(n.selection.getSelectedBlocks()).filter((t)=>t.hasAttribute("listType"));
                        if (!o.length) return;
                        o = expandListBlocksToCompleteList(o);
                        for (const n of o)e.setAttribute("listStyle", t.type || this.defaultType, n);
                    });
                }
                isStyleTypeSupported(t) {
                    if (!this._supportedTypes) return true;
                    return this._supportedTypes.includes(t);
                }
                _getValue() {
                    const t = first(this.editor.model.document.selection.getSelectedBlocks());
                    if (isListItemBlock(t)) return t.getAttribute("listStyle");
                    return null;
                }
                _checkEnabled() {
                    const t = this.editor;
                    const e = t.commands.get("numberedList");
                    const n = t.commands.get("bulletedList");
                    return e.isEnabled || n.isEnabled;
                }
                _tryToConvertItemsToList(t) {
                    if (!t.type) return;
                    const e = getListTypeFromListStyleType(t.type);
                    if (!e) return;
                    const n = this.editor;
                    const o = `${e}List`;
                    const i = n.commands.get(o);
                    if (!i.value) n.execute(o);
                }
            }
            class FL extends null {
                refresh() {
                    const t = this._getValue();
                    this.value = t;
                    this.isEnabled = t != null;
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    let o = Array.from(n.selection.getSelectedBlocks()).filter((t)=>isListItemBlock(t) && t.getAttribute("listType") == "numbered");
                    o = expandListBlocksToCompleteList(o);
                    e.change((e)=>{
                        for (const n of o)e.setAttribute("listReversed", !!t.reversed, n);
                    });
                }
                _getValue() {
                    const t = this.editor.model;
                    const e = t.document;
                    const n = first(e.selection.getSelectedBlocks());
                    if (isListItemBlock(n) && n.getAttribute("listType") == "numbered") return n.getAttribute("listReversed");
                    return null;
                }
            }
            class HL extends null {
                static get pluginName() {
                    return "DocumentListPropertiesUtils";
                }
                getAllSupportedStyleTypes() {
                    return getAllSupportedStyleTypes();
                }
                getListTypeFromListStyleType(t) {
                    return getListTypeFromListStyleType(t);
                }
                getListStyleTypeFromTypeAttribute(t) {
                    return getListStyleTypeFromTypeAttribute(t);
                }
                getTypeAttributeFromListStyleType(t) {
                    return getTypeAttributeFromListStyleType(t);
                }
            }
            const jL = "default";
            class qL extends null {
                static get requires() {
                    return [
                        DocumentListEditing,
                        DocumentListPropertiesUtils
                    ];
                }
                static get pluginName() {
                    return "DocumentListPropertiesEditing";
                }
                constructor(t){
                    super(t);
                    t.config.define("list.properties", {
                        styles: true,
                        startIndex: false,
                        reversed: false
                    });
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.plugins.get(DocumentListEditing);
                    const o = t.config.get("list.properties");
                    const i = WL(o);
                    for (const o of i){
                        o.addCommand(t);
                        e.schema.extend("$listItem", {
                            allowAttributes: o.attributeName
                        });
                        n.registerDowncastStrategy({
                            scope: "list",
                            attributeName: o.attributeName,
                            setAttributeOnDowncast (t, e, n) {
                                o.setAttributeOnDowncast(t, e, n);
                            }
                        });
                    }
                    t.conversion.for("upcast").add((t)=>{
                        for (const e of i){
                            t.on("element:ol", listPropertiesUpcastConverter(e));
                            t.on("element:ul", listPropertiesUpcastConverter(e));
                        }
                    });
                    n.on("checkAttributes:list", (t, { viewElement: e, modelAttributes: n })=>{
                        for (const o of i)if (o.getAttributeOnUpcast(e) != n[o.attributeName]) {
                            t.return = true;
                            t.stop();
                        }
                    });
                    this.listenTo(t.commands.get("indentList"), "afterExecute", (t, n)=>{
                        e.change((t)=>{
                            for (const e of n){
                                for (const n of i)if (n.appliesToListItem(e)) t.setAttribute(n.attributeName, n.defaultValue, e);
                            }
                        });
                    });
                    n.on("postFixer", (t, { listNodes: e, writer: n })=>{
                        for (const { node: o } of e)for (const e of i){
                            if (e.hasValidAttribute(o)) continue;
                            if (e.appliesToListItem(o)) n.setAttribute(e.attributeName, e.defaultValue, o);
                            else n.removeAttribute(e.attributeName, o);
                            t.return = true;
                        }
                    });
                    n.on("postFixer", (t, { listNodes: e, writer: n })=>{
                        for (const { node: o, previousNodeInList: r } of e){
                            if (!r) continue;
                            if (r.getAttribute("listType") != o.getAttribute("listType")) continue;
                            for (const e of i){
                                const { attributeName: i } = e;
                                if (!e.appliesToListItem(o)) continue;
                                const s = r.getAttribute(i);
                                if (o.getAttribute(i) != s) {
                                    n.setAttribute(i, s, o);
                                    t.return = true;
                                }
                            }
                        }
                    });
                }
            }
            function WL(t) {
                const e = [];
                if (t.styles) {
                    const n = typeof t.styles == "object" && t.styles.useAttribute;
                    e.push({
                        attributeName: "listStyle",
                        defaultValue: jL,
                        viewConsumables: {
                            styles: "list-style-type"
                        },
                        addCommand (t) {
                            let e = getAllSupportedStyleTypes();
                            if (n) e = e.filter((t)=>!!getTypeAttributeFromListStyleType(t));
                            t.commands.add("listStyle", new DocumentListStyleCommand(t, jL, e));
                        },
                        appliesToListItem (t) {
                            return t.getAttribute("listType") == "numbered" || t.getAttribute("listType") == "bulleted";
                        },
                        hasValidAttribute (t) {
                            if (!this.appliesToListItem(t)) return !t.hasAttribute("listStyle");
                            if (!t.hasAttribute("listStyle")) return false;
                            const e = t.getAttribute("listStyle");
                            if (e == jL) return true;
                            return getListTypeFromListStyleType(e) == t.getAttribute("listType");
                        },
                        setAttributeOnDowncast (t, e, o) {
                            if (e && e !== jL) {
                                if (n) {
                                    const n = getTypeAttributeFromListStyleType(e);
                                    if (n) {
                                        t.setAttribute("type", n, o);
                                        return;
                                    }
                                } else {
                                    t.setStyle("list-style-type", e, o);
                                    return;
                                }
                            }
                            t.removeStyle("list-style-type", o);
                            t.removeAttribute("type", o);
                        },
                        getAttributeOnUpcast (t) {
                            const e = t.getStyle("list-style-type");
                            if (e) return e;
                            const n = t.getAttribute("type");
                            if (n) return getListStyleTypeFromTypeAttribute(n);
                            return jL;
                        }
                    });
                }
                if (t.reversed) e.push({
                    attributeName: "listReversed",
                    defaultValue: false,
                    viewConsumables: {
                        attributes: "reversed"
                    },
                    addCommand (t) {
                        t.commands.add("listReversed", new DocumentListReversedCommand(t));
                    },
                    appliesToListItem (t) {
                        return t.getAttribute("listType") == "numbered";
                    },
                    hasValidAttribute (t) {
                        return this.appliesToListItem(t) == t.hasAttribute("listReversed");
                    },
                    setAttributeOnDowncast (t, e, n) {
                        if (e) t.setAttribute("reversed", "reversed", n);
                        else t.removeAttribute("reversed", n);
                    },
                    getAttributeOnUpcast (t) {
                        return t.hasAttribute("reversed");
                    }
                });
                if (t.startIndex) e.push({
                    attributeName: "listStart",
                    defaultValue: 1,
                    viewConsumables: {
                        attributes: "start"
                    },
                    addCommand (t) {
                        t.commands.add("listStart", new DocumentListStartCommand(t));
                    },
                    appliesToListItem (t) {
                        return t.getAttribute("listType") == "numbered";
                    },
                    hasValidAttribute (t) {
                        return this.appliesToListItem(t) == t.hasAttribute("listStart");
                    },
                    setAttributeOnDowncast (t, e, n) {
                        if (e == 0 || e > 1) t.setAttribute("start", e, n);
                        else t.removeAttribute("start", n);
                    },
                    getAttributeOnUpcast (t) {
                        const e = t.getAttribute("start");
                        return e >= 0 ? e : 1;
                    }
                });
                return e;
            }
            var $L = n(5782);
            var GL = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            GL.insert = "head";
            GL.singleton = true;
            var UL = Rl()($L.Z, GL);
            const KL = $L.Z.locals || {};
            class ZL extends null {
                constructor(t, e){
                    super(t);
                    const n = this.bindTemplate;
                    this.set("isCollapsed", false);
                    this.set("label", "");
                    this.buttonView = this._createButtonView();
                    this.children = this.createCollection();
                    this.set("_collapsibleAriaLabelUid", undefined);
                    if (e) this.children.addMany(e);
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: [
                                "ck",
                                "ck-collapsible",
                                n.if("isCollapsed", "ck-collapsible_collapsed")
                            ]
                        },
                        children: [
                            this.buttonView,
                            {
                                tag: "div",
                                attributes: {
                                    class: [
                                        "ck",
                                        "ck-collapsible__children"
                                    ],
                                    role: "region",
                                    hidden: n.if("isCollapsed", "hidden"),
                                    "aria-labelledby": n.to("_collapsibleAriaLabelUid")
                                },
                                children: this.children
                            }
                        ]
                    });
                }
                render() {
                    super.render();
                    this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
                }
                _createButtonView() {
                    const t = new ButtonView(this.locale);
                    const e = t.bindTemplate;
                    t.set({
                        withText: true,
                        icon: dropdownArrowIcon
                    });
                    t.extendTemplate({
                        attributes: {
                            "aria-expanded": e.to("isOn", (t)=>String(t))
                        }
                    });
                    t.bind("label").to(this);
                    t.bind("isOn").to(this, "isCollapsed", (t)=>!t);
                    t.on("execute", ()=>{
                        this.isCollapsed = !this.isCollapsed;
                    });
                    return t;
                }
            }
            var JL = n(9938);
            var YL = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            YL.insert = "head";
            YL.singleton = true;
            var QL = Rl()(JL.Z, YL);
            const XL = JL.Z.locals || {};
            class tz extends null {
                constructor(t, { enabledProperties: e, styleButtonViews: n, styleGridAriaLabel: o }){
                    super(t);
                    this.stylesView = null;
                    this.additionalPropertiesCollapsibleView = null;
                    this.startIndexFieldView = null;
                    this.reversedSwitchButtonView = null;
                    this.focusTracker = new FocusTracker;
                    this.keystrokes = new KeystrokeHandler;
                    this.focusables = new ViewCollection;
                    const i = [
                        "ck",
                        "ck-list-properties"
                    ];
                    this.children = this.createCollection();
                    this.focusCycler = new FocusCycler({
                        focusables: this.focusables,
                        focusTracker: this.focusTracker,
                        keystrokeHandler: this.keystrokes,
                        actions: {
                            focusPrevious: "shift + tab",
                            focusNext: "tab"
                        }
                    });
                    if (e.styles) {
                        this.stylesView = this._createStylesView(n, o);
                        this.children.add(this.stylesView);
                    } else i.push("ck-list-properties_without-styles");
                    if (e.startIndex || e.reversed) {
                        this._addNumberedListPropertyViews(e);
                        i.push("ck-list-properties_with-numbered-properties");
                    }
                    this.setTemplate({
                        tag: "div",
                        attributes: {
                            class: i
                        },
                        children: this.children
                    });
                }
                render() {
                    super.render();
                    if (this.stylesView) {
                        this.focusables.add(this.stylesView);
                        this.focusTracker.add(this.stylesView.element);
                        if (this.startIndexFieldView || this.reversedSwitchButtonView) {
                            this.focusables.add(this.children.last.buttonView);
                            this.focusTracker.add(this.children.last.buttonView.element);
                        }
                        for (const t of this.stylesView.children)this.stylesView.focusTracker.add(t.element);
                        addKeyboardHandlingForGrid({
                            keystrokeHandler: this.stylesView.keystrokes,
                            focusTracker: this.stylesView.focusTracker,
                            gridItems: this.stylesView.children,
                            numberOfColumns: ()=>$parcel$global.window.getComputedStyle(this.stylesView.element).getPropertyValue("grid-template-columns").split(" ").length,
                            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
                        });
                    }
                    if (this.startIndexFieldView) {
                        this.focusables.add(this.startIndexFieldView);
                        this.focusTracker.add(this.startIndexFieldView.element);
                        const t = (t)=>t.stopPropagation();
                        this.keystrokes.set("arrowright", t);
                        this.keystrokes.set("arrowleft", t);
                        this.keystrokes.set("arrowup", t);
                        this.keystrokes.set("arrowdown", t);
                    }
                    if (this.reversedSwitchButtonView) {
                        this.focusables.add(this.reversedSwitchButtonView);
                        this.focusTracker.add(this.reversedSwitchButtonView.element);
                    }
                    this.keystrokes.listenTo(this.element);
                }
                focus() {
                    this.focusCycler.focusFirst();
                }
                focusLast() {
                    this.focusCycler.focusLast();
                }
                destroy() {
                    super.destroy();
                    this.focusTracker.destroy();
                    this.keystrokes.destroy();
                }
                _createStylesView(t, e) {
                    const n = new View(this.locale);
                    n.children = n.createCollection();
                    n.children.addMany(t);
                    n.setTemplate({
                        tag: "div",
                        attributes: {
                            "aria-label": e,
                            class: [
                                "ck",
                                "ck-list-styles-list"
                            ]
                        },
                        children: n.children
                    });
                    n.children.delegate("execute").to(this);
                    n.focus = function() {
                        this.children.first.focus();
                    };
                    n.focusTracker = new FocusTracker;
                    n.keystrokes = new KeystrokeHandler;
                    n.render();
                    n.keystrokes.listenTo(n.element);
                    return n;
                }
                _addNumberedListPropertyViews(t) {
                    const e = this.locale.t;
                    const n = [];
                    if (t.startIndex) {
                        this.startIndexFieldView = this._createStartIndexField();
                        n.push(this.startIndexFieldView);
                    }
                    if (t.reversed) {
                        this.reversedSwitchButtonView = this._createReversedSwitchButton();
                        n.push(this.reversedSwitchButtonView);
                    }
                    if (t.styles) {
                        this.additionalPropertiesCollapsibleView = new CollapsibleView(this.locale, n);
                        this.additionalPropertiesCollapsibleView.set({
                            label: e("List properties"),
                            isCollapsed: true
                        });
                        this.additionalPropertiesCollapsibleView.buttonView.bind("isEnabled").toMany(n, "isEnabled", (...t)=>t.some((t)=>t));
                        this.additionalPropertiesCollapsibleView.buttonView.on("change:isEnabled", (t, e, n)=>{
                            if (!n) this.additionalPropertiesCollapsibleView.isCollapsed = true;
                        });
                        this.children.add(this.additionalPropertiesCollapsibleView);
                    } else this.children.addMany(n);
                }
                _createStartIndexField() {
                    const t = this.locale.t;
                    const e = new LabeledFieldView(this.locale, createLabeledInputNumber);
                    e.set({
                        label: t("Start at"),
                        class: "ck-numbered-list-properties__start-index"
                    });
                    e.fieldView.set({
                        min: 0,
                        step: 1,
                        value: 1,
                        inputMode: "numeric"
                    });
                    e.fieldView.on("input", ()=>{
                        const n = e.fieldView.element;
                        const o = n.valueAsNumber;
                        if (Number.isNaN(o)) return;
                        if (!n.checkValidity()) e.errorText = t("Start index must be greater than 0.");
                        else this.fire("listStart", {
                            startIndex: o
                        });
                    });
                    return e;
                }
                _createReversedSwitchButton() {
                    const t = this.locale.t;
                    const e = new SwitchButtonView(this.locale);
                    e.set({
                        withText: true,
                        label: t("Reversed order"),
                        class: "ck-numbered-list-properties__reversed-order"
                    });
                    e.delegate("execute").to(this, "listReversed");
                    return e;
                }
            }
            var ez = n(2591);
            var nz = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            nz.insert = "head";
            nz.singleton = true;
            var oz = Rl()(ez.Z, nz);
            const iz = ez.Z.locals || {};
            class rz extends null {
                static get pluginName() {
                    return "ListPropertiesUI";
                }
                init() {
                    const t = this.editor;
                    const e = t.locale.t;
                    const n = t.config.get("list.properties");
                    if (n.styles) t.ui.componentFactory.add("bulletedList", sz({
                        editor: t,
                        parentCommandName: "bulletedList",
                        buttonLabel: e("Bulleted List"),
                        buttonIcon: bulletedListIcon,
                        styleGridAriaLabel: e("Bulleted list styles toolbar"),
                        styleDefinitions: [
                            {
                                label: e("Toggle the disc list style"),
                                tooltip: e("Disc"),
                                type: "disc",
                                icon: listStyleDiscIcon
                            },
                            {
                                label: e("Toggle the circle list style"),
                                tooltip: e("Circle"),
                                type: "circle",
                                icon: listStyleCircleIcon
                            },
                            {
                                label: e("Toggle the square list style"),
                                tooltip: e("Square"),
                                type: "square",
                                icon: listStyleSquareIcon
                            }
                        ]
                    }));
                    if (n.styles || n.startIndex || n.reversed) t.ui.componentFactory.add("numberedList", sz({
                        editor: t,
                        parentCommandName: "numberedList",
                        buttonLabel: e("Numbered List"),
                        buttonIcon: numberedListIcon,
                        styleGridAriaLabel: e("Numbered list styles toolbar"),
                        styleDefinitions: [
                            {
                                label: e("Toggle the decimal list style"),
                                tooltip: e("Decimal"),
                                type: "decimal",
                                icon: listStyleDecimalIcon
                            },
                            {
                                label: e("Toggle the decimal with leading zero list style"),
                                tooltip: e("Decimal with leading zero"),
                                type: "decimal-leading-zero",
                                icon: listStyleDecimalWithLeadingZeroIcon
                            },
                            {
                                label: e("Toggle the lower\u2013roman list style"),
                                tooltip: e("Lower\u2013roman"),
                                type: "lower-roman",
                                icon: listStyleLowerRomanIcon
                            },
                            {
                                label: e("Toggle the upper\u2013roman list style"),
                                tooltip: e("Upper-roman"),
                                type: "upper-roman",
                                icon: listStyleUpperRomanIcon
                            },
                            {
                                label: e("Toggle the lower\u2013latin list style"),
                                tooltip: e("Lower-latin"),
                                type: "lower-latin",
                                icon: listStyleLowerLatinIcon
                            },
                            {
                                label: e("Toggle the upper\u2013latin list style"),
                                tooltip: e("Upper-latin"),
                                type: "upper-latin",
                                icon: listStyleUpperLatinIcon
                            }
                        ]
                    }));
                }
            }
            function sz({ editor: t, parentCommandName: e, buttonLabel: n, buttonIcon: o, styleGridAriaLabel: i, styleDefinitions: r }) {
                const s = t.commands.get(e);
                return (a)=>{
                    const c = createDropdown(a, SplitButtonView);
                    const l = c.buttonView;
                    c.bind("isEnabled").to(s);
                    c.class = "ck-list-styles-dropdown";
                    l.on("execute", ()=>{
                        t.execute(e);
                        t.editing.view.focus();
                    });
                    l.set({
                        label: n,
                        icon: o,
                        tooltip: true,
                        isToggleable: true
                    });
                    l.bind("isOn").to(s, "value", (t)=>!!t);
                    c.once("change:isOpen", ()=>{
                        const n = cz({
                            editor: t,
                            dropdownView: c,
                            parentCommandName: e,
                            styleGridAriaLabel: i,
                            styleDefinitions: r
                        });
                        c.panelView.children.add(n);
                    });
                    c.on("execute", ()=>{
                        t.editing.view.focus();
                    });
                    return c;
                };
            }
            function az({ editor: t, listStyleCommand: e, parentCommandName: n }) {
                const o = t.locale;
                const i = t.commands.get(n);
                return ({ label: n, type: r, icon: s, tooltip: a })=>{
                    const c = new ButtonView(o);
                    c.set({
                        label: n,
                        icon: s,
                        tooltip: a
                    });
                    e.on("change:value", ()=>{
                        c.isOn = e.value === r;
                    });
                    c.on("execute", ()=>{
                        if (i.value) {
                            if (e.value !== r) t.execute("listStyle", {
                                type: r
                            });
                            else t.execute("listStyle", {
                                type: e.defaultType
                            });
                        } else t.model.change(()=>{
                            t.execute("listStyle", {
                                type: r
                            });
                        });
                    });
                    return c;
                };
            }
            function cz({ editor: t, dropdownView: e, parentCommandName: n, styleDefinitions: o, styleGridAriaLabel: i }) {
                const r = t.locale;
                const s = t.config.get("list.properties");
                let a = null;
                if (n != "numberedList") {
                    s.startIndex = false;
                    s.reversed = false;
                }
                if (s.styles) {
                    const e = t.commands.get("listStyle");
                    const i = az({
                        editor: t,
                        parentCommandName: n,
                        listStyleCommand: e
                    });
                    const r = typeof e.isStyleTypeSupported == "function" ? (t)=>e.isStyleTypeSupported(t.type) : ()=>true;
                    a = o.filter(r).map(i);
                }
                const c = new ListPropertiesView(r, {
                    styleGridAriaLabel: i,
                    enabledProperties: s,
                    styleButtonViews: a
                });
                if (s.styles) focusChildOnDropdownOpen(e, ()=>c.stylesView.children.find((t)=>t.isOn));
                if (s.startIndex) {
                    const e = t.commands.get("listStart");
                    c.startIndexFieldView.bind("isEnabled").to(e);
                    c.startIndexFieldView.fieldView.bind("value").to(e);
                    c.on("listStart", (e, n)=>t.execute("listStart", n));
                }
                if (s.reversed) {
                    const e = t.commands.get("listReversed");
                    c.reversedSwitchButtonView.bind("isEnabled").to(e);
                    c.reversedSwitchButtonView.bind("isOn").to(e, "value", (t)=>!!t);
                    c.on("listReversed", ()=>{
                        const n = e.value;
                        t.execute("listReversed", {
                            reversed: !n
                        });
                    });
                }
                c.delegate("execute").to(e);
                return c;
            }
            class lz extends null {
                static get requires() {
                    return [
                        DocumentListPropertiesEditing,
                        ListPropertiesUI
                    ];
                }
                static get pluginName() {
                    return "DocumentListProperties";
                }
            }
            class dz extends Ru {
                constructor(t, e){
                    super(t);
                    this._indentBy = e == "forward" ? 1 : -1;
                }
                refresh() {
                    this.isEnabled = this._checkEnabled();
                }
                execute() {
                    const t = this.editor.model;
                    const e = t.document;
                    let n = Array.from(e.selection.getSelectedBlocks());
                    t.change((t)=>{
                        const e = n[n.length - 1];
                        let o = e.nextSibling;
                        while(o && o.name == "listItem" && o.getAttribute("listIndent") > e.getAttribute("listIndent")){
                            n.push(o);
                            o = o.nextSibling;
                        }
                        if (this._indentBy < 0) n = n.reverse();
                        for (const e of n){
                            const n = e.getAttribute("listIndent") + this._indentBy;
                            if (n < 0) t.rename(e, "paragraph");
                            else t.setAttribute("listIndent", n, e);
                        }
                        this.fire("_executeCleanup", n);
                    });
                }
                _checkEnabled() {
                    const t = fl(this.editor.model.document.selection.getSelectedBlocks());
                    if (!t || !t.is("element", "listItem")) return false;
                    if (this._indentBy > 0) {
                        const e = t.getAttribute("listIndent");
                        const n = t.getAttribute("listType");
                        let o = t.previousSibling;
                        while(o && o.is("element", "listItem") && o.getAttribute("listIndent") >= e){
                            if (o.getAttribute("listIndent") == e) return o.getAttribute("listType") == n;
                            o = o.previousSibling;
                        }
                        return false;
                    }
                    return true;
                }
            }
            class uz extends Ru {
                constructor(t, e){
                    super(t);
                    this.type = e;
                }
                refresh() {
                    this.value = this._getValue();
                    this.isEnabled = this._checkEnabled();
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = e.document;
                    const o = Array.from(n.selection.getSelectedBlocks()).filter((t)=>fz(t, e.schema));
                    const i = t.forceValue !== undefined ? !t.forceValue : this.value;
                    e.change((t)=>{
                        if (i) {
                            let e = o[o.length - 1].nextSibling;
                            let n = Number.POSITIVE_INFINITY;
                            let i = [];
                            while(e && e.name == "listItem" && e.getAttribute("listIndent") !== 0){
                                const t = e.getAttribute("listIndent");
                                if (t < n) n = t;
                                const o = t - n;
                                i.push({
                                    element: e,
                                    listIndent: o
                                });
                                e = e.nextSibling;
                            }
                            i = i.reverse();
                            for (const e of i)t.setAttribute("listIndent", e.listIndent, e.element);
                        }
                        if (!i) {
                            let t = Number.POSITIVE_INFINITY;
                            for (const e of o)if (e.is("element", "listItem") && e.getAttribute("listIndent") < t) t = e.getAttribute("listIndent");
                            t = t === 0 ? 1 : t;
                            hz(o, true, t);
                            hz(o, false, t);
                        }
                        for (const e of o.reverse()){
                            if (i && e.name == "listItem") t.rename(e, "paragraph");
                            else if (!i && e.name != "listItem") {
                                t.setAttributes({
                                    listType: this.type,
                                    listIndent: 0
                                }, e);
                                t.rename(e, "listItem");
                            } else if (!i && e.name == "listItem" && e.getAttribute("listType") != this.type) t.setAttribute("listType", this.type, e);
                        }
                        this.fire("_executeCleanup", o);
                    });
                }
                _getValue() {
                    const t = fl(this.editor.model.document.selection.getSelectedBlocks());
                    return !!t && t.is("element", "listItem") && t.getAttribute("listType") == this.type;
                }
                _checkEnabled() {
                    if (this.value) return true;
                    const t = this.editor.model.document.selection;
                    const e = this.editor.model.schema;
                    const n = fl(t.getSelectedBlocks());
                    if (!n) return false;
                    return fz(n, e);
                }
            }
            function hz(t, e, n) {
                const o = e ? t[0] : t[t.length - 1];
                if (o.is("element", "listItem")) {
                    let i = o[e ? "previousSibling" : "nextSibling"];
                    let r = o.getAttribute("listIndent");
                    while(i && i.is("element", "listItem") && i.getAttribute("listIndent") >= n){
                        if (r > i.getAttribute("listIndent")) r = i.getAttribute("listIndent");
                        if (i.getAttribute("listIndent") == r) t[e ? "unshift" : "push"](i);
                        i = i[e ? "previousSibling" : "nextSibling"];
                    }
                }
            }
            function fz(t, e) {
                return e.checkChild(t.parent, "listItem") && !e.isObject(t);
            }
            class pz extends Pu {
                static get pluginName() {
                    return "ListUtils";
                }
                getListTypeFromListStyleType(t) {
                    return vL(t);
                }
                getSelectedListItems(t) {
                    return wL(t);
                }
                getSiblingNodes(t, e) {
                    return bL(t, e);
                }
            }
            function gz(t) {
                return (e, n, o)=>{
                    const i = o.consumable;
                    if (!i.test(n.item, "insert") || !i.test(n.item, "attribute:listType") || !i.test(n.item, "attribute:listIndent")) return;
                    i.consume(n.item, "insert");
                    i.consume(n.item, "attribute:listType");
                    i.consume(n.item, "attribute:listIndent");
                    const r = n.item;
                    const s = uL(r, o);
                    hL(r, s, o, t);
                };
            }
            function mz(t) {
                return (e, n, o)=>{
                    const i = o.mapper.toViewPosition(n.position);
                    const r = i.getLastMatchingPosition((t)=>!t.item.is("element", "li"));
                    const s = r.nodeAfter;
                    const a = o.writer;
                    a.breakContainer(a.createPositionBefore(s));
                    a.breakContainer(a.createPositionAfter(s));
                    const c = s.parent;
                    const l = c.previousSibling;
                    const d = a.createRangeOn(c);
                    const u = a.remove(d);
                    if (l && l.nextSibling) fL(a, l, l.nextSibling);
                    const h = o.mapper.toModelElement(s);
                    Pz(h.getAttribute("listIndent") + 1, n.position, d.start, s, o, t);
                    for (const t of a.createRangeIn(u).getItems())o.mapper.unbindViewElement(t);
                    e.stop();
                };
            }
            const kz = (t, e, n)=>{
                if (!n.consumable.test(e.item, t.name)) return;
                const o = n.mapper.toViewElement(e.item);
                const i = n.writer;
                i.breakContainer(i.createPositionBefore(o));
                i.breakContainer(i.createPositionAfter(o));
                const r = o.parent;
                const s = e.attributeNewValue == "numbered" ? "ol" : "ul";
                i.rename(s, r);
            };
            const bz = (t, e, n)=>{
                n.consumable.consume(e.item, t.name);
                const o = n.mapper.toViewElement(e.item);
                const i = o.parent;
                const r = n.writer;
                fL(r, i, i.nextSibling);
                fL(r, i.previousSibling, i);
            };
            function wz(t) {
                return (e, n, o)=>{
                    if (!o.consumable.consume(n.item, "attribute:listIndent")) return;
                    const i = o.mapper.toViewElement(n.item);
                    const r = o.writer;
                    r.breakContainer(r.createPositionBefore(i));
                    r.breakContainer(r.createPositionAfter(i));
                    const s = i.parent;
                    const a = s.previousSibling;
                    const c = r.createRangeOn(s);
                    r.remove(c);
                    if (a && a.nextSibling) fL(r, a, a.nextSibling);
                    Pz(n.attributeOldValue + 1, n.range.start, c.start, i, o, t);
                    hL(n.item, i, o, t);
                    for (const t of n.item.getChildren())o.consumable.consume(t, "insert");
                };
            }
            const _z = (t, e, n)=>{
                if (!n.consumable.test(e.item, t.name)) return;
                if (e.item.name != "listItem") {
                    let t = n.mapper.toViewPosition(e.range.start);
                    const o = n.writer;
                    const i = [];
                    while(t.parent.name == "ul" || t.parent.name == "ol"){
                        t = o.breakContainer(t);
                        if (t.parent.name != "li") break;
                        const e = t;
                        const n = o.createPositionAt(t.parent, "end");
                        if (!e.isEqual(n)) {
                            const t = o.remove(o.createRange(e, n));
                            i.push(t);
                        }
                        t = o.createPositionAfter(t.parent);
                    }
                    if (i.length > 0) {
                        for(let e = 0; e < i.length; e++){
                            const n = t.nodeBefore;
                            const r = o.insert(t, i[e]);
                            t = r.end;
                            if (e > 0) {
                                const e = fL(o, n, n.nextSibling);
                                if (e && e.parent == n) t.offset--;
                            }
                        }
                        fL(o, t.nodeBefore, t.nodeAfter);
                    }
                }
            };
            const Az = (t, e, n)=>{
                const o = n.mapper.toViewPosition(e.position);
                const i = o.nodeBefore;
                const r = o.nodeAfter;
                fL(n.writer, i, r);
            };
            const vz = (t, e, n)=>{
                if (n.consumable.consume(e.viewItem, {
                    name: true
                })) {
                    const t = n.writer;
                    const o = t.createElement("listItem");
                    const i = Rz(e.viewItem);
                    t.setAttribute("listIndent", i, o);
                    const r = e.viewItem.parent && e.viewItem.parent.name == "ol" ? "numbered" : "bulleted";
                    t.setAttribute("listType", r, o);
                    if (!n.safeInsert(o, e.modelCursor)) return;
                    const s = Tz(o, e.viewItem.getChildren(), n);
                    e.modelRange = t.createRange(e.modelCursor, s);
                    n.updateConversionResult(o, e);
                }
            };
            const Cz = (t, e, n)=>{
                if (n.consumable.test(e.viewItem, {
                    name: true
                })) {
                    const t = Array.from(e.viewItem.getChildren());
                    for (const e of t){
                        const t = !(e.is("element", "li") || Iz(e));
                        if (t) e._remove();
                    }
                }
            };
            const yz = (t, e, n)=>{
                if (n.consumable.test(e.viewItem, {
                    name: true
                })) {
                    if (e.viewItem.childCount === 0) return;
                    const t = [
                        ...e.viewItem.getChildren()
                    ];
                    let n = false;
                    for (const e of t){
                        if (n && !Iz(e)) e._remove();
                        if (Iz(e)) n = true;
                    }
                }
            };
            function xz(t) {
                return (e, n)=>{
                    if (n.isPhantom) return;
                    const o = n.modelPosition.nodeBefore;
                    if (o && o.is("element", "listItem")) {
                        const e = n.mapper.toViewElement(o);
                        const i = e.getAncestors().find(Iz);
                        const r = t.createPositionAt(e, 0).getWalker();
                        for (const t of r){
                            if (t.type == "elementStart" && t.item.is("element", "li")) {
                                n.viewPosition = t.previousPosition;
                                break;
                            } else if (t.type == "elementEnd" && t.item == i) {
                                n.viewPosition = t.nextPosition;
                                break;
                            }
                        }
                    }
                };
            }
            function Ez(t) {
                return (e, n)=>{
                    const o = n.viewPosition;
                    const i = o.parent;
                    const r = n.mapper;
                    if (i.name == "ul" || i.name == "ol") {
                        if (!o.isAtEnd) {
                            const e = r.toModelElement(o.nodeAfter);
                            n.modelPosition = t.createPositionBefore(e);
                        } else {
                            const e = r.toModelElement(o.nodeBefore);
                            const i = r.getModelLength(o.nodeBefore);
                            n.modelPosition = t.createPositionBefore(e).getShiftedBy(i);
                        }
                        e.stop();
                    } else if (i.name == "li" && o.nodeBefore && (o.nodeBefore.name == "ul" || o.nodeBefore.name == "ol")) {
                        const s = r.toModelElement(i);
                        let a = 1;
                        let c = o.nodeBefore;
                        while(c && Iz(c)){
                            a += r.getModelLength(c);
                            c = c.previousSibling;
                        }
                        n.modelPosition = t.createPositionBefore(s).getShiftedBy(a);
                        e.stop();
                    }
                };
            }
            function Dz(t, e) {
                const n = t.document.differ.getChanges();
                const o = new Map;
                let i = false;
                for (const o of n){
                    if (o.type == "insert" && o.name == "listItem") r(o.position);
                    else if (o.type == "insert" && o.name != "listItem") {
                        if (o.name != "$text") {
                            const n = o.position.nodeAfter;
                            if (n.hasAttribute("listIndent")) {
                                e.removeAttribute("listIndent", n);
                                i = true;
                            }
                            if (n.hasAttribute("listType")) {
                                e.removeAttribute("listType", n);
                                i = true;
                            }
                            if (n.hasAttribute("listStyle")) {
                                e.removeAttribute("listStyle", n);
                                i = true;
                            }
                            if (n.hasAttribute("listReversed")) {
                                e.removeAttribute("listReversed", n);
                                i = true;
                            }
                            if (n.hasAttribute("listStart")) {
                                e.removeAttribute("listStart", n);
                                i = true;
                            }
                            for (const e of Array.from(t.createRangeIn(n)).filter((t)=>t.item.is("element", "listItem")))r(e.previousPosition);
                        }
                        const n = o.position.getShiftedBy(o.length);
                        r(n);
                    } else if (o.type == "remove" && o.name == "listItem") r(o.position);
                    else if (o.type == "attribute" && o.attributeKey == "listIndent") r(o.range.start);
                    else if (o.type == "attribute" && o.attributeKey == "listType") r(o.range.start);
                }
                for (const t of o.values()){
                    s(t);
                    a(t);
                }
                return i;
                function r(t) {
                    const e = t.nodeBefore;
                    if (!e || !e.is("element", "listItem")) {
                        const e = t.nodeAfter;
                        if (e && e.is("element", "listItem")) o.set(e, e);
                    } else {
                        let t = e;
                        if (o.has(t)) return;
                        for(let e = t.previousSibling; e && e.is("element", "listItem"); e = t.previousSibling){
                            t = e;
                            if (o.has(t)) return;
                        }
                        o.set(e, t);
                    }
                }
                function s(t) {
                    let n = 0;
                    let o = null;
                    while(t && t.is("element", "listItem")){
                        const r = t.getAttribute("listIndent");
                        if (r > n) {
                            let s;
                            if (o === null) {
                                o = r - n;
                                s = n;
                            } else {
                                if (o > r) o = r;
                                s = r - o;
                            }
                            e.setAttribute("listIndent", s, t);
                            i = true;
                        } else {
                            o = null;
                            n = t.getAttribute("listIndent") + 1;
                        }
                        t = t.nextSibling;
                    }
                }
                function a(t) {
                    let n = [];
                    let o = null;
                    while(t && t.is("element", "listItem")){
                        const r = t.getAttribute("listIndent");
                        if (o && o.getAttribute("listIndent") > r) n = n.slice(0, r + 1);
                        if (r != 0) {
                            if (n[r]) {
                                const o = n[r];
                                if (t.getAttribute("listType") != o) {
                                    e.setAttribute("listType", o, t);
                                    i = true;
                                }
                            } else n[r] = t.getAttribute("listType");
                        }
                        o = t;
                        t = t.nextSibling;
                    }
                }
            }
            const Sz = function(t, [e, n]) {
                const o = this;
                let i = e.is("documentFragment") ? e.getChild(0) : e;
                let r;
                if (!n) r = o.document.selection;
                else r = o.createSelection(n);
                if (i && i.is("element", "listItem")) {
                    const t = r.getFirstPosition();
                    let e = null;
                    if (t.parent.is("element", "listItem")) e = t.parent;
                    else if (t.nodeBefore && t.nodeBefore.is("element", "listItem")) e = t.nodeBefore;
                    if (e) {
                        const t = e.getAttribute("listIndent");
                        if (t > 0) while(i && i.is("element", "listItem")){
                            i._setAttribute("listIndent", i.getAttribute("listIndent") + t);
                            i = i.nextSibling;
                        }
                    }
                }
            };
            function Tz(t, e, n) {
                const { writer: o, schema: i } = n;
                let r = o.createPositionAfter(t);
                for (const s of e)if (s.name == "ul" || s.name == "ol") r = n.convertItem(s, r).modelCursor;
                else {
                    const e = n.convertItem(s, o.createPositionAt(t, "end"));
                    const a = e.modelRange.start.nodeAfter;
                    const c = a && a.is("element") && !i.checkChild(t, a.name);
                    if (c) {
                        if (e.modelCursor.parent.is("element", "listItem")) t = e.modelCursor.parent;
                        else t = Bz(e.modelCursor);
                        r = o.createPositionAfter(t);
                    }
                }
                return r;
            }
            function Bz(t) {
                const e = new Ik({
                    startPosition: t
                });
                let n;
                do n = e.next();
                while (!n.value.item.is("element", "listItem"));
                return n.value.item;
            }
            function Pz(t, e, n, o, i, r) {
                const s = gL(e.nodeBefore, {
                    sameIndent: true,
                    smallerIndent: true,
                    listIndent: t
                });
                const a = i.mapper;
                const c = i.writer;
                const l = s ? s.getAttribute("listIndent") : null;
                let d;
                if (!s) d = n;
                else if (l == t) {
                    const t = a.toViewElement(s).parent;
                    d = c.createPositionAfter(t);
                } else {
                    const t = r.createPositionAt(s, "end");
                    d = a.toViewPosition(t);
                }
                d = pL(d);
                for (const t of [
                    ...o.getChildren()
                ])if (Iz(t)) {
                    d = c.move(c.createRangeOn(t), d).end;
                    fL(c, t, t.nextSibling);
                    fL(c, t.previousSibling, t);
                }
            }
            function Iz(t) {
                return t.is("element", "ol") || t.is("element", "ul");
            }
            function Rz(t) {
                let e = 0;
                let n = t.parent;
                while(n){
                    if (n.is("element", "li")) e++;
                    else {
                        const t = n.previousSibling;
                        if (t && t.is("element", "li")) e++;
                    }
                    n = n.parent;
                }
                return e;
            }
            class Oz extends Pu {
                static get pluginName() {
                    return "ListEditing";
                }
                static get requires() {
                    return [
                        EB,
                        mT,
                        pz
                    ];
                }
                init() {
                    const t = this.editor;
                    t.model.schema.register("listItem", {
                        inheritAllFrom: "$block",
                        allowAttributes: [
                            "listType",
                            "listIndent"
                        ]
                    });
                    const e = t.data;
                    const n = t.editing;
                    t.model.document.registerPostFixer((e)=>Dz(t.model, e));
                    n.mapper.registerViewToModelLength("li", Vz);
                    e.mapper.registerViewToModelLength("li", Vz);
                    n.mapper.on("modelToViewPosition", xz(n.view));
                    n.mapper.on("viewToModelPosition", Ez(t.model));
                    e.mapper.on("modelToViewPosition", xz(n.view));
                    t.conversion.for("editingDowncast").add((e)=>{
                        e.on("insert", _z, {
                            priority: "high"
                        });
                        e.on("insert:listItem", gz(t.model));
                        e.on("attribute:listType:listItem", kz, {
                            priority: "high"
                        });
                        e.on("attribute:listType:listItem", bz, {
                            priority: "low"
                        });
                        e.on("attribute:listIndent:listItem", wz(t.model));
                        e.on("remove:listItem", mz(t.model));
                        e.on("remove", Az, {
                            priority: "low"
                        });
                    });
                    t.conversion.for("dataDowncast").add((e)=>{
                        e.on("insert", _z, {
                            priority: "high"
                        });
                        e.on("insert:listItem", gz(t.model));
                    });
                    t.conversion.for("upcast").add((t)=>{
                        t.on("element:ul", Cz, {
                            priority: "high"
                        });
                        t.on("element:ol", Cz, {
                            priority: "high"
                        });
                        t.on("element:li", yz, {
                            priority: "high"
                        });
                        t.on("element:li", vz);
                    });
                    t.model.on("insertContent", Sz, {
                        priority: "high"
                    });
                    t.commands.add("numberedList", new uz(t, "numbered"));
                    t.commands.add("bulletedList", new uz(t, "bulleted"));
                    t.commands.add("indentList", new dz(t, "forward"));
                    t.commands.add("outdentList", new dz(t, "backward"));
                    const o = n.view.document;
                    this.listenTo(o, "enter", (t, e)=>{
                        const n = this.editor.model.document;
                        const o = n.selection.getLastPosition().parent;
                        if (n.selection.isCollapsed && o.name == "listItem" && o.isEmpty) {
                            this.editor.execute("outdentList");
                            e.preventDefault();
                            t.stop();
                        }
                    }, {
                        context: "li"
                    });
                    this.listenTo(o, "delete", (t, e)=>{
                        if (e.direction !== "backward") return;
                        const n = this.editor.model.document.selection;
                        if (!n.isCollapsed) return;
                        const o = n.getFirstPosition();
                        if (!o.isAtStart) return;
                        const i = o.parent;
                        if (i.name !== "listItem") return;
                        const r = i.previousSibling && i.previousSibling.name === "listItem";
                        if (r) return;
                        this.editor.execute("outdentList");
                        e.preventDefault();
                        t.stop();
                    }, {
                        context: "li"
                    });
                    this.listenTo(t.editing.view.document, "tab", (e, n)=>{
                        const o = n.shiftKey ? "outdentList" : "indentList";
                        const i = this.editor.commands.get(o);
                        if (i.isEnabled) {
                            t.execute(o);
                            n.stopPropagation();
                            n.preventDefault();
                            e.stop();
                        }
                    }, {
                        context: "li"
                    });
                }
                afterInit() {
                    const t = this.editor.commands;
                    const e = t.get("indent");
                    const n = t.get("outdent");
                    if (e) e.registerChildCommand(t.get("indentList"));
                    if (n) n.registerChildCommand(t.get("outdentList"));
                }
            }
            function Vz(t) {
                let e = 1;
                for (const n of t.getChildren()){
                    if (n.name == "ul" || n.name == "ol") for (const t of n.getChildren())e += Vz(t);
                }
                return e;
            }
            class Mz extends Pu {
                static get requires() {
                    return [
                        Oz,
                        EL
                    ];
                }
                static get pluginName() {
                    return "List";
                }
            }
            class Lz extends null {
                constructor(t, e){
                    super(t);
                    this.defaultType = e;
                }
                refresh() {
                    this.value = this._getValue();
                    this.isEnabled = this._checkEnabled();
                }
                execute(t = {}) {
                    this._tryToConvertItemsToList(t);
                    const e = this.editor.model;
                    const n = getSelectedListItems(e);
                    if (!n.length) return;
                    e.change((e)=>{
                        for (const o of n)e.setAttribute("listStyle", t.type || this.defaultType, o);
                    });
                }
                _getValue() {
                    const t = this.editor.model.document.selection.getFirstPosition().parent;
                    if (t && t.is("element", "listItem")) return t.getAttribute("listStyle");
                    return null;
                }
                _checkEnabled() {
                    const t = this.editor;
                    const e = t.commands.get("numberedList");
                    const n = t.commands.get("bulletedList");
                    return e.isEnabled || n.isEnabled;
                }
                _tryToConvertItemsToList(t) {
                    if (!t.type) return;
                    const e = getListTypeFromListStyleType(t.type);
                    if (!e) return;
                    const n = this.editor;
                    const o = `${e}List`;
                    const i = n.commands.get(o);
                    if (!i.value) n.execute(o);
                }
            }
            class zz extends null {
                refresh() {
                    const t = this._getValue();
                    this.value = t;
                    this.isEnabled = t != null;
                }
                execute(t = {}) {
                    const e = this.editor.model;
                    const n = getSelectedListItems(e).filter((t)=>t.getAttribute("listType") == "numbered");
                    e.change((e)=>{
                        for (const o of n)e.setAttribute("listReversed", !!t.reversed, o);
                    });
                }
                _getValue() {
                    const t = this.editor.model.document.selection.getFirstPosition().parent;
                    if (t && t.is("element", "listItem") && t.getAttribute("listType") == "numbered") return t.getAttribute("listReversed");
                    return null;
                }
            }
            class Nz extends null {
                refresh() {
                    const t = this._getValue();
                    this.value = t;
                    this.isEnabled = t != null;
                }
                execute({ startIndex: t = 1 } = {}) {
                    const e = this.editor.model;
                    const n = getSelectedListItems(e).filter((t)=>t.getAttribute("listType") == "numbered");
                    e.change((e)=>{
                        for (const o of n)e.setAttribute("listStart", t >= 0 ? t : 1, o);
                    });
                }
                _getValue() {
                    const t = this.editor.model.document.selection.getFirstPosition().parent;
                    if (t && t.is("element", "listItem") && t.getAttribute("listType") == "numbered") return t.getAttribute("listStart");
                    return null;
                }
            }
            const Fz = "default";
            class Hz extends null {
                static get requires() {
                    return [
                        ListEditing
                    ];
                }
                static get pluginName() {
                    return "ListPropertiesEditing";
                }
                constructor(t){
                    super(t);
                    t.config.define("list", {
                        properties: {
                            styles: true,
                            startIndex: false,
                            reversed: false
                        }
                    });
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.config.get("list.properties");
                    const o = jz(n);
                    e.schema.extend("listItem", {
                        allowAttributes: o.map((t)=>t.attributeName)
                    });
                    for (const e of o)e.addCommand(t);
                    this.listenTo(t.commands.get("indentList"), "_executeCleanup", $z(t, o));
                    this.listenTo(t.commands.get("outdentList"), "_executeCleanup", Gz(t, o));
                    this.listenTo(t.commands.get("bulletedList"), "_executeCleanup", Yz(t));
                    this.listenTo(t.commands.get("numberedList"), "_executeCleanup", Yz(t));
                    e.document.registerPostFixer(Uz(t, o));
                    t.conversion.for("upcast").add(qz(o));
                    t.conversion.for("downcast").add(Wz(o));
                    this._mergeListAttributesWhileMergingLists(o);
                }
                afterInit() {
                    const t = this.editor;
                    if (t.commands.get("todoList")) t.model.document.registerPostFixer(Jz(t));
                }
                _mergeListAttributesWhileMergingLists(t) {
                    const e = this.editor;
                    const n = e.model;
                    let o;
                    this.listenTo(n, "deleteContent", (t, [e])=>{
                        const n = e.getFirstPosition();
                        const i = e.getLastPosition();
                        if (n.parent === i.parent) return;
                        if (!n.parent.is("element", "listItem")) return;
                        const r = i.parent.nextSibling;
                        if (!r || !r.is("element", "listItem")) return;
                        const s = getSiblingListItem(n.parent, {
                            sameIndent: true,
                            listIndent: r.getAttribute("listIndent")
                        });
                        if (!s) return;
                        if (s.getAttribute("listType") === r.getAttribute("listType")) o = s;
                    }, {
                        priority: "high"
                    });
                    this.listenTo(n, "deleteContent", ()=>{
                        if (!o) return;
                        n.change((e)=>{
                            const n = getSiblingListItem(o.nextSibling, {
                                sameIndent: true,
                                listIndent: o.getAttribute("listIndent"),
                                direction: "forward"
                            });
                            if (!n) {
                                o = null;
                                return;
                            }
                            const i = [
                                n,
                                ...getSiblingNodes(e.createPositionAt(n, 0), "forward")
                            ];
                            for (const n of i){
                                for (const i of t)if (i.appliesToListItem(n)) {
                                    const t = i.attributeName;
                                    const r = o.getAttribute(t);
                                    e.setAttribute(t, r, n);
                                }
                            }
                        });
                        o = null;
                    }, {
                        priority: "low"
                    });
                }
            }
            function jz(t) {
                const e = [];
                if (t.styles) e.push({
                    attributeName: "listStyle",
                    defaultValue: Fz,
                    addCommand (t) {
                        t.commands.add("listStyle", new ListStyleCommand(t, Fz));
                    },
                    appliesToListItem () {
                        return true;
                    },
                    setAttributeOnDowncast (t, e, n) {
                        if (e && e !== Fz) t.setStyle("list-style-type", e, n);
                        else t.removeStyle("list-style-type", n);
                    },
                    getAttributeOnUpcast (t) {
                        return t.getStyle("list-style-type") || Fz;
                    }
                });
                if (t.reversed) e.push({
                    attributeName: "listReversed",
                    defaultValue: false,
                    addCommand (t) {
                        t.commands.add("listReversed", new ListReversedCommand(t));
                    },
                    appliesToListItem (t) {
                        return t.getAttribute("listType") == "numbered";
                    },
                    setAttributeOnDowncast (t, e, n) {
                        if (e) t.setAttribute("reversed", "reversed", n);
                        else t.removeAttribute("reversed", n);
                    },
                    getAttributeOnUpcast (t) {
                        return t.hasAttribute("reversed");
                    }
                });
                if (t.startIndex) e.push({
                    attributeName: "listStart",
                    defaultValue: 1,
                    addCommand (t) {
                        t.commands.add("listStart", new ListStartCommand(t));
                    },
                    appliesToListItem (t) {
                        return t.getAttribute("listType") == "numbered";
                    },
                    setAttributeOnDowncast (t, e, n) {
                        if (e == 0 || e > 1) t.setAttribute("start", e, n);
                        else t.removeAttribute("start", n);
                    },
                    getAttributeOnUpcast (t) {
                        const e = t.getAttribute("start");
                        return e >= 0 ? e : 1;
                    }
                });
                return e;
            }
            function qz(t) {
                return (e)=>{
                    e.on("element:li", (e, n, o)=>{
                        if (!n.modelRange) return;
                        const i = n.viewItem.parent;
                        const r = n.modelRange.start.nodeAfter || n.modelRange.end.nodeBefore;
                        for (const e of t)if (e.appliesToListItem(r)) {
                            const t = e.getAttributeOnUpcast(i);
                            o.writer.setAttribute(e.attributeName, t, r);
                        }
                    }, {
                        priority: "low"
                    });
                };
            }
            function Wz(t) {
                return (n)=>{
                    for (const o of t)n.on(`attribute:${o.attributeName}:listItem`, (t, n, i)=>{
                        const r = i.writer;
                        const s = n.item;
                        const a = getSiblingListItem(s.previousSibling, {
                            sameIndent: true,
                            listIndent: s.getAttribute("listIndent"),
                            direction: "backward"
                        });
                        const c = i.mapper.toViewElement(s);
                        if (!e(s, a)) r.breakContainer(r.createPositionBefore(c));
                        o.setAttributeOnDowncast(r, n.attributeNewValue, c.parent);
                    }, {
                        priority: "low"
                    });
                };
                function e(t, e) {
                    return e && t.getAttribute("listType") === e.getAttribute("listType") && t.getAttribute("listIndent") === e.getAttribute("listIndent") && t.getAttribute("listStyle") === e.getAttribute("listStyle") && t.getAttribute("listReversed") === e.getAttribute("listReversed") && t.getAttribute("listStart") === e.getAttribute("listStart");
                }
            }
            function $z(t, e) {
                return (n, o)=>{
                    const i = o[0];
                    const r = i.getAttribute("listIndent");
                    const s = o.filter((t)=>t.getAttribute("listIndent") === r);
                    let a = null;
                    if (i.previousSibling.getAttribute("listIndent") + 1 !== r) a = getSiblingListItem(i.previousSibling, {
                        sameIndent: true,
                        direction: "backward",
                        listIndent: r
                    });
                    t.model.change((t)=>{
                        for (const n of s){
                            for (const o of e)if (o.appliesToListItem(n)) {
                                const e = a == null ? o.defaultValue : a.getAttribute(o.attributeName);
                                t.setAttribute(o.attributeName, e, n);
                            }
                        }
                    });
                };
            }
            function Gz(t, e) {
                return (n, o)=>{
                    o = o.reverse().filter((t)=>t.is("element", "listItem"));
                    if (!o.length) return;
                    const i = o[0].getAttribute("listIndent");
                    const r = o[0].getAttribute("listType");
                    let s = o[0].previousSibling;
                    if (s.is("element", "listItem")) while(s.getAttribute("listIndent") !== i)s = s.previousSibling;
                    else s = null;
                    if (!s) s = o[o.length - 1].nextSibling;
                    if (!s || !s.is("element", "listItem")) return;
                    if (s.getAttribute("listType") !== r) return;
                    t.model.change((t)=>{
                        const n = o.filter((t)=>t.getAttribute("listIndent") === i);
                        for (const o of n){
                            for (const n of e)if (n.appliesToListItem(o)) {
                                const e = n.attributeName;
                                const i = s.getAttribute(e);
                                t.setAttribute(e, i, o);
                            }
                        }
                    });
                };
            }
            function Uz(t, e) {
                return (n)=>{
                    let o = false;
                    const i = Qz(t.model.document.differ.getChanges()).filter((t)=>t.getAttribute("listType") !== "todo");
                    if (!i.length) return o;
                    let r = i[i.length - 1].nextSibling;
                    if (!r || !r.is("element", "listItem")) {
                        r = i[0].previousSibling;
                        if (r) {
                            const t = i[0].getAttribute("listIndent");
                            while(r.is("element", "listItem") && r.getAttribute("listIndent") !== t){
                                r = r.previousSibling;
                                if (!r) break;
                            }
                        }
                    }
                    for (const t of e){
                        const e = t.attributeName;
                        for (const s of i){
                            if (!t.appliesToListItem(s)) {
                                n.removeAttribute(e, s);
                                continue;
                            }
                            if (!s.hasAttribute(e)) {
                                if (Kz(r, s, t)) n.setAttribute(e, r.getAttribute(e), s);
                                else n.setAttribute(e, t.defaultValue, s);
                                o = true;
                            } else {
                                const i = s.previousSibling;
                                if (Zz(i, s, t.attributeName)) {
                                    n.setAttribute(e, i.getAttribute(e), s);
                                    o = true;
                                }
                            }
                        }
                    }
                    return o;
                };
            }
            function Kz(t, e, n) {
                if (!t) return false;
                const o = t.getAttribute(n.attributeName);
                if (!o) return false;
                if (o == n.defaultValue) return false;
                if (t.getAttribute("listType") !== e.getAttribute("listType")) return false;
                return true;
            }
            function Zz(t, e, n) {
                if (!t || !t.is("element", "listItem")) return false;
                if (e.getAttribute("listType") !== t.getAttribute("listType")) return false;
                const o = t.getAttribute("listIndent");
                if (o < 1 || o !== e.getAttribute("listIndent")) return false;
                const i = t.getAttribute(n);
                if (!i || i === e.getAttribute(n)) return false;
                return true;
            }
            function Jz(t) {
                return (e)=>{
                    const n = Qz(t.model.document.differ.getChanges()).filter((t)=>t.getAttribute("listType") === "todo" && (t.hasAttribute("listStyle") || t.hasAttribute("listReversed") || t.hasAttribute("listStart")));
                    if (!n.length) return false;
                    for (const t of n){
                        e.removeAttribute("listStyle", t);
                        e.removeAttribute("listReversed", t);
                        e.removeAttribute("listStart", t);
                    }
                    return true;
                };
            }
            function Yz(t) {
                return (e, n)=>{
                    n = n.filter((t)=>t.is("element", "listItem"));
                    t.model.change((t)=>{
                        for (const e of n)t.removeAttribute("listStyle", e);
                    });
                };
            }
            function Qz(t) {
                const e = [];
                for (const n of t){
                    const t = Xz(n);
                    if (t && t.is("element", "listItem")) e.push(t);
                }
                return e;
            }
            function Xz(t) {
                if (t.type === "attribute") return t.range.start.nodeAfter;
                if (t.type === "insert") return t.position.nodeAfter;
                return null;
            }
            class tN extends null {
                static get requires() {
                    return [
                        ListPropertiesEditing,
                        ListPropertiesUI
                    ];
                }
                static get pluginName() {
                    return "ListProperties";
                }
            }
            const eN = "todoListChecked";
            class nN extends null {
                constructor(t){
                    super(t);
                    this._selectedElements = [];
                    this.on("execute", ()=>{
                        this.refresh();
                    }, {
                        priority: "highest"
                    });
                }
                refresh() {
                    this._selectedElements = this._getSelectedItems();
                    this.value = this._selectedElements.every((t)=>!!t.getAttribute(eN));
                    this.isEnabled = !!this._selectedElements.length;
                }
                _getSelectedItems() {
                    const t = this.editor.model;
                    const e = t.schema;
                    const n = t.document.selection.getFirstRange();
                    const o = n.start.parent;
                    const i = [];
                    if (e.checkAttribute(o, eN)) i.push(o);
                    for (const t of n.getItems())if (e.checkAttribute(t, eN) && !i.includes(t)) i.push(t);
                    return i;
                }
                execute(t = {}) {
                    this.editor.model.change((e)=>{
                        for (const n of this._selectedElements){
                            const o = t.forceValue === undefined ? !this.value : t.forceValue;
                            if (o) e.setAttribute(eN, true, n);
                            else e.removeAttribute(eN, n);
                        }
                    });
                }
            }
            function oN(t, e) {
                return (n, o, i)=>{
                    const r = i.consumable;
                    if (!r.test(o.item, "insert") || !r.test(o.item, "attribute:listType") || !r.test(o.item, "attribute:listIndent")) return;
                    if (o.item.getAttribute("listType") != "todo") return;
                    const s = o.item;
                    r.consume(s, "insert");
                    r.consume(s, "attribute:listType");
                    r.consume(s, "attribute:listIndent");
                    r.consume(s, "attribute:todoListChecked");
                    const a = i.writer;
                    const c = generateLiInUl(s, i);
                    const l = !!s.getAttribute("todoListChecked");
                    const d = lN(s, a, l, e);
                    const u = a.createContainerElement("span", {
                        class: "todo-list__label__description"
                    });
                    a.addClass("todo-list", c.parent);
                    a.insert(a.createPositionAt(c, 0), d);
                    a.insert(a.createPositionAfter(d), u);
                    injectViewList(s, c, i, t);
                };
            }
            function iN(t) {
                return (e, n, o)=>{
                    const i = o.consumable;
                    if (!i.test(n.item, "insert") || !i.test(n.item, "attribute:listType") || !i.test(n.item, "attribute:listIndent")) return;
                    if (n.item.getAttribute("listType") != "todo") return;
                    const r = n.item;
                    i.consume(r, "insert");
                    i.consume(r, "attribute:listType");
                    i.consume(r, "attribute:listIndent");
                    i.consume(r, "attribute:todoListChecked");
                    const s = o.writer;
                    const a = generateLiInUl(r, o);
                    s.addClass("todo-list", a.parent);
                    const c = s.createContainerElement("label", {
                        class: "todo-list__label"
                    });
                    const l = s.createEmptyElement("input", {
                        type: "checkbox",
                        disabled: "disabled"
                    });
                    const d = s.createContainerElement("span", {
                        class: "todo-list__label__description"
                    });
                    if (r.getAttribute("todoListChecked")) s.setAttribute("checked", "checked", l);
                    s.insert(s.createPositionAt(a, 0), c);
                    s.insert(s.createPositionAt(c, 0), l);
                    s.insert(s.createPositionAfter(l), d);
                    injectViewList(r, a, o, t);
                };
            }
            const rN = (t, e, n)=>{
                const o = e.modelCursor;
                const i = o.parent;
                const r = e.viewItem;
                if (r.getAttribute("type") != "checkbox" || i.name != "listItem" || !o.isAtStart) return;
                if (!n.consumable.consume(r, {
                    name: true
                })) return;
                const s = n.writer;
                s.setAttribute("listType", "todo", i);
                if (e.viewItem.hasAttribute("checked")) s.setAttribute("todoListChecked", true, i);
                e.modelRange = s.createRange(o);
            };
            function sN(t, e) {
                return (n, o, i)=>{
                    if (!i.consumable.consume(o.item, n.name)) return;
                    const r = i.mapper.toViewElement(o.item);
                    const s = i.writer;
                    const a = dN(r, e);
                    if (o.attributeNewValue == "todo") {
                        const e = !!o.item.getAttribute("todoListChecked");
                        const n = lN(o.item, s, e, t);
                        const i = s.createContainerElement("span", {
                            class: "todo-list__label__description"
                        });
                        const a = s.createRangeIn(r);
                        const c = findNestedList(r);
                        const l = positionAfterUiElements(a.start);
                        const d = c ? s.createPositionBefore(c) : a.end;
                        const u = s.createRange(l, d);
                        s.addClass("todo-list", r.parent);
                        s.move(u, s.createPositionAt(i, 0));
                        s.insert(s.createPositionAt(r, 0), n);
                        s.insert(s.createPositionAfter(n), i);
                    } else if (o.attributeOldValue == "todo") {
                        const t = uN(r, e);
                        s.removeClass("todo-list", r.parent);
                        s.remove(a);
                        s.move(s.createRangeIn(t), s.createPositionBefore(t));
                        s.remove(t);
                    }
                };
            }
            function aN(t) {
                return (e, n, o)=>{
                    if (n.item.getAttribute("listType") != "todo") return;
                    if (!o.consumable.consume(n.item, "attribute:todoListChecked")) return;
                    const { mapper: i, writer: r } = o;
                    const s = !!n.item.getAttribute("todoListChecked");
                    const a = i.toViewElement(n.item);
                    const c = a.getChild(0);
                    const l = lN(n.item, r, s, t);
                    r.insert(r.createPositionAfter(c), l);
                    r.remove(c);
                };
            }
            function cN(t) {
                return (e, n)=>{
                    const o = n.modelPosition;
                    const i = o.parent;
                    if (!i.is("element", "listItem") || i.getAttribute("listType") != "todo") return;
                    const r = n.mapper.toViewElement(i);
                    const s = uN(r, t);
                    if (s) n.viewPosition = n.mapper.findPositionIn(s, o.offset);
                };
            }
            function lN(t, e, n, o) {
                const i = e.createUIElement("label", {
                    class: "todo-list__label",
                    contenteditable: false
                }, function(e) {
                    const i = createElement(document, "input", {
                        type: "checkbox",
                        tabindex: "-1"
                    });
                    if (n) i.setAttribute("checked", "checked");
                    i.addEventListener("change", ()=>o(t));
                    const r = this.toDomElement(e);
                    r.appendChild(i);
                    return r;
                });
                return i;
            }
            function dN(t, e) {
                const n = e.createRangeIn(t);
                for (const t of n){
                    if (t.item.is("uiElement", "label")) return t.item;
                }
            }
            function uN(t, e) {
                const n = e.createRangeIn(t);
                for (const t of n){
                    if (t.item.is("containerElement", "span") && t.item.hasClass("todo-list__label__description")) return t.item;
                }
            }
            const hN = Kc("Ctrl+Enter");
            class fN extends null {
                static get pluginName() {
                    return "TodoListEditing";
                }
                static get requires() {
                    return [
                        ListEditing
                    ];
                }
                init() {
                    const t = this.editor;
                    const { editing: e, data: n, model: o } = t;
                    o.schema.extend("listItem", {
                        allowAttributes: [
                            "todoListChecked"
                        ]
                    });
                    o.schema.addAttributeCheck((t, e)=>{
                        const n = t.last;
                        if (e == "todoListChecked" && n.name == "listItem" && n.getAttribute("listType") != "todo") return false;
                    });
                    t.commands.add("todoList", new ListCommand(t, "todo"));
                    const i = new CheckTodoListCommand(t);
                    t.commands.add("checkTodoList", i);
                    t.commands.add("todoListCheck", i);
                    n.downcastDispatcher.on("insert:listItem", dataModelViewInsertion(o), {
                        priority: "high"
                    });
                    n.upcastDispatcher.on("element:input", dataViewModelCheckmarkInsertion, {
                        priority: "high"
                    });
                    e.downcastDispatcher.on("insert:listItem", modelViewInsertion(o, (t)=>this._handleCheckmarkChange(t)), {
                        priority: "high"
                    });
                    e.downcastDispatcher.on("attribute:listType:listItem", modelViewChangeType((t)=>this._handleCheckmarkChange(t), e.view));
                    e.downcastDispatcher.on("attribute:todoListChecked:listItem", modelViewChangeChecked((t)=>this._handleCheckmarkChange(t)));
                    e.mapper.on("modelToViewPosition", mapModelToViewPosition(e.view));
                    n.mapper.on("modelToViewPosition", mapModelToViewPosition(e.view));
                    this.listenTo(e.view.document, "arrowKey", pN(o, t.locale), {
                        context: "li"
                    });
                    this.listenTo(e.view.document, "keydown", (e, n)=>{
                        if (getCode(n) === hN) {
                            t.execute("checkTodoList");
                            e.stop();
                        }
                    }, {
                        priority: "high"
                    });
                    const r = new Set;
                    this.listenTo(o, "applyOperation", (t, e)=>{
                        const n = e[0];
                        if (n.type == "rename" && n.oldName == "listItem") {
                            const t = n.position.nodeAfter;
                            if (t.hasAttribute("todoListChecked")) r.add(t);
                        } else if (n.type == "changeAttribute" && n.key == "listType" && n.oldValue === "todo") {
                            for (const t of n.range.getItems())if (t.hasAttribute("todoListChecked") && t.getAttribute("listType") !== "todo") r.add(t);
                        }
                    });
                    o.document.registerPostFixer((t)=>{
                        let e = false;
                        for (const n of r){
                            t.removeAttribute("todoListChecked", n);
                            e = true;
                        }
                        r.clear();
                        return e;
                    });
                }
                _handleCheckmarkChange(t) {
                    const e = this.editor;
                    const n = e.model;
                    const o = Array.from(n.document.selection.getRanges());
                    n.change((n)=>{
                        n.setSelection(t, "end");
                        e.execute("checkTodoList");
                        n.setSelection(o);
                    });
                }
            }
            function pN(t, e) {
                return (n, o)=>{
                    const i = getLocalizedArrowKeyCodeDirection(o.keyCode, e.contentLanguageDirection);
                    if (i != "left") return;
                    const r = t.schema;
                    const s = t.document.selection;
                    if (!s.isCollapsed) return;
                    const a = s.getFirstPosition();
                    const c = a.parent;
                    if (c.name === "listItem" && c.getAttribute("listType") == "todo" && a.isAtStart) {
                        const e = r.getNearestSelectionRange(t.createPositionBefore(c), "backward");
                        if (e) t.change((t)=>t.setSelection(e));
                        o.preventDefault();
                        o.stopPropagation();
                        n.stop();
                    }
                };
            }
            class gN extends null {
                static get pluginName() {
                    return "TodoListUI";
                }
                init() {
                    const t = this.editor.t;
                    createUIComponent(this.editor, "todoList", t("To-do List"), todoListIcon);
                }
            }
            var mN = n(9292);
            var kN = {
                injectType: "singletonStyleTag",
                attributes: {
                    "data-cke": true
                }
            };
            kN.insert = "head";
            kN.singleton = true;
            var bN = Rl()(mN.Z, kN);
            const wN = mN.Z.locals || {};
            class _N extends null {
                static get requires() {
                    return [
                        TodoListEditing,
                        TodoListUI
                    ];
                }
                static get pluginName() {
                    return "TodoList";
                }
            }
            class AN extends null {
                constructor(t){
                    super(t);
                    this.on("execute", ()=>{
                        this.refresh();
                    }, {
                        priority: "highest"
                    });
                }
                refresh() {
                    const t = this._getSelectedItems();
                    this.value = this._getValue(t);
                    this.isEnabled = !!t.length;
                }
                execute(t = {}) {
                    this.editor.model.change((e)=>{
                        const n = this._getSelectedItems();
                        const o = t.forceValue === undefined ? !this._getValue(n) : t.forceValue;
                        for (const t of n)if (o) e.setAttribute("todoListChecked", true, t);
                        else e.removeAttribute("todoListChecked", t);
                    });
                }
                _getValue(t) {
                    return t.every((t)=>t.getAttribute("todoListChecked"));
                }
                _getSelectedItems() {
                    const t = this.editor.model;
                    const e = t.schema;
                    const n = t.document.selection.getFirstRange();
                    const o = n.start.parent;
                    const i = [];
                    if (e.checkAttribute(o, "todoListChecked")) i.push(...getAllListItemBlocks(o));
                    for (const t of n.getItems({
                        shallow: true
                    }))if (e.checkAttribute(t, "todoListChecked") && !i.includes(t)) i.push(...getAllListItemBlocks(t));
                    return i;
                }
            }
            class vN extends null {
                constructor(){
                    super(...arguments);
                    this.domEventType = [
                        "change"
                    ];
                }
                onDomEvent(t) {
                    if (t.target) {
                        const e = this.view.domConverter.mapDomToView(t.target);
                        if (e && e.is("element", "input") && e.getAttribute("type") == "checkbox" && e.findAncestor({
                            classes: "todo-list__label"
                        })) this.fire("todoCheckboxChange", t);
                    }
                }
            }
            const CN = Kc("Ctrl+Enter");
            class yN extends null {
                static get pluginName() {
                    return "TodoDocumentListEditing";
                }
                static get requires() {
                    return [
                        DocumentListEditing
                    ];
                }
                init() {
                    const t = this.editor;
                    const e = t.model;
                    const n = t.editing;
                    const o = t.plugins.get(DocumentListEditing);
                    const i = t.config.get("list.multiBlock");
                    const r = i ? "paragraph" : "listItem";
                    t.commands.add("todoList", new DocumentListCommand(t, "todo"));
                    t.commands.add("checkTodoList", new CheckTodoDocumentListCommand(t));
                    n.view.addObserver(TodoCheckboxChangeObserver);
                    e.schema.extend("$listItem", {
                        allowAttributes: "todoListChecked"
                    });
                    e.schema.addAttributeCheck((t, e)=>{
                        const n = t.last;
                        if (e != "todoListChecked") return;
                        if (!n.getAttribute("listItemId") || n.getAttribute("listType") != "todo") return false;
                    });
                    t.conversion.for("upcast").add((t)=>{
                        t.on("element:input", xN());
                        t.on("element:label", EN({
                            name: "label",
                            classes: "todo-list__label"
                        }));
                        t.on("element:label", EN({
                            name: "label",
                            classes: [
                                "todo-list__label",
                                "todo-list__label_without-description"
                            ]
                        }));
                        t.on("element:span", EN({
                            name: "span",
                            classes: "todo-list__label__description"
                        }));
                        t.on("element:ul", DN({
                            name: "ul",
                            classes: "todo-list"
                        }));
                    });
                    t.conversion.for("downcast").elementToElement({
                        model: r,
                        view: (t, { writer: e })=>{
                            if (SN(t, o.getListAttributeNames())) return e.createContainerElement("span", {
                                class: "todo-list__label__description"
                            });
                        },
                        converterPriority: "highest"
                    });
                    o.registerDowncastStrategy({
                        scope: "list",
                        attributeName: "listType",
                        setAttributeOnDowncast (t, e, n) {
                            if (e == "todo") t.addClass("todo-list", n);
                            else t.removeClass("todo-list", n);
                        }
                    });
                    o.registerDowncastStrategy({
                        scope: "itemMarker",
                        attributeName: "todoListChecked",
                        createElement (t, e, { dataPipeline: n }) {
                            if (e.getAttribute("listType") != "todo") return null;
                            const o = t.createEmptyElement("input", {
                                type: "checkbox",
                                ...e.getAttribute("todoListChecked") ? {
                                    checked: "checked"
                                } : null,
                                ...n ? {
                                    disabled: "disabled"
                                } : {
                                    tabindex: "-1"
                                }
                            });
                            if (n) return o;
                            return t.createContainerElement("span", {
                                contenteditable: "false"
                            }, o);
                        },
                        canWrapElement (t) {
                            return SN(t, o.getListAttributeNames());
                        },
                        createWrapperElement (t, e, { dataPipeline: n }) {
                            const i = [
                                "todo-list__label"
                            ];
                            if (!SN(e, o.getListAttributeNames())) i.push("todo-list__label_without-description");
                            return t.createAttributeElement(n ? "label" : "span", {
                                class: i.join(" ")
                            });
                        }
                    });
                    n.mapper.registerViewToModelLength("input", (t)=>{
                        if (t.getAttribute("type") == "checkbox" && t.findAncestor({
                            classes: "todo-list__label"
                        })) return 0;
                        return n.mapper.toModelElement(t) ? 1 : 0;
                    });
                    o.on("checkElement", (t, { modelElement: e, viewElement: n })=>{
                        const i = SN(e, o.getListAttributeNames());
                        const r = n.hasClass("todo-list__label__description");
                        if (r != i) {
                            t.return = true;
                            t.stop();
                        }
                    });
                    o.on("checkElement", (e, { modelElement: n, viewElement: o })=>{
                        const i = n.getAttribute("listType") == "todo" && isFirstBlockOfListItem(n);
                        let r = false;
                        const s = t.editing.view.createPositionBefore(o).getWalker({
                            direction: "backward"
                        });
                        for (const { item: e } of s){
                            if (e.is("element") && t.editing.mapper.toModelElement(e)) break;
                            if (e.is("element", "input") && e.getAttribute("type") == "checkbox") r = true;
                        }
                        if (r != i) {
                            e.return = true;
                            e.stop();
                        }
                    });
                    o.on("postFixer", (t, { listNodes: e, writer: n })=>{
                        for (const { node: o, previousNodeInList: i } of e){
                            if (!i) continue;
                            if (i.getAttribute("listItemId") != o.getAttribute("listItemId")) continue;
                            const e = i.hasAttribute("todoListChecked");
                            const r = o.hasAttribute("todoListChecked");
                            if (r && !e) {
                                n.removeAttribute("todoListChecked", o);
                                t.return = true;
                            } else if (!r && e) {
                                n.setAttribute("todoListChecked", true, o);
                                t.return = true;
                            }
                        }
                    });
                    e.document.registerPostFixer((t)=>{
                        const n = e.document.differ.getChanges();
                        let o = false;
                        for (const e of n){
                            if (e.type == "attribute" && e.attributeKey == "listType") {
                                const n = e.range.start.nodeAfter;
                                if (e.attributeOldValue == "todo" && n.hasAttribute("todoListChecked")) {
                                    t.removeAttribute("todoListChecked", n);
                                    o = true;
                                }
                            } else if (e.type == "insert" && e.name != "$text") {
                                for (const { item: n } of t.createRangeOn(e.position.nodeAfter))if (n.is("element") && n.getAttribute("listType") != "todo" && n.hasAttribute("todoListChecked")) {
                                    t.removeAttribute("todoListChecked", n);
                                    o = true;
                                }
                            }
                        }
                        return o;
                    });
                    this.listenTo(n.view.document, "keydown", (e, n)=>{
                        if (getCode(n) === CN) {
                            t.execute("checkTodoList");
                            e.stop();
                        }
                    }, {
                        priority: "high"
                    });
                    this.listenTo(n.view.document, "todoCheckboxChange", (t, e)=>{
                        const o = e.target;
                        if (!o || !o.is("element", "input")) return;
                        const i = n.view.createPositionAfter(o);
                        const r = n.mapper.toModelPosition(i);
                        const s = r.parent;
                        if (s && isListItemBlock(s) && s.getAttribute("listType") == "todo") this._handleCheckmarkChange(s);
                    });
                    this.listenTo(n.view.document, "arrowKey", BN(e, t.locale), {
                        context: "$text"
                    });
                    this.listenTo(n.mapper, "viewToModelPosition", (t, n)=>{
                        const o = n.viewPosition.parent;
                        const i = o.is("attributeElement", "li") && n.viewPosition.offset == 0;
                        const r = PN(o) && n.viewPosition.offset <= 1;
                        const s = o.is("element", "span") && o.getAttribute("contenteditable") == "false" && PN(o.parent);
                        if (!i && !r && !s) return;
                        const a = n.modelPosition.nodeAfter;
                        if (a && a.getAttribute("listType") == "todo") n.modelPosition = e.createPositionAt(a, 0);
                    }, {
                        priority: "low"
                    });
                }
                _handleCheckmarkChange(t) {
                    const e = this.editor;
                    const n = e.model;
                    const o = Array.from(n.document.selection.getRanges());
                    n.change((n)=>{
                        n.setSelection(t, "end");
                        e.execute("checkTodoList");
                        n.setSelection(o);
                    });
                }
            }
            function xN() {
                return (t, e, n)=>{
                    const o = e.modelCursor;
                    const i = o.parent;
                    const r = e.viewItem;
                    if (!n.consumable.test(r, {
                        name: true
                    })) return;
                    if (r.getAttribute("type") != "checkbox" || !o.isAtStart || !i.hasAttribute("listType")) return;
                    n.consumable.consume(r, {
                        name: true
                    });
                    const s = n.writer;
                    s.setAttribute("listType", "todo", i);
                    if (e.viewItem.hasAttribute("checked")) s.setAttribute("todoListChecked", true, i);
                    e.modelRange = s.createRange(o);
                };
            }
            function EN(t) {
                const e = new Matcher(t);
                return (t, n, o)=>{
                    const i = e.match(n.viewItem);
                    if (!i) return;
                    if (!o.consumable.consume(n.viewItem, i.match)) return;
                    Object.assign(n, o.convertChildren(n.viewItem, n.modelCursor));
                };
            }
            function DN(t) {
                const e = new Matcher(t);
                return (t, n, o)=>{
                    const i = e.match(n.viewItem);
                    if (!i) return;
                    const r = i.match;
                    r.name = false;
                    o.consumable.consume(n.viewItem, r);
                };
            }
            function SN(t, e) {
                return (t.is("element", "paragraph") || t.is("element", "listItem")) && t.getAttribute("listType") == "todo" && isFirstBlockOfListItem(t) && TN(t, e);
            }
            function TN(t, e) {
                for (const n of t.getAttributeKeys()){
                    if (n.startsWith("selection:")) continue;
                    if (!e.includes(n)) return false;
                }
                return true;
            }
            function BN(t, e) {
                return (n, o)=>{
                    const i = getLocalizedArrowKeyCodeDirection(o.keyCode, e.contentLanguageDirection);
                    const r = t.schema;
                    const s = t.document.selection;
                    if (!s.isCollapsed) return;
                    const a = s.getFirstPosition();
                    const c = a.parent;
                    if (i == "right" && a.isAtEnd) {
                        const e = r.getNearestSelectionRange(t.createPositionAfter(c), "forward");
                        if (!e) return;
                        const i = e.start.parent;
                        if (i && isListItemBlock(i) && i.getAttribute("listType") == "todo") {
                            t.change((t)=>t.setSelection(e));
                            o.preventDefault();
                            o.stopPropagation();
                            n.stop();
                        }
                    } else if (i == "left" && a.isAtStart && isListItemBlock(c) && c.getAttribute("listType") == "todo") {
                        const e = r.getNearestSelectionRange(t.createPositionBefore(c), "backward");
                        if (!e) return;
                        t.change((t)=>t.setSelection(e));
                        o.preventDefault();
                        o.stopPropagation();
                        n.stop();
                    }
                };
            }
            function PN(t) {
                return !!t && t.is("attributeElement") && t.hasClass("todo-list__label");
            }
            class IN extends null {
                static get requires() {
                    return [
                        TodoDocumentListEditing,
                        TodoListUI
                    ];
                }
                static get pluginName() {
                    return "TodoDocumentList";
                }
            }
            class RN extends SS {
            }
            RN.builtinPlugins = [
                GS,
                qB,
                QS,
                QI,
                gR,
                WR,
                ZR,
                tB,
                KV,
                Mz,
                nR
            ];
            RN.defaultConfig = {
                toolbar: {
                    items: [
                        "heading",
                        "bold",
                        "italic",
                        "link",
                        "bulletedList",
                        "numberedList",
                        "|",
                        "alignment",
                        "outdent",
                        "indent",
                        "|",
                        "blockQuote",
                        "undo",
                        "redo"
                    ]
                },
                language: "en"
            };
            const ON = RN;
        })();
        o = o["default"];
        return o;
    })());

});


parcelRegister("eokEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7a355238de703d2$export$2e2bcd8739ae039);

var $gkCGf = parcelRequire("gkCGf");

var $2u5A9 = parcelRequire("2u5A9");

var $dacGJ = parcelRequire("dacGJ");

var $gaTMf = parcelRequire("gaTMf");

var $a49L5 = parcelRequire("a49L5");

var $l1c21 = parcelRequire("l1c21");

var $2jORh = parcelRequire("2jORh");

var $7IEdL = parcelRequire("7IEdL");

var $ednZI = parcelRequire("ednZI");

var $fXWMf = parcelRequire("fXWMf");

var $1zXqe = parcelRequire("1zXqe");

var $a7a355238de703d2$export$2e2bcd8739ae039 = ({ content: content, previewFillers: previewFillers = {}, usableVariables: usableVariables = [] })=>{
    let editor;
    return {
        updatedAt: Date.now(),
        activeTab: 'write',
        previewContent: '',
        previewFillers: previewFillers,
        usableVariables: usableVariables,
        init () {
            const _this = this;
            editor = new (0, $gkCGf.Editor)({
                element: this.$refs.element,
                extensions: [
                    (0, $fXWMf.default).configure({
                        bulletList: {
                            keepMarks: true,
                            keepAttributes: false
                        },
                        hardBreak: false
                    }),
                    (0, $ednZI.default),
                    (0, $a49L5.default).configure({
                        openOnClick: false
                    }),
                    (0, $7IEdL.default).configure({
                        types: [
                            "heading",
                            "paragraph"
                        ]
                    }),
                    (0, $gaTMf.default),
                    (0, $dacGJ.default),
                    (0, $l1c21.default),
                    (0, $2u5A9.default),
                    (0, $2jORh.default),
                    (0, $1zXqe.default).configure({
                        variables: this.usableVariables
                    })
                ],
                editorProps: {
                    attributes: {
                        class: "format lg:format-lg dark:format-invert focus:outline-none format-blue max-w-none"
                    }
                },
                content: content,
                onCreate ({ editor: editor }) {
                    _this.updatedAt = Date.now();
                },
                onUpdate ({ editor: editor }) {
                    _this.updatedAt = Date.now();
                },
                onSelectionUpdate ({ editor: editor }) {
                    _this.updatedAt = Date.now();
                }
            });
        },
        isLoaded () {
            return editor;
        },
        isActive (type, opts = {}) {
            return editor.isActive(type, opts);
        },
        toggleHeading (opts) {
            editor.chain().toggleHeading(opts).focus().run();
        },
        toggleBold () {
            editor.chain().focus().toggleBold().run();
        },
        toggleItalic () {
            editor.chain().focus().toggleItalic().run();
        },
        toggleUnderline () {
            editor.chain().focus().toggleUnderline().run();
        },
        toggleStrike () {
            editor.chain().focus().toggleStrike().run();
        },
        toggleLink () {
            const url = window.prompt("Enter the URL");
            if (url) editor.chain().focus().toggleLink({
                href: url
            }).run();
        },
        removeLink () {
            editor.chain().focus().unsetLink().run();
        },
        setTextAlign (align) {
            editor.chain().focus().setTextAlign(align).run();
        },
        toggleBulletList () {
            editor.chain().focus().toggleBulletList().run();
        },
        toggleOrderedList () {
            editor.chain().focus().toggleOrderedList().run();
        },
        toggleBlockquote () {
            editor.chain().focus().toggleBlockquote().run();
        },
        setHorizontalRule () {
            editor.chain().focus().setHorizontalRule().run();
        },
        insertVariable (variable) {
            if (editor) editor.chain().focus().insertContent(variable).run();
        },
        getContent () {
            this.previewContent = editor ? editor.getHTML() : '';
            // the html returned is a string, we need to convert it to a DOM object
            const parser = new DOMParser();
            const doc = parser.parseFromString(this.previewContent, 'text/html');
            this.previewContent = doc.body;
            const childrenToReturn = [];
            const children = this.previewContent.children;
            // well, we can't forEach this, we gotta use a for loop
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                // each child is a node, a html node, we can use the tagName property to get the type of the node
                if (child.tagName === 'P' && !child.textContent) {
                    child.innerHTML = '<br class="ProseMirror-trailingBreak">';
                    childrenToReturn.push(child);
                } else childrenToReturn.push(child);
            }
            // Convert back to string and replace variables with styled spans for preview
            let finalContent = childrenToReturn.map((child)=>child.outerHTML).join('');
            // Replace {{ variable_name }} with styled spans for preview
            finalContent = this.replaceVariablesForPreview(finalContent);
            return finalContent;
        },
        replaceVariablesForPreview (content) {
            // Replace {{ variable_name }} with styled spans
            return content.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, variableName)=>{
                const previewValue = this.previewFillers[variableName] || `{{ ${variableName} }}`;
                return previewValue;
            });
        }
    };
};

});
parcelRegister("gkCGf", function(module, exports) {

$parcel$export(module.exports, "getExtensionField", () => $be3c84bcbbb2383c$export$f73578b718a57eaa);
$parcel$export(module.exports, "mergeAttributes", () => $be3c84bcbbb2383c$export$9f98db6234c4bd78);
$parcel$export(module.exports, "callOrReturn", () => $be3c84bcbbb2383c$export$592682234826c0bd);
$parcel$export(module.exports, "Mark", () => $be3c84bcbbb2383c$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "Extension", () => $be3c84bcbbb2383c$export$eeddbf09bb970356);
$parcel$export(module.exports, "combineTransactionSteps", () => $be3c84bcbbb2383c$export$f945f1716a5df33d);
$parcel$export(module.exports, "findChildrenInRange", () => $be3c84bcbbb2383c$export$6a2a251dde98a23);
$parcel$export(module.exports, "getAttributes", () => $be3c84bcbbb2383c$export$fe94072fee8a6976);
$parcel$export(module.exports, "getChangedRanges", () => $be3c84bcbbb2383c$export$ba396fc65ff2f439);
$parcel$export(module.exports, "getMarksBetween", () => $be3c84bcbbb2383c$export$c5fd7af7c5c1efa);
$parcel$export(module.exports, "isNodeSelection", () => $be3c84bcbbb2383c$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "Editor", () => $be3c84bcbbb2383c$export$7cda8d932e2f33c0);
$parcel$export(module.exports, "markInputRule", () => $be3c84bcbbb2383c$export$9f2cb743ab9131de);
$parcel$export(module.exports, "nodeInputRule", () => $be3c84bcbbb2383c$export$6ca56856dfeaf9b6);
$parcel$export(module.exports, "textblockTypeInputRule", () => $be3c84bcbbb2383c$export$cc081314d3f6ffb0);
$parcel$export(module.exports, "wrappingInputRule", () => $be3c84bcbbb2383c$export$f7316d89abe4e1c1);
$parcel$export(module.exports, "Node", () => $be3c84bcbbb2383c$export$85c928794f8d04d4);
$parcel$export(module.exports, "markPasteRule", () => $be3c84bcbbb2383c$export$3845eb97abe74944);
$parcel$export(module.exports, "canInsertNode", () => $be3c84bcbbb2383c$export$d23217284a0e83b9);
$parcel$export(module.exports, "escapeForRegEx", () => $be3c84bcbbb2383c$export$d3f82eb9fcc60fbc);
parcelRequire("7fRs0");
var $1LeRC = parcelRequire("1LeRC");
parcelRequire("cXOg4");
var $edQEX = parcelRequire("edQEX");
parcelRequire("euyQd");
var $18HhN = parcelRequire("18HhN");
parcelRequire("k43Nl");
var $1krlL = parcelRequire("1krlL");
parcelRequire("jV6wh");
var $gfgdn = parcelRequire("gfgdn");
parcelRequire("cJglX");
var $9D0ij = parcelRequire("9D0ij");
parcelRequire("jP8IL");
var $ie1jF = parcelRequire("ie1jF");
/**
 * Takes a Transaction & Editor State and turns it into a chainable state object
 * @param config The transaction and state to create the chainable state from
 * @returns A chainable Editor state object
 */ function $be3c84bcbbb2383c$export$83e24c5933427696(config) {
    const { state: state, transaction: transaction } = config;
    let { selection: selection } = transaction;
    let { doc: doc } = transaction;
    let { storedMarks: storedMarks } = transaction;
    return {
        ...state,
        apply: state.apply.bind(state),
        applyTransaction: state.applyTransaction.bind(state),
        plugins: state.plugins,
        schema: state.schema,
        reconfigure: state.reconfigure.bind(state),
        toJSON: state.toJSON.bind(state),
        get storedMarks () {
            return storedMarks;
        },
        get selection () {
            return selection;
        },
        get doc () {
            return doc;
        },
        get tr () {
            selection = transaction.selection;
            doc = transaction.doc;
            storedMarks = transaction.storedMarks;
            return transaction;
        }
    };
}
class $be3c84bcbbb2383c$export$475014de15a4c342 {
    constructor(props){
        this.editor = props.editor;
        this.rawCommands = this.editor.extensionManager.commands;
        this.customState = props.state;
    }
    get hasCustomState() {
        return !!this.customState;
    }
    get state() {
        return this.customState || this.editor.state;
    }
    get commands() {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const { tr: tr } = state;
        const props = this.buildProps(tr);
        return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            const method = (...args)=>{
                const callback = command(...args)(props);
                if (!tr.getMeta('preventDispatch') && !this.hasCustomState) view.dispatch(tr);
                return callback;
            };
            return [
                name,
                method
            ];
        }));
    }
    get chain() {
        return ()=>this.createChain();
    }
    get can() {
        return ()=>this.createCan();
    }
    createChain(startTr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const callbacks = [];
        const hasStartTransaction = !!startTr;
        const tr = startTr || state.tr;
        const run = ()=>{
            if (!hasStartTransaction && shouldDispatch && !tr.getMeta('preventDispatch') && !this.hasCustomState) view.dispatch(tr);
            return callbacks.every((callback)=>callback === true);
        };
        const chain = {
            ...Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                const chainedCommand = (...args)=>{
                    const props = this.buildProps(tr, shouldDispatch);
                    const callback = command(...args)(props);
                    callbacks.push(callback);
                    return chain;
                };
                return [
                    name,
                    chainedCommand
                ];
            })),
            run: run
        };
        return chain;
    }
    createCan(startTr) {
        const { rawCommands: rawCommands, state: state } = this;
        const dispatch = false;
        const tr = startTr || state.tr;
        const props = this.buildProps(tr, dispatch);
        const formattedCommands = Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
            return [
                name,
                (...args)=>command(...args)({
                        ...props,
                        dispatch: undefined
                    })
            ];
        }));
        return {
            ...formattedCommands,
            chain: ()=>this.createChain(tr, dispatch)
        };
    }
    buildProps(tr, shouldDispatch = true) {
        const { rawCommands: rawCommands, editor: editor, state: state } = this;
        const { view: view } = editor;
        const props = {
            tr: tr,
            editor: editor,
            view: view,
            state: $be3c84bcbbb2383c$export$83e24c5933427696({
                state: state,
                transaction: tr
            }),
            dispatch: shouldDispatch ? ()=>undefined : undefined,
            chain: ()=>this.createChain(tr, shouldDispatch),
            can: ()=>this.createCan(tr),
            get commands () {
                return Object.fromEntries(Object.entries(rawCommands).map(([name, command])=>{
                    return [
                        name,
                        (...args)=>command(...args)(props)
                    ];
                }));
            }
        };
        return props;
    }
}
class $be3c84bcbbb2383c$var$EventEmitter {
    constructor(){
        this.callbacks = {};
    }
    on(event, fn) {
        if (!this.callbacks[event]) this.callbacks[event] = [];
        this.callbacks[event].push(fn);
        return this;
    }
    emit(event, ...args) {
        const callbacks = this.callbacks[event];
        if (callbacks) callbacks.forEach((callback)=>callback.apply(this, args));
        return this;
    }
    off(event, fn) {
        const callbacks = this.callbacks[event];
        if (callbacks) {
            if (fn) this.callbacks[event] = callbacks.filter((callback)=>callback !== fn);
            else delete this.callbacks[event];
        }
        return this;
    }
    once(event, fn) {
        const onceFn = (...args)=>{
            this.off(event, onceFn);
            fn.apply(this, args);
        };
        return this.on(event, onceFn);
    }
    removeAllListeners() {
        this.callbacks = {};
    }
}
/**
 * Returns a field from an extension
 * @param extension The Tiptap extension
 * @param field The field, for example `renderHTML` or `priority`
 * @param context The context object that should be passed as `this` into the function
 * @returns The field value
 */ function $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, field, context) {
    if (extension.config[field] === undefined && extension.parent) return $be3c84bcbbb2383c$export$f73578b718a57eaa(extension.parent, field, context);
    if (typeof extension.config[field] === 'function') {
        const value = extension.config[field].bind({
            ...context,
            parent: extension.parent ? $be3c84bcbbb2383c$export$f73578b718a57eaa(extension.parent, field, context) : null
        });
        return value;
    }
    return extension.config[field];
}
function $be3c84bcbbb2383c$export$36e8c2990da8266f(extensions) {
    const baseExtensions = extensions.filter((extension)=>extension.type === 'extension');
    const nodeExtensions = extensions.filter((extension)=>extension.type === 'node');
    const markExtensions = extensions.filter((extension)=>extension.type === 'mark');
    return {
        baseExtensions: baseExtensions,
        nodeExtensions: nodeExtensions,
        markExtensions: markExtensions
    };
}
/**
 * Get a list of all extension attributes defined in `addAttribute` and `addGlobalAttribute`.
 * @param extensions List of extensions
 */ function $be3c84bcbbb2383c$export$6e54e3e69d60df3d(extensions) {
    const extensionAttributes = [];
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $be3c84bcbbb2383c$export$36e8c2990da8266f(extensions);
    const nodeAndMarkExtensions = [
        ...nodeExtensions,
        ...markExtensions
    ];
    const defaultAttribute = {
        default: null,
        rendered: true,
        renderHTML: null,
        parseHTML: null,
        keepOnSplit: true,
        isRequired: false
    };
    extensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            extensions: nodeAndMarkExtensions
        };
        const addGlobalAttributes = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addGlobalAttributes', context);
        if (!addGlobalAttributes) return;
        const globalAttributes = addGlobalAttributes();
        globalAttributes.forEach((globalAttribute)=>{
            globalAttribute.types.forEach((type)=>{
                Object.entries(globalAttribute.attributes).forEach(([name, attribute])=>{
                    extensionAttributes.push({
                        type: type,
                        name: name,
                        attribute: {
                            ...defaultAttribute,
                            ...attribute
                        }
                    });
                });
            });
        });
    });
    nodeAndMarkExtensions.forEach((extension)=>{
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        const addAttributes = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addAttributes', context);
        if (!addAttributes) return;
        // TODO: remove `as Attributes`
        const attributes = addAttributes();
        Object.entries(attributes).forEach(([name, attribute])=>{
            const mergedAttr = {
                ...defaultAttribute,
                ...attribute
            };
            if (typeof (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === 'function') mergedAttr.default = mergedAttr.default();
            if ((mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.isRequired) && (mergedAttr === null || mergedAttr === void 0 ? void 0 : mergedAttr.default) === undefined) delete mergedAttr.default;
            extensionAttributes.push({
                type: extension.name,
                name: name,
                attribute: mergedAttr
            });
        });
    });
    return extensionAttributes;
}
function $be3c84bcbbb2383c$export$d168cba70360dd3d(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.nodes[nameOrType]) throw Error(`There is no node type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.nodes[nameOrType];
    }
    return nameOrType;
}
function $be3c84bcbbb2383c$export$9f98db6234c4bd78(...objects) {
    return objects.filter((item)=>!!item).reduce((items, item)=>{
        const mergedAttributes = {
            ...items
        };
        Object.entries(item).forEach(([key, value])=>{
            const exists = mergedAttributes[key];
            if (!exists) {
                mergedAttributes[key] = value;
                return;
            }
            if (key === 'class') {
                const valueClasses = value ? String(value).split(' ') : [];
                const existingClasses = mergedAttributes[key] ? mergedAttributes[key].split(' ') : [];
                const insertClasses = valueClasses.filter((valueClass)=>!existingClasses.includes(valueClass));
                mergedAttributes[key] = [
                    ...existingClasses,
                    ...insertClasses
                ].join(' ');
            } else if (key === 'style') {
                const newStyles = value ? value.split(';').map((style)=>style.trim()).filter(Boolean) : [];
                const existingStyles = mergedAttributes[key] ? mergedAttributes[key].split(';').map((style)=>style.trim()).filter(Boolean) : [];
                const styleMap = new Map();
                existingStyles.forEach((style)=>{
                    const [property, val] = style.split(':').map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                newStyles.forEach((style)=>{
                    const [property, val] = style.split(':').map((part)=>part.trim());
                    styleMap.set(property, val);
                });
                mergedAttributes[key] = Array.from(styleMap.entries()).map(([property, val])=>`${property}: ${val}`).join('; ');
            } else mergedAttributes[key] = value;
        });
        return mergedAttributes;
    }, {});
}
function $be3c84bcbbb2383c$export$bc79d84a417d7b02(nodeOrMark, extensionAttributes) {
    return extensionAttributes.filter((attribute)=>attribute.type === nodeOrMark.type.name).filter((item)=>item.attribute.rendered).map((item)=>{
        if (!item.attribute.renderHTML) return {
            [item.name]: nodeOrMark.attrs[item.name]
        };
        return item.attribute.renderHTML(nodeOrMark.attrs) || {};
    }).reduce((attributes, attribute)=>$be3c84bcbbb2383c$export$9f98db6234c4bd78(attributes, attribute), {});
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $be3c84bcbbb2383c$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
/**
 * Optionally calls `value` as a function.
 * Otherwise it is returned directly.
 * @param value Function or any value.
 * @param context Optional context to bind to function.
 * @param props Optional props to pass to function.
 */ function $be3c84bcbbb2383c$export$592682234826c0bd(value, context, ...props) {
    if ($be3c84bcbbb2383c$export$f6e2535fb5126e54(value)) {
        if (context) return value.bind(context)(...props);
        return value(...props);
    }
    return value;
}
function $be3c84bcbbb2383c$export$83b788b1a3698c03(value = {}) {
    return Object.keys(value).length === 0 && value.constructor === Object;
}
function $be3c84bcbbb2383c$export$3004f64547af360e(value) {
    if (typeof value !== 'string') return value;
    if (value.match(/^[+-]?(?:\d*\.)?\d+$/)) return Number(value);
    if (value === 'true') return true;
    if (value === 'false') return false;
    return value;
}
/**
 * This function merges extension attributes into parserule attributes (`attrs` or `getAttrs`).
 * Cancels when `getAttrs` returned `false`.
 * @param parseRule ProseMirror ParseRule
 * @param extensionAttributes List of attributes to inject
 */ function $be3c84bcbbb2383c$export$7ce6b571718439ec(parseRule, extensionAttributes) {
    if ('style' in parseRule) return parseRule;
    return {
        ...parseRule,
        getAttrs: (node)=>{
            const oldAttributes = parseRule.getAttrs ? parseRule.getAttrs(node) : parseRule.attrs;
            if (oldAttributes === false) return false;
            const newAttributes = extensionAttributes.reduce((items, item)=>{
                const value = item.attribute.parseHTML ? item.attribute.parseHTML(node) : $be3c84bcbbb2383c$export$3004f64547af360e(node.getAttribute(item.name));
                if (value === null || value === undefined) return items;
                return {
                    ...items,
                    [item.name]: value
                };
            }, {});
            return {
                ...oldAttributes,
                ...newAttributes
            };
        }
    };
}
function $be3c84bcbbb2383c$var$cleanUpSchemaItem(data) {
    return Object.fromEntries(// @ts-ignore
    Object.entries(data).filter(([key, value])=>{
        if (key === 'attrs' && $be3c84bcbbb2383c$export$83b788b1a3698c03(value)) return false;
        return value !== null && value !== undefined;
    }));
}
/**
 * Creates a new Prosemirror schema based on the given extensions.
 * @param extensions An array of Tiptap extensions
 * @param editor The editor instance
 * @returns A Prosemirror schema
 */ function $be3c84bcbbb2383c$export$71bc12a97b59a858(extensions, editor) {
    var _a;
    const allAttributes = $be3c84bcbbb2383c$export$6e54e3e69d60df3d(extensions);
    const { nodeExtensions: nodeExtensions, markExtensions: markExtensions } = $be3c84bcbbb2383c$export$36e8c2990da8266f(extensions);
    const topNode = (_a = nodeExtensions.find((extension)=>$be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'topNode'))) === null || _a === void 0 ? void 0 : _a.name;
    const nodes = Object.fromEntries(nodeExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraNodeFields = extensions.reduce((fields, e)=>{
            const extendNodeSchema = $be3c84bcbbb2383c$export$f73578b718a57eaa(e, 'extendNodeSchema', context);
            return {
                ...fields,
                ...extendNodeSchema ? extendNodeSchema(extension) : {}
            };
        }, {});
        const schema = $be3c84bcbbb2383c$var$cleanUpSchemaItem({
            ...extraNodeFields,
            content: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'content', context)),
            marks: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'marks', context)),
            group: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'group', context)),
            inline: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'inline', context)),
            atom: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'atom', context)),
            selectable: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'selectable', context)),
            draggable: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'draggable', context)),
            code: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'code', context)),
            whitespace: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'whitespace', context)),
            linebreakReplacement: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'linebreakReplacement', context)),
            defining: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'defining', context)),
            isolating: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'isolating', context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'parseHTML', context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$be3c84bcbbb2383c$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'renderHTML', context);
        if (renderHTML) schema.toDOM = (node)=>renderHTML({
                node: node,
                HTMLAttributes: $be3c84bcbbb2383c$export$bc79d84a417d7b02(node, extensionAttributes)
            });
        const renderText = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'renderText', context);
        if (renderText) schema.toText = renderText;
        return [
            extension.name,
            schema
        ];
    }));
    const marks = Object.fromEntries(markExtensions.map((extension)=>{
        const extensionAttributes = allAttributes.filter((attribute)=>attribute.type === extension.name);
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage,
            editor: editor
        };
        const extraMarkFields = extensions.reduce((fields, e)=>{
            const extendMarkSchema = $be3c84bcbbb2383c$export$f73578b718a57eaa(e, 'extendMarkSchema', context);
            return {
                ...fields,
                ...extendMarkSchema ? extendMarkSchema(extension) : {}
            };
        }, {});
        const schema = $be3c84bcbbb2383c$var$cleanUpSchemaItem({
            ...extraMarkFields,
            inclusive: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'inclusive', context)),
            excludes: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'excludes', context)),
            group: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'group', context)),
            spanning: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'spanning', context)),
            code: $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'code', context)),
            attrs: Object.fromEntries(extensionAttributes.map((extensionAttribute)=>{
                var _a;
                return [
                    extensionAttribute.name,
                    {
                        default: (_a = extensionAttribute === null || extensionAttribute === void 0 ? void 0 : extensionAttribute.attribute) === null || _a === void 0 ? void 0 : _a.default
                    }
                ];
            }))
        });
        const parseHTML = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'parseHTML', context));
        if (parseHTML) schema.parseDOM = parseHTML.map((parseRule)=>$be3c84bcbbb2383c$export$7ce6b571718439ec(parseRule, extensionAttributes));
        const renderHTML = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'renderHTML', context);
        if (renderHTML) schema.toDOM = (mark)=>renderHTML({
                mark: mark,
                HTMLAttributes: $be3c84bcbbb2383c$export$bc79d84a417d7b02(mark, extensionAttributes)
            });
        return [
            extension.name,
            schema
        ];
    }));
    return new (0, $1krlL.Schema)({
        topNode: topNode,
        nodes: nodes,
        marks: marks
    });
}
/**
 * Tries to get a node or mark type by its name.
 * @param name The name of the node or mark type
 * @param schema The Prosemiror schema to search in
 * @returns The node or mark type, or null if it doesn't exist
 */ function $be3c84bcbbb2383c$export$ea18268b31f54e5(name, schema) {
    return schema.nodes[name] || schema.marks[name] || null;
}
function $be3c84bcbbb2383c$export$79b791167b05aada(extension, enabled) {
    if (Array.isArray(enabled)) return enabled.some((enabledExtension)=>{
        const name = typeof enabledExtension === 'string' ? enabledExtension : enabledExtension.name;
        return name === extension.name;
    });
    return enabled;
}
function $be3c84bcbbb2383c$export$d1b60002472b2c81(fragment, schema) {
    const documentFragment = (0, $1krlL.DOMSerializer).fromSchema(schema).serializeFragment(fragment);
    const temporaryDocument = document.implementation.createHTMLDocument();
    const container = temporaryDocument.createElement('div');
    container.appendChild(documentFragment);
    return container.innerHTML;
}
/**
 * Returns the text content of a resolved prosemirror position
 * @param $from The resolved position to get the text content from
 * @param maxMatch The maximum number of characters to match
 * @returns The text content
 */ const $be3c84bcbbb2383c$export$a3e238086d556fa9 = ($from, maxMatch = 500)=>{
    let textBefore = '';
    const sliceEndPos = $from.parentOffset;
    $from.parent.nodesBetween(Math.max(0, sliceEndPos - maxMatch), sliceEndPos, (node, pos, parent, index)=>{
        var _a, _b;
        const chunk = ((_b = (_a = node.type.spec).toText) === null || _b === void 0 ? void 0 : _b.call(_a, {
            node: node,
            pos: pos,
            parent: parent,
            index: index
        })) || node.textContent || '%leaf%';
        textBefore += node.isAtom && !node.isText ? chunk : chunk.slice(0, Math.max(0, sliceEndPos - pos));
    });
    return textBefore;
};
function $be3c84bcbbb2383c$export$49841c62b9eff15(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
class $be3c84bcbbb2383c$export$9b55e2b000ad65f2 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $be3c84bcbbb2383c$var$inputRuleMatcherHandler = (text, find)=>{
    if ($be3c84bcbbb2383c$export$49841c62b9eff15(find)) return find.exec(text);
    const inputRuleMatch = find(text);
    if (!inputRuleMatch) return null;
    const result = [
        inputRuleMatch.text
    ];
    result.index = inputRuleMatch.index;
    result.input = text;
    result.data = inputRuleMatch.data;
    if (inputRuleMatch.replaceWith) {
        if (!inputRuleMatch.text.includes(inputRuleMatch.replaceWith)) console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".');
        result.push(inputRuleMatch.replaceWith);
    }
    return result;
};
function $be3c84bcbbb2383c$var$run$1(config) {
    var _a;
    const { editor: editor, from: from, to: to, text: text, rules: rules, plugin: plugin } = config;
    const { view: view } = editor;
    if (view.composing) return false;
    const $from = view.state.doc.resolve(from);
    if (// check for code node
    $from.parent.type.spec.code || !!((_a = $from.nodeBefore || $from.nodeAfter) === null || _a === void 0 ? void 0 : _a.marks.find((mark)=>mark.type.spec.code))) return false;
    let matched = false;
    const textBefore = $be3c84bcbbb2383c$export$a3e238086d556fa9($from) + text;
    rules.forEach((rule)=>{
        if (matched) return;
        const match = $be3c84bcbbb2383c$var$inputRuleMatcherHandler(textBefore, rule.find);
        if (!match) return;
        const tr = view.state.tr;
        const state = $be3c84bcbbb2383c$export$83e24c5933427696({
            state: view.state,
            transaction: tr
        });
        const range = {
            from: from - (match[0].length - text.length),
            to: to
        };
        const { commands: commands, chain: chain, can: can } = new $be3c84bcbbb2383c$export$475014de15a4c342({
            editor: editor,
            state: state
        });
        const handler = rule.handler({
            state: state,
            range: range,
            match: match,
            commands: commands,
            chain: chain,
            can: can
        });
        // stop if there are no changes
        if (handler === null || !tr.steps.length) return;
        // store transform as meta data
        // so we can undo input rules within the `undoInputRules` command
        tr.setMeta(plugin, {
            transform: tr,
            from: from,
            to: to,
            text: text
        });
        view.dispatch(tr);
        matched = true;
    });
    return matched;
}
/**
 * Create an input rules plugin. When enabled, it will cause text
 * input that matches any of the given rules to trigger the rule’s
 * action.
 */ function $be3c84bcbbb2383c$export$f2a821f78e918151(props) {
    const { editor: editor, rules: rules } = props;
    const plugin = new (0, $1LeRC.Plugin)({
        state: {
            init () {
                return null;
            },
            apply (tr, prev, state) {
                const stored = tr.getMeta(plugin);
                if (stored) return stored;
                // if InputRule is triggered by insertContent()
                const simulatedInputMeta = tr.getMeta('applyInputRules');
                const isSimulatedInput = !!simulatedInputMeta;
                if (isSimulatedInput) setTimeout(()=>{
                    let { text: text } = simulatedInputMeta;
                    if (typeof text === 'string') text;
                    else text = $be3c84bcbbb2383c$export$d1b60002472b2c81((0, $1krlL.Fragment).from(text), state.schema);
                    const { from: from } = simulatedInputMeta;
                    const to = from + text.length;
                    $be3c84bcbbb2383c$var$run$1({
                        editor: editor,
                        from: from,
                        to: to,
                        text: text,
                        rules: rules,
                        plugin: plugin
                    });
                });
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        props: {
            handleTextInput (view, from, to, text) {
                return $be3c84bcbbb2383c$var$run$1({
                    editor: editor,
                    from: from,
                    to: to,
                    text: text,
                    rules: rules,
                    plugin: plugin
                });
            },
            handleDOMEvents: {
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const { $cursor: $cursor } = view.state.selection;
                        if ($cursor) $be3c84bcbbb2383c$var$run$1({
                            editor: editor,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: '',
                            rules: rules,
                            plugin: plugin
                        });
                    });
                    return false;
                }
            },
            // add support for input rules to trigger on enter
            // this is useful for example for code blocks
            handleKeyDown (view, event) {
                if (event.key !== 'Enter') return false;
                const { $cursor: $cursor } = view.state.selection;
                if ($cursor) return $be3c84bcbbb2383c$var$run$1({
                    editor: editor,
                    from: $cursor.pos,
                    to: $cursor.pos,
                    text: '\n',
                    rules: rules,
                    plugin: plugin
                });
                return false;
            }
        },
        // @ts-ignore
        isInputRules: true
    });
    return plugin;
}
// see: https://github.com/mesqueeb/is-what/blob/88d6e4ca92fb2baab6003c54e02eedf4e729e5ab/src/index.ts
function $be3c84bcbbb2383c$var$getType(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
function $be3c84bcbbb2383c$export$53b83ca8eaab0383(value) {
    if ($be3c84bcbbb2383c$var$getType(value) !== 'Object') return false;
    return value.constructor === Object && Object.getPrototypeOf(value) === Object.prototype;
}
function $be3c84bcbbb2383c$export$dd702b3c8240390c(target, source) {
    const output = {
        ...target
    };
    if ($be3c84bcbbb2383c$export$53b83ca8eaab0383(target) && $be3c84bcbbb2383c$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if ($be3c84bcbbb2383c$export$53b83ca8eaab0383(source[key]) && $be3c84bcbbb2383c$export$53b83ca8eaab0383(target[key])) output[key] = $be3c84bcbbb2383c$export$dd702b3c8240390c(target[key], source[key]);
        else output[key] = source[key];
    });
    return output;
}
/**
 * The Mark class is used to create custom mark extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $be3c84bcbbb2383c$export$c9d15bcfc6d42044 {
    constructor(config = {}){
        this.type = 'mark';
        this.name = 'mark';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(this, 'addOptions', {
            name: this.name
        }));
        this.storage = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(this, 'addStorage', {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $be3c84bcbbb2383c$export$c9d15bcfc6d42044(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $be3c84bcbbb2383c$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $be3c84bcbbb2383c$export$c9d15bcfc6d42044(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addOptions', {
            name: extension.name
        }));
        extension.storage = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addStorage', {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
    static handleExit({ editor: editor, mark: mark }) {
        const { tr: tr } = editor.state;
        const currentPos = editor.state.selection.$from;
        const isAtEnd = currentPos.pos === currentPos.end();
        if (isAtEnd) {
            const currentMarks = currentPos.marks();
            const isInMark = !!currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (!isInMark) return false;
            const removeMark = currentMarks.find((m)=>(m === null || m === void 0 ? void 0 : m.type.name) === mark.name);
            if (removeMark) tr.removeStoredMark(removeMark);
            tr.insertText(' ', currentPos.pos);
            editor.view.dispatch(tr);
            return true;
        }
        return false;
    }
}
function $be3c84bcbbb2383c$export$7e4aa119212bc614(value) {
    return typeof value === 'number';
}
/**
 * Paste rules are used to react to pasted content.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ class $be3c84bcbbb2383c$export$e75df4392d073e98 {
    constructor(config){
        this.find = config.find;
        this.handler = config.handler;
    }
}
const $be3c84bcbbb2383c$var$pasteRuleMatcherHandler = (text, find, event)=>{
    if ($be3c84bcbbb2383c$export$49841c62b9eff15(find)) return [
        ...text.matchAll(find)
    ];
    const matches = find(text, event);
    if (!matches) return [];
    return matches.map((pasteRuleMatch)=>{
        const result = [
            pasteRuleMatch.text
        ];
        result.index = pasteRuleMatch.index;
        result.input = text;
        result.data = pasteRuleMatch.data;
        if (pasteRuleMatch.replaceWith) {
            if (!pasteRuleMatch.text.includes(pasteRuleMatch.replaceWith)) console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".');
            result.push(pasteRuleMatch.replaceWith);
        }
        return result;
    });
};
function $be3c84bcbbb2383c$var$run(config) {
    const { editor: editor, state: state, from: from, to: to, rule: rule, pasteEvent: pasteEvent, dropEvent: dropEvent } = config;
    const { commands: commands, chain: chain, can: can } = new $be3c84bcbbb2383c$export$475014de15a4c342({
        editor: editor,
        state: state
    });
    const handlers = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isTextblock || node.type.spec.code) return;
        const resolvedFrom = Math.max(from, pos);
        const resolvedTo = Math.min(to, pos + node.content.size);
        const textToMatch = node.textBetween(resolvedFrom - pos, resolvedTo - pos, undefined, '\ufffc');
        const matches = $be3c84bcbbb2383c$var$pasteRuleMatcherHandler(textToMatch, rule.find, pasteEvent);
        matches.forEach((match)=>{
            if (match.index === undefined) return;
            const start = resolvedFrom + match.index + 1;
            const end = start + match[0].length;
            const range = {
                from: state.tr.mapping.map(start),
                to: state.tr.mapping.map(end)
            };
            const handler = rule.handler({
                state: state,
                range: range,
                match: match,
                commands: commands,
                chain: chain,
                can: can,
                pasteEvent: pasteEvent,
                dropEvent: dropEvent
            });
            handlers.push(handler);
        });
    });
    const success = handlers.every((handler)=>handler !== null);
    return success;
}
// When dragging across editors, must get another editor instance to delete selection content.
let $be3c84bcbbb2383c$var$tiptapDragFromOtherEditor = null;
const $be3c84bcbbb2383c$var$createClipboardPasteEvent = (text)=>{
    var _a;
    const event = new ClipboardEvent('paste', {
        clipboardData: new DataTransfer()
    });
    (_a = event.clipboardData) === null || _a === void 0 || _a.setData('text/html', text);
    return event;
};
/**
 * Create an paste rules plugin. When enabled, it will cause pasted
 * text that matches any of the given rules to trigger the rule’s
 * action.
 */ function $be3c84bcbbb2383c$export$458282b0dddaaaa4(props) {
    const { editor: editor, rules: rules } = props;
    let dragSourceElement = null;
    let isPastedFromProseMirror = false;
    let isDroppedFromProseMirror = false;
    let pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
    let dropEvent;
    try {
        dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
    } catch  {
        dropEvent = null;
    }
    const processEvent = ({ state: state, from: from, to: to, rule: rule, pasteEvt: pasteEvt })=>{
        const tr = state.tr;
        const chainableState = $be3c84bcbbb2383c$export$83e24c5933427696({
            state: state,
            transaction: tr
        });
        const handler = $be3c84bcbbb2383c$var$run({
            editor: editor,
            state: chainableState,
            from: Math.max(from - 1, 0),
            to: to.b - 1,
            rule: rule,
            pasteEvent: pasteEvt,
            dropEvent: dropEvent
        });
        if (!handler || !tr.steps.length) return;
        try {
            dropEvent = typeof DragEvent !== 'undefined' ? new DragEvent('drop') : null;
        } catch  {
            dropEvent = null;
        }
        pasteEvent = typeof ClipboardEvent !== 'undefined' ? new ClipboardEvent('paste') : null;
        return tr;
    };
    const plugins = rules.map((rule)=>{
        return new (0, $1LeRC.Plugin)({
            // we register a global drag handler to track the current drag source element
            view (view) {
                const handleDragstart = (event)=>{
                    var _a;
                    dragSourceElement = ((_a = view.dom.parentElement) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ? view.dom.parentElement : null;
                    if (dragSourceElement) $be3c84bcbbb2383c$var$tiptapDragFromOtherEditor = editor;
                };
                const handleDragend = ()=>{
                    if ($be3c84bcbbb2383c$var$tiptapDragFromOtherEditor) $be3c84bcbbb2383c$var$tiptapDragFromOtherEditor = null;
                };
                window.addEventListener('dragstart', handleDragstart);
                window.addEventListener('dragend', handleDragend);
                return {
                    destroy () {
                        window.removeEventListener('dragstart', handleDragstart);
                        window.removeEventListener('dragend', handleDragend);
                    }
                };
            },
            props: {
                handleDOMEvents: {
                    drop: (view, event)=>{
                        isDroppedFromProseMirror = dragSourceElement === view.dom.parentElement;
                        dropEvent = event;
                        if (!isDroppedFromProseMirror) {
                            const dragFromOtherEditor = $be3c84bcbbb2383c$var$tiptapDragFromOtherEditor;
                            if (dragFromOtherEditor === null || dragFromOtherEditor === void 0 ? void 0 : dragFromOtherEditor.isEditable) // setTimeout to avoid the wrong content after drop, timeout arg can't be empty or 0
                            setTimeout(()=>{
                                const selection = dragFromOtherEditor.state.selection;
                                if (selection) dragFromOtherEditor.commands.deleteRange({
                                    from: selection.from,
                                    to: selection.to
                                });
                            }, 10);
                        }
                        return false;
                    },
                    paste: (_view, event)=>{
                        var _a;
                        const html = (_a = event.clipboardData) === null || _a === void 0 ? void 0 : _a.getData('text/html');
                        pasteEvent = event;
                        isPastedFromProseMirror = !!(html === null || html === void 0 ? void 0 : html.includes('data-pm-slice'));
                        return false;
                    }
                }
            },
            appendTransaction: (transactions, oldState, state)=>{
                const transaction = transactions[0];
                const isPaste = transaction.getMeta('uiEvent') === 'paste' && !isPastedFromProseMirror;
                const isDrop = transaction.getMeta('uiEvent') === 'drop' && !isDroppedFromProseMirror;
                // if PasteRule is triggered by insertContent()
                const simulatedPasteMeta = transaction.getMeta('applyPasteRules');
                const isSimulatedPaste = !!simulatedPasteMeta;
                if (!isPaste && !isDrop && !isSimulatedPaste) return;
                // Handle simulated paste
                if (isSimulatedPaste) {
                    let { text: text } = simulatedPasteMeta;
                    if (typeof text === 'string') text;
                    else text = $be3c84bcbbb2383c$export$d1b60002472b2c81((0, $1krlL.Fragment).from(text), state.schema);
                    const { from: from } = simulatedPasteMeta;
                    const to = from + text.length;
                    const pasteEvt = $be3c84bcbbb2383c$var$createClipboardPasteEvent(text);
                    return processEvent({
                        rule: rule,
                        state: state,
                        from: from,
                        to: {
                            b: to
                        },
                        pasteEvt: pasteEvt
                    });
                }
                // handle actual paste/drop
                const from = oldState.doc.content.findDiffStart(state.doc.content);
                const to = oldState.doc.content.findDiffEnd(state.doc.content);
                // stop if there is no changed range
                if (!$be3c84bcbbb2383c$export$7e4aa119212bc614(from) || !to || from === to.b) return;
                return processEvent({
                    rule: rule,
                    state: state,
                    from: from,
                    to: to,
                    pasteEvt: pasteEvent
                });
            }
        });
    });
    return plugins;
}
function $be3c84bcbbb2383c$export$15704658c784aef1(items) {
    const filtered = items.filter((el, index)=>items.indexOf(el) !== index);
    return Array.from(new Set(filtered));
}
class $be3c84bcbbb2383c$var$ExtensionManager {
    constructor(extensions, editor){
        this.splittableMarks = [];
        this.editor = editor;
        this.extensions = $be3c84bcbbb2383c$var$ExtensionManager.resolve(extensions);
        this.schema = $be3c84bcbbb2383c$export$71bc12a97b59a858(this.extensions, editor);
        this.setupExtensions();
    }
    /**
     * Returns a flattened and sorted extension list while
     * also checking for duplicated extensions and warns the user.
     * @param extensions An array of Tiptap extensions
     * @returns An flattened and sorted array of Tiptap extensions
     */ static resolve(extensions) {
        const resolvedExtensions = $be3c84bcbbb2383c$var$ExtensionManager.sort($be3c84bcbbb2383c$var$ExtensionManager.flatten(extensions));
        const duplicatedNames = $be3c84bcbbb2383c$export$15704658c784aef1(resolvedExtensions.map((extension)=>extension.name));
        if (duplicatedNames.length) console.warn(`[tiptap warn]: Duplicate extension names found: [${duplicatedNames.map((item)=>`'${item}'`).join(', ')}]. This can lead to issues.`);
        return resolvedExtensions;
    }
    /**
     * Create a flattened array of extensions by traversing the `addExtensions` field.
     * @param extensions An array of Tiptap extensions
     * @returns A flattened array of Tiptap extensions
     */ static flatten(extensions) {
        return extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage
            };
            const addExtensions = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addExtensions', context);
            if (addExtensions) return [
                extension,
                ...this.flatten(addExtensions())
            ];
            return extension;
        })// `Infinity` will break TypeScript so we set a number that is probably high enough
        .flat(10);
    }
    /**
     * Sort extensions by priority.
     * @param extensions An array of Tiptap extensions
     * @returns A sorted array of Tiptap extensions by priority
     */ static sort(extensions) {
        const defaultPriority = 100;
        return extensions.sort((a, b)=>{
            const priorityA = $be3c84bcbbb2383c$export$f73578b718a57eaa(a, 'priority') || defaultPriority;
            const priorityB = $be3c84bcbbb2383c$export$f73578b718a57eaa(b, 'priority') || defaultPriority;
            if (priorityA > priorityB) return -1;
            if (priorityA < priorityB) return 1;
            return 0;
        });
    }
    /**
     * Get all commands from the extensions.
     * @returns An object with all commands where the key is the command name and the value is the command function
     */ get commands() {
        return this.extensions.reduce((commands, extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $be3c84bcbbb2383c$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const addCommands = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addCommands', context);
            if (!addCommands) return commands;
            return {
                ...commands,
                ...addCommands()
            };
        }, {});
    }
    /**
     * Get all registered Prosemirror plugins from the extensions.
     * @returns An array of Prosemirror plugins
     */ get plugins() {
        const { editor: editor } = this;
        // With ProseMirror, first plugins within an array are executed first.
        // In Tiptap, we provide the ability to override plugins,
        // so it feels more natural to run plugins at the end of an array first.
        // That’s why we have to reverse the `extensions` array and sort again
        // based on the `priority` option.
        const extensions = $be3c84bcbbb2383c$var$ExtensionManager.sort([
            ...this.extensions
        ].reverse());
        const inputRules = [];
        const pasteRules = [];
        const allPlugins = extensions.map((extension)=>{
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $be3c84bcbbb2383c$export$ea18268b31f54e5(extension.name, this.schema)
            };
            const plugins = [];
            const addKeyboardShortcuts = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addKeyboardShortcuts', context);
            let defaultBindings = {};
            // bind exit handling
            if (extension.type === 'mark' && $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'exitable', context)) defaultBindings.ArrowRight = ()=>$be3c84bcbbb2383c$export$c9d15bcfc6d42044.handleExit({
                    editor: editor,
                    mark: extension
                });
            if (addKeyboardShortcuts) {
                const bindings = Object.fromEntries(Object.entries(addKeyboardShortcuts()).map(([shortcut, method])=>{
                    return [
                        shortcut,
                        ()=>method({
                                editor: editor
                            })
                    ];
                }));
                defaultBindings = {
                    ...defaultBindings,
                    ...bindings
                };
            }
            const keyMapPlugin = (0, $18HhN.keymap)(defaultBindings);
            plugins.push(keyMapPlugin);
            const addInputRules = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addInputRules', context);
            if ($be3c84bcbbb2383c$export$79b791167b05aada(extension, editor.options.enableInputRules) && addInputRules) inputRules.push(...addInputRules());
            const addPasteRules = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addPasteRules', context);
            if ($be3c84bcbbb2383c$export$79b791167b05aada(extension, editor.options.enablePasteRules) && addPasteRules) pasteRules.push(...addPasteRules());
            const addProseMirrorPlugins = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addProseMirrorPlugins', context);
            if (addProseMirrorPlugins) {
                const proseMirrorPlugins = addProseMirrorPlugins();
                plugins.push(...proseMirrorPlugins);
            }
            return plugins;
        }).flat();
        return [
            $be3c84bcbbb2383c$export$f2a821f78e918151({
                editor: editor,
                rules: inputRules
            }),
            ...$be3c84bcbbb2383c$export$458282b0dddaaaa4({
                editor: editor,
                rules: pasteRules
            }),
            ...allPlugins
        ];
    }
    /**
     * Get all attributes from the extensions.
     * @returns An array of attributes
     */ get attributes() {
        return $be3c84bcbbb2383c$export$6e54e3e69d60df3d(this.extensions);
    }
    /**
     * Get all node views from the extensions.
     * @returns An object with all node views where the key is the node name and the value is the node view function
     */ get nodeViews() {
        const { editor: editor } = this;
        const { nodeExtensions: nodeExtensions } = $be3c84bcbbb2383c$export$36e8c2990da8266f(this.extensions);
        return Object.fromEntries(nodeExtensions.filter((extension)=>!!$be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addNodeView')).map((extension)=>{
            const extensionAttributes = this.attributes.filter((attribute)=>attribute.type === extension.name);
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: editor,
                type: $be3c84bcbbb2383c$export$d168cba70360dd3d(extension.name, this.schema)
            };
            const addNodeView = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addNodeView', context);
            if (!addNodeView) return [];
            const nodeview = (node, view, getPos, decorations, innerDecorations)=>{
                const HTMLAttributes = $be3c84bcbbb2383c$export$bc79d84a417d7b02(node, extensionAttributes);
                return addNodeView()({
                    node: // pass-through
                    node,
                    view: view,
                    getPos: getPos,
                    decorations: decorations,
                    innerDecorations: innerDecorations,
                    editor: // tiptap-specific
                    editor,
                    extension: extension,
                    HTMLAttributes: HTMLAttributes
                });
            };
            return [
                extension.name,
                nodeview
            ];
        }));
    }
    /**
     * Go through all extensions, create extension storages & setup marks
     * & bind editor event listener.
     */ setupExtensions() {
        this.extensions.forEach((extension)=>{
            var _a;
            // store extension storage in editor
            this.editor.extensionStorage[extension.name] = extension.storage;
            const context = {
                name: extension.name,
                options: extension.options,
                storage: extension.storage,
                editor: this.editor,
                type: $be3c84bcbbb2383c$export$ea18268b31f54e5(extension.name, this.schema)
            };
            if (extension.type === 'mark') {
                const keepOnSplit = (_a = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'keepOnSplit', context))) !== null && _a !== void 0 ? _a : true;
                if (keepOnSplit) this.splittableMarks.push(extension.name);
            }
            const onBeforeCreate = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onBeforeCreate', context);
            const onCreate = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onCreate', context);
            const onUpdate = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onUpdate', context);
            const onSelectionUpdate = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onSelectionUpdate', context);
            const onTransaction = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onTransaction', context);
            const onFocus = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onFocus', context);
            const onBlur = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onBlur', context);
            const onDestroy = $be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'onDestroy', context);
            if (onBeforeCreate) this.editor.on('beforeCreate', onBeforeCreate);
            if (onCreate) this.editor.on('create', onCreate);
            if (onUpdate) this.editor.on('update', onUpdate);
            if (onSelectionUpdate) this.editor.on('selectionUpdate', onSelectionUpdate);
            if (onTransaction) this.editor.on('transaction', onTransaction);
            if (onFocus) this.editor.on('focus', onFocus);
            if (onBlur) this.editor.on('blur', onBlur);
            if (onDestroy) this.editor.on('destroy', onDestroy);
        });
    }
}
/**
 * The Extension class is the base class for all extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $be3c84bcbbb2383c$export$eeddbf09bb970356 {
    constructor(config = {}){
        this.type = 'extension';
        this.name = 'extension';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(this, 'addOptions', {
            name: this.name
        }));
        this.storage = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(this, 'addStorage', {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $be3c84bcbbb2383c$export$eeddbf09bb970356(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $be3c84bcbbb2383c$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $be3c84bcbbb2383c$export$eeddbf09bb970356({
            ...this.config,
            ...extendedConfig
        });
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addOptions', {
            name: extension.name
        }));
        extension.storage = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addStorage', {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
/**
 * Gets the text between two positions in a Prosemirror node
 * and serializes it using the given text serializers and block separator (see getText)
 * @param startNode The Prosemirror node to start from
 * @param range The range of the text to get
 * @param options Options for the text serializer & block separator
 * @returns The text between the two positions
 */ function $be3c84bcbbb2383c$export$6e5992a7455d9ef6(startNode, range, options) {
    const { from: from, to: to } = range;
    const { blockSeparator: blockSeparator = '\n\n', textSerializers: textSerializers = {} } = options || {};
    let text = '';
    startNode.nodesBetween(from, to, (node, pos, parent, index)=>{
        var _a;
        if (node.isBlock && pos > from) text += blockSeparator;
        const textSerializer = textSerializers === null || textSerializers === void 0 ? void 0 : textSerializers[node.type.name];
        if (textSerializer) {
            if (parent) text += textSerializer({
                node: node,
                pos: pos,
                parent: parent,
                index: index,
                range: range
            });
            // do not descend into child nodes when there exists a serializer
            return false;
        }
        if (node.isText) text += (_a = node === null || node === void 0 ? void 0 : node.text) === null || _a === void 0 ? void 0 : _a.slice(Math.max(from, pos) - pos, to - pos); // eslint-disable-line
    });
    return text;
}
/**
 * Find text serializers `toText` in a Prosemirror schema
 * @param schema The Prosemirror schema to search in
 * @returns A record of text serializers by node name
 */ function $be3c84bcbbb2383c$export$fdd92b7d22ac071c(schema) {
    return Object.fromEntries(Object.entries(schema.nodes).filter(([, node])=>node.spec.toText).map(([name, node])=>[
            name,
            node.spec.toText
        ]));
}
const $be3c84bcbbb2383c$var$ClipboardTextSerializer = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'clipboardTextSerializer',
    addOptions () {
        return {
            blockSeparator: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            new (0, $1LeRC.Plugin)({
                key: new (0, $1LeRC.PluginKey)('clipboardTextSerializer'),
                props: {
                    clipboardTextSerializer: ()=>{
                        const { editor: editor } = this;
                        const { state: state, schema: schema } = editor;
                        const { doc: doc, selection: selection } = state;
                        const { ranges: ranges } = selection;
                        const from = Math.min(...ranges.map((range)=>range.$from.pos));
                        const to = Math.max(...ranges.map((range)=>range.$to.pos));
                        const textSerializers = $be3c84bcbbb2383c$export$fdd92b7d22ac071c(schema);
                        const range = {
                            from: from,
                            to: to
                        };
                        return $be3c84bcbbb2383c$export$6e5992a7455d9ef6(doc, range, {
                            ...this.options.blockSeparator !== undefined ? {
                                blockSeparator: this.options.blockSeparator
                            } : {},
                            textSerializers: textSerializers
                        });
                    }
                }
            })
        ];
    }
});
const $be3c84bcbbb2383c$var$blur = ()=>({ editor: editor, view: view })=>{
        requestAnimationFrame(()=>{
            var _a;
            if (!editor.isDestroyed) {
                view.dom.blur();
                // Browsers should remove the caret on blur but safari does not.
                // See: https://github.com/ueberdosis/tiptap/issues/2405
                (_a = window === null || window === void 0 ? void 0 : window.getSelection()) === null || _a === void 0 || _a.removeAllRanges();
            }
        });
        return true;
    };
const $be3c84bcbbb2383c$var$clearContent = (emitUpdate = false)=>({ commands: commands })=>{
        return commands.setContent('', emitUpdate);
    };
const $be3c84bcbbb2383c$var$clearNodes = ()=>({ state: state, tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { ranges: ranges } = selection;
        if (!dispatch) return true;
        ranges.forEach(({ $from: $from, $to: $to })=>{
            state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
                if (node.type.isText) return;
                const { doc: doc, mapping: mapping } = tr;
                const $mappedFrom = doc.resolve(mapping.map(pos));
                const $mappedTo = doc.resolve(mapping.map(pos + node.nodeSize));
                const nodeRange = $mappedFrom.blockRange($mappedTo);
                if (!nodeRange) return;
                const targetLiftDepth = (0, $gfgdn.liftTarget)(nodeRange);
                if (node.type.isTextblock) {
                    const { defaultType: defaultType } = $mappedFrom.parent.contentMatchAt($mappedFrom.index());
                    tr.setNodeMarkup(nodeRange.start, defaultType);
                }
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(nodeRange, targetLiftDepth);
            });
        });
        return true;
    };
const $be3c84bcbbb2383c$var$command = (fn)=>(props)=>{
        return fn(props);
    };
const $be3c84bcbbb2383c$var$createParagraphNear = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.createParagraphNear)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$cut = (originRange, targetPos)=>({ editor: editor, tr: tr })=>{
        const { state: state } = editor;
        const contentSlice = state.doc.slice(originRange.from, originRange.to);
        tr.deleteRange(originRange.from, originRange.to);
        const newPos = tr.mapping.map(targetPos);
        tr.insert(newPos, contentSlice.content);
        tr.setSelection(new (0, $1LeRC.TextSelection)(tr.doc.resolve(Math.max(newPos - 1, 0))));
        return true;
    };
const $be3c84bcbbb2383c$var$deleteCurrentNode = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const currentNode = selection.$anchor.node();
        // if there is content inside the current node, break out of this command
        if (currentNode.content.size > 0) return false;
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === currentNode.type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $be3c84bcbbb2383c$var$deleteNode = (typeOrName)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        const $pos = tr.selection.$anchor;
        for(let depth = $pos.depth; depth > 0; depth -= 1){
            const node = $pos.node(depth);
            if (node.type === type) {
                if (dispatch) {
                    const from = $pos.before(depth);
                    const to = $pos.after(depth);
                    tr.delete(from, to).scrollIntoView();
                }
                return true;
            }
        }
        return false;
    };
const $be3c84bcbbb2383c$var$deleteRange = (range)=>({ tr: tr, dispatch: dispatch })=>{
        const { from: from, to: to } = range;
        if (dispatch) tr.delete(from, to);
        return true;
    };
const $be3c84bcbbb2383c$var$deleteSelection = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.deleteSelection)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$enter = ()=>({ commands: commands })=>{
        return commands.keyboardShortcut('Enter');
    };
const $be3c84bcbbb2383c$var$exitCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.exitCode)(state, dispatch);
    };
/**
 * Check if object1 includes object2
 * @param object1 Object
 * @param object2 Object
 */ function $be3c84bcbbb2383c$export$7aeb68f71172641d(object1, object2, options = {
    strict: true
}) {
    const keys = Object.keys(object2);
    if (!keys.length) return true;
    return keys.every((key)=>{
        if (options.strict) return object2[key] === object1[key];
        if ($be3c84bcbbb2383c$export$49841c62b9eff15(object2[key])) return object2[key].test(object1[key]);
        return object2[key] === object1[key];
    });
}
function $be3c84bcbbb2383c$var$findMarkInSet(marks, type, attributes = {}) {
    return marks.find((item)=>{
        return item.type === type && $be3c84bcbbb2383c$export$7aeb68f71172641d(// Only check equality for the attributes that are provided
        Object.fromEntries(Object.keys(attributes).map((k)=>[
                k,
                item.attrs[k]
            ])), attributes);
    });
}
function $be3c84bcbbb2383c$var$isMarkInSet(marks, type, attributes = {}) {
    return !!$be3c84bcbbb2383c$var$findMarkInSet(marks, type, attributes);
}
/**
 * Get the range of a mark at a resolved position.
 */ function $be3c84bcbbb2383c$export$8ceae6d06f5c4df5(/**
 * The position to get the mark range for.
 */ $pos, /**
 * The mark type to get the range for.
 */ type, /**
 * The attributes to match against.
 * If not provided, only the first mark at the position will be matched.
 */ attributes) {
    var _a;
    if (!$pos || !type) return;
    let start = $pos.parent.childAfter($pos.parentOffset);
    // If the cursor is at the start of a text node that does not have the mark, look backward
    if (!start.node || !start.node.marks.some((mark)=>mark.type === type)) start = $pos.parent.childBefore($pos.parentOffset);
    // If there is no text node with the mark even backward, return undefined
    if (!start.node || !start.node.marks.some((mark)=>mark.type === type)) return;
    // Default to only matching against the first mark's attributes
    attributes = attributes || ((_a = start.node.marks[0]) === null || _a === void 0 ? void 0 : _a.attrs);
    // We now know that the cursor is either at the start, middle or end of a text node with the specified mark
    // so we can look it up on the targeted mark
    const mark = $be3c84bcbbb2383c$var$findMarkInSet([
        ...start.node.marks
    ], type, attributes);
    if (!mark) return;
    let startIndex = start.index;
    let startPos = $pos.start() + start.offset;
    let endIndex = startIndex + 1;
    let endPos = startPos + start.node.nodeSize;
    while(startIndex > 0 && $be3c84bcbbb2383c$var$isMarkInSet([
        ...$pos.parent.child(startIndex - 1).marks
    ], type, attributes)){
        startIndex -= 1;
        startPos -= $pos.parent.child(startIndex).nodeSize;
    }
    while(endIndex < $pos.parent.childCount && $be3c84bcbbb2383c$var$isMarkInSet([
        ...$pos.parent.child(endIndex).marks
    ], type, attributes)){
        endPos += $pos.parent.child(endIndex).nodeSize;
        endIndex += 1;
    }
    return {
        from: startPos,
        to: endPos
    };
}
function $be3c84bcbbb2383c$export$b1269d6bf6e491ec(nameOrType, schema) {
    if (typeof nameOrType === 'string') {
        if (!schema.marks[nameOrType]) throw Error(`There is no mark type named '${nameOrType}'. Maybe you forgot to add the extension?`);
        return schema.marks[nameOrType];
    }
    return nameOrType;
}
const $be3c84bcbbb2383c$var$extendMarkRange = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const type = $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { doc: doc, selection: selection } = tr;
        const { $from: $from, from: from, to: to } = selection;
        if (dispatch) {
            const range = $be3c84bcbbb2383c$export$8ceae6d06f5c4df5($from, type, attributes);
            if (range && range.from <= from && range.to >= to) {
                const newSelection = (0, $1LeRC.TextSelection).create(doc, range.from, range.to);
                tr.setSelection(newSelection);
            }
        }
        return true;
    };
const $be3c84bcbbb2383c$var$first = (commands)=>(props)=>{
        const items = typeof commands === 'function' ? commands(props) : commands;
        for(let i = 0; i < items.length; i += 1){
            if (items[i](props)) return true;
        }
        return false;
    };
function $be3c84bcbbb2383c$export$38b50bf35e79aaf3(value) {
    return value instanceof (0, $1LeRC.TextSelection);
}
function $be3c84bcbbb2383c$export$6fb785c609d82593(value = 0, min = 0, max = 0) {
    return Math.min(Math.max(value, min), max);
}
function $be3c84bcbbb2383c$export$225b0233b78e0d61(doc, position = null) {
    if (!position) return null;
    const selectionAtStart = (0, $1LeRC.Selection).atStart(doc);
    const selectionAtEnd = (0, $1LeRC.Selection).atEnd(doc);
    if (position === 'start' || position === true) return selectionAtStart;
    if (position === 'end') return selectionAtEnd;
    const minPos = selectionAtStart.from;
    const maxPos = selectionAtEnd.to;
    if (position === 'all') return (0, $1LeRC.TextSelection).create(doc, $be3c84bcbbb2383c$export$6fb785c609d82593(0, minPos, maxPos), $be3c84bcbbb2383c$export$6fb785c609d82593(doc.content.size, minPos, maxPos));
    return (0, $1LeRC.TextSelection).create(doc, $be3c84bcbbb2383c$export$6fb785c609d82593(position, minPos, maxPos), $be3c84bcbbb2383c$export$6fb785c609d82593(position, minPos, maxPos));
}
function $be3c84bcbbb2383c$var$isAndroid() {
    return navigator.platform === 'Android' || /android/i.test(navigator.userAgent);
}
function $be3c84bcbbb2383c$export$86c1a3f9ab33da5c() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
    ].includes(navigator.platform) || navigator.userAgent.includes('Mac') && 'ontouchend' in document;
}
const $be3c84bcbbb2383c$var$focus = (position = null, options = {})=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        options = {
            scrollIntoView: true,
            ...options
        };
        const delayedFocus = ()=>{
            // focus within `requestAnimationFrame` breaks focus on iOS and Android
            // so we have to call this
            if ($be3c84bcbbb2383c$export$86c1a3f9ab33da5c() || $be3c84bcbbb2383c$var$isAndroid()) view.dom.focus();
            // For React we have to focus asynchronously. Otherwise wild things happen.
            // see: https://github.com/ueberdosis/tiptap/issues/1520
            requestAnimationFrame(()=>{
                if (!editor.isDestroyed) {
                    view.focus();
                    if (options === null || options === void 0 ? void 0 : options.scrollIntoView) editor.commands.scrollIntoView();
                }
            });
        };
        if (view.hasFocus() && position === null || position === false) return true;
        // we don’t try to resolve a NodeSelection or CellSelection
        if (dispatch && position === null && !$be3c84bcbbb2383c$export$38b50bf35e79aaf3(editor.state.selection)) {
            delayedFocus();
            return true;
        }
        // pass through tr.doc instead of editor.state.doc
        // since transactions could change the editors state before this command has been run
        const selection = $be3c84bcbbb2383c$export$225b0233b78e0d61(tr.doc, position) || editor.state.selection;
        const isSameSelection = editor.state.selection.eq(selection);
        if (dispatch) {
            if (!isSameSelection) tr.setSelection(selection);
            // `tr.setSelection` resets the stored marks
            // so we’ll restore them if the selection is the same as before
            if (isSameSelection && tr.storedMarks) tr.setStoredMarks(tr.storedMarks);
            delayedFocus();
        }
        return true;
    };
const $be3c84bcbbb2383c$var$forEach = (items, fn)=>(props)=>{
        return items.every((item, index)=>fn(item, {
                ...props,
                index: index
            }));
    };
const $be3c84bcbbb2383c$var$insertContent = (value, options)=>({ tr: tr, commands: commands })=>{
        return commands.insertContentAt({
            from: tr.selection.from,
            to: tr.selection.to
        }, value, options);
    };
const $be3c84bcbbb2383c$var$removeWhitespaces = (node)=>{
    const children = node.childNodes;
    for(let i = children.length - 1; i >= 0; i -= 1){
        const child = children[i];
        if (child.nodeType === 3 && child.nodeValue && /^(\n\s\s|\n)$/.test(child.nodeValue)) node.removeChild(child);
        else if (child.nodeType === 1) $be3c84bcbbb2383c$var$removeWhitespaces(child);
    }
    return node;
};
function $be3c84bcbbb2383c$export$1b93bf03550cde01(value) {
    // add a wrapper to preserve leading and trailing whitespace
    const wrappedValue = `<body>${value}</body>`;
    const html = new window.DOMParser().parseFromString(wrappedValue, 'text/html').body;
    return $be3c84bcbbb2383c$var$removeWhitespaces(html);
}
/**
 * Takes a JSON or HTML content and creates a Prosemirror node or fragment from it.
 * @param content The JSON or HTML content to create the node from
 * @param schema The Prosemirror schema to use for the node
 * @param options Options for the parser
 * @returns The created Prosemirror node or fragment
 */ function $be3c84bcbbb2383c$export$12c64e96dddaee61(content, schema, options) {
    if (content instanceof (0, $1krlL.Node) || content instanceof (0, $1krlL.Fragment)) return content;
    options = {
        slice: true,
        parseOptions: {},
        ...options
    };
    const isJSONContent = typeof content === 'object' && content !== null;
    const isTextContent = typeof content === 'string';
    if (isJSONContent) try {
        const isArrayContent = Array.isArray(content) && content.length > 0;
        // if the JSON Content is an array of nodes, create a fragment for each node
        if (isArrayContent) return (0, $1krlL.Fragment).fromArray(content.map((item)=>schema.nodeFromJSON(item)));
        const node = schema.nodeFromJSON(content);
        if (options.errorOnInvalidContent) node.check();
        return node;
    } catch (error) {
        if (options.errorOnInvalidContent) throw new Error('[tiptap error]: Invalid JSON content', {
            cause: error
        });
        console.warn('[tiptap warn]: Invalid content.', 'Passed value:', content, 'Error:', error);
        return $be3c84bcbbb2383c$export$12c64e96dddaee61('', schema, options);
    }
    if (isTextContent) {
        // Check for invalid content
        if (options.errorOnInvalidContent) {
            let hasInvalidContent = false;
            let invalidContent = '';
            // A copy of the current schema with a catch-all node at the end
            const contentCheckSchema = new (0, $1krlL.Schema)({
                topNode: schema.spec.topNode,
                marks: schema.spec.marks,
                // Prosemirror's schemas are executed such that: the last to execute, matches last
                // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
                nodes: schema.spec.nodes.append({
                    __tiptap__private__unknown__catch__all__node: {
                        content: 'inline*',
                        group: 'block',
                        parseDOM: [
                            {
                                tag: '*',
                                getAttrs: (e)=>{
                                    // If this is ever called, we know that the content has something that we don't know how to handle in the schema
                                    hasInvalidContent = true;
                                    // Try to stringify the element for a more helpful error message
                                    invalidContent = typeof e === 'string' ? e : e.outerHTML;
                                    return null;
                                }
                            }
                        ]
                    }
                })
            });
            if (options.slice) (0, $1krlL.DOMParser).fromSchema(contentCheckSchema).parseSlice($be3c84bcbbb2383c$export$1b93bf03550cde01(content), options.parseOptions);
            else (0, $1krlL.DOMParser).fromSchema(contentCheckSchema).parse($be3c84bcbbb2383c$export$1b93bf03550cde01(content), options.parseOptions);
            if (options.errorOnInvalidContent && hasInvalidContent) throw new Error('[tiptap error]: Invalid HTML content', {
                cause: new Error(`Invalid element found: ${invalidContent}`)
            });
        }
        const parser = (0, $1krlL.DOMParser).fromSchema(schema);
        if (options.slice) return parser.parseSlice($be3c84bcbbb2383c$export$1b93bf03550cde01(content), options.parseOptions).content;
        return parser.parse($be3c84bcbbb2383c$export$1b93bf03550cde01(content), options.parseOptions);
    }
    return $be3c84bcbbb2383c$export$12c64e96dddaee61('', schema, options);
}
// source: https://github.com/ProseMirror/prosemirror-state/blob/master/src/selection.js#L466
function $be3c84bcbbb2383c$export$bf93acd215057ab0(tr, startLen, bias) {
    const last = tr.steps.length - 1;
    if (last < startLen) return;
    const step = tr.steps[last];
    if (!(step instanceof (0, $gfgdn.ReplaceStep) || step instanceof (0, $gfgdn.ReplaceAroundStep))) return;
    const map = tr.mapping.maps[last];
    let end = 0;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end === 0) end = newTo;
    });
    tr.setSelection((0, $1LeRC.Selection).near(tr.doc.resolve(end), bias));
}
const $be3c84bcbbb2383c$var$isFragment = (nodeOrFragment)=>{
    return !('type' in nodeOrFragment);
};
const $be3c84bcbbb2383c$var$insertContentAt = (position, value, options)=>({ tr: tr, dispatch: dispatch, editor: editor })=>{
        var _a;
        if (dispatch) {
            options = {
                parseOptions: editor.options.parseOptions,
                updateSelection: true,
                applyInputRules: false,
                applyPasteRules: false,
                ...options
            };
            let content;
            const emitContentError = (error)=>{
                editor.emit('contentError', {
                    editor: editor,
                    error: error,
                    disableCollaboration: ()=>{
                        if (editor.storage.collaboration) editor.storage.collaboration.isDisabled = true;
                    }
                });
            };
            const parseOptions = {
                preserveWhitespace: 'full',
                ...options.parseOptions
            };
            // If `emitContentError` is enabled, we want to check the content for errors
            // but ignore them (do not remove the invalid content from the document)
            if (!options.errorOnInvalidContent && !editor.options.enableContentCheck && editor.options.emitContentError) try {
                $be3c84bcbbb2383c$export$12c64e96dddaee61(value, editor.schema, {
                    parseOptions: parseOptions,
                    errorOnInvalidContent: true
                });
            } catch (e) {
                emitContentError(e);
            }
            try {
                content = $be3c84bcbbb2383c$export$12c64e96dddaee61(value, editor.schema, {
                    parseOptions: parseOptions,
                    errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
                });
            } catch (e) {
                emitContentError(e);
                return false;
            }
            let { from: from, to: to } = typeof position === 'number' ? {
                from: position,
                to: position
            } : {
                from: position.from,
                to: position.to
            };
            let isOnlyTextContent = true;
            let isOnlyBlockContent = true;
            const nodes = $be3c84bcbbb2383c$var$isFragment(content) ? content : [
                content
            ];
            nodes.forEach((node)=>{
                // check if added node is valid
                node.check();
                isOnlyTextContent = isOnlyTextContent ? node.isText && node.marks.length === 0 : false;
                isOnlyBlockContent = isOnlyBlockContent ? node.isBlock : false;
            });
            // check if we can replace the wrapping node by
            // the newly inserted content
            // example:
            // replace an empty paragraph by an inserted image
            // instead of inserting the image below the paragraph
            if (from === to && isOnlyBlockContent) {
                const { parent: parent } = tr.doc.resolve(from);
                const isEmptyTextBlock = parent.isTextblock && !parent.type.spec.code && !parent.childCount;
                if (isEmptyTextBlock) {
                    from -= 1;
                    to += 1;
                }
            }
            let newContent;
            // if there is only plain text we have to use `insertText`
            // because this will keep the current marks
            if (isOnlyTextContent) {
                // if value is string, we can use it directly
                // otherwise if it is an array, we have to join it
                if (Array.isArray(value)) newContent = value.map((v)=>v.text || '').join('');
                else if (value instanceof (0, $1krlL.Fragment)) {
                    let text = '';
                    value.forEach((node)=>{
                        if (node.text) text += node.text;
                    });
                    newContent = text;
                } else if (typeof value === 'object' && !!value && !!value.text) newContent = value.text;
                else newContent = value;
                tr.insertText(newContent, from, to);
            } else {
                newContent = content;
                tr.replaceWith(from, to, newContent);
            }
            // set cursor at end of inserted content
            if (options.updateSelection) $be3c84bcbbb2383c$export$bf93acd215057ab0(tr, tr.steps.length - 1, -1);
            if (options.applyInputRules) tr.setMeta('applyInputRules', {
                from: from,
                text: newContent
            });
            if (options.applyPasteRules) tr.setMeta('applyPasteRules', {
                from: from,
                text: newContent
            });
        }
        return true;
    };
const $be3c84bcbbb2383c$var$joinUp = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.joinUp)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$joinDown = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.joinDown)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$joinBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.joinBackward)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$joinForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.joinForward)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$joinItemBackward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $gfgdn.joinPoint)(state.doc, state.selection.$from.pos, -1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch  {
            return false;
        }
    };
const $be3c84bcbbb2383c$var$joinItemForward = ()=>({ state: state, dispatch: dispatch, tr: tr })=>{
        try {
            const point = (0, $gfgdn.joinPoint)(state.doc, state.selection.$from.pos, 1);
            if (point === null || point === undefined) return false;
            tr.join(point, 2);
            if (dispatch) dispatch(tr);
            return true;
        } catch  {
            return false;
        }
    };
const $be3c84bcbbb2383c$var$joinTextblockBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.joinTextblockBackward)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$joinTextblockForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.joinTextblockForward)(state, dispatch);
    };
function $be3c84bcbbb2383c$export$6159e43e50a41987() {
    return typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
}
function $be3c84bcbbb2383c$var$normalizeKeyName(name) {
    const parts = name.split(/-(?!$)/);
    let result = parts[parts.length - 1];
    if (result === 'Space') result = ' ';
    let alt;
    let ctrl;
    let shift;
    let meta;
    for(let i = 0; i < parts.length - 1; i += 1){
        const mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($be3c84bcbbb2383c$export$86c1a3f9ab33da5c() || $be3c84bcbbb2383c$export$6159e43e50a41987()) meta = true;
            else ctrl = true;
        } else throw new Error(`Unrecognized modifier name: ${mod}`);
    }
    if (alt) result = `Alt-${result}`;
    if (ctrl) result = `Ctrl-${result}`;
    if (meta) result = `Meta-${result}`;
    if (shift) result = `Shift-${result}`;
    return result;
}
const $be3c84bcbbb2383c$var$keyboardShortcut = (name)=>({ editor: editor, view: view, tr: tr, dispatch: dispatch })=>{
        const keys = $be3c84bcbbb2383c$var$normalizeKeyName(name).split(/-(?!$)/);
        const key = keys.find((item)=>![
                'Alt',
                'Ctrl',
                'Meta',
                'Shift'
            ].includes(item));
        const event = new KeyboardEvent('keydown', {
            key: key === 'Space' ? ' ' : key,
            altKey: keys.includes('Alt'),
            ctrlKey: keys.includes('Ctrl'),
            metaKey: keys.includes('Meta'),
            shiftKey: keys.includes('Shift'),
            bubbles: true,
            cancelable: true
        });
        const capturedTransaction = editor.captureTransaction(()=>{
            view.someProp('handleKeyDown', (f)=>f(view, event));
        });
        capturedTransaction === null || capturedTransaction === void 0 || capturedTransaction.steps.forEach((step)=>{
            const newStep = step.map(tr.mapping);
            if (newStep && dispatch) tr.maybeStep(newStep);
        });
        return true;
    };
function $be3c84bcbbb2383c$export$7a24a642b0c7ad29(state, typeOrName, attributes = {}) {
    const { from: from, to: to, empty: empty } = state.selection;
    const type = typeOrName ? $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema) : null;
    const nodeRanges = [];
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isText) return;
        const relativeFrom = Math.max(from, pos);
        const relativeTo = Math.min(to, pos + node.nodeSize);
        nodeRanges.push({
            node: node,
            from: relativeFrom,
            to: relativeTo
        });
    });
    const selectionRange = to - from;
    const matchedNodeRanges = nodeRanges.filter((nodeRange)=>{
        if (!type) return true;
        return type.name === nodeRange.node.type.name;
    }).filter((nodeRange)=>$be3c84bcbbb2383c$export$7aeb68f71172641d(nodeRange.node.attrs, attributes, {
            strict: false
        }));
    if (empty) return !!matchedNodeRanges.length;
    const range = matchedNodeRanges.reduce((sum, nodeRange)=>sum + nodeRange.to - nodeRange.from, 0);
    return range >= selectionRange;
}
const $be3c84bcbbb2383c$var$lift = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $be3c84bcbbb2383c$export$7a24a642b0c7ad29(state, type, attributes);
        if (!isActive) return false;
        return (0, $9D0ij.lift)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$liftEmptyBlock = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.liftEmptyBlock)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$liftListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $ie1jF.liftListItem)(type)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$newlineInCode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.newlineInCode)(state, dispatch);
    };
/**
 * Get the type of a schema item by its name.
 * @param name The name of the schema item
 * @param schema The Prosemiror schema to search in
 * @returns The type of the schema item (`node` or `mark`), or null if it doesn't exist
 */ function $be3c84bcbbb2383c$export$e501dfcf737a48e0(name, schema) {
    if (schema.nodes[name]) return 'node';
    if (schema.marks[name]) return 'mark';
    return null;
}
/**
 * Remove a property or an array of properties from an object
 * @param obj Object
 * @param key Key to remove
 */ function $be3c84bcbbb2383c$export$8694e5c03a4df8e6(obj, propOrProps) {
    const props = typeof propOrProps === 'string' ? [
        propOrProps
    ] : propOrProps;
    return Object.keys(obj).reduce((newObj, prop)=>{
        if (!props.includes(prop)) newObj[prop] = obj[prop];
        return newObj;
    }, {});
}
const $be3c84bcbbb2383c$var$resetAttributes = (typeOrName, attributes)=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $be3c84bcbbb2383c$export$e501dfcf737a48e0(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === 'node') nodeType = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === 'mark') markType = $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            state.doc.nodesBetween(range.$from.pos, range.$to.pos, (node, pos)=>{
                if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, $be3c84bcbbb2383c$export$8694e5c03a4df8e6(node.attrs, attributes));
                if (markType && node.marks.length) node.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(pos, pos + node.nodeSize, markType.create($be3c84bcbbb2383c$export$8694e5c03a4df8e6(mark.attrs, attributes)));
                });
            });
        });
        return true;
    };
const $be3c84bcbbb2383c$var$scrollIntoView = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) tr.scrollIntoView();
        return true;
    };
const $be3c84bcbbb2383c$var$selectAll = ()=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const selection = new (0, $1LeRC.AllSelection)(tr.doc);
            tr.setSelection(selection);
        }
        return true;
    };
const $be3c84bcbbb2383c$var$selectNodeBackward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.selectNodeBackward)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$selectNodeForward = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.selectNodeForward)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$selectParentNode = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.selectParentNode)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $be3c84bcbbb2383c$var$selectTextblockEnd = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.selectTextblockEnd)(state, dispatch);
    };
// @ts-ignore
// TODO: add types to @types/prosemirror-commands
const $be3c84bcbbb2383c$var$selectTextblockStart = ()=>({ state: state, dispatch: dispatch })=>{
        return (0, $9D0ij.selectTextblockStart)(state, dispatch);
    };
/**
 * Create a new Prosemirror document node from content.
 * @param content The JSON or HTML content to create the document from
 * @param schema The Prosemirror schema to use for the document
 * @param parseOptions Options for the parser
 * @returns The created Prosemirror document node
 */ function $be3c84bcbbb2383c$export$37330def6e48b4c9(content, schema, parseOptions = {}, options = {}) {
    return $be3c84bcbbb2383c$export$12c64e96dddaee61(content, schema, {
        slice: false,
        parseOptions: parseOptions,
        errorOnInvalidContent: options.errorOnInvalidContent
    });
}
const $be3c84bcbbb2383c$var$setContent = (content, emitUpdate = false, parseOptions = {}, options = {})=>({ editor: editor, tr: tr, dispatch: dispatch, commands: commands })=>{
        var _a, _b;
        const { doc: doc } = tr;
        // This is to keep backward compatibility with the previous behavior
        // TODO remove this in the next major version
        if (parseOptions.preserveWhitespace !== 'full') {
            const document1 = $be3c84bcbbb2383c$export$37330def6e48b4c9(content, editor.schema, parseOptions, {
                errorOnInvalidContent: (_a = options.errorOnInvalidContent) !== null && _a !== void 0 ? _a : editor.options.enableContentCheck
            });
            if (dispatch) tr.replaceWith(0, doc.content.size, document1).setMeta('preventUpdate', !emitUpdate);
            return true;
        }
        if (dispatch) tr.setMeta('preventUpdate', !emitUpdate);
        return commands.insertContentAt({
            from: 0,
            to: doc.content.size
        }, content, {
            parseOptions: parseOptions,
            errorOnInvalidContent: (_b = options.errorOnInvalidContent) !== null && _b !== void 0 ? _b : editor.options.enableContentCheck
        });
    };
function $be3c84bcbbb2383c$export$2cd1d0e1f861bae0(state, typeOrName) {
    const type = $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema);
    const { from: from, to: to, empty: empty } = state.selection;
    const marks = [];
    if (empty) {
        if (state.storedMarks) marks.push(...state.storedMarks);
        marks.push(...state.selection.$head.marks());
    } else state.doc.nodesBetween(from, to, (node)=>{
        marks.push(...node.marks);
    });
    const mark = marks.find((markItem)=>markItem.type.name === type.name);
    if (!mark) return {};
    return {
        ...mark.attrs
    };
}
/**
 * Returns a new `Transform` based on all steps of the passed transactions.
 * @param oldDoc The Prosemirror node to start from
 * @param transactions The transactions to combine
 * @returns A new `Transform` with all steps of the passed transactions
 */ function $be3c84bcbbb2383c$export$f945f1716a5df33d(oldDoc, transactions) {
    const transform = new (0, $gfgdn.Transform)(oldDoc);
    transactions.forEach((transaction)=>{
        transaction.steps.forEach((step)=>{
            transform.step(step);
        });
    });
    return transform;
}
/**
 * Gets the default block type at a given match
 * @param match The content match to get the default block type from
 * @returns The default block type or null
 */ function $be3c84bcbbb2383c$export$6133a2de0e8ac885(match) {
    for(let i = 0; i < match.edgeCount; i += 1){
        const { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
 * Find children inside a Prosemirror node that match a predicate.
 * @param node The Prosemirror node to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $be3c84bcbbb2383c$export$f94ca194e830789c(node, predicate) {
    const nodesWithPos = [];
    node.descendants((child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Same as `findChildren` but searches only within a `range`.
 * @param node The Prosemirror node to search in
 * @param range The range to search in
 * @param predicate The predicate to match
 * @returns An array of nodes with their positions
 */ function $be3c84bcbbb2383c$export$6a2a251dde98a23(node, range, predicate) {
    const nodesWithPos = [];
    // if (range.from === range.to) {
    //   const nodeAt = node.nodeAt(range.from)
    //   if (nodeAt) {
    //     nodesWithPos.push({
    //       node: nodeAt,
    //       pos: range.from,
    //     })
    //   }
    // }
    node.nodesBetween(range.from, range.to, (child, pos)=>{
        if (predicate(child)) nodesWithPos.push({
            node: child,
            pos: pos
        });
    });
    return nodesWithPos;
}
/**
 * Finds the closest parent node to a resolved position that matches a predicate.
 * @param $pos The resolved position to search from
 * @param predicate The predicate to match
 * @returns The closest parent node to the resolved position that matches the predicate
 * @example ```js
 * findParentNodeClosestToPos($from, node => node.type.name === 'paragraph')
 * ```
 */ function $be3c84bcbbb2383c$export$fe09644e3bc6166b($pos, predicate) {
    for(let i = $pos.depth; i > 0; i -= 1){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
}
/**
 * Finds the closest parent node to the current selection that matches a predicate.
 * @param predicate The predicate to match
 * @returns A command that finds the closest parent node to the current selection that matches the predicate
 * @example ```js
 * findParentNode(node => node.type.name === 'paragraph')
 * ```
 */ function $be3c84bcbbb2383c$export$dc159056ffdb4c76(predicate) {
    return (selection)=>$be3c84bcbbb2383c$export$fe09644e3bc6166b(selection.$from, predicate);
}
function $be3c84bcbbb2383c$export$19a621270f26273c(extensions, editor) {
    const resolvedExtensions = $be3c84bcbbb2383c$var$ExtensionManager.resolve(extensions);
    return $be3c84bcbbb2383c$export$71bc12a97b59a858(resolvedExtensions, editor);
}
/**
 * Generate HTML from a JSONContent
 * @param doc The JSONContent to generate HTML from
 * @param extensions The extensions to use for the schema
 * @returns The generated HTML
 */ function $be3c84bcbbb2383c$export$4f413073eb19378c(doc, extensions) {
    const schema = $be3c84bcbbb2383c$export$19a621270f26273c(extensions);
    const contentNode = (0, $1krlL.Node).fromJSON(schema, doc);
    return $be3c84bcbbb2383c$export$d1b60002472b2c81(contentNode.content, schema);
}
/**
 * Generate JSONContent from HTML
 * @param html The HTML to generate JSONContent from
 * @param extensions The extensions to use for the schema
 * @returns The generated JSONContent
 */ function $be3c84bcbbb2383c$export$d23738d50f257f47(html, extensions) {
    const schema = $be3c84bcbbb2383c$export$19a621270f26273c(extensions);
    const dom = $be3c84bcbbb2383c$export$1b93bf03550cde01(html);
    return (0, $1krlL.DOMParser).fromSchema(schema).parse(dom).toJSON();
}
/**
 * Gets the text of a Prosemirror node
 * @param node The Prosemirror node
 * @param options Options for the text serializer & block separator
 * @returns The text of the node
 * @example ```js
 * const text = getText(node, { blockSeparator: '\n' })
 * ```
 */ function $be3c84bcbbb2383c$export$c72d34660a162238(node, options) {
    const range = {
        from: 0,
        to: node.content.size
    };
    return $be3c84bcbbb2383c$export$6e5992a7455d9ef6(node, range, options);
}
/**
 * Generate raw text from a JSONContent
 * @param doc The JSONContent to generate text from
 * @param extensions The extensions to use for the schema
 * @param options Options for the text generation f.e. blockSeparator or textSerializers
 * @returns The generated text
 */ function $be3c84bcbbb2383c$export$43625cf01e0b7b62(doc, extensions, options) {
    const { blockSeparator: blockSeparator = '\n\n', textSerializers: textSerializers = {} } = options || {};
    const schema = $be3c84bcbbb2383c$export$19a621270f26273c(extensions);
    const contentNode = (0, $1krlL.Node).fromJSON(schema, doc);
    return $be3c84bcbbb2383c$export$c72d34660a162238(contentNode, {
        blockSeparator: blockSeparator,
        textSerializers: {
            ...$be3c84bcbbb2383c$export$fdd92b7d22ac071c(schema),
            ...textSerializers
        }
    });
}
function $be3c84bcbbb2383c$export$e8c6736926dcac42(state, typeOrName) {
    const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
    const { from: from, to: to } = state.selection;
    const nodes = [];
    state.doc.nodesBetween(from, to, (node)=>{
        nodes.push(node);
    });
    const node = nodes.reverse().find((nodeItem)=>nodeItem.type.name === type.name);
    if (!node) return {};
    return {
        ...node.attrs
    };
}
/**
 * Get node or mark attributes by type or name on the current editor state
 * @param state The current editor state
 * @param typeOrName The node or mark type or name
 * @returns The attributes of the node or mark or an empty object
 */ function $be3c84bcbbb2383c$export$fe94072fee8a6976(state, typeOrName) {
    const schemaType = $be3c84bcbbb2383c$export$e501dfcf737a48e0(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
    if (schemaType === 'node') return $be3c84bcbbb2383c$export$e8c6736926dcac42(state, typeOrName);
    if (schemaType === 'mark') return $be3c84bcbbb2383c$export$2cd1d0e1f861bae0(state, typeOrName);
    return {};
}
/**
 * Removes duplicated values within an array.
 * Supports numbers, strings and objects.
 */ function $be3c84bcbbb2383c$export$2e2262a44ac61957(array, by = JSON.stringify) {
    const seen = {};
    return array.filter((item)=>{
        const key = by(item);
        return Object.prototype.hasOwnProperty.call(seen, key) ? false : seen[key] = true;
    });
}
/**
 * Removes duplicated ranges and ranges that are
 * fully captured by other ranges.
 */ function $be3c84bcbbb2383c$var$simplifyChangedRanges(changes) {
    const uniqueChanges = $be3c84bcbbb2383c$export$2e2262a44ac61957(changes);
    return uniqueChanges.length === 1 ? uniqueChanges : uniqueChanges.filter((change, index)=>{
        const rest = uniqueChanges.filter((_, i)=>i !== index);
        return !rest.some((otherChange)=>{
            return change.oldRange.from >= otherChange.oldRange.from && change.oldRange.to <= otherChange.oldRange.to && change.newRange.from >= otherChange.newRange.from && change.newRange.to <= otherChange.newRange.to;
        });
    });
}
/**
 * Returns a list of changed ranges
 * based on the first and last state of all steps.
 */ function $be3c84bcbbb2383c$export$ba396fc65ff2f439(transform) {
    const { mapping: mapping, steps: steps } = transform;
    const changes = [];
    mapping.maps.forEach((stepMap, index)=>{
        const ranges = [];
        // This accounts for step changes where no range was actually altered
        // e.g. when setting a mark, node attribute, etc.
        // @ts-ignore
        if (!stepMap.ranges.length) {
            const { from: from, to: to } = steps[index];
            if (from === undefined || to === undefined) return;
            ranges.push({
                from: from,
                to: to
            });
        } else stepMap.forEach((from, to)=>{
            ranges.push({
                from: from,
                to: to
            });
        });
        ranges.forEach(({ from: from, to: to })=>{
            const newStart = mapping.slice(index).map(from, -1);
            const newEnd = mapping.slice(index).map(to);
            const oldStart = mapping.invert().map(newStart, -1);
            const oldEnd = mapping.invert().map(newEnd);
            changes.push({
                oldRange: {
                    from: oldStart,
                    to: oldEnd
                },
                newRange: {
                    from: newStart,
                    to: newEnd
                }
            });
        });
    });
    return $be3c84bcbbb2383c$var$simplifyChangedRanges(changes);
}
function $be3c84bcbbb2383c$export$d661e0733145fb37(node, startOffset = 0) {
    const isTopNode = node.type === node.type.schema.topNodeType;
    const increment = isTopNode ? 0 : 1;
    const from = startOffset;
    const to = from + node.nodeSize;
    const marks = node.marks.map((mark)=>{
        const output = {
            type: mark.type.name
        };
        if (Object.keys(mark.attrs).length) output.attrs = {
            ...mark.attrs
        };
        return output;
    });
    const attrs = {
        ...node.attrs
    };
    const output = {
        type: node.type.name,
        from: from,
        to: to
    };
    if (Object.keys(attrs).length) output.attrs = attrs;
    if (marks.length) output.marks = marks;
    if (node.content.childCount) {
        output.content = [];
        node.forEach((child, offset)=>{
            var _a;
            (_a = output.content) === null || _a === void 0 || _a.push($be3c84bcbbb2383c$export$d661e0733145fb37(child, startOffset + offset + increment));
        });
    }
    if (node.text) output.text = node.text;
    return output;
}
function $be3c84bcbbb2383c$export$c5fd7af7c5c1efa(from, to, doc) {
    const marks = [];
    // get all inclusive marks on empty selection
    if (from === to) doc.resolve(from).marks().forEach((mark)=>{
        const $pos = doc.resolve(from);
        const range = $be3c84bcbbb2383c$export$8ceae6d06f5c4df5($pos, mark.type);
        if (!range) return;
        marks.push({
            mark: mark,
            ...range
        });
    });
    else doc.nodesBetween(from, to, (node, pos)=>{
        if (!node || (node === null || node === void 0 ? void 0 : node.nodeSize) === undefined) return;
        marks.push(...node.marks.map((mark)=>({
                from: pos,
                to: pos + node.nodeSize,
                mark: mark
            })));
    });
    return marks;
}
/**
 * Finds the first node of a given type or name in the current selection.
 * @param state The editor state.
 * @param typeOrName The node type or name.
 * @param pos The position to start searching from.
 * @param maxDepth The maximum depth to search.
 * @returns The node and the depth as an array.
 */ const $be3c84bcbbb2383c$export$ee90757e11fae7cd = (state, typeOrName, pos, maxDepth = 20)=>{
    const $pos = state.doc.resolve(pos);
    let currentDepth = maxDepth;
    let node = null;
    while(currentDepth > 0 && node === null){
        const currentNode = $pos.node(currentDepth);
        if ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type.name) === typeOrName) node = currentNode;
        else currentDepth -= 1;
    }
    return [
        node,
        currentDepth
    ];
};
/**
 * Return attributes of an extension that should be splitted by keepOnSplit flag
 * @param extensionAttributes Array of extension attributes
 * @param typeName The type of the extension
 * @param attributes The attributes of the extension
 * @returns The splitted attributes
 */ function $be3c84bcbbb2383c$export$49b565bbca5fba3a(extensionAttributes, typeName, attributes) {
    return Object.fromEntries(Object.entries(attributes).filter(([name])=>{
        const extensionAttribute = extensionAttributes.find((item)=>{
            return item.type === typeName && item.name === name;
        });
        if (!extensionAttribute) return false;
        return extensionAttribute.attribute.keepOnSplit;
    }));
}
function $be3c84bcbbb2383c$export$72001287e2a5b413(state, typeOrName, attributes = {}) {
    const { empty: empty, ranges: ranges } = state.selection;
    const type = typeOrName ? $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema) : null;
    if (empty) return !!(state.storedMarks || state.selection.$from.marks()).filter((mark)=>{
        if (!type) return true;
        return type.name === mark.type.name;
    }).find((mark)=>$be3c84bcbbb2383c$export$7aeb68f71172641d(mark.attrs, attributes, {
            strict: false
        }));
    let selectionRange = 0;
    const markRanges = [];
    ranges.forEach(({ $from: $from, $to: $to })=>{
        const from = $from.pos;
        const to = $to.pos;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (!node.isText && !node.marks.length) return;
            const relativeFrom = Math.max(from, pos);
            const relativeTo = Math.min(to, pos + node.nodeSize);
            const range = relativeTo - relativeFrom;
            selectionRange += range;
            markRanges.push(...node.marks.map((mark)=>({
                    mark: mark,
                    from: relativeFrom,
                    to: relativeTo
                })));
        });
    });
    if (selectionRange === 0) return false;
    // calculate range of matched mark
    const matchedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return type.name === markRange.mark.type.name;
    }).filter((markRange)=>$be3c84bcbbb2383c$export$7aeb68f71172641d(markRange.mark.attrs, attributes, {
            strict: false
        })).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // calculate range of marks that excludes the searched mark
    // for example `code` doesn’t allow any other marks
    const excludedRange = markRanges.filter((markRange)=>{
        if (!type) return true;
        return markRange.mark.type !== type && markRange.mark.type.excludes(type);
    }).reduce((sum, markRange)=>sum + markRange.to - markRange.from, 0);
    // we only include the result of `excludedRange`
    // if there is a match at all
    const range = matchedRange > 0 ? matchedRange + excludedRange : matchedRange;
    return range >= selectionRange;
}
function $be3c84bcbbb2383c$export$39e04e72f972b885(state, name, attributes = {}) {
    if (!name) return $be3c84bcbbb2383c$export$7a24a642b0c7ad29(state, null, attributes) || $be3c84bcbbb2383c$export$72001287e2a5b413(state, null, attributes);
    const schemaType = $be3c84bcbbb2383c$export$e501dfcf737a48e0(name, state.schema);
    if (schemaType === 'node') return $be3c84bcbbb2383c$export$7a24a642b0c7ad29(state, name, attributes);
    if (schemaType === 'mark') return $be3c84bcbbb2383c$export$72001287e2a5b413(state, name, attributes);
    return false;
}
const $be3c84bcbbb2383c$export$6a042f9d56fb39ec = (state, nodeType)=>{
    const { $from: $from, $to: $to, $anchor: $anchor } = state.selection;
    if (nodeType) {
        const parentNode = $be3c84bcbbb2383c$export$dc159056ffdb4c76((node)=>node.type.name === nodeType)(state.selection);
        if (!parentNode) return false;
        const $parentPos = state.doc.resolve(parentNode.pos + 1);
        if ($anchor.pos + 1 === $parentPos.end()) return true;
        return false;
    }
    if ($to.parentOffset < $to.parent.nodeSize - 2 || $from.pos !== $to.pos) return false;
    return true;
};
const $be3c84bcbbb2383c$export$d0aa6c7595396956 = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ($from.parentOffset > 0 || $from.pos !== $to.pos) return false;
    return true;
};
function $be3c84bcbbb2383c$export$ead95ff48ba53ffd(name, extensions) {
    const { nodeExtensions: nodeExtensions } = $be3c84bcbbb2383c$export$36e8c2990da8266f(extensions);
    const extension = nodeExtensions.find((item)=>item.name === name);
    if (!extension) return false;
    const context = {
        name: extension.name,
        options: extension.options,
        storage: extension.storage
    };
    const group = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'group', context));
    if (typeof group !== 'string') return false;
    return group.split(' ').includes('list');
}
/**
 * Returns true if the given prosemirror node is empty.
 */ function $be3c84bcbbb2383c$export$cd58ff1081f6abe9(node, { checkChildren: checkChildren = true, ignoreWhitespace: ignoreWhitespace = false } = {}) {
    var _a;
    if (ignoreWhitespace) {
        if (node.type.name === 'hardBreak') // Hard breaks are considered empty
        return true;
        if (node.isText) return /^\s*$/m.test((_a = node.text) !== null && _a !== void 0 ? _a : '');
    }
    if (node.isText) return !node.text;
    if (node.isAtom || node.isLeaf) return false;
    if (node.content.childCount === 0) return true;
    if (checkChildren) {
        let isContentEmpty = true;
        node.content.forEach((childNode)=>{
            if (isContentEmpty === false) // Exit early for perf
            return;
            if (!$be3c84bcbbb2383c$export$cd58ff1081f6abe9(childNode, {
                ignoreWhitespace: ignoreWhitespace,
                checkChildren: checkChildren
            })) isContentEmpty = false;
        });
        return isContentEmpty;
    }
    return false;
}
function $be3c84bcbbb2383c$export$a8c1d2c13abf8822(value) {
    return value instanceof (0, $1LeRC.NodeSelection);
}
function $be3c84bcbbb2383c$export$660ecae6cde71645(view, from, to) {
    const minPos = 0;
    const maxPos = view.state.doc.content.size;
    const resolvedFrom = $be3c84bcbbb2383c$export$6fb785c609d82593(from, minPos, maxPos);
    const resolvedEnd = $be3c84bcbbb2383c$export$6fb785c609d82593(to, minPos, maxPos);
    const start = view.coordsAtPos(resolvedFrom);
    const end = view.coordsAtPos(resolvedEnd, -1);
    const top = Math.min(start.top, end.top);
    const bottom = Math.max(start.bottom, end.bottom);
    const left = Math.min(start.left, end.left);
    const right = Math.max(start.right, end.right);
    const width = right - left;
    const height = bottom - top;
    const x = left;
    const y = top;
    const data = {
        top: top,
        bottom: bottom,
        left: left,
        right: right,
        width: width,
        height: height,
        x: x,
        y: y
    };
    return {
        ...data,
        toJSON: ()=>data
    };
}
/**
 * The actual implementation of the rewriteUnknownContent function
 */ function $be3c84bcbbb2383c$var$rewriteUnknownContentInner({ json: json, validMarks: validMarks, validNodes: validNodes, options: options, rewrittenContent: rewrittenContent = [] }) {
    if (json.marks && Array.isArray(json.marks)) json.marks = json.marks.filter((mark)=>{
        const name = typeof mark === 'string' ? mark : mark.type;
        if (validMarks.has(name)) return true;
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(mark)),
            unsupported: name
        });
        // Just ignore any unknown marks
        return false;
    });
    if (json.content && Array.isArray(json.content)) json.content = json.content.map((value)=>$be3c84bcbbb2383c$var$rewriteUnknownContentInner({
            json: value,
            validMarks: validMarks,
            validNodes: validNodes,
            options: options,
            rewrittenContent: rewrittenContent
        }).json).filter((a)=>a !== null && a !== undefined);
    if (json.type && !validNodes.has(json.type)) {
        rewrittenContent.push({
            original: JSON.parse(JSON.stringify(json)),
            unsupported: json.type
        });
        if (json.content && Array.isArray(json.content) && (options === null || options === void 0 ? void 0 : options.fallbackToParagraph) !== false) {
            // Just treat it like a paragraph and hope for the best
            json.type = 'paragraph';
            return {
                json: json,
                rewrittenContent: rewrittenContent
            };
        }
        // or just omit it entirely
        return {
            json: null,
            rewrittenContent: rewrittenContent
        };
    }
    return {
        json: json,
        rewrittenContent: rewrittenContent
    };
}
/**
 * Rewrite unknown nodes and marks within JSON content
 * Allowing for user within the editor
 */ function $be3c84bcbbb2383c$export$e29d20b0f4dc64ed(/**
 * The JSON content to clean of unknown nodes and marks
 */ json, /**
 * The schema to use for validation
 */ schema, /**
 * Options for the cleaning process
 */ options) {
    return $be3c84bcbbb2383c$var$rewriteUnknownContentInner({
        json: json,
        validNodes: new Set(Object.keys(schema.nodes)),
        validMarks: new Set(Object.keys(schema.marks)),
        options: options
    });
}
function $be3c84bcbbb2383c$var$canSetMark(state, tr, newMarkType) {
    var _a;
    const { selection: selection } = tr;
    let cursor = null;
    if ($be3c84bcbbb2383c$export$38b50bf35e79aaf3(selection)) cursor = selection.$cursor;
    if (cursor) {
        const currentMarks = (_a = state.storedMarks) !== null && _a !== void 0 ? _a : cursor.marks();
        // There can be no current marks that exclude the new mark
        return !!newMarkType.isInSet(currentMarks) || !currentMarks.some((mark)=>mark.type.excludes(newMarkType));
    }
    const { ranges: ranges } = selection;
    return ranges.some(({ $from: $from, $to: $to })=>{
        let someNodeSupportsMark = $from.depth === 0 ? state.doc.inlineContent && state.doc.type.allowsMarkType(newMarkType) : false;
        state.doc.nodesBetween($from.pos, $to.pos, (node, _pos, parent)=>{
            // If we already found a mark that we can enable, return false to bypass the remaining search
            if (someNodeSupportsMark) return false;
            if (node.isInline) {
                const parentAllowsMarkType = !parent || parent.type.allowsMarkType(newMarkType);
                const currentMarksAllowMarkType = !!newMarkType.isInSet(node.marks) || !node.marks.some((otherMark)=>otherMark.type.excludes(newMarkType));
                someNodeSupportsMark = parentAllowsMarkType && currentMarksAllowMarkType;
            }
            return !someNodeSupportsMark;
        });
        return someNodeSupportsMark;
    });
}
const $be3c84bcbbb2383c$var$setMark = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        const type = $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) {
            if (empty) {
                const oldAttributes = $be3c84bcbbb2383c$export$2cd1d0e1f861bae0(state, type);
                tr.addStoredMark(type.create({
                    ...oldAttributes,
                    ...attributes
                }));
            } else ranges.forEach((range)=>{
                const from = range.$from.pos;
                const to = range.$to.pos;
                state.doc.nodesBetween(from, to, (node, pos)=>{
                    const trimmedFrom = Math.max(pos, from);
                    const trimmedTo = Math.min(pos + node.nodeSize, to);
                    const someHasMark = node.marks.find((mark)=>mark.type === type);
                    // if there is already a mark of this type
                    // we know that we have to merge its attributes
                    // otherwise we add a fresh new mark
                    if (someHasMark) node.marks.forEach((mark)=>{
                        if (type === mark.type) tr.addMark(trimmedFrom, trimmedTo, type.create({
                            ...mark.attrs,
                            ...attributes
                        }));
                    });
                    else tr.addMark(trimmedFrom, trimmedTo, type.create(attributes));
                });
            });
        }
        return $be3c84bcbbb2383c$var$canSetMark(state, tr, type);
    };
const $be3c84bcbbb2383c$var$setMeta = (key, value)=>({ tr: tr })=>{
        tr.setMeta(key, value);
        return true;
    };
const $be3c84bcbbb2383c$var$setNode = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch, chain: chain })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        let attributesToCopy;
        if (state.selection.$anchor.sameParent(state.selection.$head)) // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
        // TODO: use a fallback like insertContent?
        if (!type.isTextblock) {
            console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.');
            return false;
        }
        return chain()// try to convert node to default node if needed
        .command(({ commands: commands })=>{
            const canSetBlock = (0, $9D0ij.setBlockType)(type, {
                ...attributesToCopy,
                ...attributes
            })(state);
            if (canSetBlock) return true;
            return commands.clearNodes();
        }).command(({ state: updatedState })=>{
            return (0, $9D0ij.setBlockType)(type, {
                ...attributesToCopy,
                ...attributes
            })(updatedState, dispatch);
        }).run();
    };
const $be3c84bcbbb2383c$var$setNodeSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const from = $be3c84bcbbb2383c$export$6fb785c609d82593(position, 0, doc.content.size);
            const selection = (0, $1LeRC.NodeSelection).create(doc, from);
            tr.setSelection(selection);
        }
        return true;
    };
const $be3c84bcbbb2383c$var$setTextSelection = (position)=>({ tr: tr, dispatch: dispatch })=>{
        if (dispatch) {
            const { doc: doc } = tr;
            const { from: from, to: to } = typeof position === 'number' ? {
                from: position,
                to: position
            } : position;
            const minPos = (0, $1LeRC.TextSelection).atStart(doc).from;
            const maxPos = (0, $1LeRC.TextSelection).atEnd(doc).to;
            const resolvedFrom = $be3c84bcbbb2383c$export$6fb785c609d82593(from, minPos, maxPos);
            const resolvedEnd = $be3c84bcbbb2383c$export$6fb785c609d82593(to, minPos, maxPos);
            const selection = (0, $1LeRC.TextSelection).create(doc, resolvedFrom, resolvedEnd);
            tr.setSelection(selection);
        }
        return true;
    };
const $be3c84bcbbb2383c$var$sinkListItem = (typeOrName)=>({ state: state, dispatch: dispatch })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $ie1jF.sinkListItem)(type)(state, dispatch);
    };
function $be3c84bcbbb2383c$var$ensureMarks(state, splittableMarks) {
    const marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
    if (marks) {
        const filteredMarks = marks.filter((mark)=>splittableMarks === null || splittableMarks === void 0 ? void 0 : splittableMarks.includes(mark.type.name));
        state.tr.ensureMarks(filteredMarks);
    }
}
const $be3c84bcbbb2383c$var$splitBlock = ({ keepMarks: keepMarks = true } = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        const { selection: selection, doc: doc } = tr;
        const { $from: $from, $to: $to } = selection;
        const extensionAttributes = editor.extensionManager.attributes;
        const newAttributes = $be3c84bcbbb2383c$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs);
        if (selection instanceof (0, $1LeRC.NodeSelection) && selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $gfgdn.canSplit)(doc, $from.pos)) return false;
            if (dispatch) {
                if (keepMarks) $be3c84bcbbb2383c$var$ensureMarks(state, editor.extensionManager.splittableMarks);
                tr.split($from.pos).scrollIntoView();
            }
            return true;
        }
        if (!$from.parent.isBlock) return false;
        const atEnd = $to.parentOffset === $to.parent.content.size;
        const deflt = $from.depth === 0 ? undefined : $be3c84bcbbb2383c$export$6133a2de0e8ac885($from.node(-1).contentMatchAt($from.indexAfter(-1)));
        let types = atEnd && deflt ? [
            {
                type: deflt,
                attrs: newAttributes
            }
        ] : undefined;
        let can = (0, $gfgdn.canSplit)(tr.doc, tr.mapping.map($from.pos), 1, types);
        if (!types && !can && (0, $gfgdn.canSplit)(tr.doc, tr.mapping.map($from.pos), 1, deflt ? [
            {
                type: deflt
            }
        ] : undefined)) {
            can = true;
            types = deflt ? [
                {
                    type: deflt,
                    attrs: newAttributes
                }
            ] : undefined;
        }
        if (dispatch) {
            if (can) {
                if (selection instanceof (0, $1LeRC.TextSelection)) tr.deleteSelection();
                tr.split(tr.mapping.map($from.pos), 1, types);
                if (deflt && !atEnd && !$from.parentOffset && $from.parent.type !== deflt) {
                    const first = tr.mapping.map($from.before());
                    const $first = tr.doc.resolve(first);
                    if ($from.node(-1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before()), deflt);
                }
            }
            if (keepMarks) $be3c84bcbbb2383c$var$ensureMarks(state, editor.extensionManager.splittableMarks);
            tr.scrollIntoView();
        }
        return can;
    };
const $be3c84bcbbb2383c$var$splitListItem = (typeOrName, overrideAttrs = {})=>({ tr: tr, state: state, dispatch: dispatch, editor: editor })=>{
        var _a;
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        const { $from: $from, $to: $to } = state.selection;
        // @ts-ignore
        // eslint-disable-next-line
        const node = state.selection.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        const grandParent = $from.node(-1);
        if (grandParent.type !== type) return false;
        const extensionAttributes = editor.extensionManager.attributes;
        if ($from.parent.content.size === 0 && $from.node(-1).childCount === $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== type || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $1krlL.Fragment).empty;
                // eslint-disable-next-line
                const depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d -= 1)wrap = (0, $1krlL.Fragment).from($from.node(d).copy(wrap));
                // eslint-disable-next-line
                const depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                const newNextTypeAttributes = {
                    ...$be3c84bcbbb2383c$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
                    ...overrideAttrs
                };
                const nextType = ((_a = type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.createAndFill(newNextTypeAttributes)) || undefined;
                wrap = wrap.append((0, $1krlL.Fragment).from(type.createAndFill(null, nextType) || undefined));
                const start = $from.before($from.depth - (depthBefore - 1));
                tr.replace(start, $from.after(-depthAfter), new (0, $1krlL.Slice)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (n, pos)=>{
                    if (sel > -1) return false;
                    if (n.isTextblock && n.content.size === 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $1LeRC.TextSelection).near(tr.doc.resolve(sel)));
                tr.scrollIntoView();
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        const newTypeAttributes = {
            ...$be3c84bcbbb2383c$export$49b565bbca5fba3a(extensionAttributes, grandParent.type.name, grandParent.attrs),
            ...overrideAttrs
        };
        const newNextTypeAttributes = {
            ...$be3c84bcbbb2383c$export$49b565bbca5fba3a(extensionAttributes, $from.node().type.name, $from.node().attrs),
            ...overrideAttrs
        };
        tr.delete($from.pos, $to.pos);
        const types = nextType ? [
            {
                type: type,
                attrs: newTypeAttributes
            },
            {
                type: nextType,
                attrs: newNextTypeAttributes
            }
        ] : [
            {
                type: type,
                attrs: newTypeAttributes
            }
        ];
        if (!(0, $gfgdn.canSplit)(tr.doc, $from.pos, 2)) return false;
        if (dispatch) {
            const { selection: selection, storedMarks: storedMarks } = state;
            const { splittableMarks: splittableMarks } = editor.extensionManager;
            const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
            tr.split($from.pos, 2, types).scrollIntoView();
            if (!marks || !dispatch) return true;
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
        }
        return true;
    };
const $be3c84bcbbb2383c$var$joinListBackwards = (tr, listType)=>{
    const list = $be3c84bcbbb2383c$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const before = tr.doc.resolve(Math.max(0, list.pos - 1)).before(list.depth);
    if (before === undefined) return true;
    const nodeBefore = tr.doc.nodeAt(before);
    const canJoinBackwards = list.node.type === (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.type) && (0, $gfgdn.canJoin)(tr.doc, list.pos);
    if (!canJoinBackwards) return true;
    tr.join(list.pos);
    return true;
};
const $be3c84bcbbb2383c$var$joinListForwards = (tr, listType)=>{
    const list = $be3c84bcbbb2383c$export$dc159056ffdb4c76((node)=>node.type === listType)(tr.selection);
    if (!list) return true;
    const after = tr.doc.resolve(list.start).after(list.depth);
    if (after === undefined) return true;
    const nodeAfter = tr.doc.nodeAt(after);
    const canJoinForwards = list.node.type === (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.type) && (0, $gfgdn.canJoin)(tr.doc, after);
    if (!canJoinForwards) return true;
    tr.join(after);
    return true;
};
const $be3c84bcbbb2383c$var$toggleList = (listTypeOrName, itemTypeOrName, keepMarks, attributes = {})=>({ editor: editor, tr: tr, state: state, dispatch: dispatch, chain: chain, commands: commands, can: can })=>{
        const { extensions: extensions, splittableMarks: splittableMarks } = editor.extensionManager;
        const listType = $be3c84bcbbb2383c$export$d168cba70360dd3d(listTypeOrName, state.schema);
        const itemType = $be3c84bcbbb2383c$export$d168cba70360dd3d(itemTypeOrName, state.schema);
        const { selection: selection, storedMarks: storedMarks } = state;
        const { $from: $from, $to: $to } = selection;
        const range = $from.blockRange($to);
        const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
        if (!range) return false;
        const parentList = $be3c84bcbbb2383c$export$dc159056ffdb4c76((node)=>$be3c84bcbbb2383c$export$ead95ff48ba53ffd(node.type.name, extensions))(selection);
        if (range.depth >= 1 && parentList && range.depth - parentList.depth <= 1) {
            // remove list
            if (parentList.node.type === listType) return commands.liftListItem(itemType);
            // change list type
            if ($be3c84bcbbb2383c$export$ead95ff48ba53ffd(parentList.node.type.name, extensions) && listType.validContent(parentList.node.content) && dispatch) return chain().command(()=>{
                tr.setNodeMarkup(parentList.pos, listType);
                return true;
            }).command(()=>$be3c84bcbbb2383c$var$joinListBackwards(tr, listType)).command(()=>$be3c84bcbbb2383c$var$joinListForwards(tr, listType)).run();
        }
        if (!keepMarks || !marks || !dispatch) return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$be3c84bcbbb2383c$var$joinListBackwards(tr, listType)).command(()=>$be3c84bcbbb2383c$var$joinListForwards(tr, listType)).run();
        return chain()// try to convert node to default node if needed
        .command(()=>{
            const canWrapInList = can().wrapInList(listType, attributes);
            const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
            tr.ensureMarks(filteredMarks);
            if (canWrapInList) return true;
            return commands.clearNodes();
        }).wrapInList(listType, attributes).command(()=>$be3c84bcbbb2383c$var$joinListBackwards(tr, listType)).command(()=>$be3c84bcbbb2383c$var$joinListForwards(tr, listType)).run();
    };
const $be3c84bcbbb2383c$var$toggleMark = (typeOrName, attributes = {}, options = {})=>({ state: state, commands: commands })=>{
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const type = $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const isActive = $be3c84bcbbb2383c$export$72001287e2a5b413(state, type, attributes);
        if (isActive) return commands.unsetMark(type, {
            extendEmptyMarkRange: extendEmptyMarkRange
        });
        return commands.setMark(type, attributes);
    };
const $be3c84bcbbb2383c$var$toggleNode = (typeOrName, toggleTypeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        const toggleType = $be3c84bcbbb2383c$export$d168cba70360dd3d(toggleTypeOrName, state.schema);
        const isActive = $be3c84bcbbb2383c$export$7a24a642b0c7ad29(state, type, attributes);
        let attributesToCopy;
        if (state.selection.$anchor.sameParent(state.selection.$head)) // only copy attributes if the selection is pointing to a node of the same type
        attributesToCopy = state.selection.$anchor.parent.attrs;
        if (isActive) return commands.setNode(toggleType, attributesToCopy);
        // If the node is not active, we want to set the new node type with the given attributes
        // Copying over the attributes from the current node if the selection is pointing to a node of the same type
        return commands.setNode(type, {
            ...attributesToCopy,
            ...attributes
        });
    };
const $be3c84bcbbb2383c$var$toggleWrap = (typeOrName, attributes = {})=>({ state: state, commands: commands })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        const isActive = $be3c84bcbbb2383c$export$7a24a642b0c7ad29(state, type, attributes);
        if (isActive) return commands.lift(type);
        return commands.wrapIn(type, attributes);
    };
const $be3c84bcbbb2383c$var$undoInputRule = ()=>({ state: state, dispatch: dispatch })=>{
        const plugins = state.plugins;
        for(let i = 0; i < plugins.length; i += 1){
            const plugin = plugins[i];
            let undoable;
            // @ts-ignore
            // eslint-disable-next-line
            if (plugin.spec.isInputRules && (undoable = plugin.getState(state))) {
                if (dispatch) {
                    const tr = state.tr;
                    const toUndo = undoable.transform;
                    for(let j = toUndo.steps.length - 1; j >= 0; j -= 1)tr.step(toUndo.steps[j].invert(toUndo.docs[j]));
                    if (undoable.text) {
                        const marks = tr.doc.resolve(undoable.from).marks();
                        tr.replaceWith(undoable.from, undoable.to, state.schema.text(undoable.text, marks));
                    } else tr.delete(undoable.from, undoable.to);
                }
                return true;
            }
        }
        return false;
    };
const $be3c84bcbbb2383c$var$unsetAllMarks = ()=>({ tr: tr, dispatch: dispatch })=>{
        const { selection: selection } = tr;
        const { empty: empty, ranges: ranges } = selection;
        if (empty) return true;
        if (dispatch) ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos);
        });
        return true;
    };
const $be3c84bcbbb2383c$var$unsetMark = (typeOrName, options = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        var _a;
        const { extendEmptyMarkRange: extendEmptyMarkRange = false } = options;
        const { selection: selection } = tr;
        const type = $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        const { $from: $from, empty: empty, ranges: ranges } = selection;
        if (!dispatch) return true;
        if (empty && extendEmptyMarkRange) {
            let { from: from, to: to } = selection;
            const attrs = (_a = $from.marks().find((mark)=>mark.type === type)) === null || _a === void 0 ? void 0 : _a.attrs;
            const range = $be3c84bcbbb2383c$export$8ceae6d06f5c4df5($from, type, attrs);
            if (range) {
                from = range.from;
                to = range.to;
            }
            tr.removeMark(from, to, type);
        } else ranges.forEach((range)=>{
            tr.removeMark(range.$from.pos, range.$to.pos, type);
        });
        tr.removeStoredMark(type);
        return true;
    };
const $be3c84bcbbb2383c$var$updateAttributes = (typeOrName, attributes = {})=>({ tr: tr, state: state, dispatch: dispatch })=>{
        let nodeType = null;
        let markType = null;
        const schemaType = $be3c84bcbbb2383c$export$e501dfcf737a48e0(typeof typeOrName === 'string' ? typeOrName : typeOrName.name, state.schema);
        if (!schemaType) return false;
        if (schemaType === 'node') nodeType = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        if (schemaType === 'mark') markType = $be3c84bcbbb2383c$export$b1269d6bf6e491ec(typeOrName, state.schema);
        if (dispatch) tr.selection.ranges.forEach((range)=>{
            const from = range.$from.pos;
            const to = range.$to.pos;
            let lastPos;
            let lastNode;
            let trimmedFrom;
            let trimmedTo;
            if (tr.selection.empty) state.doc.nodesBetween(from, to, (node, pos)=>{
                if (nodeType && nodeType === node.type) {
                    trimmedFrom = Math.max(pos, from);
                    trimmedTo = Math.min(pos + node.nodeSize, to);
                    lastPos = pos;
                    lastNode = node;
                }
            });
            else state.doc.nodesBetween(from, to, (node, pos)=>{
                if (pos < from && nodeType && nodeType === node.type) {
                    trimmedFrom = Math.max(pos, from);
                    trimmedTo = Math.min(pos + node.nodeSize, to);
                    lastPos = pos;
                    lastNode = node;
                }
                if (pos >= from && pos <= to) {
                    if (nodeType && nodeType === node.type) tr.setNodeMarkup(pos, undefined, {
                        ...node.attrs,
                        ...attributes
                    });
                    if (markType && node.marks.length) node.marks.forEach((mark)=>{
                        if (markType === mark.type) {
                            const trimmedFrom2 = Math.max(pos, from);
                            const trimmedTo2 = Math.min(pos + node.nodeSize, to);
                            tr.addMark(trimmedFrom2, trimmedTo2, markType.create({
                                ...mark.attrs,
                                ...attributes
                            }));
                        }
                    });
                }
            });
            if (lastNode) {
                if (lastPos !== undefined) tr.setNodeMarkup(lastPos, undefined, {
                    ...lastNode.attrs,
                    ...attributes
                });
                if (markType && lastNode.marks.length) lastNode.marks.forEach((mark)=>{
                    if (markType === mark.type) tr.addMark(trimmedFrom, trimmedTo, markType.create({
                        ...mark.attrs,
                        ...attributes
                    }));
                });
            }
        });
        return true;
    };
const $be3c84bcbbb2383c$var$wrapIn = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $9D0ij.wrapIn)(type, attributes)(state, dispatch);
    };
const $be3c84bcbbb2383c$var$wrapInList = (typeOrName, attributes = {})=>({ state: state, dispatch: dispatch })=>{
        const type = $be3c84bcbbb2383c$export$d168cba70360dd3d(typeOrName, state.schema);
        return (0, $ie1jF.wrapInList)(type, attributes)(state, dispatch);
    };
var $be3c84bcbbb2383c$var$commands = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    blur: $be3c84bcbbb2383c$var$blur,
    clearContent: $be3c84bcbbb2383c$var$clearContent,
    clearNodes: $be3c84bcbbb2383c$var$clearNodes,
    command: $be3c84bcbbb2383c$var$command,
    createParagraphNear: $be3c84bcbbb2383c$var$createParagraphNear,
    cut: $be3c84bcbbb2383c$var$cut,
    deleteCurrentNode: $be3c84bcbbb2383c$var$deleteCurrentNode,
    deleteNode: $be3c84bcbbb2383c$var$deleteNode,
    deleteRange: $be3c84bcbbb2383c$var$deleteRange,
    deleteSelection: $be3c84bcbbb2383c$var$deleteSelection,
    enter: $be3c84bcbbb2383c$var$enter,
    exitCode: $be3c84bcbbb2383c$var$exitCode,
    extendMarkRange: $be3c84bcbbb2383c$var$extendMarkRange,
    first: $be3c84bcbbb2383c$var$first,
    focus: $be3c84bcbbb2383c$var$focus,
    forEach: $be3c84bcbbb2383c$var$forEach,
    insertContent: $be3c84bcbbb2383c$var$insertContent,
    insertContentAt: $be3c84bcbbb2383c$var$insertContentAt,
    joinBackward: $be3c84bcbbb2383c$var$joinBackward,
    joinDown: $be3c84bcbbb2383c$var$joinDown,
    joinForward: $be3c84bcbbb2383c$var$joinForward,
    joinItemBackward: $be3c84bcbbb2383c$var$joinItemBackward,
    joinItemForward: $be3c84bcbbb2383c$var$joinItemForward,
    joinTextblockBackward: $be3c84bcbbb2383c$var$joinTextblockBackward,
    joinTextblockForward: $be3c84bcbbb2383c$var$joinTextblockForward,
    joinUp: $be3c84bcbbb2383c$var$joinUp,
    keyboardShortcut: $be3c84bcbbb2383c$var$keyboardShortcut,
    lift: $be3c84bcbbb2383c$var$lift,
    liftEmptyBlock: $be3c84bcbbb2383c$var$liftEmptyBlock,
    liftListItem: $be3c84bcbbb2383c$var$liftListItem,
    newlineInCode: $be3c84bcbbb2383c$var$newlineInCode,
    resetAttributes: $be3c84bcbbb2383c$var$resetAttributes,
    scrollIntoView: $be3c84bcbbb2383c$var$scrollIntoView,
    selectAll: $be3c84bcbbb2383c$var$selectAll,
    selectNodeBackward: $be3c84bcbbb2383c$var$selectNodeBackward,
    selectNodeForward: $be3c84bcbbb2383c$var$selectNodeForward,
    selectParentNode: $be3c84bcbbb2383c$var$selectParentNode,
    selectTextblockEnd: $be3c84bcbbb2383c$var$selectTextblockEnd,
    selectTextblockStart: $be3c84bcbbb2383c$var$selectTextblockStart,
    setContent: $be3c84bcbbb2383c$var$setContent,
    setMark: $be3c84bcbbb2383c$var$setMark,
    setMeta: $be3c84bcbbb2383c$var$setMeta,
    setNode: $be3c84bcbbb2383c$var$setNode,
    setNodeSelection: $be3c84bcbbb2383c$var$setNodeSelection,
    setTextSelection: $be3c84bcbbb2383c$var$setTextSelection,
    sinkListItem: $be3c84bcbbb2383c$var$sinkListItem,
    splitBlock: $be3c84bcbbb2383c$var$splitBlock,
    splitListItem: $be3c84bcbbb2383c$var$splitListItem,
    toggleList: $be3c84bcbbb2383c$var$toggleList,
    toggleMark: $be3c84bcbbb2383c$var$toggleMark,
    toggleNode: $be3c84bcbbb2383c$var$toggleNode,
    toggleWrap: $be3c84bcbbb2383c$var$toggleWrap,
    undoInputRule: $be3c84bcbbb2383c$var$undoInputRule,
    unsetAllMarks: $be3c84bcbbb2383c$var$unsetAllMarks,
    unsetMark: $be3c84bcbbb2383c$var$unsetMark,
    updateAttributes: $be3c84bcbbb2383c$var$updateAttributes,
    wrapIn: $be3c84bcbbb2383c$var$wrapIn,
    wrapInList: $be3c84bcbbb2383c$var$wrapInList
});
const $be3c84bcbbb2383c$var$Commands = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'commands',
    addCommands () {
        return {
            ...$be3c84bcbbb2383c$var$commands
        };
    }
});
const $be3c84bcbbb2383c$var$Drop = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'drop',
    addProseMirrorPlugins () {
        return [
            new (0, $1LeRC.Plugin)({
                key: new (0, $1LeRC.PluginKey)('tiptapDrop'),
                props: {
                    handleDrop: (_, e, slice, moved)=>{
                        this.editor.emit('drop', {
                            editor: this.editor,
                            event: e,
                            slice: slice,
                            moved: moved
                        });
                    }
                }
            })
        ];
    }
});
const $be3c84bcbbb2383c$var$Editable = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'editable',
    addProseMirrorPlugins () {
        return [
            new (0, $1LeRC.Plugin)({
                key: new (0, $1LeRC.PluginKey)('editable'),
                props: {
                    editable: ()=>this.editor.options.editable
                }
            })
        ];
    }
});
const $be3c84bcbbb2383c$var$focusEventsPluginKey = new (0, $1LeRC.PluginKey)('focusEvents');
const $be3c84bcbbb2383c$var$FocusEvents = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'focusEvents',
    addProseMirrorPlugins () {
        const { editor: editor } = this;
        return [
            new (0, $1LeRC.Plugin)({
                key: $be3c84bcbbb2383c$var$focusEventsPluginKey,
                props: {
                    handleDOMEvents: {
                        focus: (view, event)=>{
                            editor.isFocused = true;
                            const transaction = editor.state.tr.setMeta('focus', {
                                event: event
                            }).setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        },
                        blur: (view, event)=>{
                            editor.isFocused = false;
                            const transaction = editor.state.tr.setMeta('blur', {
                                event: event
                            }).setMeta('addToHistory', false);
                            view.dispatch(transaction);
                            return false;
                        }
                    }
                }
            })
        ];
    }
});
const $be3c84bcbbb2383c$var$Keymap = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'keymap',
    addKeyboardShortcuts () {
        const handleBackspace = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.undoInputRule(),
                    // maybe convert first text block node to default node
                    ()=>commands.command(({ tr: tr })=>{
                            const { selection: selection, doc: doc } = tr;
                            const { empty: empty, $anchor: $anchor } = selection;
                            const { pos: pos, parent: parent } = $anchor;
                            const $parentPos = $anchor.parent.isTextblock && pos > 0 ? tr.doc.resolve(pos - 1) : $anchor;
                            const parentIsIsolating = $parentPos.parent.type.spec.isolating;
                            const parentPos = $anchor.pos - $anchor.parentOffset;
                            const isAtStart = parentIsIsolating && $parentPos.parent.childCount === 1 ? parentPos === $anchor.pos : (0, $1LeRC.Selection).atStart(doc).from === pos;
                            if (!empty || !parent.type.isTextblock || parent.textContent.length || !isAtStart || isAtStart && $anchor.parent.type.name === 'paragraph' // prevent clearNodes when no nodes to clear, otherwise history stack is appended
                            ) return false;
                            return commands.clearNodes();
                        }),
                    ()=>commands.deleteSelection(),
                    ()=>commands.joinBackward(),
                    ()=>commands.selectNodeBackward()
                ]);
        const handleDelete = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.deleteSelection(),
                    ()=>commands.deleteCurrentNode(),
                    ()=>commands.joinForward(),
                    ()=>commands.selectNodeForward()
                ]);
        const handleEnter = ()=>this.editor.commands.first(({ commands: commands })=>[
                    ()=>commands.newlineInCode(),
                    ()=>commands.createParagraphNear(),
                    ()=>commands.liftEmptyBlock(),
                    ()=>commands.splitBlock()
                ]);
        const baseKeymap = {
            Enter: handleEnter,
            'Mod-Enter': ()=>this.editor.commands.exitCode(),
            Backspace: handleBackspace,
            'Mod-Backspace': handleBackspace,
            'Shift-Backspace': handleBackspace,
            Delete: handleDelete,
            'Mod-Delete': handleDelete,
            'Mod-a': ()=>this.editor.commands.selectAll()
        };
        const pcKeymap = {
            ...baseKeymap
        };
        const macKeymap = {
            ...baseKeymap,
            'Ctrl-h': handleBackspace,
            'Alt-Backspace': handleBackspace,
            'Ctrl-d': handleDelete,
            'Ctrl-Alt-Backspace': handleDelete,
            'Alt-Delete': handleDelete,
            'Alt-d': handleDelete,
            'Ctrl-a': ()=>this.editor.commands.selectTextblockStart(),
            'Ctrl-e': ()=>this.editor.commands.selectTextblockEnd()
        };
        if ($be3c84bcbbb2383c$export$86c1a3f9ab33da5c() || $be3c84bcbbb2383c$export$6159e43e50a41987()) return macKeymap;
        return pcKeymap;
    },
    addProseMirrorPlugins () {
        return [
            // With this plugin we check if the whole document was selected and deleted.
            // In this case we will additionally call `clearNodes()` to convert e.g. a heading
            // to a paragraph if necessary.
            // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
            // with many other commands.
            new (0, $1LeRC.Plugin)({
                key: new (0, $1LeRC.PluginKey)('clearDocument'),
                appendTransaction: (transactions, oldState, newState)=>{
                    if (transactions.some((tr)=>tr.getMeta('composition'))) return;
                    const docChanges = transactions.some((transaction)=>transaction.docChanged) && !oldState.doc.eq(newState.doc);
                    const ignoreTr = transactions.some((transaction)=>transaction.getMeta('preventClearDocument'));
                    if (!docChanges || ignoreTr) return;
                    const { empty: empty, from: from, to: to } = oldState.selection;
                    const allFrom = (0, $1LeRC.Selection).atStart(oldState.doc).from;
                    const allEnd = (0, $1LeRC.Selection).atEnd(oldState.doc).to;
                    const allWasSelected = from === allFrom && to === allEnd;
                    if (empty || !allWasSelected) return;
                    const isEmpty = $be3c84bcbbb2383c$export$cd58ff1081f6abe9(newState.doc);
                    if (!isEmpty) return;
                    const tr = newState.tr;
                    const state = $be3c84bcbbb2383c$export$83e24c5933427696({
                        state: newState,
                        transaction: tr
                    });
                    const { commands: commands } = new $be3c84bcbbb2383c$export$475014de15a4c342({
                        editor: this.editor,
                        state: state
                    });
                    commands.clearNodes();
                    if (!tr.steps.length) return;
                    return tr;
                }
            })
        ];
    }
});
const $be3c84bcbbb2383c$var$Paste = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'paste',
    addProseMirrorPlugins () {
        return [
            new (0, $1LeRC.Plugin)({
                key: new (0, $1LeRC.PluginKey)('tiptapPaste'),
                props: {
                    handlePaste: (_view, e, slice)=>{
                        this.editor.emit('paste', {
                            editor: this.editor,
                            event: e,
                            slice: slice
                        });
                    }
                }
            })
        ];
    }
});
const $be3c84bcbbb2383c$var$Tabindex = $be3c84bcbbb2383c$export$eeddbf09bb970356.create({
    name: 'tabindex',
    addProseMirrorPlugins () {
        return [
            new (0, $1LeRC.Plugin)({
                key: new (0, $1LeRC.PluginKey)('tabindex'),
                props: {
                    attributes: ()=>this.editor.isEditable ? {
                            tabindex: '0'
                        } : {}
                }
            })
        ];
    }
});
var $be3c84bcbbb2383c$export$cc3e2d3244e01b7f = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ClipboardTextSerializer: $be3c84bcbbb2383c$var$ClipboardTextSerializer,
    Commands: $be3c84bcbbb2383c$var$Commands,
    Drop: $be3c84bcbbb2383c$var$Drop,
    Editable: $be3c84bcbbb2383c$var$Editable,
    FocusEvents: $be3c84bcbbb2383c$var$FocusEvents,
    Keymap: $be3c84bcbbb2383c$var$Keymap,
    Paste: $be3c84bcbbb2383c$var$Paste,
    Tabindex: $be3c84bcbbb2383c$var$Tabindex,
    focusEventsPluginKey: $be3c84bcbbb2383c$var$focusEventsPluginKey
});
class $be3c84bcbbb2383c$export$50c0270e74640068 {
    get name() {
        return this.node.type.name;
    }
    constructor(pos, editor, isBlock = false, node = null){
        this.currentNode = null;
        this.actualDepth = null;
        this.isBlock = isBlock;
        this.resolvedPos = pos;
        this.editor = editor;
        this.currentNode = node;
    }
    get node() {
        return this.currentNode || this.resolvedPos.node();
    }
    get element() {
        return this.editor.view.domAtPos(this.pos).node;
    }
    get depth() {
        var _a;
        return (_a = this.actualDepth) !== null && _a !== void 0 ? _a : this.resolvedPos.depth;
    }
    get pos() {
        return this.resolvedPos.pos;
    }
    get content() {
        return this.node.content;
    }
    set content(content) {
        let from = this.from;
        let to = this.to;
        if (this.isBlock) {
            if (this.content.size === 0) {
                console.error(`You can\u{2019}t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
                return;
            }
            from = this.from + 1;
            to = this.to - 1;
        }
        this.editor.commands.insertContentAt({
            from: from,
            to: to
        }, content);
    }
    get attributes() {
        return this.node.attrs;
    }
    get textContent() {
        return this.node.textContent;
    }
    get size() {
        return this.node.nodeSize;
    }
    get from() {
        if (this.isBlock) return this.pos;
        return this.resolvedPos.start(this.resolvedPos.depth);
    }
    get range() {
        return {
            from: this.from,
            to: this.to
        };
    }
    get to() {
        if (this.isBlock) return this.pos + this.size;
        return this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
    }
    get parent() {
        if (this.depth === 0) return null;
        const parentPos = this.resolvedPos.start(this.resolvedPos.depth - 1);
        const $pos = this.resolvedPos.doc.resolve(parentPos);
        return new $be3c84bcbbb2383c$export$50c0270e74640068($pos, this.editor);
    }
    get before() {
        let $pos = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.from - 3);
        return new $be3c84bcbbb2383c$export$50c0270e74640068($pos, this.editor);
    }
    get after() {
        let $pos = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
        if ($pos.depth !== this.depth) $pos = this.resolvedPos.doc.resolve(this.to + 3);
        return new $be3c84bcbbb2383c$export$50c0270e74640068($pos, this.editor);
    }
    get children() {
        const children = [];
        this.node.content.forEach((node, offset)=>{
            const isBlock = node.isBlock && !node.isTextblock;
            const isNonTextAtom = node.isAtom && !node.isText;
            const targetPos = this.pos + offset + (isNonTextAtom ? 0 : 1);
            // Check if targetPos is within valid document range
            if (targetPos < 0 || targetPos > this.resolvedPos.doc.nodeSize - 2) return;
            const $pos = this.resolvedPos.doc.resolve(targetPos);
            if (!isBlock && $pos.depth <= this.depth) return;
            const childNodePos = new $be3c84bcbbb2383c$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null);
            if (isBlock) childNodePos.actualDepth = this.depth + 1;
            children.push(new $be3c84bcbbb2383c$export$50c0270e74640068($pos, this.editor, isBlock, isBlock ? node : null));
        });
        return children;
    }
    get firstChild() {
        return this.children[0] || null;
    }
    get lastChild() {
        const children = this.children;
        return children[children.length - 1] || null;
    }
    closest(selector, attributes = {}) {
        let node = null;
        let currentNode = this.parent;
        while(currentNode && !node){
            if (currentNode.node.type.name === selector) {
                if (Object.keys(attributes).length > 0) {
                    const nodeAttributes = currentNode.node.attrs;
                    const attrKeys = Object.keys(attributes);
                    for(let index = 0; index < attrKeys.length; index += 1){
                        const key = attrKeys[index];
                        if (nodeAttributes[key] !== attributes[key]) break;
                    }
                } else node = currentNode;
            }
            currentNode = currentNode.parent;
        }
        return node;
    }
    querySelector(selector, attributes = {}) {
        return this.querySelectorAll(selector, attributes, true)[0] || null;
    }
    querySelectorAll(selector, attributes = {}, firstItemOnly = false) {
        let nodes = [];
        if (!this.children || this.children.length === 0) return nodes;
        const attrKeys = Object.keys(attributes);
        /**
         * Finds all children recursively that match the selector and attributes
         * If firstItemOnly is true, it will return the first item found
         */ this.children.forEach((childPos)=>{
            // If we already found a node and we only want the first item, we dont need to keep going
            if (firstItemOnly && nodes.length > 0) return;
            if (childPos.node.type.name === selector) {
                const doesAllAttributesMatch = attrKeys.every((key)=>attributes[key] === childPos.node.attrs[key]);
                if (doesAllAttributesMatch) nodes.push(childPos);
            }
            // If we already found a node and we only want the first item, we can stop here and skip the recursion
            if (firstItemOnly && nodes.length > 0) return;
            nodes = nodes.concat(childPos.querySelectorAll(selector, attributes, firstItemOnly));
        });
        return nodes;
    }
    setAttribute(attributes) {
        const { tr: tr } = this.editor.state;
        tr.setNodeMarkup(this.from, undefined, {
            ...this.node.attrs,
            ...attributes
        });
        this.editor.view.dispatch(tr);
    }
}
const $be3c84bcbbb2383c$var$style = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function $be3c84bcbbb2383c$export$48321b481dd8a36(style, nonce, suffix) {
    const tiptapStyleTag = document.querySelector(`style[data-tiptap-style${suffix ? `-${suffix}` : ''}]`);
    if (tiptapStyleTag !== null) return tiptapStyleTag;
    const styleNode = document.createElement('style');
    if (nonce) styleNode.setAttribute('nonce', nonce);
    styleNode.setAttribute(`data-tiptap-style${suffix ? `-${suffix}` : ''}`, '');
    styleNode.innerHTML = style;
    document.getElementsByTagName('head')[0].appendChild(styleNode);
    return styleNode;
}
class $be3c84bcbbb2383c$export$7cda8d932e2f33c0 extends $be3c84bcbbb2383c$var$EventEmitter {
    constructor(options = {}){
        super();
        this.isFocused = false;
        /**
         * The editor is considered initialized after the `create` event has been emitted.
         */ this.isInitialized = false;
        this.extensionStorage = {};
        this.options = {
            element: document.createElement('div'),
            content: '',
            injectCSS: true,
            injectNonce: undefined,
            extensions: [],
            autofocus: false,
            editable: true,
            editorProps: {},
            parseOptions: {},
            coreExtensionOptions: {},
            enableInputRules: true,
            enablePasteRules: true,
            enableCoreExtensions: true,
            enableContentCheck: false,
            emitContentError: false,
            onBeforeCreate: ()=>null,
            onCreate: ()=>null,
            onUpdate: ()=>null,
            onSelectionUpdate: ()=>null,
            onTransaction: ()=>null,
            onFocus: ()=>null,
            onBlur: ()=>null,
            onDestroy: ()=>null,
            onContentError: ({ error: error })=>{
                throw error;
            },
            onPaste: ()=>null,
            onDrop: ()=>null
        };
        this.isCapturingTransaction = false;
        this.capturedTransaction = null;
        this.setOptions(options);
        this.createExtensionManager();
        this.createCommandManager();
        this.createSchema();
        this.on('beforeCreate', this.options.onBeforeCreate);
        this.emit('beforeCreate', {
            editor: this
        });
        this.on('contentError', this.options.onContentError);
        this.createView();
        this.injectCSS();
        this.on('create', this.options.onCreate);
        this.on('update', this.options.onUpdate);
        this.on('selectionUpdate', this.options.onSelectionUpdate);
        this.on('transaction', this.options.onTransaction);
        this.on('focus', this.options.onFocus);
        this.on('blur', this.options.onBlur);
        this.on('destroy', this.options.onDestroy);
        this.on('drop', ({ event: event, slice: slice, moved: moved })=>this.options.onDrop(event, slice, moved));
        this.on('paste', ({ event: event, slice: slice })=>this.options.onPaste(event, slice));
        window.setTimeout(()=>{
            if (this.isDestroyed) return;
            this.commands.focus(this.options.autofocus);
            this.emit('create', {
                editor: this
            });
            this.isInitialized = true;
        }, 0);
    }
    /**
     * Returns the editor storage.
     */ get storage() {
        return this.extensionStorage;
    }
    /**
     * An object of all registered commands.
     */ get commands() {
        return this.commandManager.commands;
    }
    /**
     * Create a command chain to call multiple commands at once.
     */ chain() {
        return this.commandManager.chain();
    }
    /**
     * Check if a command or a command chain can be executed. Without executing it.
     */ can() {
        return this.commandManager.can();
    }
    /**
     * Inject CSS styles.
     */ injectCSS() {
        if (this.options.injectCSS && document) this.css = $be3c84bcbbb2383c$export$48321b481dd8a36($be3c84bcbbb2383c$var$style, this.options.injectNonce);
    }
    /**
     * Update editor options.
     *
     * @param options A list of options
     */ setOptions(options = {}) {
        this.options = {
            ...this.options,
            ...options
        };
        if (!this.view || !this.state || this.isDestroyed) return;
        if (this.options.editorProps) this.view.setProps(this.options.editorProps);
        this.view.updateState(this.state);
    }
    /**
     * Update editable state of the editor.
     */ setEditable(editable, emitUpdate = true) {
        this.setOptions({
            editable: editable
        });
        if (emitUpdate) this.emit('update', {
            editor: this,
            transaction: this.state.tr
        });
    }
    /**
     * Returns whether the editor is editable.
     */ get isEditable() {
        // since plugins are applied after creating the view
        // `editable` is always `true` for one tick.
        // that’s why we also have to check for `options.editable`
        return this.options.editable && this.view && this.view.editable;
    }
    /**
     * Returns the editor state.
     */ get state() {
        return this.view.state;
    }
    /**
     * Register a ProseMirror plugin.
     *
     * @param plugin A ProseMirror plugin
     * @param handlePlugins Control how to merge the plugin into the existing plugins.
     * @returns The new editor state
     */ registerPlugin(plugin, handlePlugins) {
        const plugins = $be3c84bcbbb2383c$export$f6e2535fb5126e54(handlePlugins) ? handlePlugins(plugin, [
            ...this.state.plugins
        ]) : [
            ...this.state.plugins,
            plugin
        ];
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Unregister a ProseMirror plugin.
     *
     * @param nameOrPluginKeyToRemove The plugins name
     * @returns The new editor state or undefined if the editor is destroyed
     */ unregisterPlugin(nameOrPluginKeyToRemove) {
        if (this.isDestroyed) return undefined;
        const prevPlugins = this.state.plugins;
        let plugins = prevPlugins;
        [].concat(nameOrPluginKeyToRemove).forEach((nameOrPluginKey)=>{
            // @ts-ignore
            const name = typeof nameOrPluginKey === 'string' ? `${nameOrPluginKey}$` : nameOrPluginKey.key;
            // @ts-ignore
            plugins = plugins.filter((plugin)=>!plugin.key.startsWith(name));
        });
        if (prevPlugins.length === plugins.length) // No plugin was removed, so we don’t need to update the state
        return undefined;
        const state = this.state.reconfigure({
            plugins: plugins
        });
        this.view.updateState(state);
        return state;
    }
    /**
     * Creates an extension manager.
     */ createExtensionManager() {
        var _a, _b;
        const coreExtensions = this.options.enableCoreExtensions ? [
            $be3c84bcbbb2383c$var$Editable,
            $be3c84bcbbb2383c$var$ClipboardTextSerializer.configure({
                blockSeparator: (_b = (_a = this.options.coreExtensionOptions) === null || _a === void 0 ? void 0 : _a.clipboardTextSerializer) === null || _b === void 0 ? void 0 : _b.blockSeparator
            }),
            $be3c84bcbbb2383c$var$Commands,
            $be3c84bcbbb2383c$var$FocusEvents,
            $be3c84bcbbb2383c$var$Keymap,
            $be3c84bcbbb2383c$var$Tabindex,
            $be3c84bcbbb2383c$var$Drop,
            $be3c84bcbbb2383c$var$Paste
        ].filter((ext)=>{
            if (typeof this.options.enableCoreExtensions === 'object') return this.options.enableCoreExtensions[ext.name] !== false;
            return true;
        }) : [];
        const allExtensions = [
            ...coreExtensions,
            ...this.options.extensions
        ].filter((extension)=>{
            return [
                'extension',
                'node',
                'mark'
            ].includes(extension === null || extension === void 0 ? void 0 : extension.type);
        });
        this.extensionManager = new $be3c84bcbbb2383c$var$ExtensionManager(allExtensions, this);
    }
    /**
     * Creates an command manager.
     */ createCommandManager() {
        this.commandManager = new $be3c84bcbbb2383c$export$475014de15a4c342({
            editor: this
        });
    }
    /**
     * Creates a ProseMirror schema.
     */ createSchema() {
        this.schema = this.extensionManager.schema;
    }
    /**
     * Creates a ProseMirror view.
     */ createView() {
        var _a;
        let doc;
        try {
            doc = $be3c84bcbbb2383c$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: this.options.enableContentCheck
            });
        } catch (e) {
            if (!(e instanceof Error) || ![
                '[tiptap error]: Invalid JSON content',
                '[tiptap error]: Invalid HTML content'
            ].includes(e.message)) // Not the content error we were expecting
            throw e;
            this.emit('contentError', {
                editor: this,
                error: e,
                disableCollaboration: ()=>{
                    if (this.storage.collaboration) this.storage.collaboration.isDisabled = true;
                    // To avoid syncing back invalid content, reinitialize the extensions without the collaboration extension
                    this.options.extensions = this.options.extensions.filter((extension)=>extension.name !== 'collaboration');
                    // Restart the initialization process by recreating the extension manager with the new set of extensions
                    this.createExtensionManager();
                }
            });
            // Content is invalid, but attempt to create it anyway, stripping out the invalid parts
            doc = $be3c84bcbbb2383c$export$37330def6e48b4c9(this.options.content, this.schema, this.options.parseOptions, {
                errorOnInvalidContent: false
            });
        }
        const selection = $be3c84bcbbb2383c$export$225b0233b78e0d61(doc, this.options.autofocus);
        this.view = new (0, $edQEX.EditorView)(this.options.element, {
            ...this.options.editorProps,
            attributes: {
                // add `role="textbox"` to the editor element
                role: 'textbox',
                ...(_a = this.options.editorProps) === null || _a === void 0 ? void 0 : _a.attributes
            },
            dispatchTransaction: this.dispatchTransaction.bind(this),
            state: (0, $1LeRC.EditorState).create({
                doc: doc,
                selection: selection || undefined
            })
        });
        // `editor.view` is not yet available at this time.
        // Therefore we will add all plugins and node views directly afterwards.
        const newState = this.state.reconfigure({
            plugins: this.extensionManager.plugins
        });
        this.view.updateState(newState);
        this.createNodeViews();
        this.prependClass();
        // Let’s store the editor instance in the DOM element.
        // So we’ll have access to it for tests.
        // @ts-ignore
        const dom = this.view.dom;
        dom.editor = this;
    }
    /**
     * Creates all node views.
     */ createNodeViews() {
        if (this.view.isDestroyed) return;
        this.view.setProps({
            nodeViews: this.extensionManager.nodeViews
        });
    }
    /**
     * Prepend class name to element.
     */ prependClass() {
        this.view.dom.className = `tiptap ${this.view.dom.className}`;
    }
    captureTransaction(fn) {
        this.isCapturingTransaction = true;
        fn();
        this.isCapturingTransaction = false;
        const tr = this.capturedTransaction;
        this.capturedTransaction = null;
        return tr;
    }
    /**
     * The callback over which to send transactions (state updates) produced by the view.
     *
     * @param transaction An editor state transaction
     */ dispatchTransaction(transaction) {
        // if the editor / the view of the editor was destroyed
        // the transaction should not be dispatched as there is no view anymore.
        if (this.view.isDestroyed) return;
        if (this.isCapturingTransaction) {
            if (!this.capturedTransaction) {
                this.capturedTransaction = transaction;
                return;
            }
            transaction.steps.forEach((step)=>{
                var _a;
                return (_a = this.capturedTransaction) === null || _a === void 0 ? void 0 : _a.step(step);
            });
            return;
        }
        const state = this.state.apply(transaction);
        const selectionHasChanged = !this.state.selection.eq(state.selection);
        this.emit('beforeTransaction', {
            editor: this,
            transaction: transaction,
            nextState: state
        });
        this.view.updateState(state);
        this.emit('transaction', {
            editor: this,
            transaction: transaction
        });
        if (selectionHasChanged) this.emit('selectionUpdate', {
            editor: this,
            transaction: transaction
        });
        const focus = transaction.getMeta('focus');
        const blur = transaction.getMeta('blur');
        if (focus) this.emit('focus', {
            editor: this,
            event: focus.event,
            transaction: transaction
        });
        if (blur) this.emit('blur', {
            editor: this,
            event: blur.event,
            transaction: transaction
        });
        if (!transaction.docChanged || transaction.getMeta('preventUpdate')) return;
        this.emit('update', {
            editor: this,
            transaction: transaction
        });
    }
    /**
     * Get attributes of the currently selected node or mark.
     */ getAttributes(nameOrType) {
        return $be3c84bcbbb2383c$export$fe94072fee8a6976(this.state, nameOrType);
    }
    isActive(nameOrAttributes, attributesOrUndefined) {
        const name = typeof nameOrAttributes === 'string' ? nameOrAttributes : null;
        const attributes = typeof nameOrAttributes === 'string' ? attributesOrUndefined : nameOrAttributes;
        return $be3c84bcbbb2383c$export$39e04e72f972b885(this.state, name, attributes);
    }
    /**
     * Get the document as JSON.
     */ getJSON() {
        return this.state.doc.toJSON();
    }
    /**
     * Get the document as HTML.
     */ getHTML() {
        return $be3c84bcbbb2383c$export$d1b60002472b2c81(this.state.doc.content, this.schema);
    }
    /**
     * Get the document as text.
     */ getText(options) {
        const { blockSeparator: blockSeparator = '\n\n', textSerializers: textSerializers = {} } = options || {};
        return $be3c84bcbbb2383c$export$c72d34660a162238(this.state.doc, {
            blockSeparator: blockSeparator,
            textSerializers: {
                ...$be3c84bcbbb2383c$export$fdd92b7d22ac071c(this.schema),
                ...textSerializers
            }
        });
    }
    /**
     * Check if there is no content.
     */ get isEmpty() {
        return $be3c84bcbbb2383c$export$cd58ff1081f6abe9(this.state.doc);
    }
    /**
     * Get the number of characters for the current document.
     *
     * @deprecated
     */ getCharacterCount() {
        console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.');
        return this.state.doc.content.size - 2;
    }
    /**
     * Destroy the editor.
     */ destroy() {
        this.emit('destroy');
        if (this.view) {
            // Cleanup our reference to prevent circular references which caused memory leaks
            // @ts-ignore
            const dom = this.view.dom;
            if (dom && dom.editor) delete dom.editor;
            this.view.destroy();
        }
        this.removeAllListeners();
    }
    /**
     * Check if the editor is already destroyed.
     */ get isDestroyed() {
        var _a;
        // @ts-ignore
        return !((_a = this.view) === null || _a === void 0 ? void 0 : _a.docView);
    }
    $node(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelector(selector, attributes)) || null;
    }
    $nodes(selector, attributes) {
        var _a;
        return ((_a = this.$doc) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selector, attributes)) || null;
    }
    $pos(pos) {
        const $pos = this.state.doc.resolve(pos);
        return new $be3c84bcbbb2383c$export$50c0270e74640068($pos, this);
    }
    get $doc() {
        return this.$pos(0);
    }
}
/**
 * Build an input rule that adds a mark when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $be3c84bcbbb2383c$export$9f2cb743ab9131de(config) {
    return new $be3c84bcbbb2383c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $be3c84bcbbb2383c$export$592682234826c0bd(config.getAttributes, undefined, match);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $be3c84bcbbb2383c$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                const markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
/**
 * Build an input rule that adds a node when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $be3c84bcbbb2383c$export$6ca56856dfeaf9b6(config) {
    return new $be3c84bcbbb2383c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const attributes = $be3c84bcbbb2383c$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const { tr: tr } = state;
            const start = range.from;
            let end = range.to;
            const newNode = config.type.create(attributes);
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                let matchStart = start + offset;
                if (matchStart > end) matchStart = end;
                else end = matchStart + match[1].length;
                // insert last typed character
                const lastChar = match[0][match[0].length - 1];
                tr.insertText(lastChar, start + match[0].length - 1);
                // insert node from input rule
                tr.replaceWith(matchStart, end, newNode);
            } else if (match[0]) {
                const insertionStart = config.type.isInline ? start : start - 1;
                tr.insert(insertionStart, config.type.create(attributes)).delete(tr.mapping.map(start), tr.mapping.map(end));
            }
            tr.scrollIntoView();
        }
    });
}
/**
 * Build an input rule that changes the type of a textblock when the
 * matched text is typed into it. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $be3c84bcbbb2383c$export$cc081314d3f6ffb0(config) {
    return new $be3c84bcbbb2383c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            const $start = state.doc.resolve(range.from);
            const attributes = $be3c84bcbbb2383c$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            if (!$start.node(-1).canReplaceWith($start.index(-1), $start.indexAfter(-1), config.type)) return null;
            state.tr.delete(range.from, range.to).setBlockType(range.from, range.from, config.type, attributes);
        }
    });
}
/**
 * Build an input rule that replaces text when the
 * matched text is typed into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $be3c84bcbbb2383c$export$3ba5a5a15d18a35c(config) {
    return new $be3c84bcbbb2383c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
/**
 * Build an input rule for automatically wrapping a textblock when a
 * given string is typed. When using a regular expresion you’ll
 * probably want the regexp to start with `^`, so that the pattern can
 * only occur at the start of a textblock.
 *
 * `type` is the type of node to wrap in.
 *
 * By default, if there’s a node with the same type above the newly
 * wrapped node, the rule will try to join those
 * two nodes. You can pass a join predicate, which takes a regular
 * expression match and the node before the wrapped node, and can
 * return a boolean to indicate whether a join should happen.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#input-rules
 */ function $be3c84bcbbb2383c$export$f7316d89abe4e1c1(config) {
    return new $be3c84bcbbb2383c$export$9b55e2b000ad65f2({
        find: config.find,
        handler: ({ state: state, range: range, match: match, chain: chain })=>{
            const attributes = $be3c84bcbbb2383c$export$592682234826c0bd(config.getAttributes, undefined, match) || {};
            const tr = state.tr.delete(range.from, range.to);
            const $start = tr.doc.resolve(range.from);
            const blockRange = $start.blockRange();
            const wrapping = blockRange && (0, $gfgdn.findWrapping)(blockRange, config.type, attributes);
            if (!wrapping) return null;
            tr.wrap(blockRange, wrapping);
            if (config.keepMarks && config.editor) {
                const { selection: selection, storedMarks: storedMarks } = state;
                const { splittableMarks: splittableMarks } = config.editor.extensionManager;
                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                if (marks) {
                    const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                    tr.ensureMarks(filteredMarks);
                }
            }
            if (config.keepAttributes) {
                /** If the nodeType is `bulletList` or `orderedList` set the `nodeType` as `listItem` */ const nodeType = config.type.name === 'bulletList' || config.type.name === 'orderedList' ? 'listItem' : 'taskList';
                chain().updateAttributes(nodeType, attributes).run();
            }
            const before = tr.doc.resolve(range.from - 1).nodeBefore;
            if (before && before.type === config.type && (0, $gfgdn.canJoin)(tr.doc, range.from - 1) && (!config.joinPredicate || config.joinPredicate(match, before))) tr.join(range.from - 1);
        }
    });
}
/**
 * The Node class is used to create custom node extensions.
 * @see https://tiptap.dev/api/extensions#create-a-new-extension
 */ class $be3c84bcbbb2383c$export$85c928794f8d04d4 {
    constructor(config = {}){
        this.type = 'node';
        this.name = 'node';
        this.parent = null;
        this.child = null;
        this.config = {
            name: this.name,
            defaultOptions: {}
        };
        this.config = {
            ...this.config,
            ...config
        };
        this.name = this.config.name;
        if (config.defaultOptions && Object.keys(config.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`);
        // TODO: remove `addOptions` fallback
        this.options = this.config.defaultOptions;
        if (this.config.addOptions) this.options = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(this, 'addOptions', {
            name: this.name
        }));
        this.storage = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(this, 'addStorage', {
            name: this.name,
            options: this.options
        })) || {};
    }
    static create(config = {}) {
        return new $be3c84bcbbb2383c$export$85c928794f8d04d4(config);
    }
    configure(options = {}) {
        // return a new instance so we can use the same extension
        // with different calls of `configure`
        const extension = this.extend({
            ...this.config,
            addOptions: ()=>{
                return $be3c84bcbbb2383c$export$dd702b3c8240390c(this.options, options);
            }
        });
        // Always preserve the current name
        extension.name = this.name;
        // Set the parent to be our parent
        extension.parent = this.parent;
        return extension;
    }
    extend(extendedConfig = {}) {
        const extension = new $be3c84bcbbb2383c$export$85c928794f8d04d4(extendedConfig);
        extension.parent = this;
        this.child = extension;
        extension.name = extendedConfig.name ? extendedConfig.name : extension.parent.name;
        if (extendedConfig.defaultOptions && Object.keys(extendedConfig.defaultOptions).length > 0) console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${extension.name}".`);
        extension.options = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addOptions', {
            name: extension.name
        }));
        extension.storage = $be3c84bcbbb2383c$export$592682234826c0bd($be3c84bcbbb2383c$export$f73578b718a57eaa(extension, 'addStorage', {
            name: extension.name,
            options: extension.options
        }));
        return extension;
    }
}
/**
 * Node views are used to customize the rendered DOM structure of a node.
 * @see https://tiptap.dev/guide/node-views
 */ class $be3c84bcbbb2383c$export$77c6811359a01a6f {
    constructor(component, props, options){
        this.isDragging = false;
        this.component = component;
        this.editor = props.editor;
        this.options = {
            stopEvent: null,
            ignoreMutation: null,
            ...options
        };
        this.extension = props.extension;
        this.node = props.node;
        this.decorations = props.decorations;
        this.innerDecorations = props.innerDecorations;
        this.view = props.view;
        this.HTMLAttributes = props.HTMLAttributes;
        this.getPos = props.getPos;
        this.mount();
    }
    mount() {
        // eslint-disable-next-line
        return;
    }
    get dom() {
        return this.editor.view.dom;
    }
    get contentDOM() {
        return null;
    }
    onDragStart(event) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { view: view } = this.editor;
        const target = event.target;
        // get the drag handle element
        // `closest` is not available for text nodes so we may have to use its parent
        const dragHandle = target.nodeType === 3 ? (_a = target.parentElement) === null || _a === void 0 ? void 0 : _a.closest('[data-drag-handle]') : target.closest('[data-drag-handle]');
        if (!this.dom || ((_b = this.contentDOM) === null || _b === void 0 ? void 0 : _b.contains(target)) || !dragHandle) return;
        let x = 0;
        let y = 0;
        // calculate offset for drag element if we use a different drag handle element
        if (this.dom !== dragHandle) {
            const domBox = this.dom.getBoundingClientRect();
            const handleBox = dragHandle.getBoundingClientRect();
            // In React, we have to go through nativeEvent to reach offsetX/offsetY.
            const offsetX = (_c = event.offsetX) !== null && _c !== void 0 ? _c : (_d = event.nativeEvent) === null || _d === void 0 ? void 0 : _d.offsetX;
            const offsetY = (_e = event.offsetY) !== null && _e !== void 0 ? _e : (_f = event.nativeEvent) === null || _f === void 0 ? void 0 : _f.offsetY;
            x = handleBox.x - domBox.x + offsetX;
            y = handleBox.y - domBox.y + offsetY;
        }
        const clonedNode = this.dom.cloneNode(true);
        (_g = event.dataTransfer) === null || _g === void 0 || _g.setDragImage(clonedNode, x, y);
        const pos = this.getPos();
        if (typeof pos !== 'number') return;
        // we need to tell ProseMirror that we want to move the whole node
        // so we create a NodeSelection
        const selection = (0, $1LeRC.NodeSelection).create(view.state.doc, pos);
        const transaction = view.state.tr.setSelection(selection);
        view.dispatch(transaction);
    }
    stopEvent(event) {
        var _a;
        if (!this.dom) return false;
        if (typeof this.options.stopEvent === 'function') return this.options.stopEvent({
            event: event
        });
        const target = event.target;
        const isInElement = this.dom.contains(target) && !((_a = this.contentDOM) === null || _a === void 0 ? void 0 : _a.contains(target));
        // any event from child nodes should be handled by ProseMirror
        if (!isInElement) return false;
        const isDragEvent = event.type.startsWith('drag');
        const isDropEvent = event.type === 'drop';
        const isInput = [
            'INPUT',
            'BUTTON',
            'SELECT',
            'TEXTAREA'
        ].includes(target.tagName) || target.isContentEditable;
        // any input event within node views should be ignored by ProseMirror
        if (isInput && !isDropEvent && !isDragEvent) return true;
        const { isEditable: isEditable } = this.editor;
        const { isDragging: isDragging } = this;
        const isDraggable = !!this.node.type.spec.draggable;
        const isSelectable = (0, $1LeRC.NodeSelection).isSelectable(this.node);
        const isCopyEvent = event.type === 'copy';
        const isPasteEvent = event.type === 'paste';
        const isCutEvent = event.type === 'cut';
        const isClickEvent = event.type === 'mousedown';
        // ProseMirror tries to drag selectable nodes
        // even if `draggable` is set to `false`
        // this fix prevents that
        if (!isDraggable && isSelectable && isDragEvent && event.target === this.dom) event.preventDefault();
        if (isDraggable && isDragEvent && !isDragging && event.target === this.dom) {
            event.preventDefault();
            return false;
        }
        // we have to store that dragging started
        if (isDraggable && isEditable && !isDragging && isClickEvent) {
            const dragHandle = target.closest('[data-drag-handle]');
            const isValidDragHandle = dragHandle && (this.dom === dragHandle || this.dom.contains(dragHandle));
            if (isValidDragHandle) {
                this.isDragging = true;
                document.addEventListener('dragend', ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener('drop', ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
                document.addEventListener('mouseup', ()=>{
                    this.isDragging = false;
                }, {
                    once: true
                });
            }
        }
        // these events are handled by prosemirror
        if (isDragging || isDropEvent || isCopyEvent || isPasteEvent || isCutEvent || isClickEvent && isSelectable) return false;
        return true;
    }
    /**
     * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
     * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
     * @return `true` if it can safely be ignored.
     */ ignoreMutation(mutation) {
        if (!this.dom || !this.contentDOM) return true;
        if (typeof this.options.ignoreMutation === 'function') return this.options.ignoreMutation({
            mutation: mutation
        });
        // a leaf/atom node is like a black box for ProseMirror
        // and should be fully handled by the node view
        if (this.node.isLeaf || this.node.isAtom) return true;
        // ProseMirror should handle any selections
        if (mutation.type === 'selection') return false;
        // try to prevent a bug on iOS and Android that will break node views on enter
        // this is because ProseMirror can’t preventDispatch on enter
        // this will lead to a re-render of the node view on enter
        // see: https://github.com/ueberdosis/tiptap/issues/1214
        // see: https://github.com/ueberdosis/tiptap/issues/2534
        if (this.dom.contains(mutation.target) && mutation.type === 'childList' && ($be3c84bcbbb2383c$export$86c1a3f9ab33da5c() || $be3c84bcbbb2383c$var$isAndroid()) && this.editor.isFocused) {
            const changedNodes = [
                ...Array.from(mutation.addedNodes),
                ...Array.from(mutation.removedNodes)
            ];
            // we’ll check if every changed node is contentEditable
            // to make sure it’s probably mutated by ProseMirror
            if (changedNodes.every((node)=>node.isContentEditable)) return false;
        }
        // we will allow mutation contentDOM with attributes
        // so we can for example adding classes within our node view
        if (this.contentDOM === mutation.target && mutation.type === 'attributes') return true;
        // ProseMirror should handle any changes within contentDOM
        if (this.contentDOM.contains(mutation.target)) return false;
        return true;
    }
    /**
     * Update the attributes of the prosemirror node.
     */ updateAttributes(attributes) {
        this.editor.commands.command(({ tr: tr })=>{
            const pos = this.getPos();
            if (typeof pos !== 'number') return false;
            tr.setNodeMarkup(pos, undefined, {
                ...this.node.attrs,
                ...attributes
            });
            return true;
        });
    }
    /**
     * Delete the node.
     */ deleteNode() {
        const from = this.getPos();
        if (typeof from !== 'number') return;
        const to = from + this.node.nodeSize;
        this.editor.commands.deleteRange({
            from: from,
            to: to
        });
    }
}
/**
 * Build an paste rule that adds a mark when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $be3c84bcbbb2383c$export$3845eb97abe74944(config) {
    return new $be3c84bcbbb2383c$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match, pasteEvent: pasteEvent })=>{
            const attributes = $be3c84bcbbb2383c$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            if (attributes === false || attributes === null) return null;
            const { tr: tr } = state;
            const captureGroup = match[match.length - 1];
            const fullMatch = match[0];
            let markEnd = range.to;
            if (captureGroup) {
                const startSpaces = fullMatch.search(/\S/);
                const textStart = range.from + fullMatch.indexOf(captureGroup);
                const textEnd = textStart + captureGroup.length;
                const excludedMarks = $be3c84bcbbb2383c$export$c5fd7af7c5c1efa(range.from, range.to, state.doc).filter((item)=>{
                    // @ts-ignore
                    const excluded = item.mark.type.excluded;
                    return excluded.find((type)=>type === config.type && type !== item.mark.type);
                }).filter((item)=>item.to > textStart);
                if (excludedMarks.length) return null;
                if (textEnd < range.to) tr.delete(textEnd, range.to);
                if (textStart > range.from) tr.delete(range.from + startSpaces, textStart);
                markEnd = range.from + startSpaces + captureGroup.length;
                tr.addMark(range.from + startSpaces, markEnd, config.type.create(attributes || {}));
                tr.removeStoredMark(config.type);
            }
        }
    });
}
function $be3c84bcbbb2383c$export$d23217284a0e83b9(state, nodeType) {
    const { selection: selection } = state;
    const { $from: $from } = selection;
    // Special handling for NodeSelection
    if (selection instanceof (0, $1LeRC.NodeSelection)) {
        const index = $from.index();
        const parent = $from.parent;
        // Can we replace the selected node with the horizontal rule?
        return parent.canReplaceWith(index, index + 1, nodeType);
    }
    // Default: check if we can insert at the current position
    let depth = $from.depth;
    while(depth >= 0){
        const index = $from.index(depth);
        const parent = $from.node(depth);
        const match = parent.contentMatchAt(index);
        if (match.matchType(nodeType)) return true;
        depth -= 1;
    }
    return false;
}
// source: https://stackoverflow.com/a/6969486
function $be3c84bcbbb2383c$export$d3f82eb9fcc60fbc(string) {
    return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
function $be3c84bcbbb2383c$export$844ec244b1367d54(value) {
    return typeof value === 'string';
}
/**
 * Build an paste rule that adds a node when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $be3c84bcbbb2383c$export$3cb77ada4d0e5bd5(config) {
    return new $be3c84bcbbb2383c$export$e75df4392d073e98({
        find: config.find,
        handler ({ match: match, chain: chain, range: range, pasteEvent: pasteEvent }) {
            const attributes = $be3c84bcbbb2383c$export$592682234826c0bd(config.getAttributes, undefined, match, pasteEvent);
            const content = $be3c84bcbbb2383c$export$592682234826c0bd(config.getContent, undefined, attributes);
            if (attributes === false || attributes === null) return null;
            const node = {
                type: config.type.name,
                attrs: attributes
            };
            if (content) node.content = content;
            if (match.input) chain().deleteRange(range).insertContentAt(range.from, node);
        }
    });
}
/**
 * Build an paste rule that replaces text when the
 * matched text is pasted into it.
 * @see https://tiptap.dev/docs/editor/extensions/custom-extensions/extend-existing#paste-rules
 */ function $be3c84bcbbb2383c$export$1aff23e8795559fa(config) {
    return new $be3c84bcbbb2383c$export$e75df4392d073e98({
        find: config.find,
        handler: ({ state: state, range: range, match: match })=>{
            let insert = config.replace;
            let start = range.from;
            const end = range.to;
            if (match[1]) {
                const offset = match[0].lastIndexOf(match[1]);
                insert += match[0].slice(offset + match[1].length);
                start += offset;
                const cutOff = start - end;
                if (cutOff > 0) {
                    insert = match[0].slice(offset - cutOff, offset) + insert;
                    start = end;
                }
            }
            state.tr.insertText(insert, start, end);
        }
    });
}
class $be3c84bcbbb2383c$export$254d9747e34ddc90 {
    constructor(transaction){
        this.transaction = transaction;
        this.currentStep = this.transaction.steps.length;
    }
    map(position) {
        let deleted = false;
        const mappedPosition = this.transaction.steps.slice(this.currentStep).reduce((newPosition, step)=>{
            const mapResult = step.getMap().mapResult(newPosition);
            if (mapResult.deleted) deleted = true;
            return mapResult.pos;
        }, position);
        return {
            position: mappedPosition,
            deleted: deleted
        };
    }
}

});
parcelRegister("7fRs0", function(module, exports) {
$parcel$export(module.exports, "AllSelection", () => (parcelRequire("1LeRC")).AllSelection);
$parcel$export(module.exports, "EditorState", () => (parcelRequire("1LeRC")).EditorState);
$parcel$export(module.exports, "NodeSelection", () => (parcelRequire("1LeRC")).NodeSelection);
$parcel$export(module.exports, "Plugin", () => (parcelRequire("1LeRC")).Plugin);
$parcel$export(module.exports, "PluginKey", () => (parcelRequire("1LeRC")).PluginKey);
$parcel$export(module.exports, "Selection", () => (parcelRequire("1LeRC")).Selection);
$parcel$export(module.exports, "TextSelection", () => (parcelRequire("1LeRC")).TextSelection);
// state/index.ts
parcelRequire("1LeRC");

});
parcelRegister("1LeRC", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $1485b5e112c966ab$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $1485b5e112c966ab$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $1485b5e112c966ab$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $1485b5e112c966ab$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $1485b5e112c966ab$export$e2940151ac854c0b);
$parcel$export(module.exports, "EditorState", () => $1485b5e112c966ab$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $1485b5e112c966ab$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $1485b5e112c966ab$export$1692d8b0e89cecc3);

var $1krlL = parcelRequire("1krlL");

var $gfgdn = parcelRequire("gfgdn");
const $1485b5e112c966ab$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $1485b5e112c966ab$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $1485b5e112c966ab$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $1krlL.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $1krlL.Slice).empty : content);
            if (i == 0) $1485b5e112c966ab$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $1485b5e112c966ab$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $1485b5e112c966ab$export$c2b25f346d19bcbb($pos) : $1485b5e112c966ab$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $1485b5e112c966ab$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $1485b5e112c966ab$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $1485b5e112c966ab$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $1485b5e112c966ab$var$findSelectionIn(doc, doc, 0, 0, 1) || new $1485b5e112c966ab$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $1485b5e112c966ab$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $1485b5e112c966ab$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $1485b5e112c966ab$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $1485b5e112c966ab$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $1485b5e112c966ab$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $1485b5e112c966ab$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$1485b5e112c966ab$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $1485b5e112c966ab$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $1485b5e112c966ab$var$warnedAboutTextSelection = false;
function $1485b5e112c966ab$var$checkTextSelection($pos) {
    if (!$1485b5e112c966ab$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $1485b5e112c966ab$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $1485b5e112c966ab$export$c2b25f346d19bcbb extends $1485b5e112c966ab$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $1485b5e112c966ab$var$checkTextSelection($anchor);
        $1485b5e112c966ab$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $1485b5e112c966ab$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $1485b5e112c966ab$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $1krlL.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $1krlL.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $1485b5e112c966ab$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $1485b5e112c966ab$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $1485b5e112c966ab$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $1485b5e112c966ab$export$52baac22726c72bf.findFrom($head, bias, true) || $1485b5e112c966ab$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $1485b5e112c966ab$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($1485b5e112c966ab$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $1485b5e112c966ab$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $1485b5e112c966ab$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$1485b5e112c966ab$export$52baac22726c72bf.jsonID("text", $1485b5e112c966ab$export$c2b25f346d19bcbb);
class $1485b5e112c966ab$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $1485b5e112c966ab$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $1485b5e112c966ab$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $1485b5e112c966ab$export$e2940151ac854c0b extends $1485b5e112c966ab$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $1485b5e112c966ab$export$52baac22726c72bf.near($pos);
        return new $1485b5e112c966ab$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $1485b5e112c966ab$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $1485b5e112c966ab$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $1485b5e112c966ab$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $1485b5e112c966ab$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$1485b5e112c966ab$export$e2940151ac854c0b.prototype.visible = false;
$1485b5e112c966ab$export$52baac22726c72bf.jsonID("node", $1485b5e112c966ab$export$e2940151ac854c0b);
class $1485b5e112c966ab$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $1485b5e112c966ab$var$TextBookmark(pos, pos) : new $1485b5e112c966ab$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $1485b5e112c966ab$export$e2940151ac854c0b.isSelectable(node)) return new $1485b5e112c966ab$export$e2940151ac854c0b($pos);
        return $1485b5e112c966ab$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $1485b5e112c966ab$export$c15d9ba76bdbcd95 extends $1485b5e112c966ab$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $1krlL.Slice).empty) {
        if (content == (0, $1krlL.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $1485b5e112c966ab$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $1485b5e112c966ab$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $1485b5e112c966ab$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $1485b5e112c966ab$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $1485b5e112c966ab$var$AllBookmark;
    }
}
$1485b5e112c966ab$export$52baac22726c72bf.jsonID("all", $1485b5e112c966ab$export$c15d9ba76bdbcd95);
const $1485b5e112c966ab$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $1485b5e112c966ab$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $1485b5e112c966ab$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $1485b5e112c966ab$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $1485b5e112c966ab$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $1485b5e112c966ab$export$e2940151ac854c0b.isSelectable(child)) return $1485b5e112c966ab$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $1485b5e112c966ab$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $gfgdn.ReplaceStep) || step instanceof (0, $gfgdn.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($1485b5e112c966ab$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $1485b5e112c966ab$var$UPDATED_SEL = 1, $1485b5e112c966ab$var$UPDATED_MARKS = 2, $1485b5e112c966ab$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $1485b5e112c966ab$export$febc5573c75cefb0 extends (0, $gfgdn.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $1485b5e112c966ab$var$UPDATED_SEL) & ~$1485b5e112c966ab$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $1485b5e112c966ab$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $1485b5e112c966ab$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $1krlL.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $1485b5e112c966ab$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$1485b5e112c966ab$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $1krlL.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($1485b5e112c966ab$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $1485b5e112c966ab$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $1485b5e112c966ab$var$UPDATED_SCROLL) > 0;
    }
}
function $1485b5e112c966ab$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $1485b5e112c966ab$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $1485b5e112c966ab$var$bind(desc.init, self);
        this.apply = $1485b5e112c966ab$var$bind(desc.apply, self);
    }
}
const $1485b5e112c966ab$var$baseFields = [
    new $1485b5e112c966ab$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $1485b5e112c966ab$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $1485b5e112c966ab$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $1485b5e112c966ab$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $1485b5e112c966ab$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $1485b5e112c966ab$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $1485b5e112c966ab$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $1485b5e112c966ab$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $1485b5e112c966ab$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $1485b5e112c966ab$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $1485b5e112c966ab$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $1485b5e112c966ab$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $1485b5e112c966ab$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $1485b5e112c966ab$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $1485b5e112c966ab$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $1485b5e112c966ab$var$Configuration(config.schema, config.plugins);
        let instance = new $1485b5e112c966ab$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $1krlL.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $1485b5e112c966ab$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $1485b5e112c966ab$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $1485b5e112c966ab$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $1485b5e112c966ab$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $1485b5e112c966ab$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $1485b5e112c966ab$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $1485b5e112c966ab$var$keys = Object.create(null);
function $1485b5e112c966ab$var$createKey(name) {
    if (name in $1485b5e112c966ab$var$keys) return name + "$" + ++$1485b5e112c966ab$var$keys[name];
    $1485b5e112c966ab$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $1485b5e112c966ab$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $1485b5e112c966ab$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("1krlL", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0f7cdfd9537f6363$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $0f7cdfd9537f6363$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $0f7cdfd9537f6363$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "NodeRange", () => $0f7cdfd9537f6363$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $0f7cdfd9537f6363$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $0f7cdfd9537f6363$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $0f7cdfd9537f6363$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $0f7cdfd9537f6363$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $0f7cdfd9537f6363$export$3476b78f8f5a8b72);

var $6ybul = parcelRequire("6ybul");
function $0f7cdfd9537f6363$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $0f7cdfd9537f6363$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $0f7cdfd9537f6363$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $0f7cdfd9537f6363$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $0f7cdfd9537f6363$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $0f7cdfd9537f6363$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $0f7cdfd9537f6363$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $0f7cdfd9537f6363$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $0f7cdfd9537f6363$var$retIndex(0, pos);
        if (pos == this.size) return $0f7cdfd9537f6363$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $0f7cdfd9537f6363$var$retIndex(i + 1, end);
                return $0f7cdfd9537f6363$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $0f7cdfd9537f6363$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $0f7cdfd9537f6363$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $0f7cdfd9537f6363$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $0f7cdfd9537f6363$export$ffb0004e005737fa.empty;
        if (nodes instanceof $0f7cdfd9537f6363$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $0f7cdfd9537f6363$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $0f7cdfd9537f6363$export$ffb0004e005737fa.empty = new $0f7cdfd9537f6363$export$ffb0004e005737fa([], 0);
const $0f7cdfd9537f6363$var$found = {
    index: 0,
    offset: 0
};
function $0f7cdfd9537f6363$var$retIndex(index, offset) {
    $0f7cdfd9537f6363$var$found.index = index;
    $0f7cdfd9537f6363$var$found.offset = offset;
    return $0f7cdfd9537f6363$var$found;
}
function $0f7cdfd9537f6363$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$0f7cdfd9537f6363$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$0f7cdfd9537f6363$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $0f7cdfd9537f6363$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $0f7cdfd9537f6363$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none;
        if (marks instanceof $0f7cdfd9537f6363$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $0f7cdfd9537f6363$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $0f7cdfd9537f6363$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e($0f7cdfd9537f6363$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e($0f7cdfd9537f6363$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e.empty = new $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e($0f7cdfd9537f6363$export$ffb0004e005737fa.empty, 0, 0);
function $0f7cdfd9537f6363$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($0f7cdfd9537f6363$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $0f7cdfd9537f6363$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $0f7cdfd9537f6363$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $0f7cdfd9537f6363$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $0f7cdfd9537f6363$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $0f7cdfd9537f6363$export$6de0e778727af3f2("Inconsistent open depths");
    return $0f7cdfd9537f6363$var$replaceOuter($from, $to, slice, 0);
}
function $0f7cdfd9537f6363$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $0f7cdfd9537f6363$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $0f7cdfd9537f6363$var$close(node, $0f7cdfd9537f6363$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $0f7cdfd9537f6363$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $0f7cdfd9537f6363$var$prepareSliceForReplace(slice, $from);
        return $0f7cdfd9537f6363$var$close(node, $0f7cdfd9537f6363$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $0f7cdfd9537f6363$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $0f7cdfd9537f6363$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $0f7cdfd9537f6363$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $0f7cdfd9537f6363$var$checkJoin(node, $after.node(depth));
    return node;
}
function $0f7cdfd9537f6363$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $0f7cdfd9537f6363$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $0f7cdfd9537f6363$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$0f7cdfd9537f6363$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $0f7cdfd9537f6363$var$addNode($end.nodeBefore, target);
}
function $0f7cdfd9537f6363$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $0f7cdfd9537f6363$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $0f7cdfd9537f6363$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $0f7cdfd9537f6363$var$joinable($end, $to, depth + 1);
    let content = [];
    $0f7cdfd9537f6363$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $0f7cdfd9537f6363$var$checkJoin(openStart, openEnd);
        $0f7cdfd9537f6363$var$addNode($0f7cdfd9537f6363$var$close(openStart, $0f7cdfd9537f6363$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $0f7cdfd9537f6363$var$addNode($0f7cdfd9537f6363$var$close(openStart, $0f7cdfd9537f6363$var$replaceTwoWay($from, $start, depth + 1)), content);
        $0f7cdfd9537f6363$var$addRange($start, $end, depth, content);
        if (openEnd) $0f7cdfd9537f6363$var$addNode($0f7cdfd9537f6363$var$close(openEnd, $0f7cdfd9537f6363$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $0f7cdfd9537f6363$var$addRange($to, null, depth, content);
    return new $0f7cdfd9537f6363$export$ffb0004e005737fa(content);
}
function $0f7cdfd9537f6363$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $0f7cdfd9537f6363$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $0f7cdfd9537f6363$var$joinable($from, $to, depth + 1);
        $0f7cdfd9537f6363$var$addNode($0f7cdfd9537f6363$var$close(type, $0f7cdfd9537f6363$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $0f7cdfd9537f6363$var$addRange($to, null, depth, content);
    return new $0f7cdfd9537f6363$export$ffb0004e005737fa(content);
}
function $0f7cdfd9537f6363$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($0f7cdfd9537f6363$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $0f7cdfd9537f6363$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $0f7cdfd9537f6363$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $0f7cdfd9537f6363$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $0f7cdfd9537f6363$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $0f7cdfd9537f6363$var$resolveCache.set(doc, cache = new $0f7cdfd9537f6363$var$ResolveCache);
        let result = cache.elts[cache.i] = $0f7cdfd9537f6363$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $0f7cdfd9537f6363$var$resolveCacheSize;
        return result;
    }
}
class $0f7cdfd9537f6363$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $0f7cdfd9537f6363$var$resolveCacheSize = 12, $0f7cdfd9537f6363$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $0f7cdfd9537f6363$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $0f7cdfd9537f6363$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $0f7cdfd9537f6363$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $0f7cdfd9537f6363$export$ffb0004e005737fa.empty;
    }
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $0f7cdfd9537f6363$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $0f7cdfd9537f6363$var$emptyAttrs) && $0f7cdfd9537f6363$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $0f7cdfd9537f6363$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $0f7cdfd9537f6363$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $0f7cdfd9537f6363$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $0f7cdfd9537f6363$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $0f7cdfd9537f6363$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $0f7cdfd9537f6363$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $0f7cdfd9537f6363$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$0f7cdfd9537f6363$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $0f7cdfd9537f6363$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
}
$0f7cdfd9537f6363$export$85c928794f8d04d4.prototype.text = undefined;
class $0f7cdfd9537f6363$var$TextNode extends $0f7cdfd9537f6363$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $0f7cdfd9537f6363$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $0f7cdfd9537f6363$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $0f7cdfd9537f6363$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $0f7cdfd9537f6363$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $0f7cdfd9537f6363$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $0f7cdfd9537f6363$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $0f7cdfd9537f6363$export$364ed450558d7ec4.empty;
        let expr = $0f7cdfd9537f6363$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $0f7cdfd9537f6363$var$dfa($0f7cdfd9537f6363$var$nfa(expr));
        $0f7cdfd9537f6363$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $0f7cdfd9537f6363$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $0f7cdfd9537f6363$export$364ed450558d7ec4.empty = new $0f7cdfd9537f6363$export$364ed450558d7ec4(true);
class $0f7cdfd9537f6363$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $0f7cdfd9537f6363$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($0f7cdfd9537f6363$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $0f7cdfd9537f6363$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($0f7cdfd9537f6363$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $0f7cdfd9537f6363$var$parseExprSubscript(stream) {
    let expr = $0f7cdfd9537f6363$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $0f7cdfd9537f6363$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $0f7cdfd9537f6363$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $0f7cdfd9537f6363$var$parseExprRange(stream, expr) {
    let min = $0f7cdfd9537f6363$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $0f7cdfd9537f6363$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $0f7cdfd9537f6363$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $0f7cdfd9537f6363$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $0f7cdfd9537f6363$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $0f7cdfd9537f6363$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $0f7cdfd9537f6363$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $0f7cdfd9537f6363$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $0f7cdfd9537f6363$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($0f7cdfd9537f6363$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $0f7cdfd9537f6363$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($0f7cdfd9537f6363$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $0f7cdfd9537f6363$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $0f7cdfd9537f6363$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($0f7cdfd9537f6363$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $0f7cdfd9537f6363$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $0f7cdfd9537f6363$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $0f7cdfd9537f6363$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $0f7cdfd9537f6363$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $0f7cdfd9537f6363$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $0f7cdfd9537f6363$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $0f7cdfd9537f6363$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $0f7cdfd9537f6363$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $0f7cdfd9537f6363$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $0f7cdfd9537f6363$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $0f7cdfd9537f6363$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $0f7cdfd9537f6363$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $0f7cdfd9537f6363$export$ffb0004e005737fa.from(content), $0f7cdfd9537f6363$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $0f7cdfd9537f6363$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $0f7cdfd9537f6363$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $0f7cdfd9537f6363$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $0f7cdfd9537f6363$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($0f7cdfd9537f6363$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $0f7cdfd9537f6363$export$85c928794f8d04d4(this, attrs, content.append(after), $0f7cdfd9537f6363$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $0f7cdfd9537f6363$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $0f7cdfd9537f6363$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
function $0f7cdfd9537f6363$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $0f7cdfd9537f6363$var$Attribute {
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $0f7cdfd9537f6363$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $0f7cdfd9537f6363$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $0f7cdfd9537f6363$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $0f7cdfd9537f6363$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $0f7cdfd9537f6363$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $0f7cdfd9537f6363$export$c9d15bcfc6d42044(this, $0f7cdfd9537f6363$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $0f7cdfd9537f6363$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $0f7cdfd9537f6363$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $0f7cdfd9537f6363$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $6ybul.default).from(spec.nodes), instanceSpec.marks = (0, $6ybul.default).from(spec.marks || {}), this.nodes = $0f7cdfd9537f6363$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $0f7cdfd9537f6363$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $0f7cdfd9537f6363$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $0f7cdfd9537f6363$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $0f7cdfd9537f6363$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $0f7cdfd9537f6363$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $0f7cdfd9537f6363$var$TextNode(type, type.defaultAttrs, text, $0f7cdfd9537f6363$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $0f7cdfd9537f6363$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $0f7cdfd9537f6363$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $0f7cdfd9537f6363$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $0f7cdfd9537f6363$var$isTagRule(rule) {
    return rule.tag != null;
}
function $0f7cdfd9537f6363$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $0f7cdfd9537f6363$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($0f7cdfd9537f6363$var$isTagRule(rule)) this.tags.push(rule);
            else if ($0f7cdfd9537f6363$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $0f7cdfd9537f6363$var$ParseContext(this, options, false);
        context.addAll(dom, $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $0f7cdfd9537f6363$var$ParseContext(this, options, true);
        context.addAll(dom, $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $0f7cdfd9537f6363$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($0f7cdfd9537f6363$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $0f7cdfd9537f6363$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $0f7cdfd9537f6363$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $0f7cdfd9537f6363$export$1059c6e7d2ce5669(schema, $0f7cdfd9537f6363$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $0f7cdfd9537f6363$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $0f7cdfd9537f6363$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $0f7cdfd9537f6363$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $0f7cdfd9537f6363$var$OPT_PRESERVE_WS = 1, $0f7cdfd9537f6363$var$OPT_PRESERVE_WS_FULL = 2, $0f7cdfd9537f6363$var$OPT_OPEN_LEFT = 4;
function $0f7cdfd9537f6363$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $0f7cdfd9537f6363$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $0f7cdfd9537f6363$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $0f7cdfd9537f6363$var$OPT_PRESERVE_WS | $0f7cdfd9537f6363$var$OPT_PRESERVE_WS_FULL : base & ~$0f7cdfd9537f6363$var$OPT_OPEN_LEFT;
}
class $0f7cdfd9537f6363$var$NodeContext {
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $0f7cdfd9537f6363$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($0f7cdfd9537f6363$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $0f7cdfd9537f6363$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $0f7cdfd9537f6363$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($0f7cdfd9537f6363$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$0f7cdfd9537f6363$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $0f7cdfd9537f6363$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $0f7cdfd9537f6363$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $0f7cdfd9537f6363$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $0f7cdfd9537f6363$var$NodeContext(topNode.type, topNode.attrs, $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $0f7cdfd9537f6363$var$NodeContext(null, null, $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $0f7cdfd9537f6363$var$NodeContext(parser.schema.topNodeType, null, $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $0f7cdfd9537f6363$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $0f7cdfd9537f6363$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($0f7cdfd9537f6363$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $0f7cdfd9537f6363$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $0f7cdfd9537f6363$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($0f7cdfd9537f6363$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $0f7cdfd9537f6363$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $0f7cdfd9537f6363$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $0f7cdfd9537f6363$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $0f7cdfd9537f6363$var$OPT_OPEN_LEFT;
        let applyMarks = $0f7cdfd9537f6363$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $0f7cdfd9537f6363$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $0f7cdfd9537f6363$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $0f7cdfd9537f6363$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $0f7cdfd9537f6363$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $0f7cdfd9537f6363$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $0f7cdfd9537f6363$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $0f7cdfd9537f6363$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $0f7cdfd9537f6363$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $0f7cdfd9537f6363$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $0f7cdfd9537f6363$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $0f7cdfd9537f6363$var$renderSpec($0f7cdfd9537f6363$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $0f7cdfd9537f6363$var$renderSpec($0f7cdfd9537f6363$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $0f7cdfd9537f6363$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $0f7cdfd9537f6363$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $0f7cdfd9537f6363$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $0f7cdfd9537f6363$var$gatherToDOM(schema.marks);
    }
}
function $0f7cdfd9537f6363$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $0f7cdfd9537f6363$var$doc(options) {
    return options.document || window.document;
}
const $0f7cdfd9537f6363$var$suspiciousAttributeCache = new WeakMap();
function $0f7cdfd9537f6363$var$suspiciousAttributes(attrs) {
    let value = $0f7cdfd9537f6363$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $0f7cdfd9537f6363$var$suspiciousAttributeCache.set(attrs, value = $0f7cdfd9537f6363$var$suspiciousAttributesInner(attrs));
    return value;
}
function $0f7cdfd9537f6363$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $0f7cdfd9537f6363$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $0f7cdfd9537f6363$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $0f7cdfd9537f6363$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}

});
parcelRegister("6ybul", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c4ed464a3187d83$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $4c4ed464a3187d83$var$OrderedMap(content) {
    this.content = content;
}
$4c4ed464a3187d83$var$OrderedMap.prototype = {
    constructor: $4c4ed464a3187d83$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $4c4ed464a3187d83$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $4c4ed464a3187d83$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $4c4ed464a3187d83$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $4c4ed464a3187d83$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $4c4ed464a3187d83$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $4c4ed464a3187d83$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $4c4ed464a3187d83$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $4c4ed464a3187d83$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $4c4ed464a3187d83$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $4c4ed464a3187d83$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$4c4ed464a3187d83$var$OrderedMap.from = function(value) {
    if (value instanceof $4c4ed464a3187d83$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $4c4ed464a3187d83$var$OrderedMap(content);
};
var $4c4ed464a3187d83$export$2e2bcd8739ae039 = $4c4ed464a3187d83$var$OrderedMap;

});


parcelRegister("gfgdn", function(module, exports) {

$parcel$export(module.exports, "Mapping", () => $bd3a9ff77fa05947$export$f5f785078011b62);
$parcel$export(module.exports, "ReplaceStep", () => $bd3a9ff77fa05947$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $bd3a9ff77fa05947$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $bd3a9ff77fa05947$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $bd3a9ff77fa05947$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $bd3a9ff77fa05947$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $bd3a9ff77fa05947$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $bd3a9ff77fa05947$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "dropPoint", () => $bd3a9ff77fa05947$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $bd3a9ff77fa05947$export$ed6ac67359824afd);
$parcel$export(module.exports, "Transform", () => $bd3a9ff77fa05947$export$563a914cafbdc389);

var $1krlL = parcelRequire("1krlL");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $bd3a9ff77fa05947$var$lower16 = 0xffff;
const $bd3a9ff77fa05947$var$factor16 = Math.pow(2, 16);
function $bd3a9ff77fa05947$var$makeRecover(index, offset) {
    return index + offset * $bd3a9ff77fa05947$var$factor16;
}
function $bd3a9ff77fa05947$var$recoverIndex(value) {
    return value & $bd3a9ff77fa05947$var$lower16;
}
function $bd3a9ff77fa05947$var$recoverOffset(value) {
    return (value - (value & $bd3a9ff77fa05947$var$lower16)) / $bd3a9ff77fa05947$var$factor16;
}
const $bd3a9ff77fa05947$var$DEL_BEFORE = 1, $bd3a9ff77fa05947$var$DEL_AFTER = 2, $bd3a9ff77fa05947$var$DEL_ACROSS = 4, $bd3a9ff77fa05947$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $bd3a9ff77fa05947$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $bd3a9ff77fa05947$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($bd3a9ff77fa05947$var$DEL_BEFORE | $bd3a9ff77fa05947$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($bd3a9ff77fa05947$var$DEL_AFTER | $bd3a9ff77fa05947$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $bd3a9ff77fa05947$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $bd3a9ff77fa05947$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $bd3a9ff77fa05947$export$c53d01c3ab9721b3.empty) return $bd3a9ff77fa05947$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $bd3a9ff77fa05947$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $bd3a9ff77fa05947$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $bd3a9ff77fa05947$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $bd3a9ff77fa05947$var$DEL_AFTER : pos == end ? $bd3a9ff77fa05947$var$DEL_BEFORE : $bd3a9ff77fa05947$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $bd3a9ff77fa05947$var$DEL_SIDE;
                return new $bd3a9ff77fa05947$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $bd3a9ff77fa05947$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $bd3a9ff77fa05947$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $bd3a9ff77fa05947$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $bd3a9ff77fa05947$export$c53d01c3ab9721b3.empty : new $bd3a9ff77fa05947$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $bd3a9ff77fa05947$export$c53d01c3ab9721b3.empty = new $bd3a9ff77fa05947$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $bd3a9ff77fa05947$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $bd3a9ff77fa05947$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $bd3a9ff77fa05947$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $bd3a9ff77fa05947$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $bd3a9ff77fa05947$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $bd3a9ff77fa05947$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $bd3a9ff77fa05947$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $bd3a9ff77fa05947$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $bd3a9ff77fa05947$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $bd3a9ff77fa05947$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $bd3a9ff77fa05947$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $bd3a9ff77fa05947$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $bd3a9ff77fa05947$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $bd3a9ff77fa05947$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $1krlL.ReplaceError)) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $bd3a9ff77fa05947$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($bd3a9ff77fa05947$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $1krlL.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $bd3a9ff77fa05947$export$d24ba56b0e3464a9 extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $1krlL.Slice)($bd3a9ff77fa05947$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $bd3a9ff77fa05947$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $bd3a9ff77fa05947$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $bd3a9ff77fa05947$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $bd3a9ff77fa05947$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $bd3a9ff77fa05947$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("addMark", $bd3a9ff77fa05947$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $bd3a9ff77fa05947$export$94150db1311f67a9 extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $1krlL.Slice)($bd3a9ff77fa05947$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $bd3a9ff77fa05947$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $bd3a9ff77fa05947$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $bd3a9ff77fa05947$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $bd3a9ff77fa05947$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $bd3a9ff77fa05947$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("removeMark", $bd3a9ff77fa05947$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $bd3a9ff77fa05947$export$adefd16c402fee4e extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $bd3a9ff77fa05947$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $bd3a9ff77fa05947$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $bd3a9ff77fa05947$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $bd3a9ff77fa05947$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $bd3a9ff77fa05947$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("addNodeMark", $bd3a9ff77fa05947$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $bd3a9ff77fa05947$export$fdf7d1dc10724da2 extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $bd3a9ff77fa05947$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $bd3a9ff77fa05947$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $bd3a9ff77fa05947$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("removeNodeMark", $bd3a9ff77fa05947$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $bd3a9ff77fa05947$export$5c860b2e74034756 extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $bd3a9ff77fa05947$var$contentBetween(doc, this.from, this.to)) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $bd3a9ff77fa05947$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $bd3a9ff77fa05947$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $bd3a9ff77fa05947$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $bd3a9ff77fa05947$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $1krlL.Slice).empty : new (0, $1krlL.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $bd3a9ff77fa05947$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $1krlL.Slice).empty : new (0, $1krlL.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $bd3a9ff77fa05947$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $bd3a9ff77fa05947$export$5c860b2e74034756(json.from, json.to, (0, $1krlL.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("replace", $bd3a9ff77fa05947$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $bd3a9ff77fa05947$export$444ba800d6024a98 extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($bd3a9ff77fa05947$var$contentBetween(doc, this.from, this.gapFrom) || $bd3a9ff77fa05947$var$contentBetween(doc, this.gapTo, this.to))) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $bd3a9ff77fa05947$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $bd3a9ff77fa05947$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $bd3a9ff77fa05947$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $bd3a9ff77fa05947$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $1krlL.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("replaceAround", $bd3a9ff77fa05947$export$444ba800d6024a98);
function $bd3a9ff77fa05947$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $bd3a9ff77fa05947$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $bd3a9ff77fa05947$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $bd3a9ff77fa05947$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $bd3a9ff77fa05947$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $1krlL.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $bd3a9ff77fa05947$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $bd3a9ff77fa05947$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $bd3a9ff77fa05947$export$5c860b2e74034756(cur, end, (0, $1krlL.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $bd3a9ff77fa05947$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $bd3a9ff77fa05947$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $1krlL.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $1krlL.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $bd3a9ff77fa05947$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $bd3a9ff77fa05947$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$bd3a9ff77fa05947$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $bd3a9ff77fa05947$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $1krlL.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $1krlL.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $1krlL.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $1krlL.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $bd3a9ff77fa05947$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $1krlL.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $bd3a9ff77fa05947$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $bd3a9ff77fa05947$var$findWrappingOutside(range, nodeType);
    let inner = around && $bd3a9ff77fa05947$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($bd3a9ff77fa05947$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($bd3a9ff77fa05947$var$withAttrs));
}
function $bd3a9ff77fa05947$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $bd3a9ff77fa05947$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $bd3a9ff77fa05947$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $bd3a9ff77fa05947$var$wrap(tr, range, wrappers) {
    let content = (0, $1krlL.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $1krlL.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $bd3a9ff77fa05947$export$444ba800d6024a98(start, end, start, end, new (0, $1krlL.Slice)(content, 0, 0), wrappers.length, true));
}
function $bd3a9ff77fa05947$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $bd3a9ff77fa05947$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $bd3a9ff77fa05947$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $bd3a9ff77fa05947$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $bd3a9ff77fa05947$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $bd3a9ff77fa05947$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $bd3a9ff77fa05947$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $bd3a9ff77fa05947$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $bd3a9ff77fa05947$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $bd3a9ff77fa05947$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $bd3a9ff77fa05947$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $bd3a9ff77fa05947$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $bd3a9ff77fa05947$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $1krlL.Fragment).empty, after = (0, $1krlL.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $1krlL.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $1krlL.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $bd3a9ff77fa05947$export$5c860b2e74034756(pos, pos, new (0, $1krlL.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $bd3a9ff77fa05947$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $bd3a9ff77fa05947$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $bd3a9ff77fa05947$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $bd3a9ff77fa05947$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $bd3a9ff77fa05947$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $bd3a9ff77fa05947$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $bd3a9ff77fa05947$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $bd3a9ff77fa05947$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $bd3a9ff77fa05947$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $bd3a9ff77fa05947$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $bd3a9ff77fa05947$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $1krlL.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $bd3a9ff77fa05947$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $bd3a9ff77fa05947$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $bd3a9ff77fa05947$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $bd3a9ff77fa05947$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $1krlL.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($bd3a9ff77fa05947$var$fitsTrivially($from, $to, slice)) return new $bd3a9ff77fa05947$export$5c860b2e74034756(from, to, slice);
    return new $bd3a9ff77fa05947$var$Fitter($from, $to, slice).fit();
}
function $bd3a9ff77fa05947$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $bd3a9ff77fa05947$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $1krlL.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $1krlL.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $1krlL.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $bd3a9ff77fa05947$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $bd3a9ff77fa05947$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $bd3a9ff77fa05947$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $1krlL.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $bd3a9ff77fa05947$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $1krlL.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $bd3a9ff77fa05947$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $1krlL.Slice)($bd3a9ff77fa05947$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $1krlL.Slice)($bd3a9ff77fa05947$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($bd3a9ff77fa05947$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $bd3a9ff77fa05947$var$addToFragment(this.placed, frontierDepth, (0, $1krlL.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $1krlL.Slice)($bd3a9ff77fa05947$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $1krlL.Slice).empty : new (0, $1krlL.Slice)($bd3a9ff77fa05947$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$bd3a9ff77fa05947$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $bd3a9ff77fa05947$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $bd3a9ff77fa05947$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $bd3a9ff77fa05947$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $bd3a9ff77fa05947$var$addToFragment(this.placed, this.depth, (0, $1krlL.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $1krlL.Fragment).empty, true);
        if (add.childCount) this.placed = $bd3a9ff77fa05947$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $bd3a9ff77fa05947$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($bd3a9ff77fa05947$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $bd3a9ff77fa05947$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($bd3a9ff77fa05947$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $bd3a9ff77fa05947$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $bd3a9ff77fa05947$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $bd3a9ff77fa05947$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $1krlL.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $bd3a9ff77fa05947$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$bd3a9ff77fa05947$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $bd3a9ff77fa05947$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $bd3a9ff77fa05947$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $bd3a9ff77fa05947$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($bd3a9ff77fa05947$var$fitsTrivially($from, $to, slice)) return tr.step(new $bd3a9ff77fa05947$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $bd3a9ff77fa05947$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $bd3a9ff77fa05947$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $1krlL.Slice)($bd3a9ff77fa05947$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $bd3a9ff77fa05947$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($bd3a9ff77fa05947$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $1krlL.Fragment).empty, true));
    }
    return fragment;
}
function $bd3a9ff77fa05947$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $bd3a9ff77fa05947$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(node), 0, 0));
}
function $bd3a9ff77fa05947$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $bd3a9ff77fa05947$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $bd3a9ff77fa05947$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $bd3a9ff77fa05947$export$626399c38172f669 extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $bd3a9ff77fa05947$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $bd3a9ff77fa05947$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $bd3a9ff77fa05947$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $bd3a9ff77fa05947$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("attr", $bd3a9ff77fa05947$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $bd3a9ff77fa05947$export$f50707b396300ac9 extends $bd3a9ff77fa05947$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $bd3a9ff77fa05947$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $bd3a9ff77fa05947$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $bd3a9ff77fa05947$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $bd3a9ff77fa05947$export$f50707b396300ac9(json.attr, json.value);
    }
}
$bd3a9ff77fa05947$export$fd55ce593607084a.jsonID("docAttr", $bd3a9ff77fa05947$export$f50707b396300ac9);
/**
@internal
*/ let $bd3a9ff77fa05947$export$88cc3a1dfce48dd3 = class extends Error {
};
$bd3a9ff77fa05947$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$bd3a9ff77fa05947$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$bd3a9ff77fa05947$export$88cc3a1dfce48dd3.prototype.constructor = $bd3a9ff77fa05947$export$88cc3a1dfce48dd3;
$bd3a9ff77fa05947$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $bd3a9ff77fa05947$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $bd3a9ff77fa05947$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $bd3a9ff77fa05947$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $1krlL.Slice).empty) {
        let step = $bd3a9ff77fa05947$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $1krlL.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $bd3a9ff77fa05947$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $bd3a9ff77fa05947$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $bd3a9ff77fa05947$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $bd3a9ff77fa05947$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $bd3a9ff77fa05947$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $bd3a9ff77fa05947$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $bd3a9ff77fa05947$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $bd3a9ff77fa05947$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $bd3a9ff77fa05947$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $bd3a9ff77fa05947$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $bd3a9ff77fa05947$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $1krlL.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $bd3a9ff77fa05947$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $bd3a9ff77fa05947$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $bd3a9ff77fa05947$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $bd3a9ff77fa05947$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $bd3a9ff77fa05947$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});



parcelRegister("cXOg4", function(module, exports) {
$parcel$export(module.exports, "Decoration", () => (parcelRequire("edQEX")).Decoration);
$parcel$export(module.exports, "DecorationSet", () => (parcelRequire("edQEX")).DecorationSet);
$parcel$export(module.exports, "EditorView", () => (parcelRequire("edQEX")).EditorView);
// view/index.ts
parcelRequire("edQEX");

});
parcelRegister("edQEX", function(module, exports) {

$parcel$export(module.exports, "Decoration", () => $a5ab20b42a0afbae$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $a5ab20b42a0afbae$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $a5ab20b42a0afbae$export$eece2fccabbb77c5);

var $1LeRC = parcelRequire("1LeRC");

var $1krlL = parcelRequire("1krlL");

var $gfgdn = parcelRequire("gfgdn");
const $a5ab20b42a0afbae$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $a5ab20b42a0afbae$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $a5ab20b42a0afbae$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $a5ab20b42a0afbae$var$textRange = function(node, from, to) {
    let range = $a5ab20b42a0afbae$var$reusedRange || ($a5ab20b42a0afbae$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $a5ab20b42a0afbae$var$clearReusedRange = function() {
    $a5ab20b42a0afbae$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $a5ab20b42a0afbae$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($a5ab20b42a0afbae$var$scanFor(node, off, targetNode, targetOff, -1) || $a5ab20b42a0afbae$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $a5ab20b42a0afbae$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $a5ab20b42a0afbae$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $a5ab20b42a0afbae$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $a5ab20b42a0afbae$var$hasBlockDesc(node) || $a5ab20b42a0afbae$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $a5ab20b42a0afbae$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $a5ab20b42a0afbae$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $a5ab20b42a0afbae$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $a5ab20b42a0afbae$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $a5ab20b42a0afbae$var$nodeSize(node);
        } else if (node.parentNode && !$a5ab20b42a0afbae$var$hasBlockDesc(node)) {
            offset = $a5ab20b42a0afbae$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $a5ab20b42a0afbae$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$a5ab20b42a0afbae$var$hasBlockDesc(node)) {
            offset = $a5ab20b42a0afbae$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $a5ab20b42a0afbae$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $a5ab20b42a0afbae$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $a5ab20b42a0afbae$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $a5ab20b42a0afbae$var$nodeSize(node);
    }
}
function $a5ab20b42a0afbae$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $a5ab20b42a0afbae$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $a5ab20b42a0afbae$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $a5ab20b42a0afbae$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $a5ab20b42a0afbae$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $a5ab20b42a0afbae$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        // Clip the offset, because Chrome will return a text offset
        // into <input> nodes, which can't be treated as a regular DOM
        // offset
        if (pos) return {
            node: pos.offsetNode,
            offset: Math.min($a5ab20b42a0afbae$var$nodeSize(pos.offsetNode), pos.offset)
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: Math.min($a5ab20b42a0afbae$var$nodeSize(range.startContainer), range.startOffset)
        };
    }
}
const $a5ab20b42a0afbae$var$nav = typeof navigator != "undefined" ? navigator : null;
const $a5ab20b42a0afbae$var$doc = typeof document != "undefined" ? document : null;
const $a5ab20b42a0afbae$var$agent = $a5ab20b42a0afbae$var$nav && $a5ab20b42a0afbae$var$nav.userAgent || "";
const $a5ab20b42a0afbae$var$ie_edge = /Edge\/(\d+)/.exec($a5ab20b42a0afbae$var$agent);
const $a5ab20b42a0afbae$var$ie_upto10 = /MSIE \d/.exec($a5ab20b42a0afbae$var$agent);
const $a5ab20b42a0afbae$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($a5ab20b42a0afbae$var$agent);
const $a5ab20b42a0afbae$var$ie = !!($a5ab20b42a0afbae$var$ie_upto10 || $a5ab20b42a0afbae$var$ie_11up || $a5ab20b42a0afbae$var$ie_edge);
const $a5ab20b42a0afbae$var$ie_version = $a5ab20b42a0afbae$var$ie_upto10 ? document.documentMode : $a5ab20b42a0afbae$var$ie_11up ? +$a5ab20b42a0afbae$var$ie_11up[1] : $a5ab20b42a0afbae$var$ie_edge ? +$a5ab20b42a0afbae$var$ie_edge[1] : 0;
const $a5ab20b42a0afbae$var$gecko = !$a5ab20b42a0afbae$var$ie && /gecko\/(\d+)/i.test($a5ab20b42a0afbae$var$agent);
$a5ab20b42a0afbae$var$gecko && (/Firefox\/(\d+)/.exec($a5ab20b42a0afbae$var$agent) || [
    0,
    0
])[1];
const $a5ab20b42a0afbae$var$_chrome = !$a5ab20b42a0afbae$var$ie && /Chrome\/(\d+)/.exec($a5ab20b42a0afbae$var$agent);
const $a5ab20b42a0afbae$var$chrome = !!$a5ab20b42a0afbae$var$_chrome;
const $a5ab20b42a0afbae$var$chrome_version = $a5ab20b42a0afbae$var$_chrome ? +$a5ab20b42a0afbae$var$_chrome[1] : 0;
const $a5ab20b42a0afbae$var$safari = !$a5ab20b42a0afbae$var$ie && !!$a5ab20b42a0afbae$var$nav && /Apple Computer/.test($a5ab20b42a0afbae$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $a5ab20b42a0afbae$var$ios = $a5ab20b42a0afbae$var$safari && (/Mobile\/\w+/.test($a5ab20b42a0afbae$var$agent) || !!$a5ab20b42a0afbae$var$nav && $a5ab20b42a0afbae$var$nav.maxTouchPoints > 2);
const $a5ab20b42a0afbae$var$mac = $a5ab20b42a0afbae$var$ios || ($a5ab20b42a0afbae$var$nav ? /Mac/.test($a5ab20b42a0afbae$var$nav.platform) : false);
const $a5ab20b42a0afbae$var$windows = $a5ab20b42a0afbae$var$nav ? /Win/.test($a5ab20b42a0afbae$var$nav.platform) : false;
const $a5ab20b42a0afbae$var$android = /Android \d/.test($a5ab20b42a0afbae$var$agent);
const $a5ab20b42a0afbae$var$webkit = !!$a5ab20b42a0afbae$var$doc && "webkitFontSmoothing" in $a5ab20b42a0afbae$var$doc.documentElement.style;
const $a5ab20b42a0afbae$var$webkit_version = $a5ab20b42a0afbae$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $a5ab20b42a0afbae$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $a5ab20b42a0afbae$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $a5ab20b42a0afbae$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $a5ab20b42a0afbae$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $a5ab20b42a0afbae$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $a5ab20b42a0afbae$var$windowRect(doc) : $a5ab20b42a0afbae$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $a5ab20b42a0afbae$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $a5ab20b42a0afbae$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $a5ab20b42a0afbae$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $a5ab20b42a0afbae$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $a5ab20b42a0afbae$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $a5ab20b42a0afbae$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $a5ab20b42a0afbae$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $a5ab20b42a0afbae$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $a5ab20b42a0afbae$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $a5ab20b42a0afbae$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $a5ab20b42a0afbae$var$scrollStack(view.dom)
    };
}
function $a5ab20b42a0afbae$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $a5ab20b42a0afbae$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $a5ab20b42a0afbae$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $a5ab20b42a0afbae$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $a5ab20b42a0afbae$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $a5ab20b42a0afbae$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $a5ab20b42a0afbae$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($a5ab20b42a0afbae$var$preventScrollSupported) return dom.focus($a5ab20b42a0afbae$var$preventScrollSupported);
    let stored = $a5ab20b42a0afbae$var$scrollStack(dom);
    dom.focus($a5ab20b42a0afbae$var$preventScrollSupported == null ? {
        get preventScroll () {
            $a5ab20b42a0afbae$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$a5ab20b42a0afbae$var$preventScrollSupported) {
        $a5ab20b42a0afbae$var$preventScrollSupported = false;
        $a5ab20b42a0afbae$var$restoreScrollStack(stored, 0);
    }
}
function $a5ab20b42a0afbae$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $a5ab20b42a0afbae$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $a5ab20b42a0afbae$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $a5ab20b42a0afbae$var$findOffsetInNode(closest, coordsClosest);
}
function $a5ab20b42a0afbae$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $a5ab20b42a0afbae$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($a5ab20b42a0afbae$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $a5ab20b42a0afbae$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $a5ab20b42a0afbae$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $a5ab20b42a0afbae$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $a5ab20b42a0afbae$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $a5ab20b42a0afbae$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true), rect;
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent || !desc.contentDOM) && // Ignore elements with zero-size bounding rectangles
        ((rect = desc.dom.getBoundingClientRect()).width || rect.height)) {
            if (desc.node.isBlock && desc.parent) {
                // Only apply the horizontal test to the innermost block. Vertical for any parent.
                if (!sawBlock && rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (!sawBlock && rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
                sawBlock = true;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $a5ab20b42a0afbae$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($a5ab20b42a0afbae$var$inRect(coords, rect)) return $a5ab20b42a0afbae$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $a5ab20b42a0afbae$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $a5ab20b42a0afbae$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$a5ab20b42a0afbae$var$inRect(coords, box)) return null;
        elt = $a5ab20b42a0afbae$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($a5ab20b42a0afbae$var$safari) {
        for(let p = elt; node && p; p = $a5ab20b42a0afbae$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $a5ab20b42a0afbae$var$targetKludge(elt, coords);
    if (node) {
        if ($a5ab20b42a0afbae$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($a5ab20b42a0afbae$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $a5ab20b42a0afbae$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $a5ab20b42a0afbae$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $a5ab20b42a0afbae$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $a5ab20b42a0afbae$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($a5ab20b42a0afbae$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $a5ab20b42a0afbae$var$nonZero) || target.getBoundingClientRect();
}
const $a5ab20b42a0afbae$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $a5ab20b42a0afbae$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $a5ab20b42a0afbae$var$webkit || $a5ab20b42a0afbae$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($a5ab20b42a0afbae$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $a5ab20b42a0afbae$var$singleRect($a5ab20b42a0afbae$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($a5ab20b42a0afbae$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $a5ab20b42a0afbae$var$singleRect($a5ab20b42a0afbae$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $a5ab20b42a0afbae$var$singleRect($a5ab20b42a0afbae$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $a5ab20b42a0afbae$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $a5ab20b42a0afbae$var$flattenV($a5ab20b42a0afbae$var$singleRect($a5ab20b42a0afbae$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $a5ab20b42a0afbae$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $a5ab20b42a0afbae$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $a5ab20b42a0afbae$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $a5ab20b42a0afbae$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $a5ab20b42a0afbae$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $a5ab20b42a0afbae$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $a5ab20b42a0afbae$var$textRange(before, $a5ab20b42a0afbae$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $a5ab20b42a0afbae$var$flattenV($a5ab20b42a0afbae$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $a5ab20b42a0afbae$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $a5ab20b42a0afbae$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $a5ab20b42a0afbae$var$flattenV($a5ab20b42a0afbae$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $a5ab20b42a0afbae$var$flattenV($a5ab20b42a0afbae$var$singleRect(node.nodeType == 3 ? $a5ab20b42a0afbae$var$textRange(node) : node, -side), side >= 0);
}
function $a5ab20b42a0afbae$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $a5ab20b42a0afbae$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $a5ab20b42a0afbae$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $a5ab20b42a0afbae$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $a5ab20b42a0afbae$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $a5ab20b42a0afbae$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $a5ab20b42a0afbae$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $a5ab20b42a0afbae$var$maybeRTL = /[\u0590-\u08ac]/;
function $a5ab20b42a0afbae$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    if (!sel) return $head.pos == $head.start() || $head.pos == $head.end();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$a5ab20b42a0afbae$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $a5ab20b42a0afbae$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $a5ab20b42a0afbae$var$cachedState = null;
let $a5ab20b42a0afbae$var$cachedDir = null;
let $a5ab20b42a0afbae$var$cachedResult = false;
function $a5ab20b42a0afbae$var$endOfTextblock(view, state, dir) {
    if ($a5ab20b42a0afbae$var$cachedState == state && $a5ab20b42a0afbae$var$cachedDir == dir) return $a5ab20b42a0afbae$var$cachedResult;
    $a5ab20b42a0afbae$var$cachedState = state;
    $a5ab20b42a0afbae$var$cachedDir = dir;
    return $a5ab20b42a0afbae$var$cachedResult = dir == "up" || dir == "down" ? $a5ab20b42a0afbae$var$endOfTextblockVertical(view, state, dir) : $a5ab20b42a0afbae$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $a5ab20b42a0afbae$var$NOT_DIRTY = 0, $a5ab20b42a0afbae$var$CHILD_DIRTY = 1, $a5ab20b42a0afbae$var$CONTENT_DIRTY = 2, $a5ab20b42a0afbae$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $a5ab20b42a0afbae$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $a5ab20b42a0afbae$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $a5ab20b42a0afbae$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)for(let i = 0; i < child.children.length; i++){
                    let inner = child.children[i];
                    if (inner.size) {
                        child = inner;
                        break;
                    }
                }
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $a5ab20b42a0afbae$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $a5ab20b42a0afbae$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $a5ab20b42a0afbae$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $a5ab20b42a0afbae$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $a5ab20b42a0afbae$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $a5ab20b42a0afbae$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, view, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, view, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = view.root.getSelection();
        let selRange = view.domSelectionRange();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($a5ab20b42a0afbae$var$gecko || $a5ab20b42a0afbae$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $a5ab20b42a0afbae$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($a5ab20b42a0afbae$var$gecko && selRange.focusNode && selRange.focusNode != headDOM.node && selRange.focusNode.nodeType == 1) {
            let after = selRange.focusNode.childNodes[selRange.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $a5ab20b42a0afbae$var$safari) && $a5ab20b42a0afbae$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, selRange.anchorNode, selRange.anchorOffset) && $a5ab20b42a0afbae$var$isEquivalentPosition(headDOM.node, headDOM.offset, selRange.focusNode, selRange.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $a5ab20b42a0afbae$var$CONTENT_DIRTY : $a5ab20b42a0afbae$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $a5ab20b42a0afbae$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $a5ab20b42a0afbae$var$CONTENT_DIRTY : $a5ab20b42a0afbae$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $a5ab20b42a0afbae$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $a5ab20b42a0afbae$var$CONTENT_DIRTY : $a5ab20b42a0afbae$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $a5ab20b42a0afbae$var$WidgetViewDesc extends $a5ab20b42a0afbae$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $a5ab20b42a0afbae$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $a5ab20b42a0afbae$var$CompositionViewDesc extends $a5ab20b42a0afbae$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $a5ab20b42a0afbae$var$MarkViewDesc extends $a5ab20b42a0afbae$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM, spec){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
        this.spec = spec;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $1krlL.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline), null, mark.attrs);
        return new $a5ab20b42a0afbae$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom, spec);
    }
    parseRule() {
        if (this.dirty & $a5ab20b42a0afbae$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $a5ab20b42a0afbae$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $a5ab20b42a0afbae$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $a5ab20b42a0afbae$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $a5ab20b42a0afbae$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $a5ab20b42a0afbae$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $a5ab20b42a0afbae$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $a5ab20b42a0afbae$var$NodeViewDesc extends $a5ab20b42a0afbae$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) {
            let spec = (0, $1krlL.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node), null, node.attrs);
            ({ dom: dom, contentDOM: contentDOM } = spec);
        }
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $a5ab20b42a0afbae$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $a5ab20b42a0afbae$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $a5ab20b42a0afbae$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $a5ab20b42a0afbae$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $1krlL.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $a5ab20b42a0afbae$var$NOT_DIRTY && node.eq(this.node) && $a5ab20b42a0afbae$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $a5ab20b42a0afbae$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $a5ab20b42a0afbae$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $1krlL.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $a5ab20b42a0afbae$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $a5ab20b42a0afbae$var$renderDescs(this.contentDOM, this.children, view);
            if ($a5ab20b42a0afbae$var$ios) $a5ab20b42a0afbae$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $1LeRC.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $a5ab20b42a0afbae$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $a5ab20b42a0afbae$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $a5ab20b42a0afbae$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a5ab20b42a0afbae$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $a5ab20b42a0afbae$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($a5ab20b42a0afbae$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $a5ab20b42a0afbae$var$patchOuterDeco(this.dom, this.nodeDOM, $a5ab20b42a0afbae$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $a5ab20b42a0afbae$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) {
            this.nodeDOM.classList.remove("ProseMirror-selectednode");
            if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
        }
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $a5ab20b42a0afbae$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $a5ab20b42a0afbae$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $a5ab20b42a0afbae$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $a5ab20b42a0afbae$var$TextViewDesc extends $a5ab20b42a0afbae$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a5ab20b42a0afbae$var$NODE_DIRTY || this.dirty != $a5ab20b42a0afbae$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $a5ab20b42a0afbae$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $a5ab20b42a0afbae$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $a5ab20b42a0afbae$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $a5ab20b42a0afbae$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $a5ab20b42a0afbae$var$TrailingHackViewDesc extends $a5ab20b42a0afbae$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $a5ab20b42a0afbae$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $a5ab20b42a0afbae$var$CustomNodeViewDesc extends $a5ab20b42a0afbae$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $a5ab20b42a0afbae$var$NODE_DIRTY) return false;
        if (this.spec.update && (this.node.type == node.type || this.spec.multiType)) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, view, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, view.root) : super.setSelection(anchor, head, view, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $a5ab20b42a0afbae$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $a5ab20b42a0afbae$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $a5ab20b42a0afbae$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $a5ab20b42a0afbae$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $a5ab20b42a0afbae$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $a5ab20b42a0afbae$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$a5ab20b42a0afbae$var$OuterDecoLevel.prototype = Object.create(null);
const $a5ab20b42a0afbae$var$noDeco = [
    new $a5ab20b42a0afbae$var$OuterDecoLevel
];
function $a5ab20b42a0afbae$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $a5ab20b42a0afbae$var$noDeco;
    let top = needsWrap ? $a5ab20b42a0afbae$var$noDeco[0] : new $a5ab20b42a0afbae$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $a5ab20b42a0afbae$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $a5ab20b42a0afbae$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $a5ab20b42a0afbae$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $a5ab20b42a0afbae$var$noDeco && curComputed == $a5ab20b42a0afbae$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $a5ab20b42a0afbae$var$noDeco[0];
                curDOM = parent;
            }
        }
        $a5ab20b42a0afbae$var$patchAttributes(curDOM, prev || $a5ab20b42a0afbae$var$noDeco[0], deco);
    }
    return curDOM;
}
function $a5ab20b42a0afbae$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $a5ab20b42a0afbae$var$applyOuterDeco(dom, deco, node) {
    return $a5ab20b42a0afbae$var$patchOuterDeco(dom, dom, $a5ab20b42a0afbae$var$noDeco, $a5ab20b42a0afbae$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $a5ab20b42a0afbae$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $a5ab20b42a0afbae$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $a5ab20b42a0afbae$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $a5ab20b42a0afbae$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $a5ab20b42a0afbae$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $a5ab20b42a0afbae$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $a5ab20b42a0afbae$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $a5ab20b42a0afbae$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $a5ab20b42a0afbae$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $a5ab20b42a0afbae$var$NODE_DIRTY && $a5ab20b42a0afbae$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.destroyBetween(this.index, i);
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $a5ab20b42a0afbae$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $a5ab20b42a0afbae$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content) || !$a5ab20b42a0afbae$var$sameOuterDeco(outerDeco, next.outerDeco) || !innerDeco.eq(next.innerDeco)) return null;
        let wrapper = $a5ab20b42a0afbae$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $a5ab20b42a0afbae$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $a5ab20b42a0afbae$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $a5ab20b42a0afbae$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $a5ab20b42a0afbae$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($a5ab20b42a0afbae$var$safari || $a5ab20b42a0afbae$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $a5ab20b42a0afbae$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $a5ab20b42a0afbae$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $a5ab20b42a0afbae$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $a5ab20b42a0afbae$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $a5ab20b42a0afbae$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($a5ab20b42a0afbae$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $a5ab20b42a0afbae$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $a5ab20b42a0afbae$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $a5ab20b42a0afbae$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $a5ab20b42a0afbae$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), anchor, selection;
    if ($a5ab20b42a0afbae$var$selectionCollapsed(domSel)) {
        anchor = head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $1LeRC.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $a5ab20b42a0afbae$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $1LeRC.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        if (domSel instanceof view.dom.ownerDocument.defaultView.Selection && domSel.rangeCount > 1) {
            let min = head, max = head;
            for(let i = 0; i < domSel.rangeCount; i++){
                let range = domSel.getRangeAt(i);
                min = Math.min(min, view.docView.posFromDOM(range.startContainer, range.startOffset, 1));
                max = Math.max(max, view.docView.posFromDOM(range.endContainer, range.endOffset, -1));
            }
            if (min < 0) return null;
            [anchor, head] = max == view.state.selection.anchor ? [
                max,
                min
            ] : [
                min,
                max
            ];
            $head = doc.resolve(head);
        } else anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
    }
    let $anchor = doc.resolve(anchor);
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $a5ab20b42a0afbae$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $a5ab20b42a0afbae$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $a5ab20b42a0afbae$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $a5ab20b42a0afbae$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $a5ab20b42a0afbae$var$syncNodeSelection(view, sel);
    if (!$a5ab20b42a0afbae$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $a5ab20b42a0afbae$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $a5ab20b42a0afbae$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $a5ab20b42a0afbae$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($a5ab20b42a0afbae$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $1LeRC.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $a5ab20b42a0afbae$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $a5ab20b42a0afbae$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view, force);
        if ($a5ab20b42a0afbae$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $a5ab20b42a0afbae$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $a5ab20b42a0afbae$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $a5ab20b42a0afbae$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $a5ab20b42a0afbae$var$brokenSelectBetweenUneditable = $a5ab20b42a0afbae$var$safari || $a5ab20b42a0afbae$var$chrome && $a5ab20b42a0afbae$var$chrome_version < 63;
function $a5ab20b42a0afbae$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($a5ab20b42a0afbae$var$safari && after && after.contentEditable == "false") return $a5ab20b42a0afbae$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $a5ab20b42a0afbae$var$setEditable(after);
        else if (before) return $a5ab20b42a0afbae$var$setEditable(before);
    }
}
function $a5ab20b42a0afbae$var$setEditable(element) {
    element.contentEditable = "true";
    if ($a5ab20b42a0afbae$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $a5ab20b42a0afbae$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $a5ab20b42a0afbae$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$a5ab20b42a0afbae$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $a5ab20b42a0afbae$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    if (!domSel) return;
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setStart(node.parentNode, $a5ab20b42a0afbae$var$domIndex(node) + 1);
    else range.setStart(node, 0);
    range.collapse(true);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $a5ab20b42a0afbae$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $1LeRC.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $a5ab20b42a0afbae$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $a5ab20b42a0afbae$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $a5ab20b42a0afbae$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $a5ab20b42a0afbae$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $1LeRC.TextSelection).between($anchor, $head, bias);
}
function $a5ab20b42a0afbae$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $a5ab20b42a0afbae$var$hasSelection(view);
}
function $a5ab20b42a0afbae$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $a5ab20b42a0afbae$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $a5ab20b42a0afbae$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $a5ab20b42a0afbae$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $1LeRC.Selection).findFrom($start, dir);
}
function $a5ab20b42a0afbae$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $a5ab20b42a0afbae$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $1LeRC.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $a5ab20b42a0afbae$var$apply(view, new (0, $1LeRC.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $a5ab20b42a0afbae$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $1LeRC.NodeSelection)) return $a5ab20b42a0afbae$var$apply(view, next);
            return false;
        } else if (!($a5ab20b42a0afbae$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $1LeRC.NodeSelection).isSelectable(node)) return $a5ab20b42a0afbae$var$apply(view, new (0, $1LeRC.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($a5ab20b42a0afbae$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $a5ab20b42a0afbae$var$apply(view, new (0, $1LeRC.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $1LeRC.NodeSelection) && sel.node.isInline) return $a5ab20b42a0afbae$var$apply(view, new (0, $1LeRC.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $a5ab20b42a0afbae$var$moveSelectionBlock(view.state, dir);
        if (next) return $a5ab20b42a0afbae$var$apply(view, next);
        return false;
    }
}
function $a5ab20b42a0afbae$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $a5ab20b42a0afbae$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $a5ab20b42a0afbae$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $a5ab20b42a0afbae$var$skipIgnoredNodesBefore(view) : $a5ab20b42a0afbae$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $a5ab20b42a0afbae$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($a5ab20b42a0afbae$var$gecko && node.nodeType == 1 && offset < $a5ab20b42a0afbae$var$nodeLen(node) && $a5ab20b42a0afbae$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($a5ab20b42a0afbae$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($a5ab20b42a0afbae$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $a5ab20b42a0afbae$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $a5ab20b42a0afbae$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $a5ab20b42a0afbae$var$nodeLen(node);
            }
        }
    }
    if (force) $a5ab20b42a0afbae$var$setSelFocus(view, node, offset);
    else if (moveNode) $a5ab20b42a0afbae$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $a5ab20b42a0afbae$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $a5ab20b42a0afbae$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($a5ab20b42a0afbae$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($a5ab20b42a0afbae$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $a5ab20b42a0afbae$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $a5ab20b42a0afbae$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $a5ab20b42a0afbae$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $a5ab20b42a0afbae$var$setSelFocus(view, moveNode, moveOffset);
}
function $a5ab20b42a0afbae$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $a5ab20b42a0afbae$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$a5ab20b42a0afbae$var$hasBlockDesc(node)){
        offset = $a5ab20b42a0afbae$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $a5ab20b42a0afbae$var$textNodeBefore(node, offset) {
    while(node && !offset && !$a5ab20b42a0afbae$var$hasBlockDesc(node)){
        offset = $a5ab20b42a0afbae$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $a5ab20b42a0afbae$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $a5ab20b42a0afbae$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $a5ab20b42a0afbae$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if (!sel) return;
    if ($a5ab20b42a0afbae$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $a5ab20b42a0afbae$var$selectionToDOM(view);
    }, 50);
}
function $a5ab20b42a0afbae$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($a5ab20b42a0afbae$var$chrome || $a5ab20b42a0afbae$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $a5ab20b42a0afbae$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $1LeRC.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($a5ab20b42a0afbae$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $a5ab20b42a0afbae$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $1LeRC.NodeSelection)) return $a5ab20b42a0afbae$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $1LeRC.AllSelection) ? (0, $1LeRC.Selection).near(side, dir) : (0, $1LeRC.Selection).findFrom(side, dir);
        return beyond ? $a5ab20b42a0afbae$var$apply(view, beyond) : false;
    }
    return false;
}
function $a5ab20b42a0afbae$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $1LeRC.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $a5ab20b42a0afbae$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $a5ab20b42a0afbae$var$safariDownArrowBug(view) {
    if (!$a5ab20b42a0afbae$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $a5ab20b42a0afbae$var$switchEditable(view, child, "true");
        setTimeout(()=>$a5ab20b42a0afbae$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $a5ab20b42a0afbae$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $a5ab20b42a0afbae$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $a5ab20b42a0afbae$var$getMods(event);
    if (code == 8 || $a5ab20b42a0afbae$var$mac && code == 72 && mods == "c") return $a5ab20b42a0afbae$var$stopNativeHorizontalDelete(view, -1) || $a5ab20b42a0afbae$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $a5ab20b42a0afbae$var$mac && code == 68 && mods == "c") return $a5ab20b42a0afbae$var$stopNativeHorizontalDelete(view, 1) || $a5ab20b42a0afbae$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $a5ab20b42a0afbae$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $a5ab20b42a0afbae$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $a5ab20b42a0afbae$var$selectHorizontally(view, dir, mods) || $a5ab20b42a0afbae$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $a5ab20b42a0afbae$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $a5ab20b42a0afbae$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $a5ab20b42a0afbae$var$selectHorizontally(view, dir, mods) || $a5ab20b42a0afbae$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $a5ab20b42a0afbae$var$mac && code == 80 && mods == "c") return $a5ab20b42a0afbae$var$selectVertically(view, -1, mods) || $a5ab20b42a0afbae$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $a5ab20b42a0afbae$var$mac && code == 78 && mods == "c") return $a5ab20b42a0afbae$var$safariDownArrowBug(view) || $a5ab20b42a0afbae$var$selectVertically(view, 1, mods) || $a5ab20b42a0afbae$var$skipIgnoredNodes(view, 1);
    else if (mods == ($a5ab20b42a0afbae$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $a5ab20b42a0afbae$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $1krlL.DOMSerializer).fromSchema(view.state.schema);
    let doc = $a5ab20b42a0afbae$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $a5ab20b42a0afbae$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text,
        slice: slice
    };
}
// Read a slice of content from the clipboard (or drop data).
function $a5ab20b42a0afbae$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $1krlL.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $1krlL.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $a5ab20b42a0afbae$var$readHTML(html);
        if ($a5ab20b42a0afbae$var$webkit) $a5ab20b42a0afbae$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $1krlL.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$a5ab20b42a0afbae$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $a5ab20b42a0afbae$var$addContext($a5ab20b42a0afbae$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $1krlL.Slice).maxOpen($a5ab20b42a0afbae$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $a5ab20b42a0afbae$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $a5ab20b42a0afbae$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $a5ab20b42a0afbae$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $a5ab20b42a0afbae$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $a5ab20b42a0afbae$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $a5ab20b42a0afbae$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $1krlL.Fragment).from(result);
    }
    return fragment;
}
function $a5ab20b42a0afbae$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $1krlL.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $a5ab20b42a0afbae$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $a5ab20b42a0afbae$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $1krlL.Fragment).from($a5ab20b42a0afbae$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $a5ab20b42a0afbae$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $a5ab20b42a0afbae$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $1krlL.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $a5ab20b42a0afbae$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $a5ab20b42a0afbae$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $1krlL.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $a5ab20b42a0afbae$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $1krlL.Slice)($a5ab20b42a0afbae$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $1krlL.Slice)($a5ab20b42a0afbae$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $a5ab20b42a0afbae$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $a5ab20b42a0afbae$var$_detachedDoc = null;
function $a5ab20b42a0afbae$var$detachedDoc() {
    return $a5ab20b42a0afbae$var$_detachedDoc || ($a5ab20b42a0afbae$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
let $a5ab20b42a0afbae$var$_policy = null;
function $a5ab20b42a0afbae$var$maybeWrapTrusted(html) {
    let trustedTypes = window.trustedTypes;
    if (!trustedTypes) return html;
    // With the require-trusted-types-for CSP, Chrome will block
    // innerHTML, even on a detached document. This wraps the string in
    // a way that makes the browser allow us to use its parser again.
    if (!$a5ab20b42a0afbae$var$_policy) $a5ab20b42a0afbae$var$_policy = trustedTypes.createPolicy("ProseMirrorClipboard", {
        createHTML: (s)=>s
    });
    return $a5ab20b42a0afbae$var$_policy.createHTML(html);
}
function $a5ab20b42a0afbae$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $a5ab20b42a0afbae$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $a5ab20b42a0afbae$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = $a5ab20b42a0afbae$var$maybeWrapTrusted(html);
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $a5ab20b42a0afbae$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($a5ab20b42a0afbae$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $a5ab20b42a0afbae$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $1krlL.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $1krlL.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $a5ab20b42a0afbae$var$handlers = {};
const $a5ab20b42a0afbae$var$editHandlers = {};
const $a5ab20b42a0afbae$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $a5ab20b42a0afbae$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastChromeDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $a5ab20b42a0afbae$var$initInput(view) {
    for(let event in $a5ab20b42a0afbae$var$handlers){
        let handler = $a5ab20b42a0afbae$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($a5ab20b42a0afbae$var$eventBelongsToView(view, event) && !$a5ab20b42a0afbae$var$runCustomHandler(view, event) && (view.editable || !(event.type in $a5ab20b42a0afbae$var$editHandlers))) handler(view, event);
        }, $a5ab20b42a0afbae$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($a5ab20b42a0afbae$var$safari) view.dom.addEventListener("input", ()=>null);
    $a5ab20b42a0afbae$var$ensureListeners(view);
}
function $a5ab20b42a0afbae$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $a5ab20b42a0afbae$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $a5ab20b42a0afbae$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$a5ab20b42a0afbae$var$runCustomHandler(view, event));
    });
}
function $a5ab20b42a0afbae$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $a5ab20b42a0afbae$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $a5ab20b42a0afbae$var$dispatchEvent(view, event) {
    if (!$a5ab20b42a0afbae$var$runCustomHandler(view, event) && $a5ab20b42a0afbae$var$handlers[event.type] && (view.editable || !(event.type in $a5ab20b42a0afbae$var$editHandlers))) $a5ab20b42a0afbae$var$handlers[event.type](view, event);
}
$a5ab20b42a0afbae$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($a5ab20b42a0afbae$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($a5ab20b42a0afbae$var$android && $a5ab20b42a0afbae$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($a5ab20b42a0afbae$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $a5ab20b42a0afbae$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $a5ab20b42a0afbae$var$captureKeyDown(view, event)) event.preventDefault();
    else $a5ab20b42a0afbae$var$setSelectionOrigin(view, "key");
};
$a5ab20b42a0afbae$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$a5ab20b42a0afbae$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($a5ab20b42a0afbae$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $a5ab20b42a0afbae$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $1LeRC.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $a5ab20b42a0afbae$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $a5ab20b42a0afbae$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $a5ab20b42a0afbae$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $a5ab20b42a0afbae$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    if (view.state.selection.eq(selection)) return;
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $a5ab20b42a0afbae$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $1LeRC.NodeSelection).isSelectable(node)) {
        $a5ab20b42a0afbae$var$updateSelection(view, new (0, $1LeRC.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $a5ab20b42a0afbae$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $1LeRC.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $1LeRC.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $a5ab20b42a0afbae$var$updateSelection(view, (0, $1LeRC.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $a5ab20b42a0afbae$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $a5ab20b42a0afbae$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $a5ab20b42a0afbae$var$selectClickedNode(view, inside) : $a5ab20b42a0afbae$var$selectClickedLeaf(view, inside));
}
function $a5ab20b42a0afbae$var$handleDoubleClick(view, pos, inside, event) {
    return $a5ab20b42a0afbae$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $a5ab20b42a0afbae$var$handleTripleClick(view, pos, inside, event) {
    return $a5ab20b42a0afbae$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $a5ab20b42a0afbae$var$defaultTripleClick(view, inside, event);
}
function $a5ab20b42a0afbae$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $a5ab20b42a0afbae$var$updateSelection(view, (0, $1LeRC.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $a5ab20b42a0afbae$var$updateSelection(view, (0, $1LeRC.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $1LeRC.NodeSelection).isSelectable(node)) $a5ab20b42a0afbae$var$updateSelection(view, (0, $1LeRC.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $a5ab20b42a0afbae$var$forceDOMFlush(view) {
    return $a5ab20b42a0afbae$var$endComposition(view);
}
const $a5ab20b42a0afbae$var$selectNodeModifier = $a5ab20b42a0afbae$var$mac ? "metaKey" : "ctrlKey";
$a5ab20b42a0afbae$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $a5ab20b42a0afbae$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $a5ab20b42a0afbae$var$isNear(event, view.input.lastClick) && !event[$a5ab20b42a0afbae$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($a5ab20b42a0afbae$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $a5ab20b42a0afbae$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $a5ab20b42a0afbae$var$handleDoubleClick : $a5ab20b42a0afbae$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $a5ab20b42a0afbae$var$setSelectionOrigin(view, "pointer");
};
class $a5ab20b42a0afbae$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$a5ab20b42a0afbae$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc && targetDesc.dom.nodeType == 1 ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $1LeRC.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $a5ab20b42a0afbae$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $a5ab20b42a0afbae$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$a5ab20b42a0afbae$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($a5ab20b42a0afbae$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $a5ab20b42a0afbae$var$setSelectionOrigin(this.view, "pointer");
        else if ($a5ab20b42a0afbae$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $a5ab20b42a0afbae$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $a5ab20b42a0afbae$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $a5ab20b42a0afbae$var$updateSelection(this.view, (0, $1LeRC.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $a5ab20b42a0afbae$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $a5ab20b42a0afbae$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$a5ab20b42a0afbae$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $a5ab20b42a0afbae$var$forceDOMFlush(view);
    $a5ab20b42a0afbae$var$setSelectionOrigin(view, "pointer");
};
$a5ab20b42a0afbae$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $a5ab20b42a0afbae$var$setSelectionOrigin(view, "pointer");
};
$a5ab20b42a0afbae$var$handlers.contextmenu = (view)=>$a5ab20b42a0afbae$var$forceDOMFlush(view);
function $a5ab20b42a0afbae$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($a5ab20b42a0afbae$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $a5ab20b42a0afbae$var$timeoutComposition = $a5ab20b42a0afbae$var$android ? 5000 : -1;
$a5ab20b42a0afbae$var$editHandlers.compositionstart = $a5ab20b42a0afbae$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$to;
        if (state.selection instanceof (0, $1LeRC.TextSelection) && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $a5ab20b42a0afbae$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $a5ab20b42a0afbae$var$endComposition(view, !state.selection.empty);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($a5ab20b42a0afbae$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        let sel = view.domSelection();
                        if (sel) sel.collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $a5ab20b42a0afbae$var$scheduleComposeEnd(view, $a5ab20b42a0afbae$var$timeoutComposition);
};
$a5ab20b42a0afbae$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $a5ab20b42a0afbae$var$scheduleComposeEnd(view, 20);
    }
};
function $a5ab20b42a0afbae$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$a5ab20b42a0afbae$var$endComposition(view), delay);
}
function $a5ab20b42a0afbae$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $a5ab20b42a0afbae$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $a5ab20b42a0afbae$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $a5ab20b42a0afbae$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $a5ab20b42a0afbae$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc, lastChanged = view.domObserver.lastChangedTextNode;
        if (textBefore == lastChanged || textAfter == lastChanged) return lastChanged;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $a5ab20b42a0afbae$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $a5ab20b42a0afbae$var$endComposition(view, restarting = false) {
    if ($a5ab20b42a0afbae$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $a5ab20b42a0afbae$var$clearComposition(view);
    if (restarting || view.docView && view.docView.dirty) {
        let sel = $a5ab20b42a0afbae$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else if ((view.markCursor || restarting) && !view.state.selection.empty) view.dispatch(view.state.tr.deleteSelection());
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $a5ab20b42a0afbae$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $a5ab20b42a0afbae$var$brokenClipboardAPI = $a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version < 15 || $a5ab20b42a0afbae$var$ios && $a5ab20b42a0afbae$var$webkit_version < 604;
$a5ab20b42a0afbae$var$handlers.copy = $a5ab20b42a0afbae$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $a5ab20b42a0afbae$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $a5ab20b42a0afbae$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $a5ab20b42a0afbae$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $a5ab20b42a0afbae$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $a5ab20b42a0afbae$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $a5ab20b42a0afbae$var$doPaste(view, target.value, null, plain, event);
        else $a5ab20b42a0afbae$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $a5ab20b42a0afbae$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $a5ab20b42a0afbae$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $1krlL.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $a5ab20b42a0afbae$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $a5ab20b42a0afbae$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$a5ab20b42a0afbae$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$a5ab20b42a0afbae$var$android) return;
    let data = $a5ab20b42a0afbae$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $a5ab20b42a0afbae$var$doPaste(view, $a5ab20b42a0afbae$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $a5ab20b42a0afbae$var$capturePaste(view, event);
};
class $a5ab20b42a0afbae$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $a5ab20b42a0afbae$var$dragCopyModifier = $a5ab20b42a0afbae$var$mac ? "altKey" : "ctrlKey";
$a5ab20b42a0afbae$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($a5ab20b42a0afbae$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $1LeRC.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $1LeRC.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $1LeRC.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let draggedSlice = (node || view.state.selection).content();
    let { dom: dom, text: text, slice: slice } = $a5ab20b42a0afbae$var$serializeForClipboard(view, draggedSlice);
    // Pre-120 Chrome versions clear files when calling `clearData` (#1472)
    if (!event.dataTransfer.files.length || !$a5ab20b42a0afbae$var$chrome || $a5ab20b42a0afbae$var$chrome_version > 120) event.dataTransfer.clearData();
    event.dataTransfer.setData($a5ab20b42a0afbae$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$a5ab20b42a0afbae$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $a5ab20b42a0afbae$var$Dragging(slice, !event[$a5ab20b42a0afbae$var$dragCopyModifier], node);
};
$a5ab20b42a0afbae$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$a5ab20b42a0afbae$var$editHandlers.dragover = $a5ab20b42a0afbae$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$a5ab20b42a0afbae$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($a5ab20b42a0afbae$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $a5ab20b42a0afbae$var$parseFromClipboard(view, $a5ab20b42a0afbae$var$getText(event.dataTransfer), $a5ab20b42a0afbae$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$a5ab20b42a0afbae$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $1krlL.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $gfgdn.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $1LeRC.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $1LeRC.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($a5ab20b42a0afbae$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$a5ab20b42a0afbae$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $a5ab20b42a0afbae$var$selectionToDOM(view);
        }, 20);
    }
};
$a5ab20b42a0afbae$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$a5ab20b42a0afbae$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($a5ab20b42a0afbae$var$chrome && $a5ab20b42a0afbae$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $a5ab20b42a0afbae$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $a5ab20b42a0afbae$var$editHandlers)$a5ab20b42a0afbae$var$handlers[prop] = $a5ab20b42a0afbae$var$editHandlers[prop];
function $a5ab20b42a0afbae$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $a5ab20b42a0afbae$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $a5ab20b42a0afbae$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $a5ab20b42a0afbae$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $a5ab20b42a0afbae$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $a5ab20b42a0afbae$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $a5ab20b42a0afbae$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $a5ab20b42a0afbae$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $a5ab20b42a0afbae$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $a5ab20b42a0afbae$var$InlineType && $a5ab20b42a0afbae$var$compareObjs(this.attrs, other.attrs) && $a5ab20b42a0afbae$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $a5ab20b42a0afbae$var$InlineType;
    }
    destroy() {}
}
class $a5ab20b42a0afbae$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $a5ab20b42a0afbae$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $a5ab20b42a0afbae$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $a5ab20b42a0afbae$var$NodeType && $a5ab20b42a0afbae$var$compareObjs(this.attrs, other.attrs) && $a5ab20b42a0afbae$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $a5ab20b42a0afbae$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $a5ab20b42a0afbae$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $a5ab20b42a0afbae$export$10e30b733df217ea(pos, pos, new $a5ab20b42a0afbae$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $a5ab20b42a0afbae$export$10e30b733df217ea(from, to, new $a5ab20b42a0afbae$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $a5ab20b42a0afbae$export$10e30b733df217ea(from, to, new $a5ab20b42a0afbae$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $a5ab20b42a0afbae$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $a5ab20b42a0afbae$var$WidgetType;
    }
}
const $a5ab20b42a0afbae$var$none = [], $a5ab20b42a0afbae$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $a5ab20b42a0afbae$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $a5ab20b42a0afbae$var$none;
        this.children = children.length ? children : $a5ab20b42a0afbae$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $a5ab20b42a0afbae$var$buildTree(decorations, doc, 0, $a5ab20b42a0afbae$var$noSpec) : $a5ab20b42a0afbae$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $a5ab20b42a0afbae$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $a5ab20b42a0afbae$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $a5ab20b42a0afbae$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $a5ab20b42a0afbae$export$93bf62eb445cec98(newLocal.sort($a5ab20b42a0afbae$var$byPos), $a5ab20b42a0afbae$var$none) : $a5ab20b42a0afbae$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $a5ab20b42a0afbae$var$empty) return $a5ab20b42a0afbae$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $a5ab20b42a0afbae$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $a5ab20b42a0afbae$var$buildTree(found, childNode, baseOffset + 1, $a5ab20b42a0afbae$var$noSpec));
            childIndex += 3;
        });
        let local = $a5ab20b42a0afbae$var$moveSpans(childIndex ? $a5ab20b42a0afbae$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $a5ab20b42a0afbae$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($a5ab20b42a0afbae$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $a5ab20b42a0afbae$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $a5ab20b42a0afbae$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $a5ab20b42a0afbae$export$93bf62eb445cec98(local, children) : $a5ab20b42a0afbae$var$empty;
    }
    forChild(offset, node) {
        if (this == $a5ab20b42a0afbae$var$empty) return this;
        if (node.isLeaf) return $a5ab20b42a0afbae$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $a5ab20b42a0afbae$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $a5ab20b42a0afbae$export$93bf62eb445cec98(local.sort($a5ab20b42a0afbae$var$byPos), $a5ab20b42a0afbae$var$none);
            return child ? new $a5ab20b42a0afbae$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $a5ab20b42a0afbae$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $a5ab20b42a0afbae$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $a5ab20b42a0afbae$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $a5ab20b42a0afbae$var$empty) return $a5ab20b42a0afbae$var$none;
        if (node.inlineContent || !this.local.some($a5ab20b42a0afbae$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $a5ab20b42a0afbae$var$InlineType)) result.push(this.local[i]);
        return result;
    }
    forEachSet(f) {
        f(this);
    }
}
/**
The empty set of decorations.
*/ $a5ab20b42a0afbae$export$93bf62eb445cec98.empty = new $a5ab20b42a0afbae$export$93bf62eb445cec98([], []);
/**
@internal
*/ $a5ab20b42a0afbae$export$93bf62eb445cec98.removeOverlap = $a5ab20b42a0afbae$var$removeOverlap;
const $a5ab20b42a0afbae$var$empty = $a5ab20b42a0afbae$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $a5ab20b42a0afbae$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $a5ab20b42a0afbae$var$noSpec));
        return $a5ab20b42a0afbae$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $a5ab20b42a0afbae$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $a5ab20b42a0afbae$var$empty) continue;
            if (result instanceof $a5ab20b42a0afbae$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $a5ab20b42a0afbae$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $a5ab20b42a0afbae$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $a5ab20b42a0afbae$var$removeOverlap(sorted ? result : result.sort($a5ab20b42a0afbae$var$byPos)) : $a5ab20b42a0afbae$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $a5ab20b42a0afbae$var$empty;
            case 1:
                return members[0];
            default:
                return new $a5ab20b42a0afbae$var$DecorationGroup(members.every((m)=>m instanceof $a5ab20b42a0afbae$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $a5ab20b42a0afbae$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
    forEachSet(f) {
        for(let i = 0; i < this.members.length; i++)this.members[i].forEachSet(f);
    }
}
function $a5ab20b42a0afbae$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $a5ab20b42a0afbae$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $a5ab20b42a0afbae$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $a5ab20b42a0afbae$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $a5ab20b42a0afbae$export$93bf62eb445cec98(newLocal.sort($a5ab20b42a0afbae$var$byPos), children);
}
function $a5ab20b42a0afbae$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $a5ab20b42a0afbae$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $a5ab20b42a0afbae$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $a5ab20b42a0afbae$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $a5ab20b42a0afbae$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $a5ab20b42a0afbae$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $a5ab20b42a0afbae$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $a5ab20b42a0afbae$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $a5ab20b42a0afbae$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $a5ab20b42a0afbae$var$moveSpans(hasNulls ? $a5ab20b42a0afbae$var$withoutNulls(spans) : spans, -offset).sort($a5ab20b42a0afbae$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $a5ab20b42a0afbae$export$93bf62eb445cec98(locals, children) : $a5ab20b42a0afbae$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $a5ab20b42a0afbae$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $a5ab20b42a0afbae$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $a5ab20b42a0afbae$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $a5ab20b42a0afbae$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $a5ab20b42a0afbae$var$insertAhead(array, i, deco) {
    while(i < array.length && $a5ab20b42a0afbae$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $a5ab20b42a0afbae$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $a5ab20b42a0afbae$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($a5ab20b42a0afbae$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $a5ab20b42a0afbae$var$DecorationGroup.from(found);
}
const $a5ab20b42a0afbae$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $a5ab20b42a0afbae$var$useCharData = $a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version <= 11;
class $a5ab20b42a0afbae$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $a5ab20b42a0afbae$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $a5ab20b42a0afbae$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.lastChangedTextNode = null;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($a5ab20b42a0afbae$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $a5ab20b42a0afbae$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$a5ab20b42a0afbae$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $a5ab20b42a0afbae$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $a5ab20b42a0afbae$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $a5ab20b42a0afbae$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $a5ab20b42a0afbae$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $a5ab20b42a0afbae$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($a5ab20b42a0afbae$var$gecko && added.length) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let [a, b] = brs;
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            } else {
                let { focusNode: focusNode } = this.currentSelection;
                for (let br of brs){
                    let parent = br.parentNode;
                    if (parent && parent.nodeName == "LI" && (!focusNode || $a5ab20b42a0afbae$var$blockParent(view, focusNode) != parent)) br.remove();
                }
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $a5ab20b42a0afbae$var$selectionCollapsed(sel) && (readSel = $a5ab20b42a0afbae$var$selectionFromDOM(view)) && readSel.eq((0, $1LeRC.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $a5ab20b42a0afbae$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $a5ab20b42a0afbae$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $a5ab20b42a0afbae$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++){
                let node = mut.addedNodes[i];
                added.push(node);
                if (node.nodeType == 3) this.lastChangedTextNode = node;
            }
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $a5ab20b42a0afbae$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $a5ab20b42a0afbae$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else {
            this.lastChangedTextNode = mut.target;
            return {
                from: desc.posAtStart,
                to: desc.posAtEnd,
                // An event was generated for a text change that didn't change
                // any text. Mark the dom change to fall back to assuming the
                // selection was typed over with an identical value if it can't
                // find another change.
                typeOver: mut.target.nodeValue == mut.oldValue
            };
        }
    }
}
let $a5ab20b42a0afbae$var$cssChecked = new WeakMap();
let $a5ab20b42a0afbae$var$cssCheckWarned = false;
function $a5ab20b42a0afbae$var$checkCSS(view) {
    if ($a5ab20b42a0afbae$var$cssChecked.has(view)) return;
    $a5ab20b42a0afbae$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $a5ab20b42a0afbae$var$gecko;
        if ($a5ab20b42a0afbae$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $a5ab20b42a0afbae$var$cssCheckWarned = true;
    }
}
function $a5ab20b42a0afbae$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($a5ab20b42a0afbae$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $a5ab20b42a0afbae$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $a5ab20b42a0afbae$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $a5ab20b42a0afbae$var$rangeToSelectionRange(view, found) : null;
}
function $a5ab20b42a0afbae$var$blockParent(view, node) {
    for(let p = node.parentNode; p && p != view.dom; p = p.parentNode){
        let desc = view.docView.nearestDesc(p, true);
        if (desc && desc.node.isBlock) return p;
    }
    return null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $a5ab20b42a0afbae$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$a5ab20b42a0afbae$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($a5ab20b42a0afbae$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $1krlL.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $a5ab20b42a0afbae$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $a5ab20b42a0afbae$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($a5ab20b42a0afbae$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $a5ab20b42a0afbae$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $a5ab20b42a0afbae$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $a5ab20b42a0afbae$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $a5ab20b42a0afbae$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($a5ab20b42a0afbae$var$chrome && $a5ab20b42a0afbae$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $a5ab20b42a0afbae$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $a5ab20b42a0afbae$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $a5ab20b42a0afbae$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (change) view.input.domChangeCount++;
    if (($a5ab20b42a0afbae$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $a5ab20b42a0afbae$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$a5ab20b42a0afbae$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $a5ab20b42a0afbae$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $1LeRC.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $a5ab20b42a0afbae$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $1LeRC.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($a5ab20b42a0afbae$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $1LeRC.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $a5ab20b42a0afbae$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $a5ab20b42a0afbae$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $a5ab20b42a0afbae$var$keyEvent(8, "Backspace")))) {
        if ($a5ab20b42a0afbae$var$android && $a5ab20b42a0afbae$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($a5ab20b42a0afbae$var$chrome && change.endB == change.start) view.input.lastChromeDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($a5ab20b42a0afbae$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $a5ab20b42a0afbae$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($a5ab20b42a0afbae$var$ie && $a5ab20b42a0afbae$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$a5ab20b42a0afbae$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $a5ab20b42a0afbae$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $a5ab20b42a0afbae$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($a5ab20b42a0afbae$var$chrome && view.composing && sel.empty && (change.start != change.endB || view.input.lastChromeDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $a5ab20b42a0afbae$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $a5ab20b42a0afbae$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $a5ab20b42a0afbae$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $a5ab20b42a0afbae$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $1krlL.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $a5ab20b42a0afbae$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $a5ab20b42a0afbae$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($a5ab20b42a0afbae$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $a5ab20b42a0afbae$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $a5ab20b42a0afbae$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $a5ab20b42a0afbae$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $a5ab20b42a0afbae$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $a5ab20b42a0afbae$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $a5ab20b42a0afbae$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $a5ab20b42a0afbae$export$38b79e3fdcfcfd68 = $a5ab20b42a0afbae$var$serializeForClipboard;
/**
@internal
*/ const $a5ab20b42a0afbae$export$5d42ca91c11c9e4d = $a5ab20b42a0afbae$var$parseFromClipboard;
/**
@internal
*/ const $a5ab20b42a0afbae$export$76b14d3c719c32fc = $a5ab20b42a0afbae$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $a5ab20b42a0afbae$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $a5ab20b42a0afbae$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($a5ab20b42a0afbae$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $a5ab20b42a0afbae$var$getEditable(this);
        $a5ab20b42a0afbae$var$updateCursorWrapper(this);
        this.nodeViews = $a5ab20b42a0afbae$var$buildNodeViews(this);
        this.docView = $a5ab20b42a0afbae$var$docViewDesc(this.state.doc, $a5ab20b42a0afbae$var$computeDocDeco(this), $a5ab20b42a0afbae$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $a5ab20b42a0afbae$var$DOMObserver(this, (from, to, typeOver, added)=>$a5ab20b42a0afbae$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $a5ab20b42a0afbae$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $a5ab20b42a0afbae$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($a5ab20b42a0afbae$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $a5ab20b42a0afbae$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $a5ab20b42a0afbae$var$buildNodeViews(this);
            if ($a5ab20b42a0afbae$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $a5ab20b42a0afbae$var$ensureListeners(this);
        this.editable = $a5ab20b42a0afbae$var$getEditable(this);
        $a5ab20b42a0afbae$var$updateCursorWrapper(this);
        let innerDeco = $a5ab20b42a0afbae$var$viewDecorations(this), outerDeco = $a5ab20b42a0afbae$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $a5ab20b42a0afbae$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($a5ab20b42a0afbae$var$ie || $a5ab20b42a0afbae$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $a5ab20b42a0afbae$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $a5ab20b42a0afbae$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $a5ab20b42a0afbae$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $a5ab20b42a0afbae$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $a5ab20b42a0afbae$var$anchorInRightPlace(this))) $a5ab20b42a0afbae$var$selectionToDOM(this, forceSelUpdate);
            else {
                $a5ab20b42a0afbae$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $a5ab20b42a0afbae$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (!startDOM || !this.dom.contains(startDOM.nodeType == 1 ? startDOM : startDOM.parentNode)) ;
        else if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $1LeRC.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $a5ab20b42a0afbae$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $a5ab20b42a0afbae$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $a5ab20b42a0afbae$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $1LeRC.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($a5ab20b42a0afbae$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $a5ab20b42a0afbae$var$focusPreventScroll(this.dom);
        $a5ab20b42a0afbae$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $a5ab20b42a0afbae$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $a5ab20b42a0afbae$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $a5ab20b42a0afbae$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $a5ab20b42a0afbae$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $a5ab20b42a0afbae$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $a5ab20b42a0afbae$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $a5ab20b42a0afbae$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $a5ab20b42a0afbae$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $a5ab20b42a0afbae$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        if (!sel) return {
            focusNode: null,
            focusOffset: 0,
            anchorNode: null,
            anchorOffset: 0
        };
        return $a5ab20b42a0afbae$var$safari && this.root.nodeType === 11 && $a5ab20b42a0afbae$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $a5ab20b42a0afbae$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $a5ab20b42a0afbae$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $a5ab20b42a0afbae$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $a5ab20b42a0afbae$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $a5ab20b42a0afbae$export$10e30b733df217ea.widget(view.state.selection.from, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $a5ab20b42a0afbae$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $a5ab20b42a0afbae$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $a5ab20b42a0afbae$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $a5ab20b42a0afbae$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $a5ab20b42a0afbae$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});


parcelRegister("euyQd", function(module, exports) {
$parcel$export(module.exports, "keymap", () => (parcelRequire("18HhN")).keymap);
// keymap/index.ts
parcelRequire("18HhN");

});
parcelRegister("18HhN", function(module, exports) {

$parcel$export(module.exports, "keymap", () => $0d481d7d66f73fd8$export$5043418e2ef368d5);
$parcel$export(module.exports, "keydownHandler", () => $0d481d7d66f73fd8$export$53f558754f8b9fd1);

var $16T16 = parcelRequire("16T16");

var $1LeRC = parcelRequire("1LeRC");
const $0d481d7d66f73fd8$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : false;
function $0d481d7d66f73fd8$var$normalizeKeyName(name) {
    let parts = name.split(/-(?!$)/), result = parts[parts.length - 1];
    if (result == "Space") result = " ";
    let alt, ctrl, shift, meta;
    for(let i = 0; i < parts.length - 1; i++){
        let mod = parts[i];
        if (/^(cmd|meta|m)$/i.test(mod)) meta = true;
        else if (/^a(lt)?$/i.test(mod)) alt = true;
        else if (/^(c|ctrl|control)$/i.test(mod)) ctrl = true;
        else if (/^s(hift)?$/i.test(mod)) shift = true;
        else if (/^mod$/i.test(mod)) {
            if ($0d481d7d66f73fd8$var$mac) meta = true;
            else ctrl = true;
        } else throw new Error("Unrecognized modifier name: " + mod);
    }
    if (alt) result = "Alt-" + result;
    if (ctrl) result = "Ctrl-" + result;
    if (meta) result = "Meta-" + result;
    if (shift) result = "Shift-" + result;
    return result;
}
function $0d481d7d66f73fd8$var$normalize(map) {
    let copy = Object.create(null);
    for(let prop in map)copy[$0d481d7d66f73fd8$var$normalizeKeyName(prop)] = map[prop];
    return copy;
}
function $0d481d7d66f73fd8$var$modifiers(name, event, shift = true) {
    if (event.altKey) name = "Alt-" + name;
    if (event.ctrlKey) name = "Ctrl-" + name;
    if (event.metaKey) name = "Meta-" + name;
    if (shift && event.shiftKey) name = "Shift-" + name;
    return name;
}
/**
Create a keymap plugin for the given set of bindings.

Bindings should map key names to [command](https://prosemirror.net/docs/ref/#commands)-style
functions, which will be called with `(EditorState, dispatch,
EditorView)` arguments, and should return true when they've handled
the key. Note that the view argument isn't part of the command
protocol, but can be used as an escape hatch if a binding needs to
directly interact with the UI.

Key names may be strings like `"Shift-Ctrl-Enter"`—a key
identifier prefixed with zero or more modifiers. Key identifiers
are based on the strings that can appear in
[`KeyEvent.key`](https:developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key).
Use lowercase letters to refer to letter keys (or uppercase letters
if you want shift to be held). You may use `"Space"` as an alias
for the `" "` name.

Modifiers can be given in any order. `Shift-` (or `s-`), `Alt-` (or
`a-`), `Ctrl-` (or `c-` or `Control-`) and `Cmd-` (or `m-` or
`Meta-`) are recognized. For characters that are created by holding
shift, the `Shift-` prefix is implied, and should not be added
explicitly.

You can use `Mod-` as a shorthand for `Cmd-` on Mac and `Ctrl-` on
other platforms.

You can add multiple keymap plugins to an editor. The order in
which they appear determines their precedence (the ones early in
the array get to dispatch first).
*/ function $0d481d7d66f73fd8$export$5043418e2ef368d5(bindings) {
    return new (0, $1LeRC.Plugin)({
        props: {
            handleKeyDown: $0d481d7d66f73fd8$export$53f558754f8b9fd1(bindings)
        }
    });
}
/**
Given a set of bindings (using the same format as
[`keymap`](https://prosemirror.net/docs/ref/#keymap.keymap)), return a [keydown
handler](https://prosemirror.net/docs/ref/#view.EditorProps.handleKeyDown) that handles them.
*/ function $0d481d7d66f73fd8$export$53f558754f8b9fd1(bindings) {
    let map = $0d481d7d66f73fd8$var$normalize(bindings);
    return function(view, event) {
        let name = (0, $16T16.keyName)(event), baseName, direct = map[$0d481d7d66f73fd8$var$modifiers(name, event)];
        if (direct && direct(view.state, view.dispatch, view)) return true;
        // A character key
        if (name.length == 1 && name != " ") {
            if (event.shiftKey) {
                // In case the name was already modified by shift, try looking
                // it up without its shift modifier
                let noShift = map[$0d481d7d66f73fd8$var$modifiers(name, event, false)];
                if (noShift && noShift(view.state, view.dispatch, view)) return true;
            }
            if ((event.shiftKey || event.altKey || event.metaKey || name.charCodeAt(0) > 127) && (baseName = (0, $16T16.base)[event.keyCode]) && baseName != name) {
                // Try falling back to the keyCode when there's a modifier
                // active or the character produced isn't ASCII, and our table
                // produces a different name from the the keyCode. See #668,
                // #1060
                let fromCode = map[$0d481d7d66f73fd8$var$modifiers(baseName, event)];
                if (fromCode && fromCode(view.state, view.dispatch, view)) return true;
            }
        }
        return false;
    };
}

});
parcelRegister("16T16", function(module, exports) {

$parcel$export(module.exports, "base", () => $0cf1073115e44648$export$e2253033e6e1df16);
$parcel$export(module.exports, "keyName", () => $0cf1073115e44648$export$fb33aafd75404f4c);
var $0cf1073115e44648$export$e2253033e6e1df16 = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
};
var $0cf1073115e44648$export$fba63a578e423eb = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: "\""
};
var $0cf1073115e44648$var$mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var $0cf1073115e44648$var$ie = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
// Fill in the digit keys
for(var $0cf1073115e44648$var$i = 0; $0cf1073115e44648$var$i < 10; $0cf1073115e44648$var$i++)$0cf1073115e44648$export$e2253033e6e1df16[48 + $0cf1073115e44648$var$i] = $0cf1073115e44648$export$e2253033e6e1df16[96 + $0cf1073115e44648$var$i] = String($0cf1073115e44648$var$i);
// The function keys
for(var $0cf1073115e44648$var$i = 1; $0cf1073115e44648$var$i <= 24; $0cf1073115e44648$var$i++)$0cf1073115e44648$export$e2253033e6e1df16[$0cf1073115e44648$var$i + 111] = "F" + $0cf1073115e44648$var$i;
// And the alphabetic keys
for(var $0cf1073115e44648$var$i = 65; $0cf1073115e44648$var$i <= 90; $0cf1073115e44648$var$i++){
    $0cf1073115e44648$export$e2253033e6e1df16[$0cf1073115e44648$var$i] = String.fromCharCode($0cf1073115e44648$var$i + 32);
    $0cf1073115e44648$export$fba63a578e423eb[$0cf1073115e44648$var$i] = String.fromCharCode($0cf1073115e44648$var$i);
}
// For each code that doesn't have a shift-equivalent, copy the base name
for(var $0cf1073115e44648$var$code in $0cf1073115e44648$export$e2253033e6e1df16)if (!$0cf1073115e44648$export$fba63a578e423eb.hasOwnProperty($0cf1073115e44648$var$code)) $0cf1073115e44648$export$fba63a578e423eb[$0cf1073115e44648$var$code] = $0cf1073115e44648$export$e2253033e6e1df16[$0cf1073115e44648$var$code];
function $0cf1073115e44648$export$fb33aafd75404f4c(event) {
    // On macOS, keys held with Shift and Cmd don't reflect the effect of Shift in `.key`.
    // On IE, shift effect is never included in `.key`.
    var ignoreKey = $0cf1073115e44648$var$mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || $0cf1073115e44648$var$ie && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
    var name = !ignoreKey && event.key || (event.shiftKey ? $0cf1073115e44648$export$fba63a578e423eb : $0cf1073115e44648$export$e2253033e6e1df16)[event.keyCode] || event.key || "Unidentified";
    // Edge sometimes produces wrong names (Issue #3)
    if (name == "Esc") name = "Escape";
    if (name == "Del") name = "Delete";
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/8860571/
    if (name == "Left") name = "ArrowLeft";
    if (name == "Up") name = "ArrowUp";
    if (name == "Right") name = "ArrowRight";
    if (name == "Down") name = "ArrowDown";
    return name;
}

});



parcelRegister("k43Nl", function(module, exports) {
$parcel$export(module.exports, "DOMParser", () => (parcelRequire("1krlL")).DOMParser);
$parcel$export(module.exports, "DOMSerializer", () => (parcelRequire("1krlL")).DOMSerializer);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("1krlL")).Fragment);
$parcel$export(module.exports, "Node", () => (parcelRequire("1krlL")).Node);
$parcel$export(module.exports, "Schema", () => (parcelRequire("1krlL")).Schema);
$parcel$export(module.exports, "Slice", () => (parcelRequire("1krlL")).Slice);
// model/index.ts
parcelRequire("1krlL");

});

parcelRegister("jV6wh", function(module, exports) {
$parcel$export(module.exports, "canJoin", () => (parcelRequire("gfgdn")).canJoin);
$parcel$export(module.exports, "canSplit", () => (parcelRequire("gfgdn")).canSplit);
$parcel$export(module.exports, "findWrapping", () => (parcelRequire("gfgdn")).findWrapping);
$parcel$export(module.exports, "joinPoint", () => (parcelRequire("gfgdn")).joinPoint);
$parcel$export(module.exports, "liftTarget", () => (parcelRequire("gfgdn")).liftTarget);
$parcel$export(module.exports, "ReplaceAroundStep", () => (parcelRequire("gfgdn")).ReplaceAroundStep);
$parcel$export(module.exports, "ReplaceStep", () => (parcelRequire("gfgdn")).ReplaceStep);
$parcel$export(module.exports, "Transform", () => (parcelRequire("gfgdn")).Transform);
// transform/index.ts
parcelRequire("gfgdn");

});

parcelRegister("cJglX", function(module, exports) {
$parcel$export(module.exports, "createParagraphNear", () => (parcelRequire("9D0ij")).createParagraphNear);
$parcel$export(module.exports, "deleteSelection", () => (parcelRequire("9D0ij")).deleteSelection);
$parcel$export(module.exports, "exitCode", () => (parcelRequire("9D0ij")).exitCode);
$parcel$export(module.exports, "joinBackward", () => (parcelRequire("9D0ij")).joinBackward);
$parcel$export(module.exports, "joinDown", () => (parcelRequire("9D0ij")).joinDown);
$parcel$export(module.exports, "joinForward", () => (parcelRequire("9D0ij")).joinForward);
$parcel$export(module.exports, "joinTextblockBackward", () => (parcelRequire("9D0ij")).joinTextblockBackward);
$parcel$export(module.exports, "joinTextblockForward", () => (parcelRequire("9D0ij")).joinTextblockForward);
$parcel$export(module.exports, "joinUp", () => (parcelRequire("9D0ij")).joinUp);
$parcel$export(module.exports, "lift", () => (parcelRequire("9D0ij")).lift);
$parcel$export(module.exports, "liftEmptyBlock", () => (parcelRequire("9D0ij")).liftEmptyBlock);
$parcel$export(module.exports, "newlineInCode", () => (parcelRequire("9D0ij")).newlineInCode);
$parcel$export(module.exports, "selectNodeBackward", () => (parcelRequire("9D0ij")).selectNodeBackward);
$parcel$export(module.exports, "selectNodeForward", () => (parcelRequire("9D0ij")).selectNodeForward);
$parcel$export(module.exports, "selectParentNode", () => (parcelRequire("9D0ij")).selectParentNode);
$parcel$export(module.exports, "selectTextblockEnd", () => (parcelRequire("9D0ij")).selectTextblockEnd);
$parcel$export(module.exports, "selectTextblockStart", () => (parcelRequire("9D0ij")).selectTextblockStart);
$parcel$export(module.exports, "setBlockType", () => (parcelRequire("9D0ij")).setBlockType);
$parcel$export(module.exports, "wrapIn", () => (parcelRequire("9D0ij")).wrapIn);
// commands/index.ts
parcelRequire("9D0ij");

});
parcelRegister("9D0ij", function(module, exports) {

$parcel$export(module.exports, "deleteSelection", () => $7027fc0208e1ca62$export$e9a518a637d1e641);
$parcel$export(module.exports, "joinBackward", () => $7027fc0208e1ca62$export$979097b097459299);
$parcel$export(module.exports, "joinTextblockBackward", () => $7027fc0208e1ca62$export$1dce4f5c74f5f90f);
$parcel$export(module.exports, "joinTextblockForward", () => $7027fc0208e1ca62$export$e796bb96d22be2cd);
$parcel$export(module.exports, "selectNodeBackward", () => $7027fc0208e1ca62$export$52b8a4af68d19794);
$parcel$export(module.exports, "joinForward", () => $7027fc0208e1ca62$export$bf432e340007f9ef);
$parcel$export(module.exports, "selectNodeForward", () => $7027fc0208e1ca62$export$5835b52680b80cfd);
$parcel$export(module.exports, "joinUp", () => $7027fc0208e1ca62$export$4bb15e6d4372b393);
$parcel$export(module.exports, "joinDown", () => $7027fc0208e1ca62$export$8dd967a262b064bb);
$parcel$export(module.exports, "lift", () => $7027fc0208e1ca62$export$590e8b2c435046d9);
$parcel$export(module.exports, "newlineInCode", () => $7027fc0208e1ca62$export$a5d02b4b65e94f91);
$parcel$export(module.exports, "exitCode", () => $7027fc0208e1ca62$export$634b78845598ff5b);
$parcel$export(module.exports, "createParagraphNear", () => $7027fc0208e1ca62$export$d0f80ac1b4510888);
$parcel$export(module.exports, "liftEmptyBlock", () => $7027fc0208e1ca62$export$a3574cc681852c08);
$parcel$export(module.exports, "selectParentNode", () => $7027fc0208e1ca62$export$a37f6aaa9169911d);
$parcel$export(module.exports, "selectTextblockStart", () => $7027fc0208e1ca62$export$c3a64f3c9604a1b1);
$parcel$export(module.exports, "selectTextblockEnd", () => $7027fc0208e1ca62$export$a66c1876556415e5);
$parcel$export(module.exports, "wrapIn", () => $7027fc0208e1ca62$export$6e5e3c49755affd0);
$parcel$export(module.exports, "setBlockType", () => $7027fc0208e1ca62$export$36987f561c736aad);

var $gfgdn = parcelRequire("gfgdn");

var $1krlL = parcelRequire("1krlL");

var $1LeRC = parcelRequire("1LeRC");
/**
Delete the selection, if there is one.
*/ const $7027fc0208e1ca62$export$e9a518a637d1e641 = (state, dispatch)=>{
    if (state.selection.empty) return false;
    if (dispatch) dispatch(state.tr.deleteSelection().scrollIntoView());
    return true;
};
function $7027fc0208e1ca62$var$atBlockStart(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("backward", state) : $cursor.parentOffset > 0)) return null;
    return $cursor;
}
/**
If the selection is empty and at the start of a textblock, try to
reduce the distance between that block and the one before it—if
there's a block directly before it that can be joined, join them.
If not, try to move the selected block closer to the next one in
the document structure by lifting it out of its parent or moving it
into a parent of the previous block. Will use the view for accurate
(bidi-aware) start-of-textblock detection if given.
*/ const $7027fc0208e1ca62$export$979097b097459299 = (state, dispatch, view)=>{
    let $cursor = $7027fc0208e1ca62$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $7027fc0208e1ca62$var$findCutBefore($cursor);
    // If there is no node before this, try to lift
    if (!$cut) {
        let range = $cursor.blockRange(), target = range && (0, $gfgdn.liftTarget)(range);
        if (target == null) return false;
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    let before = $cut.nodeBefore;
    // Apply the joining algorithm
    if ($7027fc0208e1ca62$var$deleteBarrier(state, $cut, dispatch, -1)) return true;
    // If the node below has no content and the node above is
    // selectable, delete the node below and select the one above.
    if ($cursor.parent.content.size == 0 && ($7027fc0208e1ca62$var$textblockAt(before, "end") || (0, $1LeRC.NodeSelection).isSelectable(before))) for(let depth = $cursor.depth;; depth--){
        let delStep = (0, $gfgdn.replaceStep)(state.doc, $cursor.before(depth), $cursor.after(depth), (0, $1krlL.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($7027fc0208e1ca62$var$textblockAt(before, "end") ? (0, $1LeRC.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos, -1)), -1) : (0, $1LeRC.NodeSelection).create(tr.doc, $cut.pos - before.nodeSize));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        if (depth == 1 || $cursor.node(depth - 1).childCount > 1) break;
    }
    // If the node before is an atom, delete it
    if (before.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos - before.nodeSize, $cut.pos).scrollIntoView());
        return true;
    }
    return false;
};
/**
A more limited form of [`joinBackward`]($commands.joinBackward)
that only tries to join the current textblock to the one before
it, if the cursor is at the start of a textblock.
*/ const $7027fc0208e1ca62$export$1dce4f5c74f5f90f = (state, dispatch, view)=>{
    let $cursor = $7027fc0208e1ca62$var$atBlockStart(state, view);
    if (!$cursor) return false;
    let $cut = $7027fc0208e1ca62$var$findCutBefore($cursor);
    return $cut ? $7027fc0208e1ca62$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
/**
A more limited form of [`joinForward`]($commands.joinForward)
that only tries to join the current textblock to the one after
it, if the cursor is at the end of a textblock.
*/ const $7027fc0208e1ca62$export$e796bb96d22be2cd = (state, dispatch, view)=>{
    let $cursor = $7027fc0208e1ca62$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $7027fc0208e1ca62$var$findCutAfter($cursor);
    return $cut ? $7027fc0208e1ca62$var$joinTextblocksAround(state, $cut, dispatch) : false;
};
function $7027fc0208e1ca62$var$joinTextblocksAround(state, $cut, dispatch) {
    let before = $cut.nodeBefore, beforeText = before, beforePos = $cut.pos - 1;
    for(; !beforeText.isTextblock; beforePos--){
        if (beforeText.type.spec.isolating) return false;
        let child = beforeText.lastChild;
        if (!child) return false;
        beforeText = child;
    }
    let after = $cut.nodeAfter, afterText = after, afterPos = $cut.pos + 1;
    for(; !afterText.isTextblock; afterPos++){
        if (afterText.type.spec.isolating) return false;
        let child = afterText.firstChild;
        if (!child) return false;
        afterText = child;
    }
    let step = (0, $gfgdn.replaceStep)(state.doc, beforePos, afterPos, (0, $1krlL.Slice).empty);
    if (!step || step.from != beforePos || step instanceof (0, $gfgdn.ReplaceStep) && step.slice.size >= afterPos - beforePos) return false;
    if (dispatch) {
        let tr = state.tr.step(step);
        tr.setSelection((0, $1LeRC.TextSelection).create(tr.doc, beforePos));
        dispatch(tr.scrollIntoView());
    }
    return true;
}
function $7027fc0208e1ca62$var$textblockAt(node, side, only = false) {
    for(let scan = node; scan; scan = side == "start" ? scan.firstChild : scan.lastChild){
        if (scan.isTextblock) return true;
        if (only && scan.childCount != 1) return false;
    }
    return false;
}
/**
When the selection is empty and at the start of a textblock, select
the node before that textblock, if possible. This is intended to be
bound to keys like backspace, after
[`joinBackward`](https://prosemirror.net/docs/ref/#commands.joinBackward) or other deleting
commands, as a fall-back behavior when the schema doesn't allow
deletion at the selected point.
*/ const $7027fc0208e1ca62$export$52b8a4af68d19794 = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("backward", state) : $head.parentOffset > 0) return false;
        $cut = $7027fc0208e1ca62$var$findCutBefore($head);
    }
    let node = $cut && $cut.nodeBefore;
    if (!node || !(0, $1LeRC.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $1LeRC.NodeSelection).create(state.doc, $cut.pos - node.nodeSize)).scrollIntoView());
    return true;
};
function $7027fc0208e1ca62$var$findCutBefore($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $7027fc0208e1ca62$var$atBlockEnd(state, view) {
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || (view ? !view.endOfTextblock("forward", state) : $cursor.parentOffset < $cursor.parent.content.size)) return null;
    return $cursor;
}
/**
If the selection is empty and the cursor is at the end of a
textblock, try to reduce or remove the boundary between that block
and the one after it, either by joining them or by moving the other
block closer to this one in the tree structure. Will use the view
for accurate start-of-textblock detection if given.
*/ const $7027fc0208e1ca62$export$bf432e340007f9ef = (state, dispatch, view)=>{
    let $cursor = $7027fc0208e1ca62$var$atBlockEnd(state, view);
    if (!$cursor) return false;
    let $cut = $7027fc0208e1ca62$var$findCutAfter($cursor);
    // If there is no node after this, there's nothing to do
    if (!$cut) return false;
    let after = $cut.nodeAfter;
    // Try the joining algorithm
    if ($7027fc0208e1ca62$var$deleteBarrier(state, $cut, dispatch, 1)) return true;
    // If the node above has no content and the node below is
    // selectable, delete the node above and select the one below.
    if ($cursor.parent.content.size == 0 && ($7027fc0208e1ca62$var$textblockAt(after, "start") || (0, $1LeRC.NodeSelection).isSelectable(after))) {
        let delStep = (0, $gfgdn.replaceStep)(state.doc, $cursor.before(), $cursor.after(), (0, $1krlL.Slice).empty);
        if (delStep && delStep.slice.size < delStep.to - delStep.from) {
            if (dispatch) {
                let tr = state.tr.step(delStep);
                tr.setSelection($7027fc0208e1ca62$var$textblockAt(after, "start") ? (0, $1LeRC.Selection).findFrom(tr.doc.resolve(tr.mapping.map($cut.pos)), 1) : (0, $1LeRC.NodeSelection).create(tr.doc, tr.mapping.map($cut.pos)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    // If the next node is an atom, delete it
    if (after.isAtom && $cut.depth == $cursor.depth - 1) {
        if (dispatch) dispatch(state.tr.delete($cut.pos, $cut.pos + after.nodeSize).scrollIntoView());
        return true;
    }
    return false;
};
/**
When the selection is empty and at the end of a textblock, select
the node coming after that textblock, if possible. This is intended
to be bound to keys like delete, after
[`joinForward`](https://prosemirror.net/docs/ref/#commands.joinForward) and similar deleting
commands, to provide a fall-back behavior when the schema doesn't
allow deletion at the selected point.
*/ const $7027fc0208e1ca62$export$5835b52680b80cfd = (state, dispatch, view)=>{
    let { $head: $head, empty: empty } = state.selection, $cut = $head;
    if (!empty) return false;
    if ($head.parent.isTextblock) {
        if (view ? !view.endOfTextblock("forward", state) : $head.parentOffset < $head.parent.content.size) return false;
        $cut = $7027fc0208e1ca62$var$findCutAfter($head);
    }
    let node = $cut && $cut.nodeAfter;
    if (!node || !(0, $1LeRC.NodeSelection).isSelectable(node)) return false;
    if (dispatch) dispatch(state.tr.setSelection((0, $1LeRC.NodeSelection).create(state.doc, $cut.pos)).scrollIntoView());
    return true;
};
function $7027fc0208e1ca62$var$findCutAfter($pos) {
    if (!$pos.parent.type.spec.isolating) for(let i = $pos.depth - 1; i >= 0; i--){
        let parent = $pos.node(i);
        if ($pos.index(i) + 1 < parent.childCount) return $pos.doc.resolve($pos.after(i + 1));
        if (parent.type.spec.isolating) break;
    }
    return null;
}
/**
Join the selected block or, if there is a text selection, the
closest ancestor block of the selection that can be joined, with
the sibling above it.
*/ const $7027fc0208e1ca62$export$4bb15e6d4372b393 = (state, dispatch)=>{
    let sel = state.selection, nodeSel = sel instanceof (0, $1LeRC.NodeSelection), point;
    if (nodeSel) {
        if (sel.node.isTextblock || !(0, $gfgdn.canJoin)(state.doc, sel.from)) return false;
        point = sel.from;
    } else {
        point = (0, $gfgdn.joinPoint)(state.doc, sel.from, -1);
        if (point == null) return false;
    }
    if (dispatch) {
        let tr = state.tr.join(point);
        if (nodeSel) tr.setSelection((0, $1LeRC.NodeSelection).create(tr.doc, point - state.doc.resolve(point).nodeBefore.nodeSize));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
Join the selected block, or the closest ancestor of the selection
that can be joined, with the sibling after it.
*/ const $7027fc0208e1ca62$export$8dd967a262b064bb = (state, dispatch)=>{
    let sel = state.selection, point;
    if (sel instanceof (0, $1LeRC.NodeSelection)) {
        if (sel.node.isTextblock || !(0, $gfgdn.canJoin)(state.doc, sel.to)) return false;
        point = sel.to;
    } else {
        point = (0, $gfgdn.joinPoint)(state.doc, sel.to, 1);
        if (point == null) return false;
    }
    if (dispatch) dispatch(state.tr.join(point).scrollIntoView());
    return true;
};
/**
Lift the selected block, or the closest ancestor block of the
selection that can be lifted, out of its parent node.
*/ const $7027fc0208e1ca62$export$590e8b2c435046d9 = (state, dispatch)=>{
    let { $from: $from, $to: $to } = state.selection;
    let range = $from.blockRange($to), target = range && (0, $gfgdn.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
If the selection is in a node whose type has a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, replace the
selection with a newline character.
*/ const $7027fc0208e1ca62$export$a5d02b4b65e94f91 = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    if (dispatch) dispatch(state.tr.insertText("\n").scrollIntoView());
    return true;
};
function $7027fc0208e1ca62$var$defaultBlockAt(match) {
    for(let i = 0; i < match.edgeCount; i++){
        let { type: type } = match.edge(i);
        if (type.isTextblock && !type.hasRequiredAttrs()) return type;
    }
    return null;
}
/**
When the selection is in a node with a truthy
[`code`](https://prosemirror.net/docs/ref/#model.NodeSpec.code) property in its spec, create a
default block after the code block, and move the cursor there.
*/ const $7027fc0208e1ca62$export$634b78845598ff5b = (state, dispatch)=>{
    let { $head: $head, $anchor: $anchor } = state.selection;
    if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
    let above = $head.node(-1), after = $head.indexAfter(-1), type = $7027fc0208e1ca62$var$defaultBlockAt(above.contentMatchAt(after));
    if (!type || !above.canReplaceWith(after, after, type)) return false;
    if (dispatch) {
        let pos = $head.after(), tr = state.tr.replaceWith(pos, pos, type.createAndFill());
        tr.setSelection((0, $1LeRC.Selection).near(tr.doc.resolve(pos), 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If a block node is selected, create an empty paragraph before (if
it is its parent's first child) or after it.
*/ const $7027fc0208e1ca62$export$d0f80ac1b4510888 = (state, dispatch)=>{
    let sel = state.selection, { $from: $from, $to: $to } = sel;
    if (sel instanceof (0, $1LeRC.AllSelection) || $from.parent.inlineContent || $to.parent.inlineContent) return false;
    let type = $7027fc0208e1ca62$var$defaultBlockAt($to.parent.contentMatchAt($to.indexAfter()));
    if (!type || !type.isTextblock) return false;
    if (dispatch) {
        let side = (!$from.parentOffset && $to.index() < $to.parent.childCount ? $from : $to).pos;
        let tr = state.tr.insert(side, type.createAndFill());
        tr.setSelection((0, $1LeRC.TextSelection).create(tr.doc, side + 1));
        dispatch(tr.scrollIntoView());
    }
    return true;
};
/**
If the cursor is in an empty textblock that can be lifted, lift the
block.
*/ const $7027fc0208e1ca62$export$a3574cc681852c08 = (state, dispatch)=>{
    let { $cursor: $cursor } = state.selection;
    if (!$cursor || $cursor.parent.content.size) return false;
    if ($cursor.depth > 1 && $cursor.after() != $cursor.end(-1)) {
        let before = $cursor.before();
        if ((0, $gfgdn.canSplit)(state.doc, before)) {
            if (dispatch) dispatch(state.tr.split(before).scrollIntoView());
            return true;
        }
    }
    let range = $cursor.blockRange(), target = range && (0, $gfgdn.liftTarget)(range);
    if (target == null) return false;
    if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
    return true;
};
/**
Create a variant of [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock) that uses
a custom function to determine the type of the newly split off block.
*/ function $7027fc0208e1ca62$export$8bf8350f33b1e5ab(splitNode) {
    return (state, dispatch)=>{
        let { $from: $from, $to: $to } = state.selection;
        if (state.selection instanceof (0, $1LeRC.NodeSelection) && state.selection.node.isBlock) {
            if (!$from.parentOffset || !(0, $gfgdn.canSplit)(state.doc, $from.pos)) return false;
            if (dispatch) dispatch(state.tr.split($from.pos).scrollIntoView());
            return true;
        }
        if (!$from.depth) return false;
        let types = [];
        let splitDepth, deflt, atEnd = false, atStart = false;
        for(let d = $from.depth;; d--){
            let node = $from.node(d);
            if (node.isBlock) {
                atEnd = $from.end(d) == $from.pos + ($from.depth - d);
                atStart = $from.start(d) == $from.pos - ($from.depth - d);
                deflt = $7027fc0208e1ca62$var$defaultBlockAt($from.node(d - 1).contentMatchAt($from.indexAfter(d - 1)));
                let splitType = splitNode && splitNode($to.parent, atEnd, $from);
                types.unshift(splitType || (atEnd && deflt ? {
                    type: deflt
                } : null));
                splitDepth = d;
                break;
            } else {
                if (d == 1) return false;
                types.unshift(null);
            }
        }
        let tr = state.tr;
        if (state.selection instanceof (0, $1LeRC.TextSelection) || state.selection instanceof (0, $1LeRC.AllSelection)) tr.deleteSelection();
        let splitPos = tr.mapping.map($from.pos);
        let can = (0, $gfgdn.canSplit)(tr.doc, splitPos, types.length, types);
        if (!can) {
            types[0] = deflt ? {
                type: deflt
            } : null;
            can = (0, $gfgdn.canSplit)(tr.doc, splitPos, types.length, types);
        }
        tr.split(splitPos, types.length, types);
        if (!atEnd && atStart && $from.node(splitDepth).type != deflt) {
            let first = tr.mapping.map($from.before(splitDepth)), $first = tr.doc.resolve(first);
            if (deflt && $from.node(splitDepth - 1).canReplaceWith($first.index(), $first.index() + 1, deflt)) tr.setNodeMarkup(tr.mapping.map($from.before(splitDepth)), deflt);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
/**
Split the parent block of the selection. If the selection is a text
selection, also delete its content.
*/ const $7027fc0208e1ca62$export$e99155638ff4dff0 = $7027fc0208e1ca62$export$8bf8350f33b1e5ab();
/**
Acts like [`splitBlock`](https://prosemirror.net/docs/ref/#commands.splitBlock), but without
resetting the set of active marks at the cursor.
*/ const $7027fc0208e1ca62$export$eeb429476568b72b = (state, dispatch)=>{
    return $7027fc0208e1ca62$export$e99155638ff4dff0(state, dispatch && ((tr)=>{
        let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
        if (marks) tr.ensureMarks(marks);
        dispatch(tr);
    }));
};
/**
Move the selection to the node wrapping the current selection, if
any. (Will not select the document node.)
*/ const $7027fc0208e1ca62$export$a37f6aaa9169911d = (state, dispatch)=>{
    let { $from: $from, to: to } = state.selection, pos;
    let same = $from.sharedDepth(to);
    if (same == 0) return false;
    pos = $from.before(same);
    if (dispatch) dispatch(state.tr.setSelection((0, $1LeRC.NodeSelection).create(state.doc, pos)));
    return true;
};
/**
Select the whole document.
*/ const $7027fc0208e1ca62$export$90aca4adda6ff0f5 = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.setSelection(new (0, $1LeRC.AllSelection)(state.doc)));
    return true;
};
function $7027fc0208e1ca62$var$joinMaybeClear(state, $pos, dispatch) {
    let before = $pos.nodeBefore, after = $pos.nodeAfter, index = $pos.index();
    if (!before || !after || !before.type.compatibleContent(after.type)) return false;
    if (!before.content.size && $pos.parent.canReplace(index - 1, index)) {
        if (dispatch) dispatch(state.tr.delete($pos.pos - before.nodeSize, $pos.pos).scrollIntoView());
        return true;
    }
    if (!$pos.parent.canReplace(index, index + 1) || !(after.isTextblock || (0, $gfgdn.canJoin)(state.doc, $pos.pos))) return false;
    if (dispatch) dispatch(state.tr.join($pos.pos).scrollIntoView());
    return true;
}
function $7027fc0208e1ca62$var$deleteBarrier(state, $cut, dispatch, dir) {
    let before = $cut.nodeBefore, after = $cut.nodeAfter, conn, match;
    let isolated = before.type.spec.isolating || after.type.spec.isolating;
    if (!isolated && $7027fc0208e1ca62$var$joinMaybeClear(state, $cut, dispatch)) return true;
    let canDelAfter = !isolated && $cut.parent.canReplace($cut.index(), $cut.index() + 1);
    if (canDelAfter && (conn = (match = before.contentMatchAt(before.childCount)).findWrapping(after.type)) && match.matchType(conn[0] || after.type).validEnd) {
        if (dispatch) {
            let end = $cut.pos + after.nodeSize, wrap = (0, $1krlL.Fragment).empty;
            for(let i = conn.length - 1; i >= 0; i--)wrap = (0, $1krlL.Fragment).from(conn[i].create(null, wrap));
            wrap = (0, $1krlL.Fragment).from(before.copy(wrap));
            let tr = state.tr.step(new (0, $gfgdn.ReplaceAroundStep)($cut.pos - 1, end, $cut.pos, end, new (0, $1krlL.Slice)(wrap, 1, 0), conn.length, true));
            let $joinAt = tr.doc.resolve(end + 2 * conn.length);
            if ($joinAt.nodeAfter && $joinAt.nodeAfter.type == before.type && (0, $gfgdn.canJoin)(tr.doc, $joinAt.pos)) tr.join($joinAt.pos);
            dispatch(tr.scrollIntoView());
        }
        return true;
    }
    let selAfter = after.type.spec.isolating || dir > 0 && isolated ? null : (0, $1LeRC.Selection).findFrom($cut, 1);
    let range = selAfter && selAfter.$from.blockRange(selAfter.$to), target = range && (0, $gfgdn.liftTarget)(range);
    if (target != null && target >= $cut.depth) {
        if (dispatch) dispatch(state.tr.lift(range, target).scrollIntoView());
        return true;
    }
    if (canDelAfter && $7027fc0208e1ca62$var$textblockAt(after, "start", true) && $7027fc0208e1ca62$var$textblockAt(before, "end")) {
        let at = before, wrap = [];
        for(;;){
            wrap.push(at);
            if (at.isTextblock) break;
            at = at.lastChild;
        }
        let afterText = after, afterDepth = 1;
        for(; !afterText.isTextblock; afterText = afterText.firstChild)afterDepth++;
        if (at.canReplace(at.childCount, at.childCount, afterText.content)) {
            if (dispatch) {
                let end = (0, $1krlL.Fragment).empty;
                for(let i = wrap.length - 1; i >= 0; i--)end = (0, $1krlL.Fragment).from(wrap[i].copy(end));
                let tr = state.tr.step(new (0, $gfgdn.ReplaceAroundStep)($cut.pos - wrap.length, $cut.pos + after.nodeSize, $cut.pos + afterDepth, $cut.pos + after.nodeSize - afterDepth, new (0, $1krlL.Slice)(end, wrap.length, 0), 0, true));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
}
function $7027fc0208e1ca62$var$selectTextblockSide(side) {
    return function(state, dispatch) {
        let sel = state.selection, $pos = side < 0 ? sel.$from : sel.$to;
        let depth = $pos.depth;
        while($pos.node(depth).isInline){
            if (!depth) return false;
            depth--;
        }
        if (!$pos.node(depth).isTextblock) return false;
        if (dispatch) dispatch(state.tr.setSelection((0, $1LeRC.TextSelection).create(state.doc, side < 0 ? $pos.start(depth) : $pos.end(depth))));
        return true;
    };
}
/**
Moves the cursor to the start of current text block.
*/ const $7027fc0208e1ca62$export$c3a64f3c9604a1b1 = $7027fc0208e1ca62$var$selectTextblockSide(-1);
/**
Moves the cursor to the end of current text block.
*/ const $7027fc0208e1ca62$export$a66c1876556415e5 = $7027fc0208e1ca62$var$selectTextblockSide(1);
// Parameterized commands
/**
Wrap the selection in a node of the given type with the given
attributes.
*/ function $7027fc0208e1ca62$export$6e5e3c49755affd0(nodeType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), wrapping = range && (0, $gfgdn.findWrapping)(range, nodeType, attrs);
        if (!wrapping) return false;
        if (dispatch) dispatch(state.tr.wrap(range, wrapping).scrollIntoView());
        return true;
    };
}
/**
Returns a command that tries to set the selected textblocks to the
given node type with the given attributes.
*/ function $7027fc0208e1ca62$export$36987f561c736aad(nodeType, attrs = null) {
    return function(state, dispatch) {
        let applicable = false;
        for(let i = 0; i < state.selection.ranges.length && !applicable; i++){
            let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
            state.doc.nodesBetween(from, to, (node, pos)=>{
                if (applicable) return false;
                if (!node.isTextblock || node.hasMarkup(nodeType, attrs)) return;
                if (node.type == nodeType) applicable = true;
                else {
                    let $pos = state.doc.resolve(pos), index = $pos.index();
                    applicable = $pos.parent.canReplaceWith(index, index + 1, nodeType);
                }
            });
        }
        if (!applicable) return false;
        if (dispatch) {
            let tr = state.tr;
            for(let i = 0; i < state.selection.ranges.length; i++){
                let { $from: { pos: from }, $to: { pos: to } } = state.selection.ranges[i];
                tr.setBlockType(from, to, nodeType, attrs);
            }
            dispatch(tr.scrollIntoView());
        }
        return true;
    };
}
function $7027fc0208e1ca62$var$markApplies(doc, ranges, type, enterAtoms) {
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth == 0 ? doc.inlineContent && doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (can || !enterAtoms && node.isAtom && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
        });
        if (can) return true;
    }
    return false;
}
function $7027fc0208e1ca62$var$removeInlineAtoms(ranges) {
    let result = [];
    for(let i = 0; i < ranges.length; i++){
        let { $from: $from, $to: $to } = ranges[i];
        $from.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            if (node.isAtom && node.content.size && node.isInline && pos >= $from.pos && pos + node.nodeSize <= $to.pos) {
                if (pos + 1 > $from.pos) result.push(new (0, $1LeRC.SelectionRange)($from, $from.doc.resolve(pos + 1)));
                $from = $from.doc.resolve(pos + 1 + node.content.size);
                return false;
            }
        });
        if ($from.pos < $to.pos) result.push(new (0, $1LeRC.SelectionRange)($from, $to));
    }
    return result;
}
/**
Create a command function that toggles the given mark with the
given attributes. Will return `false` when the current selection
doesn't support that mark. This will remove the mark if any marks
of that type exist in the selection, or add it otherwise. If the
selection is empty, this applies to the [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks) instead of a range of the
document.
*/ function $7027fc0208e1ca62$export$797ad2667b8015a8(markType, attrs = null, options) {
    let removeWhenPresent = (options && options.removeWhenPresent) !== false;
    let enterAtoms = (options && options.enterInlineAtoms) !== false;
    return function(state, dispatch) {
        let { empty: empty, $cursor: $cursor, ranges: ranges } = state.selection;
        if (empty && !$cursor || !$7027fc0208e1ca62$var$markApplies(state.doc, ranges, markType, enterAtoms)) return false;
        if (dispatch) {
            if ($cursor) {
                if (markType.isInSet(state.storedMarks || $cursor.marks())) dispatch(state.tr.removeStoredMark(markType));
                else dispatch(state.tr.addStoredMark(markType.create(attrs)));
            } else {
                let add, tr = state.tr;
                if (!enterAtoms) ranges = $7027fc0208e1ca62$var$removeInlineAtoms(ranges);
                if (removeWhenPresent) add = !ranges.some((r)=>state.doc.rangeHasMark(r.$from.pos, r.$to.pos, markType));
                else add = !ranges.every((r)=>{
                    let missing = false;
                    tr.doc.nodesBetween(r.$from.pos, r.$to.pos, (node, pos, parent)=>{
                        if (missing) return false;
                        missing = !markType.isInSet(node.marks) && !!parent && parent.type.allowsMarkType(markType) && !(node.isText && /^\s*$/.test(node.textBetween(Math.max(0, r.$from.pos - pos), Math.min(node.nodeSize, r.$to.pos - pos))));
                    });
                    return !missing;
                });
                for(let i = 0; i < ranges.length; i++){
                    let { $from: $from, $to: $to } = ranges[i];
                    if (!add) tr.removeMark($from.pos, $to.pos, markType);
                    else {
                        let from = $from.pos, to = $to.pos, start = $from.nodeAfter, end = $to.nodeBefore;
                        let spaceStart = start && start.isText ? /^\s*/.exec(start.text)[0].length : 0;
                        let spaceEnd = end && end.isText ? /\s*$/.exec(end.text)[0].length : 0;
                        if (from + spaceStart < to) {
                            from += spaceStart;
                            to -= spaceEnd;
                        }
                        tr.addMark(from, to, markType.create(attrs));
                    }
                }
                dispatch(tr.scrollIntoView());
            }
        }
        return true;
    };
}
function $7027fc0208e1ca62$var$wrapDispatchForJoin(dispatch, isJoinable) {
    return (tr)=>{
        if (!tr.isGeneric) return dispatch(tr);
        let ranges = [];
        for(let i = 0; i < tr.mapping.maps.length; i++){
            let map = tr.mapping.maps[i];
            for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
            map.forEach((_s, _e, from, to)=>ranges.push(from, to));
        }
        // Figure out which joinable points exist inside those ranges,
        // by checking all node boundaries in their parent nodes.
        let joinable = [];
        for(let i = 0; i < ranges.length; i += 2){
            let from = ranges[i], to = ranges[i + 1];
            let $from = tr.doc.resolve(from), depth = $from.sharedDepth(to), parent = $from.node(depth);
            for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
                let after = parent.maybeChild(index);
                if (!after) break;
                if (index && joinable.indexOf(pos) == -1) {
                    let before = parent.child(index - 1);
                    if (before.type == after.type && isJoinable(before, after)) joinable.push(pos);
                }
                pos += after.nodeSize;
            }
        }
        // Join the joinable points
        joinable.sort((a, b)=>a - b);
        for(let i = joinable.length - 1; i >= 0; i--)if ((0, $gfgdn.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
        dispatch(tr);
    };
}
/**
Wrap a command so that, when it produces a transform that causes
two joinable nodes to end up next to each other, those are joined.
Nodes are considered joinable when they are of the same type and
when the `isJoinable` predicate returns true for them or, if an
array of strings was passed, if their node type name is in that
array.
*/ function $7027fc0208e1ca62$export$29903073afddcd8b(command, isJoinable) {
    let canJoin = Array.isArray(isJoinable) ? (node)=>isJoinable.indexOf(node.type.name) > -1 : isJoinable;
    return (state, dispatch, view)=>command(state, dispatch && $7027fc0208e1ca62$var$wrapDispatchForJoin(dispatch, canJoin), view);
}
/**
Combine a number of command functions into a single function (which
calls them one by one until one returns true).
*/ function $7027fc0208e1ca62$export$146a774cdef7663a(...commands) {
    return function(state, dispatch, view) {
        for(let i = 0; i < commands.length; i++)if (commands[i](state, dispatch, view)) return true;
        return false;
    };
}
let $7027fc0208e1ca62$var$backspace = $7027fc0208e1ca62$export$146a774cdef7663a($7027fc0208e1ca62$export$e9a518a637d1e641, $7027fc0208e1ca62$export$979097b097459299, $7027fc0208e1ca62$export$52b8a4af68d19794);
let $7027fc0208e1ca62$var$del = $7027fc0208e1ca62$export$146a774cdef7663a($7027fc0208e1ca62$export$e9a518a637d1e641, $7027fc0208e1ca62$export$bf432e340007f9ef, $7027fc0208e1ca62$export$5835b52680b80cfd);
/**
A basic keymap containing bindings not specific to any schema.
Binds the following keys (when multiple commands are listed, they
are chained with [`chainCommands`](https://prosemirror.net/docs/ref/#commands.chainCommands)):

* **Enter** to `newlineInCode`, `createParagraphNear`, `liftEmptyBlock`, `splitBlock`
* **Mod-Enter** to `exitCode`
* **Backspace** and **Mod-Backspace** to `deleteSelection`, `joinBackward`, `selectNodeBackward`
* **Delete** and **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-Delete** to `deleteSelection`, `joinForward`, `selectNodeForward`
* **Mod-a** to `selectAll`
*/ const $7027fc0208e1ca62$export$eb36e8971b04df36 = {
    "Enter": $7027fc0208e1ca62$export$146a774cdef7663a($7027fc0208e1ca62$export$a5d02b4b65e94f91, $7027fc0208e1ca62$export$d0f80ac1b4510888, $7027fc0208e1ca62$export$a3574cc681852c08, $7027fc0208e1ca62$export$e99155638ff4dff0),
    "Mod-Enter": $7027fc0208e1ca62$export$634b78845598ff5b,
    "Backspace": $7027fc0208e1ca62$var$backspace,
    "Mod-Backspace": $7027fc0208e1ca62$var$backspace,
    "Shift-Backspace": $7027fc0208e1ca62$var$backspace,
    "Delete": $7027fc0208e1ca62$var$del,
    "Mod-Delete": $7027fc0208e1ca62$var$del,
    "Mod-a": $7027fc0208e1ca62$export$90aca4adda6ff0f5
};
/**
A copy of `pcBaseKeymap` that also binds **Ctrl-h** like Backspace,
**Ctrl-d** like Delete, **Alt-Backspace** like Ctrl-Backspace, and
**Ctrl-Alt-Backspace**, **Alt-Delete**, and **Alt-d** like
Ctrl-Delete.
*/ const $7027fc0208e1ca62$export$f292ad8dbd5063c8 = {
    "Ctrl-h": $7027fc0208e1ca62$export$eb36e8971b04df36["Backspace"],
    "Alt-Backspace": $7027fc0208e1ca62$export$eb36e8971b04df36["Mod-Backspace"],
    "Ctrl-d": $7027fc0208e1ca62$export$eb36e8971b04df36["Delete"],
    "Ctrl-Alt-Backspace": $7027fc0208e1ca62$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-Delete": $7027fc0208e1ca62$export$eb36e8971b04df36["Mod-Delete"],
    "Alt-d": $7027fc0208e1ca62$export$eb36e8971b04df36["Mod-Delete"],
    "Ctrl-a": $7027fc0208e1ca62$export$c3a64f3c9604a1b1,
    "Ctrl-e": $7027fc0208e1ca62$export$a66c1876556415e5
};
for(let key in $7027fc0208e1ca62$export$eb36e8971b04df36)$7027fc0208e1ca62$export$f292ad8dbd5063c8[key] = $7027fc0208e1ca62$export$eb36e8971b04df36[key];
const $7027fc0208e1ca62$var$mac = typeof navigator != "undefined" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os != "undefined" && os.platform ? os.platform() == "darwin" : false;
/**
Depending on the detected platform, this will hold
[`pcBasekeymap`](https://prosemirror.net/docs/ref/#commands.pcBaseKeymap) or
[`macBaseKeymap`](https://prosemirror.net/docs/ref/#commands.macBaseKeymap).
*/ const $7027fc0208e1ca62$export$4a0c2b85b1f0a889 = $7027fc0208e1ca62$var$mac ? $7027fc0208e1ca62$export$f292ad8dbd5063c8 : $7027fc0208e1ca62$export$eb36e8971b04df36;

});


parcelRegister("jP8IL", function(module, exports) {
$parcel$export(module.exports, "liftListItem", () => (parcelRequire("ie1jF")).liftListItem);
$parcel$export(module.exports, "sinkListItem", () => (parcelRequire("ie1jF")).sinkListItem);
$parcel$export(module.exports, "wrapInList", () => (parcelRequire("ie1jF")).wrapInList);
// schema-list/index.ts
parcelRequire("ie1jF");

});
parcelRegister("ie1jF", function(module, exports) {

$parcel$export(module.exports, "wrapInList", () => $d44a8e25c17a1c43$export$a8aef45c6262afee);
$parcel$export(module.exports, "liftListItem", () => $d44a8e25c17a1c43$export$e74cd5adb935a538);
$parcel$export(module.exports, "sinkListItem", () => $d44a8e25c17a1c43$export$dd505f850a3798a4);

var $gfgdn = parcelRequire("gfgdn");

var $1krlL = parcelRequire("1krlL");

var $1LeRC = parcelRequire("1LeRC");
const $d44a8e25c17a1c43$var$olDOM = [
    "ol",
    0
], $d44a8e25c17a1c43$var$ulDOM = [
    "ul",
    0
], $d44a8e25c17a1c43$var$liDOM = [
    "li",
    0
];
/**
An ordered list [node spec](https://prosemirror.net/docs/ref/#model.NodeSpec). Has a single
attribute, `order`, which determines the number at which the list
starts counting, and defaults to 1. Represented as an `<ol>`
element.
*/ const $d44a8e25c17a1c43$export$a5dc81035676e7a = {
    attrs: {
        order: {
            default: 1,
            validate: "number"
        }
    },
    parseDOM: [
        {
            tag: "ol",
            getAttrs (dom) {
                return {
                    order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1
                };
            }
        }
    ],
    toDOM (node) {
        return node.attrs.order == 1 ? $d44a8e25c17a1c43$var$olDOM : [
            "ol",
            {
                start: node.attrs.order
            },
            0
        ];
    }
};
/**
A bullet list node spec, represented in the DOM as `<ul>`.
*/ const $d44a8e25c17a1c43$export$a140c94e5ea26bee = {
    parseDOM: [
        {
            tag: "ul"
        }
    ],
    toDOM () {
        return $d44a8e25c17a1c43$var$ulDOM;
    }
};
/**
A list item (`<li>`) spec.
*/ const $d44a8e25c17a1c43$export$76c7e83ecc9cdf05 = {
    parseDOM: [
        {
            tag: "li"
        }
    ],
    toDOM () {
        return $d44a8e25c17a1c43$var$liDOM;
    },
    defining: true
};
function $d44a8e25c17a1c43$var$add(obj, props) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    for(let prop in props)copy[prop] = props[prop];
    return copy;
}
/**
Convenience function for adding list-related node types to a map
specifying the nodes for a schema. Adds
[`orderedList`](https://prosemirror.net/docs/ref/#schema-list.orderedList) as `"ordered_list"`,
[`bulletList`](https://prosemirror.net/docs/ref/#schema-list.bulletList) as `"bullet_list"`, and
[`listItem`](https://prosemirror.net/docs/ref/#schema-list.listItem) as `"list_item"`.

`itemContent` determines the content expression for the list items.
If you want the commands defined in this module to apply to your
list structure, it should have a shape like `"paragraph block*"` or
`"paragraph (ordered_list | bullet_list)*"`. `listGroup` can be
given to assign a group name to the list node types, for example
`"block"`.
*/ function $d44a8e25c17a1c43$export$fa2e7d3d1550c2ea(nodes, itemContent, listGroup) {
    return nodes.append({
        ordered_list: $d44a8e25c17a1c43$var$add($d44a8e25c17a1c43$export$a5dc81035676e7a, {
            content: "list_item+",
            group: listGroup
        }),
        bullet_list: $d44a8e25c17a1c43$var$add($d44a8e25c17a1c43$export$a140c94e5ea26bee, {
            content: "list_item+",
            group: listGroup
        }),
        list_item: $d44a8e25c17a1c43$var$add($d44a8e25c17a1c43$export$76c7e83ecc9cdf05, {
            content: itemContent
        })
    });
}
/**
Returns a command function that wraps the selection in a list with
the given type an attributes. If `dispatch` is null, only return a
value to indicate whether this is possible, but don't actually
perform the change.
*/ function $d44a8e25c17a1c43$export$a8aef45c6262afee(listType, attrs = null) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to), doJoin = false, outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex == 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) == 0) return false;
            let $insert = state.doc.resolve(range.start - 2);
            outerRange = new (0, $1krlL.NodeRange)($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) range = new (0, $1krlL.NodeRange)($from, state.doc.resolve($to.end(range.depth)), range.depth);
            doJoin = true;
        }
        let wrap = (0, $gfgdn.findWrapping)(outerRange, listType, attrs, range);
        if (!wrap) return false;
        if (dispatch) dispatch($d44a8e25c17a1c43$var$doWrapInList(state.tr, range, wrap, doJoin, listType).scrollIntoView());
        return true;
    };
}
function $d44a8e25c17a1c43$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $1krlL.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $1krlL.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $gfgdn.ReplaceAroundStep)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $1krlL.Slice)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type == listType) found = i + 1;
    let splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0), parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $gfgdn.canSplit)(tr.doc, splitPos, splitDepth)) {
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}
/**
Build a command that splits a non-empty textblock at the top level
of a list item by also splitting that list item.
*/ function $d44a8e25c17a1c43$export$e920ee2eb756d384(itemType, itemAttrs) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to, node: node } = state.selection;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        let grandParent = $from.node(-1);
        if (grandParent.type != itemType) return false;
        if ($from.parent.content.size == 0 && $from.node(-1).childCount == $from.indexAfter(-1)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth == 3 || $from.node(-3).type != itemType || $from.index(-2) != $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $1krlL.Fragment).empty;
                let depthBefore = $from.index(-1) ? 1 : $from.index(-2) ? 2 : 3;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - depthBefore; d >= $from.depth - 3; d--)wrap = (0, $1krlL.Fragment).from($from.node(d).copy(wrap));
                let depthAfter = $from.indexAfter(-1) < $from.node(-2).childCount ? 1 : $from.indexAfter(-2) < $from.node(-3).childCount ? 2 : 3;
                // Add a second list item with an empty default start node
                wrap = wrap.append((0, $1krlL.Fragment).from(itemType.createAndFill()));
                let start = $from.before($from.depth - (depthBefore - 1));
                let tr = state.tr.replace(start, $from.after(-depthAfter), new (0, $1krlL.Slice)(wrap, 4 - depthBefore, 0));
                let sel = -1;
                tr.doc.nodesBetween(start, tr.doc.content.size, (node, pos)=>{
                    if (sel > -1) return false;
                    if (node.isTextblock && node.content.size == 0) sel = pos + 1;
                });
                if (sel > -1) tr.setSelection((0, $1LeRC.Selection).near(tr.doc.resolve(sel)));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
        let nextType = $to.pos == $from.end() ? grandParent.contentMatchAt(0).defaultType : null;
        let tr = state.tr.delete($from.pos, $to.pos);
        let types = nextType ? [
            itemAttrs ? {
                type: itemType,
                attrs: itemAttrs
            } : null,
            {
                type: nextType
            }
        ] : undefined;
        if (!(0, $gfgdn.canSplit)(tr.doc, $from.pos, 2, types)) return false;
        if (dispatch) dispatch(tr.split($from.pos, 2, types).scrollIntoView());
        return true;
    };
}
/**
Acts like [`splitListItem`](https://prosemirror.net/docs/ref/#schema-list.splitListItem), but
without resetting the set of active marks at the cursor.
*/ function $d44a8e25c17a1c43$export$265ad35055c66d75(itemType, itemAttrs) {
    let split = $d44a8e25c17a1c43$export$e920ee2eb756d384(itemType, itemAttrs);
    return (state, dispatch)=>{
        return split(state, dispatch && ((tr)=>{
            let marks = state.storedMarks || state.selection.$to.parentOffset && state.selection.$from.marks();
            if (marks) tr.ensureMarks(marks);
            dispatch(tr);
        }));
    };
}
/**
Create a command to lift the list item around the selection up into
a wrapping list.
*/ function $d44a8e25c17a1c43$export$e74cd5adb935a538(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        if (!dispatch) return true;
        if ($from.node(range.depth - 1).type == itemType) return $d44a8e25c17a1c43$var$liftToOuterList(state, dispatch, itemType, range);
        else return $d44a8e25c17a1c43$var$liftOutOfList(state, dispatch, range);
    };
}
function $d44a8e25c17a1c43$var$liftToOuterList(state, dispatch, itemType, range) {
    let tr = state.tr, end = range.end, endOfList = range.$to.end(range.depth);
    if (end < endOfList) {
        // There are siblings after the lifted items, which must become
        // children of the last item
        tr.step(new (0, $gfgdn.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(itemType.create(null, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $1krlL.NodeRange)(tr.doc.resolve(range.$from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    const target = (0, $gfgdn.liftTarget)(range);
    if (target == null) return false;
    tr.lift(range, target);
    let after = tr.mapping.map(end, -1) - 1;
    if ((0, $gfgdn.canJoin)(tr.doc, after)) tr.join(after);
    dispatch(tr.scrollIntoView());
    return true;
}
function $d44a8e25c17a1c43$var$liftOutOfList(state, dispatch, range) {
    let tr = state.tr, list = range.parent;
    // Merge the list items into a single big item
    for(let pos = range.end, i = range.endIndex - 1, e = range.startIndex; i > e; i--){
        pos -= list.child(i).nodeSize;
        tr.delete(pos - 1, pos + 1);
    }
    let $start = tr.doc.resolve(range.start), item = $start.nodeAfter;
    if (tr.mapping.map(range.end) != range.start + $start.nodeAfter.nodeSize) return false;
    let atStart = range.startIndex == 0, atEnd = range.endIndex == list.childCount;
    let parent = $start.node(-1), indexBefore = $start.index(-1);
    if (!parent.canReplace(indexBefore + (atStart ? 0 : 1), indexBefore + 1, item.content.append(atEnd ? (0, $1krlL.Fragment).empty : (0, $1krlL.Fragment).from(list)))) return false;
    let start = $start.pos, end = start + item.nodeSize;
    // Strip off the surrounding list. At the sides where we're not at
    // the end of the list, the existing list is closed. At sides where
    // this is the end, it is overwritten to its end.
    tr.step(new (0, $gfgdn.ReplaceAroundStep)(start - (atStart ? 1 : 0), end + (atEnd ? 1 : 0), start + 1, end - 1, new (0, $1krlL.Slice)((atStart ? (0, $1krlL.Fragment).empty : (0, $1krlL.Fragment).from(list.copy((0, $1krlL.Fragment).empty))).append(atEnd ? (0, $1krlL.Fragment).empty : (0, $1krlL.Fragment).from(list.copy((0, $1krlL.Fragment).empty))), atStart ? 0 : 1, atEnd ? 0 : 1), atStart ? 0 : 1));
    dispatch(tr.scrollIntoView());
    return true;
}
/**
Create a command to sink the list item around the selection down
into an inner list.
*/ function $d44a8e25c17a1c43$export$dd505f850a3798a4(itemType) {
    return function(state, dispatch) {
        let { $from: $from, $to: $to } = state.selection;
        let range = $from.blockRange($to, (node)=>node.childCount > 0 && node.firstChild.type == itemType);
        if (!range) return false;
        let startIndex = range.startIndex;
        if (startIndex == 0) return false;
        let parent = range.parent, nodeBefore = parent.child(startIndex - 1);
        if (nodeBefore.type != itemType) return false;
        if (dispatch) {
            let nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type == parent.type;
            let inner = (0, $1krlL.Fragment).from(nestedBefore ? itemType.create() : null);
            let slice = new (0, $1krlL.Slice)((0, $1krlL.Fragment).from(itemType.create(null, (0, $1krlL.Fragment).from(parent.type.create(null, inner)))), nestedBefore ? 3 : 1, 0);
            let before = range.start, after = range.end;
            dispatch(state.tr.step(new (0, $gfgdn.ReplaceAroundStep)(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true)).scrollIntoView());
        }
        return true;
    };
}

});



parcelRegister("2u5A9", function(module, exports) {

$parcel$export(module.exports, "Blockquote", () => $1cf2b69bc5a33625$export$29a7a275fe11687);
$parcel$export(module.exports, "default", () => $1cf2b69bc5a33625$export$29a7a275fe11687);

var $gkCGf = parcelRequire("gkCGf");
/**
 * Matches a blockquote to a `>` as input.
 */ const $1cf2b69bc5a33625$export$55b9391925fcc072 = /^\s*>\s$/;
/**
 * This extension allows you to create blockquotes.
 * @see https://tiptap.dev/api/nodes/blockquote
 */ const $1cf2b69bc5a33625$export$29a7a275fe11687 = (0, $gkCGf.Node).create({
    name: 'blockquote',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    content: 'block+',
    group: 'block',
    defining: true,
    parseHTML () {
        return [
            {
                tag: 'blockquote'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'blockquote',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBlockquote: ()=>({ commands: commands })=>{
                    return commands.wrapIn(this.name);
                },
            toggleBlockquote: ()=>({ commands: commands })=>{
                    return commands.toggleWrap(this.name);
                },
            unsetBlockquote: ()=>({ commands: commands })=>{
                    return commands.lift(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-b': ()=>this.editor.commands.toggleBlockquote()
        };
    },
    addInputRules () {
        return [
            (0, $gkCGf.wrappingInputRule)({
                find: $1cf2b69bc5a33625$export$55b9391925fcc072,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("dacGJ", function(module, exports) {

$parcel$export(module.exports, "BulletList", () => $99560d28eed0b417$export$546f606c73d35982);
$parcel$export(module.exports, "default", () => $99560d28eed0b417$export$546f606c73d35982);

var $gkCGf = parcelRequire("gkCGf");
const $99560d28eed0b417$var$ListItemName = 'listItem';
const $99560d28eed0b417$var$TextStyleName = 'textStyle';
/**
 * Matches a bullet list to a dash or asterisk.
 */ const $99560d28eed0b417$export$55b9391925fcc072 = /^\s*([-+*])\s$/;
/**
 * This extension allows you to create bullet lists.
 * This requires the ListItem extension
 * @see https://tiptap.dev/api/nodes/bullet-list
 * @see https://tiptap.dev/api/nodes/list-item.
 */ const $99560d28eed0b417$export$546f606c73d35982 = (0, $gkCGf.Node).create({
    name: 'bulletList',
    addOptions () {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: 'block list',
    content () {
        return `${this.options.itemTypeName}+`;
    },
    parseHTML () {
        return [
            {
                tag: 'ul'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'ul',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleBulletList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($99560d28eed0b417$var$ListItemName, this.editor.getAttributes($99560d28eed0b417$var$TextStyleName)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-8': ()=>this.editor.commands.toggleBulletList()
        };
    },
    addInputRules () {
        let inputRule = (0, $gkCGf.wrappingInputRule)({
            find: $99560d28eed0b417$export$55b9391925fcc072,
            type: this.type
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $gkCGf.wrappingInputRule)({
            find: $99560d28eed0b417$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: ()=>{
                return this.editor.getAttributes($99560d28eed0b417$var$TextStyleName);
            },
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});

});

parcelRegister("gaTMf", function(module, exports) {

$parcel$export(module.exports, "HorizontalRule", () => $bc68d8b20cccf3bc$export$841e9c95e6429474);
$parcel$export(module.exports, "default", () => $bc68d8b20cccf3bc$export$841e9c95e6429474);

var $gkCGf = parcelRequire("gkCGf");
parcelRequire("7fRs0");
var $1LeRC = parcelRequire("1LeRC");
/**
 * This extension allows you to insert horizontal rules.
 * @see https://www.tiptap.dev/api/nodes/horizontal-rule
 */ const $bc68d8b20cccf3bc$export$841e9c95e6429474 = (0, $gkCGf.Node).create({
    name: 'horizontalRule',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: 'block',
    parseHTML () {
        return [
            {
                tag: 'hr'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'hr',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    addCommands () {
        return {
            setHorizontalRule: ()=>({ chain: chain, state: state })=>{
                    // Check if we can insert the node at the current selection
                    if (!(0, $gkCGf.canInsertNode)(state, state.schema.nodes[this.name])) return false;
                    const { selection: selection } = state;
                    const { $from: $originFrom, $to: $originTo } = selection;
                    const currentChain = chain();
                    if ($originFrom.parentOffset === 0) currentChain.insertContentAt({
                        from: Math.max($originFrom.pos - 1, 0),
                        to: $originTo.pos
                    }, {
                        type: this.name
                    });
                    else if ((0, $gkCGf.isNodeSelection)(selection)) currentChain.insertContentAt($originTo.pos, {
                        type: this.name
                    });
                    else currentChain.insertContent({
                        type: this.name
                    });
                    return currentChain// set cursor after horizontal rule
                    .command(({ tr: tr, dispatch: dispatch })=>{
                        var _a;
                        if (dispatch) {
                            const { $to: $to } = tr.selection;
                            const posAfter = $to.end();
                            if ($to.nodeAfter) {
                                if ($to.nodeAfter.isTextblock) tr.setSelection((0, $1LeRC.TextSelection).create(tr.doc, $to.pos + 1));
                                else if ($to.nodeAfter.isBlock) tr.setSelection((0, $1LeRC.NodeSelection).create(tr.doc, $to.pos));
                                else tr.setSelection((0, $1LeRC.TextSelection).create(tr.doc, $to.pos));
                            } else {
                                // add node after horizontal rule if it’s the end of the document
                                const node = (_a = $to.parent.type.contentMatch.defaultType) === null || _a === void 0 ? void 0 : _a.create();
                                if (node) {
                                    tr.insert(posAfter, node);
                                    tr.setSelection((0, $1LeRC.TextSelection).create(tr.doc, posAfter + 1));
                                }
                            }
                            tr.scrollIntoView();
                        }
                        return true;
                    }).run();
                }
        };
    },
    addInputRules () {
        return [
            (0, $gkCGf.nodeInputRule)({
                find: /^(?:---|—-|___\s|\*\*\*\s)$/,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("a49L5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7541d8e7fc52594e$export$a6c7ac8248d6e38a);

var $gkCGf = parcelRequire("gkCGf");

var $dR4Gt = parcelRequire("dR4Gt");
parcelRequire("7fRs0");
var $1LeRC = parcelRequire("1LeRC");
// From DOMPurify
// https://github.com/cure53/DOMPurify/blob/main/src/regexp.ts
const $7541d8e7fc52594e$var$UNICODE_WHITESPACE_PATTERN = '[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]';
const $7541d8e7fc52594e$var$UNICODE_WHITESPACE_REGEX = new RegExp($7541d8e7fc52594e$var$UNICODE_WHITESPACE_PATTERN);
const $7541d8e7fc52594e$var$UNICODE_WHITESPACE_REGEX_END = new RegExp(`${$7541d8e7fc52594e$var$UNICODE_WHITESPACE_PATTERN}$`);
const $7541d8e7fc52594e$var$UNICODE_WHITESPACE_REGEX_GLOBAL = new RegExp($7541d8e7fc52594e$var$UNICODE_WHITESPACE_PATTERN, 'g');
/**
 * Check if the provided tokens form a valid link structure, which can either be a single link token
 * or a link token surrounded by parentheses or square brackets.
 *
 * This ensures that only complete and valid text is hyperlinked, preventing cases where a valid
 * top-level domain (TLD) is immediately followed by an invalid character, like a number. For
 * example, with the `find` method from Linkify, entering `example.com1` would result in
 * `example.com` being linked and the trailing `1` left as plain text. By using the `tokenize`
 * method, we can perform more comprehensive validation on the input text.
 */ function $7541d8e7fc52594e$var$isValidLinkStructure(tokens) {
    if (tokens.length === 1) return tokens[0].isLink;
    if (tokens.length === 3 && tokens[1].isLink) return [
        '()',
        '[]'
    ].includes(tokens[0].value + tokens[2].value);
    return false;
}
/**
 * This plugin allows you to automatically add links to your editor.
 * @param options The plugin options
 * @returns The plugin instance
 */ function $7541d8e7fc52594e$var$autolink(options) {
    return new (0, $1LeRC.Plugin)({
        key: new (0, $1LeRC.PluginKey)('autolink'),
        appendTransaction: (transactions, oldState, newState)=>{
            /**
             * Does the transaction change the document?
             */ const docChanges = transactions.some((transaction)=>transaction.docChanged) && !oldState.doc.eq(newState.doc);
            /**
             * Prevent autolink if the transaction is not a document change or if the transaction has the meta `preventAutolink`.
             */ const preventAutolink = transactions.some((transaction)=>transaction.getMeta('preventAutolink'));
            /**
             * Prevent autolink if the transaction is not a document change
             * or if the transaction has the meta `preventAutolink`.
             */ if (!docChanges || preventAutolink) return;
            const { tr: tr } = newState;
            const transform = (0, $gkCGf.combineTransactionSteps)(oldState.doc, [
                ...transactions
            ]);
            const changes = (0, $gkCGf.getChangedRanges)(transform);
            changes.forEach(({ newRange: newRange })=>{
                // Now let’s see if we can add new links.
                const nodesInChangedRanges = (0, $gkCGf.findChildrenInRange)(newState.doc, newRange, (node)=>node.isTextblock);
                let textBlock;
                let textBeforeWhitespace;
                if (nodesInChangedRanges.length > 1) {
                    // Grab the first node within the changed ranges (ex. the first of two paragraphs when hitting enter).
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, textBlock.pos + textBlock.node.nodeSize, undefined, ' ');
                } else if (nodesInChangedRanges.length) {
                    const endText = newState.doc.textBetween(newRange.from, newRange.to, ' ', ' ');
                    if (!$7541d8e7fc52594e$var$UNICODE_WHITESPACE_REGEX_END.test(endText)) return;
                    textBlock = nodesInChangedRanges[0];
                    textBeforeWhitespace = newState.doc.textBetween(textBlock.pos, newRange.to, undefined, ' ');
                }
                if (textBlock && textBeforeWhitespace) {
                    const wordsBeforeWhitespace = textBeforeWhitespace.split($7541d8e7fc52594e$var$UNICODE_WHITESPACE_REGEX).filter(Boolean);
                    if (wordsBeforeWhitespace.length <= 0) return false;
                    const lastWordBeforeSpace = wordsBeforeWhitespace[wordsBeforeWhitespace.length - 1];
                    const lastWordAndBlockOffset = textBlock.pos + textBeforeWhitespace.lastIndexOf(lastWordBeforeSpace);
                    if (!lastWordBeforeSpace) return false;
                    const linksBeforeSpace = (0, $dR4Gt.tokenize)(lastWordBeforeSpace).map((t)=>t.toObject(options.defaultProtocol));
                    if (!$7541d8e7fc52594e$var$isValidLinkStructure(linksBeforeSpace)) return false;
                    linksBeforeSpace.filter((link)=>link.isLink)// Calculate link position.
                    .map((link)=>({
                            ...link,
                            from: lastWordAndBlockOffset + link.start + 1,
                            to: lastWordAndBlockOffset + link.end + 1
                        }))// ignore link inside code mark
                    .filter((link)=>{
                        if (!newState.schema.marks.code) return true;
                        return !newState.doc.rangeHasMark(link.from, link.to, newState.schema.marks.code);
                    })// validate link
                    .filter((link)=>options.validate(link.value))// check whether should autolink
                    .filter((link)=>options.shouldAutoLink(link.value))// Add link mark.
                    .forEach((link)=>{
                        if ((0, $gkCGf.getMarksBetween)(link.from, link.to, newState.doc).some((item)=>item.mark.type === options.type)) return;
                        tr.addMark(link.from, link.to, options.type.create({
                            href: link.href
                        }));
                    });
                }
            });
            if (!tr.steps.length) return;
            return tr;
        }
    });
}
function $7541d8e7fc52594e$var$clickHandler(options) {
    return new (0, $1LeRC.Plugin)({
        key: new (0, $1LeRC.PluginKey)('handleClickLink'),
        props: {
            handleClick: (view, pos, event)=>{
                var _a, _b;
                if (event.button !== 0) return false;
                if (!view.editable) return false;
                let a = event.target;
                const els = [];
                while(a.nodeName !== 'DIV'){
                    els.push(a);
                    a = a.parentNode;
                }
                if (!els.find((value)=>value.nodeName === 'A')) return false;
                const attrs = (0, $gkCGf.getAttributes)(view.state, options.type.name);
                const link = event.target;
                const href = (_a = link === null || link === void 0 ? void 0 : link.href) !== null && _a !== void 0 ? _a : attrs.href;
                const target = (_b = link === null || link === void 0 ? void 0 : link.target) !== null && _b !== void 0 ? _b : attrs.target;
                if (link && href) {
                    window.open(href, target);
                    return true;
                }
                return false;
            }
        }
    });
}
function $7541d8e7fc52594e$var$pasteHandler(options) {
    return new (0, $1LeRC.Plugin)({
        key: new (0, $1LeRC.PluginKey)('handlePasteLink'),
        props: {
            handlePaste: (view, event, slice)=>{
                const { state: state } = view;
                const { selection: selection } = state;
                const { empty: empty } = selection;
                if (empty) return false;
                let textContent = '';
                slice.content.forEach((node)=>{
                    textContent += node.textContent;
                });
                const link = (0, $dR4Gt.find)(textContent, {
                    defaultProtocol: options.defaultProtocol
                }).find((item)=>item.isLink && item.value === textContent);
                if (!textContent || !link) return false;
                return options.editor.commands.setMark(options.type, {
                    href: link.href
                });
            }
        }
    });
}
const $7541d8e7fc52594e$export$4ed30f8936af1979 = /https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z]{2,}\b(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)(?:[-a-zA-Z0-9@:%._+~#=?!&/]*)/gi;
function $7541d8e7fc52594e$export$7e0e3bd861dc5487(uri, protocols) {
    const allowedProtocols = [
        'http',
        'https',
        'ftp',
        'ftps',
        'mailto',
        'tel',
        'callto',
        'sms',
        'cid',
        'xmpp'
    ];
    if (protocols) protocols.forEach((protocol)=>{
        const nextProtocol = typeof protocol === 'string' ? protocol : protocol.scheme;
        if (nextProtocol) allowedProtocols.push(nextProtocol);
    });
    return !uri || uri.replace($7541d8e7fc52594e$var$UNICODE_WHITESPACE_REGEX_GLOBAL, '').match(new RegExp(// eslint-disable-next-line no-useless-escape
    `^(?:(?:${allowedProtocols.join('|')}):|[^a-z]|[a-z0-9+.\-]+(?:[^a-z+.\-:]|$))`, 'i'));
}
/**
 * This extension allows you to create links.
 * @see https://www.tiptap.dev/api/marks/link
 */ const $7541d8e7fc52594e$export$a6c7ac8248d6e38a = (0, $gkCGf.Mark).create({
    name: 'link',
    priority: 1000,
    keepOnSplit: false,
    exitable: true,
    onCreate () {
        if (this.options.validate && !this.options.shouldAutoLink) {
            // Copy the validate function to the shouldAutoLink option
            this.options.shouldAutoLink = this.options.validate;
            console.warn('The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.');
        }
        this.options.protocols.forEach((protocol)=>{
            if (typeof protocol === 'string') {
                (0, $dR4Gt.registerCustomProtocol)(protocol);
                return;
            }
            (0, $dR4Gt.registerCustomProtocol)(protocol.scheme, protocol.optionalSlashes);
        });
    },
    onDestroy () {
        (0, $dR4Gt.reset)();
    },
    inclusive () {
        return this.options.autolink;
    },
    addOptions () {
        return {
            openOnClick: true,
            linkOnPaste: true,
            autolink: true,
            protocols: [],
            defaultProtocol: 'http',
            HTMLAttributes: {
                target: '_blank',
                rel: 'noopener noreferrer nofollow',
                class: null
            },
            isAllowedUri: (url, ctx)=>!!$7541d8e7fc52594e$export$7e0e3bd861dc5487(url, ctx.protocols),
            validate: (url)=>!!url,
            shouldAutoLink: (url)=>!!url
        };
    },
    addAttributes () {
        return {
            href: {
                default: null,
                parseHTML (element) {
                    return element.getAttribute('href');
                }
            },
            target: {
                default: this.options.HTMLAttributes.target
            },
            rel: {
                default: this.options.HTMLAttributes.rel
            },
            class: {
                default: this.options.HTMLAttributes.class
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: 'a[href]',
                getAttrs: (dom)=>{
                    const href = dom.getAttribute('href');
                    // prevent XSS attacks
                    if (!href || !this.options.isAllowedUri(href, {
                        defaultValidate: (url)=>!!$7541d8e7fc52594e$export$7e0e3bd861dc5487(url, this.options.protocols),
                        protocols: this.options.protocols,
                        defaultProtocol: this.options.defaultProtocol
                    })) return false;
                    return null;
                }
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        // prevent XSS attacks
        if (!this.options.isAllowedUri(HTMLAttributes.href, {
            defaultValidate: (href)=>!!$7541d8e7fc52594e$export$7e0e3bd861dc5487(href, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
        })) // strip out the href
        return [
            'a',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, {
                ...HTMLAttributes,
                href: ''
            }),
            0
        ];
        return [
            'a',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setLink: (attributes)=>({ chain: chain })=>{
                    const { href: href } = attributes;
                    if (!this.options.isAllowedUri(href, {
                        defaultValidate: (url)=>!!$7541d8e7fc52594e$export$7e0e3bd861dc5487(url, this.options.protocols),
                        protocols: this.options.protocols,
                        defaultProtocol: this.options.defaultProtocol
                    })) return false;
                    return chain().setMark(this.name, attributes).setMeta('preventAutolink', true).run();
                },
            toggleLink: (attributes)=>({ chain: chain })=>{
                    const { href: href } = attributes;
                    if (!this.options.isAllowedUri(href, {
                        defaultValidate: (url)=>!!$7541d8e7fc52594e$export$7e0e3bd861dc5487(url, this.options.protocols),
                        protocols: this.options.protocols,
                        defaultProtocol: this.options.defaultProtocol
                    })) return false;
                    return chain().toggleMark(this.name, attributes, {
                        extendEmptyMarkRange: true
                    }).setMeta('preventAutolink', true).run();
                },
            unsetLink: ()=>({ chain: chain })=>{
                    return chain().unsetMark(this.name, {
                        extendEmptyMarkRange: true
                    }).setMeta('preventAutolink', true).run();
                }
        };
    },
    addPasteRules () {
        return [
            (0, $gkCGf.markPasteRule)({
                find: (text)=>{
                    const foundLinks = [];
                    if (text) {
                        const { protocols: protocols, defaultProtocol: defaultProtocol } = this.options;
                        const links = (0, $dR4Gt.find)(text).filter((item)=>item.isLink && this.options.isAllowedUri(item.value, {
                                defaultValidate: (href)=>!!$7541d8e7fc52594e$export$7e0e3bd861dc5487(href, protocols),
                                protocols: protocols,
                                defaultProtocol: defaultProtocol
                            }));
                        if (links.length) links.forEach((link)=>foundLinks.push({
                                text: link.value,
                                data: {
                                    href: link.href
                                },
                                index: link.start
                            }));
                    }
                    return foundLinks;
                },
                type: this.type,
                getAttributes: (match)=>{
                    var _a;
                    return {
                        href: (_a = match.data) === null || _a === void 0 ? void 0 : _a.href
                    };
                }
            })
        ];
    },
    addProseMirrorPlugins () {
        const plugins = [];
        const { protocols: protocols, defaultProtocol: defaultProtocol } = this.options;
        if (this.options.autolink) plugins.push($7541d8e7fc52594e$var$autolink({
            type: this.type,
            defaultProtocol: this.options.defaultProtocol,
            validate: (url)=>this.options.isAllowedUri(url, {
                    defaultValidate: (href)=>!!$7541d8e7fc52594e$export$7e0e3bd861dc5487(href, protocols),
                    protocols: protocols,
                    defaultProtocol: defaultProtocol
                }),
            shouldAutoLink: this.options.shouldAutoLink
        }));
        if (this.options.openOnClick === true) plugins.push($7541d8e7fc52594e$var$clickHandler({
            type: this.type
        }));
        if (this.options.linkOnPaste) plugins.push($7541d8e7fc52594e$var$pasteHandler({
            editor: this.editor,
            defaultProtocol: this.options.defaultProtocol,
            type: this.type
        }));
        return plugins;
    }
});

});
parcelRegister("dR4Gt", function(module, exports) {

$parcel$export(module.exports, "reset", () => $a163dbbf8fe68e4d$export$aad8462122ac592b);
$parcel$export(module.exports, "registerCustomProtocol", () => $a163dbbf8fe68e4d$export$821627edc2d26f5f);
$parcel$export(module.exports, "tokenize", () => $a163dbbf8fe68e4d$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "find", () => $a163dbbf8fe68e4d$export$71aa6c912b956294);
// THIS FILE IS AUTOMATICALLY GENERATED DO NOT EDIT DIRECTLY
// See update-tlds.js for encoding/decoding format
// https://data.iana.org/TLD/tlds-alpha-by-domain.txt
const $a163dbbf8fe68e4d$var$encodedTlds = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5m\xf6gensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2";
// Internationalized domain names containing non-ASCII
const $a163dbbf8fe68e4d$var$encodedUtlds = "\u03B5\u03BB1\u03C52\u0431\u04331\u0435\u043B3\u0434\u0435\u0442\u04384\u0435\u044E2\u043A\u0430\u0442\u043E\u043B\u0438\u043A6\u043E\u043C3\u043C\u043A\u04342\u043E\u043D1\u0441\u043A\u0432\u04306\u043E\u043D\u043B\u0430\u0439\u043D5\u0440\u04333\u0440\u0443\u04412\u04442\u0441\u0430\u0439\u04423\u0440\u04313\u0443\u043A\u04403\u049B\u0430\u04373\u0570\u0561\u05753\u05D9\u05E9\u05E8\u05D0\u05DC5\u05E7\u05D5\u05DD3\u0627\u0628\u0648\u0638\u0628\u064A5\u0631\u0627\u0645\u0643\u06485\u0644\u0627\u0631\u062F\u06464\u0628\u062D\u0631\u064A\u06465\u062C\u0632\u0627\u0626\u06315\u0633\u0639\u0648\u062F\u064A\u06296\u0639\u0644\u064A\u0627\u06465\u0645\u063A\u0631\u06285\u0645\u0627\u0631\u0627\u062A5\u06CC\u0631\u0627\u06465\u0628\u0627\u0631\u062A2\u0632\u0627\u06314\u064A\u062A\u06433\u06BE\u0627\u0631\u062A5\u062A\u0648\u0646\u06334\u0633\u0648\u062F\u0627\u06463\u0631\u064A\u06295\u0634\u0628\u0643\u06294\u0639\u0631\u0627\u06422\u06282\u0645\u0627\u06464\u0641\u0644\u0633\u0637\u064A\u06466\u0642\u0637\u06313\u0643\u0627\u062B\u0648\u0644\u064A\u06436\u0648\u06453\u0645\u0635\u06312\u0644\u064A\u0633\u064A\u06275\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u06277\u0642\u06394\u0647\u0645\u0631\u0627\u06475\u067E\u0627\u06A9\u0633\u062A\u0627\u06467\u0680\u0627\u0631\u062A4\u0915\u0949\u092E3\u0928\u0947\u091F3\u092D\u093E\u0930\u09240\u092E\u094D3\u094B\u09245\u0938\u0902\u0917\u0920\u09285\u09AC\u09BE\u0982\u09B2\u09BE5\u09AD\u09BE\u09B0\u09A42\u09F0\u09A44\u0A2D\u0A3E\u0A30\u0A244\u0AAD\u0ABE\u0AB0\u0AA44\u0B2D\u0B3E\u0B30\u0B244\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE6\u0BB2\u0B99\u0BCD\u0B95\u0BC86\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD11\u0C2D\u0C3E\u0C30\u0C24\u0C4D5\u0CAD\u0CBE\u0CB0\u0CA44\u0D2D\u0D3E\u0D30\u0D24\u0D025\u0DBD\u0D82\u0D9A\u0DCF4\u0E04\u0E2D\u0E213\u0E44\u0E17\u0E223\u0EA5\u0EB2\u0EA73\u10D2\u10D42\u307F\u3093\u306A3\u30A2\u30DE\u30BE\u30F34\u30AF\u30E9\u30A6\u30C94\u30B0\u30FC\u30B0\u30EB4\u30B3\u30E02\u30B9\u30C8\u30A23\u30BB\u30FC\u30EB3\u30D5\u30A1\u30C3\u30B7\u30E7\u30F36\u30DD\u30A4\u30F3\u30C84\u4E16\u754C2\u4E2D\u4FE11\u56FD1\u570B1\u6587\u7F513\u4E9A\u9A6C\u900A3\u4F01\u4E1A2\u4F5B\u5C712\u4FE1\u606F2\u5065\u5EB72\u516B\u53662\u516C\u53F81\u76CA2\u53F0\u6E7E1\u70632\u5546\u57CE1\u5E971\u68072\u5609\u91CC0\u5927\u9152\u5E975\u5728\u7EBF2\u5927\u62FF2\u5929\u4E3B\u65593\u5A31\u4E502\u5BB6\u96FB2\u5E7F\u4E1C2\u5FAE\u535A2\u6148\u55842\u6211\u7231\u4F603\u624B\u673A2\u62DB\u80582\u653F\u52A11\u5E9C2\u65B0\u52A0\u57612\u95FB2\u65F6\u5C1A2\u66F8\u7C4D2\u673A\u67842\u6DE1\u9A6C\u95213\u6E38\u620F2\u6FB3\u95802\u70B9\u770B2\u79FB\u52A82\u7EC4\u7EC7\u673A\u67844\u7F51\u57401\u5E971\u7AD91\u7EDC2\u8054\u901A2\u8C37\u6B4C2\u8D2D\u72692\u901A\u8CA92\u96C6\u56E22\u96FB\u8A0A\u76C8\u79D14\u98DE\u5229\u6D663\u98DF\u54C12\u9910\u53852\u9999\u683C\u91CC\u62C93\u6E2F2\uB2F7\uB1371\uCEF42\uC0BC\uC1312\uD55C\uAD6D2";
/**
 * @template A
 * @template B
 * @param {A} target
 * @param {B} properties
 * @return {A & B}
 */ const $a163dbbf8fe68e4d$var$assign = (target, properties)=>{
    for(const key in properties)target[key] = properties[key];
    return target;
};
/**
 * Finite State Machine generation utilities
 */ /**
 * @template T
 * @typedef {{ [group: string]: T[] }} Collections
 */ /**
 * @typedef {{ [group: string]: true }} Flags
 */ // Keys in scanner Collections instances
const $a163dbbf8fe68e4d$var$numeric = 'numeric';
const $a163dbbf8fe68e4d$var$ascii = 'ascii';
const $a163dbbf8fe68e4d$var$alpha = 'alpha';
const $a163dbbf8fe68e4d$var$asciinumeric = 'asciinumeric';
const $a163dbbf8fe68e4d$var$alphanumeric = 'alphanumeric';
const $a163dbbf8fe68e4d$var$domain = 'domain';
const $a163dbbf8fe68e4d$var$emoji = 'emoji';
const $a163dbbf8fe68e4d$var$scheme = 'scheme';
const $a163dbbf8fe68e4d$var$slashscheme = 'slashscheme';
const $a163dbbf8fe68e4d$var$whitespace = 'whitespace';
/**
 * @template T
 * @param {string} name
 * @param {Collections<T>} groups to register in
 * @returns {T[]} Current list of tokens in the given collection
 */ function $a163dbbf8fe68e4d$var$registerGroup(name, groups) {
    if (!(name in groups)) groups[name] = [];
    return groups[name];
}
/**
 * @template T
 * @param {T} t token to add
 * @param {Collections<T>} groups
 * @param {Flags} flags
 */ function $a163dbbf8fe68e4d$var$addToGroups(t, flags, groups) {
    if (flags[$a163dbbf8fe68e4d$var$numeric]) {
        flags[$a163dbbf8fe68e4d$var$asciinumeric] = true;
        flags[$a163dbbf8fe68e4d$var$alphanumeric] = true;
    }
    if (flags[$a163dbbf8fe68e4d$var$ascii]) {
        flags[$a163dbbf8fe68e4d$var$asciinumeric] = true;
        flags[$a163dbbf8fe68e4d$var$alpha] = true;
    }
    if (flags[$a163dbbf8fe68e4d$var$asciinumeric]) flags[$a163dbbf8fe68e4d$var$alphanumeric] = true;
    if (flags[$a163dbbf8fe68e4d$var$alpha]) flags[$a163dbbf8fe68e4d$var$alphanumeric] = true;
    if (flags[$a163dbbf8fe68e4d$var$alphanumeric]) flags[$a163dbbf8fe68e4d$var$domain] = true;
    if (flags[$a163dbbf8fe68e4d$var$emoji]) flags[$a163dbbf8fe68e4d$var$domain] = true;
    for(const k in flags){
        const group = $a163dbbf8fe68e4d$var$registerGroup(k, groups);
        if (group.indexOf(t) < 0) group.push(t);
    }
}
/**
 * @template T
 * @param {T} t token to check
 * @param {Collections<T>} groups
 * @returns {Flags} group flags that contain this token
 */ function $a163dbbf8fe68e4d$var$flagsForToken(t, groups) {
    const result = {};
    for(const c in groups)if (groups[c].indexOf(t) >= 0) result[c] = true;
    return result;
}
/**
 * @template T
 * @typedef {null | T } Transition
 */ /**
 * Define a basic state machine state. j is the list of character transitions,
 * jr is the list of regex-match transitions, jd is the default state to
 * transition to t is the accepting token type, if any. If this is the terminal
 * state, then it does not emit a token.
 *
 * The template type T represents the type of the token this state accepts. This
 * should be a string (such as of the token exports in `text.js`) or a
 * MultiToken subclass (from `multi.js`)
 *
 * @template T
 * @param {T} [token] Token that this state emits
 */ function $a163dbbf8fe68e4d$export$7254cc27399e90bd(token = null) {
    // this.n = null; // DEBUG: State name
    /** @type {{ [input: string]: State<T> }} j */ this.j = {}; // IMPLEMENTATION 1
    // this.j = []; // IMPLEMENTATION 2
    /** @type {[RegExp, State<T>][]} jr */ this.jr = [];
    /** @type {?State<T>} jd */ this.jd = null;
    /** @type {?T} t */ this.t = token;
}
/**
 * Scanner token groups
 * @type Collections<string>
 */ $a163dbbf8fe68e4d$export$7254cc27399e90bd.groups = {};
$a163dbbf8fe68e4d$export$7254cc27399e90bd.prototype = {
    accepts () {
        return !!this.t;
    },
    /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */ go (input) {
        const state = this;
        const nextState = state.j[input];
        if (nextState) return nextState;
        for(let i = 0; i < state.jr.length; i++){
            const regex = state.jr[i][0];
            const nextState = state.jr[i][1]; // note: might be empty to prevent default jump
            if (nextState && regex.test(input)) return nextState;
        }
        // Nowhere left to jump! Return default, if any
        return state.jd;
    },
    /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */ has (input, exactOnly = false) {
        return exactOnly ? input in this.j : !!this.go(input);
    },
    /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */ ta (inputs, next, flags, groups) {
        for(let i = 0; i < inputs.length; i++)this.tt(inputs[i], next, flags, groups);
    },
    /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ tr (regexp, next, flags, groups) {
        groups = groups || $a163dbbf8fe68e4d$export$7254cc27399e90bd.groups;
        let nextState;
        if (next && next.j) nextState = next;
        else {
            // Token with maybe token groups
            nextState = new $a163dbbf8fe68e4d$export$7254cc27399e90bd(next);
            if (flags && groups) $a163dbbf8fe68e4d$var$addToGroups(next, flags, groups);
        }
        this.jr.push([
            regexp,
            nextState
        ]);
        return nextState;
    },
    /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */ ts (input, next, flags, groups) {
        let state = this;
        const len = input.length;
        if (!len) return state;
        for(let i = 0; i < len - 1; i++)state = state.tt(input[i]);
        return state.tt(input[len - 1], next, flags, groups);
    },
    /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */ tt (input, next, flags, groups) {
        groups = groups || $a163dbbf8fe68e4d$export$7254cc27399e90bd.groups;
        const state = this;
        // Check if existing state given, just a basic transition
        if (next && next.j) {
            state.j[input] = next;
            return next;
        }
        const t = next;
        // Take the transition with the usual default mechanisms and use that as
        // a template for creating the next state
        let nextState, templateState = state.go(input);
        if (templateState) {
            nextState = new $a163dbbf8fe68e4d$export$7254cc27399e90bd();
            $a163dbbf8fe68e4d$var$assign(nextState.j, templateState.j);
            nextState.jr.push.apply(nextState.jr, templateState.jr);
            nextState.jd = templateState.jd;
            nextState.t = templateState.t;
        } else nextState = new $a163dbbf8fe68e4d$export$7254cc27399e90bd();
        if (t) {
            // Ensure newly token is in the same groups as the old token
            if (groups) {
                if (nextState.t && typeof nextState.t === 'string') {
                    const allFlags = $a163dbbf8fe68e4d$var$assign($a163dbbf8fe68e4d$var$flagsForToken(nextState.t, groups), flags);
                    $a163dbbf8fe68e4d$var$addToGroups(t, allFlags, groups);
                } else if (flags) $a163dbbf8fe68e4d$var$addToGroups(t, flags, groups);
            }
            nextState.t = t; // overwrite anything that was previously there
        }
        state.j[input] = nextState;
        return nextState;
    }
};
// Helper functions to improve minification (not exported outside linkifyjs module)
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $a163dbbf8fe68e4d$var$ta = (state, input, next, flags, groups)=>state.ta(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {RegExp} regexp
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $a163dbbf8fe68e4d$var$tr = (state, regexp, next, flags, groups)=>state.tr(regexp, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string | string[]} input
 * @param {T | State<T>} [next]
 * @param {Flags} [flags]
 * @param {Collections<T>} [groups]
 */ const $a163dbbf8fe68e4d$var$ts = (state, input, next, flags, groups)=>state.ts(input, next, flags, groups);
/**
 * @template T
 * @param {State<T>} state
 * @param {string} input
 * @param {T | State<T>} [next]
 * @param {Collections<T>} [groups]
 * @param {Flags} [flags]
 */ const $a163dbbf8fe68e4d$var$tt = (state, input, next, flags, groups)=>state.tt(input, next, flags, groups);
/******************************************************************************
Text Tokens
Identifiers for token outputs from the regexp scanner
******************************************************************************/ // A valid web domain token
const $a163dbbf8fe68e4d$var$WORD = 'WORD'; // only contains a-z
const $a163dbbf8fe68e4d$var$UWORD = 'UWORD'; // contains letters other than a-z, used for IDN
const $a163dbbf8fe68e4d$var$ASCIINUMERICAL = 'ASCIINUMERICAL'; // contains a-z, 0-9
const $a163dbbf8fe68e4d$var$ALPHANUMERICAL = 'ALPHANUMERICAL'; // contains numbers and letters other than a-z, used for IDN
// Special case of word
const $a163dbbf8fe68e4d$var$LOCALHOST = 'LOCALHOST';
// Valid top-level domain, special case of WORD (see tlds.js)
const $a163dbbf8fe68e4d$var$TLD = 'TLD';
// Valid IDN TLD, special case of UWORD (see tlds.js)
const $a163dbbf8fe68e4d$var$UTLD = 'UTLD';
// The scheme portion of a web URI protocol. Supported types include: `mailto`,
// `file`, and user-defined custom protocols. Limited to schemes that contain
// only letters
const $a163dbbf8fe68e4d$var$SCHEME = 'SCHEME';
// Similar to SCHEME, except makes distinction for schemes that must always be
// followed by `://`, not just `:`. Supported types include `http`, `https`,
// `ftp`, `ftps`
const $a163dbbf8fe68e4d$var$SLASH_SCHEME = 'SLASH_SCHEME';
// Any sequence of digits 0-9
const $a163dbbf8fe68e4d$var$NUM = 'NUM';
// Any number of consecutive whitespace characters that are not newline
const $a163dbbf8fe68e4d$var$WS = 'WS';
// New line (unix style)
const $a163dbbf8fe68e4d$var$NL = 'NL'; // \n
// Opening/closing bracket classes
// TODO: Rename OPEN -> LEFT and CLOSE -> RIGHT in v5 to fit with Unicode names
// Also rename angle brackes to LESSTHAN and GREATER THAN
const $a163dbbf8fe68e4d$var$OPENBRACE = 'OPENBRACE'; // {
const $a163dbbf8fe68e4d$var$CLOSEBRACE = 'CLOSEBRACE'; // }
const $a163dbbf8fe68e4d$var$OPENBRACKET = 'OPENBRACKET'; // [
const $a163dbbf8fe68e4d$var$CLOSEBRACKET = 'CLOSEBRACKET'; // ]
const $a163dbbf8fe68e4d$var$OPENPAREN = 'OPENPAREN'; // (
const $a163dbbf8fe68e4d$var$CLOSEPAREN = 'CLOSEPAREN'; // )
const $a163dbbf8fe68e4d$var$OPENANGLEBRACKET = 'OPENANGLEBRACKET'; // <
const $a163dbbf8fe68e4d$var$CLOSEANGLEBRACKET = 'CLOSEANGLEBRACKET'; // >
const $a163dbbf8fe68e4d$var$FULLWIDTHLEFTPAREN = 'FULLWIDTHLEFTPAREN'; // （
const $a163dbbf8fe68e4d$var$FULLWIDTHRIGHTPAREN = 'FULLWIDTHRIGHTPAREN'; // ）
const $a163dbbf8fe68e4d$var$LEFTCORNERBRACKET = 'LEFTCORNERBRACKET'; // 「
const $a163dbbf8fe68e4d$var$RIGHTCORNERBRACKET = 'RIGHTCORNERBRACKET'; // 」
const $a163dbbf8fe68e4d$var$LEFTWHITECORNERBRACKET = 'LEFTWHITECORNERBRACKET'; // 『
const $a163dbbf8fe68e4d$var$RIGHTWHITECORNERBRACKET = 'RIGHTWHITECORNERBRACKET'; // 』
const $a163dbbf8fe68e4d$var$FULLWIDTHLESSTHAN = 'FULLWIDTHLESSTHAN'; // ＜
const $a163dbbf8fe68e4d$var$FULLWIDTHGREATERTHAN = 'FULLWIDTHGREATERTHAN'; // ＞
// Various symbols
const $a163dbbf8fe68e4d$var$AMPERSAND = 'AMPERSAND'; // &
const $a163dbbf8fe68e4d$var$APOSTROPHE = 'APOSTROPHE'; // '
const $a163dbbf8fe68e4d$var$ASTERISK = 'ASTERISK'; // *
const $a163dbbf8fe68e4d$var$AT = 'AT'; // @
const $a163dbbf8fe68e4d$var$BACKSLASH = 'BACKSLASH'; // \
const $a163dbbf8fe68e4d$var$BACKTICK = 'BACKTICK'; // `
const $a163dbbf8fe68e4d$var$CARET = 'CARET'; // ^
const $a163dbbf8fe68e4d$var$COLON = 'COLON'; // :
const $a163dbbf8fe68e4d$var$COMMA = 'COMMA'; // ,
const $a163dbbf8fe68e4d$var$DOLLAR = 'DOLLAR'; // $
const $a163dbbf8fe68e4d$var$DOT = 'DOT'; // .
const $a163dbbf8fe68e4d$var$EQUALS = 'EQUALS'; // =
const $a163dbbf8fe68e4d$var$EXCLAMATION = 'EXCLAMATION'; // !
const $a163dbbf8fe68e4d$var$HYPHEN = 'HYPHEN'; // -
const $a163dbbf8fe68e4d$var$PERCENT = 'PERCENT'; // %
const $a163dbbf8fe68e4d$var$PIPE = 'PIPE'; // |
const $a163dbbf8fe68e4d$var$PLUS = 'PLUS'; // +
const $a163dbbf8fe68e4d$var$POUND = 'POUND'; // #
const $a163dbbf8fe68e4d$var$QUERY = 'QUERY'; // ?
const $a163dbbf8fe68e4d$var$QUOTE = 'QUOTE'; // "
const $a163dbbf8fe68e4d$var$FULLWIDTHMIDDLEDOT = 'FULLWIDTHMIDDLEDOT'; // ・
const $a163dbbf8fe68e4d$var$SEMI = 'SEMI'; // ;
const $a163dbbf8fe68e4d$var$SLASH = 'SLASH'; // /
const $a163dbbf8fe68e4d$var$TILDE = 'TILDE'; // ~
const $a163dbbf8fe68e4d$var$UNDERSCORE = 'UNDERSCORE'; // _
// Emoji symbol
const $a163dbbf8fe68e4d$var$EMOJI$1 = 'EMOJI';
// Default token - anything that is not one of the above
const $a163dbbf8fe68e4d$var$SYM = 'SYM';
var $a163dbbf8fe68e4d$var$tk = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    WORD: $a163dbbf8fe68e4d$var$WORD,
    UWORD: $a163dbbf8fe68e4d$var$UWORD,
    ASCIINUMERICAL: $a163dbbf8fe68e4d$var$ASCIINUMERICAL,
    ALPHANUMERICAL: $a163dbbf8fe68e4d$var$ALPHANUMERICAL,
    LOCALHOST: $a163dbbf8fe68e4d$var$LOCALHOST,
    TLD: $a163dbbf8fe68e4d$var$TLD,
    UTLD: $a163dbbf8fe68e4d$var$UTLD,
    SCHEME: $a163dbbf8fe68e4d$var$SCHEME,
    SLASH_SCHEME: $a163dbbf8fe68e4d$var$SLASH_SCHEME,
    NUM: $a163dbbf8fe68e4d$var$NUM,
    WS: $a163dbbf8fe68e4d$var$WS,
    NL: $a163dbbf8fe68e4d$var$NL,
    OPENBRACE: $a163dbbf8fe68e4d$var$OPENBRACE,
    CLOSEBRACE: $a163dbbf8fe68e4d$var$CLOSEBRACE,
    OPENBRACKET: $a163dbbf8fe68e4d$var$OPENBRACKET,
    CLOSEBRACKET: $a163dbbf8fe68e4d$var$CLOSEBRACKET,
    OPENPAREN: $a163dbbf8fe68e4d$var$OPENPAREN,
    CLOSEPAREN: $a163dbbf8fe68e4d$var$CLOSEPAREN,
    OPENANGLEBRACKET: $a163dbbf8fe68e4d$var$OPENANGLEBRACKET,
    CLOSEANGLEBRACKET: $a163dbbf8fe68e4d$var$CLOSEANGLEBRACKET,
    FULLWIDTHLEFTPAREN: $a163dbbf8fe68e4d$var$FULLWIDTHLEFTPAREN,
    FULLWIDTHRIGHTPAREN: $a163dbbf8fe68e4d$var$FULLWIDTHRIGHTPAREN,
    LEFTCORNERBRACKET: $a163dbbf8fe68e4d$var$LEFTCORNERBRACKET,
    RIGHTCORNERBRACKET: $a163dbbf8fe68e4d$var$RIGHTCORNERBRACKET,
    LEFTWHITECORNERBRACKET: $a163dbbf8fe68e4d$var$LEFTWHITECORNERBRACKET,
    RIGHTWHITECORNERBRACKET: $a163dbbf8fe68e4d$var$RIGHTWHITECORNERBRACKET,
    FULLWIDTHLESSTHAN: $a163dbbf8fe68e4d$var$FULLWIDTHLESSTHAN,
    FULLWIDTHGREATERTHAN: $a163dbbf8fe68e4d$var$FULLWIDTHGREATERTHAN,
    AMPERSAND: $a163dbbf8fe68e4d$var$AMPERSAND,
    APOSTROPHE: $a163dbbf8fe68e4d$var$APOSTROPHE,
    ASTERISK: $a163dbbf8fe68e4d$var$ASTERISK,
    AT: $a163dbbf8fe68e4d$var$AT,
    BACKSLASH: $a163dbbf8fe68e4d$var$BACKSLASH,
    BACKTICK: $a163dbbf8fe68e4d$var$BACKTICK,
    CARET: $a163dbbf8fe68e4d$var$CARET,
    COLON: $a163dbbf8fe68e4d$var$COLON,
    COMMA: $a163dbbf8fe68e4d$var$COMMA,
    DOLLAR: $a163dbbf8fe68e4d$var$DOLLAR,
    DOT: $a163dbbf8fe68e4d$var$DOT,
    EQUALS: $a163dbbf8fe68e4d$var$EQUALS,
    EXCLAMATION: $a163dbbf8fe68e4d$var$EXCLAMATION,
    HYPHEN: $a163dbbf8fe68e4d$var$HYPHEN,
    PERCENT: $a163dbbf8fe68e4d$var$PERCENT,
    PIPE: $a163dbbf8fe68e4d$var$PIPE,
    PLUS: $a163dbbf8fe68e4d$var$PLUS,
    POUND: $a163dbbf8fe68e4d$var$POUND,
    QUERY: $a163dbbf8fe68e4d$var$QUERY,
    QUOTE: $a163dbbf8fe68e4d$var$QUOTE,
    FULLWIDTHMIDDLEDOT: $a163dbbf8fe68e4d$var$FULLWIDTHMIDDLEDOT,
    SEMI: $a163dbbf8fe68e4d$var$SEMI,
    SLASH: $a163dbbf8fe68e4d$var$SLASH,
    TILDE: $a163dbbf8fe68e4d$var$TILDE,
    UNDERSCORE: $a163dbbf8fe68e4d$var$UNDERSCORE,
    EMOJI: $a163dbbf8fe68e4d$var$EMOJI$1,
    SYM: $a163dbbf8fe68e4d$var$SYM
});
// Note that these two Unicode ones expand into a really big one with Babel
const $a163dbbf8fe68e4d$var$ASCII_LETTER = /[a-z]/;
const $a163dbbf8fe68e4d$var$LETTER = /\p{L}/u; // Any Unicode character with letter data type
const $a163dbbf8fe68e4d$var$EMOJI = /\p{Emoji}/u; // Any Unicode emoji character
const $a163dbbf8fe68e4d$var$EMOJI_VARIATION$1 = /\ufe0f/;
const $a163dbbf8fe68e4d$var$DIGIT = /\d/;
const $a163dbbf8fe68e4d$var$SPACE = /\s/;
var $a163dbbf8fe68e4d$export$efdc1e5bdb609bb = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ASCII_LETTER: $a163dbbf8fe68e4d$var$ASCII_LETTER,
    LETTER: $a163dbbf8fe68e4d$var$LETTER,
    EMOJI: $a163dbbf8fe68e4d$var$EMOJI,
    EMOJI_VARIATION: $a163dbbf8fe68e4d$var$EMOJI_VARIATION$1,
    DIGIT: $a163dbbf8fe68e4d$var$DIGIT,
    SPACE: $a163dbbf8fe68e4d$var$SPACE
});
/**
	The scanner provides an interface that takes a string of text as input, and
	outputs an array of tokens instances that can be used for easy URL parsing.
*/ const $a163dbbf8fe68e4d$var$CR = '\r'; // carriage-return character
const $a163dbbf8fe68e4d$var$LF = '\n'; // line-feed character
const $a163dbbf8fe68e4d$var$EMOJI_VARIATION = '\ufe0f'; // Variation selector, follows heart and others
const $a163dbbf8fe68e4d$var$EMOJI_JOINER = '\u200d'; // zero-width joiner
const $a163dbbf8fe68e4d$var$OBJECT_REPLACEMENT = '\ufffc'; // whitespace placeholder that sometimes appears in rich text editors
let $a163dbbf8fe68e4d$var$tlds = null, $a163dbbf8fe68e4d$var$utlds = null; // don't change so only have to be computed once
/**
 * Scanner output token:
 * - `t` is the token name (e.g., 'NUM', 'EMOJI', 'TLD')
 * - `v` is the value of the token (e.g., '123', '❤️', 'com')
 * - `s` is the start index of the token in the original string
 * - `e` is the end index of the token in the original string
 * @typedef {{t: string, v: string, s: number, e: number}} Token
 */ /**
 * @template T
 * @typedef {{ [collection: string]: T[] }} Collections
 */ /**
 * Initialize the scanner character-based state machine for the given start
 * state
 * @param {[string, boolean][]} customSchemes List of custom schemes, where each
 * item is a length-2 tuple with the first element set to the string scheme, and
 * the second element set to `true` if the `://` after the scheme is optional
 */ function $a163dbbf8fe68e4d$var$init$2(customSchemes = []) {
    // Frequently used states (name argument removed during minification)
    /** @type Collections<string> */ const groups = {}; // of tokens
    $a163dbbf8fe68e4d$export$7254cc27399e90bd.groups = groups;
    /** @type State<string> */ const Start = new $a163dbbf8fe68e4d$export$7254cc27399e90bd();
    if ($a163dbbf8fe68e4d$var$tlds == null) $a163dbbf8fe68e4d$var$tlds = $a163dbbf8fe68e4d$var$decodeTlds($a163dbbf8fe68e4d$var$encodedTlds);
    if ($a163dbbf8fe68e4d$var$utlds == null) $a163dbbf8fe68e4d$var$utlds = $a163dbbf8fe68e4d$var$decodeTlds($a163dbbf8fe68e4d$var$encodedUtlds);
    // States for special URL symbols that accept immediately after start
    $a163dbbf8fe68e4d$var$tt(Start, "'", $a163dbbf8fe68e4d$var$APOSTROPHE);
    $a163dbbf8fe68e4d$var$tt(Start, '{', $a163dbbf8fe68e4d$var$OPENBRACE);
    $a163dbbf8fe68e4d$var$tt(Start, '}', $a163dbbf8fe68e4d$var$CLOSEBRACE);
    $a163dbbf8fe68e4d$var$tt(Start, '[', $a163dbbf8fe68e4d$var$OPENBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, ']', $a163dbbf8fe68e4d$var$CLOSEBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, '(', $a163dbbf8fe68e4d$var$OPENPAREN);
    $a163dbbf8fe68e4d$var$tt(Start, ')', $a163dbbf8fe68e4d$var$CLOSEPAREN);
    $a163dbbf8fe68e4d$var$tt(Start, '<', $a163dbbf8fe68e4d$var$OPENANGLEBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, '>', $a163dbbf8fe68e4d$var$CLOSEANGLEBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, "\uFF08", $a163dbbf8fe68e4d$var$FULLWIDTHLEFTPAREN);
    $a163dbbf8fe68e4d$var$tt(Start, "\uFF09", $a163dbbf8fe68e4d$var$FULLWIDTHRIGHTPAREN);
    $a163dbbf8fe68e4d$var$tt(Start, "\u300C", $a163dbbf8fe68e4d$var$LEFTCORNERBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, "\u300D", $a163dbbf8fe68e4d$var$RIGHTCORNERBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, "\u300E", $a163dbbf8fe68e4d$var$LEFTWHITECORNERBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, "\u300F", $a163dbbf8fe68e4d$var$RIGHTWHITECORNERBRACKET);
    $a163dbbf8fe68e4d$var$tt(Start, "\uFF1C", $a163dbbf8fe68e4d$var$FULLWIDTHLESSTHAN);
    $a163dbbf8fe68e4d$var$tt(Start, "\uFF1E", $a163dbbf8fe68e4d$var$FULLWIDTHGREATERTHAN);
    $a163dbbf8fe68e4d$var$tt(Start, '&', $a163dbbf8fe68e4d$var$AMPERSAND);
    $a163dbbf8fe68e4d$var$tt(Start, '*', $a163dbbf8fe68e4d$var$ASTERISK);
    $a163dbbf8fe68e4d$var$tt(Start, '@', $a163dbbf8fe68e4d$var$AT);
    $a163dbbf8fe68e4d$var$tt(Start, '`', $a163dbbf8fe68e4d$var$BACKTICK);
    $a163dbbf8fe68e4d$var$tt(Start, '^', $a163dbbf8fe68e4d$var$CARET);
    $a163dbbf8fe68e4d$var$tt(Start, ':', $a163dbbf8fe68e4d$var$COLON);
    $a163dbbf8fe68e4d$var$tt(Start, ',', $a163dbbf8fe68e4d$var$COMMA);
    $a163dbbf8fe68e4d$var$tt(Start, '$', $a163dbbf8fe68e4d$var$DOLLAR);
    $a163dbbf8fe68e4d$var$tt(Start, '.', $a163dbbf8fe68e4d$var$DOT);
    $a163dbbf8fe68e4d$var$tt(Start, '=', $a163dbbf8fe68e4d$var$EQUALS);
    $a163dbbf8fe68e4d$var$tt(Start, '!', $a163dbbf8fe68e4d$var$EXCLAMATION);
    $a163dbbf8fe68e4d$var$tt(Start, '-', $a163dbbf8fe68e4d$var$HYPHEN);
    $a163dbbf8fe68e4d$var$tt(Start, '%', $a163dbbf8fe68e4d$var$PERCENT);
    $a163dbbf8fe68e4d$var$tt(Start, '|', $a163dbbf8fe68e4d$var$PIPE);
    $a163dbbf8fe68e4d$var$tt(Start, '+', $a163dbbf8fe68e4d$var$PLUS);
    $a163dbbf8fe68e4d$var$tt(Start, '#', $a163dbbf8fe68e4d$var$POUND);
    $a163dbbf8fe68e4d$var$tt(Start, '?', $a163dbbf8fe68e4d$var$QUERY);
    $a163dbbf8fe68e4d$var$tt(Start, '"', $a163dbbf8fe68e4d$var$QUOTE);
    $a163dbbf8fe68e4d$var$tt(Start, '/', $a163dbbf8fe68e4d$var$SLASH);
    $a163dbbf8fe68e4d$var$tt(Start, ';', $a163dbbf8fe68e4d$var$SEMI);
    $a163dbbf8fe68e4d$var$tt(Start, '~', $a163dbbf8fe68e4d$var$TILDE);
    $a163dbbf8fe68e4d$var$tt(Start, '_', $a163dbbf8fe68e4d$var$UNDERSCORE);
    $a163dbbf8fe68e4d$var$tt(Start, '\\', $a163dbbf8fe68e4d$var$BACKSLASH);
    $a163dbbf8fe68e4d$var$tt(Start, "\u30FB", $a163dbbf8fe68e4d$var$FULLWIDTHMIDDLEDOT);
    const Num = $a163dbbf8fe68e4d$var$tr(Start, $a163dbbf8fe68e4d$var$DIGIT, $a163dbbf8fe68e4d$var$NUM, {
        [$a163dbbf8fe68e4d$var$numeric]: true
    });
    $a163dbbf8fe68e4d$var$tr(Num, $a163dbbf8fe68e4d$var$DIGIT, Num);
    const Asciinumeric = $a163dbbf8fe68e4d$var$tr(Num, $a163dbbf8fe68e4d$var$ASCII_LETTER, $a163dbbf8fe68e4d$var$ASCIINUMERICAL, {
        [$a163dbbf8fe68e4d$var$asciinumeric]: true
    });
    const Alphanumeric = $a163dbbf8fe68e4d$var$tr(Num, $a163dbbf8fe68e4d$var$LETTER, $a163dbbf8fe68e4d$var$ALPHANUMERICAL, {
        [$a163dbbf8fe68e4d$var$alphanumeric]: true
    });
    // State which emits a word token
    const Word = $a163dbbf8fe68e4d$var$tr(Start, $a163dbbf8fe68e4d$var$ASCII_LETTER, $a163dbbf8fe68e4d$var$WORD, {
        [$a163dbbf8fe68e4d$var$ascii]: true
    });
    $a163dbbf8fe68e4d$var$tr(Word, $a163dbbf8fe68e4d$var$DIGIT, Asciinumeric);
    $a163dbbf8fe68e4d$var$tr(Word, $a163dbbf8fe68e4d$var$ASCII_LETTER, Word);
    $a163dbbf8fe68e4d$var$tr(Asciinumeric, $a163dbbf8fe68e4d$var$DIGIT, Asciinumeric);
    $a163dbbf8fe68e4d$var$tr(Asciinumeric, $a163dbbf8fe68e4d$var$ASCII_LETTER, Asciinumeric);
    // Same as previous, but specific to non-fsm.ascii alphabet words
    const UWord = $a163dbbf8fe68e4d$var$tr(Start, $a163dbbf8fe68e4d$var$LETTER, $a163dbbf8fe68e4d$var$UWORD, {
        [$a163dbbf8fe68e4d$var$alpha]: true
    });
    $a163dbbf8fe68e4d$var$tr(UWord, $a163dbbf8fe68e4d$var$ASCII_LETTER); // Non-accepting
    $a163dbbf8fe68e4d$var$tr(UWord, $a163dbbf8fe68e4d$var$DIGIT, Alphanumeric);
    $a163dbbf8fe68e4d$var$tr(UWord, $a163dbbf8fe68e4d$var$LETTER, UWord);
    $a163dbbf8fe68e4d$var$tr(Alphanumeric, $a163dbbf8fe68e4d$var$DIGIT, Alphanumeric);
    $a163dbbf8fe68e4d$var$tr(Alphanumeric, $a163dbbf8fe68e4d$var$ASCII_LETTER); // Non-accepting
    $a163dbbf8fe68e4d$var$tr(Alphanumeric, $a163dbbf8fe68e4d$var$LETTER, Alphanumeric); // Non-accepting
    // Whitespace jumps
    // Tokens of only non-newline whitespace are arbitrarily long
    // If any whitespace except newline, more whitespace!
    const Nl = $a163dbbf8fe68e4d$var$tt(Start, $a163dbbf8fe68e4d$var$LF, $a163dbbf8fe68e4d$var$NL, {
        [$a163dbbf8fe68e4d$var$whitespace]: true
    });
    const Cr = $a163dbbf8fe68e4d$var$tt(Start, $a163dbbf8fe68e4d$var$CR, $a163dbbf8fe68e4d$var$WS, {
        [$a163dbbf8fe68e4d$var$whitespace]: true
    });
    const Ws = $a163dbbf8fe68e4d$var$tr(Start, $a163dbbf8fe68e4d$var$SPACE, $a163dbbf8fe68e4d$var$WS, {
        [$a163dbbf8fe68e4d$var$whitespace]: true
    });
    $a163dbbf8fe68e4d$var$tt(Start, $a163dbbf8fe68e4d$var$OBJECT_REPLACEMENT, Ws);
    $a163dbbf8fe68e4d$var$tt(Cr, $a163dbbf8fe68e4d$var$LF, Nl); // \r\n
    $a163dbbf8fe68e4d$var$tt(Cr, $a163dbbf8fe68e4d$var$OBJECT_REPLACEMENT, Ws);
    $a163dbbf8fe68e4d$var$tr(Cr, $a163dbbf8fe68e4d$var$SPACE, Ws);
    $a163dbbf8fe68e4d$var$tt(Ws, $a163dbbf8fe68e4d$var$CR); // non-accepting state to avoid mixing whitespaces
    $a163dbbf8fe68e4d$var$tt(Ws, $a163dbbf8fe68e4d$var$LF); // non-accepting state to avoid mixing whitespaces
    $a163dbbf8fe68e4d$var$tr(Ws, $a163dbbf8fe68e4d$var$SPACE, Ws);
    $a163dbbf8fe68e4d$var$tt(Ws, $a163dbbf8fe68e4d$var$OBJECT_REPLACEMENT, Ws);
    // Emoji tokens. They are not grouped by the scanner except in cases where a
    // zero-width joiner is present
    const Emoji = $a163dbbf8fe68e4d$var$tr(Start, $a163dbbf8fe68e4d$var$EMOJI, $a163dbbf8fe68e4d$var$EMOJI$1, {
        [$a163dbbf8fe68e4d$var$emoji]: true
    });
    $a163dbbf8fe68e4d$var$tt(Emoji, '#'); // no transition, emoji regex seems to match #
    $a163dbbf8fe68e4d$var$tr(Emoji, $a163dbbf8fe68e4d$var$EMOJI, Emoji);
    $a163dbbf8fe68e4d$var$tt(Emoji, $a163dbbf8fe68e4d$var$EMOJI_VARIATION, Emoji);
    // tt(Start, EMOJI_VARIATION, Emoji); // This one is sketchy
    const EmojiJoiner = $a163dbbf8fe68e4d$var$tt(Emoji, $a163dbbf8fe68e4d$var$EMOJI_JOINER);
    $a163dbbf8fe68e4d$var$tt(EmojiJoiner, '#');
    $a163dbbf8fe68e4d$var$tr(EmojiJoiner, $a163dbbf8fe68e4d$var$EMOJI, Emoji);
    // tt(EmojiJoiner, EMOJI_VARIATION, Emoji); // also sketchy
    // Generates states for top-level domains
    // Note that this is most accurate when tlds are in alphabetical order
    const wordjr = [
        [
            $a163dbbf8fe68e4d$var$ASCII_LETTER,
            Word
        ],
        [
            $a163dbbf8fe68e4d$var$DIGIT,
            Asciinumeric
        ]
    ];
    const uwordjr = [
        [
            $a163dbbf8fe68e4d$var$ASCII_LETTER,
            null
        ],
        [
            $a163dbbf8fe68e4d$var$LETTER,
            UWord
        ],
        [
            $a163dbbf8fe68e4d$var$DIGIT,
            Alphanumeric
        ]
    ];
    for(let i = 0; i < $a163dbbf8fe68e4d$var$tlds.length; i++)$a163dbbf8fe68e4d$var$fastts(Start, $a163dbbf8fe68e4d$var$tlds[i], $a163dbbf8fe68e4d$var$TLD, $a163dbbf8fe68e4d$var$WORD, wordjr);
    for(let i = 0; i < $a163dbbf8fe68e4d$var$utlds.length; i++)$a163dbbf8fe68e4d$var$fastts(Start, $a163dbbf8fe68e4d$var$utlds[i], $a163dbbf8fe68e4d$var$UTLD, $a163dbbf8fe68e4d$var$UWORD, uwordjr);
    $a163dbbf8fe68e4d$var$addToGroups($a163dbbf8fe68e4d$var$TLD, {
        tld: true,
        ascii: true
    }, groups);
    $a163dbbf8fe68e4d$var$addToGroups($a163dbbf8fe68e4d$var$UTLD, {
        utld: true,
        alpha: true
    }, groups);
    // Collect the states generated by different protocols. NOTE: If any new TLDs
    // get added that are also protocols, set the token to be the same as the
    // protocol to ensure parsing works as expected.
    $a163dbbf8fe68e4d$var$fastts(Start, 'file', $a163dbbf8fe68e4d$var$SCHEME, $a163dbbf8fe68e4d$var$WORD, wordjr);
    $a163dbbf8fe68e4d$var$fastts(Start, 'mailto', $a163dbbf8fe68e4d$var$SCHEME, $a163dbbf8fe68e4d$var$WORD, wordjr);
    $a163dbbf8fe68e4d$var$fastts(Start, 'http', $a163dbbf8fe68e4d$var$SLASH_SCHEME, $a163dbbf8fe68e4d$var$WORD, wordjr);
    $a163dbbf8fe68e4d$var$fastts(Start, 'https', $a163dbbf8fe68e4d$var$SLASH_SCHEME, $a163dbbf8fe68e4d$var$WORD, wordjr);
    $a163dbbf8fe68e4d$var$fastts(Start, 'ftp', $a163dbbf8fe68e4d$var$SLASH_SCHEME, $a163dbbf8fe68e4d$var$WORD, wordjr);
    $a163dbbf8fe68e4d$var$fastts(Start, 'ftps', $a163dbbf8fe68e4d$var$SLASH_SCHEME, $a163dbbf8fe68e4d$var$WORD, wordjr);
    $a163dbbf8fe68e4d$var$addToGroups($a163dbbf8fe68e4d$var$SCHEME, {
        scheme: true,
        ascii: true
    }, groups);
    $a163dbbf8fe68e4d$var$addToGroups($a163dbbf8fe68e4d$var$SLASH_SCHEME, {
        slashscheme: true,
        ascii: true
    }, groups);
    // Register custom schemes. Assumes each scheme is asciinumeric with hyphens
    customSchemes = customSchemes.sort((a, b)=>a[0] > b[0] ? 1 : -1);
    for(let i = 0; i < customSchemes.length; i++){
        const sch = customSchemes[i][0];
        const optionalSlashSlash = customSchemes[i][1];
        const flags = optionalSlashSlash ? {
            [$a163dbbf8fe68e4d$var$scheme]: true
        } : {
            [$a163dbbf8fe68e4d$var$slashscheme]: true
        };
        if (sch.indexOf('-') >= 0) flags[$a163dbbf8fe68e4d$var$domain] = true;
        else if (!$a163dbbf8fe68e4d$var$ASCII_LETTER.test(sch)) flags[$a163dbbf8fe68e4d$var$numeric] = true; // numbers only
        else if ($a163dbbf8fe68e4d$var$DIGIT.test(sch)) flags[$a163dbbf8fe68e4d$var$asciinumeric] = true;
        else flags[$a163dbbf8fe68e4d$var$ascii] = true;
        $a163dbbf8fe68e4d$var$ts(Start, sch, sch, flags);
    }
    // Localhost token
    $a163dbbf8fe68e4d$var$ts(Start, 'localhost', $a163dbbf8fe68e4d$var$LOCALHOST, {
        ascii: true
    });
    // Set default transition for start state (some symbol)
    Start.jd = new $a163dbbf8fe68e4d$export$7254cc27399e90bd($a163dbbf8fe68e4d$var$SYM);
    return {
        start: Start,
        tokens: $a163dbbf8fe68e4d$var$assign({
            groups: groups
        }, $a163dbbf8fe68e4d$var$tk)
    };
}
/**
	Given a string, returns an array of TOKEN instances representing the
	composition of that string.

	@method run
	@param {State<string>} start scanner starting state
	@param {string} str input string to scan
	@return {Token[]} list of tokens, each with a type and value
*/ function $a163dbbf8fe68e4d$var$run$1(start, str) {
    // State machine is not case sensitive, so input is tokenized in lowercased
    // form (still returns regular case). Uses selective `toLowerCase` because
    // lowercasing the entire string causes the length and character position to
    // vary in some non-English strings with V8-based runtimes.
    const iterable = $a163dbbf8fe68e4d$export$b9ca061da17f2d30(str.replace(/[A-Z]/g, (c)=>c.toLowerCase()));
    const charCount = iterable.length; // <= len if there are emojis, etc
    const tokens = []; // return value
    // cursor through the string itself, accounting for characters that have
    // width with length 2 such as emojis
    let cursor = 0;
    // Cursor through the array-representation of the string
    let charCursor = 0;
    // Tokenize the string
    while(charCursor < charCount){
        let state = start;
        let nextState = null;
        let tokenLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        let charsSinceAccepts = -1;
        while(charCursor < charCount && (nextState = state.go(iterable[charCursor]))){
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                charsSinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) {
                sinceAccepts += iterable[charCursor].length;
                charsSinceAccepts++;
            }
            tokenLength += iterable[charCursor].length;
            cursor += iterable[charCursor].length;
            charCursor++;
        }
        // Roll back to the latest accepting state
        cursor -= sinceAccepts;
        charCursor -= charsSinceAccepts;
        tokenLength -= sinceAccepts;
        // No more jumps, just make a new token from the last accepting one
        tokens.push({
            t: latestAccepting.t,
            // token type/name
            v: str.slice(cursor - tokenLength, cursor),
            // string value
            s: cursor - tokenLength,
            // start index
            e: cursor // end index (excluding)
        });
    }
    return tokens;
}
/**
 * Convert a String to an Array of characters, taking into account that some
 * characters like emojis take up two string indexes.
 *
 * Adapted from core-js (MIT license)
 * https://github.com/zloirock/core-js/blob/2d69cf5f99ab3ea3463c395df81e5a15b68f49d9/packages/core-js/internals/string-multibyte.js
 *
 * @function stringToArray
 * @param {string} str
 * @returns {string[]}
 */ function $a163dbbf8fe68e4d$export$b9ca061da17f2d30(str) {
    const result = [];
    const len = str.length;
    let index = 0;
    while(index < len){
        let first = str.charCodeAt(index);
        let second;
        let char = first < 0xd800 || first > 0xdbff || index + 1 === len || (second = str.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? str[index] // single character
         : str.slice(index, index + 2); // two-index characters
        result.push(char);
        index += char.length;
    }
    return result;
}
/**
 * Fast version of ts function for when transition defaults are well known
 * @param {State<string>} state
 * @param {string} input
 * @param {string} t
 * @param {string} defaultt
 * @param {[RegExp, State<string>][]} jr
 * @returns {State<string>}
 */ function $a163dbbf8fe68e4d$var$fastts(state, input, t, defaultt, jr) {
    let next;
    const len = input.length;
    for(let i = 0; i < len - 1; i++){
        const char = input[i];
        if (state.j[char]) next = state.j[char];
        else {
            next = new $a163dbbf8fe68e4d$export$7254cc27399e90bd(defaultt);
            next.jr = jr.slice();
            state.j[char] = next;
        }
        state = next;
    }
    next = new $a163dbbf8fe68e4d$export$7254cc27399e90bd(t);
    next.jr = jr.slice();
    state.j[input[len - 1]] = next;
    return next;
}
/**
 * Converts a string of Top-Level Domain names encoded in update-tlds.js back
 * into a list of strings.
 * @param {str} encoded encoded TLDs string
 * @returns {str[]} original TLDs list
 */ function $a163dbbf8fe68e4d$var$decodeTlds(encoded) {
    const words = [];
    const stack = [];
    let i = 0;
    let digits = '0123456789';
    while(i < encoded.length){
        let popDigitCount = 0;
        while(digits.indexOf(encoded[i + popDigitCount]) >= 0)popDigitCount++; // encountered some digits, have to pop to go one level up trie
        if (popDigitCount > 0) {
            words.push(stack.join('')); // whatever preceded the pop digits must be a word
            for(let popCount = parseInt(encoded.substring(i, i + popDigitCount), 10); popCount > 0; popCount--)stack.pop();
            i += popDigitCount;
        } else {
            stack.push(encoded[i]); // drop down a level into the trie
            i++;
        }
    }
    return words;
}
/**
 * An object where each key is a valid DOM Event Name such as `click` or `focus`
 * and each value is an event handler function.
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Element#events
 * @typedef {?{ [event: string]: Function }} EventListeners
 */ /**
 * All formatted properties required to render a link, including `tagName`,
 * `attributes`, `content` and `eventListeners`.
 * @typedef {{ tagName: any, attributes: {[attr: string]: any}, content: string,
 * eventListeners: EventListeners }} IntermediateRepresentation
 */ /**
 * Specify either an object described by the template type `O` or a function.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `O`
 * @template O
 * @typedef {O | ((value: string, type: string, token: MultiToken) => O)} OptObj
 */ /**
 * Specify either a function described by template type `F` or an object.
 *
 * Each key in the object should be a link type (`'url'`, `'hashtag`', etc.). Each
 * value should be a function with template type `F` that is called when the
 * corresponding link type is encountered.
 * @template F
 * @typedef {F | { [type: string]: F}} OptFn
 */ /**
 * Specify either a value with template type `V`, a function that returns `V` or
 * an object where each value resolves to `V`.
 *
 * The function takes a string value (usually the link's href attribute), the
 * link type (`'url'`, `'hashtag`', etc.) and an internal token representation
 * of the link. It should return an object of the template type `V`
 *
 * For the object, each key should be a link type (`'url'`, `'hashtag`', etc.).
 * Each value should either have type `V` or a function that returns V. This
 * function similarly takes a string value and a token.
 *
 * Example valid types for `Opt<string>`:
 *
 * ```js
 * 'hello'
 * (value, type, token) => 'world'
 * { url: 'hello', email: (value, token) => 'world'}
 * ```
 * @template V
 * @typedef {V | ((value: string, type: string, token: MultiToken) => V) | { [type: string]: V | ((value: string, token: MultiToken) => V) }} Opt
 */ /**
 * See available options: https://linkify.js.org/docs/options.html
 * @typedef {{
 * 	defaultProtocol?: string,
 *  events?: OptObj<EventListeners>,
 * 	format?: Opt<string>,
 * 	formatHref?: Opt<string>,
 * 	nl2br?: boolean,
 * 	tagName?: Opt<any>,
 * 	target?: Opt<string>,
 * 	rel?: Opt<string>,
 * 	validate?: Opt<boolean>,
 * 	truncate?: Opt<number>,
 * 	className?: Opt<string>,
 * 	attributes?: OptObj<({ [attr: string]: any })>,
 *  ignoreTags?: string[],
 * 	render?: OptFn<((ir: IntermediateRepresentation) => any)>
 * }} Opts
 */ /**
 * @type Required<Opts>
 */ const $a163dbbf8fe68e4d$var$defaults = {
    defaultProtocol: 'http',
    events: null,
    format: $a163dbbf8fe68e4d$var$noop,
    formatHref: $a163dbbf8fe68e4d$var$noop,
    nl2br: false,
    tagName: 'a',
    target: null,
    rel: null,
    validate: true,
    truncate: Infinity,
    className: null,
    attributes: null,
    ignoreTags: [],
    render: null
};
/**
 * Utility class for linkify interfaces to apply specified
 * {@link Opts formatting and rendering options}.
 *
 * @param {Opts | Options} [opts] Option value overrides.
 * @param {(ir: IntermediateRepresentation) => any} [defaultRender] (For
 *   internal use) default render function that determines how to generate an
 *   HTML element based on a link token's derived tagName, attributes and HTML.
 *   Similar to render option
 */ function $a163dbbf8fe68e4d$export$c019608e5b5bb4cb(opts, defaultRender = null) {
    let o = $a163dbbf8fe68e4d$var$assign({}, $a163dbbf8fe68e4d$var$defaults);
    if (opts) o = $a163dbbf8fe68e4d$var$assign(o, opts instanceof $a163dbbf8fe68e4d$export$c019608e5b5bb4cb ? opts.o : opts);
    // Ensure all ignored tags are uppercase
    const ignoredTags = o.ignoreTags;
    const uppercaseIgnoredTags = [];
    for(let i = 0; i < ignoredTags.length; i++)uppercaseIgnoredTags.push(ignoredTags[i].toUpperCase());
    /** @protected */ this.o = o;
    if (defaultRender) this.defaultRender = defaultRender;
    this.ignoreTags = uppercaseIgnoredTags;
}
$a163dbbf8fe68e4d$export$c019608e5b5bb4cb.prototype = {
    o: $a163dbbf8fe68e4d$var$defaults,
    /**
   * @type string[]
   */ ignoreTags: [],
    /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */ defaultRender (ir) {
        return ir;
    },
    /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */ check (token) {
        return this.get('validate', token.toString(), token);
    },
    // Private methods
    /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */ get (key, operator, token) {
        const isCallable = operator != null;
        let option = this.o[key];
        if (!option) return option;
        if (typeof option === 'object') {
            option = token.t in option ? option[token.t] : $a163dbbf8fe68e4d$var$defaults[key];
            if (typeof option === 'function' && isCallable) option = option(operator, token);
        } else if (typeof option === 'function' && isCallable) option = option(operator, token.t, token);
        return option;
    },
    /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */ getObj (key, operator, token) {
        let obj = this.o[key];
        if (typeof obj === 'function' && operator != null) obj = obj(operator, token.t, token);
        return obj;
    },
    /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */ render (token) {
        const ir = token.render(this); // intermediate representation
        const renderFn = this.get('render', null, token) || this.defaultRender;
        return renderFn(ir, token.t, token);
    }
};
function $a163dbbf8fe68e4d$var$noop(val) {
    return val;
}
var $a163dbbf8fe68e4d$export$41c562ebe57d11e2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaults: $a163dbbf8fe68e4d$var$defaults,
    Options: $a163dbbf8fe68e4d$export$c019608e5b5bb4cb,
    assign: $a163dbbf8fe68e4d$var$assign
});
/******************************************************************************
	Multi-Tokens
	Tokens composed of arrays of TextTokens
******************************************************************************/ /**
 * @param {string} value
 * @param {Token[]} tokens
 */ function $a163dbbf8fe68e4d$export$28075db42e06f164(value, tokens) {
    this.t = 'token';
    this.v = value;
    this.tk = tokens;
}
/**
 * Abstract class used for manufacturing tokens of text tokens. That is rather
 * than the value for a token being a small string of text, it's value an array
 * of text tokens.
 *
 * Used for grouping together URLs, emails, hashtags, and other potential
 * creations.
 * @class MultiToken
 * @property {string} t
 * @property {string} v
 * @property {Token[]} tk
 * @abstract
 */ $a163dbbf8fe68e4d$export$28075db42e06f164.prototype = {
    isLink: false,
    /**
   * Return the string this token represents.
   * @return {string}
   */ toString () {
        return this.v;
    },
    /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */ toHref (scheme) {
        return this.toString();
    },
    /**
   * @param {Options} options Formatting options
   * @returns {string}
   */ toFormattedString (options) {
        const val = this.toString();
        const truncate = options.get('truncate', val, this);
        const formatted = options.get('format', val, this);
        return truncate && formatted.length > truncate ? formatted.substring(0, truncate) + "\u2026" : formatted;
    },
    /**
   *
   * @param {Options} options
   * @returns {string}
   */ toFormattedHref (options) {
        return options.get('formatHref', this.toHref(options.get('defaultProtocol')), this);
    },
    /**
   * The start index of this token in the original input string
   * @returns {number}
   */ startIndex () {
        return this.tk[0].s;
    },
    /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */ endIndex () {
        return this.tk[this.tk.length - 1].e;
    },
    /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */ toObject (protocol = $a163dbbf8fe68e4d$var$defaults.defaultProtocol) {
        return {
            type: this.t,
            value: this.toString(),
            isLink: this.isLink,
            href: this.toHref(protocol),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   *
   * @param {Options} options Formatting option
   */ toFormattedObject (options) {
        return {
            type: this.t,
            value: this.toFormattedString(options),
            isLink: this.isLink,
            href: this.toFormattedHref(options),
            start: this.startIndex(),
            end: this.endIndex()
        };
    },
    /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */ validate (options) {
        return options.get('validate', this.toString(), this);
    },
    /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */ render (options) {
        const token = this;
        const href = this.toHref(options.get('defaultProtocol'));
        const formattedHref = options.get('formatHref', href, this);
        const tagName = options.get('tagName', href, token);
        const content = this.toFormattedString(options);
        const attributes = {};
        const className = options.get('className', href, token);
        const target = options.get('target', href, token);
        const rel = options.get('rel', href, token);
        const attrs = options.getObj('attributes', href, token);
        const eventListeners = options.getObj('events', href, token);
        attributes.href = formattedHref;
        if (className) attributes.class = className;
        if (target) attributes.target = target;
        if (rel) attributes.rel = rel;
        if (attrs) $a163dbbf8fe68e4d$var$assign(attributes, attrs);
        return {
            tagName: tagName,
            attributes: attributes,
            content: content,
            eventListeners: eventListeners
        };
    }
};
/**
 * Create a new token that can be emitted by the parser state machine
 * @param {string} type readable type of the token
 * @param {object} props properties to assign or override, including isLink = true or false
 * @returns {new (value: string, tokens: Token[]) => MultiToken} new token class
 */ function $a163dbbf8fe68e4d$export$21042e7280c1baba(type, props) {
    class Token extends $a163dbbf8fe68e4d$export$28075db42e06f164 {
        constructor(value, tokens){
            super(value, tokens);
            this.t = type;
        }
    }
    for(const p in props)Token.prototype[p] = props[p];
    Token.t = type;
    return Token;
}
/**
	Represents a list of tokens making up a valid email address
*/ const $a163dbbf8fe68e4d$var$Email = $a163dbbf8fe68e4d$export$21042e7280c1baba('email', {
    isLink: true,
    toHref () {
        return 'mailto:' + this.toString();
    }
});
/**
	Represents some plain text
*/ const $a163dbbf8fe68e4d$var$Text = $a163dbbf8fe68e4d$export$21042e7280c1baba('text');
/**
	Multi-linebreak token - represents a line break
	@class Nl
*/ const $a163dbbf8fe68e4d$var$Nl = $a163dbbf8fe68e4d$export$21042e7280c1baba('nl');
/**
	Represents a list of text tokens making up a valid URL
	@class Url
*/ const $a163dbbf8fe68e4d$var$Url = $a163dbbf8fe68e4d$export$21042e7280c1baba('url', {
    isLink: true,
    /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */ toHref (scheme = $a163dbbf8fe68e4d$var$defaults.defaultProtocol) {
        // Check if already has a prefix scheme
        return this.hasProtocol() ? this.v : `${scheme}://${this.v}`;
    },
    /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */ hasProtocol () {
        const tokens = this.tk;
        return tokens.length >= 2 && tokens[0].t !== $a163dbbf8fe68e4d$var$LOCALHOST && tokens[1].t === $a163dbbf8fe68e4d$var$COLON;
    }
});
var $a163dbbf8fe68e4d$export$13e2537ceeaf8a3a = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MultiToken: $a163dbbf8fe68e4d$export$28075db42e06f164,
    Base: $a163dbbf8fe68e4d$export$28075db42e06f164,
    createTokenClass: $a163dbbf8fe68e4d$export$21042e7280c1baba,
    Email: $a163dbbf8fe68e4d$var$Email,
    Text: $a163dbbf8fe68e4d$var$Text,
    Nl: $a163dbbf8fe68e4d$var$Nl,
    Url: $a163dbbf8fe68e4d$var$Url
});
/**
	Not exactly parser, more like the second-stage scanner (although we can
	theoretically hotswap the code here with a real parser in the future... but
	for a little URL-finding utility abstract syntax trees may be a little
	overkill).

	URL format: http://en.wikipedia.org/wiki/URI_scheme
	Email format: http://en.wikipedia.org/wiki/EmailAddress (links to RFC in
	reference)

	@module linkify
	@submodule parser
	@main run
*/ const $a163dbbf8fe68e4d$var$makeState = (arg)=>new $a163dbbf8fe68e4d$export$7254cc27399e90bd(arg);
/**
 * Generate the parser multi token-based state machine
 * @param {{ groups: Collections<string> }} tokens
 */ function $a163dbbf8fe68e4d$var$init$1({ groups: groups }) {
    // Types of characters the URL can definitely end in
    const qsAccepting = groups.domain.concat([
        $a163dbbf8fe68e4d$var$AMPERSAND,
        $a163dbbf8fe68e4d$var$ASTERISK,
        $a163dbbf8fe68e4d$var$AT,
        $a163dbbf8fe68e4d$var$BACKSLASH,
        $a163dbbf8fe68e4d$var$BACKTICK,
        $a163dbbf8fe68e4d$var$CARET,
        $a163dbbf8fe68e4d$var$DOLLAR,
        $a163dbbf8fe68e4d$var$EQUALS,
        $a163dbbf8fe68e4d$var$HYPHEN,
        $a163dbbf8fe68e4d$var$NUM,
        $a163dbbf8fe68e4d$var$PERCENT,
        $a163dbbf8fe68e4d$var$PIPE,
        $a163dbbf8fe68e4d$var$PLUS,
        $a163dbbf8fe68e4d$var$POUND,
        $a163dbbf8fe68e4d$var$SLASH,
        $a163dbbf8fe68e4d$var$SYM,
        $a163dbbf8fe68e4d$var$TILDE,
        $a163dbbf8fe68e4d$var$UNDERSCORE
    ]);
    // Types of tokens that can follow a URL and be part of the query string
    // but cannot be the very last characters
    // Characters that cannot appear in the URL at all should be excluded
    const qsNonAccepting = [
        $a163dbbf8fe68e4d$var$COLON,
        $a163dbbf8fe68e4d$var$COMMA,
        $a163dbbf8fe68e4d$var$DOT,
        $a163dbbf8fe68e4d$var$EXCLAMATION,
        $a163dbbf8fe68e4d$var$PERCENT,
        $a163dbbf8fe68e4d$var$QUERY,
        $a163dbbf8fe68e4d$var$QUOTE,
        $a163dbbf8fe68e4d$var$SEMI,
        $a163dbbf8fe68e4d$var$OPENANGLEBRACKET,
        $a163dbbf8fe68e4d$var$CLOSEANGLEBRACKET,
        $a163dbbf8fe68e4d$var$OPENBRACE,
        $a163dbbf8fe68e4d$var$CLOSEBRACE,
        $a163dbbf8fe68e4d$var$CLOSEBRACKET,
        $a163dbbf8fe68e4d$var$OPENBRACKET,
        $a163dbbf8fe68e4d$var$OPENPAREN,
        $a163dbbf8fe68e4d$var$CLOSEPAREN,
        $a163dbbf8fe68e4d$var$FULLWIDTHLEFTPAREN,
        $a163dbbf8fe68e4d$var$FULLWIDTHRIGHTPAREN,
        $a163dbbf8fe68e4d$var$LEFTCORNERBRACKET,
        $a163dbbf8fe68e4d$var$RIGHTCORNERBRACKET,
        $a163dbbf8fe68e4d$var$LEFTWHITECORNERBRACKET,
        $a163dbbf8fe68e4d$var$RIGHTWHITECORNERBRACKET,
        $a163dbbf8fe68e4d$var$FULLWIDTHLESSTHAN,
        $a163dbbf8fe68e4d$var$FULLWIDTHGREATERTHAN
    ];
    // For addresses without the mailto prefix
    // Tokens allowed in the localpart of the email
    const localpartAccepting = [
        $a163dbbf8fe68e4d$var$AMPERSAND,
        $a163dbbf8fe68e4d$var$APOSTROPHE,
        $a163dbbf8fe68e4d$var$ASTERISK,
        $a163dbbf8fe68e4d$var$BACKSLASH,
        $a163dbbf8fe68e4d$var$BACKTICK,
        $a163dbbf8fe68e4d$var$CARET,
        $a163dbbf8fe68e4d$var$DOLLAR,
        $a163dbbf8fe68e4d$var$EQUALS,
        $a163dbbf8fe68e4d$var$HYPHEN,
        $a163dbbf8fe68e4d$var$OPENBRACE,
        $a163dbbf8fe68e4d$var$CLOSEBRACE,
        $a163dbbf8fe68e4d$var$PERCENT,
        $a163dbbf8fe68e4d$var$PIPE,
        $a163dbbf8fe68e4d$var$PLUS,
        $a163dbbf8fe68e4d$var$POUND,
        $a163dbbf8fe68e4d$var$QUERY,
        $a163dbbf8fe68e4d$var$SLASH,
        $a163dbbf8fe68e4d$var$SYM,
        $a163dbbf8fe68e4d$var$TILDE,
        $a163dbbf8fe68e4d$var$UNDERSCORE
    ];
    // The universal starting state.
    /**
   * @type State<Token>
   */ const Start = $a163dbbf8fe68e4d$var$makeState();
    const Localpart = $a163dbbf8fe68e4d$var$tt(Start, $a163dbbf8fe68e4d$var$TILDE); // Local part of the email address
    $a163dbbf8fe68e4d$var$ta(Localpart, localpartAccepting, Localpart);
    $a163dbbf8fe68e4d$var$ta(Localpart, groups.domain, Localpart);
    const Domain = $a163dbbf8fe68e4d$var$makeState(), Scheme = $a163dbbf8fe68e4d$var$makeState(), SlashScheme = $a163dbbf8fe68e4d$var$makeState();
    $a163dbbf8fe68e4d$var$ta(Start, groups.domain, Domain); // parsed string ends with a potential domain name (A)
    $a163dbbf8fe68e4d$var$ta(Start, groups.scheme, Scheme); // e.g., 'mailto'
    $a163dbbf8fe68e4d$var$ta(Start, groups.slashscheme, SlashScheme); // e.g., 'http'
    $a163dbbf8fe68e4d$var$ta(Domain, localpartAccepting, Localpart);
    $a163dbbf8fe68e4d$var$ta(Domain, groups.domain, Domain);
    const LocalpartAt = $a163dbbf8fe68e4d$var$tt(Domain, $a163dbbf8fe68e4d$var$AT); // Local part of the email address plus @
    $a163dbbf8fe68e4d$var$tt(Localpart, $a163dbbf8fe68e4d$var$AT, LocalpartAt); // close to an email address now
    // Local part of an email address can be e.g. 'http' or 'mailto'
    $a163dbbf8fe68e4d$var$tt(Scheme, $a163dbbf8fe68e4d$var$AT, LocalpartAt);
    $a163dbbf8fe68e4d$var$tt(SlashScheme, $a163dbbf8fe68e4d$var$AT, LocalpartAt);
    const LocalpartDot = $a163dbbf8fe68e4d$var$tt(Localpart, $a163dbbf8fe68e4d$var$DOT); // Local part of the email address plus '.' (localpart cannot end in .)
    $a163dbbf8fe68e4d$var$ta(LocalpartDot, localpartAccepting, Localpart);
    $a163dbbf8fe68e4d$var$ta(LocalpartDot, groups.domain, Localpart);
    const EmailDomain = $a163dbbf8fe68e4d$var$makeState();
    $a163dbbf8fe68e4d$var$ta(LocalpartAt, groups.domain, EmailDomain); // parsed string starts with local email info + @ with a potential domain name
    $a163dbbf8fe68e4d$var$ta(EmailDomain, groups.domain, EmailDomain);
    const EmailDomainDot = $a163dbbf8fe68e4d$var$tt(EmailDomain, $a163dbbf8fe68e4d$var$DOT); // domain followed by DOT
    $a163dbbf8fe68e4d$var$ta(EmailDomainDot, groups.domain, EmailDomain);
    const Email$1 = $a163dbbf8fe68e4d$var$makeState($a163dbbf8fe68e4d$var$Email); // Possible email address (could have more tlds)
    $a163dbbf8fe68e4d$var$ta(EmailDomainDot, groups.tld, Email$1);
    $a163dbbf8fe68e4d$var$ta(EmailDomainDot, groups.utld, Email$1);
    $a163dbbf8fe68e4d$var$tt(LocalpartAt, $a163dbbf8fe68e4d$var$LOCALHOST, Email$1);
    // Hyphen can jump back to a domain name
    const EmailDomainHyphen = $a163dbbf8fe68e4d$var$tt(EmailDomain, $a163dbbf8fe68e4d$var$HYPHEN); // parsed string starts with local email info + @ with a potential domain name
    $a163dbbf8fe68e4d$var$tt(EmailDomainHyphen, $a163dbbf8fe68e4d$var$HYPHEN, EmailDomainHyphen);
    $a163dbbf8fe68e4d$var$ta(EmailDomainHyphen, groups.domain, EmailDomain);
    $a163dbbf8fe68e4d$var$ta(Email$1, groups.domain, EmailDomain);
    $a163dbbf8fe68e4d$var$tt(Email$1, $a163dbbf8fe68e4d$var$DOT, EmailDomainDot);
    $a163dbbf8fe68e4d$var$tt(Email$1, $a163dbbf8fe68e4d$var$HYPHEN, EmailDomainHyphen);
    // Final possible email states
    const EmailColon = $a163dbbf8fe68e4d$var$tt(Email$1, $a163dbbf8fe68e4d$var$COLON); // URL followed by colon (potential port number here)
    /*const EmailColonPort = */ $a163dbbf8fe68e4d$var$ta(EmailColon, groups.numeric, $a163dbbf8fe68e4d$var$Email); // URL followed by colon and port number
    // Account for dots and hyphens. Hyphens are usually parts of domain names
    // (but not TLDs)
    const DomainHyphen = $a163dbbf8fe68e4d$var$tt(Domain, $a163dbbf8fe68e4d$var$HYPHEN); // domain followed by hyphen
    const DomainDot = $a163dbbf8fe68e4d$var$tt(Domain, $a163dbbf8fe68e4d$var$DOT); // domain followed by DOT
    $a163dbbf8fe68e4d$var$tt(DomainHyphen, $a163dbbf8fe68e4d$var$HYPHEN, DomainHyphen);
    $a163dbbf8fe68e4d$var$ta(DomainHyphen, groups.domain, Domain);
    $a163dbbf8fe68e4d$var$ta(DomainDot, localpartAccepting, Localpart);
    $a163dbbf8fe68e4d$var$ta(DomainDot, groups.domain, Domain);
    const DomainDotTld = $a163dbbf8fe68e4d$var$makeState($a163dbbf8fe68e4d$var$Url); // Simplest possible URL with no query string
    $a163dbbf8fe68e4d$var$ta(DomainDot, groups.tld, DomainDotTld);
    $a163dbbf8fe68e4d$var$ta(DomainDot, groups.utld, DomainDotTld);
    $a163dbbf8fe68e4d$var$ta(DomainDotTld, groups.domain, Domain);
    $a163dbbf8fe68e4d$var$ta(DomainDotTld, localpartAccepting, Localpart);
    $a163dbbf8fe68e4d$var$tt(DomainDotTld, $a163dbbf8fe68e4d$var$DOT, DomainDot);
    $a163dbbf8fe68e4d$var$tt(DomainDotTld, $a163dbbf8fe68e4d$var$HYPHEN, DomainHyphen);
    $a163dbbf8fe68e4d$var$tt(DomainDotTld, $a163dbbf8fe68e4d$var$AT, LocalpartAt);
    const DomainDotTldColon = $a163dbbf8fe68e4d$var$tt(DomainDotTld, $a163dbbf8fe68e4d$var$COLON); // URL followed by colon (potential port number here)
    const DomainDotTldColonPort = $a163dbbf8fe68e4d$var$makeState($a163dbbf8fe68e4d$var$Url); // TLD followed by a port number
    $a163dbbf8fe68e4d$var$ta(DomainDotTldColon, groups.numeric, DomainDotTldColonPort);
    // Long URL with optional port and maybe query string
    const Url$1 = $a163dbbf8fe68e4d$var$makeState($a163dbbf8fe68e4d$var$Url);
    // URL with extra symbols at the end, followed by an opening bracket
    const UrlNonaccept = $a163dbbf8fe68e4d$var$makeState(); // URL followed by some symbols (will not be part of the final URL)
    // Query strings
    $a163dbbf8fe68e4d$var$ta(Url$1, qsAccepting, Url$1);
    $a163dbbf8fe68e4d$var$ta(Url$1, qsNonAccepting, UrlNonaccept);
    $a163dbbf8fe68e4d$var$ta(UrlNonaccept, qsAccepting, Url$1);
    $a163dbbf8fe68e4d$var$ta(UrlNonaccept, qsNonAccepting, UrlNonaccept);
    // Become real URLs after `SLASH` or `COLON NUM SLASH`
    // Here works with or without scheme:// prefix
    $a163dbbf8fe68e4d$var$tt(DomainDotTld, $a163dbbf8fe68e4d$var$SLASH, Url$1);
    $a163dbbf8fe68e4d$var$tt(DomainDotTldColonPort, $a163dbbf8fe68e4d$var$SLASH, Url$1);
    // Note that domains that begin with schemes are treated slighly differently
    const SchemeColon = $a163dbbf8fe68e4d$var$tt(Scheme, $a163dbbf8fe68e4d$var$COLON); // e.g., 'mailto:'
    const SlashSchemeColon = $a163dbbf8fe68e4d$var$tt(SlashScheme, $a163dbbf8fe68e4d$var$COLON); // e.g., 'http:'
    const SlashSchemeColonSlash = $a163dbbf8fe68e4d$var$tt(SlashSchemeColon, $a163dbbf8fe68e4d$var$SLASH); // e.g., 'http:/'
    const UriPrefix = $a163dbbf8fe68e4d$var$tt(SlashSchemeColonSlash, $a163dbbf8fe68e4d$var$SLASH); // e.g., 'http://'
    // Scheme states can transition to domain states
    $a163dbbf8fe68e4d$var$ta(Scheme, groups.domain, Domain);
    $a163dbbf8fe68e4d$var$tt(Scheme, $a163dbbf8fe68e4d$var$DOT, DomainDot);
    $a163dbbf8fe68e4d$var$tt(Scheme, $a163dbbf8fe68e4d$var$HYPHEN, DomainHyphen);
    $a163dbbf8fe68e4d$var$ta(SlashScheme, groups.domain, Domain);
    $a163dbbf8fe68e4d$var$tt(SlashScheme, $a163dbbf8fe68e4d$var$DOT, DomainDot);
    $a163dbbf8fe68e4d$var$tt(SlashScheme, $a163dbbf8fe68e4d$var$HYPHEN, DomainHyphen);
    // Force URL with scheme prefix followed by anything sane
    $a163dbbf8fe68e4d$var$ta(SchemeColon, groups.domain, Url$1);
    $a163dbbf8fe68e4d$var$tt(SchemeColon, $a163dbbf8fe68e4d$var$SLASH, Url$1);
    $a163dbbf8fe68e4d$var$tt(SchemeColon, $a163dbbf8fe68e4d$var$QUERY, Url$1);
    $a163dbbf8fe68e4d$var$ta(UriPrefix, groups.domain, Url$1);
    $a163dbbf8fe68e4d$var$ta(UriPrefix, qsAccepting, Url$1);
    $a163dbbf8fe68e4d$var$tt(UriPrefix, $a163dbbf8fe68e4d$var$SLASH, Url$1);
    const bracketPairs = [
        [
            $a163dbbf8fe68e4d$var$OPENBRACE,
            $a163dbbf8fe68e4d$var$CLOSEBRACE
        ],
        // {}
        [
            $a163dbbf8fe68e4d$var$OPENBRACKET,
            $a163dbbf8fe68e4d$var$CLOSEBRACKET
        ],
        // []
        [
            $a163dbbf8fe68e4d$var$OPENPAREN,
            $a163dbbf8fe68e4d$var$CLOSEPAREN
        ],
        // ()
        [
            $a163dbbf8fe68e4d$var$OPENANGLEBRACKET,
            $a163dbbf8fe68e4d$var$CLOSEANGLEBRACKET
        ],
        // <>
        [
            $a163dbbf8fe68e4d$var$FULLWIDTHLEFTPAREN,
            $a163dbbf8fe68e4d$var$FULLWIDTHRIGHTPAREN
        ],
        // （）
        [
            $a163dbbf8fe68e4d$var$LEFTCORNERBRACKET,
            $a163dbbf8fe68e4d$var$RIGHTCORNERBRACKET
        ],
        // 「」
        [
            $a163dbbf8fe68e4d$var$LEFTWHITECORNERBRACKET,
            $a163dbbf8fe68e4d$var$RIGHTWHITECORNERBRACKET
        ],
        // 『』
        [
            $a163dbbf8fe68e4d$var$FULLWIDTHLESSTHAN,
            $a163dbbf8fe68e4d$var$FULLWIDTHGREATERTHAN
        ] // ＜＞
    ];
    for(let i = 0; i < bracketPairs.length; i++){
        const [OPEN, CLOSE] = bracketPairs[i];
        const UrlOpen = $a163dbbf8fe68e4d$var$tt(Url$1, OPEN); // URL followed by open bracket
        // Continue not accepting for open brackets
        $a163dbbf8fe68e4d$var$tt(UrlNonaccept, OPEN, UrlOpen);
        // Closing bracket component. This character WILL be included in the URL
        $a163dbbf8fe68e4d$var$tt(UrlOpen, CLOSE, Url$1);
        // URL that beings with an opening bracket, followed by a symbols.
        // Note that the final state can still be `UrlOpen` (if the URL has a
        // single opening bracket for some reason).
        const UrlOpenQ = $a163dbbf8fe68e4d$var$makeState($a163dbbf8fe68e4d$var$Url);
        $a163dbbf8fe68e4d$var$ta(UrlOpen, qsAccepting, UrlOpenQ);
        const UrlOpenSyms = $a163dbbf8fe68e4d$var$makeState(); // UrlOpen followed by some symbols it cannot end it
        $a163dbbf8fe68e4d$var$ta(UrlOpen, qsNonAccepting);
        // URL that begins with an opening bracket, followed by some symbols
        $a163dbbf8fe68e4d$var$ta(UrlOpenQ, qsAccepting, UrlOpenQ);
        $a163dbbf8fe68e4d$var$ta(UrlOpenQ, qsNonAccepting, UrlOpenSyms);
        $a163dbbf8fe68e4d$var$ta(UrlOpenSyms, qsAccepting, UrlOpenQ);
        $a163dbbf8fe68e4d$var$ta(UrlOpenSyms, qsNonAccepting, UrlOpenSyms);
        // Close brace/bracket to become regular URL
        $a163dbbf8fe68e4d$var$tt(UrlOpenQ, CLOSE, Url$1);
        $a163dbbf8fe68e4d$var$tt(UrlOpenSyms, CLOSE, Url$1);
    }
    $a163dbbf8fe68e4d$var$tt(Start, $a163dbbf8fe68e4d$var$LOCALHOST, DomainDotTld); // localhost is a valid URL state
    $a163dbbf8fe68e4d$var$tt(Start, $a163dbbf8fe68e4d$var$NL, $a163dbbf8fe68e4d$var$Nl); // single new line
    return {
        start: Start,
        tokens: $a163dbbf8fe68e4d$var$tk
    };
}
/**
 * Run the parser state machine on a list of scanned string-based tokens to
 * create a list of multi tokens, each of which represents a URL, email address,
 * plain text, etc.
 *
 * @param {State<MultiToken>} start parser start state
 * @param {string} input the original input used to generate the given tokens
 * @param {Token[]} tokens list of scanned tokens
 * @returns {MultiToken[]}
 */ function $a163dbbf8fe68e4d$var$run(start, input, tokens) {
    let len = tokens.length;
    let cursor = 0;
    let multis = [];
    let textTokens = [];
    while(cursor < len){
        let state = start;
        let secondState = null;
        let nextState = null;
        let multiLength = 0;
        let latestAccepting = null;
        let sinceAccepts = -1;
        while(cursor < len && !(secondState = state.go(tokens[cursor].t)))// Starting tokens with nowhere to jump to.
        // Consider these to be just plain text
        textTokens.push(tokens[cursor++]);
        while(cursor < len && (nextState = secondState || state.go(tokens[cursor].t))){
            // Get the next state
            secondState = null;
            state = nextState;
            // Keep track of the latest accepting state
            if (state.accepts()) {
                sinceAccepts = 0;
                latestAccepting = state;
            } else if (sinceAccepts >= 0) sinceAccepts++;
            cursor++;
            multiLength++;
        }
        if (sinceAccepts < 0) {
            // No accepting state was found, part of a regular text token add
            // the first text token to the text tokens array and try again from
            // the next
            cursor -= multiLength;
            if (cursor < len) {
                textTokens.push(tokens[cursor]);
                cursor++;
            }
        } else {
            // Accepting state!
            // First close off the textTokens (if available)
            if (textTokens.length > 0) {
                multis.push($a163dbbf8fe68e4d$var$initMultiToken($a163dbbf8fe68e4d$var$Text, input, textTokens));
                textTokens = [];
            }
            // Roll back to the latest accepting state
            cursor -= sinceAccepts;
            multiLength -= sinceAccepts;
            // Create a new multitoken
            const Multi = latestAccepting.t;
            const subtokens = tokens.slice(cursor - multiLength, cursor);
            multis.push($a163dbbf8fe68e4d$var$initMultiToken(Multi, input, subtokens));
        }
    }
    // Finally close off the textTokens (if available)
    if (textTokens.length > 0) multis.push($a163dbbf8fe68e4d$var$initMultiToken($a163dbbf8fe68e4d$var$Text, input, textTokens));
    return multis;
}
/**
 * Utility function for instantiating a new multitoken with all the relevant
 * fields during parsing.
 * @param {new (value: string, tokens: Token[]) => MultiToken} Multi class to instantiate
 * @param {string} input original input string
 * @param {Token[]} tokens consecutive tokens scanned from input string
 * @returns {MultiToken}
 */ function $a163dbbf8fe68e4d$var$initMultiToken(Multi, input, tokens) {
    const startIdx = tokens[0].s;
    const endIdx = tokens[tokens.length - 1].e;
    const value = input.slice(startIdx, endIdx);
    return new Multi(value, tokens);
}
const $a163dbbf8fe68e4d$var$warn = typeof console !== 'undefined' && console && console.warn || (()=>{});
const $a163dbbf8fe68e4d$var$warnAdvice = 'until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.';
// Side-effect initialization state
const $a163dbbf8fe68e4d$var$INIT = {
    scanner: null,
    parser: null,
    tokenQueue: [],
    pluginQueue: [],
    customSchemes: [],
    initialized: false
};
/**
 * @typedef {{
 * 	start: State<string>,
 * 	tokens: { groups: Collections<string> } & typeof tk
 * }} ScannerInit
 */ /**
 * @typedef {{
 * 	start: State<MultiToken>,
 * 	tokens: typeof multi
 * }} ParserInit
 */ /**
 * @typedef {(arg: { scanner: ScannerInit }) => void} TokenPlugin
 */ /**
 * @typedef {(arg: { scanner: ScannerInit, parser: ParserInit }) => void} Plugin
 */ /**
 * De-register all plugins and reset the internal state-machine. Used for
 * testing; not required in practice.
 * @private
 */ function $a163dbbf8fe68e4d$export$aad8462122ac592b() {
    $a163dbbf8fe68e4d$export$7254cc27399e90bd.groups = {};
    $a163dbbf8fe68e4d$var$INIT.scanner = null;
    $a163dbbf8fe68e4d$var$INIT.parser = null;
    $a163dbbf8fe68e4d$var$INIT.tokenQueue = [];
    $a163dbbf8fe68e4d$var$INIT.pluginQueue = [];
    $a163dbbf8fe68e4d$var$INIT.customSchemes = [];
    $a163dbbf8fe68e4d$var$INIT.initialized = false;
    return $a163dbbf8fe68e4d$var$INIT;
}
/**
 * Register a token plugin to allow the scanner to recognize additional token
 * types before the parser state machine is constructed from the results.
 * @param {string} name of plugin to register
 * @param {TokenPlugin} plugin function that accepts the scanner state machine
 * and available scanner tokens and collections and extends the state machine to
 * recognize additional tokens or groups.
 */ function $a163dbbf8fe68e4d$export$56d1f1cb1f3c0e96(name, plugin) {
    if (typeof plugin !== 'function') throw new Error(`linkifyjs: Invalid token plugin ${plugin} (expects function)`);
    for(let i = 0; i < $a163dbbf8fe68e4d$var$INIT.tokenQueue.length; i++)if (name === $a163dbbf8fe68e4d$var$INIT.tokenQueue[i][0]) {
        $a163dbbf8fe68e4d$var$warn(`linkifyjs: token plugin "${name}" already registered - will be overwritten`);
        $a163dbbf8fe68e4d$var$INIT.tokenQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $a163dbbf8fe68e4d$var$INIT.tokenQueue.push([
        name,
        plugin
    ]);
    if ($a163dbbf8fe68e4d$var$INIT.initialized) $a163dbbf8fe68e4d$var$warn(`linkifyjs: already initialized - will not register token plugin "${name}" ${$a163dbbf8fe68e4d$var$warnAdvice}`);
}
/**
 * Register a linkify plugin
 * @param {string} name of plugin to register
 * @param {Plugin} plugin function that accepts the parser state machine and
 * extends the parser to recognize additional link types
 */ function $a163dbbf8fe68e4d$export$7612db19fb8beb1e(name, plugin) {
    if (typeof plugin !== 'function') throw new Error(`linkifyjs: Invalid plugin ${plugin} (expects function)`);
    for(let i = 0; i < $a163dbbf8fe68e4d$var$INIT.pluginQueue.length; i++)if (name === $a163dbbf8fe68e4d$var$INIT.pluginQueue[i][0]) {
        $a163dbbf8fe68e4d$var$warn(`linkifyjs: plugin "${name}" already registered - will be overwritten`);
        $a163dbbf8fe68e4d$var$INIT.pluginQueue[i] = [
            name,
            plugin
        ];
        return;
    }
    $a163dbbf8fe68e4d$var$INIT.pluginQueue.push([
        name,
        plugin
    ]);
    if ($a163dbbf8fe68e4d$var$INIT.initialized) $a163dbbf8fe68e4d$var$warn(`linkifyjs: already initialized - will not register plugin "${name}" ${$a163dbbf8fe68e4d$var$warnAdvice}`);
}
/**
 * Detect URLs with the following additional protocol. Anything with format
 * "protocol://..." will be considered a link. If `optionalSlashSlash` is set to
 * `true`, anything with format "protocol:..." will be considered a link.
 * @param {string} scheme
 * @param {boolean} [optionalSlashSlash]
 */ function $a163dbbf8fe68e4d$export$821627edc2d26f5f(scheme, optionalSlashSlash = false) {
    if ($a163dbbf8fe68e4d$var$INIT.initialized) $a163dbbf8fe68e4d$var$warn(`linkifyjs: already initialized - will not register custom scheme "${scheme}" ${$a163dbbf8fe68e4d$var$warnAdvice}`);
    if (!/^[0-9a-z]+(-[0-9a-z]+)*$/.test(scheme)) throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
    $a163dbbf8fe68e4d$var$INIT.customSchemes.push([
        scheme,
        optionalSlashSlash
    ]);
}
/**
 * Initialize the linkify state machine. Called automatically the first time
 * linkify is called on a string, but may be called manually as well.
 */ function $a163dbbf8fe68e4d$export$2cd8252107eb640b() {
    // Initialize scanner state machine and plugins
    $a163dbbf8fe68e4d$var$INIT.scanner = $a163dbbf8fe68e4d$var$init$2($a163dbbf8fe68e4d$var$INIT.customSchemes);
    for(let i = 0; i < $a163dbbf8fe68e4d$var$INIT.tokenQueue.length; i++)$a163dbbf8fe68e4d$var$INIT.tokenQueue[i][1]({
        scanner: $a163dbbf8fe68e4d$var$INIT.scanner
    });
    // Initialize parser state machine and plugins
    $a163dbbf8fe68e4d$var$INIT.parser = $a163dbbf8fe68e4d$var$init$1($a163dbbf8fe68e4d$var$INIT.scanner.tokens);
    for(let i = 0; i < $a163dbbf8fe68e4d$var$INIT.pluginQueue.length; i++)$a163dbbf8fe68e4d$var$INIT.pluginQueue[i][1]({
        scanner: $a163dbbf8fe68e4d$var$INIT.scanner,
        parser: $a163dbbf8fe68e4d$var$INIT.parser
    });
    $a163dbbf8fe68e4d$var$INIT.initialized = true;
    return $a163dbbf8fe68e4d$var$INIT;
}
/**
 * Parse a string into tokens that represent linkable and non-linkable sub-components
 * @param {string} str
 * @return {MultiToken[]} tokens
 */ function $a163dbbf8fe68e4d$export$660b2ee2d4fb4eff(str) {
    if (!$a163dbbf8fe68e4d$var$INIT.initialized) $a163dbbf8fe68e4d$export$2cd8252107eb640b();
    return $a163dbbf8fe68e4d$var$run($a163dbbf8fe68e4d$var$INIT.parser.start, str, $a163dbbf8fe68e4d$var$run$1($a163dbbf8fe68e4d$var$INIT.scanner.start, str));
}
$a163dbbf8fe68e4d$export$660b2ee2d4fb4eff.scan = $a163dbbf8fe68e4d$var$run$1; // for testing
/**
 * Find a list of linkable items in the given string.
 * @param {string} str string to find links in
 * @param {string | Opts} [type] either formatting options or specific type of
 * links to find, e.g., 'url' or 'email'
 * @param {Opts} [opts] formatting options for final output. Cannot be specified
 * if opts already provided in `type` argument
 */ function $a163dbbf8fe68e4d$export$71aa6c912b956294(str, type = null, opts = null) {
    if (type && typeof type === 'object') {
        if (opts) throw Error(`linkifyjs: Invalid link type ${type}; must be a string`);
        opts = type;
        type = null;
    }
    const options = new $a163dbbf8fe68e4d$export$c019608e5b5bb4cb(opts);
    const tokens = $a163dbbf8fe68e4d$export$660b2ee2d4fb4eff(str);
    const filtered = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (token.isLink && (!type || token.t === type) && options.check(token)) filtered.push(token.toFormattedObject(options));
    }
    return filtered;
}
/**
 * Is the given string valid linkable text of some sort. Note that this does not
 * trim the text for you.
 *
 * Optionally pass in a second `type` param, which is the type of link to test
 * for.
 *
 * For example,
 *
 *     linkify.test(str, 'email');
 *
 * Returns `true` if str is a valid email.
 * @param {string} str string to test for links
 * @param {string} [type] optional specific link type to look for
 * @returns boolean true/false
 */ function $a163dbbf8fe68e4d$export$e0969da9b8fb378d(str, type = null) {
    const tokens = $a163dbbf8fe68e4d$export$660b2ee2d4fb4eff(str);
    return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].t === type);
}

});


parcelRegister("l1c21", function(module, exports) {

$parcel$export(module.exports, "OrderedList", () => $f4d3062c4e6e0bd6$export$547f885a1fca4e31);
$parcel$export(module.exports, "default", () => $f4d3062c4e6e0bd6$export$547f885a1fca4e31);

var $gkCGf = parcelRequire("gkCGf");
const $f4d3062c4e6e0bd6$var$ListItemName = 'listItem';
const $f4d3062c4e6e0bd6$var$TextStyleName = 'textStyle';
/**
 * Matches an ordered list to a 1. on input (or any number followed by a dot).
 */ const $f4d3062c4e6e0bd6$export$55b9391925fcc072 = /^(\d+)\.\s$/;
/**
 * This extension allows you to create ordered lists.
 * This requires the ListItem extension
 * @see https://www.tiptap.dev/api/nodes/ordered-list
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $f4d3062c4e6e0bd6$export$547f885a1fca4e31 = (0, $gkCGf.Node).create({
    name: 'orderedList',
    addOptions () {
        return {
            itemTypeName: 'listItem',
            HTMLAttributes: {},
            keepMarks: false,
            keepAttributes: false
        };
    },
    group: 'block list',
    content () {
        return `${this.options.itemTypeName}+`;
    },
    addAttributes () {
        return {
            start: {
                default: 1,
                parseHTML: (element)=>{
                    return element.hasAttribute('start') ? parseInt(element.getAttribute('start') || '', 10) : 1;
                }
            },
            type: {
                default: null,
                parseHTML: (element)=>element.getAttribute('type')
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: 'ol'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        const { start: start, ...attributesWithoutStart } = HTMLAttributes;
        return start === 1 ? [
            'ol',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, attributesWithoutStart),
            0
        ] : [
            'ol',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            toggleOrderedList: ()=>({ commands: commands, chain: chain })=>{
                    if (this.options.keepAttributes) return chain().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes($f4d3062c4e6e0bd6$var$ListItemName, this.editor.getAttributes($f4d3062c4e6e0bd6$var$TextStyleName)).run();
                    return commands.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-7': ()=>this.editor.commands.toggleOrderedList()
        };
    },
    addInputRules () {
        let inputRule = (0, $gkCGf.wrappingInputRule)({
            find: $f4d3062c4e6e0bd6$export$55b9391925fcc072,
            type: this.type,
            getAttributes: (match)=>({
                    start: +match[1]
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1]
        });
        if (this.options.keepMarks || this.options.keepAttributes) inputRule = (0, $gkCGf.wrappingInputRule)({
            find: $f4d3062c4e6e0bd6$export$55b9391925fcc072,
            type: this.type,
            keepMarks: this.options.keepMarks,
            keepAttributes: this.options.keepAttributes,
            getAttributes: (match)=>({
                    start: +match[1],
                    ...this.editor.getAttributes($f4d3062c4e6e0bd6$var$TextStyleName)
                }),
            joinPredicate: (match, node)=>node.childCount + node.attrs.start === +match[1],
            editor: this.editor
        });
        return [
            inputRule
        ];
    }
});

});

parcelRegister("2jORh", function(module, exports) {

$parcel$export(module.exports, "Strike", () => $1b04ce84bc40ae69$export$97176b8d51d2058f);
$parcel$export(module.exports, "default", () => $1b04ce84bc40ae69$export$97176b8d51d2058f);

var $gkCGf = parcelRequire("gkCGf");
/**
 * Matches a strike to a ~~strike~~ on input.
 */ const $1b04ce84bc40ae69$export$55b9391925fcc072 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/;
/**
 * Matches a strike to a ~~strike~~ on paste.
 */ const $1b04ce84bc40ae69$export$4ed30f8936af1979 = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g;
/**
 * This extension allows you to create strike text.
 * @see https://www.tiptap.dev/api/marks/strike
 */ const $1b04ce84bc40ae69$export$97176b8d51d2058f = (0, $gkCGf.Mark).create({
    name: 'strike',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 's'
            },
            {
                tag: 'del'
            },
            {
                tag: 'strike'
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: (style)=>style.includes('line-through') ? {} : false
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            's',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setStrike: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleStrike: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetStrike: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-s': ()=>this.editor.commands.toggleStrike()
        };
    },
    addInputRules () {
        return [
            (0, $gkCGf.markInputRule)({
                find: $1b04ce84bc40ae69$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $gkCGf.markPasteRule)({
                find: $1b04ce84bc40ae69$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("7IEdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ebd7842d492c6a$export$3720eb13f948f394);

var $gkCGf = parcelRequire("gkCGf");
/**
 * This extension allows you to align text.
 * @see https://www.tiptap.dev/api/extensions/text-align
 */ const $59ebd7842d492c6a$export$3720eb13f948f394 = (0, $gkCGf.Extension).create({
    name: 'textAlign',
    addOptions () {
        return {
            types: [],
            alignments: [
                'left',
                'center',
                'right',
                'justify'
            ],
            defaultAlignment: null
        };
    },
    addGlobalAttributes () {
        return [
            {
                types: this.options.types,
                attributes: {
                    textAlign: {
                        default: this.options.defaultAlignment,
                        parseHTML: (element)=>{
                            const alignment = element.style.textAlign;
                            return this.options.alignments.includes(alignment) ? alignment : this.options.defaultAlignment;
                        },
                        renderHTML: (attributes)=>{
                            if (!attributes.textAlign) return {};
                            return {
                                style: `text-align: ${attributes.textAlign}`
                            };
                        }
                    }
                }
            }
        ];
    },
    addCommands () {
        return {
            setTextAlign: (alignment)=>({ commands: commands })=>{
                    if (!this.options.alignments.includes(alignment)) return false;
                    return this.options.types.map((type)=>commands.updateAttributes(type, {
                            textAlign: alignment
                        })).every((response)=>response);
                },
            unsetTextAlign: ()=>({ commands: commands })=>{
                    return this.options.types.map((type)=>commands.resetAttributes(type, 'textAlign')).every((response)=>response);
                },
            toggleTextAlign: (alignment)=>({ editor: editor, commands: commands })=>{
                    if (!this.options.alignments.includes(alignment)) return false;
                    if (editor.isActive({
                        textAlign: alignment
                    })) return commands.unsetTextAlign();
                    return commands.setTextAlign(alignment);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Shift-l': ()=>this.editor.commands.setTextAlign('left'),
            'Mod-Shift-e': ()=>this.editor.commands.setTextAlign('center'),
            'Mod-Shift-r': ()=>this.editor.commands.setTextAlign('right'),
            'Mod-Shift-j': ()=>this.editor.commands.setTextAlign('justify')
        };
    }
});

});

parcelRegister("ednZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a594e465601a2726$export$741ee5bff4f2bc22);

var $gkCGf = parcelRequire("gkCGf");
/**
 * This extension allows you to create underline text.
 * @see https://www.tiptap.dev/api/marks/underline
 */ const $a594e465601a2726$export$741ee5bff4f2bc22 = (0, $gkCGf.Mark).create({
    name: 'underline',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'u'
            },
            {
                style: 'text-decoration',
                consuming: false,
                getAttrs: (style)=>style.includes('underline') ? {} : false
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'u',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setUnderline: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleUnderline: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetUnderline: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-u': ()=>this.editor.commands.toggleUnderline(),
            'Mod-U': ()=>this.editor.commands.toggleUnderline()
        };
    }
});

});

parcelRegister("fXWMf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9f9f5a2724622fc$export$626064c5f1b71dc);

var $gkCGf = parcelRequire("gkCGf");

var $2u5A9 = parcelRequire("2u5A9");

var $2xosh = parcelRequire("2xosh");

var $dacGJ = parcelRequire("dacGJ");

var $lluJu = parcelRequire("lluJu");

var $1BHwg = parcelRequire("1BHwg");

var $9aRSD = parcelRequire("9aRSD");

var $lnzEF = parcelRequire("lnzEF");

var $i3rT4 = parcelRequire("i3rT4");

var $k7DD8 = parcelRequire("k7DD8");

var $4w6kx = parcelRequire("4w6kx");

var $luyzA = parcelRequire("luyzA");

var $gaTMf = parcelRequire("gaTMf");

var $5G1It = parcelRequire("5G1It");

var $cabgp = parcelRequire("cabgp");

var $l1c21 = parcelRequire("l1c21");

var $dzWv6 = parcelRequire("dzWv6");

var $2jORh = parcelRequire("2jORh");

var $hirCw = parcelRequire("hirCw");
/**
 * The starter kit is a collection of essential editor extensions.
 *
 * It’s a good starting point for building your own editor.
 */ const $b9f9f5a2724622fc$export$626064c5f1b71dc = (0, $gkCGf.Extension).create({
    name: 'starterKit',
    addExtensions () {
        const extensions = [];
        if (this.options.bold !== false) extensions.push((0, $2xosh.Bold).configure(this.options.bold));
        if (this.options.blockquote !== false) extensions.push((0, $2u5A9.Blockquote).configure(this.options.blockquote));
        if (this.options.bulletList !== false) extensions.push((0, $dacGJ.BulletList).configure(this.options.bulletList));
        if (this.options.code !== false) extensions.push((0, $lluJu.Code).configure(this.options.code));
        if (this.options.codeBlock !== false) extensions.push((0, $1BHwg.CodeBlock).configure(this.options.codeBlock));
        if (this.options.document !== false) extensions.push((0, $9aRSD.Document).configure(this.options.document));
        if (this.options.dropcursor !== false) extensions.push((0, $lnzEF.Dropcursor).configure(this.options.dropcursor));
        if (this.options.gapcursor !== false) extensions.push((0, $i3rT4.Gapcursor).configure(this.options.gapcursor));
        if (this.options.hardBreak !== false) extensions.push((0, $k7DD8.HardBreak).configure(this.options.hardBreak));
        if (this.options.heading !== false) extensions.push((0, $4w6kx.Heading).configure(this.options.heading));
        if (this.options.history !== false) extensions.push((0, $luyzA.History).configure(this.options.history));
        if (this.options.horizontalRule !== false) extensions.push((0, $gaTMf.HorizontalRule).configure(this.options.horizontalRule));
        if (this.options.italic !== false) extensions.push((0, $5G1It.Italic).configure(this.options.italic));
        if (this.options.listItem !== false) extensions.push((0, $cabgp.ListItem).configure(this.options.listItem));
        if (this.options.orderedList !== false) extensions.push((0, $l1c21.OrderedList).configure(this.options.orderedList));
        if (this.options.paragraph !== false) extensions.push((0, $dzWv6.Paragraph).configure(this.options.paragraph));
        if (this.options.strike !== false) extensions.push((0, $2jORh.Strike).configure(this.options.strike));
        if (this.options.text !== false) extensions.push((0, $hirCw.Text).configure(this.options.text));
        return extensions;
    }
});

});
parcelRegister("2xosh", function(module, exports) {

$parcel$export(module.exports, "Bold", () => $1d91a21df58be65e$export$95aa4184327d6b72);

var $gkCGf = parcelRequire("gkCGf");
/**
 * Matches bold text via `**` as input.
 */ const $1d91a21df58be65e$export$73ba4776eeca629e = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/;
/**
 * Matches bold text via `**` while pasting.
 */ const $1d91a21df58be65e$export$47b75d481b90409 = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g;
/**
 * Matches bold text via `__` as input.
 */ const $1d91a21df58be65e$export$79cd1d2695dae26d = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/;
/**
 * Matches bold text via `__` while pasting.
 */ const $1d91a21df58be65e$export$9b623891dbc7bd12 = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g;
/**
 * This extension allows you to mark text as bold.
 * @see https://tiptap.dev/api/marks/bold
 */ const $1d91a21df58be65e$export$95aa4184327d6b72 = (0, $gkCGf.Mark).create({
    name: 'bold',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'strong'
            },
            {
                tag: 'b',
                getAttrs: (node)=>node.style.fontWeight !== 'normal' && null
            },
            {
                style: 'font-weight=400',
                clearMark: (mark)=>mark.type.name === this.name
            },
            {
                style: 'font-weight',
                getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'strong',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setBold: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleBold: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetBold: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-b': ()=>this.editor.commands.toggleBold(),
            'Mod-B': ()=>this.editor.commands.toggleBold()
        };
    },
    addInputRules () {
        return [
            (0, $gkCGf.markInputRule)({
                find: $1d91a21df58be65e$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $gkCGf.markInputRule)({
                find: $1d91a21df58be65e$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $gkCGf.markPasteRule)({
                find: $1d91a21df58be65e$export$47b75d481b90409,
                type: this.type
            }),
            (0, $gkCGf.markPasteRule)({
                find: $1d91a21df58be65e$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("lluJu", function(module, exports) {

$parcel$export(module.exports, "Code", () => $f8a365fd4a686699$export$52f0f02147b12c03);

var $gkCGf = parcelRequire("gkCGf");
/**
 * Regular expressions to match inline code blocks enclosed in backticks.
 *  It matches:
 *     - An opening backtick, followed by
 *     - Any text that doesn't include a backtick (captured for marking), followed by
 *     - A closing backtick.
 *  This ensures that any text between backticks is formatted as code,
 *  regardless of the surrounding characters (exception being another backtick).
 */ const $f8a365fd4a686699$export$55b9391925fcc072 = /(^|[^`])`([^`]+)`(?!`)/;
/**
 * Matches inline code while pasting.
 */ const $f8a365fd4a686699$export$4ed30f8936af1979 = /(^|[^`])`([^`]+)`(?!`)/g;
/**
 * This extension allows you to mark text as inline code.
 * @see https://tiptap.dev/api/marks/code
 */ const $f8a365fd4a686699$export$52f0f02147b12c03 = (0, $gkCGf.Mark).create({
    name: 'code',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    excludes: '_',
    code: true,
    exitable: true,
    parseHTML () {
        return [
            {
                tag: 'code'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'code',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setCode: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleCode: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetCode: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-e': ()=>this.editor.commands.toggleCode()
        };
    },
    addInputRules () {
        return [
            (0, $gkCGf.markInputRule)({
                find: $f8a365fd4a686699$export$55b9391925fcc072,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $gkCGf.markPasteRule)({
                find: $f8a365fd4a686699$export$4ed30f8936af1979,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("1BHwg", function(module, exports) {

$parcel$export(module.exports, "CodeBlock", () => $12bb012f8380ac9f$export$6c415d1fdae3dfdb);

var $gkCGf = parcelRequire("gkCGf");
parcelRequire("7fRs0");
var $1LeRC = parcelRequire("1LeRC");
/**
 * Matches a code block with backticks.
 */ const $12bb012f8380ac9f$export$4f70c75119de8367 = /^```([a-z]+)?[\s\n]$/;
/**
 * Matches a code block with tildes.
 */ const $12bb012f8380ac9f$export$ab3d90a1a99abb84 = /^~~~([a-z]+)?[\s\n]$/;
/**
 * This extension allows you to create code blocks.
 * @see https://tiptap.dev/api/nodes/code-block
 */ const $12bb012f8380ac9f$export$6c415d1fdae3dfdb = (0, $gkCGf.Node).create({
    name: 'codeBlock',
    addOptions () {
        return {
            languageClassPrefix: 'language-',
            exitOnTripleEnter: true,
            exitOnArrowDown: true,
            defaultLanguage: null,
            HTMLAttributes: {}
        };
    },
    content: 'text*',
    marks: '',
    group: 'block',
    code: true,
    defining: true,
    addAttributes () {
        return {
            language: {
                default: this.options.defaultLanguage,
                parseHTML: (element)=>{
                    var _a;
                    const { languageClassPrefix: languageClassPrefix } = this.options;
                    const classNames = [
                        ...((_a = element.firstElementChild) === null || _a === void 0 ? void 0 : _a.classList) || []
                    ];
                    const languages = classNames.filter((className)=>className.startsWith(languageClassPrefix)).map((className)=>className.replace(languageClassPrefix, ''));
                    const language = languages[0];
                    if (!language) return null;
                    return language;
                },
                rendered: false
            }
        };
    },
    parseHTML () {
        return [
            {
                tag: 'pre',
                preserveWhitespace: 'full'
            }
        ];
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        return [
            'pre',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            [
                'code',
                {
                    class: node.attrs.language ? this.options.languageClassPrefix + node.attrs.language : null
                },
                0
            ]
        ];
    },
    addCommands () {
        return {
            setCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.setNode(this.name, attributes);
                },
            toggleCodeBlock: (attributes)=>({ commands: commands })=>{
                    return commands.toggleNode(this.name, 'paragraph', attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Alt-c': ()=>this.editor.commands.toggleCodeBlock(),
            // remove code block when at start of document or code block is empty
            Backspace: ()=>{
                const { empty: empty, $anchor: $anchor } = this.editor.state.selection;
                const isAtStart = $anchor.pos === 1;
                if (!empty || $anchor.parent.type.name !== this.name) return false;
                if (isAtStart || !$anchor.parent.textContent.length) return this.editor.commands.clearNodes();
                return false;
            },
            // exit node on triple enter
            Enter: ({ editor: editor })=>{
                if (!this.options.exitOnTripleEnter) return false;
                const { state: state } = editor;
                const { selection: selection } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                const endsWithDoubleNewline = $from.parent.textContent.endsWith('\n\n');
                if (!isAtEnd || !endsWithDoubleNewline) return false;
                return editor.chain().command(({ tr: tr })=>{
                    tr.delete($from.pos - 2, $from.pos);
                    return true;
                }).exitCode().run();
            },
            // exit node on arrow down
            ArrowDown: ({ editor: editor })=>{
                if (!this.options.exitOnArrowDown) return false;
                const { state: state } = editor;
                const { selection: selection, doc: doc } = state;
                const { $from: $from, empty: empty } = selection;
                if (!empty || $from.parent.type !== this.type) return false;
                const isAtEnd = $from.parentOffset === $from.parent.nodeSize - 2;
                if (!isAtEnd) return false;
                const after = $from.after();
                if (after === undefined) return false;
                const nodeAfter = doc.nodeAt(after);
                if (nodeAfter) return editor.commands.command(({ tr: tr })=>{
                    tr.setSelection((0, $1LeRC.Selection).near(doc.resolve(after)));
                    return true;
                });
                return editor.commands.exitCode();
            }
        };
    },
    addInputRules () {
        return [
            (0, $gkCGf.textblockTypeInputRule)({
                find: $12bb012f8380ac9f$export$4f70c75119de8367,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            }),
            (0, $gkCGf.textblockTypeInputRule)({
                find: $12bb012f8380ac9f$export$ab3d90a1a99abb84,
                type: this.type,
                getAttributes: (match)=>({
                        language: match[1]
                    })
            })
        ];
    },
    addProseMirrorPlugins () {
        return [
            // this plugin creates a code block for pasted content from VS Code
            // we can also detect the copied code language
            new (0, $1LeRC.Plugin)({
                key: new (0, $1LeRC.PluginKey)('codeBlockVSCodeHandler'),
                props: {
                    handlePaste: (view, event)=>{
                        if (!event.clipboardData) return false;
                        // don’t create a new code block within code blocks
                        if (this.editor.isActive(this.type.name)) return false;
                        const text = event.clipboardData.getData('text/plain');
                        const vscode = event.clipboardData.getData('vscode-editor-data');
                        const vscodeData = vscode ? JSON.parse(vscode) : undefined;
                        const language = vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
                        if (!text || !language) return false;
                        const { tr: tr, schema: schema } = view.state;
                        // prepare a text node
                        // strip carriage return chars from text pasted as code
                        // see: https://github.com/ProseMirror/prosemirror-view/commit/a50a6bcceb4ce52ac8fcc6162488d8875613aacd
                        const textNode = schema.text(text.replace(/\r\n?/g, '\n'));
                        // create a code block with the text node
                        // replace selection with the code block
                        tr.replaceSelectionWith(this.type.create({
                            language: language
                        }, textNode));
                        if (tr.selection.$from.parent.type !== this.type) // put cursor inside the newly created code block
                        tr.setSelection((0, $1LeRC.TextSelection).near(tr.doc.resolve(Math.max(0, tr.selection.from - 2))));
                        // store meta information
                        // this is useful for other plugins that depends on the paste event
                        // like the paste rule plugin
                        tr.setMeta('paste', true);
                        view.dispatch(tr);
                        return true;
                    }
                }
            })
        ];
    }
});

});

parcelRegister("9aRSD", function(module, exports) {

$parcel$export(module.exports, "Document", () => $6aded7bc8316e260$export$b34a105447964f9f);

var $gkCGf = parcelRequire("gkCGf");
/**
 * The default document node which represents the top level node of the editor.
 * @see https://tiptap.dev/api/nodes/document
 */ const $6aded7bc8316e260$export$b34a105447964f9f = (0, $gkCGf.Node).create({
    name: 'doc',
    topNode: true,
    content: 'block+'
});

});

parcelRegister("lnzEF", function(module, exports) {

$parcel$export(module.exports, "Dropcursor", () => $f90767477590503a$export$bc16731f26f3900d);

var $gkCGf = parcelRequire("gkCGf");
parcelRequire("a1ERn");
var $e0Vzz = parcelRequire("e0Vzz");
/**
 * This extension allows you to add a drop cursor to your editor.
 * A drop cursor is a line that appears when you drag and drop content
 * inbetween nodes.
 * @see https://tiptap.dev/api/extensions/dropcursor
 */ const $f90767477590503a$export$bc16731f26f3900d = (0, $gkCGf.Extension).create({
    name: 'dropCursor',
    addOptions () {
        return {
            color: 'currentColor',
            width: 1,
            class: undefined
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $e0Vzz.dropCursor)(this.options)
        ];
    }
});

});
parcelRegister("a1ERn", function(module, exports) {
$parcel$export(module.exports, "dropCursor", () => (parcelRequire("e0Vzz")).dropCursor);
// dropcursor/index.ts
parcelRequire("e0Vzz");

});
parcelRegister("e0Vzz", function(module, exports) {

$parcel$export(module.exports, "dropCursor", () => $a33db98654728ae4$export$b8e3092a3bfa2062);

var $1LeRC = parcelRequire("1LeRC");

var $gfgdn = parcelRequire("gfgdn");
/**
Create a plugin that, when added to a ProseMirror instance,
causes a decoration to show up at the drop position when something
is dragged over the editor.

Nodes may add a `disableDropCursor` property to their spec to
control the showing of a drop cursor inside them. This may be a
boolean or a function, which will be called with a view and a
position, and should return a boolean.
*/ function $a33db98654728ae4$export$b8e3092a3bfa2062(options = {}) {
    return new (0, $1LeRC.Plugin)({
        view (editorView) {
            return new $a33db98654728ae4$var$DropCursorView(editorView, options);
        }
    });
}
class $a33db98654728ae4$var$DropCursorView {
    constructor(editorView, options){
        var _a;
        this.editorView = editorView;
        this.cursorPos = null;
        this.element = null;
        this.timeout = -1;
        this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 1;
        this.color = options.color === false ? undefined : options.color || "black";
        this.class = options.class;
        this.handlers = [
            "dragover",
            "dragend",
            "drop",
            "dragleave"
        ].map((name)=>{
            let handler = (e)=>{
                this[name](e);
            };
            editorView.dom.addEventListener(name, handler);
            return {
                name: name,
                handler: handler
            };
        });
    }
    destroy() {
        this.handlers.forEach(({ name: name, handler: handler })=>this.editorView.dom.removeEventListener(name, handler));
    }
    update(editorView, prevState) {
        if (this.cursorPos != null && prevState.doc != editorView.state.doc) {
            if (this.cursorPos > editorView.state.doc.content.size) this.setCursor(null);
            else this.updateOverlay();
        }
    }
    setCursor(pos) {
        if (pos == this.cursorPos) return;
        this.cursorPos = pos;
        if (pos == null) {
            this.element.parentNode.removeChild(this.element);
            this.element = null;
        } else this.updateOverlay();
    }
    updateOverlay() {
        let $pos = this.editorView.state.doc.resolve(this.cursorPos);
        let isBlock = !$pos.parent.inlineContent, rect;
        if (isBlock) {
            let before = $pos.nodeBefore, after = $pos.nodeAfter;
            if (before || after) {
                let node = this.editorView.nodeDOM(this.cursorPos - (before ? before.nodeSize : 0));
                if (node) {
                    let nodeRect = node.getBoundingClientRect();
                    let top = before ? nodeRect.bottom : nodeRect.top;
                    if (before && after) top = (top + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2;
                    rect = {
                        left: nodeRect.left,
                        right: nodeRect.right,
                        top: top - this.width / 2,
                        bottom: top + this.width / 2
                    };
                }
            }
        }
        if (!rect) {
            let coords = this.editorView.coordsAtPos(this.cursorPos);
            rect = {
                left: coords.left - this.width / 2,
                right: coords.left + this.width / 2,
                top: coords.top,
                bottom: coords.bottom
            };
        }
        let parent = this.editorView.dom.offsetParent;
        if (!this.element) {
            this.element = parent.appendChild(document.createElement("div"));
            if (this.class) this.element.className = this.class;
            this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;";
            if (this.color) this.element.style.backgroundColor = this.color;
        }
        this.element.classList.toggle("prosemirror-dropcursor-block", isBlock);
        this.element.classList.toggle("prosemirror-dropcursor-inline", !isBlock);
        let parentLeft, parentTop;
        if (!parent || parent == document.body && getComputedStyle(parent).position == "static") {
            parentLeft = -pageXOffset;
            parentTop = -pageYOffset;
        } else {
            let rect = parent.getBoundingClientRect();
            parentLeft = rect.left - parent.scrollLeft;
            parentTop = rect.top - parent.scrollTop;
        }
        this.element.style.left = rect.left - parentLeft + "px";
        this.element.style.top = rect.top - parentTop + "px";
        this.element.style.width = rect.right - rect.left + "px";
        this.element.style.height = rect.bottom - rect.top + "px";
    }
    scheduleRemoval(timeout) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(()=>this.setCursor(null), timeout);
    }
    dragover(event) {
        if (!this.editorView.editable) return;
        let pos = this.editorView.posAtCoords({
            left: event.clientX,
            top: event.clientY
        });
        let node = pos && pos.inside >= 0 && this.editorView.state.doc.nodeAt(pos.inside);
        let disableDropCursor = node && node.type.spec.disableDropCursor;
        let disabled = typeof disableDropCursor == "function" ? disableDropCursor(this.editorView, pos, event) : disableDropCursor;
        if (pos && !disabled) {
            let target = pos.pos;
            if (this.editorView.dragging && this.editorView.dragging.slice) {
                let point = (0, $gfgdn.dropPoint)(this.editorView.state.doc, target, this.editorView.dragging.slice);
                if (point != null) target = point;
            }
            this.setCursor(target);
            this.scheduleRemoval(5000);
        }
    }
    dragend() {
        this.scheduleRemoval(20);
    }
    drop() {
        this.scheduleRemoval(20);
    }
    dragleave(event) {
        if (event.target == this.editorView.dom || !this.editorView.dom.contains(event.relatedTarget)) this.setCursor(null);
    }
}

});



parcelRegister("i3rT4", function(module, exports) {

$parcel$export(module.exports, "Gapcursor", () => $d24e23a4ef2e6f18$export$79c3dcaa03287f63);

var $gkCGf = parcelRequire("gkCGf");
parcelRequire("hZrtw");
var $f94iL = parcelRequire("f94iL");
/**
 * This extension allows you to add a gap cursor to your editor.
 * A gap cursor is a cursor that appears when you click on a place
 * where no content is present, for example inbetween nodes.
 * @see https://tiptap.dev/api/extensions/gapcursor
 */ const $d24e23a4ef2e6f18$export$79c3dcaa03287f63 = (0, $gkCGf.Extension).create({
    name: 'gapCursor',
    addProseMirrorPlugins () {
        return [
            (0, $f94iL.gapCursor)()
        ];
    },
    extendNodeSchema (extension) {
        var _a;
        const context = {
            name: extension.name,
            options: extension.options,
            storage: extension.storage
        };
        return {
            allowGapCursor: (_a = (0, $gkCGf.callOrReturn)((0, $gkCGf.getExtensionField)(extension, 'allowGapCursor', context))) !== null && _a !== void 0 ? _a : null
        };
    }
});

});
parcelRegister("hZrtw", function(module, exports) {
$parcel$export(module.exports, "gapCursor", () => (parcelRequire("f94iL")).gapCursor);
// gapcursor/index.ts
parcelRequire("f94iL");

});
parcelRegister("f94iL", function(module, exports) {

$parcel$export(module.exports, "gapCursor", () => $b06b087e5c2a3bdd$export$54f46a1492d5247);

var $18HhN = parcelRequire("18HhN");

var $1LeRC = parcelRequire("1LeRC");

var $1krlL = parcelRequire("1krlL");

var $edQEX = parcelRequire("edQEX");
/**
Gap cursor selections are represented using this class. Its
`$anchor` and `$head` properties both point at the cursor position.
*/ class $b06b087e5c2a3bdd$export$3d3d259665dcb4d4 extends (0, $1LeRC.Selection) {
    /**
    Create a gap cursor.
    */ constructor($pos){
        super($pos, $pos);
    }
    map(doc, mapping) {
        let $pos = doc.resolve(mapping.map(this.head));
        return $b06b087e5c2a3bdd$export$3d3d259665dcb4d4.valid($pos) ? new $b06b087e5c2a3bdd$export$3d3d259665dcb4d4($pos) : (0, $1LeRC.Selection).near($pos);
    }
    content() {
        return (0, $1krlL.Slice).empty;
    }
    eq(other) {
        return other instanceof $b06b087e5c2a3bdd$export$3d3d259665dcb4d4 && other.head == this.head;
    }
    toJSON() {
        return {
            type: "gapcursor",
            pos: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for GapCursor.fromJSON");
        return new $b06b087e5c2a3bdd$export$3d3d259665dcb4d4(doc.resolve(json.pos));
    }
    /**
    @internal
    */ getBookmark() {
        return new $b06b087e5c2a3bdd$var$GapBookmark(this.anchor);
    }
    /**
    @internal
    */ static valid($pos) {
        let parent = $pos.parent;
        if (parent.isTextblock || !$b06b087e5c2a3bdd$var$closedBefore($pos) || !$b06b087e5c2a3bdd$var$closedAfter($pos)) return false;
        let override = parent.type.spec.allowGapCursor;
        if (override != null) return override;
        let deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    /**
    @internal
    */ static findGapCursorFrom($pos, dir, mustMove = false) {
        search: for(;;){
            if (!mustMove && $b06b087e5c2a3bdd$export$3d3d259665dcb4d4.valid($pos)) return $pos;
            let pos = $pos.pos, next = null;
            // Scan up from this position
            for(let d = $pos.depth;; d--){
                let parent = $pos.node(d);
                if (dir > 0 ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                    next = parent.child(dir > 0 ? $pos.indexAfter(d) : $pos.index(d) - 1);
                    break;
                } else if (d == 0) return null;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($b06b087e5c2a3bdd$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            // And then down into the next node
            for(;;){
                let inside = dir > 0 ? next.firstChild : next.lastChild;
                if (!inside) {
                    if (next.isAtom && !next.isText && !(0, $1LeRC.NodeSelection).isSelectable(next)) {
                        $pos = $pos.doc.resolve(pos + next.nodeSize * dir);
                        mustMove = false;
                        continue search;
                    }
                    break;
                }
                next = inside;
                pos += dir;
                let $cur = $pos.doc.resolve(pos);
                if ($b06b087e5c2a3bdd$export$3d3d259665dcb4d4.valid($cur)) return $cur;
            }
            return null;
        }
    }
}
$b06b087e5c2a3bdd$export$3d3d259665dcb4d4.prototype.visible = false;
$b06b087e5c2a3bdd$export$3d3d259665dcb4d4.findFrom = $b06b087e5c2a3bdd$export$3d3d259665dcb4d4.findGapCursorFrom;
(0, $1LeRC.Selection).jsonID("gapcursor", $b06b087e5c2a3bdd$export$3d3d259665dcb4d4);
class $b06b087e5c2a3bdd$var$GapBookmark {
    constructor(pos){
        this.pos = pos;
    }
    map(mapping) {
        return new $b06b087e5c2a3bdd$var$GapBookmark(mapping.map(this.pos));
    }
    resolve(doc) {
        let $pos = doc.resolve(this.pos);
        return $b06b087e5c2a3bdd$export$3d3d259665dcb4d4.valid($pos) ? new $b06b087e5c2a3bdd$export$3d3d259665dcb4d4($pos) : (0, $1LeRC.Selection).near($pos);
    }
}
function $b06b087e5c2a3bdd$var$closedBefore($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.index(d), parent = $pos.node(d);
        // At the start of this parent, look at next one
        if (index == 0) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        // See if the node before (or its first ancestor) is closed
        for(let before = parent.child(index - 1);; before = before.lastChild){
            if (before.childCount == 0 && !before.inlineContent || before.isAtom || before.type.spec.isolating) return true;
            if (before.inlineContent) return false;
        }
    }
    // Hit start of document
    return true;
}
function $b06b087e5c2a3bdd$var$closedAfter($pos) {
    for(let d = $pos.depth; d >= 0; d--){
        let index = $pos.indexAfter(d), parent = $pos.node(d);
        if (index == parent.childCount) {
            if (parent.type.spec.isolating) return true;
            continue;
        }
        for(let after = parent.child(index);; after = after.firstChild){
            if (after.childCount == 0 && !after.inlineContent || after.isAtom || after.type.spec.isolating) return true;
            if (after.inlineContent) return false;
        }
    }
    return true;
}
/**
Create a gap cursor plugin. When enabled, this will capture clicks
near and arrow-key-motion past places that don't have a normally
selectable position nearby, and create a gap cursor selection for
them. The cursor is drawn as an element with class
`ProseMirror-gapcursor`. You can either include
`style/gapcursor.css` from the package's directory or add your own
styles to make it visible.
*/ function $b06b087e5c2a3bdd$export$54f46a1492d5247() {
    return new (0, $1LeRC.Plugin)({
        props: {
            decorations: $b06b087e5c2a3bdd$var$drawGapCursor,
            createSelectionBetween (_view, $anchor, $head) {
                return $anchor.pos == $head.pos && $b06b087e5c2a3bdd$export$3d3d259665dcb4d4.valid($head) ? new $b06b087e5c2a3bdd$export$3d3d259665dcb4d4($head) : null;
            },
            handleClick: $b06b087e5c2a3bdd$var$handleClick,
            handleKeyDown: $b06b087e5c2a3bdd$var$handleKeyDown,
            handleDOMEvents: {
                beforeinput: $b06b087e5c2a3bdd$var$beforeinput
            }
        }
    });
}
const $b06b087e5c2a3bdd$var$handleKeyDown = (0, $18HhN.keydownHandler)({
    "ArrowLeft": $b06b087e5c2a3bdd$var$arrow("horiz", -1),
    "ArrowRight": $b06b087e5c2a3bdd$var$arrow("horiz", 1),
    "ArrowUp": $b06b087e5c2a3bdd$var$arrow("vert", -1),
    "ArrowDown": $b06b087e5c2a3bdd$var$arrow("vert", 1)
});
function $b06b087e5c2a3bdd$var$arrow(axis, dir) {
    const dirStr = axis == "vert" ? dir > 0 ? "down" : "up" : dir > 0 ? "right" : "left";
    return function(state, dispatch, view) {
        let sel = state.selection;
        let $start = dir > 0 ? sel.$to : sel.$from, mustMove = sel.empty;
        if (sel instanceof (0, $1LeRC.TextSelection)) {
            if (!view.endOfTextblock(dirStr) || $start.depth == 0) return false;
            mustMove = false;
            $start = state.doc.resolve(dir > 0 ? $start.after() : $start.before());
        }
        let $found = $b06b087e5c2a3bdd$export$3d3d259665dcb4d4.findGapCursorFrom($start, dir, mustMove);
        if (!$found) return false;
        if (dispatch) dispatch(state.tr.setSelection(new $b06b087e5c2a3bdd$export$3d3d259665dcb4d4($found)));
        return true;
    };
}
function $b06b087e5c2a3bdd$var$handleClick(view, pos, event) {
    if (!view || !view.editable) return false;
    let $pos = view.state.doc.resolve(pos);
    if (!$b06b087e5c2a3bdd$export$3d3d259665dcb4d4.valid($pos)) return false;
    let clickPos = view.posAtCoords({
        left: event.clientX,
        top: event.clientY
    });
    if (clickPos && clickPos.inside > -1 && (0, $1LeRC.NodeSelection).isSelectable(view.state.doc.nodeAt(clickPos.inside))) return false;
    view.dispatch(view.state.tr.setSelection(new $b06b087e5c2a3bdd$export$3d3d259665dcb4d4($pos)));
    return true;
}
// This is a hack that, when a composition starts while a gap cursor
// is active, quickly creates an inline context for the composition to
// happen in, to avoid it being aborted by the DOM selection being
// moved into a valid position.
function $b06b087e5c2a3bdd$var$beforeinput(view, event) {
    if (event.inputType != "insertCompositionText" || !(view.state.selection instanceof $b06b087e5c2a3bdd$export$3d3d259665dcb4d4)) return false;
    let { $from: $from } = view.state.selection;
    let insert = $from.parent.contentMatchAt($from.index()).findWrapping(view.state.schema.nodes.text);
    if (!insert) return false;
    let frag = (0, $1krlL.Fragment).empty;
    for(let i = insert.length - 1; i >= 0; i--)frag = (0, $1krlL.Fragment).from(insert[i].createAndFill(null, frag));
    let tr = view.state.tr.replace($from.pos, $from.pos, new (0, $1krlL.Slice)(frag, 0, 0));
    tr.setSelection((0, $1LeRC.TextSelection).near(tr.doc.resolve($from.pos + 1)));
    view.dispatch(tr);
    return false;
}
function $b06b087e5c2a3bdd$var$drawGapCursor(state) {
    if (!(state.selection instanceof $b06b087e5c2a3bdd$export$3d3d259665dcb4d4)) return null;
    let node = document.createElement("div");
    node.className = "ProseMirror-gapcursor";
    return (0, $edQEX.DecorationSet).create(state.doc, [
        (0, $edQEX.Decoration).widget(state.selection.head, node, {
            key: "gapcursor"
        })
    ]);
}

});



parcelRegister("k7DD8", function(module, exports) {

$parcel$export(module.exports, "HardBreak", () => $ea6333d2d29ed452$export$d3d3fac13fa635d9);

var $gkCGf = parcelRequire("gkCGf");
/**
 * This extension allows you to insert hard breaks.
 * @see https://www.tiptap.dev/api/nodes/hard-break
 */ const $ea6333d2d29ed452$export$d3d3fac13fa635d9 = (0, $gkCGf.Node).create({
    name: 'hardBreak',
    addOptions () {
        return {
            keepMarks: true,
            HTMLAttributes: {}
        };
    },
    inline: true,
    group: 'inline',
    selectable: false,
    linebreakReplacement: true,
    parseHTML () {
        return [
            {
                tag: 'br'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'br',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes)
        ];
    },
    renderText () {
        return '\n';
    },
    addCommands () {
        return {
            setHardBreak: ()=>({ commands: commands, chain: chain, state: state, editor: editor })=>{
                    return commands.first([
                        ()=>commands.exitCode(),
                        ()=>commands.command(()=>{
                                const { selection: selection, storedMarks: storedMarks } = state;
                                if (selection.$from.parent.type.spec.isolating) return false;
                                const { keepMarks: keepMarks } = this.options;
                                const { splittableMarks: splittableMarks } = editor.extensionManager;
                                const marks = storedMarks || selection.$to.parentOffset && selection.$from.marks();
                                return chain().insertContent({
                                    type: this.name
                                }).command(({ tr: tr, dispatch: dispatch })=>{
                                    if (dispatch && marks && keepMarks) {
                                        const filteredMarks = marks.filter((mark)=>splittableMarks.includes(mark.type.name));
                                        tr.ensureMarks(filteredMarks);
                                    }
                                    return true;
                                }).run();
                            })
                    ]);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Enter': ()=>this.editor.commands.setHardBreak(),
            'Shift-Enter': ()=>this.editor.commands.setHardBreak()
        };
    }
});

});

parcelRegister("4w6kx", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $349f0fa639d26eec$export$a8a3e93435678ff9);

var $gkCGf = parcelRequire("gkCGf");
/**
 * This extension allows you to create headings.
 * @see https://www.tiptap.dev/api/nodes/heading
 */ const $349f0fa639d26eec$export$a8a3e93435678ff9 = (0, $gkCGf.Node).create({
    name: 'heading',
    addOptions () {
        return {
            levels: [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            HTMLAttributes: {}
        };
    },
    content: 'inline*',
    group: 'block',
    defining: true,
    addAttributes () {
        return {
            level: {
                default: 1,
                rendered: false
            }
        };
    },
    parseHTML () {
        return this.options.levels.map((level)=>({
                tag: `h${level}`,
                attrs: {
                    level: level
                }
            }));
    },
    renderHTML ({ node: node, HTMLAttributes: HTMLAttributes }) {
        const hasLevel = this.options.levels.includes(node.attrs.level);
        const level = hasLevel ? node.attrs.level : this.options.levels[0];
        return [
            `h${level}`,
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.setNode(this.name, attributes);
                },
            toggleHeading: (attributes)=>({ commands: commands })=>{
                    if (!this.options.levels.includes(attributes.level)) return false;
                    return commands.toggleNode(this.name, 'paragraph', attributes);
                }
        };
    },
    addKeyboardShortcuts () {
        return this.options.levels.reduce((items, level)=>({
                ...items,
                [`Mod-Alt-${level}`]: ()=>this.editor.commands.toggleHeading({
                        level: level
                    })
            }), {});
    },
    addInputRules () {
        return this.options.levels.map((level)=>{
            return (0, $gkCGf.textblockTypeInputRule)({
                find: new RegExp(`^(#{${Math.min(...this.options.levels)},${level}})\\s$`),
                type: this.type,
                getAttributes: {
                    level: level
                }
            });
        });
    }
});

});

parcelRegister("luyzA", function(module, exports) {

$parcel$export(module.exports, "History", () => $fa5737cb756d0d98$export$84202caead5689ba);

var $gkCGf = parcelRequire("gkCGf");
parcelRequire("7sCP3");
var $1WaCX = parcelRequire("1WaCX");
/**
 * This extension allows you to undo and redo recent changes.
 * @see https://www.tiptap.dev/api/extensions/history
 *
 * **Important**: If the `@tiptap/extension-collaboration` package is used, make sure to remove
 * the `history` extension, as it is not compatible with the `collaboration` extension.
 *
 * `@tiptap/extension-collaboration` uses its own history implementation.
 */ const $fa5737cb756d0d98$export$84202caead5689ba = (0, $gkCGf.Extension).create({
    name: 'history',
    addOptions () {
        return {
            depth: 100,
            newGroupDelay: 500
        };
    },
    addCommands () {
        return {
            undo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $1WaCX.undo)(state, dispatch);
                },
            redo: ()=>({ state: state, dispatch: dispatch })=>{
                    return (0, $1WaCX.redo)(state, dispatch);
                }
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $1WaCX.history)(this.options)
        ];
    },
    addKeyboardShortcuts () {
        return {
            'Mod-z': ()=>this.editor.commands.undo(),
            'Shift-Mod-z': ()=>this.editor.commands.redo(),
            'Mod-y': ()=>this.editor.commands.redo(),
            // Russian keyboard layouts
            "Mod-\u044F": ()=>this.editor.commands.undo(),
            "Shift-Mod-\u044F": ()=>this.editor.commands.redo()
        };
    }
});

});
parcelRegister("7sCP3", function(module, exports) {
$parcel$export(module.exports, "history", () => (parcelRequire("1WaCX")).history);
$parcel$export(module.exports, "redo", () => (parcelRequire("1WaCX")).redo);
$parcel$export(module.exports, "undo", () => (parcelRequire("1WaCX")).undo);
// history/index.ts
parcelRequire("1WaCX");

});
parcelRegister("1WaCX", function(module, exports) {

$parcel$export(module.exports, "history", () => $16937392103b9646$export$55abd4691b317664);
$parcel$export(module.exports, "undo", () => $16937392103b9646$export$21f930c44940fd98);
$parcel$export(module.exports, "redo", () => $16937392103b9646$export$1688e416fee0a49e);

var $i65BY = parcelRequire("i65BY");

var $gfgdn = parcelRequire("gfgdn");

var $1LeRC = parcelRequire("1LeRC");
// ProseMirror's history isn't simply a way to roll back to a previous
// state, because ProseMirror supports applying changes without adding
// them to the history (for example during collaboration).
//
// To this end, each 'Branch' (one for the undo history and one for
// the redo history) keeps an array of 'Items', which can optionally
// hold a step (an actual undoable change), and always hold a position
// map (which is needed to move changes below them to apply to the
// current document).
//
// An item that has both a step and a selection bookmark is the start
// of an 'event' — a group of changes that will be undone or redone at
// once. (It stores only the bookmark, since that way we don't have to
// provide a document until the selection is actually applied, which
// is useful when compressing.)
// Used to schedule history compression
const $16937392103b9646$var$max_empty_items = 500;
class $16937392103b9646$var$Branch {
    constructor(items, eventCount){
        this.items = items;
        this.eventCount = eventCount;
    }
    // Pop the latest event off the branch's history and apply it
    // to a document transform.
    popEvent(state, preserveItems) {
        if (this.eventCount == 0) return null;
        let end = this.items.length;
        for(;; end--){
            let next = this.items.get(end - 1);
            if (next.selection) {
                --end;
                break;
            }
        }
        let remap, mapFrom;
        if (preserveItems) {
            remap = this.remapping(end, this.items.length);
            mapFrom = remap.maps.length;
        }
        let transform = state.tr;
        let selection, remaining;
        let addAfter = [], addBefore = [];
        this.items.forEach((item, i)=>{
            if (!item.step) {
                if (!remap) {
                    remap = this.remapping(end, i + 1);
                    mapFrom = remap.maps.length;
                }
                mapFrom--;
                addBefore.push(item);
                return;
            }
            if (remap) {
                addBefore.push(new $16937392103b9646$var$Item(item.map));
                let step = item.step.map(remap.slice(mapFrom)), map;
                if (step && transform.maybeStep(step).doc) {
                    map = transform.mapping.maps[transform.mapping.maps.length - 1];
                    addAfter.push(new $16937392103b9646$var$Item(map, undefined, undefined, addAfter.length + addBefore.length));
                }
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
            } else transform.maybeStep(item.step);
            if (item.selection) {
                selection = remap ? item.selection.map(remap.slice(mapFrom)) : item.selection;
                remaining = new $16937392103b9646$var$Branch(this.items.slice(0, end).append(addBefore.reverse().concat(addAfter)), this.eventCount - 1);
                return false;
            }
        }, this.items.length, 0);
        return {
            remaining: remaining,
            transform: transform,
            selection: selection
        };
    }
    // Create a new branch with the given transform added.
    addTransform(transform, selection, histOptions, preserveItems) {
        let newItems = [], eventCount = this.eventCount;
        let oldItems = this.items, lastItem = !preserveItems && oldItems.length ? oldItems.get(oldItems.length - 1) : null;
        for(let i = 0; i < transform.steps.length; i++){
            let step = transform.steps[i].invert(transform.docs[i]);
            let item = new $16937392103b9646$var$Item(transform.mapping.maps[i], step, selection), merged;
            if (merged = lastItem && lastItem.merge(item)) {
                item = merged;
                if (i) newItems.pop();
                else oldItems = oldItems.slice(0, oldItems.length - 1);
            }
            newItems.push(item);
            if (selection) {
                eventCount++;
                selection = undefined;
            }
            if (!preserveItems) lastItem = item;
        }
        let overflow = eventCount - histOptions.depth;
        if (overflow > $16937392103b9646$var$DEPTH_OVERFLOW) {
            oldItems = $16937392103b9646$var$cutOffEvents(oldItems, overflow);
            eventCount -= overflow;
        }
        return new $16937392103b9646$var$Branch(oldItems.append(newItems), eventCount);
    }
    remapping(from, to) {
        let maps = new (0, $gfgdn.Mapping);
        this.items.forEach((item, i)=>{
            let mirrorPos = item.mirrorOffset != null && i - item.mirrorOffset >= from ? maps.maps.length - item.mirrorOffset : undefined;
            maps.appendMap(item.map, mirrorPos);
        }, from, to);
        return maps;
    }
    addMaps(array) {
        if (this.eventCount == 0) return this;
        return new $16937392103b9646$var$Branch(this.items.append(array.map((map)=>new $16937392103b9646$var$Item(map))), this.eventCount);
    }
    // When the collab module receives remote changes, the history has
    // to know about those, so that it can adjust the steps that were
    // rebased on top of the remote changes, and include the position
    // maps for the remote changes in its array of items.
    rebased(rebasedTransform, rebasedCount) {
        if (!this.eventCount) return this;
        let rebasedItems = [], start = Math.max(0, this.items.length - rebasedCount);
        let mapping = rebasedTransform.mapping;
        let newUntil = rebasedTransform.steps.length;
        let eventCount = this.eventCount;
        this.items.forEach((item)=>{
            if (item.selection) eventCount--;
        }, start);
        let iRebased = rebasedCount;
        this.items.forEach((item)=>{
            let pos = mapping.getMirror(--iRebased);
            if (pos == null) return;
            newUntil = Math.min(newUntil, pos);
            let map = mapping.maps[pos];
            if (item.step) {
                let step = rebasedTransform.steps[pos].invert(rebasedTransform.docs[pos]);
                let selection = item.selection && item.selection.map(mapping.slice(iRebased + 1, pos));
                if (selection) eventCount++;
                rebasedItems.push(new $16937392103b9646$var$Item(map, step, selection));
            } else rebasedItems.push(new $16937392103b9646$var$Item(map));
        }, start);
        let newMaps = [];
        for(let i = rebasedCount; i < newUntil; i++)newMaps.push(new $16937392103b9646$var$Item(mapping.maps[i]));
        let items = this.items.slice(0, start).append(newMaps).append(rebasedItems);
        let branch = new $16937392103b9646$var$Branch(items, eventCount);
        if (branch.emptyItemCount() > $16937392103b9646$var$max_empty_items) branch = branch.compress(this.items.length - rebasedItems.length);
        return branch;
    }
    emptyItemCount() {
        let count = 0;
        this.items.forEach((item)=>{
            if (!item.step) count++;
        });
        return count;
    }
    // Compressing a branch means rewriting it to push the air (map-only
    // items) out. During collaboration, these naturally accumulate
    // because each remote change adds one. The `upto` argument is used
    // to ensure that only the items below a given level are compressed,
    // because `rebased` relies on a clean, untouched set of items in
    // order to associate old items with rebased steps.
    compress(upto = this.items.length) {
        let remap = this.remapping(0, upto), mapFrom = remap.maps.length;
        let items = [], events = 0;
        this.items.forEach((item, i)=>{
            if (i >= upto) {
                items.push(item);
                if (item.selection) events++;
            } else if (item.step) {
                let step = item.step.map(remap.slice(mapFrom)), map = step && step.getMap();
                mapFrom--;
                if (map) remap.appendMap(map, mapFrom);
                if (step) {
                    let selection = item.selection && item.selection.map(remap.slice(mapFrom));
                    if (selection) events++;
                    let newItem = new $16937392103b9646$var$Item(map.invert(), step, selection), merged, last = items.length - 1;
                    if (merged = items.length && items[last].merge(newItem)) items[last] = merged;
                    else items.push(newItem);
                }
            } else if (item.map) mapFrom--;
        }, this.items.length, 0);
        return new $16937392103b9646$var$Branch((0, $i65BY.default).from(items.reverse()), events);
    }
}
$16937392103b9646$var$Branch.empty = new $16937392103b9646$var$Branch((0, $i65BY.default).empty, 0);
function $16937392103b9646$var$cutOffEvents(items, n) {
    let cutPoint;
    items.forEach((item, i)=>{
        if (item.selection && n-- == 0) {
            cutPoint = i;
            return false;
        }
    });
    return items.slice(cutPoint);
}
class $16937392103b9646$var$Item {
    constructor(// The (forward) step map for this item.
    map, // The inverted step
    step, // If this is non-null, this item is the start of a group, and
    // this selection is the starting selection for the group (the one
    // that was active before the first step was applied)
    selection, // If this item is the inverse of a previous mapping on the stack,
    // this points at the inverse's offset
    mirrorOffset){
        this.map = map;
        this.step = step;
        this.selection = selection;
        this.mirrorOffset = mirrorOffset;
    }
    merge(other) {
        if (this.step && other.step && !other.selection) {
            let step = other.step.merge(this.step);
            if (step) return new $16937392103b9646$var$Item(step.getMap().invert(), step, this.selection);
        }
    }
}
// The value of the state field that tracks undo/redo history for that
// state. Will be stored in the plugin state when the history plugin
// is active.
class $16937392103b9646$var$HistoryState {
    constructor(done, undone, prevRanges, prevTime, prevComposition){
        this.done = done;
        this.undone = undone;
        this.prevRanges = prevRanges;
        this.prevTime = prevTime;
        this.prevComposition = prevComposition;
    }
}
const $16937392103b9646$var$DEPTH_OVERFLOW = 20;
// Record a transformation in undo history.
function $16937392103b9646$var$applyTransaction(history, state, tr, options) {
    let historyTr = tr.getMeta($16937392103b9646$var$historyKey), rebased;
    if (historyTr) return historyTr.historyState;
    if (tr.getMeta($16937392103b9646$var$closeHistoryKey)) history = new $16937392103b9646$var$HistoryState(history.done, history.undone, null, 0, -1);
    let appended = tr.getMeta("appendedTransaction");
    if (tr.steps.length == 0) return history;
    else if (appended && appended.getMeta($16937392103b9646$var$historyKey)) {
        if (appended.getMeta($16937392103b9646$var$historyKey).redo) return new $16937392103b9646$var$HistoryState(history.done.addTransform(tr, undefined, options, $16937392103b9646$var$mustPreserveItems(state)), history.undone, $16937392103b9646$var$rangesFor(tr.mapping.maps), history.prevTime, history.prevComposition);
        else return new $16937392103b9646$var$HistoryState(history.done, history.undone.addTransform(tr, undefined, options, $16937392103b9646$var$mustPreserveItems(state)), null, history.prevTime, history.prevComposition);
    } else if (tr.getMeta("addToHistory") !== false && !(appended && appended.getMeta("addToHistory") === false)) {
        // Group transforms that occur in quick succession into one event.
        let composition = tr.getMeta("composition");
        let newGroup = history.prevTime == 0 || !appended && history.prevComposition != composition && (history.prevTime < (tr.time || 0) - options.newGroupDelay || !$16937392103b9646$var$isAdjacentTo(tr, history.prevRanges));
        let prevRanges = appended ? $16937392103b9646$var$mapRanges(history.prevRanges, tr.mapping) : $16937392103b9646$var$rangesFor(tr.mapping.maps);
        return new $16937392103b9646$var$HistoryState(history.done.addTransform(tr, newGroup ? state.selection.getBookmark() : undefined, options, $16937392103b9646$var$mustPreserveItems(state)), $16937392103b9646$var$Branch.empty, prevRanges, tr.time, composition == null ? history.prevComposition : composition);
    } else if (rebased = tr.getMeta("rebased")) // Used by the collab module to tell the history that some of its
    // content has been rebased.
    return new $16937392103b9646$var$HistoryState(history.done.rebased(tr, rebased), history.undone.rebased(tr, rebased), $16937392103b9646$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
    else return new $16937392103b9646$var$HistoryState(history.done.addMaps(tr.mapping.maps), history.undone.addMaps(tr.mapping.maps), $16937392103b9646$var$mapRanges(history.prevRanges, tr.mapping), history.prevTime, history.prevComposition);
}
function $16937392103b9646$var$isAdjacentTo(transform, prevRanges) {
    if (!prevRanges) return false;
    if (!transform.docChanged) return true;
    let adjacent = false;
    transform.mapping.maps[0].forEach((start, end)=>{
        for(let i = 0; i < prevRanges.length; i += 2)if (start <= prevRanges[i + 1] && end >= prevRanges[i]) adjacent = true;
    });
    return adjacent;
}
function $16937392103b9646$var$rangesFor(maps) {
    let result = [];
    for(let i = maps.length - 1; i >= 0 && result.length == 0; i--)maps[i].forEach((_from, _to, from, to)=>result.push(from, to));
    return result;
}
function $16937392103b9646$var$mapRanges(ranges, mapping) {
    if (!ranges) return null;
    let result = [];
    for(let i = 0; i < ranges.length; i += 2){
        let from = mapping.map(ranges[i], 1), to = mapping.map(ranges[i + 1], -1);
        if (from <= to) result.push(from, to);
    }
    return result;
}
// Apply the latest event from one branch to the document and shift the event
// onto the other branch.
function $16937392103b9646$var$histTransaction(history, state, redo) {
    let preserveItems = $16937392103b9646$var$mustPreserveItems(state);
    let histOptions = $16937392103b9646$var$historyKey.get(state).spec.config;
    let pop = (redo ? history.undone : history.done).popEvent(state, preserveItems);
    if (!pop) return null;
    let selection = pop.selection.resolve(pop.transform.doc);
    let added = (redo ? history.done : history.undone).addTransform(pop.transform, state.selection.getBookmark(), histOptions, preserveItems);
    let newHist = new $16937392103b9646$var$HistoryState(redo ? added : pop.remaining, redo ? pop.remaining : added, null, 0, -1);
    return pop.transform.setSelection(selection).setMeta($16937392103b9646$var$historyKey, {
        redo: redo,
        historyState: newHist
    });
}
let $16937392103b9646$var$cachedPreserveItems = false, $16937392103b9646$var$cachedPreserveItemsPlugins = null;
// Check whether any plugin in the given state has a
// `historyPreserveItems` property in its spec, in which case we must
// preserve steps exactly as they came in, so that they can be
// rebased.
function $16937392103b9646$var$mustPreserveItems(state) {
    let plugins = state.plugins;
    if ($16937392103b9646$var$cachedPreserveItemsPlugins != plugins) {
        $16937392103b9646$var$cachedPreserveItems = false;
        $16937392103b9646$var$cachedPreserveItemsPlugins = plugins;
        for(let i = 0; i < plugins.length; i++)if (plugins[i].spec.historyPreserveItems) {
            $16937392103b9646$var$cachedPreserveItems = true;
            break;
        }
    }
    return $16937392103b9646$var$cachedPreserveItems;
}
/**
Set a flag on the given transaction that will prevent further steps
from being appended to an existing history event (so that they
require a separate undo command to undo).
*/ function $16937392103b9646$export$181a649d919c589e(tr) {
    return tr.setMeta($16937392103b9646$var$closeHistoryKey, true);
}
const $16937392103b9646$var$historyKey = new (0, $1LeRC.PluginKey)("history");
const $16937392103b9646$var$closeHistoryKey = new (0, $1LeRC.PluginKey)("closeHistory");
/**
Returns a plugin that enables the undo history for an editor. The
plugin will track undo and redo stacks, which can be used with the
[`undo`](https://prosemirror.net/docs/ref/#history.undo) and [`redo`](https://prosemirror.net/docs/ref/#history.redo) commands.

You can set an `"addToHistory"` [metadata
property](https://prosemirror.net/docs/ref/#state.Transaction.setMeta) of `false` on a transaction
to prevent it from being rolled back by undo.
*/ function $16937392103b9646$export$55abd4691b317664(config = {}) {
    config = {
        depth: config.depth || 100,
        newGroupDelay: config.newGroupDelay || 500
    };
    return new (0, $1LeRC.Plugin)({
        key: $16937392103b9646$var$historyKey,
        state: {
            init () {
                return new $16937392103b9646$var$HistoryState($16937392103b9646$var$Branch.empty, $16937392103b9646$var$Branch.empty, null, 0, -1);
            },
            apply (tr, hist, state) {
                return $16937392103b9646$var$applyTransaction(hist, state, tr, config);
            }
        },
        config: config,
        props: {
            handleDOMEvents: {
                beforeinput (view, e) {
                    let inputType = e.inputType;
                    let command = inputType == "historyUndo" ? $16937392103b9646$export$21f930c44940fd98 : inputType == "historyRedo" ? $16937392103b9646$export$1688e416fee0a49e : null;
                    if (!command) return false;
                    e.preventDefault();
                    return command(view.state, view.dispatch);
                }
            }
        }
    });
}
function $16937392103b9646$var$buildCommand(redo, scroll) {
    return (state, dispatch)=>{
        let hist = $16937392103b9646$var$historyKey.getState(state);
        if (!hist || (redo ? hist.undone : hist.done).eventCount == 0) return false;
        if (dispatch) {
            let tr = $16937392103b9646$var$histTransaction(hist, state, redo);
            if (tr) dispatch(scroll ? tr.scrollIntoView() : tr);
        }
        return true;
    };
}
/**
A command function that undoes the last change, if any.
*/ const $16937392103b9646$export$21f930c44940fd98 = $16937392103b9646$var$buildCommand(false, true);
/**
A command function that redoes the last undone change, if any.
*/ const $16937392103b9646$export$1688e416fee0a49e = $16937392103b9646$var$buildCommand(true, true);
/**
A command function that undoes the last change. Don't scroll the
selection into view.
*/ const $16937392103b9646$export$24b5d280435f3a3f = $16937392103b9646$var$buildCommand(false, false);
/**
A command function that redoes the last undone change. Don't
scroll the selection into view.
*/ const $16937392103b9646$export$3774e54bae7be19b = $16937392103b9646$var$buildCommand(true, false);
/**
The amount of undoable events available in a given state.
*/ function $16937392103b9646$export$f8a176c2b9a10bdb(state) {
    let hist = $16937392103b9646$var$historyKey.getState(state);
    return hist ? hist.done.eventCount : 0;
}
/**
The amount of redoable events available in a given editor state.
*/ function $16937392103b9646$export$3ffe6b288e7d941b(state) {
    let hist = $16937392103b9646$var$historyKey.getState(state);
    return hist ? hist.undone.eventCount : 0;
}

});
parcelRegister("i65BY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2cd23df1a60c401$export$2e2bcd8739ae039);
var $d2cd23df1a60c401$var$GOOD_LEAF_SIZE = 200;
// :: class<T> A rope sequence is a persistent sequence data structure
// that supports appending, prepending, and slicing without doing a
// full copy. It is represented as a mostly-balanced tree.
var $d2cd23df1a60c401$var$RopeSequence = function RopeSequence() {};
$d2cd23df1a60c401$var$RopeSequence.prototype.append = function append(other) {
    if (!other.length) return this;
    other = $d2cd23df1a60c401$var$RopeSequence.from(other);
    return !this.length && other || other.length < $d2cd23df1a60c401$var$GOOD_LEAF_SIZE && this.leafAppend(other) || this.length < $d2cd23df1a60c401$var$GOOD_LEAF_SIZE && other.leafPrepend(this) || this.appendInner(other);
};
// :: (union<[T], RopeSequence<T>>) → RopeSequence<T>
// Prepend an array or other rope to this one, returning a new rope.
$d2cd23df1a60c401$var$RopeSequence.prototype.prepend = function prepend(other) {
    if (!other.length) return this;
    return $d2cd23df1a60c401$var$RopeSequence.from(other).append(this);
};
$d2cd23df1a60c401$var$RopeSequence.prototype.appendInner = function appendInner(other) {
    return new $d2cd23df1a60c401$var$Append(this, other);
};
// :: (?number, ?number) → RopeSequence<T>
// Create a rope repesenting a sub-sequence of this rope.
$d2cd23df1a60c401$var$RopeSequence.prototype.slice = function slice(from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from >= to) return $d2cd23df1a60c401$var$RopeSequence.empty;
    return this.sliceInner(Math.max(0, from), Math.min(this.length, to));
};
// :: (number) → T
// Retrieve the element at the given position from this rope.
$d2cd23df1a60c401$var$RopeSequence.prototype.get = function get(i) {
    if (i < 0 || i >= this.length) return undefined;
    return this.getInner(i);
};
// :: ((element: T, index: number) → ?bool, ?number, ?number)
// Call the given function for each element between the given
// indices. This tends to be more efficient than looping over the
// indices and calling `get`, because it doesn't have to descend the
// tree for every element.
$d2cd23df1a60c401$var$RopeSequence.prototype.forEach = function forEach(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    if (from <= to) this.forEachInner(f, from, to, 0);
    else this.forEachInvertedInner(f, from, to, 0);
};
// :: ((element: T, index: number) → U, ?number, ?number) → [U]
// Map the given functions over the elements of the rope, producing
// a flat array.
$d2cd23df1a60c401$var$RopeSequence.prototype.map = function map(f, from, to) {
    if (from === void 0) from = 0;
    if (to === void 0) to = this.length;
    var result = [];
    this.forEach(function(elt, i) {
        return result.push(f(elt, i));
    }, from, to);
    return result;
};
// :: (?union<[T], RopeSequence<T>>) → RopeSequence<T>
// Create a rope representing the given array, or return the rope
// itself if a rope was given.
$d2cd23df1a60c401$var$RopeSequence.from = function from(values) {
    if (values instanceof $d2cd23df1a60c401$var$RopeSequence) return values;
    return values && values.length ? new $d2cd23df1a60c401$var$Leaf(values) : $d2cd23df1a60c401$var$RopeSequence.empty;
};
var $d2cd23df1a60c401$var$Leaf = /*@__PURE__*/ function(RopeSequence) {
    function Leaf(values) {
        RopeSequence.call(this);
        this.values = values;
    }
    if (RopeSequence) Leaf.__proto__ = RopeSequence;
    Leaf.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Leaf.prototype.constructor = Leaf;
    var prototypeAccessors = {
        length: {
            configurable: true
        },
        depth: {
            configurable: true
        }
    };
    Leaf.prototype.flatten = function flatten() {
        return this.values;
    };
    Leaf.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        return new Leaf(this.values.slice(from, to));
    };
    Leaf.prototype.getInner = function getInner(i) {
        return this.values[i];
    };
    Leaf.prototype.forEachInner = function forEachInner(f, from, to, start) {
        for(var i = from; i < to; i++){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        for(var i = from - 1; i >= to; i--){
            if (f(this.values[i], start + i) === false) return false;
        }
    };
    Leaf.prototype.leafAppend = function leafAppend(other) {
        if (this.length + other.length <= $d2cd23df1a60c401$var$GOOD_LEAF_SIZE) return new Leaf(this.values.concat(other.flatten()));
    };
    Leaf.prototype.leafPrepend = function leafPrepend(other) {
        if (this.length + other.length <= $d2cd23df1a60c401$var$GOOD_LEAF_SIZE) return new Leaf(other.flatten().concat(this.values));
    };
    prototypeAccessors.length.get = function() {
        return this.values.length;
    };
    prototypeAccessors.depth.get = function() {
        return 0;
    };
    Object.defineProperties(Leaf.prototype, prototypeAccessors);
    return Leaf;
}($d2cd23df1a60c401$var$RopeSequence);
// :: RopeSequence
// The empty rope sequence.
$d2cd23df1a60c401$var$RopeSequence.empty = new $d2cd23df1a60c401$var$Leaf([]);
var $d2cd23df1a60c401$var$Append = /*@__PURE__*/ function(RopeSequence) {
    function Append(left, right) {
        RopeSequence.call(this);
        this.left = left;
        this.right = right;
        this.length = left.length + right.length;
        this.depth = Math.max(left.depth, right.depth) + 1;
    }
    if (RopeSequence) Append.__proto__ = RopeSequence;
    Append.prototype = Object.create(RopeSequence && RopeSequence.prototype);
    Append.prototype.constructor = Append;
    Append.prototype.flatten = function flatten() {
        return this.left.flatten().concat(this.right.flatten());
    };
    Append.prototype.getInner = function getInner(i) {
        return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
    };
    Append.prototype.forEachInner = function forEachInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from < leftLen && this.left.forEachInner(f, from, Math.min(to, leftLen), start) === false) return false;
        if (to > leftLen && this.right.forEachInner(f, Math.max(from - leftLen, 0), Math.min(this.length, to) - leftLen, start + leftLen) === false) return false;
    };
    Append.prototype.forEachInvertedInner = function forEachInvertedInner(f, from, to, start) {
        var leftLen = this.left.length;
        if (from > leftLen && this.right.forEachInvertedInner(f, from - leftLen, Math.max(to, leftLen) - leftLen, start + leftLen) === false) return false;
        if (to < leftLen && this.left.forEachInvertedInner(f, Math.min(from, leftLen), to, start) === false) return false;
    };
    Append.prototype.sliceInner = function sliceInner(from, to) {
        if (from == 0 && to == this.length) return this;
        var leftLen = this.left.length;
        if (to <= leftLen) return this.left.slice(from, to);
        if (from >= leftLen) return this.right.slice(from - leftLen, to - leftLen);
        return this.left.slice(from, leftLen).append(this.right.slice(0, to - leftLen));
    };
    Append.prototype.leafAppend = function leafAppend(other) {
        var inner = this.right.leafAppend(other);
        if (inner) return new Append(this.left, inner);
    };
    Append.prototype.leafPrepend = function leafPrepend(other) {
        var inner = this.left.leafPrepend(other);
        if (inner) return new Append(inner, this.right);
    };
    Append.prototype.appendInner = function appendInner(other) {
        if (this.left.depth >= Math.max(this.right.depth, other.depth) + 1) return new Append(this.left, new Append(this.right, other));
        return new Append(this, other);
    };
    return Append;
}($d2cd23df1a60c401$var$RopeSequence);
var $d2cd23df1a60c401$export$2e2bcd8739ae039 = $d2cd23df1a60c401$var$RopeSequence;

});




parcelRegister("5G1It", function(module, exports) {

$parcel$export(module.exports, "Italic", () => $422234cfc13196b6$export$1cfcf4275506b1c6);

var $gkCGf = parcelRequire("gkCGf");
/**
 * Matches an italic to a *italic* on input.
 */ const $422234cfc13196b6$export$73ba4776eeca629e = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/;
/**
 * Matches an italic to a *italic* on paste.
 */ const $422234cfc13196b6$export$47b75d481b90409 = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g;
/**
 * Matches an italic to a _italic_ on input.
 */ const $422234cfc13196b6$export$79cd1d2695dae26d = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/;
/**
 * Matches an italic to a _italic_ on paste.
 */ const $422234cfc13196b6$export$9b623891dbc7bd12 = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g;
/**
 * This extension allows you to create italic text.
 * @see https://www.tiptap.dev/api/marks/italic
 */ const $422234cfc13196b6$export$1cfcf4275506b1c6 = (0, $gkCGf.Mark).create({
    name: 'italic',
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    parseHTML () {
        return [
            {
                tag: 'em'
            },
            {
                tag: 'i',
                getAttrs: (node)=>node.style.fontStyle !== 'normal' && null
            },
            {
                style: 'font-style=normal',
                clearMark: (mark)=>mark.type.name === this.name
            },
            {
                style: 'font-style=italic'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'em',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setItalic: ()=>({ commands: commands })=>{
                    return commands.setMark(this.name);
                },
            toggleItalic: ()=>({ commands: commands })=>{
                    return commands.toggleMark(this.name);
                },
            unsetItalic: ()=>({ commands: commands })=>{
                    return commands.unsetMark(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-i': ()=>this.editor.commands.toggleItalic(),
            'Mod-I': ()=>this.editor.commands.toggleItalic()
        };
    },
    addInputRules () {
        return [
            (0, $gkCGf.markInputRule)({
                find: $422234cfc13196b6$export$73ba4776eeca629e,
                type: this.type
            }),
            (0, $gkCGf.markInputRule)({
                find: $422234cfc13196b6$export$79cd1d2695dae26d,
                type: this.type
            })
        ];
    },
    addPasteRules () {
        return [
            (0, $gkCGf.markPasteRule)({
                find: $422234cfc13196b6$export$47b75d481b90409,
                type: this.type
            }),
            (0, $gkCGf.markPasteRule)({
                find: $422234cfc13196b6$export$9b623891dbc7bd12,
                type: this.type
            })
        ];
    }
});

});

parcelRegister("cabgp", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $8daf27f2875b04a8$export$a7b06bfba60a8a78);

var $gkCGf = parcelRequire("gkCGf");
/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */ const $8daf27f2875b04a8$export$a7b06bfba60a8a78 = (0, $gkCGf.Node).create({
    name: 'listItem',
    addOptions () {
        return {
            HTMLAttributes: {},
            bulletListTypeName: 'bulletList',
            orderedListTypeName: 'orderedList'
        };
    },
    content: 'paragraph block*',
    defining: true,
    parseHTML () {
        return [
            {
                tag: 'li'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'li',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addKeyboardShortcuts () {
        return {
            Enter: ()=>this.editor.commands.splitListItem(this.name),
            Tab: ()=>this.editor.commands.sinkListItem(this.name),
            'Shift-Tab': ()=>this.editor.commands.liftListItem(this.name)
        };
    }
});

});

parcelRegister("dzWv6", function(module, exports) {

$parcel$export(module.exports, "Paragraph", () => $9e2bec406bc918cd$export$358a232cca1ab2ac);

var $gkCGf = parcelRequire("gkCGf");
/**
 * This extension allows you to create paragraphs.
 * @see https://www.tiptap.dev/api/nodes/paragraph
 */ const $9e2bec406bc918cd$export$358a232cca1ab2ac = (0, $gkCGf.Node).create({
    name: 'paragraph',
    priority: 1000,
    addOptions () {
        return {
            HTMLAttributes: {}
        };
    },
    group: 'block',
    content: 'inline*',
    parseHTML () {
        return [
            {
                tag: 'p'
            }
        ];
    },
    renderHTML ({ HTMLAttributes: HTMLAttributes }) {
        return [
            'p',
            (0, $gkCGf.mergeAttributes)(this.options.HTMLAttributes, HTMLAttributes),
            0
        ];
    },
    addCommands () {
        return {
            setParagraph: ()=>({ commands: commands })=>{
                    return commands.setNode(this.name);
                }
        };
    },
    addKeyboardShortcuts () {
        return {
            'Mod-Alt-0': ()=>this.editor.commands.setParagraph()
        };
    }
});

});

parcelRegister("hirCw", function(module, exports) {

$parcel$export(module.exports, "Text", () => $c9798af43a358308$export$5f1af8db9871e1d6);

var $gkCGf = parcelRequire("gkCGf");
/**
 * This extension allows you to create text nodes.
 * @see https://www.tiptap.dev/api/nodes/text
 */ const $c9798af43a358308$export$5f1af8db9871e1d6 = (0, $gkCGf.Node).create({
    name: 'text',
    group: 'inline'
});

});


parcelRegister("1zXqe", function(module, exports) {

$parcel$export(module.exports, "default", () => $12672754d4794564$export$2e2bcd8739ae039);

var $gkCGf = parcelRequire("gkCGf");

var $4WF04 = parcelRequire("4WF04");
// Simple renderer without external libs
function $12672754d4794564$var$renderSuggestionList() {
    let popup = null;
    const createPopup = (props)=>{
        const { clientRect: clientRect } = props;
        const container = document.createElement('div');
        container.className = 'bg-white border border-gray-200 rounded shadow-md text-sm text-gray-700 max-h-60 overflow-y-auto';
        container.style.position = 'absolute';
        container.style.zIndex = '1000';
        positionPopup(container, clientRect);
        document.body.appendChild(container);
        return container;
    };
    const positionPopup = (container, clientRect)=>{
        if (!clientRect) return;
        const { top: top, left: left, height: height } = clientRect();
        container.style.top = `${top + height + window.scrollY}px`;
        container.style.left = `${left + window.scrollX}px`;
    };
    const onStart = (props)=>{
        popup = createPopup(props);
        updateList(props);
    };
    const onUpdate = (props)=>{
        updateList(props);
        positionPopup(popup, props.clientRect);
    };
    const onKeyDown = (props)=>{
        if (props.event.key === 'Escape') {
            onExit();
            return true;
        }
        const items = Array.from(popup.querySelectorAll('button'));
        let currentIndex = items.findIndex((i)=>i.classList.contains('bg-gray-100'));
        if (props.event.key === 'ArrowDown') {
            currentIndex = (currentIndex + 1) % items.length;
            highlight(items, currentIndex);
            return true;
        }
        if (props.event.key === 'ArrowUp') {
            currentIndex = (currentIndex - 1 + items.length) % items.length;
            highlight(items, currentIndex);
            return true;
        }
        if (props.event.key === 'Enter') {
            if (currentIndex >= 0) {
                items[currentIndex].click();
                return true;
            }
        }
        return false;
    };
    const onExit = ()=>{
        if (popup) {
            popup.remove();
            popup = null;
        }
    };
    function updateList(props) {
        const { items: items, command: command } = props;
        popup.innerHTML = '';
        items.forEach((item, index)=>{
            const btn = document.createElement('button');
            btn.type = 'button';
            const clean = item.label.replace(/^\s*\{\{\s*/, '').replace(/\s*\}\}\s*$/, '');
            btn.innerHTML = `<span class="text-indigo-500">{{</span><span class="mx-1">${clean}</span><span class="text-indigo-500">}}</span>`;
            btn.className = 'flex items-center gap-0 w-full px-3 py-1 text-left hover:bg-indigo-50 hover:text-indigo-600';
            if (index === 0) btn.classList.add('bg-gray-100');
            btn.addEventListener('click', ()=>command(item));
            popup.appendChild(btn);
        });
    }
    function highlight(items, index) {
        items.forEach((i)=>i.classList.remove('bg-gray-100'));
        items[index].classList.add('bg-gray-100');
        items[index].scrollIntoView({
            block: 'nearest'
        });
    }
    return {
        onStart: onStart,
        onUpdate: onUpdate,
        onKeyDown: onKeyDown,
        onExit: onExit
    };
}
const $12672754d4794564$var$VariableSuggestion = (0, $gkCGf.Extension).create({
    name: 'variableSuggestion',
    addOptions () {
        return {
            variables: [],
            char: '{'
        };
    },
    addProseMirrorPlugins () {
        return [
            (0, $4WF04.default)({
                char: this.options.char,
                startOfLine: false,
                allowSpaces: false,
                editor: this.editor,
                items: ({ query: query })=>{
                    return this.options.variables.filter((v)=>v.toLowerCase().includes(query.toLowerCase())).slice(0, 20).map((v)=>({
                            label: v
                        }));
                },
                command: ({ editor: editor, range: range, props: props })=>{
                    let content = props.label.trim();
                    if (!content.startsWith('{{')) content = `{{ ${content} }}`;
                    editor.chain().focus().insertContentAt(range, content).run();
                },
                render: $12672754d4794564$var$renderSuggestionList
            })
        ];
    }
});
var $12672754d4794564$export$2e2bcd8739ae039 = $12672754d4794564$var$VariableSuggestion;

});
parcelRegister("4WF04", function(module, exports) {

$parcel$export(module.exports, "default", () => $399c61f74c68e54b$export$e88208c327ffe234);
parcelRequire("7fRs0");
var $1LeRC = parcelRequire("1LeRC");
parcelRequire("cXOg4");
var $edQEX = parcelRequire("edQEX");

var $gkCGf = parcelRequire("gkCGf");
function $399c61f74c68e54b$export$f7cfb3ba7349a641(config) {
    var _a;
    const { char: char, allowSpaces: allowSpacesOption, allowToIncludeChar: allowToIncludeChar, allowedPrefixes: allowedPrefixes, startOfLine: startOfLine, $position: $position } = config;
    const allowSpaces = allowSpacesOption && !allowToIncludeChar;
    const escapedChar = (0, $gkCGf.escapeForRegEx)(char);
    const suffix = new RegExp(`\\s${escapedChar}$`);
    const prefix = startOfLine ? '^' : '';
    const finalEscapedChar = allowToIncludeChar ? '' : escapedChar;
    const regexp = allowSpaces ? new RegExp(`${prefix}${escapedChar}.*?(?=\\s${finalEscapedChar}|$)`, 'gm') : new RegExp(`${prefix}(?:^)?${escapedChar}[^\\s${finalEscapedChar}]*`, 'gm');
    const text = ((_a = $position.nodeBefore) === null || _a === void 0 ? void 0 : _a.isText) && $position.nodeBefore.text;
    if (!text) return null;
    const textFrom = $position.pos - text.length;
    const match = Array.from(text.matchAll(regexp)).pop();
    if (!match || match.input === undefined || match.index === undefined) return null;
    // JavaScript doesn't have lookbehinds. This hacks a check that first character
    // is a space or the start of the line
    const matchPrefix = match.input.slice(Math.max(0, match.index - 1), match.index);
    const matchPrefixIsAllowed = new RegExp(`^[${allowedPrefixes === null || allowedPrefixes === void 0 ? void 0 : allowedPrefixes.join('')}\0]?$`).test(matchPrefix);
    if (allowedPrefixes !== null && !matchPrefixIsAllowed) return null;
    // The absolute position of the match in the document
    const from = textFrom + match.index;
    let to = from + match[0].length;
    // Edge case handling; if spaces are allowed and we're directly in between
    // two triggers
    if (allowSpaces && suffix.test(text.slice(to - 1, to + 1))) {
        match[0] += ' ';
        to += 1;
    }
    // If the $position is located within the matched substring, return that range
    if (from < $position.pos && to >= $position.pos) return {
        range: {
            from: from,
            to: to
        },
        query: match[0].slice(char.length),
        text: match[0]
    };
    return null;
}
const $399c61f74c68e54b$export$14a9e419a6a9b699 = new (0, $1LeRC.PluginKey)('suggestion');
/**
 * This utility allows you to create suggestions.
 * @see https://tiptap.dev/api/utilities/suggestion
 */ function $399c61f74c68e54b$export$e88208c327ffe234({ pluginKey: pluginKey = $399c61f74c68e54b$export$14a9e419a6a9b699, editor: editor, char: char = '@', allowSpaces: allowSpaces = false, allowToIncludeChar: allowToIncludeChar = false, allowedPrefixes: allowedPrefixes = [
    ' '
], startOfLine: startOfLine = false, decorationTag: decorationTag = 'span', decorationClass: decorationClass = 'suggestion', command: command = ()=>null, items: items = ()=>[], render: render = ()=>({}), allow: allow = ()=>true, findSuggestionMatch: findSuggestionMatch$1 = $399c61f74c68e54b$export$f7cfb3ba7349a641 }) {
    let props;
    const renderer = render === null || render === void 0 ? void 0 : render();
    const plugin = new (0, $1LeRC.Plugin)({
        key: pluginKey,
        view () {
            return {
                update: async (view, prevState)=>{
                    var _a, _b, _c, _d, _e, _f, _g;
                    const prev = (_a = this.key) === null || _a === void 0 ? void 0 : _a.getState(prevState);
                    const next = (_b = this.key) === null || _b === void 0 ? void 0 : _b.getState(view.state);
                    // See how the state changed
                    const moved = prev.active && next.active && prev.range.from !== next.range.from;
                    const started = !prev.active && next.active;
                    const stopped = prev.active && !next.active;
                    const changed = !started && !stopped && prev.query !== next.query;
                    const handleStart = started || moved && changed;
                    const handleChange = changed || moved;
                    const handleExit = stopped || moved && changed;
                    // Cancel when suggestion isn't active
                    if (!handleStart && !handleChange && !handleExit) return;
                    const state = handleExit && !handleStart ? prev : next;
                    const decorationNode = view.dom.querySelector(`[data-decoration-id="${state.decorationId}"]`);
                    props = {
                        editor: editor,
                        range: state.range,
                        query: state.query,
                        text: state.text,
                        items: [],
                        command: (commandProps)=>{
                            return command({
                                editor: editor,
                                range: state.range,
                                props: commandProps
                            });
                        },
                        decorationNode: decorationNode,
                        // virtual node for popper.js or tippy.js
                        // this can be used for building popups without a DOM node
                        clientRect: decorationNode ? ()=>{
                            var _a;
                            // because of `items` can be asynchrounous we’ll search for the current decoration node
                            const { decorationId: decorationId } = (_a = this.key) === null || _a === void 0 ? void 0 : _a.getState(editor.state); // eslint-disable-line
                            const currentDecorationNode = view.dom.querySelector(`[data-decoration-id="${decorationId}"]`);
                            return (currentDecorationNode === null || currentDecorationNode === void 0 ? void 0 : currentDecorationNode.getBoundingClientRect()) || null;
                        } : null
                    };
                    if (handleStart) (_c = renderer === null || renderer === void 0 ? void 0 : renderer.onBeforeStart) === null || _c === void 0 || _c.call(renderer, props);
                    if (handleChange) (_d = renderer === null || renderer === void 0 ? void 0 : renderer.onBeforeUpdate) === null || _d === void 0 || _d.call(renderer, props);
                    if (handleChange || handleStart) props.items = await items({
                        editor: editor,
                        query: state.query
                    });
                    if (handleExit) (_e = renderer === null || renderer === void 0 ? void 0 : renderer.onExit) === null || _e === void 0 || _e.call(renderer, props);
                    if (handleChange) (_f = renderer === null || renderer === void 0 ? void 0 : renderer.onUpdate) === null || _f === void 0 || _f.call(renderer, props);
                    if (handleStart) (_g = renderer === null || renderer === void 0 ? void 0 : renderer.onStart) === null || _g === void 0 || _g.call(renderer, props);
                },
                destroy: ()=>{
                    var _a;
                    if (!props) return;
                    (_a = renderer === null || renderer === void 0 ? void 0 : renderer.onExit) === null || _a === void 0 || _a.call(renderer, props);
                }
            };
        },
        state: {
            // Initialize the plugin's internal state.
            init () {
                const state = {
                    active: false,
                    range: {
                        from: 0,
                        to: 0
                    },
                    query: null,
                    text: null,
                    composing: false
                };
                return state;
            },
            // Apply changes to the plugin state from a view transaction.
            apply (transaction, prev, _oldState, state) {
                const { isEditable: isEditable } = editor;
                const { composing: composing } = editor.view;
                const { selection: selection } = transaction;
                const { empty: empty, from: from } = selection;
                const next = {
                    ...prev
                };
                next.composing = composing;
                // We can only be suggesting if the view is editable, and:
                //   * there is no selection, or
                //   * a composition is active (see: https://github.com/ueberdosis/tiptap/issues/1449)
                if (isEditable && (empty || editor.view.composing)) {
                    // Reset active state if we just left the previous suggestion range
                    if ((from < prev.range.from || from > prev.range.to) && !composing && !prev.composing) next.active = false;
                    // Try to match against where our cursor currently is
                    const match = findSuggestionMatch$1({
                        char: char,
                        allowSpaces: allowSpaces,
                        allowToIncludeChar: allowToIncludeChar,
                        allowedPrefixes: allowedPrefixes,
                        startOfLine: startOfLine,
                        $position: selection.$from
                    });
                    const decorationId = `id_${Math.floor(Math.random() * 0xffffffff)}`;
                    // If we found a match, update the current state to show it
                    if (match && allow({
                        editor: editor,
                        state: state,
                        range: match.range,
                        isActive: prev.active
                    })) {
                        next.active = true;
                        next.decorationId = prev.decorationId ? prev.decorationId : decorationId;
                        next.range = match.range;
                        next.query = match.query;
                        next.text = match.text;
                    } else next.active = false;
                } else next.active = false;
                // Make sure to empty the range if suggestion is inactive
                if (!next.active) {
                    next.decorationId = null;
                    next.range = {
                        from: 0,
                        to: 0
                    };
                    next.query = null;
                    next.text = null;
                }
                return next;
            }
        },
        props: {
            // Call the keydown hook if suggestion is active.
            handleKeyDown (view, event) {
                var _a;
                const { active: active, range: range } = plugin.getState(view.state);
                if (!active) return false;
                return ((_a = renderer === null || renderer === void 0 ? void 0 : renderer.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(renderer, {
                    view: view,
                    event: event,
                    range: range
                })) || false;
            },
            // Setup decorator on the currently active suggestion.
            decorations (state) {
                const { active: active, range: range, decorationId: decorationId } = plugin.getState(state);
                if (!active) return null;
                return (0, $edQEX.DecorationSet).create(state.doc, [
                    (0, $edQEX.Decoration).inline(range.from, range.to, {
                        nodeName: decorationTag,
                        class: decorationClass,
                        'data-decoration-id': decorationId
                    })
                ]);
            }
        }
    });
    return plugin;
}

});



parcelRegister("d6Hx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ad9a5c4b4a74be$export$2e2bcd8739ae039);

var $jhwMH = parcelRequire("jhwMH");

var $jSNlv = parcelRequire("jSNlv");

var $1QcTx = parcelRequire("1QcTx");

var $5K4Ak = parcelRequire("5K4Ak");
$jhwMH.extend($jSNlv);
$jhwMH.extend($1QcTx);
$jhwMH.extend($5K4Ak);
var $98ad9a5c4b4a74be$export$2e2bcd8739ae039 = ({ initialCurrentDate: initialCurrentDate, userLocale: userLocale = "en" })=>{
    // Configure Day.js locale based on user preference
    const locale = userLocale === "tr" ? "tr" : "en";
    $jhwMH.locale(locale);
    return {
        inProgress: false,
        currentDate: initialCurrentDate ? $jhwMH(initialCurrentDate) : $jhwMH(),
        startTime: "09:00",
        endTime: "10:00",
        locale: locale,
        // Get localized day names for calendar header
        getLocalizedDayNames () {
            const dayNames = [];
            // Start with Monday (ISO week)
            for(let i = 1; i <= 7; i++){
                const day = $jhwMH().isoWeekday(i);
                dayNames.push(day.format("dd")); // Short day names like "Mo", "Tu", etc.
            }
            return dayNames;
        },
        processEvents (events) {
            // Sort events by start time
            const sortedEvents = [
                ...events
            ].sort((a, b)=>{
                const startA = this.convertToLocalTime(a.when.start_time, a.when.start_timezone);
                const startB = this.convertToLocalTime(b.when.start_time, b.when.start_timezone);
                return startA - startB;
            });
            // Track overlapping groups
            const groups = [];
            let currentGroup = [];
            for (const event of sortedEvents){
                const eventStart = this.convertToLocalTime(event.when.start_time, event.when.start_timezone);
                const eventEnd = this.convertToLocalTime(event.when.end_time, event.when.end_timezone);
                // If currentGroup is empty or event overlaps with last event in group
                if (currentGroup.length === 0) currentGroup.push({
                    event: event,
                    column: 0
                });
                else {
                    const lastEvent = currentGroup[currentGroup.length - 1].event;
                    const lastEnd = this.convertToLocalTime(lastEvent.when.end_time, lastEvent.when.end_timezone);
                    if (eventStart < lastEnd) {
                        // Find first available column
                        let column = 0;
                        while(currentGroup.some((item)=>item.column === column && this.eventsOverlap(item.event, event)))column++;
                        currentGroup.push({
                            event: event,
                            column: column
                        });
                    } else {
                        // No overlap, start new group
                        if (currentGroup.length > 0) groups.push(currentGroup);
                        currentGroup = [
                            {
                                event: event,
                                column: 0
                            }
                        ];
                    }
                }
            }
            if (currentGroup.length > 0) groups.push(currentGroup);
            return groups;
        },
        eventsOverlap (event1, event2) {
            const start1 = this.convertToLocalTime(event1.when.start_time, event1.when.start_timezone);
            const end1 = this.convertToLocalTime(event1.when.end_time, event1.when.end_timezone);
            const start2 = this.convertToLocalTime(event2.when.start_time, event2.when.start_timezone);
            const end2 = this.convertToLocalTime(event2.when.end_time, event2.when.end_timezone);
            return start1 < end2 && start2 < end1;
        },
        getEventStyles (event, events) {
            const groups = this.processEvents(events);
            let eventGroup;
            let groupIndex;
            // Find which group contains this event
            for(let i = 0; i < groups.length; i++){
                const group = groups[i];
                const foundEvent = group.find((item)=>item.event.id === event.id);
                if (foundEvent) {
                    eventGroup = group;
                    groupIndex = i;
                    break;
                }
            }
            if (!eventGroup) return {};
            const maxColumns = Math.max(...eventGroup.map((item)=>item.column)) + 1;
            const eventData = eventGroup.find((item)=>item.event.id === event.id);
            const column = eventData.column;
            return {
                "grid-row": `${this.getGridRow(event)} / span ${this.getGridSpan(event)}`,
                "grid-column": `${column + 1} / span 1`,
                "margin-right": "2px",
                "z-index": column + 1
            };
        },
        scrollToBusinessHours () {
            // Wait for the next tick to ensure DOM is updated
            this.$nextTick(()=>{
                const container = this.$refs.eventContainer;
                if (container) {
                    // For 9 AM:
                    // - Skip header row (1.25rem)
                    // - Each hour is 12 slots (5-minute intervals)
                    // - We want to scroll to 9 * 12 = 108 slots
                    const slotHeight = (container.scrollHeight - 1.25) / 288; // Total height minus header divided by number of slots
                    const scrollPosition = 108 * slotHeight;
                    container.scrollTop = scrollPosition;
                }
            });
        },
        today () {
            return $jhwMH();
        },
        setDate (date) {
            this.currentDate = $jhwMH(date);
        },
        nextMonth () {
            this.currentDate = this.currentDate.add(1, "month");
        },
        previousMonth () {
            this.currentDate = this.currentDate.subtract(1, "month");
        },
        getDaysArray () {
            let startDay = this.currentDate.startOf("month").startOf("isoWeek");
            let endDay = this.currentDate.endOf("month").endOf("isoWeek");
            let days = [];
            for(let day = startDay; day.isBefore(endDay); day = day.add(1, "day"))days.push({
                date: day.format("YYYY-MM-DD"),
                number: day.format("D"),
                isCurrentMonth: day.month() === this.currentDate.month(),
                isCurrentDay: day.format("YYYY-MM-DD") === this.currentDate.format("YYYY-MM-DD"),
                isToday: day.format("YYYY-MM-DD") === $jhwMH().format("YYYY-MM-DD"),
                isStartOfMonth: day.date() === 1,
                isEndOfMonth: day.date() === day.daysInMonth(),
                isTopLeftDay: day.isSame(startDay, "day"),
                isTopRightDay: day.isSame(startDay.add(6, "day"), "day"),
                isBottomLeftDay: day.isSame(endDay.subtract(6, "day"), "day"),
                isBottomRightDay: day.isSame(endDay, "day")
            });
            return days;
        },
        unauthenticatedInterviewers: [],
        // calendar data format: {id: string, events: array}
        calendars: [],
        filteredEvents (calendarData) {
            return calendarData.events.filter((event)=>{
                const eventStart = this.convertToLocalTime(event.when.start_time, event.when.start_timezone);
                const eventEnd = this.convertToLocalTime(event.when.end_time, event.when.end_timezone);
                return eventStart.isSame(this.currentDate, "day") || eventEnd.isSame(this.currentDate, "day");
            });
        },
        getEventClasses (event) {
            return "relative mt-px flex";
        },
        getGridRow (event) {
            const localTime = this.convertToLocalTime(event.when.start_time, event.when.start_timezone);
            const hour = localTime.hour();
            const minute = localTime.minute();
            return hour * 12 + Math.floor(minute / 5) + 2; // +2 for initial offset in grid rows
        },
        getGridSpan (event) {
            const startTime = this.convertToLocalTime(event.when.start_time, event.when.start_timezone);
            const endTime = this.convertToLocalTime(event.when.end_time, event.when.end_timezone);
            const duration = endTime.diff(startTime, "minute");
            return Math.ceil(duration / 5); // Each grid row represents 5 minutes
        },
        formatTime (event) {
            const localTime = this.convertToLocalTime(event.when.start_time, event.when.start_timezone);
            return localTime.format("h:mm A");
        },
        getDateTime (event) {
            return this.convertToLocalTime(event.when.start_time, event.when.start_timezone).toISOString();
        },
        convertToLocalTime (unixTime, timezone) {
            return $jhwMH.unix(unixTime).tz(timezone);
        },
        isEven (index) {
            return index % 2 === 0;
        },
        /*
     * Fetches calendar events for the given interviewer and adds them to the calendars array
     * If the interviewer is not authenticated, adds the email to the unauthenticatedInterviewers array
     *
     * @param {{ email: string, name: string, id: string }} interviewer - interviewer object
     */ fetchCalendars (interviewer) {
            this.inProgress = true;
            fetch(`/scheduling/calendars/${interviewer.id}/events/${this.currentDate.startOf("day").unix()}/`).then(async (response)=>{
                this.inProgress = false;
                if (!response.ok) {
                    const data = await response.json();
                    throw data;
                }
                return response.json();
            }).then((data)=>{
                // push data to calendars array
                // check if the interviewer is already in the calendars array
                // if so, update the events array
                const index = this.calendars.findIndex((calendar)=>calendar.id === interviewer.email);
                if (index === -1) this.calendars.push({
                    id: interviewer.email,
                    events: data.events
                });
                else this.calendars[index].events = data.events;
                // Scroll to business hours after calendar data is loaded
                this.scrollToBusinessHours();
            }).catch((error)=>{
                // If error is 400 and error.type is "grant-needed", push the email to unauthenticatedInterviewers
                if (error?.error?.type === "grant-needed") this.unauthenticatedInterviewers.push(interviewer.email);
                else // Report error to sentry
                try {
                    throw new Error("Unexpected Nylas error", error);
                } catch (err) {
                    window.Sentry && Sentry.onLoad(function() {
                        const client = Sentry.getClient();
                        client.captureException(err);
                    });
                }
            });
        },
        init () {
            if (this.interviewers) {
                this.calendars = [];
                this.unauthenticatedInterviewers = [];
                for (const interviewer of this.interviewers)this.fetchCalendars(interviewer);
            }
            this.$watch("interviewers, currentDate", (value)=>{
                // For each interviewer, fetch calender events and add returned data to calendars
                // Clean up calendars and unauthenticatedInterviewers arrays before fetching new data
                this.calendars = [];
                this.unauthenticatedInterviewers = [];
                for (const interviewer of value)this.fetchCalendars(interviewer);
            });
            // Watch for start time changes
            this.$watch("startTime", (value)=>{
                if (!value) return;
                // Parse the start time and add one hour
                const [hours, minutes] = value.split(":");
                const startDate = new Date(2000, 0, 1, parseInt(hours), parseInt(minutes));
                // Special case for 11 PM (23:00)
                if (parseInt(hours) >= 23) // Add 45 minutes instead of 1 hour
                this.endTime = "23:45";
                else {
                    // Normal case: add 1 hour
                    const endDate = new Date(startDate.getTime() + 3600000);
                    this.endTime = `${endDate.getHours().toString().padStart(2, "0")}:${endDate.getMinutes().toString().padStart(2, "0")}`;
                }
            });
            // Initial scroll to business hours
            this.scrollToBusinessHours();
        }
    };
};

});
parcelRegister("1QcTx", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, o) {
        var r, a = function(t, n, i) {
            void 0 === i && (i = {});
            var o = new Date(t), r = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", o = t + "|" + i, r = e[o];
                return r || (r = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[o] = r), r;
            }(n, i);
            return r.formatToParts(o);
        }, u = function(e, n) {
            for(var i = a(e, n), r = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (r[c] = parseInt(m, 10));
            }
            var d = r[3], l = 24 === d ? 0 : d, h = r[0] + "-" + r[1] + "-" + r[2] + " " + l + ":" + r[4] + ":" + r[5] + ":000", v = +e;
            return (o.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            void 0 === t && (t = r);
            var n, i = this.utcOffset(), a = this.toDate(), u = a.toLocaleString("en-US", {
                timeZone: t
            }), f = Math.round((a - new Date(u)) / 1e3 / 60), s = 15 * -Math.round(a.getTimezoneOffset() / 15) - f;
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = o(u, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || o.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = o(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, o.tz = function(t, e, n) {
            var i = n && e, a = n || e || r, f = u(+o(), a);
            if ("string" != typeof t) return o(t).tz(a);
            var s = function(t, e, n) {
                var i = t - 60 * e * 1e3, o = u(i, n);
                if (e === o) return [
                    i,
                    e
                ];
                var r = u(i -= 60 * (o - e) * 1e3, n);
                return o === r ? [
                    i,
                    o
                ] : [
                    t - 60 * Math.min(o, r) * 1e3,
                    Math.max(o, r)
                ];
            }(o.utc(t, i).valueOf(), f, a), m = s[0], c = s[1], d = o(m).utcOffset(c);
            return d.$x.$timezone = a, d;
        }, o.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, o.tz.setDefault = function(t) {
            r = t;
        };
    };
});

});

parcelRegister("5K4Ak", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = "day";
    return function(t, i, s) {
        var a = function(t) {
            return t.add(4 - t.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
            return a(this).year();
        }, d.isoWeek = function(t) {
            if (!this.$utils().u(t)) return this.add(7 * (t - this.isoWeek()), e);
            var i, d, n, o, r = a(this), u = (i = this.isoWeekYear(), d = this.$u, n = (d ? s.utc : s)().year(i).startOf("year"), o = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (o += 7), n.add(o, e));
            return r.diff(u, "week") + 1;
        }, d.isoWeekday = function(e) {
            return this.$utils().u(e) ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
        };
        var n = d.startOf;
        d.startOf = function(e, t) {
            var i = this.$utils(), s = !!i.u(t) || t;
            return "isoweek" === i.p(e) ? s ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e, t);
        };
    };
});

});


// Day.js configuration

var $jhwMH = parcelRequire("jhwMH");

var $jSNlv = parcelRequire("jSNlv");

var $6N7gE = parcelRequire("6N7gE");

var $17sxp = parcelRequire("17sxp");
var $8f169e030fd838f9$exports = {};

!function(a, e) {
    $8f169e030fd838f9$exports = e((parcelRequire("jhwMH")));
}($8f169e030fd838f9$exports, function(a) {
    "use strict";
    function e(a) {
        return a && "object" == typeof a && "default" in a ? a : {
            default: a
        };
    }
    var t = e(a), _ = {
        name: "tr",
        weekdays: "Pazar_Pazartesi_Sal\u0131_\xc7ar\u015Famba_Per\u015Fembe_Cuma_Cumartesi".split("_"),
        weekdaysShort: "Paz_Pts_Sal_\xc7ar_Per_Cum_Cts".split("_"),
        weekdaysMin: "Pz_Pt_Sa_\xc7a_Pe_Cu_Ct".split("_"),
        months: "Ocak_\u015Eubat_Mart_Nisan_May\u0131s_Haziran_Temmuz_A\u011Fustos_Eyl\xfcl_Ekim_Kas\u0131m_Aral\u0131k".split("_"),
        monthsShort: "Oca_\u015Eub_Mar_Nis_May_Haz_Tem_A\u011Fu_Eyl_Eki_Kas_Ara".split("_"),
        weekStart: 1,
        formats: {
            LT: "HH:mm",
            LTS: "HH:mm:ss",
            L: "DD.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY HH:mm",
            LLLL: "dddd, D MMMM YYYY HH:mm"
        },
        relativeTime: {
            future: "%s sonra",
            past: "%s \xf6nce",
            s: "birka\xe7 saniye",
            m: "bir dakika",
            mm: "%d dakika",
            h: "bir saat",
            hh: "%d saat",
            d: "bir g\xfcn",
            dd: "%d g\xfcn",
            M: "bir ay",
            MM: "%d ay",
            y: "bir y\u0131l",
            yy: "%d y\u0131l"
        },
        ordinal: function(a) {
            return a + ".";
        }
    };
    return t.default.locale(_, null, !0), _;
});


/*!
 * ApexCharts v4.7.0
 * (c) 2018-2025 ApexCharts
 * Released under the MIT License.
 */ function $e4b487e979d7c06d$var$t(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, a = Array(e); i < e; i++)a[i] = t[i];
    return a;
}
function $e4b487e979d7c06d$var$e(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
}
function $e4b487e979d7c06d$var$i(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function $e4b487e979d7c06d$var$a(t, e) {
    for(var i = 0; i < e.length; i++){
        var a = e[i];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, $e4b487e979d7c06d$var$x(a.key), a);
    }
}
function $e4b487e979d7c06d$var$s(t, e, i) {
    return e && $e4b487e979d7c06d$var$a(t.prototype, e), i && $e4b487e979d7c06d$var$a(t, i), Object.defineProperty(t, "prototype", {
        writable: !1
    }), t;
}
function $e4b487e979d7c06d$var$r(t, e) {
    var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (!i) {
        if (Array.isArray(t) || (i = $e4b487e979d7c06d$var$m(t)) || e && t && "number" == typeof t.length) {
            i && (t = i);
            var a = 0, s = function() {};
            return {
                s: s,
                n: function() {
                    return a >= t.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: t[a++]
                    };
                },
                e: function(t) {
                    throw t;
                },
                f: s
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var r, n = !0, o = !1;
    return {
        s: function() {
            i = i.call(t);
        },
        n: function() {
            var t = i.next();
            return n = t.done, t;
        },
        e: function(t) {
            o = !0, r = t;
        },
        f: function() {
            try {
                n || null == i.return || i.return();
            } finally{
                if (o) throw r;
            }
        }
    };
}
function $e4b487e979d7c06d$var$n(t) {
    var i = $e4b487e979d7c06d$var$c();
    return function() {
        var a, s = $e4b487e979d7c06d$var$l(t);
        if (i) {
            var r = $e4b487e979d7c06d$var$l(this).constructor;
            a = Reflect.construct(s, arguments, r);
        } else a = s.apply(this, arguments);
        return function(t, i) {
            if (i && ("object" == typeof i || "function" == typeof i)) return i;
            if (void 0 !== i) throw new TypeError("Derived constructors may only return object or undefined");
            return $e4b487e979d7c06d$var$e(t);
        }(this, a);
    };
}
function $e4b487e979d7c06d$var$o(t, e, i) {
    return (e = $e4b487e979d7c06d$var$x(e)) in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
function $e4b487e979d7c06d$var$l(t) {
    return $e4b487e979d7c06d$var$l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4b487e979d7c06d$var$l(t);
}
function $e4b487e979d7c06d$var$h(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $e4b487e979d7c06d$var$g(t, e);
}
function $e4b487e979d7c06d$var$c() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($e4b487e979d7c06d$var$c = function() {
        return !!t;
    })();
}
function $e4b487e979d7c06d$var$d(t, e) {
    var i = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        e && (a = a.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), i.push.apply(i, a);
    }
    return i;
}
function $e4b487e979d7c06d$var$u(t) {
    for(var e = 1; e < arguments.length; e++){
        var i = null != arguments[e] ? arguments[e] : {};
        e % 2 ? $e4b487e979d7c06d$var$d(Object(i), !0).forEach(function(e) {
            $e4b487e979d7c06d$var$o(t, e, i[e]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(i)) : $e4b487e979d7c06d$var$d(Object(i)).forEach(function(e) {
            Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(i, e));
        });
    }
    return t;
}
function $e4b487e979d7c06d$var$g(t, e) {
    return $e4b487e979d7c06d$var$g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e4b487e979d7c06d$var$g(t, e);
}
function $e4b487e979d7c06d$var$p(t, e) {
    return function(t) {
        if (Array.isArray(t)) return t;
    }(t) || function(t, e) {
        var i = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
        if (null != i) {
            var a, s, r, n, o = [], l = !0, h = !1;
            try {
                if (r = (i = i.call(t)).next, 0 === e) {
                    if (Object(i) !== i) return;
                    l = !1;
                } else for(; !(l = (a = r.call(i)).done) && (o.push(a.value), o.length !== e); l = !0);
            } catch (t) {
                h = !0, s = t;
            } finally{
                try {
                    if (!l && null != i.return && (n = i.return(), Object(n) !== n)) return;
                } finally{
                    if (h) throw s;
                }
            }
            return o;
        }
    }(t, e) || $e4b487e979d7c06d$var$m(t, e) || function() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $e4b487e979d7c06d$var$f(e) {
    return function(e) {
        if (Array.isArray(e)) return $e4b487e979d7c06d$var$t(e);
    }(e) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(e) || $e4b487e979d7c06d$var$m(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $e4b487e979d7c06d$var$x(t) {
    var e = function(t, e) {
        if ("object" != typeof t || !t) return t;
        var i = t[Symbol.toPrimitive];
        if (void 0 !== i) {
            var a = i.call(t, e || "default");
            if ("object" != typeof a) return a;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === e ? String : Number)(t);
    }(t, "string");
    return "symbol" == typeof e ? e : e + "";
}
function $e4b487e979d7c06d$var$b(t) {
    return $e4b487e979d7c06d$var$b = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $e4b487e979d7c06d$var$b(t);
}
function $e4b487e979d7c06d$var$m(e, i) {
    if (e) {
        if ("string" == typeof e) return $e4b487e979d7c06d$var$t(e, i);
        var a = ({}).toString.call(e).slice(8, -1);
        return "Object" === a && e.constructor && (a = e.constructor.name), "Map" === a || "Set" === a ? Array.from(e) : "Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? $e4b487e979d7c06d$var$t(e, i) : void 0;
    }
}
var $e4b487e979d7c06d$var$v = function() {
    function t() {
        $e4b487e979d7c06d$var$i(this, t);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "shadeRGBColor",
            value: function(t, e) {
                var i = e.split(","), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = parseInt(i[0].slice(4), 10), n = parseInt(i[1], 10), o = parseInt(i[2], 10);
                return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - n) * s) + n) + "," + (Math.round((a - o) * s) + o) + ")";
            }
        },
        {
            key: "shadeHexColor",
            value: function(t, e) {
                var i = parseInt(e.slice(1), 16), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = i >> 16, n = i >> 8 & 255, o = 255 & i;
                return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - n) * s) + n) + (Math.round((a - o) * s) + o)).toString(16).slice(1);
            }
        },
        {
            key: "shadeColor",
            value: function(e, i) {
                return t.isColorHex(i) ? this.shadeHexColor(e, i) : this.shadeRGBColor(e, i);
            }
        }
    ], [
        {
            key: "bind",
            value: function(t, e) {
                return function() {
                    return t.apply(e, arguments);
                };
            }
        },
        {
            key: "isObject",
            value: function(t) {
                return t && "object" === $e4b487e979d7c06d$var$b(t) && !Array.isArray(t) && null != t;
            }
        },
        {
            key: "is",
            value: function(t, e) {
                return Object.prototype.toString.call(e) === "[object " + t + "]";
            }
        },
        {
            key: "isSafari",
            value: function() {
                return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        {
            key: "listToArray",
            value: function(t) {
                var e, i = [];
                for(e = 0; e < t.length; e++)i[e] = t[e];
                return i;
            }
        },
        {
            key: "extend",
            value: function(t, e) {
                var i = this;
                "function" != typeof Object.assign && (Object.assign = function(t) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for(var e = Object(t), i = 1; i < arguments.length; i++){
                        var a = arguments[i];
                        if (null != a) for(var s in a)a.hasOwnProperty(s) && (e[s] = a[s]);
                    }
                    return e;
                });
                var a = Object.assign({}, t);
                return this.isObject(t) && this.isObject(e) && Object.keys(e).forEach(function(s) {
                    i.isObject(e[s]) && s in t ? a[s] = i.extend(t[s], e[s]) : Object.assign(a, $e4b487e979d7c06d$var$o({}, s, e[s]));
                }), a;
            }
        },
        {
            key: "extendArray",
            value: function(e, i) {
                var a = [];
                return e.map(function(e) {
                    a.push(t.extend(i, e));
                }), e = a;
            }
        },
        {
            key: "monthMod",
            value: function(t) {
                return t % 12;
            }
        },
        {
            key: "clone",
            value: function(t) {
                var e, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : new WeakMap;
                if (null === t || "object" !== $e4b487e979d7c06d$var$b(t)) return t;
                if (i.has(t)) return i.get(t);
                if (Array.isArray(t)) {
                    e = [], i.set(t, e);
                    for(var a = 0; a < t.length; a++)e[a] = this.clone(t[a], i);
                } else if (t instanceof Date) e = new Date(t.getTime());
                else for(var s in e = {}, i.set(t, e), t)t.hasOwnProperty(s) && (e[s] = this.clone(t[s], i));
                return e;
            }
        },
        {
            key: "log10",
            value: function(t) {
                return Math.log(t) / Math.LN10;
            }
        },
        {
            key: "roundToBase10",
            value: function(t) {
                return Math.pow(10, Math.floor(Math.log10(t)));
            }
        },
        {
            key: "roundToBase",
            value: function(t, e) {
                return Math.pow(e, Math.floor(Math.log(t) / Math.log(e)));
            }
        },
        {
            key: "parseNumber",
            value: function(t) {
                return null === t ? t : parseFloat(t);
            }
        },
        {
            key: "stripNumber",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 2;
                return Number.isInteger(t) ? t : parseFloat(t.toPrecision(e));
            }
        },
        {
            key: "randomId",
            value: function() {
                return (Math.random() + 1).toString(36).substring(4);
            }
        },
        {
            key: "noExponents",
            value: function(t) {
                return t.toString().includes("e") ? Math.round(t) : t;
            }
        },
        {
            key: "elementExists",
            value: function(t) {
                return !(!t || !t.isConnected);
            }
        },
        {
            key: "getDimensions",
            value: function(t) {
                var e = getComputedStyle(t, null), i = t.clientHeight, a = t.clientWidth;
                return i -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), [
                    a -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                    i
                ];
            }
        },
        {
            key: "getBoundingClientRect",
            value: function(t) {
                var e = t.getBoundingClientRect();
                return {
                    top: e.top,
                    right: e.right,
                    bottom: e.bottom,
                    left: e.left,
                    width: t.clientWidth,
                    height: t.clientHeight,
                    x: e.left,
                    y: e.top
                };
            }
        },
        {
            key: "getLargestStringFromArr",
            value: function(t) {
                return t.reduce(function(t, e) {
                    return Array.isArray(e) && (e = e.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    })), t.length > e.length ? t : e;
                }, 0);
            }
        },
        {
            key: "hexToRgba",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#999999", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .6;
                "#" !== t.substring(0, 1) && (t = "#999999");
                var i = t.replace("#", "");
                i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                for(var a = 0; a < i.length; a++)i[a] = parseInt(1 === i[a].length ? i[a] + i[a] : i[a], 16);
                return void 0 !== e && i.push(e), "rgba(" + i.join(",") + ")";
            }
        },
        {
            key: "getOpacityFromRGBA",
            value: function(t) {
                return parseFloat(t.replace(/^.*,(.+)\)/, "$1"));
            }
        },
        {
            key: "rgb2hex",
            value: function(t) {
                return (t = t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === t.length ? "#" + ("0" + parseInt(t[1], 10).toString(16)).slice(-2) + ("0" + parseInt(t[2], 10).toString(16)).slice(-2) + ("0" + parseInt(t[3], 10).toString(16)).slice(-2) : "";
            }
        },
        {
            key: "isColorHex",
            value: function(t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t);
            }
        },
        {
            key: "getPolygonPos",
            value: function(t, e) {
                for(var i = [], a = 2 * Math.PI / e, s = 0; s < e; s++){
                    var r = {};
                    r.x = t * Math.sin(s * a), r.y = -t * Math.cos(s * a), i.push(r);
                }
                return i;
            }
        },
        {
            key: "polarToCartesian",
            value: function(t, e, i, a) {
                var s = (a - 90) * Math.PI / 180;
                return {
                    x: t + i * Math.cos(s),
                    y: e + i * Math.sin(s)
                };
            }
        },
        {
            key: "escapeString",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x", i = t.toString().slice();
                return i = i.replace(/[` ~!@#$%^&*()|+\=?;:'",.<>{}[\]\\/]/gi, e);
            }
        },
        {
            key: "negToZero",
            value: function(t) {
                return t < 0 ? 0 : t;
            }
        },
        {
            key: "moveIndexInArray",
            value: function(t, e, i) {
                if (i >= t.length) for(var a = i - t.length + 1; a--;)t.push(void 0);
                return t.splice(i, 0, t.splice(e, 1)[0]), t;
            }
        },
        {
            key: "extractNumber",
            value: function(t) {
                return parseFloat(t.replace(/[^\d.]*/g, ""));
            }
        },
        {
            key: "findAncestor",
            value: function(t, e) {
                for(; (t = t.parentElement) && !t.classList.contains(e););
                return t;
            }
        },
        {
            key: "setELstyles",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && (t.style.key = e[i]);
            }
        },
        {
            key: "preciseAddition",
            value: function(t, e) {
                var i = (String(t).split(".")[1] || "").length, a = (String(e).split(".")[1] || "").length, s = Math.pow(10, Math.max(i, a));
                return (Math.round(t * s) + Math.round(e * s)) / s;
            }
        },
        {
            key: "isNumber",
            value: function(t) {
                return !isNaN(t) && parseFloat(Number(t)) === t && !isNaN(parseInt(t, 10));
            }
        },
        {
            key: "isFloat",
            value: function(t) {
                return Number(t) === t && t % 1 != 0;
            }
        },
        {
            key: "isMsEdge",
            value: function() {
                var t = window.navigator.userAgent, e = t.indexOf("Edge/");
                return e > 0 && parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
            }
        },
        {
            key: "getGCD",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 7, a = Math.pow(10, i - Math.floor(Math.log10(Math.max(t, e))));
                for(t = Math.round(Math.abs(t) * a), e = Math.round(Math.abs(e) * a); e;){
                    var s = e;
                    e = t % e, t = s;
                }
                return t / a;
            }
        },
        {
            key: "getPrimeFactors",
            value: function(t) {
                for(var e = [], i = 2; t >= 2;)t % i == 0 ? (e.push(i), t /= i) : i++;
                return e;
            }
        },
        {
            key: "mod",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 7, a = Math.pow(10, i - Math.floor(Math.log10(Math.max(t, e))));
                return (t = Math.round(Math.abs(t) * a)) % (e = Math.round(Math.abs(e) * a)) / a;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$y = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "animateLine",
            value: function(t, e, i, a) {
                t.attr(e).animate(a).attr(i);
            }
        },
        {
            key: "animateMarker",
            value: function(t, e, i, a) {
                t.attr({
                    opacity: 0
                }).animate(e).attr({
                    opacity: 1
                }).after(function() {
                    a();
                });
            }
        },
        {
            key: "animateRect",
            value: function(t, e, i, a, s) {
                t.attr(e).animate(a).attr(i).after(function() {
                    return s();
                });
            }
        },
        {
            key: "animatePathsGradually",
            value: function(t) {
                var e = t.el, i = t.realIndex, a = t.j, s = t.fill, r = t.pathFrom, n = t.pathTo, o = t.speed, l = t.delay, h = this.w, c = 0;
                h.config.chart.animations.animateGradually.enabled && (c = h.config.chart.animations.animateGradually.delay), h.config.chart.animations.dynamicAnimation.enabled && h.globals.dataChanged && "bar" !== h.config.chart.type && (c = 0), this.morphSVG(e, i, a, "line" !== h.config.chart.type || h.globals.comboCharts ? s : "stroke", r, n, o, l * c);
            }
        },
        {
            key: "showDelayedElements",
            value: function() {
                this.w.globals.delayedElements.forEach(function(t) {
                    var e = t.el;
                    e.classList.remove("apexcharts-element-hidden"), e.classList.add("apexcharts-hidden-element-shown");
                });
            }
        },
        {
            key: "animationCompleted",
            value: function(t) {
                var e = this.w;
                e.globals.animationEnded || (e.globals.animationEnded = !0, this.showDelayedElements(), "function" == typeof e.config.chart.events.animationEnd && e.config.chart.events.animationEnd(this.ctx, {
                    el: t,
                    w: e
                }));
            }
        },
        {
            key: "morphSVG",
            value: function(t, e, i, a, s, r, n, o) {
                var l = this, h = this.w;
                s || (s = t.attr("pathFrom")), r || (r = t.attr("pathTo"));
                var c = function(t) {
                    return "radar" === h.config.chart.type && (n = 1), "M 0 ".concat(h.globals.gridHeight);
                };
                (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = c()), (!r.trim() || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = c()), h.globals.shouldAnimate || (n = 1), t.plot(s).animate(1, o).plot(s).animate(n, o).plot(r).after(function() {
                    $e4b487e979d7c06d$var$v.isNumber(i) ? i === h.globals.series[h.globals.maxValsInArrayIndex].length - 2 && h.globals.shouldAnimate && l.animationCompleted(t) : "none" !== a && h.globals.shouldAnimate && (!h.globals.comboCharts && e === h.globals.series.length - 1 || h.globals.comboCharts) && l.animationCompleted(t), l.showDelayedElements();
                });
            }
        }
    ]), t;
}();
const $e4b487e979d7c06d$var$w = {}, $e4b487e979d7c06d$var$k = [];
function $e4b487e979d7c06d$var$A(t, e) {
    if (Array.isArray(t)) for (const i of t)$e4b487e979d7c06d$var$A(i, e);
    else if ("object" != typeof t) $e4b487e979d7c06d$var$S(Object.getOwnPropertyNames(e)), $e4b487e979d7c06d$var$w[t] = Object.assign($e4b487e979d7c06d$var$w[t] || {}, e);
    else for(const e in t)$e4b487e979d7c06d$var$A(e, t[e]);
}
function $e4b487e979d7c06d$var$C(t) {
    return $e4b487e979d7c06d$var$w[t] || {};
}
function $e4b487e979d7c06d$var$S(t) {
    $e4b487e979d7c06d$var$k.push(...t);
}
function $e4b487e979d7c06d$var$L(t, e) {
    let i;
    const a = t.length, s = [];
    for(i = 0; i < a; i++)s.push(e(t[i]));
    return s;
}
function $e4b487e979d7c06d$var$M(t) {
    return t % 360 * Math.PI / 180;
}
function $e4b487e979d7c06d$var$P(t) {
    return t.charAt(0).toUpperCase() + t.slice(1);
}
function $e4b487e979d7c06d$var$I(t, e, i, a) {
    return null != e && null != i || (a = a || t.bbox(), null == e ? e = a.width / a.height * i : null == i && (i = a.height / a.width * e)), {
        width: e,
        height: i
    };
}
function $e4b487e979d7c06d$var$T(t, e) {
    const i = t.origin;
    let a = null != t.ox ? t.ox : null != t.originX ? t.originX : "center", s = null != t.oy ? t.oy : null != t.originY ? t.originY : "center";
    null != i && ([a, s] = Array.isArray(i) ? i : "object" == typeof i ? [
        i.x,
        i.y
    ] : [
        i,
        i
    ]);
    const r = "string" == typeof a, n = "string" == typeof s;
    if (r || n) {
        const { height: t, width: i, x: o, y: l } = e.bbox();
        r && (a = a.includes("left") ? o : a.includes("right") ? o + i : o + i / 2), n && (s = s.includes("top") ? l : s.includes("bottom") ? l + t : l + t / 2);
    }
    return [
        a,
        s
    ];
}
const $e4b487e979d7c06d$var$z = new Set([
    "desc",
    "metadata",
    "title"
]), $e4b487e979d7c06d$var$X = (t)=>$e4b487e979d7c06d$var$z.has(t.nodeName), $e4b487e979d7c06d$var$R = (t, e, i = {})=>{
    const a = {
        ...e
    };
    for(const t in a)a[t].valueOf() === i[t] && delete a[t];
    Object.keys(a).length ? t.node.setAttribute("data-svgjs", JSON.stringify(a)) : (t.node.removeAttribute("data-svgjs"), t.node.removeAttribute("svgjs:data"));
}, $e4b487e979d7c06d$var$E = "http://www.w3.org/2000/svg", $e4b487e979d7c06d$var$Y = "http://www.w3.org/2000/xmlns/", $e4b487e979d7c06d$var$H = "http://www.w3.org/1999/xlink", $e4b487e979d7c06d$var$O = {
    window: "undefined" == typeof window ? null : window,
    document: "undefined" == typeof document ? null : document
};
function $e4b487e979d7c06d$var$F() {
    return $e4b487e979d7c06d$var$O.window;
}
let $e4b487e979d7c06d$var$D = class {
};
const $e4b487e979d7c06d$var$_ = {}, $e4b487e979d7c06d$var$N = "___SYMBOL___ROOT___";
function $e4b487e979d7c06d$var$W(t, e = $e4b487e979d7c06d$var$E) {
    return $e4b487e979d7c06d$var$O.document.createElementNS(e, t);
}
function $e4b487e979d7c06d$var$B(t, e = !1) {
    if (t instanceof $e4b487e979d7c06d$var$D) return t;
    if ("object" == typeof t) return $e4b487e979d7c06d$var$U(t);
    if (null == t) return new $e4b487e979d7c06d$var$_[$e4b487e979d7c06d$var$N];
    if ("string" == typeof t && "<" !== t.charAt(0)) return $e4b487e979d7c06d$var$U($e4b487e979d7c06d$var$O.document.querySelector(t));
    const i = e ? $e4b487e979d7c06d$var$O.document.createElement("div") : $e4b487e979d7c06d$var$W("svg");
    return i.innerHTML = t, t = $e4b487e979d7c06d$var$U(i.firstChild), i.removeChild(i.firstChild), t;
}
function $e4b487e979d7c06d$var$G(t, e) {
    return e && (e instanceof $e4b487e979d7c06d$var$O.window.Node || e.ownerDocument && e instanceof e.ownerDocument.defaultView.Node) ? e : $e4b487e979d7c06d$var$W(t);
}
function $e4b487e979d7c06d$var$V(t) {
    if (!t) return null;
    if (t.instance instanceof $e4b487e979d7c06d$var$D) return t.instance;
    if ("#document-fragment" === t.nodeName) return new $e4b487e979d7c06d$var$_.Fragment(t);
    let e = $e4b487e979d7c06d$var$P(t.nodeName || "Dom");
    return "LinearGradient" === e || "RadialGradient" === e ? e = "Gradient" : $e4b487e979d7c06d$var$_[e] || (e = "Dom"), new $e4b487e979d7c06d$var$_[e](t);
}
let $e4b487e979d7c06d$var$U = $e4b487e979d7c06d$var$V;
function $e4b487e979d7c06d$var$q(t, e = t.name, i = !1) {
    return $e4b487e979d7c06d$var$_[e] = t, i && ($e4b487e979d7c06d$var$_[$e4b487e979d7c06d$var$N] = t), $e4b487e979d7c06d$var$S(Object.getOwnPropertyNames(t.prototype)), t;
}
let $e4b487e979d7c06d$var$Z = 1e3;
function $e4b487e979d7c06d$var$$(t) {
    return "Svgjs" + $e4b487e979d7c06d$var$P(t) + $e4b487e979d7c06d$var$Z++;
}
function $e4b487e979d7c06d$var$J(t) {
    for(let e = t.children.length - 1; e >= 0; e--)$e4b487e979d7c06d$var$J(t.children[e]);
    return t.id ? (t.id = $e4b487e979d7c06d$var$$(t.nodeName), t) : t;
}
function $e4b487e979d7c06d$var$Q(t, e) {
    let i, a;
    for(a = (t = Array.isArray(t) ? t : [
        t
    ]).length - 1; a >= 0; a--)for(i in e)t[a].prototype[i] = e[i];
}
function $e4b487e979d7c06d$var$K(t) {
    return function(...e) {
        const i = e[e.length - 1];
        return !i || i.constructor !== Object || i instanceof Array ? t.apply(this, e) : t.apply(this, e.slice(0, -1)).attr(i);
    };
}
$e4b487e979d7c06d$var$A("Dom", {
    siblings: function() {
        return this.parent().children();
    },
    position: function() {
        return this.parent().index(this);
    },
    next: function() {
        return this.siblings()[this.position() + 1];
    },
    prev: function() {
        return this.siblings()[this.position() - 1];
    },
    forward: function() {
        const t = this.position();
        return this.parent().add(this.remove(), t + 1), this;
    },
    backward: function() {
        const t = this.position();
        return this.parent().add(this.remove(), t ? t - 1 : 0), this;
    },
    front: function() {
        return this.parent().add(this.remove()), this;
    },
    back: function() {
        return this.parent().add(this.remove(), 0), this;
    },
    before: function(t) {
        (t = $e4b487e979d7c06d$var$B(t)).remove();
        const e = this.position();
        return this.parent().add(t, e), this;
    },
    after: function(t) {
        (t = $e4b487e979d7c06d$var$B(t)).remove();
        const e = this.position();
        return this.parent().add(t, e + 1), this;
    },
    insertBefore: function(t) {
        return (t = $e4b487e979d7c06d$var$B(t)).before(this), this;
    },
    insertAfter: function(t) {
        return (t = $e4b487e979d7c06d$var$B(t)).after(this), this;
    }
});
const $e4b487e979d7c06d$var$tt = /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i, $e4b487e979d7c06d$var$et = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, $e4b487e979d7c06d$var$it = /rgb\((\d+),(\d+),(\d+)\)/, $e4b487e979d7c06d$var$at = /(#[a-z_][a-z0-9\-_]*)/i, $e4b487e979d7c06d$var$st = /\)\s*,?\s*/, $e4b487e979d7c06d$var$rt = /\s/g, $e4b487e979d7c06d$var$nt = /^#[a-f0-9]{3}$|^#[a-f0-9]{6}$/i, $e4b487e979d7c06d$var$ot = /^rgb\(/, $e4b487e979d7c06d$var$lt = /^(\s+)?$/, $e4b487e979d7c06d$var$ht = /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, $e4b487e979d7c06d$var$ct = /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i, $e4b487e979d7c06d$var$dt = /[\s,]+/, $e4b487e979d7c06d$var$ut = /[MLHVCSQTAZ]/i;
function $e4b487e979d7c06d$var$gt(t) {
    const e = Math.round(t), i = Math.max(0, Math.min(255, e)).toString(16);
    return 1 === i.length ? "0" + i : i;
}
function $e4b487e979d7c06d$var$pt(t, e) {
    for(let i = e.length; i--;)if (null == t[e[i]]) return !1;
    return !0;
}
function $e4b487e979d7c06d$var$ft(t, e, i) {
    return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? t + 6 * (e - t) * i : i < .5 ? e : i < 2 / 3 ? t + (e - t) * (2 / 3 - i) * 6 : t;
}
$e4b487e979d7c06d$var$A("Dom", {
    classes: function() {
        const t = this.attr("class");
        return null == t ? [] : t.trim().split($e4b487e979d7c06d$var$dt);
    },
    hasClass: function(t) {
        return -1 !== this.classes().indexOf(t);
    },
    addClass: function(t) {
        if (!this.hasClass(t)) {
            const e = this.classes();
            e.push(t), this.attr("class", e.join(" "));
        }
        return this;
    },
    removeClass: function(t) {
        return this.hasClass(t) && this.attr("class", this.classes().filter(function(e) {
            return e !== t;
        }).join(" ")), this;
    },
    toggleClass: function(t) {
        return this.hasClass(t) ? this.removeClass(t) : this.addClass(t);
    }
}), $e4b487e979d7c06d$var$A("Dom", {
    css: function(t, e) {
        const i = {};
        if (0 === arguments.length) return this.node.style.cssText.split(/\s*;\s*/).filter(function(t) {
            return !!t.length;
        }).forEach(function(t) {
            const e = t.split(/\s*:\s*/);
            i[e[0]] = e[1];
        }), i;
        if (arguments.length < 2) {
            if (Array.isArray(t)) {
                for (const e of t){
                    const t = e;
                    i[e] = this.node.style.getPropertyValue(t);
                }
                return i;
            }
            if ("string" == typeof t) return this.node.style.getPropertyValue(t);
            if ("object" == typeof t) for(const e in t)this.node.style.setProperty(e, null == t[e] || $e4b487e979d7c06d$var$lt.test(t[e]) ? "" : t[e]);
        }
        return 2 === arguments.length && this.node.style.setProperty(t, null == e || $e4b487e979d7c06d$var$lt.test(e) ? "" : e), this;
    },
    show: function() {
        return this.css("display", "");
    },
    hide: function() {
        return this.css("display", "none");
    },
    visible: function() {
        return "none" !== this.css("display");
    }
}), $e4b487e979d7c06d$var$A("Dom", {
    data: function(t, e, i) {
        if (null == t) return this.data($e4b487e979d7c06d$var$L(function(t, e) {
            let i;
            const a = t.length, s = [];
            for(i = 0; i < a; i++)e(t[i]) && s.push(t[i]);
            return s;
        }(this.node.attributes, (t)=>0 === t.nodeName.indexOf("data-")), (t)=>t.nodeName.slice(5)));
        if (t instanceof Array) {
            const e = {};
            for (const i of t)e[i] = this.data(i);
            return e;
        }
        if ("object" == typeof t) for(e in t)this.data(e, t[e]);
        else if (arguments.length < 2) try {
            return JSON.parse(this.attr("data-" + t));
        } catch (e) {
            return this.attr("data-" + t);
        }
        else this.attr("data-" + t, null === e ? null : !0 === i || "string" == typeof e || "number" == typeof e ? e : JSON.stringify(e));
        return this;
    }
}), $e4b487e979d7c06d$var$A("Dom", {
    remember: function(t, e) {
        if ("object" == typeof arguments[0]) for(const e in t)this.remember(e, t[e]);
        else {
            if (1 === arguments.length) return this.memory()[t];
            this.memory()[t] = e;
        }
        return this;
    },
    forget: function() {
        if (0 === arguments.length) this._memory = {};
        else for(let t = arguments.length - 1; t >= 0; t--)delete this.memory()[arguments[t]];
        return this;
    },
    memory: function() {
        return this._memory = this._memory || {};
    }
});
class $e4b487e979d7c06d$var$xt {
    constructor(...t){
        this.init(...t);
    }
    static isColor(t) {
        return t && (t instanceof $e4b487e979d7c06d$var$xt || this.isRgb(t) || this.test(t));
    }
    static isRgb(t) {
        return t && "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b;
    }
    static random(t = "vibrant", e) {
        const { random: i, round: a, sin: s, PI: r } = Math;
        if ("vibrant" === t) {
            const t = 24 * i() + 57, e = 38 * i() + 45, a = 360 * i();
            return new $e4b487e979d7c06d$var$xt(t, e, a, "lch");
        }
        if ("sine" === t) {
            const t = a(80 * s(2 * r * (e = null == e ? i() : e) / .5 + .01) + 150), n = a(50 * s(2 * r * e / .5 + 4.6) + 200), o = a(100 * s(2 * r * e / .5 + 2.3) + 150);
            return new $e4b487e979d7c06d$var$xt(t, n, o);
        }
        if ("pastel" === t) {
            const t = 8 * i() + 86, e = 17 * i() + 9, a = 360 * i();
            return new $e4b487e979d7c06d$var$xt(t, e, a, "lch");
        }
        if ("dark" === t) {
            const t = 10 + 10 * i(), e = 50 * i() + 86, a = 360 * i();
            return new $e4b487e979d7c06d$var$xt(t, e, a, "lch");
        }
        if ("rgb" === t) {
            const t = 255 * i(), e = 255 * i(), a = 255 * i();
            return new $e4b487e979d7c06d$var$xt(t, e, a);
        }
        if ("lab" === t) {
            const t = 100 * i(), e = 256 * i() - 128, a = 256 * i() - 128;
            return new $e4b487e979d7c06d$var$xt(t, e, a, "lab");
        }
        if ("grey" === t) {
            const t = 255 * i();
            return new $e4b487e979d7c06d$var$xt(t, t, t);
        }
        throw new Error("Unsupported random color mode");
    }
    static test(t) {
        return "string" == typeof t && ($e4b487e979d7c06d$var$nt.test(t) || $e4b487e979d7c06d$var$ot.test(t));
    }
    cmyk() {
        const { _a: t, _b: e, _c: i } = this.rgb(), [a, s, r] = [
            t,
            e,
            i
        ].map((t)=>t / 255), n = Math.min(1 - a, 1 - s, 1 - r);
        if (1 === n) return new $e4b487e979d7c06d$var$xt(0, 0, 0, 1, "cmyk");
        return new $e4b487e979d7c06d$var$xt((1 - a - n) / (1 - n), (1 - s - n) / (1 - n), (1 - r - n) / (1 - n), n, "cmyk");
    }
    hsl() {
        const { _a: t, _b: e, _c: i } = this.rgb(), [a, s, r] = [
            t,
            e,
            i
        ].map((t)=>t / 255), n = Math.max(a, s, r), o = Math.min(a, s, r), l = (n + o) / 2, h = n === o, c = n - o;
        return new $e4b487e979d7c06d$var$xt(360 * (h ? 0 : n === a ? ((s - r) / c + (s < r ? 6 : 0)) / 6 : n === s ? ((r - a) / c + 2) / 6 : n === r ? ((a - s) / c + 4) / 6 : 0), 100 * (h ? 0 : l > .5 ? c / (2 - n - o) : c / (n + o)), 100 * l, "hsl");
    }
    init(t = 0, e = 0, i = 0, a = 0, s = "rgb") {
        if (t = t || 0, this.space) for(const t in this.space)delete this[this.space[t]];
        if ("number" == typeof t) s = "string" == typeof a ? a : s, a = "string" == typeof a ? 0 : a, Object.assign(this, {
            _a: t,
            _b: e,
            _c: i,
            _d: a,
            space: s
        });
        else if (t instanceof Array) this.space = e || ("string" == typeof t[3] ? t[3] : t[4]) || "rgb", Object.assign(this, {
            _a: t[0],
            _b: t[1],
            _c: t[2],
            _d: t[3] || 0
        });
        else if (t instanceof Object) {
            const i = function(t, e) {
                const i = $e4b487e979d7c06d$var$pt(t, "rgb") ? {
                    _a: t.r,
                    _b: t.g,
                    _c: t.b,
                    _d: 0,
                    space: "rgb"
                } : $e4b487e979d7c06d$var$pt(t, "xyz") ? {
                    _a: t.x,
                    _b: t.y,
                    _c: t.z,
                    _d: 0,
                    space: "xyz"
                } : $e4b487e979d7c06d$var$pt(t, "hsl") ? {
                    _a: t.h,
                    _b: t.s,
                    _c: t.l,
                    _d: 0,
                    space: "hsl"
                } : $e4b487e979d7c06d$var$pt(t, "lab") ? {
                    _a: t.l,
                    _b: t.a,
                    _c: t.b,
                    _d: 0,
                    space: "lab"
                } : $e4b487e979d7c06d$var$pt(t, "lch") ? {
                    _a: t.l,
                    _b: t.c,
                    _c: t.h,
                    _d: 0,
                    space: "lch"
                } : $e4b487e979d7c06d$var$pt(t, "cmyk") ? {
                    _a: t.c,
                    _b: t.m,
                    _c: t.y,
                    _d: t.k,
                    space: "cmyk"
                } : {
                    _a: 0,
                    _b: 0,
                    _c: 0,
                    space: "rgb"
                };
                return i.space = e || i.space, i;
            }(t, e);
            Object.assign(this, i);
        } else if ("string" == typeof t) {
            if ($e4b487e979d7c06d$var$ot.test(t)) {
                const e = t.replace($e4b487e979d7c06d$var$rt, ""), [i, a, s] = $e4b487e979d7c06d$var$it.exec(e).slice(1, 4).map((t)=>parseInt(t));
                Object.assign(this, {
                    _a: i,
                    _b: a,
                    _c: s,
                    _d: 0,
                    space: "rgb"
                });
            } else {
                if (!$e4b487e979d7c06d$var$nt.test(t)) throw Error("Unsupported string format, can't construct Color");
                {
                    const e = (t)=>parseInt(t, 16), [, i, a, s] = $e4b487e979d7c06d$var$et.exec(function(t) {
                        return 4 === t.length ? [
                            "#",
                            t.substring(1, 2),
                            t.substring(1, 2),
                            t.substring(2, 3),
                            t.substring(2, 3),
                            t.substring(3, 4),
                            t.substring(3, 4)
                        ].join("") : t;
                    }(t)).map(e);
                    Object.assign(this, {
                        _a: i,
                        _b: a,
                        _c: s,
                        _d: 0,
                        space: "rgb"
                    });
                }
            }
        }
        const { _a: r, _b: n, _c: o, _d: l } = this, h = "rgb" === this.space ? {
            r: r,
            g: n,
            b: o
        } : "xyz" === this.space ? {
            x: r,
            y: n,
            z: o
        } : "hsl" === this.space ? {
            h: r,
            s: n,
            l: o
        } : "lab" === this.space ? {
            l: r,
            a: n,
            b: o
        } : "lch" === this.space ? {
            l: r,
            c: n,
            h: o
        } : "cmyk" === this.space ? {
            c: r,
            m: n,
            y: o,
            k: l
        } : {};
        Object.assign(this, h);
    }
    lab() {
        const { x: t, y: e, z: i } = this.xyz();
        return new $e4b487e979d7c06d$var$xt(116 * e - 16, 500 * (t - e), 200 * (e - i), "lab");
    }
    lch() {
        const { l: t, a: e, b: i } = this.lab(), a = Math.sqrt(e ** 2 + i ** 2);
        let s = 180 * Math.atan2(i, e) / Math.PI;
        s < 0 && (s *= -1, s = 360 - s);
        return new $e4b487e979d7c06d$var$xt(t, a, s, "lch");
    }
    rgb() {
        if ("rgb" === this.space) return this;
        if ("lab" === (t = this.space) || "xyz" === t || "lch" === t) {
            let { x: t, y: e, z: i } = this;
            if ("lab" === this.space || "lch" === this.space) {
                let { l: a, a: s, b: r } = this;
                if ("lch" === this.space) {
                    const { c: t, h: e } = this, i = Math.PI / 180;
                    s = t * Math.cos(i * e), r = t * Math.sin(i * e);
                }
                const n = (a + 16) / 116, o = s / 500 + n, l = n - r / 200, h = 16 / 116, c = .008856, d = 7.787;
                t = .95047 * (o ** 3 > c ? o ** 3 : (o - h) / d), e = 1 * (n ** 3 > c ? n ** 3 : (n - h) / d), i = 1.08883 * (l ** 3 > c ? l ** 3 : (l - h) / d);
            }
            const a = 3.2406 * t + -1.5372 * e + -0.4986 * i, s = -0.9689 * t + 1.8758 * e + .0415 * i, r = .0557 * t + -0.204 * e + 1.057 * i, n = Math.pow, o = .0031308, l = a > o ? 1.055 * n(a, 1 / 2.4) - .055 : 12.92 * a, h = s > o ? 1.055 * n(s, 1 / 2.4) - .055 : 12.92 * s, c = r > o ? 1.055 * n(r, 1 / 2.4) - .055 : 12.92 * r;
            return new $e4b487e979d7c06d$var$xt(255 * l, 255 * h, 255 * c);
        }
        if ("hsl" === this.space) {
            let { h: t, s: e, l: i } = this;
            if (t /= 360, e /= 100, i /= 100, 0 === e) {
                i *= 255;
                return new $e4b487e979d7c06d$var$xt(i, i, i);
            }
            const a = i < .5 ? i * (1 + e) : i + e - i * e, s = 2 * i - a, r = 255 * $e4b487e979d7c06d$var$ft(s, a, t + 1 / 3), n = 255 * $e4b487e979d7c06d$var$ft(s, a, t), o = 255 * $e4b487e979d7c06d$var$ft(s, a, t - 1 / 3);
            return new $e4b487e979d7c06d$var$xt(r, n, o);
        }
        if ("cmyk" === this.space) {
            const { c: t, m: e, y: i, k: a } = this, s = 255 * (1 - Math.min(1, t * (1 - a) + a)), r = 255 * (1 - Math.min(1, e * (1 - a) + a)), n = 255 * (1 - Math.min(1, i * (1 - a) + a));
            return new $e4b487e979d7c06d$var$xt(s, r, n);
        }
        var t;
        return this;
    }
    toArray() {
        const { _a: t, _b: e, _c: i, _d: a, space: s } = this;
        return [
            t,
            e,
            i,
            a,
            s
        ];
    }
    toHex() {
        const [t, e, i] = this._clamped().map($e4b487e979d7c06d$var$gt);
        return `#${t}${e}${i}`;
    }
    toRgb() {
        const [t, e, i] = this._clamped();
        return `rgb(${t},${e},${i})`;
    }
    toString() {
        return this.toHex();
    }
    xyz() {
        const { _a: t, _b: e, _c: i } = this.rgb(), [a, s, r] = [
            t,
            e,
            i
        ].map((t)=>t / 255), n = a > .04045 ? Math.pow((a + .055) / 1.055, 2.4) : a / 12.92, o = s > .04045 ? Math.pow((s + .055) / 1.055, 2.4) : s / 12.92, l = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92, h = (.4124 * n + .3576 * o + .1805 * l) / .95047, c = (.2126 * n + .7152 * o + .0722 * l) / 1, d = (.0193 * n + .1192 * o + .9505 * l) / 1.08883, u = h > .008856 ? Math.pow(h, 1 / 3) : 7.787 * h + 16 / 116, g = c > .008856 ? Math.pow(c, 1 / 3) : 7.787 * c + 16 / 116, p = d > .008856 ? Math.pow(d, 1 / 3) : 7.787 * d + 16 / 116;
        return new $e4b487e979d7c06d$var$xt(u, g, p, "xyz");
    }
    _clamped() {
        const { _a: t, _b: e, _c: i } = this.rgb(), { max: a, min: s, round: r } = Math;
        return [
            t,
            e,
            i
        ].map((t)=>a(0, s(r(t), 255)));
    }
}
class $e4b487e979d7c06d$var$bt {
    constructor(...t){
        this.init(...t);
    }
    clone() {
        return new $e4b487e979d7c06d$var$bt(this);
    }
    init(t, e) {
        const i = 0, a = 0, s = Array.isArray(t) ? {
            x: t[0],
            y: t[1]
        } : "object" == typeof t ? {
            x: t.x,
            y: t.y
        } : {
            x: t,
            y: e
        };
        return this.x = null == s.x ? i : s.x, this.y = null == s.y ? a : s.y, this;
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
    transform(t) {
        return this.clone().transformO(t);
    }
    transformO(t) {
        $e4b487e979d7c06d$var$vt.isMatrixLike(t) || (t = new $e4b487e979d7c06d$var$vt(t));
        const { x: e, y: i } = this;
        return this.x = t.a * e + t.c * i + t.e, this.y = t.b * e + t.d * i + t.f, this;
    }
}
function $e4b487e979d7c06d$var$mt(t, e, i) {
    return Math.abs(e - t) < (i || 1e-6);
}
class $e4b487e979d7c06d$var$vt {
    constructor(...t){
        this.init(...t);
    }
    static formatTransforms(t) {
        const e = "both" === t.flip || !0 === t.flip, i = t.flip && (e || "x" === t.flip) ? -1 : 1, a = t.flip && (e || "y" === t.flip) ? -1 : 1, s = t.skew && t.skew.length ? t.skew[0] : isFinite(t.skew) ? t.skew : isFinite(t.skewX) ? t.skewX : 0, r = t.skew && t.skew.length ? t.skew[1] : isFinite(t.skew) ? t.skew : isFinite(t.skewY) ? t.skewY : 0, n = t.scale && t.scale.length ? t.scale[0] * i : isFinite(t.scale) ? t.scale * i : isFinite(t.scaleX) ? t.scaleX * i : i, o = t.scale && t.scale.length ? t.scale[1] * a : isFinite(t.scale) ? t.scale * a : isFinite(t.scaleY) ? t.scaleY * a : a, l = t.shear || 0, h = t.rotate || t.theta || 0, c = new $e4b487e979d7c06d$var$bt(t.origin || t.around || t.ox || t.originX, t.oy || t.originY), d = c.x, u = c.y, g = new $e4b487e979d7c06d$var$bt(t.position || t.px || t.positionX || NaN, t.py || t.positionY || NaN), p = g.x, f = g.y, x = new $e4b487e979d7c06d$var$bt(t.translate || t.tx || t.translateX, t.ty || t.translateY), b = x.x, m = x.y, v = new $e4b487e979d7c06d$var$bt(t.relative || t.rx || t.relativeX, t.ry || t.relativeY);
        return {
            scaleX: n,
            scaleY: o,
            skewX: s,
            skewY: r,
            shear: l,
            theta: h,
            rx: v.x,
            ry: v.y,
            tx: b,
            ty: m,
            ox: d,
            oy: u,
            px: p,
            py: f
        };
    }
    static fromArray(t) {
        return {
            a: t[0],
            b: t[1],
            c: t[2],
            d: t[3],
            e: t[4],
            f: t[5]
        };
    }
    static isMatrixLike(t) {
        return null != t.a || null != t.b || null != t.c || null != t.d || null != t.e || null != t.f;
    }
    static matrixMultiply(t, e, i) {
        const a = t.a * e.a + t.c * e.b, s = t.b * e.a + t.d * e.b, r = t.a * e.c + t.c * e.d, n = t.b * e.c + t.d * e.d, o = t.e + t.a * e.e + t.c * e.f, l = t.f + t.b * e.e + t.d * e.f;
        return i.a = a, i.b = s, i.c = r, i.d = n, i.e = o, i.f = l, i;
    }
    around(t, e, i) {
        return this.clone().aroundO(t, e, i);
    }
    aroundO(t, e, i) {
        const a = t || 0, s = e || 0;
        return this.translateO(-a, -s).lmultiplyO(i).translateO(a, s);
    }
    clone() {
        return new $e4b487e979d7c06d$var$vt(this);
    }
    decompose(t = 0, e = 0) {
        const i = this.a, a = this.b, s = this.c, r = this.d, n = this.e, o = this.f, l = i * r - a * s, h = l > 0 ? 1 : -1, c = h * Math.sqrt(i * i + a * a), d = Math.atan2(h * a, h * i), u = 180 / Math.PI * d, g = Math.cos(d), p = Math.sin(d), f = (i * s + a * r) / l, x = s * c / (f * i - a) || r * c / (f * a + i);
        return {
            scaleX: c,
            scaleY: x,
            shear: f,
            rotate: u,
            translateX: n - t + t * g * c + e * (f * g * c - p * x),
            translateY: o - e + t * p * c + e * (f * p * c + g * x),
            originX: t,
            originY: e,
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
    equals(t) {
        if (t === this) return !0;
        const e = new $e4b487e979d7c06d$var$vt(t);
        return $e4b487e979d7c06d$var$mt(this.a, e.a) && $e4b487e979d7c06d$var$mt(this.b, e.b) && $e4b487e979d7c06d$var$mt(this.c, e.c) && $e4b487e979d7c06d$var$mt(this.d, e.d) && $e4b487e979d7c06d$var$mt(this.e, e.e) && $e4b487e979d7c06d$var$mt(this.f, e.f);
    }
    flip(t, e) {
        return this.clone().flipO(t, e);
    }
    flipO(t, e) {
        return "x" === t ? this.scaleO(-1, 1, e, 0) : "y" === t ? this.scaleO(1, -1, 0, e) : this.scaleO(-1, -1, t, e || t);
    }
    init(t) {
        const e = $e4b487e979d7c06d$var$vt.fromArray([
            1,
            0,
            0,
            1,
            0,
            0
        ]);
        return t = t instanceof $e4b487e979d7c06d$var$Gt ? t.matrixify() : "string" == typeof t ? $e4b487e979d7c06d$var$vt.fromArray(t.split($e4b487e979d7c06d$var$dt).map(parseFloat)) : Array.isArray(t) ? $e4b487e979d7c06d$var$vt.fromArray(t) : "object" == typeof t && $e4b487e979d7c06d$var$vt.isMatrixLike(t) ? t : "object" == typeof t ? (new $e4b487e979d7c06d$var$vt).transform(t) : 6 === arguments.length ? $e4b487e979d7c06d$var$vt.fromArray([].slice.call(arguments)) : e, this.a = null != t.a ? t.a : e.a, this.b = null != t.b ? t.b : e.b, this.c = null != t.c ? t.c : e.c, this.d = null != t.d ? t.d : e.d, this.e = null != t.e ? t.e : e.e, this.f = null != t.f ? t.f : e.f, this;
    }
    inverse() {
        return this.clone().inverseO();
    }
    inverseO() {
        const t = this.a, e = this.b, i = this.c, a = this.d, s = this.e, r = this.f, n = t * a - e * i;
        if (!n) throw new Error("Cannot invert " + this);
        const o = a / n, l = -e / n, h = -i / n, c = t / n, d = -(o * s + h * r), u = -(l * s + c * r);
        return this.a = o, this.b = l, this.c = h, this.d = c, this.e = d, this.f = u, this;
    }
    lmultiply(t) {
        return this.clone().lmultiplyO(t);
    }
    lmultiplyO(t) {
        const e = t instanceof $e4b487e979d7c06d$var$vt ? t : new $e4b487e979d7c06d$var$vt(t);
        return $e4b487e979d7c06d$var$vt.matrixMultiply(e, this, this);
    }
    multiply(t) {
        return this.clone().multiplyO(t);
    }
    multiplyO(t) {
        const e = t instanceof $e4b487e979d7c06d$var$vt ? t : new $e4b487e979d7c06d$var$vt(t);
        return $e4b487e979d7c06d$var$vt.matrixMultiply(this, e, this);
    }
    rotate(t, e, i) {
        return this.clone().rotateO(t, e, i);
    }
    rotateO(t, e = 0, i = 0) {
        t = $e4b487e979d7c06d$var$M(t);
        const a = Math.cos(t), s = Math.sin(t), { a: r, b: n, c: o, d: l, e: h, f: c } = this;
        return this.a = r * a - n * s, this.b = n * a + r * s, this.c = o * a - l * s, this.d = l * a + o * s, this.e = h * a - c * s + i * s - e * a + e, this.f = c * a + h * s - e * s - i * a + i, this;
    }
    scale() {
        return this.clone().scaleO(...arguments);
    }
    scaleO(t, e = t, i = 0, a = 0) {
        3 === arguments.length && (a = i, i = e, e = t);
        const { a: s, b: r, c: n, d: o, e: l, f: h } = this;
        return this.a = s * t, this.b = r * e, this.c = n * t, this.d = o * e, this.e = l * t - i * t + i, this.f = h * e - a * e + a, this;
    }
    shear(t, e, i) {
        return this.clone().shearO(t, e, i);
    }
    shearO(t, e = 0, i = 0) {
        const { a: a, b: s, c: r, d: n, e: o, f: l } = this;
        return this.a = a + s * t, this.c = r + n * t, this.e = o + l * t - i * t, this;
    }
    skew() {
        return this.clone().skewO(...arguments);
    }
    skewO(t, e = t, i = 0, a = 0) {
        3 === arguments.length && (a = i, i = e, e = t), t = $e4b487e979d7c06d$var$M(t), e = $e4b487e979d7c06d$var$M(e);
        const s = Math.tan(t), r = Math.tan(e), { a: n, b: o, c: l, d: h, e: c, f: d } = this;
        return this.a = n + o * s, this.b = o + n * r, this.c = l + h * s, this.d = h + l * r, this.e = c + d * s - a * s, this.f = d + c * r - i * r, this;
    }
    skewX(t, e, i) {
        return this.skew(t, 0, e, i);
    }
    skewY(t, e, i) {
        return this.skew(0, t, e, i);
    }
    toArray() {
        return [
            this.a,
            this.b,
            this.c,
            this.d,
            this.e,
            this.f
        ];
    }
    toString() {
        return "matrix(" + this.a + "," + this.b + "," + this.c + "," + this.d + "," + this.e + "," + this.f + ")";
    }
    transform(t) {
        if ($e4b487e979d7c06d$var$vt.isMatrixLike(t)) return new $e4b487e979d7c06d$var$vt(t).multiplyO(this);
        const e = $e4b487e979d7c06d$var$vt.formatTransforms(t), { x: i, y: a } = new $e4b487e979d7c06d$var$bt(e.ox, e.oy).transform(this), s = (new $e4b487e979d7c06d$var$vt).translateO(e.rx, e.ry).lmultiplyO(this).translateO(-i, -a).scaleO(e.scaleX, e.scaleY).skewO(e.skewX, e.skewY).shearO(e.shear).rotateO(e.theta).translateO(i, a);
        if (isFinite(e.px) || isFinite(e.py)) {
            const t = new $e4b487e979d7c06d$var$bt(i, a).transform(s), r = isFinite(e.px) ? e.px - t.x : 0, n = isFinite(e.py) ? e.py - t.y : 0;
            s.translateO(r, n);
        }
        return s.translateO(e.tx, e.ty), s;
    }
    translate(t, e) {
        return this.clone().translateO(t, e);
    }
    translateO(t, e) {
        return this.e += t || 0, this.f += e || 0, this;
    }
    valueOf() {
        return {
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
}
function $e4b487e979d7c06d$var$yt() {
    if (!$e4b487e979d7c06d$var$yt.nodes) {
        const t = $e4b487e979d7c06d$var$B().size(2, 0);
        t.node.style.cssText = [
            "opacity: 0",
            "position: absolute",
            "left: -100%",
            "top: -100%",
            "overflow: hidden"
        ].join(";"), t.attr("focusable", "false"), t.attr("aria-hidden", "true");
        const e = t.path().node;
        $e4b487e979d7c06d$var$yt.nodes = {
            svg: t,
            path: e
        };
    }
    if (!$e4b487e979d7c06d$var$yt.nodes.svg.node.parentNode) {
        const t = $e4b487e979d7c06d$var$O.document.body || $e4b487e979d7c06d$var$O.document.documentElement;
        $e4b487e979d7c06d$var$yt.nodes.svg.addTo(t);
    }
    return $e4b487e979d7c06d$var$yt.nodes;
}
function $e4b487e979d7c06d$var$wt(t) {
    return !(t.width || t.height || t.x || t.y);
}
$e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$vt, "Matrix");
class $e4b487e979d7c06d$var$kt {
    constructor(...t){
        this.init(...t);
    }
    addOffset() {
        return this.x += $e4b487e979d7c06d$var$O.window.pageXOffset, this.y += $e4b487e979d7c06d$var$O.window.pageYOffset, new $e4b487e979d7c06d$var$kt(this);
    }
    init(t) {
        return t = "string" == typeof t ? t.split($e4b487e979d7c06d$var$dt).map(parseFloat) : Array.isArray(t) ? t : "object" == typeof t ? [
            null != t.left ? t.left : t.x,
            null != t.top ? t.top : t.y,
            t.width,
            t.height
        ] : 4 === arguments.length ? [].slice.call(arguments) : [
            0,
            0,
            0,
            0
        ], this.x = t[0] || 0, this.y = t[1] || 0, this.width = this.w = t[2] || 0, this.height = this.h = t[3] || 0, this.x2 = this.x + this.w, this.y2 = this.y + this.h, this.cx = this.x + this.w / 2, this.cy = this.y + this.h / 2, this;
    }
    isNulled() {
        return $e4b487e979d7c06d$var$wt(this);
    }
    merge(t) {
        const e = Math.min(this.x, t.x), i = Math.min(this.y, t.y), a = Math.max(this.x + this.width, t.x + t.width) - e, s = Math.max(this.y + this.height, t.y + t.height) - i;
        return new $e4b487e979d7c06d$var$kt(e, i, a, s);
    }
    toArray() {
        return [
            this.x,
            this.y,
            this.width,
            this.height
        ];
    }
    toString() {
        return this.x + " " + this.y + " " + this.width + " " + this.height;
    }
    transform(t) {
        t instanceof $e4b487e979d7c06d$var$vt || (t = new $e4b487e979d7c06d$var$vt(t));
        let e = 1 / 0, i = -1 / 0, a = 1 / 0, s = -1 / 0;
        return [
            new $e4b487e979d7c06d$var$bt(this.x, this.y),
            new $e4b487e979d7c06d$var$bt(this.x2, this.y),
            new $e4b487e979d7c06d$var$bt(this.x, this.y2),
            new $e4b487e979d7c06d$var$bt(this.x2, this.y2)
        ].forEach(function(r) {
            r = r.transform(t), e = Math.min(e, r.x), i = Math.max(i, r.x), a = Math.min(a, r.y), s = Math.max(s, r.y);
        }), new $e4b487e979d7c06d$var$kt(e, a, i - e, s - a);
    }
}
function $e4b487e979d7c06d$var$At(t, e, i) {
    let a;
    try {
        if (a = e(t.node), $e4b487e979d7c06d$var$wt(a) && (s = t.node) !== $e4b487e979d7c06d$var$O.document && !($e4b487e979d7c06d$var$O.document.documentElement.contains || function(t) {
            for(; t.parentNode;)t = t.parentNode;
            return t === $e4b487e979d7c06d$var$O.document;
        }).call($e4b487e979d7c06d$var$O.document.documentElement, s)) throw new Error("Element not in the dom");
    } catch (e) {
        a = i(t);
    }
    var s;
    return a;
}
$e4b487e979d7c06d$var$A({
    viewbox: {
        viewbox (t, e, i, a) {
            return null == t ? new $e4b487e979d7c06d$var$kt(this.attr("viewBox")) : this.attr("viewBox", new $e4b487e979d7c06d$var$kt(t, e, i, a));
        },
        zoom (t, e) {
            let { width: i, height: a } = this.attr([
                "width",
                "height"
            ]);
            if ((i || a) && "string" != typeof i && "string" != typeof a || (i = this.node.clientWidth, a = this.node.clientHeight), !i || !a) throw new Error("Impossible to get absolute width and height. Please provide an absolute width and height attribute on the zooming element");
            const s = this.viewbox(), r = i / s.width, n = a / s.height, o = Math.min(r, n);
            if (null == t) return o;
            let l = o / t;
            l === 1 / 0 && (l = Number.MAX_SAFE_INTEGER / 100), e = e || new $e4b487e979d7c06d$var$bt(i / 2 / r + s.x, a / 2 / n + s.y);
            const h = new $e4b487e979d7c06d$var$kt(s).transform(new $e4b487e979d7c06d$var$vt({
                scale: l,
                origin: e
            }));
            return this.viewbox(h);
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$kt, "Box");
class $e4b487e979d7c06d$var$Ct extends Array {
    constructor(t = [], ...e){
        if (super(t, ...e), "number" == typeof t) return this;
        this.length = 0, this.push(...t);
    }
}
$e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$Ct
], {
    each (t, ...e) {
        return "function" == typeof t ? this.map((e, i, a)=>t.call(e, e, i, a)) : this.map((i)=>i[t](...e));
    },
    toArray () {
        return Array.prototype.concat.apply([], this);
    }
});
const $e4b487e979d7c06d$var$St = [
    "toArray",
    "constructor",
    "each"
];
function $e4b487e979d7c06d$var$Lt(t, e) {
    return new $e4b487e979d7c06d$var$Ct($e4b487e979d7c06d$var$L((e || $e4b487e979d7c06d$var$O.document).querySelectorAll(t), function(t) {
        return $e4b487e979d7c06d$var$V(t);
    }));
}
$e4b487e979d7c06d$var$Ct.extend = function(t) {
    t = t.reduce((t, e)=>($e4b487e979d7c06d$var$St.includes(e) || "_" === e[0] || (e in Array.prototype && (t["$" + e] = Array.prototype[e]), t[e] = function(...t) {
            return this.each(e, ...t);
        }), t), {}), $e4b487e979d7c06d$var$Q([
        $e4b487e979d7c06d$var$Ct
    ], t);
};
let $e4b487e979d7c06d$var$Mt = 0;
const $e4b487e979d7c06d$var$Pt = {};
function $e4b487e979d7c06d$var$It(t) {
    let e = t.getEventHolder();
    return e === $e4b487e979d7c06d$var$O.window && (e = $e4b487e979d7c06d$var$Pt), e.events || (e.events = {}), e.events;
}
function $e4b487e979d7c06d$var$Tt(t) {
    return t.getEventTarget();
}
function $e4b487e979d7c06d$var$zt(t, e, i, a, s) {
    const r = i.bind(a || t), n = $e4b487e979d7c06d$var$B(t), o = $e4b487e979d7c06d$var$It(n), l = $e4b487e979d7c06d$var$Tt(n);
    e = Array.isArray(e) ? e : e.split($e4b487e979d7c06d$var$dt), i._svgjsListenerId || (i._svgjsListenerId = ++$e4b487e979d7c06d$var$Mt), e.forEach(function(t) {
        const e = t.split(".")[0], a = t.split(".")[1] || "*";
        o[e] = o[e] || {}, o[e][a] = o[e][a] || {}, o[e][a][i._svgjsListenerId] = r, l.addEventListener(e, r, s || !1);
    });
}
function $e4b487e979d7c06d$var$Xt(t, e, i, a) {
    const s = $e4b487e979d7c06d$var$B(t), r = $e4b487e979d7c06d$var$It(s), n = $e4b487e979d7c06d$var$Tt(s);
    ("function" != typeof i || (i = i._svgjsListenerId)) && (e = Array.isArray(e) ? e : (e || "").split($e4b487e979d7c06d$var$dt)).forEach(function(t) {
        const e = t && t.split(".")[0], o = t && t.split(".")[1];
        let l, h;
        if (i) r[e] && r[e][o || "*"] && (n.removeEventListener(e, r[e][o || "*"][i], a || !1), delete r[e][o || "*"][i]);
        else if (e && o) {
            if (r[e] && r[e][o]) {
                for(h in r[e][o])$e4b487e979d7c06d$var$Xt(n, [
                    e,
                    o
                ].join("."), h);
                delete r[e][o];
            }
        } else if (o) for(t in r)for(l in r[t])o === l && $e4b487e979d7c06d$var$Xt(n, [
            t,
            o
        ].join("."));
        else if (e) {
            if (r[e]) {
                for(l in r[e])$e4b487e979d7c06d$var$Xt(n, [
                    e,
                    l
                ].join("."));
                delete r[e];
            }
        } else {
            for(t in r)$e4b487e979d7c06d$var$Xt(n, t);
            !function(t) {
                let e = t.getEventHolder();
                e === $e4b487e979d7c06d$var$O.window && (e = $e4b487e979d7c06d$var$Pt), e.events && (e.events = {});
            }(s);
        }
    });
}
class $e4b487e979d7c06d$var$Rt extends $e4b487e979d7c06d$var$D {
    addEventListener() {}
    dispatch(t, e, i) {
        return function(t, e, i, a) {
            const s = $e4b487e979d7c06d$var$Tt(t);
            return e instanceof $e4b487e979d7c06d$var$O.window.Event || (e = new $e4b487e979d7c06d$var$O.window.CustomEvent(e, {
                detail: i,
                cancelable: !0,
                ...a
            })), s.dispatchEvent(e), e;
        }(this, t, e, i);
    }
    dispatchEvent(t) {
        const e = this.getEventHolder().events;
        if (!e) return !0;
        const i = e[t.type];
        for(const e in i)for(const a in i[e])i[e][a](t);
        return !t.defaultPrevented;
    }
    fire(t, e, i) {
        return this.dispatch(t, e, i), this;
    }
    getEventHolder() {
        return this;
    }
    getEventTarget() {
        return this;
    }
    off(t, e, i) {
        return $e4b487e979d7c06d$var$Xt(this, t, e, i), this;
    }
    on(t, e, i, a) {
        return $e4b487e979d7c06d$var$zt(this, t, e, i, a), this;
    }
    removeEventListener() {}
}
function $e4b487e979d7c06d$var$Et() {}
$e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Rt, "EventTarget");
const $e4b487e979d7c06d$var$Yt = 400, $e4b487e979d7c06d$var$Ht = ">", $e4b487e979d7c06d$var$Ot = 0, $e4b487e979d7c06d$var$Ft = {
    "fill-opacity": 1,
    "stroke-opacity": 1,
    "stroke-width": 0,
    "stroke-linejoin": "miter",
    "stroke-linecap": "butt",
    fill: "#000000",
    stroke: "#000000",
    opacity: 1,
    x: 0,
    y: 0,
    cx: 0,
    cy: 0,
    width: 0,
    height: 0,
    r: 0,
    rx: 0,
    ry: 0,
    offset: 0,
    "stop-opacity": 1,
    "stop-color": "#000000",
    "text-anchor": "start"
};
class $e4b487e979d7c06d$var$Dt extends Array {
    constructor(...t){
        super(...t), this.init(...t);
    }
    clone() {
        return new this.constructor(this);
    }
    init(t) {
        return "number" == typeof t || (this.length = 0, this.push(...this.parse(t))), this;
    }
    parse(t = []) {
        return t instanceof Array ? t : t.trim().split($e4b487e979d7c06d$var$dt).map(parseFloat);
    }
    toArray() {
        return Array.prototype.concat.apply([], this);
    }
    toSet() {
        return new Set(this);
    }
    toString() {
        return this.join(" ");
    }
    valueOf() {
        const t = [];
        return t.push(...this), t;
    }
}
class $e4b487e979d7c06d$var$_t {
    constructor(...t){
        this.init(...t);
    }
    convert(t) {
        return new $e4b487e979d7c06d$var$_t(this.value, t);
    }
    divide(t) {
        return t = new $e4b487e979d7c06d$var$_t(t), new $e4b487e979d7c06d$var$_t(this / t, this.unit || t.unit);
    }
    init(t, e) {
        return e = Array.isArray(t) ? t[1] : e, t = Array.isArray(t) ? t[0] : t, this.value = 0, this.unit = e || "", "number" == typeof t ? this.value = isNaN(t) ? 0 : isFinite(t) ? t : t < 0 ? -340000000000000000000000000000000000000 : 34e37 : "string" == typeof t ? (e = t.match($e4b487e979d7c06d$var$tt)) && (this.value = parseFloat(e[1]), "%" === e[5] ? this.value /= 100 : "s" === e[5] && (this.value *= 1e3), this.unit = e[5]) : t instanceof $e4b487e979d7c06d$var$_t && (this.value = t.valueOf(), this.unit = t.unit), this;
    }
    minus(t) {
        return t = new $e4b487e979d7c06d$var$_t(t), new $e4b487e979d7c06d$var$_t(this - t, this.unit || t.unit);
    }
    plus(t) {
        return t = new $e4b487e979d7c06d$var$_t(t), new $e4b487e979d7c06d$var$_t(this + t, this.unit || t.unit);
    }
    times(t) {
        return t = new $e4b487e979d7c06d$var$_t(t), new $e4b487e979d7c06d$var$_t(this * t, this.unit || t.unit);
    }
    toArray() {
        return [
            this.value,
            this.unit
        ];
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return ("%" === this.unit ? ~~(1e8 * this.value) / 1e6 : "s" === this.unit ? this.value / 1e3 : this.value) + this.unit;
    }
    valueOf() {
        return this.value;
    }
}
const $e4b487e979d7c06d$var$Nt = new Set([
    "fill",
    "stroke",
    "color",
    "bgcolor",
    "stop-color",
    "flood-color",
    "lighting-color"
]), $e4b487e979d7c06d$var$Wt = [];
class $e4b487e979d7c06d$var$Bt extends $e4b487e979d7c06d$var$Rt {
    constructor(t, e){
        super(), this.node = t, this.type = t.nodeName, e && t !== e && this.attr(e);
    }
    add(t, e) {
        return (t = $e4b487e979d7c06d$var$B(t)).removeNamespace && this.node instanceof $e4b487e979d7c06d$var$O.window.SVGElement && t.removeNamespace(), null == e ? this.node.appendChild(t.node) : t.node !== this.node.childNodes[e] && this.node.insertBefore(t.node, this.node.childNodes[e]), this;
    }
    addTo(t, e) {
        return $e4b487e979d7c06d$var$B(t).put(this, e);
    }
    children() {
        return new $e4b487e979d7c06d$var$Ct($e4b487e979d7c06d$var$L(this.node.children, function(t) {
            return $e4b487e979d7c06d$var$V(t);
        }));
    }
    clear() {
        for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
        return this;
    }
    clone(t = !0, e = !0) {
        this.writeDataToDom();
        let i = this.node.cloneNode(t);
        return e && (i = $e4b487e979d7c06d$var$J(i)), new this.constructor(i);
    }
    each(t, e) {
        const i = this.children();
        let a, s;
        for(a = 0, s = i.length; a < s; a++)t.apply(i[a], [
            a,
            i
        ]), e && i[a].each(t, e);
        return this;
    }
    element(t, e) {
        return this.put(new $e4b487e979d7c06d$var$Bt($e4b487e979d7c06d$var$W(t), e));
    }
    first() {
        return $e4b487e979d7c06d$var$V(this.node.firstChild);
    }
    get(t) {
        return $e4b487e979d7c06d$var$V(this.node.childNodes[t]);
    }
    getEventHolder() {
        return this.node;
    }
    getEventTarget() {
        return this.node;
    }
    has(t) {
        return this.index(t) >= 0;
    }
    html(t, e) {
        return this.xml(t, e, "http://www.w3.org/1999/xhtml");
    }
    id(t) {
        return void 0 !== t || this.node.id || (this.node.id = $e4b487e979d7c06d$var$$(this.type)), this.attr("id", t);
    }
    index(t) {
        return [].slice.call(this.node.childNodes).indexOf(t.node);
    }
    last() {
        return $e4b487e979d7c06d$var$V(this.node.lastChild);
    }
    matches(t) {
        const e = this.node, i = e.matches || e.matchesSelector || e.msMatchesSelector || e.mozMatchesSelector || e.webkitMatchesSelector || e.oMatchesSelector || null;
        return i && i.call(e, t);
    }
    parent(t) {
        let e = this;
        if (!e.node.parentNode) return null;
        if (e = $e4b487e979d7c06d$var$V(e.node.parentNode), !t) return e;
        do {
            if ("string" == typeof t ? e.matches(t) : e instanceof t) return e;
        }while (e = $e4b487e979d7c06d$var$V(e.node.parentNode));
        return e;
    }
    put(t, e) {
        return t = $e4b487e979d7c06d$var$B(t), this.add(t, e), t;
    }
    putIn(t, e) {
        return $e4b487e979d7c06d$var$B(t).add(this, e);
    }
    remove() {
        return this.parent() && this.parent().removeElement(this), this;
    }
    removeElement(t) {
        return this.node.removeChild(t.node), this;
    }
    replace(t) {
        return t = $e4b487e979d7c06d$var$B(t), this.node.parentNode && this.node.parentNode.replaceChild(t.node, this.node), t;
    }
    round(t = 2, e = null) {
        const i = 10 ** t, a = this.attr(e);
        for(const t in a)"number" == typeof a[t] && (a[t] = Math.round(a[t] * i) / i);
        return this.attr(a), this;
    }
    svg(t, e) {
        return this.xml(t, e, $e4b487e979d7c06d$var$E);
    }
    toString() {
        return this.id();
    }
    words(t) {
        return this.node.textContent = t, this;
    }
    wrap(t) {
        const e = this.parent();
        if (!e) return this.addTo(t);
        const i = e.index(this);
        return e.put(t, i).put(this);
    }
    writeDataToDom() {
        return this.each(function() {
            this.writeDataToDom();
        }), this;
    }
    xml(t, e, i) {
        if ("boolean" == typeof t && (i = e, e = t, t = null), null == t || "function" == typeof t) {
            e = null == e || e, this.writeDataToDom();
            let i = this;
            if (null != t) {
                if (i = $e4b487e979d7c06d$var$V(i.node.cloneNode(!0)), e) {
                    const e = t(i);
                    if (i = e || i, !1 === e) return "";
                }
                i.each(function() {
                    const e = t(this), i = e || this;
                    !1 === e ? this.remove() : e && this !== i && this.replace(i);
                }, !0);
            }
            return e ? i.node.outerHTML : i.node.innerHTML;
        }
        e = null != e && e;
        const a = $e4b487e979d7c06d$var$W("wrapper", i), s = $e4b487e979d7c06d$var$O.document.createDocumentFragment();
        a.innerHTML = t;
        for(let t = a.children.length; t--;)s.appendChild(a.firstElementChild);
        const r = this.parent();
        return e ? this.replace(s) && r : this.add(s);
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Bt, {
    attr: function(t, e, i) {
        if (null == t) {
            t = {}, e = this.node.attributes;
            for (const i of e)t[i.nodeName] = $e4b487e979d7c06d$var$ht.test(i.nodeValue) ? parseFloat(i.nodeValue) : i.nodeValue;
            return t;
        }
        if (t instanceof Array) return t.reduce((t, e)=>(t[e] = this.attr(e), t), {});
        if ("object" == typeof t && t.constructor === Object) for(e in t)this.attr(e, t[e]);
        else if (null === e) this.node.removeAttribute(t);
        else {
            if (null == e) return null == (e = this.node.getAttribute(t)) ? $e4b487e979d7c06d$var$Ft[t] : $e4b487e979d7c06d$var$ht.test(e) ? parseFloat(e) : e;
            "number" == typeof (e = $e4b487e979d7c06d$var$Wt.reduce((e, i)=>i(t, e, this), e)) ? e = new $e4b487e979d7c06d$var$_t(e) : $e4b487e979d7c06d$var$Nt.has(t) && $e4b487e979d7c06d$var$xt.isColor(e) ? e = new $e4b487e979d7c06d$var$xt(e) : e.constructor === Array && (e = new $e4b487e979d7c06d$var$Dt(e)), "leading" === t ? this.leading && this.leading(e) : "string" == typeof i ? this.node.setAttributeNS(i, t, e.toString()) : this.node.setAttribute(t, e.toString()), !this.rebuild || "font-size" !== t && "x" !== t || this.rebuild();
        }
        return this;
    },
    find: function(t) {
        return $e4b487e979d7c06d$var$Lt(t, this.node);
    },
    findOne: function(t) {
        return $e4b487e979d7c06d$var$V(this.node.querySelector(t));
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Bt, "Dom");
let $e4b487e979d7c06d$var$Gt = class extends $e4b487e979d7c06d$var$Bt {
    constructor(t, e){
        super(t, e), this.dom = {}, this.node.instance = this, (t.hasAttribute("data-svgjs") || t.hasAttribute("svgjs:data")) && this.setData(JSON.parse(t.getAttribute("data-svgjs")) ?? JSON.parse(t.getAttribute("svgjs:data")) ?? {});
    }
    center(t, e) {
        return this.cx(t).cy(e);
    }
    cx(t) {
        return null == t ? this.x() + this.width() / 2 : this.x(t - this.width() / 2);
    }
    cy(t) {
        return null == t ? this.y() + this.height() / 2 : this.y(t - this.height() / 2);
    }
    defs() {
        const t = this.root();
        return t && t.defs();
    }
    dmove(t, e) {
        return this.dx(t).dy(e);
    }
    dx(t = 0) {
        return this.x(new $e4b487e979d7c06d$var$_t(t).plus(this.x()));
    }
    dy(t = 0) {
        return this.y(new $e4b487e979d7c06d$var$_t(t).plus(this.y()));
    }
    getEventHolder() {
        return this;
    }
    height(t) {
        return this.attr("height", t);
    }
    move(t, e) {
        return this.x(t).y(e);
    }
    parents(t = this.root()) {
        const e = "string" == typeof t;
        e || (t = $e4b487e979d7c06d$var$B(t));
        const i = new $e4b487e979d7c06d$var$Ct;
        let a = this;
        for(; (a = a.parent()) && a.node !== $e4b487e979d7c06d$var$O.document && "#document-fragment" !== a.nodeName && (i.push(a), e || a.node !== t.node) && (!e || !a.matches(t));)if (a.node === this.root().node) return null;
        return i;
    }
    reference(t) {
        if (!(t = this.attr(t))) return null;
        const e = (t + "").match($e4b487e979d7c06d$var$at);
        return e ? $e4b487e979d7c06d$var$B(e[1]) : null;
    }
    root() {
        const t = this.parent(function(t) {
            return $e4b487e979d7c06d$var$_[t];
        }($e4b487e979d7c06d$var$N));
        return t && t.root();
    }
    setData(t) {
        return this.dom = t, this;
    }
    size(t, e) {
        const i = $e4b487e979d7c06d$var$I(this, t, e);
        return this.width(new $e4b487e979d7c06d$var$_t(i.width)).height(new $e4b487e979d7c06d$var$_t(i.height));
    }
    width(t) {
        return this.attr("width", t);
    }
    writeDataToDom() {
        return $e4b487e979d7c06d$var$R(this, this.dom), super.writeDataToDom();
    }
    x(t) {
        return this.attr("x", t);
    }
    y(t) {
        return this.attr("y", t);
    }
};
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Gt, {
    bbox: function() {
        const t = $e4b487e979d7c06d$var$At(this, (t)=>t.getBBox(), (t)=>{
            try {
                const e = t.clone().addTo($e4b487e979d7c06d$var$yt().svg).show(), i = e.node.getBBox();
                return e.remove(), i;
            } catch (e) {
                throw new Error(`Getting bbox of element "${t.node.nodeName}" is not possible: ${e.toString()}`);
            }
        });
        return new $e4b487e979d7c06d$var$kt(t);
    },
    rbox: function(t) {
        const e = $e4b487e979d7c06d$var$At(this, (t)=>t.getBoundingClientRect(), (t)=>{
            throw new Error(`Getting rbox of element "${t.node.nodeName}" is not possible`);
        }), i = new $e4b487e979d7c06d$var$kt(e);
        return t ? i.transform(t.screenCTM().inverseO()) : i.addOffset();
    },
    inside: function(t, e) {
        const i = this.bbox();
        return t > i.x && e > i.y && t < i.x + i.width && e < i.y + i.height;
    },
    point: function(t, e) {
        return new $e4b487e979d7c06d$var$bt(t, e).transformO(this.screenCTM().inverseO());
    },
    ctm: function() {
        return new $e4b487e979d7c06d$var$vt(this.node.getCTM());
    },
    screenCTM: function() {
        try {
            if ("function" == typeof this.isRoot && !this.isRoot()) {
                const t = this.rect(1, 1), e = t.node.getScreenCTM();
                return t.remove(), new $e4b487e979d7c06d$var$vt(e);
            }
            return new $e4b487e979d7c06d$var$vt(this.node.getScreenCTM());
        } catch (t) {
            return console.warn(`Cannot get CTM from SVG node ${this.node.nodeName}. Is the element rendered?`), new $e4b487e979d7c06d$var$vt;
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Gt, "Element");
const $e4b487e979d7c06d$var$jt = {
    stroke: [
        "color",
        "width",
        "opacity",
        "linecap",
        "linejoin",
        "miterlimit",
        "dasharray",
        "dashoffset"
    ],
    fill: [
        "color",
        "opacity",
        "rule"
    ],
    prefix: function(t, e) {
        return "color" === e ? t : t + "-" + e;
    }
};
[
    "fill",
    "stroke"
].forEach(function(t) {
    const e = {};
    let i;
    e[t] = function(e) {
        if (void 0 === e) return this.attr(t);
        if ("string" == typeof e || e instanceof $e4b487e979d7c06d$var$xt || $e4b487e979d7c06d$var$xt.isRgb(e) || e instanceof $e4b487e979d7c06d$var$Gt) this.attr(t, e);
        else for(i = $e4b487e979d7c06d$var$jt[t].length - 1; i >= 0; i--)null != e[$e4b487e979d7c06d$var$jt[t][i]] && this.attr($e4b487e979d7c06d$var$jt.prefix(t, $e4b487e979d7c06d$var$jt[t][i]), e[$e4b487e979d7c06d$var$jt[t][i]]);
        return this;
    }, $e4b487e979d7c06d$var$A([
        "Element",
        "Runner"
    ], e);
}), $e4b487e979d7c06d$var$A([
    "Element",
    "Runner"
], {
    matrix: function(t, e, i, a, s, r) {
        return null == t ? new $e4b487e979d7c06d$var$vt(this) : this.attr("transform", new $e4b487e979d7c06d$var$vt(t, e, i, a, s, r));
    },
    rotate: function(t, e, i) {
        return this.transform({
            rotate: t,
            ox: e,
            oy: i
        }, !0);
    },
    skew: function(t, e, i, a) {
        return 1 === arguments.length || 3 === arguments.length ? this.transform({
            skew: t,
            ox: e,
            oy: i
        }, !0) : this.transform({
            skew: [
                t,
                e
            ],
            ox: i,
            oy: a
        }, !0);
    },
    shear: function(t, e, i) {
        return this.transform({
            shear: t,
            ox: e,
            oy: i
        }, !0);
    },
    scale: function(t, e, i, a) {
        return 1 === arguments.length || 3 === arguments.length ? this.transform({
            scale: t,
            ox: e,
            oy: i
        }, !0) : this.transform({
            scale: [
                t,
                e
            ],
            ox: i,
            oy: a
        }, !0);
    },
    translate: function(t, e) {
        return this.transform({
            translate: [
                t,
                e
            ]
        }, !0);
    },
    relative: function(t, e) {
        return this.transform({
            relative: [
                t,
                e
            ]
        }, !0);
    },
    flip: function(t = "both", e = "center") {
        return -1 === "xybothtrue".indexOf(t) && (e = t, t = "both"), this.transform({
            flip: t,
            origin: e
        }, !0);
    },
    opacity: function(t) {
        return this.attr("opacity", t);
    }
}), $e4b487e979d7c06d$var$A("radius", {
    radius: function(t, e = t) {
        return "radialGradient" === (this._element || this).type ? this.attr("r", new $e4b487e979d7c06d$var$_t(t)) : this.rx(t).ry(e);
    }
}), $e4b487e979d7c06d$var$A("Path", {
    length: function() {
        return this.node.getTotalLength();
    },
    pointAt: function(t) {
        return new $e4b487e979d7c06d$var$bt(this.node.getPointAtLength(t));
    }
}), $e4b487e979d7c06d$var$A([
    "Element",
    "Runner"
], {
    font: function(t, e) {
        if ("object" == typeof t) {
            for(e in t)this.font(e, t[e]);
            return this;
        }
        return "leading" === t ? this.leading(e) : "anchor" === t ? this.attr("text-anchor", e) : "size" === t || "family" === t || "weight" === t || "stretch" === t || "variant" === t || "style" === t ? this.attr("font-" + t, e) : this.attr(t, e);
    }
});
$e4b487e979d7c06d$var$A("Element", [
    "click",
    "dblclick",
    "mousedown",
    "mouseup",
    "mouseover",
    "mouseout",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "touchstart",
    "touchmove",
    "touchleave",
    "touchend",
    "touchcancel",
    "contextmenu",
    "wheel",
    "pointerdown",
    "pointermove",
    "pointerup",
    "pointerleave",
    "pointercancel"
].reduce(function(t, e) {
    return t[e] = function(t) {
        return null === t ? this.off(e) : this.on(e, t), this;
    }, t;
}, {})), $e4b487e979d7c06d$var$A("Element", {
    untransform: function() {
        return this.attr("transform", null);
    },
    matrixify: function() {
        const t = (this.attr("transform") || "").split($e4b487e979d7c06d$var$st).slice(0, -1).map(function(t) {
            const e = t.trim().split("(");
            return [
                e[0],
                e[1].split($e4b487e979d7c06d$var$dt).map(function(t) {
                    return parseFloat(t);
                })
            ];
        }).reverse().reduce(function(t, e) {
            return "matrix" === e[0] ? t.lmultiply($e4b487e979d7c06d$var$vt.fromArray(e[1])) : t[e[0]].apply(t, e[1]);
        }, new $e4b487e979d7c06d$var$vt);
        return t;
    },
    toParent: function(t, e) {
        if (this === t) return this;
        if ($e4b487e979d7c06d$var$X(this.node)) return this.addTo(t, e);
        const i = this.screenCTM(), a = t.screenCTM().inverse();
        return this.addTo(t, e).untransform().transform(a.multiply(i)), this;
    },
    toRoot: function(t) {
        return this.toParent(this.root(), t);
    },
    transform: function(t, e) {
        if (null == t || "string" == typeof t) {
            const e = new $e4b487e979d7c06d$var$vt(this).decompose();
            return null == t ? e : e[t];
        }
        $e4b487e979d7c06d$var$vt.isMatrixLike(t) || (t = {
            ...t,
            origin: $e4b487e979d7c06d$var$T(t, this)
        });
        const i = new $e4b487e979d7c06d$var$vt(!0 === e ? this : e || !1).transform(t);
        return this.attr("transform", i);
    }
});
class $e4b487e979d7c06d$var$Vt extends $e4b487e979d7c06d$var$Gt {
    flatten() {
        return this.each(function() {
            if (this instanceof $e4b487e979d7c06d$var$Vt) return this.flatten().ungroup();
        }), this;
    }
    ungroup(t = this.parent(), e = t.index(this)) {
        return e = -1 === e ? t.children().length : e, this.each(function(i, a) {
            return a[a.length - i - 1].toParent(t, e);
        }), this.remove();
    }
}
$e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Vt, "Container");
class $e4b487e979d7c06d$var$Ut extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("defs", t), e);
    }
    flatten() {
        return this;
    }
    ungroup() {
        return this;
    }
}
$e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Ut, "Defs");
class $e4b487e979d7c06d$var$qt extends $e4b487e979d7c06d$var$Gt {
}
function $e4b487e979d7c06d$var$Zt(t) {
    return this.attr("rx", t);
}
function $e4b487e979d7c06d$var$$t(t) {
    return this.attr("ry", t);
}
function $e4b487e979d7c06d$var$Jt(t) {
    return null == t ? this.cx() - this.rx() : this.cx(t + this.rx());
}
function $e4b487e979d7c06d$var$Qt(t) {
    return null == t ? this.cy() - this.ry() : this.cy(t + this.ry());
}
function $e4b487e979d7c06d$var$Kt(t) {
    return this.attr("cx", t);
}
function $e4b487e979d7c06d$var$te(t) {
    return this.attr("cy", t);
}
function $e4b487e979d7c06d$var$ee(t) {
    return null == t ? 2 * this.rx() : this.rx(new $e4b487e979d7c06d$var$_t(t).divide(2));
}
function $e4b487e979d7c06d$var$ie(t) {
    return null == t ? 2 * this.ry() : this.ry(new $e4b487e979d7c06d$var$_t(t).divide(2));
}
$e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$qt, "Shape");
var $e4b487e979d7c06d$var$ae = Object.freeze({
    __proto__: null,
    cx: $e4b487e979d7c06d$var$Kt,
    cy: $e4b487e979d7c06d$var$te,
    height: $e4b487e979d7c06d$var$ie,
    rx: $e4b487e979d7c06d$var$Zt,
    ry: $e4b487e979d7c06d$var$$t,
    width: $e4b487e979d7c06d$var$ee,
    x: $e4b487e979d7c06d$var$Jt,
    y: $e4b487e979d7c06d$var$Qt
});
class $e4b487e979d7c06d$var$se extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("ellipse", t), e);
    }
    size(t, e) {
        const i = $e4b487e979d7c06d$var$I(this, t, e);
        return this.rx(new $e4b487e979d7c06d$var$_t(i.width).divide(2)).ry(new $e4b487e979d7c06d$var$_t(i.height).divide(2));
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$se, $e4b487e979d7c06d$var$ae), $e4b487e979d7c06d$var$A("Container", {
    ellipse: $e4b487e979d7c06d$var$K(function(t = 0, e = t) {
        return this.put(new $e4b487e979d7c06d$var$se).size(t, e).move(0, 0);
    })
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$se, "Ellipse");
class $e4b487e979d7c06d$var$re extends $e4b487e979d7c06d$var$Bt {
    constructor(t = $e4b487e979d7c06d$var$O.document.createDocumentFragment()){
        super(t);
    }
    xml(t, e, i) {
        if ("boolean" == typeof t && (i = e, e = t, t = null), null == t || "function" == typeof t) {
            const t = new $e4b487e979d7c06d$var$Bt($e4b487e979d7c06d$var$W("wrapper", i));
            return t.add(this.node.cloneNode(!0)), t.xml(!1, i);
        }
        return super.xml(t, !1, i);
    }
}
function $e4b487e979d7c06d$var$ne(t, e) {
    return "radialGradient" === (this._element || this).type ? this.attr({
        fx: new $e4b487e979d7c06d$var$_t(t),
        fy: new $e4b487e979d7c06d$var$_t(e)
    }) : this.attr({
        x1: new $e4b487e979d7c06d$var$_t(t),
        y1: new $e4b487e979d7c06d$var$_t(e)
    });
}
function $e4b487e979d7c06d$var$oe(t, e) {
    return "radialGradient" === (this._element || this).type ? this.attr({
        cx: new $e4b487e979d7c06d$var$_t(t),
        cy: new $e4b487e979d7c06d$var$_t(e)
    }) : this.attr({
        x2: new $e4b487e979d7c06d$var$_t(t),
        y2: new $e4b487e979d7c06d$var$_t(e)
    });
}
$e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$re, "Fragment");
var $e4b487e979d7c06d$var$le = Object.freeze({
    __proto__: null,
    from: $e4b487e979d7c06d$var$ne,
    to: $e4b487e979d7c06d$var$oe
});
class $e4b487e979d7c06d$var$he extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e){
        super($e4b487e979d7c06d$var$G(t + "Gradient", "string" == typeof t ? null : t), e);
    }
    attr(t, e, i) {
        return "transform" === t && (t = "gradientTransform"), super.attr(t, e, i);
    }
    bbox() {
        return new $e4b487e979d7c06d$var$kt;
    }
    targets() {
        return $e4b487e979d7c06d$var$Lt("svg [fill*=" + this.id() + "]");
    }
    toString() {
        return this.url();
    }
    update(t) {
        return this.clear(), "function" == typeof t && t.call(this, this), this;
    }
    url() {
        return "url(#" + this.id() + ")";
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$he, $e4b487e979d7c06d$var$le), $e4b487e979d7c06d$var$A({
    Container: {
        gradient (...t) {
            return this.defs().gradient(...t);
        }
    },
    Defs: {
        gradient: $e4b487e979d7c06d$var$K(function(t, e) {
            return this.put(new $e4b487e979d7c06d$var$he(t)).update(e);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$he, "Gradient");
class $e4b487e979d7c06d$var$ce extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("pattern", t), e);
    }
    attr(t, e, i) {
        return "transform" === t && (t = "patternTransform"), super.attr(t, e, i);
    }
    bbox() {
        return new $e4b487e979d7c06d$var$kt;
    }
    targets() {
        return $e4b487e979d7c06d$var$Lt("svg [fill*=" + this.id() + "]");
    }
    toString() {
        return this.url();
    }
    update(t) {
        return this.clear(), "function" == typeof t && t.call(this, this), this;
    }
    url() {
        return "url(#" + this.id() + ")";
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        pattern (...t) {
            return this.defs().pattern(...t);
        }
    },
    Defs: {
        pattern: $e4b487e979d7c06d$var$K(function(t, e, i) {
            return this.put(new $e4b487e979d7c06d$var$ce).update(i).attr({
                x: 0,
                y: 0,
                width: t,
                height: e,
                patternUnits: "userSpaceOnUse"
            });
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$ce, "Pattern");
let $e4b487e979d7c06d$var$de = class extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("image", t), e);
    }
    load(t, e) {
        if (!t) return this;
        const i = new $e4b487e979d7c06d$var$O.window.Image;
        return $e4b487e979d7c06d$var$zt(i, "load", function(t) {
            const a = this.parent($e4b487e979d7c06d$var$ce);
            0 === this.width() && 0 === this.height() && this.size(i.width, i.height), a instanceof $e4b487e979d7c06d$var$ce && 0 === a.width() && 0 === a.height() && a.size(this.width(), this.height()), "function" == typeof e && e.call(this, t);
        }, this), $e4b487e979d7c06d$var$zt(i, "load error", function() {
            $e4b487e979d7c06d$var$Xt(i);
        }), this.attr("href", i.src = t, $e4b487e979d7c06d$var$H);
    }
};
var $e4b487e979d7c06d$var$ue;
$e4b487e979d7c06d$var$ue = function(t, e, i) {
    return "fill" !== t && "stroke" !== t || $e4b487e979d7c06d$var$ct.test(e) && (e = i.root().defs().image(e)), e instanceof $e4b487e979d7c06d$var$de && (e = i.root().defs().pattern(0, 0, (t)=>{
        t.add(e);
    })), e;
}, $e4b487e979d7c06d$var$Wt.push($e4b487e979d7c06d$var$ue), $e4b487e979d7c06d$var$A({
    Container: {
        image: $e4b487e979d7c06d$var$K(function(t, e) {
            return this.put(new $e4b487e979d7c06d$var$de).size(0, 0).load(t, e);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$de, "Image");
class $e4b487e979d7c06d$var$ge extends $e4b487e979d7c06d$var$Dt {
    bbox() {
        let t = -1 / 0, e = -1 / 0, i = 1 / 0, a = 1 / 0;
        return this.forEach(function(s) {
            t = Math.max(s[0], t), e = Math.max(s[1], e), i = Math.min(s[0], i), a = Math.min(s[1], a);
        }), new $e4b487e979d7c06d$var$kt(i, a, t - i, e - a);
    }
    move(t, e) {
        const i = this.bbox();
        if (t -= i.x, e -= i.y, !isNaN(t) && !isNaN(e)) for(let i = this.length - 1; i >= 0; i--)this[i] = [
            this[i][0] + t,
            this[i][1] + e
        ];
        return this;
    }
    parse(t = [
        0,
        0
    ]) {
        const e = [];
        (t = t instanceof Array ? Array.prototype.concat.apply([], t) : t.trim().split($e4b487e979d7c06d$var$dt).map(parseFloat)).length % 2 != 0 && t.pop();
        for(let i = 0, a = t.length; i < a; i += 2)e.push([
            t[i],
            t[i + 1]
        ]);
        return e;
    }
    size(t, e) {
        let i;
        const a = this.bbox();
        for(i = this.length - 1; i >= 0; i--)a.width && (this[i][0] = (this[i][0] - a.x) * t / a.width + a.x), a.height && (this[i][1] = (this[i][1] - a.y) * e / a.height + a.y);
        return this;
    }
    toLine() {
        return {
            x1: this[0][0],
            y1: this[0][1],
            x2: this[1][0],
            y2: this[1][1]
        };
    }
    toString() {
        const t = [];
        for(let e = 0, i = this.length; e < i; e++)t.push(this[e].join(","));
        return t.join(" ");
    }
    transform(t) {
        return this.clone().transformO(t);
    }
    transformO(t) {
        $e4b487e979d7c06d$var$vt.isMatrixLike(t) || (t = new $e4b487e979d7c06d$var$vt(t));
        for(let e = this.length; e--;){
            const [i, a] = this[e];
            this[e][0] = t.a * i + t.c * a + t.e, this[e][1] = t.b * i + t.d * a + t.f;
        }
        return this;
    }
}
const $e4b487e979d7c06d$var$pe = $e4b487e979d7c06d$var$ge;
var $e4b487e979d7c06d$var$fe = Object.freeze({
    __proto__: null,
    MorphArray: $e4b487e979d7c06d$var$pe,
    height: function(t) {
        const e = this.bbox();
        return null == t ? e.height : this.size(e.width, t);
    },
    width: function(t) {
        const e = this.bbox();
        return null == t ? e.width : this.size(t, e.height);
    },
    x: function(t) {
        return null == t ? this.bbox().x : this.move(t, this.bbox().y);
    },
    y: function(t) {
        return null == t ? this.bbox().y : this.move(this.bbox().x, t);
    }
});
let $e4b487e979d7c06d$var$xe = class extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("line", t), e);
    }
    array() {
        return new $e4b487e979d7c06d$var$ge([
            [
                this.attr("x1"),
                this.attr("y1")
            ],
            [
                this.attr("x2"),
                this.attr("y2")
            ]
        ]);
    }
    move(t, e) {
        return this.attr(this.array().move(t, e).toLine());
    }
    plot(t, e, i, a) {
        return null == t ? this.array() : (t = void 0 !== e ? {
            x1: t,
            y1: e,
            x2: i,
            y2: a
        } : new $e4b487e979d7c06d$var$ge(t).toLine(), this.attr(t));
    }
    size(t, e) {
        const i = $e4b487e979d7c06d$var$I(this, t, e);
        return this.attr(this.array().size(i.width, i.height).toLine());
    }
};
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$xe, $e4b487e979d7c06d$var$fe), $e4b487e979d7c06d$var$A({
    Container: {
        line: $e4b487e979d7c06d$var$K(function(...t) {
            return $e4b487e979d7c06d$var$xe.prototype.plot.apply(this.put(new $e4b487e979d7c06d$var$xe), null != t[0] ? t : [
                0,
                0,
                0,
                0
            ]);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$xe, "Line");
let $e4b487e979d7c06d$var$be = class extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("marker", t), e);
    }
    height(t) {
        return this.attr("markerHeight", t);
    }
    orient(t) {
        return this.attr("orient", t);
    }
    ref(t, e) {
        return this.attr("refX", t).attr("refY", e);
    }
    toString() {
        return "url(#" + this.id() + ")";
    }
    update(t) {
        return this.clear(), "function" == typeof t && t.call(this, this), this;
    }
    width(t) {
        return this.attr("markerWidth", t);
    }
};
function $e4b487e979d7c06d$var$me(t, e) {
    return function(i) {
        return null == i ? this[t] : (this[t] = i, e && e.call(this), this);
    };
}
$e4b487e979d7c06d$var$A({
    Container: {
        marker (...t) {
            return this.defs().marker(...t);
        }
    },
    Defs: {
        marker: $e4b487e979d7c06d$var$K(function(t, e, i) {
            return this.put(new $e4b487e979d7c06d$var$be).size(t, e).ref(t / 2, e / 2).viewbox(0, 0, t, e).attr("orient", "auto").update(i);
        })
    },
    marker: {
        marker (t, e, i, a) {
            let s = [
                "marker"
            ];
            return "all" !== t && s.push(t), s = s.join("-"), t = arguments[1] instanceof $e4b487e979d7c06d$var$be ? arguments[1] : this.defs().marker(e, i, a), this.attr(s, t);
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$be, "Marker");
const $e4b487e979d7c06d$var$ve = {
    "-": function(t) {
        return t;
    },
    "<>": function(t) {
        return -Math.cos(t * Math.PI) / 2 + .5;
    },
    ">": function(t) {
        return Math.sin(t * Math.PI / 2);
    },
    "<": function(t) {
        return 1 - Math.cos(t * Math.PI / 2);
    },
    bezier: function(t, e, i, a) {
        return function(s) {
            return s < 0 ? t > 0 ? e / t * s : i > 0 ? a / i * s : 0 : s > 1 ? i < 1 ? (1 - a) / (1 - i) * s + (a - i) / (1 - i) : t < 1 ? (1 - e) / (1 - t) * s + (e - t) / (1 - t) : 1 : 3 * s * (1 - s) ** 2 * e + 3 * s ** 2 * (1 - s) * a + s ** 3;
        };
    },
    steps: function(t, e = "end") {
        e = e.split("-").reverse()[0];
        let i = t;
        return "none" === e ? --i : "both" === e && ++i, (a, s = !1)=>{
            let r = Math.floor(a * t);
            const n = a * r % 1 == 0;
            return "start" !== e && "both" !== e || ++r, s && n && --r, a >= 0 && r < 0 && (r = 0), a <= 1 && r > i && (r = i), r / i;
        };
    }
};
class $e4b487e979d7c06d$var$ye {
    done() {
        return !1;
    }
}
class $e4b487e979d7c06d$var$we extends $e4b487e979d7c06d$var$ye {
    constructor(t = $e4b487e979d7c06d$var$Ht){
        super(), this.ease = $e4b487e979d7c06d$var$ve[t] || t;
    }
    step(t, e, i) {
        return "number" != typeof t ? i < 1 ? t : e : t + (e - t) * this.ease(i);
    }
}
class $e4b487e979d7c06d$var$ke extends $e4b487e979d7c06d$var$ye {
    constructor(t){
        super(), this.stepper = t;
    }
    done(t) {
        return t.done;
    }
    step(t, e, i, a) {
        return this.stepper(t, e, i, a);
    }
}
function $e4b487e979d7c06d$var$Ae() {
    const t = (this._duration || 500) / 1e3, e = this._overshoot || 0, i = Math.PI, a = Math.log(e / 100 + 1e-10), s = -a / Math.sqrt(i * i + a * a), r = 3.9 / (s * t);
    this.d = 2 * s * r, this.k = r * r;
}
$e4b487e979d7c06d$var$Q(class extends $e4b487e979d7c06d$var$ke {
    constructor(t = 500, e = 0){
        super(), this.duration(t).overshoot(e);
    }
    step(t, e, i, a) {
        if ("string" == typeof t) return t;
        if (a.done = i === 1 / 0, i === 1 / 0) return e;
        if (0 === i) return t;
        i > 100 && (i = 16), i /= 1e3;
        const s = a.velocity || 0, r = -this.d * s - this.k * (t - e), n = t + s * i + r * i * i / 2;
        return a.velocity = s + r * i, a.done = Math.abs(e - n) + Math.abs(s) < .002, a.done ? e : n;
    }
}, {
    duration: $e4b487e979d7c06d$var$me("_duration", $e4b487e979d7c06d$var$Ae),
    overshoot: $e4b487e979d7c06d$var$me("_overshoot", $e4b487e979d7c06d$var$Ae)
});
$e4b487e979d7c06d$var$Q(class extends $e4b487e979d7c06d$var$ke {
    constructor(t = .1, e = .01, i = 0, a = 1e3){
        super(), this.p(t).i(e).d(i).windup(a);
    }
    step(t, e, i, a) {
        if ("string" == typeof t) return t;
        if (a.done = i === 1 / 0, i === 1 / 0) return e;
        if (0 === i) return t;
        const s = e - t;
        let r = (a.integral || 0) + s * i;
        const n = (s - (a.error || 0)) / i, o = this._windup;
        return !1 !== o && (r = Math.max(-o, Math.min(r, o))), a.error = s, a.integral = r, a.done = Math.abs(s) < .001, a.done ? e : t + (this.P * s + this.I * r + this.D * n);
    }
}, {
    windup: $e4b487e979d7c06d$var$me("_windup"),
    p: $e4b487e979d7c06d$var$me("P"),
    i: $e4b487e979d7c06d$var$me("I"),
    d: $e4b487e979d7c06d$var$me("D")
});
const $e4b487e979d7c06d$var$Ce = {
    M: 2,
    L: 2,
    H: 1,
    V: 1,
    C: 6,
    S: 4,
    Q: 4,
    T: 2,
    A: 7,
    Z: 0
}, $e4b487e979d7c06d$var$Se = {
    M: function(t, e, i) {
        return e.x = i.x = t[0], e.y = i.y = t[1], [
            "M",
            e.x,
            e.y
        ];
    },
    L: function(t, e) {
        return e.x = t[0], e.y = t[1], [
            "L",
            t[0],
            t[1]
        ];
    },
    H: function(t, e) {
        return e.x = t[0], [
            "H",
            t[0]
        ];
    },
    V: function(t, e) {
        return e.y = t[0], [
            "V",
            t[0]
        ];
    },
    C: function(t, e) {
        return e.x = t[4], e.y = t[5], [
            "C",
            t[0],
            t[1],
            t[2],
            t[3],
            t[4],
            t[5]
        ];
    },
    S: function(t, e) {
        return e.x = t[2], e.y = t[3], [
            "S",
            t[0],
            t[1],
            t[2],
            t[3]
        ];
    },
    Q: function(t, e) {
        return e.x = t[2], e.y = t[3], [
            "Q",
            t[0],
            t[1],
            t[2],
            t[3]
        ];
    },
    T: function(t, e) {
        return e.x = t[0], e.y = t[1], [
            "T",
            t[0],
            t[1]
        ];
    },
    Z: function(t, e, i) {
        return e.x = i.x, e.y = i.y, [
            "Z"
        ];
    },
    A: function(t, e) {
        return e.x = t[5], e.y = t[6], [
            "A",
            t[0],
            t[1],
            t[2],
            t[3],
            t[4],
            t[5],
            t[6]
        ];
    }
}, $e4b487e979d7c06d$var$Le = "mlhvqtcsaz".split("");
for(let t = 0, e = $e4b487e979d7c06d$var$Le.length; t < e; ++t)$e4b487e979d7c06d$var$Se[$e4b487e979d7c06d$var$Le[t]] = function(t) {
    return function(e, i, a) {
        if ("H" === t) e[0] = e[0] + i.x;
        else if ("V" === t) e[0] = e[0] + i.y;
        else if ("A" === t) e[5] = e[5] + i.x, e[6] = e[6] + i.y;
        else for(let t = 0, a = e.length; t < a; ++t)e[t] = e[t] + (t % 2 ? i.y : i.x);
        return $e4b487e979d7c06d$var$Se[t](e, i, a);
    };
}($e4b487e979d7c06d$var$Le[t].toUpperCase());
function $e4b487e979d7c06d$var$Me(t) {
    return t.segment.length && t.segment.length - 1 === $e4b487e979d7c06d$var$Ce[t.segment[0].toUpperCase()];
}
function $e4b487e979d7c06d$var$Pe(t, e) {
    t.inNumber && $e4b487e979d7c06d$var$Ie(t, !1);
    const i = $e4b487e979d7c06d$var$ut.test(e);
    if (i) t.segment = [
        e
    ];
    else {
        const e = t.lastCommand, i = e.toLowerCase(), a = e === i;
        t.segment = [
            "m" === i ? a ? "l" : "L" : e
        ];
    }
    return t.inSegment = !0, t.lastCommand = t.segment[0], i;
}
function $e4b487e979d7c06d$var$Ie(t, e) {
    if (!t.inNumber) throw new Error("Parser Error");
    t.number && t.segment.push(parseFloat(t.number)), t.inNumber = e, t.number = "", t.pointSeen = !1, t.hasExponent = !1, $e4b487e979d7c06d$var$Me(t) && $e4b487e979d7c06d$var$Te(t);
}
function $e4b487e979d7c06d$var$Te(t) {
    t.inSegment = !1, t.absolute && (t.segment = function(t) {
        const e = t.segment[0];
        return $e4b487e979d7c06d$var$Se[e](t.segment.slice(1), t.p, t.p0);
    }(t)), t.segments.push(t.segment);
}
function $e4b487e979d7c06d$var$ze(t) {
    if (!t.segment.length) return !1;
    const e = "A" === t.segment[0].toUpperCase(), i = t.segment.length;
    return e && (4 === i || 5 === i);
}
function $e4b487e979d7c06d$var$Xe(t) {
    return "E" === t.lastToken.toUpperCase();
}
const $e4b487e979d7c06d$var$Re = new Set([
    " ",
    ",",
    "\t",
    "\n",
    "\r",
    "\f"
]);
class $e4b487e979d7c06d$var$Ee extends $e4b487e979d7c06d$var$Dt {
    bbox() {
        return $e4b487e979d7c06d$var$yt().path.setAttribute("d", this.toString()), new $e4b487e979d7c06d$var$kt($e4b487e979d7c06d$var$yt.nodes.path.getBBox());
    }
    move(t, e) {
        const i = this.bbox();
        if (t -= i.x, e -= i.y, !isNaN(t) && !isNaN(e)) for(let i, a = this.length - 1; a >= 0; a--)i = this[a][0], "M" === i || "L" === i || "T" === i ? (this[a][1] += t, this[a][2] += e) : "H" === i ? this[a][1] += t : "V" === i ? this[a][1] += e : "C" === i || "S" === i || "Q" === i ? (this[a][1] += t, this[a][2] += e, this[a][3] += t, this[a][4] += e, "C" === i && (this[a][5] += t, this[a][6] += e)) : "A" === i && (this[a][6] += t, this[a][7] += e);
        return this;
    }
    parse(t = "M0 0") {
        return Array.isArray(t) && (t = Array.prototype.concat.apply([], t).toString()), function(t, e = !0) {
            let i = 0, a = "";
            const s = {
                segment: [],
                inNumber: !1,
                number: "",
                lastToken: "",
                inSegment: !1,
                segments: [],
                pointSeen: !1,
                hasExponent: !1,
                absolute: e,
                p0: new $e4b487e979d7c06d$var$bt,
                p: new $e4b487e979d7c06d$var$bt
            };
            for(; s.lastToken = a, a = t.charAt(i++);)if (s.inSegment || !$e4b487e979d7c06d$var$Pe(s, a)) {
                if ("." !== a) {
                    if (isNaN(parseInt(a))) {
                        if ($e4b487e979d7c06d$var$Re.has(a)) s.inNumber && $e4b487e979d7c06d$var$Ie(s, !1);
                        else if ("-" !== a && "+" !== a) {
                            if ("E" !== a.toUpperCase()) {
                                if ($e4b487e979d7c06d$var$ut.test(a)) {
                                    if (s.inNumber) $e4b487e979d7c06d$var$Ie(s, !1);
                                    else {
                                        if (!$e4b487e979d7c06d$var$Me(s)) throw new Error("parser Error");
                                        $e4b487e979d7c06d$var$Te(s);
                                    }
                                    --i;
                                }
                            } else s.number += a, s.hasExponent = !0;
                        } else {
                            if (s.inNumber && !$e4b487e979d7c06d$var$Xe(s)) {
                                $e4b487e979d7c06d$var$Ie(s, !1), --i;
                                continue;
                            }
                            s.number += a, s.inNumber = !0;
                        }
                    } else {
                        if ("0" === s.number || $e4b487e979d7c06d$var$ze(s)) {
                            s.inNumber = !0, s.number = a, $e4b487e979d7c06d$var$Ie(s, !0);
                            continue;
                        }
                        s.inNumber = !0, s.number += a;
                    }
                } else {
                    if (s.pointSeen || s.hasExponent) {
                        $e4b487e979d7c06d$var$Ie(s, !1), --i;
                        continue;
                    }
                    s.inNumber = !0, s.pointSeen = !0, s.number += a;
                }
            }
            return s.inNumber && $e4b487e979d7c06d$var$Ie(s, !1), s.inSegment && $e4b487e979d7c06d$var$Me(s) && $e4b487e979d7c06d$var$Te(s), s.segments;
        }(t);
    }
    size(t, e) {
        const i = this.bbox();
        let a, s;
        for(i.width = 0 === i.width ? 1 : i.width, i.height = 0 === i.height ? 1 : i.height, a = this.length - 1; a >= 0; a--)s = this[a][0], "M" === s || "L" === s || "T" === s ? (this[a][1] = (this[a][1] - i.x) * t / i.width + i.x, this[a][2] = (this[a][2] - i.y) * e / i.height + i.y) : "H" === s ? this[a][1] = (this[a][1] - i.x) * t / i.width + i.x : "V" === s ? this[a][1] = (this[a][1] - i.y) * e / i.height + i.y : "C" === s || "S" === s || "Q" === s ? (this[a][1] = (this[a][1] - i.x) * t / i.width + i.x, this[a][2] = (this[a][2] - i.y) * e / i.height + i.y, this[a][3] = (this[a][3] - i.x) * t / i.width + i.x, this[a][4] = (this[a][4] - i.y) * e / i.height + i.y, "C" === s && (this[a][5] = (this[a][5] - i.x) * t / i.width + i.x, this[a][6] = (this[a][6] - i.y) * e / i.height + i.y)) : "A" === s && (this[a][1] = this[a][1] * t / i.width, this[a][2] = this[a][2] * e / i.height, this[a][6] = (this[a][6] - i.x) * t / i.width + i.x, this[a][7] = (this[a][7] - i.y) * e / i.height + i.y);
        return this;
    }
    toString() {
        return function(t) {
            let e = "";
            for(let i = 0, a = t.length; i < a; i++)e += t[i][0], null != t[i][1] && (e += t[i][1], null != t[i][2] && (e += " ", e += t[i][2], null != t[i][3] && (e += " ", e += t[i][3], e += " ", e += t[i][4], null != t[i][5] && (e += " ", e += t[i][5], e += " ", e += t[i][6], null != t[i][7] && (e += " ", e += t[i][7])))));
            return e + " ";
        }(this);
    }
}
const $e4b487e979d7c06d$var$Ye = (t)=>{
    const e = typeof t;
    return "number" === e ? $e4b487e979d7c06d$var$_t : "string" === e ? $e4b487e979d7c06d$var$xt.isColor(t) ? $e4b487e979d7c06d$var$xt : $e4b487e979d7c06d$var$dt.test(t) ? $e4b487e979d7c06d$var$ut.test(t) ? $e4b487e979d7c06d$var$Ee : $e4b487e979d7c06d$var$Dt : $e4b487e979d7c06d$var$tt.test(t) ? $e4b487e979d7c06d$var$_t : $e4b487e979d7c06d$var$Oe : $e4b487e979d7c06d$var$Ne.indexOf(t.constructor) > -1 ? t.constructor : Array.isArray(t) ? $e4b487e979d7c06d$var$Dt : "object" === e ? $e4b487e979d7c06d$var$_e : $e4b487e979d7c06d$var$Oe;
};
class $e4b487e979d7c06d$var$He {
    constructor(t){
        this._stepper = t || new $e4b487e979d7c06d$var$we("-"), this._from = null, this._to = null, this._type = null, this._context = null, this._morphObj = null;
    }
    at(t) {
        return this._morphObj.morph(this._from, this._to, t, this._stepper, this._context);
    }
    done() {
        return this._context.map(this._stepper.done).reduce(function(t, e) {
            return t && e;
        }, !0);
    }
    from(t) {
        return null == t ? this._from : (this._from = this._set(t), this);
    }
    stepper(t) {
        return null == t ? this._stepper : (this._stepper = t, this);
    }
    to(t) {
        return null == t ? this._to : (this._to = this._set(t), this);
    }
    type(t) {
        return null == t ? this._type : (this._type = t, this);
    }
    _set(t) {
        this._type || this.type($e4b487e979d7c06d$var$Ye(t));
        let e = new this._type(t);
        return this._type === $e4b487e979d7c06d$var$xt && (e = this._to ? e[this._to[4]]() : this._from ? e[this._from[4]]() : e), this._type === $e4b487e979d7c06d$var$_e && (e = this._to ? e.align(this._to) : this._from ? e.align(this._from) : e), e = e.toConsumable(), this._morphObj = this._morphObj || new this._type, this._context = this._context || Array.apply(null, Array(e.length)).map(Object).map(function(t) {
            return t.done = !0, t;
        }), e;
    }
}
class $e4b487e979d7c06d$var$Oe {
    constructor(...t){
        this.init(...t);
    }
    init(t) {
        return t = Array.isArray(t) ? t[0] : t, this.value = t, this;
    }
    toArray() {
        return [
            this.value
        ];
    }
    valueOf() {
        return this.value;
    }
}
class $e4b487e979d7c06d$var$Fe {
    constructor(...t){
        this.init(...t);
    }
    init(t) {
        return Array.isArray(t) && (t = {
            scaleX: t[0],
            scaleY: t[1],
            shear: t[2],
            rotate: t[3],
            translateX: t[4],
            translateY: t[5],
            originX: t[6],
            originY: t[7]
        }), Object.assign(this, $e4b487e979d7c06d$var$Fe.defaults, t), this;
    }
    toArray() {
        const t = this;
        return [
            t.scaleX,
            t.scaleY,
            t.shear,
            t.rotate,
            t.translateX,
            t.translateY,
            t.originX,
            t.originY
        ];
    }
}
$e4b487e979d7c06d$var$Fe.defaults = {
    scaleX: 1,
    scaleY: 1,
    shear: 0,
    rotate: 0,
    translateX: 0,
    translateY: 0,
    originX: 0,
    originY: 0
};
const $e4b487e979d7c06d$var$De = (t, e)=>t[0] < e[0] ? -1 : t[0] > e[0] ? 1 : 0;
class $e4b487e979d7c06d$var$_e {
    constructor(...t){
        this.init(...t);
    }
    align(t) {
        const e = this.values;
        for(let i = 0, a = e.length; i < a; ++i){
            if (e[i + 1] === t[i + 1]) {
                if (e[i + 1] === $e4b487e979d7c06d$var$xt && t[i + 7] !== e[i + 7]) {
                    const e = t[i + 7], a = new $e4b487e979d7c06d$var$xt(this.values.splice(i + 3, 5))[e]().toArray();
                    this.values.splice(i + 3, 0, ...a);
                }
                i += e[i + 2] + 2;
                continue;
            }
            if (!t[i + 1]) return this;
            const a = (new t[i + 1]).toArray(), s = e[i + 2] + 3;
            e.splice(i, s, t[i], t[i + 1], t[i + 2], ...a), i += e[i + 2] + 2;
        }
        return this;
    }
    init(t) {
        if (this.values = [], Array.isArray(t)) return void (this.values = t.slice());
        t = t || {};
        const e = [];
        for(const i in t){
            const a = $e4b487e979d7c06d$var$Ye(t[i]), s = new a(t[i]).toArray();
            e.push([
                i,
                a,
                s.length,
                ...s
            ]);
        }
        return e.sort($e4b487e979d7c06d$var$De), this.values = e.reduce((t, e)=>t.concat(e), []), this;
    }
    toArray() {
        return this.values;
    }
    valueOf() {
        const t = {}, e = this.values;
        for(; e.length;){
            const i = e.shift(), a = e.shift(), s = e.shift(), r = e.splice(0, s);
            t[i] = new a(r);
        }
        return t;
    }
}
const $e4b487e979d7c06d$var$Ne = [
    $e4b487e979d7c06d$var$Oe,
    $e4b487e979d7c06d$var$Fe,
    $e4b487e979d7c06d$var$_e
];
class $e4b487e979d7c06d$var$We extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("path", t), e);
    }
    array() {
        return this._array || (this._array = new $e4b487e979d7c06d$var$Ee(this.attr("d")));
    }
    clear() {
        return delete this._array, this;
    }
    height(t) {
        return null == t ? this.bbox().height : this.size(this.bbox().width, t);
    }
    move(t, e) {
        return this.attr("d", this.array().move(t, e));
    }
    plot(t) {
        return null == t ? this.array() : this.clear().attr("d", "string" == typeof t ? t : this._array = new $e4b487e979d7c06d$var$Ee(t));
    }
    size(t, e) {
        const i = $e4b487e979d7c06d$var$I(this, t, e);
        return this.attr("d", this.array().size(i.width, i.height));
    }
    width(t) {
        return null == t ? this.bbox().width : this.size(t, this.bbox().height);
    }
    x(t) {
        return null == t ? this.bbox().x : this.move(t, this.bbox().y);
    }
    y(t) {
        return null == t ? this.bbox().y : this.move(this.bbox().x, t);
    }
}
$e4b487e979d7c06d$var$We.prototype.MorphArray = $e4b487e979d7c06d$var$Ee, $e4b487e979d7c06d$var$A({
    Container: {
        path: $e4b487e979d7c06d$var$K(function(t) {
            return this.put(new $e4b487e979d7c06d$var$We).plot(t || new $e4b487e979d7c06d$var$Ee);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$We, "Path");
var $e4b487e979d7c06d$var$Be = Object.freeze({
    __proto__: null,
    array: function() {
        return this._array || (this._array = new $e4b487e979d7c06d$var$ge(this.attr("points")));
    },
    clear: function() {
        return delete this._array, this;
    },
    move: function(t, e) {
        return this.attr("points", this.array().move(t, e));
    },
    plot: function(t) {
        return null == t ? this.array() : this.clear().attr("points", "string" == typeof t ? t : this._array = new $e4b487e979d7c06d$var$ge(t));
    },
    size: function(t, e) {
        const i = $e4b487e979d7c06d$var$I(this, t, e);
        return this.attr("points", this.array().size(i.width, i.height));
    }
});
class $e4b487e979d7c06d$var$Ge extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("polygon", t), e);
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        polygon: $e4b487e979d7c06d$var$K(function(t) {
            return this.put(new $e4b487e979d7c06d$var$Ge).plot(t || new $e4b487e979d7c06d$var$ge);
        })
    }
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Ge, $e4b487e979d7c06d$var$fe), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Ge, $e4b487e979d7c06d$var$Be), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Ge, "Polygon");
class $e4b487e979d7c06d$var$je extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("polyline", t), e);
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        polyline: $e4b487e979d7c06d$var$K(function(t) {
            return this.put(new $e4b487e979d7c06d$var$je).plot(t || new $e4b487e979d7c06d$var$ge);
        })
    }
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$je, $e4b487e979d7c06d$var$fe), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$je, $e4b487e979d7c06d$var$Be), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$je, "Polyline");
class $e4b487e979d7c06d$var$Ve extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("rect", t), e);
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Ve, {
    rx: $e4b487e979d7c06d$var$Zt,
    ry: $e4b487e979d7c06d$var$$t
}), $e4b487e979d7c06d$var$A({
    Container: {
        rect: $e4b487e979d7c06d$var$K(function(t, e) {
            return this.put(new $e4b487e979d7c06d$var$Ve).size(t, e);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Ve, "Rect");
class $e4b487e979d7c06d$var$Ue {
    constructor(){
        this._first = null, this._last = null;
    }
    first() {
        return this._first && this._first.value;
    }
    last() {
        return this._last && this._last.value;
    }
    push(t) {
        const e = void 0 !== t.next ? t : {
            value: t,
            next: null,
            prev: null
        };
        return this._last ? (e.prev = this._last, this._last.next = e, this._last = e) : (this._last = e, this._first = e), e;
    }
    remove(t) {
        t.prev && (t.prev.next = t.next), t.next && (t.next.prev = t.prev), t === this._last && (this._last = t.prev), t === this._first && (this._first = t.next), t.prev = null, t.next = null;
    }
    shift() {
        const t = this._first;
        return t ? (this._first = t.next, this._first && (this._first.prev = null), this._last = this._first ? this._last : null, t.value) : null;
    }
}
const $e4b487e979d7c06d$var$qe = {
    nextDraw: null,
    frames: new $e4b487e979d7c06d$var$Ue,
    timeouts: new $e4b487e979d7c06d$var$Ue,
    immediates: new $e4b487e979d7c06d$var$Ue,
    timer: ()=>$e4b487e979d7c06d$var$O.window.performance || $e4b487e979d7c06d$var$O.window.Date,
    transforms: [],
    frame (t) {
        const e = $e4b487e979d7c06d$var$qe.frames.push({
            run: t
        });
        return null === $e4b487e979d7c06d$var$qe.nextDraw && ($e4b487e979d7c06d$var$qe.nextDraw = $e4b487e979d7c06d$var$O.window.requestAnimationFrame($e4b487e979d7c06d$var$qe._draw)), e;
    },
    timeout (t, e) {
        e = e || 0;
        const i = $e4b487e979d7c06d$var$qe.timer().now() + e, a = $e4b487e979d7c06d$var$qe.timeouts.push({
            run: t,
            time: i
        });
        return null === $e4b487e979d7c06d$var$qe.nextDraw && ($e4b487e979d7c06d$var$qe.nextDraw = $e4b487e979d7c06d$var$O.window.requestAnimationFrame($e4b487e979d7c06d$var$qe._draw)), a;
    },
    immediate (t) {
        const e = $e4b487e979d7c06d$var$qe.immediates.push(t);
        return null === $e4b487e979d7c06d$var$qe.nextDraw && ($e4b487e979d7c06d$var$qe.nextDraw = $e4b487e979d7c06d$var$O.window.requestAnimationFrame($e4b487e979d7c06d$var$qe._draw)), e;
    },
    cancelFrame (t) {
        null != t && $e4b487e979d7c06d$var$qe.frames.remove(t);
    },
    clearTimeout (t) {
        null != t && $e4b487e979d7c06d$var$qe.timeouts.remove(t);
    },
    cancelImmediate (t) {
        null != t && $e4b487e979d7c06d$var$qe.immediates.remove(t);
    },
    _draw (t) {
        let e = null;
        const i = $e4b487e979d7c06d$var$qe.timeouts.last();
        for(; (e = $e4b487e979d7c06d$var$qe.timeouts.shift()) && (t >= e.time ? e.run() : $e4b487e979d7c06d$var$qe.timeouts.push(e), e !== i););
        let a = null;
        const s = $e4b487e979d7c06d$var$qe.frames.last();
        for(; a !== s && (a = $e4b487e979d7c06d$var$qe.frames.shift());)a.run(t);
        let r = null;
        for(; r = $e4b487e979d7c06d$var$qe.immediates.shift();)r();
        $e4b487e979d7c06d$var$qe.nextDraw = $e4b487e979d7c06d$var$qe.timeouts.first() || $e4b487e979d7c06d$var$qe.frames.first() ? $e4b487e979d7c06d$var$O.window.requestAnimationFrame($e4b487e979d7c06d$var$qe._draw) : null;
    }
}, $e4b487e979d7c06d$var$Ze = function(t) {
    const e = t.start, i = t.runner.duration();
    return {
        start: e,
        duration: i,
        end: e + i,
        runner: t.runner
    };
}, $e4b487e979d7c06d$var$$e = function() {
    const t = $e4b487e979d7c06d$var$O.window;
    return (t.performance || t.Date).now();
};
class $e4b487e979d7c06d$var$Je extends $e4b487e979d7c06d$var$Rt {
    constructor(t = $e4b487e979d7c06d$var$$e){
        super(), this._timeSource = t, this.terminate();
    }
    active() {
        return !!this._nextFrame;
    }
    finish() {
        return this.time(this.getEndTimeOfTimeline() + 1), this.pause();
    }
    getEndTime() {
        const t = this.getLastRunnerInfo(), e = t ? t.runner.duration() : 0;
        return (t ? t.start : this._time) + e;
    }
    getEndTimeOfTimeline() {
        const t = this._runners.map((t)=>t.start + t.runner.duration());
        return Math.max(0, ...t);
    }
    getLastRunnerInfo() {
        return this.getRunnerInfoById(this._lastRunnerId);
    }
    getRunnerInfoById(t) {
        return this._runners[this._runnerIds.indexOf(t)] || null;
    }
    pause() {
        return this._paused = !0, this._continue();
    }
    persist(t) {
        return null == t ? this._persist : (this._persist = t, this);
    }
    play() {
        return this._paused = !1, this.updateTime()._continue();
    }
    reverse(t) {
        const e = this.speed();
        if (null == t) return this.speed(-e);
        const i = Math.abs(e);
        return this.speed(t ? -i : i);
    }
    schedule(t, e, i) {
        if (null == t) return this._runners.map($e4b487e979d7c06d$var$Ze);
        let a = 0;
        const s = this.getEndTime();
        if (e = e || 0, null == i || "last" === i || "after" === i) a = s;
        else if ("absolute" === i || "start" === i) a = e, e = 0;
        else if ("now" === i) a = this._time;
        else if ("relative" === i) {
            const i = this.getRunnerInfoById(t.id);
            i && (a = i.start + e, e = 0);
        } else {
            if ("with-last" !== i) throw new Error('Invalid value for the "when" parameter');
            {
                const t = this.getLastRunnerInfo();
                a = t ? t.start : this._time;
            }
        }
        t.unschedule(), t.timeline(this);
        const r = t.persist(), n = {
            persist: null === r ? this._persist : r,
            start: a + e,
            runner: t
        };
        return this._lastRunnerId = t.id, this._runners.push(n), this._runners.sort((t, e)=>t.start - e.start), this._runnerIds = this._runners.map((t)=>t.runner.id), this.updateTime()._continue(), this;
    }
    seek(t) {
        return this.time(this._time + t);
    }
    source(t) {
        return null == t ? this._timeSource : (this._timeSource = t, this);
    }
    speed(t) {
        return null == t ? this._speed : (this._speed = t, this);
    }
    stop() {
        return this.time(0), this.pause();
    }
    time(t) {
        return null == t ? this._time : (this._time = t, this._continue(!0));
    }
    unschedule(t) {
        const e = this._runnerIds.indexOf(t.id);
        return e < 0 || (this._runners.splice(e, 1), this._runnerIds.splice(e, 1), t.timeline(null)), this;
    }
    updateTime() {
        return this.active() || (this._lastSourceTime = this._timeSource()), this;
    }
    _continue(t = !1) {
        return $e4b487e979d7c06d$var$qe.cancelFrame(this._nextFrame), this._nextFrame = null, t ? this._stepImmediate() : (this._paused || (this._nextFrame = $e4b487e979d7c06d$var$qe.frame(this._step)), this);
    }
    _stepFn(t = !1) {
        const e = this._timeSource();
        let i = e - this._lastSourceTime;
        t && (i = 0);
        const a = this._speed * i + (this._time - this._lastStepTime);
        this._lastSourceTime = e, t || (this._time += a, this._time = this._time < 0 ? 0 : this._time), this._lastStepTime = this._time, this.fire("time", this._time);
        for(let t = this._runners.length; t--;){
            const e = this._runners[t], i = e.runner;
            this._time - e.start <= 0 && i.reset();
        }
        let s = !1;
        for(let t = 0, e = this._runners.length; t < e; t++){
            const i = this._runners[t], r = i.runner;
            let n = a;
            const o = this._time - i.start;
            if (o <= 0) {
                s = !0;
                continue;
            }
            if (o < n && (n = o), !r.active()) continue;
            if (r.step(n).done) {
                if (!0 !== i.persist) r.duration() - r.time() + this._time + i.persist < this._time && (r.unschedule(), --t, --e);
            } else s = !0;
        }
        return s && !(this._speed < 0 && 0 === this._time) || this._runnerIds.length && this._speed < 0 && this._time > 0 ? this._continue() : (this.pause(), this.fire("finished")), this;
    }
    terminate() {
        this._startTime = 0, this._speed = 1, this._persist = 0, this._nextFrame = null, this._paused = !0, this._runners = [], this._runnerIds = [], this._lastRunnerId = -1, this._time = 0, this._lastSourceTime = 0, this._lastStepTime = 0, this._step = this._stepFn.bind(this, !1), this._stepImmediate = this._stepFn.bind(this, !0);
    }
}
$e4b487e979d7c06d$var$A({
    Element: {
        timeline: function(t) {
            return null == t ? (this._timeline = this._timeline || new $e4b487e979d7c06d$var$Je, this._timeline) : (this._timeline = t, this);
        }
    }
});
class $e4b487e979d7c06d$var$Qe extends $e4b487e979d7c06d$var$Rt {
    constructor(t){
        super(), this.id = $e4b487e979d7c06d$var$Qe.id++, t = "function" == typeof (t = null == t ? $e4b487e979d7c06d$var$Yt : t) ? new $e4b487e979d7c06d$var$ke(t) : t, this._element = null, this._timeline = null, this.done = !1, this._queue = [], this._duration = "number" == typeof t && t, this._isDeclarative = t instanceof $e4b487e979d7c06d$var$ke, this._stepper = this._isDeclarative ? t : new $e4b487e979d7c06d$var$we, this._history = {}, this.enabled = !0, this._time = 0, this._lastTime = 0, this._reseted = !0, this.transforms = new $e4b487e979d7c06d$var$vt, this.transformId = 1, this._haveReversed = !1, this._reverse = !1, this._loopsDone = 0, this._swing = !1, this._wait = 0, this._times = 1, this._frameId = null, this._persist = !!this._isDeclarative || null;
    }
    static sanitise(t, e, i) {
        let a = 1, s = !1, r = 0;
        return e = e ?? $e4b487e979d7c06d$var$Ot, i = i || "last", "object" != typeof (t = t ?? $e4b487e979d7c06d$var$Yt) || t instanceof $e4b487e979d7c06d$var$ye || (e = t.delay ?? e, i = t.when ?? i, s = t.swing || s, a = t.times ?? a, r = t.wait ?? r, t = t.duration ?? $e4b487e979d7c06d$var$Yt), {
            duration: t,
            delay: e,
            swing: s,
            times: a,
            wait: r,
            when: i
        };
    }
    active(t) {
        return null == t ? this.enabled : (this.enabled = t, this);
    }
    addTransform(t) {
        return this.transforms.lmultiplyO(t), this;
    }
    after(t) {
        return this.on("finished", t);
    }
    animate(t, e, i) {
        const a = $e4b487e979d7c06d$var$Qe.sanitise(t, e, i), s = new $e4b487e979d7c06d$var$Qe(a.duration);
        return this._timeline && s.timeline(this._timeline), this._element && s.element(this._element), s.loop(a).schedule(a.delay, a.when);
    }
    clearTransform() {
        return this.transforms = new $e4b487e979d7c06d$var$vt, this;
    }
    clearTransformsFromQueue() {
        this.done && this._timeline && this._timeline._runnerIds.includes(this.id) || (this._queue = this._queue.filter((t)=>!t.isTransform));
    }
    delay(t) {
        return this.animate(0, t);
    }
    duration() {
        return this._times * (this._wait + this._duration) - this._wait;
    }
    during(t) {
        return this.queue(null, t);
    }
    ease(t) {
        return this._stepper = new $e4b487e979d7c06d$var$we(t), this;
    }
    element(t) {
        return null == t ? this._element : (this._element = t, t._prepareRunner(), this);
    }
    finish() {
        return this.step(1 / 0);
    }
    loop(t, e, i) {
        return "object" == typeof t && (e = t.swing, i = t.wait, t = t.times), this._times = t || 1 / 0, this._swing = e || !1, this._wait = i || 0, !0 === this._times && (this._times = 1 / 0), this;
    }
    loops(t) {
        const e = this._duration + this._wait;
        if (null == t) {
            const t = Math.floor(this._time / e), i = (this._time - t * e) / this._duration;
            return Math.min(t + i, this._times);
        }
        const i = t % 1, a = e * Math.floor(t) + this._duration * i;
        return this.time(a);
    }
    persist(t) {
        return null == t ? this._persist : (this._persist = t, this);
    }
    position(t) {
        const e = this._time, i = this._duration, a = this._wait, s = this._times, r = this._swing, n = this._reverse;
        let o;
        if (null == t) {
            const t = function(t) {
                const e = r * Math.floor(t % (2 * (a + i)) / (a + i)), s = e && !n || !e && n, o = Math.pow(-1, s) * (t % (a + i)) / i + s;
                return Math.max(Math.min(o, 1), 0);
            }, l = s * (a + i) - a;
            return o = e <= 0 ? Math.round(t(1e-5)) : e < l ? t(e) : Math.round(t(l - 1e-5)), o;
        }
        const l = Math.floor(this.loops()), h = r && l % 2 == 0;
        return o = l + (h && !n || n && h ? t : 1 - t), this.loops(o);
    }
    progress(t) {
        return null == t ? Math.min(1, this._time / this.duration()) : this.time(t * this.duration());
    }
    queue(t, e, i, a) {
        this._queue.push({
            initialiser: t || $e4b487e979d7c06d$var$Et,
            runner: e || $e4b487e979d7c06d$var$Et,
            retarget: i,
            isTransform: a,
            initialised: !1,
            finished: !1
        });
        return this.timeline() && this.timeline()._continue(), this;
    }
    reset() {
        return this._reseted || (this.time(0), this._reseted = !0), this;
    }
    reverse(t) {
        return this._reverse = null == t ? !this._reverse : t, this;
    }
    schedule(t, e, i) {
        if (t instanceof $e4b487e979d7c06d$var$Je || (i = e, e = t, t = this.timeline()), !t) throw Error("Runner cannot be scheduled without timeline");
        return t.schedule(this, e, i), this;
    }
    step(t) {
        if (!this.enabled) return this;
        t = null == t ? 16 : t, this._time += t;
        const e = this.position(), i = this._lastPosition !== e && this._time >= 0;
        this._lastPosition = e;
        const a = this.duration(), s = this._lastTime <= 0 && this._time > 0, r = this._lastTime < a && this._time >= a;
        this._lastTime = this._time, s && this.fire("start", this);
        const n = this._isDeclarative;
        this.done = !n && !r && this._time >= a, this._reseted = !1;
        let o = !1;
        return (i || n) && (this._initialise(i), this.transforms = new $e4b487e979d7c06d$var$vt, o = this._run(n ? t : e), this.fire("step", this)), this.done = this.done || o && n, r && this.fire("finished", this), this;
    }
    time(t) {
        if (null == t) return this._time;
        const e = t - this._time;
        return this.step(e), this;
    }
    timeline(t) {
        return void 0 === t ? this._timeline : (this._timeline = t, this);
    }
    unschedule() {
        const t = this.timeline();
        return t && t.unschedule(this), this;
    }
    _initialise(t) {
        if (t || this._isDeclarative) for(let e = 0, i = this._queue.length; e < i; ++e){
            const i = this._queue[e], a = this._isDeclarative || !i.initialised && t;
            t = !i.finished, a && t && (i.initialiser.call(this), i.initialised = !0);
        }
    }
    _rememberMorpher(t, e) {
        if (this._history[t] = {
            morpher: e,
            caller: this._queue[this._queue.length - 1]
        }, this._isDeclarative) {
            const t = this.timeline();
            t && t.play();
        }
    }
    _run(t) {
        let e = !0;
        for(let i = 0, a = this._queue.length; i < a; ++i){
            const a = this._queue[i], s = a.runner.call(this, t);
            a.finished = a.finished || !0 === s, e = e && a.finished;
        }
        return e;
    }
    _tryRetarget(t, e, i) {
        if (this._history[t]) {
            if (!this._history[t].caller.initialised) {
                const e = this._queue.indexOf(this._history[t].caller);
                return this._queue.splice(e, 1), !1;
            }
            this._history[t].caller.retarget ? this._history[t].caller.retarget.call(this, e, i) : this._history[t].morpher.to(e), this._history[t].caller.finished = !1;
            const a = this.timeline();
            return a && a.play(), !0;
        }
        return !1;
    }
}
$e4b487e979d7c06d$var$Qe.id = 0;
class $e4b487e979d7c06d$var$Ke {
    constructor(t = new $e4b487e979d7c06d$var$vt, e = -1, i = !0){
        this.transforms = t, this.id = e, this.done = i;
    }
    clearTransformsFromQueue() {}
}
$e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$Qe,
    $e4b487e979d7c06d$var$Ke
], {
    mergeWith (t) {
        return new $e4b487e979d7c06d$var$Ke(t.transforms.lmultiply(this.transforms), t.id);
    }
});
const $e4b487e979d7c06d$var$ti = (t, e)=>t.lmultiplyO(e), $e4b487e979d7c06d$var$ei = (t)=>t.transforms;
function $e4b487e979d7c06d$var$ii() {
    const t = this._transformationRunners.runners.map($e4b487e979d7c06d$var$ei).reduce($e4b487e979d7c06d$var$ti, new $e4b487e979d7c06d$var$vt);
    this.transform(t), this._transformationRunners.merge(), 1 === this._transformationRunners.length() && (this._frameId = null);
}
class $e4b487e979d7c06d$var$ai {
    constructor(){
        this.runners = [], this.ids = [];
    }
    add(t) {
        if (this.runners.includes(t)) return;
        const e = t.id + 1;
        return this.runners.push(t), this.ids.push(e), this;
    }
    clearBefore(t) {
        const e = this.ids.indexOf(t + 1) || 1;
        return this.ids.splice(0, e, 0), this.runners.splice(0, e, new $e4b487e979d7c06d$var$Ke).forEach((t)=>t.clearTransformsFromQueue()), this;
    }
    edit(t, e) {
        const i = this.ids.indexOf(t + 1);
        return this.ids.splice(i, 1, t + 1), this.runners.splice(i, 1, e), this;
    }
    getByID(t) {
        return this.runners[this.ids.indexOf(t + 1)];
    }
    length() {
        return this.ids.length;
    }
    merge() {
        let t = null;
        for(let e = 0; e < this.runners.length; ++e){
            const i = this.runners[e];
            if (t && i.done && t.done && (!i._timeline || !i._timeline._runnerIds.includes(i.id)) && (!t._timeline || !t._timeline._runnerIds.includes(t.id))) {
                this.remove(i.id);
                const a = i.mergeWith(t);
                this.edit(t.id, a), t = a, --e;
            } else t = i;
        }
        return this;
    }
    remove(t) {
        const e = this.ids.indexOf(t + 1);
        return this.ids.splice(e, 1), this.runners.splice(e, 1), this;
    }
}
$e4b487e979d7c06d$var$A({
    Element: {
        animate (t, e, i) {
            const a = $e4b487e979d7c06d$var$Qe.sanitise(t, e, i), s = this.timeline();
            return new $e4b487e979d7c06d$var$Qe(a.duration).loop(a).element(this).timeline(s.play()).schedule(a.delay, a.when);
        },
        delay (t, e) {
            return this.animate(0, t, e);
        },
        _clearTransformRunnersBefore (t) {
            this._transformationRunners.clearBefore(t.id);
        },
        _currentTransform (t) {
            return this._transformationRunners.runners.filter((e)=>e.id <= t.id).map($e4b487e979d7c06d$var$ei).reduce($e4b487e979d7c06d$var$ti, new $e4b487e979d7c06d$var$vt);
        },
        _addRunner (t) {
            this._transformationRunners.add(t), $e4b487e979d7c06d$var$qe.cancelImmediate(this._frameId), this._frameId = $e4b487e979d7c06d$var$qe.immediate($e4b487e979d7c06d$var$ii.bind(this));
        },
        _prepareRunner () {
            null == this._frameId && (this._transformationRunners = (new $e4b487e979d7c06d$var$ai).add(new $e4b487e979d7c06d$var$Ke(new $e4b487e979d7c06d$var$vt(this))));
        }
    }
});
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Qe, {
    attr (t, e) {
        return this.styleAttr("attr", t, e);
    },
    css (t, e) {
        return this.styleAttr("css", t, e);
    },
    styleAttr (t, e, i) {
        if ("string" == typeof e) return this.styleAttr(t, {
            [e]: i
        });
        let a = e;
        if (this._tryRetarget(t, a)) return this;
        let s = new $e4b487e979d7c06d$var$He(this._stepper).to(a), r = Object.keys(a);
        return this.queue(function() {
            s = s.from(this.element()[t](r));
        }, function(e) {
            return this.element()[t](s.at(e).valueOf()), s.done();
        }, function(e) {
            const i = Object.keys(e), n = (o = r, i.filter((t)=>!o.includes(t)));
            var o;
            if (n.length) {
                const e = this.element()[t](n), i = new $e4b487e979d7c06d$var$_e(s.from()).valueOf();
                Object.assign(i, e), s.from(i);
            }
            const l = new $e4b487e979d7c06d$var$_e(s.to()).valueOf();
            Object.assign(l, e), s.to(l), r = i, a = e;
        }), this._rememberMorpher(t, s), this;
    },
    zoom (t, e) {
        if (this._tryRetarget("zoom", t, e)) return this;
        let i = new $e4b487e979d7c06d$var$He(this._stepper).to(new $e4b487e979d7c06d$var$_t(t));
        return this.queue(function() {
            i = i.from(this.element().zoom());
        }, function(t) {
            return this.element().zoom(i.at(t), e), i.done();
        }, function(t, a) {
            e = a, i.to(t);
        }), this._rememberMorpher("zoom", i), this;
    },
    transform (t, e, i) {
        if (e = t.relative || e, this._isDeclarative && !e && this._tryRetarget("transform", t)) return this;
        const a = $e4b487e979d7c06d$var$vt.isMatrixLike(t);
        i = null != t.affine ? t.affine : null != i ? i : !a;
        const s = new $e4b487e979d7c06d$var$He(this._stepper).type(i ? $e4b487e979d7c06d$var$Fe : $e4b487e979d7c06d$var$vt);
        let r, n, o, l, h;
        return this.queue(function() {
            n = n || this.element(), r = r || $e4b487e979d7c06d$var$T(t, n), h = new $e4b487e979d7c06d$var$vt(e ? void 0 : n), n._addRunner(this), e || n._clearTransformRunnersBefore(this);
        }, function(c) {
            e || this.clearTransform();
            const { x: d, y: u } = new $e4b487e979d7c06d$var$bt(r).transform(n._currentTransform(this));
            let g = new $e4b487e979d7c06d$var$vt({
                ...t,
                origin: [
                    d,
                    u
                ]
            }), p = this._isDeclarative && o ? o : h;
            if (i) {
                g = g.decompose(d, u), p = p.decompose(d, u);
                const t = g.rotate, e = p.rotate, i = [
                    t - 360,
                    t,
                    t + 360
                ], a = i.map((t)=>Math.abs(t - e)), s = Math.min(...a), r = a.indexOf(s);
                g.rotate = i[r];
            }
            e && (a || (g.rotate = t.rotate || 0), this._isDeclarative && l && (p.rotate = l)), s.from(p), s.to(g);
            const f = s.at(c);
            return l = f.rotate, o = new $e4b487e979d7c06d$var$vt(f), this.addTransform(o), n._addRunner(this), s.done();
        }, function(e) {
            (e.origin || "center").toString() !== (t.origin || "center").toString() && (r = $e4b487e979d7c06d$var$T(e, n)), t = {
                ...e,
                origin: r
            };
        }, !0), this._isDeclarative && this._rememberMorpher("transform", s), this;
    },
    x (t) {
        return this._queueNumber("x", t);
    },
    y (t) {
        return this._queueNumber("y", t);
    },
    ax (t) {
        return this._queueNumber("ax", t);
    },
    ay (t) {
        return this._queueNumber("ay", t);
    },
    dx (t = 0) {
        return this._queueNumberDelta("x", t);
    },
    dy (t = 0) {
        return this._queueNumberDelta("y", t);
    },
    dmove (t, e) {
        return this.dx(t).dy(e);
    },
    _queueNumberDelta (t, e) {
        if (e = new $e4b487e979d7c06d$var$_t(e), this._tryRetarget(t, e)) return this;
        const i = new $e4b487e979d7c06d$var$He(this._stepper).to(e);
        let a = null;
        return this.queue(function() {
            a = this.element()[t](), i.from(a), i.to(a + e);
        }, function(e) {
            return this.element()[t](i.at(e)), i.done();
        }, function(t) {
            i.to(a + new $e4b487e979d7c06d$var$_t(t));
        }), this._rememberMorpher(t, i), this;
    },
    _queueObject (t, e) {
        if (this._tryRetarget(t, e)) return this;
        const i = new $e4b487e979d7c06d$var$He(this._stepper).to(e);
        return this.queue(function() {
            i.from(this.element()[t]());
        }, function(e) {
            return this.element()[t](i.at(e)), i.done();
        }), this._rememberMorpher(t, i), this;
    },
    _queueNumber (t, e) {
        return this._queueObject(t, new $e4b487e979d7c06d$var$_t(e));
    },
    cx (t) {
        return this._queueNumber("cx", t);
    },
    cy (t) {
        return this._queueNumber("cy", t);
    },
    move (t, e) {
        return this.x(t).y(e);
    },
    amove (t, e) {
        return this.ax(t).ay(e);
    },
    center (t, e) {
        return this.cx(t).cy(e);
    },
    size (t, e) {
        let i;
        return t && e || (i = this._element.bbox()), t || (t = i.width / i.height * e), e || (e = i.height / i.width * t), this.width(t).height(e);
    },
    width (t) {
        return this._queueNumber("width", t);
    },
    height (t) {
        return this._queueNumber("height", t);
    },
    plot (t, e, i, a) {
        if (4 === arguments.length) return this.plot([
            t,
            e,
            i,
            a
        ]);
        if (this._tryRetarget("plot", t)) return this;
        const s = new $e4b487e979d7c06d$var$He(this._stepper).type(this._element.MorphArray).to(t);
        return this.queue(function() {
            s.from(this._element.array());
        }, function(t) {
            return this._element.plot(s.at(t)), s.done();
        }), this._rememberMorpher("plot", s), this;
    },
    leading (t) {
        return this._queueNumber("leading", t);
    },
    viewbox (t, e, i, a) {
        return this._queueObject("viewbox", new $e4b487e979d7c06d$var$kt(t, e, i, a));
    },
    update (t) {
        return "object" != typeof t ? this.update({
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        }) : (null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", t.offset), this);
    }
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Qe, {
    rx: $e4b487e979d7c06d$var$Zt,
    ry: $e4b487e979d7c06d$var$$t,
    from: $e4b487e979d7c06d$var$ne,
    to: $e4b487e979d7c06d$var$oe
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$Qe, "Runner");
class $e4b487e979d7c06d$var$si extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("svg", t), e), this.namespace();
    }
    defs() {
        return this.isRoot() ? $e4b487e979d7c06d$var$V(this.node.querySelector("defs")) || this.put(new $e4b487e979d7c06d$var$Ut) : this.root().defs();
    }
    isRoot() {
        return !this.node.parentNode || !(this.node.parentNode instanceof $e4b487e979d7c06d$var$O.window.SVGElement) && "#document-fragment" !== this.node.parentNode.nodeName;
    }
    namespace() {
        return this.isRoot() ? this.attr({
            xmlns: $e4b487e979d7c06d$var$E,
            version: "1.1"
        }).attr("xmlns:xlink", $e4b487e979d7c06d$var$H, $e4b487e979d7c06d$var$Y) : this.root().namespace();
    }
    removeNamespace() {
        return this.attr({
            xmlns: null,
            version: null
        }).attr("xmlns:xlink", null, $e4b487e979d7c06d$var$Y).attr("xmlns:svgjs", null, $e4b487e979d7c06d$var$Y);
    }
    root() {
        return this.isRoot() ? this : super.root();
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        nested: $e4b487e979d7c06d$var$K(function() {
            return this.put(new $e4b487e979d7c06d$var$si);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$si, "Svg", !0);
let $e4b487e979d7c06d$var$ri = class extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("symbol", t), e);
    }
};
$e4b487e979d7c06d$var$A({
    Container: {
        symbol: $e4b487e979d7c06d$var$K(function() {
            return this.put(new $e4b487e979d7c06d$var$ri);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$ri, "Symbol");
var $e4b487e979d7c06d$var$ni = Object.freeze({
    __proto__: null,
    amove: function(t, e) {
        return this.ax(t).ay(e);
    },
    ax: function(t) {
        return this.attr("x", t);
    },
    ay: function(t) {
        return this.attr("y", t);
    },
    build: function(t) {
        return this._build = !!t, this;
    },
    center: function(t, e, i = this.bbox()) {
        return this.cx(t, i).cy(e, i);
    },
    cx: function(t, e = this.bbox()) {
        return null == t ? e.cx : this.attr("x", this.attr("x") + t - e.cx);
    },
    cy: function(t, e = this.bbox()) {
        return null == t ? e.cy : this.attr("y", this.attr("y") + t - e.cy);
    },
    length: function() {
        return this.node.getComputedTextLength();
    },
    move: function(t, e, i = this.bbox()) {
        return this.x(t, i).y(e, i);
    },
    plain: function(t) {
        return !1 === this._build && this.clear(), this.node.appendChild($e4b487e979d7c06d$var$O.document.createTextNode(t)), this;
    },
    x: function(t, e = this.bbox()) {
        return null == t ? e.x : this.attr("x", this.attr("x") + t - e.x);
    },
    y: function(t, e = this.bbox()) {
        return null == t ? e.y : this.attr("y", this.attr("y") + t - e.y);
    }
});
class $e4b487e979d7c06d$var$oi extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("text", t), e), this.dom.leading = this.dom.leading ?? new $e4b487e979d7c06d$var$_t(1.3), this._rebuild = !0, this._build = !1;
    }
    leading(t) {
        return null == t ? this.dom.leading : (this.dom.leading = new $e4b487e979d7c06d$var$_t(t), this.rebuild());
    }
    rebuild(t) {
        if ("boolean" == typeof t && (this._rebuild = t), this._rebuild) {
            const t = this;
            let e = 0;
            const i = this.dom.leading;
            this.each(function(a) {
                if ($e4b487e979d7c06d$var$X(this.node)) return;
                const s = $e4b487e979d7c06d$var$O.window.getComputedStyle(this.node).getPropertyValue("font-size"), r = i * new $e4b487e979d7c06d$var$_t(s);
                this.dom.newLined && (this.attr("x", t.attr("x")), "\n" === this.text() ? e += r : (this.attr("dy", a ? r + e : 0), e = 0));
            }), this.fire("rebuild");
        }
        return this;
    }
    setData(t) {
        return this.dom = t, this.dom.leading = new $e4b487e979d7c06d$var$_t(t.leading || 1.3), this;
    }
    writeDataToDom() {
        return $e4b487e979d7c06d$var$R(this, this.dom, {
            leading: 1.3
        }), this;
    }
    text(t) {
        if (void 0 === t) {
            const e = this.node.childNodes;
            let i = 0;
            t = "";
            for(let a = 0, s = e.length; a < s; ++a)"textPath" === e[a].nodeName || $e4b487e979d7c06d$var$X(e[a]) ? 0 === a && (i = a + 1) : (a !== i && 3 !== e[a].nodeType && !0 === $e4b487e979d7c06d$var$V(e[a]).dom.newLined && (t += "\n"), t += e[a].textContent);
            return t;
        }
        if (this.clear().build(!0), "function" == typeof t) t.call(this, this);
        else for(let e = 0, i = (t = (t + "").split("\n")).length; e < i; e++)this.newLine(t[e]);
        return this.build(!1).rebuild();
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$oi, $e4b487e979d7c06d$var$ni), $e4b487e979d7c06d$var$A({
    Container: {
        text: $e4b487e979d7c06d$var$K(function(t = "") {
            return this.put(new $e4b487e979d7c06d$var$oi).text(t);
        }),
        plain: $e4b487e979d7c06d$var$K(function(t = "") {
            return this.put(new $e4b487e979d7c06d$var$oi).plain(t);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$oi, "Text");
class $e4b487e979d7c06d$var$li extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("tspan", t), e), this._build = !1;
    }
    dx(t) {
        return this.attr("dx", t);
    }
    dy(t) {
        return this.attr("dy", t);
    }
    newLine() {
        this.dom.newLined = !0;
        const t = this.parent();
        if (!(t instanceof $e4b487e979d7c06d$var$oi)) return this;
        const e = t.index(this), i = $e4b487e979d7c06d$var$O.window.getComputedStyle(this.node).getPropertyValue("font-size"), a = t.dom.leading * new $e4b487e979d7c06d$var$_t(i);
        return this.dy(e ? a : 0).attr("x", t.x());
    }
    text(t) {
        return null == t ? this.node.textContent + (this.dom.newLined ? "\n" : "") : ("function" == typeof t ? (this.clear().build(!0), t.call(this, this), this.build(!1)) : this.plain(t), this);
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$li, $e4b487e979d7c06d$var$ni), $e4b487e979d7c06d$var$A({
    Tspan: {
        tspan: $e4b487e979d7c06d$var$K(function(t = "") {
            const e = new $e4b487e979d7c06d$var$li;
            return this._build || this.clear(), this.put(e).text(t);
        })
    },
    Text: {
        newLine: function(t = "") {
            return this.tspan(t).newLine();
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$li, "Tspan");
class $e4b487e979d7c06d$var$hi extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("circle", t), e);
    }
    radius(t) {
        return this.attr("r", t);
    }
    rx(t) {
        return this.attr("r", t);
    }
    ry(t) {
        return this.rx(t);
    }
    size(t) {
        return this.radius(new $e4b487e979d7c06d$var$_t(t).divide(2));
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$hi, {
    x: $e4b487e979d7c06d$var$Jt,
    y: $e4b487e979d7c06d$var$Qt,
    cx: $e4b487e979d7c06d$var$Kt,
    cy: $e4b487e979d7c06d$var$te,
    width: $e4b487e979d7c06d$var$ee,
    height: $e4b487e979d7c06d$var$ie
}), $e4b487e979d7c06d$var$A({
    Container: {
        circle: $e4b487e979d7c06d$var$K(function(t = 0) {
            return this.put(new $e4b487e979d7c06d$var$hi).size(t).move(0, 0);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$hi, "Circle");
class $e4b487e979d7c06d$var$ci extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("clipPath", t), e);
    }
    remove() {
        return this.targets().forEach(function(t) {
            t.unclip();
        }), super.remove();
    }
    targets() {
        return $e4b487e979d7c06d$var$Lt("svg [clip-path*=" + this.id() + "]");
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        clip: $e4b487e979d7c06d$var$K(function() {
            return this.defs().put(new $e4b487e979d7c06d$var$ci);
        })
    },
    Element: {
        clipper () {
            return this.reference("clip-path");
        },
        clipWith (t) {
            const e = t instanceof $e4b487e979d7c06d$var$ci ? t : this.parent().clip().add(t);
            return this.attr("clip-path", "url(#" + e.id() + ")");
        },
        unclip () {
            return this.attr("clip-path", null);
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$ci, "ClipPath");
class $e4b487e979d7c06d$var$di extends $e4b487e979d7c06d$var$Gt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("foreignObject", t), e);
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        foreignObject: $e4b487e979d7c06d$var$K(function(t, e) {
            return this.put(new $e4b487e979d7c06d$var$di).size(t, e);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$di, "ForeignObject");
var $e4b487e979d7c06d$var$ui = Object.freeze({
    __proto__: null,
    dmove: function(t, e) {
        return this.children().forEach((i)=>{
            let a;
            try {
                a = i.node instanceof $e4b487e979d7c06d$var$F().SVGSVGElement ? new $e4b487e979d7c06d$var$kt(i.attr([
                    "x",
                    "y",
                    "width",
                    "height"
                ])) : i.bbox();
            } catch (t) {
                return;
            }
            const s = new $e4b487e979d7c06d$var$vt(i), r = s.translate(t, e).transform(s.inverse()), n = new $e4b487e979d7c06d$var$bt(a.x, a.y).transform(r);
            i.move(n.x, n.y);
        }), this;
    },
    dx: function(t) {
        return this.dmove(t, 0);
    },
    dy: function(t) {
        return this.dmove(0, t);
    },
    height: function(t, e = this.bbox()) {
        return null == t ? e.height : this.size(e.width, t, e);
    },
    move: function(t = 0, e = 0, i = this.bbox()) {
        const a = t - i.x, s = e - i.y;
        return this.dmove(a, s);
    },
    size: function(t, e, i = this.bbox()) {
        const a = $e4b487e979d7c06d$var$I(this, t, e, i), s = a.width / i.width, r = a.height / i.height;
        return this.children().forEach((t)=>{
            const e = new $e4b487e979d7c06d$var$bt(i).transform(new $e4b487e979d7c06d$var$vt(t).inverse());
            t.scale(s, r, e.x, e.y);
        }), this;
    },
    width: function(t, e = this.bbox()) {
        return null == t ? e.width : this.size(t, e.height, e);
    },
    x: function(t, e = this.bbox()) {
        return null == t ? e.x : this.move(t, e.y, e);
    },
    y: function(t, e = this.bbox()) {
        return null == t ? e.y : this.move(e.x, t, e);
    }
});
class $e4b487e979d7c06d$var$gi extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("g", t), e);
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$gi, $e4b487e979d7c06d$var$ui), $e4b487e979d7c06d$var$A({
    Container: {
        group: $e4b487e979d7c06d$var$K(function() {
            return this.put(new $e4b487e979d7c06d$var$gi);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$gi, "G");
class $e4b487e979d7c06d$var$pi extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("a", t), e);
    }
    target(t) {
        return this.attr("target", t);
    }
    to(t) {
        return this.attr("href", t, $e4b487e979d7c06d$var$H);
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$pi, $e4b487e979d7c06d$var$ui), $e4b487e979d7c06d$var$A({
    Container: {
        link: $e4b487e979d7c06d$var$K(function(t) {
            return this.put(new $e4b487e979d7c06d$var$pi).to(t);
        })
    },
    Element: {
        unlink () {
            const t = this.linker();
            if (!t) return this;
            const e = t.parent();
            if (!e) return this.remove();
            const i = e.index(t);
            return e.add(this, i), t.remove(), this;
        },
        linkTo (t) {
            let e = this.linker();
            return e || (e = new $e4b487e979d7c06d$var$pi, this.wrap(e)), "function" == typeof t ? t.call(e, e) : e.to(t), this;
        },
        linker () {
            const t = this.parent();
            return t && "a" === t.node.nodeName.toLowerCase() ? t : null;
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$pi, "A");
class $e4b487e979d7c06d$var$fi extends $e4b487e979d7c06d$var$Vt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("mask", t), e);
    }
    remove() {
        return this.targets().forEach(function(t) {
            t.unmask();
        }), super.remove();
    }
    targets() {
        return $e4b487e979d7c06d$var$Lt("svg [mask*=" + this.id() + "]");
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        mask: $e4b487e979d7c06d$var$K(function() {
            return this.defs().put(new $e4b487e979d7c06d$var$fi);
        })
    },
    Element: {
        masker () {
            return this.reference("mask");
        },
        maskWith (t) {
            const e = t instanceof $e4b487e979d7c06d$var$fi ? t : this.parent().mask().add(t);
            return this.attr("mask", "url(#" + e.id() + ")");
        },
        unmask () {
            return this.attr("mask", null);
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$fi, "Mask");
class $e4b487e979d7c06d$var$xi extends $e4b487e979d7c06d$var$Gt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("stop", t), e);
    }
    update(t) {
        return ("number" == typeof t || t instanceof $e4b487e979d7c06d$var$_t) && (t = {
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        }), null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", new $e4b487e979d7c06d$var$_t(t.offset)), this;
    }
}
$e4b487e979d7c06d$var$A({
    Gradient: {
        stop: function(t, e, i) {
            return this.put(new $e4b487e979d7c06d$var$xi).update(t, e, i);
        }
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$xi, "Stop");
class $e4b487e979d7c06d$var$bi extends $e4b487e979d7c06d$var$Gt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("style", t), e);
    }
    addText(t = "") {
        return this.node.textContent += t, this;
    }
    font(t, e, i = {}) {
        return this.rule("@font-face", {
            fontFamily: t,
            src: e,
            ...i
        });
    }
    rule(t, e) {
        return this.addText(function(t, e) {
            if (!t) return "";
            if (!e) return t;
            let i = t + "{";
            for(const t in e)i += t.replace(/([A-Z])/g, function(t, e) {
                return "-" + e.toLowerCase();
            }) + ":" + e[t] + ";";
            return i += "}", i;
        }(t, e));
    }
}
$e4b487e979d7c06d$var$A("Dom", {
    style (t, e) {
        return this.put(new $e4b487e979d7c06d$var$bi).rule(t, e);
    },
    fontface (t, e, i) {
        return this.put(new $e4b487e979d7c06d$var$bi).font(t, e, i);
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$bi, "Style");
class $e4b487e979d7c06d$var$mi extends $e4b487e979d7c06d$var$oi {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("textPath", t), e);
    }
    array() {
        const t = this.track();
        return t ? t.array() : null;
    }
    plot(t) {
        const e = this.track();
        let i = null;
        return e && (i = e.plot(t)), null == t ? i : this;
    }
    track() {
        return this.reference("href");
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        textPath: $e4b487e979d7c06d$var$K(function(t, e) {
            return t instanceof $e4b487e979d7c06d$var$oi || (t = this.text(t)), t.path(e);
        })
    },
    Text: {
        path: $e4b487e979d7c06d$var$K(function(t, e = !0) {
            const i = new $e4b487e979d7c06d$var$mi;
            let a;
            if (t instanceof $e4b487e979d7c06d$var$We || (t = this.defs().path(t)), i.attr("href", "#" + t, $e4b487e979d7c06d$var$H), e) for(; a = this.node.firstChild;)i.node.appendChild(a);
            return this.put(i);
        }),
        textPath () {
            return this.findOne("textPath");
        }
    },
    Path: {
        text: $e4b487e979d7c06d$var$K(function(t) {
            return t instanceof $e4b487e979d7c06d$var$oi || (t = (new $e4b487e979d7c06d$var$oi).addTo(this.parent()).text(t)), t.path(this);
        }),
        targets () {
            return $e4b487e979d7c06d$var$Lt("svg textPath").filter((t)=>(t.attr("href") || "").includes(this.id()));
        }
    }
}), $e4b487e979d7c06d$var$mi.prototype.MorphArray = $e4b487e979d7c06d$var$Ee, $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$mi, "TextPath");
class $e4b487e979d7c06d$var$vi extends $e4b487e979d7c06d$var$qt {
    constructor(t, e = t){
        super($e4b487e979d7c06d$var$G("use", t), e);
    }
    use(t, e) {
        return this.attr("href", (e || "") + "#" + t, $e4b487e979d7c06d$var$H);
    }
}
$e4b487e979d7c06d$var$A({
    Container: {
        use: $e4b487e979d7c06d$var$K(function(t, e) {
            return this.put(new $e4b487e979d7c06d$var$vi).use(t, e);
        })
    }
}), $e4b487e979d7c06d$var$q($e4b487e979d7c06d$var$vi, "Use");
const $e4b487e979d7c06d$var$yi = $e4b487e979d7c06d$var$B;
$e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$si,
    $e4b487e979d7c06d$var$ri,
    $e4b487e979d7c06d$var$de,
    $e4b487e979d7c06d$var$ce,
    $e4b487e979d7c06d$var$be
], $e4b487e979d7c06d$var$C("viewbox")), $e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$xe,
    $e4b487e979d7c06d$var$je,
    $e4b487e979d7c06d$var$Ge,
    $e4b487e979d7c06d$var$We
], $e4b487e979d7c06d$var$C("marker")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$oi, $e4b487e979d7c06d$var$C("Text")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$We, $e4b487e979d7c06d$var$C("Path")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Ut, $e4b487e979d7c06d$var$C("Defs")), $e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$oi,
    $e4b487e979d7c06d$var$li
], $e4b487e979d7c06d$var$C("Tspan")), $e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$Ve,
    $e4b487e979d7c06d$var$se,
    $e4b487e979d7c06d$var$he,
    $e4b487e979d7c06d$var$Qe
], $e4b487e979d7c06d$var$C("radius")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Rt, $e4b487e979d7c06d$var$C("EventTarget")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Bt, $e4b487e979d7c06d$var$C("Dom")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Gt, $e4b487e979d7c06d$var$C("Element")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$qt, $e4b487e979d7c06d$var$C("Shape")), $e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$Vt,
    $e4b487e979d7c06d$var$re
], $e4b487e979d7c06d$var$C("Container")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$he, $e4b487e979d7c06d$var$C("Gradient")), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Qe, $e4b487e979d7c06d$var$C("Runner")), $e4b487e979d7c06d$var$Ct.extend([
    ...new Set($e4b487e979d7c06d$var$k)
]), function(t = []) {
    $e4b487e979d7c06d$var$Ne.push(...[].concat(t));
}([
    $e4b487e979d7c06d$var$_t,
    $e4b487e979d7c06d$var$xt,
    $e4b487e979d7c06d$var$kt,
    $e4b487e979d7c06d$var$vt,
    $e4b487e979d7c06d$var$Dt,
    $e4b487e979d7c06d$var$ge,
    $e4b487e979d7c06d$var$Ee,
    $e4b487e979d7c06d$var$bt
]), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Ne, {
    to (t) {
        return (new $e4b487e979d7c06d$var$He).type(this.constructor).from(this.toArray()).to(t);
    },
    fromArray (t) {
        return this.init(t), this;
    },
    toConsumable () {
        return this.toArray();
    },
    morph (t, e, i, a, s) {
        return this.fromArray(t.map(function(t, r) {
            return a.step(t, e[r], i, s[r], s);
        }));
    }
});
class $e4b487e979d7c06d$var$wi extends $e4b487e979d7c06d$var$Gt {
    constructor(t){
        super($e4b487e979d7c06d$var$G("filter", t), t), this.$source = "SourceGraphic", this.$sourceAlpha = "SourceAlpha", this.$background = "BackgroundImage", this.$backgroundAlpha = "BackgroundAlpha", this.$fill = "FillPaint", this.$stroke = "StrokePaint", this.$autoSetIn = !0;
    }
    put(t, e) {
        return !(t = super.put(t, e)).attr("in") && this.$autoSetIn && t.attr("in", this.$source), t.attr("result") || t.attr("result", t.id()), t;
    }
    remove() {
        return this.targets().each("unfilter"), super.remove();
    }
    targets() {
        return $e4b487e979d7c06d$var$Lt('svg [filter*="' + this.id() + '"]');
    }
    toString() {
        return "url(#" + this.id() + ")";
    }
}
class $e4b487e979d7c06d$var$ki extends $e4b487e979d7c06d$var$Gt {
    constructor(t, e){
        super(t, e), this.result(this.id());
    }
    in(t) {
        if (null == t) {
            const t = this.attr("in");
            return this.parent() && this.parent().find(`[result="${t}"]`)[0] || t;
        }
        return this.attr("in", t);
    }
    result(t) {
        return this.attr("result", t);
    }
    toString() {
        return this.result();
    }
}
const $e4b487e979d7c06d$var$Ai = (t)=>function(...e) {
        for(let i = t.length; i--;)null != e[i] && this.attr(t[i], e[i]);
    }, $e4b487e979d7c06d$var$Ci = {
    blend: $e4b487e979d7c06d$var$Ai([
        "in",
        "in2",
        "mode"
    ]),
    colorMatrix: $e4b487e979d7c06d$var$Ai([
        "type",
        "values"
    ]),
    composite: $e4b487e979d7c06d$var$Ai([
        "in",
        "in2",
        "operator"
    ]),
    convolveMatrix: function(t) {
        t = new $e4b487e979d7c06d$var$Dt(t).toString(), this.attr({
            order: Math.sqrt(t.split(" ").length),
            kernelMatrix: t
        });
    },
    diffuseLighting: $e4b487e979d7c06d$var$Ai([
        "surfaceScale",
        "lightingColor",
        "diffuseConstant",
        "kernelUnitLength"
    ]),
    displacementMap: $e4b487e979d7c06d$var$Ai([
        "in",
        "in2",
        "scale",
        "xChannelSelector",
        "yChannelSelector"
    ]),
    dropShadow: $e4b487e979d7c06d$var$Ai([
        "in",
        "dx",
        "dy",
        "stdDeviation"
    ]),
    flood: $e4b487e979d7c06d$var$Ai([
        "flood-color",
        "flood-opacity"
    ]),
    gaussianBlur: function(t = 0, e = t) {
        this.attr("stdDeviation", t + " " + e);
    },
    image: function(t) {
        this.attr("href", t, $e4b487e979d7c06d$var$H);
    },
    morphology: $e4b487e979d7c06d$var$Ai([
        "operator",
        "radius"
    ]),
    offset: $e4b487e979d7c06d$var$Ai([
        "dx",
        "dy"
    ]),
    specularLighting: $e4b487e979d7c06d$var$Ai([
        "surfaceScale",
        "lightingColor",
        "diffuseConstant",
        "specularExponent",
        "kernelUnitLength"
    ]),
    tile: $e4b487e979d7c06d$var$Ai([]),
    turbulence: $e4b487e979d7c06d$var$Ai([
        "baseFrequency",
        "numOctaves",
        "seed",
        "stitchTiles",
        "type"
    ])
};
[
    "blend",
    "colorMatrix",
    "componentTransfer",
    "composite",
    "convolveMatrix",
    "diffuseLighting",
    "displacementMap",
    "dropShadow",
    "flood",
    "gaussianBlur",
    "image",
    "merge",
    "morphology",
    "offset",
    "specularLighting",
    "tile",
    "turbulence"
].forEach((t)=>{
    const e = $e4b487e979d7c06d$var$P(t), i = $e4b487e979d7c06d$var$Ci[t];
    $e4b487e979d7c06d$var$wi[e + "Effect"] = class extends $e4b487e979d7c06d$var$ki {
        constructor(t){
            super($e4b487e979d7c06d$var$G("fe" + e, t), t);
        }
        update(t) {
            return i.apply(this, t), this;
        }
    }, $e4b487e979d7c06d$var$wi.prototype[t] = $e4b487e979d7c06d$var$K(function(t, ...i) {
        const a = new $e4b487e979d7c06d$var$wi[e + "Effect"];
        return null == t ? this.put(a) : ("function" == typeof t ? t.call(a, a) : i.unshift(t), this.put(a).update(i));
    });
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$wi, {
    merge (t) {
        const e = this.put(new $e4b487e979d7c06d$var$wi.MergeEffect);
        if ("function" == typeof t) return t.call(e, e), e;
        return (t instanceof Array ? t : [
            ...arguments
        ]).forEach((t)=>{
            t instanceof $e4b487e979d7c06d$var$wi.MergeNode ? e.put(t) : e.mergeNode(t);
        }), e;
    },
    componentTransfer (t = {}) {
        const e = this.put(new $e4b487e979d7c06d$var$wi.ComponentTransferEffect);
        if ("function" == typeof t) return t.call(e, e), e;
        if (!(t.r || t.g || t.b || t.a)) t = {
            r: t,
            g: t,
            b: t,
            a: t
        };
        for(const i in t)e.add(new $e4b487e979d7c06d$var$wi["Func" + i.toUpperCase()](t[i]));
        return e;
    }
});
[
    "distantLight",
    "pointLight",
    "spotLight",
    "mergeNode",
    "FuncR",
    "FuncG",
    "FuncB",
    "FuncA"
].forEach((t)=>{
    const e = $e4b487e979d7c06d$var$P(t);
    $e4b487e979d7c06d$var$wi[e] = class extends $e4b487e979d7c06d$var$ki {
        constructor(t){
            super($e4b487e979d7c06d$var$G("fe" + e, t), t);
        }
    };
});
[
    "funcR",
    "funcG",
    "funcB",
    "funcA"
].forEach(function(t) {
    const e = $e4b487e979d7c06d$var$wi[$e4b487e979d7c06d$var$P(t)], i = $e4b487e979d7c06d$var$K(function() {
        return this.put(new e);
    });
    $e4b487e979d7c06d$var$wi.ComponentTransferEffect.prototype[t] = i;
});
[
    "distantLight",
    "pointLight",
    "spotLight"
].forEach((t)=>{
    const e = $e4b487e979d7c06d$var$wi[$e4b487e979d7c06d$var$P(t)], i = $e4b487e979d7c06d$var$K(function() {
        return this.put(new e);
    });
    $e4b487e979d7c06d$var$wi.DiffuseLightingEffect.prototype[t] = i, $e4b487e979d7c06d$var$wi.SpecularLightingEffect.prototype[t] = i;
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$wi.MergeEffect, {
    mergeNode (t) {
        return this.put(new $e4b487e979d7c06d$var$wi.MergeNode).attr("in", t);
    }
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Ut, {
    filter: function(t) {
        const e = this.put(new $e4b487e979d7c06d$var$wi);
        return "function" == typeof t && t.call(e, e), e;
    }
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Vt, {
    filter: function(t) {
        return this.defs().filter(t);
    }
}), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Gt, {
    filterWith: function(t) {
        const e = t instanceof $e4b487e979d7c06d$var$wi ? t : this.defs().filter(t);
        return this.attr("filter", e);
    },
    unfilter: function(t) {
        return this.attr("filter", null);
    },
    filterer () {
        return this.reference("filter");
    }
});
const $e4b487e979d7c06d$var$Si = {
    blend: function(t, e) {
        return this.parent() && this.parent().blend(this, t, e);
    },
    colorMatrix: function(t, e) {
        return this.parent() && this.parent().colorMatrix(t, e).in(this);
    },
    componentTransfer: function(t) {
        return this.parent() && this.parent().componentTransfer(t).in(this);
    },
    composite: function(t, e) {
        return this.parent() && this.parent().composite(this, t, e);
    },
    convolveMatrix: function(t) {
        return this.parent() && this.parent().convolveMatrix(t).in(this);
    },
    diffuseLighting: function(t, e, i, a) {
        return this.parent() && this.parent().diffuseLighting(t, i, a).in(this);
    },
    displacementMap: function(t, e, i, a) {
        return this.parent() && this.parent().displacementMap(this, t, e, i, a);
    },
    dropShadow: function(t, e, i) {
        return this.parent() && this.parent().dropShadow(this, t, e, i).in(this);
    },
    flood: function(t, e) {
        return this.parent() && this.parent().flood(t, e);
    },
    gaussianBlur: function(t, e) {
        return this.parent() && this.parent().gaussianBlur(t, e).in(this);
    },
    image: function(t) {
        return this.parent() && this.parent().image(t);
    },
    merge: function(t) {
        return t = t instanceof Array ? t : [
            ...t
        ], this.parent() && this.parent().merge(this, ...t);
    },
    morphology: function(t, e) {
        return this.parent() && this.parent().morphology(t, e).in(this);
    },
    offset: function(t, e) {
        return this.parent() && this.parent().offset(t, e).in(this);
    },
    specularLighting: function(t, e, i, a, s) {
        return this.parent() && this.parent().specularLighting(t, i, a, s).in(this);
    },
    tile: function() {
        return this.parent() && this.parent().tile().in(this);
    },
    turbulence: function(t, e, i, a, s) {
        return this.parent() && this.parent().turbulence(t, e, i, a, s).in(this);
    }
};
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$ki, $e4b487e979d7c06d$var$Si), $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$wi.MergeEffect, {
    in: function(t) {
        return t instanceof $e4b487e979d7c06d$var$wi.MergeNode ? this.add(t, 0) : this.add((new $e4b487e979d7c06d$var$wi.MergeNode).in(t), 0), this;
    }
}), $e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$wi.CompositeEffect,
    $e4b487e979d7c06d$var$wi.BlendEffect,
    $e4b487e979d7c06d$var$wi.DisplacementMapEffect
], {
    in2: function(t) {
        if (null == t) {
            const t = this.attr("in2");
            return this.parent() && this.parent().find(`[result="${t}"]`)[0] || t;
        }
        return this.attr("in2", t);
    }
}), $e4b487e979d7c06d$var$wi.filter = {
    sepiatone: [
        .343,
        .669,
        .119,
        0,
        0,
        .249,
        .626,
        .13,
        0,
        0,
        .172,
        .334,
        .111,
        0,
        0,
        0,
        0,
        0,
        1,
        0
    ]
};
var $e4b487e979d7c06d$var$Li = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getDefaultFilter",
            value: function(t, e) {
                var i = this.w;
                t.unfilter(!0), (new $e4b487e979d7c06d$var$wi).size("120%", "180%", "-5%", "-40%"), i.config.chart.dropShadow.enabled && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "applyFilter",
            value: function(t, e, i) {
                var a, s = this, r = this.w;
                if (t.unfilter(!0), "none" !== i) {
                    var n, o, l = r.config.chart.dropShadow, h = "lighten" === i ? 2 : .3;
                    if (t.filterWith(function(t) {
                        t.colorMatrix({
                            type: "matrix",
                            values: "\n          ".concat(h, " 0 0 0 0\n          0 ").concat(h, " 0 0 0\n          0 0 ").concat(h, " 0 0\n          0 0 0 1 0\n        "),
                            in: "SourceGraphic",
                            result: "brightness"
                        }), l.enabled && s.addShadow(t, e, l, "brightness");
                    }), !l.noUserSpaceOnUse) null === (n = t.filterer()) || void 0 === n || null === (o = n.node) || void 0 === o || o.setAttribute("filterUnits", "userSpaceOnUse");
                    this._scaleFilterSize(null === (a = t.filterer()) || void 0 === a ? void 0 : a.node);
                } else this.getDefaultFilter(t, e);
            }
        },
        {
            key: "addShadow",
            value: function(t, e, i, a) {
                var s, r = this.w, n = i.blur, o = i.top, l = i.left, h = i.color, c = i.opacity;
                if (h = Array.isArray(h) ? h[e] : h, (null === (s = r.config.chart.dropShadow.enabledOnSeries) || void 0 === s ? void 0 : s.length) > 0 && -1 === r.config.chart.dropShadow.enabledOnSeries.indexOf(e)) return t;
                t.offset({
                    in: a,
                    dx: l,
                    dy: o,
                    result: "offset"
                }), t.gaussianBlur({
                    in: "offset",
                    stdDeviation: n,
                    result: "blur"
                }), t.flood({
                    "flood-color": h,
                    "flood-opacity": c,
                    result: "flood"
                }), t.composite({
                    in: "flood",
                    in2: "blur",
                    operator: "in",
                    result: "shadow"
                }), t.merge([
                    "shadow",
                    a
                ]);
            }
        },
        {
            key: "dropShadow",
            value: function(t, e) {
                var i, a, s, r, n, o = this, l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, h = this.w;
                if (t.unfilter(!0), $e4b487e979d7c06d$var$v.isMsEdge() && "radialBar" === h.config.chart.type) return t;
                if ((null === (i = h.config.chart.dropShadow.enabledOnSeries) || void 0 === i ? void 0 : i.length) > 0 && -1 === (null === (s = h.config.chart.dropShadow.enabledOnSeries) || void 0 === s ? void 0 : s.indexOf(l))) return t;
                (t.filterWith(function(t) {
                    o.addShadow(t, l, e, "SourceGraphic");
                }), e.noUserSpaceOnUse) || null === (r = t.filterer()) || void 0 === r || null === (n = r.node) || void 0 === n || n.setAttribute("filterUnits", "userSpaceOnUse");
                return this._scaleFilterSize(null === (a = t.filterer()) || void 0 === a ? void 0 : a.node), t;
            }
        },
        {
            key: "setSelectionFilter",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.globals.selectedDataPoints[e] && a.globals.selectedDataPoints[e].indexOf(i) > -1) {
                    t.node.setAttribute("selected", !0);
                    var s = a.config.states.active.filter;
                    "none" !== s && this.applyFilter(t, e, s.type);
                }
            }
        },
        {
            key: "_scaleFilterSize",
            value: function(t) {
                if (t) !function(e) {
                    for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
                }({
                    width: "200%",
                    height: "200%",
                    x: "-50%",
                    y: "-50%"
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Mi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "roundPathCorners",
            value: function(t, e) {
                function i(t, e, i) {
                    var s = e.x - t.x, r = e.y - t.y, n = Math.sqrt(s * s + r * r);
                    return a(t, e, Math.min(1, i / n));
                }
                function a(t, e, i) {
                    return {
                        x: t.x + (e.x - t.x) * i,
                        y: t.y + (e.y - t.y) * i
                    };
                }
                function s(t, e) {
                    t.length > 2 && (t[t.length - 2] = e.x, t[t.length - 1] = e.y);
                }
                function r(t) {
                    return {
                        x: parseFloat(t[t.length - 2]),
                        y: parseFloat(t[t.length - 1])
                    };
                }
                t.indexOf("NaN") > -1 && (t = "");
                var n = t.split(/[,\s]/).reduce(function(t, e) {
                    var i = e.match(/^([a-zA-Z])(.+)/);
                    return i ? (t.push(i[1]), t.push(i[2])) : t.push(e), t;
                }, []).reduce(function(t, e) {
                    return parseFloat(e) == e && t.length ? t[t.length - 1].push(e) : t.push([
                        e
                    ]), t;
                }, []), o = [];
                if (n.length > 1) {
                    var l = r(n[0]), h = null;
                    "Z" == n[n.length - 1][0] && n[0].length > 2 && (h = [
                        "L",
                        l.x,
                        l.y
                    ], n[n.length - 1] = h), o.push(n[0]);
                    for(var c = 1; c < n.length; c++){
                        var d = o[o.length - 1], u = n[c], g = u == h ? n[1] : n[c + 1];
                        if (g && d && d.length > 2 && "L" == u[0] && g.length > 2 && "L" == g[0]) {
                            var p, f, x = r(d), b = r(u), m = r(g);
                            p = i(b, x, e), f = i(b, m, e), s(u, p), u.origPoint = b, o.push(u);
                            var v = a(p, b, .5), y = a(b, f, .5), w = [
                                "C",
                                v.x,
                                v.y,
                                y.x,
                                y.y,
                                f.x,
                                f.y
                            ];
                            w.origPoint = b, o.push(w);
                        } else o.push(u);
                    }
                    if (h) {
                        var k = r(o[o.length - 1]);
                        o.push([
                            "Z"
                        ]), s(o[0], k);
                    }
                } else o = n;
                return o.reduce(function(t, e) {
                    return t + e.join(" ") + " ";
                }, "");
            }
        },
        {
            key: "drawLine",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, n = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "butt";
                return this.w.globals.dom.Paper.line().attr({
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: a,
                    stroke: s,
                    "stroke-dasharray": r,
                    "stroke-width": n,
                    "stroke-linecap": o
                });
            }
        },
        {
            key: "drawRect",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "#fefefe", n = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1, o = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null, h = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0, c = this.w.globals.dom.Paper.rect();
                return c.attr({
                    x: t,
                    y: e,
                    width: i > 0 ? i : 0,
                    height: a > 0 ? a : 0,
                    rx: s,
                    ry: s,
                    opacity: n,
                    "stroke-width": null !== o ? o : 0,
                    stroke: null !== l ? l : "none",
                    "stroke-dasharray": h
                }), c.node.setAttribute("fill", r), c;
            }
        },
        {
            key: "drawPolygon",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "none";
                return this.w.globals.dom.Paper.polygon(t).attr({
                    fill: a,
                    stroke: e,
                    "stroke-width": i
                });
            }
        },
        {
            key: "drawCircle",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                t < 0 && (t = 0);
                var i = this.w.globals.dom.Paper.circle(2 * t);
                return null !== e && i.attr(e), i;
            }
        },
        {
            key: "drawPath",
            value: function(t) {
                var e = t.d, i = void 0 === e ? "" : e, a = t.stroke, s = void 0 === a ? "#a8a8a8" : a, r = t.strokeWidth, n = void 0 === r ? 1 : r, o = t.fill, l = t.fillOpacity, h = void 0 === l ? 1 : l, c = t.strokeOpacity, d = void 0 === c ? 1 : c, u = t.classes, g = t.strokeLinecap, p = void 0 === g ? null : g, f = t.strokeDashArray, x = void 0 === f ? 0 : f, b = this.w;
                return null === p && (p = b.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(b.globals.gridHeight)), b.globals.dom.Paper.path(i).attr({
                    fill: o,
                    "fill-opacity": h,
                    stroke: s,
                    "stroke-opacity": d,
                    "stroke-linecap": p,
                    "stroke-width": n,
                    "stroke-dasharray": x,
                    class: u
                });
            }
        },
        {
            key: "group",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w.globals.dom.Paper.group();
                return null !== t && e.attr(t), e;
            }
        },
        {
            key: "move",
            value: function(t, e) {
                var i = [
                    "M",
                    t,
                    e
                ].join(" ");
                return i;
            }
        },
        {
            key: "line",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = null;
                return null === i ? a = [
                    " L",
                    t,
                    e
                ].join(" ") : "H" === i ? a = [
                    " H",
                    t
                ].join(" ") : "V" === i && (a = [
                    " V",
                    e
                ].join(" ")), a;
            }
        },
        {
            key: "curve",
            value: function(t, e, i, a, s, r) {
                var n = [
                    "C",
                    t,
                    e,
                    i,
                    a,
                    s,
                    r
                ].join(" ");
                return n;
            }
        },
        {
            key: "quadraticCurve",
            value: function(t, e, i, a) {
                return [
                    "Q",
                    t,
                    e,
                    i,
                    a
                ].join(" ");
            }
        },
        {
            key: "arc",
            value: function(t, e, i, a, s, r, n) {
                var o = "A";
                arguments.length > 7 && void 0 !== arguments[7] && arguments[7] && (o = "a");
                var l = [
                    o,
                    t,
                    e,
                    i,
                    a,
                    s,
                    r,
                    n
                ].join(" ");
                return l;
            }
        },
        {
            key: "renderPaths",
            value: function(t) {
                var e, i = t.j, a = t.realIndex, s = t.pathFrom, r = t.pathTo, n = t.stroke, o = t.strokeWidth, l = t.strokeLinecap, h = t.fill, c = t.animationDelay, d = t.initialSpeed, g = t.dataChangeSpeed, p = t.className, f = t.chartType, x = t.shouldClipToGrid, b = void 0 === x || x, m = t.bindEventsOnPaths, v = void 0 === m || m, w = t.drawShadow, k = void 0 === w || w, A = this.w, C = new $e4b487e979d7c06d$var$Li(this.ctx), S = new $e4b487e979d7c06d$var$y(this.ctx), L = this.w.config.chart.animations.enabled, M = L && this.w.config.chart.animations.dynamicAnimation.enabled;
                if (s && s.startsWith("M 0 0") && r) {
                    var P = r.match(/^M\s+[\d.-]+\s+[\d.-]+/);
                    P && (s = s.replace(/^M\s+0\s+0/, P[0]));
                }
                var I = !!(L && !A.globals.resized || M && A.globals.dataChanged && A.globals.shouldAnimate);
                I ? e = s : (e = r, A.globals.animationEnded = !0);
                var T = A.config.stroke.dashArray, z = 0;
                z = Array.isArray(T) ? T[a] : A.config.stroke.dashArray;
                var X = this.drawPath({
                    d: e,
                    stroke: n,
                    strokeWidth: o,
                    fill: h,
                    fillOpacity: 1,
                    classes: p,
                    strokeLinecap: l,
                    strokeDashArray: z
                });
                X.attr("index", a), b && ("bar" === f && !A.globals.isHorizontal || A.globals.comboCharts ? X.attr({
                    "clip-path": "url(#gridRectBarMask".concat(A.globals.cuid, ")")
                }) : X.attr({
                    "clip-path": "url(#gridRectMask".concat(A.globals.cuid, ")")
                })), A.config.chart.dropShadow.enabled && k && C.dropShadow(X, A.config.chart.dropShadow, a), v && (X.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, X)), X.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, X)), X.node.addEventListener("mousedown", this.pathMouseDown.bind(this, X))), X.attr({
                    pathTo: r,
                    pathFrom: s
                });
                var R = {
                    el: X,
                    j: i,
                    realIndex: a,
                    pathFrom: s,
                    pathTo: r,
                    fill: h,
                    strokeWidth: o,
                    delay: c
                };
                return !L || A.globals.resized || A.globals.dataChanged ? !A.globals.resized && A.globals.dataChanged || S.showDelayedElements() : S.animatePathsGradually($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, R), {}, {
                    speed: d
                })), A.globals.dataChanged && M && I && S.animatePathsGradually($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, R), {}, {
                    speed: g
                })), X;
            }
        },
        {
            key: "drawPattern",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0;
                return this.w.globals.dom.Paper.pattern(e, i, function(r) {
                    "horizontalLines" === t ? r.line(0, 0, i, 0).stroke({
                        color: a,
                        width: s + 1
                    }) : "verticalLines" === t ? r.line(0, 0, 0, e).stroke({
                        color: a,
                        width: s + 1
                    }) : "slantedLines" === t ? r.line(0, 0, e, i).stroke({
                        color: a,
                        width: s
                    }) : "squares" === t ? r.rect(e, i).fill("none").stroke({
                        color: a,
                        width: s
                    }) : "circles" === t && r.circle(e).fill("none").stroke({
                        color: a,
                        width: s
                    });
                });
            }
        },
        {
            key: "drawGradient",
            value: function(t, e, i, a, s) {
                var r, n = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : [], h = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, c = this.w;
                e.length < 9 && 0 === e.indexOf("#") && (e = $e4b487e979d7c06d$var$v.hexToRgba(e, a)), i.length < 9 && 0 === i.indexOf("#") && (i = $e4b487e979d7c06d$var$v.hexToRgba(i, s));
                var d = 0, u = 1, g = 1, p = null;
                null !== o && (d = void 0 !== o[0] ? o[0] / 100 : 0, u = void 0 !== o[1] ? o[1] / 100 : 1, g = void 0 !== o[2] ? o[2] / 100 : 1, p = void 0 !== o[3] ? o[3] / 100 : null);
                var f = !("donut" !== c.config.chart.type && "pie" !== c.config.chart.type && "polarArea" !== c.config.chart.type && "bubble" !== c.config.chart.type);
                if (r = l && 0 !== l.length ? c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    (Array.isArray(l[h]) ? l[h] : l).forEach(function(e) {
                        t.stop(e.offset / 100, e.color, e.opacity);
                    });
                }) : c.globals.dom.Paper.gradient(f ? "radial" : "linear", function(t) {
                    t.stop(d, e, a), t.stop(u, i, s), t.stop(g, i, s), null !== p && t.stop(p, e, a);
                }), f) {
                    var x = c.globals.gridWidth / 2, b = c.globals.gridHeight / 2;
                    "bubble" !== c.config.chart.type ? r.attr({
                        gradientUnits: "userSpaceOnUse",
                        cx: x,
                        cy: b,
                        r: n
                    }) : r.attr({
                        cx: .5,
                        cy: .5,
                        r: .8,
                        fx: .2,
                        fy: .2
                    });
                } else "vertical" === t ? r.from(0, 0).to(0, 1) : "diagonal" === t ? r.from(0, 0).to(1, 1) : "horizontal" === t ? r.from(0, 1).to(1, 1) : "diagonal2" === t && r.from(1, 0).to(0, 1);
                return r;
            }
        },
        {
            key: "getTextBasedOnMaxWidth",
            value: function(t) {
                var e = t.text, i = t.maxWidth, a = t.fontSize, s = t.fontFamily, r = this.getTextRects(e, a, s), n = r.width / e.length, o = Math.floor(i / n);
                return i < r.width ? e.slice(0, o - 3) + "..." : e;
            }
        },
        {
            key: "drawText",
            value: function(t) {
                var e = this, i = t.x, a = t.y, s = t.text, r = t.textAnchor, n = t.fontSize, o = t.fontFamily, l = t.fontWeight, h = t.foreColor, c = t.opacity, d = t.maxWidth, g = t.cssClass, p = void 0 === g ? "" : g, f = t.isPlainText, x = void 0 === f || f, b = t.dominantBaseline, m = void 0 === b ? "auto" : b, v = this.w;
                void 0 === s && (s = "");
                var y = s;
                r || (r = "start"), h && h.length || (h = v.config.chart.foreColor), o = o || v.config.chart.fontFamily, l = l || "regular";
                var w, k = {
                    maxWidth: d,
                    fontSize: n = n || "11px",
                    fontFamily: o
                };
                return Array.isArray(s) ? w = v.globals.dom.Paper.text(function(t) {
                    for(var i = 0; i < s.length; i++)y = s[i], d && (y = e.getTextBasedOnMaxWidth($e4b487e979d7c06d$var$u({
                        text: s[i]
                    }, k))), 0 === i ? t.tspan(y) : t.tspan(y).newLine();
                }) : (d && (y = this.getTextBasedOnMaxWidth($e4b487e979d7c06d$var$u({
                    text: s
                }, k))), w = x ? v.globals.dom.Paper.plain(s) : v.globals.dom.Paper.text(function(t) {
                    return t.tspan(y);
                })), w.attr({
                    x: i,
                    y: a,
                    "text-anchor": r,
                    "dominant-baseline": m,
                    "font-size": n,
                    "font-family": o,
                    "font-weight": l,
                    fill: h,
                    class: "apexcharts-text " + p
                }), w.node.style.fontFamily = o, w.node.style.opacity = c, w;
            }
        },
        {
            key: "getMarkerPath",
            value: function(t, e, i, a) {
                var s = "";
                switch(i){
                    case "cross":
                        s = "M ".concat(t - (a /= 1.4), " ").concat(e - a, " L ").concat(t + a, " ").concat(e + a, "  M ").concat(t - a, " ").concat(e + a, " L ").concat(t + a, " ").concat(e - a);
                        break;
                    case "plus":
                        s = "M ".concat(t - (a /= 1.12), " ").concat(e, " L ").concat(t + a, " ").concat(e, "  M ").concat(t, " ").concat(e - a, " L ").concat(t, " ").concat(e + a);
                        break;
                    case "star":
                    case "sparkle":
                        var r = 5;
                        a *= 1.15, "sparkle" === i && (a /= 1.1, r = 4);
                        for(var n = Math.PI / r, o = 0; o <= 2 * r; o++){
                            var l = o * n, h = o % 2 == 0 ? a : a / 2;
                            s += (0 === o ? "M" : "L") + (t + h * Math.sin(l)) + "," + (e - h * Math.cos(l));
                        }
                        s += "Z";
                        break;
                    case "triangle":
                        s = "M ".concat(t, " ").concat(e - a, " \n             L ").concat(t + a, " ").concat(e + a, " \n             L ").concat(t - a, " ").concat(e + a, " \n             Z");
                        break;
                    case "square":
                    case "rect":
                        s = "M ".concat(t - (a /= 1.125), " ").concat(e - a, " \n           L ").concat(t + a, " ").concat(e - a, " \n           L ").concat(t + a, " ").concat(e + a, " \n           L ").concat(t - a, " ").concat(e + a, " \n           Z");
                        break;
                    case "diamond":
                        a *= 1.05, s = "M ".concat(t, " ").concat(e - a, " \n             L ").concat(t + a, " ").concat(e, " \n             L ").concat(t, " ").concat(e + a, " \n             L ").concat(t - a, " ").concat(e, " \n            Z");
                        break;
                    case "line":
                        s = "M ".concat(t - (a /= 1.1), " ").concat(e, " \n           L ").concat(t + a, " ").concat(e);
                        break;
                    default:
                        a *= 2, s = "M ".concat(t, ", ").concat(e, " \n           m -").concat(a / 2, ", 0 \n           a ").concat(a / 2, ",").concat(a / 2, " 0 1,0 ").concat(a, ",0 \n           a ").concat(a / 2, ",").concat(a / 2, " 0 1,0 -").concat(a, ",0");
                }
                return s;
            }
        },
        {
            key: "drawMarkerShape",
            value: function(t, e, i, a, s) {
                var r = this.drawPath({
                    d: this.getMarkerPath(t, e, i, a, s),
                    stroke: s.pointStrokeColor,
                    strokeDashArray: s.pointStrokeDashArray,
                    strokeWidth: s.pointStrokeWidth,
                    fill: s.pointFillColor,
                    fillOpacity: s.pointFillOpacity,
                    strokeOpacity: s.pointStrokeOpacity
                });
                return r.attr({
                    cx: t,
                    cy: e,
                    shape: s.shape,
                    class: s.class ? s.class : ""
                }), r;
            }
        },
        {
            key: "drawMarker",
            value: function(t, e, i) {
                t = t || 0;
                var a = i.pSize || 0;
                return $e4b487e979d7c06d$var$v.isNumber(e) || (a = 0, e = 0), this.drawMarkerShape(t, e, null == i ? void 0 : i.shape, a, $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, i), "line" === i.shape || "plus" === i.shape || "cross" === i.shape ? {
                    pointStrokeColor: i.pointFillColor,
                    pointStrokeOpacity: i.pointFillOpacity
                } : {}));
            }
        },
        {
            key: "pathMouseEnter",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Li(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                if ("function" == typeof i.config.chart.events.dataPointMouseEnter && i.config.chart.events.dataPointMouseEnter(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), ("none" === i.config.states.active.filter.type || "true" !== t.node.getAttribute("selected")) && "none" !== i.config.states.hover.filter.type && !i.globals.isTouchDevice) {
                    var n = i.config.states.hover.filter;
                    a.applyFilter(t, s, n.type);
                }
            }
        },
        {
            key: "pathMouseLeave",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Li(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                "function" == typeof i.config.chart.events.dataPointMouseLeave && i.config.chart.events.dataPointMouseLeave(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), "none" !== i.config.states.active.filter.type && "true" === t.node.getAttribute("selected") || "none" !== i.config.states.hover.filter.type && a.getDefaultFilter(t, s);
            }
        },
        {
            key: "pathMouseDown",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Li(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10), n = "false";
                if ("true" === t.node.getAttribute("selected")) {
                    if (t.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                        var o = i.globals.selectedDataPoints[s].indexOf(r);
                        i.globals.selectedDataPoints[s].splice(o, 1);
                    }
                } else {
                    if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                        i.globals.selectedDataPoints = [];
                        var l = i.globals.dom.Paper.find(".apexcharts-series path:not(.apexcharts-decoration-element)"), h = i.globals.dom.Paper.find(".apexcharts-series circle:not(.apexcharts-decoration-element), .apexcharts-series rect:not(.apexcharts-decoration-element)"), c = function(t) {
                            Array.prototype.forEach.call(t, function(t) {
                                t.node.setAttribute("selected", "false"), a.getDefaultFilter(t, s);
                            });
                        };
                        c(l), c(h);
                    }
                    t.node.setAttribute("selected", "true"), n = "true", void 0 === i.globals.selectedDataPoints[s] && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                }
                if ("true" === n) {
                    var d = i.config.states.active.filter;
                    if ("none" !== d) a.applyFilter(t, s, d.type);
                    else if ("none" !== i.config.states.hover.filter && !i.globals.isTouchDevice) {
                        var u = i.config.states.hover.filter;
                        a.applyFilter(t, s, u.type);
                    }
                } else if ("none" !== i.config.states.active.filter.type) {
                    if ("none" === i.config.states.hover.filter.type || i.globals.isTouchDevice) a.getDefaultFilter(t, s);
                    else {
                        u = i.config.states.hover.filter;
                        a.applyFilter(t, s, u.type);
                    }
                }
                "function" == typeof i.config.chart.events.dataPointSelection && i.config.chart.events.dataPointSelection(e, this.ctx, {
                    selectedDataPoints: i.globals.selectedDataPoints,
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), e && this.ctx.events.fireEvent("dataPointSelection", [
                    e,
                    this.ctx,
                    {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]);
            }
        },
        {
            key: "rotateAroundCenter",
            value: function(t) {
                var e = {};
                return t && "function" == typeof t.getBBox && (e = t.getBBox()), {
                    x: e.x + e.width / 2,
                    y: e.y + e.height / 2
                };
            }
        },
        {
            key: "getTextRects",
            value: function(t, e, i, a) {
                var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = this.w, n = this.drawText({
                    x: -200,
                    y: -200,
                    text: t,
                    textAnchor: "start",
                    fontSize: e,
                    fontFamily: i,
                    foreColor: "#fff",
                    opacity: 0
                });
                a && n.attr("transform", a), r.globals.dom.Paper.add(n);
                var o = n.bbox();
                return s || (o = n.node.getBoundingClientRect()), n.remove(), {
                    width: o.width,
                    height: o.height
                };
            }
        },
        {
            key: "placeTextWithEllipsis",
            value: function(t, e, i) {
                if ("function" == typeof t.getComputedTextLength && (t.textContent = e, e.length > 0 && t.getComputedTextLength() >= i / 1.1)) {
                    for(var a = e.length - 3; a > 0; a -= 3)if (t.getSubStringLength(0, a) <= i / 1.1) return void (t.textContent = e.substring(0, a) + "...");
                    t.textContent = ".";
                }
            }
        }
    ], [
        {
            key: "setAttrs",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Pi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getStackedSeriesTotals",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = this.w, i = [];
                if (0 === e.globals.series.length) return i;
                for(var a = 0; a < e.globals.series[e.globals.maxValsInArrayIndex].length; a++){
                    for(var s = 0, r = 0; r < e.globals.series.length; r++)void 0 !== e.globals.series[r][a] && -1 === t.indexOf(r) && (s += e.globals.series[r][a]);
                    i.push(s);
                }
                return i;
            }
        },
        {
            key: "getSeriesTotalByIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return null === t ? this.w.config.series.reduce(function(t, e) {
                    return t + e;
                }, 0) : this.w.globals.series[t].reduce(function(t, e) {
                    return t + e;
                }, 0);
            }
        },
        {
            key: "getStackedSeriesTotalsByGroups",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.globals.seriesGroups.forEach(function(a) {
                    var s = [];
                    e.config.series.forEach(function(t, i) {
                        a.indexOf(e.globals.seriesNames[i]) > -1 && s.push(i);
                    });
                    var r = e.globals.series.map(function(t, e) {
                        return -1 === s.indexOf(e) ? e : -1;
                    }).filter(function(t) {
                        return -1 !== t;
                    });
                    i.push(t.getStackedSeriesTotals(r));
                }), i;
            }
        },
        {
            key: "setSeriesYAxisMappings",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = [], a = [], s = [], r = t.series.length > e.yaxis.length || e.yaxis.some(function(t) {
                    return Array.isArray(t.seriesName);
                });
                e.series.forEach(function(t, e) {
                    s.push(e), a.push(null);
                }), e.yaxis.forEach(function(t, e) {
                    i[e] = [];
                });
                var n = [];
                e.yaxis.forEach(function(t, a) {
                    var o = !1;
                    if (t.seriesName) {
                        var l = [];
                        Array.isArray(t.seriesName) ? l = t.seriesName : l.push(t.seriesName), l.forEach(function(t) {
                            e.series.forEach(function(e, n) {
                                if (e.name === t) {
                                    var l = n;
                                    a === n || r ? !r || s.indexOf(n) > -1 ? i[a].push([
                                        a,
                                        n
                                    ]) : console.warn("Series '" + e.name + "' referenced more than once in what looks like the new style. That is, when using either seriesName: [], or when there are more series than yaxes.") : (i[n].push([
                                        n,
                                        a
                                    ]), l = a), o = !0, -1 !== (l = s.indexOf(l)) && s.splice(l, 1);
                                }
                            });
                        });
                    }
                    o || n.push(a);
                }), i = i.map(function(t, e) {
                    var i = [];
                    return t.forEach(function(t) {
                        a[t[1]] = t[0], i.push(t[1]);
                    }), i;
                });
                for(var o = e.yaxis.length - 1, l = 0; l < n.length && (o = n[l], i[o] = [], s); l++){
                    var h = s[0];
                    s.shift(), i[o].push(h), a[h] = o;
                }
                s.forEach(function(t) {
                    i[o].push(t), a[t] = o;
                }), t.seriesYAxisMap = i.map(function(t) {
                    return t;
                }), t.seriesYAxisReverseMap = a.map(function(t) {
                    return t;
                }), t.seriesYAxisMap.forEach(function(t, i) {
                    t.forEach(function(t) {
                        e.series[t] && void 0 === e.series[t].group && (e.series[t].group = "apexcharts-axis-".concat(i.toString()));
                    });
                });
            }
        },
        {
            key: "isSeriesNull",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return 0 === (null === t ? this.w.config.series.filter(function(t) {
                    return null !== t;
                }) : this.w.config.series[t].data.filter(function(t) {
                    return null !== t;
                })).length;
            }
        },
        {
            key: "seriesHaveSameValues",
            value: function(t) {
                return this.w.globals.series[t].every(function(t, e, i) {
                    return t === i[0];
                });
            }
        },
        {
            key: "getCategoryLabels",
            value: function(t) {
                var e = this.w, i = t.slice();
                return e.config.xaxis.convertedCatToNumeric && (i = t.map(function(t, i) {
                    return e.config.xaxis.labels.formatter(t - e.globals.minX + 1);
                })), i;
            }
        },
        {
            key: "getLargestSeries",
            value: function() {
                var t = this.w;
                t.globals.maxValsInArrayIndex = t.globals.series.map(function(t) {
                    return t.length;
                }).indexOf(Math.max.apply(Math, t.globals.series.map(function(t) {
                    return t.length;
                })));
            }
        },
        {
            key: "getLargestMarkerSize",
            value: function() {
                var t = this.w, e = 0;
                return t.globals.markers.size.forEach(function(t) {
                    e = Math.max(e, t);
                }), t.config.markers.discrete && t.config.markers.discrete.length && t.config.markers.discrete.forEach(function(t) {
                    e = Math.max(e, t.size);
                }), e > 0 && (t.config.markers.hover.size > 0 ? e = t.config.markers.hover.size : e += t.config.markers.hover.sizeOffset), t.globals.markers.largestSize = e, e;
            }
        },
        {
            key: "getSeriesTotals",
            value: function() {
                var t = this.w;
                t.globals.seriesTotals = t.globals.series.map(function(t, e) {
                    var i = 0;
                    if (Array.isArray(t)) for(var a = 0; a < t.length; a++)i += t[a];
                    else i += t;
                    return i;
                });
            }
        },
        {
            key: "getSeriesTotalsXRange",
            value: function(t, e) {
                var i = this.w;
                return i.globals.series.map(function(a, s) {
                    for(var r = 0, n = 0; n < a.length; n++)i.globals.seriesX[s][n] > t && i.globals.seriesX[s][n] < e && (r += a[n]);
                    return r;
                });
            }
        },
        {
            key: "getPercentSeries",
            value: function() {
                var t = this.w;
                t.globals.seriesPercent = t.globals.series.map(function(e, i) {
                    var a = [];
                    if (Array.isArray(e)) for(var s = 0; s < e.length; s++){
                        var r = t.globals.stackedSeriesTotals[s], n = 0;
                        r && (n = 100 * e[s] / r), a.push(n);
                    }
                    else {
                        var o = 100 * e / t.globals.seriesTotals.reduce(function(t, e) {
                            return t + e;
                        }, 0);
                        a.push(o);
                    }
                    return a;
                });
            }
        },
        {
            key: "getCalculatedRatios",
            value: function() {
                var t, e, i, a = this, s = this.w, r = s.globals, n = [], o = 0, l = [], h = .1, c = 0;
                if (r.yRange = [], r.isMultipleYAxis) for(var d = 0; d < r.minYArr.length; d++)r.yRange.push(Math.abs(r.minYArr[d] - r.maxYArr[d])), l.push(0);
                else r.yRange.push(Math.abs(r.minY - r.maxY));
                r.xRange = Math.abs(r.maxX - r.minX), r.zRange = Math.abs(r.maxZ - r.minZ);
                for(var u = 0; u < r.yRange.length; u++)n.push(r.yRange[u] / r.gridHeight);
                if (e = r.xRange / r.gridWidth, t = r.yRange / r.gridWidth, i = r.xRange / r.gridHeight, (o = r.zRange / r.gridHeight * 16) || (o = 1), r.minY !== Number.MIN_VALUE && 0 !== Math.abs(r.minY) && (r.hasNegs = !0), s.globals.seriesYAxisReverseMap.length > 0) {
                    var g = function(t, e) {
                        var i = s.config.yaxis[s.globals.seriesYAxisReverseMap[e]], r = t < 0 ? -1 : 1;
                        return t = Math.abs(t), i.logarithmic && (t = a.getBaseLog(i.logBase, t)), -r * t / n[e];
                    };
                    if (r.isMultipleYAxis) {
                        l = [];
                        for(var p = 0; p < n.length; p++)l.push(g(r.minYArr[p], p));
                    } else (l = []).push(g(r.minY, 0)), r.minY !== Number.MIN_VALUE && 0 !== Math.abs(r.minY) && (h = -r.minY / t, c = r.minX / e);
                } else (l = []).push(0), h = 0, c = 0;
                return {
                    yRatio: n,
                    invertedYRatio: t,
                    zRatio: o,
                    xRatio: e,
                    invertedXRatio: i,
                    baseLineInvertedY: h,
                    baseLineY: l,
                    baseLineX: c
                };
            }
        },
        {
            key: "getLogSeries",
            value: function(t) {
                var e = this, i = this.w;
                return i.globals.seriesLog = t.map(function(t, a) {
                    var s = i.globals.seriesYAxisReverseMap[a];
                    return i.config.yaxis[s] && i.config.yaxis[s].logarithmic ? t.map(function(t) {
                        return null === t ? null : e.getLogVal(i.config.yaxis[s].logBase, t, a);
                    }) : t;
                }), i.globals.invalidLogScale ? t : i.globals.seriesLog;
            }
        },
        {
            key: "getLogValAtSeriesIndex",
            value: function(t, e) {
                if (null === t) return null;
                var i = this.w, a = i.globals.seriesYAxisReverseMap[e];
                return i.config.yaxis[a] && i.config.yaxis[a].logarithmic ? this.getLogVal(i.config.yaxis[a].logBase, t, e) : t;
            }
        },
        {
            key: "getBaseLog",
            value: function(t, e) {
                return Math.log(e) / Math.log(t);
            }
        },
        {
            key: "getLogVal",
            value: function(t, e, i) {
                if (e <= 0) return 0;
                var a = this.w, s = 0 === a.globals.minYArr[i] ? -1 : this.getBaseLog(t, a.globals.minYArr[i]), r = (0 === a.globals.maxYArr[i] ? 0 : this.getBaseLog(t, a.globals.maxYArr[i])) - s;
                return e < 1 ? e / r : (this.getBaseLog(t, e) - s) / r;
            }
        },
        {
            key: "getLogYRatios",
            value: function(t) {
                var e = this, i = this.w, a = this.w.globals;
                return a.yLogRatio = t.slice(), a.logYRange = a.yRange.map(function(t, s) {
                    var r = i.globals.seriesYAxisReverseMap[s];
                    if (i.config.yaxis[r] && e.w.config.yaxis[r].logarithmic) {
                        var n, o = -Number.MAX_VALUE, l = Number.MIN_VALUE;
                        return a.seriesLog.forEach(function(t, e) {
                            t.forEach(function(t) {
                                i.config.yaxis[e] && i.config.yaxis[e].logarithmic && (o = Math.max(t, o), l = Math.min(t, l));
                            });
                        }), n = Math.pow(a.yRange[s], Math.abs(l - o) / a.yRange[s]), a.yLogRatio[s] = n / a.gridHeight, n;
                    }
                }), a.invalidLogScale ? t.slice() : a.yLogRatio;
            }
        },
        {
            key: "drawSeriesByGroup",
            value: function(t, e, i, a) {
                var s = this.w, r = [];
                return t.series.length > 0 && e.forEach(function(e) {
                    var n = [], o = [];
                    t.i.forEach(function(i, a) {
                        s.config.series[i].group === e && (n.push(t.series[a]), o.push(i));
                    }), n.length > 0 && r.push(a.draw(n, i, o));
                }), r;
            }
        }
    ], [
        {
            key: "checkComboSeries",
            value: function(t, e) {
                var i = !1, a = 0, s = 0;
                return void 0 === e && (e = "line"), t.length && void 0 !== t[0].type && t.forEach(function(t) {
                    "bar" !== t.type && "column" !== t.type && "candlestick" !== t.type && "boxPlot" !== t.type || a++, void 0 !== t.type && t.type !== e && s++;
                }), s > 0 && (i = !0), {
                    comboBarCount: a,
                    comboCharts: i
                };
            }
        },
        {
            key: "extendArrayProps",
            value: function(t, e, i) {
                var a, s, r, n, o, l;
                (null !== (a = e) && void 0 !== a && a.yaxis && (e = t.extendYAxis(e, i)), null !== (s = e) && void 0 !== s && s.annotations) && (e.annotations.yaxis && (e = t.extendYAxisAnnotations(e)), null !== (r = e) && void 0 !== r && null !== (n = r.annotations) && void 0 !== n && n.xaxis && (e = t.extendXAxisAnnotations(e)), null !== (o = e) && void 0 !== o && null !== (l = o.annotations) && void 0 !== l && l.points && (e = t.extendPointAnnotations(e)));
                return e;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ii = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.annoCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "setOrientations",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.w;
                if ("vertical" === t.label.orientation) {
                    var a = null !== e ? e : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                    if (null !== s) {
                        var r = s.getBoundingClientRect();
                        s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4);
                        var n = "top" === t.label.position ? r.width : -r.width;
                        s.setAttribute("y", parseFloat(s.getAttribute("y")) + n);
                        var o = this.annoCtx.graphics.rotateAroundCenter(s), l = o.x, h = o.y;
                        s.setAttribute("transform", "rotate(-90 ".concat(l, " ").concat(h, ")"));
                    }
                }
            }
        },
        {
            key: "addBackgroundToAnno",
            value: function(t, e) {
                var i = this.w;
                if (!t || !e.label.text || !String(e.label.text).trim()) return null;
                var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = t.getBoundingClientRect(), r = e.label.style.padding, n = r.left, o = r.right, l = r.top, h = r.bottom;
                if ("vertical" === e.label.orientation) {
                    var c = [
                        n,
                        o,
                        l,
                        h
                    ];
                    l = c[0], h = c[1], n = c[2], o = c[3];
                }
                var d = s.left - a.left - n, u = s.top - a.top - l, g = this.annoCtx.graphics.drawRect(d - i.globals.barPadForNumericAxis, u, s.width + n + o, s.height + l + h, e.label.borderRadius, e.label.style.background, 1, e.label.borderWidth, e.label.borderColor, 0);
                return e.id && g.node.classList.add(e.id), g;
            }
        },
        {
            key: "annotationsBackground",
            value: function() {
                var t = this, e = this.w, i = function(i, a, s) {
                    var r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(a, "']"));
                    if (r) {
                        var n = r.parentNode, o = t.addBackgroundToAnno(r, i);
                        o && (n.insertBefore(o.node, r), i.label.mouseEnter && o.node.addEventListener("mouseenter", i.label.mouseEnter.bind(t, i)), i.label.mouseLeave && o.node.addEventListener("mouseleave", i.label.mouseLeave.bind(t, i)), i.label.click && o.node.addEventListener("click", i.label.click.bind(t, i)));
                    }
                };
                e.config.annotations.xaxis.forEach(function(t, e) {
                    return i(t, e, "xaxis");
                }), e.config.annotations.yaxis.forEach(function(t, e) {
                    return i(t, e, "yaxis");
                }), e.config.annotations.points.forEach(function(t, e) {
                    return i(t, e, "point");
                });
            }
        },
        {
            key: "getY1Y2",
            value: function(t, e) {
                var i, a = this.w, s = "y1" === t ? e.y : e.y2, r = !1;
                if (this.annoCtx.invertAxis) {
                    var n = a.config.xaxis.convertedCatToNumeric ? a.globals.categoryLabels : a.globals.labels, o = n.indexOf(s), l = a.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(".concat(o + 1, ")"));
                    i = l ? parseFloat(l.getAttribute("y")) : (a.globals.gridHeight / n.length - 1) * (o + 1) - a.globals.barHeight, void 0 !== e.seriesIndex && a.globals.barHeight && (i -= a.globals.barHeight / 2 * (a.globals.series.length - 1) - a.globals.barHeight * e.seriesIndex);
                } else {
                    var h, c = a.globals.seriesYAxisMap[e.yAxisIndex][0], d = a.config.yaxis[e.yAxisIndex].logarithmic ? new $e4b487e979d7c06d$var$Pi(this.annoCtx.ctx).getLogVal(a.config.yaxis[e.yAxisIndex].logBase, s, c) / a.globals.yLogRatio[c] : (s - a.globals.minYArr[c]) / (a.globals.yRange[c] / a.globals.gridHeight);
                    i = a.globals.gridHeight - Math.min(Math.max(d, 0), a.globals.gridHeight), r = d > a.globals.gridHeight || d < 0, !e.marker || void 0 !== e.y && null !== e.y || (i = 0), null !== (h = a.config.yaxis[e.yAxisIndex]) && void 0 !== h && h.reversed && (i = d);
                }
                return "string" == typeof s && s.includes("px") && (i = parseFloat(s)), {
                    yP: i,
                    clipped: r
                };
            }
        },
        {
            key: "getX1X2",
            value: function(t, e) {
                var i = this.w, a = "x1" === t ? e.x : e.x2, s = this.annoCtx.invertAxis ? i.globals.minY : i.globals.minX, r = this.annoCtx.invertAxis ? i.globals.maxY : i.globals.maxX, n = this.annoCtx.invertAxis ? i.globals.yRange[0] : i.globals.xRange, o = !1, l = this.annoCtx.inversedReversedAxis ? (r - a) / (n / i.globals.gridWidth) : (a - s) / (n / i.globals.gridWidth);
                return "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric || this.annoCtx.invertAxis || i.globals.dataFormatXNumeric || i.config.chart.sparkline.enabled || (l = this.getStringX(a)), "string" == typeof a && a.includes("px") && (l = parseFloat(a)), null == a && e.marker && (l = i.globals.gridWidth), void 0 !== e.seriesIndex && i.globals.barWidth && !this.annoCtx.invertAxis && (l -= i.globals.barWidth / 2 * (i.globals.series.length - 1) - i.globals.barWidth * e.seriesIndex), "number" != typeof l && (l = 0, o = !0), parseFloat(l.toFixed(10)) > parseFloat(i.globals.gridWidth.toFixed(10)) ? (l = i.globals.gridWidth, o = !0) : l < 0 && (l = 0, o = !0), {
                    x: l,
                    clipped: o
                };
            }
        },
        {
            key: "getStringX",
            value: function(t) {
                var e = this.w, i = t;
                e.config.xaxis.convertedCatToNumeric && e.globals.categoryLabels.length && (t = e.globals.categoryLabels.indexOf(t) + 1);
                var a = e.globals.labels.map(function(t) {
                    return Array.isArray(t) ? t.join(" ") : t;
                }).indexOf(t), s = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(".concat(a + 1, ")"));
                return s && (i = parseFloat(s.getAttribute("x"))), i;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ti = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis, this.helpers = new $e4b487e979d7c06d$var$Ii(this.annoCtx);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = this.helpers.getX1X2("x1", t), n = r.x, o = r.clipped, l = !0, h = t.label.text, c = t.strokeDashArray;
                if ($e4b487e979d7c06d$var$v.isNumber(n)) {
                    if (null === t.x2 || void 0 === t.x2) {
                        if (!o) {
                            var d = this.annoCtx.graphics.drawLine(n + t.offsetX, 0 + t.offsetY, n + t.offsetX, s.globals.gridHeight + t.offsetY, t.borderColor, c, t.borderWidth);
                            e.appendChild(d.node), t.id && d.node.classList.add(t.id);
                        }
                    } else {
                        var u = this.helpers.getX1X2("x2", t);
                        if (a = u.x, l = u.clipped, a < n) {
                            var g = n;
                            n = a, a = g;
                        }
                        var p = this.annoCtx.graphics.drawRect(n + t.offsetX, 0 + t.offsetY, a - n, s.globals.gridHeight + t.offsetY, 0, t.fillColor, t.opacity, 1, t.borderColor, c);
                        p.node.classList.add("apexcharts-annotation-rect"), p.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(p.node), t.id && p.node.classList.add(t.id);
                    }
                    if (!o || !l) {
                        var f = this.annoCtx.graphics.getTextRects(h, parseFloat(t.label.style.fontSize)), x = "top" === t.label.position ? 4 : "center" === t.label.position ? s.globals.gridHeight / 2 + ("vertical" === t.label.orientation ? f.width / 2 : 0) : s.globals.gridHeight, b = this.annoCtx.graphics.drawText({
                            x: n + t.label.offsetX,
                            y: x + t.label.offsetY - ("vertical" === t.label.orientation ? "top" === t.label.position ? f.width / 2 - 12 : -f.width / 2 : 0),
                            text: h,
                            textAnchor: t.label.textAnchor,
                            fontSize: t.label.style.fontSize,
                            fontFamily: t.label.style.fontFamily,
                            fontWeight: t.label.style.fontWeight,
                            foreColor: t.label.style.color,
                            cssClass: "apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                        });
                        b.attr({
                            rel: i
                        }), e.appendChild(b.node), this.annoCtx.helpers.setOrientations(t, i);
                    }
                }
            }
        },
        {
            key: "drawXAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-xaxis-annotations"
                });
                return e.config.annotations.xaxis.map(function(e, a) {
                    t.addXaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$zi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.months31 = [
            1,
            3,
            5,
            7,
            8,
            10,
            12
        ], this.months30 = [
            2,
            4,
            6,
            9,
            11
        ], this.daysCntOfYear = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "isValidDate",
            value: function(t) {
                return "number" != typeof t && !isNaN(this.parseDate(t));
            }
        },
        {
            key: "getTimeStamp",
            value: function(t) {
                return Date.parse(t) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toISOString().substr(0, 25)).getTime() : new Date(t).getTime() : t;
            }
        },
        {
            key: "getDate",
            value: function(t) {
                return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toUTCString()) : new Date(t);
            }
        },
        {
            key: "parseDate",
            value: function(t) {
                var e = Date.parse(t);
                if (!isNaN(e)) return this.getTimeStamp(t);
                var i = Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                return i = this.getTimeStamp(i);
            }
        },
        {
            key: "parseDateWithTimezone",
            value: function(t) {
                return Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
            }
        },
        {
            key: "formatDate",
            value: function(t, e) {
                var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                    "\0"
                ].concat($e4b487e979d7c06d$var$f(i.months)), r = [
                    "\x01"
                ].concat($e4b487e979d7c06d$var$f(i.shortMonths)), n = [
                    "\x02"
                ].concat($e4b487e979d7c06d$var$f(i.days)), o = [
                    "\x03"
                ].concat($e4b487e979d7c06d$var$f(i.shortDays));
                function l(t, e) {
                    var i = t + "";
                    for(e = e || 2; i.length < e;)i = "0" + i;
                    return i;
                }
                var h = a ? t.getUTCFullYear() : t.getFullYear();
                e = (e = (e = e.replace(/(^|[^\\])yyyy+/g, "$1" + h)).replace(/(^|[^\\])yy/g, "$1" + h.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + h);
                var c = (a ? t.getUTCMonth() : t.getMonth()) + 1;
                e = (e = (e = (e = e.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + l(c))).replace(/(^|[^\\])M/g, "$1" + c);
                var d = a ? t.getUTCDate() : t.getDate();
                e = (e = (e = (e = e.replace(/(^|[^\\])dddd+/g, "$1" + n[0])).replace(/(^|[^\\])ddd/g, "$1" + o[0])).replace(/(^|[^\\])dd/g, "$1" + l(d))).replace(/(^|[^\\])d/g, "$1" + d);
                var u = a ? t.getUTCHours() : t.getHours(), g = u > 12 ? u - 12 : 0 === u ? 12 : u;
                e = (e = (e = (e = e.replace(/(^|[^\\])HH+/g, "$1" + l(u))).replace(/(^|[^\\])H/g, "$1" + u)).replace(/(^|[^\\])hh+/g, "$1" + l(g))).replace(/(^|[^\\])h/g, "$1" + g);
                var p = a ? t.getUTCMinutes() : t.getMinutes();
                e = (e = e.replace(/(^|[^\\])mm+/g, "$1" + l(p))).replace(/(^|[^\\])m/g, "$1" + p);
                var x = a ? t.getUTCSeconds() : t.getSeconds();
                e = (e = e.replace(/(^|[^\\])ss+/g, "$1" + l(x))).replace(/(^|[^\\])s/g, "$1" + x);
                var b = a ? t.getUTCMilliseconds() : t.getMilliseconds();
                e = e.replace(/(^|[^\\])fff+/g, "$1" + l(b, 3)), b = Math.round(b / 10), e = e.replace(/(^|[^\\])ff/g, "$1" + l(b)), b = Math.round(b / 10);
                var m = u < 12 ? "AM" : "PM";
                e = (e = (e = e.replace(/(^|[^\\])f/g, "$1" + b)).replace(/(^|[^\\])TT+/g, "$1" + m)).replace(/(^|[^\\])T/g, "$1" + m.charAt(0));
                var v = m.toLowerCase();
                e = (e = e.replace(/(^|[^\\])tt+/g, "$1" + v)).replace(/(^|[^\\])t/g, "$1" + v.charAt(0));
                var y = -t.getTimezoneOffset(), w = a || !y ? "Z" : y > 0 ? "+" : "-";
                if (!a) {
                    var k = (y = Math.abs(y)) % 60;
                    w += l(Math.floor(y / 60)) + ":" + l(k);
                }
                e = e.replace(/(^|[^\\])K/g, "$1" + w);
                var A = (a ? t.getUTCDay() : t.getDay()) + 1;
                return e = (e = (e = (e = (e = e.replace(new RegExp(n[0], "g"), n[A])).replace(new RegExp(o[0], "g"), o[A])).replace(new RegExp(s[0], "g"), s[c])).replace(new RegExp(r[0], "g"), r[c])).replace(/\\(.)/g, "$1");
            }
        },
        {
            key: "getTimeUnitsfromTimestamp",
            value: function(t, e, i) {
                var a = this.w;
                void 0 !== a.config.xaxis.min && (t = a.config.xaxis.min), void 0 !== a.config.xaxis.max && (e = a.config.xaxis.max);
                var s = this.getDate(t), r = this.getDate(e), n = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), o = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                return {
                    minMillisecond: parseInt(n[6], 10),
                    maxMillisecond: parseInt(o[6], 10),
                    minSecond: parseInt(n[5], 10),
                    maxSecond: parseInt(o[5], 10),
                    minMinute: parseInt(n[4], 10),
                    maxMinute: parseInt(o[4], 10),
                    minHour: parseInt(n[3], 10),
                    maxHour: parseInt(o[3], 10),
                    minDate: parseInt(n[2], 10),
                    maxDate: parseInt(o[2], 10),
                    minMonth: parseInt(n[1], 10) - 1,
                    maxMonth: parseInt(o[1], 10) - 1,
                    minYear: parseInt(n[0], 10),
                    maxYear: parseInt(o[0], 10)
                };
            }
        },
        {
            key: "isLeapYear",
            value: function(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
            }
        },
        {
            key: "calculcateLastDaysOfMonth",
            value: function(t, e, i) {
                return this.determineDaysOfMonths(t, e) - i;
            }
        },
        {
            key: "determineDaysOfYear",
            value: function(t) {
                var e = 365;
                return this.isLeapYear(t) && (e = 366), e;
            }
        },
        {
            key: "determineRemainingDaysOfYear",
            value: function(t, e, i) {
                var a = this.daysCntOfYear[e] + i;
                return e > 1 && this.isLeapYear() && a++, a;
            }
        },
        {
            key: "determineDaysOfMonths",
            value: function(t, e) {
                var i = 30;
                switch(t = $e4b487e979d7c06d$var$v.monthMod(t), !0){
                    case this.months30.indexOf(t) > -1:
                        2 === t && (i = this.isLeapYear(e) ? 29 : 28);
                        break;
                    case this.months31.indexOf(t) > -1:
                    default:
                        i = 31;
                }
                return i;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Xi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "xLabelFormat",
            value: function(t, e, i, a) {
                var s = this.w;
                if ("datetime" === s.config.xaxis.type && void 0 === s.config.xaxis.labels.formatter && void 0 === s.config.tooltip.x.formatter) {
                    var r = new $e4b487e979d7c06d$var$zi(this.ctx);
                    return r.formatDate(r.getDate(e), s.config.tooltip.x.format);
                }
                return t(e, i, a);
            }
        },
        {
            key: "defaultGeneralFormatter",
            value: function(t) {
                return Array.isArray(t) ? t.map(function(t) {
                    return t;
                }) : t;
            }
        },
        {
            key: "defaultYFormatter",
            value: function(t, e, i) {
                var a = this.w;
                if ($e4b487e979d7c06d$var$v.isNumber(t)) {
                    if (0 !== a.globals.yValueDecimal) t = t.toFixed(void 0 !== e.decimalsInFloat ? e.decimalsInFloat : a.globals.yValueDecimal);
                    else {
                        var s = t.toFixed(0);
                        t = t == s ? s : t.toFixed(1);
                    }
                }
                return t;
            }
        },
        {
            key: "setLabelFormatters",
            value: function() {
                var t = this, e = this.w;
                return e.globals.xaxisTooltipFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttKeyFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttZFormatter = function(t) {
                    return t;
                }, e.globals.legendFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, void 0 !== e.config.xaxis.labels.formatter ? e.globals.xLabelFormatter = e.config.xaxis.labels.formatter : e.globals.xLabelFormatter = function(t) {
                    if ($e4b487e979d7c06d$var$v.isNumber(t)) {
                        if (!e.config.xaxis.convertedCatToNumeric && "numeric" === e.config.xaxis.type) {
                            if ($e4b487e979d7c06d$var$v.isNumber(e.config.xaxis.decimalsInFloat)) return t.toFixed(e.config.xaxis.decimalsInFloat);
                            var i = e.globals.maxX - e.globals.minX;
                            return i > 0 && i < 100 ? t.toFixed(1) : t.toFixed(0);
                        }
                        if (e.globals.isBarHorizontal) {
                            if (e.globals.maxY - e.globals.minYArr < 4) return t.toFixed(1);
                        }
                        return t.toFixed(0);
                    }
                    return t;
                }, "function" == typeof e.config.tooltip.x.formatter ? e.globals.ttKeyFormatter = e.config.tooltip.x.formatter : e.globals.ttKeyFormatter = e.globals.xLabelFormatter, "function" == typeof e.config.xaxis.tooltip.formatter && (e.globals.xaxisTooltipFormatter = e.config.xaxis.tooltip.formatter), (Array.isArray(e.config.tooltip.y) || void 0 !== e.config.tooltip.y.formatter) && (e.globals.ttVal = e.config.tooltip.y), void 0 !== e.config.tooltip.z.formatter && (e.globals.ttZFormatter = e.config.tooltip.z.formatter), void 0 !== e.config.legend.formatter && (e.globals.legendFormatter = e.config.legend.formatter), e.config.yaxis.forEach(function(i, a) {
                    void 0 !== i.labels.formatter ? e.globals.yLabelFormatters[a] = i.labels.formatter : e.globals.yLabelFormatters[a] = function(s) {
                        return e.globals.xyCharts ? Array.isArray(s) ? s.map(function(e) {
                            return t.defaultYFormatter(e, i, a);
                        }) : t.defaultYFormatter(s, i, a) : s;
                    };
                }), e.globals;
            }
        },
        {
            key: "heatmapLabelFormatters",
            value: function() {
                var t = this.w;
                if ("heatmap" === t.config.chart.type) {
                    t.globals.yAxisScale[0].result = t.globals.seriesNames.slice();
                    var e = t.globals.seriesNames.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0);
                    t.globals.yAxisScale[0].niceMax = e, t.globals.yAxisScale[0].niceMin = e;
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ri = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getLabel",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "12px", n = !(arguments.length > 6 && void 0 !== arguments[6]) || arguments[6], o = this.w, l = void 0 === t[a] ? "" : t[a], h = l, c = o.globals.xLabelFormatter, d = o.config.xaxis.labels.formatter, u = !1, g = new $e4b487e979d7c06d$var$Xi(this.ctx), p = l;
                n && (h = g.xLabelFormat(c, l, p, {
                    i: a,
                    dateFormatter: new $e4b487e979d7c06d$var$zi(this.ctx).formatDate,
                    w: o
                }), void 0 !== d && (h = d(l, t[a], {
                    i: a,
                    dateFormatter: new $e4b487e979d7c06d$var$zi(this.ctx).formatDate,
                    w: o
                })));
                var f, x;
                e.length > 0 ? (f = e[a].unit, x = null, e.forEach(function(t) {
                    "month" === t.unit ? x = "year" : "day" === t.unit ? x = "month" : "hour" === t.unit ? x = "day" : "minute" === t.unit && (x = "hour");
                }), u = x === f, i = e[a].position, h = e[a].value) : "datetime" === o.config.xaxis.type && void 0 === d && (h = ""), void 0 === h && (h = ""), h = Array.isArray(h) ? h : h.toString();
                var b = new $e4b487e979d7c06d$var$Mi(this.ctx), m = {};
                m = o.globals.rotateXLabels && n ? b.getTextRects(h, parseInt(r, 10), null, "rotate(".concat(o.config.xaxis.labels.rotate, " 0 0)"), !1) : b.getTextRects(h, parseInt(r, 10));
                var v = !o.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                return !Array.isArray(h) && ("NaN" === String(h) || s.indexOf(h) >= 0 && v) && (h = ""), {
                    x: i,
                    text: h,
                    textRect: m,
                    isBold: u
                };
            }
        },
        {
            key: "checkLabelBasedOnTickamount",
            value: function(t, e, i) {
                var a = this.w, s = a.config.xaxis.tickAmount;
                return "dataPoints" === s && (s = Math.round(a.globals.gridWidth / 120)), s > i || t % Math.round(i / (s + 1)) == 0 || (e.text = ""), e;
            }
        },
        {
            key: "checkForOverflowingLabels",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (0 === t && r.globals.skipFirstTimelinelabel && (e.text = ""), t === i - 1 && r.globals.skipLastTimelinelabel && (e.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                    var n = s[s.length - 1];
                    e.x < n.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + n.x && (e.text = "");
                }
                return e;
            }
        },
        {
            key: "checkForReversedLabels",
            value: function(t, e) {
                var i = this.w;
                return i.config.yaxis[t] && i.config.yaxis[t].reversed && e.reverse(), e;
            }
        },
        {
            key: "yAxisAllSeriesCollapsed",
            value: function(t) {
                var e = this.w.globals;
                return !e.seriesYAxisMap[t].some(function(t) {
                    return -1 === e.collapsedSeriesIndices.indexOf(t);
                });
            }
        },
        {
            key: "translateYAxisIndex",
            value: function(t) {
                var e = this.w, i = e.globals, a = e.config.yaxis;
                return i.series.length > a.length || a.some(function(t) {
                    return Array.isArray(t.seriesName);
                }) ? t : i.seriesYAxisReverseMap[t];
            }
        },
        {
            key: "isYAxisHidden",
            value: function(t) {
                var e = this.w, i = e.config.yaxis[t];
                if (!i.show || this.yAxisAllSeriesCollapsed(t)) return !0;
                if (!i.showForNullSeries) {
                    var a = e.globals.seriesYAxisMap[t], s = new $e4b487e979d7c06d$var$Pi(this.ctx);
                    return a.every(function(t) {
                        return s.isSeriesNull(t);
                    });
                }
                return !1;
            }
        },
        {
            key: "getYAxisForeColor",
            value: function(t, e) {
                var i = this.w;
                return Array.isArray(t) && i.globals.yAxisScale[e] && this.ctx.theme.pushExtraColors(t, i.globals.yAxisScale[e].result.length, !1), t;
            }
        },
        {
            key: "drawYAxisTicks",
            value: function(t, e, i, a, s, r, n) {
                var o = this.w, l = new $e4b487e979d7c06d$var$Mi(this.ctx), h = o.globals.translateY + o.config.yaxis[s].labels.offsetY;
                if (o.globals.isBarHorizontal ? h = 0 : "heatmap" === o.config.chart.type && (h += r / 2), a.show && e > 0) {
                    !0 === o.config.yaxis[s].opposite && (t += a.width);
                    for(var c = e; c >= 0; c--){
                        var d = l.drawLine(t + i.offsetX - a.width + a.offsetX, h + a.offsetY, t + i.offsetX + a.offsetX, h + a.offsetY, a.color);
                        n.add(d), h += r;
                    }
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ei = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new $e4b487e979d7c06d$var$Ii(this.annoCtx), this.axesUtils = new $e4b487e979d7c06d$var$Ri(this.annoCtx);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = t.strokeDashArray, n = this.helpers.getY1Y2("y1", t), o = n.yP, l = n.clipped, h = !0, c = !1, d = t.label.text;
                if (null === t.y2 || void 0 === t.y2) {
                    if (!l) {
                        c = !0;
                        var u = this.annoCtx.graphics.drawLine(0 + t.offsetX, o + t.offsetY, this._getYAxisAnnotationWidth(t), o + t.offsetY, t.borderColor, r, t.borderWidth);
                        e.appendChild(u.node), t.id && u.node.classList.add(t.id);
                    }
                } else {
                    if (a = (n = this.helpers.getY1Y2("y2", t)).yP, h = n.clipped, a > o) {
                        var g = o;
                        o = a, a = g;
                    }
                    if (!l || !h) {
                        c = !0;
                        var p = this.annoCtx.graphics.drawRect(0 + t.offsetX, a + t.offsetY, this._getYAxisAnnotationWidth(t), o - a, 0, t.fillColor, t.opacity, 1, t.borderColor, r);
                        p.node.classList.add("apexcharts-annotation-rect"), p.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(p.node), t.id && p.node.classList.add(t.id);
                    }
                }
                if (c) {
                    var f = "right" === t.label.position ? s.globals.gridWidth : "center" === t.label.position ? s.globals.gridWidth / 2 : 0, x = this.annoCtx.graphics.drawText({
                        x: f + t.label.offsetX,
                        y: (null != a ? a : o) + t.label.offsetY - 3,
                        text: d,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    x.attr({
                        rel: i
                    }), e.appendChild(x.node);
                }
            }
        },
        {
            key: "_getYAxisAnnotationWidth",
            value: function(t) {
                var e = this.w;
                e.globals.gridWidth;
                return (t.width.indexOf("%") > -1 ? e.globals.gridWidth * parseInt(t.width, 10) / 100 : parseInt(t.width, 10)) + t.offsetX;
            }
        },
        {
            key: "drawYAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-yaxis-annotations"
                });
                return e.config.annotations.yaxis.forEach(function(e, a) {
                    e.yAxisIndex = t.axesUtils.translateYAxisIndex(e.yAxisIndex), t.axesUtils.isYAxisHidden(e.yAxisIndex) && t.axesUtils.yAxisAllSeriesCollapsed(e.yAxisIndex) || t.addYaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Yi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.annoCtx = e, this.helpers = new $e4b487e979d7c06d$var$Ii(this.annoCtx);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                if (!(this.w.globals.collapsedSeriesIndices.indexOf(t.seriesIndex) > -1)) {
                    var a = this.helpers.getX1X2("x1", t), s = a.x, r = a.clipped, n = (a = this.helpers.getY1Y2("y1", t)).yP, o = a.clipped;
                    if ($e4b487e979d7c06d$var$v.isNumber(s) && !o && !r) {
                        var l = {
                            pSize: t.marker.size,
                            pointStrokeWidth: t.marker.strokeWidth,
                            pointFillColor: t.marker.fillColor,
                            pointStrokeColor: t.marker.strokeColor,
                            shape: t.marker.shape,
                            pRadius: t.marker.radius,
                            class: "apexcharts-point-annotation-marker ".concat(t.marker.cssClass, " ").concat(t.id ? t.id : "")
                        }, h = this.annoCtx.graphics.drawMarker(s + t.marker.offsetX, n + t.marker.offsetY, l);
                        e.appendChild(h.node);
                        var c = t.label.text ? t.label.text : "", d = this.annoCtx.graphics.drawText({
                            x: s + t.label.offsetX,
                            y: n + t.label.offsetY - t.marker.size - parseFloat(t.label.style.fontSize) / 1.6,
                            text: c,
                            textAnchor: t.label.textAnchor,
                            fontSize: t.label.style.fontSize,
                            fontFamily: t.label.style.fontFamily,
                            fontWeight: t.label.style.fontWeight,
                            foreColor: t.label.style.color,
                            cssClass: "apexcharts-point-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                        });
                        if (d.attr({
                            rel: i
                        }), e.appendChild(d.node), t.customSVG.SVG) {
                            var u = this.annoCtx.graphics.group({
                                class: "apexcharts-point-annotations-custom-svg " + t.customSVG.cssClass
                            });
                            u.attr({
                                transform: "translate(".concat(s + t.customSVG.offsetX, ", ").concat(n + t.customSVG.offsetY, ")")
                            }), u.node.innerHTML = t.customSVG.SVG, e.appendChild(u.node);
                        }
                        if (t.image.path) {
                            var g = t.image.width ? t.image.width : 20, p = t.image.height ? t.image.height : 20;
                            h = this.annoCtx.addImage({
                                x: s + t.image.offsetX - g / 2,
                                y: n + t.image.offsetY - p / 2,
                                width: g,
                                height: p,
                                path: t.image.path,
                                appendTo: ".apexcharts-point-annotations"
                            });
                        }
                        t.mouseEnter && h.node.addEventListener("mouseenter", t.mouseEnter.bind(this, t)), t.mouseLeave && h.node.addEventListener("mouseleave", t.mouseLeave.bind(this, t)), t.click && h.node.addEventListener("click", t.click.bind(this, t));
                    }
                }
            }
        },
        {
            key: "drawPointAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-point-annotations"
                });
                return e.config.annotations.points.map(function(e, a) {
                    t.addPointAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}();
var $e4b487e979d7c06d$var$Hi = {
    name: "en",
    options: {
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        toolbar: {
            exportToSVG: "Download SVG",
            exportToPNG: "Download PNG",
            exportToCSV: "Download CSV",
            menu: "Menu",
            selection: "Selection",
            selectionZoom: "Selection Zoom",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out",
            pan: "Panning",
            reset: "Reset Zoom"
        }
    }
}, $e4b487e979d7c06d$var$Oi = function() {
    function t() {
        $e4b487e979d7c06d$var$i(this, t), this.yAxis = {
            show: !0,
            showAlways: !1,
            showForNullSeries: !0,
            seriesName: void 0,
            opposite: !1,
            reversed: !1,
            logarithmic: !1,
            logBase: 10,
            tickAmount: void 0,
            stepSize: void 0,
            forceNiceScale: !1,
            max: void 0,
            min: void 0,
            floating: !1,
            decimalsInFloat: void 0,
            labels: {
                show: !0,
                showDuplicates: !1,
                minWidth: 0,
                maxWidth: 160,
                offsetX: 0,
                offsetY: 0,
                align: void 0,
                rotate: 0,
                padding: 20,
                style: {
                    colors: [],
                    fontSize: "11px",
                    fontWeight: 400,
                    fontFamily: void 0,
                    cssClass: ""
                },
                formatter: void 0
            },
            axisBorder: {
                show: !1,
                color: "#e0e0e0",
                width: 1,
                offsetX: 0,
                offsetY: 0
            },
            axisTicks: {
                show: !1,
                color: "#e0e0e0",
                width: 6,
                offsetX: 0,
                offsetY: 0
            },
            title: {
                text: void 0,
                rotate: -90,
                offsetY: 0,
                offsetX: 0,
                style: {
                    color: void 0,
                    fontSize: "11px",
                    fontWeight: 900,
                    fontFamily: void 0,
                    cssClass: ""
                }
            },
            tooltip: {
                enabled: !1,
                offsetX: 0
            },
            crosshairs: {
                show: !0,
                position: "front",
                stroke: {
                    color: "#b6b6b6",
                    width: 1,
                    dashArray: 0
                }
            }
        }, this.pointAnnotation = {
            id: void 0,
            x: 0,
            y: null,
            yAxisIndex: 0,
            seriesIndex: void 0,
            mouseEnter: void 0,
            mouseLeave: void 0,
            click: void 0,
            marker: {
                size: 4,
                fillColor: "#fff",
                strokeWidth: 2,
                strokeColor: "#333",
                shape: "circle",
                offsetX: 0,
                offsetY: 0,
                cssClass: ""
            },
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            },
            customSVG: {
                SVG: void 0,
                cssClass: void 0,
                offsetX: 0,
                offsetY: 0
            },
            image: {
                path: void 0,
                width: 20,
                height: 20,
                offsetX: 0,
                offsetY: 0
            }
        }, this.yAxisAnnotation = {
            id: void 0,
            y: 0,
            y2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            width: "100%",
            yAxisIndex: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "end",
                position: "right",
                offsetX: 0,
                offsetY: -3,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.xAxisAnnotation = {
            id: void 0,
            x: 0,
            x2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                orientation: "vertical",
                position: "top",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                click: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.text = {
            x: 0,
            y: 0,
            text: "",
            textAnchor: "start",
            foreColor: void 0,
            fontSize: "13px",
            fontFamily: void 0,
            fontWeight: 400,
            appendTo: ".apexcharts-annotations",
            backgroundColor: "transparent",
            borderColor: "#c2c2c2",
            borderRadius: 0,
            borderWidth: 0,
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 2,
            paddingBottom: 2
        };
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "init",
            value: function() {
                return {
                    annotations: {
                        yaxis: [
                            this.yAxisAnnotation
                        ],
                        xaxis: [
                            this.xAxisAnnotation
                        ],
                        points: [
                            this.pointAnnotation
                        ],
                        texts: [],
                        images: [],
                        shapes: []
                    },
                    chart: {
                        animations: {
                            enabled: !0,
                            speed: 800,
                            animateGradually: {
                                delay: 150,
                                enabled: !0
                            },
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 350
                            }
                        },
                        background: "",
                        locales: [
                            $e4b487e979d7c06d$var$Hi
                        ],
                        defaultLocale: "en",
                        dropShadow: {
                            enabled: !1,
                            enabledOnSeries: void 0,
                            top: 2,
                            left: 2,
                            blur: 4,
                            color: "#000",
                            opacity: .7
                        },
                        events: {
                            animationEnd: void 0,
                            beforeMount: void 0,
                            mounted: void 0,
                            updated: void 0,
                            click: void 0,
                            mouseMove: void 0,
                            mouseLeave: void 0,
                            xAxisLabelClick: void 0,
                            legendClick: void 0,
                            markerClick: void 0,
                            selection: void 0,
                            dataPointSelection: void 0,
                            dataPointMouseEnter: void 0,
                            dataPointMouseLeave: void 0,
                            beforeZoom: void 0,
                            beforeResetZoom: void 0,
                            zoomed: void 0,
                            scrolled: void 0,
                            brushScrolled: void 0
                        },
                        foreColor: "#373d3f",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        height: "auto",
                        parentHeightOffset: 15,
                        redrawOnParentResize: !0,
                        redrawOnWindowResize: !0,
                        id: void 0,
                        group: void 0,
                        nonce: void 0,
                        offsetX: 0,
                        offsetY: 0,
                        selection: {
                            enabled: !1,
                            type: "x",
                            fill: {
                                color: "#24292e",
                                opacity: .1
                            },
                            stroke: {
                                width: 1,
                                color: "#24292e",
                                opacity: .4,
                                dashArray: 3
                            },
                            xaxis: {
                                min: void 0,
                                max: void 0
                            },
                            yaxis: {
                                min: void 0,
                                max: void 0
                            }
                        },
                        sparkline: {
                            enabled: !1
                        },
                        brush: {
                            enabled: !1,
                            autoScaleYaxis: !0,
                            target: void 0,
                            targets: void 0
                        },
                        stacked: !1,
                        stackOnlyBar: !0,
                        stackType: "normal",
                        toolbar: {
                            show: !0,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: !0,
                                selection: !0,
                                zoom: !0,
                                zoomin: !0,
                                zoomout: !0,
                                pan: !0,
                                reset: !0,
                                customIcons: []
                            },
                            export: {
                                csv: {
                                    filename: void 0,
                                    columnDelimiter: ",",
                                    headerCategory: "category",
                                    headerValue: "value",
                                    categoryFormatter: void 0,
                                    valueFormatter: void 0
                                },
                                png: {
                                    filename: void 0
                                },
                                svg: {
                                    filename: void 0
                                },
                                scale: void 0,
                                width: void 0
                            },
                            autoSelected: "zoom"
                        },
                        type: "line",
                        width: "100%",
                        zoom: {
                            enabled: !0,
                            type: "x",
                            autoScaleYaxis: !1,
                            allowMouseWheelZoom: !0,
                            zoomedArea: {
                                fill: {
                                    color: "#90CAF9",
                                    opacity: .4
                                },
                                stroke: {
                                    color: "#0D47A1",
                                    opacity: .4,
                                    width: 1
                                }
                            }
                        }
                    },
                    plotOptions: {
                        line: {
                            isSlopeChart: !1,
                            colors: {
                                threshold: 0,
                                colorAboveThreshold: void 0,
                                colorBelowThreshold: void 0
                            }
                        },
                        area: {
                            fillTo: "origin"
                        },
                        bar: {
                            horizontal: !1,
                            columnWidth: "70%",
                            barHeight: "70%",
                            distributed: !1,
                            borderRadius: 0,
                            borderRadiusApplication: "around",
                            borderRadiusWhenStacked: "last",
                            rangeBarOverlap: !0,
                            rangeBarGroupRows: !1,
                            hideZeroBarsWhenGrouped: !1,
                            isDumbbell: !1,
                            dumbbellColors: void 0,
                            isFunnel: !1,
                            isFunnel3d: !0,
                            colors: {
                                ranges: [],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                                backgroundBarRadius: 0
                            },
                            dataLabels: {
                                position: "top",
                                maxItems: 100,
                                hideOverflowingLabels: !0,
                                orientation: "horizontal",
                                total: {
                                    enabled: !1,
                                    formatter: void 0,
                                    offsetX: 0,
                                    offsetY: 0,
                                    style: {
                                        color: "#373d3f",
                                        fontSize: "12px",
                                        fontFamily: void 0,
                                        fontWeight: 600
                                    }
                                }
                            }
                        },
                        bubble: {
                            zScaling: !0,
                            minBubbleRadius: void 0,
                            maxBubbleRadius: void 0
                        },
                        candlestick: {
                            colors: {
                                upward: "#00B746",
                                downward: "#EF403C"
                            },
                            wick: {
                                useFillColor: !0
                            }
                        },
                        boxPlot: {
                            colors: {
                                upper: "#00E396",
                                lower: "#008FFB"
                            }
                        },
                        heatmap: {
                            radius: 2,
                            enableShades: !0,
                            shadeIntensity: .5,
                            reverseNegativeShade: !1,
                            distributed: !1,
                            useFillColorAsStroke: !1,
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        treemap: {
                            enableShades: !0,
                            shadeIntensity: .5,
                            distributed: !1,
                            reverseNegativeShade: !1,
                            useFillColorAsStroke: !1,
                            borderRadius: 4,
                            dataLabels: {
                                format: "scale"
                            },
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            },
                            seriesTitle: {
                                show: !0,
                                offsetY: 1,
                                offsetX: 1,
                                borderColor: "#000",
                                borderWidth: 1,
                                borderRadius: 2,
                                style: {
                                    background: "rgba(0, 0, 0, 0.6)",
                                    color: "#fff",
                                    fontSize: "12px",
                                    fontFamily: void 0,
                                    fontWeight: 400,
                                    cssClass: "",
                                    padding: {
                                        left: 6,
                                        right: 6,
                                        top: 2,
                                        bottom: 2
                                    }
                                }
                            }
                        },
                        radialBar: {
                            inverseOrder: !1,
                            startAngle: 0,
                            endAngle: 360,
                            offsetX: 0,
                            offsetY: 0,
                            hollow: {
                                margin: 5,
                                size: "50%",
                                background: "transparent",
                                image: void 0,
                                imageWidth: 150,
                                imageHeight: 150,
                                imageOffsetX: 0,
                                imageOffsetY: 0,
                                imageClipped: !0,
                                position: "front",
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            track: {
                                show: !0,
                                startAngle: void 0,
                                endAngle: void 0,
                                background: "#f2f2f2",
                                strokeWidth: "97%",
                                opacity: 1,
                                margin: 5,
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            dataLabels: {
                                show: !0,
                                name: {
                                    show: !0,
                                    fontSize: "16px",
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    color: void 0,
                                    offsetY: 0,
                                    formatter: function(t) {
                                        return t;
                                    }
                                },
                                value: {
                                    show: !0,
                                    fontSize: "14px",
                                    fontFamily: void 0,
                                    fontWeight: 400,
                                    color: void 0,
                                    offsetY: 16,
                                    formatter: function(t) {
                                        return t + "%";
                                    }
                                },
                                total: {
                                    show: !1,
                                    label: "Total",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    fontFamily: void 0,
                                    color: void 0,
                                    formatter: function(t) {
                                        return t.globals.seriesTotals.reduce(function(t, e) {
                                            return t + e;
                                        }, 0) / t.globals.series.length + "%";
                                    }
                                }
                            },
                            barLabels: {
                                enabled: !1,
                                offsetX: 0,
                                offsetY: 0,
                                useSeriesColors: !0,
                                fontFamily: void 0,
                                fontWeight: 600,
                                fontSize: "16px",
                                formatter: function(t) {
                                    return t;
                                },
                                onClick: void 0
                            }
                        },
                        pie: {
                            customScale: 1,
                            offsetX: 0,
                            offsetY: 0,
                            startAngle: 0,
                            endAngle: 360,
                            expandOnClick: !0,
                            dataLabels: {
                                offset: 0,
                                minAngleToShowLabel: 10
                            },
                            donut: {
                                size: "65%",
                                background: "transparent",
                                labels: {
                                    show: !1,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: -10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "20px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        showAlways: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 400,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(t) {
                                            return t.globals.seriesTotals.reduce(function(t, e) {
                                                return t + e;
                                            }, 0);
                                        }
                                    }
                                }
                            }
                        },
                        polarArea: {
                            rings: {
                                strokeWidth: 1,
                                strokeColor: "#e8e8e8"
                            },
                            spokes: {
                                strokeWidth: 1,
                                connectorColors: "#e8e8e8"
                            }
                        },
                        radar: {
                            size: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            polygons: {
                                strokeWidth: 1,
                                strokeColors: "#e8e8e8",
                                connectorColors: "#e8e8e8",
                                fill: {
                                    colors: void 0
                                }
                            }
                        }
                    },
                    colors: void 0,
                    dataLabels: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        formatter: function(t) {
                            return null !== t ? t : "";
                        },
                        textAnchor: "middle",
                        distributed: !1,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 600,
                            colors: void 0
                        },
                        background: {
                            enabled: !0,
                            foreColor: "#fff",
                            backgroundColor: void 0,
                            borderRadius: 2,
                            padding: 4,
                            opacity: .9,
                            borderWidth: 1,
                            borderColor: "#fff",
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: .8
                            }
                        },
                        dropShadow: {
                            enabled: !1,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: "#000",
                            opacity: .8
                        }
                    },
                    fill: {
                        type: "solid",
                        colors: void 0,
                        opacity: .85,
                        gradient: {
                            shade: "dark",
                            type: "horizontal",
                            shadeIntensity: .5,
                            gradientToColors: void 0,
                            inverseColors: !0,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                0,
                                50,
                                100
                            ],
                            colorStops: []
                        },
                        image: {
                            src: [],
                            width: void 0,
                            height: void 0
                        },
                        pattern: {
                            style: "squares",
                            width: 6,
                            height: 6,
                            strokeWidth: 2
                        }
                    },
                    forecastDataPoints: {
                        count: 0,
                        fillOpacity: .5,
                        strokeWidth: void 0,
                        dashArray: 4
                    },
                    grid: {
                        show: !0,
                        borderColor: "#e0e0e0",
                        strokeDashArray: 0,
                        position: "back",
                        xaxis: {
                            lines: {
                                show: !1
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        row: {
                            colors: void 0,
                            opacity: .5
                        },
                        column: {
                            colors: void 0,
                            opacity: .5
                        },
                        padding: {
                            top: 0,
                            right: 10,
                            bottom: 0,
                            left: 12
                        }
                    },
                    labels: [],
                    legend: {
                        show: !0,
                        showForSingleSeries: !1,
                        showForNullSeries: !0,
                        showForZeroSeries: !0,
                        floating: !1,
                        position: "bottom",
                        horizontalAlign: "center",
                        inverseOrder: !1,
                        fontSize: "12px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        width: void 0,
                        height: void 0,
                        formatter: void 0,
                        tooltipHoverFormatter: void 0,
                        offsetX: -20,
                        offsetY: 4,
                        customLegendItems: [],
                        clusterGroupedSeries: !0,
                        clusterGroupedSeriesOrientation: "vertical",
                        labels: {
                            colors: void 0,
                            useSeriesColors: !1
                        },
                        markers: {
                            size: 7,
                            fillColors: void 0,
                            strokeWidth: 1,
                            shape: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            customHTML: void 0,
                            onClick: void 0
                        },
                        itemMargin: {
                            horizontal: 5,
                            vertical: 4
                        },
                        onItemClick: {
                            toggleDataSeries: !0
                        },
                        onItemHover: {
                            highlightDataSeries: !0
                        }
                    },
                    markers: {
                        discrete: [],
                        size: 0,
                        colors: void 0,
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        strokeOpacity: .9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        shape: "circle",
                        offsetX: 0,
                        offsetY: 0,
                        showNullDataPoints: !0,
                        onClick: void 0,
                        onDblClick: void 0,
                        hover: {
                            size: void 0,
                            sizeOffset: 3
                        }
                    },
                    noData: {
                        text: void 0,
                        align: "center",
                        verticalAlign: "middle",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: void 0,
                            fontSize: "14px",
                            fontFamily: void 0
                        }
                    },
                    responsive: [],
                    series: void 0,
                    states: {
                        hover: {
                            filter: {
                                type: "lighten"
                            }
                        },
                        active: {
                            allowMultipleDataPointsSelection: !1,
                            filter: {
                                type: "darken"
                            }
                        }
                    },
                    title: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: !1,
                        style: {
                            fontSize: "14px",
                            fontWeight: 900,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    subtitle: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 30,
                        floating: !1,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    stroke: {
                        show: !0,
                        curve: "smooth",
                        lineCap: "butt",
                        width: 2,
                        colors: void 0,
                        dashArray: 0,
                        fill: {
                            type: "solid",
                            colors: void 0,
                            opacity: .85,
                            gradient: {
                                shade: "dark",
                                type: "horizontal",
                                shadeIntensity: .5,
                                gradientToColors: void 0,
                                inverseColors: !0,
                                opacityFrom: 1,
                                opacityTo: 1,
                                stops: [
                                    0,
                                    50,
                                    100
                                ],
                                colorStops: []
                            }
                        }
                    },
                    tooltip: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        shared: !0,
                        hideEmptySeries: !1,
                        followCursor: !1,
                        intersect: !1,
                        inverseOrder: !1,
                        custom: void 0,
                        fillSeriesColor: !1,
                        theme: "light",
                        cssClass: "",
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0
                        },
                        onDatasetHover: {
                            highlightDataSeries: !1
                        },
                        x: {
                            show: !0,
                            format: "dd MMM",
                            formatter: void 0
                        },
                        y: {
                            formatter: void 0,
                            title: {
                                formatter: function(t) {
                                    return t ? t + ": " : "";
                                }
                            }
                        },
                        z: {
                            formatter: void 0,
                            title: "Size: "
                        },
                        marker: {
                            show: !0,
                            fillColors: void 0
                        },
                        items: {
                            display: "flex"
                        },
                        fixed: {
                            enabled: !1,
                            position: "topRight",
                            offsetX: 0,
                            offsetY: 0
                        }
                    },
                    xaxis: {
                        type: "category",
                        categories: [],
                        convertedCatToNumeric: !1,
                        offsetX: 0,
                        offsetY: 0,
                        overwriteCategories: void 0,
                        labels: {
                            show: !0,
                            rotate: -45,
                            rotateAlways: !1,
                            hideOverlappingLabels: !0,
                            trim: !1,
                            minHeight: void 0,
                            maxHeight: 120,
                            showDuplicates: !0,
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            },
                            offsetX: 0,
                            offsetY: 0,
                            format: void 0,
                            formatter: void 0,
                            datetimeUTC: !0,
                            datetimeFormatter: {
                                year: "yyyy",
                                month: "MMM 'yy",
                                day: "dd MMM",
                                hour: "HH:mm",
                                minute: "HH:mm:ss",
                                second: "HH:mm:ss"
                            }
                        },
                        group: {
                            groups: [],
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        axisBorder: {
                            show: !0,
                            color: "#e0e0e0",
                            width: "100%",
                            height: 1,
                            offsetX: 0,
                            offsetY: 0
                        },
                        axisTicks: {
                            show: !0,
                            color: "#e0e0e0",
                            height: 6,
                            offsetX: 0,
                            offsetY: 0
                        },
                        stepSize: void 0,
                        tickAmount: void 0,
                        tickPlacement: "on",
                        min: void 0,
                        max: void 0,
                        range: void 0,
                        floating: !1,
                        decimalsInFloat: void 0,
                        position: "bottom",
                        title: {
                            text: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "12px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        crosshairs: {
                            show: !0,
                            width: 1,
                            position: "back",
                            opacity: .9,
                            stroke: {
                                color: "#b6b6b6",
                                width: 1,
                                dashArray: 3
                            },
                            fill: {
                                type: "solid",
                                color: "#B1B9C4",
                                gradient: {
                                    colorFrom: "#D8E3F0",
                                    colorTo: "#BED1E6",
                                    stops: [
                                        0,
                                        100
                                    ],
                                    opacityFrom: .4,
                                    opacityTo: .5
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                left: 0,
                                top: 0,
                                blur: 1,
                                opacity: .8
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            offsetY: 0,
                            formatter: void 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            }
                        }
                    },
                    yaxis: this.yAxis,
                    theme: {
                        mode: "",
                        palette: "palette1",
                        monochrome: {
                            enabled: !1,
                            color: "#008FFB",
                            shadeTo: "light",
                            shadeIntensity: .65
                        }
                    }
                };
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Fi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.graphics = new $e4b487e979d7c06d$var$Mi(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new $e4b487e979d7c06d$var$Ii(this), this.xAxisAnnotations = new $e4b487e979d7c06d$var$Ti(this), this.yAxisAnnotations = new $e4b487e979d7c06d$var$Ei(this), this.pointsAnnotations = new $e4b487e979d7c06d$var$Yi(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawAxesAnnotations",
            value: function() {
                var t = this.w;
                if (t.globals.axisCharts && t.globals.dataPoints) {
                    for(var e = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = t.config.chart.animations.enabled, r = [
                        e,
                        i,
                        a
                    ], n = [
                        i.node,
                        e.node,
                        a.node
                    ], o = 0; o < 3; o++)t.globals.dom.elGraphical.add(r[o]), !s || t.globals.resized || t.globals.dataChanged || "scatter" !== t.config.chart.type && "bubble" !== t.config.chart.type && t.globals.dataPoints > 1 && n[o].classList.add("apexcharts-element-hidden"), t.globals.delayedElements.push({
                        el: n[o],
                        index: 0
                    });
                    this.helpers.annotationsBackground();
                }
            }
        },
        {
            key: "drawImageAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.images.map(function(e, i) {
                    t.addImage(e, i);
                });
            }
        },
        {
            key: "drawTextAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.texts.map(function(e, i) {
                    t.addText(e, i);
                });
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                this.xAxisAnnotations.addXaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                this.yAxisAnnotations.addYaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.pointsAnnotations.addPointAnnotation(t, e, i);
            }
        },
        {
            key: "addText",
            value: function(t, e) {
                var i = t.x, a = t.y, s = t.text, r = t.textAnchor, n = t.foreColor, o = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.cssClass, d = t.backgroundColor, u = t.borderWidth, g = t.strokeDashArray, p = t.borderRadius, f = t.borderColor, x = t.appendTo, b = void 0 === x ? ".apexcharts-svg" : x, m = t.paddingLeft, v = void 0 === m ? 4 : m, y = t.paddingRight, w = void 0 === y ? 4 : y, k = t.paddingBottom, A = void 0 === k ? 2 : k, C = t.paddingTop, S = void 0 === C ? 2 : C, L = this.w, M = this.graphics.drawText({
                    x: i,
                    y: a,
                    text: s,
                    textAnchor: r || "start",
                    fontSize: o || "12px",
                    fontWeight: h || "regular",
                    fontFamily: l || L.config.chart.fontFamily,
                    foreColor: n || L.config.chart.foreColor,
                    cssClass: c
                }), P = L.globals.dom.baseEl.querySelector(b);
                P && P.appendChild(M.node);
                var I = M.bbox();
                if (s) {
                    var T = this.graphics.drawRect(I.x - v, I.y - S, I.width + v + w, I.height + A + S, p, d || "transparent", 1, u, f, g);
                    P.insertBefore(T.node, M.node);
                }
            }
        },
        {
            key: "addImage",
            value: function(t, e) {
                var i = this.w, a = t.path, s = t.x, r = void 0 === s ? 0 : s, n = t.y, o = void 0 === n ? 0 : n, l = t.width, h = void 0 === l ? 20 : l, c = t.height, d = void 0 === c ? 20 : c, u = t.appendTo, g = void 0 === u ? ".apexcharts-svg" : u, p = i.globals.dom.Paper.image(a);
                p.size(h, d).move(r, o);
                var f = i.globals.dom.baseEl.querySelector(g);
                return f && f.appendChild(p.node), p;
            }
        },
        {
            key: "addXaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "xaxis",
                    contextMethod: i.addXaxisAnnotation
                }), i;
            }
        },
        {
            key: "addYaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "yaxis",
                    contextMethod: i.addYaxisAnnotation
                }), i;
            }
        },
        {
            key: "addPointAnnotationExternal",
            value: function(t, e, i) {
                return void 0 === this.invertAxis && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "point",
                    contextMethod: i.addPointAnnotation
                }), i;
            }
        },
        {
            key: "addAnnotationExternal",
            value: function(t) {
                var e = t.params, i = t.pushToMemory, a = t.context, s = t.type, r = t.contextMethod, n = a, o = n.w, l = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), h = l.childNodes.length + 1, c = new $e4b487e979d7c06d$var$Oi, d = Object.assign({}, "xaxis" === s ? c.xAxisAnnotation : "yaxis" === s ? c.yAxisAnnotation : c.pointAnnotation), u = $e4b487e979d7c06d$var$v.extend(d, e);
                switch(s){
                    case "xaxis":
                        this.addXaxisAnnotation(u, l, h);
                        break;
                    case "yaxis":
                        this.addYaxisAnnotation(u, l, h);
                        break;
                    case "point":
                        this.addPointAnnotation(u, l, h);
                }
                var g = o.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(h, "']")), p = this.helpers.addBackgroundToAnno(g, u);
                return p && l.insertBefore(p.node, g), i && o.globals.memory.methodsToExec.push({
                    context: n,
                    id: u.id ? u.id : $e4b487e979d7c06d$var$v.randomId(),
                    method: r,
                    label: "addAnnotation",
                    params: e
                }), a;
            }
        },
        {
            key: "clearAnnotations",
            value: function(t) {
                for(var e = t.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations"), a = e.globals.memory.methodsToExec.length - 1; a >= 0; a--)"addText" !== e.globals.memory.methodsToExec[a].label && "addAnnotation" !== e.globals.memory.methodsToExec[a].label || e.globals.memory.methodsToExec.splice(a, 1);
                i = $e4b487e979d7c06d$var$v.listToArray(i), Array.prototype.forEach.call(i, function(t) {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                });
            }
        },
        {
            key: "removeAnnotation",
            value: function(t, e) {
                var i = t.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(e));
                a && (i.globals.memory.methodsToExec.map(function(t, a) {
                    t.id === e && i.globals.memory.methodsToExec.splice(a, 1);
                }), Object.keys(i.config.annotations).forEach(function(t) {
                    var a = i.config.annotations[t];
                    Array.isArray(a) && (i.config.annotations[t] = a.filter(function(t) {
                        return t.id !== e;
                    }));
                }), Array.prototype.forEach.call(a, function(t) {
                    t.parentElement.removeChild(t);
                }));
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Di = function(t) {
    var e, i = t.isTimeline, a = t.ctx, s = t.seriesIndex, r = t.dataPointIndex, n = t.y1, o = t.y2, l = t.w, h = l.globals.seriesRangeStart[s][r], c = l.globals.seriesRangeEnd[s][r], d = l.globals.labels[r], u = l.config.series[s].name ? l.config.series[s].name : "", g = l.globals.ttKeyFormatter, p = l.config.tooltip.y.title.formatter, f = {
        w: l,
        seriesIndex: s,
        dataPointIndex: r,
        start: h,
        end: c
    };
    ("function" == typeof p && (u = p(u, f)), null !== (e = l.config.series[s].data[r]) && void 0 !== e && e.x && (d = l.config.series[s].data[r].x), i) || "datetime" === l.config.xaxis.type && (d = new $e4b487e979d7c06d$var$Xi(a).xLabelFormat(l.globals.ttKeyFormatter, d, d, {
        i: void 0,
        dateFormatter: new $e4b487e979d7c06d$var$zi(a).formatDate,
        w: l
    }));
    "function" == typeof g && (d = g(d, f)), Number.isFinite(n) && Number.isFinite(o) && (h = n, c = o);
    var x = "", b = "", m = l.globals.colors[s];
    if (void 0 === l.config.tooltip.x.formatter) {
        if ("datetime" === l.config.xaxis.type) {
            var v = new $e4b487e979d7c06d$var$zi(a);
            x = v.formatDate(v.getDate(h), l.config.tooltip.x.format), b = v.formatDate(v.getDate(c), l.config.tooltip.x.format);
        } else x = h, b = c;
    } else x = l.config.tooltip.x.formatter(h), b = l.config.tooltip.x.formatter(c);
    return {
        start: h,
        end: c,
        startVal: x,
        endVal: b,
        ylabel: d,
        color: m,
        seriesName: u
    };
}, $e4b487e979d7c06d$var$_i = function(t) {
    var e = t.color, i = t.seriesName, a = t.ylabel, s = t.start, r = t.end, n = t.seriesIndex, o = t.dataPointIndex, l = t.ctx.tooltip.tooltipLabels.getFormatters(n);
    s = l.yLbFormatter(s), r = l.yLbFormatter(r);
    var h = l.yLbFormatter(t.w.globals.series[n][o]), c = '<span class="value start-value">\n  '.concat(s, '\n  </span> <span class="separator">-</span> <span class="value end-value">\n  ').concat(r, "\n  </span>");
    return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (i || "") + '</span></div><div> <span class="category">' + a + ": </span> " + (t.w.globals.comboCharts ? "rangeArea" === t.w.config.series[n].type || "rangeBar" === t.w.config.series[n].type ? c : "<span>".concat(h, "</span>") : c) + " </div></div>";
}, $e4b487e979d7c06d$var$Ni = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.opts = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "hideYAxis",
            value: function() {
                this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
            }
        },
        {
            key: "line",
            value: function() {
                return {
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "sparkline",
            value: function(t) {
                this.hideYAxis();
                return $e4b487e979d7c06d$var$v.extend(t, {
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    legend: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    },
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    }
                });
            }
        },
        {
            key: "slope",
            value: function() {
                return this.hideYAxis(), {
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !0,
                        formatter: function(t, e) {
                            var i = e.w.config.series[e.seriesIndex].name;
                            return null !== t ? i + ": " + t : "";
                        },
                        background: {
                            enabled: !1
                        },
                        offsetX: -5
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !1
                            }
                        }
                    },
                    xaxis: {
                        position: "top",
                        labels: {
                            style: {
                                fontSize: 14,
                                fontWeight: 900
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    },
                    markers: {
                        size: 8,
                        hover: {
                            sizeOffset: 1
                        }
                    },
                    legend: {
                        show: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    }
                };
            }
        },
        {
            key: "bar",
            value: function() {
                return {
                    chart: {
                        stacked: !1
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "square"
                    },
                    fill: {
                        opacity: .85
                    },
                    legend: {
                        markers: {
                            shape: "square"
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        },
                        tickPlacement: "between",
                        crosshairs: {
                            width: "barWidth",
                            position: "back",
                            fill: {
                                type: "gradient"
                            },
                            dropShadow: {
                                enabled: !1
                            },
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "funnel",
            value: function() {
                return this.hideYAxis(), $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, this.bar()), {}, {
                    chart: {
                        animations: {
                            speed: 800,
                            animateGradually: {
                                enabled: !1
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: !0,
                            borderRadiusApplication: "around",
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    }
                });
            }
        },
        {
            key: "candlestick",
            value: function() {
                var t = this;
                return {
                    stroke: {
                        width: 1
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Open",
                                "High",
                                "",
                                "Low",
                                "Close"
                            ], "candlestick");
                        }
                    },
                    states: {
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "boxPlot",
            value: function() {
                var t = this;
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !1
                            }
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: [
                            "#24292e"
                        ]
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Minimum",
                                "Q1",
                                "Median",
                                "Q3",
                                "Maximum"
                            ], "boxPlot");
                        }
                    },
                    markers: {
                        size: 7,
                        strokeWidth: 1,
                        strokeColors: "#111"
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "rangeBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            animateGradually: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "square"
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        enabled: !1,
                        formatter: function(t, e) {
                            e.ctx;
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w, r = function() {
                                var t = s.globals.seriesRangeStart[i][a];
                                return s.globals.seriesRangeEnd[i][a] - t;
                            };
                            return s.globals.comboCharts ? "rangeBar" === s.config.series[i].type || "rangeArea" === s.config.series[i].type ? r() : t : r();
                        },
                        background: {
                            enabled: !1
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    markers: {
                        size: 10
                    },
                    tooltip: {
                        shared: !1,
                        followCursor: !0,
                        custom: function(t) {
                            return t.w.config.plotOptions && t.w.config.plotOptions.bar && t.w.config.plotOptions.bar.horizontal ? function(t) {
                                var e = $e4b487e979d7c06d$var$Di($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t), {}, {
                                    isTimeline: !0
                                })), i = e.color, a = e.seriesName, s = e.ylabel, r = e.startVal, n = e.endVal;
                                return $e4b487e979d7c06d$var$_i($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t), {}, {
                                    color: i,
                                    seriesName: a,
                                    ylabel: s,
                                    start: r,
                                    end: n
                                }));
                            }(t) : function(t) {
                                var e = $e4b487e979d7c06d$var$Di(t), i = e.color, a = e.seriesName, s = e.ylabel, r = e.start, n = e.end;
                                return $e4b487e979d7c06d$var$_i($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t), {}, {
                                    color: i,
                                    seriesName: a,
                                    ylabel: s,
                                    start: r,
                                    end: n
                                }));
                            }(t);
                        }
                    },
                    xaxis: {
                        tickPlacement: "between",
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "dumbbell",
            value: function(t) {
                var e, i;
                return null !== (e = t.plotOptions.bar) && void 0 !== e && e.barHeight || (t.plotOptions.bar.barHeight = 2), null !== (i = t.plotOptions.bar) && void 0 !== i && i.columnWidth || (t.plotOptions.bar.columnWidth = 2), t;
            }
        },
        {
            key: "area",
            value: function() {
                return {
                    stroke: {
                        width: 4,
                        fill: {
                            type: "solid",
                            gradient: {
                                inverseColors: !1,
                                shade: "light",
                                type: "vertical",
                                opacityFrom: .65,
                                opacityTo: .5,
                                stops: [
                                    0,
                                    100,
                                    100
                                ]
                            }
                        }
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            inverseColors: !1,
                            shade: "light",
                            type: "vertical",
                            opacityFrom: .65,
                            opacityTo: .5,
                            stops: [
                                0,
                                100,
                                100
                            ]
                        }
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    tooltip: {
                        followCursor: !1
                    }
                };
            }
        },
        {
            key: "rangeArea",
            value: function() {
                return {
                    stroke: {
                        curve: "straight",
                        width: 0
                    },
                    fill: {
                        type: "solid",
                        opacity: .6
                    },
                    markers: {
                        size: 0
                    },
                    states: {
                        hover: {
                            filter: {
                                type: "none"
                            }
                        },
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    tooltip: {
                        intersect: !1,
                        shared: !0,
                        followCursor: !0,
                        custom: function(t) {
                            return function(t) {
                                var e = $e4b487e979d7c06d$var$Di(t), i = e.color, a = e.seriesName, s = e.ylabel, r = e.start, n = e.end;
                                return $e4b487e979d7c06d$var$_i($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t), {}, {
                                    color: i,
                                    seriesName: a,
                                    ylabel: s,
                                    start: r,
                                    end: n
                                }));
                            }(t);
                        }
                    }
                };
            }
        },
        {
            key: "brush",
            value: function(t) {
                return $e4b487e979d7c06d$var$v.extend(t, {
                    chart: {
                        toolbar: {
                            autoSelected: "selection",
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 1
                    },
                    tooltip: {
                        enabled: !1
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        }
                    }
                });
            }
        },
        {
            key: "stacked100",
            value: function(t) {
                t.dataLabels = t.dataLabels || {}, t.dataLabels.formatter = t.dataLabels.formatter || void 0;
                var e = t.dataLabels.formatter;
                return t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }), "bar" === t.chart.type && (t.dataLabels.formatter = e || function(t) {
                    return "number" == typeof t && t ? t.toFixed(0) + "%" : t;
                }), t;
            }
        },
        {
            key: "stackedBars",
            value: function() {
                var t = this.bar();
                return $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t), {}, {
                    plotOptions: $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t.plotOptions), {}, {
                        bar: $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t.plotOptions.bar), {}, {
                            borderRadiusApplication: "end",
                            borderRadiusWhenStacked: "last"
                        })
                    })
                });
            }
        },
        {
            key: "convertCatToNumeric",
            value: function(t) {
                return t.xaxis.convertedCatToNumeric = !0, t;
            }
        },
        {
            key: "convertCatToNumericXaxis",
            value: function(t, e, i) {
                t.xaxis.type = "numeric", t.xaxis.labels = t.xaxis.labels || {}, t.xaxis.labels.formatter = t.xaxis.labels.formatter || function(t) {
                    return $e4b487e979d7c06d$var$v.isNumber(t) ? Math.floor(t) : t;
                };
                var a = t.xaxis.labels.formatter, s = t.xaxis.categories && t.xaxis.categories.length ? t.xaxis.categories : t.labels;
                return i && i.length && (s = i.map(function(t) {
                    return Array.isArray(t) ? t : String(t);
                })), s && s.length && (t.xaxis.labels.formatter = function(t) {
                    return $e4b487e979d7c06d$var$v.isNumber(t) ? a(s[Math.floor(t) - 1]) : a(t);
                }), t.xaxis.categories = [], t.labels = [], t.xaxis.tickAmount = t.xaxis.tickAmount || "dataPoints", t;
            }
        },
        {
            key: "bubble",
            value: function() {
                return {
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        crosshairs: {
                            width: 0
                        }
                    },
                    fill: {
                        type: "solid",
                        gradient: {
                            shade: "light",
                            inverse: !0,
                            shadeIntensity: .55,
                            opacityFrom: .4,
                            opacityTo: .8
                        }
                    }
                };
            }
        },
        {
            key: "scatter",
            value: function() {
                return {
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    markers: {
                        size: 6,
                        strokeWidth: 1,
                        hover: {
                            sizeOffset: 2
                        }
                    }
                };
            }
        },
        {
            key: "heatmap",
            value: function() {
                return {
                    chart: {
                        stacked: !1
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    tooltip: {
                        followCursor: !0,
                        marker: {
                            show: !1
                        },
                        x: {
                            show: !1
                        }
                    },
                    legend: {
                        position: "top",
                        markers: {
                            shape: "square"
                        }
                    },
                    grid: {
                        padding: {
                            right: 20
                        }
                    }
                };
            }
        },
        {
            key: "treemap",
            value: function() {
                return {
                    chart: {
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        style: {
                            fontSize: 14,
                            fontWeight: 600,
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        show: !0,
                        width: 2,
                        colors: [
                            "#fff"
                        ]
                    },
                    legend: {
                        show: !1
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        followCursor: !0,
                        x: {
                            show: !1
                        }
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        }
                    }
                };
            }
        },
        {
            key: "pie",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: !1
                                }
                            }
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "donut",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            shadeIntensity: .35,
                            stops: [
                                80,
                                100
                            ],
                            opacityFrom: 1,
                            opacityTo: 1
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "polarArea",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        enabled: !1
                    },
                    stroke: {
                        show: !0,
                        width: 2
                    },
                    fill: {
                        opacity: .7
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "radar",
            value: function() {
                return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                    dataLabels: {
                        enabled: !1,
                        style: {
                            fontSize: "11px"
                        }
                    },
                    stroke: {
                        width: 2
                    },
                    markers: {
                        size: 5,
                        strokeWidth: 1,
                        strokeOpacity: 1
                    },
                    fill: {
                        opacity: .2
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    xaxis: {
                        labels: {
                            formatter: function(t) {
                                return t;
                            },
                            style: {
                                colors: [
                                    "#a8a8a8"
                                ],
                                fontSize: "11px"
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    }
                };
            }
        },
        {
            key: "radialBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 800
                            }
                        },
                        toolbar: {
                            show: !1
                        }
                    },
                    fill: {
                        gradient: {
                            shade: "dark",
                            shadeIntensity: .4,
                            inverseColors: !1,
                            type: "diagonal2",
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                70,
                                98,
                                100
                            ]
                        }
                    },
                    legend: {
                        show: !1,
                        position: "right"
                    },
                    tooltip: {
                        enabled: !1,
                        fillSeriesColor: !0
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    }
                };
            }
        },
        {
            key: "_getBoxTooltip",
            value: function(t, e, i, a, s) {
                var r = t.globals.seriesCandleO[e][i], n = t.globals.seriesCandleH[e][i], o = t.globals.seriesCandleM[e][i], l = t.globals.seriesCandleL[e][i], h = t.globals.seriesCandleC[e][i];
                return t.config.series[e].type && t.config.series[e].type !== s ? '<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name ? t.config.series[e].name : "series-" + (e + 1), ": <strong>").concat(t.globals.series[e][i], "</strong>\n        </div>") : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + n + "</span></div>" + (o ? "<div>".concat(a[2], ': <span class="value">') + o + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + l + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + h + "</span></div></div>";
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Wi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.opts = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "init",
            value: function(t) {
                var e = t.responsiveOverride, i = this.opts, a = new $e4b487e979d7c06d$var$Oi, s = new $e4b487e979d7c06d$var$Ni(i);
                this.chartType = i.chart.type, i = this.extendYAxis(i), i = this.extendAnnotations(i);
                var r = a.init(), n = {};
                if (i && "object" === $e4b487e979d7c06d$var$b(i)) {
                    var o, l, h, c, d, u, g, p, f, x, m = {};
                    m = -1 !== [
                        "line",
                        "area",
                        "bar",
                        "candlestick",
                        "boxPlot",
                        "rangeBar",
                        "rangeArea",
                        "bubble",
                        "scatter",
                        "heatmap",
                        "treemap",
                        "pie",
                        "polarArea",
                        "donut",
                        "radar",
                        "radialBar"
                    ].indexOf(i.chart.type) ? s[i.chart.type]() : s.line(), null !== (o = i.plotOptions) && void 0 !== o && null !== (l = o.bar) && void 0 !== l && l.isFunnel && (m = s.funnel()), i.chart.stacked && "bar" === i.chart.type && (m = s.stackedBars()), null !== (h = i.chart.brush) && void 0 !== h && h.enabled && (m = s.brush(m)), null !== (c = i.plotOptions) && void 0 !== c && null !== (d = c.line) && void 0 !== d && d.isSlopeChart && (m = s.slope()), i.chart.stacked && "100%" === i.chart.stackType && (i = s.stacked100(i)), null !== (u = i.plotOptions) && void 0 !== u && null !== (g = u.bar) && void 0 !== g && g.isDumbbell && (i = s.dumbbell(i)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(i), i.xaxis = i.xaxis || window.Apex.xaxis || {}, e || (i.xaxis.convertedCatToNumeric = !1), (null !== (p = (i = this.checkForCatToNumericXAxis(this.chartType, m, i)).chart.sparkline) && void 0 !== p && p.enabled || null !== (f = window.Apex.chart) && void 0 !== f && null !== (x = f.sparkline) && void 0 !== x && x.enabled) && (m = s.sparkline(m)), n = $e4b487e979d7c06d$var$v.extend(r, m);
                }
                var y = $e4b487e979d7c06d$var$v.extend(n, window.Apex);
                return r = $e4b487e979d7c06d$var$v.extend(y, i), r = this.handleUserInputErrors(r);
            }
        },
        {
            key: "checkForCatToNumericXAxis",
            value: function(t, e, i) {
                var a, s, r = new $e4b487e979d7c06d$var$Ni(i), n = ("bar" === t || "boxPlot" === t) && (null === (a = i.plotOptions) || void 0 === a || null === (s = a.bar) || void 0 === s ? void 0 : s.horizontal), o = "pie" === t || "polarArea" === t || "donut" === t || "radar" === t || "radialBar" === t || "heatmap" === t, l = "datetime" !== i.xaxis.type && "numeric" !== i.xaxis.type, h = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : e.xaxis && e.xaxis.tickPlacement;
                return n || o || !l || "between" === h || (i = r.convertCatToNumeric(i)), i;
            }
        },
        {
            key: "extendYAxis",
            value: function(t, e) {
                var i = new $e4b487e979d7c06d$var$Oi;
                (void 0 === t.yaxis || !t.yaxis || Array.isArray(t.yaxis) && 0 === t.yaxis.length) && (t.yaxis = {}), t.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (t.yaxis = $e4b487e979d7c06d$var$v.extend(t.yaxis, window.Apex.yaxis)), t.yaxis.constructor !== Array ? t.yaxis = [
                    $e4b487e979d7c06d$var$v.extend(i.yAxis, t.yaxis)
                ] : t.yaxis = $e4b487e979d7c06d$var$v.extendArray(t.yaxis, i.yAxis);
                var a = !1;
                t.yaxis.forEach(function(t) {
                    t.logarithmic && (a = !0);
                });
                var s = t.series;
                return e && !s && (s = e.config.series), a && s.length !== t.yaxis.length && s.length && (t.yaxis = s.map(function(e, a) {
                    if (e.name || (s[a].name = "series-".concat(a + 1)), t.yaxis[a]) return t.yaxis[a].seriesName = s[a].name, t.yaxis[a];
                    var r = $e4b487e979d7c06d$var$v.extend(i.yAxis, t.yaxis[0]);
                    return r.show = !1, r;
                })), a && s.length > 1 && s.length !== t.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes"), t;
            }
        },
        {
            key: "extendAnnotations",
            value: function(t) {
                return void 0 === t.annotations && (t.annotations = {}, t.annotations.yaxis = [], t.annotations.xaxis = [], t.annotations.points = []), t = this.extendYAxisAnnotations(t), t = this.extendXAxisAnnotations(t), t = this.extendPointAnnotations(t);
            }
        },
        {
            key: "extendYAxisAnnotations",
            value: function(t) {
                var e = new $e4b487e979d7c06d$var$Oi;
                return t.annotations.yaxis = $e4b487e979d7c06d$var$v.extendArray(void 0 !== t.annotations.yaxis ? t.annotations.yaxis : [], e.yAxisAnnotation), t;
            }
        },
        {
            key: "extendXAxisAnnotations",
            value: function(t) {
                var e = new $e4b487e979d7c06d$var$Oi;
                return t.annotations.xaxis = $e4b487e979d7c06d$var$v.extendArray(void 0 !== t.annotations.xaxis ? t.annotations.xaxis : [], e.xAxisAnnotation), t;
            }
        },
        {
            key: "extendPointAnnotations",
            value: function(t) {
                var e = new $e4b487e979d7c06d$var$Oi;
                return t.annotations.points = $e4b487e979d7c06d$var$v.extendArray(void 0 !== t.annotations.points ? t.annotations.points : [], e.pointAnnotation), t;
            }
        },
        {
            key: "checkForDarkTheme",
            value: function(t) {
                t.theme && "dark" === t.theme.mode && (t.tooltip || (t.tooltip = {}), "light" !== t.tooltip.theme && (t.tooltip.theme = "dark"), t.chart.foreColor || (t.chart.foreColor = "#f6f7f8"), t.theme.palette || (t.theme.palette = "palette4"));
            }
        },
        {
            key: "handleUserInputErrors",
            value: function(t) {
                var e = t;
                if (e.tooltip.shared && e.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                if ("bar" === e.chart.type && e.plotOptions.bar.horizontal) {
                    if (e.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                    e.yaxis[0].reversed && (e.yaxis[0].opposite = !0), e.xaxis.tooltip.enabled = !1, e.yaxis[0].tooltip.enabled = !1, e.chart.zoom.enabled = !1;
                }
                return "bar" !== e.chart.type && "rangeBar" !== e.chart.type || e.tooltip.shared && "barWidth" === e.xaxis.crosshairs.width && e.series.length > 1 && (e.xaxis.crosshairs.width = "tickWidth"), "candlestick" !== e.chart.type && "boxPlot" !== e.chart.type || e.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(e.chart.type, " chart is not supported.")), e.yaxis[0].reversed = !1), e;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Bi = function() {
    function t() {
        $e4b487e979d7c06d$var$i(this, t);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "initGlobalVars",
            value: function(t) {
                t.series = [], t.seriesCandleO = [], t.seriesCandleH = [], t.seriesCandleM = [], t.seriesCandleL = [], t.seriesCandleC = [], t.seriesRangeStart = [], t.seriesRangeEnd = [], t.seriesRange = [], t.seriesPercent = [], t.seriesGoals = [], t.seriesX = [], t.seriesZ = [], t.seriesNames = [], t.seriesTotals = [], t.seriesLog = [], t.seriesColors = [], t.stackedSeriesTotals = [], t.seriesXvalues = [], t.seriesYvalues = [], t.labels = [], t.hasXaxisGroups = !1, t.groups = [], t.barGroups = [], t.lineGroups = [], t.areaGroups = [], t.hasSeriesGroups = !1, t.seriesGroups = [], t.categoryLabels = [], t.timescaleLabels = [], t.noLabelsProvided = !1, t.resizeTimer = null, t.selectionResizeTimer = null, t.lastWheelExecution = 0, t.delayedElements = [], t.pointsArray = [], t.dataLabelsRects = [], t.isXNumeric = !1, t.skipLastTimelinelabel = !1, t.skipFirstTimelinelabel = !1, t.isDataXYZ = !1, t.isMultiLineX = !1, t.isMultipleYAxis = !1, t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE, t.minYArr = [], t.maxYArr = [], t.maxX = -Number.MAX_VALUE, t.minX = Number.MAX_VALUE, t.initialMaxX = -Number.MAX_VALUE, t.initialMinX = Number.MAX_VALUE, t.maxDate = 0, t.minDate = Number.MAX_VALUE, t.minZ = Number.MAX_VALUE, t.maxZ = -Number.MAX_VALUE, t.minXDiff = Number.MAX_VALUE, t.yAxisScale = [], t.xAxisScale = null, t.xAxisTicksPositions = [], t.yLabelsCoords = [], t.yTitleCoords = [], t.barPadForNumericAxis = 0, t.padHorizontal = 0, t.xRange = 0, t.yRange = [], t.zRange = 0, t.dataPoints = 0, t.xTickAmount = 0, t.multiAxisTickAmount = 0;
            }
        },
        {
            key: "globalVars",
            value: function(t) {
                return {
                    chartID: null,
                    cuid: null,
                    events: {
                        beforeMount: [],
                        mounted: [],
                        updated: [],
                        clicked: [],
                        selection: [],
                        dataPointSelection: [],
                        zoomed: [],
                        scrolled: []
                    },
                    colors: [],
                    clientX: null,
                    clientY: null,
                    fill: {
                        colors: []
                    },
                    stroke: {
                        colors: []
                    },
                    dataLabels: {
                        style: {
                            colors: []
                        }
                    },
                    radarPolygons: {
                        fill: {
                            colors: []
                        }
                    },
                    markers: {
                        colors: [],
                        size: t.markers.size,
                        largestSize: 0
                    },
                    animationEnded: !1,
                    isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                    isDirty: !1,
                    isExecCalled: !1,
                    initialConfig: null,
                    initialSeries: [],
                    lastXAxis: [],
                    lastYAxis: [],
                    columnSeries: null,
                    labels: [],
                    timescaleLabels: [],
                    noLabelsProvided: !1,
                    allSeriesCollapsed: !1,
                    collapsedSeries: [],
                    collapsedSeriesIndices: [],
                    ancillaryCollapsedSeries: [],
                    ancillaryCollapsedSeriesIndices: [],
                    risingSeries: [],
                    dataFormatXNumeric: !1,
                    capturedSeriesIndex: -1,
                    capturedDataPointIndex: -1,
                    selectedDataPoints: [],
                    invalidLogScale: !1,
                    ignoreYAxisIndexes: [],
                    maxValsInArrayIndex: 0,
                    radialSize: 0,
                    selection: void 0,
                    zoomEnabled: "zoom" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.zoom && t.chart.zoom.enabled,
                    panEnabled: "pan" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.pan,
                    selectionEnabled: "selection" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.selection,
                    yaxis: null,
                    mousedown: !1,
                    lastClientPosition: {},
                    visibleXRange: void 0,
                    yValueDecimal: 0,
                    total: 0,
                    SVGNS: "http://www.w3.org/2000/svg",
                    svgWidth: 0,
                    svgHeight: 0,
                    noData: !1,
                    locale: {},
                    dom: {},
                    memory: {
                        methodsToExec: []
                    },
                    shouldAnimate: !0,
                    skipLastTimelinelabel: !1,
                    skipFirstTimelinelabel: !1,
                    delayedElements: [],
                    axisCharts: !0,
                    isDataXYZ: !1,
                    isSlopeChart: t.plotOptions.line.isSlopeChart,
                    resized: !1,
                    resizeTimer: null,
                    comboCharts: !1,
                    dataChanged: !1,
                    previousPaths: [],
                    allSeriesHasEqualX: !0,
                    pointsArray: [],
                    dataLabelsRects: [],
                    lastDrawnDataLabelsIndexes: [],
                    hasNullValues: !1,
                    zoomed: !1,
                    gridWidth: 0,
                    gridHeight: 0,
                    rotateXLabels: !1,
                    defaultLabels: !1,
                    xLabelFormatter: void 0,
                    yLabelFormatters: [],
                    xaxisTooltipFormatter: void 0,
                    ttKeyFormatter: void 0,
                    ttVal: void 0,
                    ttZFormatter: void 0,
                    LINE_HEIGHT_RATIO: 1.618,
                    xAxisLabelsHeight: 0,
                    xAxisGroupLabelsHeight: 0,
                    xAxisLabelsWidth: 0,
                    yAxisLabelsWidth: 0,
                    scaleX: 1,
                    scaleY: 1,
                    translateX: 0,
                    translateY: 0,
                    translateYAxisX: [],
                    yAxisWidths: [],
                    translateXAxisY: 0,
                    translateXAxisX: 0,
                    tooltip: null,
                    niceScaleAllowedMagMsd: [
                        [
                            1,
                            1,
                            2,
                            5,
                            5,
                            5,
                            10,
                            10,
                            10,
                            10,
                            10
                        ],
                        [
                            1,
                            1,
                            2,
                            5,
                            5,
                            5,
                            10,
                            10,
                            10,
                            10,
                            10
                        ]
                    ],
                    niceScaleDefaultTicks: [
                        1,
                        2,
                        4,
                        4,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        6,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        12,
                        24
                    ],
                    seriesYAxisMap: [],
                    seriesYAxisReverseMap: []
                };
            }
        },
        {
            key: "init",
            value: function(t) {
                var e = this.globalVars(t);
                return this.initGlobalVars(e), e.initialConfig = $e4b487e979d7c06d$var$v.extend({}, t), e.initialSeries = $e4b487e979d7c06d$var$v.clone(t.series), e.lastXAxis = $e4b487e979d7c06d$var$v.clone(e.initialConfig.xaxis), e.lastYAxis = $e4b487e979d7c06d$var$v.clone(e.initialConfig.yaxis), e;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Gi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.opts = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "init",
            value: function() {
                var t = new $e4b487e979d7c06d$var$Wi(this.opts).init({
                    responsiveOverride: !1
                });
                return {
                    config: t,
                    globals: (new $e4b487e979d7c06d$var$Bi).init(t)
                };
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ji = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0, this.patternIDs = [];
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "clippedImgArea",
            value: function(t) {
                var e = this.w, i = e.config, a = parseInt(e.globals.gridWidth, 10), s = parseInt(e.globals.gridHeight, 10), r = a > s ? a : s, n = t.image, o = 0, l = 0;
                void 0 === t.width && void 0 === t.height ? void 0 !== i.fill.image.width && void 0 !== i.fill.image.height ? (o = i.fill.image.width + 1, l = i.fill.image.height) : (o = r + 1, l = r) : (o = t.width, l = t.height);
                var h = document.createElementNS(e.globals.SVGNS, "pattern");
                $e4b487e979d7c06d$var$Mi.setAttrs(h, {
                    id: t.patternID,
                    patternUnits: t.patternUnits ? t.patternUnits : "userSpaceOnUse",
                    width: o + "px",
                    height: l + "px"
                });
                var c = document.createElementNS(e.globals.SVGNS, "image");
                h.appendChild(c), c.setAttributeNS(window.SVG.xlink, "href", n), $e4b487e979d7c06d$var$Mi.setAttrs(c, {
                    x: 0,
                    y: 0,
                    preserveAspectRatio: "none",
                    width: o + "px",
                    height: l + "px"
                }), c.style.opacity = t.opacity, e.globals.dom.elDefs.node.appendChild(h);
            }
        },
        {
            key: "getSeriesIndex",
            value: function(t) {
                var e = this.w, i = e.config.chart.type;
                return ("bar" === i || "rangeBar" === i) && e.config.plotOptions.bar.distributed || "heatmap" === i || "treemap" === i ? this.seriesIndex = t.seriesNumber : this.seriesIndex = t.seriesNumber % e.globals.series.length, this.seriesIndex;
            }
        },
        {
            key: "computeColorStops",
            value: function(t, e) {
                var i, a = this.w, s = null, n = null, o = $e4b487e979d7c06d$var$r(t);
                try {
                    for(o.s(); !(i = o.n()).done;){
                        var l = i.value;
                        l >= e.threshold ? (null === s || l > s) && (s = l) : (null === n || l < n) && (n = l);
                    }
                } catch (t) {
                    o.e(t);
                } finally{
                    o.f();
                }
                null === s && (s = e.threshold), null === n && (n = e.threshold);
                var h = s - e.threshold + (e.threshold - n);
                0 === h && (h = 1);
                var c = 100 - (e.threshold - n) / h * 100;
                return [
                    {
                        offset: c = Math.max(0, Math.min(c, 100)),
                        color: e.colorAboveThreshold,
                        opacity: a.config.fill.opacity
                    },
                    {
                        offset: 0,
                        color: e.colorBelowThreshold,
                        opacity: a.config.fill.opacity
                    }
                ];
            }
        },
        {
            key: "fillPath",
            value: function(t) {
                var e, i, a, s = this.w;
                this.opts = t;
                var r, n, o, l = this.w.config;
                this.seriesIndex = this.getSeriesIndex(t);
                var h = l.plotOptions.line.colors.colorAboveThreshold && l.plotOptions.line.colors.colorBelowThreshold, c = this.getFillColors()[this.seriesIndex];
                void 0 !== s.globals.seriesColors[this.seriesIndex] && (c = s.globals.seriesColors[this.seriesIndex]), "function" == typeof c && (c = c({
                    seriesIndex: this.seriesIndex,
                    dataPointIndex: t.dataPointIndex,
                    value: t.value,
                    w: s
                }));
                var d, u, g, p = t.fillType ? t.fillType : this.getFillType(this.seriesIndex), x = Array.isArray(l.fill.opacity) ? l.fill.opacity[this.seriesIndex] : l.fill.opacity, b = "gradient" === p || h;
                (t.color && (c = t.color), null !== (e = s.config.series[this.seriesIndex]) && void 0 !== e && null !== (i = e.data) && void 0 !== i && null !== (a = i[t.dataPointIndex]) && void 0 !== a && a.fillColor) && (c = null === (d = s.config.series[this.seriesIndex]) || void 0 === d || null === (u = d.data) || void 0 === u || null === (g = u[t.dataPointIndex]) || void 0 === g ? void 0 : g.fillColor);
                c || (c = "#fff", console.warn("undefined color - ApexCharts"));
                var m = c;
                if (-1 === c.indexOf("rgb") ? -1 === c.indexOf("#") ? m = c : c.length < 9 && (m = $e4b487e979d7c06d$var$v.hexToRgba(c, x)) : c.indexOf("rgba") > -1 ? x = $e4b487e979d7c06d$var$v.getOpacityFromRGBA(c) : m = $e4b487e979d7c06d$var$v.hexToRgba($e4b487e979d7c06d$var$v.rgb2hex(c), x), t.opacity && (x = t.opacity), "pattern" === p && (n = this.handlePatternFill({
                    fillConfig: t.fillConfig,
                    patternFill: n,
                    fillColor: c,
                    fillOpacity: x,
                    defaultColor: m
                })), b) {
                    var y = $e4b487e979d7c06d$var$f(l.fill.gradient.colorStops) || [], w = l.fill.gradient.type;
                    h && (y[this.seriesIndex] = this.computeColorStops(s.globals.series[this.seriesIndex], l.plotOptions.line.colors), w = "vertical"), o = this.handleGradientFill({
                        type: w,
                        fillConfig: t.fillConfig,
                        fillColor: c,
                        fillOpacity: x,
                        colorStops: y,
                        i: this.seriesIndex
                    });
                }
                if ("image" === p) {
                    var k = l.fill.image.src, A = t.patternID ? t.patternID : "", C = "pattern".concat(s.globals.cuid).concat(t.seriesNumber + 1).concat(A);
                    -1 === this.patternIDs.indexOf(C) && (this.clippedImgArea({
                        opacity: x,
                        image: Array.isArray(k) ? t.seriesNumber < k.length ? k[t.seriesNumber] : k[0] : k,
                        width: t.width ? t.width : void 0,
                        height: t.height ? t.height : void 0,
                        patternUnits: t.patternUnits,
                        patternID: C
                    }), this.patternIDs.push(C)), r = "url(#".concat(C, ")");
                } else r = b ? o : "pattern" === p ? n : m;
                return t.solid && (r = m), r;
            }
        },
        {
            key: "getFillType",
            value: function(t) {
                var e = this.w;
                return Array.isArray(e.config.fill.type) ? e.config.fill.type[t] : e.config.fill.type;
            }
        },
        {
            key: "getFillColors",
            value: function() {
                var t = this.w, e = t.config, i = this.opts, a = [];
                return t.globals.comboCharts ? "line" === t.config.series[this.seriesIndex].type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors) : "line" === e.chart.type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors), void 0 !== i.fillColors && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
            }
        },
        {
            key: "handlePatternFill",
            value: function(t) {
                var e = t.fillConfig, i = t.patternFill, a = t.fillColor, s = t.fillOpacity, r = t.defaultColor, n = this.w.config.fill;
                e && (n = e);
                var o = this.opts, l = new $e4b487e979d7c06d$var$Mi(this.ctx), h = Array.isArray(n.pattern.strokeWidth) ? n.pattern.strokeWidth[this.seriesIndex] : n.pattern.strokeWidth, c = a;
                Array.isArray(n.pattern.style) ? i = void 0 !== n.pattern.style[o.seriesNumber] ? l.drawPattern(n.pattern.style[o.seriesNumber], n.pattern.width, n.pattern.height, c, h, s) : r : i = l.drawPattern(n.pattern.style, n.pattern.width, n.pattern.height, c, h, s);
                return i;
            }
        },
        {
            key: "handleGradientFill",
            value: function(t) {
                var e = t.type, i = t.fillColor, a = t.fillOpacity, s = t.fillConfig, r = t.colorStops, n = t.i, o = this.w.config.fill;
                s && (o = $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, o), s));
                var l = this.opts, h = new $e4b487e979d7c06d$var$Mi(this.ctx), c = new $e4b487e979d7c06d$var$v;
                e = e || o.gradient.type;
                var d, g = i, p = void 0 === o.gradient.opacityFrom ? a : Array.isArray(o.gradient.opacityFrom) ? o.gradient.opacityFrom[n] : o.gradient.opacityFrom;
                g.indexOf("rgba") > -1 && (p = $e4b487e979d7c06d$var$v.getOpacityFromRGBA(g));
                var f = void 0 === o.gradient.opacityTo ? a : Array.isArray(o.gradient.opacityTo) ? o.gradient.opacityTo[n] : o.gradient.opacityTo;
                if (void 0 === o.gradient.gradientToColors || 0 === o.gradient.gradientToColors.length) d = "dark" === o.gradient.shade ? c.shadeColor(-1 * parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? $e4b487e979d7c06d$var$v.rgb2hex(i) : i) : c.shadeColor(parseFloat(o.gradient.shadeIntensity), i.indexOf("rgb") > -1 ? $e4b487e979d7c06d$var$v.rgb2hex(i) : i);
                else if (o.gradient.gradientToColors[l.seriesNumber]) {
                    var x = o.gradient.gradientToColors[l.seriesNumber];
                    d = x, x.indexOf("rgba") > -1 && (f = $e4b487e979d7c06d$var$v.getOpacityFromRGBA(x));
                } else d = i;
                if (o.gradient.gradientFrom && (g = o.gradient.gradientFrom), o.gradient.gradientTo && (d = o.gradient.gradientTo), o.gradient.inverseColors) {
                    var b = g;
                    g = d, d = b;
                }
                return g.indexOf("rgb") > -1 && (g = $e4b487e979d7c06d$var$v.rgb2hex(g)), d.indexOf("rgb") > -1 && (d = $e4b487e979d7c06d$var$v.rgb2hex(d)), h.drawGradient(e, g, d, p, f, l.size, o.gradient.stops, r, n);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Vi = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "setGlobalMarkerSize",
            value: function() {
                var t = this.w;
                if (t.globals.markers.size = Array.isArray(t.config.markers.size) ? t.config.markers.size : [
                    t.config.markers.size
                ], t.globals.markers.size.length > 0) {
                    if (t.globals.markers.size.length < t.globals.series.length + 1) for(var e = 0; e <= t.globals.series.length; e++)void 0 === t.globals.markers.size[e] && t.globals.markers.size.push(t.globals.markers.size[0]);
                } else t.globals.markers.size = t.config.series.map(function(e) {
                    return t.config.markers.size;
                });
            }
        },
        {
            key: "plotChartMarkers",
            value: function(t) {
                var e = t.pointsPos, i = t.seriesIndex, a = t.j, s = t.pSize, r = t.alwaysDrawMarker, n = void 0 !== r && r, o = t.isVirtualPoint, l = void 0 !== o && o, h = this.w, c = i, d = e, u = null, g = new $e4b487e979d7c06d$var$Mi(this.ctx), p = h.config.markers.discrete && h.config.markers.discrete.length;
                if (Array.isArray(d.x)) for(var f = 0; f < d.x.length; f++){
                    var x = void 0, b = a, m = !$e4b487e979d7c06d$var$v.isNumber(d.y[f]);
                    0 === h.globals.markers.largestSize && h.globals.hasNullValues && null !== h.globals.series[c][a + 1] && !l && (m = !0), 1 === a && 0 === f && (b = 0), 1 === a && 1 === f && (b = 1);
                    var y = "apexcharts-marker";
                    if ("line" !== h.config.chart.type && "area" !== h.config.chart.type || h.globals.comboCharts || h.config.tooltip.intersect || (y += " no-pointer-events"), (Array.isArray(h.config.markers.size) ? h.globals.markers.size[i] > 0 : h.config.markers.size > 0) || n || p) {
                        m || (y += " w".concat($e4b487e979d7c06d$var$v.randomId()));
                        var w = this.getMarkerConfig({
                            cssClass: y,
                            seriesIndex: i,
                            dataPointIndex: b
                        });
                        if (h.config.series[c].data[b] && (h.config.series[c].data[b].fillColor && (w.pointFillColor = h.config.series[c].data[b].fillColor), h.config.series[c].data[b].strokeColor && (w.pointStrokeColor = h.config.series[c].data[b].strokeColor)), void 0 !== s && (w.pSize = s), (d.x[f] < -h.globals.markers.largestSize || d.x[f] > h.globals.gridWidth + h.globals.markers.largestSize || d.y[f] < -h.globals.markers.largestSize || d.y[f] > h.globals.gridHeight + h.globals.markers.largestSize) && (w.pSize = 0), !m) (h.globals.markers.size[i] > 0 || n || p) && !u && (u = g.group({
                            class: n || p ? "" : "apexcharts-series-markers"
                        })).attr("clip-path", "url(#gridRectMarkerMask".concat(h.globals.cuid, ")")), (x = g.drawMarker(d.x[f], d.y[f], w)).attr("rel", b), x.attr("j", b), x.attr("index", i), x.node.setAttribute("default-marker-size", w.pSize), new $e4b487e979d7c06d$var$Li(this.ctx).setSelectionFilter(x, i, b), this.addEvents(x), u && u.add(x);
                    } else void 0 === h.globals.pointsArray[i] && (h.globals.pointsArray[i] = []), h.globals.pointsArray[i].push([
                        d.x[f],
                        d.y[f]
                    ]);
                }
                return u;
            }
        },
        {
            key: "getMarkerConfig",
            value: function(t) {
                var e = t.cssClass, i = t.seriesIndex, a = t.dataPointIndex, s = void 0 === a ? null : a, r = t.radius, n = void 0 === r ? null : r, o = t.size, l = void 0 === o ? null : o, h = t.strokeWidth, c = void 0 === h ? null : h, d = this.w, u = this.getMarkerStyle(i), g = null === l ? d.globals.markers.size[i] : l, p = d.config.markers;
                return null !== s && p.discrete.length && p.discrete.map(function(t) {
                    t.seriesIndex === i && t.dataPointIndex === s && (u.pointStrokeColor = t.strokeColor, u.pointFillColor = t.fillColor, g = t.size, u.pointShape = t.shape);
                }), {
                    pSize: null === n ? g : n,
                    pRadius: null !== n ? n : p.radius,
                    pointStrokeWidth: null !== c ? c : Array.isArray(p.strokeWidth) ? p.strokeWidth[i] : p.strokeWidth,
                    pointStrokeColor: u.pointStrokeColor,
                    pointFillColor: u.pointFillColor,
                    shape: u.pointShape || (Array.isArray(p.shape) ? p.shape[i] : p.shape),
                    class: e,
                    pointStrokeOpacity: Array.isArray(p.strokeOpacity) ? p.strokeOpacity[i] : p.strokeOpacity,
                    pointStrokeDashArray: Array.isArray(p.strokeDashArray) ? p.strokeDashArray[i] : p.strokeDashArray,
                    pointFillOpacity: Array.isArray(p.fillOpacity) ? p.fillOpacity[i] : p.fillOpacity,
                    seriesIndex: i
                };
            }
        },
        {
            key: "addEvents",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, t)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, t)), t.node.addEventListener("click", e.config.markers.onClick), t.node.addEventListener("dblclick", e.config.markers.onDblClick), t.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, t), {
                    passive: !0
                });
            }
        },
        {
            key: "getMarkerStyle",
            value: function(t) {
                var e = this.w, i = e.globals.markers.colors, a = e.config.markers.strokeColor || e.config.markers.strokeColors;
                return {
                    pointStrokeColor: Array.isArray(a) ? a[t] : a,
                    pointFillColor: Array.isArray(i) ? i[t] : i
                };
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ui = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this.w, s = new $e4b487e979d7c06d$var$Mi(this.ctx), r = i.realIndex, n = i.pointsPos, o = i.zRatio, l = i.elParent, h = s.group({
                    class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                });
                if (h.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(n.x)) for(var c = 0; c < n.x.length; c++){
                    var d = e + 1, u = !0;
                    0 === e && 0 === c && (d = 0), 0 === e && 1 === c && (d = 1);
                    var g = a.globals.markers.size[r];
                    if (o !== 1 / 0) {
                        var p = a.config.plotOptions.bubble;
                        g = a.globals.seriesZ[r][d], p.zScaling && (g /= o), p.minBubbleRadius && g < p.minBubbleRadius && (g = p.minBubbleRadius), p.maxBubbleRadius && g > p.maxBubbleRadius && (g = p.maxBubbleRadius);
                    }
                    var f = n.x[c], x = n.y[c];
                    if (g = g || 0, null !== x && void 0 !== a.globals.series[r][d] || (u = !1), u) {
                        var b = this.drawPoint(f, x, g, r, d, e);
                        h.add(b);
                    }
                    l.add(h);
                }
            }
        },
        {
            key: "drawPoint",
            value: function(t, e, i, a, s, r) {
                var n = this.w, o = a, l = new $e4b487e979d7c06d$var$y(this.ctx), h = new $e4b487e979d7c06d$var$Li(this.ctx), c = new $e4b487e979d7c06d$var$ji(this.ctx), d = new $e4b487e979d7c06d$var$Vi(this.ctx), u = new $e4b487e979d7c06d$var$Mi(this.ctx), g = d.getMarkerConfig({
                    cssClass: "apexcharts-marker",
                    seriesIndex: o,
                    dataPointIndex: s,
                    radius: "bubble" === n.config.chart.type || n.globals.comboCharts && n.config.series[a] && "bubble" === n.config.series[a].type ? i : null
                }), p = c.fillPath({
                    seriesNumber: a,
                    dataPointIndex: s,
                    color: g.pointFillColor,
                    patternUnits: "objectBoundingBox",
                    value: n.globals.series[a][r]
                }), f = u.drawMarker(t, e, g);
                if (n.config.series[o].data[s] && n.config.series[o].data[s].fillColor && (p = n.config.series[o].data[s].fillColor), f.attr({
                    fill: p
                }), n.config.chart.dropShadow.enabled) {
                    var x = n.config.chart.dropShadow;
                    h.dropShadow(f, x, a);
                }
                if (!this.initialAnim || n.globals.dataChanged || n.globals.resized) n.globals.animationEnded = !0;
                else {
                    var b = n.config.chart.animations.speed;
                    l.animateMarker(f, b, n.globals.easing, function() {
                        window.setTimeout(function() {
                            l.animationCompleted(f);
                        }, 100);
                    });
                }
                return f.attr({
                    rel: s,
                    j: s,
                    index: a,
                    "default-marker-size": g.pSize
                }), h.setSelectionFilter(f, a, s), d.addEvents(f), f.node.classList.add("apexcharts-marker"), f;
            }
        },
        {
            key: "centerTextInBubble",
            value: function(t) {
                var e = this.w;
                return {
                    y: t += parseInt(e.config.dataLabels.style.fontSize, 10) / 4
                };
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$qi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "dataLabelsCorrection",
            value: function(t, e, i, a, s, r, n) {
                var o = this.w, l = !1, h = new $e4b487e979d7c06d$var$Mi(this.ctx).getTextRects(i, n), c = h.width, d = h.height;
                e < 0 && (e = 0), e > o.globals.gridHeight + d && (e = o.globals.gridHeight + d / 2), void 0 === o.globals.dataLabelsRects[a] && (o.globals.dataLabelsRects[a] = []), o.globals.dataLabelsRects[a].push({
                    x: t,
                    y: e,
                    width: c,
                    height: d
                });
                var u = o.globals.dataLabelsRects[a].length - 2, g = void 0 !== o.globals.lastDrawnDataLabelsIndexes[a] ? o.globals.lastDrawnDataLabelsIndexes[a][o.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                if (void 0 !== o.globals.dataLabelsRects[a][u]) {
                    var p = o.globals.dataLabelsRects[a][g];
                    (t > p.x + p.width || e > p.y + p.height || e + d < p.y || t + c < p.x) && (l = !0);
                }
                return (0 === s || r) && (l = !0), {
                    x: t,
                    y: e,
                    textRects: h,
                    drawnextLabel: l
                };
            }
        },
        {
            key: "drawDataLabel",
            value: function(t) {
                var e = this, i = t.type, a = t.pos, s = t.i, r = t.j, n = t.isRangeStart, o = t.strokeWidth, l = void 0 === o ? 2 : o, h = this.w, c = new $e4b487e979d7c06d$var$Mi(this.ctx), d = h.config.dataLabels, u = 0, g = 0, p = r, f = null;
                if (-1 !== h.globals.collapsedSeriesIndices.indexOf(s) || !d.enabled || !Array.isArray(a.x)) return f;
                f = c.group({
                    class: "apexcharts-data-labels"
                });
                for(var x = 0; x < a.x.length; x++)if (u = a.x[x] + d.offsetX, g = a.y[x] + d.offsetY + l, !isNaN(u)) {
                    1 === r && 0 === x && (p = 0), 1 === r && 1 === x && (p = 1);
                    var b = h.globals.series[s][p];
                    "rangeArea" === i && (b = n ? h.globals.seriesRangeStart[s][p] : h.globals.seriesRangeEnd[s][p]);
                    var m = "", v = function(t) {
                        return h.config.dataLabels.formatter(t, {
                            ctx: e.ctx,
                            seriesIndex: s,
                            dataPointIndex: p,
                            w: h
                        });
                    };
                    if ("bubble" === h.config.chart.type) m = v(b = h.globals.seriesZ[s][p]), g = a.y[x], g = new $e4b487e979d7c06d$var$Ui(this.ctx).centerTextInBubble(g, s, p).y;
                    else void 0 !== b && (m = v(b));
                    var y = h.config.dataLabels.textAnchor;
                    h.globals.isSlopeChart && (y = 0 === p ? "end" : p === h.config.series[s].data.length - 1 ? "start" : "middle"), this.plotDataLabelsText({
                        x: u,
                        y: g,
                        text: m,
                        i: s,
                        j: p,
                        parent: f,
                        offsetCorrection: !0,
                        dataLabelsConfig: h.config.dataLabels,
                        textAnchor: y
                    });
                }
                return f;
            }
        },
        {
            key: "plotDataLabelsText",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = t.x, s = t.y, r = t.i, n = t.j, o = t.text, l = t.textAnchor, h = t.fontSize, c = t.parent, d = t.dataLabelsConfig, u = t.color, g = t.alwaysDrawDataLabel, p = t.offsetCorrection, f = t.className, x = null;
                if (Array.isArray(e.config.dataLabels.enabledOnSeries) && e.config.dataLabels.enabledOnSeries.indexOf(r) < 0) return x;
                var b = {
                    x: a,
                    y: s,
                    drawnextLabel: !0,
                    textRects: null
                };
                p && (b = this.dataLabelsCorrection(a, s, o, r, n, g, parseInt(d.style.fontSize, 10))), e.globals.zoomed || (a = b.x, s = b.y), b.textRects && (a < -20 - b.textRects.width || a > e.globals.gridWidth + b.textRects.width + 30) && (o = "");
                var m = e.globals.dataLabels.style.colors[r];
                (("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || e.config.dataLabels.distributed) && (m = e.globals.dataLabels.style.colors[n]), "function" == typeof m && (m = m({
                    series: e.globals.series,
                    seriesIndex: r,
                    dataPointIndex: n,
                    w: e
                })), u && (m = u);
                var v = d.offsetX, y = d.offsetY;
                if ("bar" !== e.config.chart.type && "rangeBar" !== e.config.chart.type || (v = 0, y = 0), e.globals.isSlopeChart && (0 !== n && (v = -2 * d.offsetX + 5), 0 !== n && n !== e.config.series[r].data.length - 1 && (v = 0)), b.drawnextLabel) {
                    if ((x = i.drawText({
                        width: 100,
                        height: parseInt(d.style.fontSize, 10),
                        x: a + v,
                        y: s + y,
                        foreColor: m,
                        textAnchor: l || d.textAnchor,
                        text: o,
                        fontSize: h || d.style.fontSize,
                        fontFamily: d.style.fontFamily,
                        fontWeight: d.style.fontWeight || "normal"
                    })).attr({
                        class: f || "apexcharts-datalabel",
                        cx: a,
                        cy: s
                    }), d.dropShadow.enabled) {
                        var w = d.dropShadow;
                        new $e4b487e979d7c06d$var$Li(this.ctx).dropShadow(x, w);
                    }
                    c.add(x), void 0 === e.globals.lastDrawnDataLabelsIndexes[r] && (e.globals.lastDrawnDataLabelsIndexes[r] = []), e.globals.lastDrawnDataLabelsIndexes[r].push(n);
                }
                return x;
            }
        },
        {
            key: "addBackgroundToDataLabel",
            value: function(t, e) {
                var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, n = e.width, o = e.height, l = new $e4b487e979d7c06d$var$Mi(this.ctx).drawRect(e.x - s, e.y - r / 2, n + 2 * s, o + r, a.borderRadius, "transparent" !== i.config.chart.background && i.config.chart.background ? i.config.chart.background : "#fff", a.opacity, a.borderWidth, a.borderColor);
                a.dropShadow.enabled && new $e4b487e979d7c06d$var$Li(this.ctx).dropShadow(l, a.dropShadow);
                return l;
            }
        },
        {
            key: "dataLabelsBackground",
            value: function() {
                var t = this.w;
                if ("bubble" !== t.config.chart.type) for(var e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < e.length; i++){
                    var a = e[i], s = a.getBBox(), r = null;
                    if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                        a.parentNode.insertBefore(r.node, a);
                        var n = t.config.dataLabels.background.backgroundColor || a.getAttribute("fill");
                        t.config.chart.animations.enabled && !t.globals.resized && !t.globals.dataChanged ? r.animate().attr({
                            fill: n
                        }) : r.attr({
                            fill: n
                        }), a.setAttribute("fill", t.config.dataLabels.background.foreColor);
                    }
                }
            }
        },
        {
            key: "bringForward",
            value: function() {
                for(var t = this.w, e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < e.length; a++)i && i.insertBefore(e[a], i.nextSibling);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Zi = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getAllSeriesEls",
            value: function() {
                return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
            }
        },
        {
            key: "getSeriesByName",
            value: function(t) {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat($e4b487e979d7c06d$var$v.escapeString(t), "']"));
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                var e = this.getSeriesByName(t), i = parseInt(e.getAttribute("data:realIndex"), 10);
                return {
                    isHidden: e.classList.contains("apexcharts-series-collapsed"),
                    realIndex: i
                };
            }
        },
        {
            key: "addCollapsedClassToSeries",
            value: function(t, e) {
                var i = this.w;
                function a(i) {
                    for(var a = 0; a < i.length; a++)i[a].index === e && t.node.classList.add("apexcharts-series-collapsed");
                }
                a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, e.isHidden), e.isHidden;
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !0);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !1);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w, s = $e4b487e979d7c06d$var$v.clone(a.globals.initialSeries);
                a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, t && (e && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
            }
        },
        {
            key: "emptyCollapsedSeries",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)e.globals.collapsedSeriesIndices.indexOf(i) > -1 && (t[i].data = []);
                return t;
            }
        },
        {
            key: "highlightSeries",
            value: function(t) {
                var e = this.w, i = this.getSeriesByName(t), a = parseInt(null == i ? void 0 : i.getAttribute("data:realIndex"), 10), s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis"), r = null, n = null, o = null;
                if (e.globals.axisCharts || "radialBar" === e.config.chart.type) {
                    if (e.globals.axisCharts) {
                        r = e.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(a, "']")), n = e.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(a, "']"));
                        var l = e.globals.seriesYAxisReverseMap[a];
                        o = e.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(l, "']"));
                    } else r = e.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(a + 1, "']"));
                } else r = e.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(a + 1, "'] path"));
                for(var h = 0; h < s.length; h++)s[h].classList.add(this.legendInactiveClass);
                if (r) e.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), null !== n && n.classList.remove(this.legendInactiveClass), null !== o && o.classList.remove(this.legendInactiveClass);
                else for(var c = 0; c < s.length; c++)s[c].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "toggleSeriesOnHover",
            value: function(t, e) {
                var i = this.w;
                e || (e = t.target);
                var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels, .apexcharts-yaxis");
                if ("mousemove" === t.type) {
                    var s = parseInt(e.getAttribute("rel"), 10) - 1;
                    this.highlightSeries(i.globals.seriesNames[s]);
                } else if ("mouseout" === t.type) for(var r = 0; r < a.length; r++)a[r].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "highlightRangeInSeries",
            value: function(t, e) {
                var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(t) {
                    for(var e = 0; e < s.length; e++)s[e].classList[t](i.legendInactiveClass);
                };
                if ("mousemove" === t.type) {
                    var n = parseInt(e.getAttribute("rel"), 10) - 1;
                    r("add");
                    var o = a.config.plotOptions.heatmap.colorScale.ranges;
                    !function(t, e) {
                        for(var a = 0; a < s.length; a++){
                            var r = Number(s[a].getAttribute("val"));
                            r >= t.from && (r < t.to || t.to === e && r === e) && s[a].classList.remove(i.legendInactiveClass);
                        }
                    }(o[n], o.reduce(function(t, e) {
                        return Math.max(t, e.to);
                    }, 0));
                } else "mouseout" === t.type && r("remove");
            }
        },
        {
            key: "getActiveConfigSeriesIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "asc", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], i = this.w, a = 0;
                if (i.config.series.length > 1) {
                    for(var s = i.config.series.map(function(t, a) {
                        return t.data && t.data.length > 0 && -1 === i.globals.collapsedSeriesIndices.indexOf(a) && (!i.globals.comboCharts || 0 === e.length || e.length && e.indexOf(i.config.series[a].type) > -1) ? a : -1;
                    }), r = "asc" === t ? 0 : s.length - 1; "asc" === t ? r < s.length : r >= 0; "asc" === t ? r++ : r--)if (-1 !== s[r]) {
                        a = s[r];
                        break;
                    }
                }
                return a;
            }
        },
        {
            key: "getBarSeriesIndices",
            value: function() {
                return this.w.globals.comboCharts ? this.w.config.series.map(function(t, e) {
                    return "bar" === t.type || "column" === t.type ? e : -1;
                }).filter(function(t) {
                    return -1 !== t;
                }) : this.w.config.series.map(function(t, e) {
                    return e;
                });
            }
        },
        {
            key: "getPreviousPaths",
            value: function() {
                var t = this.w;
                function e(e, i, a) {
                    for(var s = e[i].childNodes, r = {
                        type: a,
                        paths: [],
                        realIndex: e[i].getAttribute("data:realIndex")
                    }, n = 0; n < s.length; n++)if (s[n].hasAttribute("pathTo")) {
                        var o = s[n].getAttribute("pathTo");
                        r.paths.push({
                            d: o
                        });
                    }
                    t.globals.previousPaths.push(r);
                }
                t.globals.previousPaths = [];
                [
                    "line",
                    "area",
                    "bar",
                    "rangebar",
                    "rangeArea",
                    "candlestick",
                    "radar"
                ].forEach(function(i) {
                    for(var a, s = (a = i, t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a, "-series .apexcharts-series"))), r = 0; r < s.length; r++)e(s, r, i);
                });
                var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series"));
                if (i.length > 0) for(var a = function(e) {
                    for(var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(e, "'] rect")), a = [], s = function(t) {
                        var e = function(e) {
                            return i[t].getAttribute(e);
                        }, s = {
                            x: parseFloat(e("x")),
                            y: parseFloat(e("y")),
                            width: parseFloat(e("width")),
                            height: parseFloat(e("height"))
                        };
                        a.push({
                            rect: s,
                            color: i[t].getAttribute("color")
                        });
                    }, r = 0; r < i.length; r++)s(r);
                    t.globals.previousPaths.push(a);
                }, s = 0; s < i.length; s++)a(s);
                t.globals.axisCharts || (t.globals.previousPaths = t.globals.series);
            }
        },
        {
            key: "clearPreviousPaths",
            value: function() {
                var t = this.w;
                t.globals.previousPaths = [], t.globals.allSeriesCollapsed = !1;
            }
        },
        {
            key: "handleNoData",
            value: function() {
                var t = this.w, e = t.config.noData, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = t.globals.svgWidth / 2, s = t.globals.svgHeight / 2, r = "middle";
                if (t.globals.noData = !0, t.globals.animationEnded = !0, "left" === e.align ? (a = 10, r = "start") : "right" === e.align && (a = t.globals.svgWidth - 10, r = "end"), "top" === e.verticalAlign ? s = 50 : "bottom" === e.verticalAlign && (s = t.globals.svgHeight - 50), a += e.offsetX, s = s + parseInt(e.style.fontSize, 10) + 2 + e.offsetY, void 0 !== e.text && "" !== e.text) {
                    var n = i.drawText({
                        x: a,
                        y: s,
                        text: e.text,
                        textAnchor: r,
                        fontSize: e.style.fontSize,
                        fontFamily: e.style.fontFamily,
                        foreColor: e.style.color,
                        opacity: 1,
                        class: "apexcharts-text-nodata"
                    });
                    t.globals.dom.Paper.add(n);
                }
            }
        },
        {
            key: "setNullSeriesToZeroValues",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)if (0 === t[i].length) for(var a = 0; a < t[e.globals.maxValsInArrayIndex].length; a++)t[i].push(0);
                return t;
            }
        },
        {
            key: "hasAllSeriesEqualX",
            value: function() {
                for(var t = !0, e = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                    t = !1;
                    break;
                }
                return e.globals.allSeriesHasEqualX = t, t;
            }
        },
        {
            key: "filteredSeriesX",
            value: function() {
                var t = this.w.globals.seriesX.map(function(t) {
                    return t.length > 0 ? t : [];
                });
                return t;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$$i = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new $e4b487e979d7c06d$var$Pi(this.ctx);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "isMultiFormat",
            value: function() {
                return this.isFormatXY() || this.isFormat2DArray();
            }
        },
        {
            key: "isFormatXY",
            value: function() {
                var t = this.w.config.series.slice(), e = new $e4b487e979d7c06d$var$Zi(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && null !== t[this.activeSeriesIndex].data[0] && void 0 !== t[this.activeSeriesIndex].data[0].x && null !== t[this.activeSeriesIndex].data[0]) return !0;
            }
        },
        {
            key: "isFormat2DArray",
            value: function() {
                var t = this.w.config.series.slice(), e = new $e4b487e979d7c06d$var$Zi(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && void 0 !== t[this.activeSeriesIndex].data[0] && null !== t[this.activeSeriesIndex].data[0] && t[this.activeSeriesIndex].data[0].constructor === Array) return !0;
            }
        },
        {
            key: "handleFormat2DArray",
            value: function(t, e) {
                for(var i = this.w.config, a = this.w.globals, s = "boxPlot" === i.chart.type || "boxPlot" === i.series[e].type, r = 0; r < t[e].data.length; r++)if (void 0 !== t[e].data[r][1] && (Array.isArray(t[e].data[r][1]) && 4 === t[e].data[r][1].length && !s ? this.twoDSeries.push($e4b487e979d7c06d$var$v.parseNumber(t[e].data[r][1][3])) : t[e].data[r].length >= 5 ? this.twoDSeries.push($e4b487e979d7c06d$var$v.parseNumber(t[e].data[r][4])) : this.twoDSeries.push($e4b487e979d7c06d$var$v.parseNumber(t[e].data[r][1])), a.dataFormatXNumeric = !0), "datetime" === i.xaxis.type) {
                    var n = new Date(t[e].data[r][0]);
                    n = new Date(n).getTime(), this.twoDSeriesX.push(n);
                } else this.twoDSeriesX.push(t[e].data[r][0]);
                for(var o = 0; o < t[e].data.length; o++)void 0 !== t[e].data[o][2] && (this.threeDSeries.push(t[e].data[o][2]), a.isDataXYZ = !0);
            }
        },
        {
            key: "handleFormatXY",
            value: function(t, e) {
                var i = this.w.config, a = this.w.globals, s = new $e4b487e979d7c06d$var$zi(this.ctx), r = e;
                a.collapsedSeriesIndices.indexOf(e) > -1 && (r = this.activeSeriesIndex);
                for(var n = 0; n < t[e].data.length; n++)void 0 !== t[e].data[n].y && (Array.isArray(t[e].data[n].y) ? this.twoDSeries.push($e4b487e979d7c06d$var$v.parseNumber(t[e].data[n].y[t[e].data[n].y.length - 1])) : this.twoDSeries.push($e4b487e979d7c06d$var$v.parseNumber(t[e].data[n].y))), void 0 !== t[e].data[n].goals && Array.isArray(t[e].data[n].goals) ? (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(t[e].data[n].goals)) : (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(null));
                for(var o = 0; o < t[r].data.length; o++){
                    var l = "string" == typeof t[r].data[o].x, h = Array.isArray(t[r].data[o].x), c = !h && !!s.isValidDate(t[r].data[o].x);
                    if (l || c) {
                        if (l || i.xaxis.convertedCatToNumeric) {
                            var d = a.isBarHorizontal && a.isRangeData;
                            "datetime" !== i.xaxis.type || d ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[o].x), isNaN(t[r].data[o].x) || "category" === this.w.config.xaxis.type || "string" == typeof t[r].data[o].x || (a.isXNumeric = !0)) : this.twoDSeriesX.push(s.parseDate(t[r].data[o].x));
                        } else "datetime" === i.xaxis.type ? this.twoDSeriesX.push(s.parseDate(t[r].data[o].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(t[r].data[o].x)));
                    } else h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[o].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(t[r].data[o].x));
                }
                if (t[e].data[0] && void 0 !== t[e].data[0].z) {
                    for(var u = 0; u < t[e].data.length; u++)this.threeDSeries.push(t[e].data[u].z);
                    a.isDataXYZ = !0;
                }
            }
        },
        {
            key: "handleRangeData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", t, e)), i.seriesRangeStart[e] = void 0 === a.start ? [] : a.start, i.seriesRangeEnd[e] = void 0 === a.end ? [] : a.end, i.seriesRange[e] = a.rangeUniques, i.seriesRange.forEach(function(t, e) {
                    t && t.forEach(function(t, e) {
                        t.y.forEach(function(e, i) {
                            for(var a = 0; a < t.y.length; a++)if (i !== a) {
                                var s = e.y1, r = e.y2, n = t.y[a].y1;
                                s <= t.y[a].y2 && n <= r && (t.overlaps.indexOf(e.rangeName) < 0 && t.overlaps.push(e.rangeName), t.overlaps.indexOf(t.y[a].rangeName) < 0 && t.overlaps.push(t.y[a].rangeName));
                            }
                        });
                    });
                }), a;
            }
        },
        {
            key: "handleCandleStickBoxData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", t, e)), i.seriesCandleO[e] = a.o, i.seriesCandleH[e] = a.h, i.seriesCandleM[e] = a.m, i.seriesCandleL[e] = a.l, i.seriesCandleC[e] = a.c, a;
            }
        },
        {
            key: "handleRangeDataFormat",
            value: function(t, e, i) {
                var a = [], s = [], r = e[i].data.filter(function(t, e, i) {
                    return e === i.findIndex(function(e) {
                        return e.x === t.x;
                    });
                }).map(function(t, e) {
                    return {
                        x: t.x,
                        overlaps: [],
                        y: []
                    };
                });
                if ("array" === t) for(var n = 0; n < e[i].data.length; n++)Array.isArray(e[i].data[n]) ? (a.push(e[i].data[n][1][0]), s.push(e[i].data[n][1][1])) : (a.push(e[i].data[n]), s.push(e[i].data[n]));
                else if ("xy" === t) for(var o = function(t) {
                    var n = Array.isArray(e[i].data[t].y), o = $e4b487e979d7c06d$var$v.randomId(), l = e[i].data[t].x, h = {
                        y1: n ? e[i].data[t].y[0] : e[i].data[t].y,
                        y2: n ? e[i].data[t].y[1] : e[i].data[t].y,
                        rangeName: o
                    };
                    e[i].data[t].rangeName = o;
                    var c = r.findIndex(function(t) {
                        return t.x === l;
                    });
                    r[c].y.push(h), a.push(h.y1), s.push(h.y2);
                }, l = 0; l < e[i].data.length; l++)o(l);
                return {
                    start: a,
                    end: s,
                    rangeUniques: r
                };
            }
        },
        {
            key: "handleCandleStickBoxDataFormat",
            value: function(t, e, i) {
                var a = this.w, s = "boxPlot" === a.config.chart.type || "boxPlot" === a.config.series[i].type, r = [], n = [], o = [], l = [], h = [];
                if ("array" === t) {
                    if (s && 6 === e[i].data[0].length || !s && 5 === e[i].data[0].length) for(var c = 0; c < e[i].data.length; c++)r.push(e[i].data[c][1]), n.push(e[i].data[c][2]), s ? (o.push(e[i].data[c][3]), l.push(e[i].data[c][4]), h.push(e[i].data[c][5])) : (l.push(e[i].data[c][3]), h.push(e[i].data[c][4]));
                    else for(var d = 0; d < e[i].data.length; d++)Array.isArray(e[i].data[d][1]) && (r.push(e[i].data[d][1][0]), n.push(e[i].data[d][1][1]), s ? (o.push(e[i].data[d][1][2]), l.push(e[i].data[d][1][3]), h.push(e[i].data[d][1][4])) : (l.push(e[i].data[d][1][2]), h.push(e[i].data[d][1][3])));
                } else if ("xy" === t) for(var u = 0; u < e[i].data.length; u++)Array.isArray(e[i].data[u].y) && (r.push(e[i].data[u].y[0]), n.push(e[i].data[u].y[1]), s ? (o.push(e[i].data[u].y[2]), l.push(e[i].data[u].y[3]), h.push(e[i].data[u].y[4])) : (l.push(e[i].data[u].y[2]), h.push(e[i].data[u].y[3])));
                return {
                    o: r,
                    h: n,
                    m: o,
                    l: l,
                    c: h
                };
            }
        },
        {
            key: "parseDataAxisCharts",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.ctx, a = this.w.config, s = this.w.globals, r = new $e4b487e979d7c06d$var$zi(i), n = a.labels.length > 0 ? a.labels.slice() : a.xaxis.categories.slice();
                s.isRangeBar = "rangeBar" === a.chart.type && s.isBarHorizontal, s.hasXaxisGroups = "category" === a.xaxis.type && a.xaxis.group.groups.length > 0, s.hasXaxisGroups && (s.groups = a.xaxis.group.groups), t.forEach(function(t, e) {
                    void 0 !== t.name ? s.seriesNames.push(t.name) : s.seriesNames.push("series-" + parseInt(e + 1, 10));
                }), this.coreUtils.setSeriesYAxisMappings();
                var o = [], l = $e4b487e979d7c06d$var$f(new Set(a.series.map(function(t) {
                    return t.group;
                })));
                a.series.forEach(function(t, e) {
                    var i = l.indexOf(t.group);
                    o[i] || (o[i] = []), o[i].push(s.seriesNames[e]);
                }), s.seriesGroups = o;
                for(var h = function() {
                    for(var t = 0; t < n.length; t++)if ("string" == typeof n[t]) {
                        if (!r.isValidDate(n[t])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                        e.twoDSeriesX.push(r.parseDate(n[t]));
                    } else e.twoDSeriesX.push(n[t]);
                }, c = 0; c < t.length; c++){
                    if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], void 0 === t[c].data) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                    if ("rangeBar" !== a.chart.type && "rangeArea" !== a.chart.type && "rangeBar" !== t[c].type && "rangeArea" !== t[c].type || (s.isRangeData = !0, this.handleRangeData(t, c)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(t, c) : this.isFormatXY() && this.handleFormatXY(t, c), "candlestick" !== a.chart.type && "candlestick" !== t[c].type && "boxPlot" !== a.chart.type && "boxPlot" !== t[c].type || this.handleCandleStickBoxData(t, c), s.series.push(this.twoDSeries), s.labels.push(this.twoDSeriesX), s.seriesX.push(this.twoDSeriesX), s.seriesGoals = this.seriesGoals, c !== this.activeSeriesIndex || this.fallbackToCategory || (s.isXNumeric = !0);
                    else {
                        "datetime" === a.xaxis.type ? (s.isXNumeric = !0, h(), s.seriesX.push(this.twoDSeriesX)) : "numeric" === a.xaxis.type && (s.isXNumeric = !0, n.length > 0 && (this.twoDSeriesX = n, s.seriesX.push(this.twoDSeriesX))), s.labels.push(this.twoDSeriesX);
                        var d = t[c].data.map(function(t) {
                            return $e4b487e979d7c06d$var$v.parseNumber(t);
                        });
                        s.series.push(d);
                    }
                    s.seriesZ.push(this.threeDSeries), void 0 !== t[c].color ? s.seriesColors.push(t[c].color) : s.seriesColors.push(void 0);
                }
                return this.w;
            }
        },
        {
            key: "parseDataNonAxisCharts",
            value: function(t) {
                var e = this.w.globals, i = this.w.config;
                e.series = t.slice(), e.seriesNames = i.labels.slice();
                for(var a = 0; a < e.series.length; a++)void 0 === e.seriesNames[a] && e.seriesNames.push("series-" + (a + 1));
                return this.w;
            }
        },
        {
            key: "handleExternalLabelsData",
            value: function(t) {
                var e = this.w.config, i = this.w.globals;
                if (e.xaxis.categories.length > 0) i.labels = e.xaxis.categories;
                else if (e.labels.length > 0) i.labels = e.labels.slice();
                else if (this.fallbackToCategory) {
                    if (i.labels = i.labels[0], i.seriesRange.length && (i.seriesRange.map(function(t) {
                        t.forEach(function(t) {
                            i.labels.indexOf(t.x) < 0 && t.x && i.labels.push(t.x);
                        });
                    }), i.labels = Array.from(new Set(i.labels.map(JSON.stringify)), JSON.parse)), e.xaxis.convertedCatToNumeric) new $e4b487e979d7c06d$var$Ni(e).convertCatToNumericXaxis(e, this.ctx, i.seriesX[0]), this._generateExternalLabels(t);
                } else this._generateExternalLabels(t);
            }
        },
        {
            key: "_generateExternalLabels",
            value: function(t) {
                var e = this.w.globals, i = this.w.config, a = [];
                if (e.axisCharts) {
                    if (e.series.length > 0) {
                        if (this.isFormatXY()) for(var s = i.series.map(function(t, e) {
                            return t.data.filter(function(t, e, i) {
                                return i.findIndex(function(e) {
                                    return e.x === t.x;
                                }) === e;
                            });
                        }), r = s.reduce(function(t, e, i, a) {
                            return a[t].length > e.length ? t : i;
                        }, 0), n = 0; n < s[r].length; n++)a.push(n + 1);
                        else for(var o = 0; o < e.series[e.maxValsInArrayIndex].length; o++)a.push(o + 1);
                    }
                    e.seriesX = [];
                    for(var l = 0; l < t.length; l++)e.seriesX.push(a);
                    this.w.globals.isBarHorizontal || (e.isXNumeric = !0);
                }
                if (0 === a.length) {
                    a = e.axisCharts ? [] : e.series.map(function(t, e) {
                        return e + 1;
                    });
                    for(var h = 0; h < t.length; h++)e.seriesX.push(a);
                }
                e.labels = a, i.xaxis.convertedCatToNumeric && (e.categoryLabels = a.map(function(t) {
                    return i.xaxis.labels.formatter(t);
                })), e.noLabelsProvided = !0;
            }
        },
        {
            key: "parseData",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? (this.parseDataAxisCharts(t), this.coreUtils.getLargestSeries()) : this.parseDataNonAxisCharts(t), i.chart.stacked) {
                    var s = new $e4b487e979d7c06d$var$Zi(this.ctx);
                    a.series = s.setNullSeriesToZeroValues(a.series);
                }
                this.coreUtils.getSeriesTotals(), a.axisCharts && (a.stackedSeriesTotals = this.coreUtils.getStackedSeriesTotals(), a.stackedSeriesTotalsByGroups = this.coreUtils.getStackedSeriesTotalsByGroups()), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && ("numeric" !== i.xaxis.type || 0 !== i.labels.length || 0 !== i.xaxis.categories.length) || this.handleExternalLabelsData(t);
                for(var r = this.coreUtils.getCategoryLabels(a.labels), n = 0; n < r.length; n++)if (Array.isArray(r[n])) {
                    a.isMultiLineX = !0;
                    break;
                }
            }
        },
        {
            key: "excludeCollapsedSeriesInYAxis",
            value: function() {
                var t = this.w, e = [];
                t.globals.seriesYAxisMap.forEach(function(i, a) {
                    var s = 0;
                    i.forEach(function(e) {
                        -1 !== t.globals.collapsedSeriesIndices.indexOf(e) && s++;
                    }), s > 0 && s == i.length && e.push(a);
                }), t.globals.ignoreYAxisIndexes = e.map(function(t) {
                    return t;
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ji = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "svgStringToNode",
            value: function(t) {
                return (new DOMParser).parseFromString(t, "image/svg+xml").documentElement;
            }
        },
        {
            key: "scaleSvgNode",
            value: function(t, e) {
                var i = parseFloat(t.getAttributeNS(null, "width")), a = parseFloat(t.getAttributeNS(null, "height"));
                t.setAttributeNS(null, "width", i * e), t.setAttributeNS(null, "height", a * e), t.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
            }
        },
        {
            key: "getSvgString",
            value: function(t) {
                var e = this;
                return new Promise(function(i) {
                    var a = e.w, s = t || a.config.chart.toolbar.export.scale || a.config.chart.toolbar.export.width / a.globals.svgWidth;
                    s || (s = 1);
                    var r = a.globals.svgWidth * s, n = a.globals.svgHeight * s, o = a.globals.dom.elWrap.cloneNode(!0);
                    o.style.width = r + "px", o.style.height = n + "px";
                    var l = (new XMLSerializer).serializeToString(o), h = '\n        <svg xmlns="http://www.w3.org/2000/svg"\n          version="1.1"\n          xmlns:xlink="http://www.w3.org/1999/xlink"\n          class="apexcharts-svg"\n          xmlns:data="ApexChartsNS"\n          transform="translate(0, 0)"\n          width="'.concat(a.globals.svgWidth, 'px" height="').concat(a.globals.svgHeight, 'px">\n          <foreignObject width="100%" height="100%">\n            <div xmlns="http://www.w3.org/1999/xhtml" style="width:').concat(r, "px; height:").concat(n, 'px;">\n            <style type="text/css">\n              .apexcharts-tooltip, .apexcharts-toolbar, .apexcharts-xaxistooltip, .apexcharts-yaxistooltip, .apexcharts-xcrosshairs, .apexcharts-ycrosshairs, .apexcharts-zoom-rect, .apexcharts-selection-rect {\n                display: none;\n              }\n            </style>\n              ').concat(l, "\n            </div>\n          </foreignObject>\n        </svg>\n      "), c = e.svgStringToNode(h);
                    1 !== s && e.scaleSvgNode(c, s), e.convertImagesToBase64(c).then(function() {
                        h = (new XMLSerializer).serializeToString(c), i(h.replace(/&nbsp;/g, "&#160;"));
                    });
                });
            }
        },
        {
            key: "convertImagesToBase64",
            value: function(t) {
                var e = this, i = t.getElementsByTagName("image"), a = Array.from(i).map(function(t) {
                    var i = t.getAttributeNS("http://www.w3.org/1999/xlink", "href");
                    return i && !i.startsWith("data:") ? e.getBase64FromUrl(i).then(function(e) {
                        t.setAttributeNS("http://www.w3.org/1999/xlink", "href", e);
                    }).catch(function(t) {
                        console.error("Error converting image to base64:", t);
                    }) : Promise.resolve();
                });
                return Promise.all(a);
            }
        },
        {
            key: "getBase64FromUrl",
            value: function(t) {
                return new Promise(function(e, i) {
                    var a = new Image;
                    a.crossOrigin = "Anonymous", a.onload = function() {
                        var t = document.createElement("canvas");
                        t.width = a.width, t.height = a.height, t.getContext("2d").drawImage(a, 0, 0), e(t.toDataURL());
                    }, a.onerror = i, a.src = t;
                });
            }
        },
        {
            key: "svgUrl",
            value: function() {
                var t = this;
                return new Promise(function(e) {
                    t.getSvgString().then(function(t) {
                        var i = new Blob([
                            t
                        ], {
                            type: "image/svg+xml;charset=utf-8"
                        });
                        e(URL.createObjectURL(i));
                    });
                });
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                var e = this;
                return new Promise(function(i) {
                    var a = e.w, s = t ? t.scale || t.width / a.globals.svgWidth : 1, r = document.createElement("canvas");
                    r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                    var n = "transparent" !== a.config.chart.background && a.config.chart.background ? a.config.chart.background : "#fff", o = r.getContext("2d");
                    o.fillStyle = n, o.fillRect(0, 0, r.width * s, r.height * s), e.getSvgString(s).then(function(t) {
                        var e = "data:image/svg+xml," + encodeURIComponent(t), a = new Image;
                        a.crossOrigin = "anonymous", a.onload = function() {
                            if (o.drawImage(a, 0, 0), r.msToBlob) {
                                var t = r.msToBlob();
                                i({
                                    blob: t
                                });
                            } else {
                                var e = r.toDataURL("image/png");
                                i({
                                    imgURI: e
                                });
                            }
                        }, a.src = e;
                    });
                });
            }
        },
        {
            key: "exportToSVG",
            value: function() {
                var t = this;
                this.svgUrl().then(function(e) {
                    t.triggerDownload(e, t.w.config.chart.toolbar.export.svg.filename, ".svg");
                });
            }
        },
        {
            key: "exportToPng",
            value: function() {
                var t = this, e = this.w.config.chart.toolbar.export.scale, i = this.w.config.chart.toolbar.export.width, a = e ? {
                    scale: e
                } : i ? {
                    width: i
                } : void 0;
                this.dataURI(a).then(function(e) {
                    var i = e.imgURI, a = e.blob;
                    a ? navigator.msSaveOrOpenBlob(a, t.w.globals.chartID + ".png") : t.triggerDownload(i, t.w.config.chart.toolbar.export.png.filename, ".png");
                });
            }
        },
        {
            key: "exportToCSV",
            value: function(t) {
                var e = this, i = t.series, a = t.fileName, s = t.columnDelimiter, r = void 0 === s ? "," : s, n = t.lineDelimiter, o = void 0 === n ? "\n" : n, l = this.w;
                i || (i = l.config.series);
                var h = [], c = [], d = "", u = l.globals.series.map(function(t, e) {
                    return -1 === l.globals.collapsedSeriesIndices.indexOf(e) ? t : [];
                }), g = function(t) {
                    return "function" == typeof l.config.chart.toolbar.export.csv.categoryFormatter ? l.config.chart.toolbar.export.csv.categoryFormatter(t) : "datetime" === l.config.xaxis.type && String(t).length >= 10 ? new Date(t).toDateString() : $e4b487e979d7c06d$var$v.isNumber(t) ? t : t.split(r).join("");
                }, p = function(t) {
                    return "function" == typeof l.config.chart.toolbar.export.csv.valueFormatter ? l.config.chart.toolbar.export.csv.valueFormatter(t) : t;
                }, x = Math.max.apply(Math, $e4b487e979d7c06d$var$f(i.map(function(t) {
                    return t.data ? t.data.length : 0;
                }))), b = new $e4b487e979d7c06d$var$$i(this.ctx), m = new $e4b487e979d7c06d$var$Ri(this.ctx), y = function(t) {
                    var i = "";
                    if (l.globals.axisCharts) {
                        if ("category" === l.config.xaxis.type || l.config.xaxis.convertedCatToNumeric) {
                            if (l.globals.isBarHorizontal) {
                                var a = l.globals.yLabelFormatters[0], s = new $e4b487e979d7c06d$var$Zi(e.ctx).getActiveConfigSeriesIndex();
                                i = a(l.globals.labels[t], {
                                    seriesIndex: s,
                                    dataPointIndex: t,
                                    w: l
                                });
                            } else i = m.getLabel(l.globals.labels, l.globals.timescaleLabels, 0, t).text;
                        }
                        "datetime" === l.config.xaxis.type && (l.config.xaxis.categories.length ? i = l.config.xaxis.categories[t] : l.config.labels.length && (i = l.config.labels[t]));
                    } else i = l.config.labels[t];
                    return null === i ? "nullvalue" : (Array.isArray(i) && (i = i.join(" ")), $e4b487e979d7c06d$var$v.isNumber(i) ? i : i.split(r).join(""));
                }, w = function(t, e) {
                    if (h.length && 0 === e && c.push(h.join(r)), t.data) {
                        t.data = t.data.length && t.data || $e4b487e979d7c06d$var$f(Array(x)).map(function() {
                            return "";
                        });
                        for(var a = 0; a < t.data.length; a++){
                            h = [];
                            var s = y(a);
                            if ("nullvalue" !== s) {
                                if (s || (b.isFormatXY() ? s = i[e].data[a].x : b.isFormat2DArray() && (s = i[e].data[a] ? i[e].data[a][0] : "")), 0 === e) {
                                    h.push(g(s));
                                    for(var n = 0; n < l.globals.series.length; n++){
                                        var o, d = b.isFormatXY() ? null === (o = i[n].data[a]) || void 0 === o ? void 0 : o.y : u[n][a];
                                        h.push(p(d));
                                    }
                                }
                                ("candlestick" === l.config.chart.type || t.type && "candlestick" === t.type) && (h.pop(), h.push(l.globals.seriesCandleO[e][a]), h.push(l.globals.seriesCandleH[e][a]), h.push(l.globals.seriesCandleL[e][a]), h.push(l.globals.seriesCandleC[e][a])), ("boxPlot" === l.config.chart.type || t.type && "boxPlot" === t.type) && (h.pop(), h.push(l.globals.seriesCandleO[e][a]), h.push(l.globals.seriesCandleH[e][a]), h.push(l.globals.seriesCandleM[e][a]), h.push(l.globals.seriesCandleL[e][a]), h.push(l.globals.seriesCandleC[e][a])), "rangeBar" === l.config.chart.type && (h.pop(), h.push(l.globals.seriesRangeStart[e][a]), h.push(l.globals.seriesRangeEnd[e][a])), h.length && c.push(h.join(r));
                            }
                        }
                    }
                };
                h.push(l.config.chart.toolbar.export.csv.headerCategory), "boxPlot" === l.config.chart.type ? (h.push("minimum"), h.push("q1"), h.push("median"), h.push("q3"), h.push("maximum")) : "candlestick" === l.config.chart.type ? (h.push("open"), h.push("high"), h.push("low"), h.push("close")) : "rangeBar" === l.config.chart.type ? (h.push("minimum"), h.push("maximum")) : i.map(function(t, e) {
                    var i = (t.name ? t.name : "series-".concat(e)) + "";
                    l.globals.axisCharts && h.push(i.split(r).join("") ? i.split(r).join("") : "series-".concat(e));
                }), l.globals.axisCharts || (h.push(l.config.chart.toolbar.export.csv.headerValue), c.push(h.join(r))), l.globals.allSeriesHasEqualX || !l.globals.axisCharts || l.config.xaxis.categories.length || l.config.labels.length ? i.map(function(t, e) {
                    l.globals.axisCharts ? w(t, e) : ((h = []).push(g(l.globals.labels[e])), h.push(p(u[e])), c.push(h.join(r)));
                }) : function() {
                    var t = new Set, e = {};
                    i.forEach(function(a, s) {
                        null == a || a.data.forEach(function(a) {
                            var r, n;
                            if (b.isFormatXY()) r = a.x, n = a.y;
                            else {
                                if (!b.isFormat2DArray()) return;
                                r = a[0], n = a[1];
                            }
                            e[r] || (e[r] = Array(i.length).fill("")), e[r][s] = p(n), t.add(r);
                        });
                    }), h.length && c.push(h.join(r)), Array.from(t).sort().forEach(function(t) {
                        c.push([
                            g(t),
                            e[t].join(r)
                        ]);
                    });
                }(), d += c.join(o), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\ufeff" + d), a || l.config.chart.toolbar.export.csv.filename, ".csv");
            }
        },
        {
            key: "triggerDownload",
            value: function(t, e, i) {
                var a = document.createElement("a");
                a.href = t, a.download = (e || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Qi = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.elgrid = a, this.w = e.w;
        var s = this.w;
        this.axesUtils = new $e4b487e979d7c06d$var$Ri(e), this.xaxisLabels = s.globals.labels.slice(), s.globals.timescaleLabels.length > 0 && !s.globals.isBarHorizontal && (this.xaxisLabels = s.globals.timescaleLabels.slice()), s.config.xaxis.overwriteCategories && (this.xaxisLabels = s.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], "top" === s.config.xaxis.position ? this.offY = 0 : this.offY = s.globals.gridHeight, this.offY = this.offY + s.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.xaxisBorderWidth = s.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = s.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = s.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = s.config.xaxis.axisBorder.height, this.yaxis = s.config.yaxis[0];
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawXaxis",
            value: function() {
                var t = this.w, e = new $e4b487e979d7c06d$var$Mi(this.ctx), i = e.group({
                    class: "apexcharts-xaxis",
                    transform: "translate(".concat(t.config.xaxis.offsetX, ", ").concat(t.config.xaxis.offsetY, ")")
                }), a = e.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(t.globals.translateXAxisX, ", ").concat(t.globals.translateXAxisY, ")")
                });
                i.add(a);
                for(var s = [], r = 0; r < this.xaxisLabels.length; r++)s.push(this.xaxisLabels[r]);
                if (this.drawXAxisLabelAndGroup(!0, e, a, s, t.globals.isXNumeric, function(t, e) {
                    return e;
                }), t.globals.hasXaxisGroups) {
                    var n = t.globals.groups;
                    s = [];
                    for(var o = 0; o < n.length; o++)s.push(n[o].title);
                    var l = {};
                    t.config.xaxis.group.style && (l.xaxisFontSize = t.config.xaxis.group.style.fontSize, l.xaxisFontFamily = t.config.xaxis.group.style.fontFamily, l.xaxisForeColors = t.config.xaxis.group.style.colors, l.fontWeight = t.config.xaxis.group.style.fontWeight, l.cssClass = t.config.xaxis.group.style.cssClass), this.drawXAxisLabelAndGroup(!1, e, a, s, !1, function(t, e) {
                        return n[t].cols * e;
                    }, l);
                }
                if (void 0 !== t.config.xaxis.title.text) {
                    var h = e.group({
                        class: "apexcharts-xaxis-title"
                    }), c = e.drawText({
                        x: t.globals.gridWidth / 2 + t.config.xaxis.title.offsetX,
                        y: this.offY + parseFloat(this.xaxisFontSize) + ("bottom" === t.config.xaxis.position ? t.globals.xAxisLabelsHeight : -t.globals.xAxisLabelsHeight - 10) + t.config.xaxis.title.offsetY,
                        text: t.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: t.config.xaxis.title.style.fontSize,
                        fontFamily: t.config.xaxis.title.style.fontFamily,
                        fontWeight: t.config.xaxis.title.style.fontWeight,
                        foreColor: t.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + t.config.xaxis.title.style.cssClass
                    });
                    h.add(c), i.add(h);
                }
                if (t.config.xaxis.axisBorder.show) {
                    var d = t.globals.barPadForNumericAxis, u = e.drawLine(t.globals.padHorizontal + t.config.xaxis.axisBorder.offsetX - d, this.offY, this.xaxisBorderWidth + d, this.offY, t.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                    this.elgrid && this.elgrid.elGridBorders && t.config.grid.show ? this.elgrid.elGridBorders.add(u) : i.add(u);
                }
                return i;
            }
        },
        {
            key: "drawXAxisLabelAndGroup",
            value: function(t, e, i, a, s, r) {
                var n, o = this, l = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : {}, h = [], c = [], d = this.w, u = l.xaxisFontSize || this.xaxisFontSize, g = l.xaxisFontFamily || this.xaxisFontFamily, p = l.xaxisForeColors || this.xaxisForeColors, f = l.fontWeight || d.config.xaxis.labels.style.fontWeight, x = l.cssClass || d.config.xaxis.labels.style.cssClass, b = d.globals.padHorizontal, m = a.length, v = "category" === d.config.xaxis.type ? d.globals.dataPoints : m;
                if (0 === v && m > v && (v = m), s) {
                    var y = Math.max(Number(d.config.xaxis.tickAmount) || 1, v > 1 ? v - 1 : v);
                    n = d.globals.gridWidth / Math.min(y, m - 1), b = b + r(0, n) / 2 + d.config.xaxis.labels.offsetX;
                } else n = d.globals.gridWidth / v, b = b + r(0, n) + d.config.xaxis.labels.offsetX;
                for(var w = function(s) {
                    var l = b - r(s, n) / 2 + d.config.xaxis.labels.offsetX;
                    0 === s && 1 === m && n / 2 === b && 1 === v && (l = d.globals.gridWidth / 2);
                    var y = o.axesUtils.getLabel(a, d.globals.timescaleLabels, l, s, h, u, t), w = 28;
                    d.globals.rotateXLabels && t && (w = 22), d.config.xaxis.title.text && "top" === d.config.xaxis.position && (w += parseFloat(d.config.xaxis.title.style.fontSize) + 2), t || (w = w + parseFloat(u) + (d.globals.xAxisLabelsHeight - d.globals.xAxisGroupLabelsHeight) + (d.globals.rotateXLabels ? 10 : 0)), y = void 0 !== d.config.xaxis.tickAmount && "dataPoints" !== d.config.xaxis.tickAmount && "datetime" !== d.config.xaxis.type ? o.axesUtils.checkLabelBasedOnTickamount(s, y, m) : o.axesUtils.checkForOverflowingLabels(s, y, m, h, c);
                    if (d.config.xaxis.labels.show) {
                        var k = e.drawText({
                            x: y.x,
                            y: o.offY + d.config.xaxis.labels.offsetY + w - ("top" === d.config.xaxis.position ? d.globals.xAxisHeight + d.config.xaxis.axisTicks.height - 2 : 0),
                            text: y.text,
                            textAnchor: "middle",
                            fontWeight: y.isBold ? 600 : f,
                            fontSize: u,
                            fontFamily: g,
                            foreColor: Array.isArray(p) ? t && d.config.xaxis.convertedCatToNumeric ? p[d.globals.minX + s - 1] : p[s] : p,
                            isPlainText: !1,
                            cssClass: (t ? "apexcharts-xaxis-label " : "apexcharts-xaxis-group-label ") + x
                        });
                        if (i.add(k), k.on("click", function(t) {
                            if ("function" == typeof d.config.chart.events.xAxisLabelClick) {
                                var e = Object.assign({}, d, {
                                    labelIndex: s
                                });
                                d.config.chart.events.xAxisLabelClick(t, o.ctx, e);
                            }
                        }), t) {
                            var A = document.createElementNS(d.globals.SVGNS, "title");
                            A.textContent = Array.isArray(y.text) ? y.text.join(" ") : y.text, k.node.appendChild(A), "" !== y.text && (h.push(y.text), c.push(y));
                        }
                    }
                    s < m - 1 && (b += r(s + 1, n));
                }, k = 0; k <= m - 1; k++)w(k);
            }
        },
        {
            key: "drawXaxisInversed",
            value: function(t) {
                var e, i, a = this, s = this.w, r = new $e4b487e979d7c06d$var$Mi(this.ctx), n = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[t] : 0, o = r.group({
                    class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                    rel: t
                }), l = r.group({
                    class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                    transform: "translate(" + n + ", 0)"
                });
                o.add(l);
                var h = [];
                if (s.config.yaxis[t].show) for(var c = 0; c < this.xaxisLabels.length; c++)h.push(this.xaxisLabels[c]);
                e = s.globals.gridHeight / h.length, i = -e / 2.2;
                var d = s.globals.yLabelFormatters[0], u = s.config.yaxis[0].labels;
                if (u.show) for(var g = function(n) {
                    var o = void 0 === h[n] ? "" : h[n];
                    o = d(o, {
                        seriesIndex: t,
                        dataPointIndex: n,
                        w: s
                    });
                    var c = a.axesUtils.getYAxisForeColor(u.style.colors, t), g = 0;
                    Array.isArray(o) && (g = o.length / 2 * parseInt(u.style.fontSize, 10));
                    var p = u.offsetX - 15, f = "end";
                    a.yaxis.opposite && (f = "start"), "left" === s.config.yaxis[0].labels.align ? (p = u.offsetX, f = "start") : "center" === s.config.yaxis[0].labels.align ? (p = u.offsetX, f = "middle") : "right" === s.config.yaxis[0].labels.align && (f = "end");
                    var x = r.drawText({
                        x: p,
                        y: i + e + u.offsetY - g,
                        text: o,
                        textAnchor: f,
                        foreColor: Array.isArray(c) ? c[n] : c,
                        fontSize: u.style.fontSize,
                        fontFamily: u.style.fontFamily,
                        fontWeight: u.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + u.style.cssClass,
                        maxWidth: u.maxWidth
                    });
                    l.add(x), x.on("click", function(t) {
                        if ("function" == typeof s.config.chart.events.xAxisLabelClick) {
                            var e = Object.assign({}, s, {
                                labelIndex: n
                            });
                            s.config.chart.events.xAxisLabelClick(t, a.ctx, e);
                        }
                    });
                    var b = document.createElementNS(s.globals.SVGNS, "title");
                    if (b.textContent = Array.isArray(o) ? o.join(" ") : o, x.node.appendChild(b), 0 !== s.config.yaxis[t].labels.rotate) {
                        var m = r.rotateAroundCenter(x.node);
                        x.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[t].labels.rotate, " 0 ").concat(m.y, ")"));
                    }
                    i += e;
                }, p = 0; p <= h.length - 1; p++)g(p);
                if (void 0 !== s.config.yaxis[0].title.text) {
                    var f = r.group({
                        class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                        transform: "translate(" + n + ", 0)"
                    }), x = r.drawText({
                        x: s.config.yaxis[0].title.offsetX,
                        y: s.globals.gridHeight / 2 + s.config.yaxis[0].title.offsetY,
                        text: s.config.yaxis[0].title.text,
                        textAnchor: "middle",
                        foreColor: s.config.yaxis[0].title.style.color,
                        fontSize: s.config.yaxis[0].title.style.fontSize,
                        fontWeight: s.config.yaxis[0].title.style.fontWeight,
                        fontFamily: s.config.yaxis[0].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                    });
                    f.add(x), o.add(f);
                }
                var b = 0;
                this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (b = s.globals.gridWidth);
                var m = s.config.xaxis.axisBorder;
                if (m.show) {
                    var v = r.drawLine(s.globals.padHorizontal + m.offsetX + b, 1 + m.offsetY, s.globals.padHorizontal + m.offsetX + b, s.globals.gridHeight + m.offsetY, m.color, 0);
                    this.elgrid && this.elgrid.elGridBorders && s.config.grid.show ? this.elgrid.elGridBorders.add(v) : o.add(v);
                }
                return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(b, h.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, e, o), o;
            }
        },
        {
            key: "drawXaxisTicks",
            value: function(t, e, i) {
                var a = this.w, s = t;
                if (!(t < 0 || t - 2 > a.globals.gridWidth)) {
                    var r = this.offY + a.config.xaxis.axisTicks.offsetY;
                    if (e = e + r + a.config.xaxis.axisTicks.height, "top" === a.config.xaxis.position && (e = r - a.config.xaxis.axisTicks.height), a.config.xaxis.axisTicks.show) {
                        var n = new $e4b487e979d7c06d$var$Mi(this.ctx).drawLine(t + a.config.xaxis.axisTicks.offsetX, r + a.config.xaxis.offsetY, s + a.config.xaxis.axisTicks.offsetX, e + a.config.xaxis.offsetY, a.config.xaxis.axisTicks.color);
                        i.add(n), n.node.classList.add("apexcharts-xaxis-tick");
                    }
                }
            }
        },
        {
            key: "getXAxisTicksPositions",
            value: function() {
                var t = this.w, e = [], i = this.xaxisLabels.length, a = t.globals.padHorizontal;
                if (t.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, e.push(a);
                else for(var r = i, n = 0; n < r; n++){
                    var o = r;
                    t.globals.isXNumeric && "bar" !== t.config.chart.type && (o -= 1), a += t.globals.gridWidth / o, e.push(a);
                }
                return e;
            }
        },
        {
            key: "xAxisLabelCorrections",
            value: function() {
                var t = this.w, e = new $e4b487e979d7c06d$var$Mi(this.ctx), i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text:not(.apexcharts-xaxis-group-label)"), s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                if (t.globals.rotateXLabels || t.config.xaxis.labels.rotateAlways) for(var n = 0; n < a.length; n++){
                    var o = e.rotateAroundCenter(a[n]);
                    o.y = o.y - 1, o.x = o.x + 1, a[n].setAttribute("transform", "rotate(".concat(t.config.xaxis.labels.rotate, " ").concat(o.x, " ").concat(o.y, ")")), a[n].setAttribute("text-anchor", "end");
                    i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                    var l = a[n].childNodes;
                    t.config.xaxis.labels.trim && Array.prototype.forEach.call(l, function(i) {
                        e.placeTextWithEllipsis(i, i.textContent, t.globals.xAxisLabelsHeight - ("bottom" === t.config.legend.position ? 20 : 10));
                    });
                }
                else !function() {
                    for(var i = t.globals.gridWidth / (t.globals.labels.length + 1), s = 0; s < a.length; s++){
                        var r = a[s].childNodes;
                        t.config.xaxis.labels.trim && "datetime" !== t.config.xaxis.type && Array.prototype.forEach.call(r, function(t) {
                            e.placeTextWithEllipsis(t, t.textContent, i);
                        });
                    }
                }();
                if (s.length > 0) {
                    var h = s[s.length - 1].getBBox(), c = s[0].getBBox();
                    h.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), c.x + c.width > t.globals.gridWidth && !t.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                    for(var d = 0; d < r.length; d++)e.placeTextWithEllipsis(r[d], r[d].textContent, t.config.yaxis[0].labels.maxWidth - (t.config.yaxis[0].title.text ? 2 * parseFloat(t.config.yaxis[0].title.style.fontSize) : 0) - 15);
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ki = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.xaxisLabels = a.globals.labels.slice(), this.axesUtils = new $e4b487e979d7c06d$var$Ri(e), this.isRangeBar = a.globals.seriesRange.length && a.globals.isBarHorizontal, a.globals.timescaleLabels.length > 0 && (this.xaxisLabels = a.globals.timescaleLabels.slice());
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawGridArea",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx);
                t || (t = i.group({
                    class: "apexcharts-grid"
                }));
                var a = i.drawLine(e.globals.padHorizontal, 1, e.globals.padHorizontal, e.globals.gridHeight, "transparent"), s = i.drawLine(e.globals.padHorizontal, e.globals.gridHeight, e.globals.gridWidth, e.globals.gridHeight, "transparent");
                return t.add(s), t.add(a), t;
            }
        },
        {
            key: "drawGrid",
            value: function() {
                if (this.w.globals.axisCharts) {
                    var t = this.renderGrid();
                    return this.drawGridArea(t.el), t;
                }
                return null;
            }
        },
        {
            key: "createGridMask",
            value: function() {
                var t = this.w, e = t.globals, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = Array.isArray(t.config.stroke.width) ? Math.max.apply(Math, $e4b487e979d7c06d$var$f(t.config.stroke.width)) : t.config.stroke.width, s = function(t) {
                    var i = document.createElementNS(e.SVGNS, "clipPath");
                    return i.setAttribute("id", t), i;
                };
                e.dom.elGridRectMask = s("gridRectMask".concat(e.cuid)), e.dom.elGridRectBarMask = s("gridRectBarMask".concat(e.cuid)), e.dom.elGridRectMarkerMask = s("gridRectMarkerMask".concat(e.cuid)), e.dom.elForecastMask = s("forecastMask".concat(e.cuid)), e.dom.elNonForecastMask = s("nonForecastMask".concat(e.cuid));
                var r = 0, n = 0;
                ([
                    "bar",
                    "rangeBar",
                    "candlestick",
                    "boxPlot"
                ].includes(t.config.chart.type) || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && (r = Math.max(t.config.grid.padding.left, e.barPadForNumericAxis), n = Math.max(t.config.grid.padding.right, e.barPadForNumericAxis)), e.dom.elGridRect = i.drawRect(-a / 2 - 2, -a / 2 - 2, e.gridWidth + a + 4, e.gridHeight + a + 4, 0, "#fff"), e.dom.elGridRectBar = i.drawRect(-a / 2 - r - 2, -a / 2 - 2, e.gridWidth + a + n + r + 4, e.gridHeight + a + 4, 0, "#fff");
                var o = t.globals.markers.largestSize;
                e.dom.elGridRectMarker = i.drawRect(-o, -o, e.gridWidth + 2 * o, e.gridHeight + 2 * o, 0, "#fff"), e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node), e.dom.elGridRectBarMask.appendChild(e.dom.elGridRectBar.node), e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);
                var l = e.dom.baseEl.querySelector("defs");
                l.appendChild(e.dom.elGridRectMask), l.appendChild(e.dom.elGridRectBarMask), l.appendChild(e.dom.elGridRectMarkerMask), l.appendChild(e.dom.elForecastMask), l.appendChild(e.dom.elNonForecastMask);
            }
        },
        {
            key: "_drawGridLines",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, n = t.xCount, o = t.parent, l = this.w;
                if (!(0 === e && l.globals.skipFirstTimelinelabel || e === n - 1 && l.globals.skipLastTimelinelabel && !l.config.xaxis.labels.formatter || "radar" === l.config.chart.type)) {
                    l.config.grid.xaxis.lines.show && this._drawGridLine({
                        i: e,
                        x1: i,
                        y1: a,
                        x2: s,
                        y2: r,
                        xCount: n,
                        parent: o
                    });
                    var h = 0;
                    if (l.globals.hasXaxisGroups && "between" === l.config.xaxis.tickPlacement) {
                        var c = l.globals.groups;
                        if (c) {
                            for(var d = 0, u = 0; d < e && u < c.length; u++)d += c[u].cols;
                            d === e && (h = .6 * l.globals.xAxisLabelsHeight);
                        }
                    }
                    new $e4b487e979d7c06d$var$Qi(this.ctx).drawXaxisTicks(i, h, l.globals.dom.elGraphical);
                }
            }
        },
        {
            key: "_drawGridLine",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, n = t.xCount, o = t.parent, l = this.w, h = o.node.classList.contains("apexcharts-gridlines-horizontal"), c = l.globals.barPadForNumericAxis, d = 0 === a && 0 === r || 0 === i && 0 === s || a === l.globals.gridHeight && r === l.globals.gridHeight || l.globals.isBarHorizontal && (0 === e || e === n - 1), u = new $e4b487e979d7c06d$var$Mi(this).drawLine(i - (h ? c : 0), a, s + (h ? c : 0), r, l.config.grid.borderColor, l.config.grid.strokeDashArray);
                u.node.classList.add("apexcharts-gridline"), d && l.config.grid.show ? this.elGridBorders.add(u) : o.add(u);
            }
        },
        {
            key: "_drawGridBandRect",
            value: function(t) {
                var e = t.c, i = t.x1, a = t.y1, s = t.x2, r = t.y2, n = t.type, o = this.w, l = new $e4b487e979d7c06d$var$Mi(this.ctx), h = o.globals.barPadForNumericAxis, c = o.config.grid[n].colors[e], d = l.drawRect(i - ("row" === n ? h : 0), a, s + ("row" === n ? 2 * h : 0), r, 0, c, o.config.grid[n].opacity);
                this.elg.add(d), d.attr("clip-path", "url(#gridRectMask".concat(o.globals.cuid, ")")), d.node.classList.add("apexcharts-grid-".concat(n));
            }
        },
        {
            key: "_drawXYLines",
            value: function(t) {
                var e = this, i = t.xCount, a = t.tickAmount, s = this.w;
                if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                    var r, n = s.globals.padHorizontal, o = s.globals.gridHeight;
                    s.globals.timescaleLabels.length ? function(t) {
                        for(var a = t.xC, s = t.x1, r = t.y1, n = t.x2, o = t.y2, l = 0; l < a; l++)s = e.xaxisLabels[l].position, n = e.xaxisLabels[l].position, e._drawGridLines({
                            i: l,
                            x1: s,
                            y1: r,
                            x2: n,
                            y2: o,
                            xCount: i,
                            parent: e.elgridLinesV
                        });
                    }({
                        xC: i,
                        x1: n,
                        y1: 0,
                        x2: r,
                        y2: o
                    }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), function(t) {
                        for(var a = t.xC, r = t.x1, n = t.y1, o = t.x2, l = t.y2, h = 0; h < a + (s.globals.isXNumeric ? 0 : 1); h++)0 === h && 1 === a && 1 === s.globals.dataPoints && (o = r = s.globals.gridWidth / 2), e._drawGridLines({
                            i: h,
                            x1: r,
                            y1: n,
                            x2: o,
                            y2: l,
                            xCount: i,
                            parent: e.elgridLinesV
                        }), o = r += s.globals.gridWidth / (s.globals.isXNumeric ? a - 1 : a);
                    }({
                        xC: i,
                        x1: n,
                        y1: 0,
                        x2: r,
                        y2: o
                    }));
                }
                if (s.config.grid.yaxis.lines.show) {
                    var l = 0, h = 0, c = s.globals.gridWidth, d = a + 1;
                    this.isRangeBar && (d = s.globals.labels.length);
                    for(var u = 0; u < d + (this.isRangeBar ? 1 : 0); u++)this._drawGridLine({
                        i: u,
                        xCount: d + (this.isRangeBar ? 1 : 0),
                        x1: 0,
                        y1: l,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = l += s.globals.gridHeight / (this.isRangeBar ? d : a);
                }
            }
        },
        {
            key: "_drawInvertedXYLines",
            value: function(t) {
                var e = t.xCount, i = this.w;
                if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, n = 0; n < e + 1; n++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                    i: n,
                    xCount: e + 1,
                    x1: s,
                    y1: 0,
                    x2: a,
                    y2: r,
                    parent: this.elgridLinesV
                }), new $e4b487e979d7c06d$var$Qi(this.ctx).drawXaxisTicks(s, 0, i.globals.dom.elGraphical), a = s += i.globals.gridWidth / e;
                if (i.config.grid.yaxis.lines.show) for(var o = 0, l = 0, h = i.globals.gridWidth, c = 0; c < i.globals.dataPoints + 1; c++)this._drawGridLine({
                    i: c,
                    xCount: i.globals.dataPoints + 1,
                    x1: 0,
                    y1: o,
                    x2: h,
                    y2: l,
                    parent: this.elgridLinesH
                }), l = o += i.globals.gridHeight / i.globals.dataPoints;
            }
        },
        {
            key: "renderGrid",
            value: function() {
                var t = this.w, e = t.globals, i = new $e4b487e979d7c06d$var$Mi(this.ctx);
                this.elg = i.group({
                    class: "apexcharts-grid"
                }), this.elgridLinesH = i.group({
                    class: "apexcharts-gridlines-horizontal"
                }), this.elgridLinesV = i.group({
                    class: "apexcharts-gridlines-vertical"
                }), this.elGridBorders = i.group({
                    class: "apexcharts-grid-borders"
                }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), t.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide(), this.elGridBorders.hide());
                for(var a = 0; a < e.seriesYAxisMap.length && e.ignoreYAxisIndexes.includes(a);)a++;
                a === e.seriesYAxisMap.length && (a = 0);
                var s, r = e.yAxisScale[a].result.length - 1;
                if (!e.isBarHorizontal || this.isRangeBar) {
                    var n, o, l;
                    if (s = this.xaxisLabels.length, this.isRangeBar) r = e.labels.length, t.config.xaxis.tickAmount && t.config.xaxis.labels.formatter && (s = t.config.xaxis.tickAmount), (null === (n = e.yAxisScale) || void 0 === n || null === (o = n[a]) || void 0 === o || null === (l = o.result) || void 0 === l ? void 0 : l.length) > 0 && "datetime" !== t.config.xaxis.type && (s = e.yAxisScale[a].result.length - 1);
                    this._drawXYLines({
                        xCount: s,
                        tickAmount: r
                    });
                } else s = r, r = e.xTickAmount, this._drawInvertedXYLines({
                    xCount: s,
                    tickAmount: r
                });
                return this.drawGridBands(s, r), {
                    el: this.elg,
                    elGridBorders: this.elGridBorders,
                    xAxisTickWidth: e.gridWidth / s
                };
            }
        },
        {
            key: "drawGridBands",
            value: function(t, e) {
                var i, a, s = this, r = this.w;
                if ((null === (i = r.config.grid.row.colors) || void 0 === i ? void 0 : i.length) > 0 && function(t, i, a, n, o, l) {
                    for(var h = 0, c = 0; h < i; h++, c++)c >= r.config.grid[t].colors.length && (c = 0), s._drawGridBandRect({
                        c: c,
                        x1: a,
                        y1: n,
                        x2: o,
                        y2: l,
                        type: t
                    }), n += r.globals.gridHeight / e;
                }("row", e, 0, 0, r.globals.gridWidth, r.globals.gridHeight / e), (null === (a = r.config.grid.column.colors) || void 0 === a ? void 0 : a.length) > 0) {
                    var n = r.globals.isBarHorizontal || "on" !== r.config.xaxis.tickPlacement || "category" !== r.config.xaxis.type && !r.config.xaxis.convertedCatToNumeric ? t : t - 1;
                    r.globals.isXNumeric && (n = r.globals.xAxisScale.result.length - 1);
                    for(var o = r.globals.padHorizontal, l = r.globals.padHorizontal + r.globals.gridWidth / n, h = r.globals.gridHeight, c = 0, d = 0; c < t; c++, d++){
                        var u;
                        if (d >= r.config.grid.column.colors.length && (d = 0), "datetime" === r.config.xaxis.type) o = this.xaxisLabels[c].position, l = ((null === (u = this.xaxisLabels[c + 1]) || void 0 === u ? void 0 : u.position) || r.globals.gridWidth) - this.xaxisLabels[c].position;
                        this._drawGridBandRect({
                            c: d,
                            x1: o,
                            y1: 0,
                            x2: l,
                            y2: h,
                            type: "column"
                        }), o += r.globals.gridWidth / n;
                    }
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ta = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.coreUtils = new $e4b487e979d7c06d$var$Pi(this.ctx);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "niceScale",
            value: function(t, e) {
                var i, a, s, r, n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, o = 1e-11, l = this.w, h = l.globals;
                h.isBarHorizontal ? (i = l.config.xaxis, a = Math.max((h.svgWidth - 100) / 25, 2)) : (i = l.config.yaxis[n], a = Math.max((h.svgHeight - 100) / 15, 2)), $e4b487e979d7c06d$var$v.isNumber(a) || (a = 10), s = void 0 !== i.min && null !== i.min, r = void 0 !== i.max && null !== i.min;
                var c = void 0 !== i.stepSize && null !== i.stepSize, d = void 0 !== i.tickAmount && null !== i.tickAmount, u = d ? i.tickAmount : h.niceScaleDefaultTicks[Math.min(Math.round(a / 2), h.niceScaleDefaultTicks.length - 1)];
                if (h.isMultipleYAxis && !d && h.multiAxisTickAmount > 0 && (u = h.multiAxisTickAmount, d = !0), u = "dataPoints" === u ? h.dataPoints - 1 : Math.abs(Math.round(u)), (t === Number.MIN_VALUE && 0 === e || !$e4b487e979d7c06d$var$v.isNumber(t) && !$e4b487e979d7c06d$var$v.isNumber(e) || t === Number.MIN_VALUE && e === -Number.MAX_VALUE) && (t = $e4b487e979d7c06d$var$v.isNumber(i.min) ? i.min : 0, e = $e4b487e979d7c06d$var$v.isNumber(i.max) ? i.max : t + u, h.allSeriesCollapsed = !1), t > e) {
                    console.warn("axis.min cannot be greater than axis.max: swapping min and max");
                    var g = e;
                    e = t, t = g;
                } else t === e && (t = 0 === t ? 0 : t - 1, e = 0 === e ? 2 : e + 1);
                var p = [];
                u < 1 && (u = 1);
                var f = u, x = Math.abs(e - t);
                !s && t > 0 && t / x < .15 && (t = 0, s = !0), !r && e < 0 && -e / x < .15 && (e = 0, r = !0);
                var b = (x = Math.abs(e - t)) / f, m = b, y = Math.floor(Math.log10(m)), w = Math.pow(10, y), k = Math.ceil(m / w);
                if (b = m = (k = h.niceScaleAllowedMagMsd[0 === h.yValueDecimal ? 0 : 1][k]) * w, h.isBarHorizontal && i.stepSize && "datetime" !== i.type ? (b = i.stepSize, c = !0) : c && (b = i.stepSize), c && i.forceNiceScale) {
                    var A = Math.floor(Math.log10(b));
                    b *= Math.pow(10, y - A);
                }
                if (s && r) {
                    var C = x / f;
                    if (d) {
                        if (c) {
                            if (0 != $e4b487e979d7c06d$var$v.mod(x, b)) {
                                var S = $e4b487e979d7c06d$var$v.getGCD(b, C);
                                b = C / S < 10 ? S : C;
                            } else 0 == $e4b487e979d7c06d$var$v.mod(b, C) ? b = C : (C = b, d = !1);
                        } else b = C;
                    } else if (c) 0 == $e4b487e979d7c06d$var$v.mod(x, b) ? C = b : b = C;
                    else if (0 == $e4b487e979d7c06d$var$v.mod(x, b)) C = b;
                    else {
                        C = x / (f = Math.ceil(x / b));
                        var L = $e4b487e979d7c06d$var$v.getGCD(x, b);
                        x / L < a && (C = L), b = C;
                    }
                    f = Math.round(x / b);
                } else {
                    if (s || r) {
                        if (r) {
                            if (d) t = e - b * f;
                            else {
                                var M = t;
                                t = b * Math.floor(t / b), Math.abs(e - t) / $e4b487e979d7c06d$var$v.getGCD(x, b) > a && (t = e - b * u, t += b * Math.floor((M - t) / b));
                            }
                        } else if (s) {
                            if (d) e = t + b * f;
                            else {
                                var P = e;
                                e = b * Math.ceil(e / b), Math.abs(e - t) / $e4b487e979d7c06d$var$v.getGCD(x, b) > a && (e = t + b * u, e += b * Math.ceil((P - e) / b));
                            }
                        }
                    } else if (h.isMultipleYAxis && d) {
                        var I = b * Math.floor(t / b), T = I + b * f;
                        T < e && (b *= 2), T = e, e = (t = I) + b * f, x = Math.abs(e - t), t > 0 && t < Math.abs(T - e) && (t = 0, e = b * f), e < 0 && -e < Math.abs(I - t) && (e = 0, t = -b * f);
                    } else t = b * Math.floor(t / b), e = b * Math.ceil(e / b);
                    x = Math.abs(e - t), b = $e4b487e979d7c06d$var$v.getGCD(x, b), f = Math.round(x / b);
                }
                if (d || s || r || (f = Math.ceil((x - o) / (b + o))) > 16 && $e4b487e979d7c06d$var$v.getPrimeFactors(f).length < 2 && f++, !d && i.forceNiceScale && 0 === h.yValueDecimal && f > x && (f = x, b = Math.round(x / f)), f > a && (!d && !c || i.forceNiceScale)) {
                    var z = $e4b487e979d7c06d$var$v.getPrimeFactors(f), X = z.length - 1, R = f;
                    t: for(var E = 0; E < X; E++)for(var Y = 0; Y <= X - E; Y++){
                        for(var H = Math.min(Y + E, X), O = R, F = 1, D = Y; D <= H; D++)F *= z[D];
                        if ((O /= F) < a) {
                            R = O;
                            break t;
                        }
                    }
                    b = R === f ? x : x / R, f = Math.round(x / b);
                }
                h.isMultipleYAxis && 0 == h.multiAxisTickAmount && h.ignoreYAxisIndexes.indexOf(n) < 0 && (h.multiAxisTickAmount = f);
                var _ = t - b, N = b * o;
                do _ += b, p.push($e4b487e979d7c06d$var$v.stripNumber(_, 7));
                while (e - _ > N);
                return {
                    result: p,
                    niceMin: p[0],
                    niceMax: p[p.length - 1]
                };
            }
        },
        {
            key: "linearScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : void 0, r = Math.abs(e - t), n = [];
                if (t === e) return {
                    result: n = [
                        t
                    ],
                    niceMin: n[0],
                    niceMax: n[n.length - 1]
                };
                "dataPoints" === (i = this._adjustTicksForSmallRange(i, a, r)) && (i = this.w.globals.dataPoints - 1), s || (s = r / i), s = Math.round(100 * (s + Number.EPSILON)) / 100, i === Number.MAX_VALUE && (i = 5, s = 1);
                for(var o = t; i >= 0;)n.push(o), o = $e4b487e979d7c06d$var$v.preciseAddition(o, s), i -= 1;
                return {
                    result: n,
                    niceMin: n[0],
                    niceMax: n[n.length - 1]
                };
            }
        },
        {
            key: "logarithmicScaleNice",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.ceil(Math.log(e) / Math.log(i) + 1), r = Math.floor(Math.log(t) / Math.log(i)); r < s; r++)a.push(Math.pow(i, r));
                return {
                    result: a,
                    niceMin: a[0],
                    niceMax: a[a.length - 1]
                };
            }
        },
        {
            key: "logarithmicScale",
            value: function(t, e, i) {
                e <= 0 && (e = Math.max(t, i)), t <= 0 && (t = Math.min(e, i));
                for(var a = [], s = Math.log(e) / Math.log(i), r = Math.log(t) / Math.log(i), n = s - r, o = Math.round(n), l = n / o, h = 0, c = r; h < o; h++, c += l)a.push(Math.pow(i, c));
                return a.push(Math.pow(i, s)), {
                    result: a,
                    niceMin: t,
                    niceMax: e
                };
            }
        },
        {
            key: "_adjustTicksForSmallRange",
            value: function(t, e, i) {
                var a = t;
                if (void 0 !== e && this.w.config.yaxis[e].labels.formatter && void 0 === this.w.config.yaxis[e].tickAmount) {
                    var s = Number(this.w.config.yaxis[e].labels.formatter(1));
                    $e4b487e979d7c06d$var$v.isNumber(s) && 0 === this.w.globals.yValueDecimal && (a = Math.ceil(i));
                }
                return a < t ? a : t;
            }
        },
        {
            key: "setYScaleForIndex",
            value: function(t, e, i) {
                var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[t];
                void 0 === a.yAxisScale[t] && (a.yAxisScale[t] = []);
                var n = Math.abs(i - e);
                r.logarithmic && n <= 5 && (a.invalidLogScale = !0), r.logarithmic && n > 5 ? (a.allSeriesCollapsed = !1, a.yAxisScale[t] = r.forceNiceScale ? this.logarithmicScaleNice(e, i, r.logBase) : this.logarithmicScale(e, i, r.logBase)) : i !== -Number.MAX_VALUE && $e4b487e979d7c06d$var$v.isNumber(i) && e !== Number.MAX_VALUE && $e4b487e979d7c06d$var$v.isNumber(e) ? (a.allSeriesCollapsed = !1, a.yAxisScale[t] = this.niceScale(e, i, t)) : a.yAxisScale[t] = this.niceScale(Number.MIN_VALUE, 0, t);
            }
        },
        {
            key: "setXScale",
            value: function(t, e) {
                var i = this.w, a = i.globals;
                if (e !== -Number.MAX_VALUE && $e4b487e979d7c06d$var$v.isNumber(e)) {
                    var s = a.xTickAmount;
                    a.xAxisScale = this.linearScale(t, e, s, 0, i.config.xaxis.stepSize);
                } else a.xAxisScale = this.linearScale(0, 10, 10);
                return a.xAxisScale;
            }
        },
        {
            key: "scaleMultipleYAxes",
            value: function() {
                var t = this, e = this.w.config, i = this.w.globals;
                this.coreUtils.setSeriesYAxisMappings();
                var a = i.seriesYAxisMap, s = i.minYArr, r = i.maxYArr;
                i.allSeriesCollapsed = !0, i.barGroups = [], a.forEach(function(a, n) {
                    var o = [];
                    a.forEach(function(t) {
                        var i, a = null === (i = e.series[t]) || void 0 === i ? void 0 : i.group;
                        o.indexOf(a) < 0 && o.push(a);
                    }), a.length > 0 ? function() {
                        var l, h, c = Number.MAX_VALUE, d = -Number.MAX_VALUE, u = c, g = d;
                        if (e.chart.stacked) !function() {
                            var t = new Array(i.dataPoints).fill(0), s = [], r = [], p = [];
                            o.forEach(function() {
                                s.push(t.map(function() {
                                    return Number.MIN_VALUE;
                                })), r.push(t.map(function() {
                                    return Number.MIN_VALUE;
                                })), p.push(t.map(function() {
                                    return Number.MIN_VALUE;
                                }));
                            });
                            for(var f = function(t) {
                                !l && e.series[a[t]].type && (l = e.series[a[t]].type);
                                var c = a[t];
                                h = e.series[c].group ? e.series[c].group : "axis-".concat(n), !(i.collapsedSeriesIndices.indexOf(c) < 0 && i.ancillaryCollapsedSeriesIndices.indexOf(c) < 0) || (i.allSeriesCollapsed = !1, o.forEach(function(t, a) {
                                    if (e.series[c].group === t) for(var n = 0; n < i.series[c].length; n++){
                                        var o = i.series[c][n];
                                        o >= 0 ? r[a][n] += o : p[a][n] += o, s[a][n] += o, u = Math.min(u, o), g = Math.max(g, o);
                                    }
                                })), "bar" !== l && "column" !== l || i.barGroups.push(h);
                            }, x = 0; x < a.length; x++)f(x);
                            l || (l = e.chart.type), "bar" === l || "column" === l ? o.forEach(function(t, e) {
                                c = Math.min(c, Math.min.apply(null, p[e])), d = Math.max(d, Math.max.apply(null, r[e]));
                            }) : (o.forEach(function(t, e) {
                                u = Math.min(u, Math.min.apply(null, s[e])), g = Math.max(g, Math.max.apply(null, s[e]));
                            }), c = u, d = g), c === Number.MIN_VALUE && d === Number.MIN_VALUE && (d = -Number.MAX_VALUE);
                        }();
                        else for(var p = 0; p < a.length; p++){
                            var f = a[p];
                            c = Math.min(c, s[f]), d = Math.max(d, r[f]), !(i.collapsedSeriesIndices.indexOf(f) < 0 && i.ancillaryCollapsedSeriesIndices.indexOf(f) < 0) || (i.allSeriesCollapsed = !1);
                        }
                        void 0 !== e.yaxis[n].min && (c = "function" == typeof e.yaxis[n].min ? e.yaxis[n].min(c) : e.yaxis[n].min), void 0 !== e.yaxis[n].max && (d = "function" == typeof e.yaxis[n].max ? e.yaxis[n].max(d) : e.yaxis[n].max), i.barGroups = i.barGroups.filter(function(t, e, i) {
                            return i.indexOf(t) === e;
                        }), t.setYScaleForIndex(n, c, d), a.forEach(function(t) {
                            s[t] = i.yAxisScale[n].niceMin, r[t] = i.yAxisScale[n].niceMax;
                        });
                    }() : t.setYScaleForIndex(n, 0, -Number.MAX_VALUE);
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ea = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.scales = new $e4b487e979d7c06d$var$ta(e);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "init",
            value: function() {
                this.setYRange(), this.setXRange(), this.setZRange();
            }
        },
        {
            key: "getMinYMaxY",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w.config, r = this.w.globals, n = -Number.MAX_VALUE, o = Number.MIN_VALUE;
                null === a && (a = t + 1);
                var l = r.series, h = l, c = l;
                "candlestick" === s.chart.type ? (h = r.seriesCandleL, c = r.seriesCandleH) : "boxPlot" === s.chart.type ? (h = r.seriesCandleO, c = r.seriesCandleC) : r.isRangeData && (h = r.seriesRangeStart, c = r.seriesRangeEnd);
                var d = !1;
                if (r.seriesX.length >= a) {
                    var u, g = null === (u = r.brushSource) || void 0 === u ? void 0 : u.w.config.chart.brush;
                    (s.chart.zoom.enabled && s.chart.zoom.autoScaleYaxis || null != g && g.enabled && null != g && g.autoScaleYaxis) && (d = !0);
                }
                for(var p = t; p < a; p++){
                    r.dataPoints = Math.max(r.dataPoints, l[p].length);
                    var f = s.series[p].type;
                    r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(t) {
                        return void 0 !== t;
                    }).length), r.labels.length && "datetime" !== s.xaxis.type && 0 !== r.series.reduce(function(t, e) {
                        return t + e.length;
                    }, 0) && (r.dataPoints = Math.max(r.dataPoints, r.labels.length));
                    var x = 0, b = l[p].length - 1;
                    if (d) {
                        if (s.xaxis.min) for(; x < b && r.seriesX[p][x] < s.xaxis.min; x++);
                        if (s.xaxis.max) for(; b > x && r.seriesX[p][b] > s.xaxis.max; b--);
                    }
                    for(var m = x; m <= b && m < r.series[p].length; m++){
                        var y = l[p][m];
                        if (null !== y && $e4b487e979d7c06d$var$v.isNumber(y)) {
                            var w, k, A, C;
                            switch(void 0 !== (null === (w = c[p]) || void 0 === w ? void 0 : w[m]) && (n = Math.max(n, c[p][m]), e = Math.min(e, c[p][m])), void 0 !== (null === (k = h[p]) || void 0 === k ? void 0 : k[m]) && (e = Math.min(e, h[p][m]), i = Math.max(i, h[p][m])), f){
                                case "candlestick":
                                    void 0 !== r.seriesCandleC[p][m] && (n = Math.max(n, r.seriesCandleH[p][m]), e = Math.min(e, r.seriesCandleL[p][m]));
                                    break;
                                case "boxPlot":
                                    void 0 !== r.seriesCandleC[p][m] && (n = Math.max(n, r.seriesCandleC[p][m]), e = Math.min(e, r.seriesCandleO[p][m]));
                            }
                            f && "candlestick" !== f && "boxPlot" !== f && "rangeArea" !== f && "rangeBar" !== f && (n = Math.max(n, r.series[p][m]), e = Math.min(e, r.series[p][m])), r.seriesGoals[p] && r.seriesGoals[p][m] && Array.isArray(r.seriesGoals[p][m]) && r.seriesGoals[p][m].forEach(function(t) {
                                n = Math.max(n, t.value), e = Math.min(e, t.value);
                            }), i = n, y = $e4b487e979d7c06d$var$v.noExponents(y), $e4b487e979d7c06d$var$v.isFloat(y) && (r.yValueDecimal = Math.max(r.yValueDecimal, y.toString().split(".")[1].length)), o > (null === (A = h[p]) || void 0 === A ? void 0 : A[m]) && (null === (C = h[p]) || void 0 === C ? void 0 : C[m]) < 0 && (o = h[p][m]);
                        } else r.hasNullValues = !0;
                    }
                    "bar" !== f && "column" !== f || (o < 0 && n < 0 && (n = 0, i = Math.max(i, 0)), o === Number.MIN_VALUE && (o = 0, e = Math.min(e, 0)));
                }
                return "rangeBar" === s.chart.type && r.seriesRangeStart.length && r.isBarHorizontal && (o = e), "bar" === s.chart.type && (o < 0 && n < 0 && (n = 0), o === Number.MIN_VALUE && (o = 0)), {
                    minY: o,
                    maxY: n,
                    lowestY: e,
                    highestY: i
                };
            }
        },
        {
            key: "setYRange",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE;
                var i, a = Number.MAX_VALUE;
                if (t.isMultipleYAxis) {
                    a = Number.MAX_VALUE;
                    for(var s = 0; s < t.series.length; s++)i = this.getMinYMaxY(s), t.minYArr[s] = i.lowestY, t.maxYArr[s] = i.highestY, a = Math.min(a, i.lowestY);
                }
                if (i = this.getMinYMaxY(0, a, null, t.series.length), "bar" === e.chart.type ? (t.minY = i.minY, t.maxY = i.maxY) : (t.minY = i.lowestY, t.maxY = i.highestY), a = i.lowestY, e.chart.stacked && this._setStackedMinMax(), "line" === e.chart.type || "area" === e.chart.type || "scatter" === e.chart.type || "candlestick" === e.chart.type || "boxPlot" === e.chart.type || "rangeBar" === e.chart.type && !t.isBarHorizontal ? t.minY === Number.MIN_VALUE && a !== -Number.MAX_VALUE && a !== t.maxY && (t.minY = a) : t.minY = t.minY !== Number.MIN_VALUE ? Math.min(i.minY, t.minY) : i.minY, e.yaxis.forEach(function(e, i) {
                    void 0 !== e.max && ("number" == typeof e.max ? t.maxYArr[i] = e.max : "function" == typeof e.max && (t.maxYArr[i] = e.max(t.isMultipleYAxis ? t.maxYArr[i] : t.maxY)), t.maxY = t.maxYArr[i]), void 0 !== e.min && ("number" == typeof e.min ? t.minYArr[i] = e.min : "function" == typeof e.min && (t.minYArr[i] = e.min(t.isMultipleYAxis ? t.minYArr[i] === Number.MIN_VALUE ? 0 : t.minYArr[i] : t.minY)), t.minY = t.minYArr[i]);
                }), t.isBarHorizontal) [
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== e.xaxis[i] && "number" == typeof e.xaxis[i] && ("min" === i ? t.minY = e.xaxis[i] : t.maxY = e.xaxis[i]);
                });
                return t.isMultipleYAxis ? (this.scales.scaleMultipleYAxes(), t.minY = a) : (this.scales.setYScaleForIndex(0, t.minY, t.maxY), t.minY = t.yAxisScale[0].niceMin, t.maxY = t.yAxisScale[0].niceMax, t.minYArr[0] = t.minY, t.maxYArr[0] = t.maxY), t.barGroups = [], t.lineGroups = [], t.areaGroups = [], e.series.forEach(function(i) {
                    switch(i.type || e.chart.type){
                        case "bar":
                        case "column":
                            t.barGroups.push(i.group);
                            break;
                        case "line":
                            t.lineGroups.push(i.group);
                            break;
                        case "area":
                            t.areaGroups.push(i.group);
                    }
                }), t.barGroups = t.barGroups.filter(function(t, e, i) {
                    return i.indexOf(t) === e;
                }), t.lineGroups = t.lineGroups.filter(function(t, e, i) {
                    return i.indexOf(t) === e;
                }), t.areaGroups = t.areaGroups.filter(function(t, e, i) {
                    return i.indexOf(t) === e;
                }), {
                    minY: t.minY,
                    maxY: t.maxY,
                    minYArr: t.minYArr,
                    maxYArr: t.maxYArr,
                    yAxisScale: t.yAxisScale
                };
            }
        },
        {
            key: "setXRange",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = "numeric" === e.xaxis.type || "datetime" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided || t.noLabelsProvided || t.isXNumeric;
                if (t.isXNumeric && function() {
                    for(var e = 0; e < t.series.length; e++)if (t.labels[e]) for(var i = 0; i < t.labels[e].length; i++)null !== t.labels[e][i] && $e4b487e979d7c06d$var$v.isNumber(t.labels[e][i]) && (t.maxX = Math.max(t.maxX, t.labels[e][i]), t.initialMaxX = Math.max(t.maxX, t.labels[e][i]), t.minX = Math.min(t.minX, t.labels[e][i]), t.initialMinX = Math.min(t.minX, t.labels[e][i]));
                }(), t.noLabelsProvided && 0 === e.xaxis.categories.length && (t.maxX = t.labels[t.labels.length - 1], t.initialMaxX = t.labels[t.labels.length - 1], t.minX = 1, t.initialMinX = 1), t.isXNumeric || t.noLabelsProvided || t.dataFormatXNumeric) {
                    var a = 10;
                    if (void 0 === e.xaxis.tickAmount) a = Math.round(t.svgWidth / 150), "numeric" === e.xaxis.type && t.dataPoints < 30 && (a = t.dataPoints - 1), a > t.dataPoints && 0 !== t.dataPoints && (a = t.dataPoints - 1);
                    else if ("dataPoints" === e.xaxis.tickAmount) {
                        if (t.series.length > 1 && (a = t.series[t.maxValsInArrayIndex].length - 1), t.isXNumeric) {
                            var s = Math.round(t.maxX - t.minX);
                            s < 30 && (a = s - 1);
                        }
                    } else a = e.xaxis.tickAmount;
                    if (t.xTickAmount = a, void 0 !== e.xaxis.max && "number" == typeof e.xaxis.max && (t.maxX = e.xaxis.max), void 0 !== e.xaxis.min && "number" == typeof e.xaxis.min && (t.minX = e.xaxis.min), void 0 !== e.xaxis.range && (t.minX = t.maxX - e.xaxis.range), t.minX !== Number.MAX_VALUE && t.maxX !== -Number.MAX_VALUE) {
                        if (e.xaxis.convertedCatToNumeric && !t.dataFormatXNumeric) {
                            for(var r = [], n = t.minX - 1; n < t.maxX; n++)r.push(n + 1);
                            t.xAxisScale = {
                                result: r,
                                niceMin: r[0],
                                niceMax: r[r.length - 1]
                            };
                        } else t.xAxisScale = this.scales.setXScale(t.minX, t.maxX);
                    } else t.xAxisScale = this.scales.linearScale(0, a, a, 0, e.xaxis.stepSize), t.noLabelsProvided && t.labels.length > 0 && (t.xAxisScale = this.scales.linearScale(1, t.labels.length, a - 1, 0, e.xaxis.stepSize), t.seriesX = t.labels.slice());
                    i && (t.labels = t.xAxisScale.result.slice());
                }
                return t.isBarHorizontal && t.labels.length && (t.xTickAmount = t.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                    minX: t.minX,
                    maxX: t.maxX
                };
            }
        },
        {
            key: "setZRange",
            value: function() {
                var t = this.w.globals;
                if (t.isDataXYZ) {
                    for(var e = 0; e < t.series.length; e++)if (void 0 !== t.seriesZ[e]) for(var i = 0; i < t.seriesZ[e].length; i++)null !== t.seriesZ[e][i] && $e4b487e979d7c06d$var$v.isNumber(t.seriesZ[e][i]) && (t.maxZ = Math.max(t.maxZ, t.seriesZ[e][i]), t.minZ = Math.min(t.minZ, t.seriesZ[e][i]));
                }
            }
        },
        {
            key: "_handleSingleDataPoint",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                if (t.minX === t.maxX) {
                    var i = new $e4b487e979d7c06d$var$zi(this.ctx);
                    if ("datetime" === e.xaxis.type) {
                        var a = i.getDate(t.minX);
                        e.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), t.minX = new Date(a).getTime();
                        var s = i.getDate(t.maxX);
                        e.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), t.maxX = new Date(s).getTime();
                    } else ("numeric" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided) && (t.minX = t.minX - 2, t.initialMinX = t.minX, t.maxX = t.maxX + 2, t.initialMaxX = t.maxX);
                }
            }
        },
        {
            key: "_getMinXDiff",
            value: function() {
                var t = this.w.globals;
                t.isXNumeric && t.seriesX.forEach(function(e, i) {
                    if (e.length) {
                        1 === e.length && e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length - 1]);
                        var a = e.slice();
                        a.sort(function(t, e) {
                            return t - e;
                        }), a.forEach(function(e, i) {
                            if (i > 0) {
                                var s = e - a[i - 1];
                                s > 0 && (t.minXDiff = Math.min(s, t.minXDiff));
                            }
                        }), 1 !== t.dataPoints && t.minXDiff !== Number.MAX_VALUE || (t.minXDiff = .5);
                    }
                });
            }
        },
        {
            key: "_setStackedMinMax",
            value: function() {
                var t = this, e = this.w.globals;
                if (e.series.length) {
                    var i = e.seriesGroups;
                    i.length || (i = [
                        this.w.globals.seriesNames.map(function(t) {
                            return t;
                        })
                    ]);
                    var a = {}, s = {};
                    i.forEach(function(i) {
                        a[i] = [], s[i] = [], t.w.config.series.map(function(t, a) {
                            return i.indexOf(e.seriesNames[a]) > -1 ? a : null;
                        }).filter(function(t) {
                            return null !== t;
                        }).forEach(function(r) {
                            for(var n = 0; n < e.series[e.maxValsInArrayIndex].length; n++){
                                var o, l, h, c;
                                void 0 === a[i][n] && (a[i][n] = 0, s[i][n] = 0), (t.w.config.chart.stacked && !e.comboCharts || t.w.config.chart.stacked && e.comboCharts && (!t.w.config.chart.stackOnlyBar || "bar" === (null === (o = t.w.config.series) || void 0 === o || null === (l = o[r]) || void 0 === l ? void 0 : l.type) || "column" === (null === (h = t.w.config.series) || void 0 === h || null === (c = h[r]) || void 0 === c ? void 0 : c.type))) && null !== e.series[r][n] && $e4b487e979d7c06d$var$v.isNumber(e.series[r][n]) && (e.series[r][n] > 0 ? a[i][n] += parseFloat(e.series[r][n]) + 1e-4 : s[i][n] += parseFloat(e.series[r][n]));
                            }
                        });
                    }), Object.entries(a).forEach(function(t) {
                        var i = $e4b487e979d7c06d$var$p(t, 1)[0];
                        a[i].forEach(function(t, r) {
                            e.maxY = Math.max(e.maxY, a[i][r]), e.minY = Math.min(e.minY, s[i][r]);
                        });
                    });
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ia = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.elgrid = a, this.w = e.w;
        var s = this.w;
        this.xaxisFontSize = s.config.xaxis.labels.style.fontSize, this.axisFontFamily = s.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = s.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = "bar" === s.config.chart.type && s.config.plotOptions.bar.horizontal, this.xAxisoffX = "bottom" === s.config.xaxis.position ? s.globals.gridHeight : 0, this.drawnLabels = [], this.axesUtils = new $e4b487e979d7c06d$var$Ri(e);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawYaxis",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = e.config.yaxis[t].labels.style, s = a.fontSize, r = a.fontFamily, n = a.fontWeight, o = i.group({
                    class: "apexcharts-yaxis",
                    rel: t,
                    transform: "translate(".concat(e.globals.translateYAxisX[t], ", 0)")
                });
                if (this.axesUtils.isYAxisHidden(t)) return o;
                var l = i.group({
                    class: "apexcharts-yaxis-texts-g"
                });
                o.add(l);
                var h = e.globals.yAxisScale[t].result.length - 1, c = e.globals.gridHeight / h, d = e.globals.yLabelFormatters[t], u = this.axesUtils.checkForReversedLabels(t, e.globals.yAxisScale[t].result.slice());
                if (e.config.yaxis[t].labels.show) {
                    var g = e.globals.translateY + e.config.yaxis[t].labels.offsetY;
                    e.globals.isBarHorizontal ? g = 0 : "heatmap" === e.config.chart.type && (g -= c / 2), g += parseInt(s, 10) / 3;
                    for(var p = h; p >= 0; p--){
                        var f = d(u[p], p, e), x = e.config.yaxis[t].labels.padding;
                        e.config.yaxis[t].opposite && 0 !== e.config.yaxis.length && (x *= -1);
                        var b = this.getTextAnchor(e.config.yaxis[t].labels.align, e.config.yaxis[t].opposite), m = this.axesUtils.getYAxisForeColor(a.colors, t), y = Array.isArray(m) ? m[p] : m, w = $e4b487e979d7c06d$var$v.listToArray(e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-label tspan"))).map(function(t) {
                            return t.textContent;
                        }), k = i.drawText({
                            x: x,
                            y: g,
                            text: w.includes(f) && !e.config.yaxis[t].labels.showDuplicates ? "" : f,
                            textAnchor: b,
                            fontSize: s,
                            fontFamily: r,
                            fontWeight: n,
                            maxWidth: e.config.yaxis[t].labels.maxWidth,
                            foreColor: y,
                            isPlainText: !1,
                            cssClass: "apexcharts-yaxis-label ".concat(a.cssClass)
                        });
                        l.add(k), this.addTooltip(k, f), 0 !== e.config.yaxis[t].labels.rotate && this.rotateLabel(i, k, firstLabel, e.config.yaxis[t].labels.rotate), g += c;
                    }
                }
                return this.addYAxisTitle(i, o, t), this.addAxisBorder(i, o, t, h, c), o;
            }
        },
        {
            key: "getTextAnchor",
            value: function(t, e) {
                return "left" === t ? "start" : "center" === t ? "middle" : "right" === t ? "end" : e ? "start" : "end";
            }
        },
        {
            key: "addTooltip",
            value: function(t, e) {
                var i = document.createElementNS(this.w.globals.SVGNS, "title");
                i.textContent = Array.isArray(e) ? e.join(" ") : e, t.node.appendChild(i);
            }
        },
        {
            key: "rotateLabel",
            value: function(t, e, i, a) {
                var s = t.rotateAroundCenter(i.node), r = t.rotateAroundCenter(e.node);
                e.node.setAttribute("transform", "rotate(".concat(a, " ").concat(s.x, " ").concat(r.y, ")"));
            }
        },
        {
            key: "addYAxisTitle",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.config.yaxis[i].title.text) {
                    var s = t.group({
                        class: "apexcharts-yaxis-title"
                    }), r = a.config.yaxis[i].opposite ? a.globals.translateYAxisX[i] : 0, n = t.drawText({
                        x: r,
                        y: a.globals.gridHeight / 2 + a.globals.translateY + a.config.yaxis[i].title.offsetY,
                        text: a.config.yaxis[i].title.text,
                        textAnchor: "end",
                        foreColor: a.config.yaxis[i].title.style.color,
                        fontSize: a.config.yaxis[i].title.style.fontSize,
                        fontWeight: a.config.yaxis[i].title.style.fontWeight,
                        fontFamily: a.config.yaxis[i].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text ".concat(a.config.yaxis[i].title.style.cssClass)
                    });
                    s.add(n), e.add(s);
                }
            }
        },
        {
            key: "addAxisBorder",
            value: function(t, e, i, a, s) {
                var r = this.w, n = r.config.yaxis[i].axisBorder, o = 31 + n.offsetX;
                if (r.config.yaxis[i].opposite && (o = -31 - n.offsetX), n.show) {
                    var l = t.drawLine(o, r.globals.translateY + n.offsetY - 2, o, r.globals.gridHeight + r.globals.translateY + n.offsetY + 2, n.color, 0, n.width);
                    e.add(l);
                }
                r.config.yaxis[i].axisTicks.show && this.axesUtils.drawYAxisTicks(o, a, n, r.config.yaxis[i].axisTicks, i, s, e);
            }
        },
        {
            key: "drawYaxisInversed",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = i.group({
                    class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                }), s = i.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                });
                a.add(s);
                var r = e.globals.yAxisScale[t].result.length - 1, n = e.globals.gridWidth / r + .1, o = n + e.config.xaxis.labels.offsetX, l = e.globals.xLabelFormatter, h = this.axesUtils.checkForReversedLabels(t, e.globals.yAxisScale[t].result.slice()), c = e.globals.timescaleLabels;
                if (c.length > 0 && (this.xaxisLabels = c.slice(), r = (h = c.slice()).length), e.config.xaxis.labels.show) for(var d = c.length ? 0 : r; c.length ? d < c.length : d >= 0; c.length ? d++ : d--){
                    var u = l(h[d], d, e), g = e.globals.gridWidth + e.globals.padHorizontal - (o - n + e.config.xaxis.labels.offsetX);
                    if (c.length) {
                        var p = this.axesUtils.getLabel(h, c, g, d, this.drawnLabels, this.xaxisFontSize);
                        g = p.x, u = p.text, this.drawnLabels.push(p.text), 0 === d && e.globals.skipFirstTimelinelabel && (u = ""), d === h.length - 1 && e.globals.skipLastTimelinelabel && (u = "");
                    }
                    var f = i.drawText({
                        x: g,
                        y: this.xAxisoffX + e.config.xaxis.labels.offsetY + 30 - ("top" === e.config.xaxis.position ? e.globals.xAxisHeight + e.config.xaxis.axisTicks.height - 2 : 0),
                        text: u,
                        textAnchor: "middle",
                        foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[t] : this.xaxisForeColors,
                        fontSize: this.xaxisFontSize,
                        fontFamily: this.xaxisFontFamily,
                        fontWeight: e.config.xaxis.labels.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-xaxis-label ".concat(e.config.xaxis.labels.style.cssClass)
                    });
                    s.add(f), f.tspan(u), this.addTooltip(f, u), o += n;
                }
                return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
            }
        },
        {
            key: "inversedYAxisBorder",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = e.config.xaxis.axisBorder;
                if (a.show) {
                    var s = 0;
                    "bar" === e.config.chart.type && e.globals.isXNumeric && (s -= 15);
                    var r = i.drawLine(e.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, e.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                    this.elgrid && this.elgrid.elGridBorders && e.config.grid.show ? this.elgrid.elGridBorders.add(r) : t.add(r);
                }
            }
        },
        {
            key: "inversedYAxisTitleText",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx);
                if (void 0 !== e.config.xaxis.title.text) {
                    var a = i.group({
                        class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                    }), s = i.drawText({
                        x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                        y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(e.config.xaxis.title.style.fontSize) + e.config.xaxis.title.offsetY + 20,
                        text: e.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: e.config.xaxis.title.style.fontSize,
                        fontFamily: e.config.xaxis.title.style.fontFamily,
                        fontWeight: e.config.xaxis.title.style.fontWeight,
                        foreColor: e.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text ".concat(e.config.xaxis.title.style.cssClass)
                    });
                    a.add(s), t.add(a);
                }
            }
        },
        {
            key: "yAxisTitleRotate",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Mi(this.ctx), s = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-texts-g")), r = s ? s.getBoundingClientRect() : {
                    width: 0,
                    height: 0
                }, n = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-title text")), o = n ? n.getBoundingClientRect() : {
                    width: 0,
                    height: 0
                };
                if (n) {
                    var l = this.xPaddingForYAxisTitle(t, r, o, e);
                    n.setAttribute("x", l.xPos - (e ? 10 : 0));
                    var h = a.rotateAroundCenter(n);
                    n.setAttribute("transform", "rotate(".concat(e ? -1 * i.config.yaxis[t].title.rotate : i.config.yaxis[t].title.rotate, " ").concat(h.x, " ").concat(h.y, ")"));
                }
            }
        },
        {
            key: "xPaddingForYAxisTitle",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, n = 10;
                return void 0 === s.config.yaxis[t].title.text || t < 0 ? {
                    xPos: r,
                    padd: 0
                } : (a ? r = e.width + s.config.yaxis[t].title.offsetX + i.width / 2 + n / 2 : (r = -1 * e.width + s.config.yaxis[t].title.offsetX + n / 2 + i.width / 2, s.globals.isBarHorizontal && (n = 25, r = -1 * e.width - s.config.yaxis[t].title.offsetX - n)), {
                    xPos: r,
                    padd: n
                });
            }
        },
        {
            key: "setYAxisXPosition",
            value: function(t, e) {
                var i = this.w, a = 0, s = 0, r = 18, n = 1;
                i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.forEach(function(o, l) {
                    var h = i.globals.ignoreYAxisIndexes.includes(l) || !o.show || o.floating || 0 === t[l].width, c = t[l].width + e[l].width;
                    o.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[l] = s - o.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + n, h || (n += c + 20), i.globals.translateYAxisX[l] = s - o.labels.offsetX + 20) : (a = i.globals.translateX - r, h || (r += c + 20), i.globals.translateYAxisX[l] = a + o.labels.offsetX);
                });
            }
        },
        {
            key: "setYAxisTextAlignments",
            value: function() {
                var t = this.w;
                $e4b487e979d7c06d$var$v.listToArray(t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis")).forEach(function(e, i) {
                    var a = t.config.yaxis[i];
                    if (a && !a.floating && void 0 !== a.labels.align) {
                        var s = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-texts-g")), r = $e4b487e979d7c06d$var$v.listToArray(t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-label"))), n = s.getBoundingClientRect();
                        r.forEach(function(t) {
                            t.setAttribute("text-anchor", a.labels.align);
                        }), "left" !== a.labels.align || a.opposite ? "center" === a.labels.align ? s.setAttribute("transform", "translate(".concat(n.width / 2 * (a.opposite ? 1 : -1), ", 0)")) : "right" === a.labels.align && a.opposite && s.setAttribute("transform", "translate(".concat(n.width, ", 0)")) : s.setAttribute("transform", "translate(-".concat(n.width, ", 0)"));
                    }
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$aa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.documentEvent = $e4b487e979d7c06d$var$v.bind(this.documentEvent, this);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "addEventListener",
            value: function(t, e) {
                var i = this.w;
                i.globals.events.hasOwnProperty(t) ? i.globals.events[t].push(e) : i.globals.events[t] = [
                    e
                ];
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    var a = i.globals.events[t].indexOf(e);
                    -1 !== a && i.globals.events[t].splice(a, 1);
                }
            }
        },
        {
            key: "fireEvent",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    e && e.length || (e = []);
                    for(var a = i.globals.events[t], s = a.length, r = 0; r < s; r++)a[r].apply(null, e);
                }
            }
        },
        {
            key: "setupEventHandlers",
            value: function() {
                var t = this, e = this.w, i = this.ctx, a = e.globals.dom.baseEl.querySelector(e.globals.chartClass);
                this.ctx.eventList.forEach(function(t) {
                    a.addEventListener(t, function(t) {
                        var a = null === t.target.getAttribute("i") && -1 !== e.globals.capturedSeriesIndex ? e.globals.capturedSeriesIndex : t.target.getAttribute("i"), s = null === t.target.getAttribute("j") && -1 !== e.globals.capturedDataPointIndex ? e.globals.capturedDataPointIndex : t.target.getAttribute("j"), r = Object.assign({}, e, {
                            seriesIndex: e.globals.axisCharts ? a : 0,
                            dataPointIndex: s
                        });
                        "mousemove" === t.type || "touchmove" === t.type ? "function" == typeof e.config.chart.events.mouseMove && e.config.chart.events.mouseMove(t, i, r) : "mouseleave" === t.type || "touchleave" === t.type ? "function" == typeof e.config.chart.events.mouseLeave && e.config.chart.events.mouseLeave(t, i, r) : ("mouseup" === t.type && 1 === t.which || "touchend" === t.type) && ("function" == typeof e.config.chart.events.click && e.config.chart.events.click(t, i, r), i.ctx.events.fireEvent("click", [
                            t,
                            i,
                            r
                        ]));
                    }, {
                        capture: !1,
                        passive: !0
                    });
                }), this.ctx.eventList.forEach(function(i) {
                    e.globals.dom.baseEl.addEventListener(i, t.documentEvent, {
                        passive: !0
                    });
                }), this.ctx.core.setupBrushHandler();
            }
        },
        {
            key: "documentEvent",
            value: function(t) {
                var e = this.w, i = t.target.className;
                if ("click" === t.type) {
                    var a = e.globals.dom.baseEl.querySelector(".apexcharts-menu");
                    a && a.classList.contains("apexcharts-menu-open") && "apexcharts-menu-icon" !== i && a.classList.remove("apexcharts-menu-open");
                }
                e.globals.clientX = "touchmove" === t.type ? t.touches[0].clientX : t.clientX, e.globals.clientY = "touchmove" === t.type ? t.touches[0].clientY : t.clientY;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$sa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "setCurrentLocaleValues",
            value: function(t) {
                var e = this.w.config.chart.locales;
                window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (e = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                var i = e.filter(function(e) {
                    return e.name === t;
                })[0];
                if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                var a = $e4b487e979d7c06d$var$v.extend($e4b487e979d7c06d$var$Hi, i);
                this.w.globals.locale = a.options;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ra = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawAxis",
            value: function(t, e) {
                var i, a, s = this, r = this.w.globals, n = this.w.config, o = new $e4b487e979d7c06d$var$Qi(this.ctx, e), l = new $e4b487e979d7c06d$var$ia(this.ctx, e);
                r.axisCharts && "radar" !== t && (r.isBarHorizontal ? (a = l.drawYaxisInversed(0), i = o.drawXaxisInversed(0), r.dom.elGraphical.add(i), r.dom.elGraphical.add(a)) : (i = o.drawXaxis(), r.dom.elGraphical.add(i), n.yaxis.map(function(t, e) {
                    if (-1 === r.ignoreYAxisIndexes.indexOf(e) && (a = l.drawYaxis(e), r.dom.Paper.add(a), "back" === s.w.config.grid.position)) {
                        var i = r.dom.Paper.children()[1];
                        i.remove(), r.dom.Paper.add(i);
                    }
                })));
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$na = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawXCrosshairs",
            value: function() {
                var t = this.w, e = new $e4b487e979d7c06d$var$Mi(this.ctx), i = new $e4b487e979d7c06d$var$Li(this.ctx), a = t.config.xaxis.crosshairs.fill.gradient, s = t.config.xaxis.crosshairs.dropShadow, r = t.config.xaxis.crosshairs.fill.type, n = a.colorFrom, o = a.colorTo, l = a.opacityFrom, h = a.opacityTo, c = a.stops, d = s.enabled, u = s.left, g = s.top, p = s.blur, f = s.color, x = s.opacity, b = t.config.xaxis.crosshairs.fill.color;
                if (t.config.xaxis.crosshairs.show) {
                    "gradient" === r && (b = e.drawGradient("vertical", n, o, l, h, null, c, null));
                    var m = e.drawRect();
                    1 === t.config.xaxis.crosshairs.width && (m = e.drawLine());
                    var y = t.globals.gridHeight;
                    (!$e4b487e979d7c06d$var$v.isNumber(y) || y < 0) && (y = 0);
                    var w = t.config.xaxis.crosshairs.width;
                    (!$e4b487e979d7c06d$var$v.isNumber(w) || w < 0) && (w = 0), m.attr({
                        class: "apexcharts-xcrosshairs",
                        x: 0,
                        y: 0,
                        y2: y,
                        width: w,
                        height: y,
                        fill: b,
                        filter: "none",
                        "fill-opacity": t.config.xaxis.crosshairs.opacity,
                        stroke: t.config.xaxis.crosshairs.stroke.color,
                        "stroke-width": t.config.xaxis.crosshairs.stroke.width,
                        "stroke-dasharray": t.config.xaxis.crosshairs.stroke.dashArray
                    }), d && (m = i.dropShadow(m, {
                        left: u,
                        top: g,
                        blur: p,
                        color: f,
                        opacity: x
                    })), t.globals.dom.elGraphical.add(m);
                }
            }
        },
        {
            key: "drawYCrosshairs",
            value: function() {
                var t = this.w, e = new $e4b487e979d7c06d$var$Mi(this.ctx), i = t.config.yaxis[0].crosshairs, a = t.globals.barPadForNumericAxis;
                if (t.config.yaxis[0].crosshairs.show) {
                    var s = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                    s.attr({
                        class: "apexcharts-ycrosshairs"
                    }), t.globals.dom.elGraphical.add(s);
                }
                var r = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                r.attr({
                    class: "apexcharts-ycrosshairs-hidden"
                }), t.globals.dom.elGraphical.add(r);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$oa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "checkResponsiveConfig",
            value: function(t) {
                var e = this, i = this.w, a = i.config;
                if (0 !== a.responsive.length) {
                    var s = a.responsive.slice();
                    s.sort(function(t, e) {
                        return t.breakpoint > e.breakpoint ? 1 : e.breakpoint > t.breakpoint ? -1 : 0;
                    }).reverse();
                    var r = new $e4b487e979d7c06d$var$Wi({}), n = function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = s[0].breakpoint, n = window.innerWidth > 0 ? window.innerWidth : screen.width;
                        if (n > a) {
                            var o = $e4b487e979d7c06d$var$v.clone(i.globals.initialConfig);
                            o.series = $e4b487e979d7c06d$var$v.clone(i.config.series);
                            var l = $e4b487e979d7c06d$var$Pi.extendArrayProps(r, o, i);
                            t = $e4b487e979d7c06d$var$v.extend(l, t), t = $e4b487e979d7c06d$var$v.extend(i.config, t), e.overrideResponsiveOptions(t);
                        } else for(var h = 0; h < s.length; h++)n < s[h].breakpoint && (t = $e4b487e979d7c06d$var$Pi.extendArrayProps(r, s[h].options, i), t = $e4b487e979d7c06d$var$v.extend(i.config, t), e.overrideResponsiveOptions(t));
                    };
                    if (t) {
                        var o = $e4b487e979d7c06d$var$Pi.extendArrayProps(r, t, i);
                        o = $e4b487e979d7c06d$var$v.extend(i.config, o), n(o = $e4b487e979d7c06d$var$v.extend(o, t));
                    } else n({});
                }
            }
        },
        {
            key: "overrideResponsiveOptions",
            value: function(t) {
                var e = new $e4b487e979d7c06d$var$Wi(t).init({
                    responsiveOverride: !0
                });
                this.w.config = e;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$la = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.colors = [], this.isColorFn = !1, this.isHeatmapDistributed = this.checkHeatmapDistributed(), this.isBarDistributed = this.checkBarDistributed();
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "checkHeatmapDistributed",
            value: function() {
                var t = this.w.config, e = t.chart, i = t.plotOptions;
                return "treemap" === e.type && i.treemap && i.treemap.distributed || "heatmap" === e.type && i.heatmap && i.heatmap.distributed;
            }
        },
        {
            key: "checkBarDistributed",
            value: function() {
                var t = this.w.config, e = t.chart, i = t.plotOptions;
                return i.bar && i.bar.distributed && ("bar" === e.type || "rangeBar" === e.type);
            }
        },
        {
            key: "init",
            value: function() {
                this.setDefaultColors();
            }
        },
        {
            key: "setDefaultColors",
            value: function() {
                var t = this.w, e = new $e4b487e979d7c06d$var$v;
                t.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(t.config.theme.mode || "light"));
                var i = $e4b487e979d7c06d$var$f(t.config.colors || t.config.fill.colors || []);
                t.globals.colors = this.getColors(i), this.applySeriesColors(t.globals.seriesColors, t.globals.colors), t.config.theme.monochrome.enabled && (t.globals.colors = this.getMonochromeColors(t.config.theme.monochrome, t.globals.series, e));
                var a = t.globals.colors.slice();
                this.pushExtraColors(t.globals.colors), this.applyColorTypes([
                    "fill",
                    "stroke"
                ], a), this.applyDataLabelsColors(a), this.applyRadarPolygonsColors(), this.applyMarkersColors(a);
            }
        },
        {
            key: "getColors",
            value: function(t) {
                var e = this, i = this.w;
                return t && 0 !== t.length ? Array.isArray(t) && t.length > 0 && "function" == typeof t[0] ? (this.isColorFn = !0, i.config.series.map(function(a, s) {
                    var r = t[s] || t[0];
                    return "function" == typeof r ? r({
                        value: i.globals.axisCharts ? i.globals.series[s][0] || 0 : i.globals.series[s],
                        seriesIndex: s,
                        dataPointIndex: s,
                        w: e.w
                    }) : r;
                })) : t : this.predefined();
            }
        },
        {
            key: "applySeriesColors",
            value: function(t, e) {
                t.forEach(function(t, i) {
                    t && (e[i] = t);
                });
            }
        },
        {
            key: "getMonochromeColors",
            value: function(t, e, i) {
                var a = t.color, s = t.shadeIntensity, r = t.shadeTo, n = this.isBarDistributed || this.isHeatmapDistributed ? e[0].length * e.length : e.length, o = 1 / (n / s), l = 0;
                return Array.from({
                    length: n
                }, function() {
                    var t = "dark" === r ? i.shadeColor(-1 * l, a) : i.shadeColor(l, a);
                    return l += o, t;
                });
            }
        },
        {
            key: "applyColorTypes",
            value: function(t, e) {
                var i = this, a = this.w;
                t.forEach(function(t) {
                    a.globals[t].colors = void 0 === a.config[t].colors ? i.isColorFn ? a.config.colors : e : a.config[t].colors.slice(), i.pushExtraColors(a.globals[t].colors);
                });
            }
        },
        {
            key: "applyDataLabelsColors",
            value: function(t) {
                var e = this.w;
                e.globals.dataLabels.style.colors = void 0 === e.config.dataLabels.style.colors ? t : e.config.dataLabels.style.colors.slice(), this.pushExtraColors(e.globals.dataLabels.style.colors, 50);
            }
        },
        {
            key: "applyRadarPolygonsColors",
            value: function() {
                var t = this.w;
                t.globals.radarPolygons.fill.colors = void 0 === t.config.plotOptions.radar.polygons.fill.colors ? [
                    "dark" === t.config.theme.mode ? "#343A3F" : "none"
                ] : t.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(t.globals.radarPolygons.fill.colors, 20);
            }
        },
        {
            key: "applyMarkersColors",
            value: function(t) {
                var e = this.w;
                e.globals.markers.colors = void 0 === e.config.markers.colors ? t : e.config.markers.colors.slice(), this.pushExtraColors(e.globals.markers.colors);
            }
        },
        {
            key: "pushExtraColors",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = e || a.globals.series.length;
                if (null === i && (i = this.isBarDistributed || this.isHeatmapDistributed || "heatmap" === a.config.chart.type && a.config.plotOptions.heatmap && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), t.length < s) for(var r = s - t.length, n = 0; n < r; n++)t.push(t[n]);
            }
        },
        {
            key: "updateThemeOptions",
            value: function(t) {
                t.chart = t.chart || {}, t.tooltip = t.tooltip || {};
                var e = t.theme.mode, i = "dark" === e ? "palette4" : "light" === e ? "palette1" : t.theme.palette || "palette1", a = "dark" === e ? "#f6f7f8" : "light" === e ? "#373d3f" : t.chart.foreColor || "#373d3f";
                return t.tooltip.theme = e || "light", t.chart.foreColor = a, t.theme.palette = i, t;
            }
        },
        {
            key: "predefined",
            value: function() {
                var t = {
                    palette1: [
                        "#008FFB",
                        "#00E396",
                        "#FEB019",
                        "#FF4560",
                        "#775DD0"
                    ],
                    palette2: [
                        "#3f51b5",
                        "#03a9f4",
                        "#4caf50",
                        "#f9ce1d",
                        "#FF9800"
                    ],
                    palette3: [
                        "#33b2df",
                        "#546E7A",
                        "#d4526e",
                        "#13d8aa",
                        "#A5978B"
                    ],
                    palette4: [
                        "#4ecdc4",
                        "#c7f464",
                        "#81D4FA",
                        "#fd6a6a",
                        "#546E7A"
                    ],
                    palette5: [
                        "#2b908f",
                        "#f9a3a4",
                        "#90ee7e",
                        "#fa4443",
                        "#69d2e7"
                    ],
                    palette6: [
                        "#449DD1",
                        "#F86624",
                        "#EA3546",
                        "#662E9B",
                        "#C5D86D"
                    ],
                    palette7: [
                        "#D7263D",
                        "#1B998B",
                        "#2E294E",
                        "#F46036",
                        "#E2C044"
                    ],
                    palette8: [
                        "#662E9B",
                        "#F86624",
                        "#F9C80E",
                        "#EA3546",
                        "#43BCCD"
                    ],
                    palette9: [
                        "#5C4742",
                        "#A5978B",
                        "#8D5B4C",
                        "#5A2A27",
                        "#C4BBAF"
                    ],
                    palette10: [
                        "#A300D6",
                        "#7D02EB",
                        "#5653FE",
                        "#2983FF",
                        "#00B1F2"
                    ],
                    default: [
                        "#008FFB",
                        "#00E396",
                        "#FEB019",
                        "#FF4560",
                        "#775DD0"
                    ]
                };
                return t[this.w.config.theme.palette] || t.default;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ha = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function() {
                this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
            }
        },
        {
            key: "drawTitleSubtitle",
            value: function(t) {
                var e = this.w, i = "title" === t ? e.config.title : e.config.subtitle, a = e.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                if ("left" === i.align ? (a = 10, r = "start") : "right" === i.align && (a = e.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, void 0 !== i.text) {
                    var n = new $e4b487e979d7c06d$var$Mi(this.ctx).drawText({
                        x: a,
                        y: s,
                        text: i.text,
                        textAnchor: r,
                        fontSize: i.style.fontSize,
                        fontFamily: i.style.fontFamily,
                        fontWeight: i.style.fontWeight,
                        foreColor: i.style.color,
                        opacity: 1
                    });
                    n.node.setAttribute("class", "apexcharts-".concat(t, "-text")), e.globals.dom.Paper.add(n);
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ca = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.dCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getTitleSubtitleCoords",
            value: function(t) {
                var e = this.w, i = 0, a = 0, s = "title" === t ? e.config.title.floating : e.config.subtitle.floating, r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t, "-text"));
                if (null !== r && !s) {
                    var n = r.getBoundingClientRect();
                    i = n.width, a = e.globals.axisCharts ? n.height + 5 : n.height;
                }
                return {
                    width: i,
                    height: a
                };
            }
        },
        {
            key: "getLegendsRect",
            value: function() {
                var t = this.w, e = t.globals.dom.elLegendWrap;
                t.config.legend.height || "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || (e.style.maxHeight = t.globals.svgHeight / 2 + "px");
                var i = Object.assign({}, $e4b487e979d7c06d$var$v.getBoundingClientRect(e));
                return null !== e && !t.config.legend.floating && t.config.legend.show ? this.dCtx.lgRect = {
                    x: i.x,
                    y: i.y,
                    height: i.height,
                    width: 0 === i.height ? 0 : i.width
                } : this.dCtx.lgRect = {
                    x: 0,
                    y: 0,
                    height: 0,
                    width: 0
                }, "left" !== t.config.legend.position && "right" !== t.config.legend.position || 1.5 * this.dCtx.lgRect.width > t.globals.svgWidth && (this.dCtx.lgRect.width = t.globals.svgWidth / 1.5), this.dCtx.lgRect;
            }
        },
        {
            key: "getDatalabelsRect",
            value: function() {
                var t = this, e = this.w, i = [];
                e.config.series.forEach(function(s, r) {
                    s.data.forEach(function(s, n) {
                        var o;
                        o = e.globals.series[r][n], a = e.config.dataLabels.formatter(o, {
                            ctx: t.dCtx.ctx,
                            seriesIndex: r,
                            dataPointIndex: n,
                            w: e
                        }), i.push(a);
                    });
                });
                var a = $e4b487e979d7c06d$var$v.getLargestStringFromArr(i), s = new $e4b487e979d7c06d$var$Mi(this.dCtx.ctx), r = e.config.dataLabels.style, n = s.getTextRects(a, parseInt(r.fontSize), r.fontFamily);
                return {
                    width: 1.05 * n.width,
                    height: n.height
                };
            }
        },
        {
            key: "getLargestStringFromMultiArr",
            value: function(t, e) {
                var i = t;
                if (this.w.globals.isMultiLineX) {
                    var a = e.map(function(t, e) {
                        return Array.isArray(t) ? t.length : 1;
                    }), s = Math.max.apply(Math, $e4b487e979d7c06d$var$f(a));
                    i = e[a.indexOf(s)];
                }
                return i;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$da = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.dCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getxAxisLabelsCoords",
            value: function() {
                var t, e = this.w, i = e.globals.labels.slice();
                if (e.config.xaxis.convertedCatToNumeric && 0 === i.length && (i = e.globals.categoryLabels), e.globals.timescaleLabels.length > 0) {
                    var a = this.getxAxisTimeScaleLabelsCoords();
                    t = {
                        width: a.width,
                        height: a.height
                    }, e.globals.rotateXLabels = !1;
                } else {
                    this.dCtx.lgWidthForSideLegends = "left" !== e.config.legend.position && "right" !== e.config.legend.position || e.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                    var s = e.globals.xLabelFormatter, r = $e4b487e979d7c06d$var$v.getLargestStringFromArr(i), n = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                    e.globals.isBarHorizontal && (n = r = e.globals.yAxisScale[0].result.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0));
                    var o = new $e4b487e979d7c06d$var$Xi(this.dCtx.ctx), l = r;
                    r = o.xLabelFormat(s, r, l, {
                        i: void 0,
                        dateFormatter: new $e4b487e979d7c06d$var$zi(this.dCtx.ctx).formatDate,
                        w: e
                    }), n = o.xLabelFormat(s, n, l, {
                        i: void 0,
                        dateFormatter: new $e4b487e979d7c06d$var$zi(this.dCtx.ctx).formatDate,
                        w: e
                    }), (e.config.xaxis.convertedCatToNumeric && void 0 === r || "" === String(r).trim()) && (n = r = "1");
                    var h = new $e4b487e979d7c06d$var$Mi(this.dCtx.ctx), c = h.getTextRects(r, e.config.xaxis.labels.style.fontSize), d = c;
                    if (r !== n && (d = h.getTextRects(n, e.config.xaxis.labels.style.fontSize)), (t = {
                        width: c.width >= d.width ? c.width : d.width,
                        height: c.height >= d.height ? c.height : d.height
                    }).width * i.length > e.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && 0 !== e.config.xaxis.labels.rotate || e.config.xaxis.labels.rotateAlways) {
                        if (!e.globals.isBarHorizontal) {
                            e.globals.rotateXLabels = !0;
                            var u = function(t) {
                                return h.getTextRects(t, e.config.xaxis.labels.style.fontSize, e.config.xaxis.labels.style.fontFamily, "rotate(".concat(e.config.xaxis.labels.rotate, " 0 0)"), !1);
                            };
                            c = u(r), r !== n && (d = u(n)), t.height = (c.height > d.height ? c.height : d.height) / 1.5, t.width = c.width > d.width ? c.width : d.width;
                        }
                    } else e.globals.rotateXLabels = !1;
                }
                return e.config.xaxis.labels.show || (t = {
                    width: 0,
                    height: 0
                }), {
                    width: t.width,
                    height: t.height
                };
            }
        },
        {
            key: "getxAxisGroupLabelsCoords",
            value: function() {
                var t, e = this.w;
                if (!e.globals.hasXaxisGroups) return {
                    width: 0,
                    height: 0
                };
                var i, a = (null === (t = e.config.xaxis.group.style) || void 0 === t ? void 0 : t.fontSize) || e.config.xaxis.labels.style.fontSize, s = e.globals.groups.map(function(t) {
                    return t.title;
                }), r = $e4b487e979d7c06d$var$v.getLargestStringFromArr(s), n = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, s), o = new $e4b487e979d7c06d$var$Mi(this.dCtx.ctx), l = o.getTextRects(r, a), h = l;
                return r !== n && (h = o.getTextRects(n, a)), i = {
                    width: l.width >= h.width ? l.width : h.width,
                    height: l.height >= h.height ? l.height : h.height
                }, e.config.xaxis.labels.show || (i = {
                    width: 0,
                    height: 0
                }), {
                    width: i.width,
                    height: i.height
                };
            }
        },
        {
            key: "getxAxisTitleCoords",
            value: function() {
                var t = this.w, e = 0, i = 0;
                if (void 0 !== t.config.xaxis.title.text) {
                    var a = new $e4b487e979d7c06d$var$Mi(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text, t.config.xaxis.title.style.fontSize);
                    e = a.width, i = a.height;
                }
                return {
                    width: e,
                    height: i
                };
            }
        },
        {
            key: "getxAxisTimeScaleLabelsCoords",
            value: function() {
                var t, e = this.w;
                this.dCtx.timescaleLabels = e.globals.timescaleLabels.slice();
                var i = this.dCtx.timescaleLabels.map(function(t) {
                    return t.value;
                }), a = i.reduce(function(t, e) {
                    return void 0 === t ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : t.length > e.length ? t : e;
                }, 0);
                return 1.05 * (t = new $e4b487e979d7c06d$var$Mi(this.dCtx.ctx).getTextRects(a, e.config.xaxis.labels.style.fontSize)).width * i.length > e.globals.gridWidth && 0 !== e.config.xaxis.labels.rotate && (e.globals.overlappingXLabels = !0), t;
            }
        },
        {
            key: "additionalPaddingXLabels",
            value: function(t) {
                var e = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, n = t.width;
                a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                var o = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, l = function(t, o) {
                    s.yaxis.length > 1 && function(t) {
                        return -1 !== a.collapsedSeriesIndices.indexOf(t);
                    }(o) || function(t) {
                        if (e.dCtx.timescaleLabels && e.dCtx.timescaleLabels.length) {
                            var o = e.dCtx.timescaleLabels[0], l = e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length - 1].position + n / 1.75 - e.dCtx.yAxisWidthRight, h = o.position - n / 1.75 + e.dCtx.yAxisWidthLeft, c = "right" === i.config.legend.position && e.dCtx.lgRect.width > 0 ? e.dCtx.lgRect.width : 0;
                            l > a.svgWidth - a.translateX - c && (a.skipLastTimelinelabel = !0), h < -(t.show && !t.floating || "bar" !== s.chart.type && "candlestick" !== s.chart.type && "rangeBar" !== s.chart.type && "boxPlot" !== s.chart.type ? 10 : n / 1.75) && (a.skipFirstTimelinelabel = !0);
                        } else "datetime" === r ? e.dCtx.gridPad.right < n && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : "datetime" !== r && e.dCtx.gridPad.right < n / 2 - e.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && (e.dCtx.xPadRight = n / 2 + 1);
                    }(t);
                };
                s.yaxis.forEach(function(t, i) {
                    o ? (e.dCtx.gridPad.left < n && (e.dCtx.xPadLeft = n / 2 + 1), e.dCtx.xPadRight = n / 2 + 1) : l(t, i);
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ua = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.dCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getyAxisLabelsCoords",
            value: function() {
                var t = this, e = this.w, i = [], a = 10, s = new $e4b487e979d7c06d$var$Ri(this.dCtx.ctx);
                return e.config.yaxis.map(function(r, n) {
                    var o = {
                        seriesIndex: n,
                        dataPointIndex: -1,
                        w: e
                    }, l = e.globals.yAxisScale[n], h = 0;
                    if (!s.isYAxisHidden(n) && r.labels.show && void 0 !== r.labels.minWidth && (h = r.labels.minWidth), !s.isYAxisHidden(n) && r.labels.show && l.result.length) {
                        var c = e.globals.yLabelFormatters[n], d = l.niceMin === Number.MIN_VALUE ? 0 : l.niceMin, u = l.result.reduce(function(t, e) {
                            var i, a;
                            return (null === (i = String(c(t, o))) || void 0 === i ? void 0 : i.length) > (null === (a = String(c(e, o))) || void 0 === a ? void 0 : a.length) ? t : e;
                        }, d), g = u = c(u, o);
                        if (void 0 !== u && 0 !== u.length || (u = l.niceMax), e.globals.isBarHorizontal) {
                            a = 0;
                            var p = e.globals.labels.slice();
                            u = $e4b487e979d7c06d$var$v.getLargestStringFromArr(p), u = c(u, {
                                seriesIndex: n,
                                dataPointIndex: -1,
                                w: e
                            }), g = t.dCtx.dimHelpers.getLargestStringFromMultiArr(u, p);
                        }
                        var f = new $e4b487e979d7c06d$var$Mi(t.dCtx.ctx), x = "rotate(".concat(r.labels.rotate, " 0 0)"), b = f.getTextRects(u, r.labels.style.fontSize, r.labels.style.fontFamily, x, !1), m = b;
                        u !== g && (m = f.getTextRects(g, r.labels.style.fontSize, r.labels.style.fontFamily, x, !1)), i.push({
                            width: (h > m.width || h > b.width ? h : m.width > b.width ? m.width : b.width) + a,
                            height: m.height > b.height ? m.height : b.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getyAxisTitleCoords",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.config.yaxis.map(function(e, a) {
                    if (e.show && void 0 !== e.title.text) {
                        var s = new $e4b487e979d7c06d$var$Mi(t.dCtx.ctx), r = "rotate(".concat(e.title.rotate, " 0 0)"), n = s.getTextRects(e.title.text, e.title.style.fontSize, e.title.style.fontFamily, r, !1);
                        i.push({
                            width: n.width,
                            height: n.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getTotalYAxisWidth",
            value: function() {
                var t = this.w, e = 0, i = 0, a = 0, s = t.globals.yAxisScale.length > 1 ? 10 : 0, r = new $e4b487e979d7c06d$var$Ri(this.dCtx.ctx), n = function(n, o) {
                    var l = t.config.yaxis[o].floating, h = 0;
                    n.width > 0 && !l ? (h = n.width + s, function(e) {
                        return t.globals.ignoreYAxisIndexes.indexOf(e) > -1;
                    }(o) && (h = h - n.width - s)) : h = l || r.isYAxisHidden(o) ? 0 : 5, t.config.yaxis[o].opposite ? a += h : i += h, e += h;
                };
                return t.globals.yLabelsCoords.map(function(t, e) {
                    n(t, e);
                }), t.globals.yTitleCoords.map(function(t, e) {
                    n(t, e);
                }), t.globals.isBarHorizontal && !t.config.yaxis[0].floating && (e = t.globals.yLabelsCoords[0].width + t.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, e;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ga = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.dCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "gridPadForColumnsInNumericAxis",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (a.noData || a.collapsedSeries.length + a.ancillaryCollapsedSeries.length === i.series.length) return 0;
                var s = function(t) {
                    return [
                        "bar",
                        "rangeBar",
                        "candlestick",
                        "boxPlot"
                    ].includes(t);
                }, r = i.chart.type, n = 0, o = s(r) ? i.series.length : 1;
                a.comboBarCount > 0 && (o = a.comboBarCount), a.collapsedSeries.forEach(function(t) {
                    s(t.type) && (o -= 1);
                }), i.chart.stacked && (o = 1);
                var l = s(r) || a.comboBarCount > 0, h = Math.abs(a.initialMaxX - a.initialMinX);
                if (l && a.isXNumeric && !a.isBarHorizontal && o > 0 && 0 !== h) {
                    h <= 3 && (h = a.dataPoints);
                    var c = h / t, d = a.minXDiff && a.minXDiff / c > 0 ? a.minXDiff / c : 0;
                    d > t / 2 && (d /= 2), (n = d * parseInt(i.plotOptions.bar.columnWidth, 10) / 100) < 1 && (n = 1), a.barPadForNumericAxis = n;
                }
                return n;
            }
        },
        {
            key: "gridPadFortitleSubtitle",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dCtx.isSparkline || !i.axisCharts ? 0 : 10;
                [
                    "title",
                    "subtitle"
                ].forEach(function(s) {
                    void 0 !== e.config[s].text ? a += e.config[s].margin : a += t.dCtx.isSparkline || !i.axisCharts ? 0 : 5;
                }), !e.config.legend.show || "bottom" !== e.config.legend.position || e.config.legend.floating || i.axisCharts || (a += 10);
                var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                i.gridHeight -= s.height + r.height + a, i.translateY += s.height + r.height + a;
            }
        },
        {
            key: "setGridXPosForDualYAxis",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Ri(this.dCtx.ctx);
                i.config.yaxis.forEach(function(s, r) {
                    -1 !== i.globals.ignoreYAxisIndexes.indexOf(r) || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX -= e[r].width + t[r].width + parseInt(s.labels.style.fontSize, 10) / 1.2 + 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$pa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new $e4b487e979d7c06d$var$ca(this), this.dimYAxis = new $e4b487e979d7c06d$var$ua(this), this.dimXAxis = new $e4b487e979d7c06d$var$da(this), this.dimGrid = new $e4b487e979d7c06d$var$ga(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "plotCoords",
            value: function() {
                var t = this, e = this.w, i = e.globals;
                this.lgRect = this.dimHelpers.getLegendsRect(), this.datalabelsCoords = {
                    width: 0,
                    height: 0
                };
                var a = Array.isArray(e.config.stroke.width) ? Math.max.apply(Math, $e4b487e979d7c06d$var$f(e.config.stroke.width)) : e.config.stroke.width;
                this.isSparkline && ((e.config.markers.discrete.length > 0 || e.config.markers.size > 0) && Object.entries(this.gridPad).forEach(function(e) {
                    var i = $e4b487e979d7c06d$var$p(e, 2), a = i[0], s = i[1];
                    t.gridPad[a] = Math.max(s, t.w.globals.markers.largestSize / 1.5);
                }), this.gridPad.top = Math.max(a / 2, this.gridPad.top), this.gridPad.bottom = Math.max(a / 2, this.gridPad.bottom)), i.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), i.gridHeight = i.gridHeight - this.gridPad.top - this.gridPad.bottom, i.gridWidth = i.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                var s = this.dimGrid.gridPadForColumnsInNumericAxis(i.gridWidth);
                i.gridWidth = i.gridWidth - 2 * s, i.translateX = i.translateX + this.gridPad.left + this.xPadLeft + (s > 0 ? s : 0), i.translateY = i.translateY + this.gridPad.top;
            }
        },
        {
            key: "setDimensionsForAxisCharts",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                i.isSlopeChart && (this.datalabelsCoords = this.dimHelpers.getDatalabelsRect()), e.globals.yLabelsCoords = [], e.globals.yTitleCoords = [], e.config.yaxis.map(function(t, i) {
                    e.globals.yLabelsCoords.push({
                        width: a[i].width,
                        index: i
                    }), e.globals.yTitleCoords.push({
                        width: s[i].width,
                        index: i
                    });
                }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                var r = this.dimXAxis.getxAxisLabelsCoords(), n = this.dimXAxis.getxAxisGroupLabelsCoords(), o = this.dimXAxis.getxAxisTitleCoords();
                this.conditionalChecksForAxisCoords(r, o, n), i.translateXAxisY = e.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = e.globals.rotateXLabels && e.globals.isXNumeric && e.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, e.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(e.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + e.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + e.config.xaxis.labels.offsetX;
                var l = this.yAxisWidth, h = this.xAxisHeight;
                i.xAxisLabelsHeight = this.xAxisHeight - o.height, i.xAxisGroupLabelsHeight = i.xAxisLabelsHeight - r.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                var c = 10;
                ("radar" === e.config.chart.type || this.isSparkline) && (l = 0, h = 0), this.isSparkline && (this.lgRect = {
                    height: 0,
                    width: 0
                }), (this.isSparkline || "treemap" === e.config.chart.type) && (l = 0, h = 0, c = 0), this.isSparkline || "treemap" === e.config.chart.type || this.dimXAxis.additionalPaddingXLabels(r);
                var d = function() {
                    i.translateX = l + t.datalabelsCoords.width, i.gridHeight = i.svgHeight - t.lgRect.height - h - (t.isSparkline || "treemap" === e.config.chart.type ? 0 : e.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - l - 2 * t.datalabelsCoords.width;
                };
                switch("top" === e.config.xaxis.position && (c = i.xAxisHeight - e.config.xaxis.axisTicks.height - 5), e.config.legend.position){
                    case "bottom":
                        i.translateY = c, d();
                        break;
                    case "top":
                        i.translateY = this.lgRect.height + c, d();
                        break;
                    case "left":
                        i.translateY = c, i.translateX = this.lgRect.width + l + this.datalabelsCoords.width, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l - 2 * this.datalabelsCoords.width;
                        break;
                    case "right":
                        i.translateY = c, i.translateX = l + this.datalabelsCoords.width, i.gridHeight = i.svgHeight - h - 12, i.gridWidth = i.svgWidth - this.lgRect.width - l - 2 * this.datalabelsCoords.width - 5;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
                this.dimGrid.setGridXPosForDualYAxis(s, a), new $e4b487e979d7c06d$var$ia(this.ctx).setYAxisXPosition(a, s);
            }
        },
        {
            key: "setDimensionsForNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = 0;
                t.config.legend.show && !t.config.legend.floating && (a = 20);
                var s = "pie" === i.chart.type || "polarArea" === i.chart.type || "donut" === i.chart.type ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, n = i.plotOptions[s].offsetX;
                if (!i.legend.show || i.legend.floating) {
                    e.gridHeight = e.svgHeight;
                    var o = e.dom.elWrap.getBoundingClientRect().width;
                    return e.gridWidth = Math.min(o, e.gridHeight), e.translateY = r, void (e.translateX = n + (e.svgWidth - e.gridWidth) / 2);
                }
                switch(i.legend.position){
                    case "bottom":
                        e.gridHeight = e.svgHeight - this.lgRect.height, e.gridWidth = e.svgWidth, e.translateY = r - 10, e.translateX = n + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "top":
                        e.gridHeight = e.svgHeight - this.lgRect.height, e.gridWidth = e.svgWidth, e.translateY = this.lgRect.height + r + 10, e.translateX = n + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "left":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = n + this.lgRect.width + a;
                        break;
                    case "right":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a - 5, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = n + 10;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
            }
        },
        {
            key: "conditionalChecksForAxisCoords",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.hasXaxisGroups ? 2 : 1, r = i.height + t.height + e.height, n = a.globals.isMultiLineX ? 1.2 : a.globals.LINE_HEIGHT_RATIO, o = a.globals.rotateXLabels ? 22 : 10, l = a.globals.rotateXLabels && "bottom" === a.config.legend.position ? 10 : 0;
                this.xAxisHeight = r * n + s * o + l, this.xAxisWidth = t.width, this.xAxisHeight - e.height > a.config.xaxis.labels.maxHeight && (this.xAxisHeight = a.config.xaxis.labels.maxHeight), a.config.xaxis.labels.minHeight && this.xAxisHeight < a.config.xaxis.labels.minHeight && (this.xAxisHeight = a.config.xaxis.labels.minHeight), a.config.xaxis.floating && (this.xAxisHeight = 0);
                var h = 0, c = 0;
                a.config.yaxis.forEach(function(t) {
                    h += t.labels.minWidth, c += t.labels.maxWidth;
                }), this.yAxisWidth < h && (this.yAxisWidth = h), this.yAxisWidth > c && (this.yAxisWidth = c);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$fa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.lgCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getLegendStyles",
            value: function() {
                var t, e, i, a = document.createElement("style");
                a.setAttribute("type", "text/css");
                var s = (null === (t = this.lgCtx.ctx) || void 0 === t || null === (e = t.opts) || void 0 === e || null === (i = e.chart) || void 0 === i ? void 0 : i.nonce) || this.w.config.chart.nonce;
                s && a.setAttribute("nonce", s);
                var r = document.createTextNode("\n      .apexcharts-flip-y {\n        transform: scaleY(-1) translateY(-100%);\n        transform-origin: top;\n        transform-box: fill-box;\n      }\n      .apexcharts-flip-x {\n        transform: scaleX(-1);\n        transform-origin: center;\n        transform-box: fill-box;\n      }\n      .apexcharts-legend {\n        display: flex;\n        overflow: auto;\n        padding: 0 10px;\n      }\n      .apexcharts-legend.apexcharts-legend-group-horizontal {\n        flex-direction: column;\n      }\n      .apexcharts-legend-group {\n        display: flex;\n      }\n      .apexcharts-legend-group-vertical {\n        flex-direction: column-reverse;\n      }\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {\n        flex-wrap: wrap\n      }\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        flex-direction: column;\n        bottom: 0;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {\n        justify-content: flex-start;\n        align-items: flex-start;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {\n        justify-content: center;\n        align-items: center;\n      }\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {\n        justify-content: flex-end;\n        align-items: flex-end;\n      }\n      .apexcharts-legend-series {\n        cursor: pointer;\n        line-height: normal;\n        display: flex;\n        align-items: center;\n      }\n      .apexcharts-legend-text {\n        position: relative;\n        font-size: 14px;\n      }\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {\n        pointer-events: none;\n      }\n      .apexcharts-legend-marker {\n        position: relative;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: pointer;\n        margin-right: 1px;\n      }\n\n      .apexcharts-legend-series.apexcharts-no-click {\n        cursor: auto;\n      }\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {\n        display: none !important;\n      }\n      .apexcharts-inactive-legend {\n        opacity: 0.45;\n      }\n\n    ");
                return a.appendChild(r), a;
            }
        },
        {
            key: "getLegendDimensions",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), e = t.width;
                return {
                    clwh: t.height,
                    clww: e
                };
            }
        },
        {
            key: "appendToForeignObject",
            value: function() {
                this.w.globals.dom.elLegendForeign.appendChild(this.getLegendStyles());
            }
        },
        {
            key: "toggleDataSeries",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.axisCharts || "radialBar" === a.config.chart.type) {
                    a.globals.resized = !0;
                    var s = null, r = null;
                    if (a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), e) [
                        {
                            cs: a.globals.collapsedSeries,
                            csi: a.globals.collapsedSeriesIndices
                        },
                        {
                            cs: a.globals.ancillaryCollapsedSeries,
                            csi: a.globals.ancillaryCollapsedSeriesIndices
                        }
                    ].forEach(function(t) {
                        i.riseCollapsedSeries(t.cs, t.csi, r);
                    });
                    else this.hideSeries({
                        seriesEl: s,
                        realIndex: r
                    });
                } else {
                    var n = a.globals.dom.Paper.findOne(" .apexcharts-series[rel='".concat(t + 1, "'] path")), o = a.config.chart.type;
                    if ("pie" === o || "polarArea" === o || "donut" === o) {
                        var l = a.config.plotOptions.pie.donut.labels;
                        new $e4b487e979d7c06d$var$Mi(this.lgCtx.ctx).pathMouseDown(n, null), this.lgCtx.ctx.pie.printDataLabelsInner(n.node, l);
                    }
                    n.fire("click");
                }
            }
        },
        {
            key: "getSeriesAfterCollapsing",
            value: function(t) {
                var e = t.realIndex, i = this.w, a = i.globals, s = $e4b487e979d7c06d$var$v.clone(i.config.series);
                if (a.axisCharts) {
                    var r = i.config.yaxis[a.seriesYAxisReverseMap[e]], n = {
                        index: e,
                        data: s[e].data.slice(),
                        type: s[e].type || i.config.chart.type
                    };
                    if (r && r.show && r.showAlways) a.ancillaryCollapsedSeriesIndices.indexOf(e) < 0 && (a.ancillaryCollapsedSeries.push(n), a.ancillaryCollapsedSeriesIndices.push(e));
                    else if (a.collapsedSeriesIndices.indexOf(e) < 0) {
                        a.collapsedSeries.push(n), a.collapsedSeriesIndices.push(e);
                        var o = a.risingSeries.indexOf(e);
                        a.risingSeries.splice(o, 1);
                    }
                } else a.collapsedSeries.push({
                    index: e,
                    data: s[e]
                }), a.collapsedSeriesIndices.push(e);
                return a.allSeriesCollapsed = a.collapsedSeries.length + a.ancillaryCollapsedSeries.length === i.config.series.length, this._getSeriesBasedOnCollapsedState(s);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                for(var e = t.seriesEl, i = t.realIndex, a = this.w, s = this.getSeriesAfterCollapsing({
                    realIndex: i
                }), r = e.childNodes, n = 0; n < r.length; n++)r[n].classList.contains("apexcharts-series-markers-wrap") && (r[n].classList.contains("apexcharts-hide") ? r[n].classList.remove("apexcharts-hide") : r[n].classList.add("apexcharts-hide"));
                this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
            }
        },
        {
            key: "riseCollapsedSeries",
            value: function(t, e, i) {
                var a = this.w, s = $e4b487e979d7c06d$var$v.clone(a.config.series);
                if (t.length > 0) {
                    for(var r = 0; r < t.length; r++)t[r].index === i && (a.globals.axisCharts ? s[i].data = t[r].data.slice() : s[i] = t[r].data, "number" != typeof s[i] && (s[i].hidden = !1), t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i));
                    s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            }
        },
        {
            key: "_getSeriesBasedOnCollapsedState",
            value: function(t) {
                var e = this.w, i = 0;
                return e.globals.axisCharts ? t.forEach(function(a, s) {
                    e.globals.collapsedSeriesIndices.indexOf(s) < 0 && e.globals.ancillaryCollapsedSeriesIndices.indexOf(s) < 0 || (t[s].data = [], i++);
                }) : t.forEach(function(a, s) {
                    !e.globals.collapsedSeriesIndices.indexOf(s) < 0 && (t[s] = 0, i++);
                }), e.globals.allSeriesCollapsed = i === t.length, t;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$xa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = "bar" === this.w.config.chart.type && this.w.config.plotOptions.bar.distributed && 1 === this.w.config.series.length, this.legendHelpers = new $e4b487e979d7c06d$var$fa(this);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "init",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = i.legend.showForSingleSeries && 1 === e.series.length || this.isBarsDistributed || e.series.length > 1;
                if (this.legendHelpers.appendToForeignObject(), (a || !e.axisCharts) && i.legend.show) {
                    for(; e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);
                    this.drawLegends(), "bottom" === i.legend.position || "top" === i.legend.position ? this.legendAlignHorizontal() : "right" !== i.legend.position && "left" !== i.legend.position || this.legendAlignVertical();
                }
            }
        },
        {
            key: "createLegendMarker",
            value: function(t) {
                var e = t.i, i = t.fillcolor, a = this.w, s = document.createElement("span");
                s.classList.add("apexcharts-legend-marker");
                var r = a.config.legend.markers.shape || a.config.markers.shape, n = r;
                Array.isArray(r) && (n = r[e]);
                var o = Array.isArray(a.config.legend.markers.size) ? parseFloat(a.config.legend.markers.size[e]) : parseFloat(a.config.legend.markers.size), l = Array.isArray(a.config.legend.markers.offsetX) ? parseFloat(a.config.legend.markers.offsetX[e]) : parseFloat(a.config.legend.markers.offsetX), h = Array.isArray(a.config.legend.markers.offsetY) ? parseFloat(a.config.legend.markers.offsetY[e]) : parseFloat(a.config.legend.markers.offsetY), c = Array.isArray(a.config.legend.markers.strokeWidth) ? parseFloat(a.config.legend.markers.strokeWidth[e]) : parseFloat(a.config.legend.markers.strokeWidth), d = s.style;
                if (d.height = 2 * (o + c) + "px", d.width = 2 * (o + c) + "px", d.left = l + "px", d.top = h + "px", a.config.legend.markers.customHTML) d.background = "transparent", d.color = i[e], Array.isArray(a.config.legend.markers.customHTML) ? a.config.legend.markers.customHTML[e] && (s.innerHTML = a.config.legend.markers.customHTML[e]()) : s.innerHTML = a.config.legend.markers.customHTML();
                else {
                    var g = new $e4b487e979d7c06d$var$Vi(this.ctx).getMarkerConfig({
                        cssClass: "apexcharts-legend-marker apexcharts-marker apexcharts-marker-".concat(n),
                        seriesIndex: e,
                        strokeWidth: c,
                        size: o
                    }), p = window.SVG().addTo(s).size("100%", "100%"), f = new $e4b487e979d7c06d$var$Mi(this.ctx).drawMarker(0, 0, $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, g), {}, {
                        pointFillColor: Array.isArray(i) ? i[e] : g.pointFillColor,
                        shape: n
                    }));
                    a.globals.dom.Paper.find(".apexcharts-legend-marker.apexcharts-marker").forEach(function(t) {
                        t.node.classList.contains("apexcharts-marker-triangle") ? t.node.style.transform = "translate(50%, 45%)" : t.node.style.transform = "translate(50%, 50%)";
                    }), p.add(f);
                }
                return s;
            }
        },
        {
            key: "drawLegends",
            value: function() {
                var t = this, e = this, i = this.w, a = i.config.legend.fontFamily, s = i.globals.seriesNames, r = i.config.legend.markers.fillColors ? i.config.legend.markers.fillColors.slice() : i.globals.colors.slice();
                if ("heatmap" === i.config.chart.type) {
                    var n = i.config.plotOptions.heatmap.colorScale.ranges;
                    s = n.map(function(t) {
                        return t.name ? t.name : t.from + " - " + t.to;
                    }), r = n.map(function(t) {
                        return t.color;
                    });
                } else this.isBarsDistributed && (s = i.globals.labels.slice());
                i.config.legend.customLegendItems.length && (s = i.config.legend.customLegendItems);
                var o = i.globals.legendFormatter, l = i.config.legend.inverseOrder, h = [];
                i.globals.seriesGroups.length > 1 && i.config.legend.clusterGroupedSeries && i.globals.seriesGroups.forEach(function(t, e) {
                    h[e] = document.createElement("div"), h[e].classList.add("apexcharts-legend-group", "apexcharts-legend-group-".concat(e)), "horizontal" === i.config.legend.clusterGroupedSeriesOrientation ? i.globals.dom.elLegendWrap.classList.add("apexcharts-legend-group-horizontal") : h[e].classList.add("apexcharts-legend-group-vertical");
                });
                for(var c = function(e) {
                    var n, l = o(s[e], {
                        seriesIndex: e,
                        w: i
                    }), c = !1, d = !1;
                    if (i.globals.collapsedSeries.length > 0) for(var u = 0; u < i.globals.collapsedSeries.length; u++)i.globals.collapsedSeries[u].index === e && (c = !0);
                    if (i.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var g = 0; g < i.globals.ancillaryCollapsedSeriesIndices.length; g++)i.globals.ancillaryCollapsedSeriesIndices[g] === e && (d = !0);
                    var p = t.createLegendMarker({
                        i: e,
                        fillcolor: r
                    });
                    $e4b487e979d7c06d$var$Mi.setAttrs(p, {
                        rel: e + 1,
                        "data:collapsed": c || d
                    }), (c || d) && p.classList.add("apexcharts-inactive-legend");
                    var f = document.createElement("div"), x = document.createElement("span");
                    x.classList.add("apexcharts-legend-text"), x.innerHTML = Array.isArray(l) ? l.join(" ") : l;
                    var b = i.config.legend.labels.useSeriesColors ? i.globals.colors[e] : Array.isArray(i.config.legend.labels.colors) ? null === (n = i.config.legend.labels.colors) || void 0 === n ? void 0 : n[e] : i.config.legend.labels.colors;
                    b || (b = i.config.chart.foreColor), x.style.color = b, x.style.fontSize = parseFloat(i.config.legend.fontSize) + "px", x.style.fontWeight = i.config.legend.fontWeight, x.style.fontFamily = a || i.config.chart.fontFamily, $e4b487e979d7c06d$var$Mi.setAttrs(x, {
                        rel: e + 1,
                        i: e,
                        "data:default-text": encodeURIComponent(l),
                        "data:collapsed": c || d
                    }), f.appendChild(p), f.appendChild(x);
                    var m = new $e4b487e979d7c06d$var$Pi(t.ctx);
                    i.config.legend.showForZeroSeries || 0 === m.getSeriesTotalByIndex(e) && m.seriesHaveSameValues(e) && !m.isSeriesNull(e) && -1 === i.globals.collapsedSeriesIndices.indexOf(e) && -1 === i.globals.ancillaryCollapsedSeriesIndices.indexOf(e) && f.classList.add("apexcharts-hidden-zero-series");
                    i.config.legend.showForNullSeries || m.isSeriesNull(e) && -1 === i.globals.collapsedSeriesIndices.indexOf(e) && -1 === i.globals.ancillaryCollapsedSeriesIndices.indexOf(e) && f.classList.add("apexcharts-hidden-null-series"), h.length ? i.globals.seriesGroups.forEach(function(t, a) {
                        var s;
                        t.includes(null === (s = i.config.series[e]) || void 0 === s ? void 0 : s.name) && (i.globals.dom.elLegendWrap.appendChild(h[a]), h[a].appendChild(f));
                    }) : i.globals.dom.elLegendWrap.appendChild(f), i.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(i.config.legend.horizontalAlign)), i.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + i.config.legend.position), f.classList.add("apexcharts-legend-series"), f.style.margin = "".concat(i.config.legend.itemMargin.vertical, "px ").concat(i.config.legend.itemMargin.horizontal, "px"), i.globals.dom.elLegendWrap.style.width = i.config.legend.width ? i.config.legend.width + "px" : "", i.globals.dom.elLegendWrap.style.height = i.config.legend.height ? i.config.legend.height + "px" : "", $e4b487e979d7c06d$var$Mi.setAttrs(f, {
                        rel: e + 1,
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(s[e]),
                        "data:collapsed": c || d
                    }), (c || d) && f.classList.add("apexcharts-inactive-legend"), i.config.legend.onItemClick.toggleDataSeries || f.classList.add("apexcharts-no-click");
                }, d = l ? s.length - 1 : 0; l ? d >= 0 : d <= s.length - 1; l ? d-- : d++)c(d);
                i.globals.dom.elWrap.addEventListener("click", e.onLegendClick, !0), i.config.legend.onItemHover.highlightDataSeries && 0 === i.config.legend.customLegendItems.length && (i.globals.dom.elWrap.addEventListener("mousemove", e.onLegendHovered, !0), i.globals.dom.elWrap.addEventListener("mouseout", e.onLegendHovered, !0));
            }
        },
        {
            key: "setLegendWrapXY",
            value: function(t, e) {
                var i = this.w, a = i.globals.dom.elLegendWrap, s = a.clientHeight, r = 0, n = 0;
                if ("bottom" === i.config.legend.position) n = i.globals.svgHeight - Math.min(s, i.globals.svgHeight / 2) - 5;
                else if ("top" === i.config.legend.position) {
                    var o = new $e4b487e979d7c06d$var$pa(this.ctx), l = o.dimHelpers.getTitleSubtitleCoords("title").height, h = o.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                    n = (l > 0 ? l - 10 : 0) + (h > 0 ? h - 10 : 0);
                }
                a.style.position = "absolute", r = r + t + i.config.legend.offsetX, n = n + e + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = n + "px", "right" === i.config.legend.position && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px");
                [
                    "width",
                    "height"
                ].forEach(function(t) {
                    a.style[t] && (a.style[t] = parseInt(i.config.legend[t], 10) + "px");
                });
            }
        },
        {
            key: "legendAlignHorizontal",
            value: function() {
                var t = this.w;
                t.globals.dom.elLegendWrap.style.right = 0;
                var e = new $e4b487e979d7c06d$var$pa(this.ctx), i = e.dimHelpers.getTitleSubtitleCoords("title"), a = e.dimHelpers.getTitleSubtitleCoords("subtitle"), s = 0;
                "top" === t.config.legend.position && (s = i.height + a.height + t.config.title.margin + t.config.subtitle.margin - 10), this.setLegendWrapXY(20, s);
            }
        },
        {
            key: "legendAlignVertical",
            value: function() {
                var t = this.w, e = this.legendHelpers.getLegendDimensions(), i = 0;
                "left" === t.config.legend.position && (i = 20), "right" === t.config.legend.position && (i = t.globals.svgWidth - e.clww - 10), this.setLegendWrapXY(i, 20);
            }
        },
        {
            key: "onLegendHovered",
            value: function(t) {
                var e = this.w, i = t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker");
                if ("heatmap" === e.config.chart.type || this.isBarsDistributed) {
                    if (i) {
                        var a = parseInt(t.target.getAttribute("rel"), 10) - 1;
                        this.ctx.events.fireEvent("legendHover", [
                            this.ctx,
                            a,
                            this.w
                        ]), new $e4b487e979d7c06d$var$Zi(this.ctx).highlightRangeInSeries(t, t.target);
                    }
                } else !t.target.classList.contains("apexcharts-inactive-legend") && i && new $e4b487e979d7c06d$var$Zi(this.ctx).toggleSeriesOnHover(t, t.target);
            }
        },
        {
            key: "onLegendClick",
            value: function(t) {
                var e = this.w;
                if (!e.config.legend.customLegendItems.length && (t.target.classList.contains("apexcharts-legend-series") || t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker"))) {
                    var i = parseInt(t.target.getAttribute("rel"), 10) - 1, a = "true" === t.target.getAttribute("data:collapsed"), s = this.w.config.chart.events.legendClick;
                    "function" == typeof s && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                        this.ctx,
                        i,
                        this.w
                    ]);
                    var r = this.w.config.legend.markers.onClick;
                    "function" == typeof r && t.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                        this.ctx,
                        i,
                        this.w
                    ])), "treemap" !== e.config.chart.type && "heatmap" !== e.config.chart.type && !this.isBarsDistributed && e.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ba = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = a.globals.minX, this.maxX = a.globals.maxX;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "createToolbar",
            value: function() {
                var t = this, e = this.w, i = function() {
                    return document.createElement("div");
                }, a = i();
                if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = e.config.chart.toolbar.offsetY + "px", a.style.right = 3 - e.config.chart.toolbar.offsetX + "px", e.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = e.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                var r = [], n = function(i, a, s) {
                    var n = i.toLowerCase();
                    t.t[n] && e.config.chart.zoom.enabled && r.push({
                        el: a,
                        icon: "string" == typeof t.t[n] ? t.t[n] : s,
                        title: t.localeValues[i],
                        class: "apexcharts-".concat(n, "-icon")
                    });
                };
                n("zoomIn", this.elZoomIn, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'), n("zoomOut", this.elZoomOut, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');
                var o = function(i) {
                    t.t[i] && e.config.chart[i].enabled && r.push({
                        el: "zoom" === i ? t.elZoom : t.elSelection,
                        icon: "string" == typeof t.t[i] ? t.t[i] : "zoom" === i ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>' : '<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',
                        title: t.localeValues["zoom" === i ? "selectionZoom" : "selection"],
                        class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(i, "-icon")
                    });
                };
                o("zoom"), o("selection"), this.t.pan && e.config.chart.zoom.enabled && r.push({
                    el: this.elPan,
                    icon: "string" == typeof this.t.pan ? this.t.pan : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',
                    title: this.localeValues.pan,
                    class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                }), n("reset", this.elZoomReset, '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'), this.t.download && r.push({
                    el: this.elMenuIcon,
                    icon: "string" == typeof this.t.download ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                    title: this.localeValues.menu,
                    class: "apexcharts-menu-icon"
                });
                for(var l = 0; l < this.elCustomIcons.length; l++)r.push({
                    el: this.elCustomIcons[l],
                    icon: this.t.customIcons[l].icon,
                    title: this.t.customIcons[l].title,
                    index: this.t.customIcons[l].index,
                    class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[l].class
                });
                r.forEach(function(t, e) {
                    t.index && $e4b487e979d7c06d$var$v.moveIndexInArray(r, e, t.index);
                });
                for(var h = 0; h < r.length; h++)$e4b487e979d7c06d$var$Mi.setAttrs(r[h].el, {
                    class: r[h].class,
                    title: r[h].title
                }), r[h].el.innerHTML = r[h].icon, a.appendChild(r[h].el);
                this._createHamburgerMenu(a), e.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : e.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : e.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
            }
        },
        {
            key: "_createHamburgerMenu",
            value: function(t) {
                this.elMenuItems = [], t.appendChild(this.elMenu), $e4b487e979d7c06d$var$Mi.setAttrs(this.elMenu, {
                    class: "apexcharts-menu"
                });
                for(var e = [
                    {
                        name: "exportSVG",
                        title: this.localeValues.exportToSVG
                    },
                    {
                        name: "exportPNG",
                        title: this.localeValues.exportToPNG
                    },
                    {
                        name: "exportCSV",
                        title: this.localeValues.exportToCSV
                    }
                ], i = 0; i < e.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = e[i].title, $e4b487e979d7c06d$var$Mi.setAttrs(this.elMenuItems[i], {
                    class: "apexcharts-menu-item ".concat(e[i].name),
                    title: e[i].title
                }), this.elMenu.appendChild(this.elMenuItems[i]);
            }
        },
        {
            key: "addToolbarEventListeners",
            value: function() {
                var t = this;
                this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(e) {
                    e.classList.contains("exportSVG") ? e.addEventListener("click", t.handleDownload.bind(t, "svg")) : e.classList.contains("exportPNG") ? e.addEventListener("click", t.handleDownload.bind(t, "png")) : e.classList.contains("exportCSV") && e.addEventListener("click", t.handleDownload.bind(t, "csv"));
                });
                for(var e = 0; e < this.t.customIcons.length; e++)this.elCustomIcons[e].addEventListener("click", this.t.customIcons[e].click.bind(this, this.ctx, this.ctx.w));
            }
        },
        {
            key: "toggleZoomSelection",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(e) {
                    e.ctx.toolbar.toggleOtherControls();
                    var i = "selection" === t ? e.ctx.toolbar.elSelection : e.ctx.toolbar.elZoom, a = "selection" === t ? "selectionEnabled" : "zoomEnabled";
                    e.w.globals[a] = !e.w.globals[a], i.classList.contains(e.ctx.toolbar.selectedClass) ? i.classList.remove(e.ctx.toolbar.selectedClass) : i.classList.add(e.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "getToolbarIconsReference",
            value: function() {
                var t = this.w;
                this.elZoom || (this.elZoom = t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
            }
        },
        {
            key: "enableZoomPanFromToolbar",
            value: function(t) {
                this.toggleOtherControls(), "pan" === t ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                var e = "pan" === t ? this.elPan : this.elZoom, i = "pan" === t ? this.elZoom : this.elPan;
                e && e.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
            }
        },
        {
            key: "togglePanning",
            value: function() {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    t.ctx.toolbar.toggleOtherControls(), t.w.globals.panEnabled = !t.w.globals.panEnabled, t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass) ? t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass) : t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "toggleOtherControls",
            value: function() {
                var t = this, e = this.w;
                e.globals.panEnabled = !1, e.globals.zoomEnabled = !1, e.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                    this.elPan,
                    this.elSelection,
                    this.elZoom
                ].forEach(function(e) {
                    e && e.classList.remove(t.selectedClass);
                });
            }
        },
        {
            key: "handleZoomIn",
            value: function() {
                var t = this.w;
                t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY);
                var e = (this.minX + this.maxX) / 2, i = (this.minX + e) / 2, a = (this.maxX + e) / 2, s = this._getNewMinXMaxX(i, a);
                t.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
            }
        },
        {
            key: "handleZoomOut",
            value: function() {
                var t = this.w;
                if (t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY), !("datetime" === t.config.xaxis.type && new Date(this.minX).getUTCFullYear() < 1e3)) {
                    var e = (this.minX + this.maxX) / 2, i = this.minX - (e - this.minX), a = this.maxX - (e - this.maxX), s = this._getNewMinXMaxX(i, a);
                    t.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            }
        },
        {
            key: "_getNewMinXMaxX",
            value: function(t, e) {
                var i = this.w.config.xaxis.convertedCatToNumeric;
                return {
                    minX: i ? Math.floor(t) : t,
                    maxX: i ? Math.floor(e) : e
                };
            }
        },
        {
            key: "zoomUpdateOptions",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== t || void 0 !== e) {
                    if (!(i.config.xaxis.convertedCatToNumeric && (t < 1 && (t = 1, e = i.globals.dataPoints), e - t < 2))) {
                        var a = {
                            min: t,
                            max: e
                        }, s = this.getBeforeZoomRange(a);
                        s && (a = s.xaxis);
                        var r = {
                            xaxis: a
                        }, n = $e4b487e979d7c06d$var$v.clone(i.globals.initialConfig.yaxis);
                        i.config.chart.group || (r.yaxis = n), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, n);
                    }
                } else this.handleZoomReset();
            }
        },
        {
            key: "zoomCallback",
            value: function(t, e) {
                "function" == typeof this.ev.zoomed && (this.ev.zoomed(this.ctx, {
                    xaxis: t,
                    yaxis: e
                }), this.ctx.events.fireEvent("zoomed", {
                    xaxis: t,
                    yaxis: e
                }));
            }
        },
        {
            key: "getBeforeZoomRange",
            value: function(t, e) {
                var i = null;
                return "function" == typeof this.ev.beforeZoom && (i = this.ev.beforeZoom(this, {
                    xaxis: t,
                    yaxis: e
                })), i;
            }
        },
        {
            key: "toggleMenu",
            value: function() {
                var t = this;
                window.setTimeout(function() {
                    t.elMenu.classList.contains("apexcharts-menu-open") ? t.elMenu.classList.remove("apexcharts-menu-open") : t.elMenu.classList.add("apexcharts-menu-open");
                }, 0);
            }
        },
        {
            key: "handleDownload",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Ji(this.ctx);
                switch(t){
                    case "svg":
                        i.exportToSVG(this.ctx);
                        break;
                    case "png":
                        i.exportToPng(this.ctx);
                        break;
                    case "csv":
                        i.exportToCSV({
                            series: e.config.series,
                            columnDelimiter: e.config.chart.toolbar.export.csv.columnDelimiter
                        });
                }
            }
        },
        {
            key: "handleZoomReset",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    var e = t.w;
                    if (e.globals.lastXAxis.min = e.globals.initialConfig.xaxis.min, e.globals.lastXAxis.max = e.globals.initialConfig.xaxis.max, t.updateHelpers.revertDefaultAxisMinMax(), "function" == typeof e.config.chart.events.beforeResetZoom) {
                        var i = e.config.chart.events.beforeResetZoom(t, e);
                        i && t.updateHelpers.revertDefaultAxisMinMax(i);
                    }
                    "function" == typeof e.config.chart.events.zoomed && t.ctx.toolbar.zoomCallback({
                        min: e.config.xaxis.min,
                        max: e.config.xaxis.max
                    }), e.globals.zoomed = !1;
                    var a = t.ctx.series.emptyCollapsedSeries($e4b487e979d7c06d$var$v.clone(e.globals.initialSeries));
                    t.updateHelpers._updateSeries(a, e.config.chart.animations.dynamicAnimation.enabled);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ma = function(t) {
    $e4b487e979d7c06d$var$h(a, $e4b487e979d7c06d$var$ba);
    var e = $e4b487e979d7c06d$var$n(a);
    function a(t) {
        var s;
        return $e4b487e979d7c06d$var$i(this, a), (s = e.call(this, t)).ctx = t, s.w = t.w, s.dragged = !1, s.graphics = new $e4b487e979d7c06d$var$Mi(s.ctx), s.eventList = [
            "mousedown",
            "mouseleave",
            "mousemove",
            "touchstart",
            "touchmove",
            "mouseup",
            "touchend",
            "wheel"
        ], s.clientX = 0, s.clientY = 0, s.startX = 0, s.endX = 0, s.dragX = 0, s.startY = 0, s.endY = 0, s.dragY = 0, s.moveDirection = "none", s.debounceTimer = null, s.debounceDelay = 100, s.wheelDelay = 400, s;
    }
    return $e4b487e979d7c06d$var$s(a, [
        {
            key: "init",
            value: function(t) {
                var e = this, i = t.xyRatios, a = this.w, s = this;
                this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = a.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.constraints = new $e4b487e979d7c06d$var$kt(0, 0, a.globals.gridWidth, a.globals.gridHeight), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), a.globals.dom.Paper.add(this.zoomRect), a.globals.dom.Paper.add(this.selectionRect), "x" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    minY: 0,
                    maxX: a.globals.gridWidth,
                    maxY: a.globals.gridHeight
                }).on("dragmove.namespace", this.selectionDragging.bind(this, "dragging")) : "y" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    maxX: a.globals.gridWidth
                }).on("dragmove.namespace", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove.namespace", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(t) {
                    e.hoverArea.addEventListener(t, s.svgMouseEvents.bind(s, i), {
                        capture: !1,
                        passive: !0
                    });
                }), a.config.chart.zoom.enabled && a.config.chart.zoom.allowMouseWheelZoom && this.hoverArea.addEventListener("wheel", s.mouseWheelEvent.bind(s), {
                    capture: !1,
                    passive: !1
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
            }
        },
        {
            key: "svgMouseEvents",
            value: function(t, e) {
                var i = this.w, a = this.ctx.toolbar, s = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type, r = i.config.chart.toolbar.autoSelected;
                if (e.shiftKey ? (this.shiftWasPressed = !0, a.enableZoomPanFromToolbar("pan" === r ? "zoom" : "pan")) : this.shiftWasPressed && (a.enableZoomPanFromToolbar(r), this.shiftWasPressed = !1), e.target) {
                    var n, o = e.target.classList;
                    if (e.target.parentNode && null !== e.target.parentNode && (n = e.target.parentNode.classList), !(o.contains("apexcharts-legend-marker") || o.contains("apexcharts-legend-text") || n && n.contains("apexcharts-toolbar"))) {
                        if (this.clientX = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientX : "touchend" === e.type ? e.changedTouches[0].clientX : e.clientX, this.clientY = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientY : "touchend" === e.type ? e.changedTouches[0].clientY : e.clientY, "mousedown" === e.type && 1 === e.which || "touchstart" === e.type) {
                            var l = this.gridRect.getBoundingClientRect();
                            this.startX = this.clientX - l.left - i.globals.barPadForNumericAxis, this.startY = this.clientY - l.top, this.dragged = !1, this.w.globals.mousedown = !0;
                        }
                        ("mousemove" === e.type && 1 === e.which || "touchmove" === e.type) && (this.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, this.w.globals.mousedown && this.panDragging({
                            context: this,
                            zoomtype: s,
                            xyRatios: t
                        })) : (this.w.globals.mousedown && i.globals.zoomEnabled || this.w.globals.mousedown && i.globals.selectionEnabled) && (this.selection = this.selectionDrawing({
                            context: this,
                            zoomtype: s
                        }))), "mouseup" !== e.type && "touchend" !== e.type && "mouseleave" !== e.type || this.handleMouseUp({
                            zoomtype: s
                        }), this.makeSelectionRectDraggable();
                    }
                }
            }
        },
        {
            key: "handleMouseUp",
            value: function(t) {
                var e, i = t.zoomtype, a = t.isResized, s = this.w, r = null === (e = this.gridRect) || void 0 === e ? void 0 : e.getBoundingClientRect();
                r && (this.w.globals.mousedown || a) && (this.endX = this.clientX - r.left - s.globals.barPadForNumericAxis, this.endY = this.clientY - r.top, this.dragX = Math.abs(this.endX - this.startX), this.dragY = Math.abs(this.endY - this.startY), (s.globals.zoomEnabled || s.globals.selectionEnabled) && this.selectionDrawn({
                    context: this,
                    zoomtype: i
                })), s.globals.zoomEnabled && this.hideSelectionRect(this.selectionRect), this.dragged = !1, this.w.globals.mousedown = !1;
            }
        },
        {
            key: "mouseWheelEvent",
            value: function(t) {
                var e = this, i = this.w;
                t.preventDefault();
                var a = Date.now();
                a - i.globals.lastWheelExecution > this.wheelDelay && (this.executeMouseWheelZoom(t), i.globals.lastWheelExecution = a), this.debounceTimer && clearTimeout(this.debounceTimer), this.debounceTimer = setTimeout(function() {
                    a - i.globals.lastWheelExecution > e.wheelDelay && (e.executeMouseWheelZoom(t), i.globals.lastWheelExecution = a);
                }, this.debounceDelay);
            }
        },
        {
            key: "executeMouseWheelZoom",
            value: function(t) {
                var e, i = this.w;
                this.minX = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, this.maxX = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                var a = null === (e = this.gridRect) || void 0 === e ? void 0 : e.getBoundingClientRect();
                if (a) {
                    var s, r, n, o = (t.clientX - a.left) / a.width, l = this.minX, h = this.maxX, c = h - l;
                    if (t.deltaY < 0) {
                        var d = l + o * c;
                        r = d - (s = .5 * c) / 2, n = d + s / 2;
                    } else r = l - (s = 1.5 * c) / 2, n = h + s / 2;
                    if (!i.globals.isRangeBar) {
                        r = Math.max(r, i.globals.initialMinX), n = Math.min(n, i.globals.initialMaxX);
                        var u = .01 * (i.globals.initialMaxX - i.globals.initialMinX);
                        if (n - r < u) {
                            var g = (r + n) / 2;
                            r = g - u / 2, n = g + u / 2;
                        }
                    }
                    var p = this._getNewMinXMaxX(r, n);
                    isNaN(p.minX) || isNaN(p.maxX) || this.zoomUpdateOptions(p.minX, p.maxX);
                }
            }
        },
        {
            key: "makeSelectionRectDraggable",
            value: function() {
                var t = this, e = this.w;
                if (this.selectionRect) {
                    var i = this.selectionRect.node.getBoundingClientRect();
                    i.width > 0 && i.height > 0 && (this.selectionRect.select(!1).resize(!1), this.selectionRect.select({
                        createRot: function() {},
                        updateRot: function() {},
                        createHandle: function(t, e, i, a, s) {
                            return "l" === s || "r" === s ? t.circle(8).css({
                                "stroke-width": 1,
                                stroke: "#333",
                                fill: "#fff"
                            }) : t.circle(0);
                        },
                        updateHandle: function(t, e) {
                            return t.center(e[0], e[1]);
                        }
                    }).resize().on("resize", function() {
                        var i = e.globals.zoomEnabled ? e.config.chart.zoom.type : e.config.chart.selection.type;
                        t.handleMouseUp({
                            zoomtype: i,
                            isResized: !0
                        });
                    }));
                }
            }
        },
        {
            key: "preselectedSelection",
            value: function() {
                var t = this.w, e = this.xyRatios;
                if (!t.globals.zoomEnabled) {
                    if (void 0 !== t.globals.selection && null !== t.globals.selection) this.drawSelectionRect($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, t.globals.selection), {}, {
                        translateX: t.globals.translateX,
                        translateY: t.globals.translateY
                    }));
                    else if (void 0 !== t.config.chart.selection.xaxis.min && void 0 !== t.config.chart.selection.xaxis.max) {
                        var i = (t.config.chart.selection.xaxis.min - t.globals.minX) / e.xRatio, a = t.globals.gridWidth - (t.globals.maxX - t.config.chart.selection.xaxis.max) / e.xRatio - i;
                        t.globals.isRangeBar && (i = (t.config.chart.selection.xaxis.min - t.globals.yAxisScale[0].niceMin) / e.invertedYRatio, a = (t.config.chart.selection.xaxis.max - t.config.chart.selection.xaxis.min) / e.invertedYRatio);
                        var s = {
                            x: i,
                            y: 0,
                            width: a,
                            height: t.globals.gridHeight,
                            translateX: t.globals.translateX,
                            translateY: t.globals.translateY,
                            selectionEnabled: !0
                        };
                        this.drawSelectionRect(s), this.makeSelectionRectDraggable(), "function" == typeof t.config.chart.events.selection && t.config.chart.events.selection(this.ctx, {
                            xaxis: {
                                min: t.config.chart.selection.xaxis.min,
                                max: t.config.chart.selection.xaxis.max
                            },
                            yaxis: {}
                        });
                    }
                }
            }
        },
        {
            key: "drawSelectionRect",
            value: function(t) {
                var e = t.x, i = t.y, a = t.width, s = t.height, r = t.translateX, n = void 0 === r ? 0 : r, o = t.translateY, l = void 0 === o ? 0 : o, h = this.w, c = this.zoomRect, d = this.selectionRect;
                if (this.dragged || null !== h.globals.selection) {
                    var u = {
                        transform: "translate(" + n + ", " + l + ")"
                    };
                    h.globals.zoomEnabled && this.dragged && (a < 0 && (a = 1), c.attr({
                        x: e,
                        y: i,
                        width: a,
                        height: s,
                        fill: h.config.chart.zoom.zoomedArea.fill.color,
                        "fill-opacity": h.config.chart.zoom.zoomedArea.fill.opacity,
                        stroke: h.config.chart.zoom.zoomedArea.stroke.color,
                        "stroke-width": h.config.chart.zoom.zoomedArea.stroke.width,
                        "stroke-opacity": h.config.chart.zoom.zoomedArea.stroke.opacity
                    }), $e4b487e979d7c06d$var$Mi.setAttrs(c.node, u)), h.globals.selectionEnabled && (d.attr({
                        x: e,
                        y: i,
                        width: a > 0 ? a : 0,
                        height: s > 0 ? s : 0,
                        fill: h.config.chart.selection.fill.color,
                        "fill-opacity": h.config.chart.selection.fill.opacity,
                        stroke: h.config.chart.selection.stroke.color,
                        "stroke-width": h.config.chart.selection.stroke.width,
                        "stroke-dasharray": h.config.chart.selection.stroke.dashArray,
                        "stroke-opacity": h.config.chart.selection.stroke.opacity
                    }), $e4b487e979d7c06d$var$Mi.setAttrs(d.node, u));
                }
            }
        },
        {
            key: "hideSelectionRect",
            value: function(t) {
                t && t.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
        },
        {
            key: "selectionDrawing",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.gridRect.getBoundingClientRect(), n = s.startX - 1, o = s.startY, l = !1, h = !1, c = s.clientX - r.left - a.globals.barPadForNumericAxis, d = s.clientY - r.top, g = c - n, p = d - o, f = {
                    translateX: a.globals.translateX,
                    translateY: a.globals.translateY
                };
                return Math.abs(g + n) > a.globals.gridWidth ? g = a.globals.gridWidth - n : c < 0 && (g = n), n > c && (l = !0, g = Math.abs(g)), o > d && (h = !0, p = Math.abs(p)), f = $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, f = "x" === i ? {
                    x: l ? n - g : n,
                    y: 0,
                    width: g,
                    height: a.globals.gridHeight
                } : "y" === i ? {
                    x: 0,
                    y: h ? o - p : o,
                    width: a.globals.gridWidth,
                    height: p
                } : {
                    x: l ? n - g : n,
                    y: h ? o - p : o,
                    width: g,
                    height: p
                }), {}, {
                    translateX: a.globals.translateX,
                    translateY: a.globals.translateY
                }), s.drawSelectionRect(f), s.selectionDragging("resizing"), f;
            }
        },
        {
            key: "selectionDragging",
            value: function(t, e) {
                var i = this, a = this.w;
                if (e) {
                    e.preventDefault();
                    var s = e.detail, r = s.handler, n = s.box, o = n.x, l = n.y;
                    o < this.constraints.x && (o = this.constraints.x), l < this.constraints.y && (l = this.constraints.y), n.x2 > this.constraints.x2 && (o = this.constraints.x2 - n.w), n.y2 > this.constraints.y2 && (l = this.constraints.y2 - n.h), r.move(o, l);
                    var h = this.xyRatios, c = this.selectionRect, d = 0;
                    "resizing" === t && (d = 30);
                    var u = function(t) {
                        return parseFloat(c.node.getAttribute(t));
                    }, g = {
                        x: u("x"),
                        y: u("y"),
                        width: u("width"),
                        height: u("height")
                    };
                    a.globals.selection = g, "function" == typeof a.config.chart.events.selection && a.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                        var t, e, s, r, n = i.gridRect.getBoundingClientRect(), o = c.node.getBoundingClientRect();
                        a.globals.isRangeBar ? (t = a.globals.yAxisScale[0].niceMin + (o.left - n.left) * h.invertedYRatio, e = a.globals.yAxisScale[0].niceMin + (o.right - n.left) * h.invertedYRatio, s = 0, r = 1) : (t = a.globals.xAxisScale.niceMin + (o.left - n.left) * h.xRatio, e = a.globals.xAxisScale.niceMin + (o.right - n.left) * h.xRatio, s = a.globals.yAxisScale[0].niceMin + (n.bottom - o.bottom) * h.yRatio[0], r = a.globals.yAxisScale[0].niceMax - (o.top - n.top) * h.yRatio[0]);
                        var l = {
                            xaxis: {
                                min: t,
                                max: e
                            },
                            yaxis: {
                                min: s,
                                max: r
                            }
                        };
                        a.config.chart.events.selection(i.ctx, l), a.config.chart.brush.enabled && void 0 !== a.config.chart.events.brushScrolled && a.config.chart.events.brushScrolled(i.ctx, l);
                    }, d));
                }
            }
        },
        {
            key: "selectionDrawn",
            value: function(t) {
                var e, i, a = t.context, s = t.zoomtype, r = this.w, n = a, o = this.xyRatios, l = this.ctx.toolbar, h = r.globals.zoomEnabled ? n.zoomRect.node.getBoundingClientRect() : n.selectionRect.node.getBoundingClientRect(), c = n.gridRect.getBoundingClientRect(), d = h.left - c.left - r.globals.barPadForNumericAxis, u = h.right - c.left - r.globals.barPadForNumericAxis, g = h.top - c.top, p = h.bottom - c.top;
                r.globals.isRangeBar ? (e = r.globals.yAxisScale[0].niceMin + d * o.invertedYRatio, i = r.globals.yAxisScale[0].niceMin + u * o.invertedYRatio) : (e = r.globals.xAxisScale.niceMin + d * o.xRatio, i = r.globals.xAxisScale.niceMin + u * o.xRatio);
                var f = [], x = [];
                if (r.config.yaxis.forEach(function(t, e) {
                    var i = r.globals.seriesYAxisMap[e][0], a = r.globals.yAxisScale[e].niceMax - o.yRatio[i] * g, s = r.globals.yAxisScale[e].niceMax - o.yRatio[i] * p;
                    f.push(a), x.push(s);
                }), n.dragged && (n.dragX > 10 || n.dragY > 10) && e !== i) {
                    if (r.globals.zoomEnabled) {
                        var b = $e4b487e979d7c06d$var$v.clone(r.globals.initialConfig.yaxis), m = $e4b487e979d7c06d$var$v.clone(r.globals.initialConfig.xaxis);
                        if (r.globals.zoomed = !0, r.config.xaxis.convertedCatToNumeric && (e = Math.floor(e), i = Math.floor(i), e < 1 && (e = 1, i = r.globals.dataPoints), i - e < 2 && (i = e + 1)), "xy" !== s && "x" !== s || (m = {
                            min: e,
                            max: i
                        }), "xy" !== s && "y" !== s || b.forEach(function(t, e) {
                            b[e].min = x[e], b[e].max = f[e];
                        }), l) {
                            var y = l.getBeforeZoomRange(m, b);
                            y && (m = y.xaxis ? y.xaxis : m, b = y.yaxis ? y.yaxis : b);
                        }
                        var w = {
                            xaxis: m
                        };
                        r.config.chart.group || (w.yaxis = b), n.ctx.updateHelpers._updateOptions(w, !1, n.w.config.chart.animations.dynamicAnimation.enabled), "function" == typeof r.config.chart.events.zoomed && l.zoomCallback(m, b);
                    } else if (r.globals.selectionEnabled) {
                        var k, A = null;
                        k = {
                            min: e,
                            max: i
                        }, "xy" !== s && "y" !== s || (A = $e4b487e979d7c06d$var$v.clone(r.config.yaxis)).forEach(function(t, e) {
                            A[e].min = x[e], A[e].max = f[e];
                        }), r.globals.selection = n.selection, "function" == typeof r.config.chart.events.selection && r.config.chart.events.selection(n.ctx, {
                            xaxis: k,
                            yaxis: A
                        });
                    }
                }
            }
        },
        {
            key: "panDragging",
            value: function(t) {
                var e = t.context, i = this.w, a = e;
                if (void 0 !== i.globals.lastClientPosition.x) {
                    var s = i.globals.lastClientPosition.x - a.clientX, r = i.globals.lastClientPosition.y - a.clientY;
                    Math.abs(s) > Math.abs(r) && s > 0 ? this.moveDirection = "left" : Math.abs(s) > Math.abs(r) && s < 0 ? this.moveDirection = "right" : Math.abs(r) > Math.abs(s) && r > 0 ? this.moveDirection = "up" : Math.abs(r) > Math.abs(s) && r < 0 && (this.moveDirection = "down");
                }
                i.globals.lastClientPosition = {
                    x: a.clientX,
                    y: a.clientY
                };
                var n = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, o = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                a.panScrolled(n, o);
            }
        },
        {
            key: "panScrolled",
            value: function(t, e) {
                var i = this.w, a = this.xyRatios, s = $e4b487e979d7c06d$var$v.clone(i.globals.initialConfig.yaxis), r = a.xRatio, n = i.globals.minX, o = i.globals.maxX;
                i.globals.isRangeBar && (r = a.invertedYRatio, n = i.globals.minY, o = i.globals.maxY), "left" === this.moveDirection ? (t = n + i.globals.gridWidth / 15 * r, e = o + i.globals.gridWidth / 15 * r) : "right" === this.moveDirection && (t = n - i.globals.gridWidth / 15 * r, e = o - i.globals.gridWidth / 15 * r), i.globals.isRangeBar || (t < i.globals.initialMinX || e > i.globals.initialMaxX) && (t = n, e = o);
                var l = {
                    xaxis: {
                        min: t,
                        max: e
                    }
                };
                i.config.chart.group || (l.yaxis = s), this.updateScrolledChart(l, t, e);
            }
        },
        {
            key: "updateScrolledChart",
            value: function(t, e, i) {
                var a = this.w;
                if (this.ctx.updateHelpers._updateOptions(t, !1, !1), "function" == typeof a.config.chart.events.scrolled) {
                    var s = {
                        xaxis: {
                            min: e,
                            max: i
                        }
                    };
                    a.config.chart.events.scrolled(this.ctx, s), this.ctx.events.fireEvent("scrolled", s);
                }
            }
        }
    ]), a;
}(), $e4b487e979d7c06d$var$va = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getNearestValues",
            value: function(t) {
                var e = t.hoverArea, i = t.elGrid, a = t.clientX, s = t.clientY, r = this.w, n = i.getBoundingClientRect(), o = n.width, l = n.height, h = o / (r.globals.dataPoints - 1), c = l / r.globals.dataPoints, d = this.hasBars();
                !r.globals.comboCharts && !d || r.config.xaxis.convertedCatToNumeric || (h = o / r.globals.dataPoints);
                var u = a - n.left - r.globals.barPadForNumericAxis, g = s - n.top;
                u < 0 || g < 0 || u > o || g > l ? (e.classList.remove("hovering-zoom"), e.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (e.classList.remove("hovering-pan"), e.classList.add("hovering-zoom")) : r.globals.panEnabled && (e.classList.remove("hovering-zoom"), e.classList.add("hovering-pan"));
                var p = Math.round(u / h), f = Math.floor(g / c);
                d && !r.config.xaxis.convertedCatToNumeric && (p = Math.ceil(u / h), p -= 1);
                var x = null, b = null, m = r.globals.seriesXvalues.map(function(t) {
                    return t.filter(function(t) {
                        return $e4b487e979d7c06d$var$v.isNumber(t);
                    });
                }), y = r.globals.seriesYvalues.map(function(t) {
                    return t.filter(function(t) {
                        return $e4b487e979d7c06d$var$v.isNumber(t);
                    });
                });
                if (r.globals.isXNumeric) {
                    var w = this.ttCtx.getElGrid().getBoundingClientRect(), k = u * (w.width / o), A = g * (w.height / l);
                    x = (b = this.closestInMultiArray(k, A, m, y)).index, p = b.j, null !== x && r.globals.hasNullValues && (m = r.globals.seriesXvalues[x], p = (b = this.closestInArray(k, m)).j);
                }
                return r.globals.capturedSeriesIndex = null === x ? -1 : x, (!p || p < 1) && (p = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = f : r.globals.capturedDataPointIndex = p, {
                    capturedSeries: x,
                    j: r.globals.isBarHorizontal ? f : p,
                    hoverX: u,
                    hoverY: g
                };
            }
        },
        {
            key: "getFirstActiveXArray",
            value: function(t) {
                for(var e = this.w, i = 0, a = t.map(function(t, e) {
                    return t.length > 0 ? e : -1;
                }), s = 0; s < a.length; s++)if (-1 !== a[s] && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)) {
                    i = a[s];
                    break;
                }
                return i;
            }
        },
        {
            key: "closestInMultiArray",
            value: function(t, e, i, a) {
                for(var s, r = this.w, n = 1 / 0, o = null, l = null, h = 0; h < i.length; h++)if (s = h, -1 === r.globals.collapsedSeriesIndices.indexOf(s) && -1 === r.globals.ancillaryCollapsedSeriesIndices.indexOf(s)) for(var c = i[h], d = a[h], u = Math.min(c.length, d.length), g = 0; g < u; g++){
                    var p = t - c[g], f = Math.sqrt(p * p);
                    if (!r.globals.allSeriesHasEqualX) {
                        var x = e - d[g];
                        f = Math.sqrt(p * p + x * x);
                    }
                    f < n && (n = f, o = h, l = g);
                }
                return {
                    index: o,
                    j: l
                };
            }
        },
        {
            key: "closestInArray",
            value: function(t, e) {
                for(var i = e[0], a = null, s = Math.abs(t - i), r = 0; r < e.length; r++){
                    var n = Math.abs(t - e[r]);
                    n < s && (s = n, a = r);
                }
                return {
                    j: a
                };
            }
        },
        {
            key: "isXoverlap",
            value: function(t) {
                var e = [], i = this.w.globals.seriesX.filter(function(t) {
                    return void 0 !== t[0];
                });
                if (i.length > 0) for(var a = 0; a < i.length - 1; a++)void 0 !== i[a][t] && void 0 !== i[a + 1][t] && i[a][t] !== i[a + 1][t] && e.push("unEqual");
                return 0 === e.length;
            }
        },
        {
            key: "isInitialSeriesSameLen",
            value: function() {
                for(var t = !0, e = this.w.globals.initialSeries, i = 0; i < e.length - 1; i++)if (e[i].data.length !== e[i + 1].data.length) {
                    t = !1;
                    break;
                }
                return t;
            }
        },
        {
            key: "getBarsHeight",
            value: function(t) {
                return $e4b487e979d7c06d$var$f(t).reduce(function(t, e) {
                    return t + e.getBBox().height;
                }, 0);
            }
        },
        {
            key: "getElMarkers",
            value: function(t) {
                return "number" == typeof t ? this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-series-markers-wrap > *")) : this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap > *");
            }
        },
        {
            key: "getAllMarkers",
            value: function() {
                var t = this, e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], i = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                i = $e4b487e979d7c06d$var$f(i), e && (i = i.filter(function(e) {
                    var i = Number(e.getAttribute("data:realIndex"));
                    return -1 === t.w.globals.collapsedSeriesIndices.indexOf(i);
                })), i.sort(function(t, e) {
                    var i = Number(t.getAttribute("data:realIndex")), a = Number(e.getAttribute("data:realIndex"));
                    return a < i ? 1 : a > i ? -1 : 0;
                });
                var a = [];
                return i.forEach(function(t) {
                    a.push(t.querySelector(".apexcharts-marker"));
                }), a;
            }
        },
        {
            key: "hasMarkers",
            value: function(t) {
                return this.getElMarkers(t).length > 0;
            }
        },
        {
            key: "getPathFromPoint",
            value: function(t, e) {
                var i = Number(t.getAttribute("cx")), a = Number(t.getAttribute("cy")), s = t.getAttribute("shape");
                return new $e4b487e979d7c06d$var$Mi(this.ctx).getMarkerPath(i, a, s, e);
            }
        },
        {
            key: "getElBars",
            value: function() {
                return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
            }
        },
        {
            key: "hasBars",
            value: function() {
                return this.getElBars().length > 0;
            }
        },
        {
            key: "getHoverMarkerSize",
            value: function(t) {
                var e = this.w, i = e.config.markers.hover.size;
                return void 0 === i && (i = e.globals.markers.size[t] + e.config.markers.hover.sizeOffset), i;
            }
        },
        {
            key: "toggleAllTooltipSeriesGroups",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                0 === i.allTooltipSeriesGroups.length && (i.allTooltipSeriesGroups = e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)"enable" === t ? (a[s].classList.add("apexcharts-active"), a[s].style.display = e.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ya = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new $e4b487e979d7c06d$var$va(e);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawSeriesTexts",
            value: function(t) {
                var e = t.shared, i = void 0 === e || e, a = t.ttItems, s = t.i, r = void 0 === s ? 0 : s, n = t.j, o = void 0 === n ? null : n, l = t.y1, h = t.y2, c = t.e, d = this.w;
                void 0 !== d.config.tooltip.custom ? this.handleCustomTooltip({
                    i: r,
                    j: o,
                    y1: l,
                    y2: h,
                    w: d
                }) : this.toggleActiveInactiveSeries(i, r);
                var u = this.getValuesToPrint({
                    i: r,
                    j: o
                });
                this.printLabels({
                    i: r,
                    j: o,
                    values: u,
                    ttItems: a,
                    shared: i,
                    e: c
                });
                var g = this.ttCtx.getElTooltip();
                this.ttCtx.tooltipRect.ttWidth = g.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = g.getBoundingClientRect().height;
            }
        },
        {
            key: "printLabels",
            value: function(t) {
                var e, i = this, a = t.i, s = t.j, r = t.values, n = t.ttItems, o = t.shared, l = t.e, h = this.w, c = [], d = function(t) {
                    return h.globals.seriesGoals[t] && h.globals.seriesGoals[t][s] && Array.isArray(h.globals.seriesGoals[t][s]);
                }, g = r.xVal, p = r.zVal, f = r.xAxisTTVal, x = "", b = h.globals.colors[a];
                null !== s && h.config.plotOptions.bar.distributed && (b = h.globals.colors[s]);
                for(var m = function(t, r) {
                    var m = i.getFormatters(a);
                    x = i.getSeriesName({
                        fn: m.yLbTitleFormatter,
                        index: a,
                        seriesIndex: a,
                        j: s
                    }), "treemap" === h.config.chart.type && (x = m.yLbTitleFormatter(String(h.config.series[a].data[s].x), {
                        series: h.globals.series,
                        seriesIndex: a,
                        dataPointIndex: s,
                        w: h
                    }));
                    var v = h.config.tooltip.inverseOrder ? r : t;
                    if (h.globals.axisCharts) {
                        var y = function(t) {
                            var e, i, a, r;
                            return h.globals.isRangeData ? m.yLbFormatter(null === (e = h.globals.seriesRangeStart) || void 0 === e || null === (i = e[t]) || void 0 === i ? void 0 : i[s], {
                                series: h.globals.seriesRangeStart,
                                seriesIndex: t,
                                dataPointIndex: s,
                                w: h
                            }) + " - " + m.yLbFormatter(null === (a = h.globals.seriesRangeEnd) || void 0 === a || null === (r = a[t]) || void 0 === r ? void 0 : r[s], {
                                series: h.globals.seriesRangeEnd,
                                seriesIndex: t,
                                dataPointIndex: s,
                                w: h
                            }) : m.yLbFormatter(h.globals.series[t][s], {
                                series: h.globals.series,
                                seriesIndex: t,
                                dataPointIndex: s,
                                w: h
                            });
                        };
                        if (o) m = i.getFormatters(v), x = i.getSeriesName({
                            fn: m.yLbTitleFormatter,
                            index: v,
                            seriesIndex: a,
                            j: s
                        }), b = h.globals.colors[v], e = y(v), d(v) && (c = h.globals.seriesGoals[v][s].map(function(t) {
                            return {
                                attrs: t,
                                val: m.yLbFormatter(t.value, {
                                    seriesIndex: v,
                                    dataPointIndex: s,
                                    w: h
                                })
                            };
                        }));
                        else {
                            var w, k = null == l || null === (w = l.target) || void 0 === w ? void 0 : w.getAttribute("fill");
                            k && (-1 !== k.indexOf("url") ? -1 !== k.indexOf("Pattern") && (b = h.globals.dom.baseEl.querySelector(k.substr(4).slice(0, -1)).childNodes[0].getAttribute("stroke")) : b = k), e = y(a), d(a) && Array.isArray(h.globals.seriesGoals[a][s]) && (c = h.globals.seriesGoals[a][s].map(function(t) {
                                return {
                                    attrs: t,
                                    val: m.yLbFormatter(t.value, {
                                        seriesIndex: a,
                                        dataPointIndex: s,
                                        w: h
                                    })
                                };
                            }));
                        }
                    }
                    null === s && (e = m.yLbFormatter(h.globals.series[a], $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, h), {}, {
                        seriesIndex: a,
                        dataPointIndex: a
                    }))), i.DOMHandling({
                        i: a,
                        t: v,
                        j: s,
                        ttItems: n,
                        values: {
                            val: e,
                            goalVals: c,
                            xVal: g,
                            xAxisTTVal: f,
                            zVal: p
                        },
                        seriesName: x,
                        shared: o,
                        pColor: b
                    });
                }, v = 0, y = h.globals.series.length - 1; v < h.globals.series.length; v++, y--)m(v, y);
            }
        },
        {
            key: "getFormatters",
            value: function(t) {
                var e, i = this.w, a = i.globals.yLabelFormatters[t];
                return void 0 !== i.globals.ttVal ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[t] && i.globals.ttVal[t].formatter, e = i.globals.ttVal[t] && i.globals.ttVal[t].title && i.globals.ttVal[t].title.formatter) : (a = i.globals.ttVal.formatter, "function" == typeof i.globals.ttVal.title.formatter && (e = i.globals.ttVal.title.formatter)) : e = i.config.tooltip.y.title.formatter, "function" != typeof a && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(t) {
                    return t;
                }), "function" != typeof e && (e = function(t) {
                    return t ? t + ": " : "";
                }), {
                    yLbFormatter: a,
                    yLbTitleFormatter: e
                };
            }
        },
        {
            key: "getSeriesName",
            value: function(t) {
                var e = t.fn, i = t.index, a = t.seriesIndex, s = t.j, r = this.w;
                return e(String(r.globals.seriesNames[i]), {
                    series: r.globals.series,
                    seriesIndex: a,
                    dataPointIndex: s,
                    w: r
                });
            }
        },
        {
            key: "DOMHandling",
            value: function(t) {
                t.i;
                var e = t.t, i = t.j, a = t.ttItems, s = t.values, r = t.seriesName, n = t.shared, o = t.pColor, l = this.w, h = this.ttCtx, c = s.val, d = s.goalVals, u = s.xVal, g = s.xAxisTTVal, p = s.zVal, f = null;
                f = a[e].children, l.config.tooltip.fillSeriesColor && (a[e].style.backgroundColor = o, f[0].style.display = "none"), h.showTooltipTitle && (null === h.tooltipTitle && (h.tooltipTitle = l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), h.tooltipTitle.innerHTML = u), h.isXAxisTooltipEnabled && (h.xaxisTooltipText.innerHTML = "" !== g ? g : u);
                var x = a[e].querySelector(".apexcharts-tooltip-text-y-label");
                x && (x.innerHTML = r || "");
                var b = a[e].querySelector(".apexcharts-tooltip-text-y-value");
                b && (b.innerHTML = void 0 !== c ? c : ""), f[0] && f[0].classList.contains("apexcharts-tooltip-marker") && (l.config.tooltip.marker.fillColors && Array.isArray(l.config.tooltip.marker.fillColors) && (o = l.config.tooltip.marker.fillColors[e]), l.config.tooltip.fillSeriesColor ? f[0].style.backgroundColor = o : f[0].style.color = o), l.config.tooltip.marker.show || (f[0].style.display = "none");
                var m = a[e].querySelector(".apexcharts-tooltip-text-goals-label"), v = a[e].querySelector(".apexcharts-tooltip-text-goals-value");
                if (d.length && l.globals.seriesGoals[e]) {
                    var y = function() {
                        var t = "<div>", e = "<div>";
                        d.forEach(function(i, a) {
                            t += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name, "</div>"), e += "<div>".concat(i.val, "</div>");
                        }), m.innerHTML = t + "</div>", v.innerHTML = e + "</div>";
                    };
                    n ? l.globals.seriesGoals[e][i] && Array.isArray(l.globals.seriesGoals[e][i]) ? y() : (m.innerHTML = "", v.innerHTML = "") : y();
                } else m.innerHTML = "", v.innerHTML = "";
                null !== p && (a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = l.config.tooltip.z.title, a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = void 0 !== p ? p : "");
                if (n && f[0]) {
                    if (l.config.tooltip.hideEmptySeries) {
                        var w = a[e].querySelector(".apexcharts-tooltip-marker"), k = a[e].querySelector(".apexcharts-tooltip-text");
                        0 == parseFloat(c) ? (w.style.display = "none", k.style.display = "none") : (w.style.display = "block", k.style.display = "block");
                    }
                    null == c || l.globals.ancillaryCollapsedSeriesIndices.indexOf(e) > -1 || l.globals.collapsedSeriesIndices.indexOf(e) > -1 || Array.isArray(h.tConfig.enabledOnSeries) && -1 === h.tConfig.enabledOnSeries.indexOf(e) ? f[0].parentNode.style.display = "none" : f[0].parentNode.style.display = l.config.tooltip.items.display;
                } else Array.isArray(h.tConfig.enabledOnSeries) && -1 === h.tConfig.enabledOnSeries.indexOf(e) && (f[0].parentNode.style.display = "none");
            }
        },
        {
            key: "toggleActiveInactiveSeries",
            value: function(t, e) {
                var i = this.w;
                if (t) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                else {
                    this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                    var a = i.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group-".concat(e));
                    a && (a.classList.add("apexcharts-active"), a.style.display = i.config.tooltip.items.display);
                }
            }
        },
        {
            key: "getValuesToPrint",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", n = "", o = null, l = null, h = {
                    series: a.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }, c = a.globals.ttZFormatter;
                null === i ? l = a.globals.series[e] : a.globals.isXNumeric && "treemap" !== a.config.chart.type ? (r = s[e][i], 0 === s[e].length && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = new $e4b487e979d7c06d$var$$i(this.ctx).isFormatXY() ? void 0 !== a.config.series[e].data[i] ? a.config.series[e].data[i].x : "" : void 0 !== a.globals.labels[i] ? a.globals.labels[i] : "";
                var d = r;
                a.globals.isXNumeric && "datetime" === a.config.xaxis.type ? r = new $e4b487e979d7c06d$var$Xi(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, d, d, {
                    i: void 0,
                    dateFormatter: new $e4b487e979d7c06d$var$zi(this.ctx).formatDate,
                    w: this.w
                }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](d, h) : a.globals.xLabelFormatter(d, h);
                return void 0 !== a.config.tooltip.x.formatter && (r = a.globals.ttKeyFormatter(d, h)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[e].length > 0 && (o = c(a.globals.seriesZ[e][i], a)), n = "function" == typeof a.config.xaxis.tooltip.formatter ? a.globals.xaxisTooltipFormatter(d, h) : r, {
                    val: Array.isArray(l) ? l.join(" ") : l,
                    xVal: Array.isArray(r) ? r.join(" ") : r,
                    xAxisTTVal: Array.isArray(n) ? n.join(" ") : n,
                    zVal: o
                };
            }
        },
        {
            key: "handleCustomTooltip",
            value: function(t) {
                var e = t.i, i = t.j, a = t.y1, s = t.y2, r = t.w, n = this.ttCtx.getElTooltip(), o = r.config.tooltip.custom;
                Array.isArray(o) && o[e] && (o = o[e]);
                var l = o({
                    ctx: this.ctx,
                    series: r.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    y1: a,
                    y2: s,
                    w: r
                });
                "string" == typeof l || "number" == typeof l ? n.innerHTML = l : (l instanceof Element || "string" == typeof l.nodeName) && (n.innerHTML = "", n.appendChild(l.cloneNode(!0)));
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$wa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "moveXCrosshairs",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = t - i.xcrosshairsWidth / 2, n = a.globals.labels.slice().length;
                if (null !== e && (r = a.globals.gridWidth / n * e), null === s || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                    var o = r;
                    "tickWidth" !== a.config.xaxis.crosshairs.width && "barWidth" !== a.config.xaxis.crosshairs.width || (o = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(o);
                }
            }
        },
        {
            key: "moveYCrosshairs",
            value: function(t) {
                var e = this.ttCtx;
                null !== e.ycrosshairs && $e4b487e979d7c06d$var$Mi.setAttrs(e.ycrosshairs, {
                    y1: t,
                    y2: t
                }), null !== e.ycrosshairsHidden && $e4b487e979d7c06d$var$Mi.setAttrs(e.ycrosshairsHidden, {
                    y1: t,
                    y2: t
                });
            }
        },
        {
            key: "moveXAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                if (null !== i.xaxisTooltip && 0 !== i.xcrosshairsWidth) {
                    i.xaxisTooltip.classList.add("apexcharts-active");
                    var a = i.xaxisOffY + e.config.xaxis.tooltip.offsetY + e.globals.translateY + 1 + e.config.xaxis.offsetY;
                    if (t -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(t)) {
                        t += e.globals.translateX;
                        var s;
                        s = new $e4b487e979d7c06d$var$Mi(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = t + "px", i.xaxisTooltip.style.top = a + "px";
                    }
                }
            }
        },
        {
            key: "moveYAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                null === i.yaxisTTEls && (i.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = e.globals.translateY + a, r = i.yaxisTTEls[t].getBoundingClientRect(), n = r.height, o = e.globals.translateYAxisX[t] - 2;
                e.config.yaxis[t].opposite && (o -= r.width), s -= n / 2, -1 === e.globals.ignoreYAxisIndexes.indexOf(t) && s > 0 && s < e.globals.gridHeight ? (i.yaxisTTEls[t].classList.add("apexcharts-active"), i.yaxisTTEls[t].style.top = s + "px", i.yaxisTTEls[t].style.left = o + e.config.yaxis[t].tooltip.offsetX + "px") : i.yaxisTTEls[t].classList.remove("apexcharts-active");
            }
        },
        {
            key: "moveTooltip",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), n = s.tooltipRect, o = null !== i ? parseFloat(i) : 1, l = parseFloat(t) + o + 5, h = parseFloat(e) + o / 2;
                if (l > a.globals.gridWidth / 2 && (l = l - n.ttWidth - o - 10), l > a.globals.gridWidth - n.ttWidth - 10 && (l = a.globals.gridWidth - n.ttWidth), l < -20 && (l = -20), a.config.tooltip.followCursor) {
                    var c = s.getElGrid().getBoundingClientRect();
                    (l = s.e.clientX - c.left) > a.globals.gridWidth / 2 && (l -= s.tooltipRect.ttWidth), (h = s.e.clientY + a.globals.translateY - c.top) > a.globals.gridHeight / 2 && (h -= s.tooltipRect.ttHeight);
                } else a.globals.isBarHorizontal || n.ttHeight / 2 + h > a.globals.gridHeight && (h = a.globals.gridHeight - n.ttHeight + a.globals.translateY);
                isNaN(l) || (l += a.globals.translateX, r.style.left = l + "px", r.style.top = h + "px");
            }
        },
        {
            key: "moveMarkers",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx;
                if (i.globals.markers.size[t] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === e && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(e, s[r]));
                else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(e, t);
            }
        },
        {
            key: "moveDynamicPointOnHover",
            value: function(t, e) {
                var i, a, s, r, n = this.w, o = this.ttCtx, l = new $e4b487e979d7c06d$var$Mi(this.ctx), h = n.globals.pointsArray, c = o.tooltipUtil.getHoverMarkerSize(e), d = n.config.series[e].type;
                if (!d || "column" !== d && "candlestick" !== d && "boxPlot" !== d) {
                    s = null === (i = h[e][t]) || void 0 === i ? void 0 : i[0], r = (null === (a = h[e][t]) || void 0 === a ? void 0 : a[1]) || 0;
                    var u = n.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers path"));
                    if (u && r < n.globals.gridHeight && r > 0) {
                        var g = u.getAttribute("shape"), p = l.getMarkerPath(s, r, g, 1.5 * c);
                        u.setAttribute("d", p);
                    }
                    this.moveXCrosshairs(s), o.fixedTooltip || this.moveTooltip(s, r, c);
                }
            }
        },
        {
            key: "moveDynamicPointsOnHover",
            value: function(t) {
                var e, i = this.ttCtx, a = i.w, s = 0, r = 0, n = a.globals.pointsArray, o = new $e4b487e979d7c06d$var$Zi(this.ctx), l = new $e4b487e979d7c06d$var$Mi(this.ctx);
                e = o.getActiveConfigSeriesIndex("asc", [
                    "line",
                    "area",
                    "scatter",
                    "bubble"
                ]);
                var h = i.tooltipUtil.getHoverMarkerSize(e);
                if (n[e] && (s = n[e][t][0], r = n[e][t][1]), !isNaN(s)) {
                    var c = i.tooltipUtil.getAllMarkers();
                    if (c.length) for(var d = 0; d < a.globals.series.length; d++){
                        var u = n[d];
                        if (a.globals.comboCharts && void 0 === u && c.splice(d, 0, null), u && u.length) {
                            var g = n[d][t][1], p = void 0;
                            c[d].setAttribute("cx", s);
                            var f = c[d].getAttribute("shape");
                            if ("rangeArea" === a.config.chart.type && !a.globals.comboCharts) {
                                var x = t + a.globals.series[d].length;
                                p = n[d][x][1], g -= Math.abs(g - p) / 2;
                            }
                            if (null !== g && !isNaN(g) && g < a.globals.gridHeight + h && g + h > 0) {
                                var b = l.getMarkerPath(s, g, f, h);
                                c[d].setAttribute("d", b);
                            } else c[d].setAttribute("d", "");
                        }
                    }
                    this.moveXCrosshairs(s), i.fixedTooltip || this.moveTooltip(s, r || a.globals.gridHeight, h);
                }
            }
        },
        {
            key: "moveStickyTooltipOverBars",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx, s = i.globals.columnSeries ? i.globals.columnSeries.length : i.globals.series.length;
                i.config.chart.stacked && (s = i.globals.barGroups.length);
                var r = s >= 2 && s % 2 == 0 ? Math.floor(s / 2) : Math.floor(s / 2) + 1;
                i.globals.isBarHorizontal && (r = new $e4b487e979d7c06d$var$Zi(this.ctx).getActiveConfigSeriesIndex("desc") + 1);
                var n = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(r, "'] path[j='").concat(t, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(r, "'] path[j='").concat(t, "']"));
                n || "number" != typeof e || (n = i.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[data\\:realIndex='".concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-candlestick-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-boxPlot-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "'],\n        .apexcharts-rangebar-series .apexcharts-series[data\\:realIndex='").concat(e, "'] path[j='").concat(t, "']")));
                var o = n ? parseFloat(n.getAttribute("cx")) : 0, l = n ? parseFloat(n.getAttribute("cy")) : 0, h = n ? parseFloat(n.getAttribute("barWidth")) : 0, c = a.getElGrid().getBoundingClientRect(), d = n && (n.classList.contains("apexcharts-candlestick-area") || n.classList.contains("apexcharts-boxPlot-area"));
                i.globals.isXNumeric ? (n && !d && (o -= s % 2 != 0 ? h / 2 : 0), n && d && (o -= h / 2)) : i.globals.isBarHorizontal || (o = a.xAxisTicksPositions[t - 1] + a.dataPointsDividedWidth / 2, isNaN(o) && (o = a.xAxisTicksPositions[t] - a.dataPointsDividedWidth / 2)), i.globals.isBarHorizontal ? l -= a.tooltipRect.ttHeight : i.config.tooltip.followCursor ? l = a.e.clientY - c.top - a.tooltipRect.ttHeight / 2 : l + a.tooltipRect.ttHeight + 15 > i.globals.gridHeight && (l = i.globals.gridHeight), i.globals.isBarHorizontal || this.moveXCrosshairs(o), a.fixedTooltip || this.moveTooltip(o, l || i.globals.gridHeight);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ka = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new $e4b487e979d7c06d$var$wa(e);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawDynamicPoints",
            value: function() {
                var t = this.w, e = new $e4b487e979d7c06d$var$Mi(this.ctx), i = new $e4b487e979d7c06d$var$Vi(this.ctx), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                a = $e4b487e979d7c06d$var$f(a), t.config.chart.stacked && a.sort(function(t, e) {
                    return parseFloat(t.getAttribute("data:realIndex")) - parseFloat(e.getAttribute("data:realIndex"));
                });
                for(var s = 0; s < a.length; s++){
                    var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                    if (null !== r) {
                        var n = void 0, o = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                        "line" !== t.config.chart.type && "area" !== t.config.chart.type || t.globals.comboCharts || t.config.tooltip.intersect || (o += " no-pointer-events");
                        var l = i.getMarkerConfig({
                            cssClass: o,
                            seriesIndex: Number(r.getAttribute("data:realIndex"))
                        });
                        (n = e.drawMarker(0, 0, l)).node.setAttribute("default-marker-size", 0);
                        var h = document.createElementNS(t.globals.SVGNS, "g");
                        h.classList.add("apexcharts-series-markers"), h.appendChild(n.node), r.appendChild(h);
                    }
                }
            }
        },
        {
            key: "enlargeCurrentPoint",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w;
                "bubble" !== s.config.chart.type && this.newPointSize(t, e);
                var r = e.getAttribute("cx"), n = e.getAttribute("cy");
                if (null !== i && null !== a && (r = i, n = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                    if ("radar" === s.config.chart.type) {
                        var o = this.ttCtx.getElGrid().getBoundingClientRect();
                        r = this.ttCtx.e.clientX - o.left;
                    }
                    this.tooltipPosition.moveTooltip(r, n, s.config.markers.hover.size);
                }
            }
        },
        {
            key: "enlargePoints",
            value: function(t) {
                for(var e = this.w, i = this, a = this.ttCtx, s = t, r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), n = e.config.markers.hover.size, o = 0; o < r.length; o++){
                    var l = r[o].getAttribute("rel"), h = r[o].getAttribute("index");
                    if (void 0 === n && (n = e.globals.markers.size[h] + e.config.markers.hover.sizeOffset), s === parseInt(l, 10)) {
                        i.newPointSize(s, r[o]);
                        var c = r[o].getAttribute("cx"), d = r[o].getAttribute("cy");
                        i.tooltipPosition.moveXCrosshairs(c), a.fixedTooltip || i.tooltipPosition.moveTooltip(c, d, n);
                    } else i.oldPointSize(r[o]);
                }
            }
        },
        {
            key: "newPointSize",
            value: function(t, e) {
                var i = this.w, a = i.config.markers.hover.size, s = 0 === t ? e.parentNode.firstChild : e.parentNode.lastChild;
                if ("0" !== s.getAttribute("default-marker-size")) {
                    var r = parseInt(s.getAttribute("index"), 10);
                    void 0 === a && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0);
                    var n = this.ttCtx.tooltipUtil.getPathFromPoint(e, a);
                    e.setAttribute("d", n);
                }
            }
        },
        {
            key: "oldPointSize",
            value: function(t) {
                var e = parseFloat(t.getAttribute("default-marker-size")), i = this.ttCtx.tooltipUtil.getPathFromPoint(t, e);
                t.setAttribute("d", i);
            }
        },
        {
            key: "resetPointsSize",
            value: function() {
                for(var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), e = 0; e < t.length; e++){
                    var i = parseFloat(t[e].getAttribute("default-marker-size"));
                    if ($e4b487e979d7c06d$var$v.isNumber(i) && i > 0) {
                        var a = this.ttCtx.tooltipUtil.getPathFromPoint(t[e], i);
                        t[e].setAttribute("d", a);
                    } else t[e].setAttribute("d", "M0,0");
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Aa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w;
        var a = this.w;
        this.ttCtx = e, this.isVerticalGroupedRangeBar = !a.globals.isBarHorizontal && "rangeBar" === a.config.chart.type && a.config.plotOptions.bar.rangeBarGroupRows;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getAttr",
            value: function(t, e) {
                return parseFloat(t.target.getAttribute(e));
            }
        },
        {
            key: "handleHeatTreeTooltip",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.x, s = t.y, r = t.type, n = this.ttCtx, o = this.w;
                if (e.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                    var l = this.getAttr(e, "i"), h = this.getAttr(e, "j"), c = this.getAttr(e, "cx"), d = this.getAttr(e, "cy"), u = this.getAttr(e, "width"), g = this.getAttr(e, "height");
                    if (n.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: l,
                        j: h,
                        shared: !1,
                        e: e
                    }), o.globals.capturedSeriesIndex = l, o.globals.capturedDataPointIndex = h, a = c + n.tooltipRect.ttWidth / 2 + u, s = d + n.tooltipRect.ttHeight / 2 - g / 2, n.tooltipPosition.moveXCrosshairs(c + u / 2), a > o.globals.gridWidth / 2 && (a = c - n.tooltipRect.ttWidth / 2 + u), n.w.config.tooltip.followCursor) {
                        var p = o.globals.dom.elWrap.getBoundingClientRect();
                        a = o.globals.clientX - p.left - (a > o.globals.gridWidth / 2 ? n.tooltipRect.ttWidth : 0), s = o.globals.clientY - p.top - (s > o.globals.gridHeight / 2 ? n.tooltipRect.ttHeight : 0);
                    }
                }
                return {
                    x: a,
                    y: s
                };
            }
        },
        {
            key: "handleMarkerTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = t.x, n = t.y, o = this.w, l = this.ttCtx;
                if (a.target.classList.contains("apexcharts-marker")) {
                    var h = parseInt(s.paths.getAttribute("cx"), 10), c = parseInt(s.paths.getAttribute("cy"), 10), d = parseFloat(s.paths.getAttribute("val"));
                    if (i = parseInt(s.paths.getAttribute("rel"), 10), e = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, l.intersect) {
                        var u = $e4b487e979d7c06d$var$v.findAncestor(s.paths, "apexcharts-series");
                        u && (e = parseInt(u.getAttribute("data:realIndex"), 10));
                    }
                    if (l.tooltipLabels.drawSeriesTexts({
                        ttItems: s.ttItems,
                        i: e,
                        j: i,
                        shared: !l.showOnIntersect && o.config.tooltip.shared,
                        e: a
                    }), "mouseup" === a.type && l.markerClick(a, e, i), o.globals.capturedSeriesIndex = e, o.globals.capturedDataPointIndex = i, r = h, n = c + o.globals.translateY - 1.4 * l.tooltipRect.ttHeight, l.w.config.tooltip.followCursor) {
                        var g = l.getElGrid().getBoundingClientRect();
                        n = l.e.clientY + o.globals.translateY - g.top;
                    }
                    d < 0 && (n = c), l.marker.enlargeCurrentPoint(i, s.paths, r, n);
                }
                return {
                    x: r,
                    y: n
                };
            }
        },
        {
            key: "handleBarTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, n = this.ttCtx, o = n.getElTooltip(), l = 0, h = 0, c = 0, d = this.getBarTooltipXY({
                    e: a,
                    opt: s
                });
                if (null !== d.j || 0 !== d.barHeight || 0 !== d.barWidth) {
                    e = d.i;
                    var u = d.j;
                    if (r.globals.capturedSeriesIndex = e, r.globals.capturedDataPointIndex = u, r.globals.isBarHorizontal && n.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (h = d.x, c = d.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[e] : r.config.stroke.width, l = h) : r.globals.comboCharts || r.config.tooltip.shared || (l /= 2), isNaN(c) && (c = r.globals.svgHeight - n.tooltipRect.ttHeight), parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10), h + n.tooltipRect.ttWidth > r.globals.gridWidth ? h -= n.tooltipRect.ttWidth : h < 0 && (h = 0), n.w.config.tooltip.followCursor) {
                        var g = n.getElGrid().getBoundingClientRect();
                        c = n.e.clientY - g.top;
                    }
                    null === n.tooltip && (n.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? n.tooltipPosition.moveXCrosshairs(l + i / 2) : n.tooltipPosition.moveXCrosshairs(l)), !n.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && n.tooltipUtil.hasBars()) && (c = c + r.globals.translateY - n.tooltipRect.ttHeight / 2, o.style.left = h + r.globals.translateX + "px", o.style.top = c + "px");
                }
            }
        },
        {
            key: "getBarTooltipXY",
            value: function(t) {
                var e = this, i = t.e, a = t.opt, s = this.w, r = null, n = this.ttCtx, o = 0, l = 0, h = 0, c = 0, d = 0, u = i.target.classList;
                if (u.contains("apexcharts-bar-area") || u.contains("apexcharts-candlestick-area") || u.contains("apexcharts-boxPlot-area") || u.contains("apexcharts-rangebar-area")) {
                    var g = i.target, p = g.getBoundingClientRect(), f = a.elGrid.getBoundingClientRect(), x = p.height;
                    d = p.height;
                    var b = p.width, m = parseInt(g.getAttribute("cx"), 10), v = parseInt(g.getAttribute("cy"), 10);
                    c = parseFloat(g.getAttribute("barWidth"));
                    var y = "touchmove" === i.type ? i.touches[0].clientX : i.clientX;
                    r = parseInt(g.getAttribute("j"), 10), o = parseInt(g.parentNode.getAttribute("rel"), 10) - 1;
                    var w = g.getAttribute("data-range-y1"), k = g.getAttribute("data-range-y2");
                    s.globals.comboCharts && (o = parseInt(g.parentNode.getAttribute("data:realIndex"), 10));
                    var A = function(t) {
                        return s.globals.isXNumeric ? m - b / 2 : e.isVerticalGroupedRangeBar ? m + b / 2 : m - n.dataPointsDividedWidth + b / 2;
                    }, C = function() {
                        return v - n.dataPointsDividedHeight + x / 2 - n.tooltipRect.ttHeight / 2;
                    };
                    n.tooltipLabels.drawSeriesTexts({
                        ttItems: a.ttItems,
                        i: o,
                        j: r,
                        y1: w ? parseInt(w, 10) : null,
                        y2: k ? parseInt(k, 10) : null,
                        shared: !n.showOnIntersect && s.config.tooltip.shared,
                        e: i
                    }), s.config.tooltip.followCursor ? s.globals.isBarHorizontal ? (l = y - f.left + 15, h = C()) : (l = A(), h = i.clientY - f.top - n.tooltipRect.ttHeight / 2 - 15) : s.globals.isBarHorizontal ? ((l = m) < n.xyRatios.baseLineInvertedY && (l = m - n.tooltipRect.ttWidth), h = C()) : (l = A(), h = v);
                }
                return {
                    x: l,
                    y: h,
                    barHeight: d,
                    barWidth: c,
                    i: o,
                    j: r
                };
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ca = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.ttCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawXaxisTooltip",
            value: function() {
                var t = this.w, e = this.ttCtx, i = "bottom" === t.config.xaxis.position;
                e.xaxisOffY = i ? t.globals.gridHeight + 1 : -t.globals.xAxisHeight - t.config.xaxis.axisTicks.height + 3;
                var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = t.globals.dom.elWrap;
                e.isXAxisTooltipEnabled && null === t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") && (e.xaxisTooltip = document.createElement("div"), e.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + t.config.tooltip.theme), s.appendChild(e.xaxisTooltip), e.xaxisTooltipText = document.createElement("div"), e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), e.xaxisTooltipText.style.fontFamily = t.config.xaxis.tooltip.style.fontFamily || t.config.chart.fontFamily, e.xaxisTooltipText.style.fontSize = t.config.xaxis.tooltip.style.fontSize, e.xaxisTooltip.appendChild(e.xaxisTooltipText));
            }
        },
        {
            key: "drawYaxisTooltip",
            value: function() {
                for(var t = this.w, e = this.ttCtx, i = 0; i < t.config.yaxis.length; i++){
                    var a = t.config.yaxis[i].opposite || t.config.yaxis[i].crosshairs.opposite;
                    e.yaxisOffX = a ? t.globals.gridWidth + 1 : 1;
                    var s = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i, a ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left"), r = t.globals.dom.elWrap;
                    null === t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i)) && (e.yaxisTooltip = document.createElement("div"), e.yaxisTooltip.setAttribute("class", s + " apexcharts-theme-" + t.config.tooltip.theme), r.appendChild(e.yaxisTooltip), 0 === i && (e.yaxisTooltipText = []), e.yaxisTooltipText[i] = document.createElement("div"), e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"), e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]));
                }
            }
        },
        {
            key: "setXCrosshairWidth",
            value: function() {
                var t = this.w, e = this.ttCtx, i = e.getElXCrosshairs();
                if (e.xcrosshairsWidth = parseInt(t.config.xaxis.crosshairs.width, 10), t.globals.comboCharts) {
                    var a = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== a && "barWidth" === t.config.xaxis.crosshairs.width) {
                        var s = parseFloat(a.getAttribute("barWidth"));
                        e.xcrosshairsWidth = s;
                    } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                        var r = t.globals.labels.length;
                        e.xcrosshairsWidth = t.globals.gridWidth / r;
                    }
                } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                    var n = t.globals.labels.length;
                    e.xcrosshairsWidth = t.globals.gridWidth / n;
                } else if ("barWidth" === t.config.xaxis.crosshairs.width) {
                    var o = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== o) {
                        var l = parseFloat(o.getAttribute("barWidth"));
                        e.xcrosshairsWidth = l;
                    } else e.xcrosshairsWidth = 1;
                }
                t.globals.isBarHorizontal && (e.xcrosshairsWidth = 0), null !== i && e.xcrosshairsWidth > 0 && i.setAttribute("width", e.xcrosshairsWidth);
            }
        },
        {
            key: "handleYCrosshair",
            value: function() {
                var t = this.w, e = this.ttCtx;
                e.ycrosshairs = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), e.ycrosshairsHidden = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
            }
        },
        {
            key: "drawYaxisTooltipText",
            value: function(t, e, i) {
                var a = this.ttCtx, s = this.w, r = s.globals, n = r.seriesYAxisMap[t];
                if (a.yaxisTooltips[t] && n.length > 0) {
                    var o = r.yLabelFormatters[t], l = a.getElGrid().getBoundingClientRect(), h = n[0], c = 0;
                    i.yRatio.length > 1 && (c = h);
                    var d = (e - l.top) * i.yRatio[c], u = r.maxYArr[h] - r.minYArr[h], g = r.minYArr[h] + (u - d);
                    s.config.yaxis[t].reversed && (g = r.maxYArr[h] - (u - d)), a.tooltipPosition.moveYCrosshairs(e - l.top), a.yaxisTooltipText[t].innerHTML = o(g), a.tooltipPosition.moveYAxisTooltip(t);
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Sa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.tConfig = a.config.tooltip, this.tooltipUtil = new $e4b487e979d7c06d$var$va(this), this.tooltipLabels = new $e4b487e979d7c06d$var$ya(this), this.tooltipPosition = new $e4b487e979d7c06d$var$wa(this), this.marker = new $e4b487e979d7c06d$var$ka(this), this.intersect = new $e4b487e979d7c06d$var$Aa(this), this.axesTooltip = new $e4b487e979d7c06d$var$Ca(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !a.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "getElTooltip",
            value: function(t) {
                return t || (t = this), t.w.globals.dom.baseEl ? t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
            }
        },
        {
            key: "getElXCrosshairs",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
            }
        },
        {
            key: "getElGrid",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
            }
        },
        {
            key: "drawTooltip",
            value: function(t) {
                var e = this.w;
                this.xyRatios = t, this.isXAxisTooltipEnabled = e.config.xaxis.tooltip.enabled && e.globals.axisCharts, this.yaxisTooltips = e.config.yaxis.map(function(t, i) {
                    return !!(t.show && t.tooltip.enabled && e.globals.axisCharts);
                }), this.allTooltipSeriesGroups = [], e.globals.axisCharts || (this.showTooltipTitle = !1);
                var i = document.createElement("div");
                if (i.classList.add("apexcharts-tooltip"), e.config.tooltip.cssClass && i.classList.add(e.config.tooltip.cssClass), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme || "light")), e.globals.dom.elWrap.appendChild(i), e.globals.axisCharts) {
                    this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                    var a = new $e4b487e979d7c06d$var$Qi(this.ctx);
                    this.xAxisTicksPositions = a.getXAxisTicksPositions();
                }
                if (!e.globals.comboCharts && !this.tConfig.intersect && "rangeBar" !== e.config.chart.type || this.tConfig.shared || (this.showOnIntersect = !0), 0 !== e.config.markers.size && 0 !== e.globals.markers.largestSize || this.marker.drawDynamicPoints(this), e.globals.collapsedSeries.length !== e.globals.series.length) {
                    this.dataPointsDividedHeight = e.globals.gridHeight / e.globals.dataPoints, this.dataPointsDividedWidth = e.globals.gridWidth / e.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                    var s = e.globals.series.length;
                    (e.globals.xyCharts || e.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : e.globals.series.length), this.legendLabels = e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                }
            }
        },
        {
            key: "createTTElements",
            value: function(t) {
                for(var e = this, i = this.w, a = [], s = this.getElTooltip(), r = function(r) {
                    var n = document.createElement("div");
                    n.classList.add("apexcharts-tooltip-series-group", "apexcharts-tooltip-series-group-".concat(r)), n.style.order = i.config.tooltip.inverseOrder ? t - r : r + 1;
                    var o = document.createElement("span");
                    o.classList.add("apexcharts-tooltip-marker"), i.config.tooltip.fillSeriesColor ? o.style.backgroundColor = i.globals.colors[r] : o.style.color = i.globals.colors[r];
                    var l = i.config.markers.shape, h = l;
                    Array.isArray(l) && (h = l[r]), o.setAttribute("shape", h), n.appendChild(o);
                    var c = document.createElement("div");
                    c.classList.add("apexcharts-tooltip-text"), c.style.fontFamily = e.tConfig.style.fontFamily || i.config.chart.fontFamily, c.style.fontSize = e.tConfig.style.fontSize, [
                        "y",
                        "goals",
                        "z"
                    ].forEach(function(t) {
                        var e = document.createElement("div");
                        e.classList.add("apexcharts-tooltip-".concat(t, "-group"));
                        var i = document.createElement("span");
                        i.classList.add("apexcharts-tooltip-text-".concat(t, "-label")), e.appendChild(i);
                        var a = document.createElement("span");
                        a.classList.add("apexcharts-tooltip-text-".concat(t, "-value")), e.appendChild(a), c.appendChild(e);
                    }), n.appendChild(c), s.appendChild(n), a.push(n);
                }, n = 0; n < t; n++)r(n);
                return a;
            }
        },
        {
            key: "addSVGEvents",
            value: function() {
                var t = this.w, e = t.config.chart.type, i = this.getElTooltip(), a = !("bar" !== e && "candlestick" !== e && "boxPlot" !== e && "rangeBar" !== e), s = "area" === e || "line" === e || "scatter" === e || "bubble" === e || "radar" === e, r = t.globals.dom.Paper.node, n = this.getElGrid();
                n && (this.seriesBound = n.getBoundingClientRect());
                var o, l = [], h = [], c = {
                    hoverArea: r,
                    elGrid: n,
                    tooltipEl: i,
                    tooltipY: l,
                    tooltipX: h,
                    ttItems: this.ttItems
                };
                if (t.globals.axisCharts && (s ? o = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? o = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : "heatmap" !== e && "treemap" !== e || (o = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), o && o.length)) for(var d = 0; d < o.length; d++)l.push(o[d].getAttribute("cy")), h.push(o[d].getAttribute("cx"));
                if (t.globals.xyCharts && !this.showOnIntersect || t.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                    r
                ], c);
                else if (a && !t.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(c);
                else if (!t.globals.axisCharts || "heatmap" === e || "treemap" === e) {
                    var u = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    this.addPathsEventListeners(u, c);
                }
                if (this.showOnIntersect) {
                    var g = t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                    g.length > 0 && this.addPathsEventListeners(g, c), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(c);
                }
            }
        },
        {
            key: "drawFixedTooltipRect",
            value: function() {
                var t = this.w, e = this.getElTooltip(), i = e.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, n = this.tConfig.fixed.offsetY, o = this.tConfig.fixed.position.toLowerCase();
                return o.indexOf("right") > -1 && (r = r + t.globals.svgWidth - a + 10), o.indexOf("bottom") > -1 && (n = n + t.globals.svgHeight - s - 10), e.style.left = r + "px", e.style.top = n + "px", {
                    x: r,
                    y: n,
                    ttWidth: a,
                    ttHeight: s
                };
            }
        },
        {
            key: "addDatapointEventsListeners",
            value: function(t) {
                var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                this.addPathsEventListeners(e, t);
            }
        },
        {
            key: "addPathsEventListeners",
            value: function(t, e) {
                for(var i = this, a = function(a) {
                    var s = {
                        paths: t[a],
                        tooltipEl: e.tooltipEl,
                        tooltipY: e.tooltipY,
                        tooltipX: e.tooltipX,
                        elGrid: e.elGrid,
                        hoverArea: e.hoverArea,
                        ttItems: e.ttItems
                    };
                    [
                        "mousemove",
                        "mouseup",
                        "touchmove",
                        "mouseout",
                        "touchend"
                    ].map(function(e) {
                        return t[a].addEventListener(e, i.onSeriesHover.bind(i, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }, s = 0; s < t.length; s++)a(s);
            }
        },
        {
            key: "onSeriesHover",
            value: function(t, e) {
                var i = this, a = Date.now() - this.lastHoverTime;
                a >= 20 ? this.seriesHover(t, e) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                    i.seriesHover(t, e);
                }, 20 - a));
            }
        },
        {
            key: "seriesHover",
            value: function(t, e) {
                var i = this;
                this.lastHoverTime = Date.now();
                var a = [], s = this.w;
                s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || 0 === s.globals.dataPoints) || (a.length ? a.forEach(function(a) {
                    var s = i.getElTooltip(a), r = {
                        paths: t.paths,
                        tooltipEl: s,
                        tooltipY: t.tooltipY,
                        tooltipX: t.tooltipX,
                        elGrid: t.elGrid,
                        hoverArea: t.hoverArea,
                        ttItems: a.w.globals.tooltip.ttItems
                    };
                    a.w.globals.minX === i.w.globals.minX && a.w.globals.maxX === i.w.globals.maxX && a.w.globals.tooltip.seriesHoverByContext({
                        chartCtx: a,
                        ttCtx: a.w.globals.tooltip,
                        opt: r,
                        e: e
                    });
                }) : this.seriesHoverByContext({
                    chartCtx: this.ctx,
                    ttCtx: this.w.globals.tooltip,
                    opt: t,
                    e: e
                }));
            }
        },
        {
            key: "seriesHoverByContext",
            value: function(t) {
                var e = t.chartCtx, i = t.ttCtx, a = t.opt, s = t.e, r = e.w, n = this.getElTooltip(e);
                if (n) {
                    if (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: n.getBoundingClientRect().width,
                        ttHeight: n.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared) {
                        if (this.tConfig.onDatasetHover.highlightDataSeries) new $e4b487e979d7c06d$var$Zi(e).toggleSeriesOnHover(s, s.target.parentNode);
                    }
                    r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }), i.fixedTooltip && i.drawFixedTooltipRect();
                }
            }
        },
        {
            key: "axisChartsTooltips",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, n = s.elGrid.getBoundingClientRect(), o = "touchmove" === a.type ? a.touches[0].clientX : a.clientX, l = "touchmove" === a.type ? a.touches[0].clientY : a.clientY;
                if (this.clientY = l, this.clientX = o, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, l < n.top || l > n.top + n.height) this.handleMouseOut(s);
                else {
                    if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                        var h = parseInt(s.paths.getAttribute("index"), 10);
                        if (this.tConfig.enabledOnSeries.indexOf(h) < 0) return void this.handleMouseOut(s);
                    }
                    var c = this.getElTooltip(), d = this.getElXCrosshairs(), u = [];
                    r.config.chart.group && (u = this.ctx.getSyncedCharts());
                    var g = r.globals.xyCharts || "bar" === r.config.chart.type && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                    if ("mousemove" === a.type || "touchmove" === a.type || "mouseup" === a.type) {
                        if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                        null !== d && d.classList.add("apexcharts-active");
                        var p = this.yaxisTooltips.filter(function(t) {
                            return !0 === t;
                        });
                        if (null !== this.ycrosshairs && p.length && this.ycrosshairs.classList.add("apexcharts-active"), g && !this.showOnIntersect || u.length > 1) this.handleStickyTooltip(a, o, l, s);
                        else if ("heatmap" === r.config.chart.type || "treemap" === r.config.chart.type) {
                            var f = this.intersect.handleHeatTreeTooltip({
                                e: a,
                                opt: s,
                                x: e,
                                y: i,
                                type: r.config.chart.type
                            });
                            e = f.x, i = f.y, c.style.left = e + "px", c.style.top = i + "px";
                        } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                            e: a,
                            opt: s
                        }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                            e: a,
                            opt: s,
                            x: e,
                            y: i
                        });
                        if (this.yaxisTooltips.length) for(var x = 0; x < r.config.yaxis.length; x++)this.axesTooltip.drawYaxisTooltipText(x, l, this.xyRatios);
                        r.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"), s.tooltipEl.classList.add("apexcharts-active");
                    } else "mouseout" !== a.type && "touchend" !== a.type || this.handleMouseOut(s);
                }
            }
        },
        {
            key: "nonAxisChartsTooltips",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), n = this.getElTooltip(), o = s.globals.dom.elWrap.getBoundingClientRect();
                if ("mousemove" === e.type || "touchmove" === e.type) {
                    s.globals.dom.baseEl.classList.add("apexcharts-tooltip-active"), n.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: parseInt(r, 10) - 1,
                        shared: !1
                    });
                    var l = s.globals.clientX - o.left - a.ttWidth / 2, h = s.globals.clientY - o.top - a.ttHeight - 10;
                    if (n.style.left = l + "px", n.style.top = h + "px", s.config.legend.tooltipHoverFormatter) {
                        var c = r - 1, d = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"), {
                            seriesIndex: c,
                            dataPointIndex: c,
                            w: s
                        });
                        this.legendLabels[c].innerHTML = d;
                    }
                } else "mouseout" !== e.type && "touchend" !== e.type || (n.classList.remove("apexcharts-active"), s.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                }));
            }
        },
        {
            key: "handleStickyTooltip",
            value: function(t, e, i, a) {
                var s = this.w, r = this.tooltipUtil.getNearestValues({
                    context: this,
                    hoverArea: a.hoverArea,
                    elGrid: a.elGrid,
                    clientX: e,
                    clientY: i
                }), n = r.j, o = r.capturedSeries;
                s.globals.collapsedSeriesIndices.includes(o) && (o = null);
                var l = a.elGrid.getBoundingClientRect();
                if (r.hoverX < 0 || r.hoverX > l.width) this.handleMouseOut(a);
                else if (null !== o) this.handleStickyCapturedSeries(t, o, a, n);
                else if (this.tooltipUtil.isXoverlap(n) || s.globals.isBarHorizontal) {
                    var h = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, h, n, a.ttItems);
                }
            }
        },
        {
            key: "handleStickyCapturedSeries",
            value: function(t, e, i, a) {
                var s = this.w;
                if (!this.tConfig.shared && null === s.globals.series[e][a]) return void this.handleMouseOut(i);
                if (void 0 !== s.globals.series[e][a]) this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(t, this, e, a, i.ttItems) : this.create(t, this, e, a, i.ttItems, !1);
                else if (this.tooltipUtil.isXoverlap(a)) {
                    var r = s.globals.series.findIndex(function(t, e) {
                        return !s.globals.collapsedSeriesIndices.includes(e);
                    });
                    this.create(t, this, r, a, i.ttItems);
                }
            }
        },
        {
            key: "deactivateHoverFilter",
            value: function() {
                for(var t = this.w, e = new $e4b487e979d7c06d$var$Mi(this.ctx), i = t.globals.dom.Paper.find(".apexcharts-bar-area"), a = 0; a < i.length; a++)e.pathMouseLeave(i[a]);
            }
        },
        {
            key: "handleMouseOut",
            value: function(t) {
                var e = this.w, i = this.getElXCrosshairs();
                if (e.globals.dom.baseEl.classList.remove("apexcharts-tooltip-active"), t.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), "bubble" !== e.config.chart.type && this.marker.resetPointsSize(), null !== i && i.classList.remove("apexcharts-active"), null !== this.ycrosshairs && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                    null === this.yaxisTTEls && (this.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                }
                e.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                });
            }
        },
        {
            key: "markerClick",
            value: function(t, e, i) {
                var a = this.w;
                "function" == typeof a.config.chart.events.markerClick && a.config.chart.events.markerClick(t, this.ctx, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }), this.ctx.events.fireEvent("markerClick", [
                    t,
                    this.ctx,
                    {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: a
                    }
                ]);
            }
        },
        {
            key: "create",
            value: function(t, e, i, a, s) {
                var r, n, o, l, h, c, d, g, p, f, x, b, m, v, y, w, k = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, A = this.w, C = e;
                "mouseup" === t.type && this.markerClick(t, i, a), null === k && (k = this.tConfig.shared);
                var S = this.tooltipUtil.hasMarkers(i), L = this.tooltipUtil.getElBars(), M = function() {
                    A.globals.markers.largestSize > 0 ? C.marker.enlargePoints(a) : C.tooltipPosition.moveDynamicPointsOnHover(a);
                };
                if (A.config.legend.tooltipHoverFormatter) {
                    var P = A.config.legend.tooltipHoverFormatter, I = Array.from(this.legendLabels);
                    I.forEach(function(t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e);
                    });
                    for(var T = 0; T < I.length; T++){
                        var z = I[T], X = parseInt(z.getAttribute("i"), 10), R = decodeURIComponent(z.getAttribute("data:default-text")), E = P(R, {
                            seriesIndex: k ? X : i,
                            dataPointIndex: a,
                            w: A
                        });
                        if (k) z.innerHTML = A.globals.collapsedSeriesIndices.indexOf(X) < 0 ? E : R;
                        else if (z.innerHTML = X === i ? E : R, i === X) break;
                    }
                }
                var Y = $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({
                    ttItems: s,
                    i: i,
                    j: a
                }, void 0 !== (null === (r = A.globals.seriesRange) || void 0 === r || null === (n = r[i]) || void 0 === n || null === (o = n[a]) || void 0 === o || null === (l = o.y[0]) || void 0 === l ? void 0 : l.y1) && {
                    y1: null === (h = A.globals.seriesRange) || void 0 === h || null === (c = h[i]) || void 0 === c || null === (d = c[a]) || void 0 === d || null === (g = d.y[0]) || void 0 === g ? void 0 : g.y1
                }), void 0 !== (null === (p = A.globals.seriesRange) || void 0 === p || null === (f = p[i]) || void 0 === f || null === (x = f[a]) || void 0 === x || null === (b = x.y[0]) || void 0 === b ? void 0 : b.y2) && {
                    y2: null === (m = A.globals.seriesRange) || void 0 === m || null === (v = m[i]) || void 0 === v || null === (y = v[a]) || void 0 === y || null === (w = y.y[0]) || void 0 === w ? void 0 : w.y2
                });
                if (k) {
                    if (C.tooltipLabels.drawSeriesTexts($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, Y), {}, {
                        shared: !this.showOnIntersect && this.tConfig.shared
                    })), S) M();
                    else if (this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(L), this.barSeriesHeight > 0)) {
                        var H = new $e4b487e979d7c06d$var$Mi(this.ctx), O = A.globals.dom.Paper.find(".apexcharts-bar-area[j='".concat(a, "']"));
                        this.deactivateHoverFilter(), C.tooltipUtil.getAllMarkers(!0).length && !this.barSeriesHeight && M(), C.tooltipPosition.moveStickyTooltipOverBars(a, i);
                        for(var F = 0; F < O.length; F++)H.pathMouseEnter(O[F]);
                    }
                } else C.tooltipLabels.drawSeriesTexts($e4b487e979d7c06d$var$u({
                    shared: !1
                }, Y)), this.tooltipUtil.hasBars() && C.tooltipPosition.moveStickyTooltipOverBars(a, i), S && C.tooltipPosition.moveMarkers(i, a);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$La = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.barCtx = e, this.totalFormatter = this.w.config.plotOptions.bar.dataLabels.total.formatter, this.totalFormatter || (this.totalFormatter = this.w.config.dataLabels.formatter);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "handleBarDataLabels",
            value: function(t) {
                var e, i, a = t.x, s = t.y, r = t.y1, n = t.y2, o = t.i, l = t.j, h = t.realIndex, c = t.columnGroupIndex, d = t.series, g = t.barHeight, p = t.barWidth, f = t.barXPosition, x = t.barYPosition, b = t.visibleSeries, m = this.w, v = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx), y = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[h] : this.barCtx.strokeWidth;
                m.globals.isXNumeric && !m.globals.isBarHorizontal ? (e = a + parseFloat(p * (b + 1)), i = s + parseFloat(g * (b + 1)) - y) : (e = a + parseFloat(p * b), i = s + parseFloat(g * b));
                var w, k = null, A = a, C = s, S = {}, L = m.config.dataLabels, M = this.barCtx.barOptions.dataLabels, P = this.barCtx.barOptions.dataLabels.total;
                void 0 !== x && this.barCtx.isRangeBar && (i = x, C = x), void 0 !== f && this.barCtx.isVerticalGroupedRangeBar && (e = f, A = f);
                var I = L.offsetX, T = L.offsetY, z = {
                    width: 0,
                    height: 0
                };
                if (m.config.dataLabels.enabled) {
                    var X = m.globals.series[o][l];
                    z = v.getTextRects(m.config.dataLabels.formatter ? m.config.dataLabels.formatter(X, $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, m), {}, {
                        seriesIndex: o,
                        dataPointIndex: l,
                        w: m
                    })) : m.globals.yLabelFormatters[0](X), parseFloat(L.style.fontSize));
                }
                var R = {
                    x: a,
                    y: s,
                    i: o,
                    j: l,
                    realIndex: h,
                    columnGroupIndex: c,
                    bcx: e,
                    bcy: i,
                    barHeight: g,
                    barWidth: p,
                    textRects: z,
                    strokeWidth: y,
                    dataLabelsX: A,
                    dataLabelsY: C,
                    dataLabelsConfig: L,
                    barDataLabelsConfig: M,
                    barTotalDataLabelsConfig: P,
                    offX: I,
                    offY: T
                };
                return S = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(R) : this.calculateColumnsDataLabelsPosition(R), w = this.drawCalculatedDataLabels({
                    x: S.dataLabelsX,
                    y: S.dataLabelsY,
                    val: this.barCtx.isRangeBar ? [
                        r,
                        n
                    ] : "100%" === m.config.chart.stackType ? d[h][l] : m.globals.series[h][l],
                    i: h,
                    j: l,
                    barWidth: p,
                    barHeight: g,
                    textRects: z,
                    dataLabelsConfig: L
                }), m.config.chart.stacked && P.enabled && (k = this.drawTotalDataLabels({
                    x: S.totalDataLabelsX,
                    y: S.totalDataLabelsY,
                    barWidth: p,
                    barHeight: g,
                    realIndex: h,
                    textAnchor: S.totalDataLabelsAnchor,
                    val: this.getStackedTotalDataLabel({
                        realIndex: h,
                        j: l
                    }),
                    dataLabelsConfig: L,
                    barTotalDataLabelsConfig: P
                })), {
                    dataLabelsPos: S,
                    dataLabels: w,
                    totalDataLabels: k
                };
            }
        },
        {
            key: "getStackedTotalDataLabel",
            value: function(t) {
                var e = t.realIndex, i = t.j, a = this.w, s = this.barCtx.stackedSeriesTotals[i];
                return this.totalFormatter && (s = this.totalFormatter(s, $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, a), {}, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }))), s;
            }
        },
        {
            key: "calculateColumnsDataLabelsPosition",
            value: function(t) {
                var e = this, i = this.w, a = t.i, s = t.j, r = t.realIndex;
                t.columnGroupIndex;
                var n, o, l = t.y, h = t.bcx, c = t.barWidth, d = t.barHeight, u = t.textRects, g = t.dataLabelsX, p = t.dataLabelsY, f = t.dataLabelsConfig, x = t.barDataLabelsConfig, b = t.barTotalDataLabelsConfig, m = t.strokeWidth, v = t.offX, y = t.offY, w = h;
                d = Math.abs(d);
                var k = "vertical" === i.config.plotOptions.bar.dataLabels.orientation, A = this.barCtx.barHelpers.getZeroValueEncounters({
                    i: a,
                    j: s
                }).zeroEncounters;
                h -= m / 2;
                var C = i.globals.gridWidth / i.globals.dataPoints;
                if (this.barCtx.isVerticalGroupedRangeBar ? g += c / 2 : (g = i.globals.isXNumeric ? h - c / 2 + v : h - C + c / 2 + v, !i.config.chart.stacked && A > 0 && i.config.plotOptions.bar.hideZeroBarsWhenGrouped && (g -= c * A)), k) g = g + u.height / 2 - m / 2 - 2;
                var S = i.globals.series[a][s] < 0, L = l;
                switch(this.barCtx.isReversed && (L = l + (S ? d : -d)), x.position){
                    case "center":
                        p = k ? S ? L - d / 2 + y : L + d / 2 - y : S ? L - d / 2 + u.height / 2 + y : L + d / 2 + u.height / 2 - y;
                        break;
                    case "bottom":
                        p = k ? S ? L - d + y : L + d - y : S ? L - d + u.height + m + y : L + d - u.height / 2 + m - y;
                        break;
                    case "top":
                        p = k ? S ? L + y : L - y : S ? L - u.height / 2 - y : L + u.height + y;
                }
                var M = L;
                if (i.globals.seriesGroups.forEach(function(t) {
                    var i;
                    null === (i = e.barCtx[t.join(",")]) || void 0 === i || i.prevY.forEach(function(t) {
                        M = S ? Math.max(t[s], M) : Math.min(t[s], M);
                    });
                }), this.barCtx.lastActiveBarSerieIndex === r && b.enabled) {
                    var P = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: r,
                        j: s
                    }), f.fontSize);
                    n = S ? M - P.height / 2 - y - b.offsetY + 18 : M + P.height + y + b.offsetY - 18;
                    var I = C;
                    o = w + (i.globals.isXNumeric ? -c * i.globals.barGroups.length / 2 : i.globals.barGroups.length * c / 2 - (i.globals.barGroups.length - 1) * c - I) + b.offsetX;
                }
                return i.config.chart.stacked || (p < 0 ? p = 0 + m : p + u.height / 3 > i.globals.gridHeight && (p = i.globals.gridHeight - m)), {
                    bcx: h,
                    bcy: l,
                    dataLabelsX: g,
                    dataLabelsY: p,
                    totalDataLabelsX: o,
                    totalDataLabelsY: n,
                    totalDataLabelsAnchor: "middle"
                };
            }
        },
        {
            key: "calculateBarsDataLabelsPosition",
            value: function(t) {
                var e = this, i = this.w, a = t.x, s = t.i, r = t.j, n = t.realIndex, o = t.bcy, l = t.barHeight, h = t.barWidth, c = t.textRects, d = t.dataLabelsX, u = t.strokeWidth, g = t.dataLabelsConfig, p = t.barDataLabelsConfig, f = t.barTotalDataLabelsConfig, x = t.offX, b = t.offY, m = i.globals.gridHeight / i.globals.dataPoints, v = this.barCtx.barHelpers.getZeroValueEncounters({
                    i: s,
                    j: r
                }).zeroEncounters;
                h = Math.abs(h);
                var y, w, k = o - (this.barCtx.isRangeBar ? 0 : m) + l / 2 + c.height / 2 + b - 3;
                !i.config.chart.stacked && v > 0 && i.config.plotOptions.bar.hideZeroBarsWhenGrouped && (k -= l * v);
                var A = "start", C = i.globals.series[s][r] < 0, S = a;
                switch(this.barCtx.isReversed && (S = a + (C ? -h : h), A = C ? "start" : "end"), p.position){
                    case "center":
                        d = C ? S + h / 2 - x : Math.max(c.width / 2, S - h / 2) + x;
                        break;
                    case "bottom":
                        d = C ? S + h - u - x : S - h + u + x;
                        break;
                    case "top":
                        d = C ? S - u - x : S - u + x;
                }
                var L = S;
                if (i.globals.seriesGroups.forEach(function(t) {
                    var i;
                    null === (i = e.barCtx[t.join(",")]) || void 0 === i || i.prevX.forEach(function(t) {
                        L = C ? Math.min(t[r], L) : Math.max(t[r], L);
                    });
                }), this.barCtx.lastActiveBarSerieIndex === n && f.enabled) {
                    var M = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx).getTextRects(this.getStackedTotalDataLabel({
                        realIndex: n,
                        j: r
                    }), g.fontSize);
                    C ? (y = L - u - x - f.offsetX, A = "end") : y = L + x + f.offsetX + (this.barCtx.isReversed ? -(h + u) : u), w = k - c.height / 2 + M.height / 2 + f.offsetY + u, i.globals.barGroups.length > 1 && (w -= i.globals.barGroups.length / 2 * (l / 2));
                }
                return i.config.chart.stacked || ("start" === g.textAnchor ? d - c.width < 0 ? d = C ? c.width + u : u : d + c.width > i.globals.gridWidth && (d = C ? i.globals.gridWidth - u : i.globals.gridWidth - c.width - u) : "middle" === g.textAnchor ? d - c.width / 2 < 0 ? d = c.width / 2 + u : d + c.width / 2 > i.globals.gridWidth && (d = i.globals.gridWidth - c.width / 2 - u) : "end" === g.textAnchor && (d < 1 ? d = c.width + u : d + 1 > i.globals.gridWidth && (d = i.globals.gridWidth - c.width - u))), {
                    bcx: a,
                    bcy: o,
                    dataLabelsX: d,
                    dataLabelsY: k,
                    totalDataLabelsX: y,
                    totalDataLabelsY: w,
                    totalDataLabelsAnchor: A
                };
            }
        },
        {
            key: "drawCalculatedDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.val, s = t.i, r = t.j, n = t.textRects, o = t.barHeight, l = t.barWidth, h = t.dataLabelsConfig, c = this.w, d = "rotate(0)";
                "vertical" === c.config.plotOptions.bar.dataLabels.orientation && (d = "rotate(-90, ".concat(e, ", ").concat(i, ")"));
                var g = new $e4b487e979d7c06d$var$qi(this.barCtx.ctx), p = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx), f = h.formatter, x = null, b = c.globals.collapsedSeriesIndices.indexOf(s) > -1;
                if (h.enabled && !b) {
                    x = p.group({
                        class: "apexcharts-data-labels",
                        transform: d
                    });
                    var m = "";
                    void 0 !== a && (m = f(a, $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, c), {}, {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: c
                    }))), !a && c.config.plotOptions.bar.hideZeroBarsWhenGrouped && (m = "");
                    var v = c.globals.series[s][r] < 0, y = c.config.plotOptions.bar.dataLabels.position;
                    if ("vertical" === c.config.plotOptions.bar.dataLabels.orientation && ("top" === y && (h.textAnchor = v ? "end" : "start"), "center" === y && (h.textAnchor = "middle"), "bottom" === y && (h.textAnchor = v ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels) l < p.getTextRects(m, parseFloat(h.style.fontSize)).width && (m = "");
                    c.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? n.width / 1.6 > Math.abs(l) && (m = "") : n.height / 1.6 > Math.abs(o) && (m = ""));
                    var w = $e4b487e979d7c06d$var$u({}, h);
                    this.barCtx.isHorizontal && a < 0 && ("start" === h.textAnchor ? w.textAnchor = "end" : "end" === h.textAnchor && (w.textAnchor = "start")), g.plotDataLabelsText({
                        x: e,
                        y: i,
                        text: m,
                        i: s,
                        j: r,
                        parent: x,
                        dataLabelsConfig: w,
                        alwaysDrawDataLabel: !0,
                        offsetCorrection: !0
                    });
                }
                return x;
            }
        },
        {
            key: "drawTotalDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.val, s = t.realIndex, r = t.textAnchor, n = t.barTotalDataLabelsConfig;
                this.w;
                var o, l = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx);
                return n.enabled && void 0 !== e && void 0 !== i && this.barCtx.lastActiveBarSerieIndex === s && (o = l.drawText({
                    x: e,
                    y: i,
                    foreColor: n.style.color,
                    text: a,
                    textAnchor: r,
                    fontFamily: n.style.fontFamily,
                    fontSize: n.style.fontSize,
                    fontWeight: n.style.fontWeight
                })), o;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ma = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.barCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "initVariables",
            value: function(t) {
                var e = this.w;
                this.barCtx.series = t, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                for(var i = 0; i < t.length; i++)if (t[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += t[i].length), e.globals.isXNumeric) for(var a = 0; a < t[i].length; a++)e.globals.seriesX[i][a] > e.globals.minX && e.globals.seriesX[i][a] < e.globals.maxX && this.barCtx.visibleItems++;
                else this.barCtx.visibleItems = e.globals.dataPoints;
                this.arrBorderRadius = this.createBorderRadiusArr(e.globals.series), $e4b487e979d7c06d$var$v.isSafari() && (this.arrBorderRadius = this.arrBorderRadius.map(function(t) {
                    return t.map(function(t) {
                        return "none";
                    });
                })), 0 === this.barCtx.seriesLen && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], e.globals.comboCharts || this.checkZeroSeries({
                    series: t
                });
            }
        },
        {
            key: "initialPositions",
            value: function(t) {
                var e, i, a, s, r, n, o, l, h = this.w, c = h.globals.dataPoints;
                this.barCtx.isRangeBar && (c = h.globals.labels.length);
                var d = this.barCtx.seriesLen;
                if (h.config.plotOptions.bar.rangeBarGroupRows && (d = 1), this.barCtx.isHorizontal) r = (a = h.globals.gridHeight / c) / d, h.globals.isXNumeric && (r = (a = h.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), r = r * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, -1 === String(this.barCtx.barOptions.barHeight).indexOf("%") && (r = parseInt(this.barCtx.barOptions.barHeight, 10)), l = this.barCtx.baseLineInvertedY + h.globals.padHorizontal + (this.barCtx.isReversed ? h.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), this.barCtx.isFunnel && (l = h.globals.gridWidth / 2), i = (a - r * this.barCtx.seriesLen) / 2;
                else {
                    if (s = h.globals.gridWidth / this.barCtx.visibleItems, h.config.xaxis.convertedCatToNumeric && (s = h.globals.gridWidth / h.globals.dataPoints), n = s / d * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, h.globals.isXNumeric) {
                        var u = this.barCtx.xRatio;
                        h.globals.minXDiff && .5 !== h.globals.minXDiff && h.globals.minXDiff / u > 0 && (s = h.globals.minXDiff / u), (n = s / d * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (n = 1);
                    }
                    if (-1 === String(this.barCtx.barOptions.columnWidth).indexOf("%") && (n = parseInt(this.barCtx.barOptions.columnWidth, 10)), o = h.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.translationsIndex] - (this.barCtx.isReversed ? h.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.translationsIndex] : 0), h.globals.isXNumeric) e = this.barCtx.getBarXForNumericXAxis({
                        x: e,
                        j: 0,
                        realIndex: t,
                        barWidth: n
                    }).x;
                    else e = h.globals.padHorizontal + $e4b487e979d7c06d$var$v.noExponents(s - n * this.barCtx.seriesLen) / 2;
                }
                return h.globals.barHeight = r, h.globals.barWidth = n, {
                    x: e,
                    y: i,
                    yDivision: a,
                    xDivision: s,
                    barHeight: r,
                    barWidth: n,
                    zeroH: o,
                    zeroW: l
                };
            }
        },
        {
            key: "initializeStackedPrevVars",
            value: function(t) {
                t.w.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].prevY = [], t[e].prevX = [], t[e].prevYF = [], t[e].prevXF = [], t[e].prevYVal = [], t[e].prevXVal = [];
                });
            }
        },
        {
            key: "initializeStackedXYVars",
            value: function(t) {
                t.w.globals.seriesGroups.forEach(function(e) {
                    t[e] || (t[e] = {}), t[e].xArrj = [], t[e].xArrjF = [], t[e].xArrjVal = [], t[e].yArrj = [], t[e].yArrjF = [], t[e].yArrjVal = [];
                });
            }
        },
        {
            key: "getPathFillColor",
            value: function(t, e, i, a) {
                var s, r, n, o, l = this.w, h = this.barCtx.ctx.fill, c = null, d = this.barCtx.barOptions.distributed ? i : e, u = !1;
                this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(a) {
                    t[e][i] >= a.from && t[e][i] <= a.to && (c = a.color, u = !0);
                });
                return {
                    color: h.fillPath({
                        seriesNumber: this.barCtx.barOptions.distributed ? d : a,
                        dataPointIndex: i,
                        color: c,
                        value: t[e][i],
                        fillConfig: null === (s = l.config.series[e].data[i]) || void 0 === s ? void 0 : s.fill,
                        fillType: null !== (r = l.config.series[e].data[i]) && void 0 !== r && null !== (n = r.fill) && void 0 !== n && n.type ? null === (o = l.config.series[e].data[i]) || void 0 === o ? void 0 : o.fill.type : Array.isArray(l.config.fill.type) ? l.config.fill.type[a] : l.config.fill.type
                    }),
                    useRangeColor: u
                };
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t, e, i) {
                var a = 0, s = this.w;
                return void 0 === this.barCtx.series[t][e] || null === this.barCtx.series[t][e] ? this.barCtx.isNullValue = !0 : this.barCtx.isNullValue = !1, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
            }
        },
        {
            key: "createBorderRadiusArr",
            value: function(t) {
                var e, i = this.w, a = !this.w.config.chart.stacked || i.config.plotOptions.bar.borderRadius <= 0, s = t.length, n = 0 | (null === (e = t[0]) || void 0 === e ? void 0 : e.length), o = Array.from({
                    length: s
                }, function() {
                    return Array(n).fill(a ? "top" : "none");
                });
                if (a) return o;
                for(var l = 0; l < n; l++){
                    for(var h = [], c = [], d = 0, u = 0; u < s; u++){
                        var g = t[u][l];
                        g > 0 ? (h.push(u), d++) : g < 0 && (c.push(u), d++);
                    }
                    if (h.length > 0 && 0 === c.length) {
                        if (1 === h.length) o[h[0]][l] = "both";
                        else {
                            var p, f = h[0], x = h[h.length - 1], b = $e4b487e979d7c06d$var$r(h);
                            try {
                                for(b.s(); !(p = b.n()).done;){
                                    var m = p.value;
                                    o[m][l] = m === f ? "bottom" : m === x ? "top" : "none";
                                }
                            } catch (t) {
                                b.e(t);
                            } finally{
                                b.f();
                            }
                        }
                    } else if (c.length > 0 && 0 === h.length) {
                        if (1 === c.length) o[c[0]][l] = "both";
                        else {
                            var v, y = Math.max.apply(Math, c), w = Math.min.apply(Math, c), k = $e4b487e979d7c06d$var$r(c);
                            try {
                                for(k.s(); !(v = k.n()).done;){
                                    var A = v.value;
                                    o[A][l] = A === y ? "bottom" : A === w ? "top" : "none";
                                }
                            } catch (t) {
                                k.e(t);
                            } finally{
                                k.f();
                            }
                        }
                    } else if (h.length > 0 && c.length > 0) {
                        var C, S = h[h.length - 1], L = $e4b487e979d7c06d$var$r(h);
                        try {
                            for(L.s(); !(C = L.n()).done;){
                                var M = C.value;
                                o[M][l] = M === S ? "top" : "none";
                            }
                        } catch (t) {
                            L.e(t);
                        } finally{
                            L.f();
                        }
                        var P, I = Math.max.apply(Math, c), T = $e4b487e979d7c06d$var$r(c);
                        try {
                            for(T.s(); !(P = T.n()).done;){
                                var z = P.value;
                                o[z][l] = z === I ? "bottom" : "none";
                            }
                        } catch (t) {
                            T.e(t);
                        } finally{
                            T.f();
                        }
                    } else if (1 === d) o[h[0] || c[0]][l] = "both";
                }
                return o;
            }
        },
        {
            key: "barBackground",
            value: function(t) {
                var e = t.j, i = t.i, a = t.x1, s = t.x2, r = t.y1, n = t.y2, o = t.elSeries, l = this.w, h = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx), c = new $e4b487e979d7c06d$var$Zi(this.barCtx.ctx).getActiveConfigSeriesIndex();
                if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && c === i) {
                    e >= this.barCtx.barOptions.colors.backgroundBarColors.length && (e %= this.barCtx.barOptions.colors.backgroundBarColors.length);
                    var d = this.barCtx.barOptions.colors.backgroundBarColors[e], u = h.drawRect(void 0 !== a ? a : 0, void 0 !== r ? r : 0, void 0 !== s ? s : l.globals.gridWidth, void 0 !== n ? n : l.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, d, this.barCtx.barOptions.colors.backgroundBarOpacity);
                    o.add(u), u.node.classList.add("apexcharts-backgroundBar");
                }
            }
        },
        {
            key: "getColumnPaths",
            value: function(t) {
                var e, i = t.barWidth, a = t.barXPosition, s = t.y1, r = t.y2, n = t.strokeWidth, o = t.isReversed, l = t.series, h = t.seriesGroup, c = t.realIndex, d = t.i, u = t.j, g = t.w, p = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx);
                (n = Array.isArray(n) ? n[c] : n) || (n = 0);
                var f = i, x = a;
                null !== (e = g.config.series[c].data[u]) && void 0 !== e && e.columnWidthOffset && (x = a - g.config.series[c].data[u].columnWidthOffset / 2, f = i + g.config.series[c].data[u].columnWidthOffset);
                var b = n / 2, m = x + b, v = x + f - b, y = (l[d][u] >= 0 ? 1 : -1) * (o ? -1 : 1);
                s += .001 - b * y, r += .001 + b * y;
                var w = p.move(m, s), k = p.move(m, s), A = p.line(v, s);
                if (g.globals.previousPaths.length > 0 && (k = this.barCtx.getPreviousPath(c, u, !1)), w = w + p.line(m, r) + p.line(v, r) + A + ("around" === g.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][u] ? " Z" : " z"), k = k + p.line(m, s) + A + A + A + A + A + p.line(m, s) + ("around" === g.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][u] ? " Z" : " z"), "none" !== this.arrBorderRadius[c][u] && (w = p.roundPathCorners(w, g.config.plotOptions.bar.borderRadius)), g.config.chart.stacked) {
                    var C = this.barCtx;
                    (C = this.barCtx[h]).yArrj.push(r - b * y), C.yArrjF.push(Math.abs(s - r + n * y)), C.yArrjVal.push(this.barCtx.series[d][u]);
                }
                return {
                    pathTo: w,
                    pathFrom: k
                };
            }
        },
        {
            key: "getBarpaths",
            value: function(t) {
                var e, i = t.barYPosition, a = t.barHeight, s = t.x1, r = t.x2, n = t.strokeWidth, o = t.isReversed, l = t.series, h = t.seriesGroup, c = t.realIndex, d = t.i, u = t.j, g = t.w, p = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx);
                (n = Array.isArray(n) ? n[c] : n) || (n = 0);
                var f = i, x = a;
                null !== (e = g.config.series[c].data[u]) && void 0 !== e && e.barHeightOffset && (f = i - g.config.series[c].data[u].barHeightOffset / 2, x = a + g.config.series[c].data[u].barHeightOffset);
                var b = n / 2, m = f + b, v = f + x - b, y = (l[d][u] >= 0 ? 1 : -1) * (o ? -1 : 1);
                s += .001 + b * y, r += .001 - b * y;
                var w = p.move(s, m), k = p.move(s, m);
                g.globals.previousPaths.length > 0 && (k = this.barCtx.getPreviousPath(c, u, !1));
                var A = p.line(s, v);
                if (w = w + p.line(r, m) + p.line(r, v) + A + ("around" === g.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][u] ? " Z" : " z"), k = k + p.line(s, m) + A + A + A + A + A + p.line(s, m) + ("around" === g.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[c][u] ? " Z" : " z"), "none" !== this.arrBorderRadius[c][u] && (w = p.roundPathCorners(w, g.config.plotOptions.bar.borderRadius)), g.config.chart.stacked) {
                    var C = this.barCtx;
                    (C = this.barCtx[h]).xArrj.push(r + b * y), C.xArrjF.push(Math.abs(s - r - n * y)), C.xArrjVal.push(this.barCtx.series[d][u]);
                }
                return {
                    pathTo: w,
                    pathFrom: k
                };
            }
        },
        {
            key: "checkZeroSeries",
            value: function(t) {
                for(var e = t.series, i = this.w, a = 0; a < e.length; a++){
                    for(var s = 0, r = 0; r < e[i.globals.maxValsInArrayIndex].length; r++)s += e[a][r];
                    0 === s && this.barCtx.zeroSerieses.push(a);
                }
            }
        },
        {
            key: "getXForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2] ? e : null;
                return null != t && (i = e + t / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? t / this.barCtx.invertedYRatio : 0)), i;
            }
        },
        {
            key: "getYForValue",
            value: function(t, e, i) {
                var a = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3] ? e : null;
                return null != t && (a = e - t / this.barCtx.yRatio[i] + 2 * (this.barCtx.isReversed ? t / this.barCtx.yRatio[i] : 0)), a;
            }
        },
        {
            key: "getGoalValues",
            value: function(t, e, i, a, s, r) {
                var n = this, l = this.w, h = [], c = function(a, s) {
                    var l;
                    h.push(($e4b487e979d7c06d$var$o(l = {}, t, "x" === t ? n.getXForValue(a, e, !1) : n.getYForValue(a, i, r, !1)), $e4b487e979d7c06d$var$o(l, "attrs", s), l));
                };
                if (l.globals.seriesGoals[a] && l.globals.seriesGoals[a][s] && Array.isArray(l.globals.seriesGoals[a][s]) && l.globals.seriesGoals[a][s].forEach(function(t) {
                    c(t.value, t);
                }), this.barCtx.barOptions.isDumbbell && l.globals.seriesRange.length) {
                    var d = this.barCtx.barOptions.dumbbellColors ? this.barCtx.barOptions.dumbbellColors : l.globals.colors, g = {
                        strokeHeight: "x" === t ? 0 : l.globals.markers.size[a],
                        strokeWidth: "x" === t ? l.globals.markers.size[a] : 0,
                        strokeDashArray: 0,
                        strokeLineCap: "round",
                        strokeColor: Array.isArray(d[a]) ? d[a][0] : d[a]
                    };
                    c(l.globals.seriesRangeStart[a][s], g), c(l.globals.seriesRangeEnd[a][s], $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, g), {}, {
                        strokeColor: Array.isArray(d[a]) ? d[a][1] : d[a]
                    }));
                }
                return h;
            }
        },
        {
            key: "drawGoalLine",
            value: function(t) {
                var e = t.barXPosition, i = t.barYPosition, a = t.goalX, s = t.goalY, r = t.barWidth, n = t.barHeight, o = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx), l = o.group({
                    className: "apexcharts-bar-goals-groups"
                });
                l.node.classList.add("apexcharts-element-hidden"), this.barCtx.w.globals.delayedElements.push({
                    el: l.node
                }), l.attr("clip-path", "url(#gridRectMarkerMask".concat(this.barCtx.w.globals.cuid, ")"));
                var h = null;
                return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(t) {
                    if (t.x >= -1 && t.x <= o.w.globals.gridWidth + 1) {
                        var e = void 0 !== t.attrs.strokeHeight ? t.attrs.strokeHeight : n / 2, a = i + e + n / 2;
                        h = o.drawLine(t.x, a - 2 * e, t.x, a, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeWidth ? t.attrs.strokeWidth : 2, t.attrs.strokeLineCap), l.add(h);
                    }
                }) : Array.isArray(s) && s.forEach(function(t) {
                    if (t.y >= -1 && t.y <= o.w.globals.gridHeight + 1) {
                        var i = void 0 !== t.attrs.strokeWidth ? t.attrs.strokeWidth : r / 2, a = e + i + r / 2;
                        h = o.drawLine(a - 2 * i, t.y, a, t.y, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeHeight ? t.attrs.strokeHeight : 2, t.attrs.strokeLineCap), l.add(h);
                    }
                }), l;
            }
        },
        {
            key: "drawBarShadow",
            value: function(t) {
                var e = t.prevPaths, i = t.currPaths, a = t.color, s = this.w, r = e.x, n = e.x1, o = e.barYPosition, l = i.x, h = i.x1, c = i.barYPosition, d = o + i.barHeight, u = new $e4b487e979d7c06d$var$Mi(this.barCtx.ctx), g = new $e4b487e979d7c06d$var$v, p = u.move(n, d) + u.line(r, d) + u.line(l, c) + u.line(h, c) + u.line(n, d) + ("around" === s.config.plotOptions.bar.borderRadiusApplication || "both" === this.arrBorderRadius[realIndex][j] ? " Z" : " z");
                return u.drawPath({
                    d: p,
                    fill: g.shadeColor(.5, $e4b487e979d7c06d$var$v.rgb2hex(a)),
                    stroke: "none",
                    strokeWidth: 0,
                    fillOpacity: 1,
                    classes: "apexcharts-bar-shadow apexcharts-decoration-element"
                });
            }
        },
        {
            key: "getZeroValueEncounters",
            value: function(t) {
                var e, i = t.i, a = t.j, s = this.w, r = 0, n = 0;
                return (s.config.plotOptions.bar.horizontal ? s.globals.series.map(function(t, e) {
                    return e;
                }) : (null === (e = s.globals.columnSeries) || void 0 === e ? void 0 : e.i.map(function(t) {
                    return t;
                })) || []).forEach(function(t) {
                    var e = s.globals.seriesPercent[t][a];
                    e && r++, t < i && 0 === e && n++;
                }), {
                    nonZeroColumns: r,
                    zeroEncounters: n
                };
            }
        },
        {
            key: "getGroupIndex",
            value: function(t) {
                var e = this.w, i = e.globals.seriesGroups.findIndex(function(i) {
                    return i.indexOf(e.globals.seriesNames[t]) > -1;
                }), a = this.barCtx.columnGroupIndices, s = a.indexOf(i);
                return s < 0 && (a.push(i), s = a.length - 1), {
                    groupIndex: i,
                    columnGroupIndex: s
                };
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Pa = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
        var s = this.w;
        this.barOptions = s.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = s.config.stroke.width, this.isNullValue = !1, this.isRangeBar = s.globals.seriesRange.length && this.isHorizontal, this.isVerticalGroupedRangeBar = !s.globals.isBarHorizontal && s.globals.seriesRange.length && s.config.plotOptions.bar.rangeBarGroupRows, this.isFunnel = this.barOptions.isFunnel, this.xyRatios = a, null !== this.xyRatios && (this.xRatio = a.xRatio, this.yRatio = a.yRatio, this.invertedXRatio = a.invertedXRatio, this.invertedYRatio = a.invertedYRatio, this.baseLineY = a.baseLineY, this.baseLineInvertedY = a.baseLineInvertedY), this.yaxisIndex = 0, this.translationsIndex = 0, this.seriesLen = 0, this.pathArr = [];
        var r = new $e4b487e979d7c06d$var$Zi(this.ctx);
        this.lastActiveBarSerieIndex = r.getActiveConfigSeriesIndex("desc", [
            "bar",
            "column"
        ]), this.columnGroupIndices = [];
        var n = r.getBarSeriesIndices(), o = new $e4b487e979d7c06d$var$Pi(this.ctx);
        this.stackedSeriesTotals = o.getStackedSeriesTotals(this.w.config.series.map(function(t, e) {
            return -1 === n.indexOf(e) ? e : -1;
        }).filter(function(t) {
            return -1 !== t;
        })), this.barHelpers = new $e4b487e979d7c06d$var$Ma(this);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Mi(this.ctx), s = new $e4b487e979d7c06d$var$Pi(this.ctx, i);
                t = s.getLogSeries(t), this.series = t, this.yRatio = s.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                var r = a.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                });
                i.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering - ApexCharts");
                for(var n = 0, o = 0; n < t.length; n++, o++){
                    var l, h, c, d, g = void 0, p = void 0, f = [], x = [], b = i.globals.comboCharts ? e[n] : n, m = this.barHelpers.getGroupIndex(b).columnGroupIndex, y = a.group({
                        class: "apexcharts-series",
                        rel: n + 1,
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(i.globals.seriesNames[b]),
                        "data:realIndex": b
                    });
                    this.ctx.series.addCollapsedClassToSeries(y, b), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var w = 0, k = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = i.globals.seriesYAxisReverseMap[b], this.translationsIndex = b);
                    var A = this.translationsIndex;
                    this.isReversed = i.config.yaxis[this.yaxisIndex] && i.config.yaxis[this.yaxisIndex].reversed;
                    var C = this.barHelpers.initialPositions(b);
                    p = C.y, w = C.barHeight, h = C.yDivision, d = C.zeroW, g = C.x, k = C.barWidth, l = C.xDivision, c = C.zeroH, this.isHorizontal || x.push(g + k / 2);
                    var S = a.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": b
                    });
                    i.globals.delayedElements.push({
                        el: S.node
                    }), S.node.classList.add("apexcharts-element-hidden");
                    var L = a.group({
                        class: "apexcharts-bar-goals-markers"
                    }), M = a.group({
                        class: "apexcharts-bar-shadows"
                    });
                    i.globals.delayedElements.push({
                        el: M.node
                    }), M.node.classList.add("apexcharts-element-hidden");
                    for(var P = 0; P < t[n].length; P++){
                        var I = this.barHelpers.getStrokeWidth(n, P, b), T = null, z = {
                            indexes: {
                                i: n,
                                j: P,
                                realIndex: b,
                                translationsIndex: A,
                                bc: o
                            },
                            x: g,
                            y: p,
                            strokeWidth: I,
                            elSeries: y
                        };
                        this.isHorizontal ? (T = this.drawBarPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, z), {}, {
                            barHeight: w,
                            zeroW: d,
                            yDivision: h
                        })), k = this.series[n][P] / this.invertedYRatio) : (T = this.drawColumnPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, z), {}, {
                            xDivision: l,
                            barWidth: k,
                            zeroH: c
                        })), w = this.series[n][P] / this.yRatio[A]);
                        var X = this.barHelpers.getPathFillColor(t, n, P, b);
                        if (this.isFunnel && this.barOptions.isFunnel3d && this.pathArr.length && P > 0) {
                            var R, E = this.barHelpers.drawBarShadow({
                                color: "string" == typeof X.color && -1 === (null === (R = X.color) || void 0 === R ? void 0 : R.indexOf("url")) ? X.color : $e4b487e979d7c06d$var$v.hexToRgba(i.globals.colors[n]),
                                prevPaths: this.pathArr[this.pathArr.length - 1],
                                currPaths: T
                            });
                            if (M.add(E), i.config.chart.dropShadow.enabled) new $e4b487e979d7c06d$var$Li(this.ctx).dropShadow(E, i.config.chart.dropShadow, b);
                        }
                        this.pathArr.push(T);
                        var Y = this.barHelpers.drawGoalLine({
                            barXPosition: T.barXPosition,
                            barYPosition: T.barYPosition,
                            goalX: T.goalX,
                            goalY: T.goalY,
                            barHeight: w,
                            barWidth: k
                        });
                        Y && L.add(Y), p = T.y, g = T.x, P > 0 && x.push(g + k / 2), f.push(p), this.renderSeries($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({
                            realIndex: b,
                            pathFill: X.color
                        }, X.useRangeColor ? {
                            lineFill: X.color
                        } : {}), {}, {
                            j: P,
                            i: n,
                            columnGroupIndex: m,
                            pathFrom: T.pathFrom,
                            pathTo: T.pathTo,
                            strokeWidth: I,
                            elSeries: y,
                            x: g,
                            y: p,
                            series: t,
                            barHeight: Math.abs(T.barHeight ? T.barHeight : w),
                            barWidth: Math.abs(T.barWidth ? T.barWidth : k),
                            elDataLabelsWrap: S,
                            elGoalsMarkers: L,
                            elBarShadows: M,
                            visibleSeries: this.visibleI,
                            type: "bar"
                        }));
                    }
                    i.globals.seriesXvalues[b] = x, i.globals.seriesYvalues[b] = f, r.add(y);
                }
                return r;
            }
        },
        {
            key: "renderSeries",
            value: function(t) {
                var e = t.realIndex, i = t.pathFill, a = t.lineFill, s = t.j, r = t.i, n = t.columnGroupIndex, o = t.pathFrom, l = t.pathTo, h = t.strokeWidth, c = t.elSeries, d = t.x, u = t.y, g = t.y1, p = t.y2, f = t.series, x = t.barHeight, b = t.barWidth, m = t.barXPosition, v = t.barYPosition, y = t.elDataLabelsWrap, w = t.elGoalsMarkers, k = t.elBarShadows, A = t.visibleSeries, C = t.type, S = t.classes, L = this.w, M = new $e4b487e979d7c06d$var$Mi(this.ctx), P = !1;
                if (!a) {
                    var I = "function" == typeof L.globals.stroke.colors[e] ? function(t) {
                        var e, i = L.config.stroke.colors;
                        return Array.isArray(i) && i.length > 0 && ((e = i[t]) || (e = ""), "function" == typeof e) ? e({
                            value: L.globals.series[t][s],
                            dataPointIndex: s,
                            w: L
                        }) : e;
                    }(e) : L.globals.stroke.colors[e];
                    a = this.barOptions.distributed ? L.globals.stroke.colors[s] : I;
                }
                var T = new $e4b487e979d7c06d$var$La(this).handleBarDataLabels({
                    x: d,
                    y: u,
                    y1: g,
                    y2: p,
                    i: r,
                    j: s,
                    series: f,
                    realIndex: e,
                    columnGroupIndex: n,
                    barHeight: x,
                    barWidth: b,
                    barXPosition: m,
                    barYPosition: v,
                    visibleSeries: A
                });
                L.globals.isBarHorizontal || (T.dataLabelsPos.dataLabelsX + b < 0 || T.dataLabelsPos.dataLabelsX - b > L.globals.gridWidth) && (P = !0), L.config.series[r].data[s] && L.config.series[r].data[s].strokeColor && (a = L.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                var z = s / L.config.chart.animations.animateGradually.delay * (L.config.chart.animations.speed / L.globals.dataPoints) / 2.4;
                if (!P) {
                    var X = M.renderPaths({
                        i: r,
                        j: s,
                        realIndex: e,
                        pathFrom: o,
                        pathTo: l,
                        stroke: a,
                        strokeWidth: h,
                        strokeLineCap: L.config.stroke.lineCap,
                        fill: i,
                        animationDelay: z,
                        initialSpeed: L.config.chart.animations.speed,
                        dataChangeSpeed: L.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-".concat(C, "-area ").concat(S),
                        chartType: C
                    });
                    X.attr("clip-path", "url(#gridRectBarMask".concat(L.globals.cuid, ")"));
                    var R = L.config.forecastDataPoints;
                    R.count > 0 && s >= L.globals.dataPoints - R.count && (X.node.setAttribute("stroke-dasharray", R.dashArray), X.node.setAttribute("stroke-width", R.strokeWidth), X.node.setAttribute("fill-opacity", R.fillOpacity)), void 0 !== g && void 0 !== p && (X.attr("data-range-y1", g), X.attr("data-range-y2", p)), new $e4b487e979d7c06d$var$Li(this.ctx).setSelectionFilter(X, e, s), c.add(X), X.attr({
                        cy: T.dataLabelsPos.bcy,
                        cx: T.dataLabelsPos.bcx,
                        j: s,
                        val: L.globals.series[r][s],
                        barHeight: x,
                        barWidth: b
                    }), null !== T.dataLabels && y.add(T.dataLabels), T.totalDataLabels && y.add(T.totalDataLabels), c.add(y), w && c.add(w), k && c.add(k);
                }
                return c;
            }
        },
        {
            key: "drawBarPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, n = t.x, o = t.y, l = t.yDivision, h = t.elSeries, c = this.w, d = i.i, u = i.j;
                if (c.globals.isXNumeric) e = (o = (c.globals.seriesX[d][u] - c.globals.minX) / this.invertedXRatio - a) + a * this.visibleI;
                else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var g = this.barHelpers.getZeroValueEncounters({
                        i: d,
                        j: u
                    }), p = g.nonZeroColumns, f = g.zeroEncounters;
                    p > 0 && (a = this.seriesLen * a / p), e = o + a * this.visibleI, e -= a * f;
                } else e = o + a * this.visibleI;
                this.isFunnel && (r -= (this.barHelpers.getXForValue(this.series[d][u], r) - r) / 2), n = this.barHelpers.getXForValue(this.series[d][u], r);
                var x = this.barHelpers.getBarpaths({
                    barYPosition: e,
                    barHeight: a,
                    x1: r,
                    x2: n,
                    strokeWidth: s,
                    isReversed: this.isReversed,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: d,
                    j: u,
                    w: c
                });
                return c.globals.isXNumeric || (o += l), this.barHelpers.barBackground({
                    j: u,
                    i: d,
                    y1: e - a * this.visibleI,
                    y2: a * this.seriesLen,
                    elSeries: h
                }), {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    x1: r,
                    x: n,
                    y: o,
                    goalX: this.barHelpers.getGoalValues("x", r, null, d, u),
                    barYPosition: e,
                    barHeight: a
                };
            }
        },
        {
            key: "drawColumnPaths",
            value: function(t) {
                var e, i = t.indexes, a = t.x, s = t.y, r = t.xDivision, n = t.barWidth, o = t.zeroH, l = t.strokeWidth, h = t.elSeries, c = this.w, d = i.realIndex, u = i.translationsIndex, g = i.i, p = i.j, f = i.bc;
                if (c.globals.isXNumeric) {
                    var x = this.getBarXForNumericXAxis({
                        x: a,
                        j: p,
                        realIndex: d,
                        barWidth: n
                    });
                    a = x.x, e = x.barXPosition;
                } else if (c.config.plotOptions.bar.hideZeroBarsWhenGrouped) {
                    var b = this.barHelpers.getZeroValueEncounters({
                        i: g,
                        j: p
                    }), m = b.nonZeroColumns, v = b.zeroEncounters;
                    m > 0 && (n = this.seriesLen * n / m), e = a + n * this.visibleI, e -= n * v;
                } else e = a + n * this.visibleI;
                s = this.barHelpers.getYForValue(this.series[g][p], o, u);
                var y = this.barHelpers.getColumnPaths({
                    barXPosition: e,
                    barWidth: n,
                    y1: o,
                    y2: s,
                    strokeWidth: l,
                    isReversed: this.isReversed,
                    series: this.series,
                    realIndex: d,
                    i: g,
                    j: p,
                    w: c
                });
                return c.globals.isXNumeric || (a += r), this.barHelpers.barBackground({
                    bc: f,
                    j: p,
                    i: g,
                    x1: e - l / 2 - n * this.visibleI,
                    x2: n * this.seriesLen + l / 2,
                    elSeries: h
                }), {
                    pathTo: y.pathTo,
                    pathFrom: y.pathFrom,
                    x: a,
                    y: s,
                    goalY: this.barHelpers.getGoalValues("y", null, o, g, p, u),
                    barXPosition: e,
                    barWidth: n
                };
            }
        },
        {
            key: "getBarXForNumericXAxis",
            value: function(t) {
                var e = t.x, i = t.barWidth, a = t.realIndex, s = t.j, r = this.w, n = a;
                return r.globals.seriesX[a].length || (n = r.globals.maxValsInArrayIndex), $e4b487e979d7c06d$var$v.isNumber(r.globals.seriesX[n][s]) && (e = (r.globals.seriesX[n][s] - r.globals.minX) / this.xRatio - i * this.seriesLen / 2), {
                    barXPosition: e + i * this.visibleI,
                    x: e
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t, e) {
                for(var i = this.w, a = "M 0 0", s = 0; s < i.globals.previousPaths.length; s++){
                    var r = i.globals.previousPaths[s];
                    r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(t, 10) && void 0 !== i.globals.previousPaths[s].paths[e] && (a = i.globals.previousPaths[s].paths[e].d);
                }
                return a;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ia = function(t) {
    $e4b487e979d7c06d$var$h(a, $e4b487e979d7c06d$var$Pa);
    var e = $e4b487e979d7c06d$var$n(a);
    function a() {
        return $e4b487e979d7c06d$var$i(this, a), e.apply(this, arguments);
    }
    return $e4b487e979d7c06d$var$s(a, [
        {
            key: "draw",
            value: function(t, e) {
                var i = this, a = this.w;
                this.graphics = new $e4b487e979d7c06d$var$Mi(this.ctx), this.bar = new $e4b487e979d7c06d$var$Pa(this.ctx, this.xyRatios);
                var s = new $e4b487e979d7c06d$var$Pi(this.ctx, a);
                t = s.getLogSeries(t), this.yRatio = s.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t), "100%" === a.config.chart.stackType && (t = a.globals.comboCharts ? e.map(function(t) {
                    return a.globals.seriesPercent[t];
                }) : a.globals.seriesPercent.slice()), this.series = t, this.barHelpers.initializeStackedPrevVars(this);
                for(var r = this.graphics.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                }), n = 0, o = 0, l = function(s, l) {
                    var h = void 0, c = void 0, d = void 0, g = void 0, p = a.globals.comboCharts ? e[s] : s, f = i.barHelpers.getGroupIndex(p), x = f.groupIndex, b = f.columnGroupIndex;
                    i.groupCtx = i[a.globals.seriesGroups[x]];
                    var m = [], y = [], w = 0;
                    i.yRatio.length > 1 && (i.yaxisIndex = a.globals.seriesYAxisReverseMap[p][0], w = p), i.isReversed = a.config.yaxis[i.yaxisIndex] && a.config.yaxis[i.yaxisIndex].reversed;
                    var k = i.graphics.group({
                        class: "apexcharts-series",
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(a.globals.seriesNames[p]),
                        rel: s + 1,
                        "data:realIndex": p
                    });
                    i.ctx.series.addCollapsedClassToSeries(k, p);
                    var A = i.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": p
                    }), C = i.graphics.group({
                        class: "apexcharts-bar-goals-markers"
                    }), S = 0, L = 0, M = i.initialPositions(n, o, h, c, d, g, w);
                    o = M.y, S = M.barHeight, c = M.yDivision, g = M.zeroW, n = M.x, L = M.barWidth, h = M.xDivision, d = M.zeroH, a.globals.barHeight = S, a.globals.barWidth = L, i.barHelpers.initializeStackedXYVars(i), 1 === i.groupCtx.prevY.length && i.groupCtx.prevY[0].every(function(t) {
                        return isNaN(t);
                    }) && (i.groupCtx.prevY[0] = i.groupCtx.prevY[0].map(function() {
                        return d;
                    }), i.groupCtx.prevYF[0] = i.groupCtx.prevYF[0].map(function() {
                        return 0;
                    }));
                    for(var P = 0; P < a.globals.dataPoints; P++){
                        var I = i.barHelpers.getStrokeWidth(s, P, p), T = {
                            indexes: {
                                i: s,
                                j: P,
                                realIndex: p,
                                translationsIndex: w,
                                bc: l
                            },
                            strokeWidth: I,
                            x: n,
                            y: o,
                            elSeries: k,
                            columnGroupIndex: b,
                            seriesGroup: a.globals.seriesGroups[x]
                        }, z = null;
                        i.isHorizontal ? (z = i.drawStackedBarPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, T), {}, {
                            zeroW: g,
                            barHeight: S,
                            yDivision: c
                        })), L = i.series[s][P] / i.invertedYRatio) : (z = i.drawStackedColumnPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, T), {}, {
                            xDivision: h,
                            barWidth: L,
                            zeroH: d
                        })), S = i.series[s][P] / i.yRatio[w]);
                        var X = i.barHelpers.drawGoalLine({
                            barXPosition: z.barXPosition,
                            barYPosition: z.barYPosition,
                            goalX: z.goalX,
                            goalY: z.goalY,
                            barHeight: S,
                            barWidth: L
                        });
                        X && C.add(X), o = z.y, n = z.x, m.push(n), y.push(o);
                        var R = i.barHelpers.getPathFillColor(t, s, P, p), E = "", Y = a.globals.isBarHorizontal ? "apexcharts-flip-x" : "apexcharts-flip-y";
                        ("bottom" === i.barHelpers.arrBorderRadius[p][P] && a.globals.series[p][P] > 0 || "top" === i.barHelpers.arrBorderRadius[p][P] && a.globals.series[p][P] < 0) && (E = Y), k = i.renderSeries($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({
                            realIndex: p,
                            pathFill: R.color
                        }, R.useRangeColor ? {
                            lineFill: R.color
                        } : {}), {}, {
                            j: P,
                            i: s,
                            columnGroupIndex: b,
                            pathFrom: z.pathFrom,
                            pathTo: z.pathTo,
                            strokeWidth: I,
                            elSeries: k,
                            x: n,
                            y: o,
                            series: t,
                            barHeight: S,
                            barWidth: L,
                            elDataLabelsWrap: A,
                            elGoalsMarkers: C,
                            type: "bar",
                            visibleSeries: b,
                            classes: E
                        }));
                    }
                    a.globals.seriesXvalues[p] = m, a.globals.seriesYvalues[p] = y, i.groupCtx.prevY.push(i.groupCtx.yArrj), i.groupCtx.prevYF.push(i.groupCtx.yArrjF), i.groupCtx.prevYVal.push(i.groupCtx.yArrjVal), i.groupCtx.prevX.push(i.groupCtx.xArrj), i.groupCtx.prevXF.push(i.groupCtx.xArrjF), i.groupCtx.prevXVal.push(i.groupCtx.xArrjVal), r.add(k);
                }, h = 0, c = 0; h < t.length; h++, c++)l(h, c);
                return r;
            }
        },
        {
            key: "initialPositions",
            value: function(t, e, i, a, s, r, n) {
                var o, l, h = this.w;
                if (this.isHorizontal) {
                    a = h.globals.gridHeight / h.globals.dataPoints;
                    var c = h.config.plotOptions.bar.barHeight;
                    o = -1 === String(c).indexOf("%") ? parseInt(c, 10) : a * parseInt(c, 10) / 100, r = h.globals.padHorizontal + (this.isReversed ? h.globals.gridWidth - this.baseLineInvertedY : this.baseLineInvertedY), e = (a - o) / 2;
                } else {
                    l = i = h.globals.gridWidth / h.globals.dataPoints;
                    var d = h.config.plotOptions.bar.columnWidth;
                    h.globals.isXNumeric && h.globals.dataPoints > 1 ? l = (i = h.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : -1 === String(d).indexOf("%") ? l = parseInt(d, 10) : l *= parseInt(d, 10) / 100, s = this.isReversed ? this.baseLineY[n] : h.globals.gridHeight - this.baseLineY[n], t = h.globals.padHorizontal + (i - l) / 2;
                }
                var u = h.globals.barGroups.length || 1;
                return {
                    x: t,
                    y: e,
                    yDivision: a,
                    xDivision: i,
                    barHeight: o / u,
                    barWidth: l / u,
                    zeroH: s,
                    zeroW: r
                };
            }
        },
        {
            key: "drawStackedBarPaths",
            value: function(t) {
                for(var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, n = t.x, o = t.y, l = t.columnGroupIndex, h = t.seriesGroup, c = t.yDivision, d = t.elSeries, u = this.w, g = o + l * a, p = i.i, f = i.j, x = i.realIndex, b = i.translationsIndex, m = 0, v = 0; v < this.groupCtx.prevXF.length; v++)m += this.groupCtx.prevXF[v][f];
                var y = p;
                if (u.config.series[x].name && (y = h.indexOf(u.config.series[x].name)), y > 0) {
                    var w = r;
                    this.groupCtx.prevXVal[y - 1][f] < 0 ? w = this.series[p][f] >= 0 ? this.groupCtx.prevX[y - 1][f] + m - 2 * (this.isReversed ? m : 0) : this.groupCtx.prevX[y - 1][f] : this.groupCtx.prevXVal[y - 1][f] >= 0 && (w = this.series[p][f] >= 0 ? this.groupCtx.prevX[y - 1][f] : this.groupCtx.prevX[y - 1][f] - m + 2 * (this.isReversed ? m : 0)), e = w;
                } else e = r;
                n = null === this.series[p][f] ? e : e + this.series[p][f] / this.invertedYRatio - 2 * (this.isReversed ? this.series[p][f] / this.invertedYRatio : 0);
                var k = this.barHelpers.getBarpaths({
                    barYPosition: g,
                    barHeight: a,
                    x1: e,
                    x2: n,
                    strokeWidth: s,
                    isReversed: this.isReversed,
                    series: this.series,
                    realIndex: i.realIndex,
                    seriesGroup: h,
                    i: p,
                    j: f,
                    w: u
                });
                return this.barHelpers.barBackground({
                    j: f,
                    i: p,
                    y1: g,
                    y2: a,
                    elSeries: d
                }), o += c, {
                    pathTo: k.pathTo,
                    pathFrom: k.pathFrom,
                    goalX: this.barHelpers.getGoalValues("x", r, null, p, f, b),
                    barXPosition: e,
                    barYPosition: g,
                    x: n,
                    y: o
                };
            }
        },
        {
            key: "drawStackedColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.y, s = t.xDivision, r = t.barWidth, n = t.zeroH, o = t.columnGroupIndex, l = t.seriesGroup, h = t.elSeries, c = this.w, d = e.i, u = e.j, g = e.bc, p = e.realIndex, f = e.translationsIndex;
                if (c.globals.isXNumeric) {
                    var x = c.globals.seriesX[p][u];
                    x || (x = 0), i = (x - c.globals.minX) / this.xRatio - r / 2 * c.globals.barGroups.length;
                }
                for(var b, m = i + o * r, v = 0, y = 0; y < this.groupCtx.prevYF.length; y++)v += isNaN(this.groupCtx.prevYF[y][u]) ? 0 : this.groupCtx.prevYF[y][u];
                var w = d;
                if (l && (w = l.indexOf(c.globals.seriesNames[p])), w > 0 && !c.globals.isXNumeric || w > 0 && c.globals.isXNumeric && c.globals.seriesX[p - 1][u] === c.globals.seriesX[p][u]) {
                    var k, A, C, S = Math.min(this.yRatio.length + 1, p + 1);
                    if (void 0 !== this.groupCtx.prevY[w - 1] && this.groupCtx.prevY[w - 1].length) for(var L = 1; L < S; L++){
                        var M;
                        if (!isNaN(null === (M = this.groupCtx.prevY[w - L]) || void 0 === M ? void 0 : M[u])) {
                            C = this.groupCtx.prevY[w - L][u];
                            break;
                        }
                    }
                    for(var P = 1; P < S; P++){
                        var I, T;
                        if ((null === (I = this.groupCtx.prevYVal[w - P]) || void 0 === I ? void 0 : I[u]) < 0) {
                            A = this.series[d][u] >= 0 ? C - v + 2 * (this.isReversed ? v : 0) : C;
                            break;
                        }
                        if ((null === (T = this.groupCtx.prevYVal[w - P]) || void 0 === T ? void 0 : T[u]) >= 0) {
                            A = this.series[d][u] >= 0 ? C : C + v - 2 * (this.isReversed ? v : 0);
                            break;
                        }
                    }
                    void 0 === A && (A = c.globals.gridHeight), b = null !== (k = this.groupCtx.prevYF[0]) && void 0 !== k && k.every(function(t) {
                        return 0 === t;
                    }) && this.groupCtx.prevYF.slice(1, w).every(function(t) {
                        return t.every(function(t) {
                            return isNaN(t);
                        });
                    }) ? n : A;
                } else b = n;
                a = this.series[d][u] ? b - this.series[d][u] / this.yRatio[f] + 2 * (this.isReversed ? this.series[d][u] / this.yRatio[f] : 0) : b;
                var z = this.barHelpers.getColumnPaths({
                    barXPosition: m,
                    barWidth: r,
                    y1: b,
                    y2: a,
                    yRatio: this.yRatio[f],
                    strokeWidth: this.strokeWidth,
                    isReversed: this.isReversed,
                    series: this.series,
                    seriesGroup: l,
                    realIndex: e.realIndex,
                    i: d,
                    j: u,
                    w: c
                });
                return this.barHelpers.barBackground({
                    bc: g,
                    j: u,
                    i: d,
                    x1: m,
                    x2: r,
                    elSeries: h
                }), {
                    pathTo: z.pathTo,
                    pathFrom: z.pathFrom,
                    goalY: this.barHelpers.getGoalValues("y", null, n, d, u),
                    barXPosition: m,
                    x: c.globals.isXNumeric ? i : i + s,
                    y: a
                };
            }
        }
    ]), a;
}(), $e4b487e979d7c06d$var$Ta = function(t) {
    $e4b487e979d7c06d$var$h(a, $e4b487e979d7c06d$var$Pa);
    var e = $e4b487e979d7c06d$var$n(a);
    function a() {
        return $e4b487e979d7c06d$var$i(this, a), e.apply(this, arguments);
    }
    return $e4b487e979d7c06d$var$s(a, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this, s = this.w, r = new $e4b487e979d7c06d$var$Mi(this.ctx), n = s.globals.comboCharts ? e : s.config.chart.type, o = new $e4b487e979d7c06d$var$ji(this.ctx);
                this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = s.config.plotOptions.bar.horizontal, this.isOHLC = this.candlestickOptions && "ohlc" === this.candlestickOptions.type;
                var l = new $e4b487e979d7c06d$var$Pi(this.ctx, s);
                t = l.getLogSeries(t), this.series = t, this.yRatio = l.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                for(var h = r.group({
                    class: "apexcharts-".concat(n, "-series apexcharts-plot-series")
                }), c = function(e) {
                    a.isBoxPlot = "boxPlot" === s.config.chart.type || "boxPlot" === s.config.series[e].type;
                    var n, l, c, d, g = void 0, p = void 0, f = [], x = [], b = s.globals.comboCharts ? i[e] : e, m = a.barHelpers.getGroupIndex(b).columnGroupIndex, y = r.group({
                        class: "apexcharts-series",
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(s.globals.seriesNames[b]),
                        rel: e + 1,
                        "data:realIndex": b
                    });
                    a.ctx.series.addCollapsedClassToSeries(y, b), t[e].length > 0 && (a.visibleI = a.visibleI + 1);
                    var w, k, A = 0;
                    a.yRatio.length > 1 && (a.yaxisIndex = s.globals.seriesYAxisReverseMap[b][0], A = b);
                    var C = a.barHelpers.initialPositions(b);
                    p = C.y, w = C.barHeight, l = C.yDivision, d = C.zeroW, g = C.x, k = C.barWidth, n = C.xDivision, c = C.zeroH, x.push(g + k / 2);
                    for(var S = r.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": b
                    }), L = r.group({
                        class: "apexcharts-bar-goals-markers"
                    }), M = function(i) {
                        var r = a.barHelpers.getStrokeWidth(e, i, b), h = null, v = {
                            indexes: {
                                i: e,
                                j: i,
                                realIndex: b,
                                translationsIndex: A
                            },
                            x: g,
                            y: p,
                            strokeWidth: r,
                            elSeries: y
                        };
                        h = a.isHorizontal ? a.drawHorizontalBoxPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, v), {}, {
                            yDivision: l,
                            barHeight: w,
                            zeroW: d
                        })) : a.drawVerticalBoxPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, v), {}, {
                            xDivision: n,
                            barWidth: k,
                            zeroH: c
                        })), p = h.y, g = h.x;
                        var C = a.barHelpers.drawGoalLine({
                            barXPosition: h.barXPosition,
                            barYPosition: h.barYPosition,
                            goalX: h.goalX,
                            goalY: h.goalY,
                            barHeight: w,
                            barWidth: k
                        });
                        C && L.add(C), i > 0 && x.push(g + k / 2), f.push(p), h.pathTo.forEach(function(n, l) {
                            var c = !a.isBoxPlot && a.candlestickOptions.wick.useFillColor ? h.color[l] : s.globals.stroke.colors[e], d = o.fillPath({
                                seriesNumber: b,
                                dataPointIndex: i,
                                color: h.color[l],
                                value: t[e][i]
                            });
                            a.renderSeries({
                                realIndex: b,
                                pathFill: d,
                                lineFill: c,
                                j: i,
                                i: e,
                                pathFrom: h.pathFrom,
                                pathTo: n,
                                strokeWidth: r,
                                elSeries: y,
                                x: g,
                                y: p,
                                series: t,
                                columnGroupIndex: m,
                                barHeight: w,
                                barWidth: k,
                                elDataLabelsWrap: S,
                                elGoalsMarkers: L,
                                visibleSeries: a.visibleI,
                                type: s.config.chart.type
                            });
                        });
                    }, P = 0; P < s.globals.dataPoints; P++)M(P);
                    s.globals.seriesXvalues[b] = x, s.globals.seriesYvalues[b] = f, h.add(y);
                }, d = 0; d < t.length; d++)c(d);
                return h;
            }
        },
        {
            key: "drawVerticalBoxPaths",
            value: function(t) {
                var e = t.indexes, i = t.x;
                t.y;
                var a = t.xDivision, s = t.barWidth, r = t.zeroH, n = t.strokeWidth, o = this.w, l = new $e4b487e979d7c06d$var$Mi(this.ctx), h = e.i, c = e.j, d = o.config.plotOptions.candlestick.colors, u = this.boxOptions.colors, g = e.realIndex, p = function(t) {
                    return Array.isArray(t) ? t[g] : t;
                }, f = p(d.upward), x = p(d.downward), b = this.yRatio[e.translationsIndex], m = this.getOHLCValue(g, c), v = r, y = r, w = m.o < m.c ? [
                    f
                ] : [
                    x
                ];
                this.isBoxPlot && (w = [
                    p(u.lower),
                    p(u.upper)
                ]);
                var k = Math.min(m.o, m.c), A = Math.max(m.o, m.c), C = m.m;
                o.globals.isXNumeric && (i = (o.globals.seriesX[g][c] - o.globals.minX) / this.xRatio - s / 2);
                var S = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (k = r, A = r) : (k = r - k / b, A = r - A / b, v = r - m.h / b, y = r - m.l / b, C = r - m.m / b);
                var L = l.move(S, r), M = l.move(S + s / 2, k);
                if (o.globals.previousPaths.length > 0 && (M = this.getPreviousPath(g, c, !0)), this.isOHLC) {
                    var P = S + s / 2, I = r - m.o / b, T = r - m.c / b;
                    L = [
                        l.move(P, v) + l.line(P, y) + l.move(P, I) + l.line(S, I) + l.move(P, T) + l.line(S + s, T)
                    ];
                } else L = this.isBoxPlot ? [
                    l.move(S, k) + l.line(S + s / 2, k) + l.line(S + s / 2, v) + l.line(S + s / 4, v) + l.line(S + s - s / 4, v) + l.line(S + s / 2, v) + l.line(S + s / 2, k) + l.line(S + s, k) + l.line(S + s, C) + l.line(S, C) + l.line(S, k + n / 2),
                    l.move(S, C) + l.line(S + s, C) + l.line(S + s, A) + l.line(S + s / 2, A) + l.line(S + s / 2, y) + l.line(S + s - s / 4, y) + l.line(S + s / 4, y) + l.line(S + s / 2, y) + l.line(S + s / 2, A) + l.line(S, A) + l.line(S, C) + "z"
                ] : [
                    l.move(S, A) + l.line(S + s / 2, A) + l.line(S + s / 2, v) + l.line(S + s / 2, A) + l.line(S + s, A) + l.line(S + s, k) + l.line(S + s / 2, k) + l.line(S + s / 2, y) + l.line(S + s / 2, k) + l.line(S, k) + l.line(S, A - n / 2)
                ];
                return M += l.move(S, k), o.globals.isXNumeric || (i += a), {
                    pathTo: L,
                    pathFrom: M,
                    x: i,
                    y: A,
                    goalY: this.barHelpers.getGoalValues("y", null, r, h, c, e.translationsIndex),
                    barXPosition: S,
                    color: w
                };
            }
        },
        {
            key: "drawHorizontalBoxPaths",
            value: function(t) {
                var e = t.indexes;
                t.x;
                var i = t.y, a = t.yDivision, s = t.barHeight, r = t.zeroW, n = t.strokeWidth, o = this.w, l = new $e4b487e979d7c06d$var$Mi(this.ctx), h = e.i, c = e.j, d = this.boxOptions.colors.lower;
                this.isBoxPlot && (d = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var u = this.invertedYRatio, g = e.realIndex, p = this.getOHLCValue(g, c), f = r, x = r, b = Math.min(p.o, p.c), m = Math.max(p.o, p.c), v = p.m;
                o.globals.isXNumeric && (i = (o.globals.seriesX[g][c] - o.globals.minX) / this.invertedXRatio - s / 2);
                var y = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (b = r, m = r) : (b = r + b / u, m = r + m / u, f = r + p.h / u, x = r + p.l / u, v = r + p.m / u);
                var w = l.move(r, y), k = l.move(b, y + s / 2);
                return o.globals.previousPaths.length > 0 && (k = this.getPreviousPath(g, c, !0)), w = [
                    l.move(b, y) + l.line(b, y + s / 2) + l.line(f, y + s / 2) + l.line(f, y + s / 2 - s / 4) + l.line(f, y + s / 2 + s / 4) + l.line(f, y + s / 2) + l.line(b, y + s / 2) + l.line(b, y + s) + l.line(v, y + s) + l.line(v, y) + l.line(b + n / 2, y),
                    l.move(v, y) + l.line(v, y + s) + l.line(m, y + s) + l.line(m, y + s / 2) + l.line(x, y + s / 2) + l.line(x, y + s - s / 4) + l.line(x, y + s / 4) + l.line(x, y + s / 2) + l.line(m, y + s / 2) + l.line(m, y) + l.line(v, y) + "z"
                ], k += l.move(b, y), o.globals.isXNumeric || (i += a), {
                    pathTo: w,
                    pathFrom: k,
                    x: m,
                    y: i,
                    goalX: this.barHelpers.getGoalValues("x", r, null, h, c),
                    barYPosition: y,
                    color: d
                };
            }
        },
        {
            key: "getOHLCValue",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Pi(this.ctx, i), s = a.getLogValAtSeriesIndex(i.globals.seriesCandleH[t][e], t), r = a.getLogValAtSeriesIndex(i.globals.seriesCandleO[t][e], t), n = a.getLogValAtSeriesIndex(i.globals.seriesCandleM[t][e], t), o = a.getLogValAtSeriesIndex(i.globals.seriesCandleC[t][e], t), l = a.getLogValAtSeriesIndex(i.globals.seriesCandleL[t][e], t);
                return {
                    o: this.isBoxPlot ? s : r,
                    h: this.isBoxPlot ? r : s,
                    m: n,
                    l: this.isBoxPlot ? o : l,
                    c: this.isBoxPlot ? l : o
                };
            }
        }
    ]), a;
}(), $e4b487e979d7c06d$var$za = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "checkColorRange",
            value: function() {
                var t = this.w, e = !1, i = t.config.plotOptions[t.config.chart.type];
                return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(t, i) {
                    t.from <= 0 && (e = !0);
                }), e;
            }
        },
        {
            key: "getShadeColor",
            value: function(t, e, i, a) {
                var s = this.w, r = 1, n = s.config.plotOptions[t].shadeIntensity, o = this.determineColor(t, e, i);
                s.globals.hasNegs || a ? r = s.config.plotOptions[t].reverseNegativeShade ? o.percent < 0 ? o.percent / 100 * (1.25 * n) : (1 - o.percent / 100) * (1.25 * n) : o.percent <= 0 ? 1 - (1 + o.percent / 100) * n : (1 - o.percent / 100) * n : (r = 1 - o.percent / 100, "treemap" === t && (r = (1 - o.percent / 100) * (1.25 * n)));
                var l = o.color, h = new $e4b487e979d7c06d$var$v;
                if (s.config.plotOptions[t].enableShades) {
                    if ("dark" === this.w.config.theme.mode) {
                        var c = h.shadeColor(-1 * r, o.color);
                        l = $e4b487e979d7c06d$var$v.hexToRgba($e4b487e979d7c06d$var$v.isColorHex(c) ? c : $e4b487e979d7c06d$var$v.rgb2hex(c), s.config.fill.opacity);
                    } else {
                        var d = h.shadeColor(r, o.color);
                        l = $e4b487e979d7c06d$var$v.hexToRgba($e4b487e979d7c06d$var$v.isColorHex(d) ? d : $e4b487e979d7c06d$var$v.rgb2hex(d), s.config.fill.opacity);
                    }
                }
                return {
                    color: l,
                    colorProps: o
                };
            }
        },
        {
            key: "determineColor",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.series[e][i], r = a.config.plotOptions[t], n = r.colorScale.inverse ? i : e;
                r.distributed && "treemap" === a.config.chart.type && (n = i);
                var o = a.globals.colors[n], l = null, h = Math.min.apply(Math, $e4b487e979d7c06d$var$f(a.globals.series[e])), c = Math.max.apply(Math, $e4b487e979d7c06d$var$f(a.globals.series[e]));
                r.distributed || "heatmap" !== t || (h = a.globals.minY, c = a.globals.maxY), void 0 !== r.colorScale.min && (h = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, c = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                var d = Math.abs(c) + Math.abs(h), u = 100 * s / (0 === d ? d - 1e-6 : d);
                r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(t, e) {
                    if (s >= t.from && s <= t.to) {
                        o = t.color, l = t.foreColor ? t.foreColor : null, h = t.from, c = t.to;
                        var i = Math.abs(c) + Math.abs(h);
                        u = 100 * s / (0 === i ? i - 1e-6 : i);
                    }
                });
                return {
                    color: o,
                    foreColor: l,
                    percent: u
                };
            }
        },
        {
            key: "calculateDataLabels",
            value: function(t) {
                var e = t.text, i = t.x, a = t.y, s = t.i, r = t.j, n = t.colorProps, o = t.fontSize, l = this.w.config.dataLabels, h = new $e4b487e979d7c06d$var$Mi(this.ctx), c = new $e4b487e979d7c06d$var$qi(this.ctx), d = null;
                if (l.enabled) {
                    d = h.group({
                        class: "apexcharts-data-labels"
                    });
                    var u = l.offsetX, g = l.offsetY, p = i + u, f = a + parseFloat(l.style.fontSize) / 3 + g;
                    c.plotDataLabelsText({
                        x: p,
                        y: f,
                        text: e,
                        i: s,
                        j: r,
                        color: n.foreColor,
                        parent: d,
                        fontSize: o,
                        dataLabelsConfig: l
                    });
                }
                return d;
            }
        },
        {
            key: "addListeners",
            value: function(t) {
                var e = new $e4b487e979d7c06d$var$Mi(this.ctx);
                t.node.addEventListener("mouseenter", e.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", e.pathMouseLeave.bind(this, t)), t.node.addEventListener("mousedown", e.pathMouseDown.bind(this, t));
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Xa = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.xRatio = a.xRatio, this.yRatio = a.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new $e4b487e979d7c06d$var$za(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = i.group({
                    class: "apexcharts-heatmap"
                });
                a.attr("clip-path", "url(#gridRectMask".concat(e.globals.cuid, ")"));
                var s = e.globals.gridWidth / e.globals.dataPoints, r = e.globals.gridHeight / e.globals.series.length, n = 0, o = !1;
                this.negRange = this.helpers.checkColorRange();
                var l = t.slice();
                e.config.yaxis[0].reversed && (o = !0, l.reverse());
                for(var h = o ? 0 : l.length - 1; o ? h < l.length : h >= 0; o ? h++ : h--){
                    var c = i.group({
                        class: "apexcharts-series apexcharts-heatmap-series",
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(e.globals.seriesNames[h]),
                        rel: h + 1,
                        "data:realIndex": h
                    });
                    if (this.ctx.series.addCollapsedClassToSeries(c, h), e.config.chart.dropShadow.enabled) {
                        var d = e.config.chart.dropShadow;
                        new $e4b487e979d7c06d$var$Li(this.ctx).dropShadow(c, d, h);
                    }
                    for(var u = 0, g = e.config.plotOptions.heatmap.shadeIntensity, p = 0, f = 0; f < e.globals.dataPoints; f++)if (e.globals.seriesX.length && !e.globals.allSeriesHasEqualX && e.globals.minX + e.globals.minXDiff * f < e.globals.seriesX[h][p]) u += s;
                    else {
                        if (p >= l[h].length) break;
                        var x = this.helpers.getShadeColor(e.config.chart.type, h, p, this.negRange), b = x.color, m = x.colorProps;
                        if ("image" === e.config.fill.type) b = new $e4b487e979d7c06d$var$ji(this.ctx).fillPath({
                            seriesNumber: h,
                            dataPointIndex: p,
                            opacity: e.globals.hasNegs ? m.percent < 0 ? 1 - (1 + m.percent / 100) : g + m.percent / 100 : m.percent / 100,
                            patternID: $e4b487e979d7c06d$var$v.randomId(),
                            width: e.config.fill.image.width ? e.config.fill.image.width : s,
                            height: e.config.fill.image.height ? e.config.fill.image.height : r
                        });
                        var y = this.rectRadius, w = i.drawRect(u, n, s, r, y);
                        if (w.attr({
                            cx: u,
                            cy: n
                        }), w.node.classList.add("apexcharts-heatmap-rect"), c.add(w), w.attr({
                            fill: b,
                            i: h,
                            index: h,
                            j: p,
                            val: t[h][p],
                            "stroke-width": this.strokeWidth,
                            stroke: e.config.plotOptions.heatmap.useFillColorAsStroke ? b : e.globals.stroke.colors[0],
                            color: b
                        }), this.helpers.addListeners(w), e.config.chart.animations.enabled && !e.globals.dataChanged) {
                            var k = 1;
                            e.globals.resized || (k = e.config.chart.animations.speed), this.animateHeatMap(w, u, n, s, r, k);
                        }
                        if (e.globals.dataChanged) {
                            var A = 1;
                            if (this.dynamicAnim.enabled && e.globals.shouldAnimate) {
                                A = this.dynamicAnim.speed;
                                var C = e.globals.previousPaths[h] && e.globals.previousPaths[h][p] && e.globals.previousPaths[h][p].color;
                                C || (C = "rgba(255, 255, 255, 0)"), this.animateHeatColor(w, $e4b487e979d7c06d$var$v.isColorHex(C) ? C : $e4b487e979d7c06d$var$v.rgb2hex(C), $e4b487e979d7c06d$var$v.isColorHex(b) ? b : $e4b487e979d7c06d$var$v.rgb2hex(b), A);
                            }
                        }
                        var S = (0, e.config.dataLabels.formatter)(e.globals.series[h][p], {
                            value: e.globals.series[h][p],
                            seriesIndex: h,
                            dataPointIndex: p,
                            w: e
                        }), L = this.helpers.calculateDataLabels({
                            text: S,
                            x: u + s / 2,
                            y: n + r / 2,
                            i: h,
                            j: p,
                            colorProps: m,
                            series: l
                        });
                        null !== L && c.add(L), u += s, p++;
                    }
                    n += r, a.add(c);
                }
                var M = e.globals.yAxisScale[0].result.slice();
                return e.config.yaxis[0].reversed ? M.unshift("") : M.push(""), e.globals.yAxisScale[0].result = M, a;
            }
        },
        {
            key: "animateHeatMap",
            value: function(t, e, i, a, s, r) {
                var n = new $e4b487e979d7c06d$var$y(this.ctx);
                n.animateRect(t, {
                    x: e + a / 2,
                    y: i + s / 2,
                    width: 0,
                    height: 0
                }, {
                    x: e,
                    y: i,
                    width: a,
                    height: s
                }, r, function() {
                    n.animationCompleted(t);
                });
            }
        },
        {
            key: "animateHeatColor",
            value: function(t, e, i, a) {
                t.attr({
                    fill: e
                }).animate(a).attr({
                    fill: i
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ra = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "drawYAxisTexts",
            value: function(t, e, i, a) {
                var s = this.w, r = s.config.yaxis[0], n = s.globals.yLabelFormatters[0];
                return new $e4b487e979d7c06d$var$Mi(this.ctx).drawText({
                    x: t + r.labels.offsetX,
                    y: e + r.labels.offsetY,
                    text: n(a, i),
                    textAnchor: "middle",
                    fontSize: r.labels.style.fontSize,
                    fontFamily: r.labels.style.fontFamily,
                    foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ea = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
        var a = this.w;
        this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
            0
        ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = void 0 !== a.globals.stroke.colors ? a.globals.stroke.colors : a.globals.colors, this.defaultSize = Math.min(a.globals.gridWidth, a.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = a.globals.gridWidth / 2, "radialBar" === a.config.chart.type ? this.fullAngle = 360 : this.fullAngle = Math.abs(a.config.plotOptions.pie.endAngle - a.config.plotOptions.pie.startAngle), this.initialAngle = a.config.plotOptions.pie.startAngle % this.fullAngle, a.globals.radialSize = this.defaultSize / 2.05 - a.config.stroke.width - (a.config.chart.sparkline.enabled ? 0 : a.config.chart.dropShadow.blur), this.donutSize = a.globals.radialSize * parseInt(a.config.plotOptions.pie.donut.size, 10) / 100;
        var s = a.config.plotOptions.pie.customScale, r = a.globals.gridWidth / 2, n = a.globals.gridHeight / 2;
        this.translateX = r - r * s, this.translateY = n - n * s, this.dataLabelsGroup = new $e4b487e979d7c06d$var$Mi(this.ctx).group({
            class: "apexcharts-datalabels-group",
            transform: "translate(".concat(this.translateX, ", ").concat(this.translateY, ") scale(").concat(s, ")")
        }), this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $e4b487e979d7c06d$var$Mi(this.ctx), s = a.group({
                    class: "apexcharts-pie"
                });
                if (i.globals.noData) return s;
                for(var r = 0, n = 0; n < t.length; n++)r += $e4b487e979d7c06d$var$v.negToZero(t[n]);
                var o = [], l = a.group();
                0 === r && (r = 1e-5), t.forEach(function(t) {
                    e.maxY = Math.max(e.maxY, t);
                }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), "back" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(s);
                for(var h = 0; h < t.length; h++){
                    var c = this.fullAngle * $e4b487e979d7c06d$var$v.negToZero(t[h]) / r;
                    o.push(c), "polarArea" === this.chartType ? (o[h] = this.fullAngle / t.length, this.sliceSizes.push(i.globals.radialSize * t[h] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                }
                if (i.globals.dataChanged) {
                    for(var d, u = 0, g = 0; g < i.globals.previousPaths.length; g++)u += $e4b487e979d7c06d$var$v.negToZero(i.globals.previousPaths[g]);
                    for(var p = 0; p < i.globals.previousPaths.length; p++)d = this.fullAngle * $e4b487e979d7c06d$var$v.negToZero(i.globals.previousPaths[p]) / u, this.prevSectorAngleArr.push(d);
                }
                if (this.donutSize < 0 && (this.donutSize = 0), "donut" === this.chartType) {
                    var f = a.drawCircle(this.donutSize);
                    f.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                    }), l.add(f);
                }
                var x = this.drawArcs(o, t);
                if (this.sliceLabels.forEach(function(t) {
                    x.add(t);
                }), l.attr({
                    transform: "translate(".concat(this.translateX, ", ").concat(this.translateY, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                }), l.add(x), s.add(l), this.donutDataLabels.show) {
                    var b = this.renderInnerDataLabels(this.dataLabelsGroup, this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show
                    });
                    s.add(b);
                }
                return "front" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(s), s;
            }
        },
        {
            key: "drawArcs",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Li(this.ctx), s = new $e4b487e979d7c06d$var$Mi(this.ctx), r = new $e4b487e979d7c06d$var$ji(this.ctx), n = s.group({
                    class: "apexcharts-slices"
                }), o = this.initialAngle, l = this.initialAngle, h = this.initialAngle, c = this.initialAngle;
                this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                for(var d = 0; d < t.length; d++){
                    var u = s.group({
                        class: "apexcharts-series apexcharts-pie-series",
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(i.globals.seriesNames[d]),
                        rel: d + 1,
                        "data:realIndex": d
                    });
                    n.add(u), l = c, h = (o = h) + t[d], c = l + this.prevSectorAngleArr[d];
                    var g = h < o ? this.fullAngle + h - o : h - o, p = r.fillPath({
                        seriesNumber: d,
                        size: this.sliceSizes[d],
                        value: e[d]
                    }), f = this.getChangedPath(l, c), x = s.drawPath({
                        d: f,
                        stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[d] : this.lineColorArr,
                        strokeWidth: 0,
                        fill: p,
                        fillOpacity: i.config.fill.opacity,
                        classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(d)
                    });
                    if (x.attr({
                        index: 0,
                        j: d
                    }), a.setSelectionFilter(x, 0, d), i.config.chart.dropShadow.enabled) {
                        var b = i.config.chart.dropShadow;
                        a.dropShadow(x, b, d);
                    }
                    this.addListeners(x, this.donutDataLabels), $e4b487e979d7c06d$var$Mi.setAttrs(x.node, {
                        "data:angle": g,
                        "data:startAngle": o,
                        "data:strokeWidth": this.strokeWidth,
                        "data:value": e[d]
                    });
                    var m = {
                        x: 0,
                        y: 0
                    };
                    "pie" === this.chartType || "polarArea" === this.chartType ? m = $e4b487e979d7c06d$var$v.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (o + g / 2) % this.fullAngle) : "donut" === this.chartType && (m = $e4b487e979d7c06d$var$v.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (o + g / 2) % this.fullAngle)), u.add(x);
                    var y = 0;
                    if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : (0 === (y = g / this.fullAngle * i.config.chart.animations.speed) && (y = 1), this.animDur = y + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(x, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: o,
                        prevStartAngle: l,
                        prevEndAngle: c,
                        animateStartingPos: !0,
                        i: d,
                        animBeginArr: this.animBeginArr,
                        shouldSetPrevPaths: !0,
                        dur: i.config.chart.animations.dynamicAnimation.speed
                    }) : this.animatePaths(x, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: o,
                        i: d,
                        totalItems: t.length - 1,
                        animBeginArr: this.animBeginArr,
                        dur: y
                    }), i.config.plotOptions.pie.expandOnClick && "polarArea" !== this.chartType && x.node.addEventListener("mouseup", this.pieClicked.bind(this, d)), void 0 !== i.globals.selectedDataPoints[0] && i.globals.selectedDataPoints[0].indexOf(d) > -1 && this.pieClicked(d), i.config.dataLabels.enabled) {
                        var w = m.x, k = m.y, A = 100 * g / this.fullAngle + "%";
                        if (0 !== g && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < t[d]) {
                            var C = i.config.dataLabels.formatter;
                            void 0 !== C && (A = C(i.globals.seriesPercent[d][0], {
                                seriesIndex: d,
                                w: i
                            }));
                            var S = i.globals.dataLabels.style.colors[d], L = s.group({
                                class: "apexcharts-datalabels"
                            }), M = s.drawText({
                                x: w,
                                y: k,
                                text: A,
                                textAnchor: "middle",
                                fontSize: i.config.dataLabels.style.fontSize,
                                fontFamily: i.config.dataLabels.style.fontFamily,
                                fontWeight: i.config.dataLabels.style.fontWeight,
                                foreColor: S
                            });
                            if (L.add(M), i.config.dataLabels.dropShadow.enabled) {
                                var P = i.config.dataLabels.dropShadow;
                                a.dropShadow(M, P);
                            }
                            M.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && !1 === i.globals.resized && (M.node.classList.add("apexcharts-pie-label-delay"), M.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(L);
                        }
                    }
                }
                return n;
            }
        },
        {
            key: "addListeners",
            value: function(t, e) {
                var i = new $e4b487e979d7c06d$var$Mi(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, t)), t.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this, t)), this.donutDataLabels.total.showAlways || (t.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, t.node, e)));
            }
        },
        {
            key: "animatePaths",
            value: function(t, e) {
                var i = this.w, a = e.endAngle < e.startAngle ? this.fullAngle + e.endAngle - e.startAngle : e.endAngle - e.startAngle, s = a, r = e.startAngle, n = e.startAngle;
                void 0 !== e.prevStartAngle && void 0 !== e.prevEndAngle && (r = e.prevEndAngle, s = e.prevEndAngle < e.prevStartAngle ? this.fullAngle + e.prevEndAngle - e.prevStartAngle : e.prevEndAngle - e.prevStartAngle), e.i === i.config.series.length - 1 && (a + n > this.fullAngle ? e.endAngle = e.endAngle - (a + n) : a + n < this.fullAngle && (e.endAngle = e.endAngle + (this.fullAngle - (a + n)))), a === this.fullAngle && (a = this.fullAngle - .01), this.animateArc(t, r, n, a, s, e);
            }
        },
        {
            key: "animateArc",
            value: function(t, e, i, a, s, r) {
                var n, o = this, l = this.w, h = new $e4b487e979d7c06d$var$y(this.ctx), c = r.size;
                (isNaN(e) || isNaN(s)) && (e = i, s = a, r.dur = 0);
                var d = a, u = i, g = e < i ? this.fullAngle + e - i : e - i;
                l.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (n = o.getPiePath({
                    me: o,
                    startAngle: r.prevStartAngle,
                    angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                    size: c
                }), t.attr({
                    d: n
                })), 0 !== r.dur ? t.animate(r.dur, r.animBeginArr[r.i]).after(function() {
                    "pie" !== o.chartType && "donut" !== o.chartType && "polarArea" !== o.chartType || this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({
                        "stroke-width": o.strokeWidth
                    }), r.i === l.config.series.length - 1 && h.animationCompleted(t);
                }).during(function(l) {
                    d = g + (a - g) * l, r.animateStartingPos && (d = s + (a - s) * l, u = e - s + (i - (e - s)) * l), n = o.getPiePath({
                        me: o,
                        startAngle: u,
                        angle: d,
                        size: c
                    }), t.node.setAttribute("data:pathOrig", n), t.attr({
                        d: n
                    });
                }) : (n = o.getPiePath({
                    me: o,
                    startAngle: u,
                    angle: a,
                    size: c
                }), r.isTrack || (l.globals.animationEnded = !0), t.node.setAttribute("data:pathOrig", n), t.attr({
                    d: n,
                    "stroke-width": o.strokeWidth
                }));
            }
        },
        {
            key: "pieClicked",
            value: function(t) {
                var e, i = this.w, a = this, s = a.sliceSizes[t] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.findOne(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(t));
                if ("true" !== r.attr("data:pieClicked")) {
                    var n = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                    Array.prototype.forEach.call(n, function(t) {
                        t.setAttribute("data:pieClicked", "false");
                        var e = t.getAttribute("data:pathOrig");
                        e && t.setAttribute("d", e);
                    }), i.globals.capturedDataPointIndex = t, r.attr("data:pieClicked", "true");
                    var o = parseInt(r.attr("data:startAngle"), 10), l = parseInt(r.attr("data:angle"), 10);
                    e = a.getPiePath({
                        me: a,
                        startAngle: o,
                        angle: l,
                        size: s
                    }), 360 !== l && r.plot(e);
                } else {
                    r.attr({
                        "data:pieClicked": "false"
                    }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                    var h = r.attr("data:pathOrig");
                    r.attr({
                        d: h
                    });
                }
            }
        },
        {
            key: "getChangedPath",
            value: function(t, e) {
                var i = "";
                return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                    me: this,
                    startAngle: t,
                    angle: e - t,
                    size: this.size
                })), i;
            }
        },
        {
            key: "getPiePath",
            value: function(t) {
                var e, i = t.me, a = t.startAngle, s = t.angle, r = t.size, n = new $e4b487e979d7c06d$var$Mi(this.ctx), o = a, l = Math.PI * (o - 90) / 180, h = s + a;
                Math.ceil(h) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (h = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - .01), Math.ceil(h) > this.fullAngle && (h -= this.fullAngle);
                var c = Math.PI * (h - 90) / 180, d = i.centerX + r * Math.cos(l), u = i.centerY + r * Math.sin(l), g = i.centerX + r * Math.cos(c), p = i.centerY + r * Math.sin(c), f = $e4b487e979d7c06d$var$v.polarToCartesian(i.centerX, i.centerY, i.donutSize, h), x = $e4b487e979d7c06d$var$v.polarToCartesian(i.centerX, i.centerY, i.donutSize, o), b = s > 180 ? 1 : 0, m = [
                    "M",
                    d,
                    u,
                    "A",
                    r,
                    r,
                    0,
                    b,
                    1,
                    g,
                    p
                ];
                return e = "donut" === i.chartType ? [].concat(m, [
                    "L",
                    f.x,
                    f.y,
                    "A",
                    i.donutSize,
                    i.donutSize,
                    0,
                    b,
                    0,
                    x.x,
                    x.y,
                    "L",
                    d,
                    u,
                    "z"
                ]).join(" ") : "pie" === i.chartType || "polarArea" === i.chartType ? [].concat(m, [
                    "L",
                    i.centerX,
                    i.centerY,
                    "L",
                    d,
                    u
                ]).join(" ") : [].concat(m).join(" "), n.roundPathCorners(e, 2 * this.strokeWidth);
            }
        },
        {
            key: "drawPolarElements",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$ta(this.ctx), a = new $e4b487e979d7c06d$var$Mi(this.ctx), s = new $e4b487e979d7c06d$var$Ra(this.ctx), r = a.group(), n = a.group(), o = i.niceScale(0, Math.ceil(this.maxY), 0), l = o.result.reverse(), h = o.result.length;
                this.maxY = o.niceMax;
                for(var c = e.globals.radialSize, d = c / (h - 1), u = 0; u < h - 1; u++){
                    var g = a.drawCircle(c);
                    if (g.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: "none",
                        "stroke-width": e.config.plotOptions.polarArea.rings.strokeWidth,
                        stroke: e.config.plotOptions.polarArea.rings.strokeColor
                    }), e.config.yaxis[0].show) {
                        var p = s.drawYAxisTexts(this.centerX, this.centerY - c + parseInt(e.config.yaxis[0].labels.style.fontSize, 10) / 2, u, l[u]);
                        n.add(p);
                    }
                    r.add(g), c -= d;
                }
                this.drawSpokes(t), t.add(r), t.add(n);
            }
        },
        {
            key: "renderInnerDataLabels",
            value: function(t, e, i) {
                var a = this.w, s = new $e4b487e979d7c06d$var$Mi(this.ctx), r = e.total.show;
                t.node.innerHTML = "", t.node.style.opacity = i.opacity;
                var n, o, l = i.centerX, h = this.donutDataLabels.total.label ? i.centerY : i.centerY - i.centerY / 6;
                n = void 0 === e.name.color ? a.globals.colors[0] : e.name.color;
                var c = e.name.fontSize, d = e.name.fontFamily, u = e.name.fontWeight;
                o = void 0 === e.value.color ? a.config.chart.foreColor : e.value.color;
                var g = e.value.formatter, p = "", f = "";
                if (r ? (n = e.total.color, c = e.total.fontSize, d = e.total.fontFamily, u = e.total.fontWeight, f = this.donutDataLabels.total.label ? e.total.label : "", p = e.total.formatter(a)) : 1 === a.globals.series.length && (p = g(a.globals.series[0], a), f = a.globals.seriesNames[0]), f && (f = e.name.formatter(f, e.total.show, a)), e.name.show) {
                    var x = s.drawText({
                        x: l,
                        y: h + parseFloat(e.name.offsetY),
                        text: f,
                        textAnchor: "middle",
                        foreColor: n,
                        fontSize: c,
                        fontWeight: u,
                        fontFamily: d
                    });
                    x.node.classList.add("apexcharts-datalabel-label"), t.add(x);
                }
                if (e.value.show) {
                    var b = e.name.show ? parseFloat(e.value.offsetY) + 16 : e.value.offsetY, m = s.drawText({
                        x: l,
                        y: h + b,
                        text: p,
                        textAnchor: "middle",
                        foreColor: o,
                        fontWeight: e.value.fontWeight,
                        fontSize: e.value.fontSize,
                        fontFamily: e.value.fontFamily
                    });
                    m.node.classList.add("apexcharts-datalabel-value"), t.add(m);
                }
                return t;
            }
        },
        {
            key: "printInnerLabels",
            value: function(t, e, i, a) {
                var s, r = this.w;
                a ? s = void 0 === t.name.color ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : t.name.color : r.globals.series.length > 1 && t.total.show && (s = t.total.color);
                var n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                i = (0, t.value.formatter)(i, r), a || "function" != typeof t.total.formatter || (i = t.total.formatter(r));
                var l = e === t.total.label;
                e = this.donutDataLabels.total.label ? t.name.formatter(e, l, r) : "", null !== n && (n.textContent = e), null !== o && (o.textContent = i), null !== n && (n.style.fill = s);
            }
        },
        {
            key: "printDataLabelsInner",
            value: function(t, e) {
                var i = this.w, a = t.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"), 10) - 1];
                i.globals.series.length > 1 && this.printInnerLabels(e, s, a, t);
                var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                null !== r && (r.style.opacity = 1);
            }
        },
        {
            key: "drawSpokes",
            value: function(t) {
                var e = this, i = this.w, a = new $e4b487e979d7c06d$var$Mi(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                if (0 !== s.strokeWidth) {
                    for(var r = [], n = 360 / i.globals.series.length, o = 0; o < i.globals.series.length; o++)r.push($e4b487e979d7c06d$var$v.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + n * o));
                    r.forEach(function(i, r) {
                        var n = a.drawLine(i.x, i.y, e.centerX, e.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[r] : s.connectorColors);
                        t.add(n);
                    });
                }
            }
        },
        {
            key: "revertDataLabelsInner",
            value: function() {
                var t = this.w;
                if (this.donutDataLabels.show) {
                    var e = t.globals.dom.Paper.findOne(".apexcharts-datalabels-group"), i = this.renderInnerDataLabels(e, this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show
                    });
                    t.globals.dom.Paper.findOne(".apexcharts-radialbar, .apexcharts-pie").add(i);
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ya = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
        var a = this.w;
        this.graphics = new $e4b487e979d7c06d$var$Mi(this.ctx), this.lineColorArr = void 0 !== a.globals.stroke.colors ? a.globals.stroke.colors : a.globals.colors, this.defaultSize = a.globals.svgHeight < a.globals.svgWidth ? a.globals.gridHeight : a.globals.gridWidth, this.isLog = a.config.yaxis[0].logarithmic, this.logBase = a.config.yaxis[0].logBase, this.coreUtils = new $e4b487e979d7c06d$var$Pi(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(this.logBase, a.globals.maxY, 0) : a.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.logBase, this.w.globals.minY, 0) : a.globals.minY, this.polygons = a.config.plotOptions.radar.polygons, this.strokeWidth = a.config.stroke.show ? a.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - a.config.chart.dropShadow.blur, a.config.xaxis.labels.show && (this.size = this.size - a.globals.xAxisLabelsWidth / 1.75), void 0 !== a.config.plotOptions.radar.size && (this.size = a.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $e4b487e979d7c06d$var$ji(this.ctx), s = [], r = new $e4b487e979d7c06d$var$qi(this.ctx);
                t.length && (this.dataPointsLen = t[i.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                var n = i.globals.gridWidth / 2, o = i.globals.gridHeight / 2, l = n + i.config.plotOptions.radar.offsetX, h = o + i.config.plotOptions.radar.offsetY, c = this.graphics.group({
                    class: "apexcharts-radar-series apexcharts-plot-series",
                    transform: "translate(".concat(l || 0, ", ").concat(h || 0, ")")
                }), d = [], g = null, p = null;
                if (this.yaxisLabels = this.graphics.group({
                    class: "apexcharts-yaxis"
                }), t.forEach(function(t, n) {
                    var o = t.length === i.globals.dataPoints, l = e.graphics.group().attr({
                        class: "apexcharts-series",
                        "data:longestSeries": o,
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(i.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    e.dataRadiusOfPercent[n] = [], e.dataRadius[n] = [], e.angleArr[n] = [], t.forEach(function(t, i) {
                        var a = Math.abs(e.maxValue - e.minValue);
                        t -= e.minValue, e.isLog && (t = e.coreUtils.getLogVal(e.logBase, t, 0)), e.dataRadiusOfPercent[n][i] = t / a, e.dataRadius[n][i] = e.dataRadiusOfPercent[n][i] * e.size, e.angleArr[n][i] = i * e.disAngle;
                    }), d = e.getDataPointsPos(e.dataRadius[n], e.angleArr[n]);
                    var h = e.createPaths(d, {
                        x: 0,
                        y: 0
                    });
                    g = e.graphics.group({
                        class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                    }), p = e.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": n
                    }), i.globals.delayedElements.push({
                        el: g.node,
                        index: n
                    });
                    var c = {
                        i: n,
                        realIndex: n,
                        animationDelay: n,
                        initialSpeed: i.config.chart.animations.speed,
                        dataChangeSpeed: i.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-radar",
                        shouldClipToGrid: !1,
                        bindEventsOnPaths: !1,
                        stroke: i.globals.stroke.colors[n],
                        strokeLineCap: i.config.stroke.lineCap
                    }, f = null;
                    i.globals.previousPaths.length > 0 && (f = e.getPreviousPath(n));
                    for(var x = 0; x < h.linePathsTo.length; x++){
                        var b = e.graphics.renderPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, c), {}, {
                            pathFrom: null === f ? h.linePathsFrom[x] : f,
                            pathTo: h.linePathsTo[x],
                            strokeWidth: Array.isArray(e.strokeWidth) ? e.strokeWidth[n] : e.strokeWidth,
                            fill: "none",
                            drawShadow: !1
                        }));
                        l.add(b);
                        var m = a.fillPath({
                            seriesNumber: n
                        }), y = e.graphics.renderPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, c), {}, {
                            pathFrom: null === f ? h.areaPathsFrom[x] : f,
                            pathTo: h.areaPathsTo[x],
                            strokeWidth: 0,
                            fill: m,
                            drawShadow: !1
                        }));
                        if (i.config.chart.dropShadow.enabled) {
                            var w = new $e4b487e979d7c06d$var$Li(e.ctx), k = i.config.chart.dropShadow;
                            w.dropShadow(y, Object.assign({}, k, {
                                noUserSpaceOnUse: !0
                            }), n);
                        }
                        l.add(y);
                    }
                    t.forEach(function(t, a) {
                        var s = new $e4b487e979d7c06d$var$Vi(e.ctx).getMarkerConfig({
                            cssClass: "apexcharts-marker",
                            seriesIndex: n,
                            dataPointIndex: a
                        }), o = e.graphics.drawMarker(d[a].x, d[a].y, s);
                        o.attr("rel", a), o.attr("j", a), o.attr("index", n), o.node.setAttribute("default-marker-size", s.pSize);
                        var h = e.graphics.group({
                            class: "apexcharts-series-markers"
                        });
                        h && h.add(o), g.add(h), l.add(g);
                        var c = i.config.dataLabels;
                        if (c.enabled) {
                            var f = c.formatter(i.globals.series[n][a], {
                                seriesIndex: n,
                                dataPointIndex: a,
                                w: i
                            });
                            r.plotDataLabelsText({
                                x: d[a].x,
                                y: d[a].y,
                                text: f,
                                textAnchor: "middle",
                                i: n,
                                j: n,
                                parent: p,
                                offsetCorrection: !1,
                                dataLabelsConfig: $e4b487e979d7c06d$var$u({}, c)
                            });
                        }
                        l.add(p);
                    }), s.push(l);
                }), this.drawPolygons({
                    parent: c
                }), i.config.xaxis.labels.show) {
                    var f = this.drawXAxisTexts();
                    c.add(f);
                }
                return s.forEach(function(t) {
                    c.add(t);
                }), c.add(this.yaxisLabels), c;
            }
        },
        {
            key: "drawPolygons",
            value: function(t) {
                for(var e = this, i = this.w, a = t.parent, s = new $e4b487e979d7c06d$var$Ra(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), n = r.length, o = [], l = this.size / (n - 1), h = 0; h < n; h++)o[h] = l * h;
                o.reverse();
                var c = [], d = [];
                o.forEach(function(t, i) {
                    var a = $e4b487e979d7c06d$var$v.getPolygonPos(t, e.dataPointsLen), s = "";
                    a.forEach(function(t, a) {
                        if (0 === i) {
                            var r = e.graphics.drawLine(t.x, t.y, 0, 0, Array.isArray(e.polygons.connectorColors) ? e.polygons.connectorColors[a] : e.polygons.connectorColors);
                            d.push(r);
                        }
                        0 === a && e.yaxisLabelsTextsPos.push({
                            x: t.x,
                            y: t.y
                        }), s += t.x + "," + t.y + " ";
                    }), c.push(s);
                }), c.forEach(function(t, s) {
                    var r = e.polygons.strokeColors, n = e.polygons.strokeWidth, o = e.graphics.drawPolygon(t, Array.isArray(r) ? r[s] : r, Array.isArray(n) ? n[s] : n, i.globals.radarPolygons.fill.colors[s]);
                    a.add(o);
                }), d.forEach(function(t) {
                    a.add(t);
                }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(t, i) {
                    var a = s.drawYAxisTexts(t.x, t.y, i, r[i]);
                    e.yaxisLabels.add(a);
                });
            }
        },
        {
            key: "drawXAxisTexts",
            value: function() {
                var t = this, e = this.w, i = e.config.xaxis.labels, a = this.graphics.group({
                    class: "apexcharts-xaxis"
                }), s = $e4b487e979d7c06d$var$v.getPolygonPos(this.size, this.dataPointsLen);
                return e.globals.labels.forEach(function(r, n) {
                    var o = e.config.xaxis.labels.formatter, l = new $e4b487e979d7c06d$var$qi(t.ctx);
                    if (s[n]) {
                        var h = t.getTextPos(s[n], t.size), c = o(r, {
                            seriesIndex: -1,
                            dataPointIndex: n,
                            w: e
                        });
                        l.plotDataLabelsText({
                            x: h.newX,
                            y: h.newY,
                            text: c,
                            textAnchor: h.textAnchor,
                            i: n,
                            j: n,
                            parent: a,
                            className: "apexcharts-xaxis-label",
                            color: Array.isArray(i.style.colors) && i.style.colors[n] ? i.style.colors[n] : "#a8a8a8",
                            dataLabelsConfig: $e4b487e979d7c06d$var$u({
                                textAnchor: h.textAnchor,
                                dropShadow: {
                                    enabled: !1
                                }
                            }, i),
                            offsetCorrection: !1
                        }).on("click", function(i) {
                            if ("function" == typeof e.config.chart.events.xAxisLabelClick) {
                                var a = Object.assign({}, e, {
                                    labelIndex: n
                                });
                                e.config.chart.events.xAxisLabelClick(i, t.ctx, a);
                            }
                        });
                    }
                }), a;
            }
        },
        {
            key: "createPaths",
            value: function(t, e) {
                var i = this, a = [], s = [], r = [], n = [];
                if (t.length) {
                    s = [
                        this.graphics.move(e.x, e.y)
                    ], n = [
                        this.graphics.move(e.x, e.y)
                    ];
                    var o = this.graphics.move(t[0].x, t[0].y), l = this.graphics.move(t[0].x, t[0].y);
                    t.forEach(function(e, a) {
                        o += i.graphics.line(e.x, e.y), l += i.graphics.line(e.x, e.y), a === t.length - 1 && (o += "Z", l += "Z");
                    }), a.push(o), r.push(l);
                }
                return {
                    linePathsFrom: s,
                    linePathsTo: a,
                    areaPathsFrom: n,
                    areaPathsTo: r
                };
            }
        },
        {
            key: "getTextPos",
            value: function(t, e) {
                var i = "middle", a = t.x, s = t.y;
                return Math.abs(t.x) >= 10 ? t.x > 0 ? (i = "start", a += 10) : t.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(t.y) >= e - 10 && (t.y < 0 ? s -= 10 : t.y > 0 && (s += 10)), {
                    textAnchor: i,
                    newX: a,
                    newY: s
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t) {
                for(var e = this.w, i = null, a = 0; a < e.globals.previousPaths.length; a++){
                    var s = e.globals.previousPaths[a];
                    s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(t, 10) && void 0 !== e.globals.previousPaths[a].paths[0] && (i = e.globals.previousPaths[a].paths[0].d);
                }
                return i;
            }
        },
        {
            key: "getDataPointsPos",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.dataPointsLen;
                t = t || [], e = e || [];
                for(var a = [], s = 0; s < i; s++){
                    var r = {};
                    r.x = t[s] * Math.sin(e[s]), r.y = -t[s] * Math.cos(e[s]), a.push(r);
                }
                return a;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Ha = function(t) {
    $e4b487e979d7c06d$var$h(r, $e4b487e979d7c06d$var$Ea);
    var a = $e4b487e979d7c06d$var$n(r);
    function r(t) {
        var s;
        $e4b487e979d7c06d$var$i(this, r), (s = a.call(this, t)).ctx = t, s.w = t.w, s.animBeginArr = [
            0
        ], s.animDur = 0;
        var n = s.w;
        return s.startAngle = n.config.plotOptions.radialBar.startAngle, s.endAngle = n.config.plotOptions.radialBar.endAngle, s.totalAngle = Math.abs(n.config.plotOptions.radialBar.endAngle - n.config.plotOptions.radialBar.startAngle), s.trackStartAngle = n.config.plotOptions.radialBar.track.startAngle, s.trackEndAngle = n.config.plotOptions.radialBar.track.endAngle, s.barLabels = s.w.config.plotOptions.radialBar.barLabels, s.donutDataLabels = s.w.config.plotOptions.radialBar.dataLabels, s.radialDataLabels = s.donutDataLabels, s.trackStartAngle || (s.trackStartAngle = s.startAngle), s.trackEndAngle || (s.trackEndAngle = s.endAngle), 360 === s.endAngle && (s.endAngle = 359.99), s.margin = parseInt(n.config.plotOptions.radialBar.track.margin, 10), s.onBarLabelClick = s.onBarLabelClick.bind($e4b487e979d7c06d$var$e(s)), s;
    }
    return $e4b487e979d7c06d$var$s(r, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = i.group({
                    class: "apexcharts-radialbar"
                });
                if (e.globals.noData) return a;
                var s = i.group(), r = this.defaultSize / 2, n = e.globals.gridWidth / 2, o = this.defaultSize / 2.05;
                e.config.chart.sparkline.enabled || (o = o - e.config.stroke.width - e.config.chart.dropShadow.blur);
                var l = e.globals.fill.colors;
                if (e.config.plotOptions.radialBar.track.show) {
                    var h = this.drawTracks({
                        size: o,
                        centerX: n,
                        centerY: r,
                        colorArr: l,
                        series: t
                    });
                    s.add(h);
                }
                var c = this.drawArcs({
                    size: o,
                    centerX: n,
                    centerY: r,
                    colorArr: l,
                    series: t
                }), d = 360;
                e.config.plotOptions.radialBar.startAngle < 0 && (d = this.totalAngle);
                var u = (360 - d) / 360;
                if (e.globals.radialSize = o - o * u, this.radialDataLabels.value.show) {
                    var g = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                    e.globals.radialSize += g * u;
                }
                return s.add(c.g), "front" === e.config.plotOptions.radialBar.hollow.position && (c.g.add(c.elHollow), c.dataLabels && c.g.add(c.dataLabels)), a.add(s), a;
            }
        },
        {
            key: "drawTracks",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = i.group({
                    class: "apexcharts-tracks"
                }), s = new $e4b487e979d7c06d$var$Li(this.ctx), r = new $e4b487e979d7c06d$var$ji(this.ctx), n = this.getStrokeWidth(t);
                t.size = t.size - n / 2;
                for(var o = 0; o < t.series.length; o++){
                    var l = i.group({
                        class: "apexcharts-radialbar-track apexcharts-track"
                    });
                    a.add(l), l.attr({
                        rel: o + 1
                    }), t.size = t.size - n - this.margin;
                    var h = e.config.plotOptions.radialBar.track, c = r.fillPath({
                        seriesNumber: 0,
                        size: t.size,
                        fillColors: Array.isArray(h.background) ? h.background[o] : h.background,
                        solid: !0
                    }), d = this.trackStartAngle, u = this.trackEndAngle;
                    Math.abs(u) + Math.abs(d) >= 360 && (u = 360 - Math.abs(this.startAngle) - .1);
                    var g = i.drawPath({
                        d: "",
                        stroke: c,
                        strokeWidth: n * parseInt(h.strokeWidth, 10) / 100,
                        fill: "none",
                        strokeOpacity: h.opacity,
                        classes: "apexcharts-radialbar-area"
                    });
                    if (h.dropShadow.enabled) {
                        var p = h.dropShadow;
                        s.dropShadow(g, p);
                    }
                    l.add(g), g.attr("id", "apexcharts-radialbarTrack-" + o), this.animatePaths(g, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: u,
                        startAngle: d,
                        size: t.size,
                        i: o,
                        totalItems: 2,
                        animBeginArr: 0,
                        dur: 0,
                        isTrack: !0
                    });
                }
                return a;
            }
        },
        {
            key: "drawArcs",
            value: function(t) {
                var e = this.w, i = new $e4b487e979d7c06d$var$Mi(this.ctx), a = new $e4b487e979d7c06d$var$ji(this.ctx), s = new $e4b487e979d7c06d$var$Li(this.ctx), r = i.group(), n = this.getStrokeWidth(t);
                t.size = t.size - n / 2;
                var o = e.config.plotOptions.radialBar.hollow.background, l = t.size - n * t.series.length - this.margin * t.series.length - n * parseInt(e.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, h = l - e.config.plotOptions.radialBar.hollow.margin;
                void 0 !== e.config.plotOptions.radialBar.hollow.image && (o = this.drawHollowImage(t, r, l, o));
                var c = this.drawHollow({
                    size: h,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    fill: o || "transparent"
                });
                if (e.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                    var d = e.config.plotOptions.radialBar.hollow.dropShadow;
                    s.dropShadow(c, d);
                }
                var u = 1;
                !this.radialDataLabels.total.show && e.globals.series.length > 1 && (u = 0);
                var g = null;
                if (this.radialDataLabels.show) {
                    var p = e.globals.dom.Paper.findOne(".apexcharts-datalabels-group");
                    g = this.renderInnerDataLabels(p, this.radialDataLabels, {
                        hollowSize: l,
                        centerX: t.centerX,
                        centerY: t.centerY,
                        opacity: u
                    });
                }
                "back" === e.config.plotOptions.radialBar.hollow.position && (r.add(c), g && r.add(g));
                var f = !1;
                e.config.plotOptions.radialBar.inverseOrder && (f = !0);
                for(var x = f ? t.series.length - 1 : 0; f ? x >= 0 : x < t.series.length; f ? x-- : x++){
                    var b = i.group({
                        class: "apexcharts-series apexcharts-radial-series",
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(e.globals.seriesNames[x])
                    });
                    r.add(b), b.attr({
                        rel: x + 1,
                        "data:realIndex": x
                    }), this.ctx.series.addCollapsedClassToSeries(b, x), t.size = t.size - n - this.margin;
                    var m = a.fillPath({
                        seriesNumber: x,
                        size: t.size,
                        value: t.series[x]
                    }), y = this.startAngle, w = void 0, k = $e4b487e979d7c06d$var$v.negToZero(t.series[x] > 100 ? 100 : t.series[x]) / 100, A = Math.round(this.totalAngle * k) + this.startAngle, C = void 0;
                    e.globals.dataChanged && (w = this.startAngle, C = Math.round(this.totalAngle * $e4b487e979d7c06d$var$v.negToZero(e.globals.previousPaths[x]) / 100) + w), Math.abs(A) + Math.abs(y) > 360 && (A -= .01), Math.abs(C) + Math.abs(w) > 360 && (C -= .01);
                    var S = A - y, L = Array.isArray(e.config.stroke.dashArray) ? e.config.stroke.dashArray[x] : e.config.stroke.dashArray, M = i.drawPath({
                        d: "",
                        stroke: m,
                        strokeWidth: n,
                        fill: "none",
                        fillOpacity: e.config.fill.opacity,
                        classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + x,
                        strokeDashArray: L
                    });
                    if ($e4b487e979d7c06d$var$Mi.setAttrs(M.node, {
                        "data:angle": S,
                        "data:value": t.series[x]
                    }), e.config.chart.dropShadow.enabled) {
                        var P = e.config.chart.dropShadow;
                        s.dropShadow(M, P, x);
                    }
                    if (s.setSelectionFilter(M, 0, x), this.addListeners(M, this.radialDataLabels), b.add(M), M.attr({
                        index: 0,
                        j: x
                    }), this.barLabels.enabled) {
                        var I = $e4b487e979d7c06d$var$v.polarToCartesian(t.centerX, t.centerY, t.size, y), T = this.barLabels.formatter(e.globals.seriesNames[x], {
                            seriesIndex: x,
                            w: e
                        }), z = [
                            "apexcharts-radialbar-label"
                        ];
                        this.barLabels.onClick || z.push("apexcharts-no-click");
                        var X = this.barLabels.useSeriesColors ? e.globals.colors[x] : e.config.chart.foreColor;
                        X || (X = e.config.chart.foreColor);
                        var R = I.x + this.barLabels.offsetX, E = I.y + this.barLabels.offsetY, Y = i.drawText({
                            x: R,
                            y: E,
                            text: T,
                            textAnchor: "end",
                            dominantBaseline: "middle",
                            fontFamily: this.barLabels.fontFamily,
                            fontWeight: this.barLabels.fontWeight,
                            fontSize: this.barLabels.fontSize,
                            foreColor: X,
                            cssClass: z.join(" ")
                        });
                        Y.on("click", this.onBarLabelClick), Y.attr({
                            rel: x + 1
                        }), 0 !== y && Y.attr({
                            "transform-origin": "".concat(R, " ").concat(E),
                            transform: "rotate(".concat(y, " 0 0)")
                        }), b.add(Y);
                    }
                    var H = 0;
                    !this.initialAnim || e.globals.resized || e.globals.dataChanged || (H = e.config.chart.animations.speed), e.globals.dataChanged && (H = e.config.chart.animations.dynamicAnimation.speed), this.animDur = H / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(M, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: A,
                        startAngle: y,
                        prevEndAngle: C,
                        prevStartAngle: w,
                        size: t.size,
                        i: x,
                        totalItems: 2,
                        animBeginArr: this.animBeginArr,
                        dur: H,
                        shouldSetPrevPaths: !0
                    });
                }
                return {
                    g: r,
                    elHollow: c,
                    dataLabels: g
                };
            }
        },
        {
            key: "drawHollow",
            value: function(t) {
                var e = new $e4b487e979d7c06d$var$Mi(this.ctx).drawCircle(2 * t.size);
                return e.attr({
                    class: "apexcharts-radialbar-hollow",
                    cx: t.centerX,
                    cy: t.centerY,
                    r: t.size,
                    fill: t.fill
                }), e;
            }
        },
        {
            key: "drawHollowImage",
            value: function(t, e, i, a) {
                var s = this.w, r = new $e4b487e979d7c06d$var$ji(this.ctx), n = $e4b487e979d7c06d$var$v.randomId(), o = s.config.plotOptions.radialBar.hollow.image;
                if (s.config.plotOptions.radialBar.hollow.imageClipped) r.clippedImgArea({
                    width: i,
                    height: i,
                    image: o,
                    patternID: "pattern".concat(s.globals.cuid).concat(n)
                }), a = "url(#pattern".concat(s.globals.cuid).concat(n, ")");
                else {
                    var l = s.config.plotOptions.radialBar.hollow.imageWidth, h = s.config.plotOptions.radialBar.hollow.imageHeight;
                    if (void 0 === l && void 0 === h) {
                        var c = s.globals.dom.Paper.image(o, function(e) {
                            this.move(t.centerX - e.width / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - e.height / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY);
                        });
                        e.add(c);
                    } else {
                        var d = s.globals.dom.Paper.image(o, function(e) {
                            this.move(t.centerX - l / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - h / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(l, h);
                        });
                        e.add(d);
                    }
                }
                return a;
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t) {
                var e = this.w;
                return t.size * (100 - parseInt(e.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (t.series.length + 1) - this.margin;
            }
        },
        {
            key: "onBarLabelClick",
            value: function(t) {
                var e = parseInt(t.target.getAttribute("rel"), 10) - 1, i = this.barLabels.onClick, a = this.w;
                i && i(a.globals.seriesNames[e], {
                    w: a,
                    seriesIndex: e
                });
            }
        }
    ]), r;
}(), $e4b487e979d7c06d$var$Oa = function(t) {
    $e4b487e979d7c06d$var$h(a, $e4b487e979d7c06d$var$Pa);
    var e = $e4b487e979d7c06d$var$n(a);
    function a() {
        return $e4b487e979d7c06d$var$i(this, a), e.apply(this, arguments);
    }
    return $e4b487e979d7c06d$var$s(a, [
        {
            key: "draw",
            value: function(t, e) {
                var i = this.w, a = new $e4b487e979d7c06d$var$Mi(this.ctx);
                this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = t, this.seriesRangeStart = i.globals.seriesRangeStart, this.seriesRangeEnd = i.globals.seriesRangeEnd, this.barHelpers.initVariables(t);
                for(var s = a.group({
                    class: "apexcharts-rangebar-series apexcharts-plot-series"
                }), r = 0; r < t.length; r++){
                    var n, o, l, h, c = void 0, d = void 0, g = i.globals.comboCharts ? e[r] : r, p = this.barHelpers.getGroupIndex(g).columnGroupIndex, f = a.group({
                        class: "apexcharts-series",
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(i.globals.seriesNames[g]),
                        rel: r + 1,
                        "data:realIndex": g
                    });
                    this.ctx.series.addCollapsedClassToSeries(f, g), t[r].length > 0 && (this.visibleI = this.visibleI + 1);
                    var x = 0, b = 0, m = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = i.globals.seriesYAxisReverseMap[g][0], m = g);
                    var y = this.barHelpers.initialPositions(g);
                    d = y.y, h = y.zeroW, c = y.x, b = y.barWidth, x = y.barHeight, n = y.xDivision, o = y.yDivision, l = y.zeroH;
                    for(var w = a.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": g
                    }), k = a.group({
                        class: "apexcharts-rangebar-goals-markers"
                    }), A = 0; A < i.globals.dataPoints; A++){
                        var C = this.barHelpers.getStrokeWidth(r, A, g), S = this.seriesRangeStart[r][A], L = this.seriesRangeEnd[r][A], M = null, P = null, I = null, T = {
                            x: c,
                            y: d,
                            strokeWidth: C,
                            elSeries: f
                        }, z = this.seriesLen;
                        if (i.config.plotOptions.bar.rangeBarGroupRows && (z = 1), void 0 === i.config.series[r].data[A]) break;
                        if (this.isHorizontal) {
                            I = d + x * this.visibleI;
                            var X = (o - x * z) / 2;
                            if (i.config.series[r].data[A].x) {
                                var R = this.detectOverlappingBars({
                                    i: r,
                                    j: A,
                                    barYPosition: I,
                                    srty: X,
                                    barHeight: x,
                                    yDivision: o,
                                    initPositions: y
                                });
                                x = R.barHeight, I = R.barYPosition;
                            }
                            b = (M = this.drawRangeBarPaths($e4b487e979d7c06d$var$u({
                                indexes: {
                                    i: r,
                                    j: A,
                                    realIndex: g
                                },
                                barHeight: x,
                                barYPosition: I,
                                zeroW: h,
                                yDivision: o,
                                y1: S,
                                y2: L
                            }, T))).barWidth;
                        } else {
                            i.globals.isXNumeric && (c = (i.globals.seriesX[r][A] - i.globals.minX) / this.xRatio - b / 2), P = c + b * this.visibleI;
                            var E = (n - b * z) / 2;
                            if (i.config.series[r].data[A].x) {
                                var Y = this.detectOverlappingBars({
                                    i: r,
                                    j: A,
                                    barXPosition: P,
                                    srtx: E,
                                    barWidth: b,
                                    xDivision: n,
                                    initPositions: y
                                });
                                b = Y.barWidth, P = Y.barXPosition;
                            }
                            x = (M = this.drawRangeColumnPaths($e4b487e979d7c06d$var$u({
                                indexes: {
                                    i: r,
                                    j: A,
                                    realIndex: g,
                                    translationsIndex: m
                                },
                                barWidth: b,
                                barXPosition: P,
                                zeroH: l,
                                xDivision: n
                            }, T))).barHeight;
                        }
                        var H = this.barHelpers.drawGoalLine({
                            barXPosition: M.barXPosition,
                            barYPosition: I,
                            goalX: M.goalX,
                            goalY: M.goalY,
                            barHeight: x,
                            barWidth: b
                        });
                        H && k.add(H), d = M.y, c = M.x;
                        var O = this.barHelpers.getPathFillColor(t, r, A, g);
                        this.renderSeries({
                            realIndex: g,
                            pathFill: O.color,
                            lineFill: O.useRangeColor ? O.color : i.globals.stroke.colors[g],
                            j: A,
                            i: r,
                            x: c,
                            y: d,
                            y1: S,
                            y2: L,
                            pathFrom: M.pathFrom,
                            pathTo: M.pathTo,
                            strokeWidth: C,
                            elSeries: f,
                            series: t,
                            barHeight: x,
                            barWidth: b,
                            barXPosition: P,
                            barYPosition: I,
                            columnGroupIndex: p,
                            elDataLabelsWrap: w,
                            elGoalsMarkers: k,
                            visibleSeries: this.visibleI,
                            type: "rangebar"
                        });
                    }
                    s.add(f);
                }
                return s;
            }
        },
        {
            key: "detectOverlappingBars",
            value: function(t) {
                var e = t.i, i = t.j, a = t.barYPosition, s = t.barXPosition, r = t.srty, n = t.srtx, o = t.barHeight, l = t.barWidth, h = t.yDivision, c = t.xDivision, d = t.initPositions, u = this.w, g = [], p = u.config.series[e].data[i].rangeName, f = u.config.series[e].data[i].x, x = Array.isArray(f) ? f.join(" ") : f, b = u.globals.labels.map(function(t) {
                    return Array.isArray(t) ? t.join(" ") : t;
                }).indexOf(x), m = u.globals.seriesRange[e].findIndex(function(t) {
                    return t.x === x && t.overlaps.length > 0;
                });
                return this.isHorizontal ? (a = u.config.plotOptions.bar.rangeBarGroupRows ? r + h * b : r + o * this.visibleI + h * b, m > -1 && !u.config.plotOptions.bar.rangeBarOverlap && (g = u.globals.seriesRange[e][m].overlaps).indexOf(p) > -1 && (a = (o = d.barHeight / g.length) * this.visibleI + h * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + o * (this.visibleI + g.indexOf(p)) + h * b)) : (b > -1 && !u.globals.timescaleLabels.length && (s = u.config.plotOptions.bar.rangeBarGroupRows ? n + c * b : n + l * this.visibleI + c * b), m > -1 && !u.config.plotOptions.bar.rangeBarOverlap && (g = u.globals.seriesRange[e][m].overlaps).indexOf(p) > -1 && (s = (l = d.barWidth / g.length) * this.visibleI + c * (100 - parseInt(this.barOptions.barWidth, 10)) / 100 / 2 + l * (this.visibleI + g.indexOf(p)) + c * b)), {
                    barYPosition: a,
                    barXPosition: s,
                    barHeight: o,
                    barWidth: l
                };
            }
        },
        {
            key: "drawRangeColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.xDivision, s = t.barWidth, r = t.barXPosition, n = t.zeroH, o = this.w, l = e.i, h = e.j, c = e.realIndex, d = e.translationsIndex, u = this.yRatio[d], g = this.getRangeValue(c, h), p = Math.min(g.start, g.end), f = Math.max(g.start, g.end);
                void 0 === this.series[l][h] || null === this.series[l][h] ? p = n : (p = n - p / u, f = n - f / u);
                var x = Math.abs(f - p), b = this.barHelpers.getColumnPaths({
                    barXPosition: r,
                    barWidth: s,
                    y1: p,
                    y2: f,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    realIndex: c,
                    i: c,
                    j: h,
                    w: o
                });
                if (o.globals.isXNumeric) {
                    var m = this.getBarXForNumericXAxis({
                        x: i,
                        j: h,
                        realIndex: c,
                        barWidth: s
                    });
                    i = m.x, r = m.barXPosition;
                } else i += a;
                return {
                    pathTo: b.pathTo,
                    pathFrom: b.pathFrom,
                    barHeight: x,
                    x: i,
                    y: g.start < 0 && g.end < 0 ? p : f,
                    goalY: this.barHelpers.getGoalValues("y", null, n, l, h, d),
                    barXPosition: r
                };
            }
        },
        {
            key: "preventBarOverflow",
            value: function(t) {
                var e = this.w;
                return t < 0 && (t = 0), t > e.globals.gridWidth && (t = e.globals.gridWidth), t;
            }
        },
        {
            key: "drawRangeBarPaths",
            value: function(t) {
                var e = t.indexes, i = t.y, a = t.y1, s = t.y2, r = t.yDivision, n = t.barHeight, o = t.barYPosition, l = t.zeroW, h = this.w, c = e.realIndex, d = e.j, u = this.preventBarOverflow(l + a / this.invertedYRatio), g = this.preventBarOverflow(l + s / this.invertedYRatio), p = this.getRangeValue(c, d), f = Math.abs(g - u), x = this.barHelpers.getBarpaths({
                    barYPosition: o,
                    barHeight: n,
                    x1: u,
                    x2: g,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    i: c,
                    realIndex: c,
                    j: d,
                    w: h
                });
                return h.globals.isXNumeric || (i += r), {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    barWidth: f,
                    x: p.start < 0 && p.end < 0 ? u : g,
                    goalX: this.barHelpers.getGoalValues("x", l, null, c, d),
                    y: i
                };
            }
        },
        {
            key: "getRangeValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    start: i.globals.seriesRangeStart[t][e],
                    end: i.globals.seriesRangeEnd[t][e]
                };
            }
        }
    ]), a;
}(), $e4b487e979d7c06d$var$Fa = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.w = e.w, this.lineCtx = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "sameValueSeriesFix",
            value: function(t, e) {
                var i = this.w;
                if (("gradient" === i.config.fill.type || "gradient" === i.config.fill.type[t]) && new $e4b487e979d7c06d$var$Pi(this.lineCtx.ctx, i).seriesHaveSameValues(t)) {
                    var a = e[t].slice();
                    a[a.length - 1] = a[a.length - 1] + 1e-6, e[t] = a;
                }
                return e;
            }
        },
        {
            key: "calculatePoints",
            value: function(t) {
                var e = t.series, i = t.realIndex, a = t.x, s = t.y, r = t.i, n = t.j, o = t.prevY, l = this.w, h = [], c = [], d = this.lineCtx.categoryAxisCorrection + l.config.markers.offsetX;
                return l.globals.isXNumeric && (d = (l.globals.seriesX[i][0] - l.globals.minX) / this.lineCtx.xRatio + l.config.markers.offsetX), 0 === n && (h.push(d), c.push($e4b487e979d7c06d$var$v.isNumber(e[r][0]) ? o + l.config.markers.offsetY : null)), h.push(a + l.config.markers.offsetX), c.push($e4b487e979d7c06d$var$v.isNumber(e[r][n + 1]) ? s + l.config.markers.offsetY : null), {
                    x: h,
                    y: c
                };
            }
        },
        {
            key: "checkPreviousPaths",
            value: function(t) {
                for(var e = t.pathFromLine, i = t.pathFromArea, a = t.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                    var n = s.globals.previousPaths[r];
                    ("line" === n.type || "area" === n.type) && n.paths.length > 0 && parseInt(n.realIndex, 10) === parseInt(a, 10) && ("line" === n.type ? (this.lineCtx.appendPathFrom = !1, e = s.globals.previousPaths[r].paths[0].d) : "area" === n.type && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (e = s.globals.previousPaths[r].paths[1].d)));
                }
                return {
                    pathFromLine: e,
                    pathFromArea: i
                };
            }
        },
        {
            key: "determineFirstPrevY",
            value: function(t) {
                var e, i, a, s = t.i, r = t.realIndex, n = t.series, o = t.prevY, l = t.lineYPosition, h = t.translationsIndex, c = this.w, d = c.config.chart.stacked && !c.globals.comboCharts || c.config.chart.stacked && c.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || "bar" === (null === (e = this.w.config.series[r]) || void 0 === e ? void 0 : e.type) || "column" === (null === (i = this.w.config.series[r]) || void 0 === i ? void 0 : i.type));
                if (void 0 !== (null === (a = n[s]) || void 0 === a ? void 0 : a[0])) o = (l = d && s > 0 ? this.lineCtx.prevSeriesY[s - 1][0] : this.lineCtx.zeroY) - n[s][0] / this.lineCtx.yRatio[h] + 2 * (this.lineCtx.isReversed ? n[s][0] / this.lineCtx.yRatio[h] : 0);
                else if (d && s > 0 && void 0 === n[s][0]) {
                    for(var u = s - 1; u >= 0; u--)if (null !== n[u][0] && void 0 !== n[u][0]) {
                        o = l = this.lineCtx.prevSeriesY[u][0];
                        break;
                    }
                }
                return {
                    prevY: o,
                    lineYPosition: l
                };
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Da = function(t) {
    for(var e, i, a, s, r = function(t) {
        for(var e = [], i = t[0], a = t[1], s = e[0] = $e4b487e979d7c06d$var$Wa(i, a), r = 1, n = t.length - 1; r < n; r++)i = a, a = t[r + 1], e[r] = .5 * (s + (s = $e4b487e979d7c06d$var$Wa(i, a)));
        return e[r] = s, e;
    }(t), n = t.length - 1, o = [], l = 0; l < n; l++)a = $e4b487e979d7c06d$var$Wa(t[l], t[l + 1]), Math.abs(a) < 1e-6 ? r[l] = r[l + 1] = 0 : (s = (e = r[l] / a) * e + (i = r[l + 1] / a) * i) > 9 && (s = 3 * a / Math.sqrt(s), r[l] = s * e, r[l + 1] = s * i);
    for(var h = 0; h <= n; h++)s = (t[Math.min(n, h + 1)][0] - t[Math.max(0, h - 1)][0]) / (6 * (1 + r[h] * r[h])), o.push([
        s || 0,
        r[h] * s || 0
    ]);
    return o;
}, $e4b487e979d7c06d$var$_a = function(t) {
    var e = $e4b487e979d7c06d$var$Da(t), i = t[1], a = t[0], s = [], r = e[1], n = e[0];
    s.push(a, [
        a[0] + n[0],
        a[1] + n[1],
        i[0] - r[0],
        i[1] - r[1],
        i[0],
        i[1]
    ]);
    for(var o = 2, l = e.length; o < l; o++){
        var h = t[o], c = e[o];
        s.push([
            h[0] - c[0],
            h[1] - c[1],
            h[0],
            h[1]
        ]);
    }
    return s;
}, $e4b487e979d7c06d$var$Na = function(t, e, i) {
    var a = t.slice(e, i);
    if (e) {
        if (i - e > 1 && a[1].length < 6) {
            var s = a[0].length;
            a[1] = [
                2 * a[0][s - 2] - a[0][s - 4],
                2 * a[0][s - 1] - a[0][s - 3]
            ].concat(a[1]);
        }
        a[0] = a[0].slice(-2);
    }
    return a;
};
function $e4b487e979d7c06d$var$Wa(t, e) {
    return (e[1] - t[1]) / (e[0] - t[0]);
}
var $e4b487e979d7c06d$var$Ba = function() {
    function t(e, a, s) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.xyRatios = a, this.pointsChart = !("bubble" !== this.w.config.chart.type && "scatter" !== this.w.config.chart.type) || s, this.scatter = new $e4b487e979d7c06d$var$Ui(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new $e4b487e979d7c06d$var$Fa(this), this.markers = new $e4b487e979d7c06d$var$Vi(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function(t, e, i, a) {
                var s, r = this.w, n = new $e4b487e979d7c06d$var$Mi(this.ctx), o = r.globals.comboCharts ? e : r.config.chart.type, l = n.group({
                    class: "apexcharts-".concat(o, "-series apexcharts-plot-series")
                }), h = new $e4b487e979d7c06d$var$Pi(this.ctx, r);
                this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, t = h.getLogSeries(t), this.yRatio = h.getLogYRatios(this.yRatio), this.prevSeriesY = [];
                for(var c = [], d = 0; d < t.length; d++){
                    t = this.lineHelpers.sameValueSeriesFix(d, t);
                    var g = r.globals.comboCharts ? i[d] : d, p = this.yRatio.length > 1 ? g : 0;
                    this._initSerieVariables(t, d, g);
                    var f = [], x = [], b = [], m = r.globals.padHorizontal + this.categoryAxisCorrection;
                    this.ctx.series.addCollapsedClassToSeries(this.elSeries, g), r.globals.isXNumeric && r.globals.seriesX.length > 0 && (m = (r.globals.seriesX[g][0] - r.globals.minX) / this.xRatio), b.push(m);
                    var v, y = m, w = void 0, k = y, A = this.zeroY, C = this.zeroY;
                    A = this.lineHelpers.determineFirstPrevY({
                        i: d,
                        realIndex: g,
                        series: t,
                        prevY: A,
                        lineYPosition: 0,
                        translationsIndex: p
                    }).prevY, "monotoneCubic" === r.config.stroke.curve && null === t[d][0] ? f.push(null) : f.push(A), v = A;
                    "rangeArea" === o && (w = C = this.lineHelpers.determineFirstPrevY({
                        i: d,
                        realIndex: g,
                        series: a,
                        prevY: C,
                        lineYPosition: 0,
                        translationsIndex: p
                    }).prevY, x.push(null !== f[0] ? C : null));
                    var S = this._calculatePathsFrom({
                        type: o,
                        series: t,
                        i: d,
                        realIndex: g,
                        translationsIndex: p,
                        prevX: k,
                        prevY: A,
                        prevY2: C
                    }), L = [
                        f[0]
                    ], M = [
                        x[0]
                    ], P = {
                        type: o,
                        series: t,
                        realIndex: g,
                        translationsIndex: p,
                        i: d,
                        x: m,
                        y: 1,
                        pX: y,
                        pY: v,
                        pathsFrom: S,
                        linePaths: [],
                        areaPaths: [],
                        seriesIndex: i,
                        lineYPosition: 0,
                        xArrj: b,
                        yArrj: f,
                        y2Arrj: x,
                        seriesRangeEnd: a
                    }, I = this._iterateOverDataPoints($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, P), {}, {
                        iterations: "rangeArea" === o ? t[d].length - 1 : void 0,
                        isRangeStart: !0
                    }));
                    if ("rangeArea" === o) {
                        for(var T = this._calculatePathsFrom({
                            series: a,
                            i: d,
                            realIndex: g,
                            prevX: k,
                            prevY: C
                        }), z = this._iterateOverDataPoints($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, P), {}, {
                            series: a,
                            xArrj: [
                                m
                            ],
                            yArrj: L,
                            y2Arrj: M,
                            pY: w,
                            areaPaths: I.areaPaths,
                            pathsFrom: T,
                            iterations: a[d].length - 1,
                            isRangeStart: !1
                        })), X = I.linePaths.length / 2, R = 0; R < X; R++)I.linePaths[R] = z.linePaths[R + X] + I.linePaths[R];
                        I.linePaths.splice(X), I.pathFromLine = z.pathFromLine + I.pathFromLine;
                    } else I.pathFromArea += "z";
                    this._handlePaths({
                        type: o,
                        realIndex: g,
                        i: d,
                        paths: I
                    }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), c.push(this.elSeries);
                }
                if (void 0 !== (null === (s = r.config.series[0]) || void 0 === s ? void 0 : s.zIndex) && c.sort(function(t, e) {
                    return Number(t.node.getAttribute("zIndex")) - Number(e.node.getAttribute("zIndex"));
                }), r.config.chart.stacked) for(var E = c.length - 1; E >= 0; E--)l.add(c[E]);
                else for(var Y = 0; Y < c.length; Y++)l.add(c[Y]);
                return l;
            }
        },
        {
            key: "_initSerieVariables",
            value: function(t, e, i) {
                var a = this.w, s = new $e4b487e979d7c06d$var$Mi(this.ctx);
                this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - ("on" === a.config.xaxis.tickPlacement ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width;
                var r = 0;
                if (this.yRatio.length > 1 && (this.yaxisIndex = a.globals.seriesYAxisReverseMap[i], r = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[r] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[r] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || "end" === a.config.plotOptions.area.fillTo) && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                    class: "apexcharts-series",
                    zIndex: void 0 !== a.config.series[i].zIndex ? a.config.series[i].zIndex : i,
                    seriesName: $e4b487e979d7c06d$var$v.escapeString(a.globals.seriesNames[i])
                }), this.elPointsMain = s.group({
                    class: "apexcharts-series-markers-wrap",
                    "data:realIndex": i
                }), a.globals.hasNullValues) {
                    var n = this.markers.plotChartMarkers({
                        pointsPos: {
                            x: [
                                0
                            ],
                            y: [
                                a.globals.gridHeight + a.globals.markers.largestSize
                            ]
                        },
                        seriesIndex: e,
                        j: 0,
                        pSize: .1,
                        alwaysDrawMarker: !0,
                        isVirtualPoint: !0
                    });
                    null !== n && this.elPointsMain.add(n);
                }
                this.elDataLabelsWrap = s.group({
                    class: "apexcharts-datalabels",
                    "data:realIndex": i
                });
                var o = t[e].length === a.globals.dataPoints;
                this.elSeries.attr({
                    "data:longestSeries": o,
                    rel: e + 1,
                    "data:realIndex": i
                }), this.appendPathFrom = !0;
            }
        },
        {
            key: "_calculatePathsFrom",
            value: function(t) {
                var e, i, a, s, r = t.type, n = t.series, o = t.i, l = t.realIndex, h = t.translationsIndex, c = t.prevX, d = t.prevY, u = t.prevY2, g = this.w, p = new $e4b487e979d7c06d$var$Mi(this.ctx);
                if (null === n[o][0]) {
                    for(var f = 0; f < n[o].length; f++)if (null !== n[o][f]) {
                        c = this.xDivision * f, d = this.zeroY - n[o][f] / this.yRatio[h], e = p.move(c, d), i = p.move(c, this.areaBottomY);
                        break;
                    }
                } else e = p.move(c, d), "rangeArea" === r && (e = p.move(c, u) + p.line(c, d)), i = p.move(c, this.areaBottomY) + p.line(c, d);
                if (a = p.move(0, this.areaBottomY) + p.line(0, this.areaBottomY), s = p.move(0, this.areaBottomY) + p.line(0, this.areaBottomY), g.globals.previousPaths.length > 0) {
                    var x = this.lineHelpers.checkPreviousPaths({
                        pathFromLine: a,
                        pathFromArea: s,
                        realIndex: l
                    });
                    a = x.pathFromLine, s = x.pathFromArea;
                }
                return {
                    prevX: c,
                    prevY: d,
                    linePath: e,
                    areaPath: i,
                    pathFromLine: a,
                    pathFromArea: s
                };
            }
        },
        {
            key: "_handlePaths",
            value: function(t) {
                var e = t.type, i = t.realIndex, a = t.i, s = t.paths, r = this.w, n = new $e4b487e979d7c06d$var$Mi(this.ctx), o = new $e4b487e979d7c06d$var$ji(this.ctx);
                this.prevSeriesY.push(s.yArrj), r.globals.seriesXvalues[i] = s.xArrj, r.globals.seriesYvalues[i] = s.yArrj;
                var l = r.config.forecastDataPoints;
                if (l.count > 0 && "rangeArea" !== e) {
                    var h = r.globals.seriesXvalues[i][r.globals.seriesXvalues[i].length - l.count - 1], c = n.drawRect(h, 0, r.globals.gridWidth, r.globals.gridHeight, 0);
                    r.globals.dom.elForecastMask.appendChild(c.node);
                    var d = n.drawRect(0, 0, h, r.globals.gridHeight, 0);
                    r.globals.dom.elNonForecastMask.appendChild(d.node);
                }
                this.pointsChart || r.globals.delayedElements.push({
                    el: this.elPointsMain.node,
                    index: i
                });
                var g = {
                    i: a,
                    realIndex: i,
                    animationDelay: a,
                    initialSpeed: r.config.chart.animations.speed,
                    dataChangeSpeed: r.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(e)
                };
                if ("area" === e) for(var p = o.fillPath({
                    seriesNumber: i
                }), f = 0; f < s.areaPaths.length; f++){
                    var x = n.renderPaths($e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, g), {}, {
                        pathFrom: s.pathFromArea,
                        pathTo: s.areaPaths[f],
                        stroke: "none",
                        strokeWidth: 0,
                        strokeLineCap: null,
                        fill: p
                    }));
                    this.elSeries.add(x);
                }
                if (r.config.stroke.show && !this.pointsChart) {
                    var b = null;
                    if ("line" === e) b = o.fillPath({
                        seriesNumber: i,
                        i: a
                    });
                    else if ("solid" === r.config.stroke.fill.type) b = r.globals.stroke.colors[i];
                    else {
                        var m = r.config.fill;
                        r.config.fill = r.config.stroke.fill, b = o.fillPath({
                            seriesNumber: i,
                            i: a
                        }), r.config.fill = m;
                    }
                    for(var v = 0; v < s.linePaths.length; v++){
                        var y = b;
                        "rangeArea" === e && (y = o.fillPath({
                            seriesNumber: i
                        }));
                        var w = $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, g), {}, {
                            pathFrom: s.pathFromLine,
                            pathTo: s.linePaths[v],
                            stroke: b,
                            strokeWidth: this.strokeWidth,
                            strokeLineCap: r.config.stroke.lineCap,
                            fill: "rangeArea" === e ? y : "none"
                        }), k = n.renderPaths(w);
                        if (this.elSeries.add(k), k.attr("fill-rule", "evenodd"), l.count > 0 && "rangeArea" !== e) {
                            var A = n.renderPaths(w);
                            A.node.setAttribute("stroke-dasharray", l.dashArray), l.strokeWidth && A.node.setAttribute("stroke-width", l.strokeWidth), this.elSeries.add(A), A.attr("clip-path", "url(#forecastMask".concat(r.globals.cuid, ")")), k.attr("clip-path", "url(#nonForecastMask".concat(r.globals.cuid, ")"));
                        }
                    }
                }
            }
        },
        {
            key: "_iterateOverDataPoints",
            value: function(t) {
                var e, i, a = this, s = t.type, r = t.series, n = t.iterations, o = t.realIndex, l = t.translationsIndex, h = t.i, c = t.x, d = t.y, u = t.pX, g = t.pY, p = t.pathsFrom, f = t.linePaths, x = t.areaPaths, b = t.seriesIndex, m = t.lineYPosition, y = t.xArrj, w = t.yArrj, k = t.y2Arrj, A = t.isRangeStart, C = t.seriesRangeEnd, S = this.w, L = new $e4b487e979d7c06d$var$Mi(this.ctx), M = this.yRatio, P = p.prevY, I = p.linePath, T = p.areaPath, z = p.pathFromLine, X = p.pathFromArea, R = $e4b487e979d7c06d$var$v.isNumber(S.globals.minYArr[o]) ? S.globals.minYArr[o] : S.globals.minY;
                n || (n = S.globals.dataPoints > 1 ? S.globals.dataPoints - 1 : S.globals.dataPoints);
                var E = function(t, e) {
                    return e - t / M[l] + 2 * (a.isReversed ? t / M[l] : 0);
                }, Y = d, H = S.config.chart.stacked && !S.globals.comboCharts || S.config.chart.stacked && S.globals.comboCharts && (!this.w.config.chart.stackOnlyBar || "bar" === (null === (e = this.w.config.series[o]) || void 0 === e ? void 0 : e.type) || "column" === (null === (i = this.w.config.series[o]) || void 0 === i ? void 0 : i.type)), O = S.config.stroke.curve;
                Array.isArray(O) && (O = Array.isArray(b) ? O[b[h]] : O[h]);
                for(var F, D = 0, _ = 0; _ < n && 0 !== r[h].length; _++){
                    var N = void 0 === r[h][_ + 1] || null === r[h][_ + 1];
                    if (S.globals.isXNumeric) {
                        var W = S.globals.seriesX[o][_ + 1];
                        void 0 === S.globals.seriesX[o][_ + 1] && (W = S.globals.seriesX[o][n - 1]), c = (W - S.globals.minX) / this.xRatio;
                    } else c += this.xDivision;
                    if (H) {
                        if (h > 0 && S.globals.collapsedSeries.length < S.config.series.length - 1) m = this.prevSeriesY[function(t) {
                            for(var e = t; e > 0; e--){
                                if (!(S.globals.collapsedSeriesIndices.indexOf((null == b ? void 0 : b[e]) || e) > -1)) return e;
                                e--;
                            }
                            return 0;
                        }(h - 1)][_ + 1];
                        else m = this.zeroY;
                    } else m = this.zeroY;
                    N ? d = E(R, m) : (d = E(r[h][_ + 1], m), "rangeArea" === s && (Y = E(C[h][_ + 1], m))), y.push(null === r[h][_ + 1] ? null : c), !N || "smooth" !== S.config.stroke.curve && "monotoneCubic" !== S.config.stroke.curve ? (w.push(d), k.push(Y)) : (w.push(null), k.push(null));
                    var B = this.lineHelpers.calculatePoints({
                        series: r,
                        x: c,
                        y: d,
                        realIndex: o,
                        i: h,
                        j: _,
                        prevY: P
                    }), G = this._createPaths({
                        type: s,
                        series: r,
                        i: h,
                        realIndex: o,
                        j: _,
                        x: c,
                        y: d,
                        y2: Y,
                        xArrj: y,
                        yArrj: w,
                        y2Arrj: k,
                        pX: u,
                        pY: g,
                        pathState: D,
                        segmentStartX: F,
                        linePath: I,
                        areaPath: T,
                        linePaths: f,
                        areaPaths: x,
                        curve: O,
                        isRangeStart: A
                    });
                    x = G.areaPaths, f = G.linePaths, u = G.pX, g = G.pY, D = G.pathState, F = G.segmentStartX, T = G.areaPath, I = G.linePath, !this.appendPathFrom || S.globals.hasNullValues || "monotoneCubic" === O && "rangeArea" === s || (z += L.line(c, this.areaBottomY), X += L.line(c, this.areaBottomY)), this.handleNullDataPoints(r, B, h, _, o), this._handleMarkersAndLabels({
                        type: s,
                        pointsPos: B,
                        i: h,
                        j: _,
                        realIndex: o,
                        isRangeStart: A
                    });
                }
                return {
                    yArrj: w,
                    xArrj: y,
                    pathFromArea: X,
                    areaPaths: x,
                    pathFromLine: z,
                    linePaths: f,
                    linePath: I,
                    areaPath: T
                };
            }
        },
        {
            key: "_handleMarkersAndLabels",
            value: function(t) {
                var e = t.type, i = t.pointsPos, a = t.isRangeStart, s = t.i, r = t.j, n = t.realIndex, o = this.w, l = new $e4b487e979d7c06d$var$qi(this.ctx);
                if (this.pointsChart) this.scatter.draw(this.elSeries, r, {
                    realIndex: n,
                    pointsPos: i,
                    zRatio: this.zRatio,
                    elParent: this.elPointsMain
                });
                else {
                    o.globals.series[s].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                    var h = this.markers.plotChartMarkers({
                        pointsPos: i,
                        seriesIndex: n,
                        j: r + 1
                    });
                    null !== h && this.elPointsMain.add(h);
                }
                var c = l.drawDataLabel({
                    type: e,
                    isRangeStart: a,
                    pos: i,
                    i: n,
                    j: r + 1
                });
                null !== c && this.elDataLabelsWrap.add(c);
            }
        },
        {
            key: "_createPaths",
            value: function(t) {
                var e = t.type, i = t.series, a = t.i;
                t.realIndex;
                var s, r = t.j, n = t.x, o = t.y, l = t.xArrj, h = t.yArrj, c = t.y2, d = t.y2Arrj, u = t.pX, g = t.pY, p = t.pathState, f = t.segmentStartX, x = t.linePath, b = t.areaPath, m = t.linePaths, v = t.areaPaths, y = t.curve, w = t.isRangeStart, k = new $e4b487e979d7c06d$var$Mi(this.ctx), A = this.areaBottomY, C = "rangeArea" === e, S = "rangeArea" === e && w;
                switch(y){
                    case "monotoneCubic":
                        var L = w ? h : d;
                        switch(p){
                            case 0:
                                if (null === L[r + 1]) break;
                                p = 1;
                            case 1:
                                if (!(C ? l.length === i[a].length : r === i[a].length - 2)) break;
                            case 2:
                                var M = w ? l : l.slice().reverse(), P = w ? L : L.slice().reverse(), I = (s = P, M.map(function(t, e) {
                                    return [
                                        t,
                                        s[e]
                                    ];
                                }).filter(function(t) {
                                    return null !== t[1];
                                })), T = I.length > 1 ? $e4b487e979d7c06d$var$_a(I) : I, z = [];
                                C && (S ? v = I : z = v.reverse());
                                var X = 0, R = 0;
                                if ((function(t, e) {
                                    for(var i = function(t) {
                                        var e = [], i = 0;
                                        return t.forEach(function(t) {
                                            null !== t ? i++ : i > 0 && (e.push(i), i = 0);
                                        }), i > 0 && e.push(i), e;
                                    }(t), a = [], s = 0, r = 0; s < i.length; r += i[s++])a[s] = $e4b487e979d7c06d$var$Na(e, r, r + i[s]);
                                    return a;
                                })(P, T).forEach(function(t) {
                                    X++;
                                    var e = function(t) {
                                        for(var e = "", i = 0; i < t.length; i++){
                                            var a = t[i], s = a.length;
                                            s > 4 ? (e += "C".concat(a[0], ", ").concat(a[1]), e += ", ".concat(a[2], ", ").concat(a[3]), e += ", ".concat(a[4], ", ").concat(a[5])) : s > 2 && (e += "S".concat(a[0], ", ").concat(a[1]), e += ", ".concat(a[2], ", ").concat(a[3]));
                                        }
                                        return e;
                                    }(t), i = R, a = (R += t.length) - 1;
                                    S ? x = k.move(I[i][0], I[i][1]) + e : C ? x = k.move(z[i][0], z[i][1]) + k.line(I[i][0], I[i][1]) + e + k.line(z[a][0], z[a][1]) : (x = k.move(I[i][0], I[i][1]) + e, b = x + k.line(I[a][0], A) + k.line(I[i][0], A) + "z", v.push(b)), m.push(x);
                                }), C && X > 1 && !S) {
                                    var E = m.slice(X).reverse();
                                    m.splice(X), E.forEach(function(t) {
                                        return m.push(t);
                                    });
                                }
                                p = 0;
                        }
                        break;
                    case "smooth":
                        var Y = .35 * (n - u);
                        if (null === i[a][r]) p = 0;
                        else switch(p){
                            case 0:
                                if (f = u, x = S ? k.move(u, d[r]) + k.line(u, g) : k.move(u, g), b = k.move(u, g), null === i[a][r + 1] || void 0 === i[a][r + 1]) {
                                    m.push(x), v.push(b);
                                    break;
                                }
                                if (p = 1, r < i[a].length - 2) {
                                    var H = k.curve(u + Y, g, n - Y, o, n, o);
                                    x += H, b += H;
                                    break;
                                }
                            case 1:
                                if (null === i[a][r + 1]) x += S ? k.line(u, c) : k.move(u, g), b += k.line(u, A) + k.line(f, A) + "z", m.push(x), v.push(b), p = -1;
                                else {
                                    var O = k.curve(u + Y, g, n - Y, o, n, o);
                                    x += O, b += O, r >= i[a].length - 2 && (S && (x += k.curve(n, o, n, o, n, c) + k.move(n, c)), b += k.curve(n, o, n, o, n, A) + k.line(f, A) + "z", m.push(x), v.push(b), p = -1);
                                }
                        }
                        u = n, g = o;
                        break;
                    default:
                        var F = function(t, e, i) {
                            var a = [];
                            switch(t){
                                case "stepline":
                                    a = k.line(e, null, "H") + k.line(null, i, "V");
                                    break;
                                case "linestep":
                                    a = k.line(null, i, "V") + k.line(e, null, "H");
                                    break;
                                case "straight":
                                    a = k.line(e, i);
                            }
                            return a;
                        };
                        if (null === i[a][r]) p = 0;
                        else switch(p){
                            case 0:
                                if (f = u, x = S ? k.move(u, d[r]) + k.line(u, g) : k.move(u, g), b = k.move(u, g), null === i[a][r + 1] || void 0 === i[a][r + 1]) {
                                    m.push(x), v.push(b);
                                    break;
                                }
                                if (p = 1, r < i[a].length - 2) {
                                    var D = F(y, n, o);
                                    x += D, b += D;
                                    break;
                                }
                            case 1:
                                if (null === i[a][r + 1]) x += S ? k.line(u, c) : k.move(u, g), b += k.line(u, A) + k.line(f, A) + "z", m.push(x), v.push(b), p = -1;
                                else {
                                    var _ = F(y, n, o);
                                    x += _, b += _, r >= i[a].length - 2 && (S && (x += k.line(n, c)), b += k.line(n, A) + k.line(f, A) + "z", m.push(x), v.push(b), p = -1);
                                }
                        }
                        u = n, g = o;
                }
                return {
                    linePaths: m,
                    areaPaths: v,
                    pX: u,
                    pY: g,
                    pathState: p,
                    segmentStartX: f,
                    linePath: x,
                    areaPath: b
                };
            }
        },
        {
            key: "handleNullDataPoints",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (null === t[i][a] && r.config.markers.showNullDataPoints || 1 === t[i].length) {
                    var n = this.strokeWidth - r.config.markers.strokeWidth / 2;
                    n > 0 || (n = 0);
                    var o = this.markers.plotChartMarkers({
                        pointsPos: e,
                        seriesIndex: s,
                        j: a + 1,
                        pSize: n,
                        alwaysDrawMarker: !0
                    });
                    null !== o && this.elPointsMain.add(o);
                }
            }
        }
    ]), t;
}();
window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
    function t(e, i, a, s) {
        this.xoffset = e, this.yoffset = i, this.height = s, this.width = a, this.shortestEdge = function() {
            return Math.min(this.height, this.width);
        }, this.getCoordinates = function(t) {
            var e, i = [], a = this.xoffset, s = this.yoffset, n = r(t) / this.height, o = r(t) / this.width;
            if (this.width >= this.height) for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + n,
                s + t[e] / n
            ]), s += t[e] / n;
            else for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + t[e] / o,
                s + o
            ]), a += t[e] / o;
            return i;
        }, this.cutArea = function(e) {
            var i;
            if (this.width >= this.height) {
                var a = e / this.height, s = this.width - a;
                i = new t(this.xoffset + a, this.yoffset, s, this.height);
            } else {
                var r = e / this.width, n = this.height - r;
                i = new t(this.xoffset, this.yoffset + r, this.width, n);
            }
            return i;
        };
    }
    function e(e, a, s, n, o) {
        n = void 0 === n ? 0 : n, o = void 0 === o ? 0 : o;
        var l = i(function(t, e) {
            var i, a = [], s = e / r(t);
            for(i = 0; i < t.length; i++)a[i] = t[i] * s;
            return a;
        }(e, a * s), [], new t(n, o, a, s), []);
        return function(t) {
            var e, i, a = [];
            for(e = 0; e < t.length; e++)for(i = 0; i < t[e].length; i++)a.push(t[e][i]);
            return a;
        }(l);
    }
    function i(t, e, s, n) {
        var o, l, h;
        if (0 !== t.length) return o = s.shortestEdge(), function(t, e, i) {
            var s;
            if (0 === t.length) return !0;
            (s = t.slice()).push(e);
            var r = a(t, i), n = a(s, i);
            return r >= n;
        }(e, l = t[0], o) ? (e.push(l), i(t.slice(1), e, s, n)) : (h = s.cutArea(r(e), n), n.push(s.getCoordinates(e)), i(t, [], h, n)), n;
        n.push(s.getCoordinates(e));
    }
    function a(t, e) {
        var i = Math.min.apply(Math, t), a = Math.max.apply(Math, t), s = r(t);
        return Math.max(Math.pow(e, 2) * a / Math.pow(s, 2), Math.pow(s, 2) / (Math.pow(e, 2) * i));
    }
    function s(t) {
        return t && t.constructor === Array;
    }
    function r(t) {
        var e, i = 0;
        for(e = 0; e < t.length; e++)i += t[e];
        return i;
    }
    function n(t) {
        var e, i = 0;
        if (s(t[0])) for(e = 0; e < t.length; e++)i += n(t[e]);
        else i = r(t);
        return i;
    }
    return function t(i, a, r, o, l) {
        o = void 0 === o ? 0 : o, l = void 0 === l ? 0 : l;
        var h, c, d = [], u = [];
        if (s(i[0])) {
            for(c = 0; c < i.length; c++)d[c] = n(i[c]);
            for(h = e(d, a, r, o, l), c = 0; c < i.length; c++)u.push(t(i[c], h[c][2] - h[c][0], h[c][3] - h[c][1], h[c][0], h[c][1]));
        } else u = e(i, a, r, o, l);
        return u;
    };
}();
var $e4b487e979d7c06d$var$Ga = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new $e4b487e979d7c06d$var$za(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $e4b487e979d7c06d$var$Mi(this.ctx), s = new $e4b487e979d7c06d$var$ji(this.ctx), r = a.group({
                    class: "apexcharts-treemap"
                });
                if (i.globals.noData) return r;
                var n = [];
                return t.forEach(function(t) {
                    var e = t.map(function(t) {
                        return Math.abs(t);
                    });
                    n.push(e);
                }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(t, i) {
                    t.data.forEach(function(t) {
                        Array.isArray(e.labels[i]) || (e.labels[i] = []), e.labels[i].push(t.x);
                    });
                }), window.TreemapSquared.generate(n, i.globals.gridWidth, i.globals.gridHeight).forEach(function(n, o) {
                    var l = a.group({
                        class: "apexcharts-series apexcharts-treemap-series",
                        seriesName: $e4b487e979d7c06d$var$v.escapeString(i.globals.seriesNames[o]),
                        rel: o + 1,
                        "data:realIndex": o
                    });
                    if (i.config.chart.dropShadow.enabled) {
                        var h = i.config.chart.dropShadow;
                        new $e4b487e979d7c06d$var$Li(e.ctx).dropShadow(r, h, o);
                    }
                    var c = a.group({
                        class: "apexcharts-data-labels"
                    }), d = {
                        xMin: 1 / 0,
                        yMin: 1 / 0,
                        xMax: -1 / 0,
                        yMax: -1 / 0
                    };
                    n.forEach(function(r, n) {
                        var h = r[0], c = r[1], u = r[2], g = r[3];
                        d.xMin = Math.min(d.xMin, h), d.yMin = Math.min(d.yMin, c), d.xMax = Math.max(d.xMax, u), d.yMax = Math.max(d.yMax, g);
                        var p = e.helpers.getShadeColor(i.config.chart.type, o, n, e.negRange), f = p.color, x = s.fillPath({
                            color: f,
                            seriesNumber: o,
                            dataPointIndex: n
                        }), b = a.drawRect(h, c, u - h, g - c, i.config.plotOptions.treemap.borderRadius, "#fff", 1, e.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? f : i.globals.stroke.colors[o]);
                        b.attr({
                            cx: h,
                            cy: c,
                            index: o,
                            i: o,
                            j: n,
                            width: u - h,
                            height: g - c,
                            fill: x
                        }), b.node.classList.add("apexcharts-treemap-rect"), e.helpers.addListeners(b);
                        var m = {
                            x: h + (u - h) / 2,
                            y: c + (g - c) / 2,
                            width: 0,
                            height: 0
                        }, v = {
                            x: h,
                            y: c,
                            width: u - h,
                            height: g - c
                        };
                        if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                            var y = 1;
                            i.globals.resized || (y = i.config.chart.animations.speed), e.animateTreemap(b, m, v, y);
                        }
                        if (i.globals.dataChanged) {
                            var w = 1;
                            e.dynamicAnim.enabled && i.globals.shouldAnimate && (w = e.dynamicAnim.speed, i.globals.previousPaths[o] && i.globals.previousPaths[o][n] && i.globals.previousPaths[o][n].rect && (m = i.globals.previousPaths[o][n].rect), e.animateTreemap(b, m, v, w));
                        }
                        var k = e.getFontSize(r), A = i.config.dataLabels.formatter(e.labels[o][n], {
                            value: i.globals.series[o][n],
                            seriesIndex: o,
                            dataPointIndex: n,
                            w: i
                        });
                        "truncate" === i.config.plotOptions.treemap.dataLabels.format && (k = parseInt(i.config.dataLabels.style.fontSize, 10), A = e.truncateLabels(A, k, h, c, u, g));
                        var C = null;
                        i.globals.series[o][n] && (C = e.helpers.calculateDataLabels({
                            text: A,
                            x: (h + u) / 2,
                            y: (c + g) / 2 + e.strokeWidth / 2 + k / 3,
                            i: o,
                            j: n,
                            colorProps: p,
                            fontSize: k,
                            series: t
                        })), i.config.dataLabels.enabled && C && e.rotateToFitLabel(C, k, A, h, c, u, g), l.add(b), null !== C && l.add(C);
                    });
                    var u = i.config.plotOptions.treemap.seriesTitle;
                    if (i.config.series.length > 1 && u && u.show) {
                        var g = i.config.series[o].name || "";
                        if (g && d.xMin < 1 / 0 && d.yMin < 1 / 0) {
                            var p = u.offsetX, f = u.offsetY, x = u.borderColor, b = u.borderWidth, m = u.borderRadius, y = u.style, w = y.color || i.config.chart.foreColor, k = {
                                left: y.padding.left,
                                right: y.padding.right,
                                top: y.padding.top,
                                bottom: y.padding.bottom
                            }, A = a.getTextRects(g, y.fontSize, y.fontFamily), C = A.width + k.left + k.right, S = A.height + k.top + k.bottom, L = d.xMin + (p || 0), M = d.yMin + (f || 0), P = a.drawRect(L, M, C, S, m, y.background, 1, b, x), I = a.drawText({
                                x: L + k.left,
                                y: M + k.top + .75 * A.height,
                                text: g,
                                fontSize: y.fontSize,
                                fontFamily: y.fontFamily,
                                fontWeight: y.fontWeight,
                                foreColor: w,
                                cssClass: y.cssClass || ""
                            });
                            l.add(P), l.add(I);
                        }
                    }
                    l.add(c), r.add(l);
                }), r;
            }
        },
        {
            key: "getFontSize",
            value: function(t) {
                var e = this.w;
                var i = function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += e[i].length;
                    return a;
                }(this.labels) / function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += 1;
                    return a;
                }(this.labels);
                return function(t, a) {
                    var s = t * a, r = Math.pow(s, .5);
                    return Math.min(r / i, parseInt(e.config.dataLabels.style.fontSize, 10));
                }(t[2] - t[0], t[3] - t[1]);
            }
        },
        {
            key: "rotateToFitLabel",
            value: function(t, e, i, a, s, r, n) {
                var o = new $e4b487e979d7c06d$var$Mi(this.ctx), l = o.getTextRects(i, e);
                if (l.width + this.w.config.stroke.width + 5 > r - a && l.width <= n - s) {
                    var h = o.rotateAroundCenter(t.node);
                    t.node.setAttribute("transform", "rotate(-90 ".concat(h.x, " ").concat(h.y, ") translate(").concat(l.height / 3, ")"));
                }
            }
        },
        {
            key: "truncateLabels",
            value: function(t, e, i, a, s, r) {
                var n = new $e4b487e979d7c06d$var$Mi(this.ctx), o = n.getTextRects(t, e).width + this.w.config.stroke.width + 5 > s - i && r - a > s - i ? r - a : s - i, l = n.getTextBasedOnMaxWidth({
                    text: t,
                    maxWidth: o,
                    fontSize: e
                });
                return t.length !== l.length && o / e < 5 ? "" : l;
            }
        },
        {
            key: "animateTreemap",
            value: function(t, e, i, a) {
                var s = new $e4b487e979d7c06d$var$y(this.ctx);
                s.animateRect(t, e, i, a, function() {
                    s.animationCompleted(t);
                });
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ja = 86400, $e4b487e979d7c06d$var$Va = 10 / $e4b487e979d7c06d$var$ja, $e4b487e979d7c06d$var$Ua = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "calculateTimeScaleTicks",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.allSeriesCollapsed) return a.globals.labels = [], a.globals.timescaleLabels = [], [];
                var s = new $e4b487e979d7c06d$var$zi(this.ctx), r = (e - t) / 864e5;
                this.determineInterval(r), a.globals.disableZoomIn = !1, a.globals.disableZoomOut = !1, r < $e4b487e979d7c06d$var$Va ? a.globals.disableZoomIn = !0 : r > 5e4 && (a.globals.disableZoomOut = !0);
                var n = s.getTimeUnitsfromTimestamp(t, e, this.utc), o = a.globals.gridWidth / r, l = o / 24, h = l / 60, c = h / 60, d = Math.floor(24 * r), g = Math.floor(1440 * r), p = Math.floor(r * $e4b487e979d7c06d$var$ja), f = Math.floor(r), x = Math.floor(r / 30), b = Math.floor(r / 365), m = {
                    minMillisecond: n.minMillisecond,
                    minSecond: n.minSecond,
                    minMinute: n.minMinute,
                    minHour: n.minHour,
                    minDate: n.minDate,
                    minMonth: n.minMonth,
                    minYear: n.minYear
                }, v = {
                    firstVal: m,
                    currentMillisecond: m.minMillisecond,
                    currentSecond: m.minSecond,
                    currentMinute: m.minMinute,
                    currentHour: m.minHour,
                    currentMonthDate: m.minDate,
                    currentDate: m.minDate,
                    currentMonth: m.minMonth,
                    currentYear: m.minYear,
                    daysWidthOnXAxis: o,
                    hoursWidthOnXAxis: l,
                    minutesWidthOnXAxis: h,
                    secondsWidthOnXAxis: c,
                    numberOfSeconds: p,
                    numberOfMinutes: g,
                    numberOfHours: d,
                    numberOfDays: f,
                    numberOfMonths: x,
                    numberOfYears: b
                };
                switch(this.tickInterval){
                    case "years":
                        this.generateYearScale(v);
                        break;
                    case "months":
                    case "half_year":
                        this.generateMonthScale(v);
                        break;
                    case "months_days":
                    case "months_fortnight":
                    case "days":
                    case "week_days":
                        this.generateDayScale(v);
                        break;
                    case "hours":
                        this.generateHourScale(v);
                        break;
                    case "minutes_fives":
                    case "minutes":
                        this.generateMinuteScale(v);
                        break;
                    case "seconds_tens":
                    case "seconds_fives":
                    case "seconds":
                        this.generateSecondScale(v);
                }
                var y = this.timeScaleArray.map(function(t) {
                    var e = {
                        position: t.position,
                        unit: t.unit,
                        year: t.year,
                        day: t.day ? t.day : 1,
                        hour: t.hour ? t.hour : 0,
                        month: t.month + 1
                    };
                    return "month" === t.unit ? $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, e), {}, {
                        day: 1,
                        value: t.value + 1
                    }) : "day" === t.unit || "hour" === t.unit ? $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, e), {}, {
                        value: t.value
                    }) : "minute" === t.unit ? $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, e), {}, {
                        value: t.value,
                        minute: t.value
                    }) : "second" === t.unit ? $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, e), {}, {
                        value: t.value,
                        minute: t.minute,
                        second: t.second
                    }) : t;
                });
                return y.filter(function(t) {
                    var e = 1, s = Math.ceil(a.globals.gridWidth / 120), r = t.value;
                    void 0 !== a.config.xaxis.tickAmount && (s = a.config.xaxis.tickAmount), y.length > s && (e = Math.floor(y.length / s));
                    var n = !1, o = !1;
                    switch(i.tickInterval){
                        case "years":
                            "year" === t.unit && (n = !0);
                            break;
                        case "half_year":
                            e = 7, "year" === t.unit && (n = !0);
                            break;
                        case "months":
                            e = 1, "year" === t.unit && (n = !0);
                            break;
                        case "months_fortnight":
                            e = 15, "year" !== t.unit && "month" !== t.unit || (n = !0), 30 === r && (o = !0);
                            break;
                        case "months_days":
                            e = 10, "month" === t.unit && (n = !0), 30 === r && (o = !0);
                            break;
                        case "week_days":
                            e = 8, "month" === t.unit && (n = !0);
                            break;
                        case "days":
                            e = 1, "month" === t.unit && (n = !0);
                            break;
                        case "hours":
                            "day" === t.unit && (n = !0);
                            break;
                        case "minutes_fives":
                        case "seconds_fives":
                            r % 5 != 0 && (o = !0);
                            break;
                        case "seconds_tens":
                            r % 10 != 0 && (o = !0);
                    }
                    if ("hours" === i.tickInterval || "minutes_fives" === i.tickInterval || "seconds_tens" === i.tickInterval || "seconds_fives" === i.tickInterval) {
                        if (!o) return !0;
                    } else if ((r % e == 0 || n) && !o) return !0;
                });
            }
        },
        {
            key: "recalcDimensionsBasedOnFormat",
            value: function(t, e) {
                var i = this.w, a = this.formatDates(t), s = this.removeOverlappingTS(a);
                i.globals.timescaleLabels = s.slice(), new $e4b487e979d7c06d$var$pa(this.ctx).plotCoords();
            }
        },
        {
            key: "determineInterval",
            value: function(t) {
                var e = 24 * t, i = 60 * e;
                switch(!0){
                    case t / 365 > 5:
                        this.tickInterval = "years";
                        break;
                    case t > 800:
                        this.tickInterval = "half_year";
                        break;
                    case t > 180:
                        this.tickInterval = "months";
                        break;
                    case t > 90:
                        this.tickInterval = "months_fortnight";
                        break;
                    case t > 60:
                        this.tickInterval = "months_days";
                        break;
                    case t > 30:
                        this.tickInterval = "week_days";
                        break;
                    case t > 2:
                        this.tickInterval = "days";
                        break;
                    case e > 2.4:
                        this.tickInterval = "hours";
                        break;
                    case i > 15:
                        this.tickInterval = "minutes_fives";
                        break;
                    case i > 5:
                        this.tickInterval = "minutes";
                        break;
                    case i > 1:
                        this.tickInterval = "seconds_tens";
                        break;
                    case 60 * i > 20:
                        this.tickInterval = "seconds_fives";
                        break;
                    default:
                        this.tickInterval = "seconds";
                }
            }
        },
        {
            key: "generateYearScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.daysWidthOnXAxis, r = t.numberOfYears, n = e.minYear, o = 0, l = new $e4b487e979d7c06d$var$zi(this.ctx), h = "year";
                if (e.minDate > 1 || e.minMonth > 0) {
                    var c = l.determineRemainingDaysOfYear(e.minYear, e.minMonth, e.minDate);
                    o = (l.determineDaysOfYear(e.minYear) - c + 1) * s, n = e.minYear + 1, this.timeScaleArray.push({
                        position: o,
                        value: n,
                        unit: h,
                        year: n,
                        month: $e4b487e979d7c06d$var$v.monthMod(i + 1)
                    });
                } else 1 === e.minDate && 0 === e.minMonth && this.timeScaleArray.push({
                    position: o,
                    value: n,
                    unit: h,
                    year: a,
                    month: $e4b487e979d7c06d$var$v.monthMod(i + 1)
                });
                for(var d = n, u = o, g = 0; g < r; g++)d++, u = l.determineDaysOfYear(d - 1) * s + u, this.timeScaleArray.push({
                    position: u,
                    value: d,
                    unit: h,
                    year: d,
                    month: 1
                });
            }
        },
        {
            key: "generateMonthScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonthDate, a = t.currentMonth, s = t.currentYear, r = t.daysWidthOnXAxis, n = t.numberOfMonths, o = a, l = 0, h = new $e4b487e979d7c06d$var$zi(this.ctx), c = "month", d = 0;
                if (e.minDate > 1) {
                    l = (h.determineDaysOfMonths(a + 1, e.minYear) - i + 1) * r, o = $e4b487e979d7c06d$var$v.monthMod(a + 1);
                    var u = s + d, g = $e4b487e979d7c06d$var$v.monthMod(o), p = o;
                    0 === o && (c = "year", p = u, g = 1, u += d += 1), this.timeScaleArray.push({
                        position: l,
                        value: p,
                        unit: c,
                        year: u,
                        month: g
                    });
                } else this.timeScaleArray.push({
                    position: l,
                    value: o,
                    unit: c,
                    year: s,
                    month: $e4b487e979d7c06d$var$v.monthMod(a)
                });
                for(var f = o + 1, x = l, b = 0, m = 1; b < n; b++, m++){
                    0 === (f = $e4b487e979d7c06d$var$v.monthMod(f)) ? (c = "year", d += 1) : c = "month";
                    var y = this._getYear(s, f, d);
                    x = h.determineDaysOfMonths(f, y) * r + x;
                    var w = 0 === f ? y : f;
                    this.timeScaleArray.push({
                        position: x,
                        value: w,
                        unit: c,
                        year: y,
                        month: 0 === f ? 1 : f
                    }), f++;
                }
            }
        },
        {
            key: "generateDayScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.hoursWidthOnXAxis, r = t.numberOfDays, n = new $e4b487e979d7c06d$var$zi(this.ctx), o = "day", l = e.minDate + 1, h = l, c = function(t, e, i) {
                    return t > n.determineDaysOfMonths(e + 1, i) ? (h = 1, o = "month", u = e += 1, e) : e;
                }, d = (24 - e.minHour) * s, u = l, g = c(h, i, a);
                0 === e.minHour && 1 === e.minDate ? (d = 0, u = $e4b487e979d7c06d$var$v.monthMod(e.minMonth), o = "month", h = e.minDate) : 1 !== e.minDate && 0 === e.minHour && 0 === e.minMinute && (d = 0, l = e.minDate, u = l, g = c(h = l, i, a), 1 !== u && (o = "day")), this.timeScaleArray.push({
                    position: d,
                    value: u,
                    unit: o,
                    year: this._getYear(a, g, 0),
                    month: $e4b487e979d7c06d$var$v.monthMod(g),
                    day: h
                });
                for(var p = d, f = 0; f < r; f++){
                    o = "day", g = c(h += 1, g, this._getYear(a, g, 0));
                    var x = this._getYear(a, g, 0);
                    p = 24 * s + p;
                    var b = 1 === h ? $e4b487e979d7c06d$var$v.monthMod(g) : h;
                    this.timeScaleArray.push({
                        position: p,
                        value: b,
                        unit: o,
                        year: x,
                        month: $e4b487e979d7c06d$var$v.monthMod(g),
                        day: b
                    });
                }
            }
        },
        {
            key: "generateHourScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentDate, a = t.currentMonth, s = t.currentYear, r = t.minutesWidthOnXAxis, n = t.numberOfHours, o = new $e4b487e979d7c06d$var$zi(this.ctx), l = "hour", h = function(t, e) {
                    return t > o.determineDaysOfMonths(e + 1, s) && (f = 1, e += 1), {
                        month: e,
                        date: f
                    };
                }, c = function(t, e) {
                    return t > o.determineDaysOfMonths(e + 1, s) ? e += 1 : e;
                }, d = 60 - (e.minMinute + e.minSecond / 60), u = d * r, g = e.minHour + 1, p = g;
                60 === d && (u = 0, p = g = e.minHour);
                var f = i;
                p >= 24 && (p = 0, l = "day", g = f += 1);
                var x = h(f, a).month;
                x = c(f, x), g > 31 && (g = f = 1), this.timeScaleArray.push({
                    position: u,
                    value: g,
                    unit: l,
                    day: f,
                    hour: p,
                    year: s,
                    month: $e4b487e979d7c06d$var$v.monthMod(x)
                }), p++;
                for(var b = u, m = 0; m < n; m++){
                    if (l = "hour", p >= 24) p = 0, l = "day", x = h(f += 1, x).month, x = c(f, x);
                    var y = this._getYear(s, x, 0);
                    b = 60 * r + b;
                    var w = 0 === p ? f : p;
                    this.timeScaleArray.push({
                        position: b,
                        value: w,
                        unit: l,
                        hour: p,
                        day: f,
                        year: y,
                        month: $e4b487e979d7c06d$var$v.monthMod(x)
                    }), p++;
                }
            }
        },
        {
            key: "generateMinuteScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, n = t.currentMonth, o = t.currentYear, l = t.minutesWidthOnXAxis, h = t.secondsWidthOnXAxis, c = t.numberOfMinutes, d = a + 1, u = r, g = n, p = o, f = s, x = (60 - i - e / 1e3) * h, b = 0; b < c; b++)d >= 60 && (d = 0, 24 === (f += 1) && (f = 0)), this.timeScaleArray.push({
                    position: x,
                    value: d,
                    unit: "minute",
                    hour: f,
                    minute: d,
                    day: u,
                    year: this._getYear(p, g, 0),
                    month: $e4b487e979d7c06d$var$v.monthMod(g)
                }), x += l, d++;
            }
        },
        {
            key: "generateSecondScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, n = t.currentMonth, o = t.currentYear, l = t.secondsWidthOnXAxis, h = t.numberOfSeconds, c = i + 1, d = a, u = r, g = n, p = o, f = s, x = (1e3 - e) / 1e3 * l, b = 0; b < h; b++)c >= 60 && (c = 0, ++d >= 60 && (d = 0, 24 === ++f && (f = 0))), this.timeScaleArray.push({
                    position: x,
                    value: c,
                    unit: "second",
                    hour: f,
                    minute: d,
                    second: c,
                    day: u,
                    year: this._getYear(p, g, 0),
                    month: $e4b487e979d7c06d$var$v.monthMod(g)
                }), x += l, c++;
            }
        },
        {
            key: "createRawDateString",
            value: function(t, e) {
                var i = t.year;
                return 0 === t.month && (t.month = 1), i += "-" + ("0" + t.month.toString()).slice(-2), "day" === t.unit ? i += "day" === t.unit ? "-" + ("0" + e).slice(-2) : "-01" : i += "-" + ("0" + (t.day ? t.day : "1")).slice(-2), "hour" === t.unit ? i += "hour" === t.unit ? "T" + ("0" + e).slice(-2) : "T00" : i += "T" + ("0" + (t.hour ? t.hour : "0")).slice(-2), "minute" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":" + (t.minute ? ("0" + t.minute).slice(-2) : "00"), "second" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
            }
        },
        {
            key: "formatDates",
            value: function(t) {
                var e = this, i = this.w;
                return t.map(function(t) {
                    var a = t.value.toString(), s = new $e4b487e979d7c06d$var$zi(e.ctx), r = e.createRawDateString(t, a), n = s.getDate(s.parseDate(r));
                    if (e.utc || (n = s.getDate(s.parseDateWithTimezone(r))), void 0 === i.config.xaxis.labels.format) {
                        var o = "dd MMM", l = i.config.xaxis.labels.datetimeFormatter;
                        "year" === t.unit && (o = l.year), "month" === t.unit && (o = l.month), "day" === t.unit && (o = l.day), "hour" === t.unit && (o = l.hour), "minute" === t.unit && (o = l.minute), "second" === t.unit && (o = l.second), a = s.formatDate(n, o);
                    } else a = s.formatDate(n, i.config.xaxis.labels.format);
                    return {
                        dateString: r,
                        position: t.position,
                        value: a,
                        unit: t.unit,
                        year: t.year,
                        month: t.month
                    };
                });
            }
        },
        {
            key: "removeOverlappingTS",
            value: function(t) {
                var e, i = this, a = new $e4b487e979d7c06d$var$Mi(this.ctx), s = !1;
                t.length > 0 && t[0].value && t.every(function(e) {
                    return e.value.length === t[0].value.length;
                }) && (s = !0, e = a.getTextRects(t[0].value).width);
                var r = 0, n = t.map(function(n, o) {
                    if (o > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                        var l = s ? e : a.getTextRects(t[r].value).width, h = t[r].position;
                        return n.position > h + l + 10 ? (r = o, n) : null;
                    }
                    return n;
                });
                return n = n.filter(function(t) {
                    return null !== t;
                });
            }
        },
        {
            key: "_getYear",
            value: function(t, e, i) {
                return t + Math.floor(e / 12) + i;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$qa = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = a, this.w = a.w, this.el = e;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "setupElements",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = i.chart.type;
                e.axisCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble",
                    "radar",
                    "heatmap",
                    "treemap"
                ].includes(a), e.xyCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "rangeArea",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble"
                ].includes(a), e.isBarHorizontal = [
                    "bar",
                    "rangeBar",
                    "boxPlot"
                ].includes(a) && i.plotOptions.bar.horizontal, e.chartClass = ".apexcharts".concat(e.chartID), e.dom.baseEl = this.el, e.dom.elWrap = document.createElement("div"), $e4b487e979d7c06d$var$Mi.setAttrs(e.dom.elWrap, {
                    id: e.chartClass.substring(1),
                    class: "apexcharts-canvas ".concat(e.chartClass.substring(1))
                }), this.el.appendChild(e.dom.elWrap), e.dom.Paper = window.SVG().addTo(e.dom.elWrap), e.dom.Paper.attr({
                    class: "apexcharts-svg",
                    "xmlns:data": "ApexChartsNS",
                    transform: "translate(".concat(i.chart.offsetX, ", ").concat(i.chart.offsetY, ")")
                }), e.dom.Paper.node.style.background = "dark" !== i.theme.mode || i.chart.background ? "light" !== i.theme.mode || i.chart.background ? i.chart.background : "#fff" : "#343A3F", this.setSVGDimensions(), e.dom.elLegendForeign = document.createElementNS(e.SVGNS, "foreignObject"), $e4b487e979d7c06d$var$Mi.setAttrs(e.dom.elLegendForeign, {
                    x: 0,
                    y: 0,
                    width: e.svgWidth,
                    height: e.svgHeight
                }), e.dom.elLegendWrap = document.createElement("div"), e.dom.elLegendWrap.classList.add("apexcharts-legend"), e.dom.elWrap.appendChild(e.dom.elLegendWrap), e.dom.Paper.node.appendChild(e.dom.elLegendForeign), e.dom.elGraphical = e.dom.Paper.group().attr({
                    class: "apexcharts-inner apexcharts-graphical"
                }), e.dom.elDefs = e.dom.Paper.defs(), e.dom.Paper.add(e.dom.elGraphical), e.dom.elGraphical.add(e.dom.elDefs);
            }
        },
        {
            key: "plotChartType",
            value: function(t, e) {
                var i = this.w, a = this.ctx, s = i.config, r = i.globals, n = {
                    line: {
                        series: [],
                        i: []
                    },
                    area: {
                        series: [],
                        i: []
                    },
                    scatter: {
                        series: [],
                        i: []
                    },
                    bubble: {
                        series: [],
                        i: []
                    },
                    bar: {
                        series: [],
                        i: []
                    },
                    candlestick: {
                        series: [],
                        i: []
                    },
                    boxPlot: {
                        series: [],
                        i: []
                    },
                    rangeBar: {
                        series: [],
                        i: []
                    },
                    rangeArea: {
                        series: [],
                        seriesRangeEnd: [],
                        i: []
                    }
                }, o = s.chart.type || "line", l = null, h = 0;
                r.series.forEach(function(e, a) {
                    var s = "column" === t[a].type ? "bar" : t[a].type || ("column" === o ? "bar" : o);
                    n[s] ? ("rangeArea" === s ? (n[s].series.push(r.seriesRangeStart[a]), n[s].seriesRangeEnd.push(r.seriesRangeEnd[a])) : n[s].series.push(e), n[s].i.push(a), "bar" === s && (i.globals.columnSeries = n.bar)) : [
                        "heatmap",
                        "treemap",
                        "pie",
                        "donut",
                        "polarArea",
                        "radialBar",
                        "radar"
                    ].includes(s) ? l = s : console.warn("You have specified an unrecognized series type (".concat(s, ").")), o !== s && "scatter" !== s && h++;
                }), h > 0 && (l && console.warn("Chart or series type ".concat(l, " cannot appear with other chart or series types.")), n.bar.series.length > 0 && s.plotOptions.bar.horizontal && (h -= n.bar.series.length, n.bar = {
                    series: [],
                    i: []
                }, i.globals.columnSeries = {
                    series: [],
                    i: []
                }, console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"))), r.comboCharts || (r.comboCharts = h > 0);
                var c = new $e4b487e979d7c06d$var$Ba(a, e), d = new $e4b487e979d7c06d$var$Ta(a, e);
                a.pie = new $e4b487e979d7c06d$var$Ea(a);
                var u = new $e4b487e979d7c06d$var$Ha(a);
                a.rangeBar = new $e4b487e979d7c06d$var$Oa(a, e);
                var g = new $e4b487e979d7c06d$var$Ya(a), p = [];
                if (r.comboCharts) {
                    var x, b, m = new $e4b487e979d7c06d$var$Pi(a);
                    if (n.area.series.length > 0) (x = p).push.apply(x, $e4b487e979d7c06d$var$f(m.drawSeriesByGroup(n.area, r.areaGroups, "area", c)));
                    if (n.bar.series.length > 0) {
                        if (s.chart.stacked) {
                            var v = new $e4b487e979d7c06d$var$Ia(a, e);
                            p.push(v.draw(n.bar.series, n.bar.i));
                        } else a.bar = new $e4b487e979d7c06d$var$Pa(a, e), p.push(a.bar.draw(n.bar.series, n.bar.i));
                    }
                    if (n.rangeArea.series.length > 0 && p.push(c.draw(n.rangeArea.series, "rangeArea", n.rangeArea.i, n.rangeArea.seriesRangeEnd)), n.line.series.length > 0) (b = p).push.apply(b, $e4b487e979d7c06d$var$f(m.drawSeriesByGroup(n.line, r.lineGroups, "line", c)));
                    if (n.candlestick.series.length > 0 && p.push(d.draw(n.candlestick.series, "candlestick", n.candlestick.i)), n.boxPlot.series.length > 0 && p.push(d.draw(n.boxPlot.series, "boxPlot", n.boxPlot.i)), n.rangeBar.series.length > 0 && p.push(a.rangeBar.draw(n.rangeBar.series, n.rangeBar.i)), n.scatter.series.length > 0) {
                        var y = new $e4b487e979d7c06d$var$Ba(a, e, !0);
                        p.push(y.draw(n.scatter.series, "scatter", n.scatter.i));
                    }
                    if (n.bubble.series.length > 0) {
                        var w = new $e4b487e979d7c06d$var$Ba(a, e, !0);
                        p.push(w.draw(n.bubble.series, "bubble", n.bubble.i));
                    }
                } else switch(s.chart.type){
                    case "line":
                        p = c.draw(r.series, "line");
                        break;
                    case "area":
                        p = c.draw(r.series, "area");
                        break;
                    case "bar":
                        if (s.chart.stacked) p = new $e4b487e979d7c06d$var$Ia(a, e).draw(r.series);
                        else a.bar = new $e4b487e979d7c06d$var$Pa(a, e), p = a.bar.draw(r.series);
                        break;
                    case "candlestick":
                        p = new $e4b487e979d7c06d$var$Ta(a, e).draw(r.series, "candlestick");
                        break;
                    case "boxPlot":
                        p = new $e4b487e979d7c06d$var$Ta(a, e).draw(r.series, s.chart.type);
                        break;
                    case "rangeBar":
                        p = a.rangeBar.draw(r.series);
                        break;
                    case "rangeArea":
                        p = c.draw(r.seriesRangeStart, "rangeArea", void 0, r.seriesRangeEnd);
                        break;
                    case "heatmap":
                        p = new $e4b487e979d7c06d$var$Xa(a, e).draw(r.series);
                        break;
                    case "treemap":
                        p = new $e4b487e979d7c06d$var$Ga(a, e).draw(r.series);
                        break;
                    case "pie":
                    case "donut":
                    case "polarArea":
                        p = a.pie.draw(r.series);
                        break;
                    case "radialBar":
                        p = u.draw(r.series);
                        break;
                    case "radar":
                        p = g.draw(r.series);
                        break;
                    default:
                        p = c.draw(r.series);
                }
                return p;
            }
        },
        {
            key: "setSVGDimensions",
            value: function() {
                var t = this.w, e = t.globals, i = t.config;
                i.chart.width = i.chart.width || "100%", i.chart.height = i.chart.height || "auto", e.svgWidth = i.chart.width, e.svgHeight = i.chart.height;
                var a = $e4b487e979d7c06d$var$v.getDimensions(this.el), s = i.chart.width.toString().split(/[0-9]+/g).pop();
                "%" === s ? $e4b487e979d7c06d$var$v.isNumber(a[0]) && (0 === a[0].width && (a = $e4b487e979d7c06d$var$v.getDimensions(this.el.parentNode)), e.svgWidth = a[0] * parseInt(i.chart.width, 10) / 100) : "px" !== s && "" !== s || (e.svgWidth = parseInt(i.chart.width, 10));
                var r = String(i.chart.height).toString().split(/[0-9]+/g).pop();
                if ("auto" !== e.svgHeight && "" !== e.svgHeight) {
                    if ("%" === r) {
                        var n = $e4b487e979d7c06d$var$v.getDimensions(this.el.parentNode);
                        e.svgHeight = n[1] * parseInt(i.chart.height, 10) / 100;
                    } else e.svgHeight = parseInt(i.chart.height, 10);
                } else e.svgHeight = e.axisCharts ? e.svgWidth / 1.61 : e.svgWidth / 1.2;
                if (e.svgWidth = Math.max(e.svgWidth, 0), e.svgHeight = Math.max(e.svgHeight, 0), $e4b487e979d7c06d$var$Mi.setAttrs(e.dom.Paper.node, {
                    width: e.svgWidth,
                    height: e.svgHeight
                }), "%" !== r) {
                    var o = i.chart.sparkline.enabled ? 0 : e.axisCharts ? i.chart.parentHeightOffset : 0;
                    e.dom.Paper.node.parentNode.parentNode.style.minHeight = "".concat(e.svgHeight + o, "px");
                }
                e.dom.elWrap.style.width = "".concat(e.svgWidth, "px"), e.dom.elWrap.style.height = "".concat(e.svgHeight, "px");
            }
        },
        {
            key: "shiftGraphPosition",
            value: function() {
                var t = this.w.globals, e = t.translateY, i = t.translateX;
                $e4b487e979d7c06d$var$Mi.setAttrs(t.dom.elGraphical.node, {
                    transform: "translate(".concat(i, ", ").concat(e, ")")
                });
            }
        },
        {
            key: "resizeNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = 0, a = t.config.chart.sparkline.enabled ? 1 : 15;
                a += t.config.grid.padding.bottom, [
                    "top",
                    "bottom"
                ].includes(t.config.legend.position) && t.config.legend.show && !t.config.legend.floating && (i = new $e4b487e979d7c06d$var$xa(this.ctx).legendHelpers.getLegendDimensions().clwh + 7);
                var s = t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * t.globals.radialSize;
                if (s && !t.config.chart.sparkline.enabled && 0 !== t.config.plotOptions.radialBar.startAngle) {
                    var n = $e4b487e979d7c06d$var$v.getBoundingClientRect(s);
                    r = n.bottom;
                    var o = n.bottom - n.top;
                    r = Math.max(2.05 * t.globals.radialSize, o);
                }
                var l = Math.ceil(r + e.translateY + i + a);
                e.dom.elLegendForeign && e.dom.elLegendForeign.setAttribute("height", l), t.config.chart.height && String(t.config.chart.height).includes("%") || (e.dom.elWrap.style.height = "".concat(l, "px"), $e4b487e979d7c06d$var$Mi.setAttrs(e.dom.Paper.node, {
                    height: l
                }), e.dom.Paper.node.parentNode.parentNode.style.minHeight = "".concat(l, "px"));
            }
        },
        {
            key: "coreCalculations",
            value: function() {
                new $e4b487e979d7c06d$var$ea(this.ctx).init();
            }
        },
        {
            key: "resetGlobals",
            value: function() {
                var t = this, e = function() {
                    return t.w.config.series.map(function() {
                        return [];
                    });
                }, i = new $e4b487e979d7c06d$var$Bi, a = this.w.globals;
                i.initGlobalVars(a), a.seriesXvalues = e(), a.seriesYvalues = e();
            }
        },
        {
            key: "isMultipleY",
            value: function() {
                return !!(Array.isArray(this.w.config.yaxis) && this.w.config.yaxis.length > 1) && (this.w.globals.isMultipleYAxis = !0, !0);
            }
        },
        {
            key: "xySettings",
            value: function() {
                var t = this.w, e = null;
                if (t.globals.axisCharts) {
                    if ("back" === t.config.xaxis.crosshairs.position && new $e4b487e979d7c06d$var$na(this.ctx).drawXCrosshairs(), "back" === t.config.yaxis[0].crosshairs.position && new $e4b487e979d7c06d$var$na(this.ctx).drawYCrosshairs(), "datetime" === t.config.xaxis.type && void 0 === t.config.xaxis.labels.formatter) {
                        this.ctx.timeScale = new $e4b487e979d7c06d$var$Ua(this.ctx);
                        var i = [];
                        isFinite(t.globals.minX) && isFinite(t.globals.maxX) && !t.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minX, t.globals.maxX) : t.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(t.globals.minY, t.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                    }
                    e = new $e4b487e979d7c06d$var$Pi(this.ctx).getCalculatedRatios();
                }
                return e;
            }
        },
        {
            key: "updateSourceChart",
            value: function(t) {
                this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                    chart: {
                        selection: {
                            xaxis: {
                                min: t.w.globals.minX,
                                max: t.w.globals.maxX
                            }
                        }
                    }
                }, !1, !1);
            }
        },
        {
            key: "setupBrushHandler",
            value: function() {
                var t = this, e = this.ctx, i = this.w;
                if (i.config.chart.brush.enabled && "function" != typeof i.config.chart.events.selection) {
                    var a = Array.isArray(i.config.chart.brush.targets) ? i.config.chart.brush.targets : [
                        i.config.chart.brush.target
                    ];
                    a.forEach(function(i) {
                        var a = e.constructor.getChartByID(i);
                        a.w.globals.brushSource = t.ctx, "function" != typeof a.w.config.chart.events.zoomed && (a.w.config.chart.events.zoomed = function() {
                            return t.updateSourceChart(a);
                        }), "function" != typeof a.w.config.chart.events.scrolled && (a.w.config.chart.events.scrolled = function() {
                            return t.updateSourceChart(a);
                        });
                    }), i.config.chart.events.selection = function(t, i) {
                        a.forEach(function(t) {
                            e.constructor.getChartByID(t).ctx.updateHelpers._updateOptions({
                                xaxis: {
                                    min: i.xaxis.min,
                                    max: i.xaxis.max
                                }
                            }, !1, !1, !1, !1);
                        });
                    };
                }
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$Za = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "_updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return new Promise(function(n) {
                    var o = [
                        e.ctx
                    ];
                    s && (o = e.ctx.getSyncedCharts()), e.ctx.w.globals.isExecCalled && (o = [
                        e.ctx
                    ], e.ctx.w.globals.isExecCalled = !1), o.forEach(function(s, l) {
                        var h = s.w;
                        if (h.globals.shouldAnimate = a, i || (h.globals.resized = !0, h.globals.dataChanged = !0, a && s.series.getPreviousPaths()), t && "object" === $e4b487e979d7c06d$var$b(t) && (s.config = new $e4b487e979d7c06d$var$Wi(t), t = $e4b487e979d7c06d$var$Pi.extendArrayProps(s.config, t, h), s.w.globals.chartID !== e.ctx.w.globals.chartID && delete t.series, h.config = $e4b487e979d7c06d$var$v.extend(h.config, t), r && (h.globals.lastXAxis = t.xaxis ? $e4b487e979d7c06d$var$v.clone(t.xaxis) : [], h.globals.lastYAxis = t.yaxis ? $e4b487e979d7c06d$var$v.clone(t.yaxis) : [], h.globals.initialConfig = $e4b487e979d7c06d$var$v.extend({}, h.config), h.globals.initialSeries = $e4b487e979d7c06d$var$v.clone(h.config.series), t.series))) {
                            for(var c = 0; c < h.globals.collapsedSeriesIndices.length; c++){
                                var d = h.config.series[h.globals.collapsedSeriesIndices[c]];
                                h.globals.collapsedSeries[c].data = h.globals.axisCharts ? d.data.slice() : d;
                            }
                            for(var u = 0; u < h.globals.ancillaryCollapsedSeriesIndices.length; u++){
                                var g = h.config.series[h.globals.ancillaryCollapsedSeriesIndices[u]];
                                h.globals.ancillaryCollapsedSeries[u].data = h.globals.axisCharts ? g.data.slice() : g;
                            }
                            s.series.emptyCollapsedSeries(h.config.series);
                        }
                        return s.update(t).then(function() {
                            l === o.length - 1 && n(s);
                        });
                    });
                });
            }
        },
        {
            key: "_updateSeries",
            value: function(t, e) {
                var i = this, a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise(function(s) {
                    var r, n = i.w;
                    return n.globals.shouldAnimate = e, n.globals.dataChanged = !0, e && i.ctx.series.getPreviousPaths(), n.globals.axisCharts ? (0 === (r = t.map(function(t, e) {
                        return i._extendSeries(t, e);
                    })).length && (r = [
                        {
                            data: []
                        }
                    ]), n.config.series = r) : n.config.series = t.slice(), a && (n.globals.initialConfig.series = $e4b487e979d7c06d$var$v.clone(n.config.series), n.globals.initialSeries = $e4b487e979d7c06d$var$v.clone(n.config.series)), i.ctx.update().then(function() {
                        s(i.ctx);
                    });
                });
            }
        },
        {
            key: "_extendSeries",
            value: function(t, e) {
                var i = this.w, a = i.config.series[e];
                return $e4b487e979d7c06d$var$u($e4b487e979d7c06d$var$u({}, i.config.series[e]), {}, {
                    name: t.name ? t.name : null == a ? void 0 : a.name,
                    color: t.color ? t.color : null == a ? void 0 : a.color,
                    type: t.type ? t.type : null == a ? void 0 : a.type,
                    group: t.group ? t.group : null == a ? void 0 : a.group,
                    hidden: void 0 !== t.hidden ? t.hidden : null == a ? void 0 : a.hidden,
                    data: t.data ? t.data : null == a ? void 0 : a.data,
                    zIndex: void 0 !== t.zIndex ? t.zIndex : e
                });
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(t, "']");
                return i.globals.axisCharts ? a = i.globals.dom.Paper.findOne("".concat(s, " path[j='").concat(e, "'], ").concat(s, " circle[j='").concat(e, "'], ").concat(s, " rect[j='").concat(e, "']")) : void 0 === e && (a = i.globals.dom.Paper.findOne("".concat(s, " path[j='").concat(t, "']")), "pie" !== i.config.chart.type && "polarArea" !== i.config.chart.type && "donut" !== i.config.chart.type || this.ctx.pie.pieClicked(t)), a ? (new $e4b487e979d7c06d$var$Mi(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
            }
        },
        {
            key: "forceXAxisUpdate",
            value: function(t) {
                var e = this.w;
                if ([
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== t.xaxis[i] && (e.config.xaxis[i] = t.xaxis[i], e.globals.lastXAxis[i] = t.xaxis[i]);
                }), t.xaxis.categories && t.xaxis.categories.length && (e.config.xaxis.categories = t.xaxis.categories), e.config.xaxis.convertedCatToNumeric) {
                    var i = new $e4b487e979d7c06d$var$Ni(t);
                    t = i.convertCatToNumericXaxis(t, this.ctx);
                }
                return t;
            }
        },
        {
            key: "forceYAxisUpdate",
            value: function(t) {
                return t.chart && t.chart.stacked && "100%" === t.chart.stackType && (Array.isArray(t.yaxis) ? t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }) : (t.yaxis.min = 0, t.yaxis.max = 100)), t;
            }
        },
        {
            key: "revertDefaultAxisMinMax",
            value: function(t) {
                var e = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                t && t.xaxis && (a = t.xaxis), t && t.yaxis && (s = t.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                var r = function(t) {
                    void 0 !== s[t] && (i.config.yaxis[t].min = s[t].min, i.config.yaxis[t].max = s[t].max);
                };
                i.config.yaxis.map(function(t, a) {
                    i.globals.zoomed || void 0 !== s[a] ? r(a) : void 0 !== e.ctx.opts.yaxis[a] && (t.min = e.ctx.opts.yaxis[a].min, t.max = e.ctx.opts.yaxis[a].max);
                });
            }
        }
    ]), t;
}();
!function() {
    function t() {
        for(var t = arguments.length > 0 && arguments[0] !== h ? arguments[0] : [], s = arguments.length > 1 ? arguments[1] : h, r = arguments.length > 2 ? arguments[2] : h, n = arguments.length > 3 ? arguments[3] : h, o = arguments.length > 4 ? arguments[4] : h, l = arguments.length > 5 ? arguments[5] : h, h = arguments.length > 6 ? arguments[6] : h, c = t.slice(s, r || h), d = n.slice(o, l || h), u = 0, g = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        }, p = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        };;){
            if (c[u] = e.call(g, c[u]), d[u] = e.call(p, d[u]), c[u][0] != d[u][0] || "M" == c[u][0] || "A" == c[u][0] && (c[u][4] != d[u][4] || c[u][5] != d[u][5]) ? (Array.prototype.splice.apply(c, [
                u,
                1
            ].concat(a.call(g, c[u]))), Array.prototype.splice.apply(d, [
                u,
                1
            ].concat(a.call(p, d[u])))) : (c[u] = i.call(g, c[u]), d[u] = i.call(p, d[u])), ++u == c.length && u == d.length) break;
            u == c.length && c.push([
                "C",
                g.pos[0],
                g.pos[1],
                g.pos[0],
                g.pos[1],
                g.pos[0],
                g.pos[1]
            ]), u == d.length && d.push([
                "C",
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1]
            ]);
        }
        return {
            start: c,
            dest: d
        };
    }
    function e(t) {
        switch(t[0]){
            case "z":
            case "Z":
                t[0] = "L", t[1] = this.start[0], t[2] = this.start[1];
                break;
            case "H":
                t[0] = "L", t[2] = this.pos[1];
                break;
            case "V":
                t[0] = "L", t[2] = t[1], t[1] = this.pos[0];
                break;
            case "T":
                t[0] = "Q", t[3] = t[1], t[4] = t[2], t[1] = this.reflection[1], t[2] = this.reflection[0];
                break;
            case "S":
                t[0] = "C", t[6] = t[4], t[5] = t[3], t[4] = t[2], t[3] = t[1], t[2] = this.reflection[1], t[1] = this.reflection[0];
        }
        return t;
    }
    function i(t) {
        var e = t.length;
        return this.pos = [
            t[e - 2],
            t[e - 1]
        ], -1 != "SCQT".indexOf(t[0]) && (this.reflection = [
            2 * this.pos[0] - t[e - 4],
            2 * this.pos[1] - t[e - 3]
        ]), t;
    }
    function a(t) {
        var e = [
            t
        ];
        switch(t[0]){
            case "M":
                return this.pos = this.start = [
                    t[1],
                    t[2]
                ], e;
            case "L":
                t[5] = t[3] = t[1], t[6] = t[4] = t[2], t[1] = this.pos[0], t[2] = this.pos[1];
                break;
            case "Q":
                t[6] = t[4], t[5] = t[3], t[4] = 1 * t[4] / 3 + 2 * t[2] / 3, t[3] = 1 * t[3] / 3 + 2 * t[1] / 3, t[2] = 1 * this.pos[1] / 3 + 2 * t[2] / 3, t[1] = 1 * this.pos[0] / 3 + 2 * t[1] / 3;
                break;
            case "A":
                e = function(t, e) {
                    var i, a, s, r, n, o, l, h, c, d, u, g, p, f, x, b, m, v, y, w, k, A, C, S, L, M, P = Math.abs(e[1]), I = Math.abs(e[2]), T = e[3] % 360, z = e[4], X = e[5], R = e[6], E = e[7], Y = new $e4b487e979d7c06d$var$bt(t), H = new $e4b487e979d7c06d$var$bt(R, E), O = [];
                    if (0 === P || 0 === I || Y.x === H.x && Y.y === H.y) return [
                        [
                            "C",
                            Y.x,
                            Y.y,
                            H.x,
                            H.y,
                            H.x,
                            H.y
                        ]
                    ];
                    i = new $e4b487e979d7c06d$var$bt((Y.x - H.x) / 2, (Y.y - H.y) / 2).transform((new $e4b487e979d7c06d$var$vt).rotate(T)), a = i.x * i.x / (P * P) + i.y * i.y / (I * I), a > 1 && (P *= a = Math.sqrt(a), I *= a);
                    s = (new $e4b487e979d7c06d$var$vt).rotate(T).scale(1 / P, 1 / I).rotate(-T), Y = Y.transform(s), H = H.transform(s), r = [
                        H.x - Y.x,
                        H.y - Y.y
                    ], o = r[0] * r[0] + r[1] * r[1], n = Math.sqrt(o), r[0] /= n, r[1] /= n, l = o < 4 ? Math.sqrt(1 - o / 4) : 0, z === X && (l *= -1);
                    h = new $e4b487e979d7c06d$var$bt((H.x + Y.x) / 2 + l * -r[1], (H.y + Y.y) / 2 + l * r[0]), c = new $e4b487e979d7c06d$var$bt(Y.x - h.x, Y.y - h.y), d = new $e4b487e979d7c06d$var$bt(H.x - h.x, H.y - h.y), u = Math.acos(c.x / Math.sqrt(c.x * c.x + c.y * c.y)), c.y < 0 && (u *= -1);
                    g = Math.acos(d.x / Math.sqrt(d.x * d.x + d.y * d.y)), d.y < 0 && (g *= -1);
                    X && u > g && (g += 2 * Math.PI);
                    !X && u < g && (g -= 2 * Math.PI);
                    for(f = Math.ceil(2 * Math.abs(u - g) / Math.PI), b = [], m = u, p = (g - u) / f, x = 4 * Math.tan(p / 4) / 3, k = 0; k <= f; k++)y = Math.cos(m), v = Math.sin(m), w = new $e4b487e979d7c06d$var$bt(h.x + y, h.y + v), b[k] = [
                        new $e4b487e979d7c06d$var$bt(w.x + x * v, w.y - x * y),
                        w,
                        new $e4b487e979d7c06d$var$bt(w.x - x * v, w.y + x * y)
                    ], m += p;
                    for(b[0][0] = b[0][1].clone(), b[b.length - 1][2] = b[b.length - 1][1].clone(), s = (new $e4b487e979d7c06d$var$vt).rotate(T).scale(P, I).rotate(-T), k = 0, A = b.length; k < A; k++)b[k][0] = b[k][0].transform(s), b[k][1] = b[k][1].transform(s), b[k][2] = b[k][2].transform(s);
                    for(k = 1, A = b.length; k < A; k++)C = (w = b[k - 1][2]).x, S = w.y, L = (w = b[k][0]).x, M = w.y, R = (w = b[k][1]).x, E = w.y, O.push([
                        "C",
                        C,
                        S,
                        L,
                        M,
                        R,
                        E
                    ]);
                    return O;
                }(this.pos, t), t = e[0];
        }
        return t[0] = "C", this.pos = [
            t[5],
            t[6]
        ], this.reflection = [
            2 * t[5] - t[3],
            2 * t[6] - t[4]
        ], e;
    }
    function s() {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = arguments.length > 1 ? arguments[1] : void 0;
        if (!1 === e) return !1;
        for(var i = e, a = t.length; i < a; ++i)if ("M" == t[i][0]) return i;
        return !1;
    }
    $e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Ee, {
        morph: function(e, i, a, r, n) {
            for(var o = this.parse(e), l = this.parse(i), h = 0, c = 0, d = !1, u = !1; !1 !== h || !1 !== c;){
                var g;
                d = s(o, !1 !== h && h + 1), u = s(l, !1 !== c && c + 1), !1 === h && (h = 0 == (g = new $e4b487e979d7c06d$var$Ee(p.start).bbox()).height || 0 == g.width ? o.push(o[0]) - 1 : o.push([
                    "M",
                    g.x + g.width / 2,
                    g.y + g.height / 2
                ]) - 1), !1 === c && (c = 0 == (g = new $e4b487e979d7c06d$var$Ee(p.dest).bbox()).height || 0 == g.width ? l.push(l[0]) - 1 : l.push([
                    "M",
                    g.x + g.width / 2,
                    g.y + g.height / 2
                ]) - 1);
                var p = t(o, h, d, l, c, u);
                o = o.slice(0, h).concat(p.start, !1 === d ? [] : o.slice(d)), l = l.slice(0, c).concat(p.dest, !1 === u ? [] : l.slice(u)), h = !1 !== d && h + p.start.length, c = !1 !== u && c + p.dest.length;
            }
            this._array = o, this.destination = new $e4b487e979d7c06d$var$Ee, this.destination._array = l;
            var f = this.fromArray(o.map(function(t, e) {
                var i = l[e].map(function(i, s) {
                    return 0 === s ? i : r.step(t[s], l[e][s], a, n[e], n);
                });
                return i;
            }));
            return f;
        }
    });
}();
const $e4b487e979d7c06d$var$$a = (t)=>(t.changedTouches && (t = t.changedTouches[0]), {
        x: t.clientX,
        y: t.clientY
    });
class $e4b487e979d7c06d$var$Ja {
    constructor(t){
        t.remember("_draggable", this), this.el = t, this.drag = this.drag.bind(this), this.startDrag = this.startDrag.bind(this), this.endDrag = this.endDrag.bind(this);
    }
    init(t) {
        t ? (this.el.on("mousedown.drag", this.startDrag), this.el.on("touchstart.drag", this.startDrag, {
            passive: !1
        })) : (this.el.off("mousedown.drag"), this.el.off("touchstart.drag"));
    }
    startDrag(t) {
        const e = !t.type.indexOf("mouse");
        if (e && 1 !== t.which && 0 !== t.buttons) return;
        if (this.el.dispatch("beforedrag", {
            event: t,
            handler: this
        }).defaultPrevented) return;
        t.preventDefault(), t.stopPropagation(), this.init(!1), this.box = this.el.bbox(), this.lastClick = this.el.point($e4b487e979d7c06d$var$$a(t));
        const i = (e ? "mouseup" : "touchend") + ".drag";
        $e4b487e979d7c06d$var$zt(window, (e ? "mousemove" : "touchmove") + ".drag", this.drag, this, {
            passive: !1
        }), $e4b487e979d7c06d$var$zt(window, i, this.endDrag, this, {
            passive: !1
        }), this.el.fire("dragstart", {
            event: t,
            handler: this,
            box: this.box
        });
    }
    drag(t) {
        const { box: e, lastClick: i } = this, a = this.el.point($e4b487e979d7c06d$var$$a(t)), s = a.x - i.x, r = a.y - i.y;
        if (!s && !r) return e;
        const n = e.x + s, o = e.y + r;
        this.box = new $e4b487e979d7c06d$var$kt(n, o, e.w, e.h), this.lastClick = a, this.el.dispatch("dragmove", {
            event: t,
            handler: this,
            box: this.box
        }).defaultPrevented || this.move(n, o);
    }
    move(t, e) {
        "svg" === this.el.type ? $e4b487e979d7c06d$var$gi.prototype.move.call(this.el, t, e) : this.el.move(t, e);
    }
    endDrag(t) {
        this.drag(t), this.el.fire("dragend", {
            event: t,
            handler: this,
            box: this.box
        }), $e4b487e979d7c06d$var$Xt(window, "mousemove.drag"), $e4b487e979d7c06d$var$Xt(window, "touchmove.drag"), $e4b487e979d7c06d$var$Xt(window, "mouseup.drag"), $e4b487e979d7c06d$var$Xt(window, "touchend.drag"), this.init(!0);
    }
}
/*!
* @svgdotjs/svg.select.js - An extension of svg.js which allows to select elements with mouse
* @version 4.0.1
* https://github.com/svgdotjs/svg.select.js
*
* @copyright Ulrich-Matthias Schäfer
* @license MIT
*
* BUILT: Mon Jul 01 2024 15:04:42 GMT+0200 (Central European Summer Time)
*/ function $e4b487e979d7c06d$var$Qa(t, e, i, a = null) {
    return function(s) {
        s.preventDefault(), s.stopPropagation();
        var r = s.pageX || s.touches[0].pageX, n = s.pageY || s.touches[0].pageY;
        e.fire(t, {
            x: r,
            y: n,
            event: s,
            index: a,
            points: i
        });
    };
}
function $e4b487e979d7c06d$var$Ka([t, e], { a: i, b: a, c: s, d: r, e: n, f: o }) {
    return [
        t * i + e * s + n,
        t * a + e * r + o
    ];
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Gt, {
    draggable (t = !0) {
        return (this.remember("_draggable") || new $e4b487e979d7c06d$var$Ja(this)).init(t), this;
    }
});
let $e4b487e979d7c06d$var$ts = class {
    constructor(t){
        this.el = t, t.remember("_selectHandler", this), this.selection = new $e4b487e979d7c06d$var$gi, this.order = [
            "lt",
            "t",
            "rt",
            "r",
            "rb",
            "b",
            "lb",
            "l",
            "rot"
        ], this.mutationHandler = this.mutationHandler.bind(this);
        const e = $e4b487e979d7c06d$var$F();
        this.observer = new e.MutationObserver(this.mutationHandler);
    }
    init(t) {
        this.createHandle = t.createHandle || this.createHandleFn, this.createRot = t.createRot || this.createRotFn, this.updateHandle = t.updateHandle || this.updateHandleFn, this.updateRot = t.updateRot || this.updateRotFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createResizeHandles(), this.updateResizeHandles(), this.createRotationHandle(), this.updateRotationHandle(), this.observer.observe(this.el.node, {
            attributes: !0
        });
    }
    active(t, e) {
        if (!t) return this.selection.clear().remove(), void this.observer.disconnect();
        this.init(e);
    }
    createSelection() {
        this.selection.polygon(this.handlePoints).addClass("svg_select_shape");
    }
    updateSelection() {
        this.selection.get(0).plot(this.handlePoints);
    }
    createResizeHandles() {
        this.handlePoints.forEach((t, e, i)=>{
            const a = this.order[e];
            this.createHandle.call(this, this.selection, t, e, i, a), this.selection.get(e + 1).addClass("svg_select_handle svg_select_handle_" + a).on("mousedown.selection touchstart.selection", $e4b487e979d7c06d$var$Qa(a, this.el, this.handlePoints, e));
        });
    }
    createHandleFn(t) {
        t.polyline();
    }
    updateHandleFn(t, e, i, a) {
        const s = a.at(i - 1), r = a[(i + 1) % a.length], n = e, o = [
            n[0] - s[0],
            n[1] - s[1]
        ], l = [
            n[0] - r[0],
            n[1] - r[1]
        ], h = Math.sqrt(o[0] * o[0] + o[1] * o[1]), c = Math.sqrt(l[0] * l[0] + l[1] * l[1]), d = [
            o[0] / h,
            o[1] / h
        ], u = [
            l[0] / c,
            l[1] / c
        ], g = [
            n[0] - 10 * d[0],
            n[1] - 10 * d[1]
        ], p = [
            n[0] - 10 * u[0],
            n[1] - 10 * u[1]
        ];
        t.plot([
            g,
            n,
            p
        ]);
    }
    updateResizeHandles() {
        this.handlePoints.forEach((t, e, i)=>{
            const a = this.order[e];
            this.updateHandle.call(this, this.selection.get(e + 1), t, e, i, a);
        });
    }
    createRotFn(t) {
        t.line(), t.circle(5);
    }
    getPoint(t) {
        return this.handlePoints[this.order.indexOf(t)];
    }
    getPointHandle(t) {
        return this.selection.get(this.order.indexOf(t) + 1);
    }
    updateRotFn(t, e) {
        const i = this.getPoint("t");
        t.get(0).plot(i[0], i[1], e[0], e[1]), t.get(1).center(e[0], e[1]);
    }
    createRotationHandle() {
        const t = this.selection.group().addClass("svg_select_handle_rot").on("mousedown.selection touchstart.selection", $e4b487e979d7c06d$var$Qa("rot", this.el, this.handlePoints));
        this.createRot.call(this, t);
    }
    updateRotationHandle() {
        const t = this.selection.findOne("g.svg_select_handle_rot");
        this.updateRot(t, this.rotationPoint, this.handlePoints);
    }
    updatePoints() {
        const t = this.el.bbox(), e = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
        this.handlePoints = this.getHandlePoints(t).map((t)=>$e4b487e979d7c06d$var$Ka(t, e)), this.rotationPoint = $e4b487e979d7c06d$var$Ka(this.getRotationPoint(t), e);
    }
    getHandlePoints({ x: t, x2: e, y: i, y2: a, cx: s, cy: r } = this.el.bbox()) {
        return [
            [
                t,
                i
            ],
            [
                s,
                i
            ],
            [
                e,
                i
            ],
            [
                e,
                r
            ],
            [
                e,
                a
            ],
            [
                s,
                a
            ],
            [
                t,
                a
            ],
            [
                t,
                r
            ]
        ];
    }
    getRotationPoint({ y: t, cx: e } = this.el.bbox()) {
        return [
            e,
            t - 20
        ];
    }
    mutationHandler() {
        this.updatePoints(), this.updateSelection(), this.updateResizeHandles(), this.updateRotationHandle();
    }
};
const $e4b487e979d7c06d$var$es = (t)=>function(e = !0, i = {}) {
        "object" == typeof e && (i = e, e = !0);
        let a = this.remember("_" + t.name);
        return a || (e.prototype instanceof $e4b487e979d7c06d$var$ts ? (a = new e(this), e = !0) : a = new t(this), this.remember("_" + t.name, a)), a.active(e, i), this;
    };
/*!
* @svgdotjs/svg.resize.js - An extension for svg.js which allows to resize elements which are selected
* @version 2.0.4
* https://github.com/svgdotjs/svg.resize.js
*
* @copyright [object Object]
* @license MIT
*
* BUILT: Fri Sep 13 2024 12:43:14 GMT+0200 (Central European Summer Time)
*/ /*!
* @svgdotjs/svg.select.js - An extension of svg.js which allows to select elements with mouse
* @version 4.0.1
* https://github.com/svgdotjs/svg.select.js
*
* @copyright Ulrich-Matthias Schäfer
* @license MIT
*
* BUILT: Mon Jul 01 2024 15:04:42 GMT+0200 (Central European Summer Time)
*/ function $e4b487e979d7c06d$var$is(t, e, i, a = null) {
    return function(s) {
        s.preventDefault(), s.stopPropagation();
        var r = s.pageX || s.touches[0].pageX, n = s.pageY || s.touches[0].pageY;
        e.fire(t, {
            x: r,
            y: n,
            event: s,
            index: a,
            points: i
        });
    };
}
function $e4b487e979d7c06d$var$as([t, e], { a: i, b: a, c: s, d: r, e: n, f: o }) {
    return [
        t * i + e * s + n,
        t * a + e * r + o
    ];
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Gt, {
    select: $e4b487e979d7c06d$var$es($e4b487e979d7c06d$var$ts)
}), $e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$Ge,
    $e4b487e979d7c06d$var$je,
    $e4b487e979d7c06d$var$xe
], {
    pointSelect: $e4b487e979d7c06d$var$es(class {
        constructor(t){
            this.el = t, t.remember("_pointSelectHandler", this), this.selection = new $e4b487e979d7c06d$var$gi, this.order = [
                "lt",
                "t",
                "rt",
                "r",
                "rb",
                "b",
                "lb",
                "l",
                "rot"
            ], this.mutationHandler = this.mutationHandler.bind(this);
            const e = $e4b487e979d7c06d$var$F();
            this.observer = new e.MutationObserver(this.mutationHandler);
        }
        init(t) {
            this.createHandle = t.createHandle || this.createHandleFn, this.updateHandle = t.updateHandle || this.updateHandleFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createPointHandles(), this.updatePointHandles(), this.observer.observe(this.el.node, {
                attributes: !0
            });
        }
        active(t, e) {
            if (!t) return this.selection.clear().remove(), void this.observer.disconnect();
            this.init(e);
        }
        createSelection() {
            this.selection.polygon(this.points).addClass("svg_select_shape_pointSelect");
        }
        updateSelection() {
            this.selection.get(0).plot(this.points);
        }
        createPointHandles() {
            this.points.forEach((t, e, i)=>{
                this.createHandle.call(this, this.selection, t, e, i), this.selection.get(e + 1).addClass("svg_select_handle_point").on("mousedown.selection touchstart.selection", $e4b487e979d7c06d$var$Qa("point", this.el, this.points, e));
            });
        }
        createHandleFn(t) {
            t.circle(5);
        }
        updateHandleFn(t, e) {
            t.center(e[0], e[1]);
        }
        updatePointHandles() {
            this.points.forEach((t, e, i)=>{
                this.updateHandle.call(this, this.selection.get(e + 1), t, e, i);
            });
        }
        updatePoints() {
            const t = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
            this.points = this.el.array().map((e)=>$e4b487e979d7c06d$var$Ka(e, t));
        }
        mutationHandler() {
            this.updatePoints(), this.updateSelection(), this.updatePointHandles();
        }
    })
});
class $e4b487e979d7c06d$var$ss {
    constructor(t){
        this.el = t, t.remember("_selectHandler", this), this.selection = new $e4b487e979d7c06d$var$gi, this.order = [
            "lt",
            "t",
            "rt",
            "r",
            "rb",
            "b",
            "lb",
            "l",
            "rot"
        ], this.mutationHandler = this.mutationHandler.bind(this);
        const e = $e4b487e979d7c06d$var$F();
        this.observer = new e.MutationObserver(this.mutationHandler);
    }
    init(t) {
        this.createHandle = t.createHandle || this.createHandleFn, this.createRot = t.createRot || this.createRotFn, this.updateHandle = t.updateHandle || this.updateHandleFn, this.updateRot = t.updateRot || this.updateRotFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createResizeHandles(), this.updateResizeHandles(), this.createRotationHandle(), this.updateRotationHandle(), this.observer.observe(this.el.node, {
            attributes: !0
        });
    }
    active(t, e) {
        if (!t) return this.selection.clear().remove(), void this.observer.disconnect();
        this.init(e);
    }
    createSelection() {
        this.selection.polygon(this.handlePoints).addClass("svg_select_shape");
    }
    updateSelection() {
        this.selection.get(0).plot(this.handlePoints);
    }
    createResizeHandles() {
        this.handlePoints.forEach((t, e, i)=>{
            const a = this.order[e];
            this.createHandle.call(this, this.selection, t, e, i, a), this.selection.get(e + 1).addClass("svg_select_handle svg_select_handle_" + a).on("mousedown.selection touchstart.selection", $e4b487e979d7c06d$var$is(a, this.el, this.handlePoints, e));
        });
    }
    createHandleFn(t) {
        t.polyline();
    }
    updateHandleFn(t, e, i, a) {
        const s = a.at(i - 1), r = a[(i + 1) % a.length], n = e, o = [
            n[0] - s[0],
            n[1] - s[1]
        ], l = [
            n[0] - r[0],
            n[1] - r[1]
        ], h = Math.sqrt(o[0] * o[0] + o[1] * o[1]), c = Math.sqrt(l[0] * l[0] + l[1] * l[1]), d = [
            o[0] / h,
            o[1] / h
        ], u = [
            l[0] / c,
            l[1] / c
        ], g = [
            n[0] - 10 * d[0],
            n[1] - 10 * d[1]
        ], p = [
            n[0] - 10 * u[0],
            n[1] - 10 * u[1]
        ];
        t.plot([
            g,
            n,
            p
        ]);
    }
    updateResizeHandles() {
        this.handlePoints.forEach((t, e, i)=>{
            const a = this.order[e];
            this.updateHandle.call(this, this.selection.get(e + 1), t, e, i, a);
        });
    }
    createRotFn(t) {
        t.line(), t.circle(5);
    }
    getPoint(t) {
        return this.handlePoints[this.order.indexOf(t)];
    }
    getPointHandle(t) {
        return this.selection.get(this.order.indexOf(t) + 1);
    }
    updateRotFn(t, e) {
        const i = this.getPoint("t");
        t.get(0).plot(i[0], i[1], e[0], e[1]), t.get(1).center(e[0], e[1]);
    }
    createRotationHandle() {
        const t = this.selection.group().addClass("svg_select_handle_rot").on("mousedown.selection touchstart.selection", $e4b487e979d7c06d$var$is("rot", this.el, this.handlePoints));
        this.createRot.call(this, t);
    }
    updateRotationHandle() {
        const t = this.selection.findOne("g.svg_select_handle_rot");
        this.updateRot(t, this.rotationPoint, this.handlePoints);
    }
    updatePoints() {
        const t = this.el.bbox(), e = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
        this.handlePoints = this.getHandlePoints(t).map((t)=>$e4b487e979d7c06d$var$as(t, e)), this.rotationPoint = $e4b487e979d7c06d$var$as(this.getRotationPoint(t), e);
    }
    getHandlePoints({ x: t, x2: e, y: i, y2: a, cx: s, cy: r } = this.el.bbox()) {
        return [
            [
                t,
                i
            ],
            [
                s,
                i
            ],
            [
                e,
                i
            ],
            [
                e,
                r
            ],
            [
                e,
                a
            ],
            [
                s,
                a
            ],
            [
                t,
                a
            ],
            [
                t,
                r
            ]
        ];
    }
    getRotationPoint({ y: t, cx: e } = this.el.bbox()) {
        return [
            e,
            t - 20
        ];
    }
    mutationHandler() {
        this.updatePoints(), this.updateSelection(), this.updateResizeHandles(), this.updateRotationHandle();
    }
}
const $e4b487e979d7c06d$var$rs = (t)=>function(e = !0, i = {}) {
        "object" == typeof e && (i = e, e = !0);
        let a = this.remember("_" + t.name);
        return a || (e.prototype instanceof $e4b487e979d7c06d$var$ss ? (a = new e(this), e = !0) : a = new t(this), this.remember("_" + t.name, a)), a.active(e, i), this;
    };
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Gt, {
    select: $e4b487e979d7c06d$var$rs($e4b487e979d7c06d$var$ss)
}), $e4b487e979d7c06d$var$Q([
    $e4b487e979d7c06d$var$Ge,
    $e4b487e979d7c06d$var$je,
    $e4b487e979d7c06d$var$xe
], {
    pointSelect: $e4b487e979d7c06d$var$rs(class {
        constructor(t){
            this.el = t, t.remember("_pointSelectHandler", this), this.selection = new $e4b487e979d7c06d$var$gi, this.order = [
                "lt",
                "t",
                "rt",
                "r",
                "rb",
                "b",
                "lb",
                "l",
                "rot"
            ], this.mutationHandler = this.mutationHandler.bind(this);
            const e = $e4b487e979d7c06d$var$F();
            this.observer = new e.MutationObserver(this.mutationHandler);
        }
        init(t) {
            this.createHandle = t.createHandle || this.createHandleFn, this.updateHandle = t.updateHandle || this.updateHandleFn, this.el.root().put(this.selection), this.updatePoints(), this.createSelection(), this.createPointHandles(), this.updatePointHandles(), this.observer.observe(this.el.node, {
                attributes: !0
            });
        }
        active(t, e) {
            if (!t) return this.selection.clear().remove(), void this.observer.disconnect();
            this.init(e);
        }
        createSelection() {
            this.selection.polygon(this.points).addClass("svg_select_shape_pointSelect");
        }
        updateSelection() {
            this.selection.get(0).plot(this.points);
        }
        createPointHandles() {
            this.points.forEach((t, e, i)=>{
                this.createHandle.call(this, this.selection, t, e, i), this.selection.get(e + 1).addClass("svg_select_handle_point").on("mousedown.selection touchstart.selection", $e4b487e979d7c06d$var$is("point", this.el, this.points, e));
            });
        }
        createHandleFn(t) {
            t.circle(5);
        }
        updateHandleFn(t, e) {
            t.center(e[0], e[1]);
        }
        updatePointHandles() {
            this.points.forEach((t, e, i)=>{
                this.updateHandle.call(this, this.selection.get(e + 1), t, e, i);
            });
        }
        updatePoints() {
            const t = this.el.parent().screenCTM().inverseO().multiplyO(this.el.screenCTM());
            this.points = this.el.array().map((e)=>$e4b487e979d7c06d$var$as(e, t));
        }
        mutationHandler() {
            this.updatePoints(), this.updateSelection(), this.updatePointHandles();
        }
    })
});
const $e4b487e979d7c06d$var$ns = (t)=>(t.changedTouches && (t = t.changedTouches[0]), {
        x: t.clientX,
        y: t.clientY
    }), $e4b487e979d7c06d$var$os = (t)=>{
    let e = 1 / 0, i = 1 / 0, a = -1 / 0, s = -1 / 0;
    for(let r = 0; r < t.length; r++){
        const n = t[r];
        e = Math.min(e, n[0]), i = Math.min(i, n[1]), a = Math.max(a, n[0]), s = Math.max(s, n[1]);
    }
    return new $e4b487e979d7c06d$var$kt(e, i, a - e, s - i);
};
class $e4b487e979d7c06d$var$ls {
    constructor(t){
        this.el = t, t.remember("_ResizeHandler", this), this.lastCoordinates = null, this.eventType = "", this.lastEvent = null, this.handleResize = this.handleResize.bind(this), this.resize = this.resize.bind(this), this.endResize = this.endResize.bind(this), this.rotate = this.rotate.bind(this), this.movePoint = this.movePoint.bind(this);
    }
    active(t, e) {
        this.preserveAspectRatio = e.preserveAspectRatio ?? !1, this.aroundCenter = e.aroundCenter ?? !1, this.grid = e.grid ?? 0, this.degree = e.degree ?? 0, this.el.off(".resize"), t && (this.el.on([
            "lt.resize",
            "rt.resize",
            "rb.resize",
            "lb.resize",
            "t.resize",
            "r.resize",
            "b.resize",
            "l.resize",
            "rot.resize",
            "point.resize"
        ], this.handleResize), this.lastEvent && ("rot" === this.eventType ? this.rotate(this.lastEvent) : "point" === this.eventType ? this.movePoint(this.lastEvent) : this.resize(this.lastEvent)));
    }
    handleResize(t) {
        this.eventType = t.type;
        const { event: e, index: i, points: a } = t.detail, s = !e.type.indexOf("mouse");
        if (s && 1 !== (e.which || e.buttons)) return;
        if (this.el.dispatch("beforeresize", {
            event: t,
            handler: this
        }).defaultPrevented) return;
        this.box = this.el.bbox(), this.startPoint = this.el.point($e4b487e979d7c06d$var$ns(e)), this.index = i, this.points = a.slice();
        const r = (s ? "mousemove" : "touchmove") + ".resize", n = (s ? "mouseup" : "touchcancel.resize touchend") + ".resize";
        "point" === t.type ? $e4b487e979d7c06d$var$zt(window, r, this.movePoint) : "rot" === t.type ? $e4b487e979d7c06d$var$zt(window, r, this.rotate) : $e4b487e979d7c06d$var$zt(window, r, this.resize), $e4b487e979d7c06d$var$zt(window, n, this.endResize);
    }
    resize(t) {
        this.lastEvent = t;
        const e = this.snapToGrid(this.el.point($e4b487e979d7c06d$var$ns(t)));
        let i = e.x - this.startPoint.x, a = e.y - this.startPoint.y;
        this.preserveAspectRatio && this.aroundCenter && (i *= 2, a *= 2);
        const s = this.box.x + i, r = this.box.y + a, n = this.box.x2 + i, o = this.box.y2 + a;
        let l = new $e4b487e979d7c06d$var$kt(this.box);
        if (this.eventType.includes("l") && (l.x = Math.min(s, this.box.x2), l.x2 = Math.max(s, this.box.x2)), this.eventType.includes("r") && (l.x = Math.min(n, this.box.x), l.x2 = Math.max(n, this.box.x)), this.eventType.includes("t") && (l.y = Math.min(r, this.box.y2), l.y2 = Math.max(r, this.box.y2)), this.eventType.includes("b") && (l.y = Math.min(o, this.box.y), l.y2 = Math.max(o, this.box.y)), l.width = l.x2 - l.x, l.height = l.y2 - l.y, this.preserveAspectRatio) {
            const t = l.width / this.box.width, e = l.height / this.box.height, i = [
                "lt",
                "t",
                "rt",
                "r",
                "rb",
                "b",
                "lb",
                "l"
            ], a = (i.indexOf(this.eventType) + 4) % i.length, s = this.aroundCenter ? [
                this.box.cx,
                this.box.cy
            ] : this.points[a];
            let r = this.eventType.includes("t") || this.eventType.includes("b") ? e : t;
            r = 2 === this.eventType.length ? Math.max(t, e) : r, l = function(t, e, i) {
                const a = [
                    [
                        t.x,
                        t.y
                    ],
                    [
                        t.x + t.width,
                        t.y
                    ],
                    [
                        t.x + t.width,
                        t.y + t.height
                    ],
                    [
                        t.x,
                        t.y + t.height
                    ]
                ].map(([t, a])=>{
                    const s = t - e[0], r = (a - e[1]) * i;
                    return [
                        s * i + e[0],
                        r + e[1]
                    ];
                });
                return $e4b487e979d7c06d$var$os(a);
            }(this.box, s, r);
        }
        this.el.dispatch("resize", {
            box: new $e4b487e979d7c06d$var$kt(l),
            angle: 0,
            eventType: this.eventType,
            event: t,
            handler: this
        }).defaultPrevented || this.el.size(l.width, l.height).move(l.x, l.y);
    }
    movePoint(t) {
        this.lastEvent = t;
        const { x: e, y: i } = this.snapToGrid(this.el.point($e4b487e979d7c06d$var$ns(t))), a = this.el.array().slice();
        a[this.index] = [
            e,
            i
        ], this.el.dispatch("resize", {
            box: $e4b487e979d7c06d$var$os(a),
            angle: 0,
            eventType: this.eventType,
            event: t,
            handler: this
        }).defaultPrevented || this.el.plot(a);
    }
    rotate(t) {
        this.lastEvent = t;
        const e = this.startPoint, i = this.el.point($e4b487e979d7c06d$var$ns(t)), { cx: a, cy: s } = this.box, r = e.x - a, n = e.y - s, o = i.x - a, l = i.y - s, h = Math.sqrt(r * r + n * n) * Math.sqrt(o * o + l * l);
        if (0 === h) return;
        let c = Math.acos((r * o + n * l) / h) / Math.PI * 180;
        if (!c) return;
        i.x < e.x && (c = -c);
        const d = new $e4b487e979d7c06d$var$vt(this.el), { x: u, y: g } = new $e4b487e979d7c06d$var$bt(a, s).transformO(d), { rotate: p } = d.decompose(), f = this.snapToAngle(p + c) - p;
        this.el.dispatch("resize", {
            box: this.box,
            angle: f,
            eventType: this.eventType,
            event: t,
            handler: this
        }).defaultPrevented || this.el.transform(d.rotateO(f, u, g));
    }
    endResize(t) {
        "rot" !== this.eventType && "point" !== this.eventType && this.resize(t), this.lastEvent = null, this.eventType = "", $e4b487e979d7c06d$var$Xt(window, "mousemove.resize touchmove.resize"), $e4b487e979d7c06d$var$Xt(window, "mouseup.resize touchend.resize");
    }
    snapToGrid(t) {
        return this.grid && (t.x = Math.round(t.x / this.grid) * this.grid, t.y = Math.round(t.y / this.grid) * this.grid), t;
    }
    snapToAngle(t) {
        return this.degree && (t = Math.round(t / this.degree) * this.degree), t;
    }
}
$e4b487e979d7c06d$var$Q($e4b487e979d7c06d$var$Gt, {
    resize: function(t = !0, e = {}) {
        "object" == typeof t && (e = t, t = !0);
        let i = this.remember("_ResizeHandler");
        return i || (t.prototype instanceof $e4b487e979d7c06d$var$ls ? (i = new t(this), t = !0) : i = new $e4b487e979d7c06d$var$ls(this), this.remember("_resizeHandler", i)), i.active(t, e), this;
    }
}), void 0 === window.SVG && (window.SVG = $e4b487e979d7c06d$var$yi), void 0 === window.Apex && (window.Apex = {});
var $e4b487e979d7c06d$var$hs = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "initModules",
            value: function() {
                this.ctx.publicMethods = [
                    "updateOptions",
                    "updateSeries",
                    "appendData",
                    "appendSeries",
                    "isSeriesHidden",
                    "highlightSeries",
                    "toggleSeries",
                    "showSeries",
                    "hideSeries",
                    "setLocale",
                    "resetSeries",
                    "zoomX",
                    "toggleDataPointSelection",
                    "dataURI",
                    "exportToCSV",
                    "addXaxisAnnotation",
                    "addYaxisAnnotation",
                    "addPointAnnotation",
                    "clearAnnotations",
                    "removeAnnotation",
                    "paper",
                    "destroy"
                ], this.ctx.eventList = [
                    "click",
                    "mousedown",
                    "mousemove",
                    "mouseleave",
                    "touchstart",
                    "touchmove",
                    "touchleave",
                    "mouseup",
                    "touchend"
                ], this.ctx.animations = new $e4b487e979d7c06d$var$y(this.ctx), this.ctx.axes = new $e4b487e979d7c06d$var$ra(this.ctx), this.ctx.core = new $e4b487e979d7c06d$var$qa(this.ctx.el, this.ctx), this.ctx.config = new $e4b487e979d7c06d$var$Wi({}), this.ctx.data = new $e4b487e979d7c06d$var$$i(this.ctx), this.ctx.grid = new $e4b487e979d7c06d$var$Ki(this.ctx), this.ctx.graphics = new $e4b487e979d7c06d$var$Mi(this.ctx), this.ctx.coreUtils = new $e4b487e979d7c06d$var$Pi(this.ctx), this.ctx.crosshairs = new $e4b487e979d7c06d$var$na(this.ctx), this.ctx.events = new $e4b487e979d7c06d$var$aa(this.ctx), this.ctx.exports = new $e4b487e979d7c06d$var$Ji(this.ctx), this.ctx.fill = new $e4b487e979d7c06d$var$ji(this.ctx), this.ctx.localization = new $e4b487e979d7c06d$var$sa(this.ctx), this.ctx.options = new $e4b487e979d7c06d$var$Oi, this.ctx.responsive = new $e4b487e979d7c06d$var$oa(this.ctx), this.ctx.series = new $e4b487e979d7c06d$var$Zi(this.ctx), this.ctx.theme = new $e4b487e979d7c06d$var$la(this.ctx), this.ctx.formatters = new $e4b487e979d7c06d$var$Xi(this.ctx), this.ctx.titleSubtitle = new $e4b487e979d7c06d$var$ha(this.ctx), this.ctx.legend = new $e4b487e979d7c06d$var$xa(this.ctx), this.ctx.toolbar = new $e4b487e979d7c06d$var$ba(this.ctx), this.ctx.tooltip = new $e4b487e979d7c06d$var$Sa(this.ctx), this.ctx.dimensions = new $e4b487e979d7c06d$var$pa(this.ctx), this.ctx.updateHelpers = new $e4b487e979d7c06d$var$Za(this.ctx), this.ctx.zoomPanSelection = new $e4b487e979d7c06d$var$ma(this.ctx), this.ctx.w.globals.tooltip = new $e4b487e979d7c06d$var$Sa(this.ctx);
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$cs = function() {
    function t(e) {
        $e4b487e979d7c06d$var$i(this, t), this.ctx = e, this.w = e.w;
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "clear",
            value: function(t) {
                var e = t.isUpdating;
                this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                    isUpdating: e
                });
            }
        },
        {
            key: "killSVG",
            value: function(t) {
                t.each(function() {
                    this.removeClass("*"), this.off();
                }, !0), t.clear();
            }
        },
        {
            key: "clearDomElements",
            value: function(t) {
                var e = this, i = t.isUpdating, a = this.w.globals.dom.Paper.node;
                a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                var s = this.w.globals.dom.baseEl;
                s && this.ctx.eventList.forEach(function(t) {
                    s.removeEventListener(t, e.ctx.events.documentEvent);
                });
                var r = this.w.globals.dom;
                if (null !== this.ctx.el) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elLegendWrap = null, r.elLegendForeign = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectBarMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
            }
        }
    ]), t;
}(), $e4b487e979d7c06d$var$ds = new WeakMap;
var $e4b487e979d7c06d$export$2e2bcd8739ae039 = function() {
    function t(e, a) {
        $e4b487e979d7c06d$var$i(this, t), this.opts = a, this.ctx = this, this.w = new $e4b487e979d7c06d$var$Gi(a).init(), this.el = e, this.w.globals.cuid = $e4b487e979d7c06d$var$v.randomId(), this.w.globals.chartID = this.w.config.chart.id ? $e4b487e979d7c06d$var$v.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new $e4b487e979d7c06d$var$hs(this).initModules(), this.lastUpdateOptions = null, this.create = $e4b487e979d7c06d$var$v.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
    }
    return $e4b487e979d7c06d$var$s(t, [
        {
            key: "render",
            value: function() {
                var t = this;
                return new Promise(function(e, i) {
                    if ($e4b487e979d7c06d$var$v.elementExists(t.el)) {
                        void 0 === Apex._chartInstances && (Apex._chartInstances = []), t.w.config.chart.id && Apex._chartInstances.push({
                            id: t.w.globals.chartID,
                            group: t.w.config.chart.group,
                            chart: t
                        }), t.setLocale(t.w.config.chart.defaultLocale);
                        var a = t.w.config.chart.events.beforeMount;
                        "function" == typeof a && a(t, t.w), t.events.fireEvent("beforeMount", [
                            t,
                            t.w
                        ]), window.addEventListener("resize", t.windowResizeHandler), function(t, e) {
                            var i = !1;
                            if (t.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
                                var a = t.getBoundingClientRect();
                                "none" !== t.style.display && 0 !== a.width || (i = !0);
                            }
                            var s = new ResizeObserver(function(a) {
                                i && e.call(t, a), i = !0;
                            });
                            t.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(t.children).forEach(function(t) {
                                return s.observe(t);
                            }) : s.observe(t), $e4b487e979d7c06d$var$ds.set(e, s);
                        }(t.el.parentNode, t.parentResizeHandler);
                        var s = t.el.getRootNode && t.el.getRootNode(), r = $e4b487e979d7c06d$var$v.is("ShadowRoot", s), n = t.el.ownerDocument, o = r ? s.getElementById("apexcharts-css") : n.getElementById("apexcharts-css");
                        if (!o) {
                            var l;
                            (o = document.createElement("style")).id = "apexcharts-css", o.textContent = '@keyframes opaque {\n  0% {\n    opacity: 0\n  }\n\n  to {\n    opacity: 1\n  }\n}\n\n@keyframes resizeanim {\n\n  0%,\n  to {\n    opacity: 0\n  }\n}\n\n.apexcharts-canvas {\n  position: relative;\n  direction: ltr !important;\n  user-select: none\n}\n\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5)\n}\n\n.apexcharts-inner {\n  position: relative\n}\n\n.apexcharts-text tspan {\n  font-family: inherit\n}\n\nrect.legend-mouseover-inactive,\n.legend-mouseover-inactive rect,\n.legend-mouseover-inactive path,\n.legend-mouseover-inactive circle,\n.legend-mouseover-inactive line,\n.legend-mouseover-inactive text.apexcharts-yaxis-title-text,\n.legend-mouseover-inactive text.apexcharts-yaxis-label {\n  transition: .15s ease all;\n  opacity: .2\n}\n\n.apexcharts-legend-text {\n  padding-left: 15px;\n  margin-left: -15px;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255, 255, 255, .96)\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30, 30, 30, .8)\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit\n}\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #eceff1;\n  border-bottom: 1px solid #ddd\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0, 0, 0, .7);\n  border-bottom: 1px solid #333\n}\n\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  margin-left: 5px;\n  font-weight: 600\n}\n\n.apexcharts-tooltip-text-goals-label:empty,\n.apexcharts-tooltip-text-goals-value:empty,\n.apexcharts-tooltip-text-y-label:empty,\n.apexcharts-tooltip-text-y-value:empty,\n.apexcharts-tooltip-text-z-value:empty,\n.apexcharts-tooltip-title:empty {\n  display: none\n}\n\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px\n}\n\n.apexcharts-tooltip-goals-group,\n.apexcharts-tooltip-text-goals-label,\n.apexcharts-tooltip-text-goals-value {\n  display: flex\n}\n\n.apexcharts-tooltip-text-goals-label:not(:empty),\n.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px\n}\n\n.apexcharts-tooltip-marker {\n  display: inline-block;\n  position: relative;\n  width: 16px;\n  height: 16px;\n  font-size: 16px;\n  line-height: 16px;\n  margin-right: 4px;\n  text-align: center;\n  vertical-align: middle;\n  color: inherit;\n}\n\n.apexcharts-tooltip-marker::before {\n  content: "";\n  display: inline-block;\n  width: 100%;\n  text-align: center;\n  color: currentcolor;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  font-size: 26px;\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 14px;\n  font-weight: 900;\n}\n\n.apexcharts-tooltip-marker[shape="circle"]::before {\n  content: "\\25CF";\n}\n\n.apexcharts-tooltip-marker[shape="square"]::before,\n.apexcharts-tooltip-marker[shape="rect"]::before {\n  content: "\\25A0";\n  transform: translate(-1px, -2px);\n}\n\n.apexcharts-tooltip-marker[shape="line"]::before {\n  content: "\\2500";\n}\n\n.apexcharts-tooltip-marker[shape="diamond"]::before {\n  content: "\\25C6";\n  font-size: 28px;\n}\n\n.apexcharts-tooltip-marker[shape="triangle"]::before {\n  content: "\\25B2";\n  font-size: 22px;\n}\n\n.apexcharts-tooltip-marker[shape="cross"]::before {\n  content: "\\2715";\n  font-size: 18px;\n}\n\n.apexcharts-tooltip-marker[shape="plus"]::before {\n  content: "\\2715";\n  transform: rotate(45deg) translate(-1px, -1px);\n  font-size: 18px;\n}\n\n.apexcharts-tooltip-marker[shape="star"]::before {\n  content: "\\2605";\n  font-size: 18px;\n}\n\n.apexcharts-tooltip-marker[shape="sparkle"]::before {\n  content: "\\2726";\n  font-size: 20px;\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,\n.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px\n}\n\n.apexcharts-custom-tooltip,\n.apexcharts-tooltip-box {\n  padding: 4px 8px\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: 700\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: 700;\n  display: block;\n  margin-bottom: 5px\n}\n\n.apexcharts-xaxistooltip,\n.apexcharts-yaxistooltip {\n  opacity: 0;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #eceff1;\n  border: 1px solid #90a4ae\n}\n\n.apexcharts-xaxistooltip {\n  padding: 9px 10px;\n  transition: .15s ease all\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, .7);\n  border: 1px solid rgba(0, 0, 0, .5);\n  color: #fff\n}\n\n.apexcharts-xaxistooltip:after,\n.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-left: -6px\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-left: -7px\n}\n\n.apexcharts-xaxistooltip-bottom:after,\n.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%\n}\n\n.apexcharts-xaxistooltip-top:after,\n.apexcharts-xaxistooltip-top:before {\n  top: 100%\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after,\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #eceff1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90a4ae\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after,\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-yaxistooltip {\n  padding: 4px 10px\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, .7);\n  border: 1px solid rgba(0, 0, 0, .5);\n  color: #fff\n}\n\n.apexcharts-yaxistooltip:after,\n.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: transparent;\n  border-width: 6px;\n  margin-top: -6px\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: transparent;\n  border-width: 7px;\n  margin-top: -7px\n}\n\n.apexcharts-yaxistooltip-left:after,\n.apexcharts-yaxistooltip-left:before {\n  left: 100%\n}\n\n.apexcharts-yaxistooltip-right:after,\n.apexcharts-yaxistooltip-right:before {\n  right: 100%\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after,\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #eceff1\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90a4ae\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after,\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0, 0, 0, .5)\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none\n}\n\n.apexcharts-xcrosshairs,\n.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: .15s ease all\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,\n.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: .15s ease all\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0\n}\n\n.apexcharts-selection-rect {\n  cursor: move\n}\n\n.svg_select_shape {\n  stroke-width: 1;\n  stroke-dasharray: 10 10;\n  stroke: black;\n  stroke-opacity: 0.1;\n  pointer-events: none;\n  fill: none;\n}\n\n.svg_select_handle {\n  stroke-width: 3;\n  stroke: black;\n  fill: none;\n}\n\n.svg_select_handle_r {\n  cursor: e-resize;\n}\n\n.svg_select_handle_l {\n  cursor: w-resize;\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-menu-icon,\n.apexcharts-pan-icon,\n.apexcharts-reset-icon,\n.apexcharts-selection-icon,\n.apexcharts-toolbar-custom-icon,\n.apexcharts-zoom-icon,\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6e8192;\n  text-align: center\n}\n\n.apexcharts-menu-icon svg,\n.apexcharts-reset-icon svg,\n.apexcharts-zoom-icon svg,\n.apexcharts-zoomin-icon svg,\n.apexcharts-zoomout-icon svg {\n  fill: #6e8192\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(.76)\n}\n\n.apexcharts-theme-dark .apexcharts-menu-icon svg,\n.apexcharts-theme-dark .apexcharts-pan-icon svg,\n.apexcharts-theme-dark .apexcharts-reset-icon svg,\n.apexcharts-theme-dark .apexcharts-selection-icon svg,\n.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomin-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomout-icon svg {\n  fill: #f3f4f5\n}\n\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg {\n  fill: #008ffb\n}\n\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg,\n.apexcharts-theme-light .apexcharts-reset-icon:hover svg,\n.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,\n.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg {\n  fill: #333\n}\n\n.apexcharts-menu-icon,\n.apexcharts-selection-icon {\n  position: relative\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px\n}\n\n.apexcharts-menu-icon,\n.apexcharts-reset-icon,\n.apexcharts-zoom-icon {\n  transform: scale(.85)\n}\n\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  transform: scale(.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px\n}\n\n.apexcharts-pan-icon {\n  transform: scale(.62);\n  position: relative;\n  left: 1px;\n  top: 0\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6e8192;\n  stroke-width: 2\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008ffb\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0 6px 2px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: .15s ease all;\n  pointer-events: none\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: .15s ease all\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0, 0, 0, .7);\n  color: #fff\n}\n\n@media screen and (min-width:768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n    opacity: 1\n  }\n}\n\n.apexcharts-canvas .apexcharts-element-hidden,\n.apexcharts-datalabel.apexcharts-element-hidden,\n.apexcharts-hide .apexcharts-series-points {\n  opacity: 0;\n}\n\n.apexcharts-hidden-element-shown {\n  opacity: 1;\n  transition: 0.25s ease all;\n}\n\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value,\n.apexcharts-datalabels,\n.apexcharts-pie-label {\n  cursor: default;\n  pointer-events: none\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: .3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease\n}\n\n.apexcharts-radialbar-label {\n  cursor: pointer;\n}\n\n.apexcharts-annotation-rect,\n.apexcharts-area-series .apexcharts-area,\n.apexcharts-gridline,\n.apexcharts-line,\n.apexcharts-point-annotation-label,\n.apexcharts-radar-series path:not(.apexcharts-marker),\n.apexcharts-radar-series polygon,\n.apexcharts-toolbar svg,\n.apexcharts-tooltip .apexcharts-marker,\n.apexcharts-xaxis-annotation-label,\n.apexcharts-yaxis-annotation-label,\n.apexcharts-zoom-rect,\n.no-pointer-events {\n  pointer-events: none\n}\n\n.apexcharts-tooltip-active .apexcharts-marker {\n  transition: .15s ease all\n}\n\n.apexcharts-radar-series .apexcharts-yaxis {\n  pointer-events: none;\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden\n}\n\n.contract-trigger:before,\n.resize-triggers,\n.resize-triggers>div {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0\n}\n\n.resize-triggers>div {\n  height: 100%;\n  width: 100%;\n  background: #eee;\n  overflow: auto\n}\n\n.contract-trigger:before {\n  overflow: hidden;\n  width: 200%;\n  height: 200%\n}\n\n.apexcharts-bar-goals-markers {\n  pointer-events: none\n}\n\n.apexcharts-bar-shadows {\n  pointer-events: none\n}\n\n.apexcharts-rangebar-goals-markers {\n  pointer-events: none\n}\n\n.apexcharts-disable-transitions * {\n  transition: none !important;\n}';
                            var h = (null === (l = t.opts.chart) || void 0 === l ? void 0 : l.nonce) || t.w.config.chart.nonce;
                            h && o.setAttribute("nonce", h), r ? s.prepend(o) : n.head.appendChild(o);
                        }
                        var c = t.create(t.w.config.series, {});
                        if (!c) return e(t);
                        t.mount(c).then(function() {
                            "function" == typeof t.w.config.chart.events.mounted && t.w.config.chart.events.mounted(t, t.w), t.events.fireEvent("mounted", [
                                t,
                                t.w
                            ]), e(c);
                        }).catch(function(t) {
                            i(t);
                        });
                    } else i(new Error("Element not found"));
                });
            }
        },
        {
            key: "create",
            value: function(t, e) {
                var i = this, a = this.w;
                new $e4b487e979d7c06d$var$hs(this).initModules();
                var s = this.w.globals;
                if (s.noData = !1, s.animationEnded = !1, !$e4b487e979d7c06d$var$v.elementExists(this.el)) return s.animationEnded = !0, null;
                (this.responsive.checkResponsiveConfig(e), a.config.xaxis.convertedCatToNumeric) && new $e4b487e979d7c06d$var$Ni(a.config).convertCatToNumericXaxis(a.config, this.ctx);
                if (this.core.setupElements(), "treemap" === a.config.chart.type && (a.config.grid.show = !1, a.config.yaxis[0].show = !1), 0 === s.svgWidth) return s.animationEnded = !0, null;
                var r = t;
                t.forEach(function(t, e) {
                    t.hidden && (r = i.legend.legendHelpers.getSeriesAfterCollapsing({
                        realIndex: e
                    }));
                });
                var n = $e4b487e979d7c06d$var$Pi.checkComboSeries(r, a.config.chart.type);
                s.comboCharts = n.comboCharts, s.comboBarCount = n.comboBarCount;
                var o = r.every(function(t) {
                    return t.data && 0 === t.data.length;
                });
                (0 === r.length || o && s.collapsedSeries.length < 1) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(r), this.theme.init(), new $e4b487e979d7c06d$var$Vi(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), s.noData && s.collapsedSeries.length !== s.series.length && !a.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), s.axisCharts && (this.core.coreCalculations(), "category" !== a.config.xaxis.type && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = a.globals.minX, this.ctx.toolbar.maxX = a.globals.maxX), this.formatters.heatmapLabelFormatters(), new $e4b487e979d7c06d$var$Pi(this).getLargestMarkerSize(), this.dimensions.plotCoords();
                var l = this.core.xySettings();
                this.grid.createGridMask();
                var h = this.core.plotChartType(r, l), c = new $e4b487e979d7c06d$var$qi(this);
                return c.bringForward(), a.config.dataLabels.background.enabled && c.dataLabelsBackground(), this.core.shiftGraphPosition(), a.globals.dataPoints > 50 && a.globals.dom.elWrap.classList.add("apexcharts-disable-transitions"), {
                    elGraph: h,
                    xyRatios: l,
                    dimensions: {
                        plot: {
                            left: a.globals.translateX,
                            top: a.globals.translateY,
                            width: a.globals.gridWidth,
                            height: a.globals.gridHeight
                        }
                    }
                };
            }
        },
        {
            key: "mount",
            value: function() {
                var t = this, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = this, a = i.w;
                return new Promise(function(s, r) {
                    if (null === i.el) return r(new Error("Not enough data to display or target element not found"));
                    (null === e || a.globals.allSeriesCollapsed) && i.series.handleNoData(), i.grid = new $e4b487e979d7c06d$var$Ki(i);
                    var n, o, l = i.grid.drawGrid();
                    (i.annotations = new $e4b487e979d7c06d$var$Fi(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), "back" === a.config.grid.position) && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (n = l.elGridBorders) && void 0 !== n && n.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    if (Array.isArray(e.elGraph)) for(var h = 0; h < e.elGraph.length; h++)a.globals.dom.elGraphical.add(e.elGraph[h]);
                    else a.globals.dom.elGraphical.add(e.elGraph);
                    "front" === a.config.grid.position && (l && a.globals.dom.elGraphical.add(l.el), null != l && null !== (o = l.elGridBorders) && void 0 !== o && o.node && a.globals.dom.elGraphical.add(l.elGridBorders));
                    "front" === a.config.xaxis.crosshairs.position && i.crosshairs.drawXCrosshairs(), "front" === a.config.yaxis[0].crosshairs.position && i.crosshairs.drawYCrosshairs(), "treemap" !== a.config.chart.type && i.axes.drawAxis(a.config.chart.type, l);
                    var c = new $e4b487e979d7c06d$var$Qi(t.ctx, l), d = new $e4b487e979d7c06d$var$ia(t.ctx, l);
                    if (null !== l && (c.xAxisLabelCorrections(l.xAxisTickWidth), d.setYAxisTextAlignments(), a.config.yaxis.map(function(t, e) {
                        -1 === a.globals.ignoreYAxisIndexes.indexOf(e) && d.yAxisTitleRotate(e, t.opposite);
                    })), i.annotations.drawAxesAnnotations(), !a.globals.noData) {
                        if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(e.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                            xyRatios: e.xyRatios
                        });
                        else {
                            var u = a.config.chart.toolbar.tools;
                            [
                                "zoom",
                                "zoomin",
                                "zoomout",
                                "selection",
                                "pan",
                                "reset"
                            ].forEach(function(t) {
                                u[t] = !1;
                            });
                        }
                        a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                    }
                    a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(t) {
                        t.method(t.params, !1, t.context);
                    }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                window.removeEventListener("resize", this.windowResizeHandler), function(t, e) {
                    var i = $e4b487e979d7c06d$var$ds.get(e);
                    i && (i.disconnect(), $e4b487e979d7c06d$var$ds.delete(e));
                }(this.el.parentNode, this.parentResizeHandler);
                var t = this.w.config.chart.id;
                t && Apex._chartInstances.forEach(function(e, i) {
                    e.id === $e4b487e979d7c06d$var$v.escapeString(t) && Apex._chartInstances.splice(i, 1);
                }), new $e4b487e979d7c06d$var$cs(this.ctx).clear({
                    isUpdating: !1
                });
            }
        },
        {
            key: "updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], n = this.w;
                return n.globals.selection = void 0, this.lastUpdateOptions && JSON.stringify(this.lastUpdateOptions) === JSON.stringify(t) ? this : (this.lastUpdateOptions = $e4b487e979d7c06d$var$v.clone(t), t.series && (this.series.resetSeries(!1, !0, !1), t.series.length && t.series[0].data && (t.series = t.series.map(function(t, i) {
                    return e.updateHelpers._extendSeries(t, i);
                })), this.updateHelpers.revertDefaultAxisMinMax()), t.xaxis && (t = this.updateHelpers.forceXAxisUpdate(t)), t.yaxis && (t = this.updateHelpers.forceYAxisUpdate(t)), n.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), t.theme && (t = this.theme.updateThemeOptions(t)), this.updateHelpers._updateOptions(t, i, a, s, r));
            }
        },
        {
            key: "updateSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(t, e, i);
            }
        },
        {
            key: "appendSeries",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w.config.series.slice();
                return a.push(t), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, e, i);
            }
        },
        {
            key: "appendData",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this;
                i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (null !== t[s] && void 0 !== t[s]) for(var r = 0; r < t[s].data.length; r++)a[s].data.push(t[s].data[r]);
                return i.w.config.series = a, e && (i.w.globals.initialSeries = $e4b487e979d7c06d$var$v.clone(i.w.config.series)), this.update();
            }
        },
        {
            key: "update",
            value: function(t) {
                var e = this;
                return new Promise(function(i, a) {
                    if (e.lastUpdateOptions && JSON.stringify(e.lastUpdateOptions) === JSON.stringify(t)) return i(e);
                    e.lastUpdateOptions = $e4b487e979d7c06d$var$v.clone(t), new $e4b487e979d7c06d$var$cs(e.ctx).clear({
                        isUpdating: !0
                    });
                    var s = e.create(e.w.config.series, t);
                    if (!s) return i(e);
                    e.mount(s).then(function() {
                        "function" == typeof e.w.config.chart.events.updated && e.w.config.chart.events.updated(e, e.w), e.events.fireEvent("updated", [
                            e,
                            e.w
                        ]), e.w.globals.isDirty = !0, i(e);
                    }).catch(function(t) {
                        a(t);
                    });
                });
            }
        },
        {
            key: "getSyncedCharts",
            value: function() {
                var t = this.getGroupedCharts(), e = [
                    this
                ];
                return t.length && (e = [], t.forEach(function(t) {
                    e.push(t);
                })), e;
            }
        },
        {
            key: "getGroupedCharts",
            value: function() {
                var t = this;
                return Apex._chartInstances.filter(function(t) {
                    if (t.group) return !0;
                }).map(function(e) {
                    return t.w.config.chart.group === e.group ? e.chart : t;
                });
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                return this.series.toggleSeries(t);
            }
        },
        {
            key: "highlightSeriesOnLegendHover",
            value: function(t, e) {
                return this.series.toggleSeriesOnHover(t, e);
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                this.series.showSeries(t);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                this.series.hideSeries(t);
            }
        },
        {
            key: "highlightSeries",
            value: function(t) {
                this.series.highlightSeries(t);
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                this.series.isSeriesHidden(t);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.series.resetSeries(t, e);
            }
        },
        {
            key: "addEventListener",
            value: function(t, e) {
                this.events.addEventListener(t, e);
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                this.events.removeEventListener(t, e);
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addXaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addYaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addPointAnnotationExternal(t, e, a);
            }
        },
        {
            key: "clearAnnotations",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, e = this;
                t && (e = t), e.annotations.clearAnnotations(e);
            }
        },
        {
            key: "removeAnnotation",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = this;
                e && (i = e), i.annotations.removeAnnotation(i, t);
            }
        },
        {
            key: "getChartArea",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
            }
        },
        {
            key: "getSeriesTotalXRange",
            value: function(t, e) {
                return this.coreUtils.getSeriesTotalsXRange(t, e);
            }
        },
        {
            key: "getHighestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new $e4b487e979d7c06d$var$ea(this.ctx).getMinYMaxY(t).highestY;
            }
        },
        {
            key: "getLowestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
                return new $e4b487e979d7c06d$var$ea(this.ctx).getMinYMaxY(t).lowestY;
            }
        },
        {
            key: "getSeriesTotal",
            value: function() {
                return this.w.globals.seriesTotals;
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                return this.updateHelpers.toggleDataPointSelection(t, e);
            }
        },
        {
            key: "zoomX",
            value: function(t, e) {
                this.ctx.toolbar.zoomUpdateOptions(t, e);
            }
        },
        {
            key: "setLocale",
            value: function(t) {
                this.localization.setCurrentLocaleValues(t);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                return new $e4b487e979d7c06d$var$Ji(this.ctx).dataURI(t);
            }
        },
        {
            key: "getSvgString",
            value: function(t) {
                return new $e4b487e979d7c06d$var$Ji(this.ctx).getSvgString(t);
            }
        },
        {
            key: "exportToCSV",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return new $e4b487e979d7c06d$var$Ji(this.ctx).exportToCSV(t);
            }
        },
        {
            key: "paper",
            value: function() {
                return this.w.globals.dom.Paper;
            }
        },
        {
            key: "_parentResizeCallback",
            value: function() {
                this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
            }
        },
        {
            key: "_windowResize",
            value: function() {
                var t = this;
                clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                    t.w.globals.resized = !0, t.w.globals.dataChanged = !1, t.ctx.update();
                }, 150);
            }
        },
        {
            key: "_windowResizeHandler",
            value: function() {
                var t = this.w.config.chart.redrawOnWindowResize;
                "function" == typeof t && (t = t()), t && this._windowResize();
            }
        }
    ], [
        {
            key: "getChartByID",
            value: function(t) {
                var e = $e4b487e979d7c06d$var$v.escapeString(t);
                if (Apex._chartInstances) {
                    var i = Apex._chartInstances.filter(function(t) {
                        return t.id === e;
                    })[0];
                    return i && i.chart;
                }
            }
        },
        {
            key: "initOnLoad",
            value: function() {
                for(var e = document.querySelectorAll("[data-apexcharts]"), i = 0; i < e.length; i++)new t(e[i], JSON.parse(e[i].getAttribute("data-options"))).render();
            }
        },
        {
            key: "exec",
            value: function(t, e) {
                var i = this.getChartByID(t);
                if (i) {
                    i.w.globals.isExecCalled = !0;
                    var a = null;
                    if (-1 !== i.publicMethods.indexOf(e)) {
                        for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), n = 2; n < s; n++)r[n - 2] = arguments[n];
                        a = i[e].apply(i, r);
                    }
                    return a;
                }
            }
        },
        {
            key: "merge",
            value: function(t, e) {
                return $e4b487e979d7c06d$var$v.extend(t, e);
            }
        }
    ]), t;
}();


// packages/collapse/src/index.js
function $21b57f0df60ff3c3$export$ec45920981e0ca9b(Alpine) {
    Alpine.directive("collapse", collapse);
    collapse.inline = (el, { modifiers: modifiers })=>{
        if (!modifiers.includes("min")) return;
        el._x_doShow = ()=>{};
        el._x_doHide = ()=>{};
    };
    function collapse(el, { modifiers: modifiers }) {
        let duration = $21b57f0df60ff3c3$var$modifierValue(modifiers, "duration", 250) / 1e3;
        let floor = $21b57f0df60ff3c3$var$modifierValue(modifiers, "min", 0);
        let fullyHide = !modifiers.includes("min");
        if (!el._x_isShown) el.style.height = `${floor}px`;
        if (!el._x_isShown && fullyHide) el.hidden = true;
        if (!el._x_isShown) el.style.overflow = "hidden";
        let setFunction = (el2, styles)=>{
            let revertFunction = Alpine.setStyles(el2, styles);
            return styles.height ? ()=>{} : revertFunction;
        };
        let transitionStyles = {
            transitionProperty: "height",
            transitionDuration: `${duration}s`,
            transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)"
        };
        el._x_transition = {
            in (before = ()=>{}, after = ()=>{}) {
                if (fullyHide) el.hidden = false;
                if (fullyHide) el.style.display = null;
                let current = el.getBoundingClientRect().height;
                el.style.height = "auto";
                let full = el.getBoundingClientRect().height;
                if (current === full) current = floor;
                Alpine.transition(el, Alpine.setStyles, {
                    during: transitionStyles,
                    start: {
                        height: current + "px"
                    },
                    end: {
                        height: full + "px"
                    }
                }, ()=>el._x_isShown = true, ()=>{
                    if (Math.abs(el.getBoundingClientRect().height - full) < 1) el.style.overflow = null;
                });
            },
            out (before = ()=>{}, after = ()=>{}) {
                let full = el.getBoundingClientRect().height;
                Alpine.transition(el, setFunction, {
                    during: transitionStyles,
                    start: {
                        height: full + "px"
                    },
                    end: {
                        height: floor + "px"
                    }
                }, ()=>el.style.overflow = "hidden", ()=>{
                    el._x_isShown = false;
                    if (el.style.height == `${floor}px` && fullyHide) {
                        el.style.display = "none";
                        el.hidden = true;
                    }
                });
            }
        };
    }
}
function $21b57f0df60ff3c3$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "duration") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "min") {
        let match = rawValue.match(/([0-9]+)px/);
        if (match) return match[1];
    }
    return rawValue;
}
// packages/collapse/builds/module.js
var $21b57f0df60ff3c3$export$2e2bcd8739ae039 = $21b57f0df60ff3c3$export$ec45920981e0ca9b;



var $ojnWK = parcelRequire("ojnWK");
// packages/intersect/src/index.js
function $d09a060543d6a2e2$export$1f4807a235930d45(Alpine) {
    Alpine.directive("intersect", Alpine.skipDuringClone((el, { value: value, expression: expression, modifiers: modifiers }, { evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let evaluate = evaluateLater(expression);
        let options = {
            rootMargin: $d09a060543d6a2e2$var$getRootMargin(modifiers),
            threshold: $d09a060543d6a2e2$var$getThreshold(modifiers)
        };
        let observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting === (value === "leave")) return;
                evaluate();
                modifiers.includes("once") && observer.disconnect();
            });
        }, options);
        observer.observe(el);
        cleanup(()=>{
            observer.disconnect();
        });
    }));
}
function $d09a060543d6a2e2$var$getThreshold(modifiers) {
    if (modifiers.includes("full")) return 0.99;
    if (modifiers.includes("half")) return 0.5;
    if (!modifiers.includes("threshold")) return 0;
    let threshold = modifiers[modifiers.indexOf("threshold") + 1];
    if (threshold === "100") return 1;
    if (threshold === "0") return 0;
    return Number(`.${threshold}`);
}
function $d09a060543d6a2e2$var$getLengthValue(rawValue) {
    let match = rawValue.match(/^(-?[0-9]+)(px|%)?$/);
    return match ? match[1] + (match[2] || "px") : void 0;
}
function $d09a060543d6a2e2$var$getRootMargin(modifiers) {
    const key = "margin";
    const fallback = "0px 0px 0px 0px";
    const index = modifiers.indexOf(key);
    if (index === -1) return fallback;
    let values = [];
    for(let i = 1; i < 5; i++)values.push($d09a060543d6a2e2$var$getLengthValue(modifiers[index + i] || ""));
    values = values.filter((v)=>v !== void 0);
    return values.length ? values.join(" ").trim() : fallback;
}
// packages/intersect/builds/module.js
var $d09a060543d6a2e2$export$2e2bcd8739ae039 = $d09a060543d6a2e2$export$1f4807a235930d45;


// packages/mask/src/index.js
function $cf417a97d74b93bb$export$d99f0801a68bbcf1(Alpine) {
    Alpine.directive("mask", (el, { value: value, expression: expression }, { effect: effect, evaluateLater: evaluateLater, cleanup: cleanup })=>{
        let templateFn = ()=>expression;
        let lastInputValue = "";
        queueMicrotask(()=>{
            if ([
                "function",
                "dynamic"
            ].includes(value)) {
                let evaluator = evaluateLater(expression);
                effect(()=>{
                    templateFn = (input)=>{
                        let result;
                        Alpine.dontAutoEvaluateFunctions(()=>{
                            evaluator((value2)=>{
                                result = typeof value2 === "function" ? value2(input) : value2;
                            }, {
                                scope: {
                                    // These are "magics" we'll make available to the x-mask:function:
                                    "$input": input,
                                    "$money": $cf417a97d74b93bb$var$formatMoney.bind({
                                        el: el
                                    })
                                }
                            });
                        });
                        return result;
                    };
                    processInputValue(el, false);
                });
            } else processInputValue(el, false);
            if (el._x_model) {
                if (el._x_model.get() === el.value) return;
                if (el._x_model.get() === null && el.value === "") return;
                el._x_model.set(el.value);
            }
        });
        const controller = new AbortController();
        cleanup(()=>{
            controller.abort();
        });
        el.addEventListener("input", ()=>processInputValue(el), {
            signal: controller.signal,
            // Setting this as a capture phase listener to ensure it runs
            // before wire:model or x-model added as a latent binding...
            capture: true
        });
        el.addEventListener("blur", ()=>processInputValue(el, false), {
            signal: controller.signal
        });
        function processInputValue(el2, shouldRestoreCursor = true) {
            let input = el2.value;
            let template = templateFn(input);
            if (!template || template === "false") return false;
            if (lastInputValue.length - el2.value.length === 1) return lastInputValue = el2.value;
            let setInput = ()=>{
                lastInputValue = el2.value = formatInput(input, template);
            };
            if (shouldRestoreCursor) $cf417a97d74b93bb$var$restoreCursorPosition(el2, template, ()=>{
                setInput();
            });
            else setInput();
        }
        function formatInput(input, template) {
            if (input === "") return "";
            let strippedDownInput = $cf417a97d74b93bb$export$bb0fb8c0cad50b07(template, input);
            let rebuiltInput = $cf417a97d74b93bb$var$buildUp(template, strippedDownInput);
            return rebuiltInput;
        }
    }).before("model");
}
function $cf417a97d74b93bb$var$restoreCursorPosition(el, template, callback) {
    let cursorPosition = el.selectionStart;
    let unformattedValue = el.value;
    callback();
    let beforeLeftOfCursorBeforeFormatting = unformattedValue.slice(0, cursorPosition);
    let newPosition = $cf417a97d74b93bb$var$buildUp(template, $cf417a97d74b93bb$export$bb0fb8c0cad50b07(template, beforeLeftOfCursorBeforeFormatting)).length;
    el.setSelectionRange(newPosition, newPosition);
}
function $cf417a97d74b93bb$export$bb0fb8c0cad50b07(template, input) {
    let inputToBeStripped = input;
    let output = "";
    let regexes = {
        "9": /[0-9]/,
        "a": /[a-zA-Z]/,
        "*": /[a-zA-Z0-9]/
    };
    let wildcardTemplate = "";
    for(let i = 0; i < template.length; i++){
        if ([
            "9",
            "a",
            "*"
        ].includes(template[i])) {
            wildcardTemplate += template[i];
            continue;
        }
        for(let j = 0; j < inputToBeStripped.length; j++)if (inputToBeStripped[j] === template[i]) {
            inputToBeStripped = inputToBeStripped.slice(0, j) + inputToBeStripped.slice(j + 1);
            break;
        }
    }
    for(let i = 0; i < wildcardTemplate.length; i++){
        let found = false;
        for(let j = 0; j < inputToBeStripped.length; j++)if (regexes[wildcardTemplate[i]].test(inputToBeStripped[j])) {
            output += inputToBeStripped[j];
            inputToBeStripped = inputToBeStripped.slice(0, j) + inputToBeStripped.slice(j + 1);
            found = true;
            break;
        }
        if (!found) break;
    }
    return output;
}
function $cf417a97d74b93bb$var$buildUp(template, input) {
    let clean = Array.from(input);
    let output = "";
    for(let i = 0; i < template.length; i++){
        if (![
            "9",
            "a",
            "*"
        ].includes(template[i])) {
            output += template[i];
            continue;
        }
        if (clean.length === 0) break;
        output += clean.shift();
    }
    return output;
}
function $cf417a97d74b93bb$var$formatMoney(input, delimiter = ".", thousands, precision = 2) {
    if (input === "-") return "-";
    if (/^\D+$/.test(input)) return "9";
    if (thousands === null || thousands === void 0) thousands = delimiter === "," ? "." : ",";
    let addThousands = (input2, thousands2)=>{
        let output = "";
        let counter = 0;
        for(let i = input2.length - 1; i >= 0; i--){
            if (input2[i] === thousands2) continue;
            if (counter === 3) {
                output = input2[i] + thousands2 + output;
                counter = 0;
            } else output = input2[i] + output;
            counter++;
        }
        return output;
    };
    let minus = input.startsWith("-") ? "-" : "";
    let strippedInput = input.replaceAll(new RegExp(`[^0-9\\${delimiter}]`, "g"), "");
    let template = Array.from({
        length: strippedInput.split(delimiter)[0].length
    }).fill("9").join("");
    template = `${minus}${addThousands(template, thousands)}`;
    if (precision > 0 && input.includes(delimiter)) template += `${delimiter}` + "9".repeat(precision);
    queueMicrotask(()=>{
        if (this.el.value.endsWith(delimiter)) return;
        if (this.el.value[this.el.selectionStart - 1] === delimiter) this.el.setSelectionRange(this.el.selectionStart - 1, this.el.selectionStart - 1);
    });
    return template;
}
// packages/mask/builds/module.js
var $cf417a97d74b93bb$export$2e2bcd8739ae039 = $cf417a97d74b93bb$export$d99f0801a68bbcf1;


// packages/morph/src/morph.js
function $85572a2cec6fb903$var$morph(from, toHtml, options) {
    $85572a2cec6fb903$var$monkeyPatchDomSetAttributeToAllowAtSymbols();
    let fromEl;
    let toEl;
    let key, lookahead, updating, updated, removing, removed, adding, added;
    function assignOptions(options2 = {}) {
        let defaultGetKey = (el)=>el.getAttribute("key");
        let noop = ()=>{};
        updating = options2.updating || noop;
        updated = options2.updated || noop;
        removing = options2.removing || noop;
        removed = options2.removed || noop;
        adding = options2.adding || noop;
        added = options2.added || noop;
        key = options2.key || defaultGetKey;
        lookahead = options2.lookahead || false;
    }
    function patch(from2, to) {
        if (differentElementNamesTypesOrKeys(from2, to)) return swapElements(from2, to);
        let updateChildrenOnly = false;
        let skipChildren = false;
        if ($85572a2cec6fb903$var$shouldSkipChildren(updating, ()=>skipChildren = true, from2, to, ()=>updateChildrenOnly = true)) return;
        if (from2.nodeType === 1 && window.Alpine) {
            window.Alpine.cloneNode(from2, to);
            if (from2._x_teleport && to._x_teleport) patch(from2._x_teleport, to._x_teleport);
        }
        if ($85572a2cec6fb903$var$textOrComment(to)) {
            patchNodeValue(from2, to);
            updated(from2, to);
            return;
        }
        if (!updateChildrenOnly) patchAttributes(from2, to);
        updated(from2, to);
        if (!skipChildren) patchChildren(from2, to);
    }
    function differentElementNamesTypesOrKeys(from2, to) {
        return from2.nodeType != to.nodeType || from2.nodeName != to.nodeName || getKey(from2) != getKey(to);
    }
    function swapElements(from2, to) {
        if ($85572a2cec6fb903$var$shouldSkip(removing, from2)) return;
        let toCloned = to.cloneNode(true);
        if ($85572a2cec6fb903$var$shouldSkip(adding, toCloned)) return;
        from2.replaceWith(toCloned);
        removed(from2);
        added(toCloned);
    }
    function patchNodeValue(from2, to) {
        let value = to.nodeValue;
        if (from2.nodeValue !== value) from2.nodeValue = value;
    }
    function patchAttributes(from2, to) {
        if (from2._x_transitioning) return;
        if (from2._x_isShown && !to._x_isShown) return;
        if (!from2._x_isShown && to._x_isShown) return;
        let domAttributes = Array.from(from2.attributes);
        let toAttributes = Array.from(to.attributes);
        for(let i = domAttributes.length - 1; i >= 0; i--){
            let name = domAttributes[i].name;
            if (!to.hasAttribute(name)) from2.removeAttribute(name);
        }
        for(let i = toAttributes.length - 1; i >= 0; i--){
            let name = toAttributes[i].name;
            let value = toAttributes[i].value;
            if (from2.getAttribute(name) !== value) from2.setAttribute(name, value);
        }
    }
    function patchChildren(from2, to) {
        let fromKeys = keyToMap(from2.children);
        let fromKeyHoldovers = {};
        let currentTo = $85572a2cec6fb903$var$getFirstNode(to);
        let currentFrom = $85572a2cec6fb903$var$getFirstNode(from2);
        while(currentTo){
            $85572a2cec6fb903$var$seedingMatchingId(currentTo, currentFrom);
            let toKey = getKey(currentTo);
            let fromKey = getKey(currentFrom);
            if (!currentFrom) {
                if (toKey && fromKeyHoldovers[toKey]) {
                    let holdover = fromKeyHoldovers[toKey];
                    from2.appendChild(holdover);
                    currentFrom = holdover;
                    fromKey = getKey(currentFrom);
                } else {
                    if (!$85572a2cec6fb903$var$shouldSkip(adding, currentTo)) {
                        let clone = currentTo.cloneNode(true);
                        from2.appendChild(clone);
                        added(clone);
                    }
                    currentTo = $85572a2cec6fb903$var$getNextSibling(to, currentTo);
                    continue;
                }
            }
            let isIf = (node)=>node && node.nodeType === 8 && node.textContent === "[if BLOCK]><![endif]";
            let isEnd = (node)=>node && node.nodeType === 8 && node.textContent === "[if ENDBLOCK]><![endif]";
            if (isIf(currentTo) && isIf(currentFrom)) {
                let nestedIfCount = 0;
                let fromBlockStart = currentFrom;
                while(currentFrom){
                    let next = $85572a2cec6fb903$var$getNextSibling(from2, currentFrom);
                    if (isIf(next)) nestedIfCount++;
                    else if (isEnd(next) && nestedIfCount > 0) nestedIfCount--;
                    else if (isEnd(next) && nestedIfCount === 0) {
                        currentFrom = next;
                        break;
                    }
                    currentFrom = next;
                }
                let fromBlockEnd = currentFrom;
                nestedIfCount = 0;
                let toBlockStart = currentTo;
                while(currentTo){
                    let next = $85572a2cec6fb903$var$getNextSibling(to, currentTo);
                    if (isIf(next)) nestedIfCount++;
                    else if (isEnd(next) && nestedIfCount > 0) nestedIfCount--;
                    else if (isEnd(next) && nestedIfCount === 0) {
                        currentTo = next;
                        break;
                    }
                    currentTo = next;
                }
                let toBlockEnd = currentTo;
                let fromBlock = new $85572a2cec6fb903$var$Block(fromBlockStart, fromBlockEnd);
                let toBlock = new $85572a2cec6fb903$var$Block(toBlockStart, toBlockEnd);
                patchChildren(fromBlock, toBlock);
                continue;
            }
            if (currentFrom.nodeType === 1 && lookahead && !currentFrom.isEqualNode(currentTo)) {
                let nextToElementSibling = $85572a2cec6fb903$var$getNextSibling(to, currentTo);
                let found = false;
                while(!found && nextToElementSibling){
                    if (nextToElementSibling.nodeType === 1 && currentFrom.isEqualNode(nextToElementSibling)) {
                        found = true;
                        currentFrom = addNodeBefore(from2, currentTo, currentFrom);
                        fromKey = getKey(currentFrom);
                    }
                    nextToElementSibling = $85572a2cec6fb903$var$getNextSibling(to, nextToElementSibling);
                }
            }
            if (toKey !== fromKey) {
                if (!toKey && fromKey) {
                    fromKeyHoldovers[fromKey] = currentFrom;
                    currentFrom = addNodeBefore(from2, currentTo, currentFrom);
                    fromKeyHoldovers[fromKey].remove();
                    currentFrom = $85572a2cec6fb903$var$getNextSibling(from2, currentFrom);
                    currentTo = $85572a2cec6fb903$var$getNextSibling(to, currentTo);
                    continue;
                }
                if (toKey && !fromKey) {
                    if (fromKeys[toKey]) {
                        currentFrom.replaceWith(fromKeys[toKey]);
                        currentFrom = fromKeys[toKey];
                        fromKey = getKey(currentFrom);
                    }
                }
                if (toKey && fromKey) {
                    let fromKeyNode = fromKeys[toKey];
                    if (fromKeyNode) {
                        fromKeyHoldovers[fromKey] = currentFrom;
                        currentFrom.replaceWith(fromKeyNode);
                        currentFrom = fromKeyNode;
                        fromKey = getKey(currentFrom);
                    } else {
                        fromKeyHoldovers[fromKey] = currentFrom;
                        currentFrom = addNodeBefore(from2, currentTo, currentFrom);
                        fromKeyHoldovers[fromKey].remove();
                        currentFrom = $85572a2cec6fb903$var$getNextSibling(from2, currentFrom);
                        currentTo = $85572a2cec6fb903$var$getNextSibling(to, currentTo);
                        continue;
                    }
                }
            }
            let currentFromNext = currentFrom && $85572a2cec6fb903$var$getNextSibling(from2, currentFrom);
            patch(currentFrom, currentTo);
            currentTo = currentTo && $85572a2cec6fb903$var$getNextSibling(to, currentTo);
            currentFrom = currentFromNext;
        }
        let removals = [];
        while(currentFrom){
            if (!$85572a2cec6fb903$var$shouldSkip(removing, currentFrom)) removals.push(currentFrom);
            currentFrom = $85572a2cec6fb903$var$getNextSibling(from2, currentFrom);
        }
        while(removals.length){
            let domForRemoval = removals.shift();
            domForRemoval.remove();
            removed(domForRemoval);
        }
    }
    function getKey(el) {
        return el && el.nodeType === 1 && key(el);
    }
    function keyToMap(els) {
        let map = {};
        for (let el of els){
            let theKey = getKey(el);
            if (theKey) map[theKey] = el;
        }
        return map;
    }
    function addNodeBefore(parent, node, beforeMe) {
        if (!$85572a2cec6fb903$var$shouldSkip(adding, node)) {
            let clone = node.cloneNode(true);
            parent.insertBefore(clone, beforeMe);
            added(clone);
            return clone;
        }
        return node;
    }
    assignOptions(options);
    fromEl = from;
    toEl = typeof toHtml === "string" ? $85572a2cec6fb903$var$createElement(toHtml) : toHtml;
    if (window.Alpine && window.Alpine.closestDataStack && !from._x_dataStack) {
        toEl._x_dataStack = window.Alpine.closestDataStack(from);
        toEl._x_dataStack && window.Alpine.cloneNode(from, toEl);
    }
    patch(from, toEl);
    fromEl = void 0;
    toEl = void 0;
    return from;
}
$85572a2cec6fb903$var$morph.step = ()=>{};
$85572a2cec6fb903$var$morph.log = ()=>{};
function $85572a2cec6fb903$var$shouldSkip(hook, ...args) {
    let skip = false;
    hook(...args, ()=>skip = true);
    return skip;
}
function $85572a2cec6fb903$var$shouldSkipChildren(hook, skipChildren, ...args) {
    let skip = false;
    hook(...args, ()=>skip = true, skipChildren);
    return skip;
}
var $85572a2cec6fb903$var$patched = false;
function $85572a2cec6fb903$var$createElement(html) {
    const template = document.createElement("template");
    template.innerHTML = html;
    return template.content.firstElementChild;
}
function $85572a2cec6fb903$var$textOrComment(el) {
    return el.nodeType === 3 || el.nodeType === 8;
}
var $85572a2cec6fb903$var$Block = class {
    constructor(start, end){
        this.startComment = start;
        this.endComment = end;
    }
    get children() {
        let children = [];
        let currentNode = this.startComment.nextSibling;
        while(currentNode && currentNode !== this.endComment){
            children.push(currentNode);
            currentNode = currentNode.nextSibling;
        }
        return children;
    }
    appendChild(child) {
        this.endComment.before(child);
    }
    get firstChild() {
        let first = this.startComment.nextSibling;
        if (first === this.endComment) return;
        return first;
    }
    nextNode(reference) {
        let next = reference.nextSibling;
        if (next === this.endComment) return;
        return next;
    }
    insertBefore(newNode, reference) {
        reference.before(newNode);
        return newNode;
    }
};
function $85572a2cec6fb903$var$getFirstNode(parent) {
    return parent.firstChild;
}
function $85572a2cec6fb903$var$getNextSibling(parent, reference) {
    let next;
    if (parent instanceof $85572a2cec6fb903$var$Block) next = parent.nextNode(reference);
    else next = reference.nextSibling;
    return next;
}
function $85572a2cec6fb903$var$monkeyPatchDomSetAttributeToAllowAtSymbols() {
    if ($85572a2cec6fb903$var$patched) return;
    $85572a2cec6fb903$var$patched = true;
    let original = Element.prototype.setAttribute;
    let hostDiv = document.createElement("div");
    Element.prototype.setAttribute = function newSetAttribute(name, value) {
        if (!name.includes("@")) return original.call(this, name, value);
        hostDiv.innerHTML = `<span ${name}="${value}"></span>`;
        let attr = hostDiv.firstElementChild.getAttributeNode(name);
        hostDiv.firstElementChild.removeAttributeNode(attr);
        this.setAttributeNode(attr);
    };
}
function $85572a2cec6fb903$var$seedingMatchingId(to, from) {
    let fromId = from && from._x_bindings && from._x_bindings.id;
    if (!fromId) return;
    if (!to.setAttribute) return;
    to.setAttribute("id", fromId);
    to.id = fromId;
}
// packages/morph/src/index.js
function $85572a2cec6fb903$export$2e5e8c41f5d4e7c7(Alpine) {
    Alpine.morph = $85572a2cec6fb903$var$morph;
}
// packages/morph/builds/module.js
var $85572a2cec6fb903$export$2e2bcd8739ae039 = $85572a2cec6fb903$export$2e5e8c41f5d4e7c7;


// packages/persist/src/index.js
function $dc5e95bf63b2a32e$export$9a6132153fba2e0(Alpine) {
    let persist = ()=>{
        let alias;
        let storage;
        try {
            storage = localStorage;
        } catch (e) {
            console.error(e);
            console.warn("Alpine: $persist is using temporary storage since localStorage is unavailable.");
            let dummy = /* @__PURE__ */ new Map();
            storage = {
                getItem: dummy.get.bind(dummy),
                setItem: dummy.set.bind(dummy)
            };
        }
        return Alpine.interceptor((initialValue, getter, setter, path, key)=>{
            let lookup = alias || `_x_${path}`;
            let initial = $dc5e95bf63b2a32e$var$storageHas(lookup, storage) ? $dc5e95bf63b2a32e$var$storageGet(lookup, storage) : initialValue;
            setter(initial);
            Alpine.effect(()=>{
                let value = getter();
                $dc5e95bf63b2a32e$var$storageSet(lookup, value, storage);
                setter(value);
            });
            return initial;
        }, (func)=>{
            func.as = (key)=>{
                alias = key;
                return func;
            }, func.using = (target)=>{
                storage = target;
                return func;
            };
        });
    };
    Object.defineProperty(Alpine, "$persist", {
        get: ()=>persist()
    });
    Alpine.magic("persist", persist);
    Alpine.persist = (key, { get: get, set: set }, storage = localStorage)=>{
        let initial = $dc5e95bf63b2a32e$var$storageHas(key, storage) ? $dc5e95bf63b2a32e$var$storageGet(key, storage) : get();
        set(initial);
        Alpine.effect(()=>{
            let value = get();
            $dc5e95bf63b2a32e$var$storageSet(key, value, storage);
            set(value);
        });
    };
}
function $dc5e95bf63b2a32e$var$storageHas(key, storage) {
    return storage.getItem(key) !== null;
}
function $dc5e95bf63b2a32e$var$storageGet(key, storage) {
    let value = storage.getItem(key, storage);
    if (value === void 0) return;
    return JSON.parse(value);
}
function $dc5e95bf63b2a32e$var$storageSet(key, value, storage) {
    storage.setItem(key, JSON.stringify(value));
}
// packages/persist/builds/module.js
var $dc5e95bf63b2a32e$export$2e2bcd8739ae039 = $dc5e95bf63b2a32e$export$9a6132153fba2e0;



var $a9mZZ = parcelRequire("a9mZZ");
// packages/ui/src/list-context.js
function $182977f45aac8dca$var$generateContext(Alpine2, multiple, orientation, activateSelectedOrFirst) {
    return {
        /**
     * Main state...
     */ items: [],
        activeKey: $182977f45aac8dca$var$switchboard(),
        orderedKeys: [],
        activatedByKeyPress: false,
        /**
     *  Initialization...
     */ activateSelectedOrFirst: Alpine2.debounce(function() {
            activateSelectedOrFirst(false);
        }),
        registerItemsQueue: [],
        registerItem (key, el, value, disabled) {
            if (this.registerItemsQueue.length === 0) queueMicrotask(()=>{
                if (this.registerItemsQueue.length > 0) {
                    this.items = this.items.concat(this.registerItemsQueue);
                    this.registerItemsQueue = [];
                    this.reorderKeys();
                    this.activateSelectedOrFirst();
                }
            });
            let item = {
                key: key,
                el: el,
                value: value,
                disabled: disabled
            };
            this.registerItemsQueue.push(item);
        },
        unregisterKeysQueue: [],
        unregisterItem (key) {
            if (this.unregisterKeysQueue.length === 0) queueMicrotask(()=>{
                if (this.unregisterKeysQueue.length > 0) {
                    this.items = this.items.filter((i)=>!this.unregisterKeysQueue.includes(i.key));
                    this.orderedKeys = this.orderedKeys.filter((i)=>!this.unregisterKeysQueue.includes(i));
                    this.unregisterKeysQueue = [];
                    this.reorderKeys();
                    this.activateSelectedOrFirst();
                }
            });
            this.unregisterKeysQueue.push(key);
        },
        getItemByKey (key) {
            return this.items.find((i)=>i.key === key);
        },
        getItemByValue (value) {
            return this.items.find((i)=>Alpine2.raw(i.value) === Alpine2.raw(value));
        },
        getItemByEl (el) {
            return this.items.find((i)=>i.el === el);
        },
        getItemsByValues (values) {
            let rawValues = values.map((i)=>Alpine2.raw(i));
            let filteredValue = this.items.filter((i)=>rawValues.includes(Alpine2.raw(i.value)));
            filteredValue = filteredValue.slice().sort((a, b)=>{
                let position = a.el.compareDocumentPosition(b.el);
                if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
                if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
                return 0;
            });
            return filteredValue;
        },
        getActiveItem () {
            if (!this.hasActive()) return null;
            let item = this.items.find((i)=>i.key === this.activeKey.get());
            if (!item) this.deactivateKey(this.activeKey.get());
            return item;
        },
        activateItem (item) {
            if (!item) return;
            this.activateKey(item.key);
        },
        /**
     * Handle elements...
     */ reorderKeys: Alpine2.debounce(function() {
            this.orderedKeys = this.items.map((i)=>i.key);
            this.orderedKeys = this.orderedKeys.slice().sort((a, z)=>{
                if (a === null || z === null) return 0;
                let aEl = this.items.find((i)=>i.key === a).el;
                let zEl = this.items.find((i)=>i.key === z).el;
                let position = aEl.compareDocumentPosition(zEl);
                if (position & Node.DOCUMENT_POSITION_FOLLOWING) return -1;
                if (position & Node.DOCUMENT_POSITION_PRECEDING) return 1;
                return 0;
            });
            if (!this.orderedKeys.includes(this.activeKey.get())) this.deactivateKey(this.activeKey.get());
        }),
        getActiveKey () {
            return this.activeKey.get();
        },
        activeEl () {
            if (!this.activeKey.get()) return;
            return this.items.find((i)=>i.key === this.activeKey.get()).el;
        },
        isActiveEl (el) {
            let key = this.items.find((i)=>i.el === el);
            return this.activeKey.is(key);
        },
        activateEl (el) {
            let item = this.items.find((i)=>i.el === el);
            this.activateKey(item.key);
        },
        isDisabledEl (el) {
            return this.items.find((i)=>i.el === el).disabled;
        },
        get isScrollingTo () {
            return this.scrollingCount > 0;
        },
        scrollingCount: 0,
        activateAndScrollToKey (key, activatedByKeyPress) {
            if (!this.getItemByKey(key)) return;
            this.scrollingCount++;
            this.activateKey(key, activatedByKeyPress);
            let targetEl = this.items.find((i)=>i.key === key).el;
            targetEl.scrollIntoView({
                block: "nearest"
            });
            setTimeout(()=>{
                this.scrollingCount--;
            }, 25);
        },
        /**
     * Handle disabled keys...
     */ isDisabled (key) {
            let item = this.items.find((i)=>i.key === key);
            if (!item) return false;
            return item.disabled;
        },
        get nonDisabledOrderedKeys () {
            return this.orderedKeys.filter((i)=>!this.isDisabled(i));
        },
        /**
     * Handle activated keys...
     */ hasActive () {
            return !!this.activeKey.get();
        },
        /**
     * Return true if the latest active element was activated
     * by the user (i.e. using the arrow keys) and false if was
     * activated automatically by alpine (i.e. first element automatically
     * activated after filtering the list)
     */ wasActivatedByKeyPress () {
            return this.activatedByKeyPress;
        },
        isActiveKey (key) {
            return this.activeKey.is(key);
        },
        activateKey (key, activatedByKeyPress = false) {
            if (this.isDisabled(key)) return;
            this.activeKey.set(key);
            this.activatedByKeyPress = activatedByKeyPress;
        },
        deactivateKey (key) {
            if (this.activeKey.get() === key) {
                this.activeKey.set(null);
                this.activatedByKeyPress = false;
            }
        },
        deactivate () {
            if (!this.activeKey.get()) return;
            if (this.isScrollingTo) return;
            this.activeKey.set(null);
            this.activatedByKeyPress = false;
        },
        /**
     * Handle active key traversal...
     */ nextKey () {
            if (!this.activeKey.get()) return;
            let index = this.nonDisabledOrderedKeys.findIndex((i)=>i === this.activeKey.get());
            return this.nonDisabledOrderedKeys[index + 1];
        },
        prevKey () {
            if (!this.activeKey.get()) return;
            let index = this.nonDisabledOrderedKeys.findIndex((i)=>i === this.activeKey.get());
            return this.nonDisabledOrderedKeys[index - 1];
        },
        firstKey () {
            return this.nonDisabledOrderedKeys[0];
        },
        lastKey () {
            return this.nonDisabledOrderedKeys[this.nonDisabledOrderedKeys.length - 1];
        },
        searchQuery: "",
        clearSearch: Alpine2.debounce(function() {
            this.searchQuery = "";
        }, 350),
        searchKey (query) {
            this.clearSearch();
            this.searchQuery += query;
            let foundKey;
            for(let key in this.items){
                let content = this.items[key].el.textContent.trim().toLowerCase();
                if (content.startsWith(this.searchQuery)) {
                    foundKey = this.items[key].key;
                    break;
                }
            }
            if (!this.nonDisabledOrderedKeys.includes(foundKey)) return;
            return foundKey;
        },
        activateByKeyEvent (e, searchable = false, isOpen = ()=>false, open = ()=>{}, setIsTyping) {
            let targetKey, hasActive;
            setIsTyping(true);
            let activatedByKeyPress = true;
            switch(e.key){
                case [
                    "ArrowDown",
                    "ArrowRight"
                ][orientation === "vertical" ? 0 : 1]:
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    if (!isOpen()) {
                        open();
                        break;
                    }
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = hasActive ? this.nextKey() : this.firstKey();
                    break;
                case [
                    "ArrowUp",
                    "ArrowLeft"
                ][orientation === "vertical" ? 0 : 1]:
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    if (!isOpen()) {
                        open();
                        break;
                    }
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = hasActive ? this.prevKey() : this.lastKey();
                    break;
                case "Home":
                case "PageUp":
                    if (e.key == "Home" && e.shiftKey) return;
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = this.firstKey();
                    break;
                case "End":
                case "PageDown":
                    if (e.key == "End" && e.shiftKey) return;
                    e.preventDefault();
                    e.stopPropagation();
                    setIsTyping(false);
                    this.reorderKeys();
                    hasActive = this.hasActive();
                    targetKey = this.lastKey();
                    break;
                default:
                    activatedByKeyPress = this.activatedByKeyPress;
                    if (searchable && e.key.length === 1) targetKey = this.searchKey(e.key);
                    break;
            }
            if (targetKey) this.activateAndScrollToKey(targetKey, activatedByKeyPress);
        }
    };
}
function $182977f45aac8dca$var$renderHiddenInputs(Alpine2, el, name, value) {
    let newInputs = $182977f45aac8dca$var$generateInputs(name, value);
    newInputs.forEach((i)=>i._x_hiddenInput = true);
    newInputs.forEach((i)=>i._x_ignore = true);
    let children = el.children;
    let oldInputs = [];
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        if (child._x_hiddenInput) oldInputs.push(child);
        else break;
    }
    Alpine2.mutateDom(()=>{
        oldInputs.forEach((i)=>i.remove());
        newInputs.reverse().forEach((i)=>el.prepend(i));
    });
}
function $182977f45aac8dca$var$generateInputs(name, value, carry = []) {
    if ($182977f45aac8dca$var$isObjectOrArray(value)) for(let key in value)carry = carry.concat($182977f45aac8dca$var$generateInputs(`${name}[${key}]`, value[key]));
    else {
        let el = document.createElement("input");
        el.setAttribute("type", "hidden");
        el.setAttribute("name", name);
        el.setAttribute("value", "" + value);
        return [
            el
        ];
    }
    return carry;
}
function $182977f45aac8dca$var$isObjectOrArray(subject) {
    return typeof subject === "object" && subject !== null;
}
function $182977f45aac8dca$var$switchboard(value) {
    let lookup = {};
    let current;
    let changeTracker = Alpine.reactive({
        state: false
    });
    let get = ()=>{
        changeTracker.state;
        return current;
    };
    let set = (newValue)=>{
        if (newValue === current) return;
        if (current !== void 0) lookup[current].state = false;
        current = newValue;
        if (lookup[newValue] === void 0) lookup[newValue] = Alpine.reactive({
            state: true
        });
        else lookup[newValue].state = true;
        changeTracker.state = !changeTracker.state;
    };
    let is = (comparisonValue)=>{
        if (lookup[comparisonValue] === void 0) {
            lookup[comparisonValue] = Alpine.reactive({
                state: false
            });
            return lookup[comparisonValue].state;
        }
        return !!lookup[comparisonValue].state;
    };
    value === void 0 || set(value);
    return {
        get: get,
        set: set,
        is: is
    };
}
// packages/ui/src/combobox.js
function $182977f45aac8dca$var$combobox_default(Alpine2) {
    Alpine2.directive("combobox", (el, directive, { evaluate: evaluate })=>{
        if (directive.value === "input") $182977f45aac8dca$var$handleInput(el, Alpine2);
        else if (directive.value === "button") $182977f45aac8dca$var$handleButton(el, Alpine2);
        else if (directive.value === "label") $182977f45aac8dca$var$handleLabel(el, Alpine2);
        else if (directive.value === "options") $182977f45aac8dca$var$handleOptions(el, Alpine2);
        else if (directive.value === "option") $182977f45aac8dca$var$handleOption(el, Alpine2, directive, evaluate);
        else $182977f45aac8dca$var$handleRoot(el, Alpine2);
    }).before("bind");
    Alpine2.magic("combobox", (el)=>{
        let data = Alpine2.$data(el);
        return {
            get value () {
                return data.__value;
            },
            get isOpen () {
                return data.__isOpen;
            },
            get isDisabled () {
                return data.__isDisabled;
            },
            get activeOption () {
                let active = data.__context?.getActiveItem();
                return active && active.value;
            },
            get activeIndex () {
                let active = data.__context?.getActiveItem();
                if (active) return Object.values(Alpine2.raw(data.__context.items)).findIndex((i)=>Alpine2.raw(active) == Alpine2.raw(i));
                return null;
            }
        };
    });
    Alpine2.magic("comboboxOption", (el)=>{
        let data = Alpine2.$data(el);
        let optionEl = Alpine2.findClosest(el, (i)=>{
            return i.hasAttribute("x-combobox:option");
        });
        if (!optionEl) throw "No x-combobox:option directive found...";
        return {
            get isActive () {
                return data.__context.isActiveKey(Alpine2.$data(optionEl).__optionKey);
            },
            get isSelected () {
                return data.__isSelected(optionEl);
            },
            get isDisabled () {
                return data.__context.isDisabled(Alpine2.$data(optionEl).__optionKey);
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-id" () {
            return [
                "alpine-combobox-button",
                "alpine-combobox-options",
                "alpine-combobox-label"
            ];
        },
        "x-modelable": "__value",
        // Initialize...
        "x-data" () {
            return {
                /**
         * Combobox state...
         */ __ready: false,
                __value: null,
                __isOpen: false,
                __context: void 0,
                __isMultiple: void 0,
                __isStatic: false,
                __isDisabled: void 0,
                __displayValue: void 0,
                __compareBy: null,
                __inputName: null,
                __isTyping: false,
                __hold: false,
                /**
         * Combobox initialization...
         */ init () {
                    this.__isMultiple = Alpine2.extractProp(el, "multiple", false);
                    this.__isDisabled = Alpine2.extractProp(el, "disabled", false);
                    this.__inputName = Alpine2.extractProp(el, "name", null);
                    this.__nullable = Alpine2.extractProp(el, "nullable", false);
                    this.__compareBy = Alpine2.extractProp(el, "by");
                    this.__context = $182977f45aac8dca$var$generateContext(Alpine2, this.__isMultiple, "vertical", ()=>this.__activateSelectedOrFirst());
                    let defaultValue = Alpine2.extractProp(el, "default-value", this.__isMultiple ? [] : null);
                    this.__value = defaultValue;
                    queueMicrotask(()=>{
                        Alpine2.effect(()=>{
                            this.__inputName && $182977f45aac8dca$var$renderHiddenInputs(Alpine2, this.$el, this.__inputName, this.__value);
                        });
                        Alpine2.effect(()=>!this.__isMultiple && this.__resetInput());
                    });
                },
                __startTyping () {
                    this.__isTyping = true;
                },
                __stopTyping () {
                    this.__isTyping = false;
                },
                __resetInput () {
                    let input = this.$refs.__input;
                    if (!input) return;
                    let value = this.__getCurrentValue();
                    input.value = value;
                },
                __getCurrentValue () {
                    if (!this.$refs.__input) return "";
                    if (!this.__value) return "";
                    if (this.__displayValue) return this.__displayValue(this.__value);
                    if (typeof this.__value === "string") return this.__value;
                    return "";
                },
                __open () {
                    if (this.__isOpen) return;
                    this.__isOpen = true;
                    let input = this.$refs.__input;
                    if (input) {
                        let value = input.value;
                        let { selectionStart: selectionStart, selectionEnd: selectionEnd, selectionDirection: selectionDirection } = input;
                        input.value = "";
                        input.dispatchEvent(new Event("change"));
                        input.value = value;
                        if (selectionDirection !== null) input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
                        else input.setSelectionRange(selectionStart, selectionEnd);
                    }
                    let nextTick = (callback)=>requestAnimationFrame(()=>requestAnimationFrame(callback));
                    nextTick(()=>{
                        this.$refs.__input.focus({
                            preventScroll: true
                        });
                        this.__activateSelectedOrFirst();
                    });
                },
                __close () {
                    this.__isOpen = false;
                    this.__context.deactivate();
                },
                __activateSelectedOrFirst (activateSelected = true) {
                    if (!this.__isOpen) return;
                    if (this.__context.hasActive() && this.__context.wasActivatedByKeyPress()) return;
                    let firstSelectedValue;
                    if (this.__isMultiple) {
                        let selectedItem = this.__context.getItemsByValues(this.__value);
                        firstSelectedValue = selectedItem.length ? selectedItem[0].value : null;
                    } else firstSelectedValue = this.__value;
                    let firstSelected = null;
                    if (activateSelected && firstSelectedValue) firstSelected = this.__context.getItemByValue(firstSelectedValue);
                    if (firstSelected) {
                        this.__context.activateAndScrollToKey(firstSelected.key);
                        return;
                    }
                    this.__context.activateAndScrollToKey(this.__context.firstKey());
                },
                __selectActive () {
                    let active = this.__context.getActiveItem();
                    if (active) this.__toggleSelected(active.value);
                },
                __selectOption (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (item) this.__toggleSelected(item.value);
                },
                __isSelected (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (!item) return false;
                    if (item.value === null || item.value === void 0) return false;
                    return this.__hasSelected(item.value);
                },
                __toggleSelected (value) {
                    if (!this.__isMultiple) {
                        this.__value = value;
                        return;
                    }
                    let index = this.__value.findIndex((j)=>this.__compare(j, value));
                    if (index === -1) this.__value.push(value);
                    else this.__value.splice(index, 1);
                },
                __hasSelected (value) {
                    if (!this.__isMultiple) return this.__compare(this.__value, value);
                    return this.__value.some((i)=>this.__compare(i, value));
                },
                __compare (a, b) {
                    let by = this.__compareBy;
                    if (!by) by = (a2, b2)=>Alpine2.raw(a2) === Alpine2.raw(b2);
                    if (typeof by === "string") {
                        let property = by;
                        by = (a2, b2)=>{
                            if (!a2 || typeof a2 !== "object" || !b2 || typeof b2 !== "object") return Alpine2.raw(a2) === Alpine2.raw(b2);
                            return a2[property] === b2[property];
                        };
                    }
                    return by(a, b);
                }
            };
        },
        // Register event listeners..
        "@mousedown.window" (e) {
            if (!!!this.$refs.__input.contains(e.target) && !this.$refs.__button.contains(e.target) && !this.$refs.__options.contains(e.target)) {
                this.__close();
                this.__resetInput();
            }
        }
    });
}
function $182977f45aac8dca$var$handleInput(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__input",
        ":id" () {
            return this.$id("alpine-combobox-input");
        },
        // Accessibility attributes...
        "role": "combobox",
        "tabindex": "0",
        "aria-autocomplete": "list",
        // We need to defer this evaluation a bit because $refs that get declared later
        // in the DOM aren't available yet when x-ref is the result of an Alpine.bind object.
        async ":aria-controls" () {
            return await $182977f45aac8dca$var$microtask(()=>this.$refs.__options && this.$refs.__options.id);
        },
        ":aria-expanded" () {
            return this.$data.__isDisabled ? void 0 : this.$data.__isOpen;
        },
        ":aria-multiselectable" () {
            return this.$data.__isMultiple ? true : void 0;
        },
        ":aria-activedescendant" () {
            if (!this.$data.__context.hasActive()) return;
            let active = this.$data.__context.getActiveItem();
            return active ? active.el.id : null;
        },
        ":aria-labelledby" () {
            return this.$refs.__label ? this.$refs.__label.id : this.$refs.__button ? this.$refs.__button.id : null;
        },
        // Initialize...
        "x-init" () {
            let displayValueFn = Alpine2.extractProp(this.$el, "display-value");
            if (displayValueFn) this.$data.__displayValue = displayValueFn;
        },
        // Register listeners...
        "@input.stop" (e) {
            if (this.$data.__isTyping) {
                this.$data.__open();
                this.$dispatch("change");
            }
        },
        "@blur" () {
            this.$data.__stopTyping(false);
        },
        "@keydown" (e) {
            queueMicrotask(()=>this.$data.__context.activateByKeyEvent(e, false, ()=>this.$data.__isOpen, ()=>this.$data.__open(), (state)=>this.$data.__isTyping = state));
        },
        "@keydown.enter.prevent.stop" () {
            this.$data.__selectActive();
            this.$data.__stopTyping();
            if (!this.$data.__isMultiple) {
                this.$data.__close();
                this.$data.__resetInput();
            }
        },
        "@keydown.escape.prevent" (e) {
            if (!this.$data.__static) e.stopPropagation();
            this.$data.__stopTyping();
            this.$data.__close();
            this.$data.__resetInput();
        },
        "@keydown.tab" () {
            this.$data.__stopTyping();
            if (this.$data.__isOpen) this.$data.__close();
            this.$data.__resetInput();
        },
        "@keydown.backspace" (e) {
            if (this.$data.__isMultiple) return;
            if (!this.$data.__nullable) return;
            let input = e.target;
            requestAnimationFrame(()=>{
                if (input.value === "") {
                    this.$data.__value = null;
                    let options = this.$refs.__options;
                    if (options) options.scrollTop = 0;
                    this.$data.__context.deactivate();
                }
            });
        }
    });
}
function $182977f45aac8dca$var$handleButton(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__button",
        ":id" () {
            return this.$id("alpine-combobox-button");
        },
        // Accessibility attributes...
        "aria-haspopup": "true",
        // We need to defer this evaluation a bit because $refs that get declared later
        // in the DOM aren't available yet when x-ref is the result of an Alpine.bind object.
        async ":aria-controls" () {
            return await $182977f45aac8dca$var$microtask(()=>this.$refs.__options && this.$refs.__options.id);
        },
        ":aria-labelledby" () {
            return this.$refs.__label ? [
                this.$refs.__label.id,
                this.$el.id
            ].join(" ") : null;
        },
        ":aria-expanded" () {
            return this.$data.__isDisabled ? null : this.$data.__isOpen;
        },
        ":disabled" () {
            return this.$data.__isDisabled;
        },
        "tabindex": "-1",
        // Initialize....
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        // Register listeners...
        "@click" (e) {
            if (this.$data.__isDisabled) return;
            if (this.$data.__isOpen) {
                this.$data.__close();
                this.$data.__resetInput();
            } else {
                e.preventDefault();
                this.$data.__open();
            }
            this.$nextTick(()=>this.$refs.__input.focus({
                    preventScroll: true
                }));
        }
    });
}
function $182977f45aac8dca$var$handleLabel(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__label",
        ":id" () {
            return this.$id("alpine-combobox-label");
        },
        "@click" () {
            this.$refs.__input.focus({
                preventScroll: true
            });
        }
    });
}
function $182977f45aac8dca$var$handleOptions(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__options",
        ":id" () {
            return this.$id("alpine-combobox-options");
        },
        // Accessibility attributes...
        "role": "listbox",
        ":aria-labelledby" () {
            return this.$refs.__label ? this.$refs.__label.id : this.$refs.__button ? this.$refs.__button.id : null;
        },
        // Initialize...
        "x-init" () {
            this.$data.__isStatic = Alpine2.bound(this.$el, "static", false);
            if (Alpine2.bound(this.$el, "hold")) this.$data.__hold = true;
        },
        "x-show" () {
            return this.$data.__isStatic ? true : this.$data.__isOpen;
        }
    });
}
function $182977f45aac8dca$var$handleOption(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-id" () {
            return [
                "alpine-combobox-option"
            ];
        },
        ":id" () {
            return this.$id("alpine-combobox-option");
        },
        // Accessibility attributes...
        "role": "option",
        ":tabindex" () {
            return this.$comboboxOption.isDisabled ? void 0 : "-1";
        },
        // Only the active element should have aria-selected="true"...
        "x-effect" () {
            this.$comboboxOption.isSelected ? el.setAttribute("aria-selected", true) : el.setAttribute("aria-selected", false);
        },
        ":aria-disabled" () {
            return this.$comboboxOption.isDisabled;
        },
        // Initialize...
        "x-data" () {
            return {
                "__optionKey": null,
                init () {
                    this.__optionKey = (Math.random() + 1).toString(36).substring(7);
                    let value = Alpine2.extractProp(this.$el, "value");
                    let disabled = Alpine2.extractProp(this.$el, "disabled", false, false);
                    this.__context.registerItem(this.__optionKey, this.$el, value, disabled);
                },
                destroy () {
                    this.__context.unregisterItem(this.__optionKey);
                }
            };
        },
        // Register listeners...
        "@click" () {
            if (this.$comboboxOption.isDisabled) return;
            this.__selectOption(this.$el);
            if (!this.__isMultiple) {
                this.__close();
                this.__resetInput();
            }
            this.$nextTick(()=>this.$refs.__input.focus({
                    preventScroll: true
                }));
        },
        "@mouseenter" (e) {
            this.__context.activateEl(this.$el);
        },
        "@mousemove" (e) {
            if (this.__context.isActiveEl(this.$el)) return;
            this.__context.activateEl(this.$el);
        },
        "@mouseleave" (e) {
            if (this.__hold) return;
            this.__context.deactivate();
        }
    });
}
function $182977f45aac8dca$var$microtask(callback) {
    return new Promise((resolve)=>queueMicrotask(()=>resolve(callback())));
}
// packages/ui/src/dialog.js
function $182977f45aac8dca$var$dialog_default(Alpine2) {
    Alpine2.directive("dialog", (el, directive)=>{
        if (directive.value === "overlay") $182977f45aac8dca$var$handleOverlay(el, Alpine2);
        else if (directive.value === "panel") $182977f45aac8dca$var$handlePanel(el, Alpine2);
        else if (directive.value === "title") $182977f45aac8dca$var$handleTitle(el, Alpine2);
        else if (directive.value === "description") $182977f45aac8dca$var$handleDescription(el, Alpine2);
        else $182977f45aac8dca$var$handleRoot2(el, Alpine2);
    });
    Alpine2.magic("dialog", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            // Kept here for legacy. Remove after out of beta.
            get open () {
                return $data.__isOpen;
            },
            get isOpen () {
                return $data.__isOpen;
            },
            close () {
                $data.__close();
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-data" () {
            return {
                init () {
                    Alpine2.bound(el, "open") !== void 0 && Alpine2.effect(()=>{
                        this.__isOpenState = Alpine2.bound(el, "open");
                    });
                    if (Alpine2.bound(el, "initial-focus") !== void 0) this.$watch("__isOpenState", ()=>{
                        if (!this.__isOpenState) return;
                        setTimeout(()=>{
                            Alpine2.bound(el, "initial-focus").focus();
                        }, 0);
                    });
                },
                __isOpenState: false,
                __close () {
                    if (Alpine2.bound(el, "open")) this.$dispatch("close");
                    else this.__isOpenState = false;
                },
                get __isOpen () {
                    return Alpine2.bound(el, "static", this.__isOpenState);
                }
            };
        },
        "x-modelable": "__isOpenState",
        "x-id" () {
            return [
                "alpine-dialog-title",
                "alpine-dialog-description"
            ];
        },
        "x-show" () {
            return this.__isOpen;
        },
        "x-trap.inert.noscroll" () {
            return this.__isOpen;
        },
        "@keydown.escape" () {
            this.__close();
        },
        ":aria-labelledby" () {
            return this.$id("alpine-dialog-title");
        },
        ":aria-describedby" () {
            return this.$id("alpine-dialog-description");
        },
        "role": "dialog",
        "aria-modal": "true"
    });
}
function $182977f45aac8dca$var$handleOverlay(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$data.__isOpen === void 0) console.warn('"x-dialog:overlay" is missing a parent element with "x-dialog".');
        },
        "x-show" () {
            return this.__isOpen;
        },
        "@click.prevent.stop" () {
            this.$data.__close();
        }
    });
}
function $182977f45aac8dca$var$handlePanel(el, Alpine2) {
    Alpine2.bind(el, {
        "@click.outside" () {
            this.$data.__close();
        },
        "x-show" () {
            return this.$data.__isOpen;
        }
    });
}
function $182977f45aac8dca$var$handleTitle(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$data.__isOpen === void 0) console.warn('"x-dialog:title" is missing a parent element with "x-dialog".');
        },
        ":id" () {
            return this.$id("alpine-dialog-title");
        }
    });
}
function $182977f45aac8dca$var$handleDescription(el, Alpine2) {
    Alpine2.bind(el, {
        ":id" () {
            return this.$id("alpine-dialog-description");
        }
    });
}
// packages/ui/src/disclosure.js
function $182977f45aac8dca$var$disclosure_default(Alpine2) {
    Alpine2.directive("disclosure", (el, directive)=>{
        if (!directive.value) $182977f45aac8dca$var$handleRoot3(el, Alpine2);
        else if (directive.value === "panel") $182977f45aac8dca$var$handlePanel2(el, Alpine2);
        else if (directive.value === "button") $182977f45aac8dca$var$handleButton2(el, Alpine2);
    }).before("bind");
    Alpine2.magic("disclosure", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isOpen () {
                return $data.__isOpen;
            },
            close () {
                $data.__close();
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__isOpen",
        "x-data" () {
            return {
                // The panel will call this...
                // We can't do this inside a microtask in x-init because, when default-open is set to "true",
                // It will cause the panel to transition in for the first time, instead of showing instantly...
                __determineDefaultOpenState () {
                    let defaultIsOpen = Boolean(Alpine2.bound(this.$el, "default-open", false));
                    if (defaultIsOpen) this.__isOpen = defaultIsOpen;
                },
                __isOpen: false,
                __close () {
                    this.__isOpen = false;
                },
                __toggle () {
                    this.__isOpen = !this.__isOpen;
                }
            };
        },
        "x-id" () {
            return [
                "alpine-disclosure-panel"
            ];
        }
    });
}
function $182977f45aac8dca$var$handleButton2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        "@click" () {
            this.$data.__isOpen = !this.$data.__isOpen;
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.$id("alpine-disclosure-panel");
        },
        "@keydown.space.prevent.stop" () {
            this.$data.__toggle();
        },
        "@keydown.enter.prevent.stop" () {
            this.$data.__toggle();
        },
        // Required for firefox, event.preventDefault() in handleKeyDown for
        // the Space key doesn't cancel the handleKeyUp, which in turn
        // triggers a *click*.
        "@keyup.space.prevent" () {}
    });
}
function $182977f45aac8dca$var$handlePanel2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__determineDefaultOpenState();
        },
        "x-show" () {
            return this.$data.__isOpen;
        },
        ":id" () {
            return this.$data.$id("alpine-disclosure-panel");
        }
    });
}
// packages/ui/src/listbox.js
function $182977f45aac8dca$var$listbox_default(Alpine2) {
    Alpine2.directive("listbox", (el, directive)=>{
        if (!directive.value) $182977f45aac8dca$var$handleRoot4(el, Alpine2);
        else if (directive.value === "label") $182977f45aac8dca$var$handleLabel2(el, Alpine2);
        else if (directive.value === "button") $182977f45aac8dca$var$handleButton3(el, Alpine2);
        else if (directive.value === "options") $182977f45aac8dca$var$handleOptions2(el, Alpine2);
        else if (directive.value === "option") $182977f45aac8dca$var$handleOption2(el, Alpine2);
    }).before("bind");
    Alpine2.magic("listbox", (el)=>{
        let data = Alpine2.$data(el);
        return {
            // @deprecated:
            get selected () {
                return data.__value;
            },
            // @deprecated:
            get active () {
                let active = data.__context.getActiveItem();
                return active && active.value;
            },
            get value () {
                return data.__value;
            },
            get isOpen () {
                return data.__isOpen;
            },
            get isDisabled () {
                return data.__isDisabled;
            },
            get activeOption () {
                let active = data.__context.getActiveItem();
                return active && active.value;
            },
            get activeIndex () {
                let active = data.__context.getActiveItem();
                return active && active.key;
            }
        };
    });
    Alpine2.magic("listboxOption", (el)=>{
        let data = Alpine2.$data(el);
        let optionEl = Alpine2.findClosest(el, (i)=>{
            return i.hasAttribute("x-listbox:option");
        });
        if (!optionEl) throw "No x-listbox:option directive found...";
        return {
            get isActive () {
                return data.__context.isActiveKey(Alpine2.$data(optionEl).__optionKey);
            },
            get isSelected () {
                return data.__isSelected(optionEl);
            },
            get isDisabled () {
                return data.__context.isDisabled(Alpine2.$data(optionEl).__optionKey);
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot4(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-id" () {
            return [
                "alpine-listbox-button",
                "alpine-listbox-options",
                "alpine-listbox-label"
            ];
        },
        "x-modelable": "__value",
        // Initialize...
        "x-data" () {
            return {
                /**
         * Listbox state...
         */ __ready: false,
                __value: null,
                __isOpen: false,
                __context: void 0,
                __isMultiple: void 0,
                __isStatic: false,
                __isDisabled: void 0,
                __compareBy: null,
                __inputName: null,
                __orientation: "vertical",
                __hold: false,
                /**
         * Listbox initialization...
         */ init () {
                    this.__isMultiple = Alpine2.extractProp(el, "multiple", false);
                    this.__isDisabled = Alpine2.extractProp(el, "disabled", false);
                    this.__inputName = Alpine2.extractProp(el, "name", null);
                    this.__compareBy = Alpine2.extractProp(el, "by");
                    this.__orientation = Alpine2.extractProp(el, "horizontal", false) ? "horizontal" : "vertical";
                    this.__context = $182977f45aac8dca$var$generateContext(Alpine2, this.__isMultiple, this.__orientation, ()=>this.__activateSelectedOrFirst());
                    let defaultValue = Alpine2.extractProp(el, "default-value", this.__isMultiple ? [] : null);
                    this.__value = defaultValue;
                    queueMicrotask(()=>{
                        Alpine2.effect(()=>{
                            this.__inputName && $182977f45aac8dca$var$renderHiddenInputs(Alpine2, this.$el, this.__inputName, this.__value);
                        });
                        Alpine2.effect(()=>{
                            this.__resetInput();
                        });
                    });
                },
                __resetInput () {
                    let input = this.$refs.__input;
                    if (!input) return;
                    let value = this.$data.__getCurrentValue();
                    input.value = value;
                },
                __getCurrentValue () {
                    if (!this.$refs.__input) return "";
                    if (!this.__value) return "";
                    if (this.$data.__displayValue && this.__value !== void 0) return this.$data.__displayValue(this.__value);
                    if (typeof this.__value === "string") return this.__value;
                    return "";
                },
                __open () {
                    if (this.__isOpen) return;
                    this.__isOpen = true;
                    this.__activateSelectedOrFirst();
                    let nextTick = (callback)=>requestAnimationFrame(()=>requestAnimationFrame(callback));
                    nextTick(()=>this.$refs.__options.focus({
                            preventScroll: true
                        }));
                },
                __close () {
                    this.__isOpen = false;
                    this.__context.deactivate();
                    this.$nextTick(()=>this.$refs.__button.focus({
                            preventScroll: true
                        }));
                },
                __activateSelectedOrFirst (activateSelected = true) {
                    if (!this.__isOpen) return;
                    if (this.__context.getActiveKey()) {
                        this.__context.activateAndScrollToKey(this.__context.getActiveKey());
                        return;
                    }
                    let firstSelectedValue;
                    if (this.__isMultiple) firstSelectedValue = this.__value.find((i)=>{
                        return !!this.__context.getItemByValue(i);
                    });
                    else firstSelectedValue = this.__value;
                    if (activateSelected && firstSelectedValue) {
                        let firstSelected = this.__context.getItemByValue(firstSelectedValue);
                        firstSelected && this.__context.activateAndScrollToKey(firstSelected.key);
                    } else this.__context.activateAndScrollToKey(this.__context.firstKey());
                },
                __selectActive () {
                    let active = this.$data.__context.getActiveItem();
                    if (active) this.__toggleSelected(active.value);
                },
                __selectOption (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (item) this.__toggleSelected(item.value);
                },
                __isSelected (el2) {
                    let item = this.__context.getItemByEl(el2);
                    if (!item) return false;
                    if (item.value === null || item.value === void 0) return false;
                    return this.__hasSelected(item.value);
                },
                __toggleSelected (value) {
                    if (!this.__isMultiple) {
                        this.__value = value;
                        return;
                    }
                    let index = this.__value.findIndex((j)=>this.__compare(j, value));
                    if (index === -1) this.__value.push(value);
                    else this.__value.splice(index, 1);
                },
                __hasSelected (value) {
                    if (!this.__isMultiple) return this.__compare(this.__value, value);
                    return this.__value.some((i)=>this.__compare(i, value));
                },
                __compare (a, b) {
                    let by = this.__compareBy;
                    if (!by) by = (a2, b2)=>Alpine2.raw(a2) === Alpine2.raw(b2);
                    if (typeof by === "string") {
                        let property = by;
                        by = (a2, b2)=>{
                            if (!a2 || typeof a2 !== "object" || !b2 || typeof b2 !== "object") return Alpine2.raw(a2) === Alpine2.raw(b2);
                            return a2[property] === b2[property];
                        };
                    }
                    return by(a, b);
                }
            };
        }
    });
}
function $182977f45aac8dca$var$handleLabel2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__label",
        ":id" () {
            return this.$id("alpine-listbox-label");
        },
        "@click" () {
            this.$refs.__button.focus({
                preventScroll: true
            });
        }
    });
}
function $182977f45aac8dca$var$handleButton3(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__button",
        ":id" () {
            return this.$id("alpine-listbox-button");
        },
        // Accessibility attributes...
        "aria-haspopup": "true",
        ":aria-labelledby" () {
            return this.$id("alpine-listbox-label");
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.__isOpen && this.$id("alpine-listbox-options");
        },
        // Initialize....
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        // Register listeners...
        "@click" () {
            this.$data.__open();
        },
        "@keydown" (e) {
            if ([
                "ArrowDown",
                "ArrowUp",
                "ArrowLeft",
                "ArrowRight"
            ].includes(e.key)) {
                e.stopPropagation();
                e.preventDefault();
                this.$data.__open();
            }
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__open();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__open();
        }
    });
}
function $182977f45aac8dca$var$handleOptions2(el, Alpine2) {
    Alpine2.bind(el, {
        // Setup...
        "x-ref": "__options",
        ":id" () {
            return this.$id("alpine-listbox-options");
        },
        // Accessibility attributes...
        "role": "listbox",
        tabindex: "0",
        ":aria-orientation" () {
            return this.$data.__orientation;
        },
        ":aria-labelledby" () {
            return this.$id("alpine-listbox-button");
        },
        ":aria-activedescendant" () {
            if (!this.$data.__context.hasActive()) return;
            let active = this.$data.__context.getActiveItem();
            return active ? active.el.id : null;
        },
        // Initialize...
        "x-init" () {
            this.$data.__isStatic = Alpine2.extractProp(this.$el, "static", false);
            if (Alpine2.bound(this.$el, "hold")) this.$data.__hold = true;
        },
        "x-show" () {
            return this.$data.__isStatic ? true : this.$data.__isOpen;
        },
        "x-trap" () {
            return this.$data.__isOpen;
        },
        "@click.outside" () {
            this.$data.__close();
        },
        "@keydown.escape.stop.prevent" () {
            this.$data.__close();
        },
        "@focus" () {
            this.$data.__activateSelectedOrFirst();
        },
        "@keydown" (e) {
            queueMicrotask(()=>this.$data.__context.activateByKeyEvent(e, true, ()=>this.$data.__isOpen, ()=>this.$data.__open(), ()=>{}));
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__selectActive();
            this.$data.__isMultiple || this.$data.__close();
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__selectActive();
            this.$data.__isMultiple || this.$data.__close();
        }
    });
}
function $182977f45aac8dca$var$handleOption2(el, Alpine2) {
    Alpine2.bind(el, ()=>{
        return {
            "x-id" () {
                return [
                    "alpine-listbox-option"
                ];
            },
            ":id" () {
                return this.$id("alpine-listbox-option");
            },
            // Accessibility attributes...
            "role": "option",
            ":tabindex" () {
                return this.$listboxOption.isDisabled ? false : "-1";
            },
            ":aria-selected" () {
                return this.$listboxOption.isSelected;
            },
            // Initialize...
            "x-data" () {
                return {
                    "__optionKey": null,
                    init () {
                        this.__optionKey = (Math.random() + 1).toString(36).substring(7);
                        let value = Alpine2.extractProp(el, "value");
                        let disabled = Alpine2.extractProp(el, "disabled", false, false);
                        this.$data.__context.registerItem(this.__optionKey, el, value, disabled);
                    },
                    destroy () {
                        this.$data.__context.unregisterItem(this.__optionKey);
                    }
                };
            },
            // Register listeners...
            "@click" () {
                if (this.$listboxOption.isDisabled) return;
                this.$data.__selectOption(el);
                this.$data.__isMultiple || this.$data.__close();
            },
            "@mouseenter" () {
                this.$data.__context.activateEl(el);
            },
            "@mouseleave" () {
                this.$data.__hold || this.$data.__context.deactivate();
            }
        };
    });
}
// packages/ui/src/popover.js
function $182977f45aac8dca$var$popover_default(Alpine2) {
    Alpine2.directive("popover", (el, directive)=>{
        if (!directive.value) $182977f45aac8dca$var$handleRoot5(el, Alpine2);
        else if (directive.value === "overlay") $182977f45aac8dca$var$handleOverlay2(el, Alpine2);
        else if (directive.value === "button") $182977f45aac8dca$var$handleButton4(el, Alpine2);
        else if (directive.value === "panel") $182977f45aac8dca$var$handlePanel3(el, Alpine2);
        else if (directive.value === "group") $182977f45aac8dca$var$handleGroup(el, Alpine2);
    });
    Alpine2.magic("popover", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isOpen () {
                return $data.__isOpenState;
            },
            open () {
                $data.__open();
            },
            close () {
                $data.__close();
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot5(el, Alpine2) {
    Alpine2.bind(el, {
        "x-id" () {
            return [
                "alpine-popover-button",
                "alpine-popover-panel"
            ];
        },
        "x-modelable": "__isOpenState",
        "x-data" () {
            return {
                init () {
                    if (this.$data.__groupEl) this.$data.__groupEl.addEventListener("__close-others", ({ detail: detail })=>{
                        if (detail.el.isSameNode(this.$el)) return;
                        this.__close(false);
                    });
                },
                __buttonEl: void 0,
                __panelEl: void 0,
                __isStatic: false,
                get __isOpen () {
                    if (this.__isStatic) return true;
                    return this.__isOpenState;
                },
                __isOpenState: false,
                __open () {
                    this.__isOpenState = true;
                    this.$dispatch("__close-others", {
                        el: this.$el
                    });
                },
                __toggle () {
                    this.__isOpenState ? this.__close() : this.__open();
                },
                __close (el2) {
                    if (this.__isStatic) return;
                    this.__isOpenState = false;
                    if (el2 === false) return;
                    el2 = el2 || this.$data.__buttonEl;
                    if (document.activeElement.isSameNode(el2)) return;
                    setTimeout(()=>el2.focus());
                },
                __contains (outer, inner) {
                    return !!Alpine2.findClosest(inner, (el2)=>el2.isSameNode(outer));
                }
            };
        },
        "@keydown.escape.stop.prevent" () {
            this.__close();
        },
        "@focusin.window" () {
            if (this.$data.__groupEl) {
                if (!this.$data.__contains(this.$data.__groupEl, document.activeElement)) this.$data.__close(false);
                return;
            }
            if (!this.$data.__contains(this.$el, document.activeElement)) this.$data.__close(false);
        }
    });
}
function $182977f45aac8dca$var$handleButton4(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "button",
        ":id" () {
            return this.$id("alpine-popover-button");
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.__isOpen && this.$id("alpine-popover-panel");
        },
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
            this.$data.__buttonEl = this.$el;
        },
        "@click" () {
            this.$data.__toggle();
        },
        "@keydown.tab" (e) {
            if (!e.shiftKey && this.$data.__isOpen) {
                let firstFocusableEl = this.$focus.within(this.$data.__panelEl).getFirst();
                if (firstFocusableEl) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.$focus.focus(firstFocusableEl);
                }
            }
        },
        "@keyup.tab" (e) {
            if (this.$data.__isOpen) {
                let lastEl = this.$focus.previouslyFocused();
                if (!lastEl) return;
                if (// Make sure the last focused wasn't part of this popover.
                !this.$data.__buttonEl.contains(lastEl) && !this.$data.__panelEl.contains(lastEl) && lastEl && this.$el.compareDocumentPosition(lastEl) & Node.DOCUMENT_POSITION_FOLLOWING) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.$focus.within(this.$data.__panelEl).last();
                }
            }
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__toggle();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__toggle();
        },
        // This is to stop Firefox from firing a "click".
        "@keyup.space.stop.prevent" () {}
    });
}
function $182977f45aac8dca$var$handlePanel3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__isStatic = Alpine2.bound(this.$el, "static", false);
            this.$data.__panelEl = this.$el;
        },
        "x-effect" () {
            this.$data.__isOpen && Alpine2.bound(el, "focus") && this.$focus.first();
        },
        "x-ref": "panel",
        ":id" () {
            return this.$id("alpine-popover-panel");
        },
        "x-show" () {
            return this.$data.__isOpen;
        },
        "@mousedown.window" ($event) {
            if (!this.$data.__isOpen) return;
            if (this.$data.__contains(this.$data.__buttonEl, $event.target)) return;
            if (this.$data.__contains(this.$el, $event.target)) return;
            if (!this.$focus.focusable($event.target)) this.$data.__close();
        },
        "@keydown.tab" (e) {
            if (e.shiftKey && this.$focus.isFirst(e.target)) {
                e.preventDefault();
                e.stopPropagation();
                Alpine2.bound(el, "focus") ? this.$data.__close() : this.$data.__buttonEl.focus();
            } else if (!e.shiftKey && this.$focus.isLast(e.target)) {
                e.preventDefault();
                e.stopPropagation();
                let els = this.$focus.within(document).all();
                let buttonIdx = els.indexOf(this.$data.__buttonEl);
                let nextEls = els.splice(buttonIdx + 1).filter((el2)=>!this.$el.contains(el2));
                nextEls[0].focus();
                Alpine2.bound(el, "focus") && this.$data.__close(false);
            }
        }
    });
}
function $182977f45aac8dca$var$handleGroup(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "container",
        "x-data" () {
            return {
                __groupEl: this.$el
            };
        }
    });
}
function $182977f45aac8dca$var$handleOverlay2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-show" () {
            return this.$data.__isOpen;
        }
    });
}
// packages/ui/src/menu.js
function $182977f45aac8dca$var$menu_default(Alpine2) {
    Alpine2.directive("menu", (el, directive)=>{
        if (!directive.value) $182977f45aac8dca$var$handleRoot6(el, Alpine2);
        else if (directive.value === "items") $182977f45aac8dca$var$handleItems(el, Alpine2);
        else if (directive.value === "item") $182977f45aac8dca$var$handleItem(el, Alpine2);
        else if (directive.value === "button") $182977f45aac8dca$var$handleButton5(el, Alpine2);
    }).before("bind");
    Alpine2.magic("menuItem", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isActive () {
                return $data.__activeEl == $data.__itemEl;
            },
            get isDisabled () {
                return $data.__itemEl.__isDisabled.value;
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot6(el, Alpine2) {
    Alpine2.bind(el, {
        "x-id" () {
            return [
                "alpine-menu-button",
                "alpine-menu-items"
            ];
        },
        "x-modelable": "__isOpen",
        "x-data" () {
            return {
                __itemEls: [],
                __activeEl: null,
                __isOpen: false,
                __open (activationStrategy) {
                    this.__isOpen = true;
                    let nextTick = (callback)=>requestAnimationFrame(()=>requestAnimationFrame(callback));
                    nextTick(()=>{
                        this.$refs.__items.focus({
                            preventScroll: true
                        });
                        activationStrategy && activationStrategy(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
                    });
                },
                __close (focusAfter = true) {
                    this.__isOpen = false;
                    focusAfter && this.$nextTick(()=>this.$refs.__button.focus({
                            preventScroll: true
                        }));
                },
                __contains (outer, inner) {
                    return !!Alpine2.findClosest(inner, (el2)=>el2.isSameNode(outer));
                }
            };
        },
        "@focusin.window" () {
            if (!this.$data.__contains(this.$el, document.activeElement)) this.$data.__close(false);
        }
    });
}
function $182977f45aac8dca$var$handleButton5(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__button",
        "aria-haspopup": "true",
        ":aria-labelledby" () {
            return this.$id("alpine-menu-label");
        },
        ":id" () {
            return this.$id("alpine-menu-button");
        },
        ":aria-expanded" () {
            return this.$data.__isOpen;
        },
        ":aria-controls" () {
            return this.$data.__isOpen && this.$id("alpine-menu-items");
        },
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        "@click" () {
            this.$data.__open();
        },
        "@keydown.down.stop.prevent" () {
            this.$data.__open();
        },
        "@keydown.up.stop.prevent" () {
            this.$data.__open($182977f45aac8dca$var$dom.last);
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__open();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__open();
        }
    });
}
function $182977f45aac8dca$var$handleItems(el, Alpine2) {
    Alpine2.bind(el, {
        "x-ref": "__items",
        "aria-orientation": "vertical",
        "role": "menu",
        ":id" () {
            return this.$id("alpine-menu-items");
        },
        ":aria-labelledby" () {
            return this.$id("alpine-menu-button");
        },
        ":aria-activedescendant" () {
            return this.$data.__activeEl && this.$data.__activeEl.id;
        },
        "x-show" () {
            return this.$data.__isOpen;
        },
        "tabindex": "0",
        "@click.outside" () {
            this.$data.__close();
        },
        "@keydown" (e) {
            $182977f45aac8dca$var$dom.search(Alpine2, this.$refs.__items, e.key, (el2)=>el2.__activate());
        },
        "@keydown.down.stop.prevent" () {
            if (this.$data.__activeEl) $182977f45aac8dca$var$dom.next(Alpine2, this.$data.__activeEl, (el2)=>el2.__activate());
            else $182977f45aac8dca$var$dom.first(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.up.stop.prevent" () {
            if (this.$data.__activeEl) $182977f45aac8dca$var$dom.previous(Alpine2, this.$data.__activeEl, (el2)=>el2.__activate());
            else $182977f45aac8dca$var$dom.last(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.home.stop.prevent" () {
            $182977f45aac8dca$var$dom.first(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.end.stop.prevent" () {
            $182977f45aac8dca$var$dom.last(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.page-up.stop.prevent" () {
            $182977f45aac8dca$var$dom.first(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.page-down.stop.prevent" () {
            $182977f45aac8dca$var$dom.last(Alpine2, this.$refs.__items, (el2)=>el2.__activate());
        },
        "@keydown.escape.stop.prevent" () {
            this.$data.__close();
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__activeEl && this.$data.__activeEl.click();
        },
        "@keydown.enter.stop.prevent" () {
            this.$data.__activeEl && this.$data.__activeEl.click();
        },
        // Required for firefox, event.preventDefault() in handleKeyDown for
        // the Space key doesn't cancel the handleKeyUp, which in turn
        // triggers a *click*.
        "@keyup.space.prevent" () {}
    });
}
function $182977f45aac8dca$var$handleItem(el, Alpine2) {
    Alpine2.bind(el, ()=>{
        return {
            "x-data" () {
                return {
                    __itemEl: this.$el,
                    init () {
                        let els = Alpine2.raw(this.$data.__itemEls);
                        let inserted = false;
                        for(let i = 0; i < els.length; i++)if (els[i].compareDocumentPosition(this.$el) & Node.DOCUMENT_POSITION_PRECEDING) {
                            els.splice(i, 0, this.$el);
                            inserted = true;
                            break;
                        }
                        if (!inserted) els.push(this.$el);
                        this.$el.__activate = ()=>{
                            this.$data.__activeEl = this.$el;
                            this.$el.scrollIntoView({
                                block: "nearest"
                            });
                        };
                        this.$el.__deactivate = ()=>{
                            this.$data.__activeEl = null;
                        };
                        this.$el.__isDisabled = Alpine2.reactive({
                            value: false
                        });
                        queueMicrotask(()=>{
                            this.$el.__isDisabled.value = Alpine2.bound(this.$el, "disabled", false);
                        });
                    },
                    destroy () {
                        let els = this.$data.__itemEls;
                        els.splice(els.indexOf(this.$el), 1);
                    }
                };
            },
            "x-id" () {
                return [
                    "alpine-menu-item"
                ];
            },
            ":id" () {
                return this.$id("alpine-menu-item");
            },
            ":tabindex" () {
                return this.__itemEl.__isDisabled.value ? false : "-1";
            },
            "role": "menuitem",
            "@mousemove" () {
                this.__itemEl.__isDisabled.value || this.$menuItem.isActive || this.__itemEl.__activate();
            },
            "@mouseleave" () {
                this.__itemEl.__isDisabled.value || !this.$menuItem.isActive || this.__itemEl.__deactivate();
            }
        };
    });
}
var $182977f45aac8dca$var$dom = {
    first (Alpine2, parent, receive = (i)=>i, fallback = ()=>{}) {
        let first = Alpine2.$data(parent).__itemEls[0];
        if (!first) return fallback();
        if (first.tagName.toLowerCase() === "template") return this.next(Alpine2, first, receive);
        if (first.__isDisabled.value) return this.next(Alpine2, first, receive);
        return receive(first);
    },
    last (Alpine2, parent, receive = (i)=>i, fallback = ()=>{}) {
        let last = Alpine2.$data(parent).__itemEls.slice(-1)[0];
        if (!last) return fallback();
        if (last.__isDisabled.value) return this.previous(Alpine2, last, receive);
        return receive(last);
    },
    next (Alpine2, el, receive = (i)=>i, fallback = ()=>{}) {
        if (!el) return fallback();
        let els = Alpine2.$data(el).__itemEls;
        let next = els[els.indexOf(el) + 1];
        if (!next) return fallback();
        if (next.__isDisabled.value || next.tagName.toLowerCase() === "template") return this.next(Alpine2, next, receive, fallback);
        return receive(next);
    },
    previous (Alpine2, el, receive = (i)=>i, fallback = ()=>{}) {
        if (!el) return fallback();
        let els = Alpine2.$data(el).__itemEls;
        let prev = els[els.indexOf(el) - 1];
        if (!prev) return fallback();
        if (prev.__isDisabled.value || prev.tagName.toLowerCase() === "template") return this.previous(Alpine2, prev, receive, fallback);
        return receive(prev);
    },
    searchQuery: "",
    debouncedClearSearch: void 0,
    clearSearch (Alpine2) {
        if (!this.debouncedClearSearch) this.debouncedClearSearch = Alpine2.debounce(function() {
            this.searchQuery = "";
        }, 350);
        this.debouncedClearSearch();
    },
    search (Alpine2, parent, key, receiver) {
        if (key.length > 1) return;
        this.searchQuery += key;
        let els = Alpine2.raw(Alpine2.$data(parent).__itemEls);
        let el = els.find((el2)=>{
            return el2.textContent.trim().toLowerCase().startsWith(this.searchQuery);
        });
        el && !el.__isDisabled.value && receiver(el);
        this.clearSearch(Alpine2);
    }
};
// packages/ui/src/switch.js
function $182977f45aac8dca$var$switch_default(Alpine2) {
    Alpine2.directive("switch", (el, directive)=>{
        if (directive.value === "group") $182977f45aac8dca$var$handleGroup2(el, Alpine2);
        else if (directive.value === "label") $182977f45aac8dca$var$handleLabel3(el, Alpine2);
        else if (directive.value === "description") $182977f45aac8dca$var$handleDescription2(el, Alpine2);
        else $182977f45aac8dca$var$handleRoot7(el, Alpine2);
    }).before("bind");
    Alpine2.magic("switch", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isChecked () {
                return $data.__value === true;
            }
        };
    });
}
function $182977f45aac8dca$var$handleGroup2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-id" () {
            return [
                "alpine-switch-label",
                "alpine-switch-description"
            ];
        },
        "x-data" () {
            return {
                __hasLabel: false,
                __hasDescription: false,
                __switchEl: void 0
            };
        }
    });
}
function $182977f45aac8dca$var$handleRoot7(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__value",
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        this.__value = Alpine2.bound(this.$el, "default-checked", false);
                        this.__inputName = Alpine2.bound(this.$el, "name", false);
                        this.__inputValue = Alpine2.bound(this.$el, "value", "on");
                        this.__inputId = "alpine-switch-" + Date.now();
                    });
                },
                __value: void 0,
                __inputName: void 0,
                __inputValue: void 0,
                __inputId: void 0,
                __toggle () {
                    this.__value = !this.__value;
                }
            };
        },
        "x-effect" () {
            let value = this.__value;
            if (!this.__inputName) return;
            let nextEl = this.$el.nextElementSibling;
            if (nextEl && String(nextEl.id) === String(this.__inputId)) nextEl.remove();
            if (value) {
                let input = document.createElement("input");
                input.type = "hidden";
                input.value = this.__inputValue;
                input.name = this.__inputName;
                input.id = this.__inputId;
                this.$el.after(input);
            }
        },
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
            this.$data.__switchEl = this.$el;
        },
        "role": "switch",
        "tabindex": "0",
        ":aria-checked" () {
            return !!this.__value;
        },
        ":aria-labelledby" () {
            return this.$data.__hasLabel && this.$id("alpine-switch-label");
        },
        ":aria-describedby" () {
            return this.$data.__hasDescription && this.$id("alpine-switch-description");
        },
        "@click.prevent" () {
            this.__toggle();
        },
        "@keyup" (e) {
            if (e.key !== "Tab") e.preventDefault();
            if (e.key === " ") this.__toggle();
        },
        // This is needed so that we can "cancel" the click event when we use the `Enter` key on a button.
        "@keypress.prevent" () {}
    });
}
function $182977f45aac8dca$var$handleLabel3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasLabel = true;
        },
        ":id" () {
            return this.$id("alpine-switch-label");
        },
        "@click" () {
            this.$data.__switchEl.click();
            this.$data.__switchEl.focus({
                preventScroll: true
            });
        }
    });
}
function $182977f45aac8dca$var$handleDescription2(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasDescription = true;
        },
        ":id" () {
            return this.$id("alpine-switch-description");
        }
    });
}
// packages/ui/src/radio.js
function $182977f45aac8dca$var$radio_default(Alpine2) {
    Alpine2.directive("radio", (el, directive)=>{
        if (!directive.value) $182977f45aac8dca$var$handleRoot8(el, Alpine2);
        else if (directive.value === "option") $182977f45aac8dca$var$handleOption3(el, Alpine2);
        else if (directive.value === "label") $182977f45aac8dca$var$handleLabel4(el, Alpine2);
        else if (directive.value === "description") $182977f45aac8dca$var$handleDescription3(el, Alpine2);
    }).before("bind");
    Alpine2.magic("radioOption", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isActive () {
                return $data.__option === $data.__active;
            },
            get isChecked () {
                return $data.__option === $data.__value;
            },
            get isDisabled () {
                let disabled = $data.__disabled;
                if ($data.__rootDisabled) return true;
                return disabled;
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot8(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__value",
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        this.__rootDisabled = Alpine2.bound(el, "disabled", false);
                        this.__value = Alpine2.bound(this.$el, "default-value", false);
                        this.__inputName = Alpine2.bound(this.$el, "name", false);
                        this.__inputId = "alpine-radio-" + Date.now();
                    });
                    this.$nextTick(()=>{
                        let walker = document.createTreeWalker(this.$el, NodeFilter.SHOW_ELEMENT, {
                            acceptNode: (node)=>{
                                if (node.getAttribute("role") === "radio") return NodeFilter.FILTER_REJECT;
                                if (node.hasAttribute("role")) return NodeFilter.FILTER_SKIP;
                                return NodeFilter.FILTER_ACCEPT;
                            }
                        }, false);
                        while(walker.nextNode())walker.currentNode.setAttribute("role", "none");
                    });
                },
                __value: void 0,
                __active: void 0,
                __rootEl: this.$el,
                __optionValues: [],
                __disabledOptions: /* @__PURE__ */ new Set(),
                __optionElsByValue: /* @__PURE__ */ new Map(),
                __hasLabel: false,
                __hasDescription: false,
                __rootDisabled: false,
                __inputName: void 0,
                __inputId: void 0,
                __change (value) {
                    if (this.__rootDisabled) return;
                    this.__value = value;
                },
                __addOption (option, el2, disabled) {
                    let options = Alpine2.raw(this.__optionValues);
                    let els = options.map((i)=>this.__optionElsByValue.get(i));
                    let inserted = false;
                    for(let i = 0; i < els.length; i++)if (els[i].compareDocumentPosition(el2) & Node.DOCUMENT_POSITION_PRECEDING) {
                        options.splice(i, 0, option);
                        this.__optionElsByValue.set(option, el2);
                        inserted = true;
                        break;
                    }
                    if (!inserted) {
                        options.push(option);
                        this.__optionElsByValue.set(option, el2);
                    }
                    disabled && this.__disabledOptions.add(option);
                },
                __isFirstOption (option) {
                    return this.__optionValues.indexOf(option) === 0;
                },
                __setActive (option) {
                    this.__active = option;
                },
                __focusOptionNext () {
                    let option = this.__active;
                    let all = this.__optionValues.filter((i)=>!this.__disabledOptions.has(i));
                    let next = all[this.__optionValues.indexOf(option) + 1];
                    next = next || all[0];
                    this.__optionElsByValue.get(next).focus();
                    this.__change(next);
                },
                __focusOptionPrev () {
                    let option = this.__active;
                    let all = this.__optionValues.filter((i)=>!this.__disabledOptions.has(i));
                    let prev = all[all.indexOf(option) - 1];
                    prev = prev || all.slice(-1)[0];
                    this.__optionElsByValue.get(prev).focus();
                    this.__change(prev);
                }
            };
        },
        "x-effect" () {
            let value = this.__value;
            if (!this.__inputName) return;
            let nextEl = this.$el.nextElementSibling;
            if (nextEl && String(nextEl.id) === String(this.__inputId)) nextEl.remove();
            if (value) {
                let input = document.createElement("input");
                input.type = "hidden";
                input.value = value;
                input.name = this.__inputName;
                input.id = this.__inputId;
                this.$el.after(input);
            }
        },
        "role": "radiogroup",
        "x-id" () {
            return [
                "alpine-radio-label",
                "alpine-radio-description"
            ];
        },
        ":aria-labelledby" () {
            return this.__hasLabel && this.$id("alpine-radio-label");
        },
        ":aria-describedby" () {
            return this.__hasDescription && this.$id("alpine-radio-description");
        },
        "@keydown.up.prevent.stop" () {
            this.__focusOptionPrev();
        },
        "@keydown.left.prevent.stop" () {
            this.__focusOptionPrev();
        },
        "@keydown.down.prevent.stop" () {
            this.__focusOptionNext();
        },
        "@keydown.right.prevent.stop" () {
            this.__focusOptionNext();
        }
    });
}
function $182977f45aac8dca$var$handleOption3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        this.__disabled = Alpine2.bound(el, "disabled", false);
                        this.__option = Alpine2.bound(el, "value");
                        this.$data.__addOption(this.__option, this.$el, this.__disabled);
                    });
                },
                __option: void 0,
                __disabled: false,
                __hasLabel: false,
                __hasDescription: false
            };
        },
        "x-id" () {
            return [
                "alpine-radio-label",
                "alpine-radio-description"
            ];
        },
        "role": "radio",
        ":aria-checked" () {
            return this.$radioOption.isChecked;
        },
        ":aria-disabled" () {
            return this.$radioOption.isDisabled;
        },
        ":aria-labelledby" () {
            return this.__hasLabel && this.$id("alpine-radio-label");
        },
        ":aria-describedby" () {
            return this.__hasDescription && this.$id("alpine-radio-description");
        },
        ":tabindex" () {
            if (this.$radioOption.isDisabled) return -1;
            if (this.$radioOption.isChecked) return 0;
            if (!this.$data.__value && this.$data.__isFirstOption(this.$data.__option)) return 0;
            return -1;
        },
        "@click" () {
            if (this.$radioOption.isDisabled) return;
            this.$data.__change(this.$data.__option);
            this.$el.focus();
        },
        "@focus" () {
            if (this.$radioOption.isDisabled) return;
            this.$data.__setActive(this.$data.__option);
        },
        "@blur" () {
            if (this.$data.__active === this.$data.__option) this.$data.__setActive(void 0);
        },
        "@keydown.space.stop.prevent" () {
            this.$data.__change(this.$data.__option);
        }
    });
}
function $182977f45aac8dca$var$handleLabel4(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasLabel = true;
        },
        ":id" () {
            return this.$id("alpine-radio-label");
        }
    });
}
function $182977f45aac8dca$var$handleDescription3(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__hasDescription = true;
        },
        ":id" () {
            return this.$id("alpine-radio-description");
        }
    });
}
// packages/ui/src/tabs.js
function $182977f45aac8dca$var$tabs_default(Alpine2) {
    Alpine2.directive("tabs", (el, directive)=>{
        if (!directive.value) $182977f45aac8dca$var$handleRoot9(el, Alpine2);
        else if (directive.value === "list") $182977f45aac8dca$var$handleList(el, Alpine2);
        else if (directive.value === "tab") $182977f45aac8dca$var$handleTab(el, Alpine2);
        else if (directive.value === "panels") $182977f45aac8dca$var$handlePanels(el, Alpine2);
        else if (directive.value === "panel") $182977f45aac8dca$var$handlePanel4(el, Alpine2);
    }).before("bind");
    Alpine2.magic("tab", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isSelected () {
                return $data.__selectedIndex === $data.__tabs.indexOf($data.__tabEl);
            },
            get isDisabled () {
                return $data.__isDisabled;
            }
        };
    });
    Alpine2.magic("panel", (el)=>{
        let $data = Alpine2.$data(el);
        return {
            get isSelected () {
                return $data.__selectedIndex === $data.__panels.indexOf($data.__panelEl);
            }
        };
    });
}
function $182977f45aac8dca$var$handleRoot9(el, Alpine2) {
    Alpine2.bind(el, {
        "x-modelable": "__selectedIndex",
        "x-data" () {
            return {
                init () {
                    queueMicrotask(()=>{
                        let defaultIndex = this.__selectedIndex || Number(Alpine2.bound(this.$el, "default-index", 0));
                        let tabs = this.__activeTabs();
                        let clamp = (number, min, max)=>Math.min(Math.max(number, min), max);
                        this.__selectedIndex = clamp(defaultIndex, 0, tabs.length - 1);
                        Alpine2.effect(()=>{
                            this.__manualActivation = Alpine2.bound(this.$el, "manual", false);
                        });
                    });
                },
                __tabs: [],
                __panels: [],
                __selectedIndex: null,
                __tabGroupEl: void 0,
                __manualActivation: false,
                __addTab (el2) {
                    this.__tabs.push(el2);
                },
                __addPanel (el2) {
                    this.__panels.push(el2);
                },
                __selectTab (el2) {
                    this.__selectedIndex = this.__tabs.indexOf(el2);
                },
                __activeTabs () {
                    return this.__tabs.filter((i)=>!i.__disabled);
                }
            };
        }
    });
}
function $182977f45aac8dca$var$handleList(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            this.$data.__tabGroupEl = this.$el;
        }
    });
}
function $182977f45aac8dca$var$handleTab(el, Alpine2) {
    Alpine2.bind(el, {
        "x-init" () {
            if (this.$el.tagName.toLowerCase() === "button" && !this.$el.hasAttribute("type")) this.$el.type = "button";
        },
        "x-data" () {
            return {
                init () {
                    this.__tabEl = this.$el;
                    this.$data.__addTab(this.$el);
                    this.__tabEl.__disabled = Alpine2.bound(this.$el, "disabled", false);
                    this.__isDisabled = this.__tabEl.__disabled;
                },
                __tabEl: void 0,
                __isDisabled: false
            };
        },
        "@click" () {
            if (this.$el.__disabled) return;
            this.$data.__selectTab(this.$el);
            this.$el.focus();
        },
        "@keydown.enter.prevent.stop" () {
            this.__selectTab(this.$el);
        },
        "@keydown.space.prevent.stop" () {
            this.__selectTab(this.$el);
        },
        "@keydown.home.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).first();
        },
        "@keydown.page-up.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).first();
        },
        "@keydown.end.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).last();
        },
        "@keydown.page-down.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).last();
        },
        "@keydown.down.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().next();
        },
        "@keydown.right.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().next();
        },
        "@keydown.up.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().prev();
        },
        "@keydown.left.prevent.stop" () {
            this.$focus.within(this.$data.__activeTabs()).withWrapAround().prev();
        },
        ":tabindex" () {
            return this.$tab.isSelected ? 0 : -1;
        },
        // This is important because we want to only focus the tab when it gets focus
        // OR it finished the click event (mouseup). However, if you perform a `click`,
        // then you will first get the `focus` and then get the `click` event.
        // See https://github.com/tailwindlabs/headlessui/pull/1192
        "@mousedown" (event) {
            event.preventDefault();
        },
        "@focus" () {
            if (this.$data.__manualActivation) this.$el.focus();
            else {
                if (this.$el.__disabled) return;
                this.$data.__selectTab(this.$el);
                this.$el.focus();
            }
        }
    });
}
function $182977f45aac8dca$var$handlePanels(el, Alpine2) {
    Alpine2.bind(el, {
    });
}
function $182977f45aac8dca$var$handlePanel4(el, Alpine2) {
    Alpine2.bind(el, {
        ":tabindex" () {
            return this.$panel.isSelected ? 0 : -1;
        },
        "x-data" () {
            return {
                init () {
                    this.__panelEl = this.$el;
                    this.$data.__addPanel(this.$el);
                },
                __panelEl: void 0
            };
        },
        "x-show" () {
            return this.$panel.isSelected;
        }
    });
}
// packages/ui/src/index.js
function $182977f45aac8dca$export$5525e5ba287fa6f5(Alpine2) {
    $182977f45aac8dca$var$combobox_default(Alpine2);
    $182977f45aac8dca$var$dialog_default(Alpine2);
    $182977f45aac8dca$var$disclosure_default(Alpine2);
    $182977f45aac8dca$var$listbox_default(Alpine2);
    $182977f45aac8dca$var$menu_default(Alpine2);
    $182977f45aac8dca$var$switch_default(Alpine2);
    $182977f45aac8dca$var$popover_default(Alpine2);
    $182977f45aac8dca$var$radio_default(Alpine2);
    $182977f45aac8dca$var$tabs_default(Alpine2);
}
// packages/ui/builds/module.js
var $182977f45aac8dca$export$2e2bcd8739ae039 = $182977f45aac8dca$export$5525e5ba287fa6f5;


// packages/alpinejs/src/scheduler.js
var $f347e48613385d9c$var$flushPending = false;
var $f347e48613385d9c$var$flushing = false;
var $f347e48613385d9c$var$queue = [];
var $f347e48613385d9c$var$lastFlushedIndex = -1;
function $f347e48613385d9c$var$scheduler(callback) {
    $f347e48613385d9c$var$queueJob(callback);
}
function $f347e48613385d9c$var$queueJob(job) {
    if (!$f347e48613385d9c$var$queue.includes(job)) $f347e48613385d9c$var$queue.push(job);
    $f347e48613385d9c$var$queueFlush();
}
function $f347e48613385d9c$var$dequeueJob(job) {
    let index = $f347e48613385d9c$var$queue.indexOf(job);
    if (index !== -1 && index > $f347e48613385d9c$var$lastFlushedIndex) $f347e48613385d9c$var$queue.splice(index, 1);
}
function $f347e48613385d9c$var$queueFlush() {
    if (!$f347e48613385d9c$var$flushing && !$f347e48613385d9c$var$flushPending) {
        $f347e48613385d9c$var$flushPending = true;
        queueMicrotask($f347e48613385d9c$var$flushJobs);
    }
}
function $f347e48613385d9c$var$flushJobs() {
    $f347e48613385d9c$var$flushPending = false;
    $f347e48613385d9c$var$flushing = true;
    for(let i = 0; i < $f347e48613385d9c$var$queue.length; i++){
        $f347e48613385d9c$var$queue[i]();
        $f347e48613385d9c$var$lastFlushedIndex = i;
    }
    $f347e48613385d9c$var$queue.length = 0;
    $f347e48613385d9c$var$lastFlushedIndex = -1;
    $f347e48613385d9c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f347e48613385d9c$var$reactive;
var $f347e48613385d9c$var$effect;
var $f347e48613385d9c$var$release;
var $f347e48613385d9c$var$raw;
var $f347e48613385d9c$var$shouldSchedule = true;
function $f347e48613385d9c$var$disableEffectScheduling(callback) {
    $f347e48613385d9c$var$shouldSchedule = false;
    callback();
    $f347e48613385d9c$var$shouldSchedule = true;
}
function $f347e48613385d9c$var$setReactivityEngine(engine) {
    $f347e48613385d9c$var$reactive = engine.reactive;
    $f347e48613385d9c$var$release = engine.release;
    $f347e48613385d9c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f347e48613385d9c$var$shouldSchedule) $f347e48613385d9c$var$scheduler(task);
                else task();
            }
        });
    $f347e48613385d9c$var$raw = engine.raw;
}
function $f347e48613385d9c$var$overrideEffect(override) {
    $f347e48613385d9c$var$effect = override;
}
function $f347e48613385d9c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f347e48613385d9c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f347e48613385d9c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $f347e48613385d9c$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $f347e48613385d9c$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$f347e48613385d9c$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $f347e48613385d9c$var$onAttributeAddeds = [];
var $f347e48613385d9c$var$onElRemoveds = [];
var $f347e48613385d9c$var$onElAddeds = [];
function $f347e48613385d9c$var$onElAdded(callback) {
    $f347e48613385d9c$var$onElAddeds.push(callback);
}
function $f347e48613385d9c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f347e48613385d9c$var$onElRemoveds.push(callback);
    }
}
function $f347e48613385d9c$var$onAttributesAdded(callback) {
    $f347e48613385d9c$var$onAttributeAddeds.push(callback);
}
function $f347e48613385d9c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f347e48613385d9c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f347e48613385d9c$var$cleanupElement(el) {
    el._x_effects?.forEach($f347e48613385d9c$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $f347e48613385d9c$var$observer = new MutationObserver($f347e48613385d9c$var$onMutate);
var $f347e48613385d9c$var$currentlyObserving = false;
function $f347e48613385d9c$var$startObservingMutations() {
    $f347e48613385d9c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f347e48613385d9c$var$currentlyObserving = true;
}
function $f347e48613385d9c$var$stopObservingMutations() {
    $f347e48613385d9c$var$flushObserver();
    $f347e48613385d9c$var$observer.disconnect();
    $f347e48613385d9c$var$currentlyObserving = false;
}
var $f347e48613385d9c$var$queuedMutations = [];
function $f347e48613385d9c$var$flushObserver() {
    let records = $f347e48613385d9c$var$observer.takeRecords();
    $f347e48613385d9c$var$queuedMutations.push(()=>records.length > 0 && $f347e48613385d9c$var$onMutate(records));
    let queueLengthWhenTriggered = $f347e48613385d9c$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($f347e48613385d9c$var$queuedMutations.length === queueLengthWhenTriggered) while($f347e48613385d9c$var$queuedMutations.length > 0)$f347e48613385d9c$var$queuedMutations.shift()();
    });
}
function $f347e48613385d9c$var$mutateDom(callback) {
    if (!$f347e48613385d9c$var$currentlyObserving) return callback();
    $f347e48613385d9c$var$stopObservingMutations();
    let result = callback();
    $f347e48613385d9c$var$startObservingMutations();
    return result;
}
var $f347e48613385d9c$var$isCollecting = false;
var $f347e48613385d9c$var$deferredMutations = [];
function $f347e48613385d9c$var$deferMutations() {
    $f347e48613385d9c$var$isCollecting = true;
}
function $f347e48613385d9c$var$flushAndStopDeferringMutations() {
    $f347e48613385d9c$var$isCollecting = false;
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$deferredMutations);
    $f347e48613385d9c$var$deferredMutations = [];
}
function $f347e48613385d9c$var$onMutate(mutations) {
    if ($f347e48613385d9c$var$isCollecting) {
        $f347e48613385d9c$var$deferredMutations = $f347e48613385d9c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $f347e48613385d9c$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $f347e48613385d9c$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f347e48613385d9c$var$scope(node) {
    return $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$closestDataStack(node));
}
function $f347e48613385d9c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f347e48613385d9c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f347e48613385d9c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f347e48613385d9c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f347e48613385d9c$var$closestDataStack(node.parentNode);
}
function $f347e48613385d9c$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $f347e48613385d9c$var$mergeProxyTrap);
}
var $f347e48613385d9c$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $f347e48613385d9c$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $f347e48613385d9c$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $f347e48613385d9c$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f347e48613385d9c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f347e48613385d9c$var$get(data2, path), (value)=>$f347e48613385d9c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f347e48613385d9c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f347e48613385d9c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f347e48613385d9c$var$magics = {};
function $f347e48613385d9c$var$magic(name, callback) {
    $f347e48613385d9c$var$magics[name] = callback;
}
function $f347e48613385d9c$var$injectMagics(obj, el) {
    let memoizedUtilities = $f347e48613385d9c$var$getUtilities(el);
    Object.entries($f347e48613385d9c$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $f347e48613385d9c$var$getUtilities(el) {
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $f347e48613385d9c$var$interceptor,
        ...utilities
    };
    $f347e48613385d9c$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $f347e48613385d9c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f347e48613385d9c$var$handleError(e, el, expression);
    }
}
function $f347e48613385d9c$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f347e48613385d9c$var$shouldAutoEvaluateFunctions = true;
function $f347e48613385d9c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f347e48613385d9c$var$shouldAutoEvaluateFunctions;
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f347e48613385d9c$var$evaluate(el, expression, extras = {}) {
    let result;
    $f347e48613385d9c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f347e48613385d9c$var$evaluateLater(...args) {
    return $f347e48613385d9c$var$theEvaluatorFunction(...args);
}
var $f347e48613385d9c$var$theEvaluatorFunction = $f347e48613385d9c$var$normalEvaluator;
function $f347e48613385d9c$var$setEvaluator(newEvaluator) {
    $f347e48613385d9c$var$theEvaluatorFunction = newEvaluator;
}
function $f347e48613385d9c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f347e48613385d9c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f347e48613385d9c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, expression) : $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f347e48613385d9c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        let result = func.apply($f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f347e48613385d9c$var$evaluatorMemo = {};
function $f347e48613385d9c$var$generateFunctionFromString(expression, el) {
    if ($f347e48613385d9c$var$evaluatorMemo[expression]) return $f347e48613385d9c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $f347e48613385d9c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f347e48613385d9c$var$evaluatorMemo[expression] = func;
    return func;
}
function $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f347e48613385d9c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [] } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func(func, completeScope).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression));
            if (func.finished) {
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f347e48613385d9c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f347e48613385d9c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f347e48613385d9c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f347e48613385d9c$var$prefixAsString = "x-";
function $f347e48613385d9c$var$prefix(subject = "") {
    return $f347e48613385d9c$var$prefixAsString + subject;
}
function $f347e48613385d9c$var$setPrefix(newPrefix) {
    $f347e48613385d9c$var$prefixAsString = newPrefix;
}
var $f347e48613385d9c$var$directiveHandlers = {};
function $f347e48613385d9c$var$directive(name, callback) {
    $f347e48613385d9c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f347e48613385d9c$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $f347e48613385d9c$var$directiveOrder.indexOf(directive2);
            $f347e48613385d9c$var$directiveOrder.splice(pos >= 0 ? pos : $f347e48613385d9c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f347e48613385d9c$var$directiveExists(name) {
    return Object.keys($f347e48613385d9c$var$directiveHandlers).includes(name);
}
function $f347e48613385d9c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f347e48613385d9c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f347e48613385d9c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f347e48613385d9c$var$outNonAlpineAttributes).map($f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f347e48613385d9c$var$byPriority);
    return directives2.map((directive2)=>{
        return $f347e48613385d9c$var$getDirectiveHandler(el, directive2);
    });
}
function $f347e48613385d9c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f347e48613385d9c$var$toTransformedAttributes()).filter((attr)=>!$f347e48613385d9c$var$outNonAlpineAttributes(attr));
}
var $f347e48613385d9c$var$isDeferringHandlers = false;
var $f347e48613385d9c$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f347e48613385d9c$var$currentHandlerStackKey = Symbol();
function $f347e48613385d9c$var$deferHandlingDirectives(callback) {
    $f347e48613385d9c$var$isDeferringHandlers = true;
    let key = Symbol();
    $f347e48613385d9c$var$currentHandlerStackKey = key;
    $f347e48613385d9c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f347e48613385d9c$var$directiveHandlerStacks.get(key).length)$f347e48613385d9c$var$directiveHandlerStacks.get(key).shift()();
        $f347e48613385d9c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f347e48613385d9c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f347e48613385d9c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f347e48613385d9c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f347e48613385d9c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f347e48613385d9c$var$evaluateLater.bind($f347e48613385d9c$var$evaluateLater, el),
        evaluate: $f347e48613385d9c$var$evaluate.bind($f347e48613385d9c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f347e48613385d9c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f347e48613385d9c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    $f347e48613385d9c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f347e48613385d9c$var$isDeferringHandlers ? $f347e48613385d9c$var$directiveHandlerStacks.get($f347e48613385d9c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f347e48613385d9c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f347e48613385d9c$var$into = (i)=>i;
function $f347e48613385d9c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f347e48613385d9c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f347e48613385d9c$var$attributeTransformers = [];
function $f347e48613385d9c$var$mapAttributes(callback) {
    $f347e48613385d9c$var$attributeTransformers.push(callback);
}
function $f347e48613385d9c$var$outNonAlpineAttributes({ name: name }) {
    return $f347e48613385d9c$var$alpineAttributeRegex().test(name);
}
var $f347e48613385d9c$var$alpineAttributeRegex = ()=>new RegExp(`^${$f347e48613385d9c$var$prefixAsString}([^:^.]+)\\b`);
function $f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f347e48613385d9c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f347e48613385d9c$var$DEFAULT = "DEFAULT";
var $f347e48613385d9c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f347e48613385d9c$var$DEFAULT,
    "teleport"
];
function $f347e48613385d9c$var$byPriority(a, b) {
    let typeA = $f347e48613385d9c$var$directiveOrder.indexOf(a.type) === -1 ? $f347e48613385d9c$var$DEFAULT : a.type;
    let typeB = $f347e48613385d9c$var$directiveOrder.indexOf(b.type) === -1 ? $f347e48613385d9c$var$DEFAULT : b.type;
    return $f347e48613385d9c$var$directiveOrder.indexOf(typeA) - $f347e48613385d9c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $f347e48613385d9c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f347e48613385d9c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f347e48613385d9c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f347e48613385d9c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f347e48613385d9c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f347e48613385d9c$var$started = false;
function $f347e48613385d9c$var$start() {
    if ($f347e48613385d9c$var$started) $f347e48613385d9c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f347e48613385d9c$var$started = true;
    if (!document.body) $f347e48613385d9c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f347e48613385d9c$var$dispatch(document, "alpine:init");
    $f347e48613385d9c$var$dispatch(document, "alpine:initializing");
    $f347e48613385d9c$var$startObservingMutations();
    $f347e48613385d9c$var$onElAdded((el)=>$f347e48613385d9c$var$initTree(el, $f347e48613385d9c$var$walk));
    $f347e48613385d9c$var$onElRemoved((el)=>$f347e48613385d9c$var$destroyTree(el));
    $f347e48613385d9c$var$onAttributesAdded((el, attrs)=>{
        $f347e48613385d9c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f347e48613385d9c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f347e48613385d9c$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $f347e48613385d9c$var$initTree(el);
    });
    $f347e48613385d9c$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $f347e48613385d9c$var$warnAboutMissingPlugins();
    });
}
var $f347e48613385d9c$var$rootSelectorCallbacks = [];
var $f347e48613385d9c$var$initSelectorCallbacks = [];
function $f347e48613385d9c$var$rootSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f347e48613385d9c$var$allSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.concat($f347e48613385d9c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f347e48613385d9c$var$addRootSelector(selectorCallback) {
    $f347e48613385d9c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$addInitSelector(selectorCallback) {
    $f347e48613385d9c$var$initSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$closestRoot(el, includeInitSelectors = false) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f347e48613385d9c$var$allSelectors() : $f347e48613385d9c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f347e48613385d9c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f347e48613385d9c$var$findClosest(el.parentElement, callback);
}
function $f347e48613385d9c$var$isRoot(el) {
    return $f347e48613385d9c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f347e48613385d9c$var$initInterceptors2 = [];
function $f347e48613385d9c$var$interceptInit(callback) {
    $f347e48613385d9c$var$initInterceptors2.push(callback);
}
var $f347e48613385d9c$var$markerDispenser = 1;
function $f347e48613385d9c$var$initTree(el, walker = $f347e48613385d9c$var$walk, intercept = ()=>{}) {
    if ($f347e48613385d9c$var$findClosest(el, (i)=>i._x_ignore)) return;
    $f347e48613385d9c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $f347e48613385d9c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $f347e48613385d9c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $f347e48613385d9c$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $f347e48613385d9c$var$destroyTree(root, walker = $f347e48613385d9c$var$walk) {
    walker(root, (el)=>{
        $f347e48613385d9c$var$cleanupElement(el);
        $f347e48613385d9c$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $f347e48613385d9c$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($f347e48613385d9c$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $f347e48613385d9c$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $f347e48613385d9c$var$tickStack = [];
var $f347e48613385d9c$var$isHolding = false;
function $f347e48613385d9c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f347e48613385d9c$var$isHolding || setTimeout(()=>{
            $f347e48613385d9c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f347e48613385d9c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f347e48613385d9c$var$releaseNextTicks() {
    $f347e48613385d9c$var$isHolding = false;
    while($f347e48613385d9c$var$tickStack.length)$f347e48613385d9c$var$tickStack.shift()();
}
function $f347e48613385d9c$var$holdNextTicks() {
    $f347e48613385d9c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f347e48613385d9c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f347e48613385d9c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f347e48613385d9c$var$setClasses(el, value());
    return $f347e48613385d9c$var$setClassesFromString(el, value);
}
function $f347e48613385d9c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f347e48613385d9c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f347e48613385d9c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setStylesFromObject(el, value);
    return $f347e48613385d9c$var$setStylesFromString(el, value);
}
function $f347e48613385d9c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f347e48613385d9c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f347e48613385d9c$var$setStyles(el, previousStyles);
    };
}
function $f347e48613385d9c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f347e48613385d9c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f347e48613385d9c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f347e48613385d9c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f347e48613385d9c$var$registerTransitionsFromClassString(el, expression, value);
});
function $f347e48613385d9c$var$registerTransitionsFromClassString(el, classString, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f347e48613385d9c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f347e48613385d9c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f347e48613385d9c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f347e48613385d9c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f347e48613385d9c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f347e48613385d9c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f347e48613385d9c$var$closestHide(parent);
}
function $f347e48613385d9c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f347e48613385d9c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f347e48613385d9c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f347e48613385d9c$var$once(()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f347e48613385d9c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f347e48613385d9c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f347e48613385d9c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f347e48613385d9c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f347e48613385d9c$var$mutateDom(()=>{
                stages.end();
            });
            $f347e48613385d9c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f347e48613385d9c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f347e48613385d9c$var$isCloning = false;
function $f347e48613385d9c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f347e48613385d9c$var$isCloning ? fallback(...args) : callback(...args);
}
function $f347e48613385d9c$var$onlyDuringClone(callback) {
    return (...args)=>$f347e48613385d9c$var$isCloning && callback(...args);
}
var $f347e48613385d9c$var$interceptors = [];
function $f347e48613385d9c$var$interceptClone(callback) {
    $f347e48613385d9c$var$interceptors.push(callback);
}
function $f347e48613385d9c$var$cloneNode(from, to) {
    $f347e48613385d9c$var$interceptors.forEach((i)=>i(from, to));
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f347e48613385d9c$var$isCloning = false;
}
var $f347e48613385d9c$var$isCloningLegacy = false;
function $f347e48613385d9c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$isCloningLegacy = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$cloneTree(newEl);
    });
    $f347e48613385d9c$var$isCloning = false;
    $f347e48613385d9c$var$isCloningLegacy = false;
}
function $f347e48613385d9c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f347e48613385d9c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f347e48613385d9c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f347e48613385d9c$var$initTree(el, shallowWalker);
}
function $f347e48613385d9c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f347e48613385d9c$var$effect;
    $f347e48613385d9c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f347e48613385d9c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f347e48613385d9c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f347e48613385d9c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f347e48613385d9c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f347e48613385d9c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f347e48613385d9c$var$bindInputValue(el, value);
            break;
        case "style":
            $f347e48613385d9c$var$bindStyles(el, value);
            break;
        case "class":
            $f347e48613385d9c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f347e48613385d9c$var$bindAttribute(el, name, value);
            break;
    }
}
function $f347e48613385d9c$var$bindInputValue(el, value) {
    if ($f347e48613385d9c$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $f347e48613385d9c$var$safeParseBoolean(el.value) === value;
            else el.checked = $f347e48613385d9c$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($f347e48613385d9c$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f347e48613385d9c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f347e48613385d9c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f347e48613385d9c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f347e48613385d9c$var$setClasses(el, value);
}
function $f347e48613385d9c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f347e48613385d9c$var$setStyles(el, value);
}
function $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value) {
    $f347e48613385d9c$var$bindAttribute(el, name, value);
    $f347e48613385d9c$var$setPropertyIfChanged(el, name, value);
}
function $f347e48613385d9c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f347e48613385d9c$var$isBooleanAttr(name)) value = name;
        $f347e48613385d9c$var$setIfChanged(el, name, value);
    }
}
function $f347e48613385d9c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f347e48613385d9c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f347e48613385d9c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f347e48613385d9c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $f347e48613385d9c$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $f347e48613385d9c$var$isBooleanAttr(attrName) {
    return $f347e48613385d9c$var$booleanAttributes.has(attrName);
}
function $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f347e48613385d9c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f347e48613385d9c$var$dontAutoEvaluateFunctions(()=>{
            return $f347e48613385d9c$var$evaluate(el, binding.expression);
        });
    }
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f347e48613385d9c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $f347e48613385d9c$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $f347e48613385d9c$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $f347e48613385d9c$var$debounce(func, wait) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f347e48613385d9c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f347e48613385d9c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $f347e48613385d9c$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($f347e48613385d9c$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $f347e48613385d9c$var$release(reference);
    };
}
function $f347e48613385d9c$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $f347e48613385d9c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f347e48613385d9c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f347e48613385d9c$var$stores = {};
var $f347e48613385d9c$var$isReactive = false;
function $f347e48613385d9c$var$store(name, value) {
    if (!$f347e48613385d9c$var$isReactive) {
        $f347e48613385d9c$var$stores = $f347e48613385d9c$var$reactive($f347e48613385d9c$var$stores);
        $f347e48613385d9c$var$isReactive = true;
    }
    if (value === void 0) return $f347e48613385d9c$var$stores[name];
    $f347e48613385d9c$var$stores[name] = value;
    $f347e48613385d9c$var$initInterceptors($f347e48613385d9c$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f347e48613385d9c$var$stores[name].init();
}
function $f347e48613385d9c$var$getStores() {
    return $f347e48613385d9c$var$stores;
}
// packages/alpinejs/src/binds.js
var $f347e48613385d9c$var$binds = {};
function $f347e48613385d9c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f347e48613385d9c$var$applyBindingsObject(name, getBindings());
    else $f347e48613385d9c$var$binds[name] = getBindings;
    return ()=>{};
}
function $f347e48613385d9c$var$injectBindingProviders(obj) {
    Object.entries($f347e48613385d9c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f347e48613385d9c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f347e48613385d9c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f347e48613385d9c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f347e48613385d9c$var$datas = {};
function $f347e48613385d9c$var$data(name, callback) {
    $f347e48613385d9c$var$datas[name] = callback;
}
function $f347e48613385d9c$var$injectDataProviders(obj, context) {
    Object.entries($f347e48613385d9c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f347e48613385d9c$var$Alpine = {
    get reactive () {
        return $f347e48613385d9c$var$reactive;
    },
    get release () {
        return $f347e48613385d9c$var$release;
    },
    get effect () {
        return $f347e48613385d9c$var$effect;
    },
    get raw () {
        return $f347e48613385d9c$var$raw;
    },
    version: "3.14.9",
    flushAndStopDeferringMutations: $f347e48613385d9c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f347e48613385d9c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f347e48613385d9c$var$disableEffectScheduling,
    startObservingMutations: $f347e48613385d9c$var$startObservingMutations,
    stopObservingMutations: $f347e48613385d9c$var$stopObservingMutations,
    setReactivityEngine: $f347e48613385d9c$var$setReactivityEngine,
    onAttributeRemoved: $f347e48613385d9c$var$onAttributeRemoved,
    onAttributesAdded: $f347e48613385d9c$var$onAttributesAdded,
    closestDataStack: $f347e48613385d9c$var$closestDataStack,
    skipDuringClone: $f347e48613385d9c$var$skipDuringClone,
    onlyDuringClone: $f347e48613385d9c$var$onlyDuringClone,
    addRootSelector: $f347e48613385d9c$var$addRootSelector,
    addInitSelector: $f347e48613385d9c$var$addInitSelector,
    interceptClone: $f347e48613385d9c$var$interceptClone,
    addScopeToNode: $f347e48613385d9c$var$addScopeToNode,
    deferMutations: $f347e48613385d9c$var$deferMutations,
    mapAttributes: $f347e48613385d9c$var$mapAttributes,
    evaluateLater: $f347e48613385d9c$var$evaluateLater,
    interceptInit: $f347e48613385d9c$var$interceptInit,
    setEvaluator: $f347e48613385d9c$var$setEvaluator,
    mergeProxies: $f347e48613385d9c$var$mergeProxies,
    extractProp: $f347e48613385d9c$var$extractProp,
    findClosest: $f347e48613385d9c$var$findClosest,
    onElRemoved: $f347e48613385d9c$var$onElRemoved,
    closestRoot: $f347e48613385d9c$var$closestRoot,
    destroyTree: $f347e48613385d9c$var$destroyTree,
    interceptor: $f347e48613385d9c$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f347e48613385d9c$var$transition,
    setStyles: // INTERNAL
    $f347e48613385d9c$var$setStyles,
    mutateDom: // INTERNAL
    $f347e48613385d9c$var$mutateDom,
    directive: $f347e48613385d9c$var$directive,
    entangle: $f347e48613385d9c$var$entangle,
    throttle: $f347e48613385d9c$var$throttle,
    debounce: $f347e48613385d9c$var$debounce,
    evaluate: $f347e48613385d9c$var$evaluate,
    initTree: $f347e48613385d9c$var$initTree,
    nextTick: $f347e48613385d9c$var$nextTick,
    prefixed: $f347e48613385d9c$var$prefix,
    prefix: $f347e48613385d9c$var$setPrefix,
    plugin: $f347e48613385d9c$var$plugin,
    magic: $f347e48613385d9c$var$magic,
    store: $f347e48613385d9c$var$store,
    start: $f347e48613385d9c$var$start,
    clone: $f347e48613385d9c$var$clone,
    cloneNode: // INTERNAL
    $f347e48613385d9c$var$cloneNode,
    // INTERNAL
    bound: $f347e48613385d9c$var$getBinding,
    $data: $f347e48613385d9c$var$scope,
    watch: $f347e48613385d9c$var$watch,
    walk: $f347e48613385d9c$var$walk,
    data: $f347e48613385d9c$var$data,
    bind: $f347e48613385d9c$var$bind2
};
var $f347e48613385d9c$var$alpine_default = $f347e48613385d9c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f347e48613385d9c$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f347e48613385d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f347e48613385d9c$var$isBooleanAttr2 = /* @__PURE__ */ $f347e48613385d9c$var$makeMap($f347e48613385d9c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f347e48613385d9c$var$EMPTY_OBJ = Object.freeze({});
var $f347e48613385d9c$var$EMPTY_ARR = Object.freeze([]);
var $f347e48613385d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f347e48613385d9c$var$hasOwn = (val, key)=>$f347e48613385d9c$var$hasOwnProperty.call(val, key);
var $f347e48613385d9c$var$isArray = Array.isArray;
var $f347e48613385d9c$var$isMap = (val)=>$f347e48613385d9c$var$toTypeString(val) === "[object Map]";
var $f347e48613385d9c$var$isString = (val)=>typeof val === "string";
var $f347e48613385d9c$var$isSymbol = (val)=>typeof val === "symbol";
var $f347e48613385d9c$var$isObject = (val)=>val !== null && typeof val === "object";
var $f347e48613385d9c$var$objectToString = Object.prototype.toString;
var $f347e48613385d9c$var$toTypeString = (value)=>$f347e48613385d9c$var$objectToString.call(value);
var $f347e48613385d9c$var$toRawType = (value)=>{
    return $f347e48613385d9c$var$toTypeString(value).slice(8, -1);
};
var $f347e48613385d9c$var$isIntegerKey = (key)=>$f347e48613385d9c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f347e48613385d9c$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f347e48613385d9c$var$camelizeRE = /-(\w)/g;
var $f347e48613385d9c$var$camelize = $f347e48613385d9c$var$cacheStringFunction((str)=>{
    return str.replace($f347e48613385d9c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f347e48613385d9c$var$hyphenateRE = /\B([A-Z])/g;
var $f347e48613385d9c$var$hyphenate = $f347e48613385d9c$var$cacheStringFunction((str)=>str.replace($f347e48613385d9c$var$hyphenateRE, "-$1").toLowerCase());
var $f347e48613385d9c$var$capitalize = $f347e48613385d9c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f347e48613385d9c$var$toHandlerKey = $f347e48613385d9c$var$cacheStringFunction((str)=>str ? `on${$f347e48613385d9c$var$capitalize(str)}` : ``);
var $f347e48613385d9c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f347e48613385d9c$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$effectStack = [];
var $f347e48613385d9c$var$activeEffect;
var $f347e48613385d9c$var$ITERATE_KEY = Symbol("iterate");
var $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f347e48613385d9c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f347e48613385d9c$var$effect2(fn, options = $f347e48613385d9c$var$EMPTY_OBJ) {
    if ($f347e48613385d9c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f347e48613385d9c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f347e48613385d9c$var$stop(effect3) {
    if (effect3.active) {
        $f347e48613385d9c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f347e48613385d9c$var$uid = 0;
function $f347e48613385d9c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f347e48613385d9c$var$effectStack.includes(effect3)) {
            $f347e48613385d9c$var$cleanup(effect3);
            try {
                $f347e48613385d9c$var$enableTracking();
                $f347e48613385d9c$var$effectStack.push(effect3);
                $f347e48613385d9c$var$activeEffect = effect3;
                return fn();
            } finally{
                $f347e48613385d9c$var$effectStack.pop();
                $f347e48613385d9c$var$resetTracking();
                $f347e48613385d9c$var$activeEffect = $f347e48613385d9c$var$effectStack[$f347e48613385d9c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f347e48613385d9c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f347e48613385d9c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f347e48613385d9c$var$shouldTrack = true;
var $f347e48613385d9c$var$trackStack = [];
function $f347e48613385d9c$var$pauseTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = false;
}
function $f347e48613385d9c$var$enableTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = true;
}
function $f347e48613385d9c$var$resetTracking() {
    const last = $f347e48613385d9c$var$trackStack.pop();
    $f347e48613385d9c$var$shouldTrack = last === void 0 ? true : last;
}
function $f347e48613385d9c$var$track(target, type, key) {
    if (!$f347e48613385d9c$var$shouldTrack || $f347e48613385d9c$var$activeEffect === void 0) return;
    let depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) $f347e48613385d9c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($f347e48613385d9c$var$activeEffect)) {
        dep.add($f347e48613385d9c$var$activeEffect);
        $f347e48613385d9c$var$activeEffect.deps.push(dep);
        if ($f347e48613385d9c$var$activeEffect.options.onTrack) $f347e48613385d9c$var$activeEffect.options.onTrack({
            effect: $f347e48613385d9c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f347e48613385d9c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f347e48613385d9c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f347e48613385d9c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                } else if ($f347e48613385d9c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f347e48613385d9c$var$isNonTrackableKeys = /* @__PURE__ */ $f347e48613385d9c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f347e48613385d9c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f347e48613385d9c$var$isSymbol));
var $f347e48613385d9c$var$get2 = /* @__PURE__ */ $f347e48613385d9c$var$createGetter();
var $f347e48613385d9c$var$readonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true);
var $f347e48613385d9c$var$arrayInstrumentations = /* @__PURE__ */ $f347e48613385d9c$var$createArrayInstrumentations();
function $f347e48613385d9c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $f347e48613385d9c$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$f347e48613385d9c$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($f347e48613385d9c$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $f347e48613385d9c$var$pauseTracking();
            const res = $f347e48613385d9c$var$toRaw(this)[key].apply(this, args);
            $f347e48613385d9c$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $f347e48613385d9c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f347e48613385d9c$var$shallowReadonlyMap : $f347e48613385d9c$var$readonlyMap : shallow ? $f347e48613385d9c$var$shallowReactiveMap : $f347e48613385d9c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f347e48613385d9c$var$isArray(target);
        if (!isReadonly && targetIsArray && $f347e48613385d9c$var$hasOwn($f347e48613385d9c$var$arrayInstrumentations, key)) return Reflect.get($f347e48613385d9c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f347e48613385d9c$var$isSymbol(key) ? $f347e48613385d9c$var$builtInSymbols.has(key) : $f347e48613385d9c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f347e48613385d9c$var$track(target, "get", key);
        if (shallow) return res;
        if ($f347e48613385d9c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f347e48613385d9c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f347e48613385d9c$var$isObject(res)) return isReadonly ? $f347e48613385d9c$var$readonly(res) : $f347e48613385d9c$var$reactive2(res);
        return res;
    };
}
var $f347e48613385d9c$var$set2 = /* @__PURE__ */ $f347e48613385d9c$var$createSetter();
function $f347e48613385d9c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f347e48613385d9c$var$toRaw(value);
            oldValue = $f347e48613385d9c$var$toRaw(oldValue);
            if (!$f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isRef(oldValue) && !$f347e48613385d9c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isIntegerKey(key) ? Number(key) < target.length : $f347e48613385d9c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f347e48613385d9c$var$toRaw(receiver)) {
            if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
            else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f347e48613385d9c$var$deleteProperty(target, key) {
    const hadKey = $f347e48613385d9c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f347e48613385d9c$var$isSymbol(key) || !$f347e48613385d9c$var$builtInSymbols.has(key)) $f347e48613385d9c$var$track(target, "has", key);
    return result;
}
function $f347e48613385d9c$var$ownKeys(target) {
    $f347e48613385d9c$var$track(target, "iterate", $f347e48613385d9c$var$isArray(target) ? "length" : $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f347e48613385d9c$var$mutableHandlers = {
    get: $f347e48613385d9c$var$get2,
    set: $f347e48613385d9c$var$set2,
    deleteProperty: $f347e48613385d9c$var$deleteProperty,
    has: $f347e48613385d9c$var$has,
    ownKeys: $f347e48613385d9c$var$ownKeys
};
var $f347e48613385d9c$var$readonlyHandlers = {
    get: $f347e48613385d9c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f347e48613385d9c$var$toReactive = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$reactive2(value) : value;
var $f347e48613385d9c$var$toReadonly = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$readonly(value) : value;
var $f347e48613385d9c$var$toShallow = (value)=>value;
var $f347e48613385d9c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f347e48613385d9c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f347e48613385d9c$var$getProto(rawTarget);
    const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f347e48613385d9c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f347e48613385d9c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f347e48613385d9c$var$track($f347e48613385d9c$var$toRaw(target), "iterate", $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f347e48613385d9c$var$add(value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const proto = $f347e48613385d9c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f347e48613385d9c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f347e48613385d9c$var$set$1(key, value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
    else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f347e48613385d9c$var$deleteEntry(key) {
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$clear() {
    const target = $f347e48613385d9c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f347e48613385d9c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f347e48613385d9c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f347e48613385d9c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", $f347e48613385d9c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f347e48613385d9c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const targetIsMap = $f347e48613385d9c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", isKeyOnly ? $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY : $f347e48613385d9c$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f347e48613385d9c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f347e48613385d9c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f347e48613385d9c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $f347e48613385d9c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, false, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$f347e48613385d9c$var$mutableInstrumentations, $f347e48613385d9c$var$readonlyInstrumentations, $f347e48613385d9c$var$shallowInstrumentations, $f347e48613385d9c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentations();
function $f347e48613385d9c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f347e48613385d9c$var$shallowReadonlyInstrumentations : $f347e48613385d9c$var$shallowInstrumentations : isReadonly ? $f347e48613385d9c$var$readonlyInstrumentations : $f347e48613385d9c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f347e48613385d9c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f347e48613385d9c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(false, false)
};
var $f347e48613385d9c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(true, false)
};
function $f347e48613385d9c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f347e48613385d9c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f347e48613385d9c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f347e48613385d9c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f347e48613385d9c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f347e48613385d9c$var$targetTypeMap($f347e48613385d9c$var$toRawType(value));
}
function $f347e48613385d9c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f347e48613385d9c$var$createReactiveObject(target, false, $f347e48613385d9c$var$mutableHandlers, $f347e48613385d9c$var$mutableCollectionHandlers, $f347e48613385d9c$var$reactiveMap);
}
function $f347e48613385d9c$var$readonly(target) {
    return $f347e48613385d9c$var$createReactiveObject(target, true, $f347e48613385d9c$var$readonlyHandlers, $f347e48613385d9c$var$readonlyCollectionHandlers, $f347e48613385d9c$var$readonlyMap);
}
function $f347e48613385d9c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f347e48613385d9c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f347e48613385d9c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f347e48613385d9c$var$toRaw(observed) {
    return observed && $f347e48613385d9c$var$toRaw(observed["__v_raw"]) || observed;
}
function $f347e48613385d9c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f347e48613385d9c$var$magic("nextTick", ()=>$f347e48613385d9c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f347e48613385d9c$var$magic("dispatch", (el)=>$f347e48613385d9c$var$dispatch.bind($f347e48613385d9c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f347e48613385d9c$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $f347e48613385d9c$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$f347e48613385d9c$var$magic("store", $f347e48613385d9c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f347e48613385d9c$var$magic("data", (el)=>$f347e48613385d9c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f347e48613385d9c$var$magic("root", (el)=>$f347e48613385d9c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f347e48613385d9c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f347e48613385d9c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $f347e48613385d9c$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f347e48613385d9c$var$globalIdMemo = {};
function $f347e48613385d9c$var$findAndIncrementId(name) {
    if (!$f347e48613385d9c$var$globalIdMemo[name]) $f347e48613385d9c$var$globalIdMemo[name] = 0;
    return ++$f347e48613385d9c$var$globalIdMemo[name];
}
function $f347e48613385d9c$var$closestIdRoot(el, name) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f347e48613385d9c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f347e48613385d9c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f347e48613385d9c$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $f347e48613385d9c$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $f347e48613385d9c$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$f347e48613385d9c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f347e48613385d9c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f347e48613385d9c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f347e48613385d9c$var$warnMissingPluginMagic(name, magicName, slug) {
    $f347e48613385d9c$var$magic(magicName, (el)=>$f347e48613385d9c$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f347e48613385d9c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f347e48613385d9c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$f347e48613385d9c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f347e48613385d9c$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $f347e48613385d9c$var$skipDuringClone(()=>{
            $f347e48613385d9c$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $f347e48613385d9c$var$getTarget(expression);
        $f347e48613385d9c$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$f347e48613385d9c$var$mutateDom(()=>{
            clone2.remove();
            $f347e48613385d9c$var$destroyTree(clone2);
        }));
});
var $f347e48613385d9c$var$teleportContainerDuringClone = document.createElement("div");
function $f347e48613385d9c$var$getTarget(expression) {
    let target = $f347e48613385d9c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f347e48613385d9c$var$teleportContainerDuringClone;
    })();
    if (!target) $f347e48613385d9c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $f347e48613385d9c$var$handler = ()=>{};
$f347e48613385d9c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f347e48613385d9c$var$directive("ignore", $f347e48613385d9c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f347e48613385d9c$var$directive("effect", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($f347e48613385d9c$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $f347e48613385d9c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f347e48613385d9c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f347e48613385d9c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($f347e48613385d9c$var$isKeyEvent(event) || $f347e48613385d9c$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f347e48613385d9c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f347e48613385d9c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f347e48613385d9c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f347e48613385d9c$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f347e48613385d9c$var$isClickEvent(e.type)) return false;
            if ($f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f347e48613385d9c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f347e48613385d9c$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f347e48613385d9c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f347e48613385d9c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f347e48613385d9c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f347e48613385d9c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f347e48613385d9c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    var event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f347e48613385d9c$var$isCloning ? ()=>{} : $f347e48613385d9c$var$on(el, event, modifiers, (e)=>{
        setValue($f347e48613385d9c$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $f347e48613385d9c$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($f347e48613385d9c$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f347e48613385d9c$var$on(el.form, "reset", [], (e)=>{
            $f347e48613385d9c$var$nextTick(()=>el._x_model && el._x_model.set($f347e48613385d9c$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f347e48613385d9c$var$getInputValue(el, modifiers, event, currentValue) {
    return $f347e48613385d9c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($f347e48613385d9c$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $f347e48613385d9c$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $f347e48613385d9c$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f347e48613385d9c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($f347e48613385d9c$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $f347e48613385d9c$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $f347e48613385d9c$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $f347e48613385d9c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f347e48613385d9c$var$isNumeric2(number) ? number : rawValue;
}
function $f347e48613385d9c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f347e48613385d9c$var$directive("cloak", (el)=>queueMicrotask(()=>$f347e48613385d9c$var$mutateDom(()=>el.removeAttribute($f347e48613385d9c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f347e48613385d9c$var$addInitSelector(()=>`[${$f347e48613385d9c$var$prefix("init")}]`);
$f347e48613385d9c$var$directive("init", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f347e48613385d9c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f347e48613385d9c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f347e48613385d9c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith(":", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("bind:"))));
var $f347e48613385d9c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $f347e48613385d9c$var$injectBindingProviders(bindingProviders);
        let getBindings = $f347e48613385d9c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f347e48613385d9c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f347e48613385d9c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$f347e48613385d9c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f347e48613385d9c$var$directive("bind", $f347e48613385d9c$var$handler2);
function $f347e48613385d9c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f347e48613385d9c$var$addRootSelector(()=>`[${$f347e48613385d9c$var$prefix("data")}]`);
$f347e48613385d9c$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f347e48613385d9c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f347e48613385d9c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f347e48613385d9c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f347e48613385d9c$var$injectMagics(data2, el);
    let reactiveData = $f347e48613385d9c$var$reactive(data2);
    $f347e48613385d9c$var$initInterceptors(reactiveData);
    let undo = $f347e48613385d9c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f347e48613385d9c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f347e48613385d9c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f347e48613385d9c$var$isCloning) return false;
    if ($f347e48613385d9c$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$f347e48613385d9c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f347e48613385d9c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f347e48613385d9c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f347e48613385d9c$var$parseForExpression(expression);
    let evaluateItems = $f347e48613385d9c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f347e48613385d9c$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f347e48613385d9c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f347e48613385d9c$var$mutateDom(()=>{
                if (!elForSpot) $f347e48613385d9c$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f347e48613385d9c$var$reactive(scope2);
            $f347e48613385d9c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f347e48613385d9c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
            });
            if (typeof key === "object") $f347e48613385d9c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f347e48613385d9c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f347e48613385d9c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f347e48613385d9c$var$handler3() {}
$f347e48613385d9c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f347e48613385d9c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f347e48613385d9c$var$directive("ref", $f347e48613385d9c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f347e48613385d9c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
        $f347e48613385d9c$var$mutateDom(()=>{
            el.after(clone2);
            $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f347e48613385d9c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f347e48613385d9c$var$setIdRoot(el, name));
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith("@", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("on:"))));
$f347e48613385d9c$var$directive("on", $f347e48613385d9c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f347e48613385d9c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f347e48613385d9c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f347e48613385d9c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f347e48613385d9c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f347e48613385d9c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f347e48613385d9c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f347e48613385d9c$var$warnMissingPluginDirective(name, directiveName, slug) {
    $f347e48613385d9c$var$directive(directiveName, (el)=>$f347e48613385d9c$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f347e48613385d9c$var$alpine_default.setEvaluator($f347e48613385d9c$var$normalEvaluator);
$f347e48613385d9c$var$alpine_default.setReactivityEngine({
    reactive: $f347e48613385d9c$var$reactive2,
    effect: $f347e48613385d9c$var$effect2,
    release: $f347e48613385d9c$var$stop,
    raw: $f347e48613385d9c$var$toRaw
});
var $f347e48613385d9c$export$b7ee041e4ad2afec = $f347e48613385d9c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f347e48613385d9c$export$2e2bcd8739ae039 = $f347e48613385d9c$export$b7ee041e4ad2afec;



var $lrtgD = parcelRequire("lrtgD");

var $bV58F = parcelRequire("bV58F");

var $lguVw = parcelRequire("lguVw");

var $busg4 = parcelRequire("busg4");

var $cSEGC = parcelRequire("cSEGC");

var $8DTOO = parcelRequire("8DTOO");

var $bKHmb = parcelRequire("bKHmb");

var $aFSg5 = parcelRequire("aFSg5");

var $b4EcM = parcelRequire("b4EcM");

var $1c3wp = parcelRequire("1c3wp");

var $46Bky = parcelRequire("46Bky");

var $eokEX = parcelRequire("eokEX");

var $d6Hx1 = parcelRequire("d6Hx1");
var $2bd4b9c31e857ffa$var$Events = /** @class */ function() {
    function Events(eventType, eventFunctions) {
        if (eventFunctions === void 0) eventFunctions = [];
        this._eventType = eventType;
        this._eventFunctions = eventFunctions;
    }
    Events.prototype.init = function() {
        var _this = this;
        this._eventFunctions.forEach(function(eventFunction) {
            if (typeof window !== 'undefined') window.addEventListener(_this._eventType, eventFunction);
        });
    };
    return Events;
}();
var $2bd4b9c31e857ffa$export$2e2bcd8739ae039 = $2bd4b9c31e857ffa$var$Events;


var $5d5682da381fac09$var$Instances = /** @class */ function() {
    function Instances() {
        this._instances = {
            Accordion: {},
            Carousel: {},
            Collapse: {},
            Dial: {},
            Dismiss: {},
            Drawer: {},
            Dropdown: {},
            Modal: {},
            Popover: {},
            Tabs: {},
            Tooltip: {},
            InputCounter: {},
            CopyClipboard: {},
            Datepicker: {}
        };
    }
    Instances.prototype.addInstance = function(component, instance, id, override) {
        if (override === void 0) override = false;
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (this._instances[component][id] && !override) {
            console.warn("Flowbite: Instance with ID ".concat(id, " already exists."));
            return;
        }
        if (override && this._instances[component][id]) this._instances[component][id].destroyAndRemoveInstance();
        this._instances[component][id ? id : this._generateRandomId()] = instance;
    };
    Instances.prototype.getAllInstances = function() {
        return this._instances;
    };
    Instances.prototype.getInstances = function(component) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        return this._instances[component];
    };
    Instances.prototype.getInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return;
        }
        return this._instances[component][id];
    };
    Instances.prototype.destroyAndRemoveInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this.destroyInstanceObject(component, id);
        this.removeInstance(component, id);
    };
    Instances.prototype.removeInstance = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        delete this._instances[component][id];
    };
    Instances.prototype.destroyInstanceObject = function(component, id) {
        if (!this._componentAndInstanceCheck(component, id)) return;
        this._instances[component][id].destroy();
    };
    Instances.prototype.instanceExists = function(component, id) {
        if (!this._instances[component]) return false;
        if (!this._instances[component][id]) return false;
        return true;
    };
    Instances.prototype._generateRandomId = function() {
        return Math.random().toString(36).substr(2, 9);
    };
    Instances.prototype._componentAndInstanceCheck = function(component, id) {
        if (!this._instances[component]) {
            console.warn("Flowbite: Component ".concat(component, " does not exist."));
            return false;
        }
        if (!this._instances[component][id]) {
            console.warn("Flowbite: Instance with ID ".concat(id, " does not exist."));
            return false;
        }
        return true;
    };
    return Instances;
}();
var $5d5682da381fac09$var$instances = new $5d5682da381fac09$var$Instances();
var $5d5682da381fac09$export$2e2bcd8739ae039 = $5d5682da381fac09$var$instances;
if (typeof window !== 'undefined') window.FlowbiteInstances = $5d5682da381fac09$var$instances;


var $d93a619a461d9c03$var$__assign = undefined && undefined.__assign || function() {
    $d93a619a461d9c03$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d93a619a461d9c03$var$__assign.apply(this, arguments);
};
var $d93a619a461d9c03$var$Default = {
    alwaysOpen: false,
    activeClasses: 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-white',
    inactiveClasses: 'text-gray-500 dark:text-gray-400',
    onOpen: function() {},
    onClose: function() {},
    onToggle: function() {}
};
var $d93a619a461d9c03$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $d93a619a461d9c03$var$Accordion = /** @class */ function() {
    function Accordion(accordionEl, items, options, instanceOptions) {
        if (accordionEl === void 0) accordionEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $d93a619a461d9c03$var$Default;
        if (instanceOptions === void 0) instanceOptions = $d93a619a461d9c03$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : accordionEl.id;
        this._accordionEl = accordionEl;
        this._items = items;
        this._options = $d93a619a461d9c03$var$__assign($d93a619a461d9c03$var$__assign({}, $d93a619a461d9c03$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Accordion', this, this._instanceId, instanceOptions.override);
    }
    Accordion.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // show accordion item based on click
            this._items.forEach(function(item) {
                if (item.active) _this.open(item.id);
                var clickHandler = function() {
                    _this.toggle(item.id);
                };
                item.triggerEl.addEventListener('click', clickHandler);
                // Store the clickHandler in a property of the item for removal later
                item.clickHandler = clickHandler;
            });
            this._initialized = true;
        }
    };
    Accordion.prototype.destroy = function() {
        if (this._items.length && this._initialized) {
            this._items.forEach(function(item) {
                item.triggerEl.removeEventListener('click', item.clickHandler);
                // Clean up by deleting the clickHandler property from the item
                delete item.clickHandler;
            });
            this._initialized = false;
        }
    };
    Accordion.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Accordion', this._instanceId);
    };
    Accordion.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Accordion.prototype.getItem = function(id) {
        return this._items.filter(function(item) {
            return item.id === id;
        })[0];
    };
    Accordion.prototype.open = function(id) {
        var _a, _b;
        var _this = this;
        var item = this.getItem(id);
        // don't hide other accordions if always open
        if (!this._options.alwaysOpen) this._items.map(function(i) {
            var _a, _b;
            if (i !== item) {
                (_a = i.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(' '));
                (_b = i.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(' '));
                i.targetEl.classList.add('hidden');
                i.triggerEl.setAttribute('aria-expanded', 'false');
                i.active = false;
                // rotate icon if set
                if (i.iconEl) i.iconEl.classList.add('rotate-180');
            }
        });
        // show active item
        (_a = item.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(' '));
        (_b = item.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(' '));
        item.triggerEl.setAttribute('aria-expanded', 'true');
        item.targetEl.classList.remove('hidden');
        item.active = true;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.remove('rotate-180');
        // callback function
        this._options.onOpen(this, item);
    };
    Accordion.prototype.toggle = function(id) {
        var item = this.getItem(id);
        if (item.active) this.close(id);
        else this.open(id);
        // callback function
        this._options.onToggle(this, item);
    };
    Accordion.prototype.close = function(id) {
        var _a, _b;
        var item = this.getItem(id);
        (_a = item.triggerEl.classList).remove.apply(_a, this._options.activeClasses.split(' '));
        (_b = item.triggerEl.classList).add.apply(_b, this._options.inactiveClasses.split(' '));
        item.targetEl.classList.add('hidden');
        item.triggerEl.setAttribute('aria-expanded', 'false');
        item.active = false;
        // rotate icon if set
        if (item.iconEl) item.iconEl.classList.add('rotate-180');
        // callback function
        this._options.onClose(this, item);
    };
    Accordion.prototype.updateOnOpen = function(callback) {
        this._options.onOpen = callback;
    };
    Accordion.prototype.updateOnClose = function(callback) {
        this._options.onClose = callback;
    };
    Accordion.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Accordion;
}();
function $d93a619a461d9c03$export$226c1dc98323ee4d() {
    document.querySelectorAll('[data-accordion]').forEach(function($accordionEl) {
        var alwaysOpen = $accordionEl.getAttribute('data-accordion');
        var activeClasses = $accordionEl.getAttribute('data-active-classes');
        var inactiveClasses = $accordionEl.getAttribute('data-inactive-classes');
        var items = [];
        $accordionEl.querySelectorAll('[data-accordion-target]').forEach(function($triggerEl) {
            // Consider only items that directly belong to $accordionEl
            // (to make nested accordions work).
            if ($triggerEl.closest('[data-accordion]') === $accordionEl) {
                var item = {
                    id: $triggerEl.getAttribute('data-accordion-target'),
                    triggerEl: $triggerEl,
                    targetEl: document.querySelector($triggerEl.getAttribute('data-accordion-target')),
                    iconEl: $triggerEl.querySelector('[data-accordion-icon]'),
                    active: $triggerEl.getAttribute('aria-expanded') === 'true' ? true : false
                };
                items.push(item);
            }
        });
        new $d93a619a461d9c03$var$Accordion($accordionEl, items, {
            alwaysOpen: alwaysOpen === 'open' ? true : false,
            activeClasses: activeClasses ? activeClasses : $d93a619a461d9c03$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $d93a619a461d9c03$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== 'undefined') {
    window.Accordion = $d93a619a461d9c03$var$Accordion;
    window.initAccordions = $d93a619a461d9c03$export$226c1dc98323ee4d;
}
var $d93a619a461d9c03$export$2e2bcd8739ae039 = $d93a619a461d9c03$var$Accordion;



var $fc7ccf099a511882$var$__assign = undefined && undefined.__assign || function() {
    $fc7ccf099a511882$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc7ccf099a511882$var$__assign.apply(this, arguments);
};
var $fc7ccf099a511882$var$Default = {
    onCollapse: function() {},
    onExpand: function() {},
    onToggle: function() {}
};
var $fc7ccf099a511882$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $fc7ccf099a511882$var$Collapse = /** @class */ function() {
    function Collapse(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $fc7ccf099a511882$var$Default;
        if (instanceOptions === void 0) instanceOptions = $fc7ccf099a511882$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $fc7ccf099a511882$var$__assign($fc7ccf099a511882$var$__assign({}, $fc7ccf099a511882$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Collapse', this, this._instanceId, instanceOptions.override);
    }
    Collapse.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            if (this._triggerEl.hasAttribute('aria-expanded')) this._visible = this._triggerEl.getAttribute('aria-expanded') === 'true';
            else // fix until v2 not to break previous single collapses which became dismiss
            this._visible = !this._targetEl.classList.contains('hidden');
            this._clickHandler = function() {
                _this.toggle();
            };
            this._triggerEl.addEventListener('click', this._clickHandler);
            this._initialized = true;
        }
    };
    Collapse.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener('click', this._clickHandler);
            this._initialized = false;
        }
    };
    Collapse.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Collapse', this._instanceId);
    };
    Collapse.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Collapse.prototype.collapse = function() {
        this._targetEl.classList.add('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'false');
        this._visible = false;
        // callback function
        this._options.onCollapse(this);
    };
    Collapse.prototype.expand = function() {
        this._targetEl.classList.remove('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'true');
        this._visible = true;
        // callback function
        this._options.onExpand(this);
    };
    Collapse.prototype.toggle = function() {
        if (this._visible) this.collapse();
        else this.expand();
        // callback function
        this._options.onToggle(this);
    };
    Collapse.prototype.updateOnCollapse = function(callback) {
        this._options.onCollapse = callback;
    };
    Collapse.prototype.updateOnExpand = function(callback) {
        this._options.onExpand = callback;
    };
    Collapse.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Collapse;
}();
function $fc7ccf099a511882$export$355ba5a528b4009a() {
    document.querySelectorAll('[data-collapse-toggle]').forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute('data-collapse-toggle');
        var $targetEl = document.getElementById(targetId);
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $5d5682da381fac09$export$2e2bcd8739ae039).instanceExists('Collapse', $targetEl.getAttribute('id'))) new $fc7ccf099a511882$var$Collapse($targetEl, $triggerEl);
            else // if instance exists already for the same target element then create a new one with a different trigger element
            new $fc7ccf099a511882$var$Collapse($targetEl, $triggerEl, {}, {
                id: $targetEl.getAttribute('id') + '_' + (0, $5d5682da381fac09$export$2e2bcd8739ae039)._generateRandomId()
            });
        } else console.error("The target element with id \"".concat(targetId, "\" does not exist. Please check the data-collapse-toggle attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Collapse = $fc7ccf099a511882$var$Collapse;
    window.initCollapses = $fc7ccf099a511882$export$355ba5a528b4009a;
}
var $fc7ccf099a511882$export$2e2bcd8739ae039 = $fc7ccf099a511882$var$Collapse;



var $c1b11beef829dd56$var$__assign = undefined && undefined.__assign || function() {
    $c1b11beef829dd56$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c1b11beef829dd56$var$__assign.apply(this, arguments);
};
var $c1b11beef829dd56$var$Default = {
    defaultPosition: 0,
    indicators: {
        items: [],
        activeClasses: 'bg-white dark:bg-gray-800',
        inactiveClasses: 'bg-white/50 dark:bg-gray-800/50 hover:bg-white dark:hover:bg-gray-800'
    },
    interval: 3000,
    onNext: function() {},
    onPrev: function() {},
    onChange: function() {}
};
var $c1b11beef829dd56$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $c1b11beef829dd56$var$Carousel = /** @class */ function() {
    function Carousel(carouselEl, items, options, instanceOptions) {
        if (carouselEl === void 0) carouselEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $c1b11beef829dd56$var$Default;
        if (instanceOptions === void 0) instanceOptions = $c1b11beef829dd56$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : carouselEl.id;
        this._carouselEl = carouselEl;
        this._items = items;
        this._options = $c1b11beef829dd56$var$__assign($c1b11beef829dd56$var$__assign($c1b11beef829dd56$var$__assign({}, $c1b11beef829dd56$var$Default), options), {
            indicators: $c1b11beef829dd56$var$__assign($c1b11beef829dd56$var$__assign({}, $c1b11beef829dd56$var$Default.indicators), options.indicators)
        });
        this._activeItem = this.getItem(this._options.defaultPosition);
        this._indicators = this._options.indicators.items;
        this._intervalDuration = this._options.interval;
        this._intervalInstance = null;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Carousel', this, this._instanceId, instanceOptions.override);
    }
    /**
     * initialize carousel and items based on active one
     */ Carousel.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            this._items.map(function(item) {
                item.el.classList.add('absolute', 'inset-0', 'transition-transform', 'transform');
            });
            // if no active item is set then first position is default
            if (this.getActiveItem()) this.slideTo(this.getActiveItem().position);
            else this.slideTo(0);
            this._indicators.map(function(indicator, position) {
                indicator.el.addEventListener('click', function() {
                    _this.slideTo(position);
                });
            });
            this._initialized = true;
        }
    };
    Carousel.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Carousel.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Carousel', this._instanceId);
    };
    Carousel.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Carousel.prototype.getItem = function(position) {
        return this._items[position];
    };
    /**
     * Slide to the element based on id
     * @param {*} position
     */ Carousel.prototype.slideTo = function(position) {
        var nextItem = this._items[position];
        var rotationItems = {
            left: nextItem.position === 0 ? this._items[this._items.length - 1] : this._items[nextItem.position - 1],
            middle: nextItem,
            right: nextItem.position === this._items.length - 1 ? this._items[0] : this._items[nextItem.position + 1]
        };
        this._rotate(rotationItems);
        this._setActiveItem(nextItem);
        if (this._intervalInstance) {
            this.pause();
            this.cycle();
        }
        this._options.onChange(this);
    };
    /**
     * Based on the currently active item it will go to the next position
     */ Carousel.prototype.next = function() {
        var activeItem = this.getActiveItem();
        var nextItem = null;
        // check if last item
        if (activeItem.position === this._items.length - 1) nextItem = this._items[0];
        else nextItem = this._items[activeItem.position + 1];
        this.slideTo(nextItem.position);
        // callback function
        this._options.onNext(this);
    };
    /**
     * Based on the currently active item it will go to the previous position
     */ Carousel.prototype.prev = function() {
        var activeItem = this.getActiveItem();
        var prevItem = null;
        // check if first item
        if (activeItem.position === 0) prevItem = this._items[this._items.length - 1];
        else prevItem = this._items[activeItem.position - 1];
        this.slideTo(prevItem.position);
        // callback function
        this._options.onPrev(this);
    };
    /**
     * This method applies the transform classes based on the left, middle, and right rotation carousel items
     * @param {*} rotationItems
     */ Carousel.prototype._rotate = function(rotationItems) {
        // reset
        this._items.map(function(item) {
            item.el.classList.add('hidden');
        });
        // Handling the case when there is only one item
        if (this._items.length === 1) {
            rotationItems.middle.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-10');
            rotationItems.middle.el.classList.add('translate-x-0', 'z-20');
            return;
        }
        // left item (previously active)
        rotationItems.left.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-20');
        rotationItems.left.el.classList.add('-translate-x-full', 'z-10');
        // currently active item
        rotationItems.middle.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-10');
        rotationItems.middle.el.classList.add('translate-x-0', 'z-30');
        // right item (upcoming active)
        rotationItems.right.el.classList.remove('-translate-x-full', 'translate-x-full', 'translate-x-0', 'hidden', 'z-30');
        rotationItems.right.el.classList.add('translate-x-full', 'z-20');
    };
    /**
     * Set an interval to cycle through the carousel items
     */ Carousel.prototype.cycle = function() {
        var _this = this;
        if (typeof window !== 'undefined') this._intervalInstance = window.setInterval(function() {
            _this.next();
        }, this._intervalDuration);
    };
    /**
     * Clears the cycling interval
     */ Carousel.prototype.pause = function() {
        clearInterval(this._intervalInstance);
    };
    /**
     * Get the currently active item
     */ Carousel.prototype.getActiveItem = function() {
        return this._activeItem;
    };
    /**
     * Set the currently active item and data attribute
     * @param {*} position
     */ Carousel.prototype._setActiveItem = function(item) {
        var _a, _b;
        var _this = this;
        this._activeItem = item;
        var position = item.position;
        // update the indicators if available
        if (this._indicators.length) {
            this._indicators.map(function(indicator) {
                var _a, _b;
                indicator.el.setAttribute('aria-current', 'false');
                (_a = indicator.el.classList).remove.apply(_a, _this._options.indicators.activeClasses.split(' '));
                (_b = indicator.el.classList).add.apply(_b, _this._options.indicators.inactiveClasses.split(' '));
            });
            (_a = this._indicators[position].el.classList).add.apply(_a, this._options.indicators.activeClasses.split(' '));
            (_b = this._indicators[position].el.classList).remove.apply(_b, this._options.indicators.inactiveClasses.split(' '));
            this._indicators[position].el.setAttribute('aria-current', 'true');
        }
    };
    Carousel.prototype.updateOnNext = function(callback) {
        this._options.onNext = callback;
    };
    Carousel.prototype.updateOnPrev = function(callback) {
        this._options.onPrev = callback;
    };
    Carousel.prototype.updateOnChange = function(callback) {
        this._options.onChange = callback;
    };
    return Carousel;
}();
function $c1b11beef829dd56$export$3ab77386b16b9e58() {
    document.querySelectorAll('[data-carousel]').forEach(function($carouselEl) {
        var interval = $carouselEl.getAttribute('data-carousel-interval');
        var slide = $carouselEl.getAttribute('data-carousel') === 'slide' ? true : false;
        var items = [];
        var defaultPosition = 0;
        if ($carouselEl.querySelectorAll('[data-carousel-item]').length) Array.from($carouselEl.querySelectorAll('[data-carousel-item]')).map(function($carouselItemEl, position) {
            items.push({
                position: position,
                el: $carouselItemEl
            });
            if ($carouselItemEl.getAttribute('data-carousel-item') === 'active') defaultPosition = position;
        });
        var indicators = [];
        if ($carouselEl.querySelectorAll('[data-carousel-slide-to]').length) Array.from($carouselEl.querySelectorAll('[data-carousel-slide-to]')).map(function($indicatorEl) {
            indicators.push({
                position: parseInt($indicatorEl.getAttribute('data-carousel-slide-to')),
                el: $indicatorEl
            });
        });
        var carousel = new $c1b11beef829dd56$var$Carousel($carouselEl, items, {
            defaultPosition: defaultPosition,
            indicators: {
                items: indicators
            },
            interval: interval ? interval : $c1b11beef829dd56$var$Default.interval
        });
        if (slide) carousel.cycle();
        // check for controls
        var carouselNextEl = $carouselEl.querySelector('[data-carousel-next]');
        var carouselPrevEl = $carouselEl.querySelector('[data-carousel-prev]');
        if (carouselNextEl) carouselNextEl.addEventListener('click', function() {
            carousel.next();
        });
        if (carouselPrevEl) carouselPrevEl.addEventListener('click', function() {
            carousel.prev();
        });
    });
}
if (typeof window !== 'undefined') {
    window.Carousel = $c1b11beef829dd56$var$Carousel;
    window.initCarousels = $c1b11beef829dd56$export$3ab77386b16b9e58;
}
var $c1b11beef829dd56$export$2e2bcd8739ae039 = $c1b11beef829dd56$var$Carousel;



var $6d6d37a8acee51c1$var$__assign = undefined && undefined.__assign || function() {
    $6d6d37a8acee51c1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6d6d37a8acee51c1$var$__assign.apply(this, arguments);
};
var $6d6d37a8acee51c1$var$Default = {
    transition: 'transition-opacity',
    duration: 300,
    timing: 'ease-out',
    onHide: function() {}
};
var $6d6d37a8acee51c1$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $6d6d37a8acee51c1$var$Dismiss = /** @class */ function() {
    function Dismiss(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $6d6d37a8acee51c1$var$Default;
        if (instanceOptions === void 0) instanceOptions = $6d6d37a8acee51c1$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $6d6d37a8acee51c1$var$__assign($6d6d37a8acee51c1$var$__assign({}, $6d6d37a8acee51c1$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Dismiss', this, this._instanceId, instanceOptions.override);
    }
    Dismiss.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._clickHandler = function() {
                _this.hide();
            };
            this._triggerEl.addEventListener('click', this._clickHandler);
            this._initialized = true;
        }
    };
    Dismiss.prototype.destroy = function() {
        if (this._triggerEl && this._initialized) {
            this._triggerEl.removeEventListener('click', this._clickHandler);
            this._initialized = false;
        }
    };
    Dismiss.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Dismiss', this._instanceId);
    };
    Dismiss.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dismiss.prototype.hide = function() {
        var _this = this;
        this._targetEl.classList.add(this._options.transition, "duration-".concat(this._options.duration), this._options.timing, 'opacity-0');
        setTimeout(function() {
            _this._targetEl.classList.add('hidden');
        }, this._options.duration);
        // callback function
        this._options.onHide(this, this._targetEl);
    };
    Dismiss.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    return Dismiss;
}();
function $6d6d37a8acee51c1$export$69c84787a503daef() {
    document.querySelectorAll('[data-dismiss-target]').forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute('data-dismiss-target');
        var $dismissEl = document.querySelector(targetId);
        if ($dismissEl) new $6d6d37a8acee51c1$var$Dismiss($dismissEl, $triggerEl);
        else console.error("The dismiss element with id \"".concat(targetId, "\" does not exist. Please check the data-dismiss-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Dismiss = $6d6d37a8acee51c1$var$Dismiss;
    window.initDismisses = $6d6d37a8acee51c1$export$69c84787a503daef;
}
var $6d6d37a8acee51c1$export$2e2bcd8739ae039 = $6d6d37a8acee51c1$var$Dismiss;


function $df9341392e6ed7b1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $d98cb23738a6d9d0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d98cb23738a6d9d0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d98cb23738a6d9d0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $7e23bad950468b82$export$8960430cfd85939f = Math.max;
var $7e23bad950468b82$export$96ec731ed4dcb222 = Math.min;
var $7e23bad950468b82$export$2077e0241d6afd3c = Math.round;



function $90ccbd5892233dd2$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $993d40d65cc118cd$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
}


function $84019ab652aa921b$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $7e23bad950468b82$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $993d40d65cc118cd$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $68a584be1dc90596$export$2e2bcd8739ae039(node) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $9102221f9e13ae54$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ca14c6927ef497ac$export$2e2bcd8739ae039(node) {
    if (node === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(node) || !(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node)) return (0, $68a584be1dc90596$export$2e2bcd8739ae039)(node);
    else return (0, $9102221f9e13ae54$export$2e2bcd8739ae039)(node);
}


function $4f30cf0ce50e075e$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $433af39bc2fae35d$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $943aee5c7065ad53$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $84019ab652aa921b$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)).left + (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $41cae7042543c5d5$export$2e2bcd8739ae039(element) {
    return (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $18583dfdff147fd4$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $34abf65a06d63352$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $7e23bad950468b82$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $34abf65a06d63352$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent) && $34abf65a06d63352$var$isElementScaled(offsetParent);
    var documentElement = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ca14c6927ef497ac$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $30ced62b744c6cfe$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $17f6a21d28fc02f5$export$2e2bcd8739ae039(element) {
    if ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $3eb5703c925e0e5d$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(node) && (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(node)) return node;
    return $3eb5703c925e0e5d$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(node));
}





function $a621d360f1a81b88$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3eb5703c925e0e5d$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $18583dfdff147fd4$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a621d360f1a81b88$export$2e2bcd8739ae039((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(target)));
}







function $6829c22fb01dde5a$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a56b734280245ffb$var$getTrueOffsetParent(element) {
    if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a56b734280245ffb$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $90ccbd5892233dd2$export$2e2bcd8739ae039)());
    if (isIE && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element);
    if ((0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a56b734280245ffb$export$2e2bcd8739ae039(element) {
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6829c22fb01dde5a$export$2e2bcd8739ae039)(offsetParent) && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $a56b734280245ffb$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $a56b734280245ffb$var$getContainingBlock(element) || window;
}


var $f5c54167a3c62105$export$1e95b668f3b82d = 'top';
var $f5c54167a3c62105$export$40e543e69a8b3fbb = 'bottom';
var $f5c54167a3c62105$export$79ffe56a765070d2 = 'right';
var $f5c54167a3c62105$export$eabcd2c8791e7bf4 = 'left';
var $f5c54167a3c62105$export$dfb5619354ba860 = 'auto';
var $f5c54167a3c62105$export$aec2ce47c367b8c3 = [
    $f5c54167a3c62105$export$1e95b668f3b82d,
    $f5c54167a3c62105$export$40e543e69a8b3fbb,
    $f5c54167a3c62105$export$79ffe56a765070d2,
    $f5c54167a3c62105$export$eabcd2c8791e7bf4
];
var $f5c54167a3c62105$export$b3571188c770cc5a = 'start';
var $f5c54167a3c62105$export$bd5df0f255a350f8 = 'end';
var $f5c54167a3c62105$export$390fd549c5303b4d = 'clippingParents';
var $f5c54167a3c62105$export$d7b7311ec04a3e8f = 'viewport';
var $f5c54167a3c62105$export$ae5ab1c730825774 = 'popper';
var $f5c54167a3c62105$export$ca50aac9f3ba507f = 'reference';
var $f5c54167a3c62105$export$368f9a87e87fa4e1 = /*#__PURE__*/ $f5c54167a3c62105$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []);
var $f5c54167a3c62105$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($f5c54167a3c62105$export$aec2ce47c367b8c3, [
    $f5c54167a3c62105$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $f5c54167a3c62105$export$b3571188c770cc5a,
        placement + "-" + $f5c54167a3c62105$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $f5c54167a3c62105$export$421679a7c3d56e = 'beforeRead';
var $f5c54167a3c62105$export$aafa59e2e03f2942 = 'read';
var $f5c54167a3c62105$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $f5c54167a3c62105$export$c65e99957a05207c = 'beforeMain';
var $f5c54167a3c62105$export$f22da7240b7add18 = 'main';
var $f5c54167a3c62105$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $f5c54167a3c62105$export$8d4d2d70e7d46032 = 'beforeWrite';
var $f5c54167a3c62105$export$68d8715fc104d294 = 'write';
var $f5c54167a3c62105$export$70a6e5159acce2e6 = 'afterWrite';
var $f5c54167a3c62105$export$d087d3878fdf71d5 = [
    $f5c54167a3c62105$export$421679a7c3d56e,
    $f5c54167a3c62105$export$aafa59e2e03f2942,
    $f5c54167a3c62105$export$6964f6c886723980,
    $f5c54167a3c62105$export$c65e99957a05207c,
    $f5c54167a3c62105$export$f22da7240b7add18,
    $f5c54167a3c62105$export$bab79516f2d662fe,
    $f5c54167a3c62105$export$8d4d2d70e7d46032,
    $f5c54167a3c62105$export$68d8715fc104d294,
    $f5c54167a3c62105$export$70a6e5159acce2e6
];


function $0baf5472b5ad4a5a$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0baf5472b5ad4a5a$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0baf5472b5ad4a5a$var$order(modifiers); // order based on phase
    return (0, $f5c54167a3c62105$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b65b878009bf47f$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $46d929ffbbd3136a$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b3c2fd6800546b4b$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b3c2fd6800546b4b$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b3c2fd6800546b4b$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b3c2fd6800546b4b$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b3c2fd6800546b4b$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(reference) ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $a621d360f1a81b88$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $0baf5472b5ad4a5a$export$2e2bcd8739ae039)((0, $46d929ffbbd3136a$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $34abf65a06d63352$export$2e2bcd8739ae039)(reference, (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b65b878009bf47f$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b3c2fd6800546b4b$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b3c2fd6800546b4b$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b3c2fd6800546b4b$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $ff355aafd082b0cd$var$passive = {
    passive: true
};
function $ff355aafd082b0cd$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $ff355aafd082b0cd$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $ff355aafd082b0cd$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $ff355aafd082b0cd$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $ff355aafd082b0cd$var$effect,
    data: {}
};



function $afe288682115fde3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $7b08f0526e425773$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $b518c35b71cf930f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $03cba2f7a1498b5f$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $f5c54167a3c62105$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $f5c54167a3c62105$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $f5c54167a3c62105$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $f5c54167a3c62105$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $f5c54167a3c62105$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $f5c54167a3c62105$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e92fb10df1450f31$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e92fb10df1450f31$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e92fb10df1450f31$var$popperOffsets,
    data: {}
};










var $c8f8eadcf7685dc5$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $c8f8eadcf7685dc5$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $7e23bad950468b82$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $c8f8eadcf7685dc5$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var sideY = (0, $f5c54167a3c62105$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(popper);
            if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || placement === (0, $f5c54167a3c62105$export$79ffe56a765070d2)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideY = (0, $f5c54167a3c62105$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) || (placement === (0, $f5c54167a3c62105$export$1e95b668f3b82d) || placement === (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)) && variation === (0, $f5c54167a3c62105$export$bd5df0f255a350f8)) {
            sideX = (0, $f5c54167a3c62105$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $c8f8eadcf7685dc5$var$unsetSides);
    var _ref4 = roundOffsets === true ? $c8f8eadcf7685dc5$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $c8f8eadcf7685dc5$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $c8f8eadcf7685dc5$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $c8f8eadcf7685dc5$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $c8f8eadcf7685dc5$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $83c1fc4c4e58d7dd$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $83c1fc4c4e58d7dd$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) || !(0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $83c1fc4c4e58d7dd$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $83c1fc4c4e58d7dd$var$applyStyles,
    effect: $83c1fc4c4e58d7dd$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $7c04da2e958a3fe8$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $f5c54167a3c62105$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $7c04da2e958a3fe8$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $7c04da2e958a3fe8$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $7c04da2e958a3fe8$var$offset
};


var $825ae98fe4f5d029$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $825ae98fe4f5d029$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $825ae98fe4f5d029$var$hash[matched];
    });
}



var $76c023b5f4bd6339$var$hash = {
    start: 'end',
    end: 'start'
};
function $76c023b5f4bd6339$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $76c023b5f4bd6339$var$hash[matched];
    });
}







function $7b0a0ce1fa68929f$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $df9341392e6ed7b1$export$2e2bcd8739ae039)(element);
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $993d40d65cc118cd$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $3e70615fb3e74824$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $68a584be1dc90596$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $7e23bad950468b82$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $943aee5c7065ad53$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $7e23bad950468b82$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $d63950b756706495$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $d98cb23738a6d9d0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $b0d5f0927fb8bf5c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $631049efb60e96c6$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) ? (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $7b0a0ce1fa68929f$export$2e2bcd8739ae039)(element, strategy)) : (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) ? $631049efb60e96c6$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)((0, $3e70615fb3e74824$export$2e2bcd8739ae039)((0, $433af39bc2fae35d$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $631049efb60e96c6$var$getClippingParents(element) {
    var clippingParents = (0, $a621d360f1a81b88$export$2e2bcd8739ae039)((0, $17f6a21d28fc02f5$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $41cae7042543c5d5$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $d98cb23738a6d9d0$export$1b3bfaa9684536aa)(element) ? (0, $a56b734280245ffb$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $d63950b756706495$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $4f30cf0ce50e075e$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $631049efb60e96c6$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $631049efb60e96c6$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $631049efb60e96c6$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $7e23bad950468b82$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $7e23bad950468b82$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $631049efb60e96c6$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $683c5e26d5f8bfe5$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $387b887da02b7e69$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)(), paddingObject);
}


function $4d11a6decde23bf9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $f765731200b57f98$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $f5c54167a3c62105$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $f5c54167a3c62105$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $f5c54167a3c62105$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? (0, $f5c54167a3c62105$export$ca50aac9f3ba507f) : (0, $f5c54167a3c62105$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $631049efb60e96c6$export$2e2bcd8739ae039)((0, $d98cb23738a6d9d0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $433af39bc2fae35d$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $84019ab652aa921b$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $03cba2f7a1498b5f$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $b0d5f0927fb8bf5c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $f5c54167a3c62105$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $f5c54167a3c62105$export$79ffe56a765070d2),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $f5c54167a3c62105$export$1e95b668f3b82d),
                (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dbd70d4ba9902caa$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $f5c54167a3c62105$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $f5c54167a3c62105$export$368f9a87e87fa4e1) : (0, $f5c54167a3c62105$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $f5c54167a3c62105$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $afe288682115fde3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $b1f32a1d9525a032$var$getExpandedFallbackPlacements(placement) {
    if ((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(placement);
    return [
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $76c023b5f4bd6339$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $b1f32a1d9525a032$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $b1f32a1d9525a032$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $afe288682115fde3$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$dfb5619354ba860) ? (0, $dbd70d4ba9902caa$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(placement) === (0, $f5c54167a3c62105$export$b3571188c770cc5a);
        var isVertical = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $f5c54167a3c62105$export$79ffe56a765070d2) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $825ae98fe4f5d029$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $b1f32a1d9525a032$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $b1f32a1d9525a032$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $d8b68132b61080af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max) {
    return (0, $7e23bad950468b82$export$8960430cfd85939f)(min, (0, $7e23bad950468b82$export$96ec731ed4dcb222)(value, max));
}
function $b6f0b0266e764faa$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $b6f0b0266e764faa$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $3295dac8746ffe59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $7b08f0526e425773$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $d8b68132b61080af$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $f5c54167a3c62105$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $683c5e26d5f8bfe5$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a56b734280245ffb$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? (0, $7e23bad950468b82$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $7e23bad950468b82$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $f5c54167a3c62105$export$1e95b668f3b82d),
            (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $b6f0b0266e764faa$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $3295dac8746ffe59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $3295dac8746ffe59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $1992f2d714808ab6$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $387b887da02b7e69$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4d11a6decde23bf9$export$2e2bcd8739ae039)(padding, (0, $f5c54167a3c62105$export$aec2ce47c367b8c3)));
};
function $1992f2d714808ab6$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $afe288682115fde3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $b518c35b71cf930f$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $1992f2d714808ab6$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $30ced62b744c6cfe$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $f5c54167a3c62105$export$1e95b668f3b82d) : (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $f5c54167a3c62105$export$40e543e69a8b3fbb) : (0, $f5c54167a3c62105$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a56b734280245ffb$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $b6f0b0266e764faa$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $1992f2d714808ab6$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $d63950b756706495$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $1992f2d714808ab6$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $1992f2d714808ab6$var$arrow,
    effect: $1992f2d714808ab6$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $174d14927bb4f43b$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $174d14927bb4f43b$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $f5c54167a3c62105$export$1e95b668f3b82d),
        (0, $f5c54167a3c62105$export$79ffe56a765070d2),
        (0, $f5c54167a3c62105$export$40e543e69a8b3fbb),
        (0, $f5c54167a3c62105$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $174d14927bb4f43b$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f765731200b57f98$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $174d14927bb4f43b$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $174d14927bb4f43b$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $174d14927bb4f43b$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $174d14927bb4f43b$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $174d14927bb4f43b$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $174d14927bb4f43b$var$hide
};




var $1bf0bf541303046d$export$d34966752335dd47 = [
    (0, $ff355aafd082b0cd$export$2e2bcd8739ae039),
    (0, $e92fb10df1450f31$export$2e2bcd8739ae039),
    (0, $c8f8eadcf7685dc5$export$2e2bcd8739ae039),
    (0, $83c1fc4c4e58d7dd$export$2e2bcd8739ae039),
    (0, $7c04da2e958a3fe8$export$2e2bcd8739ae039),
    (0, $b1f32a1d9525a032$export$2e2bcd8739ae039),
    (0, $3295dac8746ffe59$export$2e2bcd8739ae039),
    (0, $1992f2d714808ab6$export$2e2bcd8739ae039),
    (0, $174d14927bb4f43b$export$2e2bcd8739ae039)
];
var $1bf0bf541303046d$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $b3c2fd6800546b4b$export$ed5e13716264f202)({
    defaultModifiers: $1bf0bf541303046d$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules



var $9d7e083df5284b15$var$__assign = undefined && undefined.__assign || function() {
    $9d7e083df5284b15$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d7e083df5284b15$var$__assign.apply(this, arguments);
};
var $9d7e083df5284b15$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9d7e083df5284b15$var$Default = {
    placement: 'bottom',
    triggerType: 'click',
    offsetSkidding: 0,
    offsetDistance: 10,
    delay: 300,
    ignoreClickOutsideClass: false,
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $9d7e083df5284b15$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $9d7e083df5284b15$var$Dropdown = /** @class */ function() {
    function Dropdown(targetElement, triggerElement, options, instanceOptions) {
        if (targetElement === void 0) targetElement = null;
        if (triggerElement === void 0) triggerElement = null;
        if (options === void 0) options = $9d7e083df5284b15$var$Default;
        if (instanceOptions === void 0) instanceOptions = $9d7e083df5284b15$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetElement.id;
        this._targetEl = targetElement;
        this._triggerEl = triggerElement;
        this._options = $9d7e083df5284b15$var$__assign($9d7e083df5284b15$var$__assign({}, $9d7e083df5284b15$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Dropdown', this, this._instanceId, instanceOptions.override);
    }
    Dropdown.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._popperInstance = this._createPopperInstance();
            this._setupEventListeners();
            this._initialized = true;
        }
    };
    Dropdown.prototype.destroy = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        // Remove click event listeners for trigger element
        if (this._options.triggerType === 'click') triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.removeEventListener(ev, _this._clickHandler);
        });
        // Remove hover event listeners for trigger and target elements
        if (this._options.triggerType === 'hover') {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.removeEventListener(ev, _this._hoverHideHandler);
            });
        }
        this._popperInstance.destroy();
        this._initialized = false;
    };
    Dropdown.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Dropdown', this._instanceId);
    };
    Dropdown.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dropdown.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._clickHandler = function() {
            _this.toggle();
        };
        // click event handling for trigger element
        if (this._options.triggerType === 'click') triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._clickHandler);
        });
        this._hoverShowTriggerElHandler = function(ev) {
            if (ev.type === 'click') _this.toggle();
            else setTimeout(function() {
                _this.show();
            }, _this._options.delay);
        };
        this._hoverShowTargetElHandler = function() {
            _this.show();
        };
        this._hoverHideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(':hover')) _this.hide();
            }, _this._options.delay);
        };
        // hover event handling for trigger element
        if (this._options.triggerType === 'hover') {
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverShowTriggerElHandler);
                _this._targetEl.addEventListener(ev, _this._hoverShowTargetElHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._hoverHideHandler);
                _this._targetEl.addEventListener(ev, _this._hoverHideHandler);
            });
        }
    };
    Dropdown.prototype._createPopperInstance = function() {
        return (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            this._options.offsetSkidding,
                            this._options.offsetDistance
                        ]
                    }
                }
            ]
        });
    };
    Dropdown.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener('click', this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener('click', this._clickOutsideEventListener, true);
    };
    Dropdown.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        // Ignore clicks on the trigger element (ie. a datepicker input)
        var ignoreClickOutsideClass = this._options.ignoreClickOutsideClass;
        var isIgnored = false;
        if (ignoreClickOutsideClass) {
            var ignoredClickOutsideEls = document.querySelectorAll(".".concat(ignoreClickOutsideClass));
            ignoredClickOutsideEls.forEach(function(el) {
                if (el.contains(clickedEl)) {
                    isIgnored = true;
                    return;
                }
            });
        }
        // Ignore clicks on the target element (ie. dropdown itself)
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && !isIgnored && this.isVisible()) this.hide();
    };
    Dropdown.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'click'
                    ],
                    hideEvents: [
                        'mouseleave'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click'
                    ],
                    hideEvents: []
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'click'
                    ],
                    hideEvents: []
                };
        }
    };
    Dropdown.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Dropdown.prototype.isVisible = function() {
        return this._visible;
    };
    Dropdown.prototype.show = function() {
        this._targetEl.classList.remove('hidden');
        this._targetEl.classList.add('block');
        this._targetEl.removeAttribute('aria-hidden');
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $9d7e083df5284b15$var$__assign($9d7e083df5284b15$var$__assign({}, options), {
                modifiers: $9d7e083df5284b15$var$__spreadArray($9d7e083df5284b15$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: true
                    }
                ], false)
            });
        });
        this._setupClickOutsideListener();
        // Update its position
        this._popperInstance.update();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dropdown.prototype.hide = function() {
        this._targetEl.classList.remove('block');
        this._targetEl.classList.add('hidden');
        this._targetEl.setAttribute('aria-hidden', 'true');
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $9d7e083df5284b15$var$__assign($9d7e083df5284b15$var$__assign({}, options), {
                modifiers: $9d7e083df5284b15$var$__spreadArray($9d7e083df5284b15$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: false
                    }
                ], false)
            });
        });
        this._visible = false;
        this._removeClickOutsideListener();
        // callback function
        this._options.onHide(this);
    };
    Dropdown.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dropdown.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dropdown.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dropdown;
}();
function $9d7e083df5284b15$export$8cb65a02593bf108() {
    document.querySelectorAll('[data-dropdown-toggle]').forEach(function($triggerEl) {
        var dropdownId = $triggerEl.getAttribute('data-dropdown-toggle');
        var $dropdownEl = document.getElementById(dropdownId);
        if ($dropdownEl) {
            var placement = $triggerEl.getAttribute('data-dropdown-placement');
            var offsetSkidding = $triggerEl.getAttribute('data-dropdown-offset-skidding');
            var offsetDistance = $triggerEl.getAttribute('data-dropdown-offset-distance');
            var triggerType = $triggerEl.getAttribute('data-dropdown-trigger');
            var delay = $triggerEl.getAttribute('data-dropdown-delay');
            var ignoreClickOutsideClass = $triggerEl.getAttribute('data-dropdown-ignore-click-outside-class');
            new $9d7e083df5284b15$var$Dropdown($dropdownEl, $triggerEl, {
                placement: placement ? placement : $9d7e083df5284b15$var$Default.placement,
                triggerType: triggerType ? triggerType : $9d7e083df5284b15$var$Default.triggerType,
                offsetSkidding: offsetSkidding ? parseInt(offsetSkidding) : $9d7e083df5284b15$var$Default.offsetSkidding,
                offsetDistance: offsetDistance ? parseInt(offsetDistance) : $9d7e083df5284b15$var$Default.offsetDistance,
                delay: delay ? parseInt(delay) : $9d7e083df5284b15$var$Default.delay,
                ignoreClickOutsideClass: ignoreClickOutsideClass ? ignoreClickOutsideClass : $9d7e083df5284b15$var$Default.ignoreClickOutsideClass
            });
        } else console.error("The dropdown element with id \"".concat(dropdownId, "\" does not exist. Please check the data-dropdown-toggle attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Dropdown = $9d7e083df5284b15$var$Dropdown;
    window.initDropdowns = $9d7e083df5284b15$export$8cb65a02593bf108;
}
var $9d7e083df5284b15$export$2e2bcd8739ae039 = $9d7e083df5284b15$var$Dropdown;



var $eaca6a069237aaf5$var$__assign = undefined && undefined.__assign || function() {
    $eaca6a069237aaf5$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $eaca6a069237aaf5$var$__assign.apply(this, arguments);
};
var $eaca6a069237aaf5$var$Default = {
    placement: 'center',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40',
    backdrop: 'dynamic',
    closable: true,
    onHide: function() {},
    onShow: function() {},
    onToggle: function() {}
};
var $eaca6a069237aaf5$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $eaca6a069237aaf5$var$Modal = /** @class */ function() {
    function Modal(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $eaca6a069237aaf5$var$Default;
        if (instanceOptions === void 0) instanceOptions = $eaca6a069237aaf5$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $eaca6a069237aaf5$var$__assign($eaca6a069237aaf5$var$__assign({}, $eaca6a069237aaf5$var$Default), options);
        this._isHidden = true;
        this._backdropEl = null;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Modal', this, this._instanceId, instanceOptions.override);
    }
    Modal.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._getPlacementClasses().map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._initialized = true;
        }
    };
    Modal.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            this._initialized = false;
        }
    };
    Modal.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Modal', this._instanceId);
    };
    Modal.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Modal.prototype._createBackdrop = function() {
        var _a;
        if (this._isHidden) {
            var backdropEl = document.createElement('div');
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(' '));
            document.querySelector('body').append(backdropEl);
            this._backdropEl = backdropEl;
        }
    };
    Modal.prototype._destroyBackdropEl = function() {
        if (!this._isHidden && this._backdropEl) {
            this._backdropEl.remove();
            this._backdropEl = null;
        }
    };
    Modal.prototype._setupModalCloseEventListeners = function() {
        var _this = this;
        if (this._options.backdrop === 'dynamic') {
            this._clickOutsideEventListener = function(ev) {
                _this._handleOutsideClick(ev.target);
            };
            this._targetEl.addEventListener('click', this._clickOutsideEventListener, true);
        }
        this._keydownEventListener = function(ev) {
            if (ev.key === 'Escape') _this.hide();
        };
        document.body.addEventListener('keydown', this._keydownEventListener, true);
    };
    Modal.prototype._removeModalCloseEventListeners = function() {
        if (this._options.backdrop === 'dynamic') this._targetEl.removeEventListener('click', this._clickOutsideEventListener, true);
        document.body.removeEventListener('keydown', this._keydownEventListener, true);
    };
    Modal.prototype._handleOutsideClick = function(target) {
        if (target === this._targetEl || target === this._backdropEl && this.isVisible()) this.hide();
    };
    Modal.prototype._getPlacementClasses = function() {
        switch(this._options.placement){
            // top
            case 'top-left':
                return [
                    'justify-start',
                    'items-start'
                ];
            case 'top-center':
                return [
                    'justify-center',
                    'items-start'
                ];
            case 'top-right':
                return [
                    'justify-end',
                    'items-start'
                ];
            // center
            case 'center-left':
                return [
                    'justify-start',
                    'items-center'
                ];
            case 'center':
                return [
                    'justify-center',
                    'items-center'
                ];
            case 'center-right':
                return [
                    'justify-end',
                    'items-center'
                ];
            // bottom
            case 'bottom-left':
                return [
                    'justify-start',
                    'items-end'
                ];
            case 'bottom-center':
                return [
                    'justify-center',
                    'items-end'
                ];
            case 'bottom-right':
                return [
                    'justify-end',
                    'items-end'
                ];
            default:
                return [
                    'justify-center',
                    'items-center'
                ];
        }
    };
    Modal.prototype.toggle = function() {
        if (this._isHidden) this.show();
        else this.hide();
        // callback function
        this._options.onToggle(this);
    };
    Modal.prototype.show = function() {
        if (this.isHidden) {
            this._targetEl.classList.add('flex');
            this._targetEl.classList.remove('hidden');
            this._targetEl.setAttribute('aria-modal', 'true');
            this._targetEl.setAttribute('role', 'dialog');
            this._targetEl.removeAttribute('aria-hidden');
            this._createBackdrop();
            this._isHidden = false;
            // Add keyboard event listener to the document
            if (this._options.closable) this._setupModalCloseEventListeners();
            // prevent body scroll
            document.body.classList.add('overflow-hidden');
            // callback function
            this._options.onShow(this);
        }
    };
    Modal.prototype.hide = function() {
        if (this.isVisible) {
            this._targetEl.classList.add('hidden');
            this._targetEl.classList.remove('flex');
            this._targetEl.setAttribute('aria-hidden', 'true');
            this._targetEl.removeAttribute('aria-modal');
            this._targetEl.removeAttribute('role');
            this._destroyBackdropEl();
            this._isHidden = true;
            // re-apply body scroll
            document.body.classList.remove('overflow-hidden');
            if (this._options.closable) this._removeModalCloseEventListeners();
            // callback function
            this._options.onHide(this);
        }
    };
    Modal.prototype.isVisible = function() {
        return !this._isHidden;
    };
    Modal.prototype.isHidden = function() {
        return this._isHidden;
    };
    Modal.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Modal.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Modal.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Modal.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Modal.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Modal.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Modal;
}();
function $eaca6a069237aaf5$export$e14d3bc873a8b9b1() {
    // initiate modal based on data-modal-target
    document.querySelectorAll('[data-modal-target]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-target');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var placement = $modalEl.getAttribute('data-modal-placement');
            var backdrop = $modalEl.getAttribute('data-modal-backdrop');
            new $eaca6a069237aaf5$var$Modal($modalEl, {
                placement: placement ? placement : $eaca6a069237aaf5$var$Default.placement,
                backdrop: backdrop ? backdrop : $eaca6a069237aaf5$var$Default.backdrop
            });
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-target attribute points to the correct modal id?."));
    });
    // toggle modal visibility
    document.querySelectorAll('[data-modal-toggle]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-toggle');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_1 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance('Modal', modalId);
            if (modal_1) {
                var toggleModal = function() {
                    modal_1.toggle();
                };
                $triggerEl.addEventListener('click', toggleModal);
                modal_1.addEventListenerInstance($triggerEl, 'click', toggleModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-toggle attribute points to the correct modal id?"));
    });
    // show modal on click if exists based on id
    document.querySelectorAll('[data-modal-show]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-show');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_2 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance('Modal', modalId);
            if (modal_2) {
                var showModal = function() {
                    modal_2.show();
                };
                $triggerEl.addEventListener('click', showModal);
                modal_2.addEventListenerInstance($triggerEl, 'click', showModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-show attribute points to the correct modal id?"));
    });
    // hide modal on click if exists based on id
    document.querySelectorAll('[data-modal-hide]').forEach(function($triggerEl) {
        var modalId = $triggerEl.getAttribute('data-modal-hide');
        var $modalEl = document.getElementById(modalId);
        if ($modalEl) {
            var modal_3 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance('Modal', modalId);
            if (modal_3) {
                var hideModal = function() {
                    modal_3.hide();
                };
                $triggerEl.addEventListener('click', hideModal);
                modal_3.addEventListenerInstance($triggerEl, 'click', hideModal);
            } else console.error("Modal with id ".concat(modalId, " has not been initialized. Please initialize it using the data-modal-target attribute."));
        } else console.error("Modal with id ".concat(modalId, " does not exist. Are you sure that the data-modal-hide attribute points to the correct modal id?"));
    });
}
if (typeof window !== 'undefined') {
    window.Modal = $eaca6a069237aaf5$var$Modal;
    window.initModals = $eaca6a069237aaf5$export$e14d3bc873a8b9b1;
}
var $eaca6a069237aaf5$export$2e2bcd8739ae039 = $eaca6a069237aaf5$var$Modal;



var $48c8331f22e653e8$var$__assign = undefined && undefined.__assign || function() {
    $48c8331f22e653e8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $48c8331f22e653e8$var$__assign.apply(this, arguments);
};
var $48c8331f22e653e8$var$Default = {
    placement: 'left',
    bodyScrolling: false,
    backdrop: true,
    edge: false,
    edgeOffset: 'bottom-[60px]',
    backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-30',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $48c8331f22e653e8$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $48c8331f22e653e8$var$Drawer = /** @class */ function() {
    function Drawer(targetEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $48c8331f22e653e8$var$Default;
        if (instanceOptions === void 0) instanceOptions = $48c8331f22e653e8$var$DefaultInstanceOptions;
        this._eventListenerInstances = [];
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._options = $48c8331f22e653e8$var$__assign($48c8331f22e653e8$var$__assign({}, $48c8331f22e653e8$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Drawer', this, this._instanceId, instanceOptions.override);
    }
    Drawer.prototype.init = function() {
        var _this = this;
        // set initial accessibility attributes
        if (this._targetEl && !this._initialized) {
            this._targetEl.setAttribute('aria-hidden', 'true');
            this._targetEl.classList.add('transition-transform');
            // set base placement classes
            this._getPlacementClasses(this._options.placement).base.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._handleEscapeKey = function(event) {
                if (event.key === 'Escape') // if 'Escape' key is pressed
                {
                    if (_this.isVisible()) // if the Drawer is visible
                    _this.hide(); // hide the Drawer
                }
            };
            // add keyboard event listener to document
            document.addEventListener('keydown', this._handleEscapeKey);
            this._initialized = true;
        }
    };
    Drawer.prototype.destroy = function() {
        if (this._initialized) {
            this.removeAllEventListenerInstances();
            this._destroyBackdropEl();
            // Remove the keyboard event listener
            document.removeEventListener('keydown', this._handleEscapeKey);
            this._initialized = false;
        }
    };
    Drawer.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Drawer', this._instanceId);
    };
    Drawer.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Drawer.prototype.hide = function() {
        var _this = this;
        // based on the edge option show placement classes
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + '-edge').active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement + '-edge').inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.add(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute('aria-hidden', 'true');
        this._targetEl.removeAttribute('aria-modal');
        this._targetEl.removeAttribute('role');
        // enable body scroll
        if (!this._options.bodyScrolling) document.body.classList.remove('overflow-hidden');
        // destroy backdrop
        if (this._options.backdrop) this._destroyBackdropEl();
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Drawer.prototype.show = function() {
        var _this = this;
        if (this._options.edge) {
            this._getPlacementClasses(this._options.placement + '-edge').active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement + '-edge').inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        } else {
            this._getPlacementClasses(this._options.placement).active.map(function(c) {
                _this._targetEl.classList.add(c);
            });
            this._getPlacementClasses(this._options.placement).inactive.map(function(c) {
                _this._targetEl.classList.remove(c);
            });
        }
        // set accessibility attributes
        this._targetEl.setAttribute('aria-modal', 'true');
        this._targetEl.setAttribute('role', 'dialog');
        this._targetEl.removeAttribute('aria-hidden');
        // disable body scroll
        if (!this._options.bodyScrolling) document.body.classList.add('overflow-hidden');
        // show backdrop
        if (this._options.backdrop) this._createBackdrop();
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Drawer.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Drawer.prototype._createBackdrop = function() {
        var _a;
        var _this = this;
        if (!this._visible) {
            var backdropEl = document.createElement('div');
            backdropEl.setAttribute('drawer-backdrop', '');
            (_a = backdropEl.classList).add.apply(_a, this._options.backdropClasses.split(' '));
            document.querySelector('body').append(backdropEl);
            backdropEl.addEventListener('click', function() {
                _this.hide();
            });
        }
    };
    Drawer.prototype._destroyBackdropEl = function() {
        if (this._visible && document.querySelector('[drawer-backdrop]') !== null) document.querySelector('[drawer-backdrop]').remove();
    };
    Drawer.prototype._getPlacementClasses = function(placement) {
        switch(placement){
            case 'top':
                return {
                    base: [
                        'top-0',
                        'left-0',
                        'right-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        '-translate-y-full'
                    ]
                };
            case 'right':
                return {
                    base: [
                        'right-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        'translate-x-full'
                    ]
                };
            case 'bottom':
                return {
                    base: [
                        'bottom-0',
                        'left-0',
                        'right-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        'translate-y-full'
                    ]
                };
            case 'left':
                return {
                    base: [
                        'left-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        '-translate-x-full'
                    ]
                };
            case 'bottom-edge':
                return {
                    base: [
                        'left-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        'translate-y-full',
                        this._options.edgeOffset
                    ]
                };
            default:
                return {
                    base: [
                        'left-0',
                        'top-0'
                    ],
                    active: [
                        'transform-none'
                    ],
                    inactive: [
                        '-translate-x-full'
                    ]
                };
        }
    };
    Drawer.prototype.isHidden = function() {
        return !this._visible;
    };
    Drawer.prototype.isVisible = function() {
        return this._visible;
    };
    Drawer.prototype.addEventListenerInstance = function(element, type, handler) {
        this._eventListenerInstances.push({
            element: element,
            type: type,
            handler: handler
        });
    };
    Drawer.prototype.removeAllEventListenerInstances = function() {
        this._eventListenerInstances.map(function(eventListenerInstance) {
            eventListenerInstance.element.removeEventListener(eventListenerInstance.type, eventListenerInstance.handler);
        });
        this._eventListenerInstances = [];
    };
    Drawer.prototype.getAllEventListenerInstances = function() {
        return this._eventListenerInstances;
    };
    Drawer.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Drawer.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Drawer.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Drawer;
}();
function $48c8331f22e653e8$export$319df2b10e87c8ec() {
    document.querySelectorAll('[data-drawer-target]').forEach(function($triggerEl) {
        // mandatory
        var drawerId = $triggerEl.getAttribute('data-drawer-target');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var placement = $triggerEl.getAttribute('data-drawer-placement');
            var bodyScrolling = $triggerEl.getAttribute('data-drawer-body-scrolling');
            var backdrop = $triggerEl.getAttribute('data-drawer-backdrop');
            var edge = $triggerEl.getAttribute('data-drawer-edge');
            var edgeOffset = $triggerEl.getAttribute('data-drawer-edge-offset');
            new $48c8331f22e653e8$var$Drawer($drawerEl, {
                placement: placement ? placement : $48c8331f22e653e8$var$Default.placement,
                bodyScrolling: bodyScrolling ? bodyScrolling === 'true' ? true : false : $48c8331f22e653e8$var$Default.bodyScrolling,
                backdrop: backdrop ? backdrop === 'true' ? true : false : $48c8331f22e653e8$var$Default.backdrop,
                edge: edge ? edge === 'true' ? true : false : $48c8331f22e653e8$var$Default.edge,
                edgeOffset: edgeOffset ? edgeOffset : $48c8331f22e653e8$var$Default.edgeOffset
            });
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll('[data-drawer-toggle]').forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute('data-drawer-toggle');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_1 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance('Drawer', drawerId);
            if (drawer_1) {
                var toggleDrawer = function() {
                    drawer_1.toggle();
                };
                $triggerEl.addEventListener('click', toggleDrawer);
                drawer_1.addEventListenerInstance($triggerEl, 'click', toggleDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
    document.querySelectorAll('[data-drawer-dismiss], [data-drawer-hide]').forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute('data-drawer-dismiss') ? $triggerEl.getAttribute('data-drawer-dismiss') : $triggerEl.getAttribute('data-drawer-hide');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_2 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance('Drawer', drawerId);
            if (drawer_2) {
                var hideDrawer = function() {
                    drawer_2.hide();
                };
                $triggerEl.addEventListener('click', hideDrawer);
                drawer_2.addEventListenerInstance($triggerEl, 'click', hideDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id"));
    });
    document.querySelectorAll('[data-drawer-show]').forEach(function($triggerEl) {
        var drawerId = $triggerEl.getAttribute('data-drawer-show');
        var $drawerEl = document.getElementById(drawerId);
        if ($drawerEl) {
            var drawer_3 = (0, $5d5682da381fac09$export$2e2bcd8739ae039).getInstance('Drawer', drawerId);
            if (drawer_3) {
                var showDrawer = function() {
                    drawer_3.show();
                };
                $triggerEl.addEventListener('click', showDrawer);
                drawer_3.addEventListenerInstance($triggerEl, 'click', showDrawer);
            } else console.error("Drawer with id ".concat(drawerId, " has not been initialized. Please initialize it using the data-drawer-target attribute."));
        } else console.error("Drawer with id ".concat(drawerId, " not found. Are you sure that the data-drawer-target attribute points to the correct drawer id?"));
    });
}
if (typeof window !== 'undefined') {
    window.Drawer = $48c8331f22e653e8$var$Drawer;
    window.initDrawers = $48c8331f22e653e8$export$319df2b10e87c8ec;
}
var $48c8331f22e653e8$export$2e2bcd8739ae039 = $48c8331f22e653e8$var$Drawer;



var $d9a3b96db6d5dbb4$var$__assign = undefined && undefined.__assign || function() {
    $d9a3b96db6d5dbb4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d9a3b96db6d5dbb4$var$__assign.apply(this, arguments);
};
var $d9a3b96db6d5dbb4$var$Default = {
    defaultTabId: null,
    activeClasses: 'text-blue-600 hover:text-blue-600 dark:text-blue-500 dark:hover:text-blue-500 border-blue-600 dark:border-blue-500',
    inactiveClasses: 'dark:border-transparent text-gray-500 hover:text-gray-600 dark:text-gray-400 border-gray-100 hover:border-gray-300 dark:border-gray-700 dark:hover:text-gray-300',
    onShow: function() {}
};
var $d9a3b96db6d5dbb4$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $d9a3b96db6d5dbb4$var$Tabs = /** @class */ function() {
    function Tabs(tabsEl, items, options, instanceOptions) {
        if (tabsEl === void 0) tabsEl = null;
        if (items === void 0) items = [];
        if (options === void 0) options = $d9a3b96db6d5dbb4$var$Default;
        if (instanceOptions === void 0) instanceOptions = $d9a3b96db6d5dbb4$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : tabsEl.id;
        this._tabsEl = tabsEl;
        this._items = items;
        this._activeTab = options ? this.getTab(options.defaultTabId) : null;
        this._options = $d9a3b96db6d5dbb4$var$__assign($d9a3b96db6d5dbb4$var$__assign({}, $d9a3b96db6d5dbb4$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Tabs', this, this._instanceId, instanceOptions.override);
    }
    Tabs.prototype.init = function() {
        var _this = this;
        if (this._items.length && !this._initialized) {
            // set the first tab as active if not set by explicitly
            if (!this._activeTab) this.setActiveTab(this._items[0]);
            // force show the first default tab
            this.show(this._activeTab.id, true);
            // show tab content based on click
            this._items.map(function(tab) {
                tab.triggerEl.addEventListener('click', function(event) {
                    event.preventDefault();
                    _this.show(tab.id);
                });
            });
        }
    };
    Tabs.prototype.destroy = function() {
        if (this._initialized) this._initialized = false;
    };
    Tabs.prototype.removeInstance = function() {
        this.destroy();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Tabs', this._instanceId);
    };
    Tabs.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tabs.prototype.getActiveTab = function() {
        return this._activeTab;
    };
    Tabs.prototype.setActiveTab = function(tab) {
        this._activeTab = tab;
    };
    Tabs.prototype.getTab = function(id) {
        return this._items.filter(function(t) {
            return t.id === id;
        })[0];
    };
    Tabs.prototype.show = function(id, forceShow) {
        var _a, _b;
        var _this = this;
        if (forceShow === void 0) forceShow = false;
        var tab = this.getTab(id);
        // don't do anything if already active
        if (tab === this._activeTab && !forceShow) return;
        // hide other tabs
        this._items.map(function(t) {
            var _a, _b;
            if (t !== tab) {
                (_a = t.triggerEl.classList).remove.apply(_a, _this._options.activeClasses.split(' '));
                (_b = t.triggerEl.classList).add.apply(_b, _this._options.inactiveClasses.split(' '));
                t.targetEl.classList.add('hidden');
                t.triggerEl.setAttribute('aria-selected', 'false');
            }
        });
        // show active tab
        (_a = tab.triggerEl.classList).add.apply(_a, this._options.activeClasses.split(' '));
        (_b = tab.triggerEl.classList).remove.apply(_b, this._options.inactiveClasses.split(' '));
        tab.triggerEl.setAttribute('aria-selected', 'true');
        tab.targetEl.classList.remove('hidden');
        this.setActiveTab(tab);
        // callback function
        this._options.onShow(this, tab);
    };
    Tabs.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    return Tabs;
}();
function $d9a3b96db6d5dbb4$export$c92e8f569ad2976f() {
    document.querySelectorAll('[data-tabs-toggle]').forEach(function($parentEl) {
        var tabItems = [];
        var activeClasses = $parentEl.getAttribute('data-tabs-active-classes');
        var inactiveClasses = $parentEl.getAttribute('data-tabs-inactive-classes');
        var defaultTabId = null;
        $parentEl.querySelectorAll('[role="tab"]').forEach(function($triggerEl) {
            var isActive = $triggerEl.getAttribute('aria-selected') === 'true';
            var tab = {
                id: $triggerEl.getAttribute('data-tabs-target'),
                triggerEl: $triggerEl,
                targetEl: document.querySelector($triggerEl.getAttribute('data-tabs-target'))
            };
            tabItems.push(tab);
            if (isActive) defaultTabId = tab.id;
        });
        new $d9a3b96db6d5dbb4$var$Tabs($parentEl, tabItems, {
            defaultTabId: defaultTabId,
            activeClasses: activeClasses ? activeClasses : $d9a3b96db6d5dbb4$var$Default.activeClasses,
            inactiveClasses: inactiveClasses ? inactiveClasses : $d9a3b96db6d5dbb4$var$Default.inactiveClasses
        });
    });
}
if (typeof window !== 'undefined') {
    window.Tabs = $d9a3b96db6d5dbb4$var$Tabs;
    window.initTabs = $d9a3b96db6d5dbb4$export$c92e8f569ad2976f;
}
var $d9a3b96db6d5dbb4$export$2e2bcd8739ae039 = $d9a3b96db6d5dbb4$var$Tabs;




var $91c32ed640e0fec6$var$__assign = undefined && undefined.__assign || function() {
    $91c32ed640e0fec6$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $91c32ed640e0fec6$var$__assign.apply(this, arguments);
};
var $91c32ed640e0fec6$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $91c32ed640e0fec6$var$Default = {
    placement: 'top',
    triggerType: 'hover',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $91c32ed640e0fec6$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $91c32ed640e0fec6$var$Tooltip = /** @class */ function() {
    function Tooltip(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $91c32ed640e0fec6$var$Default;
        if (instanceOptions === void 0) instanceOptions = $91c32ed640e0fec6$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $91c32ed640e0fec6$var$__assign($91c32ed640e0fec6$var$__assign({}, $91c32ed640e0fec6$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Tooltip', this, this._instanceId, instanceOptions.override);
    }
    Tooltip.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Tooltip.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Tooltip.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Tooltip', this._instanceId);
    };
    Tooltip.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Tooltip.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            _this.hide();
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Tooltip.prototype._createPopperInstance = function() {
        return (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                }
            ]
        });
    };
    Tooltip.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click',
                        'focus'
                    ],
                    hideEvents: [
                        'focusout',
                        'blur'
                    ]
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
        }
    };
    Tooltip.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === 'Escape') _this.hide();
        };
        document.body.addEventListener('keydown', this._keydownEventListener, true);
    };
    Tooltip.prototype._removeKeydownListener = function() {
        document.body.removeEventListener('keydown', this._keydownEventListener, true);
    };
    Tooltip.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener('click', this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener('click', this._clickOutsideEventListener, true);
    };
    Tooltip.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Tooltip.prototype.isVisible = function() {
        return this._visible;
    };
    Tooltip.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
    };
    Tooltip.prototype.show = function() {
        this._targetEl.classList.remove('opacity-0', 'invisible');
        this._targetEl.classList.add('opacity-100', 'visible');
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $91c32ed640e0fec6$var$__assign($91c32ed640e0fec6$var$__assign({}, options), {
                modifiers: $91c32ed640e0fec6$var$__spreadArray($91c32ed640e0fec6$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Tooltip.prototype.hide = function() {
        this._targetEl.classList.remove('opacity-100', 'visible');
        this._targetEl.classList.add('opacity-0', 'invisible');
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $91c32ed640e0fec6$var$__assign($91c32ed640e0fec6$var$__assign({}, options), {
                modifiers: $91c32ed640e0fec6$var$__spreadArray($91c32ed640e0fec6$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Tooltip.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Tooltip.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Tooltip.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Tooltip;
}();
function $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e() {
    document.querySelectorAll('[data-tooltip-target]').forEach(function($triggerEl) {
        var tooltipId = $triggerEl.getAttribute('data-tooltip-target');
        var $tooltipEl = document.getElementById(tooltipId);
        if ($tooltipEl) {
            var triggerType = $triggerEl.getAttribute('data-tooltip-trigger');
            var placement = $triggerEl.getAttribute('data-tooltip-placement');
            new $91c32ed640e0fec6$var$Tooltip($tooltipEl, $triggerEl, {
                placement: placement ? placement : $91c32ed640e0fec6$var$Default.placement,
                triggerType: triggerType ? triggerType : $91c32ed640e0fec6$var$Default.triggerType
            });
        } else console.error("The tooltip element with id \"".concat(tooltipId, "\" does not exist. Please check the data-tooltip-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Tooltip = $91c32ed640e0fec6$var$Tooltip;
    window.initTooltips = $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e;
}
var $91c32ed640e0fec6$export$2e2bcd8739ae039 = $91c32ed640e0fec6$var$Tooltip;




var $6aca18f5cd7d8b7b$var$__assign = undefined && undefined.__assign || function() {
    $6aca18f5cd7d8b7b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6aca18f5cd7d8b7b$var$__assign.apply(this, arguments);
};
var $6aca18f5cd7d8b7b$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $6aca18f5cd7d8b7b$var$Default = {
    placement: 'top',
    offset: 10,
    triggerType: 'hover',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $6aca18f5cd7d8b7b$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $6aca18f5cd7d8b7b$var$Popover = /** @class */ function() {
    function Popover(targetEl, triggerEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (options === void 0) options = $6aca18f5cd7d8b7b$var$Default;
        if (instanceOptions === void 0) instanceOptions = $6aca18f5cd7d8b7b$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._triggerEl = triggerEl;
        this._options = $6aca18f5cd7d8b7b$var$__assign($6aca18f5cd7d8b7b$var$__assign({}, $6aca18f5cd7d8b7b$var$Default), options);
        this._popperInstance = null;
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Popover', this, instanceOptions.id ? instanceOptions.id : this._targetEl.id, instanceOptions.override);
    }
    Popover.prototype.init = function() {
        if (this._triggerEl && this._targetEl && !this._initialized) {
            this._setupEventListeners();
            this._popperInstance = this._createPopperInstance();
            this._initialized = true;
        }
    };
    Popover.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            // remove event listeners associated with the trigger element and target element
            var triggerEvents = this._getTriggerEvents();
            triggerEvents.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showHandler);
                _this._targetEl.removeEventListener(ev, _this._showHandler);
            });
            triggerEvents.hideEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._hideHandler);
                _this._targetEl.removeEventListener(ev, _this._hideHandler);
            });
            // remove event listeners for keydown
            this._removeKeydownListener();
            // remove event listeners for click outside
            this._removeClickOutsideListener();
            // destroy the Popper instance if you have one (assuming this._popperInstance is the Popper instance)
            if (this._popperInstance) this._popperInstance.destroy();
            this._initialized = false;
        }
    };
    Popover.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Popover', this._instanceId);
    };
    Popover.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Popover.prototype._setupEventListeners = function() {
        var _this = this;
        var triggerEvents = this._getTriggerEvents();
        this._showHandler = function() {
            _this.show();
        };
        this._hideHandler = function() {
            setTimeout(function() {
                if (!_this._targetEl.matches(':hover')) _this.hide();
            }, 100);
        };
        triggerEvents.showEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._showHandler);
            _this._targetEl.addEventListener(ev, _this._showHandler);
        });
        triggerEvents.hideEvents.forEach(function(ev) {
            _this._triggerEl.addEventListener(ev, _this._hideHandler);
            _this._targetEl.addEventListener(ev, _this._hideHandler);
        });
    };
    Popover.prototype._createPopperInstance = function() {
        return (0, $1bf0bf541303046d$export$8f7491d57c8f97a9)(this._triggerEl, this._targetEl, {
            placement: this._options.placement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            this._options.offset
                        ]
                    }
                }
            ]
        });
    };
    Popover.prototype._getTriggerEvents = function() {
        switch(this._options.triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click',
                        'focus'
                    ],
                    hideEvents: [
                        'focusout',
                        'blur'
                    ]
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
        }
    };
    Popover.prototype._setupKeydownListener = function() {
        var _this = this;
        this._keydownEventListener = function(ev) {
            if (ev.key === 'Escape') _this.hide();
        };
        document.body.addEventListener('keydown', this._keydownEventListener, true);
    };
    Popover.prototype._removeKeydownListener = function() {
        document.body.removeEventListener('keydown', this._keydownEventListener, true);
    };
    Popover.prototype._setupClickOutsideListener = function() {
        var _this = this;
        this._clickOutsideEventListener = function(ev) {
            _this._handleClickOutside(ev, _this._targetEl);
        };
        document.body.addEventListener('click', this._clickOutsideEventListener, true);
    };
    Popover.prototype._removeClickOutsideListener = function() {
        document.body.removeEventListener('click', this._clickOutsideEventListener, true);
    };
    Popover.prototype._handleClickOutside = function(ev, targetEl) {
        var clickedEl = ev.target;
        if (clickedEl !== targetEl && !targetEl.contains(clickedEl) && !this._triggerEl.contains(clickedEl) && this.isVisible()) this.hide();
    };
    Popover.prototype.isVisible = function() {
        return this._visible;
    };
    Popover.prototype.toggle = function() {
        if (this.isVisible()) this.hide();
        else this.show();
        this._options.onToggle(this);
    };
    Popover.prototype.show = function() {
        this._targetEl.classList.remove('opacity-0', 'invisible');
        this._targetEl.classList.add('opacity-100', 'visible');
        // Enable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $6aca18f5cd7d8b7b$var$__assign($6aca18f5cd7d8b7b$var$__assign({}, options), {
                modifiers: $6aca18f5cd7d8b7b$var$__spreadArray($6aca18f5cd7d8b7b$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: true
                    }
                ], false)
            });
        });
        // handle click outside
        this._setupClickOutsideListener();
        // handle esc keydown
        this._setupKeydownListener();
        // Update its position
        this._popperInstance.update();
        // set visibility to true
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Popover.prototype.hide = function() {
        this._targetEl.classList.remove('opacity-100', 'visible');
        this._targetEl.classList.add('opacity-0', 'invisible');
        // Disable the event listeners
        this._popperInstance.setOptions(function(options) {
            return $6aca18f5cd7d8b7b$var$__assign($6aca18f5cd7d8b7b$var$__assign({}, options), {
                modifiers: $6aca18f5cd7d8b7b$var$__spreadArray($6aca18f5cd7d8b7b$var$__spreadArray([], options.modifiers, true), [
                    {
                        name: 'eventListeners',
                        enabled: false
                    }
                ], false)
            });
        });
        // handle click outside
        this._removeClickOutsideListener();
        // handle esc keydown
        this._removeKeydownListener();
        // set visibility to false
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Popover.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Popover.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Popover.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Popover;
}();
function $6aca18f5cd7d8b7b$export$200409e83b2a0dd4() {
    document.querySelectorAll('[data-popover-target]').forEach(function($triggerEl) {
        var popoverID = $triggerEl.getAttribute('data-popover-target');
        var $popoverEl = document.getElementById(popoverID);
        if ($popoverEl) {
            var triggerType = $triggerEl.getAttribute('data-popover-trigger');
            var placement = $triggerEl.getAttribute('data-popover-placement');
            var offset = $triggerEl.getAttribute('data-popover-offset');
            new $6aca18f5cd7d8b7b$var$Popover($popoverEl, $triggerEl, {
                placement: placement ? placement : $6aca18f5cd7d8b7b$var$Default.placement,
                offset: offset ? parseInt(offset) : $6aca18f5cd7d8b7b$var$Default.offset,
                triggerType: triggerType ? triggerType : $6aca18f5cd7d8b7b$var$Default.triggerType
            });
        } else console.error("The popover element with id \"".concat(popoverID, "\" does not exist. Please check the data-popover-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.Popover = $6aca18f5cd7d8b7b$var$Popover;
    window.initPopovers = $6aca18f5cd7d8b7b$export$200409e83b2a0dd4;
}
var $6aca18f5cd7d8b7b$export$2e2bcd8739ae039 = $6aca18f5cd7d8b7b$var$Popover;



var $027785b5e7762569$var$__assign = undefined && undefined.__assign || function() {
    $027785b5e7762569$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $027785b5e7762569$var$__assign.apply(this, arguments);
};
var $027785b5e7762569$var$Default = {
    triggerType: 'hover',
    onShow: function() {},
    onHide: function() {},
    onToggle: function() {}
};
var $027785b5e7762569$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $027785b5e7762569$var$Dial = /** @class */ function() {
    function Dial(parentEl, triggerEl, targetEl, options, instanceOptions) {
        if (parentEl === void 0) parentEl = null;
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $027785b5e7762569$var$Default;
        if (instanceOptions === void 0) instanceOptions = $027785b5e7762569$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._parentEl = parentEl;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $027785b5e7762569$var$__assign($027785b5e7762569$var$__assign({}, $027785b5e7762569$var$Default), options);
        this._visible = false;
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Dial', this, this._instanceId, instanceOptions.override);
    }
    Dial.prototype.init = function() {
        var _this = this;
        if (this._triggerEl && this._targetEl && !this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            this._showEventHandler = function() {
                _this.show();
            };
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.addEventListener(ev, _this._showEventHandler);
                _this._targetEl.addEventListener(ev, _this._showEventHandler);
            });
            this._hideEventHandler = function() {
                if (!_this._parentEl.matches(':hover')) _this.hide();
            };
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.addEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = true;
        }
    };
    Dial.prototype.destroy = function() {
        var _this = this;
        if (this._initialized) {
            var triggerEventTypes = this._getTriggerEventTypes(this._options.triggerType);
            triggerEventTypes.showEvents.forEach(function(ev) {
                _this._triggerEl.removeEventListener(ev, _this._showEventHandler);
                _this._targetEl.removeEventListener(ev, _this._showEventHandler);
            });
            triggerEventTypes.hideEvents.forEach(function(ev) {
                _this._parentEl.removeEventListener(ev, _this._hideEventHandler);
            });
            this._initialized = false;
        }
    };
    Dial.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Dial', this._instanceId);
    };
    Dial.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Dial.prototype.hide = function() {
        this._targetEl.classList.add('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'false');
        this._visible = false;
        // callback function
        this._options.onHide(this);
    };
    Dial.prototype.show = function() {
        this._targetEl.classList.remove('hidden');
        if (this._triggerEl) this._triggerEl.setAttribute('aria-expanded', 'true');
        this._visible = true;
        // callback function
        this._options.onShow(this);
    };
    Dial.prototype.toggle = function() {
        if (this._visible) this.hide();
        else this.show();
    };
    Dial.prototype.isHidden = function() {
        return !this._visible;
    };
    Dial.prototype.isVisible = function() {
        return this._visible;
    };
    Dial.prototype._getTriggerEventTypes = function(triggerType) {
        switch(triggerType){
            case 'hover':
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
            case 'click':
                return {
                    showEvents: [
                        'click',
                        'focus'
                    ],
                    hideEvents: [
                        'focusout',
                        'blur'
                    ]
                };
            case 'none':
                return {
                    showEvents: [],
                    hideEvents: []
                };
            default:
                return {
                    showEvents: [
                        'mouseenter',
                        'focus'
                    ],
                    hideEvents: [
                        'mouseleave',
                        'blur'
                    ]
                };
        }
    };
    Dial.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Dial.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    Dial.prototype.updateOnToggle = function(callback) {
        this._options.onToggle = callback;
    };
    return Dial;
}();
function $027785b5e7762569$export$33aa68e0bfaa065d() {
    document.querySelectorAll('[data-dial-init]').forEach(function($parentEl) {
        var $triggerEl = $parentEl.querySelector('[data-dial-toggle]');
        if ($triggerEl) {
            var dialId = $triggerEl.getAttribute('data-dial-toggle');
            var $dialEl = document.getElementById(dialId);
            if ($dialEl) {
                var triggerType = $triggerEl.getAttribute('data-dial-trigger');
                new $027785b5e7762569$var$Dial($parentEl, $triggerEl, $dialEl, {
                    triggerType: triggerType ? triggerType : $027785b5e7762569$var$Default.triggerType
                });
            } else console.error("Dial with id ".concat(dialId, " does not exist. Are you sure that the data-dial-toggle attribute points to the correct modal id?"));
        } else console.error("Dial with id ".concat($parentEl.id, " does not have a trigger element. Are you sure that the data-dial-toggle attribute exists?"));
    });
}
if (typeof window !== 'undefined') {
    window.Dial = $027785b5e7762569$var$Dial;
    window.initDials = $027785b5e7762569$export$33aa68e0bfaa065d;
}
var $027785b5e7762569$export$2e2bcd8739ae039 = $027785b5e7762569$var$Dial;



var $5252bf9f038f0bda$var$__assign = undefined && undefined.__assign || function() {
    $5252bf9f038f0bda$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5252bf9f038f0bda$var$__assign.apply(this, arguments);
};
var $5252bf9f038f0bda$var$Default = {
    minValue: null,
    maxValue: null,
    onIncrement: function() {},
    onDecrement: function() {}
};
var $5252bf9f038f0bda$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $5252bf9f038f0bda$var$InputCounter = /** @class */ function() {
    function InputCounter(targetEl, incrementEl, decrementEl, options, instanceOptions) {
        if (targetEl === void 0) targetEl = null;
        if (incrementEl === void 0) incrementEl = null;
        if (decrementEl === void 0) decrementEl = null;
        if (options === void 0) options = $5252bf9f038f0bda$var$Default;
        if (instanceOptions === void 0) instanceOptions = $5252bf9f038f0bda$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._targetEl = targetEl;
        this._incrementEl = incrementEl;
        this._decrementEl = decrementEl;
        this._options = $5252bf9f038f0bda$var$__assign($5252bf9f038f0bda$var$__assign({}, $5252bf9f038f0bda$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('InputCounter', this, this._instanceId, instanceOptions.override);
    }
    InputCounter.prototype.init = function() {
        var _this = this;
        if (this._targetEl && !this._initialized) {
            this._inputHandler = function(event) {
                var target = event.target;
                // check if the value is numeric
                if (!/^\d*$/.test(target.value)) // Regex to check if the value is numeric
                target.value = target.value.replace(/[^\d]/g, ''); // Remove non-numeric characters
                // check for max value
                if (_this._options.maxValue !== null && parseInt(target.value) > _this._options.maxValue) target.value = _this._options.maxValue.toString();
                // check for min value
                if (_this._options.minValue !== null && parseInt(target.value) < _this._options.minValue) target.value = _this._options.minValue.toString();
            };
            this._incrementClickHandler = function() {
                _this.increment();
            };
            this._decrementClickHandler = function() {
                _this.decrement();
            };
            // Add event listener to restrict input to numeric values only
            this._targetEl.addEventListener('input', this._inputHandler);
            if (this._incrementEl) this._incrementEl.addEventListener('click', this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.addEventListener('click', this._decrementClickHandler);
            this._initialized = true;
        }
    };
    InputCounter.prototype.destroy = function() {
        if (this._targetEl && this._initialized) {
            this._targetEl.removeEventListener('input', this._inputHandler);
            if (this._incrementEl) this._incrementEl.removeEventListener('click', this._incrementClickHandler);
            if (this._decrementEl) this._decrementEl.removeEventListener('click', this._decrementClickHandler);
            this._initialized = false;
        }
    };
    InputCounter.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('InputCounter', this._instanceId);
    };
    InputCounter.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    InputCounter.prototype.getCurrentValue = function() {
        return parseInt(this._targetEl.value) || 0;
    };
    InputCounter.prototype.increment = function() {
        // don't increment if the value is already at the maximum value
        if (this._options.maxValue !== null && this.getCurrentValue() >= this._options.maxValue) return;
        this._targetEl.value = (this.getCurrentValue() + 1).toString();
        this._options.onIncrement(this);
    };
    InputCounter.prototype.decrement = function() {
        // don't decrement if the value is already at the minimum value
        if (this._options.minValue !== null && this.getCurrentValue() <= this._options.minValue) return;
        this._targetEl.value = (this.getCurrentValue() - 1).toString();
        this._options.onDecrement(this);
    };
    InputCounter.prototype.updateOnIncrement = function(callback) {
        this._options.onIncrement = callback;
    };
    InputCounter.prototype.updateOnDecrement = function(callback) {
        this._options.onDecrement = callback;
    };
    return InputCounter;
}();
function $5252bf9f038f0bda$export$4352dd3b7a1676ab() {
    document.querySelectorAll('[data-input-counter]').forEach(function($targetEl) {
        var targetId = $targetEl.id;
        var $incrementEl = document.querySelector('[data-input-counter-increment="' + targetId + '"]');
        var $decrementEl = document.querySelector('[data-input-counter-decrement="' + targetId + '"]');
        var minValue = $targetEl.getAttribute('data-input-counter-min');
        var maxValue = $targetEl.getAttribute('data-input-counter-max');
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $5d5682da381fac09$export$2e2bcd8739ae039).instanceExists('InputCounter', $targetEl.getAttribute('id'))) new $5252bf9f038f0bda$var$InputCounter($targetEl, $incrementEl ? $incrementEl : null, $decrementEl ? $decrementEl : null, {
                minValue: minValue ? parseInt(minValue) : null,
                maxValue: maxValue ? parseInt(maxValue) : null
            });
        } else console.error("The target element with id \"".concat(targetId, "\" does not exist. Please check the data-input-counter attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.InputCounter = $5252bf9f038f0bda$var$InputCounter;
    window.initInputCounters = $5252bf9f038f0bda$export$4352dd3b7a1676ab;
}
var $5252bf9f038f0bda$export$2e2bcd8739ae039 = $5252bf9f038f0bda$var$InputCounter;



var $d10e6c36a2232fe1$var$__assign = undefined && undefined.__assign || function() {
    $d10e6c36a2232fe1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d10e6c36a2232fe1$var$__assign.apply(this, arguments);
};
var $d10e6c36a2232fe1$var$Default = {
    htmlEntities: false,
    contentType: 'input',
    onCopy: function() {}
};
var $d10e6c36a2232fe1$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $d10e6c36a2232fe1$var$CopyClipboard = /** @class */ function() {
    function CopyClipboard(triggerEl, targetEl, options, instanceOptions) {
        if (triggerEl === void 0) triggerEl = null;
        if (targetEl === void 0) targetEl = null;
        if (options === void 0) options = $d10e6c36a2232fe1$var$Default;
        if (instanceOptions === void 0) instanceOptions = $d10e6c36a2232fe1$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : targetEl.id;
        this._triggerEl = triggerEl;
        this._targetEl = targetEl;
        this._options = $d10e6c36a2232fe1$var$__assign($d10e6c36a2232fe1$var$__assign({}, $d10e6c36a2232fe1$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('CopyClipboard', this, this._instanceId, instanceOptions.override);
    }
    CopyClipboard.prototype.init = function() {
        var _this = this;
        if (this._targetEl && this._triggerEl && !this._initialized) {
            this._triggerElClickHandler = function() {
                _this.copy();
            };
            // clicking on the trigger element should copy the value of the target element
            if (this._triggerEl) this._triggerEl.addEventListener('click', this._triggerElClickHandler);
            this._initialized = true;
        }
    };
    CopyClipboard.prototype.destroy = function() {
        if (this._triggerEl && this._targetEl && this._initialized) {
            if (this._triggerEl) this._triggerEl.removeEventListener('click', this._triggerElClickHandler);
            this._initialized = false;
        }
    };
    CopyClipboard.prototype.removeInstance = function() {
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('CopyClipboard', this._instanceId);
    };
    CopyClipboard.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    CopyClipboard.prototype.getTargetValue = function() {
        if (this._options.contentType === 'input') return this._targetEl.value;
        if (this._options.contentType === 'innerHTML') return this._targetEl.innerHTML;
        if (this._options.contentType === 'textContent') return this._targetEl.textContent.replace(/\s+/g, ' ').trim();
    };
    CopyClipboard.prototype.copy = function() {
        var textToCopy = this.getTargetValue();
        // Check if HTMLEntities option is enabled
        if (this._options.htmlEntities) // Encode the text using HTML entities
        textToCopy = this.decodeHTML(textToCopy);
        // Create a temporary textarea element
        var tempTextArea = document.createElement('textarea');
        tempTextArea.value = textToCopy;
        document.body.appendChild(tempTextArea);
        // Select the text inside the textarea and copy it to the clipboard
        tempTextArea.select();
        document.execCommand('copy');
        // Remove the temporary textarea
        document.body.removeChild(tempTextArea);
        // Callback function
        this._options.onCopy(this);
        return textToCopy;
    };
    // Function to encode text into HTML entities
    CopyClipboard.prototype.decodeHTML = function(html) {
        var textarea = document.createElement('textarea');
        textarea.innerHTML = html;
        return textarea.textContent;
    };
    CopyClipboard.prototype.updateOnCopyCallback = function(callback) {
        this._options.onCopy = callback;
    };
    return CopyClipboard;
}();
function $d10e6c36a2232fe1$export$ad4117886fd6cf74() {
    document.querySelectorAll('[data-copy-to-clipboard-target]').forEach(function($triggerEl) {
        var targetId = $triggerEl.getAttribute('data-copy-to-clipboard-target');
        var $targetEl = document.getElementById(targetId);
        var contentType = $triggerEl.getAttribute('data-copy-to-clipboard-content-type');
        var htmlEntities = $triggerEl.getAttribute('data-copy-to-clipboard-html-entities');
        // check if the target element exists
        if ($targetEl) {
            if (!(0, $5d5682da381fac09$export$2e2bcd8739ae039).instanceExists('CopyClipboard', $targetEl.getAttribute('id'))) new $d10e6c36a2232fe1$var$CopyClipboard($triggerEl, $targetEl, {
                htmlEntities: htmlEntities && htmlEntities === 'true' ? true : $d10e6c36a2232fe1$var$Default.htmlEntities,
                contentType: contentType ? contentType : $d10e6c36a2232fe1$var$Default.contentType
            });
        } else console.error("The target element with id \"".concat(targetId, "\" does not exist. Please check the data-copy-to-clipboard-target attribute."));
    });
}
if (typeof window !== 'undefined') {
    window.CopyClipboard = $d10e6c36a2232fe1$var$CopyClipboard;
    window.initClipboards = $d10e6c36a2232fe1$export$ad4117886fd6cf74;
}
var $d10e6c36a2232fe1$export$2e2bcd8739ae039 = $d10e6c36a2232fe1$var$CopyClipboard;



function $7c39ee59de2954f9$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $7c39ee59de2954f9$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $7c39ee59de2954f9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $7c39ee59de2954f9$var$_arrayLikeToArray(r);
}
function $7c39ee59de2954f9$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function $7c39ee59de2954f9$var$_callSuper(t, o, e) {
    return o = $7c39ee59de2954f9$var$_getPrototypeOf(o), $7c39ee59de2954f9$var$_possibleConstructorReturn(t, $7c39ee59de2954f9$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $7c39ee59de2954f9$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $7c39ee59de2954f9$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $7c39ee59de2954f9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $7c39ee59de2954f9$var$_toPropertyKey(o.key), o);
    }
}
function $7c39ee59de2954f9$var$_createClass(e, r, t) {
    return r && $7c39ee59de2954f9$var$_defineProperties(e.prototype, r), t && $7c39ee59de2954f9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $7c39ee59de2954f9$var$_get() {
    return $7c39ee59de2954f9$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $7c39ee59de2954f9$var$_superPropBase(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $7c39ee59de2954f9$var$_get.apply(null, arguments);
}
function $7c39ee59de2954f9$var$_getPrototypeOf(t) {
    return $7c39ee59de2954f9$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $7c39ee59de2954f9$var$_getPrototypeOf(t);
}
function $7c39ee59de2954f9$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7c39ee59de2954f9$var$_setPrototypeOf(t, e);
}
function $7c39ee59de2954f9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($7c39ee59de2954f9$var$_isNativeReflectConstruct = function() {
        return !!t;
    })();
}
function $7c39ee59de2954f9$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $7c39ee59de2954f9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $7c39ee59de2954f9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7c39ee59de2954f9$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7c39ee59de2954f9$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $7c39ee59de2954f9$var$_assertThisInitialized(t);
}
function $7c39ee59de2954f9$var$_setPrototypeOf(t, e) {
    return $7c39ee59de2954f9$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7c39ee59de2954f9$var$_setPrototypeOf(t, e);
}
function $7c39ee59de2954f9$var$_slicedToArray(r, e) {
    return $7c39ee59de2954f9$var$_arrayWithHoles(r) || $7c39ee59de2954f9$var$_iterableToArrayLimit(r, e) || $7c39ee59de2954f9$var$_unsupportedIterableToArray(r, e) || $7c39ee59de2954f9$var$_nonIterableRest();
}
function $7c39ee59de2954f9$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $7c39ee59de2954f9$var$_getPrototypeOf(t)););
    return t;
}
function $7c39ee59de2954f9$var$_toConsumableArray(r) {
    return $7c39ee59de2954f9$var$_arrayWithoutHoles(r) || $7c39ee59de2954f9$var$_iterableToArray(r) || $7c39ee59de2954f9$var$_unsupportedIterableToArray(r) || $7c39ee59de2954f9$var$_nonIterableSpread();
}
function $7c39ee59de2954f9$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $7c39ee59de2954f9$var$_toPropertyKey(t) {
    var i = $7c39ee59de2954f9$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7c39ee59de2954f9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $7c39ee59de2954f9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $7c39ee59de2954f9$var$_typeof(o);
}
function $7c39ee59de2954f9$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7c39ee59de2954f9$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7c39ee59de2954f9$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7c39ee59de2954f9$var$hasProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $7c39ee59de2954f9$var$lastItemOf(arr) {
    return arr[arr.length - 1];
}
// push only the items not included in the array
function $7c39ee59de2954f9$var$pushUnique(arr) {
    for(var _len = arguments.length, items = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)items[_key - 1] = arguments[_key];
    items.forEach(function(item) {
        if (arr.includes(item)) return;
        arr.push(item);
    });
    return arr;
}
function $7c39ee59de2954f9$var$stringToArray(str, separator) {
    // convert empty string to an empty array
    return str ? str.split(separator) : [];
}
function $7c39ee59de2954f9$var$isInRange(testVal, min, max) {
    var minOK = min === undefined || testVal >= min;
    var maxOK = max === undefined || testVal <= max;
    return minOK && maxOK;
}
function $7c39ee59de2954f9$var$limitToRange(val, min, max) {
    if (val < min) return min;
    if (val > max) return max;
    return val;
}
function $7c39ee59de2954f9$var$createTagRepeat(tagName, repeat) {
    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var html = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    var openTagSrc = Object.keys(attributes).reduce(function(src, attr) {
        var val = attributes[attr];
        if (typeof val === 'function') val = val(index);
        return "".concat(src, " ").concat(attr, "=\"").concat(val, "\"");
    }, tagName);
    html += "<".concat(openTagSrc, "></").concat(tagName, ">");
    var next = index + 1;
    return next < repeat ? $7c39ee59de2954f9$var$createTagRepeat(tagName, repeat, attributes, next, html) : html;
}
// Remove the spacing surrounding tags for HTML parser not to create text nodes
// before/after elements
function $7c39ee59de2954f9$var$optimizeTemplateHTML(html) {
    return html.replace(/>\s+/g, '>').replace(/\s+</, '<');
}
function $7c39ee59de2954f9$var$stripTime(timeValue) {
    return new Date(timeValue).setHours(0, 0, 0, 0);
}
function $7c39ee59de2954f9$var$today() {
    return new Date().setHours(0, 0, 0, 0);
}
// Get the time value of the start of given date or year, month and day
function $7c39ee59de2954f9$var$dateValue() {
    switch(arguments.length){
        case 0:
            return $7c39ee59de2954f9$var$today();
        case 1:
            return $7c39ee59de2954f9$var$stripTime(arguments.length <= 0 ? undefined : arguments[0]);
    }
    // use setFullYear() to keep 2-digit year from being mapped to 1900-1999
    var newDate = new Date(0);
    newDate.setFullYear.apply(newDate, arguments);
    return newDate.setHours(0, 0, 0, 0);
}
function $7c39ee59de2954f9$var$addDays(date, amount) {
    var newDate = new Date(date);
    return newDate.setDate(newDate.getDate() + amount);
}
function $7c39ee59de2954f9$var$addWeeks(date, amount) {
    return $7c39ee59de2954f9$var$addDays(date, amount * 7);
}
function $7c39ee59de2954f9$var$addMonths(date, amount) {
    // If the day of the date is not in the new month, the last day of the new
    // month will be returned. e.g. Jan 31 + 1 month → Feb 28 (not Mar 03)
    var newDate = new Date(date);
    var monthsToSet = newDate.getMonth() + amount;
    var expectedMonth = monthsToSet % 12;
    if (expectedMonth < 0) expectedMonth += 12;
    var time = newDate.setMonth(monthsToSet);
    return newDate.getMonth() !== expectedMonth ? newDate.setDate(0) : time;
}
function $7c39ee59de2954f9$var$addYears(date, amount) {
    // If the date is Feb 29 and the new year is not a leap year, Feb 28 of the
    // new year will be returned.
    var newDate = new Date(date);
    var expectedMonth = newDate.getMonth();
    var time = newDate.setFullYear(newDate.getFullYear() + amount);
    return expectedMonth === 1 && newDate.getMonth() === 2 ? newDate.setDate(0) : time;
}
// Calculate the distance bettwen 2 days of the week
function $7c39ee59de2954f9$var$dayDiff(day, from) {
    return (day - from + 7) % 7;
}
// Get the date of the specified day of the week of given base date
function $7c39ee59de2954f9$var$dayOfTheWeekOf(baseDate, dayOfWeek) {
    var weekStart = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var baseDay = new Date(baseDate).getDay();
    return $7c39ee59de2954f9$var$addDays(baseDate, $7c39ee59de2954f9$var$dayDiff(dayOfWeek, weekStart) - $7c39ee59de2954f9$var$dayDiff(baseDay, weekStart));
}
// Get the ISO week of a date
function $7c39ee59de2954f9$var$getWeek(date) {
    // start of ISO week is Monday
    var thuOfTheWeek = $7c39ee59de2954f9$var$dayOfTheWeekOf(date, 4, 1);
    // 1st week == the week where the 4th of January is in
    var firstThu = $7c39ee59de2954f9$var$dayOfTheWeekOf(new Date(thuOfTheWeek).setMonth(0, 4), 4, 1);
    return Math.round((thuOfTheWeek - firstThu) / 604800000) + 1;
}
// Get the start year of the period of years that includes given date
// years: length of the year period
function $7c39ee59de2954f9$var$startOfYearPeriod(date, years) {
    /* @see https://en.wikipedia.org/wiki/Year_zero#ISO_8601 */ var year = new Date(date).getFullYear();
    return Math.floor(year / years) * years;
}
// pattern for format parts
var $7c39ee59de2954f9$var$reFormatTokens = /dd?|DD?|mm?|MM?|yy?(?:yy)?/;
// pattern for non date parts
var $7c39ee59de2954f9$var$reNonDateParts = /[\s!-/:-@[-`{-~年月日]+/;
// cache for persed formats
var $7c39ee59de2954f9$var$knownFormats = {};
// parse funtions for date parts
var $7c39ee59de2954f9$var$parseFns = {
    y: function y(date, year) {
        return new Date(date).setFullYear(parseInt(year, 10));
    },
    m: function m(date, month, locale) {
        var newDate = new Date(date);
        var monthIndex = parseInt(month, 10) - 1;
        if (isNaN(monthIndex)) {
            if (!month) return NaN;
            var monthName = month.toLowerCase();
            var compareNames = function compareNames(name) {
                return name.toLowerCase().startsWith(monthName);
            };
            // compare with both short and full names because some locales have periods
            // in the short names (not equal to the first X letters of the full names)
            monthIndex = locale.monthsShort.findIndex(compareNames);
            if (monthIndex < 0) monthIndex = locale.months.findIndex(compareNames);
            if (monthIndex < 0) return NaN;
        }
        newDate.setMonth(monthIndex);
        return newDate.getMonth() !== $7c39ee59de2954f9$var$normalizeMonth(monthIndex) ? newDate.setDate(0) : newDate.getTime();
    },
    d: function d(date, day) {
        return new Date(date).setDate(parseInt(day, 10));
    }
};
// format functions for date parts
var $7c39ee59de2954f9$var$formatFns = {
    d: function d(date) {
        return date.getDate();
    },
    dd: function dd(date) {
        return $7c39ee59de2954f9$var$padZero(date.getDate(), 2);
    },
    D: function D(date, locale) {
        return locale.daysShort[date.getDay()];
    },
    DD: function DD(date, locale) {
        return locale.days[date.getDay()];
    },
    m: function m(date) {
        return date.getMonth() + 1;
    },
    mm: function mm(date) {
        return $7c39ee59de2954f9$var$padZero(date.getMonth() + 1, 2);
    },
    M: function M(date, locale) {
        return locale.monthsShort[date.getMonth()];
    },
    MM: function MM(date, locale) {
        return locale.months[date.getMonth()];
    },
    y: function y(date) {
        return date.getFullYear();
    },
    yy: function yy(date) {
        return $7c39ee59de2954f9$var$padZero(date.getFullYear(), 2).slice(-2);
    },
    yyyy: function yyyy(date) {
        return $7c39ee59de2954f9$var$padZero(date.getFullYear(), 4);
    }
};
// get month index in normal range (0 - 11) from any number
function $7c39ee59de2954f9$var$normalizeMonth(monthIndex) {
    return monthIndex > -1 ? monthIndex % 12 : $7c39ee59de2954f9$var$normalizeMonth(monthIndex + 12);
}
function $7c39ee59de2954f9$var$padZero(num, length) {
    return num.toString().padStart(length, '0');
}
function $7c39ee59de2954f9$var$parseFormatString(format) {
    if (typeof format !== 'string') throw new Error("Invalid date format.");
    if (format in $7c39ee59de2954f9$var$knownFormats) return $7c39ee59de2954f9$var$knownFormats[format];
    // sprit the format string into parts and seprators
    var separators = format.split($7c39ee59de2954f9$var$reFormatTokens);
    var parts = format.match(new RegExp($7c39ee59de2954f9$var$reFormatTokens, 'g'));
    if (separators.length === 0 || !parts) throw new Error("Invalid date format.");
    // collect format functions used in the format
    var partFormatters = parts.map(function(token) {
        return $7c39ee59de2954f9$var$formatFns[token];
    });
    // collect parse function keys used in the format
    // iterate over parseFns' keys in order to keep the order of the keys.
    var partParserKeys = Object.keys($7c39ee59de2954f9$var$parseFns).reduce(function(keys, key) {
        var token = parts.find(function(part) {
            return part[0] !== 'D' && part[0].toLowerCase() === key;
        });
        if (token) keys.push(key);
        return keys;
    }, []);
    return $7c39ee59de2954f9$var$knownFormats[format] = {
        parser: function parser(dateStr, locale) {
            var dateParts = dateStr.split($7c39ee59de2954f9$var$reNonDateParts).reduce(function(dtParts, part, index) {
                if (part.length > 0 && parts[index]) {
                    var token = parts[index][0];
                    if (token === 'M') dtParts.m = part;
                    else if (token !== 'D') dtParts[token] = part;
                }
                return dtParts;
            }, {});
            // iterate over partParserkeys so that the parsing is made in the oder
            // of year, month and day to prevent the day parser from correcting last
            // day of month wrongly
            return partParserKeys.reduce(function(origDate, key) {
                var newDate = $7c39ee59de2954f9$var$parseFns[key](origDate, dateParts[key], locale);
                // ingnore the part failed to parse
                return isNaN(newDate) ? origDate : newDate;
            }, $7c39ee59de2954f9$var$today());
        },
        formatter: function formatter(date, locale) {
            var dateStr = partFormatters.reduce(function(str, fn, index) {
                return str += "".concat(separators[index]).concat(fn(date, locale));
            }, '');
            // separators' length is always parts' length + 1,
            return dateStr += $7c39ee59de2954f9$var$lastItemOf(separators);
        }
    };
}
function $7c39ee59de2954f9$var$parseDate(dateStr, format, locale) {
    if (dateStr instanceof Date || typeof dateStr === 'number') {
        var date = $7c39ee59de2954f9$var$stripTime(dateStr);
        return isNaN(date) ? undefined : date;
    }
    if (!dateStr) return undefined;
    if (dateStr === 'today') return $7c39ee59de2954f9$var$today();
    if (format && format.toValue) {
        var _date = format.toValue(dateStr, format, locale);
        return isNaN(_date) ? undefined : $7c39ee59de2954f9$var$stripTime(_date);
    }
    return $7c39ee59de2954f9$var$parseFormatString(format).parser(dateStr, locale);
}
function $7c39ee59de2954f9$var$formatDate(date, format, locale) {
    if (isNaN(date) || !date && date !== 0) return '';
    var dateObj = typeof date === 'number' ? new Date(date) : date;
    if (format.toDisplay) return format.toDisplay(dateObj, format, locale);
    return $7c39ee59de2954f9$var$parseFormatString(format).formatter(dateObj, locale);
}
var $7c39ee59de2954f9$var$listenerRegistry = new WeakMap();
var $7c39ee59de2954f9$var$_EventTarget$prototyp = EventTarget.prototype, $7c39ee59de2954f9$var$addEventListener = $7c39ee59de2954f9$var$_EventTarget$prototyp.addEventListener, $7c39ee59de2954f9$var$removeEventListener = $7c39ee59de2954f9$var$_EventTarget$prototyp.removeEventListener;
// Register event listeners to a key object
// listeners: array of listener definitions;
//   - each definition must be a flat array of event target and the arguments
//     used to call addEventListener() on the target
function $7c39ee59de2954f9$var$registerListeners(keyObj, listeners) {
    var registered = $7c39ee59de2954f9$var$listenerRegistry.get(keyObj);
    if (!registered) {
        registered = [];
        $7c39ee59de2954f9$var$listenerRegistry.set(keyObj, registered);
    }
    listeners.forEach(function(listener) {
        $7c39ee59de2954f9$var$addEventListener.call.apply($7c39ee59de2954f9$var$addEventListener, $7c39ee59de2954f9$var$_toConsumableArray(listener));
        registered.push(listener);
    });
}
function $7c39ee59de2954f9$var$unregisterListeners(keyObj) {
    var listeners = $7c39ee59de2954f9$var$listenerRegistry.get(keyObj);
    if (!listeners) return;
    listeners.forEach(function(listener) {
        $7c39ee59de2954f9$var$removeEventListener.call.apply($7c39ee59de2954f9$var$removeEventListener, $7c39ee59de2954f9$var$_toConsumableArray(listener));
    });
    $7c39ee59de2954f9$var$listenerRegistry["delete"](keyObj);
}
// Event.composedPath() polyfill for Edge
// based on https://gist.github.com/kleinfreund/e9787d73776c0e3750dcfcdc89f100ec
if (!Event.prototype.composedPath) {
    var $7c39ee59de2954f9$var$getComposedPath = function getComposedPath(node) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        path.push(node);
        var parent;
        if (node.parentNode) parent = node.parentNode;
        else if (node.host) // ShadowRoot
        parent = node.host;
        else if (node.defaultView) // Document
        parent = node.defaultView;
        return parent ? getComposedPath(parent, path) : path;
    };
    Event.prototype.composedPath = function() {
        return $7c39ee59de2954f9$var$getComposedPath(this.target);
    };
}
function $7c39ee59de2954f9$var$findFromPath(path, criteria, currentTarget) {
    var index = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var el = path[index];
    if (criteria(el)) return el;
    else if (el === currentTarget || !el.parentElement) // stop when reaching currentTarget or <html>
    return;
    return $7c39ee59de2954f9$var$findFromPath(path, criteria, currentTarget, index + 1);
}
// Search for the actual target of a delegated event
function $7c39ee59de2954f9$var$findElementInEventPath(ev, selector) {
    var criteria = typeof selector === 'function' ? selector : function(el) {
        return el.matches(selector);
    };
    return $7c39ee59de2954f9$var$findFromPath(ev.composedPath(), criteria, ev.currentTarget);
}
// default locales
var $7c39ee59de2954f9$var$locales = {
    en: {
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        daysShort: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        daysMin: [
            "Su",
            "Mo",
            "Tu",
            "We",
            "Th",
            "Fr",
            "Sa"
        ],
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        monthsShort: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        today: "Today",
        clear: "Clear",
        titleFormat: "MM y"
    }
};
// config options updatable by setOptions() and their default values
var $7c39ee59de2954f9$var$defaultOptions = {
    autohide: false,
    beforeShowDay: null,
    beforeShowDecade: null,
    beforeShowMonth: null,
    beforeShowYear: null,
    calendarWeeks: false,
    clearBtn: false,
    dateDelimiter: ',',
    datesDisabled: [],
    daysOfWeekDisabled: [],
    daysOfWeekHighlighted: [],
    defaultViewDate: undefined,
    // placeholder, defaults to today() by the program
    disableTouchKeyboard: false,
    format: 'mm/dd/yyyy',
    language: 'en',
    maxDate: null,
    maxNumberOfDates: 1,
    maxView: 3,
    minDate: null,
    nextArrow: '<svg class="w-4 h-4 rtl:rotate-180 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/></svg>',
    orientation: 'auto',
    pickLevel: 0,
    prevArrow: '<svg class="w-4 h-4 rtl:rotate-180 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0 4 4M1 5l4-4"/></svg>',
    showDaysOfWeek: true,
    showOnClick: true,
    showOnFocus: true,
    startView: 0,
    title: '',
    todayBtn: false,
    todayBtnMode: 0,
    todayHighlight: false,
    updateOnBlur: true,
    weekStart: 0
};
var $7c39ee59de2954f9$var$range = document.createRange();
function $7c39ee59de2954f9$var$parseHTML(html) {
    return $7c39ee59de2954f9$var$range.createContextualFragment(html);
}
function $7c39ee59de2954f9$var$hideElement(el) {
    if (el.style.display === 'none') return;
    // back up the existing display setting in data-style-display
    if (el.style.display) el.dataset.styleDisplay = el.style.display;
    el.style.display = 'none';
}
function $7c39ee59de2954f9$var$showElement(el) {
    if (el.style.display !== 'none') return;
    if (el.dataset.styleDisplay) {
        // restore backed-up dispay property
        el.style.display = el.dataset.styleDisplay;
        delete el.dataset.styleDisplay;
    } else el.style.display = '';
}
function $7c39ee59de2954f9$var$emptyChildNodes(el) {
    if (el.firstChild) {
        el.removeChild(el.firstChild);
        $7c39ee59de2954f9$var$emptyChildNodes(el);
    }
}
function $7c39ee59de2954f9$var$replaceChildNodes(el, newChildNodes) {
    $7c39ee59de2954f9$var$emptyChildNodes(el);
    if (newChildNodes instanceof DocumentFragment) el.appendChild(newChildNodes);
    else if (typeof newChildNodes === 'string') el.appendChild($7c39ee59de2954f9$var$parseHTML(newChildNodes));
    else if (typeof newChildNodes.forEach === 'function') newChildNodes.forEach(function(node) {
        el.appendChild(node);
    });
}
var $7c39ee59de2954f9$var$defaultLang = $7c39ee59de2954f9$var$defaultOptions.language, $7c39ee59de2954f9$var$defaultFormat = $7c39ee59de2954f9$var$defaultOptions.format, $7c39ee59de2954f9$var$defaultWeekStart = $7c39ee59de2954f9$var$defaultOptions.weekStart;
// Reducer function to filter out invalid day-of-week from the input
function $7c39ee59de2954f9$var$sanitizeDOW(dow, day) {
    return dow.length < 6 && day >= 0 && day < 7 ? $7c39ee59de2954f9$var$pushUnique(dow, day) : dow;
}
function $7c39ee59de2954f9$var$calcEndOfWeek(startOfWeek) {
    return (startOfWeek + 6) % 7;
}
// validate input date. if invalid, fallback to the original value
function $7c39ee59de2954f9$var$validateDate(value, format, locale, origValue) {
    var date = $7c39ee59de2954f9$var$parseDate(value, format, locale);
    return date !== undefined ? date : origValue;
}
// Validate viewId. if invalid, fallback to the original value
function $7c39ee59de2954f9$var$validateViewId(value, origValue) {
    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var viewId = parseInt(value, 10);
    return viewId >= 0 && viewId <= max ? viewId : origValue;
}
// Create Datepicker configuration to set
function $7c39ee59de2954f9$var$processOptions(options, datepicker) {
    var inOpts = Object.assign({}, options);
    var config = {};
    var locales = datepicker.constructor.locales;
    var _ref = datepicker.config || {}, format = _ref.format, language = _ref.language, locale = _ref.locale, maxDate = _ref.maxDate, maxView = _ref.maxView, minDate = _ref.minDate, pickLevel = _ref.pickLevel, startView = _ref.startView, weekStart = _ref.weekStart;
    if (inOpts.language) {
        var lang;
        if (inOpts.language !== language) {
            if (locales[inOpts.language]) lang = inOpts.language;
            else {
                // Check if langauge + region tag can fallback to the one without
                // region (e.g. fr-CA → fr)
                lang = inOpts.language.split('-')[0];
                if (locales[lang] === undefined) lang = false;
            }
        }
        delete inOpts.language;
        if (lang) {
            language = config.language = lang;
            // update locale as well when updating language
            var origLocale = locale || locales[$7c39ee59de2954f9$var$defaultLang];
            // use default language's properties for the fallback
            locale = Object.assign({
                format: $7c39ee59de2954f9$var$defaultFormat,
                weekStart: $7c39ee59de2954f9$var$defaultWeekStart
            }, locales[$7c39ee59de2954f9$var$defaultLang]);
            if (language !== $7c39ee59de2954f9$var$defaultLang) Object.assign(locale, locales[language]);
            config.locale = locale;
            // if format and/or weekStart are the same as old locale's defaults,
            // update them to new locale's defaults
            if (format === origLocale.format) format = config.format = locale.format;
            if (weekStart === origLocale.weekStart) {
                weekStart = config.weekStart = locale.weekStart;
                config.weekEnd = $7c39ee59de2954f9$var$calcEndOfWeek(locale.weekStart);
            }
        }
    }
    if (inOpts.format) {
        var hasToDisplay = typeof inOpts.format.toDisplay === 'function';
        var hasToValue = typeof inOpts.format.toValue === 'function';
        var validFormatString = $7c39ee59de2954f9$var$reFormatTokens.test(inOpts.format);
        if (hasToDisplay && hasToValue || validFormatString) format = config.format = inOpts.format;
        delete inOpts.format;
    }
    //*** dates ***//
    // while min and maxDate for "no limit" in the options are better to be null
    // (especially when updating), the ones in the config have to be undefined
    // because null is treated as 0 (= unix epoch) when comparing with time value
    var minDt = minDate;
    var maxDt = maxDate;
    if (inOpts.minDate !== undefined) {
        minDt = inOpts.minDate === null ? $7c39ee59de2954f9$var$dateValue(0, 0, 1) // set 0000-01-01 to prevent negative values for year
         : $7c39ee59de2954f9$var$validateDate(inOpts.minDate, format, locale, minDt);
        delete inOpts.minDate;
    }
    if (inOpts.maxDate !== undefined) {
        maxDt = inOpts.maxDate === null ? undefined : $7c39ee59de2954f9$var$validateDate(inOpts.maxDate, format, locale, maxDt);
        delete inOpts.maxDate;
    }
    if (maxDt < minDt) {
        minDate = config.minDate = maxDt;
        maxDate = config.maxDate = minDt;
    } else {
        if (minDate !== minDt) minDate = config.minDate = minDt;
        if (maxDate !== maxDt) maxDate = config.maxDate = maxDt;
    }
    if (inOpts.datesDisabled) {
        config.datesDisabled = inOpts.datesDisabled.reduce(function(dates, dt) {
            var date = $7c39ee59de2954f9$var$parseDate(dt, format, locale);
            return date !== undefined ? $7c39ee59de2954f9$var$pushUnique(dates, date) : dates;
        }, []);
        delete inOpts.datesDisabled;
    }
    if (inOpts.defaultViewDate !== undefined) {
        var viewDate = $7c39ee59de2954f9$var$parseDate(inOpts.defaultViewDate, format, locale);
        if (viewDate !== undefined) config.defaultViewDate = viewDate;
        delete inOpts.defaultViewDate;
    }
    //*** days of week ***//
    if (inOpts.weekStart !== undefined) {
        var wkStart = Number(inOpts.weekStart) % 7;
        if (!isNaN(wkStart)) {
            weekStart = config.weekStart = wkStart;
            config.weekEnd = $7c39ee59de2954f9$var$calcEndOfWeek(wkStart);
        }
        delete inOpts.weekStart;
    }
    if (inOpts.daysOfWeekDisabled) {
        config.daysOfWeekDisabled = inOpts.daysOfWeekDisabled.reduce($7c39ee59de2954f9$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekDisabled;
    }
    if (inOpts.daysOfWeekHighlighted) {
        config.daysOfWeekHighlighted = inOpts.daysOfWeekHighlighted.reduce($7c39ee59de2954f9$var$sanitizeDOW, []);
        delete inOpts.daysOfWeekHighlighted;
    }
    //*** multi date ***//
    if (inOpts.maxNumberOfDates !== undefined) {
        var maxNumberOfDates = parseInt(inOpts.maxNumberOfDates, 10);
        if (maxNumberOfDates >= 0) {
            config.maxNumberOfDates = maxNumberOfDates;
            config.multidate = maxNumberOfDates !== 1;
        }
        delete inOpts.maxNumberOfDates;
    }
    if (inOpts.dateDelimiter) {
        config.dateDelimiter = String(inOpts.dateDelimiter);
        delete inOpts.dateDelimiter;
    }
    //*** pick level & view ***//
    var newPickLevel = pickLevel;
    if (inOpts.pickLevel !== undefined) {
        newPickLevel = $7c39ee59de2954f9$var$validateViewId(inOpts.pickLevel, 2);
        delete inOpts.pickLevel;
    }
    if (newPickLevel !== pickLevel) pickLevel = config.pickLevel = newPickLevel;
    var newMaxView = maxView;
    if (inOpts.maxView !== undefined) {
        newMaxView = $7c39ee59de2954f9$var$validateViewId(inOpts.maxView, maxView);
        delete inOpts.maxView;
    }
    // ensure max view >= pick level
    newMaxView = pickLevel > newMaxView ? pickLevel : newMaxView;
    if (newMaxView !== maxView) maxView = config.maxView = newMaxView;
    var newStartView = startView;
    if (inOpts.startView !== undefined) {
        newStartView = $7c39ee59de2954f9$var$validateViewId(inOpts.startView, newStartView);
        delete inOpts.startView;
    }
    // ensure pick level <= start view <= max view
    if (newStartView < pickLevel) newStartView = pickLevel;
    else if (newStartView > maxView) newStartView = maxView;
    if (newStartView !== startView) config.startView = newStartView;
    //*** template ***//
    if (inOpts.prevArrow) {
        var prevArrow = $7c39ee59de2954f9$var$parseHTML(inOpts.prevArrow);
        if (prevArrow.childNodes.length > 0) config.prevArrow = prevArrow.childNodes;
        delete inOpts.prevArrow;
    }
    if (inOpts.nextArrow) {
        var nextArrow = $7c39ee59de2954f9$var$parseHTML(inOpts.nextArrow);
        if (nextArrow.childNodes.length > 0) config.nextArrow = nextArrow.childNodes;
        delete inOpts.nextArrow;
    }
    //*** misc ***//
    if (inOpts.disableTouchKeyboard !== undefined) {
        config.disableTouchKeyboard = 'ontouchstart' in document && !!inOpts.disableTouchKeyboard;
        delete inOpts.disableTouchKeyboard;
    }
    if (inOpts.orientation) {
        var orientation = inOpts.orientation.toLowerCase().split(/\s+/g);
        config.orientation = {
            x: orientation.find(function(x) {
                return x === 'left' || x === 'right';
            }) || 'auto',
            y: orientation.find(function(y) {
                return y === 'top' || y === 'bottom';
            }) || 'auto'
        };
        delete inOpts.orientation;
    }
    if (inOpts.todayBtnMode !== undefined) {
        switch(inOpts.todayBtnMode){
            case 0:
            case 1:
                config.todayBtnMode = inOpts.todayBtnMode;
        }
        delete inOpts.todayBtnMode;
    }
    //*** copy the rest ***//
    Object.keys(inOpts).forEach(function(key) {
        if (inOpts[key] !== undefined && $7c39ee59de2954f9$var$hasProperty($7c39ee59de2954f9$var$defaultOptions, key)) config[key] = inOpts[key];
    });
    return config;
}
var $7c39ee59de2954f9$var$pickerTemplate = $7c39ee59de2954f9$var$optimizeTemplateHTML("<div class=\"datepicker hidden\">\n  <div class=\"datepicker-picker inline-block rounded-lg bg-white dark:bg-gray-700 shadow-lg p-4\">\n    <div class=\"datepicker-header\">\n      <div class=\"datepicker-title bg-white dark:bg-gray-700 dark:text-white px-2 py-3 text-center font-semibold\"></div>\n      <div class=\"datepicker-controls flex justify-between mb-2\">\n        <button type=\"button\" class=\"bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 prev-btn\"></button>\n        <button type=\"button\" class=\"text-sm rounded-lg text-gray-900 dark:text-white bg-white dark:bg-gray-700 font-semibold py-2.5 px-5 hover:bg-gray-100 dark:hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-200 view-switch\"></button>\n        <button type=\"button\" class=\"bg-white dark:bg-gray-700 rounded-lg text-gray-500 dark:text-white hover:bg-gray-100 dark:hover:bg-gray-600 hover:text-gray-900 dark:hover:text-white text-lg p-2.5 focus:outline-none focus:ring-2 focus:ring-gray-200 next-btn\"></button>\n      </div>\n    </div>\n    <div class=\"datepicker-main p-1\"></div>\n    <div class=\"datepicker-footer\">\n      <div class=\"datepicker-controls flex space-x-2 rtl:space-x-reverse mt-2\">\n        <button type=\"button\" class=\"%buttonClass% today-btn text-white bg-blue-700 !bg-primary-700 dark:bg-blue-600 dark:!bg-primary-600 hover:bg-blue-800 hover:!bg-primary-800 dark:hover:bg-blue-700 dark:hover:!bg-primary-700 focus:ring-4 focus:ring-blue-300 focus:!ring-primary-300 font-medium rounded-lg text-sm px-5 py-2 text-center w-1/2\"></button>\n        <button type=\"button\" class=\"%buttonClass% clear-btn text-gray-900 dark:text-white bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-600 focus:ring-4 focus:ring-blue-300 focus:!ring-primary-300 font-medium rounded-lg text-sm px-5 py-2 text-center w-1/2\"></button>\n      </div>\n    </div>\n  </div>\n</div>");
var $7c39ee59de2954f9$var$daysTemplate = $7c39ee59de2954f9$var$optimizeTemplateHTML("<div class=\"days\">\n  <div class=\"days-of-week grid grid-cols-7 mb-1\">".concat($7c39ee59de2954f9$var$createTagRepeat('span', 7, {
    "class": 'dow block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm'
}), "</div>\n  <div class=\"datepicker-grid w-64 grid grid-cols-7\">").concat($7c39ee59de2954f9$var$createTagRepeat('span', 42, {
    "class": 'block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400'
}), "</div>\n</div>"));
var $7c39ee59de2954f9$var$calendarWeeksTemplate = $7c39ee59de2954f9$var$optimizeTemplateHTML("<div class=\"calendar-weeks\">\n  <div class=\"days-of-week flex\"><span class=\"dow h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400\"></span></div>\n  <div class=\"weeks\">".concat($7c39ee59de2954f9$var$createTagRepeat('span', 6, {
    "class": 'week block flex-1 leading-9 border-0 rounded-lg cursor-default text-center text-gray-900 font-semibold text-sm'
}), "</div>\n</div>"));
// Base class of the view classes
var $7c39ee59de2954f9$var$View = /*#__PURE__*/ function() {
    function View(picker, config) {
        $7c39ee59de2954f9$var$_classCallCheck(this, View);
        Object.assign(this, config, {
            picker: picker,
            element: $7c39ee59de2954f9$var$parseHTML("<div class=\"datepicker-view flex\"></div>").firstChild,
            selected: []
        });
        this.init(this.picker.datepicker.config);
    }
    return $7c39ee59de2954f9$var$_createClass(View, [
        {
            key: "init",
            value: function init(options) {
                if (options.pickLevel !== undefined) this.isMinView = this.id === options.pickLevel;
                this.setOptions(options);
                this.updateFocus();
                this.updateSelection();
            }
        },
        {
            key: "performBeforeHook",
            value: function performBeforeHook(el, current, timeValue) {
                var result = this.beforeShow(new Date(timeValue));
                switch($7c39ee59de2954f9$var$_typeof(result)){
                    case 'boolean':
                        result = {
                            enabled: result
                        };
                        break;
                    case 'string':
                        result = {
                            classes: result
                        };
                }
                if (result) {
                    if (result.enabled === false) {
                        el.classList.add('disabled');
                        $7c39ee59de2954f9$var$pushUnique(this.disabled, current);
                    }
                    if (result.classes) {
                        var _el$classList;
                        var extraClasses = result.classes.split(/\s+/);
                        (_el$classList = el.classList).add.apply(_el$classList, $7c39ee59de2954f9$var$_toConsumableArray(extraClasses));
                        if (extraClasses.includes('disabled')) $7c39ee59de2954f9$var$pushUnique(this.disabled, current);
                    }
                    if (result.content) $7c39ee59de2954f9$var$replaceChildNodes(el, result.content);
                }
            }
        }
    ]);
}();
var $7c39ee59de2954f9$var$DaysView = /*#__PURE__*/ function(_View) {
    function DaysView(picker) {
        $7c39ee59de2954f9$var$_classCallCheck(this, DaysView);
        return $7c39ee59de2954f9$var$_callSuper(this, DaysView, [
            picker,
            {
                id: 0,
                name: 'days',
                cellClass: 'day'
            }
        ]);
    }
    $7c39ee59de2954f9$var$_inherits(DaysView, _View);
    return $7c39ee59de2954f9$var$_createClass(DaysView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    var inner = $7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$daysTemplate).firstChild;
                    this.dow = inner.firstChild;
                    this.grid = inner.lastChild;
                    this.element.appendChild(inner);
                }
                $7c39ee59de2954f9$var$_get($7c39ee59de2954f9$var$_getPrototypeOf(DaysView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var _this = this;
                var updateDOW;
                if ($7c39ee59de2954f9$var$hasProperty(options, 'minDate')) this.minDate = options.minDate;
                if ($7c39ee59de2954f9$var$hasProperty(options, 'maxDate')) this.maxDate = options.maxDate;
                if (options.datesDisabled) this.datesDisabled = options.datesDisabled;
                if (options.daysOfWeekDisabled) {
                    this.daysOfWeekDisabled = options.daysOfWeekDisabled;
                    updateDOW = true;
                }
                if (options.daysOfWeekHighlighted) this.daysOfWeekHighlighted = options.daysOfWeekHighlighted;
                if (options.todayHighlight !== undefined) this.todayHighlight = options.todayHighlight;
                if (options.weekStart !== undefined) {
                    this.weekStart = options.weekStart;
                    this.weekEnd = options.weekEnd;
                    updateDOW = true;
                }
                if (options.locale) {
                    var locale = this.locale = options.locale;
                    this.dayNames = locale.daysMin;
                    this.switchLabelFormat = locale.titleFormat;
                    updateDOW = true;
                }
                if (options.beforeShowDay !== undefined) this.beforeShow = typeof options.beforeShowDay === 'function' ? options.beforeShowDay : undefined;
                if (options.calendarWeeks !== undefined) {
                    if (options.calendarWeeks && !this.calendarWeeks) {
                        var weeksElem = $7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$calendarWeeksTemplate).firstChild;
                        this.calendarWeeks = {
                            element: weeksElem,
                            dow: weeksElem.firstChild,
                            weeks: weeksElem.lastChild
                        };
                        this.element.insertBefore(weeksElem, this.element.firstChild);
                    } else if (this.calendarWeeks && !options.calendarWeeks) {
                        this.element.removeChild(this.calendarWeeks.element);
                        this.calendarWeeks = null;
                    }
                }
                if (options.showDaysOfWeek !== undefined) {
                    if (options.showDaysOfWeek) {
                        $7c39ee59de2954f9$var$showElement(this.dow);
                        if (this.calendarWeeks) $7c39ee59de2954f9$var$showElement(this.calendarWeeks.dow);
                    } else {
                        $7c39ee59de2954f9$var$hideElement(this.dow);
                        if (this.calendarWeeks) $7c39ee59de2954f9$var$hideElement(this.calendarWeeks.dow);
                    }
                }
                // update days-of-week when locale, daysOfweekDisabled or weekStart is changed
                if (updateDOW) Array.from(this.dow.children).forEach(function(el, index) {
                    var dow = (_this.weekStart + index) % 7;
                    el.textContent = _this.dayNames[dow];
                    el.className = _this.daysOfWeekDisabled.includes(dow) ? 'dow disabled text-center h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400 cursor-not-allowed' : 'dow text-center h-6 leading-6 text-sm font-medium text-gray-500 dark:text-gray-400';
                });
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                var viewYear = viewDate.getFullYear();
                var viewMonth = viewDate.getMonth();
                var firstOfMonth = $7c39ee59de2954f9$var$dateValue(viewYear, viewMonth, 1);
                var start = $7c39ee59de2954f9$var$dayOfTheWeekOf(firstOfMonth, this.weekStart, this.weekStart);
                this.first = firstOfMonth;
                this.last = $7c39ee59de2954f9$var$dateValue(viewYear, viewMonth + 1, 0);
                this.start = start;
                this.focused = this.picker.viewDate;
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates;
                if (rangepicker) this.range = rangepicker.dates;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // update today marker on ever render
                this.today = this.todayHighlight ? $7c39ee59de2954f9$var$today() : undefined;
                // refresh disabled dates on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = $7c39ee59de2954f9$var$_toConsumableArray(this.datesDisabled);
                var switchLabel = $7c39ee59de2954f9$var$formatDate(this.focused, this.switchLabelFormat, this.locale);
                this.picker.setViewSwitchLabel(switchLabel);
                this.picker.setPrevBtnDisabled(this.first <= this.minDate);
                this.picker.setNextBtnDisabled(this.last >= this.maxDate);
                if (this.calendarWeeks) {
                    // start of the UTC week (Monday) of the 1st of the month
                    var startOfWeek = $7c39ee59de2954f9$var$dayOfTheWeekOf(this.first, 1, 1);
                    Array.from(this.calendarWeeks.weeks.children).forEach(function(el, index) {
                        el.textContent = $7c39ee59de2954f9$var$getWeek($7c39ee59de2954f9$var$addWeeks(startOfWeek, index));
                    });
                }
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var current = $7c39ee59de2954f9$var$addDays(_this2.start, index);
                    var date = new Date(current);
                    var day = date.getDay();
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this2.cellClass);
                    el.dataset.date = current;
                    el.textContent = date.getDate();
                    if (current < _this2.first) classList.add('prev', 'text-gray-500', 'dark:text-white');
                    else if (current > _this2.last) classList.add('next', 'text-gray-500', 'dark:text-white');
                    if (_this2.today === current) classList.add('today', 'bg-gray-100', 'dark:bg-gray-600');
                    if (current < _this2.minDate || current > _this2.maxDate || _this2.disabled.includes(current)) {
                        classList.add('disabled', 'cursor-not-allowed', 'text-gray-400', 'dark:text-gray-500');
                        classList.remove('hover:bg-gray-100', 'dark:hover:bg-gray-600', 'text-gray-900', 'dark:text-white', 'cursor-pointer');
                    }
                    if (_this2.daysOfWeekDisabled.includes(day)) {
                        classList.add('disabled', 'cursor-not-allowed', 'text-gray-400', 'dark:text-gray-500');
                        classList.remove('hover:bg-gray-100', 'dark:hover:bg-gray-600', 'text-gray-900', 'dark:text-white', 'cursor-pointer');
                        $7c39ee59de2954f9$var$pushUnique(_this2.disabled, current);
                    }
                    if (_this2.daysOfWeekHighlighted.includes(day)) classList.add('highlighted');
                    if (_this2.range) {
                        var _this2$range = $7c39ee59de2954f9$var$_slicedToArray(_this2.range, 2), rangeStart = _this2$range[0], rangeEnd = _this2$range[1];
                        if (current > rangeStart && current < rangeEnd) {
                            classList.add('range', 'bg-gray-200', 'dark:bg-gray-600');
                            classList.remove('rounded-lg', 'rounded-l-lg', 'rounded-r-lg');
                        }
                        if (current === rangeStart) {
                            classList.add('range-start', 'bg-gray-100', 'dark:bg-gray-600', 'rounded-l-lg');
                            classList.remove('rounded-lg', 'rounded-r-lg');
                        }
                        if (current === rangeEnd) {
                            classList.add('range-end', 'bg-gray-100', 'dark:bg-gray-600', 'rounded-r-lg');
                            classList.remove('rounded-lg', 'rounded-l-lg');
                        }
                    }
                    if (_this2.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'text-gray-500', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600', 'dark:bg-gray-600', 'bg-gray-100', 'bg-gray-200');
                    }
                    if (current === _this2.focused) classList.add('focused');
                    if (_this2.beforeShow) _this2.performBeforeHook(el, current, current);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;
                var _ref = this.range || [], _ref2 = $7c39ee59de2954f9$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll('.range, .range-start, .range-end, .selected, .focused').forEach(function(el) {
                    el.classList.remove('range', 'range-start', 'range-end', 'selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white', 'focused');
                    el.classList.add('text-gray-900', 'rounded-lg', 'dark:text-white');
                });
                Array.from(this.grid.children).forEach(function(el) {
                    var current = Number(el.dataset.date);
                    var classList = el.classList;
                    classList.remove('bg-gray-200', 'dark:bg-gray-600', 'rounded-l-lg', 'rounded-r-lg');
                    if (current > rangeStart && current < rangeEnd) {
                        classList.add('range', 'bg-gray-200', 'dark:bg-gray-600');
                        classList.remove('rounded-lg');
                    }
                    if (current === rangeStart) {
                        classList.add('range-start', 'bg-gray-200', 'dark:bg-gray-600', 'rounded-l-lg');
                        classList.remove('rounded-lg');
                    }
                    if (current === rangeEnd) {
                        classList.add('range-end', 'bg-gray-200', 'dark:bg-gray-600', 'rounded-r-lg');
                        classList.remove('rounded-lg');
                    }
                    if (_this3.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600', 'bg-gray-100', 'bg-gray-200', 'dark:bg-gray-600');
                    }
                    if (current === _this3.focused) classList.add('focused');
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                var index = Math.round((this.focused - this.start) / 86400000);
                this.grid.querySelectorAll('.focused').forEach(function(el) {
                    el.classList.remove('focused');
                });
                this.grid.children[index].classList.add('focused');
            }
        }
    ]);
}($7c39ee59de2954f9$var$View);
function $7c39ee59de2954f9$var$computeMonthRange(range, thisYear) {
    if (!range || !range[0] || !range[1]) return;
    var _range = $7c39ee59de2954f9$var$_slicedToArray(range, 2), _range$ = $7c39ee59de2954f9$var$_slicedToArray(_range[0], 2), startY = _range$[0], startM = _range$[1], _range$2 = $7c39ee59de2954f9$var$_slicedToArray(_range[1], 2), endY = _range$2[0], endM = _range$2[1];
    if (startY > thisYear || endY < thisYear) return;
    return [
        startY === thisYear ? startM : -1,
        endY === thisYear ? endM : 12
    ];
}
var $7c39ee59de2954f9$var$MonthsView = /*#__PURE__*/ function(_View) {
    function MonthsView(picker) {
        $7c39ee59de2954f9$var$_classCallCheck(this, MonthsView);
        return $7c39ee59de2954f9$var$_callSuper(this, MonthsView, [
            picker,
            {
                id: 1,
                name: 'months',
                cellClass: 'month'
            }
        ]);
    }
    $7c39ee59de2954f9$var$_inherits(MonthsView, _View);
    return $7c39ee59de2954f9$var$_createClass(MonthsView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    this.grid = this.element;
                    this.element.classList.add('months', 'datepicker-grid', 'w-64', 'grid', 'grid-cols-4');
                    this.grid.appendChild($7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$createTagRepeat('span', 12, {
                        'data-month': function dataMonth(ix) {
                            return ix;
                        }
                    })));
                }
                $7c39ee59de2954f9$var$_get($7c39ee59de2954f9$var$_getPrototypeOf(MonthsView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if (options.locale) this.monthNames = options.locale.monthsShort;
                if ($7c39ee59de2954f9$var$hasProperty(options, 'minDate')) {
                    if (options.minDate === undefined) this.minYear = this.minMonth = this.minDate = undefined;
                    else {
                        var minDateObj = new Date(options.minDate);
                        this.minYear = minDateObj.getFullYear();
                        this.minMonth = minDateObj.getMonth();
                        this.minDate = minDateObj.setDate(1);
                    }
                }
                if ($7c39ee59de2954f9$var$hasProperty(options, 'maxDate')) {
                    if (options.maxDate === undefined) this.maxYear = this.maxMonth = this.maxDate = undefined;
                    else {
                        var maxDateObj = new Date(options.maxDate);
                        this.maxYear = maxDateObj.getFullYear();
                        this.maxMonth = maxDateObj.getMonth();
                        this.maxDate = $7c39ee59de2954f9$var$dateValue(this.maxYear, this.maxMonth + 1, 0);
                    }
                }
                if (options.beforeShowMonth !== undefined) this.beforeShow = typeof options.beforeShowMonth === 'function' ? options.beforeShowMonth : undefined;
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                this.year = viewDate.getFullYear();
                this.focused = viewDate.getMonth();
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates.reduce(function(selected, timeValue) {
                    var date = new Date(timeValue);
                    var year = date.getFullYear();
                    var month = date.getMonth();
                    if (selected[year] === undefined) selected[year] = [
                        month
                    ];
                    else $7c39ee59de2954f9$var$pushUnique(selected[year], month);
                    return selected;
                }, {});
                if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map(function(timeValue) {
                    var date = new Date(timeValue);
                    return isNaN(date) ? undefined : [
                        date.getFullYear(),
                        date.getMonth()
                    ];
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                // refresh disabled months on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = [];
                this.picker.setViewSwitchLabel(this.year);
                this.picker.setPrevBtnDisabled(this.year <= this.minYear);
                this.picker.setNextBtnDisabled(this.year >= this.maxYear);
                var selected = this.selected[this.year] || [];
                var yrOutOfRange = this.year < this.minYear || this.year > this.maxYear;
                var isMinYear = this.year === this.minYear;
                var isMaxYear = this.year === this.maxYear;
                var range = $7c39ee59de2954f9$var$computeMonthRange(this.range, this.year);
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var date = $7c39ee59de2954f9$var$dateValue(_this.year, index, 1);
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this.cellClass);
                    if (_this.isMinView) el.dataset.date = date;
                    // reset text on every render to clear the custom content set
                    // by beforeShow hook at previous render
                    el.textContent = _this.monthNames[index];
                    if (yrOutOfRange || isMinYear && index < _this.minMonth || isMaxYear && index > _this.maxMonth) classList.add('disabled');
                    if (range) {
                        var _range2 = $7c39ee59de2954f9$var$_slicedToArray(range, 2), rangeStart = _range2[0], rangeEnd = _range2[1];
                        if (index > rangeStart && index < rangeEnd) classList.add('range');
                        if (index === rangeStart) classList.add('range-start');
                        if (index === rangeEnd) classList.add('range-end');
                    }
                    if (selected.includes(index)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (index === _this.focused) classList.add('focused');
                    if (_this.beforeShow) _this.performBeforeHook(el, index, date);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this2 = this;
                var selected = this.selected[this.year] || [];
                var _ref = $7c39ee59de2954f9$var$computeMonthRange(this.range, this.year) || [], _ref2 = $7c39ee59de2954f9$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll('.range, .range-start, .range-end, .selected, .focused').forEach(function(el) {
                    el.classList.remove('range', 'range-start', 'range-end', 'selected', 'bg-blue-700', '!bg-primary-700', 'dark:bg-blue-600', 'dark:!bg-primary-700', 'dark:text-white', 'text-white', 'focused');
                    el.classList.add('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                });
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    if (index > rangeStart && index < rangeEnd) classList.add('range');
                    if (index === rangeStart) classList.add('range-start');
                    if (index === rangeEnd) classList.add('range-end');
                    if (selected.includes(index)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (index === _this2.focused) classList.add('focused');
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                this.grid.querySelectorAll('.focused').forEach(function(el) {
                    el.classList.remove('focused');
                });
                this.grid.children[this.focused].classList.add('focused');
            }
        }
    ]);
}($7c39ee59de2954f9$var$View);
function $7c39ee59de2954f9$var$toTitleCase(word) {
    return $7c39ee59de2954f9$var$_toConsumableArray(word).reduce(function(str, ch, ix) {
        return str += ix ? ch : ch.toUpperCase();
    }, '');
}
// Class representing the years and decades view elements
var $7c39ee59de2954f9$var$YearsView = /*#__PURE__*/ function(_View) {
    function YearsView(picker, config) {
        $7c39ee59de2954f9$var$_classCallCheck(this, YearsView);
        return $7c39ee59de2954f9$var$_callSuper(this, YearsView, [
            picker,
            config
        ]);
    }
    $7c39ee59de2954f9$var$_inherits(YearsView, _View);
    return $7c39ee59de2954f9$var$_createClass(YearsView, [
        {
            key: "init",
            value: function init(options) {
                var onConstruction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                if (onConstruction) {
                    this.navStep = this.step * 10;
                    this.beforeShowOption = "beforeShow".concat($7c39ee59de2954f9$var$toTitleCase(this.cellClass));
                    this.grid = this.element;
                    this.element.classList.add(this.name, 'datepicker-grid', 'w-64', 'grid', 'grid-cols-4');
                    this.grid.appendChild($7c39ee59de2954f9$var$parseHTML($7c39ee59de2954f9$var$createTagRepeat('span', 12)));
                }
                $7c39ee59de2954f9$var$_get($7c39ee59de2954f9$var$_getPrototypeOf(YearsView.prototype), "init", this).call(this, options);
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                if ($7c39ee59de2954f9$var$hasProperty(options, 'minDate')) {
                    if (options.minDate === undefined) this.minYear = this.minDate = undefined;
                    else {
                        this.minYear = $7c39ee59de2954f9$var$startOfYearPeriod(options.minDate, this.step);
                        this.minDate = $7c39ee59de2954f9$var$dateValue(this.minYear, 0, 1);
                    }
                }
                if ($7c39ee59de2954f9$var$hasProperty(options, 'maxDate')) {
                    if (options.maxDate === undefined) this.maxYear = this.maxDate = undefined;
                    else {
                        this.maxYear = $7c39ee59de2954f9$var$startOfYearPeriod(options.maxDate, this.step);
                        this.maxDate = $7c39ee59de2954f9$var$dateValue(this.maxYear, 11, 31);
                    }
                }
                if (options[this.beforeShowOption] !== undefined) {
                    var beforeShow = options[this.beforeShowOption];
                    this.beforeShow = typeof beforeShow === 'function' ? beforeShow : undefined;
                }
            }
        },
        {
            key: "updateFocus",
            value: function updateFocus() {
                var viewDate = new Date(this.picker.viewDate);
                var first = $7c39ee59de2954f9$var$startOfYearPeriod(viewDate, this.navStep);
                var last = first + 9 * this.step;
                this.first = first;
                this.last = last;
                this.start = first - this.step;
                this.focused = $7c39ee59de2954f9$var$startOfYearPeriod(viewDate, this.step);
            }
        },
        {
            key: "updateSelection",
            value: function updateSelection() {
                var _this = this;
                var _this$picker$datepick = this.picker.datepicker, dates = _this$picker$datepick.dates, rangepicker = _this$picker$datepick.rangepicker;
                this.selected = dates.reduce(function(years, timeValue) {
                    return $7c39ee59de2954f9$var$pushUnique(years, $7c39ee59de2954f9$var$startOfYearPeriod(timeValue, _this.step));
                }, []);
                if (rangepicker && rangepicker.dates) this.range = rangepicker.dates.map(function(timeValue) {
                    if (timeValue !== undefined) return $7c39ee59de2954f9$var$startOfYearPeriod(timeValue, _this.step);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                // refresh disabled years on every render in order to clear the ones added
                // by beforeShow hook at previous render
                this.disabled = [];
                this.picker.setViewSwitchLabel("".concat(this.first, "-").concat(this.last));
                this.picker.setPrevBtnDisabled(this.first <= this.minYear);
                this.picker.setNextBtnDisabled(this.last >= this.maxYear);
                Array.from(this.grid.children).forEach(function(el, index) {
                    var classList = el.classList;
                    var current = _this2.start + index * _this2.step;
                    var date = $7c39ee59de2954f9$var$dateValue(current, 0, 1);
                    el.className = "datepicker-cell hover:bg-gray-100 dark:hover:bg-gray-600 block flex-1 leading-9 border-0 rounded-lg cursor-pointer text-center text-gray-900 dark:text-white font-semibold text-sm ".concat(_this2.cellClass);
                    if (_this2.isMinView) el.dataset.date = date;
                    el.textContent = el.dataset.year = current;
                    if (index === 0) classList.add('prev');
                    else if (index === 11) classList.add('next');
                    if (current < _this2.minYear || current > _this2.maxYear) classList.add('disabled');
                    if (_this2.range) {
                        var _this2$range = $7c39ee59de2954f9$var$_slicedToArray(_this2.range, 2), rangeStart = _this2$range[0], rangeEnd = _this2$range[1];
                        if (current > rangeStart && current < rangeEnd) classList.add('range');
                        if (current === rangeStart) classList.add('range-start');
                        if (current === rangeEnd) classList.add('range-end');
                    }
                    if (_this2.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (current === _this2.focused) classList.add('focused');
                    if (_this2.beforeShow) _this2.performBeforeHook(el, current, date);
                });
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var _this3 = this;
                var _ref = this.range || [], _ref2 = $7c39ee59de2954f9$var$_slicedToArray(_ref, 2), rangeStart = _ref2[0], rangeEnd = _ref2[1];
                this.grid.querySelectorAll('.range, .range-start, .range-end, .selected, .focused').forEach(function(el) {
                    el.classList.remove('range', 'range-start', 'range-end', 'selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark!bg-primary-600', 'dark:text-white', 'focused');
                });
                Array.from(this.grid.children).forEach(function(el) {
                    var current = Number(el.textContent);
                    var classList = el.classList;
                    if (current > rangeStart && current < rangeEnd) classList.add('range');
                    if (current === rangeStart) classList.add('range-start');
                    if (current === rangeEnd) classList.add('range-end');
                    if (_this3.selected.includes(current)) {
                        classList.add('selected', 'bg-blue-700', '!bg-primary-700', 'text-white', 'dark:bg-blue-600', 'dark:!bg-primary-600', 'dark:text-white');
                        classList.remove('text-gray-900', 'hover:bg-gray-100', 'dark:text-white', 'dark:hover:bg-gray-600');
                    }
                    if (current === _this3.focused) classList.add('focused');
                });
            }
        },
        {
            key: "refreshFocus",
            value: function refreshFocus() {
                var index = Math.round((this.focused - this.start) / this.step);
                this.grid.querySelectorAll('.focused').forEach(function(el) {
                    el.classList.remove('focused');
                });
                this.grid.children[index].classList.add('focused');
            }
        }
    ]);
}($7c39ee59de2954f9$var$View);
function $7c39ee59de2954f9$var$triggerDatepickerEvent(datepicker, type) {
    var detail = {
        date: datepicker.getDate(),
        viewDate: new Date(datepicker.picker.viewDate),
        viewId: datepicker.picker.currentView.id,
        datepicker: datepicker
    };
    datepicker.element.dispatchEvent(new CustomEvent(type, {
        detail: detail
    }));
}
// direction: -1 (to previous), 1 (to next)
function $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, direction) {
    var _datepicker$config = datepicker.config, minDate = _datepicker$config.minDate, maxDate = _datepicker$config.maxDate;
    var _datepicker$picker = datepicker.picker, currentView = _datepicker$picker.currentView, viewDate = _datepicker$picker.viewDate;
    var newViewDate;
    switch(currentView.id){
        case 0:
            newViewDate = $7c39ee59de2954f9$var$addMonths(viewDate, direction);
            break;
        case 1:
            newViewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction);
            break;
        default:
            newViewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction * currentView.navStep);
    }
    newViewDate = $7c39ee59de2954f9$var$limitToRange(newViewDate, minDate, maxDate);
    datepicker.picker.changeFocus(newViewDate).render();
}
function $7c39ee59de2954f9$var$switchView(datepicker) {
    var viewId = datepicker.picker.currentView.id;
    if (viewId === datepicker.config.maxView) return;
    datepicker.picker.changeView(viewId + 1).render();
}
function $7c39ee59de2954f9$var$unfocus(datepicker) {
    if (datepicker.config.updateOnBlur) datepicker.update({
        autohide: true
    });
    else {
        datepicker.refresh('input');
        datepicker.hide();
    }
}
function $7c39ee59de2954f9$var$goToSelectedMonthOrYear(datepicker, selection) {
    var picker = datepicker.picker;
    var viewDate = new Date(picker.viewDate);
    var viewId = picker.currentView.id;
    var newDate = viewId === 1 ? $7c39ee59de2954f9$var$addMonths(viewDate, selection - viewDate.getMonth()) : $7c39ee59de2954f9$var$addYears(viewDate, selection - viewDate.getFullYear());
    picker.changeFocus(newDate).changeView(viewId - 1).render();
}
function $7c39ee59de2954f9$var$onClickTodayBtn(datepicker) {
    var picker = datepicker.picker;
    var currentDate = $7c39ee59de2954f9$var$today();
    if (datepicker.config.todayBtnMode === 1) {
        if (datepicker.config.autohide) {
            datepicker.setDate(currentDate);
            return;
        }
        datepicker.setDate(currentDate, {
            render: false
        });
        picker.update();
    }
    if (picker.viewDate !== currentDate) picker.changeFocus(currentDate);
    picker.changeView(0).render();
}
function $7c39ee59de2954f9$var$onClickClearBtn(datepicker) {
    datepicker.setDate({
        clear: true
    });
}
function $7c39ee59de2954f9$var$onClickViewSwitch(datepicker) {
    $7c39ee59de2954f9$var$switchView(datepicker);
}
function $7c39ee59de2954f9$var$onClickPrevBtn(datepicker) {
    $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, -1);
}
function $7c39ee59de2954f9$var$onClickNextBtn(datepicker) {
    $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, 1);
}
// For the picker's main block to delegete the events from `datepicker-cell`s
function $7c39ee59de2954f9$var$onClickView(datepicker, ev) {
    var target = $7c39ee59de2954f9$var$findElementInEventPath(ev, '.datepicker-cell');
    if (!target || target.classList.contains('disabled')) return;
    var _datepicker$picker$cu = datepicker.picker.currentView, id = _datepicker$picker$cu.id, isMinView = _datepicker$picker$cu.isMinView;
    if (isMinView) datepicker.setDate(Number(target.dataset.date));
    else if (id === 1) $7c39ee59de2954f9$var$goToSelectedMonthOrYear(datepicker, Number(target.dataset.month));
    else $7c39ee59de2954f9$var$goToSelectedMonthOrYear(datepicker, Number(target.dataset.year));
}
function $7c39ee59de2954f9$var$onClickPicker(datepicker) {
    if (!datepicker.inline && !datepicker.config.disableTouchKeyboard) datepicker.inputField.focus();
}
function $7c39ee59de2954f9$var$processPickerOptions(picker, options) {
    if (options.title !== undefined) {
        if (options.title) {
            picker.controls.title.textContent = options.title;
            $7c39ee59de2954f9$var$showElement(picker.controls.title);
        } else {
            picker.controls.title.textContent = '';
            $7c39ee59de2954f9$var$hideElement(picker.controls.title);
        }
    }
    if (options.prevArrow) {
        var prevBtn = picker.controls.prevBtn;
        $7c39ee59de2954f9$var$emptyChildNodes(prevBtn);
        options.prevArrow.forEach(function(node) {
            prevBtn.appendChild(node.cloneNode(true));
        });
    }
    if (options.nextArrow) {
        var nextBtn = picker.controls.nextBtn;
        $7c39ee59de2954f9$var$emptyChildNodes(nextBtn);
        options.nextArrow.forEach(function(node) {
            nextBtn.appendChild(node.cloneNode(true));
        });
    }
    if (options.locale) {
        picker.controls.todayBtn.textContent = options.locale.today;
        picker.controls.clearBtn.textContent = options.locale.clear;
    }
    if (options.todayBtn !== undefined) {
        if (options.todayBtn) $7c39ee59de2954f9$var$showElement(picker.controls.todayBtn);
        else $7c39ee59de2954f9$var$hideElement(picker.controls.todayBtn);
    }
    if ($7c39ee59de2954f9$var$hasProperty(options, 'minDate') || $7c39ee59de2954f9$var$hasProperty(options, 'maxDate')) {
        var _picker$datepicker$co = picker.datepicker.config, minDate = _picker$datepicker$co.minDate, maxDate = _picker$datepicker$co.maxDate;
        picker.controls.todayBtn.disabled = !$7c39ee59de2954f9$var$isInRange($7c39ee59de2954f9$var$today(), minDate, maxDate);
    }
    if (options.clearBtn !== undefined) {
        if (options.clearBtn) $7c39ee59de2954f9$var$showElement(picker.controls.clearBtn);
        else $7c39ee59de2954f9$var$hideElement(picker.controls.clearBtn);
    }
}
// Compute view date to reset, which will be...
// - the last item of the selected dates or defaultViewDate if no selection
// - limitted to minDate or maxDate if it exceeds the range
function $7c39ee59de2954f9$var$computeResetViewDate(datepicker) {
    var dates = datepicker.dates, config = datepicker.config;
    var viewDate = dates.length > 0 ? $7c39ee59de2954f9$var$lastItemOf(dates) : config.defaultViewDate;
    return $7c39ee59de2954f9$var$limitToRange(viewDate, config.minDate, config.maxDate);
}
// Change current view's view date
function $7c39ee59de2954f9$var$setViewDate(picker, newDate) {
    var oldViewDate = new Date(picker.viewDate);
    var newViewDate = new Date(newDate);
    var _picker$currentView = picker.currentView, id = _picker$currentView.id, year = _picker$currentView.year, first = _picker$currentView.first, last = _picker$currentView.last;
    var viewYear = newViewDate.getFullYear();
    picker.viewDate = newDate;
    if (viewYear !== oldViewDate.getFullYear()) $7c39ee59de2954f9$var$triggerDatepickerEvent(picker.datepicker, 'changeYear');
    if (newViewDate.getMonth() !== oldViewDate.getMonth()) $7c39ee59de2954f9$var$triggerDatepickerEvent(picker.datepicker, 'changeMonth');
    // return whether the new date is in different period on time from the one
    // displayed in the current view
    // when true, the view needs to be re-rendered on the next UI refresh.
    switch(id){
        case 0:
            return newDate < first || newDate > last;
        case 1:
            return viewYear !== year;
        default:
            return viewYear < first || viewYear > last;
    }
}
function $7c39ee59de2954f9$var$getTextDirection(el) {
    return window.getComputedStyle(el).direction;
}
// Class representing the picker UI
var $7c39ee59de2954f9$var$Picker = /*#__PURE__*/ function() {
    function Picker(datepicker) {
        $7c39ee59de2954f9$var$_classCallCheck(this, Picker);
        this.datepicker = datepicker;
        var template = $7c39ee59de2954f9$var$pickerTemplate.replace(/%buttonClass%/g, datepicker.config.buttonClass);
        var element = this.element = $7c39ee59de2954f9$var$parseHTML(template).firstChild;
        var _element$firstChild$c = $7c39ee59de2954f9$var$_slicedToArray(element.firstChild.children, 3), header = _element$firstChild$c[0], main = _element$firstChild$c[1], footer = _element$firstChild$c[2];
        var title = header.firstElementChild;
        var _header$lastElementCh = $7c39ee59de2954f9$var$_slicedToArray(header.lastElementChild.children, 3), prevBtn = _header$lastElementCh[0], viewSwitch = _header$lastElementCh[1], nextBtn = _header$lastElementCh[2];
        var _footer$firstChild$ch = $7c39ee59de2954f9$var$_slicedToArray(footer.firstChild.children, 2), todayBtn = _footer$firstChild$ch[0], clearBtn = _footer$firstChild$ch[1];
        var controls = {
            title: title,
            prevBtn: prevBtn,
            viewSwitch: viewSwitch,
            nextBtn: nextBtn,
            todayBtn: todayBtn,
            clearBtn: clearBtn
        };
        this.main = main;
        this.controls = controls;
        var elementClass = datepicker.inline ? 'inline' : 'dropdown';
        element.classList.add("datepicker-".concat(elementClass));
        elementClass === 'dropdown' && element.classList.add('dropdown', 'absolute', 'top-0', 'left-0', 'z-50', 'pt-2');
        $7c39ee59de2954f9$var$processPickerOptions(this, datepicker.config);
        this.viewDate = $7c39ee59de2954f9$var$computeResetViewDate(datepicker);
        // set up event listeners
        $7c39ee59de2954f9$var$registerListeners(datepicker, [
            [
                element,
                'click',
                $7c39ee59de2954f9$var$onClickPicker.bind(null, datepicker),
                {
                    capture: true
                }
            ],
            [
                main,
                'click',
                $7c39ee59de2954f9$var$onClickView.bind(null, datepicker)
            ],
            [
                controls.viewSwitch,
                'click',
                $7c39ee59de2954f9$var$onClickViewSwitch.bind(null, datepicker)
            ],
            [
                controls.prevBtn,
                'click',
                $7c39ee59de2954f9$var$onClickPrevBtn.bind(null, datepicker)
            ],
            [
                controls.nextBtn,
                'click',
                $7c39ee59de2954f9$var$onClickNextBtn.bind(null, datepicker)
            ],
            [
                controls.todayBtn,
                'click',
                $7c39ee59de2954f9$var$onClickTodayBtn.bind(null, datepicker)
            ],
            [
                controls.clearBtn,
                'click',
                $7c39ee59de2954f9$var$onClickClearBtn.bind(null, datepicker)
            ]
        ]);
        // set up views
        this.views = [
            new $7c39ee59de2954f9$var$DaysView(this),
            new $7c39ee59de2954f9$var$MonthsView(this),
            new $7c39ee59de2954f9$var$YearsView(this, {
                id: 2,
                name: 'years',
                cellClass: 'year',
                step: 1
            }),
            new $7c39ee59de2954f9$var$YearsView(this, {
                id: 3,
                name: 'decades',
                cellClass: 'decade',
                step: 10
            })
        ];
        this.currentView = this.views[datepicker.config.startView];
        this.currentView.render();
        this.main.appendChild(this.currentView.element);
        datepicker.config.container.appendChild(this.element);
    }
    return $7c39ee59de2954f9$var$_createClass(Picker, [
        {
            key: "setOptions",
            value: function setOptions(options) {
                $7c39ee59de2954f9$var$processPickerOptions(this, options);
                this.views.forEach(function(view) {
                    view.init(options, false);
                });
                this.currentView.render();
            }
        },
        {
            key: "detach",
            value: function detach() {
                this.datepicker.config.container.removeChild(this.element);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.active) return;
                this.element.classList.add('active', 'block');
                this.element.classList.remove('hidden');
                this.active = true;
                var datepicker = this.datepicker;
                if (!datepicker.inline) {
                    // ensure picker's direction matches input's
                    var inputDirection = $7c39ee59de2954f9$var$getTextDirection(datepicker.inputField);
                    if (inputDirection !== $7c39ee59de2954f9$var$getTextDirection(datepicker.config.container)) this.element.dir = inputDirection;
                    else if (this.element.dir) this.element.removeAttribute('dir');
                    this.place();
                    if (datepicker.config.disableTouchKeyboard) datepicker.inputField.blur();
                }
                $7c39ee59de2954f9$var$triggerDatepickerEvent(datepicker, 'show');
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (!this.active) return;
                this.datepicker.exitEditMode();
                this.element.classList.remove('active', 'block');
                this.element.classList.add('active', 'block', 'hidden');
                this.active = false;
                $7c39ee59de2954f9$var$triggerDatepickerEvent(this.datepicker, 'hide');
            }
        },
        {
            key: "place",
            value: function place() {
                var _this$element = this.element, classList = _this$element.classList, style = _this$element.style;
                var _this$datepicker = this.datepicker, config = _this$datepicker.config, inputField = _this$datepicker.inputField;
                var container = config.container;
                var _this$element$getBoun = this.element.getBoundingClientRect(), calendarWidth = _this$element$getBoun.width, calendarHeight = _this$element$getBoun.height;
                var _container$getBoundin = container.getBoundingClientRect(), containerLeft = _container$getBoundin.left, containerTop = _container$getBoundin.top, containerWidth = _container$getBoundin.width;
                var _inputField$getBoundi = inputField.getBoundingClientRect(), inputLeft = _inputField$getBoundi.left, inputTop = _inputField$getBoundi.top, inputWidth = _inputField$getBoundi.width, inputHeight = _inputField$getBoundi.height;
                var _config$orientation = config.orientation, orientX = _config$orientation.x, orientY = _config$orientation.y;
                var scrollTop;
                var left;
                var top;
                if (container === document.body) {
                    scrollTop = window.scrollY;
                    left = inputLeft + window.scrollX;
                    top = inputTop + scrollTop;
                } else {
                    scrollTop = container.scrollTop;
                    left = inputLeft - containerLeft;
                    top = inputTop - containerTop + scrollTop;
                }
                if (orientX === 'auto') {
                    if (left < 0) {
                        // align to the left and move into visible area if input's left edge < window's
                        orientX = 'left';
                        left = 10;
                    } else if (left + calendarWidth > containerWidth) // align to the right if canlendar's right edge > container's
                    orientX = 'right';
                    else orientX = $7c39ee59de2954f9$var$getTextDirection(inputField) === 'rtl' ? 'right' : 'left';
                }
                if (orientX === 'right') left -= calendarWidth - inputWidth;
                if (orientY === 'auto') orientY = top - calendarHeight < scrollTop ? 'bottom' : 'top';
                if (orientY === 'top') top -= calendarHeight;
                else top += inputHeight;
                classList.remove('datepicker-orient-top', 'datepicker-orient-bottom', 'datepicker-orient-right', 'datepicker-orient-left');
                classList.add("datepicker-orient-".concat(orientY), "datepicker-orient-".concat(orientX));
                style.top = top ? "".concat(top, "px") : top;
                style.left = left ? "".concat(left, "px") : left;
            }
        },
        {
            key: "setViewSwitchLabel",
            value: function setViewSwitchLabel(labelText) {
                this.controls.viewSwitch.textContent = labelText;
            }
        },
        {
            key: "setPrevBtnDisabled",
            value: function setPrevBtnDisabled(disabled) {
                this.controls.prevBtn.disabled = disabled;
            }
        },
        {
            key: "setNextBtnDisabled",
            value: function setNextBtnDisabled(disabled) {
                this.controls.nextBtn.disabled = disabled;
            }
        },
        {
            key: "changeView",
            value: function changeView(viewId) {
                var oldView = this.currentView;
                var newView = this.views[viewId];
                if (newView.id !== oldView.id) {
                    this.currentView = newView;
                    this._renderMethod = 'render';
                    $7c39ee59de2954f9$var$triggerDatepickerEvent(this.datepicker, 'changeView');
                    this.main.replaceChild(newView.element, oldView.element);
                }
                return this;
            }
        },
        {
            key: "changeFocus",
            value: function changeFocus(newViewDate) {
                this._renderMethod = $7c39ee59de2954f9$var$setViewDate(this, newViewDate) ? 'render' : 'refreshFocus';
                this.views.forEach(function(view) {
                    view.updateFocus();
                });
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var newViewDate = $7c39ee59de2954f9$var$computeResetViewDate(this.datepicker);
                this._renderMethod = $7c39ee59de2954f9$var$setViewDate(this, newViewDate) ? 'render' : 'refresh';
                this.views.forEach(function(view) {
                    view.updateFocus();
                    view.updateSelection();
                });
                return this;
            }
        },
        {
            key: "render",
            value: function render() {
                var quickRender = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var renderMethod = quickRender && this._renderMethod || 'render';
                delete this._renderMethod;
                this.currentView[renderMethod]();
            }
        }
    ]);
}();
// Find the closest date that doesn't meet the condition for unavailable date
// Returns undefined if no available date is found
// addFn: function to calculate the next date
//   - args: time value, amount
// increase: amount to pass to addFn
// testFn: function to test the unavailablity of the date
//   - args: time value; retun: true if unavailable
function $7c39ee59de2954f9$var$findNextAvailableOne(date, addFn, increase, testFn, min, max) {
    if (!$7c39ee59de2954f9$var$isInRange(date, min, max)) return;
    if (testFn(date)) {
        var newDate = addFn(date, increase);
        return $7c39ee59de2954f9$var$findNextAvailableOne(newDate, addFn, increase, testFn, min, max);
    }
    return date;
}
// direction: -1 (left/up), 1 (right/down)
// vertical: true for up/down, false for left/right
function $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, direction, vertical) {
    var picker = datepicker.picker;
    var currentView = picker.currentView;
    var step = currentView.step || 1;
    var viewDate = picker.viewDate;
    var addFn;
    var testFn;
    switch(currentView.id){
        case 0:
            if (vertical) viewDate = $7c39ee59de2954f9$var$addDays(viewDate, direction * 7);
            else if (ev.ctrlKey || ev.metaKey) viewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction);
            else viewDate = $7c39ee59de2954f9$var$addDays(viewDate, direction);
            addFn = $7c39ee59de2954f9$var$addDays;
            testFn = function testFn(date) {
                return currentView.disabled.includes(date);
            };
            break;
        case 1:
            viewDate = $7c39ee59de2954f9$var$addMonths(viewDate, vertical ? direction * 4 : direction);
            addFn = $7c39ee59de2954f9$var$addMonths;
            testFn = function testFn(date) {
                var dt = new Date(date);
                var year = currentView.year, disabled = currentView.disabled;
                return dt.getFullYear() === year && disabled.includes(dt.getMonth());
            };
            break;
        default:
            viewDate = $7c39ee59de2954f9$var$addYears(viewDate, direction * (vertical ? 4 : 1) * step);
            addFn = $7c39ee59de2954f9$var$addYears;
            testFn = function testFn(date) {
                return currentView.disabled.includes($7c39ee59de2954f9$var$startOfYearPeriod(date, step));
            };
    }
    viewDate = $7c39ee59de2954f9$var$findNextAvailableOne(viewDate, addFn, direction < 0 ? -step : step, testFn, currentView.minDate, currentView.maxDate);
    if (viewDate !== undefined) picker.changeFocus(viewDate).render();
}
function $7c39ee59de2954f9$var$onKeydown(datepicker, ev) {
    if (ev.key === 'Tab') {
        $7c39ee59de2954f9$var$unfocus(datepicker);
        return;
    }
    var picker = datepicker.picker;
    var _picker$currentView = picker.currentView, id = _picker$currentView.id, isMinView = _picker$currentView.isMinView;
    if (!picker.active) switch(ev.key){
        case 'ArrowDown':
        case 'Escape':
            picker.show();
            break;
        case 'Enter':
            datepicker.update();
            break;
        default:
            return;
    }
    else if (datepicker.editMode) switch(ev.key){
        case 'Escape':
            picker.hide();
            break;
        case 'Enter':
            datepicker.exitEditMode({
                update: true,
                autohide: datepicker.config.autohide
            });
            break;
        default:
            return;
    }
    else switch(ev.key){
        case 'Escape':
            picker.hide();
            break;
        case 'ArrowLeft':
            if (ev.ctrlKey || ev.metaKey) $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, -1);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, -1, false);
            break;
        case 'ArrowRight':
            if (ev.ctrlKey || ev.metaKey) $7c39ee59de2954f9$var$goToPrevOrNext(datepicker, 1);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, 1, false);
            break;
        case 'ArrowUp':
            if (ev.ctrlKey || ev.metaKey) $7c39ee59de2954f9$var$switchView(datepicker);
            else if (ev.shiftKey) {
                datepicker.enterEditMode();
                return;
            } else $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, -1, true);
            break;
        case 'ArrowDown':
            if (ev.shiftKey && !ev.ctrlKey && !ev.metaKey) {
                datepicker.enterEditMode();
                return;
            }
            $7c39ee59de2954f9$var$moveByArrowKey(datepicker, ev, 1, true);
            break;
        case 'Enter':
            if (isMinView) datepicker.setDate(picker.viewDate);
            else picker.changeView(id - 1).render();
            break;
        case 'Backspace':
        case 'Delete':
            datepicker.enterEditMode();
            return;
        default:
            if (ev.key.length === 1 && !ev.ctrlKey && !ev.metaKey) datepicker.enterEditMode();
            return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
function $7c39ee59de2954f9$var$onFocus(datepicker) {
    if (datepicker.config.showOnFocus && !datepicker._showing) datepicker.show();
}
// for the prevention for entering edit mode while getting focus on click
function $7c39ee59de2954f9$var$onMousedown(datepicker, ev) {
    var el = ev.target;
    if (datepicker.picker.active || datepicker.config.showOnClick) {
        el._active = el === document.activeElement;
        el._clicking = setTimeout(function() {
            delete el._active;
            delete el._clicking;
        }, 2000);
    }
}
function $7c39ee59de2954f9$var$onClickInput(datepicker, ev) {
    var el = ev.target;
    if (!el._clicking) return;
    clearTimeout(el._clicking);
    delete el._clicking;
    if (el._active) datepicker.enterEditMode();
    delete el._active;
    if (datepicker.config.showOnClick) datepicker.show();
}
function $7c39ee59de2954f9$var$onPaste(datepicker, ev) {
    if (ev.clipboardData.types.includes('text/plain')) datepicker.enterEditMode();
}
// for the `document` to delegate the events from outside the picker/input field
function $7c39ee59de2954f9$var$onClickOutside(datepicker, ev) {
    var element = datepicker.element;
    if (element !== document.activeElement) return;
    var pickerElem = datepicker.picker.element;
    if ($7c39ee59de2954f9$var$findElementInEventPath(ev, function(el) {
        return el === element || el === pickerElem;
    })) return;
    $7c39ee59de2954f9$var$unfocus(datepicker);
}
function $7c39ee59de2954f9$var$stringifyDates(dates, config) {
    return dates.map(function(dt) {
        return $7c39ee59de2954f9$var$formatDate(dt, config.format, config.locale);
    }).join(config.dateDelimiter);
}
// parse input dates and create an array of time values for selection
// returns undefined if there are no valid dates in inputDates
// when origDates (current selection) is passed, the function works to mix
// the input dates into the current selection
function $7c39ee59de2954f9$var$processInputDates(datepicker, inputDates) {
    var clear = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var config = datepicker.config, origDates = datepicker.dates, rangepicker = datepicker.rangepicker;
    if (inputDates.length === 0) // empty input is considered valid unless origiDates is passed
    return clear ? [] : undefined;
    var rangeEnd = rangepicker && datepicker === rangepicker.datepickers[1];
    var newDates = inputDates.reduce(function(dates, dt) {
        var date = $7c39ee59de2954f9$var$parseDate(dt, config.format, config.locale);
        if (date === undefined) return dates;
        if (config.pickLevel > 0) {
            // adjust to 1st of the month/Jan 1st of the year
            // or to the last day of the monh/Dec 31st of the year if the datepicker
            // is the range-end picker of a rangepicker
            var _dt = new Date(date);
            if (config.pickLevel === 1) date = rangeEnd ? _dt.setMonth(_dt.getMonth() + 1, 0) : _dt.setDate(1);
            else date = rangeEnd ? _dt.setFullYear(_dt.getFullYear() + 1, 0, 0) : _dt.setMonth(0, 1);
        }
        if ($7c39ee59de2954f9$var$isInRange(date, config.minDate, config.maxDate) && !dates.includes(date) && !config.datesDisabled.includes(date) && !config.daysOfWeekDisabled.includes(new Date(date).getDay())) dates.push(date);
        return dates;
    }, []);
    if (newDates.length === 0) return;
    if (config.multidate && !clear) // get the synmetric difference between origDates and newDates
    newDates = newDates.reduce(function(dates, date) {
        if (!origDates.includes(date)) dates.push(date);
        return dates;
    }, origDates.filter(function(date) {
        return !newDates.includes(date);
    }));
    // do length check always because user can input multiple dates regardless of the mode
    return config.maxNumberOfDates && newDates.length > config.maxNumberOfDates ? newDates.slice(config.maxNumberOfDates * -1) : newDates;
}
// refresh the UI elements
// modes: 1: input only, 2, picker only, 3 both
function $7c39ee59de2954f9$var$refreshUI(datepicker) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
    var quickRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var config = datepicker.config, picker = datepicker.picker, inputField = datepicker.inputField;
    if (mode & 2) {
        var newView = picker.active ? config.pickLevel : config.startView;
        picker.update().changeView(newView).render(quickRender);
    }
    if (mode & 1 && inputField) inputField.value = $7c39ee59de2954f9$var$stringifyDates(datepicker.dates, config);
}
function $7c39ee59de2954f9$var$_setDate(datepicker, inputDates, options) {
    var clear = options.clear, render = options.render, autohide = options.autohide;
    if (render === undefined) render = true;
    if (!render) autohide = false;
    else if (autohide === undefined) autohide = datepicker.config.autohide;
    var newDates = $7c39ee59de2954f9$var$processInputDates(datepicker, inputDates, clear);
    if (!newDates) return;
    if (newDates.toString() !== datepicker.dates.toString()) {
        datepicker.dates = newDates;
        $7c39ee59de2954f9$var$refreshUI(datepicker, render ? 3 : 1);
        $7c39ee59de2954f9$var$triggerDatepickerEvent(datepicker, 'changeDate');
    } else $7c39ee59de2954f9$var$refreshUI(datepicker, 1);
    if (autohide) datepicker.hide();
}
/**
 * Class representing a date picker
 */ var $7c39ee59de2954f9$export$7235422eca03ec90 = /*#__PURE__*/ function() {
    /**
   * Create a date picker
   * @param  {Element} element - element to bind a date picker
   * @param  {Object} [options] - config options
   * @param  {DateRangePicker} [rangepicker] - DateRangePicker instance the
   * date picker belongs to. Use this only when creating date picker as a part
   * of date range picker
   */ function Datepicker(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var rangepicker = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
        $7c39ee59de2954f9$var$_classCallCheck(this, Datepicker);
        element.datepicker = this;
        this.element = element;
        // set up config
        var config = this.config = Object.assign({
            buttonClass: options.buttonClass && String(options.buttonClass) || 'button',
            container: document.body,
            defaultViewDate: $7c39ee59de2954f9$var$today(),
            maxDate: undefined,
            minDate: undefined
        }, $7c39ee59de2954f9$var$processOptions($7c39ee59de2954f9$var$defaultOptions, this));
        this._options = options;
        Object.assign(config, $7c39ee59de2954f9$var$processOptions(options, this));
        // configure by type
        var inline = this.inline = element.tagName !== 'INPUT';
        var inputField;
        var initialDates;
        if (inline) {
            config.container = element;
            initialDates = $7c39ee59de2954f9$var$stringToArray(element.dataset.date, config.dateDelimiter);
            delete element.dataset.date;
        } else {
            var container = options.container ? document.querySelector(options.container) : null;
            if (container) config.container = container;
            inputField = this.inputField = element;
            inputField.classList.add('datepicker-input');
            initialDates = $7c39ee59de2954f9$var$stringToArray(inputField.value, config.dateDelimiter);
        }
        if (rangepicker) {
            // check validiry
            var index = rangepicker.inputs.indexOf(inputField);
            var datepickers = rangepicker.datepickers;
            if (index < 0 || index > 1 || !Array.isArray(datepickers)) throw Error('Invalid rangepicker object.');
            // attach itaelf to the rangepicker here so that processInputDates() can
            // determine if this is the range-end picker of the rangepicker while
            // setting inital values when pickLevel > 0
            datepickers[index] = this;
            // add getter for rangepicker
            Object.defineProperty(this, 'rangepicker', {
                get: function get() {
                    return rangepicker;
                }
            });
        }
        // set initial dates
        this.dates = [];
        // process initial value
        var inputDateValues = $7c39ee59de2954f9$var$processInputDates(this, initialDates);
        if (inputDateValues && inputDateValues.length > 0) this.dates = inputDateValues;
        if (inputField) inputField.value = $7c39ee59de2954f9$var$stringifyDates(this.dates, config);
        var picker = this.picker = new $7c39ee59de2954f9$var$Picker(this);
        if (inline) this.show();
        else {
            // set up event listeners in other modes
            var onMousedownDocument = $7c39ee59de2954f9$var$onClickOutside.bind(null, this);
            var listeners = [
                [
                    inputField,
                    'keydown',
                    $7c39ee59de2954f9$var$onKeydown.bind(null, this)
                ],
                [
                    inputField,
                    'focus',
                    $7c39ee59de2954f9$var$onFocus.bind(null, this)
                ],
                [
                    inputField,
                    'mousedown',
                    $7c39ee59de2954f9$var$onMousedown.bind(null, this)
                ],
                [
                    inputField,
                    'click',
                    $7c39ee59de2954f9$var$onClickInput.bind(null, this)
                ],
                [
                    inputField,
                    'paste',
                    $7c39ee59de2954f9$var$onPaste.bind(null, this)
                ],
                [
                    document,
                    'mousedown',
                    onMousedownDocument
                ],
                [
                    document,
                    'touchstart',
                    onMousedownDocument
                ],
                [
                    window,
                    'resize',
                    picker.place.bind(picker)
                ]
            ];
            $7c39ee59de2954f9$var$registerListeners(this, listeners);
        }
    }
    /**
   * Format Date object or time value in given format and language
   * @param  {Date|Number} date - date or time value to format
   * @param  {String|Object} format - format string or object that contains
   * toDisplay() custom formatter, whose signature is
   * - args:
   *   - date: {Date} - Date instance of the date passed to the method
   *   - format: {Object} - the format object passed to the method
   *   - locale: {Object} - locale for the language specified by `lang`
   * - return:
   *     {String} formatted date
   * @param  {String} [lang=en] - language code for the locale to use
   * @return {String} formatted date
   */ return $7c39ee59de2954f9$var$_createClass(Datepicker, [
        {
            key: "active",
            get: /**
     * @type {Boolean} - Whether the picker element is shown. `true` whne shown
     */ function get() {
                return !!(this.picker && this.picker.active);
            }
        },
        {
            key: "pickerElement",
            get: function get() {
                return this.picker ? this.picker.element : undefined;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                var picker = this.picker;
                var newOptions = $7c39ee59de2954f9$var$processOptions(options, this);
                Object.assign(this._options, options);
                Object.assign(this.config, newOptions);
                picker.setOptions(newOptions);
                $7c39ee59de2954f9$var$refreshUI(this, 3);
            }
        },
        {
            key: "show",
            value: function show() {
                if (this.inputField) {
                    if (this.inputField.disabled) return;
                    if (this.inputField !== document.activeElement) {
                        this._showing = true;
                        this.inputField.focus();
                        delete this._showing;
                    }
                }
                this.picker.show();
            }
        },
        {
            key: "hide",
            value: function hide() {
                if (this.inline) return;
                this.picker.hide();
                this.picker.update().changeView(this.config.startView).render();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.hide();
                $7c39ee59de2954f9$var$unregisterListeners(this);
                this.picker.detach();
                if (!this.inline) this.inputField.classList.remove('datepicker-input');
                delete this.element.datepicker;
                return this;
            }
        },
        {
            key: "getDate",
            value: function getDate() {
                var _this = this;
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var callback = format ? function(date) {
                    return $7c39ee59de2954f9$var$formatDate(date, format, _this.config.locale);
                } : function(date) {
                    return new Date(date);
                };
                if (this.config.multidate) return this.dates.map(callback);
                if (this.dates.length > 0) return callback(this.dates[0]);
            }
        },
        {
            key: "setDate",
            value: function setDate() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var dates = [].concat(args);
                var opts = {};
                var lastArg = $7c39ee59de2954f9$var$lastItemOf(args);
                if ($7c39ee59de2954f9$var$_typeof(lastArg) === 'object' && !Array.isArray(lastArg) && !(lastArg instanceof Date) && lastArg) Object.assign(opts, dates.pop());
                var inputDates = Array.isArray(dates[0]) ? dates[0] : dates;
                $7c39ee59de2954f9$var$_setDate(this, inputDates, opts);
            }
        },
        {
            key: "update",
            value: function update() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                if (this.inline) return;
                var opts = {
                    clear: true,
                    autohide: !!(options && options.autohide)
                };
                var inputDates = $7c39ee59de2954f9$var$stringToArray(this.inputField.value, this.config.dateDelimiter);
                $7c39ee59de2954f9$var$_setDate(this, inputDates, opts);
            }
        },
        {
            key: "refresh",
            value: function refresh() {
                var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var forceRender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (target && typeof target !== 'string') {
                    forceRender = target;
                    target = undefined;
                }
                var mode;
                if (target === 'picker') mode = 2;
                else if (target === 'input') mode = 1;
                else mode = 3;
                $7c39ee59de2954f9$var$refreshUI(this, mode, !forceRender);
            }
        },
        {
            key: "enterEditMode",
            value: function enterEditMode() {
                if (this.inline || !this.picker.active || this.editMode) return;
                this.editMode = true;
                this.inputField.classList.add('in-edit', 'border-blue-700', '!border-primary-700');
            }
        },
        {
            key: "exitEditMode",
            value: function exitEditMode() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                if (this.inline || !this.editMode) return;
                var opts = Object.assign({
                    update: false
                }, options);
                delete this.editMode;
                this.inputField.classList.remove('in-edit', 'border-blue-700', '!border-primary-700');
                if (opts.update) this.update(opts);
            }
        }
    ], [
        {
            key: "formatDate",
            value: function formatDate$1(date, format, lang) {
                return $7c39ee59de2954f9$var$formatDate(date, format, lang && $7c39ee59de2954f9$var$locales[lang] || $7c39ee59de2954f9$var$locales.en);
            }
        },
        {
            key: "parseDate",
            value: function parseDate$1(dateStr, format, lang) {
                return $7c39ee59de2954f9$var$parseDate(dateStr, format, lang && $7c39ee59de2954f9$var$locales[lang] || $7c39ee59de2954f9$var$locales.en);
            }
        },
        {
            key: "locales",
            get: function get() {
                return $7c39ee59de2954f9$var$locales;
            }
        }
    ]);
}();
// filter out the config options inapproprite to pass to Datepicker
function $7c39ee59de2954f9$var$filterOptions(options) {
    var newOpts = Object.assign({}, options);
    delete newOpts.inputs;
    delete newOpts.allowOneSidedRange;
    delete newOpts.maxNumberOfDates; // to ensure each datepicker handles a single date
    return newOpts;
}
function $7c39ee59de2954f9$var$setupDatepicker(rangepicker, changeDateListener, el, options) {
    $7c39ee59de2954f9$var$registerListeners(rangepicker, [
        [
            el,
            'changeDate',
            changeDateListener
        ]
    ]);
    new $7c39ee59de2954f9$export$7235422eca03ec90(el, options, rangepicker);
}
function $7c39ee59de2954f9$var$onChangeDate(rangepicker, ev) {
    // to prevent both datepickers trigger the other side's update each other
    if (rangepicker._updating) return;
    rangepicker._updating = true;
    var target = ev.target;
    if (target.datepicker === undefined) return;
    var datepickers = rangepicker.datepickers;
    var setDateOptions = {
        render: false
    };
    var changedSide = rangepicker.inputs.indexOf(target);
    var otherSide = changedSide === 0 ? 1 : 0;
    var changedDate = datepickers[changedSide].dates[0];
    var otherDate = datepickers[otherSide].dates[0];
    if (changedDate !== undefined && otherDate !== undefined) {
        // if the start of the range > the end, swap them
        if (changedSide === 0 && changedDate > otherDate) {
            datepickers[0].setDate(otherDate, setDateOptions);
            datepickers[1].setDate(changedDate, setDateOptions);
        } else if (changedSide === 1 && changedDate < otherDate) {
            datepickers[0].setDate(changedDate, setDateOptions);
            datepickers[1].setDate(otherDate, setDateOptions);
        }
    } else if (!rangepicker.allowOneSidedRange) // to prevent the range from becoming one-sided, copy changed side's
    // selection (no matter if it's empty) to the other side
    {
        if (changedDate !== undefined || otherDate !== undefined) {
            setDateOptions.clear = true;
            datepickers[otherSide].setDate(datepickers[changedSide].dates, setDateOptions);
        }
    }
    datepickers[0].picker.update().render();
    datepickers[1].picker.update().render();
    delete rangepicker._updating;
}
/**
 * Class representing a date range picker
 */ var $7c39ee59de2954f9$export$17334619f3ac2224 = /*#__PURE__*/ function() {
    /**
   * Create a date range picker
   * @param  {Element} element - element to bind a date range picker
   * @param  {Object} [options] - config options
   */ function DateRangePicker(element) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $7c39ee59de2954f9$var$_classCallCheck(this, DateRangePicker);
        var inputs = Array.isArray(options.inputs) ? options.inputs : Array.from(element.querySelectorAll('input'));
        if (inputs.length < 2) return;
        element.rangepicker = this;
        this.element = element;
        this.inputs = inputs.slice(0, 2);
        this.allowOneSidedRange = !!options.allowOneSidedRange;
        var changeDateListener = $7c39ee59de2954f9$var$onChangeDate.bind(null, this);
        var cleanOptions = $7c39ee59de2954f9$var$filterOptions(options);
        // in order for initial date setup to work right when pcicLvel > 0,
        // let Datepicker constructor add the instance to the rangepicker
        var datepickers = [];
        Object.defineProperty(this, 'datepickers', {
            get: function get() {
                return datepickers;
            }
        });
        $7c39ee59de2954f9$var$setupDatepicker(this, changeDateListener, this.inputs[0], cleanOptions);
        $7c39ee59de2954f9$var$setupDatepicker(this, changeDateListener, this.inputs[1], cleanOptions);
        Object.freeze(datepickers);
        // normalize the range if inital dates are given
        if (datepickers[0].dates.length > 0) $7c39ee59de2954f9$var$onChangeDate(this, {
            target: this.inputs[0]
        });
        else if (datepickers[1].dates.length > 0) $7c39ee59de2954f9$var$onChangeDate(this, {
            target: this.inputs[1]
        });
    }
    /**
   * @type {Array} - selected date of the linked date pickers
   */ return $7c39ee59de2954f9$var$_createClass(DateRangePicker, [
        {
            key: "dates",
            get: function get() {
                return this.datepickers.length === 2 ? [
                    this.datepickers[0].dates[0],
                    this.datepickers[1].dates[0]
                ] : undefined;
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                this.allowOneSidedRange = !!options.allowOneSidedRange;
                var cleanOptions = $7c39ee59de2954f9$var$filterOptions(options);
                this.datepickers[0].setOptions(cleanOptions);
                this.datepickers[1].setOptions(cleanOptions);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.datepickers[0].destroy();
                this.datepickers[1].destroy();
                $7c39ee59de2954f9$var$unregisterListeners(this);
                delete this.element.rangepicker;
            }
        },
        {
            key: "getDates",
            value: function getDates() {
                var _this = this;
                var format = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
                var callback = format ? function(date) {
                    return $7c39ee59de2954f9$var$formatDate(date, format, _this.datepickers[0].config.locale);
                } : function(date) {
                    return new Date(date);
                };
                return this.dates.map(function(date) {
                    return date === undefined ? date : callback(date);
                });
            }
        },
        {
            key: "setDates",
            value: function setDates(rangeStart, rangeEnd) {
                var _this$datepickers = $7c39ee59de2954f9$var$_slicedToArray(this.datepickers, 2), datepicker0 = _this$datepickers[0], datepicker1 = _this$datepickers[1];
                var origDates = this.dates;
                // If range normalization runs on every change, we can't set a new range
                // that starts after the end of the current range correctly because the
                // normalization process swaps start↔︎end right after setting the new start
                // date. To prevent this, the normalization process needs to run once after
                // both of the new dates are set.
                this._updating = true;
                datepicker0.setDate(rangeStart);
                datepicker1.setDate(rangeEnd);
                delete this._updating;
                if (datepicker1.dates[0] !== origDates[1]) $7c39ee59de2954f9$var$onChangeDate(this, {
                    target: this.inputs[1]
                });
                else if (datepicker0.dates[0] !== origDates[0]) $7c39ee59de2954f9$var$onChangeDate(this, {
                    target: this.inputs[0]
                });
            }
        }
    ]);
}();


var $b94af47b4b1b850b$var$__assign = undefined && undefined.__assign || function() {
    $b94af47b4b1b850b$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b94af47b4b1b850b$var$__assign.apply(this, arguments);
};
var $b94af47b4b1b850b$var$Default = {
    defaultDatepickerId: null,
    autohide: false,
    format: 'mm/dd/yyyy',
    maxDate: null,
    minDate: null,
    orientation: 'bottom',
    buttons: false,
    autoSelectToday: 0,
    title: null,
    language: 'en',
    rangePicker: false,
    onShow: function() {},
    onHide: function() {}
};
var $b94af47b4b1b850b$var$DefaultInstanceOptions = {
    id: null,
    override: true
};
var $b94af47b4b1b850b$var$Datepicker = /** @class */ function() {
    function Datepicker(datepickerEl, options, instanceOptions) {
        if (datepickerEl === void 0) datepickerEl = null;
        if (options === void 0) options = $b94af47b4b1b850b$var$Default;
        if (instanceOptions === void 0) instanceOptions = $b94af47b4b1b850b$var$DefaultInstanceOptions;
        this._instanceId = instanceOptions.id ? instanceOptions.id : datepickerEl.id;
        this._datepickerEl = datepickerEl;
        this._datepickerInstance = null;
        this._options = $b94af47b4b1b850b$var$__assign($b94af47b4b1b850b$var$__assign({}, $b94af47b4b1b850b$var$Default), options);
        this._initialized = false;
        this.init();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).addInstance('Datepicker', this, this._instanceId, instanceOptions.override);
    }
    Datepicker.prototype.init = function() {
        if (this._datepickerEl && !this._initialized) {
            if (this._options.rangePicker) this._datepickerInstance = new (0, $7c39ee59de2954f9$export$17334619f3ac2224)(this._datepickerEl, this._getDatepickerOptions(this._options));
            else this._datepickerInstance = new (0, $7c39ee59de2954f9$export$7235422eca03ec90)(this._datepickerEl, this._getDatepickerOptions(this._options));
            this._initialized = true;
        }
    };
    Datepicker.prototype.destroy = function() {
        if (this._initialized) {
            this._initialized = false;
            this._datepickerInstance.destroy();
        }
    };
    Datepicker.prototype.removeInstance = function() {
        this.destroy();
        (0, $5d5682da381fac09$export$2e2bcd8739ae039).removeInstance('Datepicker', this._instanceId);
    };
    Datepicker.prototype.destroyAndRemoveInstance = function() {
        this.destroy();
        this.removeInstance();
    };
    Datepicker.prototype.getDatepickerInstance = function() {
        return this._datepickerInstance;
    };
    Datepicker.prototype.getDate = function() {
        if (this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$17334619f3ac2224)) return this._datepickerInstance.getDates();
        if (!this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$7235422eca03ec90)) return this._datepickerInstance.getDate();
    };
    Datepicker.prototype.setDate = function(date) {
        if (this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$17334619f3ac2224)) return this._datepickerInstance.setDates(date);
        if (!this._options.rangePicker && this._datepickerInstance instanceof (0, $7c39ee59de2954f9$export$7235422eca03ec90)) return this._datepickerInstance.setDate(date);
    };
    Datepicker.prototype.show = function() {
        this._datepickerInstance.show();
        this._options.onShow(this);
    };
    Datepicker.prototype.hide = function() {
        this._datepickerInstance.hide();
        this._options.onHide(this);
    };
    Datepicker.prototype._getDatepickerOptions = function(options) {
        var datepickerOptions = {};
        if (options.buttons) {
            datepickerOptions.todayBtn = true;
            datepickerOptions.clearBtn = true;
            if (options.autoSelectToday) datepickerOptions.todayBtnMode = 1;
        }
        if (options.autohide) datepickerOptions.autohide = true;
        if (options.format) datepickerOptions.format = options.format;
        if (options.maxDate) datepickerOptions.maxDate = options.maxDate;
        if (options.minDate) datepickerOptions.minDate = options.minDate;
        if (options.orientation) datepickerOptions.orientation = options.orientation;
        if (options.title) datepickerOptions.title = options.title;
        if (options.language) datepickerOptions.language = options.language;
        return datepickerOptions;
    };
    Datepicker.prototype.updateOnShow = function(callback) {
        this._options.onShow = callback;
    };
    Datepicker.prototype.updateOnHide = function(callback) {
        this._options.onHide = callback;
    };
    return Datepicker;
}();
function $b94af47b4b1b850b$export$81c9f52a292162ae() {
    document.querySelectorAll('[datepicker], [inline-datepicker], [date-rangepicker]').forEach(function($datepickerEl) {
        if ($datepickerEl) {
            var buttons = $datepickerEl.hasAttribute('datepicker-buttons');
            var autoselectToday = $datepickerEl.hasAttribute('datepicker-autoselect-today');
            var autohide = $datepickerEl.hasAttribute('datepicker-autohide');
            var format = $datepickerEl.getAttribute('datepicker-format');
            var maxDate = $datepickerEl.getAttribute('datepicker-max-date');
            var minDate = $datepickerEl.getAttribute('datepicker-min-date');
            var orientation_1 = $datepickerEl.getAttribute('datepicker-orientation');
            var title = $datepickerEl.getAttribute('datepicker-title');
            var language = $datepickerEl.getAttribute('datepicker-language');
            var rangePicker = $datepickerEl.hasAttribute('date-rangepicker');
            new $b94af47b4b1b850b$var$Datepicker($datepickerEl, {
                buttons: buttons ? buttons : $b94af47b4b1b850b$var$Default.buttons,
                autoSelectToday: autoselectToday ? autoselectToday : $b94af47b4b1b850b$var$Default.autoSelectToday,
                autohide: autohide ? autohide : $b94af47b4b1b850b$var$Default.autohide,
                format: format ? format : $b94af47b4b1b850b$var$Default.format,
                maxDate: maxDate ? maxDate : $b94af47b4b1b850b$var$Default.maxDate,
                minDate: minDate ? minDate : $b94af47b4b1b850b$var$Default.minDate,
                orientation: orientation_1 ? orientation_1 : $b94af47b4b1b850b$var$Default.orientation,
                title: title ? title : $b94af47b4b1b850b$var$Default.title,
                language: language ? language : $b94af47b4b1b850b$var$Default.language,
                rangePicker: rangePicker ? rangePicker : $b94af47b4b1b850b$var$Default.rangePicker
            });
        } else console.error("The datepicker element does not exist. Please check the datepicker attribute.");
    });
}
if (typeof window !== 'undefined') {
    window.Datepicker = $b94af47b4b1b850b$var$Datepicker;
    window.initDatepickers = $b94af47b4b1b850b$export$81c9f52a292162ae;
}
var $b94af47b4b1b850b$export$2e2bcd8739ae039 = $b94af47b4b1b850b$var$Datepicker;
















function $60d1a2d369db67b0$export$4cd50b9c69a85fd5() {
    (0, $d93a619a461d9c03$export$226c1dc98323ee4d)();
    (0, $fc7ccf099a511882$export$355ba5a528b4009a)();
    (0, $c1b11beef829dd56$export$3ab77386b16b9e58)();
    (0, $6d6d37a8acee51c1$export$69c84787a503daef)();
    (0, $9d7e083df5284b15$export$8cb65a02593bf108)();
    (0, $eaca6a069237aaf5$export$e14d3bc873a8b9b1)();
    (0, $48c8331f22e653e8$export$319df2b10e87c8ec)();
    (0, $d9a3b96db6d5dbb4$export$c92e8f569ad2976f)();
    (0, $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e)();
    (0, $6aca18f5cd7d8b7b$export$200409e83b2a0dd4)();
    (0, $027785b5e7762569$export$33aa68e0bfaa065d)();
    (0, $5252bf9f038f0bda$export$4352dd3b7a1676ab)();
    (0, $d10e6c36a2232fe1$export$ad4117886fd6cf74)();
    (0, $b94af47b4b1b850b$export$81c9f52a292162ae)();
}
if (typeof window !== 'undefined') window.initFlowbite = $60d1a2d369db67b0$export$4cd50b9c69a85fd5;






























































// setup events for data attributes
var $948592d8c330c4e7$var$events = new (0, $2bd4b9c31e857ffa$export$2e2bcd8739ae039)('load', [
    (0, $d93a619a461d9c03$export$226c1dc98323ee4d),
    (0, $fc7ccf099a511882$export$355ba5a528b4009a),
    (0, $c1b11beef829dd56$export$3ab77386b16b9e58),
    (0, $6d6d37a8acee51c1$export$69c84787a503daef),
    (0, $9d7e083df5284b15$export$8cb65a02593bf108),
    (0, $eaca6a069237aaf5$export$e14d3bc873a8b9b1),
    (0, $48c8331f22e653e8$export$319df2b10e87c8ec),
    (0, $d9a3b96db6d5dbb4$export$c92e8f569ad2976f),
    (0, $91c32ed640e0fec6$export$8f2a38c1f9d9dc3e),
    (0, $6aca18f5cd7d8b7b$export$200409e83b2a0dd4),
    (0, $027785b5e7762569$export$33aa68e0bfaa065d),
    (0, $5252bf9f038f0bda$export$4352dd3b7a1676ab),
    (0, $d10e6c36a2232fe1$export$ad4117886fd6cf74),
    (0, $b94af47b4b1b850b$export$81c9f52a292162ae)
]);
$948592d8c330c4e7$var$events.init();


(0, (/*@__PURE__*/$parcel$interopDefault($jhwMH))).extend((0, (/*@__PURE__*/$parcel$interopDefault($jSNlv))));
(0, (/*@__PURE__*/$parcel$interopDefault($jhwMH))).extend((0, (/*@__PURE__*/$parcel$interopDefault($6N7gE))));
(0, (/*@__PURE__*/$parcel$interopDefault($jhwMH))).extend((0, (/*@__PURE__*/$parcel$interopDefault($17sxp))));
window.dayjs = (0, (/*@__PURE__*/$parcel$interopDefault($jhwMH)));
window.ApexCharts = (0, $e4b487e979d7c06d$export$2e2bcd8739ae039);
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $ojnWK.default));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $182977f45aac8dca$export$2e2bcd8739ae039));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $85572a2cec6fb903$export$2e2bcd8739ae039));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $cf417a97d74b93bb$export$2e2bcd8739ae039));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $21b57f0df60ff3c3$export$2e2bcd8739ae039));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $dc5e95bf63b2a32e$export$2e2bcd8739ae039));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $a9mZZ.default));
(0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin((0, $d09a060543d6a2e2$export$2e2bcd8739ae039));
// Global stores
(0, $f347e48613385d9c$export$2e2bcd8739ae039).store("filterFields", {
    fields: [],
    add (field) {
        this.fields.push(field);
    },
    remove (field) {
        const index = this.fields.indexOf(field);
        this.fields.splice(index, 1);
    },
    has (field) {
        return this.fields.includes(field) ? true : false;
    },
    flush () {
        this.fields = [];
    }
});
(0, $f347e48613385d9c$export$2e2bcd8739ae039).store("filterFieldsAndTheirItems", {
    fields: {},
    getTheFieldsItself () {
        return JSON.stringify(this.fields);
    },
    add (key, value) {
        this.fields[key] = value;
    },
    remove (key) {
        delete this.fields[key];
    },
    removeFromCustomFields (customFieldMainKey, key) {
        const customFields = JSON.parse(this.get(customFieldMainKey));
        // now we got the main one, it will be like [{field_id: '32121321'}]
        // I will go ahead, iterate over it, find the one with it and kill it
        const filteredCustomFields = customFields.filter((i)=>i.field_id != key);
        // then update the custom fields with it again
        this.add(customFieldMainKey, JSON.stringify(filteredCustomFields));
    },
    has (key) {
        return typeof this.fields[key] !== "undefined";
    },
    get (key) {
        const val = this.fields[key];
        if (typeof key === "undefined") return null;
        else return val;
    },
    flush () {
        this.fields = {};
    }
});
window.Alpine = (0, $f347e48613385d9c$export$2e2bcd8739ae039);
window.Alpine.data("email_editor", (0, $lguVw.default));
window.Alpine.data("text_editor", (0, $46Bky.default));
window.Alpine.data("wysiwyg", (0, $eokEX.default));
window.Alpine.data("combobox", (0, $cSEGC.default));
window.Alpine.data("file_input", (0, $8DTOO.default));
window.Alpine.data("workflow", (0, $b4EcM.default));
window.Alpine.data("organization_sortable", (0, $1c3wp.default));
window.Alpine.data("job_form", (0, $aFSg5.default));
window.Alpine.data("options_editor", (0, $lrtgD.default));
window.Alpine.data("phone_input", (0, $bKHmb.default));
window.Alpine.data("filter", (0, $busg4.default));
window.Alpine.data("command_palette", (0, $bV58F.default));
window.Alpine.data("availability_calendar", (0, $d6Hx1.default));
window.Alpine.start();

})();
//# sourceMappingURL=index.js.map
